(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9e50"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9e50"] = parcelRequire;
}
parcelRequire.register("gm4sb", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $be8227c7ee2b94f0$export$6503ec6e8aabbaf; }, function (v) { return $be8227c7ee2b94f0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $be8227c7ee2b94f0$export$f7ad0328861e2f03; }, function (v) { return $be8227c7ee2b94f0$export$f7ad0328861e2f03 = v; });
var $be8227c7ee2b94f0$export$6503ec6e8aabbaf;
var $be8227c7ee2b94f0$export$f7ad0328861e2f03;
"use strict";
var $be8227c7ee2b94f0$var$mapping = {};
function $be8227c7ee2b94f0$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$be8227c7ee2b94f0$var$mapping[keys[i]] = pairs[keys[i]];
}
function $be8227c7ee2b94f0$var$resolve(id) {
    var resolved = $be8227c7ee2b94f0$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$be8227c7ee2b94f0$export$6503ec6e8aabbaf = $be8227c7ee2b94f0$var$register;
$be8227c7ee2b94f0$export$f7ad0328861e2f03 = $be8227c7ee2b94f0$var$resolve;

});

parcelRequire.register("jAv3h", function(module, exports) {
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : module.exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\x00") return "�";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\x00-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});

parcelRequire.register("5NVy9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $439e2b92216f4625$export$2e2bcd8739ae039; });

var $iQter = parcelRequire("iQter");

var $dFrCp = parcelRequire("dFrCp");
var $439e2b92216f4625$var$scriptExports = {
    components: {
        LogoItem: $dFrCp.default,
        VBurger: $iQter.VBurger
    },
    data () {
        return {
            menuOpen: false,
            navigationData: window.navigationData
        };
    },
    methods: {
        toggleMenu () {
            this.menuOpen = !this.menuOpen;
            if (this.menuOpen) document.querySelector("body").classList.add("overflow-hidden", "h-screen");
            else document.querySelector("body").classList.remove("overflow-hidden", "h-screen");
        }
    }
};
var $439e2b92216f4625$var$options = typeof $439e2b92216f4625$var$scriptExports === "function" ? $439e2b92216f4625$var$scriptExports.options : $439e2b92216f4625$var$scriptExports;
var $439e2b92216f4625$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $439e2b92216f4625$var$options;

});
parcelRequire.register("iQter", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var $db83c22a80e9120a$var$script = {
    name: "v-burger",
    props: {
        active: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: "boring"
        },
        burgerStyle: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        ariaLabel: {
            type: String,
            default: "Menu"
        },
        ariaControls: {
            type: String,
            default: "navigation"
        },
        tabIndex: {
            type: Number,
            default: 0
        }
    }
};
/* script */ var $db83c22a80e9120a$var$__vue_script__ = $db83c22a80e9120a$var$script;
/* template */ var $db83c22a80e9120a$var$__vue_render__ = function __vue_render__() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("button", {
        staticClass: "hamburger",
        class: [
            "hamburger--" + _vm.type,
            {
                "is-active": _vm.active
            }
        ],
        style: _vm.burgerStyle,
        attrs: {
            "aria-label": _vm.ariaLabel,
            "aria-controls": _vm.ariaControls,
            "aria-expanded": _vm.active,
            "tabindex": _vm.tabIndex,
            "type": "button"
        },
        on: {
            "click": function click($event) {
                return _vm.$emit("updated", !_vm.active);
            }
        }
    }, [
        _vm._m(0),
        _vm._v(" "),
        _vm._t("label")
    ], 2);
};
var $db83c22a80e9120a$var$__vue_staticRenderFns__ = [
    function() {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c("span", {
            staticClass: "hamburger-box"
        }, [
            _c("span", {
                staticClass: "hamburger-inner"
            })
        ]);
    }
];
/* style */ var $db83c22a80e9120a$var$__vue_inject_styles__ = undefined;
/* scoped */ var $db83c22a80e9120a$var$__vue_scope_id__ = undefined;
/* functional template */ var $db83c22a80e9120a$var$__vue_is_functional_template__ = false;
/* component normalizer */ function $db83c22a80e9120a$var$__vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
    var component = (typeof script === "function" ? script.options : script) || {}; // For security concerns, we use only base name in production mode.
    component.__file = "Burger.vue";
    if (!component.render) {
        component.render = template.render;
        component.staticRenderFns = template.staticRenderFns;
        component._compiled = true;
        if (functional) component.functional = true;
    }
    component._scopeId = scope;
    return component;
}
/* style inject */ /* style inject SSR */ var $db83c22a80e9120a$var$VBurger = $db83c22a80e9120a$var$__vue_normalize__({
    render: $db83c22a80e9120a$var$__vue_render__,
    staticRenderFns: $db83c22a80e9120a$var$__vue_staticRenderFns__
}, $db83c22a80e9120a$var$__vue_inject_styles__, $db83c22a80e9120a$var$__vue_script__, $db83c22a80e9120a$var$__vue_scope_id__, $db83c22a80e9120a$var$__vue_is_functional_template__);
var $db83c22a80e9120a$var$VBurgerPlugin = {
    install: function install(Vue) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var name = options.name || $db83c22a80e9120a$var$VBurger.name;
        Vue.component(name, $db83c22a80e9120a$var$VBurger);
    }
};
if (typeof window !== "undefined" && window.Vue) window.Vue.use($db83c22a80e9120a$var$VBurgerPlugin);
module.exports.VBurger = $db83c22a80e9120a$var$VBurger;
module.exports.VBurgerPlugin = $db83c22a80e9120a$var$VBurgerPlugin;
module.exports.default = $db83c22a80e9120a$var$VBurgerPlugin;

});

parcelRequire.register("dFrCp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9f348722d59024f6$export$2e2bcd8739ae039; });
let $9f348722d59024f6$var$script;




let $9f348722d59024f6$var$initialize = ()=>{
    $9f348722d59024f6$var$script = (parcelRequire("jWl6H"));
    if ($9f348722d59024f6$var$script.__esModule) $9f348722d59024f6$var$script = $9f348722d59024f6$var$script.default;
    $9f348722d59024f6$var$script.render = (parcelRequire("8hryh")).render;
    $9f348722d59024f6$var$script.staticRenderFns = (parcelRequire("8hryh")).staticRenderFns;
    $9f348722d59024f6$var$script._scopeId = "data-v-31c975";
    (parcelRequire("hLsrf")).default($9f348722d59024f6$var$script);
    $9f348722d59024f6$var$script.__scopeId = "data-v-31c975";
    $9f348722d59024f6$var$script.__file = "LogoItem.vue";
};
$9f348722d59024f6$var$initialize();
var $9f348722d59024f6$export$2e2bcd8739ae039 = $9f348722d59024f6$var$script;

});
parcelRequire.register("jWl6H", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $e843ce81e1dd4bbd$export$2e2bcd8739ae039; });
var $e843ce81e1dd4bbd$var$scriptExports = {
    data () {
        return {};
    },
    mounted () {},
    methods: {}
};
var $e843ce81e1dd4bbd$var$options = typeof $e843ce81e1dd4bbd$var$scriptExports === "function" ? $e843ce81e1dd4bbd$var$scriptExports.options : $e843ce81e1dd4bbd$var$scriptExports;
var $e843ce81e1dd4bbd$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $e843ce81e1dd4bbd$var$options;

});

parcelRequire.register("8hryh", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $607548834de8d2c3$export$b3890eb0ae9dca99; }, function (v) { return $607548834de8d2c3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $607548834de8d2c3$export$f8436702749526f9; }, function (v) { return $607548834de8d2c3$export$f8436702749526f9 = v; });
var $607548834de8d2c3$export$b3890eb0ae9dca99;
var $607548834de8d2c3$export$f8436702749526f9;
var $607548834de8d2c3$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", {
        staticClass: "px-4 py-2 bg-white rounded"
    }, [
        _c("svg", {
            staticClass: "w-6",
            attrs: {
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 270.268 344.593"
            }
        }, [
            _c("g", {
                attrs: {
                    "id": "Group_27",
                    "data-name": "Group 27",
                    "transform": "translate(-794.53 -48.229)"
                }
            }, [
                _c("path", {
                    attrs: {
                        "id": "Path_98",
                        "data-name": "Path 98",
                        "d": "M1247.936,226.2l38.8,37.845L1389.245,177.9h0l-104.492,131-59.915-59.377Z",
                        "transform": "translate(-347.602 83.926)",
                        "fill": "#d63943"
                    }
                }),
                _vm._v(" "),
                _c("path", {
                    attrs: {
                        "id": "Path_99",
                        "data-name": "Path 99",
                        "d": "M1340.381,164.97l-15.208-14.659V124.584h-19.43l0,7-20.013-19.29-38.585,37.787h0l-15.208,14.894h15.208v45.638h26.444V179.113h25.123v31.494h26.466V164.97Z",
                        "transform": "translate(-342.165 33.634)",
                        "fill": "#d63943"
                    }
                }),
                _vm._v(" "),
                _c("path", {
                    attrs: {
                        "id": "Path_100",
                        "data-name": "Path 100",
                        "d": "M1448.275,194.893c.949-80.744-47.393-137.906-126.685-137.906a143.569,143.569,0,0,0-90.607,254.937l22.8-23.311a110.819,110.819,0,0,1-42.562-87.4c0-2.577.1-5.13.268-7.663,3.09-64.232,49.727-110.162,118.087-110.162,70.417,0,119.359,60.423,109.876,161.15A148.223,148.223,0,0,0,1448.275,194.893Z",
                        "transform": "translate(-383.491 -8.758)",
                        "fill": "#0a0143"
                    }
                })
            ])
        ])
    ]);
};
var $607548834de8d2c3$var$staticRenderFns = [];
$607548834de8d2c3$export$b3890eb0ae9dca99 = $607548834de8d2c3$var$render;
$607548834de8d2c3$export$f8436702749526f9 = $607548834de8d2c3$var$staticRenderFns;

});

parcelRequire.register("hLsrf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ceece2bbd40cb14d$export$2e2bcd8739ae039; });
let $ceece2bbd40cb14d$var$NOOP = ()=>{};
var $ceece2bbd40cb14d$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRequire.register("dJGnT", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $a0005afcce434bb4$export$b3890eb0ae9dca99; }, function (v) { return $a0005afcce434bb4$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $a0005afcce434bb4$export$f8436702749526f9; }, function (v) { return $a0005afcce434bb4$export$f8436702749526f9 = v; });
var $a0005afcce434bb4$export$b3890eb0ae9dca99;
var $a0005afcce434bb4$export$f8436702749526f9;
var $a0005afcce434bb4$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", [
        _c("nav", {
            staticClass: "fixed top-0 z-40 flex w-full bg-brand-500 xl:hidden",
            attrs: {
                "role": "navigation"
            }
        }, [
            _c("div", {
                staticClass: "flex-1 px-5 py-3 pt-4"
            }, [
                _c("a", {
                    staticClass: "inline-block outline-none",
                    attrs: {
                        "href": "/"
                    }
                }, [
                    _c("LogoItem")
                ], 1)
            ]),
            _vm._v(" "),
            _c("v-burger", {
                attrs: {
                    "type": "collapse",
                    "active": _vm.menuOpen
                },
                on: {
                    "updated": _vm.toggleMenu
                }
            })
        ], 1),
        _vm._v(" "),
        _c("transition", {
            attrs: {
                "enter-active-class": "transition-all duration-500 ease-in-out",
                "leave-active-class": "transition-all duration-500 ease-in-out",
                "enter-class": "transform -translate-y-full opacity-0",
                "enter-to-class": "transform translate-y-0 opacity-100",
                "leave-class": "transform translate-y-0 opacity-100",
                "leave-to-class": "transform -translate-y-full opacity-0"
            }
        }, [
            _vm.menuOpen ? _c("div", {
                staticClass: "fixed top-0 z-30 flex flex-col w-full h-screen px-10 pb-32 overflow-hidden text-white pt-28 bg-brand-500 xl:hidden"
            }, [
                _c("div", {
                    staticClass: "flex-1"
                }, [
                    _c("ul", {
                        staticClass: "flex flex-col justify-between h-full text-xl tracking-wider uppercase max-h-menu"
                    }, [
                        _vm._l(_vm.navigationData.menu, function(item, index) {
                            return _c("li", {
                                key: index
                            }, [
                                _c("a", {
                                    staticClass: "btn-link",
                                    attrs: {
                                        "href": item.url
                                    }
                                }, [
                                    _vm._v(_vm._s(item.title))
                                ])
                            ]);
                        }),
                        _vm._v(" "),
                        _c("li", {
                            staticClass: "mt-2"
                        }, [
                            _c("a", {
                                staticClass: "inline-block text-center outline-none btn btn-danger",
                                attrs: {
                                    "href": _vm.navigationData.cta.url
                                }
                            }, [
                                _vm._v(_vm._s(_vm.navigationData.cta.label))
                            ])
                        ])
                    ], 2),
                    _vm._v(" "),
                    _c("ul", {
                        staticClass: "flex mt-5 space-x-5"
                    }, [
                        _c("li", [
                            _c("a", {
                                staticClass: "btn-link is-line is-thick",
                                attrs: {
                                    "href": _vm.navigationData.languages.fr
                                }
                            }, [
                                _vm._v("FR")
                            ])
                        ]),
                        _vm._v(" "),
                        _c("li", [
                            _c("a", {
                                staticClass: "btn-link is-line is-thick",
                                attrs: {
                                    "href": _vm.navigationData.languages.nl
                                }
                            }, [
                                _vm._v("NL")
                            ])
                        ])
                    ])
                ]),
                _vm._v(" "),
                _vm.navigationData.enable_badge ? _c("div", {
                    staticClass: "pt-20"
                }, [
                    _c("img", {
                        staticClass: "h-20",
                        attrs: {
                            "src": _vm.navigationData.badge
                        }
                    })
                ]) : _vm._e()
            ]) : _vm._e()
        ])
    ], 1);
};
var $a0005afcce434bb4$var$staticRenderFns = [];
$a0005afcce434bb4$export$b3890eb0ae9dca99 = $a0005afcce434bb4$var$render;
$a0005afcce434bb4$export$f8436702749526f9 = $a0005afcce434bb4$var$staticRenderFns;

});

parcelRequire.register("lgVAD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7c7c3b92029cd3a$export$2e2bcd8739ae039; });
let $f7c7c3b92029cd3a$var$NOOP = ()=>{};
var $f7c7c3b92029cd3a$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire.register("kI4kR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f13b47a061136e3c$export$2e2bcd8739ae039; });

var $f13b47a061136e3c$var$scriptExports = function(x) {
    return x.default || x;
}((parcelRequire("1l6v0")));
var $f13b47a061136e3c$var$options = typeof $f13b47a061136e3c$var$scriptExports === "function" ? $f13b47a061136e3c$var$scriptExports.options : $f13b47a061136e3c$var$scriptExports;
var $f13b47a061136e3c$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $f13b47a061136e3c$var$options;

});
parcelRequire.register("1l6v0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3P0WM = parcelRequire("3P0WM");
var $0f9ccb2bdf8418c9$var$_mapElementFactory2 = $0f9ccb2bdf8418c9$var$_interopRequireDefault($3P0WM);
function $0f9ccb2bdf8418c9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $0f9ccb2bdf8418c9$var$props = {
    options: {
        type: Object,
        required: false,
        default: function _default() {
            return {};
        }
    },
    position: {
        type: Object,
        twoWay: true
    },
    zIndex: {
        type: Number,
        twoWay: true
    }
};
var $0f9ccb2bdf8418c9$var$events = [
    "domready",
    "closeclick",
    "content_changed"
];
module.exports.default = (0, $0f9ccb2bdf8418c9$var$_mapElementFactory2.default)({
    mappedProps: $0f9ccb2bdf8418c9$var$props,
    events: $0f9ccb2bdf8418c9$var$events,
    name: "infoWindow",
    ctr: function ctr() {
        return google.maps.InfoWindow;
    },
    props: {
        opened: {
            type: Boolean,
            default: true
        }
    },
    inject: {
        "$markerPromise": {
            default: null
        }
    },
    mounted: function mounted() {
        var el = this.$refs.flyaway;
        el.parentNode.removeChild(el);
    },
    beforeCreate: function beforeCreate(options) {
        var _this = this;
        options.content = this.$refs.flyaway;
        if (this.$markerPromise) {
            delete options.position;
            return this.$markerPromise.then(function(mo) {
                _this.$markerObject = mo;
                return mo;
            });
        }
    },
    methods: {
        _openInfoWindow: function _openInfoWindow() {
            if (this.opened) {
                if (this.$markerObject !== null) this.$infoWindowObject.open(this.$map, this.$markerObject);
                else this.$infoWindowObject.open(this.$map);
            } else this.$infoWindowObject.close();
        }
    },
    afterCreate: function afterCreate() {
        var _this2 = this;
        this._openInfoWindow();
        this.$watch("opened", function() {
            _this2._openInfoWindow();
        });
    }
});

});
parcelRequire.register("3P0WM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2c86de9b611913cc$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $2c86de9b611913cc$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
module.exports.default = function(options) {
    var mappedProps = options.mappedProps, name = options.name, ctr = options.ctr, ctrArgs = options.ctrArgs, events = options.events, beforeCreate = options.beforeCreate, afterCreate = options.afterCreate, props = options.props, rest = $2c86de9b611913cc$var$_objectWithoutProperties(options, [
        "mappedProps",
        "name",
        "ctr",
        "ctrArgs",
        "events",
        "beforeCreate",
        "afterCreate",
        "props"
    ]);
    var promiseName = "$" + name + "Promise";
    var instanceName = "$" + name + "Object";
    $2c86de9b611913cc$var$assert(!(rest.props instanceof Array), "`props` should be an object, not Array");
    return $2c86de9b611913cc$var$_extends({}, typeof GENERATE_DOC !== "undefined" ? {
        $vgmOptions: options
    } : {}, {
        mixins: [
            $2c86de9b611913cc$var$_mapElementMixin2.default
        ],
        props: $2c86de9b611913cc$var$_extends({}, props, $2c86de9b611913cc$var$mappedPropsToVueProps(mappedProps)),
        render: function render() {
            return "";
        },
        provide: function provide() {
            var _this = this;
            var promise = this.$mapPromise.then(function(map) {
                // Infowindow needs this to be immediately available
                _this.$map = map;
                // Initialize the maps with the given options
                var options = $2c86de9b611913cc$var$_extends({}, _this.options, {
                    map: map
                }, (0, $3SCF9.getPropsValues)(_this, mappedProps));
                delete options.options; // delete the extra options
                if (beforeCreate) {
                    var result = beforeCreate.bind(_this)(options);
                    if (result instanceof Promise) return result.then(function() {
                        return {
                            options: options
                        };
                    });
                }
                return {
                    options: options
                };
            }).then(function(_ref) {
                var _Function$prototype$b;
                var options = _ref.options;
                var ConstructorObject = ctr();
                // https://stackoverflow.com/questions/1606797/use-of-apply-with-new-operator-is-this-possible
                _this[instanceName] = ctrArgs ? new ((_Function$prototype$b = Function.prototype.bind).call.apply(_Function$prototype$b, [
                    ConstructorObject,
                    null
                ].concat($2c86de9b611913cc$var$_toConsumableArray(ctrArgs(options, (0, $3SCF9.getPropsValues)(_this, props || {}))))))() : new ConstructorObject(options);
                (0, $3SCF9.bindProps)(_this, _this[instanceName], mappedProps);
                (0, $2c86de9b611913cc$var$_bindEvents2.default)(_this, _this[instanceName], events);
                if (afterCreate) afterCreate.bind(_this)(_this[instanceName]);
                return _this[instanceName];
            });
            this[promiseName] = promise;
            return $2c86de9b611913cc$var$_defineProperty({}, promiseName, promise);
        },
        destroyed: function destroyed() {
            // Note: not all Google Maps components support maps
            if (this[instanceName] && this[instanceName].setMap) this[instanceName].setMap(null);
        }
    }, rest);
};
module.exports.mappedPropsToVueProps = $2c86de9b611913cc$var$mappedPropsToVueProps;

var $B3efH = parcelRequire("B3efH");
var $2c86de9b611913cc$var$_bindEvents2 = $2c86de9b611913cc$var$_interopRequireDefault($B3efH);

var $3SCF9 = parcelRequire("3SCF9");

var $6H6Oq = parcelRequire("6H6Oq");
var $2c86de9b611913cc$var$_mapElementMixin2 = $2c86de9b611913cc$var$_interopRequireDefault($6H6Oq);
function $2c86de9b611913cc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2c86de9b611913cc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2c86de9b611913cc$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
function $2c86de9b611913cc$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
/**
 *
 * @param {Object} options
 * @param {Object} options.mappedProps - Definitions of props
 * @param {Object} options.mappedProps.PROP.type - Value type
 * @param {Boolean} options.mappedProps.PROP.twoWay
 *  - Whether the prop has a corresponding PROP_changed
 *   event
 * @param {Boolean} options.mappedProps.PROP.noBind
 *  - If true, do not apply the default bindProps / bindEvents.
 * However it will still be added to the list of component props
 * @param {Object} options.props - Regular Vue-style props.
 *  Note: must be in the Object form because it will be
 *  merged with the `mappedProps`
 *
 * @param {Object} options.events - Google Maps API events
 *  that are not bound to a corresponding prop
 * @param {String} options.name - e.g. `polyline`
 * @param {=> String} options.ctr - constructor, e.g.
 *  `google.maps.Polyline`. However, since this is not
 *  generally available during library load, this becomes
 *  a function instead, e.g. () => google.maps.Polyline
 *  which will be called only after the API has been loaded
 * @param {(MappedProps, OtherVueProps) => Array} options.ctrArgs -
 *   If the constructor in `ctr` needs to be called with
 *   arguments other than a single `options` object, e.g. for
 *   GroundOverlay, we call `new GroundOverlay(url, bounds, options)`
 *   then pass in a function that returns the argument list as an array
 *
 * Otherwise, the constructor will be called with an `options` object,
 *   with property and values merged from:
 *
 *   1. the `options` property, if any
 *   2. a `map` property with the Google Maps
 *   3. all the properties passed to the component in `mappedProps`
 * @param {Object => Any} options.beforeCreate -
 *  Hook to modify the options passed to the initializer
 * @param {(options.ctr, Object) => Any} options.afterCreate -
 *  Hook called when
 *
 */ function $2c86de9b611913cc$var$assert(v, message) {
    if (!v) throw new Error(message);
}
/**
 * Strips out the extraneous properties we have in our
 * props definitions
 * @param {Object} props
 */ function $2c86de9b611913cc$var$mappedPropsToVueProps(mappedProps) {
    return Object.entries(mappedProps).map(function(_ref3) {
        var _ref4 = $2c86de9b611913cc$var$_slicedToArray(_ref3, 2), key = _ref4[0], prop = _ref4[1];
        var value = {};
        if ("type" in prop) value.type = prop.type;
        if ("default" in prop) value.default = prop.default;
        if ("required" in prop) value.required = prop.required;
        return [
            key,
            value
        ];
    }).reduce(function(acc, _ref5) {
        var _ref6 = $2c86de9b611913cc$var$_slicedToArray(_ref5, 2), key = _ref6[0], val = _ref6[1];
        acc[key] = val;
        return acc;
    }, {});
}

});
parcelRequire.register("B3efH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(vueInst, googleMapsInst, events) {
    var _loop = function(eventName) {
        if (vueInst.$gmapOptions.autobindAllEvents || vueInst.$listeners[eventName]) googleMapsInst.addListener(eventName, function(ev) {
            vueInst.$emit(eventName, ev);
        });
    };
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = events[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var eventName = _step.value;
            _loop(eventName);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
};

});

parcelRequire.register("3SCF9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPropsValues = $2d3467e1840d1061$var$getPropsValues;
module.exports.bindProps = $2d3467e1840d1061$var$bindProps;

var $fubri = parcelRequire("fubri");
var $2d3467e1840d1061$var$_WatchPrimitiveProperties2 = $2d3467e1840d1061$var$_interopRequireDefault($fubri);
function $2d3467e1840d1061$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2d3467e1840d1061$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function $2d3467e1840d1061$var$getPropsValues(vueInst, props) {
    return Object.keys(props).reduce(function(acc, prop) {
        if (vueInst[prop] !== undefined) acc[prop] = vueInst[prop];
        return acc;
    }, {});
}
/**
  * Binds the properties defined in props to the google maps instance.
  * If the prop is an Object type, and we wish to track the properties
  * of the object (e.g. the lat and lng of a LatLng), then we do a deep
  * watch. For deep watch, we also prevent the _changed event from being
  * emitted if the data source was external.
  */ function $2d3467e1840d1061$var$bindProps(vueInst, googleMapsInst, props) {
    var _loop = function(attribute) {
        var _props$attribute = props[attribute], twoWay = _props$attribute.twoWay, type = _props$attribute.type, trackProperties = _props$attribute.trackProperties, noBind = _props$attribute.noBind;
        if (noBind) return "continue";
        var setMethodName = "set" + $2d3467e1840d1061$var$capitalizeFirstLetter(attribute);
        var getMethodName = "get" + $2d3467e1840d1061$var$capitalizeFirstLetter(attribute);
        var eventName = attribute.toLowerCase() + "_changed";
        var initialValue = vueInst[attribute];
        if (typeof googleMapsInst[setMethodName] === "undefined") throw new Error(setMethodName + " is not a method of (the Maps object corresponding to) " + vueInst.$options._componentTag);
        // We need to avoid an endless
        // propChanged -> event emitted -> propChanged -> event emitted loop
        // although this may really be the user's responsibility
        if (type !== Object || !trackProperties) // Track the object deeply
        vueInst.$watch(attribute, function() {
            var attributeValue = vueInst[attribute];
            googleMapsInst[setMethodName](attributeValue);
        }, {
            immediate: typeof initialValue !== "undefined",
            deep: type === Object
        });
        else (0, $2d3467e1840d1061$var$_WatchPrimitiveProperties2.default)(vueInst, trackProperties.map(function(prop) {
            return attribute + "." + prop;
        }), function() {
            googleMapsInst[setMethodName](vueInst[attribute]);
        }, vueInst[attribute] !== undefined);
        if (twoWay && (vueInst.$gmapOptions.autobindAllEvents || vueInst.$listeners[eventName])) googleMapsInst.addListener(eventName, function() {
            // eslint-disable-line no-unused-vars
            vueInst.$emit(eventName, googleMapsInst[getMethodName]());
        });
    };
    for(var attribute in props){
        var _ret = _loop(attribute);
        if (_ret === "continue") continue;
    }
}

});
parcelRequire.register("fubri", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b46287f03b0ae581$var$WatchPrimitiveProperties;
/**
 * Watch the individual properties of a PoD object, instead of the object
 * per se. This is different from a deep watch where both the reference
 * and the individual values are watched.
 *
 * In effect, it throttles the multiple $watch to execute at most once per tick.
 */ function $b46287f03b0ae581$var$WatchPrimitiveProperties(vueInst, propertiesToTrack, handler) {
    var immediate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var isHandled = false;
    function requestHandle() {
        if (!isHandled) {
            isHandled = true;
            vueInst.$nextTick(function() {
                isHandled = false;
                handler();
            });
        }
    }
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = propertiesToTrack[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var prop = _step.value;
            vueInst.$watch(prop, requestHandle, {
                immediate: immediate
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
}

});


parcelRequire.register("6H6Oq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * @class MapElementMixin
 *
 * Extends components to include the following fields:
 *
 * @property $map        The Google map (valid only after the promise returns)
 *
 *
 * */ module.exports.default = {
    inject: {
        "$mapPromise": {
            default: "abcdef"
        }
    },
    provide: function provide() {
        var _this = this;
        // Note: although this mixin is not "providing" anything,
        // components' expect the `$map` property to be present on the component.
        // In order for that to happen, this mixin must intercept the $mapPromise
        // .then(() =>) first before its component does so.
        //
        // Since a provide() on a mixin is executed before a provide() on the
        // component, putting this code in provide() ensures that the $map is
        // already set by the time the
        // component's provide() is called.
        this.$mapPromise.then(function(map) {
            _this.$map = map;
        });
        return {};
    }
};

});




parcelRequire.register("jSVgF", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $e79f7bb096fc4787$export$b3890eb0ae9dca99; }, function (v) { return $e79f7bb096fc4787$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $e79f7bb096fc4787$export$f8436702749526f9; }, function (v) { return $e79f7bb096fc4787$export$f8436702749526f9 = v; });
var $e79f7bb096fc4787$export$b3890eb0ae9dca99;
var $e79f7bb096fc4787$export$f8436702749526f9;
var $e79f7bb096fc4787$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", [
        _c("div", {
            ref: "flyaway"
        }, [
            _vm._t("default")
        ], 2)
    ]);
};
var $e79f7bb096fc4787$var$staticRenderFns = [];
$e79f7bb096fc4787$export$b3890eb0ae9dca99 = $e79f7bb096fc4787$var$render;
$e79f7bb096fc4787$export$f8436702749526f9 = $e79f7bb096fc4787$var$staticRenderFns;

});

parcelRequire.register("ivs1J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d790dcce5f2ac700$export$2e2bcd8739ae039; });
let $d790dcce5f2ac700$var$NOOP = ()=>{};
var $d790dcce5f2ac700$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire.register("f4FUa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $af97bc331f98e449$export$2e2bcd8739ae039; });

var $af97bc331f98e449$var$scriptExports = function(x) {
    return x.default || x;
}((parcelRequire("j7k1M")));
var $af97bc331f98e449$var$options = typeof $af97bc331f98e449$var$scriptExports === "function" ? $af97bc331f98e449$var$scriptExports.options : $af97bc331f98e449$var$scriptExports;
var $af97bc331f98e449$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $af97bc331f98e449$var$options;

});
parcelRequire.register("j7k1M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $deae34dc78aa4174$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $B3efH = parcelRequire("B3efH");
var $deae34dc78aa4174$var$_bindEvents2 = $deae34dc78aa4174$var$_interopRequireDefault($B3efH);

var $3SCF9 = parcelRequire("3SCF9");

var $7ICIr = parcelRequire("7ICIr");
var $deae34dc78aa4174$var$_mountableMixin2 = $deae34dc78aa4174$var$_interopRequireDefault($7ICIr);

var $Zr2SG = parcelRequire("Zr2SG");
var $deae34dc78aa4174$var$_TwoWayBindingWrapper2 = $deae34dc78aa4174$var$_interopRequireDefault($Zr2SG);

var $fubri = parcelRequire("fubri");
var $deae34dc78aa4174$var$_WatchPrimitiveProperties2 = $deae34dc78aa4174$var$_interopRequireDefault($fubri);

var $3P0WM = parcelRequire("3P0WM");
function $deae34dc78aa4174$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $deae34dc78aa4174$var$props = {
    center: {
        required: true,
        twoWay: true,
        type: Object,
        noBind: true
    },
    zoom: {
        required: false,
        twoWay: true,
        type: Number,
        noBind: true
    },
    heading: {
        type: Number,
        twoWay: true
    },
    mapTypeId: {
        twoWay: true,
        type: String
    },
    tilt: {
        twoWay: true,
        type: Number
    },
    options: {
        type: Object,
        default: function _default() {
            return {};
        }
    }
};
var $deae34dc78aa4174$var$events = [
    "bounds_changed",
    "click",
    "dblclick",
    "drag",
    "dragend",
    "dragstart",
    "idle",
    "mousemove",
    "mouseout",
    "mouseover",
    "resize",
    "rightclick",
    "tilesloaded"
];
// Plain Google Maps methods exposed here for convenience
var $deae34dc78aa4174$var$linkedMethods = [
    "panBy",
    "panTo",
    "panToBounds",
    "fitBounds"
].reduce(function(all, methodName) {
    all[methodName] = function() {
        if (this.$mapObject) this.$mapObject[methodName].apply(this.$mapObject, arguments);
    };
    return all;
}, {});
// Other convenience methods exposed by Vue Google Maps
var $deae34dc78aa4174$var$customMethods = {
    resize: function resize() {
        if (this.$mapObject) google.maps.event.trigger(this.$mapObject, "resize");
    },
    resizePreserveCenter: function resizePreserveCenter() {
        if (!this.$mapObject) return;
        var oldCenter = this.$mapObject.getCenter();
        google.maps.event.trigger(this.$mapObject, "resize");
        this.$mapObject.setCenter(oldCenter);
    },
    /// Override mountableMixin::_resizeCallback
    /// because resizePreserveCenter is usually the
    /// expected behaviour
    _resizeCallback: function _resizeCallback() {
        this.resizePreserveCenter();
    }
};
module.exports.default = {
    mixins: [
        $deae34dc78aa4174$var$_mountableMixin2.default
    ],
    props: (0, $3P0WM.mappedPropsToVueProps)($deae34dc78aa4174$var$props),
    provide: function provide() {
        var _this = this;
        this.$mapPromise = new Promise(function(resolve, reject) {
            _this.$mapPromiseDeferred = {
                resolve: resolve,
                reject: reject
            };
        });
        return {
            "$mapPromise": this.$mapPromise
        };
    },
    computed: {
        finalLat: function finalLat() {
            return this.center && typeof this.center.lat === "function" ? this.center.lat() : this.center.lat;
        },
        finalLng: function finalLng() {
            return this.center && typeof this.center.lng === "function" ? this.center.lng() : this.center.lng;
        },
        finalLatLng: function finalLatLng() {
            return {
                lat: this.finalLat,
                lng: this.finalLng
            };
        }
    },
    watch: {
        zoom: function zoom(_zoom) {
            if (this.$mapObject) this.$mapObject.setZoom(_zoom);
        }
    },
    mounted: function mounted() {
        var _this2 = this;
        return this.$gmapApiPromiseLazy().then(function() {
            // getting the DOM element where to create the map
            var element = _this2.$refs["vue-map"];
            // creating the map
            var options = $deae34dc78aa4174$var$_extends({}, _this2.options, (0, $3SCF9.getPropsValues)(_this2, $deae34dc78aa4174$var$props));
            delete options.options;
            _this2.$mapObject = new google.maps.Map(element, options);
            // binding properties (two and one way)
            (0, $3SCF9.bindProps)(_this2, _this2.$mapObject, $deae34dc78aa4174$var$props);
            // binding events
            (0, $deae34dc78aa4174$var$_bindEvents2.default)(_this2, _this2.$mapObject, $deae34dc78aa4174$var$events);
            // manually trigger center and zoom
            (0, $deae34dc78aa4174$var$_TwoWayBindingWrapper2.default)(function(increment, decrement, shouldUpdate) {
                _this2.$mapObject.addListener("center_changed", function() {
                    if (shouldUpdate()) _this2.$emit("center_changed", _this2.$mapObject.getCenter());
                    decrement();
                });
                (0, $deae34dc78aa4174$var$_WatchPrimitiveProperties2.default)(_this2, [
                    "finalLat",
                    "finalLng"
                ], function updateCenter() {
                    increment();
                    _this2.$mapObject.setCenter(_this2.finalLatLng);
                });
            });
            _this2.$mapObject.addListener("zoom_changed", function() {
                _this2.$emit("zoom_changed", _this2.$mapObject.getZoom());
            });
            _this2.$mapObject.addListener("bounds_changed", function() {
                _this2.$emit("bounds_changed", _this2.$mapObject.getBounds());
            });
            _this2.$mapPromiseDeferred.resolve(_this2.$mapObject);
            return _this2.$mapObject;
        }).catch(function(error) {
            throw error;
        });
    },
    methods: $deae34dc78aa4174$var$_extends({}, $deae34dc78aa4174$var$customMethods, $deae34dc78aa4174$var$linkedMethods)
};

});
parcelRequire.register("7ICIr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/*
Mixin for objects that are mounted by Google Maps
Javascript API.

These are objects that are sensitive to element resize
operations so it exposes a property which accepts a bus

*/ module.exports.default = {
    props: [
        "resizeBus"
    ],
    data: function data() {
        return {
            _actualResizeBus: null
        };
    },
    created: function created() {
        if (typeof this.resizeBus === "undefined") this.$data._actualResizeBus = this.$gmapDefaultResizeBus;
        else this.$data._actualResizeBus = this.resizeBus;
    },
    methods: {
        _resizeCallback: function _resizeCallback() {
            this.resize();
        },
        _delayedResizeCallback: function _delayedResizeCallback() {
            var _this = this;
            this.$nextTick(function() {
                return _this._resizeCallback();
            });
        }
    },
    watch: {
        resizeBus: function resizeBus(newVal) {
            // eslint-disable-line no-unused-vars
            this.$data._actualResizeBus = newVal;
        },
        "$data._actualResizeBus": function $data_actualResizeBus(newVal, oldVal) {
            if (oldVal) oldVal.$off("resize", this._delayedResizeCallback);
            if (newVal) newVal.$on("resize", this._delayedResizeCallback);
        }
    },
    destroyed: function destroyed() {
        if (this.$data._actualResizeBus) this.$data._actualResizeBus.$off("resize", this._delayedResizeCallback);
    }
};

});

parcelRequire.register("Zr2SG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b8aad495e1a191e$var$TwoWayBindingWrapper;
/**
 * When you have two-way bindings, but the actual bound value will not equal
 * the value you initially passed in, then to avoid an infinite loop you
 * need to increment a counter every time you pass in a value, decrement the
 * same counter every time the bound value changed, but only bubble up
 * the event when the counter is zero.
 *
Example:

Let's say DrawingRecognitionCanvas is a deep-learning backed canvas
that, when given the name of an object (e.g. 'dog'), draws a dog.
But whenever the drawing on it changes, it also sends back its interpretation
of the image by way of the @newObjectRecognized event.

<input
  type="text"
  placeholder="an object, e.g. Dog, Cat, Frog"
  v-model="identifiedObject" />
<DrawingRecognitionCanvas
  :object="identifiedObject"
  @newObjectRecognized="identifiedObject = $event"
  />

new TwoWayBindingWrapper((increment, decrement, shouldUpdate) => {
  this.$watch('identifiedObject', () => {
    // new object passed in
    increment()
  })
  this.$deepLearningBackend.on('drawingChanged', () => {
    recognizeObject(this.$deepLearningBackend)
      .then((object) => {
        decrement()
        if (shouldUpdate()) {
          this.$emit('newObjectRecognized', object.name)
        }
      })
  })
})
 */ function $0b8aad495e1a191e$var$TwoWayBindingWrapper(fn) {
    var counter = 0;
    fn(function() {
        counter += 1;
    }, function() {
        counter = Math.max(0, counter - 1);
    }, function() {
        return counter === 0;
    });
}

});



parcelRequire.register("eT7TD", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $ad6c53c8f4933254$export$b3890eb0ae9dca99; }, function (v) { return $ad6c53c8f4933254$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $ad6c53c8f4933254$export$f8436702749526f9; }, function (v) { return $ad6c53c8f4933254$export$f8436702749526f9 = v; });
var $ad6c53c8f4933254$export$b3890eb0ae9dca99;
var $ad6c53c8f4933254$export$f8436702749526f9;
var $ad6c53c8f4933254$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", {
        staticClass: "vue-map-container"
    }, [
        _c("div", {
            ref: "vue-map",
            staticClass: "vue-map"
        }),
        _vm._v(" "),
        _c("div", {
            staticClass: "vue-map-hidden"
        }, [
            _vm._t("default")
        ], 2),
        _vm._v(" "),
        _vm._t("visible")
    ], 2);
};
var $ad6c53c8f4933254$var$staticRenderFns = [];
$ad6c53c8f4933254$export$b3890eb0ae9dca99 = $ad6c53c8f4933254$var$render;
$ad6c53c8f4933254$export$f8436702749526f9 = $ad6c53c8f4933254$var$staticRenderFns;

});

parcelRequire.register("crHYS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02569d68961c2e67$export$2e2bcd8739ae039; });
let $02569d68961c2e67$var$NOOP = ()=>{};
var $02569d68961c2e67$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire.register("kT3cN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f34b6e39ae220585$export$2e2bcd8739ae039; });

var $f34b6e39ae220585$var$scriptExports = function(x) {
    return x.default || x;
}((parcelRequire("dUdND")));
var $f34b6e39ae220585$var$options = typeof $f34b6e39ae220585$var$scriptExports === "function" ? $f34b6e39ae220585$var$scriptExports.options : $f34b6e39ae220585$var$scriptExports;
var $f34b6e39ae220585$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $f34b6e39ae220585$var$options;

});
parcelRequire.register("dUdND", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a1fb359ba04be815$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $B3efH = parcelRequire("B3efH");
var $a1fb359ba04be815$var$_bindEvents2 = $a1fb359ba04be815$var$_interopRequireDefault($B3efH);

var $3SCF9 = parcelRequire("3SCF9");

var $7ICIr = parcelRequire("7ICIr");
var $a1fb359ba04be815$var$_mountableMixin2 = $a1fb359ba04be815$var$_interopRequireDefault($7ICIr);

var $Zr2SG = parcelRequire("Zr2SG");
var $a1fb359ba04be815$var$_TwoWayBindingWrapper2 = $a1fb359ba04be815$var$_interopRequireDefault($Zr2SG);

var $fubri = parcelRequire("fubri");
var $a1fb359ba04be815$var$_WatchPrimitiveProperties2 = $a1fb359ba04be815$var$_interopRequireDefault($fubri);

var $3P0WM = parcelRequire("3P0WM");
function $a1fb359ba04be815$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a1fb359ba04be815$var$props = {
    zoom: {
        twoWay: true,
        type: Number
    },
    pov: {
        twoWay: true,
        type: Object,
        trackProperties: [
            "pitch",
            "heading"
        ]
    },
    position: {
        twoWay: true,
        type: Object,
        noBind: true
    },
    pano: {
        twoWay: true,
        type: String
    },
    motionTracking: {
        twoWay: false,
        type: Boolean
    },
    visible: {
        twoWay: true,
        type: Boolean,
        default: true
    },
    options: {
        twoWay: false,
        type: Object,
        default: function _default() {
            return {};
        }
    }
};
var $a1fb359ba04be815$var$events = [
    "closeclick",
    "status_changed"
];
module.exports.default = {
    mixins: [
        $a1fb359ba04be815$var$_mountableMixin2.default
    ],
    props: (0, $3P0WM.mappedPropsToVueProps)($a1fb359ba04be815$var$props),
    replace: false,
    methods: {
        resize: function resize() {
            if (this.$panoObject) google.maps.event.trigger(this.$panoObject, "resize");
        }
    },
    provide: function provide() {
        var _this = this;
        var promise = new Promise(function(resolve, reject) {
            _this.$panoPromiseDeferred = {
                resolve: resolve,
                reject: reject
            };
        });
        return {
            "$panoPromise": promise,
            "$mapPromise": promise // so that we can use it with markers
        };
    },
    computed: {
        finalLat: function finalLat() {
            return this.position && typeof this.position.lat === "function" ? this.position.lat() : this.position.lat;
        },
        finalLng: function finalLng() {
            return this.position && typeof this.position.lng === "function" ? this.position.lng() : this.position.lng;
        },
        finalLatLng: function finalLatLng() {
            return {
                lat: this.finalLat,
                lng: this.finalLng
            };
        }
    },
    watch: {
        zoom: function zoom(_zoom) {
            if (this.$panoObject) this.$panoObject.setZoom(_zoom);
        }
    },
    mounted: function mounted() {
        var _this2 = this;
        return this.$gmapApiPromiseLazy().then(function() {
            // getting the DOM element where to create the map
            var element = _this2.$refs["vue-street-view-pano"];
            // creating the map
            var options = $a1fb359ba04be815$var$_extends({}, _this2.options, (0, $3SCF9.getPropsValues)(_this2, $a1fb359ba04be815$var$props));
            delete options.options;
            _this2.$panoObject = new google.maps.StreetViewPanorama(element, options);
            // binding properties (two and one way)
            (0, $3SCF9.bindProps)(_this2, _this2.$panoObject, $a1fb359ba04be815$var$props);
            // binding events
            (0, $a1fb359ba04be815$var$_bindEvents2.default)(_this2, _this2.$panoObject, $a1fb359ba04be815$var$events);
            // manually trigger position
            (0, $a1fb359ba04be815$var$_TwoWayBindingWrapper2.default)(function(increment, decrement, shouldUpdate) {
                // Panos take a while to load
                increment();
                _this2.$panoObject.addListener("position_changed", function() {
                    if (shouldUpdate()) _this2.$emit("position_changed", _this2.$panoObject.getPosition());
                    decrement();
                });
                (0, $a1fb359ba04be815$var$_WatchPrimitiveProperties2.default)(_this2, [
                    "finalLat",
                    "finalLng"
                ], function updateCenter() {
                    increment();
                    _this2.$panoObject.setPosition(_this2.finalLatLng);
                });
            });
            _this2.$panoPromiseDeferred.resolve(_this2.$panoObject);
            return _this2.$panoPromise;
        }).catch(function(error) {
            throw error;
        });
    }
};

});


parcelRequire.register("g4sLo", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $bb3354dee5bdb465$export$b3890eb0ae9dca99; }, function (v) { return $bb3354dee5bdb465$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $bb3354dee5bdb465$export$f8436702749526f9; }, function (v) { return $bb3354dee5bdb465$export$f8436702749526f9 = v; });
var $bb3354dee5bdb465$export$b3890eb0ae9dca99;
var $bb3354dee5bdb465$export$f8436702749526f9;
var $bb3354dee5bdb465$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", {
        staticClass: "vue-street-view-pano-container"
    }, [
        _c("div", {
            ref: "vue-street-view-pano",
            staticClass: "vue-street-view-pano"
        }),
        _vm._v(" "),
        _vm._t("default")
    ], 2);
};
var $bb3354dee5bdb465$var$staticRenderFns = [];
$bb3354dee5bdb465$export$b3890eb0ae9dca99 = $bb3354dee5bdb465$var$render;
$bb3354dee5bdb465$export$f8436702749526f9 = $bb3354dee5bdb465$var$staticRenderFns;

});

parcelRequire.register("gJBUS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2ee42b85a647614$export$2e2bcd8739ae039; });
let $c2ee42b85a647614$var$NOOP = ()=>{};
var $c2ee42b85a647614$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire.register("9UsEM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3SCF9 = parcelRequire("3SCF9");

var $lp3D5 = parcelRequire("lp3D5");
var $736f92aab7b99edf$var$_simulateArrowDown2 = $736f92aab7b99edf$var$_interopRequireDefault($lp3D5);
function $736f92aab7b99edf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $736f92aab7b99edf$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $736f92aab7b99edf$var$props = {
    bounds: {
        type: Object
    },
    defaultPlace: {
        type: String,
        default: ""
    },
    componentRestrictions: {
        type: Object,
        default: null
    },
    types: {
        type: Array,
        default: function _default() {
            return [];
        }
    },
    placeholder: {
        required: false,
        type: String
    },
    className: {
        required: false,
        type: String
    },
    label: {
        required: false,
        type: String,
        default: null
    },
    selectFirstOnEnter: {
        require: false,
        type: Boolean,
        default: false
    }
};
module.exports.default = {
    mounted: function mounted() {
        var _this = this;
        var input = this.$refs.input;
        // Allow default place to be set
        input.value = this.defaultPlace;
        this.$watch("defaultPlace", function() {
            input.value = _this.defaultPlace;
        });
        this.$gmapApiPromiseLazy().then(function() {
            var options = (0, $3SCF9.getPropsValues)(_this, $736f92aab7b99edf$var$props);
            if (_this.selectFirstOnEnter) (0, $736f92aab7b99edf$var$_simulateArrowDown2.default)(_this.$refs.input);
            if (typeof google.maps.places.Autocomplete !== "function") throw new Error("google.maps.places.Autocomplete is undefined. Did you add 'places' to libraries when loading Google Maps?");
            _this.autoCompleter = new google.maps.places.Autocomplete(_this.$refs.input, options);
            var placeholder = $736f92aab7b99edf$var$props.placeholder, place = $736f92aab7b99edf$var$props.place, defaultPlace = $736f92aab7b99edf$var$props.defaultPlace, className = $736f92aab7b99edf$var$props.className, label = $736f92aab7b99edf$var$props.label, selectFirstOnEnter = $736f92aab7b99edf$var$props.selectFirstOnEnter, rest = $736f92aab7b99edf$var$_objectWithoutProperties($736f92aab7b99edf$var$props, [
                "placeholder",
                "place",
                "defaultPlace",
                "className",
                "label",
                "selectFirstOnEnter"
            ]); // eslint-disable-line
            (0, $3SCF9.bindProps)(_this, _this.autoCompleter, rest);
            _this.autoCompleter.addListener("place_changed", function() {
                _this.$emit("place_changed", _this.autoCompleter.getPlace());
            });
        });
    },
    created: function created() {
        console.warn("The PlaceInput class is deprecated! Please consider using the Autocomplete input instead"); // eslint-disable-line no-console
    },
    props: $736f92aab7b99edf$var$props
};

});
parcelRequire.register("lp3D5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// This piece of code was orignally written by amirnissim and can be seen here
// http://stackoverflow.com/a/11703018/2694653
// This has been ported to Vanilla.js by GuillaumeLeclerc
module.exports.default = function(input) {
    var _addEventListener = input.addEventListener ? input.addEventListener : input.attachEvent;
    function addEventListenerWrapper(type, listener) {
        // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
        // and then trigger the original listener.
        if (type === "keydown") {
            var origListener = listener;
            listener = function(event) {
                var suggestionSelected = document.getElementsByClassName("pac-item-selected").length > 0;
                if (event.which === 13 && !suggestionSelected) {
                    var simulatedEvent = document.createEvent("Event");
                    simulatedEvent.keyCode = 40;
                    simulatedEvent.which = 40;
                    origListener.apply(input, [
                        simulatedEvent
                    ]);
                }
                origListener.apply(input, [
                    event
                ]);
            };
        }
        _addEventListener.apply(input, [
            type,
            listener
        ]);
    }
    input.addEventListener = addEventListenerWrapper;
    input.attachEvent = addEventListenerWrapper;
};

});


parcelRequire.register("knm8z", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $ed57209c493bc2bb$export$b3890eb0ae9dca99; }, function (v) { return $ed57209c493bc2bb$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $ed57209c493bc2bb$export$f8436702749526f9; }, function (v) { return $ed57209c493bc2bb$export$f8436702749526f9 = v; });
var $ed57209c493bc2bb$export$b3890eb0ae9dca99;
var $ed57209c493bc2bb$export$f8436702749526f9;
var $ed57209c493bc2bb$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("label", [
        _c("span", {
            domProps: {
                "textContent": _vm._s(_vm.label)
            }
        }),
        _vm._v(" "),
        _c("input", {
            ref: "input",
            class: _vm.className,
            attrs: {
                "type": "text",
                "placeholder": _vm.placeholder
            }
        })
    ]);
};
var $ed57209c493bc2bb$var$staticRenderFns = [];
$ed57209c493bc2bb$export$b3890eb0ae9dca99 = $ed57209c493bc2bb$var$render;
$ed57209c493bc2bb$export$f8436702749526f9 = $ed57209c493bc2bb$var$staticRenderFns;

});

parcelRequire.register("hiWaH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9913dc484f00d93$export$2e2bcd8739ae039; });
let $c9913dc484f00d93$var$NOOP = ()=>{};
var $c9913dc484f00d93$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire.register("1QxqX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $15849503c15059ed$export$2e2bcd8739ae039; });

var $15849503c15059ed$var$scriptExports = function(x) {
    return x.default || x;
}((parcelRequire("48CjU")));
var $15849503c15059ed$var$options = typeof $15849503c15059ed$var$scriptExports === "function" ? $15849503c15059ed$var$scriptExports.options : $15849503c15059ed$var$scriptExports;
var $15849503c15059ed$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $15849503c15059ed$var$options;

});
parcelRequire.register("48CjU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3035a25cd723fa31$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $3SCF9 = parcelRequire("3SCF9");

var $lp3D5 = parcelRequire("lp3D5");
var $3035a25cd723fa31$var$_simulateArrowDown2 = $3035a25cd723fa31$var$_interopRequireDefault($lp3D5);

var $3P0WM = parcelRequire("3P0WM");
function $3035a25cd723fa31$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3035a25cd723fa31$var$mappedProps = {
    bounds: {
        type: Object
    },
    componentRestrictions: {
        type: Object,
        // Do not bind -- must check for undefined
        // in the property
        noBind: true
    },
    types: {
        type: Array,
        default: function _default() {
            return [];
        }
    }
};
var $3035a25cd723fa31$var$props = {
    selectFirstOnEnter: {
        required: false,
        type: Boolean,
        default: false
    },
    options: {
        type: Object
    }
};
module.exports.default = {
    mounted: function mounted() {
        var _this = this;
        this.$gmapApiPromiseLazy().then(function() {
            if (_this.selectFirstOnEnter) (0, $3035a25cd723fa31$var$_simulateArrowDown2.default)(_this.$refs.input);
            if (typeof google.maps.places.Autocomplete !== "function") throw new Error("google.maps.places.Autocomplete is undefined. Did you add 'places' to libraries when loading Google Maps?");
            /* eslint-disable no-unused-vars */ var finalOptions = $3035a25cd723fa31$var$_extends({}, (0, $3SCF9.getPropsValues)(_this, $3035a25cd723fa31$var$mappedProps), _this.options);
            _this.$autocomplete = new google.maps.places.Autocomplete(_this.$refs.input, finalOptions);
            (0, $3SCF9.bindProps)(_this, _this.$autocomplete, $3035a25cd723fa31$var$mappedProps);
            _this.$watch("componentRestrictions", function(v) {
                if (v !== undefined) _this.$autocomplete.setComponentRestrictions(v);
            });
            // Not using `bindEvents` because we also want
            // to return the result of `getPlace()`
            _this.$autocomplete.addListener("place_changed", function() {
                _this.$emit("place_changed", _this.$autocomplete.getPlace());
            });
        });
    },
    props: $3035a25cd723fa31$var$_extends({}, (0, $3P0WM.mappedPropsToVueProps)($3035a25cd723fa31$var$mappedProps), $3035a25cd723fa31$var$props)
};

});


parcelRequire.register("cd2Go", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $8e38c7b12beb1d3b$export$b3890eb0ae9dca99; }, function (v) { return $8e38c7b12beb1d3b$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $8e38c7b12beb1d3b$export$f8436702749526f9; }, function (v) { return $8e38c7b12beb1d3b$export$f8436702749526f9 = v; });
var $8e38c7b12beb1d3b$export$b3890eb0ae9dca99;
var $8e38c7b12beb1d3b$export$f8436702749526f9;
var $8e38c7b12beb1d3b$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("input", _vm._g(_vm._b({
        ref: "input"
    }, "input", _vm.$attrs, false), _vm.$listeners));
};
var $8e38c7b12beb1d3b$var$staticRenderFns = [];
$8e38c7b12beb1d3b$export$b3890eb0ae9dca99 = $8e38c7b12beb1d3b$var$render;
$8e38c7b12beb1d3b$export$f8436702749526f9 = $8e38c7b12beb1d3b$var$staticRenderFns;

});

parcelRequire.register("f4fmr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af83251402bcb2e3$export$2e2bcd8739ae039; });
let $af83251402bcb2e3$var$NOOP = ()=>{};
var $af83251402bcb2e3$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire.register("kBln0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $eff7d7000286f201$export$2e2bcd8739ae039; });

var $jAv3h = parcelRequire("jAv3h");
parcelRequire("fXhd6");

var $a9ufu = parcelRequire("a9ufu");

var $3EdsD = parcelRequire("3EdsD");

var $6XlU4 = parcelRequire("6XlU4");

var $2uJKh = parcelRequire("2uJKh");

var $fxJ9Z = parcelRequire("fxJ9Z");

var $dDOAs = parcelRequire("dDOAs");

var $67Buk = parcelRequire("67Buk");

var $lMoeL = parcelRequire("lMoeL");

var $d67vX = parcelRequire("d67vX");

var $kHxEk = parcelRequire("kHxEk");

var $dY8jF = parcelRequire("dY8jF");

const $eff7d7000286f201$var$state = (parcelRequire("cUFT1"))({
    autoApply: false
});
var $eff7d7000286f201$var$scriptExports = {
    components: {
        LoadingBar: $3EdsD.default,
        FilterCategories: $6XlU4.default,
        FilterMinMaxPrice: $2uJKh.default,
        FilterRooms: $fxJ9Z.default,
        FilterStatus: $dDOAs.default,
        FilterSort: $67Buk.default,
        MapView: $lMoeL.default,
        SearchFilter: $d67vX.default,
        CardDefault: $kHxEk.default,
        CardAlt: $dY8jF.default
    },
    props: {
        component: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            estateData: false,
            isLoading: false,
            markersLoaded: false,
            store: {
                filters: {
                    showFilter: true,
                    status: false,
                    categories: [],
                    min_price: false,
                    max_price: false,
                    rooms: false,
                    location: {
                        region: "",
                        lat: false,
                        lng: false
                    },
                    sort: {
                        orderBy: "relevance",
                        order: "desc"
                    }
                },
                mapMode: false,
                locales: {
                    nl: {
                        filter: "Filter",
                        empty_filter: "<p>Er zijn geen resultaten.</p><p>U kunt proberen de zoekcriteria te wijzigen.</p>",
                        show_results: "Toon resultaten",
                        back_to_overview: "Terug naar overzicht",
                        to: "Tot",
                        search: "Kies een gemeente...",
                        rooms: "Slaapkamers",
                        total_results: "panden gevonden",
                        view_map: "Kaartweergave",
                        view_list: "Lijstweergave",
                        only_available: "Enkel beschikbaar",
                        units_in: "units in",
                        more_info: "Meer info",
                        starting_from: "Prijs vanaf",
                        no_results: "Het spijt ons, maar we konden geen panden vinden die aan uw criteria voldoen.",
                        categories: {
                            label: "Categorie\xebn",
                            house: "Huis",
                            apartment: "Appartement",
                            commercial: "Commercieel",
                            land: "Grond",
                            office: "Kantoor",
                            parking: "Parking"
                        },
                        sort: {
                            label: "Sorteer op",
                            relevance: "Relevantie",
                            price_h_l: "Prijs ↑",
                            price_l_h: "Prijs ↓",
                            date_h_l: "Datum ↑",
                            date_l_h: "Datum ↓"
                        },
                        min_price: "Minimum €",
                        max_price: "Maximum €",
                        sold: "Verkocht",
                        rented: "Verhuurd",
                        option: "In optie",
                        under_contract: "Onder contract",
                        open_home: "Opendeur",
                        let: "Te huur",
                        sale: "Te koop"
                    },
                    fr: {
                        filter: "Filtrer",
                        empty_filter: "<p>Aucun r\xe9sultat.</p><p>Vous pouvez essayer de modifier les crit\xe8res de recherche.</p>",
                        show_results: "Afficher les r\xe9sultats",
                        back_to_overview: "Retour \xe0 l'aper\xe7u",
                        to: "\xe0",
                        search: "Choisissez une commune...",
                        rooms: "Chambres",
                        total_results: "propri\xe9t\xe9s trouv\xe9es",
                        view_map: "Vue carte",
                        view_list: "Vue liste",
                        only_available: "Seulement disponible",
                        units_in: "unit\xe9s \xe0",
                        more_info: "Plus d'info",
                        starting_from: "\xc0 partir de",
                        no_results: "Nous sommes d\xe9sol\xe9s mais nous n'avons pas trouv\xe9 de propri\xe9t\xe9s correspondant \xe0 vos crit\xe8res.",
                        categories: {
                            label: "Cat\xe9gories",
                            house: "Maison",
                            apartment: "Appartement",
                            commercial: "Commercial",
                            land: "Terrain",
                            office: "Bureau",
                            parking: "Parking"
                        },
                        sort: {
                            label: "Trier par",
                            relevance: "Pertinence",
                            price_h_l: "Prix ↑",
                            price_l_h: "Prix ↓",
                            date_h_l: "Date ↑",
                            date_l_h: "Date ↓"
                        },
                        min_price: "Minimum €",
                        max_price: "Maximum €",
                        sold: "Vendu",
                        rented: "Lou\xe9",
                        option: "En option",
                        under_contract: "Sous contrat",
                        open_home: "Journ\xe9e portes ouvertes"
                    }
                }
            }
        };
    },
    mounted () {
        this.responsiveFilter();
        (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))(window).resize(()=>{
            this.responsiveFilter();
        });
        this.estateData = window.estateData[this.component];
        this.setDefaultFilters();
        this.setCache();
        this.setRouter();
        this.setListeners();
        this.$list();
    },
    methods: {
        setRouter () {
            window.addEventListener("popstate", ()=>{
                this.setFilters();
                this.load();
            });
            this.setFilters();
        },
        setCache () {
            this.requestCache = JSON.parse(JSON.stringify(this.request));
            this.store.filtersCache = JSON.parse(JSON.stringify(this.store.filters));
        },
        setDefaultCache () {
            this.request = JSON.parse(JSON.stringify(this.requestCache));
            this.store.filters = JSON.parse(JSON.stringify(this.store.filtersCache));
        },
        setDefaultFilters () {
            // Set default negotiation
            switch(this.estateData.type){
                case "let":
                    this.request.filters.negotiation = "let";
                    break;
                case "sale":
                    this.request.filters.negotiation = "sale_non_projects";
                    break;
                case "projects":
                    this.request.filters.negotiation = "projects";
                    break;
                default:
                    break;
            }
            // Set agent filter for Spain
            if (this.estateData.type === "spain") this.request.filters.agent = [
                "espagne@vosagences.be"
            ];
            // Set the status to 'available' by default
            if (this.estateData.mode !== "latest" && (this.estateData.type === "let" || this.estateData.type === "sale")) {
                this.request.filters.agent = [
                    "ardenne@vosagences.be",
                    "ciney@vosagences.be",
                    "marche@vosagences.be",
                    "dinant@vosagences.be",
                    "beauraing@vosagences.be",
                    "immoaht@vosagences.be"
                ];
                this.request.filters.status = "available";
                this.store.filters.status = true;
            } else if (this.estateData.type === "rented_sold") this.request.filters.status = [
                "sold",
                "rented"
            ];
            else // Update the filter value dynamically
            this.store.filters.status = false;
            // Set default mode
            if (this.estateData.mode === "latest") this.request.recent = 3;
        },
        setListeners () {
            (0, $a9ufu.default).$on("setData", (item)=>{
                // Location
                if (item.id === "location") {
                    if (item.data.region && item.data.location) {
                        $eff7d7000286f201$var$state.set("region", item.data.region);
                        $eff7d7000286f201$var$state.set("lat", item.data.location.lat);
                        $eff7d7000286f201$var$state.set("lng", item.data.location.lng);
                    } else {
                        $eff7d7000286f201$var$state.remove("region");
                        $eff7d7000286f201$var$state.remove("lat");
                        $eff7d7000286f201$var$state.remove("lng");
                    }
                    $eff7d7000286f201$var$state.apply();
                }
                // Sort
                if (item.id === "sort") {
                    $eff7d7000286f201$var$state.set("order", item.data.order);
                    $eff7d7000286f201$var$state.set("orderBy", item.data.orderBy);
                    $eff7d7000286f201$var$state.apply();
                }
                // Status
                if (item.id === "status") {
                    $eff7d7000286f201$var$state.set("only_available", item.data);
                    $eff7d7000286f201$var$state.apply();
                }
                // Categories
                if (item.id === "categories") {
                    if (item.data.length > 0) {
                        const categories = [];
                        item.data.forEach((element)=>{
                            categories.push(element.value);
                        });
                        $eff7d7000286f201$var$state.set("categories", categories.join("+"));
                    } else $eff7d7000286f201$var$state.remove("categories");
                    $eff7d7000286f201$var$state.apply();
                }
                // Min/max price
                if (item.id === "min_max_price") {
                    if (item.data.min) $eff7d7000286f201$var$state.set("min_price", item.data.min);
                    else $eff7d7000286f201$var$state.remove("min_price");
                    if (item.data.max) $eff7d7000286f201$var$state.set("max_price", item.data.max);
                    else $eff7d7000286f201$var$state.remove("max_price");
                    $eff7d7000286f201$var$state.apply();
                }
                // Rooms
                if (item.id === "rooms") {
                    if (item.data) $eff7d7000286f201$var$state.set("rooms", item.data);
                    else $eff7d7000286f201$var$state.remove("rooms");
                    $eff7d7000286f201$var$state.apply();
                }
                this.setFilters();
                this.load();
            });
        },
        setFilters () {
            // Reset request & filters
            this.setDefaultCache();
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            // Default filter values
            const data = JSON.parse(JSON.stringify(this.store.filtersCache));
            // Location
            if (urlParams.has("region") && urlParams.has("lat") && urlParams.has("lng")) {
                data.location.region = urlParams.get("region");
                data.location.lat = parseFloat(urlParams.get("lat"));
                data.location.lng = parseFloat(urlParams.get("lng"));
                this.request.filters.location.region = data.location.region;
                this.request.filters.location.lat = data.location.lat;
                this.request.filters.location.lng = data.location.lng;
            }
            // Categories
            if (urlParams.has("categories") && urlParams.get("categories")) {
                const categories = urlParams.get("categories").split("+");
                categories.forEach((element)=>{
                    data.categories.push(element);
                });
                this.request.filters.category = data.categories;
            }
            // Min / max price
            if (urlParams.has("max_price")) {
                data.max_price = parseInt(urlParams.get("max_price"), 10);
                this.request.filters.price.max = data.max_price;
            }
            if (urlParams.has("min_price")) {
                data.min_price = parseInt(urlParams.get("min_price"), 10);
                this.request.filters.price.min = data.min_price;
            }
            // Rooms
            if (urlParams.has("rooms")) {
                data.rooms = parseInt(urlParams.get("rooms"), 10);
                this.request.filters.facilities.bedrooms.min = data.rooms;
            }
            // Status
            if (urlParams.has("only_available") && urlParams.get("only_available") === "false") {
                data.status = false;
                this.request.filters.status = false;
            } else if (urlParams.has("only_available") && urlParams.get("only_available") === "true") {
                data.status = true;
                this.request.filters.status = "available";
            }
            // Sort
            if (urlParams.has("order") && urlParams.has("orderBy")) {
                data.sort = {
                    order: urlParams.get("order"),
                    orderBy: urlParams.get("orderBy")
                };
                this.request.sort.order = data.sort.order;
                this.request.sort.orderBy = data.sort.orderBy;
            }
            // Set filter component data
            this.updateFilters("status", data);
            this.updateFilters("categories", data);
            this.updateFilters("min_price", data);
            this.updateFilters("max_price", data);
            this.updateFilters("rooms", data);
            this.updateFilters("sort", data);
            this.updateFilters("location", data);
        },
        updateFilters (id, data) {
            this.$nextTick(()=>{
                (0, $a9ufu.default).$emit("updateData", {
                    id: id,
                    data: data[id]
                });
            });
        },
        load () {
            if (this.store.mapMode) this.$search({
                mapMode: true
            });
            else this.$search();
        },
        loadMap () {
            this.store.mapMode = !this.store.mapMode;
            if (this.store.mapMode) {
                this.$search({
                    mapMode: true
                });
                window.addEventListener("loadedMap", ()=>{
                    this.$gmapApiPromiseLazy().then(()=>{
                        this.markersLoaded = true;
                        this.isLoading = false;
                    });
                });
            }
        },
        toggleFilter () {
            this.showFilter = !this.showFilter;
            if (this.showFilter) {
                this.$nextTick(()=>{
                    this.setFilters();
                });
                document.querySelector("body").classList.add("overflow-hidden", "h-screen");
            } else document.querySelector("body").classList.remove("overflow-hidden", "h-screen");
            this.$forceUpdate();
        },
        responsiveFilter () {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))(window).width() < 1024) this.showFilter = false;
            else {
                this.showFilter = true;
                document.querySelector("body").classList.remove("overflow-hidden", "h-screen");
            }
            this.$forceUpdate();
        }
    }
};
var $eff7d7000286f201$var$options = typeof $eff7d7000286f201$var$scriptExports === "function" ? $eff7d7000286f201$var$scriptExports.options : $eff7d7000286f201$var$scriptExports;
var $eff7d7000286f201$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $eff7d7000286f201$var$options;

});
parcelRequire.register("fXhd6", function(module, exports) {
/**!
 * url-search-params-polyfill
 *
 * @author Jerry Bendy (https://github.com/jerrybendy)
 * @licence MIT
 */ (function(self) {
    "use strict";
    var nativeURLSearchParams = function() {
        // #41 Fix issue in RN
        try {
            if (self.URLSearchParams && new self.URLSearchParams("foo=bar").get("foo") === "bar") return self.URLSearchParams;
        } catch (e) {}
        return null;
    }(), isSupportObjectConstructor = nativeURLSearchParams && new nativeURLSearchParams({
        a: 1
    }).toString() === "a=1", // There is a bug in safari 10.1 (and earlier) that incorrectly decodes `%2B` as an empty space and not a plus.
    decodesPlusesCorrectly = nativeURLSearchParams && new nativeURLSearchParams("s=%2B").get("s") === "+", isSupportSize = nativeURLSearchParams && "size" in nativeURLSearchParams.prototype, __URLSearchParams__ = "__URLSearchParams__", // Fix bug in Edge which cannot encode ' &' correctly
    encodesAmpersandsCorrectly = nativeURLSearchParams ? function() {
        var ampersandTest = new nativeURLSearchParams();
        ampersandTest.append("s", " &");
        return ampersandTest.toString() === "s=+%26";
    }() : true, prototype = URLSearchParamsPolyfill.prototype, iterable = !!(self.Symbol && self.Symbol.iterator);
    if (nativeURLSearchParams && isSupportObjectConstructor && decodesPlusesCorrectly && encodesAmpersandsCorrectly && isSupportSize) return;
    /**
     * Make a URLSearchParams instance
     *
     * @param {object|string|URLSearchParams} search
     * @constructor
     */ function URLSearchParamsPolyfill(search) {
        search = search || "";
        // support construct object with another URLSearchParams instance
        if (search instanceof URLSearchParams || search instanceof URLSearchParamsPolyfill) search = search.toString();
        this[__URLSearchParams__] = parseToDict(search);
    }
    /**
     * Appends a specified key/value pair as a new search parameter.
     *
     * @param {string} name
     * @param {string} value
     */ prototype.append = function(name, value) {
        appendTo(this[__URLSearchParams__], name, value);
    };
    /**
     * Deletes the given search parameter, and its associated value,
     * from the list of all search parameters.
     *
     * @param {string} name
     */ prototype["delete"] = function(name) {
        delete this[__URLSearchParams__][name];
    };
    /**
     * Returns the first value associated to the given search parameter.
     *
     * @param {string} name
     * @returns {string|null}
     */ prototype.get = function(name) {
        var dict = this[__URLSearchParams__];
        return this.has(name) ? dict[name][0] : null;
    };
    /**
     * Returns all the values association with a given search parameter.
     *
     * @param {string} name
     * @returns {Array}
     */ prototype.getAll = function(name) {
        var dict = this[__URLSearchParams__];
        return this.has(name) ? dict[name].slice(0) : [];
    };
    /**
     * Returns a Boolean indicating if such a search parameter exists.
     *
     * @param {string} name
     * @returns {boolean}
     */ prototype.has = function(name) {
        return hasOwnProperty(this[__URLSearchParams__], name);
    };
    /**
     * Sets the value associated to a given search parameter to
     * the given value. If there were several values, delete the
     * others.
     *
     * @param {string} name
     * @param {string} value
     */ prototype.set = function set(name, value) {
        this[__URLSearchParams__][name] = [
            "" + value
        ];
    };
    /**
     * Returns a string containg a query string suitable for use in a URL.
     *
     * @returns {string}
     */ prototype.toString = function() {
        var dict = this[__URLSearchParams__], query = [], i, key, name, value;
        for(key in dict){
            name = encode(key);
            for(i = 0, value = dict[key]; i < value.length; i++)query.push(name + "=" + encode(value[i]));
        }
        return query.join("&");
    };
    // There is a bug in Safari 10.1 and `Proxy`ing it is not enough.
    var useProxy = self.Proxy && nativeURLSearchParams && (!decodesPlusesCorrectly || !encodesAmpersandsCorrectly || !isSupportObjectConstructor || !isSupportSize);
    var propValue;
    if (useProxy) {
        // Safari 10.0 doesn't support Proxy, so it won't extend URLSearchParams on safari 10.0
        propValue = new Proxy(nativeURLSearchParams, {
            construct: function(target, args) {
                return new target(new URLSearchParamsPolyfill(args[0]).toString());
            }
        });
        // Chrome <=60 .toString() on a function proxy got error "Function.prototype.toString is not generic"
        propValue.toString = Function.prototype.toString.bind(URLSearchParamsPolyfill);
    } else propValue = URLSearchParamsPolyfill;
    /*
     * Apply polyfill to global object and append other prototype into it
     */ Object.defineProperty(self, "URLSearchParams", {
        value: propValue
    });
    var USPProto = self.URLSearchParams.prototype;
    USPProto.polyfill = true;
    // Fix #54, `toString.call(new URLSearchParams)` will return correct value when Proxy not used
    if (!useProxy && self.Symbol) USPProto[self.Symbol.toStringTag] = "URLSearchParams";
    /**
     *
     * @param {function} callback
     * @param {object} thisArg
     */ if (!("forEach" in USPProto)) USPProto.forEach = function(callback, thisArg) {
        var dict = parseToDict(this.toString());
        Object.getOwnPropertyNames(dict).forEach(function(name) {
            dict[name].forEach(function(value) {
                callback.call(thisArg, value, name, this);
            }, this);
        }, this);
    };
    /**
     * Sort all name-value pairs
     */ if (!("sort" in USPProto)) USPProto.sort = function() {
        var dict = parseToDict(this.toString()), keys = [], k, i, j;
        for(k in dict)keys.push(k);
        keys.sort();
        for(i = 0; i < keys.length; i++)this["delete"](keys[i]);
        for(i = 0; i < keys.length; i++){
            var key = keys[i], values = dict[key];
            for(j = 0; j < values.length; j++)this.append(key, values[j]);
        }
    };
    /**
     * Returns an iterator allowing to go through all keys of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */ if (!("keys" in USPProto)) USPProto.keys = function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push(name);
        });
        return makeIterator(items);
    };
    /**
     * Returns an iterator allowing to go through all values of
     * the key/value pairs contained in this object.
     *
     * @returns {function}
     */ if (!("values" in USPProto)) USPProto.values = function() {
        var items = [];
        this.forEach(function(item) {
            items.push(item);
        });
        return makeIterator(items);
    };
    /**
     * Returns an iterator allowing to go through all key/value
     * pairs contained in this object.
     *
     * @returns {function}
     */ if (!("entries" in USPProto)) USPProto.entries = function() {
        var items = [];
        this.forEach(function(item, name) {
            items.push([
                name,
                item
            ]);
        });
        return makeIterator(items);
    };
    if (iterable) USPProto[self.Symbol.iterator] = USPProto[self.Symbol.iterator] || USPProto.entries;
    if (!("size" in USPProto)) Object.defineProperty(USPProto, "size", {
        get: function() {
            var dict = parseToDict(this.toString());
            if (USPProto === this) throw new TypeError("Illegal invocation at URLSearchParams.invokeGetter");
            return Object.keys(dict).reduce(function(prev, cur) {
                return prev + dict[cur].length;
            }, 0);
        }
    });
    function encode(str) {
        var replace = {
            "!": "%21",
            "'": "%27",
            "(": "%28",
            ")": "%29",
            "~": "%7E",
            "%20": "+",
            "%00": "\x00"
        };
        return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function(match) {
            return replace[match];
        });
    }
    function decode(str) {
        return str.replace(/[ +]/g, "%20").replace(/(%[a-f0-9]{2})+/ig, function(match) {
            return decodeURIComponent(match);
        });
    }
    function makeIterator(arr) {
        var iterator = {
            next: function() {
                var value = arr.shift();
                return {
                    done: value === undefined,
                    value: value
                };
            }
        };
        if (iterable) iterator[self.Symbol.iterator] = function() {
            return iterator;
        };
        return iterator;
    }
    function parseToDict(search) {
        var dict = {};
        if (typeof search === "object") {
            // if `search` is an array, treat it as a sequence
            if (isArray(search)) for(var i = 0; i < search.length; i++){
                var item = search[i];
                if (isArray(item) && item.length === 2) appendTo(dict, item[0], item[1]);
                else throw new TypeError("Failed to construct 'URLSearchParams': Sequence initializer must only contain pair elements");
            }
            else {
                for(var key in search)if (search.hasOwnProperty(key)) appendTo(dict, key, search[key]);
            }
        } else {
            // remove first '?'
            if (search.indexOf("?") === 0) search = search.slice(1);
            var pairs = search.split("&");
            for(var j = 0; j < pairs.length; j++){
                var value = pairs[j], index = value.indexOf("=");
                if (-1 < index) appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));
                else if (value) appendTo(dict, decode(value), "");
            }
        }
        return dict;
    }
    function appendTo(dict, name, value) {
        var val = typeof value === "string" ? value : value !== null && value !== undefined && typeof value.toString === "function" ? value.toString() : JSON.stringify(value);
        // #47 Prevent using `hasOwnProperty` as a property name
        if (hasOwnProperty(dict, name)) dict[name].push(val);
        else dict[name] = [
            val
        ];
    }
    function isArray(val) {
        return !!val && "[object Array]" === Object.prototype.toString.call(val);
    }
    function hasOwnProperty(obj, prop) {
        return Object.prototype.hasOwnProperty.call(obj, prop);
    }
})(typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : module.exports);

});

parcelRequire.register("a9ufu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7642356ee8c76106$export$2e2bcd8739ae039; });

var $16hem = parcelRequire("16hem");
// Devtools
(0, $16hem.default).config.productionTip = false;
(0, $16hem.default).config.devtools = false;
const $7642356ee8c76106$var$bus = new (0, $16hem.default)();
var $7642356ee8c76106$export$2e2bcd8739ae039 = $7642356ee8c76106$var$bus;

});
parcelRequire.register("16hem", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cd3b79ca22907b8$export$2e2bcd8739ae039; });
/*!
 * Vue.js v2.7.14
 * (c) 2014-2022 Evan You
 * Released under the MIT License.
 */ var $0cd3b79ca22907b8$var$emptyObject = Object.freeze({});
var $0cd3b79ca22907b8$var$isArray = Array.isArray;
// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function $0cd3b79ca22907b8$var$isUndef(v) {
    return v === undefined || v === null;
}
function $0cd3b79ca22907b8$var$isDef(v) {
    return v !== undefined && v !== null;
}
function $0cd3b79ca22907b8$var$isTrue(v) {
    return v === true;
}
function $0cd3b79ca22907b8$var$isFalse(v) {
    return v === false;
}
/**
 * Check if value is primitive.
 */ function $0cd3b79ca22907b8$var$isPrimitive(value) {
    return typeof value === "string" || typeof value === "number" || // $flow-disable-line
    typeof value === "symbol" || typeof value === "boolean";
}
function $0cd3b79ca22907b8$var$isFunction(value) {
    return typeof value === "function";
}
/**
 * Quick object check - this is primarily used to tell
 * objects from primitive values when we know the value
 * is a JSON-compliant type.
 */ function $0cd3b79ca22907b8$var$isObject(obj) {
    return obj !== null && typeof obj === "object";
}
/**
 * Get the raw type string of a value, e.g., [object Object].
 */ var $0cd3b79ca22907b8$var$_toString = Object.prototype.toString;
function $0cd3b79ca22907b8$var$toRawType(value) {
    return $0cd3b79ca22907b8$var$_toString.call(value).slice(8, -1);
}
/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */ function $0cd3b79ca22907b8$var$isPlainObject(obj) {
    return $0cd3b79ca22907b8$var$_toString.call(obj) === "[object Object]";
}
function $0cd3b79ca22907b8$var$isRegExp(v) {
    return $0cd3b79ca22907b8$var$_toString.call(v) === "[object RegExp]";
}
/**
 * Check if val is a valid array index.
 */ function $0cd3b79ca22907b8$var$isValidArrayIndex(val) {
    var n = parseFloat(String(val));
    return n >= 0 && Math.floor(n) === n && isFinite(val);
}
function $0cd3b79ca22907b8$var$isPromise(val) {
    return $0cd3b79ca22907b8$var$isDef(val) && typeof val.then === "function" && typeof val.catch === "function";
}
/**
 * Convert a value to a string that is actually rendered.
 */ function $0cd3b79ca22907b8$var$toString(val) {
    return val == null ? "" : Array.isArray(val) || $0cd3b79ca22907b8$var$isPlainObject(val) && val.toString === $0cd3b79ca22907b8$var$_toString ? JSON.stringify(val, null, 2) : String(val);
}
/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */ function $0cd3b79ca22907b8$var$toNumber(val) {
    var n = parseFloat(val);
    return isNaN(n) ? val : n;
}
/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */ function $0cd3b79ca22907b8$var$makeMap(str, expectsLowerCase) {
    var map = Object.create(null);
    var list = str.split(",");
    for(var i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? function(val) {
        return map[val.toLowerCase()];
    } : function(val) {
        return map[val];
    };
}
/**
 * Check if a tag is a built-in tag.
 */ var $0cd3b79ca22907b8$var$isBuiltInTag = $0cd3b79ca22907b8$var$makeMap("slot,component", true);
/**
 * Check if an attribute is a reserved attribute.
 */ var $0cd3b79ca22907b8$var$isReservedAttribute = $0cd3b79ca22907b8$var$makeMap("key,ref,slot,slot-scope,is");
/**
 * Remove an item from an array.
 */ function $0cd3b79ca22907b8$var$remove$2(arr, item) {
    var len = arr.length;
    if (len) {
        // fast path for the only / last item
        if (item === arr[len - 1]) {
            arr.length = len - 1;
            return;
        }
        var index = arr.indexOf(item);
        if (index > -1) return arr.splice(index, 1);
    }
}
/**
 * Check whether an object has the property.
 */ var $0cd3b79ca22907b8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $0cd3b79ca22907b8$var$hasOwn(obj, key) {
    return $0cd3b79ca22907b8$var$hasOwnProperty.call(obj, key);
}
/**
 * Create a cached version of a pure function.
 */ function $0cd3b79ca22907b8$var$cached(fn) {
    var cache = Object.create(null);
    return function cachedFn(str) {
        var hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
}
/**
 * Camelize a hyphen-delimited string.
 */ var $0cd3b79ca22907b8$var$camelizeRE = /-(\w)/g;
var $0cd3b79ca22907b8$var$camelize = $0cd3b79ca22907b8$var$cached(function(str) {
    return str.replace($0cd3b79ca22907b8$var$camelizeRE, function(_, c) {
        return c ? c.toUpperCase() : "";
    });
});
/**
 * Capitalize a string.
 */ var $0cd3b79ca22907b8$var$capitalize = $0cd3b79ca22907b8$var$cached(function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
});
/**
 * Hyphenate a camelCase string.
 */ var $0cd3b79ca22907b8$var$hyphenateRE = /\B([A-Z])/g;
var $0cd3b79ca22907b8$var$hyphenate = $0cd3b79ca22907b8$var$cached(function(str) {
    return str.replace($0cd3b79ca22907b8$var$hyphenateRE, "-$1").toLowerCase();
});
/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */ /* istanbul ignore next */ function $0cd3b79ca22907b8$var$polyfillBind(fn, ctx) {
    function boundFn(a) {
        var l = arguments.length;
        return l ? l > 1 ? fn.apply(ctx, arguments) : fn.call(ctx, a) : fn.call(ctx);
    }
    boundFn._length = fn.length;
    return boundFn;
}
function $0cd3b79ca22907b8$var$nativeBind(fn, ctx) {
    return fn.bind(ctx);
}
// @ts-expect-error bind cannot be `undefined`
var $0cd3b79ca22907b8$var$bind = Function.prototype.bind ? $0cd3b79ca22907b8$var$nativeBind : $0cd3b79ca22907b8$var$polyfillBind;
/**
 * Convert an Array-like object to a real Array.
 */ function $0cd3b79ca22907b8$var$toArray(list, start) {
    start = start || 0;
    var i = list.length - start;
    var ret = new Array(i);
    while(i--)ret[i] = list[i + start];
    return ret;
}
/**
 * Mix properties into target object.
 */ function $0cd3b79ca22907b8$var$extend(to, _from) {
    for(var key in _from)to[key] = _from[key];
    return to;
}
/**
 * Merge an Array of Objects into a single Object.
 */ function $0cd3b79ca22907b8$var$toObject(arr) {
    var res = {};
    for(var i = 0; i < arr.length; i++)if (arr[i]) $0cd3b79ca22907b8$var$extend(res, arr[i]);
    return res;
}
/* eslint-disable no-unused-vars */ /**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */ function $0cd3b79ca22907b8$var$noop(a, b, c) {}
/**
 * Always return false.
 */ var $0cd3b79ca22907b8$var$no = function(a, b, c) {
    return false;
};
/* eslint-enable no-unused-vars */ /**
 * Return the same value.
 */ var $0cd3b79ca22907b8$var$identity = function(_) {
    return _;
};
/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */ function $0cd3b79ca22907b8$var$looseEqual(a, b) {
    if (a === b) return true;
    var isObjectA = $0cd3b79ca22907b8$var$isObject(a);
    var isObjectB = $0cd3b79ca22907b8$var$isObject(b);
    if (isObjectA && isObjectB) try {
        var isArrayA = Array.isArray(a);
        var isArrayB = Array.isArray(b);
        if (isArrayA && isArrayB) return a.length === b.length && a.every(function(e, i) {
            return $0cd3b79ca22907b8$var$looseEqual(e, b[i]);
        });
        else if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
        else if (!isArrayA && !isArrayB) {
            var keysA = Object.keys(a);
            var keysB = Object.keys(b);
            return keysA.length === keysB.length && keysA.every(function(key) {
                return $0cd3b79ca22907b8$var$looseEqual(a[key], b[key]);
            });
        } else /* istanbul ignore next */ return false;
    } catch (e) {
        /* istanbul ignore next */ return false;
    }
    else if (!isObjectA && !isObjectB) return String(a) === String(b);
    else return false;
}
/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */ function $0cd3b79ca22907b8$var$looseIndexOf(arr, val) {
    for(var i = 0; i < arr.length; i++){
        if ($0cd3b79ca22907b8$var$looseEqual(arr[i], val)) return i;
    }
    return -1;
}
/**
 * Ensure a function is called only once.
 */ function $0cd3b79ca22907b8$var$once(fn) {
    var called = false;
    return function() {
        if (!called) {
            called = true;
            fn.apply(this, arguments);
        }
    };
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is#polyfill
function $0cd3b79ca22907b8$var$hasChanged(x, y) {
    if (x === y) return x === 0 && 1 / x !== 1 / y;
    else return x === x || y === y;
}
var $0cd3b79ca22907b8$var$SSR_ATTR = "data-server-rendered";
var $0cd3b79ca22907b8$var$ASSET_TYPES = [
    "component",
    "directive",
    "filter"
];
var $0cd3b79ca22907b8$var$LIFECYCLE_HOOKS = [
    "beforeCreate",
    "created",
    "beforeMount",
    "mounted",
    "beforeUpdate",
    "updated",
    "beforeDestroy",
    "destroyed",
    "activated",
    "deactivated",
    "errorCaptured",
    "serverPrefetch",
    "renderTracked",
    "renderTriggered"
];
var $0cd3b79ca22907b8$var$config = {
    /**
     * Option merge strategies (used in core/util/options)
     */ // $flow-disable-line
    optionMergeStrategies: Object.create(null),
    /**
     * Whether to suppress warnings.
     */ silent: false,
    /**
     * Show production mode tip message on boot?
     */ productionTip: false,
    /**
     * Whether to enable devtools
     */ devtools: false,
    /**
     * Whether to record perf
     */ performance: false,
    /**
     * Error handler for watcher errors
     */ errorHandler: null,
    /**
     * Warn handler for watcher warns
     */ warnHandler: null,
    /**
     * Ignore certain custom elements
     */ ignoredElements: [],
    /**
     * Custom user key aliases for v-on
     */ // $flow-disable-line
    keyCodes: Object.create(null),
    /**
     * Check if a tag is reserved so that it cannot be registered as a
     * component. This is platform-dependent and may be overwritten.
     */ isReservedTag: $0cd3b79ca22907b8$var$no,
    /**
     * Check if an attribute is reserved so that it cannot be used as a component
     * prop. This is platform-dependent and may be overwritten.
     */ isReservedAttr: $0cd3b79ca22907b8$var$no,
    /**
     * Check if a tag is an unknown element.
     * Platform-dependent.
     */ isUnknownElement: $0cd3b79ca22907b8$var$no,
    /**
     * Get the namespace of an element
     */ getTagNamespace: $0cd3b79ca22907b8$var$noop,
    /**
     * Parse the real tag name for the specific platform.
     */ parsePlatformTagName: $0cd3b79ca22907b8$var$identity,
    /**
     * Check if an attribute must be bound using property, e.g. value
     * Platform-dependent.
     */ mustUseProp: $0cd3b79ca22907b8$var$no,
    /**
     * Perform updates asynchronously. Intended to be used by Vue Test Utils
     * This will significantly reduce performance if set to false.
     */ async: true,
    /**
     * Exposed for legacy reasons
     */ _lifecycleHooks: $0cd3b79ca22907b8$var$LIFECYCLE_HOOKS
};
/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */ var $0cd3b79ca22907b8$var$unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;
/**
 * Check if a string starts with $ or _
 */ function $0cd3b79ca22907b8$var$isReserved(str) {
    var c = (str + "").charCodeAt(0);
    return c === 0x24 || c === 0x5f;
}
/**
 * Define a property.
 */ function $0cd3b79ca22907b8$var$def(obj, key, val, enumerable) {
    Object.defineProperty(obj, key, {
        value: val,
        enumerable: !!enumerable,
        writable: true,
        configurable: true
    });
}
/**
 * Parse simple path.
 */ var $0cd3b79ca22907b8$var$bailRE = new RegExp("[^".concat($0cd3b79ca22907b8$var$unicodeRegExp.source, ".$_\\d]"));
function $0cd3b79ca22907b8$var$parsePath(path) {
    if ($0cd3b79ca22907b8$var$bailRE.test(path)) return;
    var segments = path.split(".");
    return function(obj) {
        for(var i = 0; i < segments.length; i++){
            if (!obj) return;
            obj = obj[segments[i]];
        }
        return obj;
    };
}
// can we use __proto__?
var $0cd3b79ca22907b8$var$hasProto = "__proto__" in {};
// Browser environment sniffing
var $0cd3b79ca22907b8$var$inBrowser = typeof window !== "undefined";
var $0cd3b79ca22907b8$var$UA = $0cd3b79ca22907b8$var$inBrowser && window.navigator.userAgent.toLowerCase();
var $0cd3b79ca22907b8$var$isIE = $0cd3b79ca22907b8$var$UA && /msie|trident/.test($0cd3b79ca22907b8$var$UA);
var $0cd3b79ca22907b8$var$isIE9 = $0cd3b79ca22907b8$var$UA && $0cd3b79ca22907b8$var$UA.indexOf("msie 9.0") > 0;
var $0cd3b79ca22907b8$var$isEdge = $0cd3b79ca22907b8$var$UA && $0cd3b79ca22907b8$var$UA.indexOf("edge/") > 0;
$0cd3b79ca22907b8$var$UA && $0cd3b79ca22907b8$var$UA.indexOf("android");
var $0cd3b79ca22907b8$var$isIOS = $0cd3b79ca22907b8$var$UA && /iphone|ipad|ipod|ios/.test($0cd3b79ca22907b8$var$UA);
$0cd3b79ca22907b8$var$UA && /chrome\/\d+/.test($0cd3b79ca22907b8$var$UA) && $0cd3b79ca22907b8$var$isEdge;
$0cd3b79ca22907b8$var$UA && /phantomjs/.test($0cd3b79ca22907b8$var$UA);
var $0cd3b79ca22907b8$var$isFF = $0cd3b79ca22907b8$var$UA && $0cd3b79ca22907b8$var$UA.match(/firefox\/(\d+)/);
// Firefox has a "watch" function on Object.prototype...
// @ts-expect-error firebox support
var $0cd3b79ca22907b8$var$nativeWatch = {}.watch;
var $0cd3b79ca22907b8$var$supportsPassive = false;
if ($0cd3b79ca22907b8$var$inBrowser) try {
    var $0cd3b79ca22907b8$var$opts = {};
    Object.defineProperty($0cd3b79ca22907b8$var$opts, "passive", {
        get: function() {
            /* istanbul ignore next */ $0cd3b79ca22907b8$var$supportsPassive = true;
        }
    }); // https://github.com/facebook/flow/issues/285
    window.addEventListener("test-passive", null, $0cd3b79ca22907b8$var$opts);
} catch (e) {}
// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var $0cd3b79ca22907b8$var$_isServer;
var $0cd3b79ca22907b8$var$isServerRendering = function() {
    if ($0cd3b79ca22907b8$var$_isServer === undefined) {
        /* istanbul ignore if */ if (!$0cd3b79ca22907b8$var$inBrowser && typeof $parcel$global !== "undefined") // detect presence of vue-server-renderer and avoid
        // Webpack shimming the process
        $0cd3b79ca22907b8$var$_isServer = $parcel$global["process"] && $parcel$global["process"].env.VUE_ENV === "server";
        else $0cd3b79ca22907b8$var$_isServer = false;
    }
    return $0cd3b79ca22907b8$var$_isServer;
};
// detect devtools
var $0cd3b79ca22907b8$var$devtools = $0cd3b79ca22907b8$var$inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;
/* istanbul ignore next */ function $0cd3b79ca22907b8$var$isNative(Ctor) {
    return typeof Ctor === "function" && /native code/.test(Ctor.toString());
}
var $0cd3b79ca22907b8$var$hasSymbol = typeof Symbol !== "undefined" && $0cd3b79ca22907b8$var$isNative(Symbol) && typeof Reflect !== "undefined" && $0cd3b79ca22907b8$var$isNative(Reflect.ownKeys);
var $0cd3b79ca22907b8$var$_Set; // $flow-disable-line
/* istanbul ignore if */ if (typeof Set !== "undefined" && $0cd3b79ca22907b8$var$isNative(Set)) // use native Set when available.
$0cd3b79ca22907b8$var$_Set = Set;
else // a non-standard Set polyfill that only works with primitive keys.
$0cd3b79ca22907b8$var$_Set = /** @class */ function() {
    function Set1() {
        this.set = Object.create(null);
    }
    Set1.prototype.has = function(key) {
        return this.set[key] === true;
    };
    Set1.prototype.add = function(key) {
        this.set[key] = true;
    };
    Set1.prototype.clear = function() {
        this.set = Object.create(null);
    };
    return Set1;
}();
var $0cd3b79ca22907b8$var$currentInstance = null;
/**
 * This is exposed for compatibility with v3 (e.g. some functions in VueUse
 * relies on it). Do not use this internally, just use `currentInstance`.
 *
 * @internal this function needs manual type declaration because it relies
 * on previously manually authored types from Vue 2
 */ function $0cd3b79ca22907b8$export$f13e630aa3915748() {
    return $0cd3b79ca22907b8$var$currentInstance && {
        proxy: $0cd3b79ca22907b8$var$currentInstance
    };
}
/**
 * @internal
 */ function $0cd3b79ca22907b8$var$setCurrentInstance(vm) {
    if (vm === void 0) vm = null;
    if (!vm) $0cd3b79ca22907b8$var$currentInstance && $0cd3b79ca22907b8$var$currentInstance._scope.off();
    $0cd3b79ca22907b8$var$currentInstance = vm;
    vm && vm._scope.on();
}
/**
 * @internal
 */ var $0cd3b79ca22907b8$var$VNode = /** @class */ function() {
    function VNode(tag, data, children, text, elm, context, componentOptions, asyncFactory) {
        this.tag = tag;
        this.data = data;
        this.children = children;
        this.text = text;
        this.elm = elm;
        this.ns = undefined;
        this.context = context;
        this.fnContext = undefined;
        this.fnOptions = undefined;
        this.fnScopeId = undefined;
        this.key = data && data.key;
        this.componentOptions = componentOptions;
        this.componentInstance = undefined;
        this.parent = undefined;
        this.raw = false;
        this.isStatic = false;
        this.isRootInsert = true;
        this.isComment = false;
        this.isCloned = false;
        this.isOnce = false;
        this.asyncFactory = asyncFactory;
        this.asyncMeta = undefined;
        this.isAsyncPlaceholder = false;
    }
    Object.defineProperty(VNode.prototype, "child", {
        // DEPRECATED: alias for componentInstance for backwards compat.
        /* istanbul ignore next */ get: function() {
            return this.componentInstance;
        },
        enumerable: false,
        configurable: true
    });
    return VNode;
}();
var $0cd3b79ca22907b8$var$createEmptyVNode = function(text) {
    if (text === void 0) text = "";
    var node = new $0cd3b79ca22907b8$var$VNode();
    node.text = text;
    node.isComment = true;
    return node;
};
function $0cd3b79ca22907b8$var$createTextVNode(val) {
    return new $0cd3b79ca22907b8$var$VNode(undefined, undefined, undefined, String(val));
}
// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function $0cd3b79ca22907b8$var$cloneVNode(vnode) {
    var cloned = new $0cd3b79ca22907b8$var$VNode(vnode.tag, vnode.data, // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(), vnode.text, vnode.elm, vnode.context, vnode.componentOptions, vnode.asyncFactory);
    cloned.ns = vnode.ns;
    cloned.isStatic = vnode.isStatic;
    cloned.key = vnode.key;
    cloned.isComment = vnode.isComment;
    cloned.fnContext = vnode.fnContext;
    cloned.fnOptions = vnode.fnOptions;
    cloned.fnScopeId = vnode.fnScopeId;
    cloned.asyncMeta = vnode.asyncMeta;
    cloned.isCloned = true;
    return cloned;
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $0cd3b79ca22907b8$var$__assign = function() {
    $0cd3b79ca22907b8$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $0cd3b79ca22907b8$var$__assign.apply(this, arguments);
};
var $0cd3b79ca22907b8$var$uid$2 = 0;
var $0cd3b79ca22907b8$var$pendingCleanupDeps = [];
var $0cd3b79ca22907b8$var$cleanupDeps = function() {
    for(var i = 0; i < $0cd3b79ca22907b8$var$pendingCleanupDeps.length; i++){
        var dep = $0cd3b79ca22907b8$var$pendingCleanupDeps[i];
        dep.subs = dep.subs.filter(function(s) {
            return s;
        });
        dep._pending = false;
    }
    $0cd3b79ca22907b8$var$pendingCleanupDeps.length = 0;
};
/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 * @internal
 */ var $0cd3b79ca22907b8$var$Dep = /** @class */ function() {
    function Dep() {
        // pending subs cleanup
        this._pending = false;
        this.id = $0cd3b79ca22907b8$var$uid$2++;
        this.subs = [];
    }
    Dep.prototype.addSub = function(sub) {
        this.subs.push(sub);
    };
    Dep.prototype.removeSub = function(sub) {
        // #12696 deps with massive amount of subscribers are extremely slow to
        // clean up in Chromium
        // to workaround this, we unset the sub for now, and clear them on
        // next scheduler flush.
        this.subs[this.subs.indexOf(sub)] = null;
        if (!this._pending) {
            this._pending = true;
            $0cd3b79ca22907b8$var$pendingCleanupDeps.push(this);
        }
    };
    Dep.prototype.depend = function(info) {
        if (Dep.target) Dep.target.addDep(this);
    };
    Dep.prototype.notify = function(info) {
        // stabilize the subscriber list first
        var subs = this.subs.filter(function(s) {
            return s;
        });
        for(var i = 0, l = subs.length; i < l; i++){
            var sub = subs[i];
            sub.update();
        }
    };
    return Dep;
}();
// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
$0cd3b79ca22907b8$var$Dep.target = null;
var $0cd3b79ca22907b8$var$targetStack = [];
function $0cd3b79ca22907b8$var$pushTarget(target) {
    $0cd3b79ca22907b8$var$targetStack.push(target);
    $0cd3b79ca22907b8$var$Dep.target = target;
}
function $0cd3b79ca22907b8$var$popTarget() {
    $0cd3b79ca22907b8$var$targetStack.pop();
    $0cd3b79ca22907b8$var$Dep.target = $0cd3b79ca22907b8$var$targetStack[$0cd3b79ca22907b8$var$targetStack.length - 1];
}
/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */ var $0cd3b79ca22907b8$var$arrayProto = Array.prototype;
var $0cd3b79ca22907b8$var$arrayMethods = Object.create($0cd3b79ca22907b8$var$arrayProto);
var $0cd3b79ca22907b8$var$methodsToPatch = [
    "push",
    "pop",
    "shift",
    "unshift",
    "splice",
    "sort",
    "reverse"
];
/**
 * Intercept mutating methods and emit events
 */ $0cd3b79ca22907b8$var$methodsToPatch.forEach(function(method) {
    // cache original method
    var original = $0cd3b79ca22907b8$var$arrayProto[method];
    $0cd3b79ca22907b8$var$def($0cd3b79ca22907b8$var$arrayMethods, method, function mutator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var result = original.apply(this, args);
        var ob = this.__ob__;
        var inserted;
        switch(method){
            case "push":
            case "unshift":
                inserted = args;
                break;
            case "splice":
                inserted = args.slice(2);
                break;
        }
        if (inserted) ob.observeArray(inserted);
        ob.dep.notify();
        return result;
    });
});
var $0cd3b79ca22907b8$var$arrayKeys = Object.getOwnPropertyNames($0cd3b79ca22907b8$var$arrayMethods);
var $0cd3b79ca22907b8$var$NO_INIITIAL_VALUE = {};
/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */ var $0cd3b79ca22907b8$var$shouldObserve = true;
function $0cd3b79ca22907b8$var$toggleObserving(value) {
    $0cd3b79ca22907b8$var$shouldObserve = value;
}
// ssr mock dep
var $0cd3b79ca22907b8$var$mockDep = {
    notify: $0cd3b79ca22907b8$var$noop,
    depend: $0cd3b79ca22907b8$var$noop,
    addSub: $0cd3b79ca22907b8$var$noop,
    removeSub: $0cd3b79ca22907b8$var$noop
};
/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */ var $0cd3b79ca22907b8$var$Observer = /** @class */ function() {
    function Observer(value, shallow, mock) {
        if (shallow === void 0) shallow = false;
        if (mock === void 0) mock = false;
        this.value = value;
        this.shallow = shallow;
        this.mock = mock;
        // this.value = value
        this.dep = mock ? $0cd3b79ca22907b8$var$mockDep : new $0cd3b79ca22907b8$var$Dep();
        this.vmCount = 0;
        $0cd3b79ca22907b8$var$def(value, "__ob__", this);
        if ($0cd3b79ca22907b8$var$isArray(value)) {
            if (!mock) {
                if ($0cd3b79ca22907b8$var$hasProto) value.__proto__ = $0cd3b79ca22907b8$var$arrayMethods;
                else for(var i = 0, l = $0cd3b79ca22907b8$var$arrayKeys.length; i < l; i++){
                    var key = $0cd3b79ca22907b8$var$arrayKeys[i];
                    $0cd3b79ca22907b8$var$def(value, key, $0cd3b79ca22907b8$var$arrayMethods[key]);
                }
            }
            if (!shallow) this.observeArray(value);
        } else {
            /**
             * Walk through all properties and convert them into
             * getter/setters. This method should only be called when
             * value type is Object.
             */ var keys = Object.keys(value);
            for(var i = 0; i < keys.length; i++){
                var key = keys[i];
                $0cd3b79ca22907b8$var$defineReactive(value, key, $0cd3b79ca22907b8$var$NO_INIITIAL_VALUE, undefined, shallow, mock);
            }
        }
    }
    /**
     * Observe a list of Array items.
     */ Observer.prototype.observeArray = function(value) {
        for(var i = 0, l = value.length; i < l; i++)$0cd3b79ca22907b8$var$observe(value[i], false, this.mock);
    };
    return Observer;
}();
// helpers
/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */ function $0cd3b79ca22907b8$var$observe(value, shallow, ssrMockReactivity) {
    if (value && $0cd3b79ca22907b8$var$hasOwn(value, "__ob__") && value.__ob__ instanceof $0cd3b79ca22907b8$var$Observer) return value.__ob__;
    if ($0cd3b79ca22907b8$var$shouldObserve && (ssrMockReactivity || !$0cd3b79ca22907b8$var$isServerRendering()) && ($0cd3b79ca22907b8$var$isArray(value) || $0cd3b79ca22907b8$var$isPlainObject(value)) && Object.isExtensible(value) && !value.__v_skip /* ReactiveFlags.SKIP */  && !$0cd3b79ca22907b8$export$4f9f5282de18fc69(value) && !(value instanceof $0cd3b79ca22907b8$var$VNode)) return new $0cd3b79ca22907b8$var$Observer(value, shallow, ssrMockReactivity);
}
/**
 * Define a reactive property on an Object.
 */ function $0cd3b79ca22907b8$var$defineReactive(obj, key, val, customSetter, shallow, mock) {
    var dep = new $0cd3b79ca22907b8$var$Dep();
    var property = Object.getOwnPropertyDescriptor(obj, key);
    if (property && property.configurable === false) return;
    // cater for pre-defined getter/setters
    var getter = property && property.get;
    var setter = property && property.set;
    if ((!getter || setter) && (val === $0cd3b79ca22907b8$var$NO_INIITIAL_VALUE || arguments.length === 2)) val = obj[key];
    var childOb = !shallow && $0cd3b79ca22907b8$var$observe(val, false, mock);
    Object.defineProperty(obj, key, {
        enumerable: true,
        configurable: true,
        get: function reactiveGetter() {
            var value = getter ? getter.call(obj) : val;
            if ($0cd3b79ca22907b8$var$Dep.target) {
                dep.depend();
                if (childOb) {
                    childOb.dep.depend();
                    if ($0cd3b79ca22907b8$var$isArray(value)) $0cd3b79ca22907b8$var$dependArray(value);
                }
            }
            return $0cd3b79ca22907b8$export$4f9f5282de18fc69(value) && !shallow ? value.value : value;
        },
        set: function reactiveSetter(newVal1) {
            var value = getter ? getter.call(obj) : val;
            if (!$0cd3b79ca22907b8$var$hasChanged(value, newVal1)) return;
            if (setter) setter.call(obj, newVal1);
            else if (getter) // #7981: for accessor properties without setter
            return;
            else if (!shallow && $0cd3b79ca22907b8$export$4f9f5282de18fc69(value) && !$0cd3b79ca22907b8$export$4f9f5282de18fc69(newVal1)) {
                value.value = newVal1;
                return;
            } else val = newVal1;
            childOb = !shallow && $0cd3b79ca22907b8$var$observe(newVal1, false, mock);
            dep.notify();
        }
    });
    return dep;
}
function $0cd3b79ca22907b8$export$adaa4cf7ef1b65be(target, key, val) {
    if ($0cd3b79ca22907b8$export$92d09b48637741e7(target)) return;
    var ob = target.__ob__;
    if ($0cd3b79ca22907b8$var$isArray(target) && $0cd3b79ca22907b8$var$isValidArrayIndex(key)) {
        target.length = Math.max(target.length, key);
        target.splice(key, 1, val);
        // when mocking for SSR, array methods are not hijacked
        if (ob && !ob.shallow && ob.mock) $0cd3b79ca22907b8$var$observe(val, false, true);
        return val;
    }
    if (key in target && !(key in Object.prototype)) {
        target[key] = val;
        return val;
    }
    if (target._isVue || ob && ob.vmCount) return val;
    if (!ob) {
        target[key] = val;
        return val;
    }
    $0cd3b79ca22907b8$var$defineReactive(ob.value, key, val, undefined, ob.shallow, ob.mock);
    ob.dep.notify();
    return val;
}
function $0cd3b79ca22907b8$export$1d2f21e549771e67(target, key) {
    if ($0cd3b79ca22907b8$var$isArray(target) && $0cd3b79ca22907b8$var$isValidArrayIndex(key)) {
        target.splice(key, 1);
        return;
    }
    var ob = target.__ob__;
    if (target._isVue || ob && ob.vmCount) return;
    if ($0cd3b79ca22907b8$export$92d09b48637741e7(target)) return;
    if (!$0cd3b79ca22907b8$var$hasOwn(target, key)) return;
    delete target[key];
    if (!ob) return;
    ob.dep.notify();
}
/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */ function $0cd3b79ca22907b8$var$dependArray(value) {
    for(var e = void 0, i = 0, l = value.length; i < l; i++){
        e = value[i];
        if (e && e.__ob__) e.__ob__.dep.depend();
        if ($0cd3b79ca22907b8$var$isArray(e)) $0cd3b79ca22907b8$var$dependArray(e);
    }
}
function $0cd3b79ca22907b8$export$90a44edba14e47be(target) {
    $0cd3b79ca22907b8$var$makeReactive(target, false);
    return target;
}
/**
 * Return a shallowly-reactive copy of the original object, where only the root
 * level properties are reactive. It also does not auto-unwrap refs (even at the
 * root level).
 */ function $0cd3b79ca22907b8$export$8d81cefd22d22260(target) {
    $0cd3b79ca22907b8$var$makeReactive(target, true);
    $0cd3b79ca22907b8$var$def(target, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */ , true);
    return target;
}
function $0cd3b79ca22907b8$var$makeReactive(target, shallow) {
    // if trying to observe a readonly proxy, return the readonly version.
    if (!$0cd3b79ca22907b8$export$92d09b48637741e7(target)) {
        var existingOb;
        var ob = $0cd3b79ca22907b8$var$observe(target, shallow, $0cd3b79ca22907b8$var$isServerRendering());
    }
}
function $0cd3b79ca22907b8$export$352205f445242f02(value) {
    if ($0cd3b79ca22907b8$export$92d09b48637741e7(value)) return $0cd3b79ca22907b8$export$352205f445242f02(value["__v_raw" /* ReactiveFlags.RAW */ ]);
    return !!(value && value.__ob__);
}
function $0cd3b79ca22907b8$export$7f3fe6025abfa26e(value) {
    return !!(value && value.__v_isShallow);
}
function $0cd3b79ca22907b8$export$92d09b48637741e7(value) {
    return !!(value && value.__v_isReadonly);
}
function $0cd3b79ca22907b8$export$5f3ca29d057519b3(value) {
    return $0cd3b79ca22907b8$export$352205f445242f02(value) || $0cd3b79ca22907b8$export$92d09b48637741e7(value);
}
function $0cd3b79ca22907b8$export$ab18938b9fc5f28e(observed) {
    var raw = observed && observed["__v_raw" /* ReactiveFlags.RAW */ ];
    return raw ? $0cd3b79ca22907b8$export$ab18938b9fc5f28e(raw) : observed;
}
function $0cd3b79ca22907b8$export$995ab8b13ad7a9d0(value) {
    // non-extensible objects won't be observed anyway
    if (Object.isExtensible(value)) $0cd3b79ca22907b8$var$def(value, "__v_skip" /* ReactiveFlags.SKIP */ , true);
    return value;
}
/**
 * @internal
 */ function $0cd3b79ca22907b8$var$isCollectionType(value) {
    var type = $0cd3b79ca22907b8$var$toRawType(value);
    return type === "Map" || type === "WeakMap" || type === "Set" || type === "WeakSet";
}
/**
 * @internal
 */ var $0cd3b79ca22907b8$var$RefFlag = "__v_isRef";
function $0cd3b79ca22907b8$export$4f9f5282de18fc69(r) {
    return !!(r && r.__v_isRef === true);
}
function $0cd3b79ca22907b8$export$eff4d24c3ff7876e(value) {
    return $0cd3b79ca22907b8$var$createRef(value, false);
}
function $0cd3b79ca22907b8$export$9b7bc5fe3b17c8b3(value) {
    return $0cd3b79ca22907b8$var$createRef(value, true);
}
function $0cd3b79ca22907b8$var$createRef(rawValue, shallow) {
    if ($0cd3b79ca22907b8$export$4f9f5282de18fc69(rawValue)) return rawValue;
    var ref = {};
    $0cd3b79ca22907b8$var$def(ref, $0cd3b79ca22907b8$var$RefFlag, true);
    $0cd3b79ca22907b8$var$def(ref, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */ , shallow);
    $0cd3b79ca22907b8$var$def(ref, "dep", $0cd3b79ca22907b8$var$defineReactive(ref, "value", rawValue, null, shallow, $0cd3b79ca22907b8$var$isServerRendering()));
    return ref;
}
function $0cd3b79ca22907b8$export$f402f86588575ccc(ref) {
    ref.dep && ref.dep.notify();
}
function $0cd3b79ca22907b8$export$a239a76781616204(ref) {
    return $0cd3b79ca22907b8$export$4f9f5282de18fc69(ref) ? ref.value : ref;
}
function $0cd3b79ca22907b8$export$f353fd1b97db3fa0(objectWithRefs) {
    if ($0cd3b79ca22907b8$export$352205f445242f02(objectWithRefs)) return objectWithRefs;
    var proxy = {};
    var keys = Object.keys(objectWithRefs);
    for(var i = 0; i < keys.length; i++)$0cd3b79ca22907b8$var$proxyWithRefUnwrap(proxy, objectWithRefs, keys[i]);
    return proxy;
}
function $0cd3b79ca22907b8$var$proxyWithRefUnwrap(target, source, key) {
    Object.defineProperty(target, key, {
        enumerable: true,
        configurable: true,
        get: function() {
            var val = source[key];
            if ($0cd3b79ca22907b8$export$4f9f5282de18fc69(val)) return val.value;
            else {
                var ob = val && val.__ob__;
                if (ob) ob.dep.depend();
                return val;
            }
        },
        set: function(value) {
            var oldValue = source[key];
            if ($0cd3b79ca22907b8$export$4f9f5282de18fc69(oldValue) && !$0cd3b79ca22907b8$export$4f9f5282de18fc69(value)) oldValue.value = value;
            else source[key] = value;
        }
    });
}
function $0cd3b79ca22907b8$export$a20c2dd6199824cb(factory) {
    var dep = new $0cd3b79ca22907b8$var$Dep();
    var _a = factory(function() {
        dep.depend();
    }, function() {
        dep.notify();
    }), get = _a.get, set = _a.set;
    var ref = {
        get value () {
            return get();
        },
        set value (newVal){
            set(newVal);
        }
    };
    $0cd3b79ca22907b8$var$def(ref, $0cd3b79ca22907b8$var$RefFlag, true);
    return ref;
}
function $0cd3b79ca22907b8$export$2e9533675e5e70e0(object) {
    var ret = $0cd3b79ca22907b8$var$isArray(object) ? new Array(object.length) : {};
    for(var key in object)ret[key] = $0cd3b79ca22907b8$export$1f60508e4f47b4b7(object, key);
    return ret;
}
function $0cd3b79ca22907b8$export$1f60508e4f47b4b7(object, key, defaultValue) {
    var val = object[key];
    if ($0cd3b79ca22907b8$export$4f9f5282de18fc69(val)) return val;
    var ref = {
        get value () {
            var val1 = object[key];
            return val1 === undefined ? defaultValue : val1;
        },
        set value (newVal){
            object[key] = newVal;
        }
    };
    $0cd3b79ca22907b8$var$def(ref, $0cd3b79ca22907b8$var$RefFlag, true);
    return ref;
}
var $0cd3b79ca22907b8$var$rawToReadonlyFlag = "__v_rawToReadonly";
var $0cd3b79ca22907b8$var$rawToShallowReadonlyFlag = "__v_rawToShallowReadonly";
function $0cd3b79ca22907b8$export$6ec456bd5b7b3c51(target) {
    return $0cd3b79ca22907b8$var$createReadonly(target, false);
}
function $0cd3b79ca22907b8$var$createReadonly(target, shallow) {
    if (!$0cd3b79ca22907b8$var$isPlainObject(target)) return target;
    // already a readonly object
    if ($0cd3b79ca22907b8$export$92d09b48637741e7(target)) return target;
    // already has a readonly proxy
    var existingFlag = shallow ? $0cd3b79ca22907b8$var$rawToShallowReadonlyFlag : $0cd3b79ca22907b8$var$rawToReadonlyFlag;
    var existingProxy = target[existingFlag];
    if (existingProxy) return existingProxy;
    var proxy = Object.create(Object.getPrototypeOf(target));
    $0cd3b79ca22907b8$var$def(target, existingFlag, proxy);
    $0cd3b79ca22907b8$var$def(proxy, "__v_isReadonly" /* ReactiveFlags.IS_READONLY */ , true);
    $0cd3b79ca22907b8$var$def(proxy, "__v_raw" /* ReactiveFlags.RAW */ , target);
    if ($0cd3b79ca22907b8$export$4f9f5282de18fc69(target)) $0cd3b79ca22907b8$var$def(proxy, $0cd3b79ca22907b8$var$RefFlag, true);
    if (shallow || $0cd3b79ca22907b8$export$7f3fe6025abfa26e(target)) $0cd3b79ca22907b8$var$def(proxy, "__v_isShallow" /* ReactiveFlags.IS_SHALLOW */ , true);
    var keys = Object.keys(target);
    for(var i = 0; i < keys.length; i++)$0cd3b79ca22907b8$var$defineReadonlyProperty(proxy, target, keys[i], shallow);
    return proxy;
}
function $0cd3b79ca22907b8$var$defineReadonlyProperty(proxy, target, key, shallow) {
    Object.defineProperty(proxy, key, {
        enumerable: true,
        configurable: true,
        get: function() {
            var val = target[key];
            return shallow || !$0cd3b79ca22907b8$var$isPlainObject(val) ? val : $0cd3b79ca22907b8$export$6ec456bd5b7b3c51(val);
        },
        set: function() {}
    });
}
/**
 * Returns a reactive-copy of the original object, where only the root level
 * properties are readonly, and does NOT unwrap refs nor recursively convert
 * returned properties.
 * This is used for creating the props proxy object for stateful components.
 */ function $0cd3b79ca22907b8$export$7c4b5f2b50f09f6b(target) {
    return $0cd3b79ca22907b8$var$createReadonly(target, true);
}
function $0cd3b79ca22907b8$export$2983e091f1a1e8e2(getterOrOptions, debugOptions) {
    var getter;
    var setter;
    var onlyGetter = $0cd3b79ca22907b8$var$isFunction(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = $0cd3b79ca22907b8$var$noop;
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    var watcher = $0cd3b79ca22907b8$var$isServerRendering() ? null : new $0cd3b79ca22907b8$var$Watcher($0cd3b79ca22907b8$var$currentInstance, getter, $0cd3b79ca22907b8$var$noop, {
        lazy: true
    });
    var ref = {
        // some libs rely on the presence effect for checking computed refs
        // from normal refs, but the implementation doesn't matter
        effect: watcher,
        get value () {
            if (watcher) {
                if (watcher.dirty) watcher.evaluate();
                if ($0cd3b79ca22907b8$var$Dep.target) watcher.depend();
                return watcher.value;
            } else return getter();
        },
        set value (newVal){
            setter(newVal);
        }
    };
    $0cd3b79ca22907b8$var$def(ref, $0cd3b79ca22907b8$var$RefFlag, true);
    $0cd3b79ca22907b8$var$def(ref, "__v_isReadonly" /* ReactiveFlags.IS_READONLY */ , onlyGetter);
    return ref;
}
var $0cd3b79ca22907b8$var$WATCHER = "watcher";
var $0cd3b79ca22907b8$var$WATCHER_CB = "".concat($0cd3b79ca22907b8$var$WATCHER, " callback");
var $0cd3b79ca22907b8$var$WATCHER_GETTER = "".concat($0cd3b79ca22907b8$var$WATCHER, " getter");
var $0cd3b79ca22907b8$var$WATCHER_CLEANUP = "".concat($0cd3b79ca22907b8$var$WATCHER, " cleanup");
// Simple effect.
function $0cd3b79ca22907b8$export$ede35fc0e5500309(effect, options) {
    return $0cd3b79ca22907b8$var$doWatch(effect, null, options);
}
function $0cd3b79ca22907b8$export$b7f27ea67102d543(effect, options) {
    return $0cd3b79ca22907b8$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $0cd3b79ca22907b8$export$2035654f31b0e555(effect, options) {
    return $0cd3b79ca22907b8$var$doWatch(effect, null, {
        flush: "sync"
    });
}
// initial value for watchers to trigger on undefined initial values
var $0cd3b79ca22907b8$var$INITIAL_WATCHER_VALUE = {};
// implementation
function $0cd3b79ca22907b8$export$3db5d71bdb2d5499(source, cb, options) {
    return $0cd3b79ca22907b8$var$doWatch(source, cb, options);
}
function $0cd3b79ca22907b8$var$doWatch(source, cb, _a) {
    var _b = _a === void 0 ? $0cd3b79ca22907b8$var$emptyObject : _a, immediate = _b.immediate, deep = _b.deep, _c = _b.flush, flush = _c === void 0 ? "pre" : _c, onTrack = _b.onTrack, onTrigger = _b.onTrigger;
    var warnInvalidSource = function(s) {
        $0cd3b79ca22907b8$var$warn("Invalid watch source: ".concat(s, ". A watch source can only be a getter/effect ") + "function, a ref, a reactive object, or an array of these types.");
    };
    var instance = $0cd3b79ca22907b8$var$currentInstance;
    var call = function(fn, type, args) {
        if (args === void 0) args = null;
        return $0cd3b79ca22907b8$var$invokeWithErrorHandling(fn, null, args, instance, type);
    };
    var getter;
    var forceTrigger = false;
    var isMultiSource = false;
    if ($0cd3b79ca22907b8$export$4f9f5282de18fc69(source)) {
        getter = function() {
            return source.value;
        };
        forceTrigger = $0cd3b79ca22907b8$export$7f3fe6025abfa26e(source);
    } else if ($0cd3b79ca22907b8$export$352205f445242f02(source)) {
        getter = function() {
            source.__ob__.dep.depend();
            return source;
        };
        deep = true;
    } else if ($0cd3b79ca22907b8$var$isArray(source)) {
        isMultiSource = true;
        forceTrigger = source.some(function(s) {
            return $0cd3b79ca22907b8$export$352205f445242f02(s) || $0cd3b79ca22907b8$export$7f3fe6025abfa26e(s);
        });
        getter = function() {
            return source.map(function(s) {
                if ($0cd3b79ca22907b8$export$4f9f5282de18fc69(s)) return s.value;
                else if ($0cd3b79ca22907b8$export$352205f445242f02(s)) return $0cd3b79ca22907b8$var$traverse(s);
                else if ($0cd3b79ca22907b8$var$isFunction(s)) return call(s, $0cd3b79ca22907b8$var$WATCHER_GETTER);
            });
        };
    } else if ($0cd3b79ca22907b8$var$isFunction(source)) {
        if (cb) // getter with cb
        getter = function() {
            return call(source, $0cd3b79ca22907b8$var$WATCHER_GETTER);
        };
        else // no cb -> simple effect
        getter = function() {
            if (instance && instance._isDestroyed) return;
            if (cleanup) cleanup();
            return call(source, $0cd3b79ca22907b8$var$WATCHER, [
                onCleanup
            ]);
        };
    } else getter = $0cd3b79ca22907b8$var$noop;
    if (cb && deep) {
        var baseGetter_1 = getter;
        getter = function() {
            return $0cd3b79ca22907b8$var$traverse(baseGetter_1());
        };
    }
    var cleanup;
    var onCleanup = function(fn) {
        cleanup = watcher.onStop = function() {
            call(fn, $0cd3b79ca22907b8$var$WATCHER_CLEANUP);
        };
    };
    // in SSR there is no need to setup an actual effect, and it should be noop
    // unless it's eager
    if ($0cd3b79ca22907b8$var$isServerRendering()) {
        // we will also not call the invalidate callback (+ runner is not set up)
        onCleanup = $0cd3b79ca22907b8$var$noop;
        if (!cb) getter();
        else if (immediate) call(cb, $0cd3b79ca22907b8$var$WATCHER_CB, [
            getter(),
            isMultiSource ? [] : undefined,
            onCleanup
        ]);
        return $0cd3b79ca22907b8$var$noop;
    }
    var watcher = new $0cd3b79ca22907b8$var$Watcher($0cd3b79ca22907b8$var$currentInstance, getter, $0cd3b79ca22907b8$var$noop, {
        lazy: true
    });
    watcher.noRecurse = !cb;
    var oldValue = isMultiSource ? [] : $0cd3b79ca22907b8$var$INITIAL_WATCHER_VALUE;
    // overwrite default run
    watcher.run = function() {
        if (!watcher.active) return;
        if (cb) {
            // watch(source, cb)
            var newValue = watcher.get();
            if (deep || forceTrigger || (isMultiSource ? newValue.some(function(v, i) {
                return $0cd3b79ca22907b8$var$hasChanged(v, oldValue[i]);
            }) : $0cd3b79ca22907b8$var$hasChanged(newValue, oldValue))) {
                // cleanup before running cb again
                if (cleanup) cleanup();
                call(cb, $0cd3b79ca22907b8$var$WATCHER_CB, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $0cd3b79ca22907b8$var$INITIAL_WATCHER_VALUE ? undefined : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else // watchEffect
        watcher.get();
    };
    if (flush === "sync") watcher.update = watcher.run;
    else if (flush === "post") {
        watcher.post = true;
        watcher.update = function() {
            return $0cd3b79ca22907b8$var$queueWatcher(watcher);
        };
    } else // pre
    watcher.update = function() {
        if (instance && instance === $0cd3b79ca22907b8$var$currentInstance && !instance._isMounted) {
            // pre-watcher triggered before
            var buffer = instance._preWatchers || (instance._preWatchers = []);
            if (buffer.indexOf(watcher) < 0) buffer.push(watcher);
        } else $0cd3b79ca22907b8$var$queueWatcher(watcher);
    };
    // initial run
    if (cb) {
        if (immediate) watcher.run();
        else oldValue = watcher.get();
    } else if (flush === "post" && instance) instance.$once("hook:mounted", function() {
        return watcher.get();
    });
    else watcher.get();
    return function() {
        watcher.teardown();
    };
}
var $0cd3b79ca22907b8$var$activeEffectScope;
var $0cd3b79ca22907b8$export$1168ed9dbc71ddbd = /** @class */ function() {
    function EffectScope(detached) {
        if (detached === void 0) detached = false;
        this.detached = detached;
        /**
         * @internal
         */ this.active = true;
        /**
         * @internal
         */ this.effects = [];
        /**
         * @internal
         */ this.cleanups = [];
        this.parent = $0cd3b79ca22907b8$var$activeEffectScope;
        if (!detached && $0cd3b79ca22907b8$var$activeEffectScope) this.index = ($0cd3b79ca22907b8$var$activeEffectScope.scopes || ($0cd3b79ca22907b8$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    EffectScope.prototype.run = function(fn) {
        if (this.active) {
            var currentEffectScope = $0cd3b79ca22907b8$var$activeEffectScope;
            try {
                $0cd3b79ca22907b8$var$activeEffectScope = this;
                return fn();
            } finally{
                $0cd3b79ca22907b8$var$activeEffectScope = currentEffectScope;
            }
        }
    };
    /**
     * This should only be called on non-detached scopes
     * @internal
     */ EffectScope.prototype.on = function() {
        $0cd3b79ca22907b8$var$activeEffectScope = this;
    };
    /**
     * This should only be called on non-detached scopes
     * @internal
     */ EffectScope.prototype.off = function() {
        $0cd3b79ca22907b8$var$activeEffectScope = this.parent;
    };
    EffectScope.prototype.stop = function(fromParent) {
        if (this.active) {
            var i = void 0, l = void 0;
            for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].teardown();
            for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
            if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
            // nested scope, dereference from parent to avoid memory leaks
            if (!this.detached && this.parent && !fromParent) {
                // optimized O(1) removal
                var last = this.parent.scopes.pop();
                if (last && last !== this) {
                    this.parent.scopes[this.index] = last;
                    last.index = this.index;
                }
            }
            this.parent = undefined;
            this.active = false;
        }
    };
    return EffectScope;
}();
function $0cd3b79ca22907b8$export$7056603ea81600be(detached) {
    return new $0cd3b79ca22907b8$export$1168ed9dbc71ddbd(detached);
}
/**
 * @internal
 */ function $0cd3b79ca22907b8$var$recordEffectScope(effect, scope) {
    if (scope === void 0) scope = $0cd3b79ca22907b8$var$activeEffectScope;
    if (scope && scope.active) scope.effects.push(effect);
}
function $0cd3b79ca22907b8$export$c7be4b0125a10cba() {
    return $0cd3b79ca22907b8$var$activeEffectScope;
}
function $0cd3b79ca22907b8$export$a780418acd4762da(fn) {
    if ($0cd3b79ca22907b8$var$activeEffectScope) $0cd3b79ca22907b8$var$activeEffectScope.cleanups.push(fn);
}
function $0cd3b79ca22907b8$export$abe1e183e22e10ad(key, value) {
    if (!$0cd3b79ca22907b8$var$currentInstance) ;
    else // TS doesn't allow symbol as index type
    $0cd3b79ca22907b8$var$resolveProvided($0cd3b79ca22907b8$var$currentInstance)[key] = value;
}
function $0cd3b79ca22907b8$var$resolveProvided(vm) {
    // by default an instance inherits its parent's provides object
    // but when it needs to provide values of its own, it creates its
    // own provides object using parent provides object as prototype.
    // this way in `inject` we can simply look up injections from direct
    // parent and let the prototype chain do the work.
    var existing = vm._provided;
    var parentProvides = vm.$parent && vm.$parent._provided;
    if (parentProvides === existing) return vm._provided = Object.create(parentProvides);
    else return existing;
}
function $0cd3b79ca22907b8$export$a976684a0efeb93f(key, defaultValue, treatDefaultAsFactory) {
    if (treatDefaultAsFactory === void 0) treatDefaultAsFactory = false;
    // fallback to `currentRenderingInstance` so that this can be called in
    // a functional component
    var instance = $0cd3b79ca22907b8$var$currentInstance;
    if (instance) {
        // #2400
        // to support `app.use` plugins,
        // fallback to appContext's `provides` if the instance is at root
        var provides = instance.$parent && instance.$parent._provided;
        if (provides && key in provides) // TS doesn't allow symbol as index type
        return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && $0cd3b79ca22907b8$var$isFunction(defaultValue) ? defaultValue.call(instance) : defaultValue;
    }
}
var $0cd3b79ca22907b8$var$normalizeEvent = $0cd3b79ca22907b8$var$cached(function(name) {
    var passive = name.charAt(0) === "&";
    name = passive ? name.slice(1) : name;
    var once = name.charAt(0) === "~"; // Prefixed last, checked first
    name = once ? name.slice(1) : name;
    var capture = name.charAt(0) === "!";
    name = capture ? name.slice(1) : name;
    return {
        name: name,
        once: once,
        capture: capture,
        passive: passive
    };
});
function $0cd3b79ca22907b8$var$createFnInvoker(fns, vm) {
    function invoker() {
        var fns = invoker.fns;
        if ($0cd3b79ca22907b8$var$isArray(fns)) {
            var cloned = fns.slice();
            for(var i = 0; i < cloned.length; i++)$0cd3b79ca22907b8$var$invokeWithErrorHandling(cloned[i], null, arguments, vm, "v-on handler");
        } else // return handler return value for single handlers
        return $0cd3b79ca22907b8$var$invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler");
    }
    invoker.fns = fns;
    return invoker;
}
function $0cd3b79ca22907b8$var$updateListeners(on, oldOn, add, remove, createOnceHandler, vm) {
    var name, cur, old, event;
    for(name in on){
        cur = on[name];
        old = oldOn[name];
        event = $0cd3b79ca22907b8$var$normalizeEvent(name);
        if ($0cd3b79ca22907b8$var$isUndef(cur)) ;
        else if ($0cd3b79ca22907b8$var$isUndef(old)) {
            if ($0cd3b79ca22907b8$var$isUndef(cur.fns)) cur = on[name] = $0cd3b79ca22907b8$var$createFnInvoker(cur, vm);
            if ($0cd3b79ca22907b8$var$isTrue(event.once)) cur = on[name] = createOnceHandler(event.name, cur, event.capture);
            add(event.name, cur, event.capture, event.passive, event.params);
        } else if (cur !== old) {
            old.fns = cur;
            on[name] = old;
        }
    }
    for(name in oldOn)if ($0cd3b79ca22907b8$var$isUndef(on[name])) {
        event = $0cd3b79ca22907b8$var$normalizeEvent(name);
        remove(event.name, oldOn[name], event.capture);
    }
}
function $0cd3b79ca22907b8$var$mergeVNodeHook(def, hookKey, hook) {
    if (def instanceof $0cd3b79ca22907b8$var$VNode) def = def.data.hook || (def.data.hook = {});
    var invoker;
    var oldHook = def[hookKey];
    function wrappedHook() {
        hook.apply(this, arguments);
        // important: remove merged hook to ensure it's called only once
        // and prevent memory leak
        $0cd3b79ca22907b8$var$remove$2(invoker.fns, wrappedHook);
    }
    if ($0cd3b79ca22907b8$var$isUndef(oldHook)) // no existing hook
    invoker = $0cd3b79ca22907b8$var$createFnInvoker([
        wrappedHook
    ]);
    else /* istanbul ignore if */ if ($0cd3b79ca22907b8$var$isDef(oldHook.fns) && $0cd3b79ca22907b8$var$isTrue(oldHook.merged)) {
        // already a merged invoker
        invoker = oldHook;
        invoker.fns.push(wrappedHook);
    } else // existing plain hook
    invoker = $0cd3b79ca22907b8$var$createFnInvoker([
        oldHook,
        wrappedHook
    ]);
    invoker.merged = true;
    def[hookKey] = invoker;
}
function $0cd3b79ca22907b8$var$extractPropsFromVNodeData(data, Ctor, tag) {
    // we are only extracting raw values here.
    // validation and default values are handled in the child
    // component itself.
    var propOptions = Ctor.options.props;
    if ($0cd3b79ca22907b8$var$isUndef(propOptions)) return;
    var res = {};
    var attrs = data.attrs, props = data.props;
    if ($0cd3b79ca22907b8$var$isDef(attrs) || $0cd3b79ca22907b8$var$isDef(props)) for(var key in propOptions){
        var altKey = $0cd3b79ca22907b8$var$hyphenate(key);
        var keyInLowerCase;
        $0cd3b79ca22907b8$var$checkProp(res, props, key, altKey, true) || $0cd3b79ca22907b8$var$checkProp(res, attrs, key, altKey, false);
    }
    return res;
}
function $0cd3b79ca22907b8$var$checkProp(res, hash, key, altKey, preserve) {
    if ($0cd3b79ca22907b8$var$isDef(hash)) {
        if ($0cd3b79ca22907b8$var$hasOwn(hash, key)) {
            res[key] = hash[key];
            if (!preserve) delete hash[key];
            return true;
        } else if ($0cd3b79ca22907b8$var$hasOwn(hash, altKey)) {
            res[key] = hash[altKey];
            if (!preserve) delete hash[altKey];
            return true;
        }
    }
    return false;
}
// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:
// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function $0cd3b79ca22907b8$var$simpleNormalizeChildren(children) {
    for(var i = 0; i < children.length; i++){
        if ($0cd3b79ca22907b8$var$isArray(children[i])) return Array.prototype.concat.apply([], children);
    }
    return children;
}
// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function $0cd3b79ca22907b8$var$normalizeChildren(children) {
    return $0cd3b79ca22907b8$var$isPrimitive(children) ? [
        $0cd3b79ca22907b8$var$createTextVNode(children)
    ] : $0cd3b79ca22907b8$var$isArray(children) ? $0cd3b79ca22907b8$var$normalizeArrayChildren(children) : undefined;
}
function $0cd3b79ca22907b8$var$isTextNode(node) {
    return $0cd3b79ca22907b8$var$isDef(node) && $0cd3b79ca22907b8$var$isDef(node.text) && $0cd3b79ca22907b8$var$isFalse(node.isComment);
}
function $0cd3b79ca22907b8$var$normalizeArrayChildren(children, nestedIndex) {
    var res = [];
    var i, c, lastIndex, last;
    for(i = 0; i < children.length; i++){
        c = children[i];
        if ($0cd3b79ca22907b8$var$isUndef(c) || typeof c === "boolean") continue;
        lastIndex = res.length - 1;
        last = res[lastIndex];
        //  nested
        if ($0cd3b79ca22907b8$var$isArray(c)) {
            if (c.length > 0) {
                c = $0cd3b79ca22907b8$var$normalizeArrayChildren(c, "".concat(nestedIndex || "", "_").concat(i));
                // merge adjacent text nodes
                if ($0cd3b79ca22907b8$var$isTextNode(c[0]) && $0cd3b79ca22907b8$var$isTextNode(last)) {
                    res[lastIndex] = $0cd3b79ca22907b8$var$createTextVNode(last.text + c[0].text);
                    c.shift();
                }
                res.push.apply(res, c);
            }
        } else if ($0cd3b79ca22907b8$var$isPrimitive(c)) {
            if ($0cd3b79ca22907b8$var$isTextNode(last)) // merge adjacent text nodes
            // this is necessary for SSR hydration because text nodes are
            // essentially merged when rendered to HTML strings
            res[lastIndex] = $0cd3b79ca22907b8$var$createTextVNode(last.text + c);
            else if (c !== "") // convert primitive to vnode
            res.push($0cd3b79ca22907b8$var$createTextVNode(c));
        } else if ($0cd3b79ca22907b8$var$isTextNode(c) && $0cd3b79ca22907b8$var$isTextNode(last)) // merge adjacent text nodes
        res[lastIndex] = $0cd3b79ca22907b8$var$createTextVNode(last.text + c.text);
        else {
            // default key for nested array children (likely generated by v-for)
            if ($0cd3b79ca22907b8$var$isTrue(children._isVList) && $0cd3b79ca22907b8$var$isDef(c.tag) && $0cd3b79ca22907b8$var$isUndef(c.key) && $0cd3b79ca22907b8$var$isDef(nestedIndex)) c.key = "__vlist".concat(nestedIndex, "_").concat(i, "__");
            res.push(c);
        }
    }
    return res;
}
/**
 * Runtime helper for rendering v-for lists.
 */ function $0cd3b79ca22907b8$var$renderList(val, render) {
    var ret = null, i, l, keys, key;
    if ($0cd3b79ca22907b8$var$isArray(val) || typeof val === "string") {
        ret = new Array(val.length);
        for(i = 0, l = val.length; i < l; i++)ret[i] = render(val[i], i);
    } else if (typeof val === "number") {
        ret = new Array(val);
        for(i = 0; i < val; i++)ret[i] = render(i + 1, i);
    } else if ($0cd3b79ca22907b8$var$isObject(val)) {
        if ($0cd3b79ca22907b8$var$hasSymbol && val[Symbol.iterator]) {
            ret = [];
            var iterator = val[Symbol.iterator]();
            var result = iterator.next();
            while(!result.done){
                ret.push(render(result.value, ret.length));
                result = iterator.next();
            }
        } else {
            keys = Object.keys(val);
            ret = new Array(keys.length);
            for(i = 0, l = keys.length; i < l; i++){
                key = keys[i];
                ret[i] = render(val[key], key, i);
            }
        }
    }
    if (!$0cd3b79ca22907b8$var$isDef(ret)) ret = [];
    ret._isVList = true;
    return ret;
}
/**
 * Runtime helper for rendering <slot>
 */ function $0cd3b79ca22907b8$var$renderSlot(name, fallbackRender, props, bindObject) {
    var scopedSlotFn = this.$scopedSlots[name];
    var nodes;
    if (scopedSlotFn) {
        // scoped slot
        props = props || {};
        if (bindObject) props = $0cd3b79ca22907b8$var$extend($0cd3b79ca22907b8$var$extend({}, bindObject), props);
        nodes = scopedSlotFn(props) || ($0cd3b79ca22907b8$var$isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
    } else nodes = this.$slots[name] || ($0cd3b79ca22907b8$var$isFunction(fallbackRender) ? fallbackRender() : fallbackRender);
    var target = props && props.slot;
    if (target) return this.$createElement("template", {
        slot: target
    }, nodes);
    else return nodes;
}
/**
 * Runtime helper for resolving filters
 */ function $0cd3b79ca22907b8$var$resolveFilter(id) {
    return $0cd3b79ca22907b8$var$resolveAsset(this.$options, "filters", id, true) || $0cd3b79ca22907b8$var$identity;
}
function $0cd3b79ca22907b8$var$isKeyNotMatch(expect, actual) {
    if ($0cd3b79ca22907b8$var$isArray(expect)) return expect.indexOf(actual) === -1;
    else return expect !== actual;
}
/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */ function $0cd3b79ca22907b8$var$checkKeyCodes(eventKeyCode, key, builtInKeyCode, eventKeyName, builtInKeyName) {
    var mappedKeyCode = $0cd3b79ca22907b8$var$config.keyCodes[key] || builtInKeyCode;
    if (builtInKeyName && eventKeyName && !$0cd3b79ca22907b8$var$config.keyCodes[key]) return $0cd3b79ca22907b8$var$isKeyNotMatch(builtInKeyName, eventKeyName);
    else if (mappedKeyCode) return $0cd3b79ca22907b8$var$isKeyNotMatch(mappedKeyCode, eventKeyCode);
    else if (eventKeyName) return $0cd3b79ca22907b8$var$hyphenate(eventKeyName) !== key;
    return eventKeyCode === undefined;
}
/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */ function $0cd3b79ca22907b8$var$bindObjectProps(data, tag, value, asProp, isSync) {
    if (value) {
        if (!$0cd3b79ca22907b8$var$isObject(value)) ;
        else {
            if ($0cd3b79ca22907b8$var$isArray(value)) value = $0cd3b79ca22907b8$var$toObject(value);
            var hash = void 0;
            var _loop_1 = function(key) {
                if (key === "class" || key === "style" || $0cd3b79ca22907b8$var$isReservedAttribute(key)) hash = data;
                else {
                    var type = data.attrs && data.attrs.type;
                    hash = asProp || $0cd3b79ca22907b8$var$config.mustUseProp(tag, type, key) ? data.domProps || (data.domProps = {}) : data.attrs || (data.attrs = {});
                }
                var camelizedKey = $0cd3b79ca22907b8$var$camelize(key);
                var hyphenatedKey = $0cd3b79ca22907b8$var$hyphenate(key);
                if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
                    hash[key] = value[key];
                    if (isSync) {
                        var on = data.on || (data.on = {});
                        on["update:".concat(key)] = function($event) {
                            value[key] = $event;
                        };
                    }
                }
            };
            for(var key in value)_loop_1(key);
        }
    }
    return data;
}
/**
 * Runtime helper for rendering static trees.
 */ function $0cd3b79ca22907b8$var$renderStatic(index, isInFor) {
    var cached = this._staticTrees || (this._staticTrees = []);
    var tree = cached[index];
    // if has already-rendered static tree and not inside v-for,
    // we can reuse the same tree.
    if (tree && !isInFor) return tree;
    // otherwise, render a fresh tree.
    tree = cached[index] = this.$options.staticRenderFns[index].call(this._renderProxy, this._c, this // for render fns generated for functional component templates
    );
    $0cd3b79ca22907b8$var$markStatic(tree, "__static__".concat(index), false);
    return tree;
}
/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */ function $0cd3b79ca22907b8$var$markOnce(tree, index, key) {
    $0cd3b79ca22907b8$var$markStatic(tree, "__once__".concat(index).concat(key ? "_".concat(key) : ""), true);
    return tree;
}
function $0cd3b79ca22907b8$var$markStatic(tree, key, isOnce) {
    if ($0cd3b79ca22907b8$var$isArray(tree)) {
        for(var i = 0; i < tree.length; i++)if (tree[i] && typeof tree[i] !== "string") $0cd3b79ca22907b8$var$markStaticNode(tree[i], "".concat(key, "_").concat(i), isOnce);
    } else $0cd3b79ca22907b8$var$markStaticNode(tree, key, isOnce);
}
function $0cd3b79ca22907b8$var$markStaticNode(node, key, isOnce) {
    node.isStatic = true;
    node.key = key;
    node.isOnce = isOnce;
}
function $0cd3b79ca22907b8$var$bindObjectListeners(data, value) {
    if (value) {
        if (!$0cd3b79ca22907b8$var$isPlainObject(value)) ;
        else {
            var on = data.on = data.on ? $0cd3b79ca22907b8$var$extend({}, data.on) : {};
            for(var key in value){
                var existing = on[key];
                var ours = value[key];
                on[key] = existing ? [].concat(existing, ours) : ours;
            }
        }
    }
    return data;
}
function $0cd3b79ca22907b8$var$resolveScopedSlots(fns, res, // the following are added in 2.6
hasDynamicKeys, contentHashKey) {
    res = res || {
        $stable: !hasDynamicKeys
    };
    for(var i = 0; i < fns.length; i++){
        var slot = fns[i];
        if ($0cd3b79ca22907b8$var$isArray(slot)) $0cd3b79ca22907b8$var$resolveScopedSlots(slot, res, hasDynamicKeys);
        else if (slot) {
            // marker for reverse proxying v-slot without scope on this.$slots
            // @ts-expect-error
            if (slot.proxy) // @ts-expect-error
            slot.fn.proxy = true;
            res[slot.key] = slot.fn;
        }
    }
    if (contentHashKey) res.$key = contentHashKey;
    return res;
}
// helper to process dynamic keys for dynamic arguments in v-bind and v-on.
function $0cd3b79ca22907b8$var$bindDynamicKeys(baseObj, values) {
    for(var i = 0; i < values.length; i += 2){
        var key = values[i];
        if (typeof key === "string" && key) baseObj[values[i]] = values[i + 1];
    }
    return baseObj;
}
// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function $0cd3b79ca22907b8$var$prependModifier(value, symbol) {
    return typeof value === "string" ? symbol + value : value;
}
function $0cd3b79ca22907b8$var$installRenderHelpers(target) {
    target._o = $0cd3b79ca22907b8$var$markOnce;
    target._n = $0cd3b79ca22907b8$var$toNumber;
    target._s = $0cd3b79ca22907b8$var$toString;
    target._l = $0cd3b79ca22907b8$var$renderList;
    target._t = $0cd3b79ca22907b8$var$renderSlot;
    target._q = $0cd3b79ca22907b8$var$looseEqual;
    target._i = $0cd3b79ca22907b8$var$looseIndexOf;
    target._m = $0cd3b79ca22907b8$var$renderStatic;
    target._f = $0cd3b79ca22907b8$var$resolveFilter;
    target._k = $0cd3b79ca22907b8$var$checkKeyCodes;
    target._b = $0cd3b79ca22907b8$var$bindObjectProps;
    target._v = $0cd3b79ca22907b8$var$createTextVNode;
    target._e = $0cd3b79ca22907b8$var$createEmptyVNode;
    target._u = $0cd3b79ca22907b8$var$resolveScopedSlots;
    target._g = $0cd3b79ca22907b8$var$bindObjectListeners;
    target._d = $0cd3b79ca22907b8$var$bindDynamicKeys;
    target._p = $0cd3b79ca22907b8$var$prependModifier;
}
/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */ function $0cd3b79ca22907b8$var$resolveSlots(children, context) {
    if (!children || !children.length) return {};
    var slots = {};
    for(var i = 0, l = children.length; i < l; i++){
        var child = children[i];
        var data = child.data;
        // remove slot attribute if the node is resolved as a Vue slot node
        if (data && data.attrs && data.attrs.slot) delete data.attrs.slot;
        // named slots should only be respected if the vnode was rendered in the
        // same context.
        if ((child.context === context || child.fnContext === context) && data && data.slot != null) {
            var name_1 = data.slot;
            var slot = slots[name_1] || (slots[name_1] = []);
            if (child.tag === "template") slot.push.apply(slot, child.children || []);
            else slot.push(child);
        } else (slots.default || (slots.default = [])).push(child);
    }
    // ignore slots that contains only whitespace
    for(var name_2 in slots)if (slots[name_2].every($0cd3b79ca22907b8$var$isWhitespace)) delete slots[name_2];
    return slots;
}
function $0cd3b79ca22907b8$var$isWhitespace(node) {
    return node.isComment && !node.asyncFactory || node.text === " ";
}
function $0cd3b79ca22907b8$var$isAsyncPlaceholder(node) {
    // @ts-expect-error not really boolean type
    return node.isComment && node.asyncFactory;
}
function $0cd3b79ca22907b8$var$normalizeScopedSlots(ownerVm, scopedSlots, normalSlots, prevScopedSlots) {
    var res;
    var hasNormalSlots = Object.keys(normalSlots).length > 0;
    var isStable = scopedSlots ? !!scopedSlots.$stable : !hasNormalSlots;
    var key = scopedSlots && scopedSlots.$key;
    if (!scopedSlots) res = {};
    else if (scopedSlots._normalized) // fast path 1: child component re-render only, parent did not change
    return scopedSlots._normalized;
    else if (isStable && prevScopedSlots && prevScopedSlots !== $0cd3b79ca22907b8$var$emptyObject && key === prevScopedSlots.$key && !hasNormalSlots && !prevScopedSlots.$hasNormal) // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevScopedSlots;
    else {
        res = {};
        for(var key_1 in scopedSlots)if (scopedSlots[key_1] && key_1[0] !== "$") res[key_1] = $0cd3b79ca22907b8$var$normalizeScopedSlot(ownerVm, normalSlots, key_1, scopedSlots[key_1]);
    }
    // expose normal slots on scopedSlots
    for(var key_2 in normalSlots)if (!(key_2 in res)) res[key_2] = $0cd3b79ca22907b8$var$proxyNormalSlot(normalSlots, key_2);
    // avoriaz seems to mock a non-extensible $scopedSlots object
    // and when that is passed down this would cause an error
    if (scopedSlots && Object.isExtensible(scopedSlots)) scopedSlots._normalized = res;
    $0cd3b79ca22907b8$var$def(res, "$stable", isStable);
    $0cd3b79ca22907b8$var$def(res, "$key", key);
    $0cd3b79ca22907b8$var$def(res, "$hasNormal", hasNormalSlots);
    return res;
}
function $0cd3b79ca22907b8$var$normalizeScopedSlot(vm, normalSlots, key, fn) {
    var normalized = function() {
        var cur = $0cd3b79ca22907b8$var$currentInstance;
        $0cd3b79ca22907b8$var$setCurrentInstance(vm);
        var res = arguments.length ? fn.apply(null, arguments) : fn({});
        res = res && typeof res === "object" && !$0cd3b79ca22907b8$var$isArray(res) ? [
            res
        ] // single vnode
         : $0cd3b79ca22907b8$var$normalizeChildren(res);
        var vnode = res && res[0];
        $0cd3b79ca22907b8$var$setCurrentInstance(cur);
        return res && (!vnode || res.length === 1 && vnode.isComment && !$0cd3b79ca22907b8$var$isAsyncPlaceholder(vnode) // #9658, #10391
        ) ? undefined : res;
    };
    // this is a slot using the new v-slot syntax without scope. although it is
    // compiled as a scoped slot, render fn users would expect it to be present
    // on this.$slots because the usage is semantically a normal slot.
    if (fn.proxy) Object.defineProperty(normalSlots, key, {
        get: normalized,
        enumerable: true,
        configurable: true
    });
    return normalized;
}
function $0cd3b79ca22907b8$var$proxyNormalSlot(slots, key) {
    return function() {
        return slots[key];
    };
}
function $0cd3b79ca22907b8$var$initSetup(vm) {
    var options = vm.$options;
    var setup = options.setup;
    if (setup) {
        var ctx = vm._setupContext = $0cd3b79ca22907b8$var$createSetupContext(vm);
        $0cd3b79ca22907b8$var$setCurrentInstance(vm);
        $0cd3b79ca22907b8$var$pushTarget();
        var setupResult = $0cd3b79ca22907b8$var$invokeWithErrorHandling(setup, null, [
            vm._props || $0cd3b79ca22907b8$export$8d81cefd22d22260({}),
            ctx
        ], vm, "setup");
        $0cd3b79ca22907b8$var$popTarget();
        $0cd3b79ca22907b8$var$setCurrentInstance();
        if ($0cd3b79ca22907b8$var$isFunction(setupResult)) // render function
        // @ts-ignore
        options.render = setupResult;
        else if ($0cd3b79ca22907b8$var$isObject(setupResult)) {
            vm._setupState = setupResult;
            // __sfc indicates compiled bindings from <script setup>
            if (!setupResult.__sfc) {
                for(var key in setupResult)if (!$0cd3b79ca22907b8$var$isReserved(key)) $0cd3b79ca22907b8$var$proxyWithRefUnwrap(vm, setupResult, key);
            } else {
                // exposed for compiled render fn
                var proxy = vm._setupProxy = {};
                for(var key in setupResult)if (key !== "__sfc") $0cd3b79ca22907b8$var$proxyWithRefUnwrap(proxy, setupResult, key);
            }
        }
    }
}
function $0cd3b79ca22907b8$var$createSetupContext(vm) {
    var exposeCalled = false;
    return {
        get attrs () {
            if (!vm._attrsProxy) {
                var proxy = vm._attrsProxy = {};
                $0cd3b79ca22907b8$var$def(proxy, "_v_attr_proxy", true);
                $0cd3b79ca22907b8$var$syncSetupProxy(proxy, vm.$attrs, $0cd3b79ca22907b8$var$emptyObject, vm, "$attrs");
            }
            return vm._attrsProxy;
        },
        get listeners () {
            if (!vm._listenersProxy) {
                var proxy1 = vm._listenersProxy = {};
                $0cd3b79ca22907b8$var$syncSetupProxy(proxy1, vm.$listeners, $0cd3b79ca22907b8$var$emptyObject, vm, "$listeners");
            }
            return vm._listenersProxy;
        },
        get slots () {
            return $0cd3b79ca22907b8$var$initSlotsProxy(vm);
        },
        emit: $0cd3b79ca22907b8$var$bind(vm.$emit, vm),
        expose: function(exposed) {
            if (exposed) Object.keys(exposed).forEach(function(key) {
                return $0cd3b79ca22907b8$var$proxyWithRefUnwrap(vm, exposed, key);
            });
        }
    };
}
function $0cd3b79ca22907b8$var$syncSetupProxy(to, from, prev, instance, type) {
    var changed = false;
    for(var key in from){
        if (!(key in to)) {
            changed = true;
            $0cd3b79ca22907b8$var$defineProxyAttr(to, key, instance, type);
        } else if (from[key] !== prev[key]) changed = true;
    }
    for(var key in to)if (!(key in from)) {
        changed = true;
        delete to[key];
    }
    return changed;
}
function $0cd3b79ca22907b8$var$defineProxyAttr(proxy, key, instance, type) {
    Object.defineProperty(proxy, key, {
        enumerable: true,
        configurable: true,
        get: function() {
            return instance[type][key];
        }
    });
}
function $0cd3b79ca22907b8$var$initSlotsProxy(vm) {
    if (!vm._slotsProxy) $0cd3b79ca22907b8$var$syncSetupSlots(vm._slotsProxy = {}, vm.$scopedSlots);
    return vm._slotsProxy;
}
function $0cd3b79ca22907b8$var$syncSetupSlots(to, from) {
    for(var key in from)to[key] = from[key];
    for(var key in to)if (!(key in from)) delete to[key];
}
/**
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */ function $0cd3b79ca22907b8$export$9203a8e84125433c() {
    return $0cd3b79ca22907b8$var$getContext().slots;
}
/**
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */ function $0cd3b79ca22907b8$export$75e29435042cd2ea() {
    return $0cd3b79ca22907b8$var$getContext().attrs;
}
/**
 * Vue 2 only
 * @internal use manual type def because public setup context type relies on
 * legacy VNode types
 */ function $0cd3b79ca22907b8$export$23ea48d3fbb763f5() {
    return $0cd3b79ca22907b8$var$getContext().listeners;
}
function $0cd3b79ca22907b8$var$getContext() {
    var vm = $0cd3b79ca22907b8$var$currentInstance;
    return vm._setupContext || (vm._setupContext = $0cd3b79ca22907b8$var$createSetupContext(vm));
}
/**
 * Runtime helper for merging default declarations. Imported by compiled code
 * only.
 * @internal
 */ function $0cd3b79ca22907b8$export$ec60f47d4a8a2e7f(raw, defaults) {
    var props = $0cd3b79ca22907b8$var$isArray(raw) ? raw.reduce(function(normalized, p) {
        return normalized[p] = {}, normalized;
    }, {}) : raw;
    for(var key in defaults){
        var opt = props[key];
        if (opt) {
            if ($0cd3b79ca22907b8$var$isArray(opt) || $0cd3b79ca22907b8$var$isFunction(opt)) props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) props[key] = {
            default: defaults[key]
        };
    }
    return props;
}
function $0cd3b79ca22907b8$var$initRender(vm) {
    vm._vnode = null; // the root of the child tree
    vm._staticTrees = null; // v-once cached trees
    var options = vm.$options;
    var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
    var renderContext = parentVnode && parentVnode.context;
    vm.$slots = $0cd3b79ca22907b8$var$resolveSlots(options._renderChildren, renderContext);
    vm.$scopedSlots = parentVnode ? $0cd3b79ca22907b8$var$normalizeScopedSlots(vm.$parent, parentVnode.data.scopedSlots, vm.$slots) : $0cd3b79ca22907b8$var$emptyObject;
    // bind the createElement fn to this instance
    // so that we get proper render context inside it.
    // args order: tag, data, children, normalizationType, alwaysNormalize
    // internal version is used by render functions compiled from templates
    // @ts-expect-error
    vm._c = function(a, b, c, d) {
        return $0cd3b79ca22907b8$var$createElement$1(vm, a, b, c, d, false);
    };
    // normalization is always applied for the public version, used in
    // user-written render functions.
    // @ts-expect-error
    vm.$createElement = function(a, b, c, d) {
        return $0cd3b79ca22907b8$var$createElement$1(vm, a, b, c, d, true);
    };
    // $attrs & $listeners are exposed for easier HOC creation.
    // they need to be reactive so that HOCs using them are always updated
    var parentData = parentVnode && parentVnode.data;
    $0cd3b79ca22907b8$var$defineReactive(vm, "$attrs", parentData && parentData.attrs || $0cd3b79ca22907b8$var$emptyObject, null, true);
    $0cd3b79ca22907b8$var$defineReactive(vm, "$listeners", options._parentListeners || $0cd3b79ca22907b8$var$emptyObject, null, true);
}
var $0cd3b79ca22907b8$var$currentRenderingInstance = null;
function $0cd3b79ca22907b8$var$renderMixin(Vue) {
    // install runtime convenience helpers
    $0cd3b79ca22907b8$var$installRenderHelpers(Vue.prototype);
    Vue.prototype.$nextTick = function(fn) {
        return $0cd3b79ca22907b8$export$bdd553fddd433dcb(fn, this);
    };
    Vue.prototype._render = function() {
        var vm = this;
        var _a = vm.$options, render = _a.render, _parentVnode = _a._parentVnode;
        if (_parentVnode && vm._isMounted) {
            vm.$scopedSlots = $0cd3b79ca22907b8$var$normalizeScopedSlots(vm.$parent, _parentVnode.data.scopedSlots, vm.$slots, vm.$scopedSlots);
            if (vm._slotsProxy) $0cd3b79ca22907b8$var$syncSetupSlots(vm._slotsProxy, vm.$scopedSlots);
        }
        // set parent vnode. this allows render functions to have access
        // to the data on the placeholder node.
        vm.$vnode = _parentVnode;
        // render self
        var vnode;
        try {
            // There's no need to maintain a stack because all render fns are called
            // separately from one another. Nested component's render fns are called
            // when parent component is patched.
            $0cd3b79ca22907b8$var$setCurrentInstance(vm);
            $0cd3b79ca22907b8$var$currentRenderingInstance = vm;
            vnode = render.call(vm._renderProxy, vm.$createElement);
        } catch (e1) {
            $0cd3b79ca22907b8$var$handleError(e1, vm, "render");
            var e;
            vnode = vm._vnode;
        } finally{
            $0cd3b79ca22907b8$var$currentRenderingInstance = null;
            $0cd3b79ca22907b8$var$setCurrentInstance();
        }
        // if the returned array contains only a single node, allow it
        if ($0cd3b79ca22907b8$var$isArray(vnode) && vnode.length === 1) vnode = vnode[0];
        // return empty vnode in case the render function errored out
        if (!(vnode instanceof $0cd3b79ca22907b8$var$VNode)) vnode = $0cd3b79ca22907b8$var$createEmptyVNode();
        // set parent
        vnode.parent = _parentVnode;
        return vnode;
    };
}
function $0cd3b79ca22907b8$var$ensureCtor(comp, base) {
    if (comp.__esModule || $0cd3b79ca22907b8$var$hasSymbol && comp[Symbol.toStringTag] === "Module") comp = comp.default;
    return $0cd3b79ca22907b8$var$isObject(comp) ? base.extend(comp) : comp;
}
function $0cd3b79ca22907b8$var$createAsyncPlaceholder(factory, data, context, children, tag) {
    var node = $0cd3b79ca22907b8$var$createEmptyVNode();
    node.asyncFactory = factory;
    node.asyncMeta = {
        data: data,
        context: context,
        children: children,
        tag: tag
    };
    return node;
}
function $0cd3b79ca22907b8$var$resolveAsyncComponent(factory, baseCtor) {
    if ($0cd3b79ca22907b8$var$isTrue(factory.error) && $0cd3b79ca22907b8$var$isDef(factory.errorComp)) return factory.errorComp;
    if ($0cd3b79ca22907b8$var$isDef(factory.resolved)) return factory.resolved;
    var owner = $0cd3b79ca22907b8$var$currentRenderingInstance;
    if (owner && $0cd3b79ca22907b8$var$isDef(factory.owners) && factory.owners.indexOf(owner) === -1) // already pending
    factory.owners.push(owner);
    if ($0cd3b79ca22907b8$var$isTrue(factory.loading) && $0cd3b79ca22907b8$var$isDef(factory.loadingComp)) return factory.loadingComp;
    if (owner && !$0cd3b79ca22907b8$var$isDef(factory.owners)) {
        var owners_1 = factory.owners = [
            owner
        ];
        var sync_1 = true;
        var timerLoading_1 = null;
        var timerTimeout_1 = null;
        owner.$on("hook:destroyed", function() {
            return $0cd3b79ca22907b8$var$remove$2(owners_1, owner);
        });
        var forceRender_1 = function(renderCompleted) {
            for(var i = 0, l = owners_1.length; i < l; i++)owners_1[i].$forceUpdate();
            if (renderCompleted) {
                owners_1.length = 0;
                if (timerLoading_1 !== null) {
                    clearTimeout(timerLoading_1);
                    timerLoading_1 = null;
                }
                if (timerTimeout_1 !== null) {
                    clearTimeout(timerTimeout_1);
                    timerTimeout_1 = null;
                }
            }
        };
        var resolve = $0cd3b79ca22907b8$var$once(function(res) {
            // cache resolved
            factory.resolved = $0cd3b79ca22907b8$var$ensureCtor(res, baseCtor);
            // invoke callbacks only if this is not a synchronous resolve
            // (async resolves are shimmed as synchronous during SSR)
            if (!sync_1) forceRender_1(true);
            else owners_1.length = 0;
        });
        var reject_1 = $0cd3b79ca22907b8$var$once(function(reason) {
            if ($0cd3b79ca22907b8$var$isDef(factory.errorComp)) {
                factory.error = true;
                forceRender_1(true);
            }
        });
        var res_1 = factory(resolve, reject_1);
        if ($0cd3b79ca22907b8$var$isObject(res_1)) {
            if ($0cd3b79ca22907b8$var$isPromise(res_1)) // () => Promise
            {
                if ($0cd3b79ca22907b8$var$isUndef(factory.resolved)) res_1.then(resolve, reject_1);
            } else if ($0cd3b79ca22907b8$var$isPromise(res_1.component)) {
                res_1.component.then(resolve, reject_1);
                if ($0cd3b79ca22907b8$var$isDef(res_1.error)) factory.errorComp = $0cd3b79ca22907b8$var$ensureCtor(res_1.error, baseCtor);
                if ($0cd3b79ca22907b8$var$isDef(res_1.loading)) {
                    factory.loadingComp = $0cd3b79ca22907b8$var$ensureCtor(res_1.loading, baseCtor);
                    if (res_1.delay === 0) factory.loading = true;
                    else // @ts-expect-error NodeJS timeout type
                    timerLoading_1 = setTimeout(function() {
                        timerLoading_1 = null;
                        if ($0cd3b79ca22907b8$var$isUndef(factory.resolved) && $0cd3b79ca22907b8$var$isUndef(factory.error)) {
                            factory.loading = true;
                            forceRender_1(false);
                        }
                    }, res_1.delay || 200);
                }
                if ($0cd3b79ca22907b8$var$isDef(res_1.timeout)) // @ts-expect-error NodeJS timeout type
                timerTimeout_1 = setTimeout(function() {
                    timerTimeout_1 = null;
                    if ($0cd3b79ca22907b8$var$isUndef(factory.resolved)) reject_1(null);
                }, res_1.timeout);
            }
        }
        sync_1 = false;
        // return in case resolved synchronously
        return factory.loading ? factory.loadingComp : factory.resolved;
    }
}
function $0cd3b79ca22907b8$var$getFirstComponentChild(children) {
    if ($0cd3b79ca22907b8$var$isArray(children)) for(var i = 0; i < children.length; i++){
        var c = children[i];
        if ($0cd3b79ca22907b8$var$isDef(c) && ($0cd3b79ca22907b8$var$isDef(c.componentOptions) || $0cd3b79ca22907b8$var$isAsyncPlaceholder(c))) return c;
    }
}
var $0cd3b79ca22907b8$var$SIMPLE_NORMALIZE = 1;
var $0cd3b79ca22907b8$var$ALWAYS_NORMALIZE = 2;
// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function $0cd3b79ca22907b8$var$createElement$1(context, tag, data, children, normalizationType, alwaysNormalize) {
    if ($0cd3b79ca22907b8$var$isArray(data) || $0cd3b79ca22907b8$var$isPrimitive(data)) {
        normalizationType = children;
        children = data;
        data = undefined;
    }
    if ($0cd3b79ca22907b8$var$isTrue(alwaysNormalize)) normalizationType = $0cd3b79ca22907b8$var$ALWAYS_NORMALIZE;
    return $0cd3b79ca22907b8$var$_createElement(context, tag, data, children, normalizationType);
}
function $0cd3b79ca22907b8$var$_createElement(context, tag, data, children, normalizationType) {
    if ($0cd3b79ca22907b8$var$isDef(data) && $0cd3b79ca22907b8$var$isDef(data.__ob__)) return $0cd3b79ca22907b8$var$createEmptyVNode();
    // object syntax in v-bind
    if ($0cd3b79ca22907b8$var$isDef(data) && $0cd3b79ca22907b8$var$isDef(data.is)) tag = data.is;
    if (!tag) // in case of component :is set to falsy value
    return $0cd3b79ca22907b8$var$createEmptyVNode();
    // support single function children as default scoped slot
    if ($0cd3b79ca22907b8$var$isArray(children) && $0cd3b79ca22907b8$var$isFunction(children[0])) {
        data = data || {};
        data.scopedSlots = {
            default: children[0]
        };
        children.length = 0;
    }
    if (normalizationType === $0cd3b79ca22907b8$var$ALWAYS_NORMALIZE) children = $0cd3b79ca22907b8$var$normalizeChildren(children);
    else if (normalizationType === $0cd3b79ca22907b8$var$SIMPLE_NORMALIZE) children = $0cd3b79ca22907b8$var$simpleNormalizeChildren(children);
    var vnode, ns;
    if (typeof tag === "string") {
        var Ctor = void 0;
        ns = context.$vnode && context.$vnode.ns || $0cd3b79ca22907b8$var$config.getTagNamespace(tag);
        if ($0cd3b79ca22907b8$var$config.isReservedTag(tag)) vnode = new $0cd3b79ca22907b8$var$VNode($0cd3b79ca22907b8$var$config.parsePlatformTagName(tag), data, children, undefined, undefined, context);
        else if ((!data || !data.pre) && $0cd3b79ca22907b8$var$isDef(Ctor = $0cd3b79ca22907b8$var$resolveAsset(context.$options, "components", tag))) // component
        vnode = $0cd3b79ca22907b8$var$createComponent(Ctor, data, context, children, tag);
        else // unknown or unlisted namespaced elements
        // check at runtime because it may get assigned a namespace when its
        // parent normalizes children
        vnode = new $0cd3b79ca22907b8$var$VNode(tag, data, children, undefined, undefined, context);
    } else // direct component options / constructor
    vnode = $0cd3b79ca22907b8$var$createComponent(tag, data, context, children);
    if ($0cd3b79ca22907b8$var$isArray(vnode)) return vnode;
    else if ($0cd3b79ca22907b8$var$isDef(vnode)) {
        if ($0cd3b79ca22907b8$var$isDef(ns)) $0cd3b79ca22907b8$var$applyNS(vnode, ns);
        if ($0cd3b79ca22907b8$var$isDef(data)) $0cd3b79ca22907b8$var$registerDeepBindings(data);
        return vnode;
    } else return $0cd3b79ca22907b8$var$createEmptyVNode();
}
function $0cd3b79ca22907b8$var$applyNS(vnode, ns, force) {
    vnode.ns = ns;
    if (vnode.tag === "foreignObject") {
        // use default namespace inside foreignObject
        ns = undefined;
        force = true;
    }
    if ($0cd3b79ca22907b8$var$isDef(vnode.children)) for(var i = 0, l = vnode.children.length; i < l; i++){
        var child = vnode.children[i];
        if ($0cd3b79ca22907b8$var$isDef(child.tag) && ($0cd3b79ca22907b8$var$isUndef(child.ns) || $0cd3b79ca22907b8$var$isTrue(force) && child.tag !== "svg")) $0cd3b79ca22907b8$var$applyNS(child, ns, force);
    }
}
// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function $0cd3b79ca22907b8$var$registerDeepBindings(data) {
    if ($0cd3b79ca22907b8$var$isObject(data.style)) $0cd3b79ca22907b8$var$traverse(data.style);
    if ($0cd3b79ca22907b8$var$isObject(data.class)) $0cd3b79ca22907b8$var$traverse(data.class);
}
/**
 * @internal this function needs manual public type declaration because it relies
 * on previously manually authored types from Vue 2
 */ function $0cd3b79ca22907b8$export$dda1d9f60106f0e9(type, props, children) {
    $0cd3b79ca22907b8$var$currentInstance;
    return $0cd3b79ca22907b8$var$createElement$1($0cd3b79ca22907b8$var$currentInstance, type, props, children, 2, true);
}
function $0cd3b79ca22907b8$var$handleError(err, vm, info) {
    // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
    // See: https://github.com/vuejs/vuex/issues/1505
    $0cd3b79ca22907b8$var$pushTarget();
    try {
        if (vm) {
            var cur = vm;
            while(cur = cur.$parent){
                var hooks = cur.$options.errorCaptured;
                if (hooks) {
                    for(var i = 0; i < hooks.length; i++)try {
                        var capture = hooks[i].call(cur, err, vm, info) === false;
                        if (capture) return;
                    } catch (e) {
                        $0cd3b79ca22907b8$var$globalHandleError(e, cur, "errorCaptured hook");
                    }
                }
            }
        }
        $0cd3b79ca22907b8$var$globalHandleError(err, vm, info);
    } finally{
        $0cd3b79ca22907b8$var$popTarget();
    }
}
function $0cd3b79ca22907b8$var$invokeWithErrorHandling(handler, context, args, vm, info) {
    var res;
    try {
        res = args ? handler.apply(context, args) : handler.call(context);
        if (res && !res._isVue && $0cd3b79ca22907b8$var$isPromise(res) && !res._handled) {
            res.catch(function(e) {
                return $0cd3b79ca22907b8$var$handleError(e, vm, info + " (Promise/async)");
            });
            res._handled = true;
        }
    } catch (e) {
        $0cd3b79ca22907b8$var$handleError(e, vm, info);
    }
    return res;
}
function $0cd3b79ca22907b8$var$globalHandleError(err, vm, info) {
    if ($0cd3b79ca22907b8$var$config.errorHandler) try {
        return $0cd3b79ca22907b8$var$config.errorHandler.call(null, err, vm, info);
    } catch (e) {
        // if the user intentionally throws the original error in the handler,
        // do not log it twice
        if (e !== err) $0cd3b79ca22907b8$var$logError(e, null, "config.errorHandler");
    }
    $0cd3b79ca22907b8$var$logError(err, vm, info);
}
function $0cd3b79ca22907b8$var$logError(err, vm, info) {
    /* istanbul ignore else */ if ($0cd3b79ca22907b8$var$inBrowser && typeof console !== "undefined") console.error(err);
    else throw err;
}
/* globals MutationObserver */ var $0cd3b79ca22907b8$var$isUsingMicroTask = false;
var $0cd3b79ca22907b8$var$callbacks = [];
var $0cd3b79ca22907b8$var$pending = false;
function $0cd3b79ca22907b8$var$flushCallbacks() {
    $0cd3b79ca22907b8$var$pending = false;
    var copies = $0cd3b79ca22907b8$var$callbacks.slice(0);
    $0cd3b79ca22907b8$var$callbacks.length = 0;
    for(var i = 0; i < copies.length; i++)copies[i]();
}
// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var $0cd3b79ca22907b8$var$timerFunc;
// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */ if (typeof Promise !== "undefined" && $0cd3b79ca22907b8$var$isNative(Promise)) {
    var $0cd3b79ca22907b8$var$p_1 = Promise.resolve();
    $0cd3b79ca22907b8$var$timerFunc = function() {
        $0cd3b79ca22907b8$var$p_1.then($0cd3b79ca22907b8$var$flushCallbacks);
        // In problematic UIWebViews, Promise.then doesn't completely break, but
        // it can get stuck in a weird state where callbacks are pushed into the
        // microtask queue but the queue isn't being flushed, until the browser
        // needs to do some other work, e.g. handle a timer. Therefore we can
        // "force" the microtask queue to be flushed by adding an empty timer.
        if ($0cd3b79ca22907b8$var$isIOS) setTimeout($0cd3b79ca22907b8$var$noop);
    };
    $0cd3b79ca22907b8$var$isUsingMicroTask = true;
} else if (!$0cd3b79ca22907b8$var$isIE && typeof MutationObserver !== "undefined" && ($0cd3b79ca22907b8$var$isNative(MutationObserver) || // PhantomJS and iOS 7.x
MutationObserver.toString() === "[object MutationObserverConstructor]")) {
    // Use MutationObserver where native Promise is not available,
    // e.g. PhantomJS, iOS7, Android 4.4
    // (#6466 MutationObserver is unreliable in IE11)
    var $0cd3b79ca22907b8$var$counter_1 = 1;
    var $0cd3b79ca22907b8$var$observer = new MutationObserver($0cd3b79ca22907b8$var$flushCallbacks);
    var $0cd3b79ca22907b8$var$textNode_1 = document.createTextNode(String($0cd3b79ca22907b8$var$counter_1));
    $0cd3b79ca22907b8$var$observer.observe($0cd3b79ca22907b8$var$textNode_1, {
        characterData: true
    });
    $0cd3b79ca22907b8$var$timerFunc = function() {
        $0cd3b79ca22907b8$var$counter_1 = ($0cd3b79ca22907b8$var$counter_1 + 1) % 2;
        $0cd3b79ca22907b8$var$textNode_1.data = String($0cd3b79ca22907b8$var$counter_1);
    };
    $0cd3b79ca22907b8$var$isUsingMicroTask = true;
} else if (typeof setImmediate !== "undefined" && $0cd3b79ca22907b8$var$isNative(setImmediate)) // Fallback to setImmediate.
// Technically it leverages the (macro) task queue,
// but it is still a better choice than setTimeout.
$0cd3b79ca22907b8$var$timerFunc = function() {
    setImmediate($0cd3b79ca22907b8$var$flushCallbacks);
};
else // Fallback to setTimeout.
$0cd3b79ca22907b8$var$timerFunc = function() {
    setTimeout($0cd3b79ca22907b8$var$flushCallbacks, 0);
};
/**
 * @internal
 */ function $0cd3b79ca22907b8$export$bdd553fddd433dcb(cb, ctx) {
    var _resolve;
    $0cd3b79ca22907b8$var$callbacks.push(function() {
        if (cb) try {
            cb.call(ctx);
        } catch (e) {
            $0cd3b79ca22907b8$var$handleError(e, ctx, "nextTick");
        }
        else if (_resolve) _resolve(ctx);
    });
    if (!$0cd3b79ca22907b8$var$pending) {
        $0cd3b79ca22907b8$var$pending = true;
        $0cd3b79ca22907b8$var$timerFunc();
    }
    // $flow-disable-line
    if (!cb && typeof Promise !== "undefined") return new Promise(function(resolve) {
        _resolve = resolve;
    });
}
function $0cd3b79ca22907b8$export$9300d5b90d56e3d1(name) {
    if (name === void 0) name = "$style";
    if (!$0cd3b79ca22907b8$var$currentInstance) return $0cd3b79ca22907b8$var$emptyObject;
    var mod = $0cd3b79ca22907b8$var$currentInstance[name];
    if (!mod) return $0cd3b79ca22907b8$var$emptyObject;
    return mod;
}
/**
 * Runtime helper for SFC's CSS variable injection feature.
 * @private
 */ function $0cd3b79ca22907b8$export$ef28b76f07940108(getter) {
    if (!$0cd3b79ca22907b8$var$inBrowser && true) return;
    var instance = $0cd3b79ca22907b8$var$currentInstance;
    if (!instance) return;
    $0cd3b79ca22907b8$export$b7f27ea67102d543(function() {
        var el = instance.$el;
        var vars = getter(instance, instance._setupProxy);
        if (el && el.nodeType === 1) {
            var style = el.style;
            for(var key in vars)style.setProperty("--".concat(key), vars[key]);
        }
    });
}
/**
 * v3-compatible async component API.
 * @internal the type is manually declared in <root>/types/v3-define-async-component.d.ts
 * because it relies on existing manual types
 */ function $0cd3b79ca22907b8$export$d75d499b4c16cf21(source) {
    if ($0cd3b79ca22907b8$var$isFunction(source)) source = {
        loader: source
    };
    var loader = source.loader, loadingComponent = source.loadingComponent, errorComponent = source.errorComponent, _a = source.delay, delay = _a === void 0 ? 200 : _a, timeout = source.timeout, _b = source.suspensible, suspensible = _b === void 0 ? false : _b, userOnError = source.onError;
    var pendingRequest = null;
    var retries = 0;
    var retry = function() {
        retries++;
        pendingRequest = null;
        return load();
    };
    var load = function() {
        var thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch(function(err) {
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise(function(resolve, reject) {
                var userRetry = function() {
                    return resolve(retry());
                };
                var userFail = function() {
                    return reject(err);
                };
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then(function(comp) {
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            // interop module default
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            return comp;
        }));
    };
    return function() {
        var component = load();
        return {
            component: component,
            delay: delay,
            timeout: timeout,
            error: errorComponent,
            loading: loadingComponent
        };
    };
}
function $0cd3b79ca22907b8$var$createLifeCycle(hookName) {
    return function(fn, target) {
        if (target === void 0) target = $0cd3b79ca22907b8$var$currentInstance;
        if (!target) return;
        return $0cd3b79ca22907b8$var$injectHook(target, hookName, fn);
    };
}
function $0cd3b79ca22907b8$var$formatName(name) {
    if (name === "beforeDestroy") name = "beforeUnmount";
    else if (name === "destroyed") name = "unmounted";
    return "on".concat(name[0].toUpperCase() + name.slice(1));
}
function $0cd3b79ca22907b8$var$injectHook(instance, hookName, fn) {
    var options = instance.$options;
    options[hookName] = $0cd3b79ca22907b8$var$mergeLifecycleHook(options[hookName], fn);
}
var $0cd3b79ca22907b8$export$23b7aeb0d671f804 = $0cd3b79ca22907b8$var$createLifeCycle("beforeMount");
var $0cd3b79ca22907b8$export$6d1641039221b5cb = $0cd3b79ca22907b8$var$createLifeCycle("mounted");
var $0cd3b79ca22907b8$export$ab91988a13872e4c = $0cd3b79ca22907b8$var$createLifeCycle("beforeUpdate");
var $0cd3b79ca22907b8$export$5876c47052fb88b1 = $0cd3b79ca22907b8$var$createLifeCycle("updated");
var $0cd3b79ca22907b8$export$40c420df62d2614 = $0cd3b79ca22907b8$var$createLifeCycle("beforeDestroy");
var $0cd3b79ca22907b8$export$13348a43ccacfe58 = $0cd3b79ca22907b8$var$createLifeCycle("destroyed");
var $0cd3b79ca22907b8$export$ba52d824b95a2154 = $0cd3b79ca22907b8$var$createLifeCycle("activated");
var $0cd3b79ca22907b8$export$bf1440eeaf5fa709 = $0cd3b79ca22907b8$var$createLifeCycle("deactivated");
var $0cd3b79ca22907b8$export$ebf0c601f267bceb = $0cd3b79ca22907b8$var$createLifeCycle("serverPrefetch");
var $0cd3b79ca22907b8$export$2b41f4235363e921 = $0cd3b79ca22907b8$var$createLifeCycle("renderTracked");
var $0cd3b79ca22907b8$export$898295a813d662eb = $0cd3b79ca22907b8$var$createLifeCycle("renderTriggered");
var $0cd3b79ca22907b8$var$injectErrorCapturedHook = $0cd3b79ca22907b8$var$createLifeCycle("errorCaptured");
function $0cd3b79ca22907b8$export$6a3a15856e50ad19(hook, target) {
    if (target === void 0) target = $0cd3b79ca22907b8$var$currentInstance;
    $0cd3b79ca22907b8$var$injectErrorCapturedHook(hook, target);
}
/**
 * Note: also update dist/vue.runtime.mjs when adding new exports to this file.
 */ var $0cd3b79ca22907b8$export$83d89fbfd8236492 = "2.7.14";
/**
 * @internal type is manually declared in <root>/types/v3-define-component.d.ts
 */ function $0cd3b79ca22907b8$export$afa64b67e5a01c3b(options) {
    return options;
}
var $0cd3b79ca22907b8$var$seenObjects = new $0cd3b79ca22907b8$var$_Set();
/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */ function $0cd3b79ca22907b8$var$traverse(val) {
    $0cd3b79ca22907b8$var$_traverse(val, $0cd3b79ca22907b8$var$seenObjects);
    $0cd3b79ca22907b8$var$seenObjects.clear();
    return val;
}
function $0cd3b79ca22907b8$var$_traverse(val, seen) {
    var i, keys;
    var isA = $0cd3b79ca22907b8$var$isArray(val);
    if (!isA && !$0cd3b79ca22907b8$var$isObject(val) || val.__v_skip /* ReactiveFlags.SKIP */  || Object.isFrozen(val) || val instanceof $0cd3b79ca22907b8$var$VNode) return;
    if (val.__ob__) {
        var depId = val.__ob__.dep.id;
        if (seen.has(depId)) return;
        seen.add(depId);
    }
    if (isA) {
        i = val.length;
        while(i--)$0cd3b79ca22907b8$var$_traverse(val[i], seen);
    } else if ($0cd3b79ca22907b8$export$4f9f5282de18fc69(val)) $0cd3b79ca22907b8$var$_traverse(val.value, seen);
    else {
        keys = Object.keys(val);
        i = keys.length;
        while(i--)$0cd3b79ca22907b8$var$_traverse(val[keys[i]], seen);
    }
}
var $0cd3b79ca22907b8$var$uid$1 = 0;
/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 * @internal
 */ var $0cd3b79ca22907b8$var$Watcher = /** @class */ function() {
    function Watcher(vm, expOrFn, cb, options, isRenderWatcher) {
        $0cd3b79ca22907b8$var$recordEffectScope(this, // if the active effect scope is manually created (not a component scope),
        // prioritize it
        $0cd3b79ca22907b8$var$activeEffectScope && !$0cd3b79ca22907b8$var$activeEffectScope._vm ? $0cd3b79ca22907b8$var$activeEffectScope : vm ? vm._scope : undefined);
        if ((this.vm = vm) && isRenderWatcher) vm._watcher = this;
        // options
        if (options) {
            this.deep = !!options.deep;
            this.user = !!options.user;
            this.lazy = !!options.lazy;
            this.sync = !!options.sync;
            this.before = options.before;
        } else this.deep = this.user = this.lazy = this.sync = false;
        this.cb = cb;
        this.id = ++$0cd3b79ca22907b8$var$uid$1; // uid for batching
        this.active = true;
        this.post = false;
        this.dirty = this.lazy; // for lazy watchers
        this.deps = [];
        this.newDeps = [];
        this.depIds = new $0cd3b79ca22907b8$var$_Set();
        this.newDepIds = new $0cd3b79ca22907b8$var$_Set();
        this.expression = "";
        // parse expression for getter
        if ($0cd3b79ca22907b8$var$isFunction(expOrFn)) this.getter = expOrFn;
        else {
            this.getter = $0cd3b79ca22907b8$var$parsePath(expOrFn);
            if (!this.getter) this.getter = $0cd3b79ca22907b8$var$noop;
        }
        this.value = this.lazy ? undefined : this.get();
    }
    /**
     * Evaluate the getter, and re-collect dependencies.
     */ Watcher.prototype.get = function() {
        $0cd3b79ca22907b8$var$pushTarget(this);
        var value;
        var vm = this.vm;
        try {
            value = this.getter.call(vm, vm);
        } catch (e) {
            if (this.user) $0cd3b79ca22907b8$var$handleError(e, vm, 'getter for watcher "'.concat(this.expression, '"'));
            else throw e;
        } finally{
            // "touch" every property so they are all tracked as
            // dependencies for deep watching
            if (this.deep) $0cd3b79ca22907b8$var$traverse(value);
            $0cd3b79ca22907b8$var$popTarget();
            this.cleanupDeps();
        }
        return value;
    };
    /**
     * Add a dependency to this directive.
     */ Watcher.prototype.addDep = function(dep) {
        var id = dep.id;
        if (!this.newDepIds.has(id)) {
            this.newDepIds.add(id);
            this.newDeps.push(dep);
            if (!this.depIds.has(id)) dep.addSub(this);
        }
    };
    /**
     * Clean up for dependency collection.
     */ Watcher.prototype.cleanupDeps = function() {
        var i = this.deps.length;
        while(i--){
            var dep = this.deps[i];
            if (!this.newDepIds.has(dep.id)) dep.removeSub(this);
        }
        var tmp = this.depIds;
        this.depIds = this.newDepIds;
        this.newDepIds = tmp;
        this.newDepIds.clear();
        tmp = this.deps;
        this.deps = this.newDeps;
        this.newDeps = tmp;
        this.newDeps.length = 0;
    };
    /**
     * Subscriber interface.
     * Will be called when a dependency changes.
     */ Watcher.prototype.update = function() {
        /* istanbul ignore else */ if (this.lazy) this.dirty = true;
        else if (this.sync) this.run();
        else $0cd3b79ca22907b8$var$queueWatcher(this);
    };
    /**
     * Scheduler job interface.
     * Will be called by the scheduler.
     */ Watcher.prototype.run = function() {
        if (this.active) {
            var value = this.get();
            if (value !== this.value || // Deep watchers and watchers on Object/Arrays should fire even
            // when the value is the same, because the value may
            // have mutated.
            $0cd3b79ca22907b8$var$isObject(value) || this.deep) {
                // set new value
                var oldValue = this.value;
                this.value = value;
                if (this.user) {
                    var info = 'callback for watcher "'.concat(this.expression, '"');
                    $0cd3b79ca22907b8$var$invokeWithErrorHandling(this.cb, this.vm, [
                        value,
                        oldValue
                    ], this.vm, info);
                } else this.cb.call(this.vm, value, oldValue);
            }
        }
    };
    /**
     * Evaluate the value of the watcher.
     * This only gets called for lazy watchers.
     */ Watcher.prototype.evaluate = function() {
        this.value = this.get();
        this.dirty = false;
    };
    /**
     * Depend on all deps collected by this watcher.
     */ Watcher.prototype.depend = function() {
        var i = this.deps.length;
        while(i--)this.deps[i].depend();
    };
    /**
     * Remove self from all dependencies' subscriber list.
     */ Watcher.prototype.teardown = function() {
        if (this.vm && !this.vm._isBeingDestroyed) $0cd3b79ca22907b8$var$remove$2(this.vm._scope.effects, this);
        if (this.active) {
            var i = this.deps.length;
            while(i--)this.deps[i].removeSub(this);
            this.active = false;
            if (this.onStop) this.onStop();
        }
    };
    return Watcher;
}();
var $0cd3b79ca22907b8$var$mark;
var $0cd3b79ca22907b8$var$measure;
var $0cd3b79ca22907b8$var$perf_1;
function $0cd3b79ca22907b8$var$initEvents(vm) {
    vm._events = Object.create(null);
    vm._hasHookEvent = false;
    // init parent attached events
    var listeners = vm.$options._parentListeners;
    if (listeners) $0cd3b79ca22907b8$var$updateComponentListeners(vm, listeners);
}
var $0cd3b79ca22907b8$var$target$1;
function $0cd3b79ca22907b8$var$add$1(event, fn) {
    $0cd3b79ca22907b8$var$target$1.$on(event, fn);
}
function $0cd3b79ca22907b8$var$remove$1(event, fn) {
    $0cd3b79ca22907b8$var$target$1.$off(event, fn);
}
function $0cd3b79ca22907b8$var$createOnceHandler$1(event, fn) {
    var _target = $0cd3b79ca22907b8$var$target$1;
    return function onceHandler() {
        var res = fn.apply(null, arguments);
        if (res !== null) _target.$off(event, onceHandler);
    };
}
function $0cd3b79ca22907b8$var$updateComponentListeners(vm, listeners, oldListeners) {
    $0cd3b79ca22907b8$var$target$1 = vm;
    $0cd3b79ca22907b8$var$updateListeners(listeners, oldListeners || {}, $0cd3b79ca22907b8$var$add$1, $0cd3b79ca22907b8$var$remove$1, $0cd3b79ca22907b8$var$createOnceHandler$1, vm);
    $0cd3b79ca22907b8$var$target$1 = undefined;
}
function $0cd3b79ca22907b8$var$eventsMixin(Vue) {
    var hookRE = /^hook:/;
    Vue.prototype.$on = function(event, fn) {
        var vm = this;
        if ($0cd3b79ca22907b8$var$isArray(event)) for(var i = 0, l = event.length; i < l; i++)vm.$on(event[i], fn);
        else {
            (vm._events[event] || (vm._events[event] = [])).push(fn);
            // optimize hook:event cost by using a boolean flag marked at registration
            // instead of a hash lookup
            if (hookRE.test(event)) vm._hasHookEvent = true;
        }
        return vm;
    };
    Vue.prototype.$once = function(event, fn) {
        var vm = this;
        function on() {
            vm.$off(event, on);
            fn.apply(vm, arguments);
        }
        on.fn = fn;
        vm.$on(event, on);
        return vm;
    };
    Vue.prototype.$off = function(event, fn) {
        var vm = this;
        // all
        if (!arguments.length) {
            vm._events = Object.create(null);
            return vm;
        }
        // array of events
        if ($0cd3b79ca22907b8$var$isArray(event)) {
            for(var i_1 = 0, l = event.length; i_1 < l; i_1++)vm.$off(event[i_1], fn);
            return vm;
        }
        // specific event
        var cbs = vm._events[event];
        if (!cbs) return vm;
        if (!fn) {
            vm._events[event] = null;
            return vm;
        }
        // specific handler
        var cb;
        var i = cbs.length;
        while(i--){
            cb = cbs[i];
            if (cb === fn || cb.fn === fn) {
                cbs.splice(i, 1);
                break;
            }
        }
        return vm;
    };
    Vue.prototype.$emit = function(event) {
        var vm = this;
        var lowerCaseEvent;
        var cbs = vm._events[event];
        if (cbs) {
            cbs = cbs.length > 1 ? $0cd3b79ca22907b8$var$toArray(cbs) : cbs;
            var args = $0cd3b79ca22907b8$var$toArray(arguments, 1);
            var info = 'event handler for "'.concat(event, '"');
            for(var i = 0, l = cbs.length; i < l; i++)$0cd3b79ca22907b8$var$invokeWithErrorHandling(cbs[i], vm, args, vm, info);
        }
        return vm;
    };
}
var $0cd3b79ca22907b8$var$activeInstance = null;
var $0cd3b79ca22907b8$var$isUpdatingChildComponent = false;
function $0cd3b79ca22907b8$var$setActiveInstance(vm) {
    var prevActiveInstance = $0cd3b79ca22907b8$var$activeInstance;
    $0cd3b79ca22907b8$var$activeInstance = vm;
    return function() {
        $0cd3b79ca22907b8$var$activeInstance = prevActiveInstance;
    };
}
function $0cd3b79ca22907b8$var$initLifecycle(vm) {
    var options = vm.$options;
    // locate first non-abstract parent
    var parent = options.parent;
    if (parent && !options.abstract) {
        while(parent.$options.abstract && parent.$parent)parent = parent.$parent;
        parent.$children.push(vm);
    }
    vm.$parent = parent;
    vm.$root = parent ? parent.$root : vm;
    vm.$children = [];
    vm.$refs = {};
    vm._provided = parent ? parent._provided : Object.create(null);
    vm._watcher = null;
    vm._inactive = null;
    vm._directInactive = false;
    vm._isMounted = false;
    vm._isDestroyed = false;
    vm._isBeingDestroyed = false;
}
function $0cd3b79ca22907b8$var$lifecycleMixin(Vue) {
    Vue.prototype._update = function(vnode, hydrating) {
        var vm = this;
        var prevEl = vm.$el;
        var prevVnode = vm._vnode;
        var restoreActiveInstance = $0cd3b79ca22907b8$var$setActiveInstance(vm);
        vm._vnode = vnode;
        // Vue.prototype.__patch__ is injected in entry points
        // based on the rendering backend used.
        if (!prevVnode) // initial render
        vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false);
        else // updates
        vm.$el = vm.__patch__(prevVnode, vnode);
        restoreActiveInstance();
        // update __vue__ reference
        if (prevEl) prevEl.__vue__ = null;
        if (vm.$el) vm.$el.__vue__ = vm;
        // if parent is an HOC, update its $el as well
        var wrapper = vm;
        while(wrapper && wrapper.$vnode && wrapper.$parent && wrapper.$vnode === wrapper.$parent._vnode){
            wrapper.$parent.$el = wrapper.$el;
            wrapper = wrapper.$parent;
        }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
    };
    Vue.prototype.$forceUpdate = function() {
        var vm = this;
        if (vm._watcher) vm._watcher.update();
    };
    Vue.prototype.$destroy = function() {
        var vm = this;
        if (vm._isBeingDestroyed) return;
        $0cd3b79ca22907b8$var$callHook$1(vm, "beforeDestroy");
        vm._isBeingDestroyed = true;
        // remove self from parent
        var parent = vm.$parent;
        if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) $0cd3b79ca22907b8$var$remove$2(parent.$children, vm);
        // teardown scope. this includes both the render watcher and other
        // watchers created
        vm._scope.stop();
        // remove reference from data ob
        // frozen object may not have observer.
        if (vm._data.__ob__) vm._data.__ob__.vmCount--;
        // call the last hook...
        vm._isDestroyed = true;
        // invoke destroy hooks on current rendered tree
        vm.__patch__(vm._vnode, null);
        // fire destroyed hook
        $0cd3b79ca22907b8$var$callHook$1(vm, "destroyed");
        // turn off all instance listeners.
        vm.$off();
        // remove __vue__ reference
        if (vm.$el) vm.$el.__vue__ = null;
        // release circular reference (#6759)
        if (vm.$vnode) vm.$vnode.parent = null;
    };
}
function $0cd3b79ca22907b8$var$mountComponent(vm, el, hydrating) {
    vm.$el = el;
    if (!vm.$options.render) // @ts-expect-error invalid type
    vm.$options.render = $0cd3b79ca22907b8$var$createEmptyVNode;
    $0cd3b79ca22907b8$var$callHook$1(vm, "beforeMount");
    var updateComponent;
    updateComponent = function() {
        vm._update(vm._render(), hydrating);
    };
    var watcherOptions = {
        before: function() {
            if (vm._isMounted && !vm._isDestroyed) $0cd3b79ca22907b8$var$callHook$1(vm, "beforeUpdate");
        }
    };
    // we set this to vm._watcher inside the watcher's constructor
    // since the watcher's initial patch may call $forceUpdate (e.g. inside child
    // component's mounted hook), which relies on vm._watcher being already defined
    new $0cd3b79ca22907b8$var$Watcher(vm, updateComponent, $0cd3b79ca22907b8$var$noop, watcherOptions, true);
    hydrating = false;
    // flush buffer for flush: "pre" watchers queued in setup()
    var preWatchers = vm._preWatchers;
    if (preWatchers) for(var i = 0; i < preWatchers.length; i++)preWatchers[i].run();
    // manually mounted instance, call mounted on self
    // mounted is called for render-created child components in its inserted hook
    if (vm.$vnode == null) {
        vm._isMounted = true;
        $0cd3b79ca22907b8$var$callHook$1(vm, "mounted");
    }
    return vm;
}
function $0cd3b79ca22907b8$var$updateChildComponent(vm, propsData, listeners, parentVnode, renderChildren) {
    // determine whether component has slot children
    // we need to do this before overwriting $options._renderChildren.
    // check if there are dynamic scopedSlots (hand-written or compiled but with
    // dynamic slot names). Static scoped slots compiled from template has the
    // "$stable" marker.
    var newScopedSlots = parentVnode.data.scopedSlots;
    var oldScopedSlots = vm.$scopedSlots;
    var hasDynamicScopedSlot = !!(newScopedSlots && !newScopedSlots.$stable || oldScopedSlots !== $0cd3b79ca22907b8$var$emptyObject && !oldScopedSlots.$stable || newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key || !newScopedSlots && vm.$scopedSlots.$key);
    // Any static slot children from the parent may have changed during parent's
    // update. Dynamic scoped slots may also have changed. In such cases, a forced
    // update is necessary to ensure correctness.
    var needsForceUpdate = !!(renderChildren || // has new static slots
    vm.$options._renderChildren || // has old static slots
    hasDynamicScopedSlot);
    var prevVNode = vm.$vnode;
    vm.$options._parentVnode = parentVnode;
    vm.$vnode = parentVnode; // update vm's placeholder node without re-render
    if (vm._vnode) // update child tree's parent
    vm._vnode.parent = parentVnode;
    vm.$options._renderChildren = renderChildren;
    // update $attrs and $listeners hash
    // these are also reactive so they may trigger child update if the child
    // used them during render
    var attrs = parentVnode.data.attrs || $0cd3b79ca22907b8$var$emptyObject;
    if (vm._attrsProxy) // force update if attrs are accessed and has changed since it may be
    // passed to a child component.
    {
        if ($0cd3b79ca22907b8$var$syncSetupProxy(vm._attrsProxy, attrs, prevVNode.data && prevVNode.data.attrs || $0cd3b79ca22907b8$var$emptyObject, vm, "$attrs")) needsForceUpdate = true;
    }
    vm.$attrs = attrs;
    // update listeners
    listeners = listeners || $0cd3b79ca22907b8$var$emptyObject;
    var prevListeners = vm.$options._parentListeners;
    if (vm._listenersProxy) $0cd3b79ca22907b8$var$syncSetupProxy(vm._listenersProxy, listeners, prevListeners || $0cd3b79ca22907b8$var$emptyObject, vm, "$listeners");
    vm.$listeners = vm.$options._parentListeners = listeners;
    $0cd3b79ca22907b8$var$updateComponentListeners(vm, listeners, prevListeners);
    // update props
    if (propsData && vm.$options.props) {
        $0cd3b79ca22907b8$var$toggleObserving(false);
        var props = vm._props;
        var propKeys = vm.$options._propKeys || [];
        for(var i = 0; i < propKeys.length; i++){
            var key = propKeys[i];
            var propOptions = vm.$options.props; // wtf flow?
            props[key] = $0cd3b79ca22907b8$var$validateProp(key, propOptions, propsData, vm);
        }
        $0cd3b79ca22907b8$var$toggleObserving(true);
        // keep a copy of raw propsData
        vm.$options.propsData = propsData;
    }
    // resolve slots + force update if has children
    if (needsForceUpdate) {
        vm.$slots = $0cd3b79ca22907b8$var$resolveSlots(renderChildren, parentVnode.context);
        vm.$forceUpdate();
    }
}
function $0cd3b79ca22907b8$var$isInInactiveTree(vm) {
    while(vm && (vm = vm.$parent)){
        if (vm._inactive) return true;
    }
    return false;
}
function $0cd3b79ca22907b8$var$activateChildComponent(vm, direct) {
    if (direct) {
        vm._directInactive = false;
        if ($0cd3b79ca22907b8$var$isInInactiveTree(vm)) return;
    } else if (vm._directInactive) return;
    if (vm._inactive || vm._inactive === null) {
        vm._inactive = false;
        for(var i = 0; i < vm.$children.length; i++)$0cd3b79ca22907b8$var$activateChildComponent(vm.$children[i]);
        $0cd3b79ca22907b8$var$callHook$1(vm, "activated");
    }
}
function $0cd3b79ca22907b8$var$deactivateChildComponent(vm, direct) {
    if (direct) {
        vm._directInactive = true;
        if ($0cd3b79ca22907b8$var$isInInactiveTree(vm)) return;
    }
    if (!vm._inactive) {
        vm._inactive = true;
        for(var i = 0; i < vm.$children.length; i++)$0cd3b79ca22907b8$var$deactivateChildComponent(vm.$children[i]);
        $0cd3b79ca22907b8$var$callHook$1(vm, "deactivated");
    }
}
function $0cd3b79ca22907b8$var$callHook$1(vm, hook, args, setContext) {
    if (setContext === void 0) setContext = true;
    // #7573 disable dep collection when invoking lifecycle hooks
    $0cd3b79ca22907b8$var$pushTarget();
    var prev = $0cd3b79ca22907b8$var$currentInstance;
    setContext && $0cd3b79ca22907b8$var$setCurrentInstance(vm);
    var handlers = vm.$options[hook];
    var info = "".concat(hook, " hook");
    if (handlers) for(var i = 0, j = handlers.length; i < j; i++)$0cd3b79ca22907b8$var$invokeWithErrorHandling(handlers[i], vm, args || null, vm, info);
    if (vm._hasHookEvent) vm.$emit("hook:" + hook);
    setContext && $0cd3b79ca22907b8$var$setCurrentInstance(prev);
    $0cd3b79ca22907b8$var$popTarget();
}
var $0cd3b79ca22907b8$var$MAX_UPDATE_COUNT = 100;
var $0cd3b79ca22907b8$var$queue = [];
var $0cd3b79ca22907b8$var$activatedChildren = [];
var $0cd3b79ca22907b8$var$has = {};
var $0cd3b79ca22907b8$var$circular = {};
var $0cd3b79ca22907b8$var$waiting = false;
var $0cd3b79ca22907b8$var$flushing = false;
var $0cd3b79ca22907b8$var$index = 0;
/**
 * Reset the scheduler's state.
 */ function $0cd3b79ca22907b8$var$resetSchedulerState() {
    $0cd3b79ca22907b8$var$index = $0cd3b79ca22907b8$var$queue.length = $0cd3b79ca22907b8$var$activatedChildren.length = 0;
    $0cd3b79ca22907b8$var$has = {};
    $0cd3b79ca22907b8$var$waiting = $0cd3b79ca22907b8$var$flushing = false;
}
// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var $0cd3b79ca22907b8$var$currentFlushTimestamp = 0;
// Async edge case fix requires storing an event listener's attach timestamp.
var $0cd3b79ca22907b8$var$getNow = Date.now;
// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if ($0cd3b79ca22907b8$var$inBrowser && !$0cd3b79ca22907b8$var$isIE) {
    var $0cd3b79ca22907b8$var$performance_1 = window.performance;
    if ($0cd3b79ca22907b8$var$performance_1 && typeof $0cd3b79ca22907b8$var$performance_1.now === "function" && $0cd3b79ca22907b8$var$getNow() > document.createEvent("Event").timeStamp) // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    $0cd3b79ca22907b8$var$getNow = function() {
        return $0cd3b79ca22907b8$var$performance_1.now();
    };
}
var $0cd3b79ca22907b8$var$sortCompareFn = function(a, b) {
    if (a.post) {
        if (!b.post) return 1;
    } else if (b.post) return -1;
    return a.id - b.id;
};
/**
 * Flush both queues and run the watchers.
 */ function $0cd3b79ca22907b8$var$flushSchedulerQueue() {
    $0cd3b79ca22907b8$var$currentFlushTimestamp = $0cd3b79ca22907b8$var$getNow();
    $0cd3b79ca22907b8$var$flushing = true;
    var watcher, id;
    // Sort queue before flush.
    // This ensures that:
    // 1. Components are updated from parent to child. (because parent is always
    //    created before the child)
    // 2. A component's user watchers are run before its render watcher (because
    //    user watchers are created before the render watcher)
    // 3. If a component is destroyed during a parent component's watcher run,
    //    its watchers can be skipped.
    $0cd3b79ca22907b8$var$queue.sort($0cd3b79ca22907b8$var$sortCompareFn);
    // do not cache length because more watchers might be pushed
    // as we run existing watchers
    for($0cd3b79ca22907b8$var$index = 0; $0cd3b79ca22907b8$var$index < $0cd3b79ca22907b8$var$queue.length; $0cd3b79ca22907b8$var$index++){
        watcher = $0cd3b79ca22907b8$var$queue[$0cd3b79ca22907b8$var$index];
        if (watcher.before) watcher.before();
        id = watcher.id;
        $0cd3b79ca22907b8$var$has[id] = null;
        watcher.run();
    }
    // keep copies of post queues before resetting state
    var activatedQueue = $0cd3b79ca22907b8$var$activatedChildren.slice();
    var updatedQueue = $0cd3b79ca22907b8$var$queue.slice();
    $0cd3b79ca22907b8$var$resetSchedulerState();
    // call component updated and activated hooks
    $0cd3b79ca22907b8$var$callActivatedHooks(activatedQueue);
    $0cd3b79ca22907b8$var$callUpdatedHooks(updatedQueue);
    $0cd3b79ca22907b8$var$cleanupDeps();
    // devtool hook
    /* istanbul ignore if */ if ($0cd3b79ca22907b8$var$devtools && $0cd3b79ca22907b8$var$config.devtools) $0cd3b79ca22907b8$var$devtools.emit("flush");
}
function $0cd3b79ca22907b8$var$callUpdatedHooks(queue) {
    var i = queue.length;
    while(i--){
        var watcher = queue[i];
        var vm = watcher.vm;
        if (vm && vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) $0cd3b79ca22907b8$var$callHook$1(vm, "updated");
    }
}
/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */ function $0cd3b79ca22907b8$var$queueActivatedComponent(vm) {
    // setting _inactive to false here so that a render function can
    // rely on checking whether it's in an inactive tree (e.g. router-view)
    vm._inactive = false;
    $0cd3b79ca22907b8$var$activatedChildren.push(vm);
}
function $0cd3b79ca22907b8$var$callActivatedHooks(queue) {
    for(var i = 0; i < queue.length; i++){
        queue[i]._inactive = true;
        $0cd3b79ca22907b8$var$activateChildComponent(queue[i], true);
    }
}
/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */ function $0cd3b79ca22907b8$var$queueWatcher(watcher) {
    var id = watcher.id;
    if ($0cd3b79ca22907b8$var$has[id] != null) return;
    if (watcher === $0cd3b79ca22907b8$var$Dep.target && watcher.noRecurse) return;
    $0cd3b79ca22907b8$var$has[id] = true;
    if (!$0cd3b79ca22907b8$var$flushing) $0cd3b79ca22907b8$var$queue.push(watcher);
    else {
        // if already flushing, splice the watcher based on its id
        // if already past its id, it will be run next immediately.
        var i = $0cd3b79ca22907b8$var$queue.length - 1;
        while(i > $0cd3b79ca22907b8$var$index && $0cd3b79ca22907b8$var$queue[i].id > watcher.id)i--;
        $0cd3b79ca22907b8$var$queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!$0cd3b79ca22907b8$var$waiting) {
        $0cd3b79ca22907b8$var$waiting = true;
        $0cd3b79ca22907b8$export$bdd553fddd433dcb($0cd3b79ca22907b8$var$flushSchedulerQueue);
    }
}
function $0cd3b79ca22907b8$var$initProvide(vm) {
    var provideOption = vm.$options.provide;
    if (provideOption) {
        var provided = $0cd3b79ca22907b8$var$isFunction(provideOption) ? provideOption.call(vm) : provideOption;
        if (!$0cd3b79ca22907b8$var$isObject(provided)) return;
        var source = $0cd3b79ca22907b8$var$resolveProvided(vm);
        // IE9 doesn't support Object.getOwnPropertyDescriptors so we have to
        // iterate the keys ourselves.
        var keys = $0cd3b79ca22907b8$var$hasSymbol ? Reflect.ownKeys(provided) : Object.keys(provided);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            Object.defineProperty(source, key, Object.getOwnPropertyDescriptor(provided, key));
        }
    }
}
function $0cd3b79ca22907b8$var$initInjections(vm) {
    var result = $0cd3b79ca22907b8$var$resolveInject(vm.$options.inject, vm);
    if (result) {
        $0cd3b79ca22907b8$var$toggleObserving(false);
        Object.keys(result).forEach(function(key) {
            $0cd3b79ca22907b8$var$defineReactive(vm, key, result[key]);
        });
        $0cd3b79ca22907b8$var$toggleObserving(true);
    }
}
function $0cd3b79ca22907b8$var$resolveInject(inject, vm) {
    if (inject) {
        // inject is :any because flow is not smart enough to figure out cached
        var result = Object.create(null);
        var keys = $0cd3b79ca22907b8$var$hasSymbol ? Reflect.ownKeys(inject) : Object.keys(inject);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            // #6574 in case the inject object is observed...
            if (key === "__ob__") continue;
            var provideKey = inject[key].from;
            if (provideKey in vm._provided) result[key] = vm._provided[provideKey];
            else if ("default" in inject[key]) {
                var provideDefault = inject[key].default;
                result[key] = $0cd3b79ca22907b8$var$isFunction(provideDefault) ? provideDefault.call(vm) : provideDefault;
            }
        }
        return result;
    }
}
function $0cd3b79ca22907b8$var$FunctionalRenderContext(data, props, children, parent, Ctor) {
    var _this = this;
    var options = Ctor.options;
    // ensure the createElement function in functional components
    // gets a unique context - this is necessary for correct named slot check
    var contextVm;
    if ($0cd3b79ca22907b8$var$hasOwn(parent, "_uid")) {
        contextVm = Object.create(parent);
        contextVm._original = parent;
    } else {
        // the context vm passed in is a functional context as well.
        // in this case we want to make sure we are able to get a hold to the
        // real context instance.
        contextVm = parent;
        // @ts-ignore
        parent = parent._original;
    }
    var isCompiled = $0cd3b79ca22907b8$var$isTrue(options._compiled);
    var needNormalization = !isCompiled;
    this.data = data;
    this.props = props;
    this.children = children;
    this.parent = parent;
    this.listeners = data.on || $0cd3b79ca22907b8$var$emptyObject;
    this.injections = $0cd3b79ca22907b8$var$resolveInject(options.inject, parent);
    this.slots = function() {
        if (!_this.$slots) $0cd3b79ca22907b8$var$normalizeScopedSlots(parent, data.scopedSlots, _this.$slots = $0cd3b79ca22907b8$var$resolveSlots(children, parent));
        return _this.$slots;
    };
    Object.defineProperty(this, "scopedSlots", {
        enumerable: true,
        get: function() {
            return $0cd3b79ca22907b8$var$normalizeScopedSlots(parent, data.scopedSlots, this.slots());
        }
    });
    // support for compiled functional template
    if (isCompiled) {
        // exposing $options for renderStatic()
        this.$options = options;
        // pre-resolve slots for renderSlot()
        this.$slots = this.slots();
        this.$scopedSlots = $0cd3b79ca22907b8$var$normalizeScopedSlots(parent, data.scopedSlots, this.$slots);
    }
    if (options._scopeId) this._c = function(a, b, c, d) {
        var vnode = $0cd3b79ca22907b8$var$createElement$1(contextVm, a, b, c, d, needNormalization);
        if (vnode && !$0cd3b79ca22907b8$var$isArray(vnode)) {
            vnode.fnScopeId = options._scopeId;
            vnode.fnContext = parent;
        }
        return vnode;
    };
    else this._c = function(a, b, c, d) {
        return $0cd3b79ca22907b8$var$createElement$1(contextVm, a, b, c, d, needNormalization);
    };
}
$0cd3b79ca22907b8$var$installRenderHelpers($0cd3b79ca22907b8$var$FunctionalRenderContext.prototype);
function $0cd3b79ca22907b8$var$createFunctionalComponent(Ctor, propsData, data, contextVm, children) {
    var options = Ctor.options;
    var props = {};
    var propOptions = options.props;
    if ($0cd3b79ca22907b8$var$isDef(propOptions)) for(var key in propOptions)props[key] = $0cd3b79ca22907b8$var$validateProp(key, propOptions, propsData || $0cd3b79ca22907b8$var$emptyObject);
    else {
        if ($0cd3b79ca22907b8$var$isDef(data.attrs)) $0cd3b79ca22907b8$var$mergeProps(props, data.attrs);
        if ($0cd3b79ca22907b8$var$isDef(data.props)) $0cd3b79ca22907b8$var$mergeProps(props, data.props);
    }
    var renderContext = new $0cd3b79ca22907b8$var$FunctionalRenderContext(data, props, children, contextVm, Ctor);
    var vnode = options.render.call(null, renderContext._c, renderContext);
    if (vnode instanceof $0cd3b79ca22907b8$var$VNode) return $0cd3b79ca22907b8$var$cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext);
    else if ($0cd3b79ca22907b8$var$isArray(vnode)) {
        var vnodes = $0cd3b79ca22907b8$var$normalizeChildren(vnode) || [];
        var res = new Array(vnodes.length);
        for(var i = 0; i < vnodes.length; i++)res[i] = $0cd3b79ca22907b8$var$cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
        return res;
    }
}
function $0cd3b79ca22907b8$var$cloneAndMarkFunctionalResult(vnode, data, contextVm, options, renderContext) {
    // #7817 clone node before setting fnContext, otherwise if the node is reused
    // (e.g. it was from a cached normal slot) the fnContext causes named slots
    // that should not be matched to match.
    var clone = $0cd3b79ca22907b8$var$cloneVNode(vnode);
    clone.fnContext = contextVm;
    clone.fnOptions = options;
    if (data.slot) (clone.data || (clone.data = {})).slot = data.slot;
    return clone;
}
function $0cd3b79ca22907b8$var$mergeProps(to, from) {
    for(var key in from)to[$0cd3b79ca22907b8$var$camelize(key)] = from[key];
}
function $0cd3b79ca22907b8$var$getComponentName(options) {
    return options.name || options.__name || options._componentTag;
}
// inline hooks to be invoked on component VNodes during patch
var $0cd3b79ca22907b8$var$componentVNodeHooks = {
    init: function(vnode, hydrating) {
        if (vnode.componentInstance && !vnode.componentInstance._isDestroyed && vnode.data.keepAlive) {
            // kept-alive components, treat as a patch
            var mountedNode = vnode; // work around flow
            $0cd3b79ca22907b8$var$componentVNodeHooks.prepatch(mountedNode, mountedNode);
        } else {
            var child = vnode.componentInstance = $0cd3b79ca22907b8$var$createComponentInstanceForVnode(vnode, $0cd3b79ca22907b8$var$activeInstance);
            child.$mount(hydrating ? vnode.elm : undefined, hydrating);
        }
    },
    prepatch: function(oldVnode, vnode) {
        var options = vnode.componentOptions;
        var child = vnode.componentInstance = oldVnode.componentInstance;
        $0cd3b79ca22907b8$var$updateChildComponent(child, options.propsData, options.listeners, vnode, options.children // new children
        );
    },
    insert: function(vnode) {
        var context = vnode.context, componentInstance = vnode.componentInstance;
        if (!componentInstance._isMounted) {
            componentInstance._isMounted = true;
            $0cd3b79ca22907b8$var$callHook$1(componentInstance, "mounted");
        }
        if (vnode.data.keepAlive) {
            if (context._isMounted) // vue-router#1212
            // During updates, a kept-alive component's child components may
            // change, so directly walking the tree here may call activated hooks
            // on incorrect children. Instead we push them into a queue which will
            // be processed after the whole patch process ended.
            $0cd3b79ca22907b8$var$queueActivatedComponent(componentInstance);
            else $0cd3b79ca22907b8$var$activateChildComponent(componentInstance, true);
        }
    },
    destroy: function(vnode) {
        var componentInstance = vnode.componentInstance;
        if (!componentInstance._isDestroyed) {
            if (!vnode.data.keepAlive) componentInstance.$destroy();
            else $0cd3b79ca22907b8$var$deactivateChildComponent(componentInstance, true);
        }
    }
};
var $0cd3b79ca22907b8$var$hooksToMerge = Object.keys($0cd3b79ca22907b8$var$componentVNodeHooks);
function $0cd3b79ca22907b8$var$createComponent(Ctor, data, context, children, tag) {
    if ($0cd3b79ca22907b8$var$isUndef(Ctor)) return;
    var baseCtor = context.$options._base;
    // plain options object: turn it into a constructor
    if ($0cd3b79ca22907b8$var$isObject(Ctor)) Ctor = baseCtor.extend(Ctor);
    // if at this stage it's not a constructor or an async component factory,
    // reject.
    if (typeof Ctor !== "function") return;
    // async component
    var asyncFactory;
    // @ts-expect-error
    if ($0cd3b79ca22907b8$var$isUndef(Ctor.cid)) {
        asyncFactory = Ctor;
        Ctor = $0cd3b79ca22907b8$var$resolveAsyncComponent(asyncFactory, baseCtor);
        if (Ctor === undefined) // return a placeholder node for async component, which is rendered
        // as a comment node but preserves all the raw information for the node.
        // the information will be used for async server-rendering and hydration.
        return $0cd3b79ca22907b8$var$createAsyncPlaceholder(asyncFactory, data, context, children, tag);
    }
    data = data || {};
    // resolve constructor options in case global mixins are applied after
    // component constructor creation
    $0cd3b79ca22907b8$var$resolveConstructorOptions(Ctor);
    // transform component v-model data into props & events
    if ($0cd3b79ca22907b8$var$isDef(data.model)) // @ts-expect-error
    $0cd3b79ca22907b8$var$transformModel(Ctor.options, data);
    // extract props
    // @ts-expect-error
    var propsData = $0cd3b79ca22907b8$var$extractPropsFromVNodeData(data, Ctor, tag);
    // functional component
    // @ts-expect-error
    if ($0cd3b79ca22907b8$var$isTrue(Ctor.options.functional)) return $0cd3b79ca22907b8$var$createFunctionalComponent(Ctor, propsData, data, context, children);
    // extract listeners, since these needs to be treated as
    // child component listeners instead of DOM listeners
    var listeners = data.on;
    // replace with listeners with .native modifier
    // so it gets processed during parent component patch.
    data.on = data.nativeOn;
    // @ts-expect-error
    if ($0cd3b79ca22907b8$var$isTrue(Ctor.options.abstract)) {
        // abstract components do not keep anything
        // other than props & listeners & slot
        // work around flow
        var slot = data.slot;
        data = {};
        if (slot) data.slot = slot;
    }
    // install component management hooks onto the placeholder node
    $0cd3b79ca22907b8$var$installComponentHooks(data);
    // return a placeholder vnode
    // @ts-expect-error
    var name = $0cd3b79ca22907b8$var$getComponentName(Ctor.options) || tag;
    var vnode = new $0cd3b79ca22907b8$var$VNode(// @ts-expect-error
    "vue-component-".concat(Ctor.cid).concat(name ? "-".concat(name) : ""), data, undefined, undefined, undefined, context, // @ts-expect-error
    {
        Ctor: Ctor,
        propsData: propsData,
        listeners: listeners,
        tag: tag,
        children: children
    }, asyncFactory);
    return vnode;
}
function $0cd3b79ca22907b8$var$createComponentInstanceForVnode(// we know it's MountedComponentVNode but flow doesn't
vnode, // activeInstance in lifecycle state
parent) {
    var options = {
        _isComponent: true,
        _parentVnode: vnode,
        parent: parent
    };
    // check inline-template render functions
    var inlineTemplate = vnode.data.inlineTemplate;
    if ($0cd3b79ca22907b8$var$isDef(inlineTemplate)) {
        options.render = inlineTemplate.render;
        options.staticRenderFns = inlineTemplate.staticRenderFns;
    }
    return new vnode.componentOptions.Ctor(options);
}
function $0cd3b79ca22907b8$var$installComponentHooks(data) {
    var hooks = data.hook || (data.hook = {});
    for(var i = 0; i < $0cd3b79ca22907b8$var$hooksToMerge.length; i++){
        var key = $0cd3b79ca22907b8$var$hooksToMerge[i];
        var existing = hooks[key];
        var toMerge = $0cd3b79ca22907b8$var$componentVNodeHooks[key];
        // @ts-expect-error
        if (existing !== toMerge && !(existing && existing._merged)) hooks[key] = existing ? $0cd3b79ca22907b8$var$mergeHook(toMerge, existing) : toMerge;
    }
}
function $0cd3b79ca22907b8$var$mergeHook(f1, f2) {
    var merged = function(a, b) {
        // flow complains about extra args which is why we use any
        f1(a, b);
        f2(a, b);
    };
    merged._merged = true;
    return merged;
}
// transform component v-model info (value and callback) into
// prop and event handler respectively.
function $0cd3b79ca22907b8$var$transformModel(options, data) {
    var prop = options.model && options.model.prop || "value";
    var event = options.model && options.model.event || "input";
    (data.attrs || (data.attrs = {}))[prop] = data.model.value;
    var on = data.on || (data.on = {});
    var existing = on[event];
    var callback = data.model.callback;
    if ($0cd3b79ca22907b8$var$isDef(existing)) {
        if ($0cd3b79ca22907b8$var$isArray(existing) ? existing.indexOf(callback) === -1 : existing !== callback) on[event] = [
            callback
        ].concat(existing);
    } else on[event] = callback;
}
var $0cd3b79ca22907b8$var$warn = $0cd3b79ca22907b8$var$noop;
var $0cd3b79ca22907b8$var$tip = $0cd3b79ca22907b8$var$noop;
var $0cd3b79ca22907b8$var$generateComponentTrace; // work around flow check
var $0cd3b79ca22907b8$var$formatComponentName;
var $0cd3b79ca22907b8$var$hasConsole_1, $0cd3b79ca22907b8$var$classifyRE_1, $0cd3b79ca22907b8$var$classify_1, $0cd3b79ca22907b8$var$repeat_1;
/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */ var $0cd3b79ca22907b8$var$strats = $0cd3b79ca22907b8$var$config.optionMergeStrategies;
/**
 * Helper that recursively merges two data objects together.
 */ function $0cd3b79ca22907b8$var$mergeData(to, from, recursive) {
    if (recursive === void 0) recursive = true;
    if (!from) return to;
    var key, toVal, fromVal;
    var keys = $0cd3b79ca22907b8$var$hasSymbol ? Reflect.ownKeys(from) : Object.keys(from);
    for(var i = 0; i < keys.length; i++){
        key = keys[i];
        // in case the object is already observed...
        if (key === "__ob__") continue;
        toVal = to[key];
        fromVal = from[key];
        if (!recursive || !$0cd3b79ca22907b8$var$hasOwn(to, key)) $0cd3b79ca22907b8$export$adaa4cf7ef1b65be(to, key, fromVal);
        else if (toVal !== fromVal && $0cd3b79ca22907b8$var$isPlainObject(toVal) && $0cd3b79ca22907b8$var$isPlainObject(fromVal)) $0cd3b79ca22907b8$var$mergeData(toVal, fromVal);
    }
    return to;
}
/**
 * Data
 */ function $0cd3b79ca22907b8$var$mergeDataOrFn(parentVal, childVal, vm) {
    if (!vm) {
        // in a Vue.extend merge, both should be functions
        if (!childVal) return parentVal;
        if (!parentVal) return childVal;
        // when parentVal & childVal are both present,
        // we need to return a function that returns the
        // merged result of both functions... no need to
        // check if parentVal is a function here because
        // it has to be a function to pass previous merges.
        return function mergedDataFn() {
            return $0cd3b79ca22907b8$var$mergeData($0cd3b79ca22907b8$var$isFunction(childVal) ? childVal.call(this, this) : childVal, $0cd3b79ca22907b8$var$isFunction(parentVal) ? parentVal.call(this, this) : parentVal);
        };
    } else return function mergedInstanceDataFn() {
        // instance merge
        var instanceData = $0cd3b79ca22907b8$var$isFunction(childVal) ? childVal.call(vm, vm) : childVal;
        var defaultData = $0cd3b79ca22907b8$var$isFunction(parentVal) ? parentVal.call(vm, vm) : parentVal;
        if (instanceData) return $0cd3b79ca22907b8$var$mergeData(instanceData, defaultData);
        else return defaultData;
    };
}
$0cd3b79ca22907b8$var$strats.data = function(parentVal, childVal, vm) {
    if (!vm) {
        if (childVal && typeof childVal !== "function") return parentVal;
        return $0cd3b79ca22907b8$var$mergeDataOrFn(parentVal, childVal);
    }
    return $0cd3b79ca22907b8$var$mergeDataOrFn(parentVal, childVal, vm);
};
/**
 * Hooks and props are merged as arrays.
 */ function $0cd3b79ca22907b8$var$mergeLifecycleHook(parentVal, childVal) {
    var res = childVal ? parentVal ? parentVal.concat(childVal) : $0cd3b79ca22907b8$var$isArray(childVal) ? childVal : [
        childVal
    ] : parentVal;
    return res ? $0cd3b79ca22907b8$var$dedupeHooks(res) : res;
}
function $0cd3b79ca22907b8$var$dedupeHooks(hooks) {
    var res = [];
    for(var i = 0; i < hooks.length; i++)if (res.indexOf(hooks[i]) === -1) res.push(hooks[i]);
    return res;
}
$0cd3b79ca22907b8$var$LIFECYCLE_HOOKS.forEach(function(hook) {
    $0cd3b79ca22907b8$var$strats[hook] = $0cd3b79ca22907b8$var$mergeLifecycleHook;
});
/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */ function $0cd3b79ca22907b8$var$mergeAssets(parentVal, childVal, vm, key) {
    var res = Object.create(parentVal || null);
    if (childVal) return $0cd3b79ca22907b8$var$extend(res, childVal);
    else return res;
}
$0cd3b79ca22907b8$var$ASSET_TYPES.forEach(function(type) {
    $0cd3b79ca22907b8$var$strats[type + "s"] = $0cd3b79ca22907b8$var$mergeAssets;
});
/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */ $0cd3b79ca22907b8$var$strats.watch = function(parentVal, childVal, vm, key) {
    // work around Firefox's Object.prototype.watch...
    //@ts-expect-error work around
    if (parentVal === $0cd3b79ca22907b8$var$nativeWatch) parentVal = undefined;
    //@ts-expect-error work around
    if (childVal === $0cd3b79ca22907b8$var$nativeWatch) childVal = undefined;
    /* istanbul ignore if */ if (!childVal) return Object.create(parentVal || null);
    if (!parentVal) return childVal;
    var ret = {};
    $0cd3b79ca22907b8$var$extend(ret, parentVal);
    for(var key_1 in childVal){
        var parent_1 = ret[key_1];
        var child = childVal[key_1];
        if (parent_1 && !$0cd3b79ca22907b8$var$isArray(parent_1)) parent_1 = [
            parent_1
        ];
        ret[key_1] = parent_1 ? parent_1.concat(child) : $0cd3b79ca22907b8$var$isArray(child) ? child : [
            child
        ];
    }
    return ret;
};
/**
 * Other object hashes.
 */ $0cd3b79ca22907b8$var$strats.props = $0cd3b79ca22907b8$var$strats.methods = $0cd3b79ca22907b8$var$strats.inject = $0cd3b79ca22907b8$var$strats.computed = function(parentVal, childVal, vm, key) {
    if (!parentVal) return childVal;
    var ret = Object.create(null);
    $0cd3b79ca22907b8$var$extend(ret, parentVal);
    if (childVal) $0cd3b79ca22907b8$var$extend(ret, childVal);
    return ret;
};
$0cd3b79ca22907b8$var$strats.provide = function(parentVal, childVal) {
    if (!parentVal) return childVal;
    return function() {
        var ret = Object.create(null);
        $0cd3b79ca22907b8$var$mergeData(ret, $0cd3b79ca22907b8$var$isFunction(parentVal) ? parentVal.call(this) : parentVal);
        if (childVal) $0cd3b79ca22907b8$var$mergeData(ret, $0cd3b79ca22907b8$var$isFunction(childVal) ? childVal.call(this) : childVal, false // non-recursive
        );
        return ret;
    };
};
/**
 * Default strategy.
 */ var $0cd3b79ca22907b8$var$defaultStrat = function(parentVal, childVal) {
    return childVal === undefined ? parentVal : childVal;
};
/**
 * Validate component names
 */ function $0cd3b79ca22907b8$var$checkComponents(options) {
    for(var key in options.components)$0cd3b79ca22907b8$var$validateComponentName(key);
}
function $0cd3b79ca22907b8$var$validateComponentName(name) {
    if (!new RegExp("^[a-zA-Z][\\-\\.0-9_".concat($0cd3b79ca22907b8$var$unicodeRegExp.source, "]*$")).test(name)) $0cd3b79ca22907b8$var$warn('Invalid component name: "' + name + '". Component names ' + "should conform to valid custom element name in html5 specification.");
    if ($0cd3b79ca22907b8$var$isBuiltInTag(name) || $0cd3b79ca22907b8$var$config.isReservedTag(name)) $0cd3b79ca22907b8$var$warn("Do not use built-in or reserved HTML elements as component id: " + name);
}
/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */ function $0cd3b79ca22907b8$var$normalizeProps(options, vm) {
    var props = options.props;
    if (!props) return;
    var res = {};
    var i, val, name;
    if ($0cd3b79ca22907b8$var$isArray(props)) {
        i = props.length;
        while(i--){
            val = props[i];
            if (typeof val === "string") {
                name = $0cd3b79ca22907b8$var$camelize(val);
                res[name] = {
                    type: null
                };
            }
        }
    } else if ($0cd3b79ca22907b8$var$isPlainObject(props)) for(var key in props){
        val = props[key];
        name = $0cd3b79ca22907b8$var$camelize(key);
        res[name] = $0cd3b79ca22907b8$var$isPlainObject(val) ? val : {
            type: val
        };
    }
    options.props = res;
}
/**
 * Normalize all injections into Object-based format
 */ function $0cd3b79ca22907b8$var$normalizeInject(options, vm) {
    var inject = options.inject;
    if (!inject) return;
    var normalized = options.inject = {};
    if ($0cd3b79ca22907b8$var$isArray(inject)) for(var i = 0; i < inject.length; i++)normalized[inject[i]] = {
        from: inject[i]
    };
    else if ($0cd3b79ca22907b8$var$isPlainObject(inject)) for(var key in inject){
        var val = inject[key];
        normalized[key] = $0cd3b79ca22907b8$var$isPlainObject(val) ? $0cd3b79ca22907b8$var$extend({
            from: key
        }, val) : {
            from: val
        };
    }
}
/**
 * Normalize raw function directives into object format.
 */ function $0cd3b79ca22907b8$var$normalizeDirectives$1(options) {
    var dirs = options.directives;
    if (dirs) for(var key in dirs){
        var def = dirs[key];
        if ($0cd3b79ca22907b8$var$isFunction(def)) dirs[key] = {
            bind: def,
            update: def
        };
    }
}
function $0cd3b79ca22907b8$var$assertObjectType(name, value, vm) {
    if (!$0cd3b79ca22907b8$var$isPlainObject(value)) $0cd3b79ca22907b8$var$warn('Invalid value for option "'.concat(name, '": expected an Object, ') + "but got ".concat($0cd3b79ca22907b8$var$toRawType(value), "."), vm);
}
/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */ function $0cd3b79ca22907b8$var$mergeOptions(parent, child, vm) {
    if ($0cd3b79ca22907b8$var$isFunction(child)) // @ts-expect-error
    child = child.options;
    $0cd3b79ca22907b8$var$normalizeProps(child, vm);
    $0cd3b79ca22907b8$var$normalizeInject(child, vm);
    $0cd3b79ca22907b8$var$normalizeDirectives$1(child);
    // Apply extends and mixins on the child options,
    // but only if it is a raw options object that isn't
    // the result of another mergeOptions call.
    // Only merged options has the _base property.
    if (!child._base) {
        if (child.extends) parent = $0cd3b79ca22907b8$var$mergeOptions(parent, child.extends, vm);
        if (child.mixins) for(var i = 0, l = child.mixins.length; i < l; i++)parent = $0cd3b79ca22907b8$var$mergeOptions(parent, child.mixins[i], vm);
    }
    var options = {};
    var key;
    for(key in parent)mergeField(key);
    for(key in child)if (!$0cd3b79ca22907b8$var$hasOwn(parent, key)) mergeField(key);
    function mergeField(key) {
        var strat = $0cd3b79ca22907b8$var$strats[key] || $0cd3b79ca22907b8$var$defaultStrat;
        options[key] = strat(parent[key], child[key], vm, key);
    }
    return options;
}
/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */ function $0cd3b79ca22907b8$var$resolveAsset(options, type, id, warnMissing) {
    /* istanbul ignore if */ if (typeof id !== "string") return;
    var assets = options[type];
    // check local registration variations first
    if ($0cd3b79ca22907b8$var$hasOwn(assets, id)) return assets[id];
    var camelizedId = $0cd3b79ca22907b8$var$camelize(id);
    if ($0cd3b79ca22907b8$var$hasOwn(assets, camelizedId)) return assets[camelizedId];
    var PascalCaseId = $0cd3b79ca22907b8$var$capitalize(camelizedId);
    if ($0cd3b79ca22907b8$var$hasOwn(assets, PascalCaseId)) return assets[PascalCaseId];
    // fallback to prototype chain
    var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
    return res;
}
function $0cd3b79ca22907b8$var$validateProp(key, propOptions, propsData, vm) {
    var prop = propOptions[key];
    var absent = !$0cd3b79ca22907b8$var$hasOwn(propsData, key);
    var value = propsData[key];
    // boolean casting
    var booleanIndex = $0cd3b79ca22907b8$var$getTypeIndex(Boolean, prop.type);
    if (booleanIndex > -1) {
        if (absent && !$0cd3b79ca22907b8$var$hasOwn(prop, "default")) value = false;
        else if (value === "" || value === $0cd3b79ca22907b8$var$hyphenate(key)) {
            // only cast empty string / same name to boolean if
            // boolean has higher priority
            var stringIndex = $0cd3b79ca22907b8$var$getTypeIndex(String, prop.type);
            if (stringIndex < 0 || booleanIndex < stringIndex) value = true;
        }
    }
    // check default value
    if (value === undefined) {
        value = $0cd3b79ca22907b8$var$getPropDefaultValue(vm, prop, key);
        // since the default value is a fresh copy,
        // make sure to observe it.
        var prevShouldObserve = $0cd3b79ca22907b8$var$shouldObserve;
        $0cd3b79ca22907b8$var$toggleObserving(true);
        $0cd3b79ca22907b8$var$observe(value);
        $0cd3b79ca22907b8$var$toggleObserving(prevShouldObserve);
    }
    return value;
}
/**
 * Get the default value of a prop.
 */ function $0cd3b79ca22907b8$var$getPropDefaultValue(vm, prop, key) {
    // no default, return undefined
    if (!$0cd3b79ca22907b8$var$hasOwn(prop, "default")) return undefined;
    var def = prop.default;
    // the raw prop value was also undefined from previous render,
    // return previous default value to avoid unnecessary watcher trigger
    if (vm && vm.$options.propsData && vm.$options.propsData[key] === undefined && vm._props[key] !== undefined) return vm._props[key];
    // call factory function for non-Function types
    // a value is Function if its prototype is function even across different execution context
    return $0cd3b79ca22907b8$var$isFunction(def) && $0cd3b79ca22907b8$var$getType(prop.type) !== "Function" ? def.call(vm) : def;
}
/**
 * Assert whether a prop is valid.
 */ function $0cd3b79ca22907b8$var$assertProp(prop, name, value, vm, absent) {
    if (prop.required && absent) {
        $0cd3b79ca22907b8$var$warn('Missing required prop: "' + name + '"', vm);
        return;
    }
    if (value == null && !prop.required) return;
    var type = prop.type;
    var valid = !type || type === true;
    var expectedTypes = [];
    if (type) {
        if (!$0cd3b79ca22907b8$var$isArray(type)) type = [
            type
        ];
        for(var i = 0; i < type.length && !valid; i++){
            var assertedType = $0cd3b79ca22907b8$var$assertType(value, type[i], vm);
            expectedTypes.push(assertedType.expectedType || "");
            valid = assertedType.valid;
        }
    }
    var haveExpectedTypes = expectedTypes.some(function(t) {
        return t;
    });
    if (!valid && haveExpectedTypes) {
        $0cd3b79ca22907b8$var$warn($0cd3b79ca22907b8$var$getInvalidTypeMessage(name, value, expectedTypes), vm);
        return;
    }
    var validator = prop.validator;
    if (validator) {
        if (!validator(value)) $0cd3b79ca22907b8$var$warn('Invalid prop: custom validator check failed for prop "' + name + '".', vm);
    }
}
var $0cd3b79ca22907b8$var$simpleCheckRE = /^(String|Number|Boolean|Function|Symbol|BigInt)$/;
function $0cd3b79ca22907b8$var$assertType(value, type, vm) {
    var valid;
    var expectedType = $0cd3b79ca22907b8$var$getType(type);
    if ($0cd3b79ca22907b8$var$simpleCheckRE.test(expectedType)) {
        var t = typeof value;
        valid = t === expectedType.toLowerCase();
        // for primitive wrapper objects
        if (!valid && t === "object") valid = value instanceof type;
    } else if (expectedType === "Object") valid = $0cd3b79ca22907b8$var$isPlainObject(value);
    else if (expectedType === "Array") valid = $0cd3b79ca22907b8$var$isArray(value);
    else try {
        valid = value instanceof type;
    } catch (e) {
        $0cd3b79ca22907b8$var$warn('Invalid prop type: "' + String(type) + '" is not a constructor', vm);
        valid = false;
    }
    return {
        valid: valid,
        expectedType: expectedType
    };
}
var $0cd3b79ca22907b8$var$functionTypeCheckRE = /^\s*function (\w+)/;
/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */ function $0cd3b79ca22907b8$var$getType(fn) {
    var match = fn && fn.toString().match($0cd3b79ca22907b8$var$functionTypeCheckRE);
    return match ? match[1] : "";
}
function $0cd3b79ca22907b8$var$isSameType(a, b) {
    return $0cd3b79ca22907b8$var$getType(a) === $0cd3b79ca22907b8$var$getType(b);
}
function $0cd3b79ca22907b8$var$getTypeIndex(type, expectedTypes) {
    if (!$0cd3b79ca22907b8$var$isArray(expectedTypes)) return $0cd3b79ca22907b8$var$isSameType(expectedTypes, type) ? 0 : -1;
    for(var i = 0, len = expectedTypes.length; i < len; i++){
        if ($0cd3b79ca22907b8$var$isSameType(expectedTypes[i], type)) return i;
    }
    return -1;
}
function $0cd3b79ca22907b8$var$getInvalidTypeMessage(name, value, expectedTypes) {
    var message = 'Invalid prop: type check failed for prop "'.concat(name, '".') + " Expected ".concat(expectedTypes.map($0cd3b79ca22907b8$var$capitalize).join(", "));
    var expectedType = expectedTypes[0];
    var receivedType = $0cd3b79ca22907b8$var$toRawType(value);
    // check if we need to specify expected value
    if (expectedTypes.length === 1 && $0cd3b79ca22907b8$var$isExplicable(expectedType) && $0cd3b79ca22907b8$var$isExplicable(typeof value) && !$0cd3b79ca22907b8$var$isBoolean(expectedType, receivedType)) message += " with value ".concat($0cd3b79ca22907b8$var$styleValue(value, expectedType));
    message += ", got ".concat(receivedType, " ");
    // check if we need to specify received value
    if ($0cd3b79ca22907b8$var$isExplicable(receivedType)) message += "with value ".concat($0cd3b79ca22907b8$var$styleValue(value, receivedType), ".");
    return message;
}
function $0cd3b79ca22907b8$var$styleValue(value, type) {
    if (type === "String") return '"'.concat(value, '"');
    else if (type === "Number") return "".concat(Number(value));
    else return "".concat(value);
}
var $0cd3b79ca22907b8$var$EXPLICABLE_TYPES = [
    "string",
    "number",
    "boolean"
];
function $0cd3b79ca22907b8$var$isExplicable(value) {
    return $0cd3b79ca22907b8$var$EXPLICABLE_TYPES.some(function(elem) {
        return value.toLowerCase() === elem;
    });
}
function $0cd3b79ca22907b8$var$isBoolean() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return args.some(function(elem) {
        return elem.toLowerCase() === "boolean";
    });
}
/* not type checking this file because flow doesn't play well with Proxy */ var $0cd3b79ca22907b8$var$initProxy;
var $0cd3b79ca22907b8$var$allowedGlobals_1, $0cd3b79ca22907b8$var$warnNonPresent_1, $0cd3b79ca22907b8$var$warnReservedPrefix_1, $0cd3b79ca22907b8$var$hasProxy_1, $0cd3b79ca22907b8$var$isBuiltInModifier_1, $0cd3b79ca22907b8$var$hasHandler_1, $0cd3b79ca22907b8$var$getHandler_1;
var $0cd3b79ca22907b8$var$sharedPropertyDefinition = {
    enumerable: true,
    configurable: true,
    get: $0cd3b79ca22907b8$var$noop,
    set: $0cd3b79ca22907b8$var$noop
};
function $0cd3b79ca22907b8$var$proxy(target, sourceKey, key) {
    $0cd3b79ca22907b8$var$sharedPropertyDefinition.get = function proxyGetter() {
        return this[sourceKey][key];
    };
    $0cd3b79ca22907b8$var$sharedPropertyDefinition.set = function proxySetter(val) {
        this[sourceKey][key] = val;
    };
    Object.defineProperty(target, key, $0cd3b79ca22907b8$var$sharedPropertyDefinition);
}
function $0cd3b79ca22907b8$var$initState(vm) {
    var opts = vm.$options;
    if (opts.props) $0cd3b79ca22907b8$var$initProps$1(vm, opts.props);
    // Composition API
    $0cd3b79ca22907b8$var$initSetup(vm);
    if (opts.methods) $0cd3b79ca22907b8$var$initMethods(vm, opts.methods);
    if (opts.data) $0cd3b79ca22907b8$var$initData(vm);
    else {
        var ob = $0cd3b79ca22907b8$var$observe(vm._data = {});
        ob && ob.vmCount++;
    }
    if (opts.computed) $0cd3b79ca22907b8$var$initComputed$1(vm, opts.computed);
    if (opts.watch && opts.watch !== $0cd3b79ca22907b8$var$nativeWatch) $0cd3b79ca22907b8$var$initWatch(vm, opts.watch);
}
function $0cd3b79ca22907b8$var$initProps$1(vm, propsOptions) {
    var propsData = vm.$options.propsData || {};
    var props = vm._props = $0cd3b79ca22907b8$export$8d81cefd22d22260({});
    // cache prop keys so that future props updates can iterate using Array
    // instead of dynamic object key enumeration.
    var keys = vm.$options._propKeys = [];
    var isRoot = !vm.$parent;
    // root instance props should be converted
    if (!isRoot) $0cd3b79ca22907b8$var$toggleObserving(false);
    var _loop_1 = function(key) {
        keys.push(key);
        var value = $0cd3b79ca22907b8$var$validateProp(key, propsOptions, propsData, vm);
        var hyphenatedKey;
        $0cd3b79ca22907b8$var$defineReactive(props, key, value);
        // static props are already proxied on the component's prototype
        // during Vue.extend(). We only need to proxy props defined at
        // instantiation here.
        if (!(key in vm)) $0cd3b79ca22907b8$var$proxy(vm, "_props", key);
    };
    for(var key in propsOptions)_loop_1(key);
    $0cd3b79ca22907b8$var$toggleObserving(true);
}
function $0cd3b79ca22907b8$var$initData(vm) {
    var data = vm.$options.data;
    data = vm._data = $0cd3b79ca22907b8$var$isFunction(data) ? $0cd3b79ca22907b8$var$getData(data, vm) : data || {};
    if (!$0cd3b79ca22907b8$var$isPlainObject(data)) data = {};
    // proxy data on instance
    var keys = Object.keys(data);
    var props = vm.$options.props;
    var methods = vm.$options.methods;
    var i = keys.length;
    while(i--){
        var key = keys[i];
        if (props && $0cd3b79ca22907b8$var$hasOwn(props, key)) ;
        else if (!$0cd3b79ca22907b8$var$isReserved(key)) $0cd3b79ca22907b8$var$proxy(vm, "_data", key);
    }
    // observe data
    var ob = $0cd3b79ca22907b8$var$observe(data);
    ob && ob.vmCount++;
}
function $0cd3b79ca22907b8$var$getData(data, vm) {
    // #7573 disable dep collection when invoking data getters
    $0cd3b79ca22907b8$var$pushTarget();
    try {
        return data.call(vm, vm);
    } catch (e) {
        $0cd3b79ca22907b8$var$handleError(e, vm, "data()");
        return {};
    } finally{
        $0cd3b79ca22907b8$var$popTarget();
    }
}
var $0cd3b79ca22907b8$var$computedWatcherOptions = {
    lazy: true
};
function $0cd3b79ca22907b8$var$initComputed$1(vm, computed) {
    // $flow-disable-line
    var watchers = vm._computedWatchers = Object.create(null);
    // computed properties are just getters during SSR
    var isSSR = $0cd3b79ca22907b8$var$isServerRendering();
    for(var key in computed){
        var userDef = computed[key];
        var getter = $0cd3b79ca22907b8$var$isFunction(userDef) ? userDef : userDef.get;
        if (!isSSR) // create internal watcher for the computed property.
        watchers[key] = new $0cd3b79ca22907b8$var$Watcher(vm, getter || $0cd3b79ca22907b8$var$noop, $0cd3b79ca22907b8$var$noop, $0cd3b79ca22907b8$var$computedWatcherOptions);
        // component-defined computed properties are already defined on the
        // component prototype. We only need to define computed properties defined
        // at instantiation here.
        if (!(key in vm)) $0cd3b79ca22907b8$var$defineComputed(vm, key, userDef);
    }
}
function $0cd3b79ca22907b8$var$defineComputed(target, key, userDef) {
    var shouldCache = !$0cd3b79ca22907b8$var$isServerRendering();
    if ($0cd3b79ca22907b8$var$isFunction(userDef)) {
        $0cd3b79ca22907b8$var$sharedPropertyDefinition.get = shouldCache ? $0cd3b79ca22907b8$var$createComputedGetter(key) : $0cd3b79ca22907b8$var$createGetterInvoker(userDef);
        $0cd3b79ca22907b8$var$sharedPropertyDefinition.set = $0cd3b79ca22907b8$var$noop;
    } else {
        $0cd3b79ca22907b8$var$sharedPropertyDefinition.get = userDef.get ? shouldCache && userDef.cache !== false ? $0cd3b79ca22907b8$var$createComputedGetter(key) : $0cd3b79ca22907b8$var$createGetterInvoker(userDef.get) : $0cd3b79ca22907b8$var$noop;
        $0cd3b79ca22907b8$var$sharedPropertyDefinition.set = userDef.set || $0cd3b79ca22907b8$var$noop;
    }
    Object.defineProperty(target, key, $0cd3b79ca22907b8$var$sharedPropertyDefinition);
}
function $0cd3b79ca22907b8$var$createComputedGetter(key) {
    return function computedGetter() {
        var watcher = this._computedWatchers && this._computedWatchers[key];
        if (watcher) {
            if (watcher.dirty) watcher.evaluate();
            if ($0cd3b79ca22907b8$var$Dep.target) watcher.depend();
            return watcher.value;
        }
    };
}
function $0cd3b79ca22907b8$var$createGetterInvoker(fn) {
    return function computedGetter() {
        return fn.call(this, this);
    };
}
function $0cd3b79ca22907b8$var$initMethods(vm, methods) {
    var props = vm.$options.props;
    for(var key in methods)vm[key] = typeof methods[key] !== "function" ? $0cd3b79ca22907b8$var$noop : $0cd3b79ca22907b8$var$bind(methods[key], vm);
}
function $0cd3b79ca22907b8$var$initWatch(vm, watch) {
    for(var key in watch){
        var handler = watch[key];
        if ($0cd3b79ca22907b8$var$isArray(handler)) for(var i = 0; i < handler.length; i++)$0cd3b79ca22907b8$var$createWatcher(vm, key, handler[i]);
        else $0cd3b79ca22907b8$var$createWatcher(vm, key, handler);
    }
}
function $0cd3b79ca22907b8$var$createWatcher(vm, expOrFn, handler, options) {
    if ($0cd3b79ca22907b8$var$isPlainObject(handler)) {
        options = handler;
        handler = handler.handler;
    }
    if (typeof handler === "string") handler = vm[handler];
    return vm.$watch(expOrFn, handler, options);
}
function $0cd3b79ca22907b8$var$stateMixin(Vue) {
    // flow somehow has problems with directly declared definition object
    // when using Object.defineProperty, so we have to procedurally build up
    // the object here.
    var dataDef = {};
    dataDef.get = function() {
        return this._data;
    };
    var propsDef = {};
    propsDef.get = function() {
        return this._props;
    };
    Object.defineProperty(Vue.prototype, "$data", dataDef);
    Object.defineProperty(Vue.prototype, "$props", propsDef);
    Vue.prototype.$set = $0cd3b79ca22907b8$export$adaa4cf7ef1b65be;
    Vue.prototype.$delete = $0cd3b79ca22907b8$export$1d2f21e549771e67;
    Vue.prototype.$watch = function(expOrFn, cb, options) {
        var vm = this;
        if ($0cd3b79ca22907b8$var$isPlainObject(cb)) return $0cd3b79ca22907b8$var$createWatcher(vm, expOrFn, cb, options);
        options = options || {};
        options.user = true;
        var watcher = new $0cd3b79ca22907b8$var$Watcher(vm, expOrFn, cb, options);
        if (options.immediate) {
            var info = 'callback for immediate watcher "'.concat(watcher.expression, '"');
            $0cd3b79ca22907b8$var$pushTarget();
            $0cd3b79ca22907b8$var$invokeWithErrorHandling(cb, vm, [
                watcher.value
            ], vm, info);
            $0cd3b79ca22907b8$var$popTarget();
        }
        return function unwatchFn() {
            watcher.teardown();
        };
    };
}
var $0cd3b79ca22907b8$var$uid = 0;
function $0cd3b79ca22907b8$var$initMixin$1(Vue) {
    Vue.prototype._init = function(options) {
        var vm = this;
        // a uid
        vm._uid = $0cd3b79ca22907b8$var$uid++;
        var startTag, endTag;
        // a flag to mark this as a Vue instance without having to do instanceof
        // check
        vm._isVue = true;
        // avoid instances from being observed
        vm.__v_skip = true;
        // effect scope
        vm._scope = new $0cd3b79ca22907b8$export$1168ed9dbc71ddbd(true);
        vm._scope._vm = true;
        // merge options
        if (options && options._isComponent) // optimize internal component instantiation
        // since dynamic options merging is pretty slow, and none of the
        // internal component options needs special treatment.
        $0cd3b79ca22907b8$var$initInternalComponent(vm, options);
        else vm.$options = $0cd3b79ca22907b8$var$mergeOptions($0cd3b79ca22907b8$var$resolveConstructorOptions(vm.constructor), options || {}, vm);
        vm._renderProxy = vm;
        // expose real self
        vm._self = vm;
        $0cd3b79ca22907b8$var$initLifecycle(vm);
        $0cd3b79ca22907b8$var$initEvents(vm);
        $0cd3b79ca22907b8$var$initRender(vm);
        $0cd3b79ca22907b8$var$callHook$1(vm, "beforeCreate", undefined, false);
        $0cd3b79ca22907b8$var$initInjections(vm); // resolve injections before data/props
        $0cd3b79ca22907b8$var$initState(vm);
        $0cd3b79ca22907b8$var$initProvide(vm); // resolve provide after data/props
        $0cd3b79ca22907b8$var$callHook$1(vm, "created");
        if (vm.$options.el) vm.$mount(vm.$options.el);
    };
}
function $0cd3b79ca22907b8$var$initInternalComponent(vm, options) {
    var opts = vm.$options = Object.create(vm.constructor.options);
    // doing this because it's faster than dynamic enumeration.
    var parentVnode = options._parentVnode;
    opts.parent = options.parent;
    opts._parentVnode = parentVnode;
    var vnodeComponentOptions = parentVnode.componentOptions;
    opts.propsData = vnodeComponentOptions.propsData;
    opts._parentListeners = vnodeComponentOptions.listeners;
    opts._renderChildren = vnodeComponentOptions.children;
    opts._componentTag = vnodeComponentOptions.tag;
    if (options.render) {
        opts.render = options.render;
        opts.staticRenderFns = options.staticRenderFns;
    }
}
function $0cd3b79ca22907b8$var$resolveConstructorOptions(Ctor) {
    var options = Ctor.options;
    if (Ctor.super) {
        var superOptions = $0cd3b79ca22907b8$var$resolveConstructorOptions(Ctor.super);
        var cachedSuperOptions = Ctor.superOptions;
        if (superOptions !== cachedSuperOptions) {
            // super option changed,
            // need to resolve new options.
            Ctor.superOptions = superOptions;
            // check if there are any late-modified/attached options (#4976)
            var modifiedOptions = $0cd3b79ca22907b8$var$resolveModifiedOptions(Ctor);
            // update base extend options
            if (modifiedOptions) $0cd3b79ca22907b8$var$extend(Ctor.extendOptions, modifiedOptions);
            options = Ctor.options = $0cd3b79ca22907b8$var$mergeOptions(superOptions, Ctor.extendOptions);
            if (options.name) options.components[options.name] = Ctor;
        }
    }
    return options;
}
function $0cd3b79ca22907b8$var$resolveModifiedOptions(Ctor) {
    var modified;
    var latest = Ctor.options;
    var sealed = Ctor.sealedOptions;
    for(var key in latest)if (latest[key] !== sealed[key]) {
        if (!modified) modified = {};
        modified[key] = latest[key];
    }
    return modified;
}
function $0cd3b79ca22907b8$export$2e2bcd8739ae039(options) {
    this._init(options);
}
//@ts-expect-error Vue has function type
$0cd3b79ca22907b8$var$initMixin$1($0cd3b79ca22907b8$export$2e2bcd8739ae039);
//@ts-expect-error Vue has function type
$0cd3b79ca22907b8$var$stateMixin($0cd3b79ca22907b8$export$2e2bcd8739ae039);
//@ts-expect-error Vue has function type
$0cd3b79ca22907b8$var$eventsMixin($0cd3b79ca22907b8$export$2e2bcd8739ae039);
//@ts-expect-error Vue has function type
$0cd3b79ca22907b8$var$lifecycleMixin($0cd3b79ca22907b8$export$2e2bcd8739ae039);
//@ts-expect-error Vue has function type
$0cd3b79ca22907b8$var$renderMixin($0cd3b79ca22907b8$export$2e2bcd8739ae039);
function $0cd3b79ca22907b8$var$initUse(Vue) {
    Vue.use = function(plugin) {
        var installedPlugins = this._installedPlugins || (this._installedPlugins = []);
        if (installedPlugins.indexOf(plugin) > -1) return this;
        // additional parameters
        var args = $0cd3b79ca22907b8$var$toArray(arguments, 1);
        args.unshift(this);
        if ($0cd3b79ca22907b8$var$isFunction(plugin.install)) plugin.install.apply(plugin, args);
        else if ($0cd3b79ca22907b8$var$isFunction(plugin)) plugin.apply(null, args);
        installedPlugins.push(plugin);
        return this;
    };
}
function $0cd3b79ca22907b8$var$initMixin(Vue) {
    Vue.mixin = function(mixin) {
        this.options = $0cd3b79ca22907b8$var$mergeOptions(this.options, mixin);
        return this;
    };
}
function $0cd3b79ca22907b8$var$initExtend(Vue) {
    /**
     * Each instance constructor, including Vue, has a unique
     * cid. This enables us to create wrapped "child
     * constructors" for prototypal inheritance and cache them.
     */ Vue.cid = 0;
    var cid = 1;
    /**
     * Class inheritance
     */ Vue.extend = function(extendOptions) {
        extendOptions = extendOptions || {};
        var Super = this;
        var SuperId = Super.cid;
        var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
        if (cachedCtors[SuperId]) return cachedCtors[SuperId];
        var name = $0cd3b79ca22907b8$var$getComponentName(extendOptions) || $0cd3b79ca22907b8$var$getComponentName(Super.options);
        var Sub = function VueComponent(options) {
            this._init(options);
        };
        Sub.prototype = Object.create(Super.prototype);
        Sub.prototype.constructor = Sub;
        Sub.cid = cid++;
        Sub.options = $0cd3b79ca22907b8$var$mergeOptions(Super.options, extendOptions);
        Sub["super"] = Super;
        // For props and computed properties, we define the proxy getters on
        // the Vue instances at extension time, on the extended prototype. This
        // avoids Object.defineProperty calls for each instance created.
        if (Sub.options.props) $0cd3b79ca22907b8$var$initProps(Sub);
        if (Sub.options.computed) $0cd3b79ca22907b8$var$initComputed(Sub);
        // allow further extension/mixin/plugin usage
        Sub.extend = Super.extend;
        Sub.mixin = Super.mixin;
        Sub.use = Super.use;
        // create asset registers, so extended classes
        // can have their private assets too.
        $0cd3b79ca22907b8$var$ASSET_TYPES.forEach(function(type) {
            Sub[type] = Super[type];
        });
        // enable recursive self-lookup
        if (name) Sub.options.components[name] = Sub;
        // keep a reference to the super options at extension time.
        // later at instantiation we can check if Super's options have
        // been updated.
        Sub.superOptions = Super.options;
        Sub.extendOptions = extendOptions;
        Sub.sealedOptions = $0cd3b79ca22907b8$var$extend({}, Sub.options);
        // cache constructor
        cachedCtors[SuperId] = Sub;
        return Sub;
    };
}
function $0cd3b79ca22907b8$var$initProps(Comp) {
    var props = Comp.options.props;
    for(var key in props)$0cd3b79ca22907b8$var$proxy(Comp.prototype, "_props", key);
}
function $0cd3b79ca22907b8$var$initComputed(Comp) {
    var computed = Comp.options.computed;
    for(var key in computed)$0cd3b79ca22907b8$var$defineComputed(Comp.prototype, key, computed[key]);
}
function $0cd3b79ca22907b8$var$initAssetRegisters(Vue) {
    /**
     * Create asset registration methods.
     */ $0cd3b79ca22907b8$var$ASSET_TYPES.forEach(function(type) {
        // @ts-expect-error function is not exact same type
        Vue[type] = function(id, definition) {
            if (!definition) return this.options[type + "s"][id];
            else {
                if (type === "component" && $0cd3b79ca22907b8$var$isPlainObject(definition)) {
                    // @ts-expect-error
                    definition.name = definition.name || id;
                    definition = this.options._base.extend(definition);
                }
                if (type === "directive" && $0cd3b79ca22907b8$var$isFunction(definition)) definition = {
                    bind: definition,
                    update: definition
                };
                this.options[type + "s"][id] = definition;
                return definition;
            }
        };
    });
}
function $0cd3b79ca22907b8$var$_getComponentName(opts) {
    return opts && ($0cd3b79ca22907b8$var$getComponentName(opts.Ctor.options) || opts.tag);
}
function $0cd3b79ca22907b8$var$matches(pattern, name) {
    if ($0cd3b79ca22907b8$var$isArray(pattern)) return pattern.indexOf(name) > -1;
    else if (typeof pattern === "string") return pattern.split(",").indexOf(name) > -1;
    else if ($0cd3b79ca22907b8$var$isRegExp(pattern)) return pattern.test(name);
    /* istanbul ignore next */ return false;
}
function $0cd3b79ca22907b8$var$pruneCache(keepAliveInstance, filter) {
    var cache = keepAliveInstance.cache, keys = keepAliveInstance.keys, _vnode = keepAliveInstance._vnode;
    for(var key in cache){
        var entry = cache[key];
        if (entry) {
            var name_1 = entry.name;
            if (name_1 && !filter(name_1)) $0cd3b79ca22907b8$var$pruneCacheEntry(cache, key, keys, _vnode);
        }
    }
}
function $0cd3b79ca22907b8$var$pruneCacheEntry(cache, key, keys, current) {
    var entry = cache[key];
    if (entry && (!current || entry.tag !== current.tag)) // @ts-expect-error can be undefined
    entry.componentInstance.$destroy();
    cache[key] = null;
    $0cd3b79ca22907b8$var$remove$2(keys, key);
}
var $0cd3b79ca22907b8$var$patternTypes = [
    String,
    RegExp,
    Array
];
// TODO defineComponent
var $0cd3b79ca22907b8$var$KeepAlive = {
    name: "keep-alive",
    abstract: true,
    props: {
        include: $0cd3b79ca22907b8$var$patternTypes,
        exclude: $0cd3b79ca22907b8$var$patternTypes,
        max: [
            String,
            Number
        ]
    },
    methods: {
        cacheVNode: function() {
            var _a = this, cache = _a.cache, keys = _a.keys, vnodeToCache = _a.vnodeToCache, keyToCache = _a.keyToCache;
            if (vnodeToCache) {
                var tag = vnodeToCache.tag, componentInstance = vnodeToCache.componentInstance, componentOptions = vnodeToCache.componentOptions;
                cache[keyToCache] = {
                    name: $0cd3b79ca22907b8$var$_getComponentName(componentOptions),
                    tag: tag,
                    componentInstance: componentInstance
                };
                keys.push(keyToCache);
                // prune oldest entry
                if (this.max && keys.length > parseInt(this.max)) $0cd3b79ca22907b8$var$pruneCacheEntry(cache, keys[0], keys, this._vnode);
                this.vnodeToCache = null;
            }
        }
    },
    created: function() {
        this.cache = Object.create(null);
        this.keys = [];
    },
    destroyed: function() {
        for(var key in this.cache)$0cd3b79ca22907b8$var$pruneCacheEntry(this.cache, key, this.keys);
    },
    mounted: function() {
        var _this = this;
        this.cacheVNode();
        this.$watch("include", function(val) {
            $0cd3b79ca22907b8$var$pruneCache(_this, function(name) {
                return $0cd3b79ca22907b8$var$matches(val, name);
            });
        });
        this.$watch("exclude", function(val) {
            $0cd3b79ca22907b8$var$pruneCache(_this, function(name) {
                return !$0cd3b79ca22907b8$var$matches(val, name);
            });
        });
    },
    updated: function() {
        this.cacheVNode();
    },
    render: function() {
        var slot = this.$slots.default;
        var vnode = $0cd3b79ca22907b8$var$getFirstComponentChild(slot);
        var componentOptions = vnode && vnode.componentOptions;
        if (componentOptions) {
            // check pattern
            var name_2 = $0cd3b79ca22907b8$var$_getComponentName(componentOptions);
            var _a = this, include = _a.include, exclude = _a.exclude;
            if (// not included
            include && (!name_2 || !$0cd3b79ca22907b8$var$matches(include, name_2)) || // excluded
            exclude && name_2 && $0cd3b79ca22907b8$var$matches(exclude, name_2)) return vnode;
            var _b = this, cache = _b.cache, keys = _b.keys;
            var key = vnode.key == null ? // so cid alone is not enough (#3269)
            componentOptions.Ctor.cid + (componentOptions.tag ? "::".concat(componentOptions.tag) : "") : vnode.key;
            if (cache[key]) {
                vnode.componentInstance = cache[key].componentInstance;
                // make current key freshest
                $0cd3b79ca22907b8$var$remove$2(keys, key);
                keys.push(key);
            } else {
                // delay setting the cache until update
                this.vnodeToCache = vnode;
                this.keyToCache = key;
            }
            // @ts-expect-error can vnode.data can be undefined
            vnode.data.keepAlive = true;
        }
        return vnode || slot && slot[0];
    }
};
var $0cd3b79ca22907b8$var$builtInComponents = {
    KeepAlive: $0cd3b79ca22907b8$var$KeepAlive
};
function $0cd3b79ca22907b8$var$initGlobalAPI(Vue) {
    // config
    var configDef = {};
    configDef.get = function() {
        return $0cd3b79ca22907b8$var$config;
    };
    Object.defineProperty(Vue, "config", configDef);
    // exposed util methods.
    // NOTE: these are not considered part of the public API - avoid relying on
    // them unless you are aware of the risk.
    Vue.util = {
        warn: $0cd3b79ca22907b8$var$warn,
        extend: $0cd3b79ca22907b8$var$extend,
        mergeOptions: $0cd3b79ca22907b8$var$mergeOptions,
        defineReactive: $0cd3b79ca22907b8$var$defineReactive
    };
    Vue.set = $0cd3b79ca22907b8$export$adaa4cf7ef1b65be;
    Vue.delete = $0cd3b79ca22907b8$export$1d2f21e549771e67;
    Vue.nextTick = $0cd3b79ca22907b8$export$bdd553fddd433dcb;
    // 2.6 explicit observable API
    Vue.observable = function(obj) {
        $0cd3b79ca22907b8$var$observe(obj);
        return obj;
    };
    Vue.options = Object.create(null);
    $0cd3b79ca22907b8$var$ASSET_TYPES.forEach(function(type) {
        Vue.options[type + "s"] = Object.create(null);
    });
    // this is used to identify the "base" constructor to extend all plain-object
    // components with in Weex's multi-instance scenarios.
    Vue.options._base = Vue;
    $0cd3b79ca22907b8$var$extend(Vue.options.components, $0cd3b79ca22907b8$var$builtInComponents);
    $0cd3b79ca22907b8$var$initUse(Vue);
    $0cd3b79ca22907b8$var$initMixin(Vue);
    $0cd3b79ca22907b8$var$initExtend(Vue);
    $0cd3b79ca22907b8$var$initAssetRegisters(Vue);
}
$0cd3b79ca22907b8$var$initGlobalAPI($0cd3b79ca22907b8$export$2e2bcd8739ae039);
Object.defineProperty($0cd3b79ca22907b8$export$2e2bcd8739ae039.prototype, "$isServer", {
    get: $0cd3b79ca22907b8$var$isServerRendering
});
Object.defineProperty($0cd3b79ca22907b8$export$2e2bcd8739ae039.prototype, "$ssrContext", {
    get: function() {
        /* istanbul ignore next */ return this.$vnode && this.$vnode.ssrContext;
    }
});
// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty($0cd3b79ca22907b8$export$2e2bcd8739ae039, "FunctionalRenderContext", {
    value: $0cd3b79ca22907b8$var$FunctionalRenderContext
});
$0cd3b79ca22907b8$export$2e2bcd8739ae039.version = $0cd3b79ca22907b8$export$83d89fbfd8236492;
// these are reserved for web because they are directly compiled away
// during template compilation
var $0cd3b79ca22907b8$var$isReservedAttr = $0cd3b79ca22907b8$var$makeMap("style,class");
// attributes that should be using props for binding
var $0cd3b79ca22907b8$var$acceptValue = $0cd3b79ca22907b8$var$makeMap("input,textarea,option,select,progress");
var $0cd3b79ca22907b8$var$mustUseProp = function(tag, type, attr) {
    return attr === "value" && $0cd3b79ca22907b8$var$acceptValue(tag) && type !== "button" || attr === "selected" && tag === "option" || attr === "checked" && tag === "input" || attr === "muted" && tag === "video";
};
var $0cd3b79ca22907b8$var$isEnumeratedAttr = $0cd3b79ca22907b8$var$makeMap("contenteditable,draggable,spellcheck");
var $0cd3b79ca22907b8$var$isValidContentEditableValue = $0cd3b79ca22907b8$var$makeMap("events,caret,typing,plaintext-only");
var $0cd3b79ca22907b8$var$convertEnumeratedValue = function(key, value) {
    return $0cd3b79ca22907b8$var$isFalsyAttrValue(value) || value === "false" ? "false" : key === "contenteditable" && $0cd3b79ca22907b8$var$isValidContentEditableValue(value) ? value : "true";
};
var $0cd3b79ca22907b8$var$isBooleanAttr = $0cd3b79ca22907b8$var$makeMap("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,truespeed,typemustmatch,visible");
var $0cd3b79ca22907b8$var$xlinkNS = "http://www.w3.org/1999/xlink";
var $0cd3b79ca22907b8$var$isXlink = function(name) {
    return name.charAt(5) === ":" && name.slice(0, 5) === "xlink";
};
var $0cd3b79ca22907b8$var$getXlinkProp = function(name) {
    return $0cd3b79ca22907b8$var$isXlink(name) ? name.slice(6, name.length) : "";
};
var $0cd3b79ca22907b8$var$isFalsyAttrValue = function(val) {
    return val == null || val === false;
};
function $0cd3b79ca22907b8$var$genClassForVnode(vnode) {
    var data = vnode.data;
    var parentNode = vnode;
    var childNode = vnode;
    while($0cd3b79ca22907b8$var$isDef(childNode.componentInstance)){
        childNode = childNode.componentInstance._vnode;
        if (childNode && childNode.data) data = $0cd3b79ca22907b8$var$mergeClassData(childNode.data, data);
    }
    // @ts-expect-error parentNode.parent not VNodeWithData
    while($0cd3b79ca22907b8$var$isDef(parentNode = parentNode.parent))if (parentNode && parentNode.data) data = $0cd3b79ca22907b8$var$mergeClassData(data, parentNode.data);
    return $0cd3b79ca22907b8$var$renderClass(data.staticClass, data.class);
}
function $0cd3b79ca22907b8$var$mergeClassData(child, parent) {
    return {
        staticClass: $0cd3b79ca22907b8$var$concat(child.staticClass, parent.staticClass),
        class: $0cd3b79ca22907b8$var$isDef(child.class) ? [
            child.class,
            parent.class
        ] : parent.class
    };
}
function $0cd3b79ca22907b8$var$renderClass(staticClass, dynamicClass) {
    if ($0cd3b79ca22907b8$var$isDef(staticClass) || $0cd3b79ca22907b8$var$isDef(dynamicClass)) return $0cd3b79ca22907b8$var$concat(staticClass, $0cd3b79ca22907b8$var$stringifyClass(dynamicClass));
    /* istanbul ignore next */ return "";
}
function $0cd3b79ca22907b8$var$concat(a, b) {
    return a ? b ? a + " " + b : a : b || "";
}
function $0cd3b79ca22907b8$var$stringifyClass(value) {
    if (Array.isArray(value)) return $0cd3b79ca22907b8$var$stringifyArray(value);
    if ($0cd3b79ca22907b8$var$isObject(value)) return $0cd3b79ca22907b8$var$stringifyObject(value);
    if (typeof value === "string") return value;
    /* istanbul ignore next */ return "";
}
function $0cd3b79ca22907b8$var$stringifyArray(value) {
    var res = "";
    var stringified;
    for(var i = 0, l = value.length; i < l; i++)if ($0cd3b79ca22907b8$var$isDef(stringified = $0cd3b79ca22907b8$var$stringifyClass(value[i])) && stringified !== "") {
        if (res) res += " ";
        res += stringified;
    }
    return res;
}
function $0cd3b79ca22907b8$var$stringifyObject(value) {
    var res = "";
    for(var key in value)if (value[key]) {
        if (res) res += " ";
        res += key;
    }
    return res;
}
var $0cd3b79ca22907b8$var$namespaceMap = {
    svg: "http://www.w3.org/2000/svg",
    math: "http://www.w3.org/1998/Math/MathML"
};
var $0cd3b79ca22907b8$var$isHTMLTag = $0cd3b79ca22907b8$var$makeMap("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot");
// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var $0cd3b79ca22907b8$var$isSVG = $0cd3b79ca22907b8$var$makeMap("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignobject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view", true);
var $0cd3b79ca22907b8$var$isReservedTag = function(tag) {
    return $0cd3b79ca22907b8$var$isHTMLTag(tag) || $0cd3b79ca22907b8$var$isSVG(tag);
};
function $0cd3b79ca22907b8$var$getTagNamespace(tag) {
    if ($0cd3b79ca22907b8$var$isSVG(tag)) return "svg";
    // basic support for MathML
    // note it doesn't support other MathML elements being component roots
    if (tag === "math") return "math";
}
var $0cd3b79ca22907b8$var$unknownElementCache = Object.create(null);
function $0cd3b79ca22907b8$var$isUnknownElement(tag) {
    /* istanbul ignore if */ if (!$0cd3b79ca22907b8$var$inBrowser) return true;
    if ($0cd3b79ca22907b8$var$isReservedTag(tag)) return false;
    tag = tag.toLowerCase();
    /* istanbul ignore if */ if ($0cd3b79ca22907b8$var$unknownElementCache[tag] != null) return $0cd3b79ca22907b8$var$unknownElementCache[tag];
    var el = document.createElement(tag);
    if (tag.indexOf("-") > -1) // http://stackoverflow.com/a/28210364/1070244
    return $0cd3b79ca22907b8$var$unknownElementCache[tag] = el.constructor === window.HTMLUnknownElement || el.constructor === window.HTMLElement;
    else return $0cd3b79ca22907b8$var$unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString());
}
var $0cd3b79ca22907b8$var$isTextInputType = $0cd3b79ca22907b8$var$makeMap("text,number,password,search,email,tel,url");
/**
 * Query an element selector if it's not an element already.
 */ function $0cd3b79ca22907b8$var$query(el) {
    if (typeof el === "string") {
        var selected = document.querySelector(el);
        if (!selected) return document.createElement("div");
        return selected;
    } else return el;
}
function $0cd3b79ca22907b8$var$createElement(tagName, vnode) {
    var elm = document.createElement(tagName);
    if (tagName !== "select") return elm;
    // false or null will remove the attribute but undefined will not
    if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) elm.setAttribute("multiple", "multiple");
    return elm;
}
function $0cd3b79ca22907b8$var$createElementNS(namespace, tagName) {
    return document.createElementNS($0cd3b79ca22907b8$var$namespaceMap[namespace], tagName);
}
function $0cd3b79ca22907b8$var$createTextNode(text) {
    return document.createTextNode(text);
}
function $0cd3b79ca22907b8$var$createComment(text) {
    return document.createComment(text);
}
function $0cd3b79ca22907b8$var$insertBefore(parentNode, newNode, referenceNode) {
    parentNode.insertBefore(newNode, referenceNode);
}
function $0cd3b79ca22907b8$var$removeChild(node, child) {
    node.removeChild(child);
}
function $0cd3b79ca22907b8$var$appendChild(node, child) {
    node.appendChild(child);
}
function $0cd3b79ca22907b8$var$parentNode(node) {
    return node.parentNode;
}
function $0cd3b79ca22907b8$var$nextSibling(node) {
    return node.nextSibling;
}
function $0cd3b79ca22907b8$var$tagName(node) {
    return node.tagName;
}
function $0cd3b79ca22907b8$var$setTextContent(node, text) {
    node.textContent = text;
}
function $0cd3b79ca22907b8$var$setStyleScope(node, scopeId) {
    node.setAttribute(scopeId, "");
}
var $0cd3b79ca22907b8$var$nodeOps = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    createElement: $0cd3b79ca22907b8$var$createElement,
    createElementNS: $0cd3b79ca22907b8$var$createElementNS,
    createTextNode: $0cd3b79ca22907b8$var$createTextNode,
    createComment: $0cd3b79ca22907b8$var$createComment,
    insertBefore: $0cd3b79ca22907b8$var$insertBefore,
    removeChild: $0cd3b79ca22907b8$var$removeChild,
    appendChild: $0cd3b79ca22907b8$var$appendChild,
    parentNode: $0cd3b79ca22907b8$var$parentNode,
    nextSibling: $0cd3b79ca22907b8$var$nextSibling,
    tagName: $0cd3b79ca22907b8$var$tagName,
    setTextContent: $0cd3b79ca22907b8$var$setTextContent,
    setStyleScope: $0cd3b79ca22907b8$var$setStyleScope
});
var $0cd3b79ca22907b8$var$ref = {
    create: function(_, vnode) {
        $0cd3b79ca22907b8$var$registerRef(vnode);
    },
    update: function(oldVnode, vnode) {
        if (oldVnode.data.ref !== vnode.data.ref) {
            $0cd3b79ca22907b8$var$registerRef(oldVnode, true);
            $0cd3b79ca22907b8$var$registerRef(vnode);
        }
    },
    destroy: function(vnode) {
        $0cd3b79ca22907b8$var$registerRef(vnode, true);
    }
};
function $0cd3b79ca22907b8$var$registerRef(vnode, isRemoval) {
    var ref = vnode.data.ref;
    if (!$0cd3b79ca22907b8$var$isDef(ref)) return;
    var vm = vnode.context;
    var refValue = vnode.componentInstance || vnode.elm;
    var value = isRemoval ? null : refValue;
    var $refsValue = isRemoval ? undefined : refValue;
    if ($0cd3b79ca22907b8$var$isFunction(ref)) {
        $0cd3b79ca22907b8$var$invokeWithErrorHandling(ref, vm, [
            value
        ], vm, "template ref function");
        return;
    }
    var isFor = vnode.data.refInFor;
    var _isString = typeof ref === "string" || typeof ref === "number";
    var _isRef = $0cd3b79ca22907b8$export$4f9f5282de18fc69(ref);
    var refs = vm.$refs;
    if (_isString || _isRef) {
        if (isFor) {
            var existing = _isString ? refs[ref] : ref.value;
            if (isRemoval) $0cd3b79ca22907b8$var$isArray(existing) && $0cd3b79ca22907b8$var$remove$2(existing, refValue);
            else {
                if (!$0cd3b79ca22907b8$var$isArray(existing)) {
                    if (_isString) {
                        refs[ref] = [
                            refValue
                        ];
                        $0cd3b79ca22907b8$var$setSetupRef(vm, ref, refs[ref]);
                    } else ref.value = [
                        refValue
                    ];
                } else if (!existing.includes(refValue)) existing.push(refValue);
            }
        } else if (_isString) {
            if (isRemoval && refs[ref] !== refValue) return;
            refs[ref] = $refsValue;
            $0cd3b79ca22907b8$var$setSetupRef(vm, ref, value);
        } else if (_isRef) {
            if (isRemoval && ref.value !== refValue) return;
            ref.value = value;
        }
    }
}
function $0cd3b79ca22907b8$var$setSetupRef(_a, key, val) {
    var _setupState = _a._setupState;
    if (_setupState && $0cd3b79ca22907b8$var$hasOwn(_setupState, key)) {
        if ($0cd3b79ca22907b8$export$4f9f5282de18fc69(_setupState[key])) _setupState[key].value = val;
        else _setupState[key] = val;
    }
}
/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */ var $0cd3b79ca22907b8$var$emptyNode = new $0cd3b79ca22907b8$var$VNode("", {}, []);
var $0cd3b79ca22907b8$var$hooks = [
    "create",
    "activate",
    "update",
    "remove",
    "destroy"
];
function $0cd3b79ca22907b8$var$sameVnode(a, b) {
    return a.key === b.key && a.asyncFactory === b.asyncFactory && (a.tag === b.tag && a.isComment === b.isComment && $0cd3b79ca22907b8$var$isDef(a.data) === $0cd3b79ca22907b8$var$isDef(b.data) && $0cd3b79ca22907b8$var$sameInputType(a, b) || $0cd3b79ca22907b8$var$isTrue(a.isAsyncPlaceholder) && $0cd3b79ca22907b8$var$isUndef(b.asyncFactory.error));
}
function $0cd3b79ca22907b8$var$sameInputType(a, b) {
    if (a.tag !== "input") return true;
    var i;
    var typeA = $0cd3b79ca22907b8$var$isDef(i = a.data) && $0cd3b79ca22907b8$var$isDef(i = i.attrs) && i.type;
    var typeB = $0cd3b79ca22907b8$var$isDef(i = b.data) && $0cd3b79ca22907b8$var$isDef(i = i.attrs) && i.type;
    return typeA === typeB || $0cd3b79ca22907b8$var$isTextInputType(typeA) && $0cd3b79ca22907b8$var$isTextInputType(typeB);
}
function $0cd3b79ca22907b8$var$createKeyToOldIdx(children, beginIdx, endIdx) {
    var i, key;
    var map = {};
    for(i = beginIdx; i <= endIdx; ++i){
        key = children[i].key;
        if ($0cd3b79ca22907b8$var$isDef(key)) map[key] = i;
    }
    return map;
}
function $0cd3b79ca22907b8$var$createPatchFunction(backend) {
    var i, j;
    var cbs = {};
    var modules = backend.modules, nodeOps = backend.nodeOps;
    for(i = 0; i < $0cd3b79ca22907b8$var$hooks.length; ++i){
        cbs[$0cd3b79ca22907b8$var$hooks[i]] = [];
        for(j = 0; j < modules.length; ++j)if ($0cd3b79ca22907b8$var$isDef(modules[j][$0cd3b79ca22907b8$var$hooks[i]])) cbs[$0cd3b79ca22907b8$var$hooks[i]].push(modules[j][$0cd3b79ca22907b8$var$hooks[i]]);
    }
    function emptyNodeAt(elm) {
        return new $0cd3b79ca22907b8$var$VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm);
    }
    function createRmCb(childElm, listeners) {
        function remove() {
            if (--remove.listeners === 0) removeNode(childElm);
        }
        remove.listeners = listeners;
        return remove;
    }
    function removeNode(el) {
        var parent = nodeOps.parentNode(el);
        // element may have already been removed due to v-html / v-text
        if ($0cd3b79ca22907b8$var$isDef(parent)) nodeOps.removeChild(parent, el);
    }
    function isUnknownElement(vnode, inVPre) {
        return !inVPre && !vnode.ns && !($0cd3b79ca22907b8$var$config.ignoredElements.length && $0cd3b79ca22907b8$var$config.ignoredElements.some(function(ignore) {
            return $0cd3b79ca22907b8$var$isRegExp(ignore) ? ignore.test(vnode.tag) : ignore === vnode.tag;
        })) && $0cd3b79ca22907b8$var$config.isUnknownElement(vnode.tag);
    }
    var creatingElmInVPre = 0;
    function createElm(vnode, insertedVnodeQueue, parentElm, refElm, nested, ownerArray, index) {
        if ($0cd3b79ca22907b8$var$isDef(vnode.elm) && $0cd3b79ca22907b8$var$isDef(ownerArray)) // This vnode was used in a previous render!
        // now it's used as a new node, overwriting its elm would cause
        // potential patch errors down the road when it's used as an insertion
        // reference node. Instead, we clone the node on-demand before creating
        // associated DOM element for it.
        vnode = ownerArray[index] = $0cd3b79ca22907b8$var$cloneVNode(vnode);
        vnode.isRootInsert = !nested; // for transition enter check
        if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) return;
        var data = vnode.data;
        var children = vnode.children;
        var tag = vnode.tag;
        if ($0cd3b79ca22907b8$var$isDef(tag)) {
            vnode.elm = vnode.ns ? nodeOps.createElementNS(vnode.ns, tag) : nodeOps.createElement(tag, vnode);
            setScope(vnode);
            createChildren(vnode, children, insertedVnodeQueue);
            if ($0cd3b79ca22907b8$var$isDef(data)) invokeCreateHooks(vnode, insertedVnodeQueue);
            insert(parentElm, vnode.elm, refElm);
        } else if ($0cd3b79ca22907b8$var$isTrue(vnode.isComment)) {
            vnode.elm = nodeOps.createComment(vnode.text);
            insert(parentElm, vnode.elm, refElm);
        } else {
            vnode.elm = nodeOps.createTextNode(vnode.text);
            insert(parentElm, vnode.elm, refElm);
        }
    }
    function createComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
        var i = vnode.data;
        if ($0cd3b79ca22907b8$var$isDef(i)) {
            var isReactivated = $0cd3b79ca22907b8$var$isDef(vnode.componentInstance) && i.keepAlive;
            if ($0cd3b79ca22907b8$var$isDef(i = i.hook) && $0cd3b79ca22907b8$var$isDef(i = i.init)) i(vnode, false);
            // after calling the init hook, if the vnode is a child component
            // it should've created a child instance and mounted it. the child
            // component also has set the placeholder vnode's elm.
            // in that case we can just return the element and be done.
            if ($0cd3b79ca22907b8$var$isDef(vnode.componentInstance)) {
                initComponent(vnode, insertedVnodeQueue);
                insert(parentElm, vnode.elm, refElm);
                if ($0cd3b79ca22907b8$var$isTrue(isReactivated)) reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
                return true;
            }
        }
    }
    function initComponent(vnode, insertedVnodeQueue) {
        if ($0cd3b79ca22907b8$var$isDef(vnode.data.pendingInsert)) {
            insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
            vnode.data.pendingInsert = null;
        }
        vnode.elm = vnode.componentInstance.$el;
        if (isPatchable(vnode)) {
            invokeCreateHooks(vnode, insertedVnodeQueue);
            setScope(vnode);
        } else {
            // empty component root.
            // skip all element-related modules except for ref (#3455)
            $0cd3b79ca22907b8$var$registerRef(vnode);
            // make sure to invoke the insert hook
            insertedVnodeQueue.push(vnode);
        }
    }
    function reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm) {
        var i;
        // hack for #4339: a reactivated component with inner transition
        // does not trigger because the inner node's created hooks are not called
        // again. It's not ideal to involve module-specific logic in here but
        // there doesn't seem to be a better way to do it.
        var innerNode = vnode;
        while(innerNode.componentInstance){
            innerNode = innerNode.componentInstance._vnode;
            if ($0cd3b79ca22907b8$var$isDef(i = innerNode.data) && $0cd3b79ca22907b8$var$isDef(i = i.transition)) {
                for(i = 0; i < cbs.activate.length; ++i)cbs.activate[i]($0cd3b79ca22907b8$var$emptyNode, innerNode);
                insertedVnodeQueue.push(innerNode);
                break;
            }
        }
        // unlike a newly created component,
        // a reactivated keep-alive component doesn't insert itself
        insert(parentElm, vnode.elm, refElm);
    }
    function insert(parent, elm, ref) {
        if ($0cd3b79ca22907b8$var$isDef(parent)) {
            if ($0cd3b79ca22907b8$var$isDef(ref)) {
                if (nodeOps.parentNode(ref) === parent) nodeOps.insertBefore(parent, elm, ref);
            } else nodeOps.appendChild(parent, elm);
        }
    }
    function createChildren(vnode, children, insertedVnodeQueue) {
        if ($0cd3b79ca22907b8$var$isArray(children)) for(var i_1 = 0; i_1 < children.length; ++i_1)createElm(children[i_1], insertedVnodeQueue, vnode.elm, null, true, children, i_1);
        else if ($0cd3b79ca22907b8$var$isPrimitive(vnode.text)) nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
    function isPatchable(vnode) {
        while(vnode.componentInstance)vnode = vnode.componentInstance._vnode;
        return $0cd3b79ca22907b8$var$isDef(vnode.tag);
    }
    function invokeCreateHooks(vnode, insertedVnodeQueue) {
        for(var i_2 = 0; i_2 < cbs.create.length; ++i_2)cbs.create[i_2]($0cd3b79ca22907b8$var$emptyNode, vnode);
        i = vnode.data.hook; // Reuse variable
        if ($0cd3b79ca22907b8$var$isDef(i)) {
            if ($0cd3b79ca22907b8$var$isDef(i.create)) i.create($0cd3b79ca22907b8$var$emptyNode, vnode);
            if ($0cd3b79ca22907b8$var$isDef(i.insert)) insertedVnodeQueue.push(vnode);
        }
    }
    // set scope id attribute for scoped CSS.
    // this is implemented as a special case to avoid the overhead
    // of going through the normal attribute patching process.
    function setScope(vnode) {
        var i;
        if ($0cd3b79ca22907b8$var$isDef(i = vnode.fnScopeId)) nodeOps.setStyleScope(vnode.elm, i);
        else {
            var ancestor = vnode;
            while(ancestor){
                if ($0cd3b79ca22907b8$var$isDef(i = ancestor.context) && $0cd3b79ca22907b8$var$isDef(i = i.$options._scopeId)) nodeOps.setStyleScope(vnode.elm, i);
                ancestor = ancestor.parent;
            }
        }
        // for slot content they should also get the scopeId from the host instance.
        if ($0cd3b79ca22907b8$var$isDef(i = $0cd3b79ca22907b8$var$activeInstance) && i !== vnode.context && i !== vnode.fnContext && $0cd3b79ca22907b8$var$isDef(i = i.$options._scopeId)) nodeOps.setStyleScope(vnode.elm, i);
    }
    function addVnodes(parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
        for(; startIdx <= endIdx; ++startIdx)createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
    function invokeDestroyHook(vnode) {
        var i, j;
        var data = vnode.data;
        if ($0cd3b79ca22907b8$var$isDef(data)) {
            if ($0cd3b79ca22907b8$var$isDef(i = data.hook) && $0cd3b79ca22907b8$var$isDef(i = i.destroy)) i(vnode);
            for(i = 0; i < cbs.destroy.length; ++i)cbs.destroy[i](vnode);
        }
        if ($0cd3b79ca22907b8$var$isDef(i = vnode.children)) for(j = 0; j < vnode.children.length; ++j)invokeDestroyHook(vnode.children[j]);
    }
    function removeVnodes(vnodes, startIdx, endIdx) {
        for(; startIdx <= endIdx; ++startIdx){
            var ch = vnodes[startIdx];
            if ($0cd3b79ca22907b8$var$isDef(ch)) {
                if ($0cd3b79ca22907b8$var$isDef(ch.tag)) {
                    removeAndInvokeRemoveHook(ch);
                    invokeDestroyHook(ch);
                } else // Text node
                removeNode(ch.elm);
            }
        }
    }
    function removeAndInvokeRemoveHook(vnode, rm) {
        if ($0cd3b79ca22907b8$var$isDef(rm) || $0cd3b79ca22907b8$var$isDef(vnode.data)) {
            var i_3;
            var listeners = cbs.remove.length + 1;
            if ($0cd3b79ca22907b8$var$isDef(rm)) // we have a recursively passed down rm callback
            // increase the listeners count
            rm.listeners += listeners;
            else // directly removing
            rm = createRmCb(vnode.elm, listeners);
            // recursively invoke hooks on child component root node
            if ($0cd3b79ca22907b8$var$isDef(i_3 = vnode.componentInstance) && $0cd3b79ca22907b8$var$isDef(i_3 = i_3._vnode) && $0cd3b79ca22907b8$var$isDef(i_3.data)) removeAndInvokeRemoveHook(i_3, rm);
            for(i_3 = 0; i_3 < cbs.remove.length; ++i_3)cbs.remove[i_3](vnode, rm);
            if ($0cd3b79ca22907b8$var$isDef(i_3 = vnode.data.hook) && $0cd3b79ca22907b8$var$isDef(i_3 = i_3.remove)) i_3(vnode, rm);
            else rm();
        } else removeNode(vnode.elm);
    }
    function updateChildren(parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
        var oldStartIdx = 0;
        var newStartIdx = 0;
        var oldEndIdx = oldCh.length - 1;
        var oldStartVnode = oldCh[0];
        var oldEndVnode = oldCh[oldEndIdx];
        var newEndIdx = newCh.length - 1;
        var newStartVnode = newCh[0];
        var newEndVnode = newCh[newEndIdx];
        var oldKeyToIdx, idxInOld, vnodeToMove, refElm;
        // removeOnly is a special flag used only by <transition-group>
        // to ensure removed elements stay in correct relative positions
        // during leaving transitions
        var canMove = !removeOnly;
        while(oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx){
            if ($0cd3b79ca22907b8$var$isUndef(oldStartVnode)) oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
            else if ($0cd3b79ca22907b8$var$isUndef(oldEndVnode)) oldEndVnode = oldCh[--oldEndIdx];
            else if ($0cd3b79ca22907b8$var$sameVnode(oldStartVnode, newStartVnode)) {
                patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                oldStartVnode = oldCh[++oldStartIdx];
                newStartVnode = newCh[++newStartIdx];
            } else if ($0cd3b79ca22907b8$var$sameVnode(oldEndVnode, newEndVnode)) {
                patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
                oldEndVnode = oldCh[--oldEndIdx];
                newEndVnode = newCh[--newEndIdx];
            } else if ($0cd3b79ca22907b8$var$sameVnode(oldStartVnode, newEndVnode)) {
                // Vnode moved right
                patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
                canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
                oldStartVnode = oldCh[++oldStartIdx];
                newEndVnode = newCh[--newEndIdx];
            } else if ($0cd3b79ca22907b8$var$sameVnode(oldEndVnode, newStartVnode)) {
                // Vnode moved left
                patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
                oldEndVnode = oldCh[--oldEndIdx];
                newStartVnode = newCh[++newStartIdx];
            } else {
                if ($0cd3b79ca22907b8$var$isUndef(oldKeyToIdx)) oldKeyToIdx = $0cd3b79ca22907b8$var$createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx);
                idxInOld = $0cd3b79ca22907b8$var$isDef(newStartVnode.key) ? oldKeyToIdx[newStartVnode.key] : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
                if ($0cd3b79ca22907b8$var$isUndef(idxInOld)) // New element
                createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                else {
                    vnodeToMove = oldCh[idxInOld];
                    if ($0cd3b79ca22907b8$var$sameVnode(vnodeToMove, newStartVnode)) {
                        patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
                        oldCh[idxInOld] = undefined;
                        canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
                    } else // same key but different element. treat as new element
                    createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
                }
                newStartVnode = newCh[++newStartIdx];
            }
        }
        if (oldStartIdx > oldEndIdx) {
            refElm = $0cd3b79ca22907b8$var$isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
            addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
        } else if (newStartIdx > newEndIdx) removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
    function checkDuplicateKeys(children) {
        var seenKeys = {};
        for(var i_4 = 0; i_4 < children.length; i_4++){
            var vnode = children[i_4];
            var key = vnode.key;
            if ($0cd3b79ca22907b8$var$isDef(key)) {
                if (seenKeys[key]) $0cd3b79ca22907b8$var$warn("Duplicate keys detected: '".concat(key, "'. This may cause an update error."), vnode.context);
                else seenKeys[key] = true;
            }
        }
    }
    function findIdxInOld(node, oldCh, start, end) {
        for(var i_5 = start; i_5 < end; i_5++){
            var c = oldCh[i_5];
            if ($0cd3b79ca22907b8$var$isDef(c) && $0cd3b79ca22907b8$var$sameVnode(node, c)) return i_5;
        }
    }
    function patchVnode(oldVnode, vnode, insertedVnodeQueue, ownerArray, index, removeOnly) {
        if (oldVnode === vnode) return;
        if ($0cd3b79ca22907b8$var$isDef(vnode.elm) && $0cd3b79ca22907b8$var$isDef(ownerArray)) // clone reused vnode
        vnode = ownerArray[index] = $0cd3b79ca22907b8$var$cloneVNode(vnode);
        var elm = vnode.elm = oldVnode.elm;
        if ($0cd3b79ca22907b8$var$isTrue(oldVnode.isAsyncPlaceholder)) {
            if ($0cd3b79ca22907b8$var$isDef(vnode.asyncFactory.resolved)) hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
            else vnode.isAsyncPlaceholder = true;
            return;
        }
        // reuse element for static trees.
        // note we only do this if the vnode is cloned -
        // if the new node is not cloned it means the render functions have been
        // reset by the hot-reload-api and we need to do a proper re-render.
        if ($0cd3b79ca22907b8$var$isTrue(vnode.isStatic) && $0cd3b79ca22907b8$var$isTrue(oldVnode.isStatic) && vnode.key === oldVnode.key && ($0cd3b79ca22907b8$var$isTrue(vnode.isCloned) || $0cd3b79ca22907b8$var$isTrue(vnode.isOnce))) {
            vnode.componentInstance = oldVnode.componentInstance;
            return;
        }
        var i;
        var data = vnode.data;
        if ($0cd3b79ca22907b8$var$isDef(data) && $0cd3b79ca22907b8$var$isDef(i = data.hook) && $0cd3b79ca22907b8$var$isDef(i = i.prepatch)) i(oldVnode, vnode);
        var oldCh = oldVnode.children;
        var ch = vnode.children;
        if ($0cd3b79ca22907b8$var$isDef(data) && isPatchable(vnode)) {
            for(i = 0; i < cbs.update.length; ++i)cbs.update[i](oldVnode, vnode);
            if ($0cd3b79ca22907b8$var$isDef(i = data.hook) && $0cd3b79ca22907b8$var$isDef(i = i.update)) i(oldVnode, vnode);
        }
        if ($0cd3b79ca22907b8$var$isUndef(vnode.text)) {
            if ($0cd3b79ca22907b8$var$isDef(oldCh) && $0cd3b79ca22907b8$var$isDef(ch)) {
                if (oldCh !== ch) updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly);
            } else if ($0cd3b79ca22907b8$var$isDef(ch)) {
                if ($0cd3b79ca22907b8$var$isDef(oldVnode.text)) nodeOps.setTextContent(elm, "");
                addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
            } else if ($0cd3b79ca22907b8$var$isDef(oldCh)) removeVnodes(oldCh, 0, oldCh.length - 1);
            else if ($0cd3b79ca22907b8$var$isDef(oldVnode.text)) nodeOps.setTextContent(elm, "");
        } else if (oldVnode.text !== vnode.text) nodeOps.setTextContent(elm, vnode.text);
        if ($0cd3b79ca22907b8$var$isDef(data)) {
            if ($0cd3b79ca22907b8$var$isDef(i = data.hook) && $0cd3b79ca22907b8$var$isDef(i = i.postpatch)) i(oldVnode, vnode);
        }
    }
    function invokeInsertHook(vnode, queue, initial) {
        // delay insert hooks for component root nodes, invoke them after the
        // element is really inserted
        if ($0cd3b79ca22907b8$var$isTrue(initial) && $0cd3b79ca22907b8$var$isDef(vnode.parent)) vnode.parent.data.pendingInsert = queue;
        else for(var i_6 = 0; i_6 < queue.length; ++i_6)queue[i_6].data.hook.insert(queue[i_6]);
    }
    var hydrationBailed = false;
    // list of modules that can skip create hook during hydration because they
    // are already rendered on the client or has no need for initialization
    // Note: style is excluded because it relies on initial clone for future
    // deep updates (#7063).
    var isRenderedModule = $0cd3b79ca22907b8$var$makeMap("attrs,class,staticClass,staticStyle,key");
    // Note: this is a browser-only function so we can assume elms are DOM nodes.
    function hydrate(elm, vnode, insertedVnodeQueue, inVPre) {
        var i;
        var tag = vnode.tag, data = vnode.data, children = vnode.children;
        inVPre = inVPre || data && data.pre;
        vnode.elm = elm;
        if ($0cd3b79ca22907b8$var$isTrue(vnode.isComment) && $0cd3b79ca22907b8$var$isDef(vnode.asyncFactory)) {
            vnode.isAsyncPlaceholder = true;
            return true;
        }
        if ($0cd3b79ca22907b8$var$isDef(data)) {
            if ($0cd3b79ca22907b8$var$isDef(i = data.hook) && $0cd3b79ca22907b8$var$isDef(i = i.init)) i(vnode, true);
            if ($0cd3b79ca22907b8$var$isDef(i = vnode.componentInstance)) {
                // child component. it should have hydrated its own tree.
                initComponent(vnode, insertedVnodeQueue);
                return true;
            }
        }
        if ($0cd3b79ca22907b8$var$isDef(tag)) {
            if ($0cd3b79ca22907b8$var$isDef(children)) {
                // empty element, allow client to pick up and populate children
                if (!elm.hasChildNodes()) createChildren(vnode, children, insertedVnodeQueue);
                else // v-html and domProps: innerHTML
                if ($0cd3b79ca22907b8$var$isDef(i = data) && $0cd3b79ca22907b8$var$isDef(i = i.domProps) && $0cd3b79ca22907b8$var$isDef(i = i.innerHTML)) {
                    if (i !== elm.innerHTML) return false;
                } else {
                    // iterate and compare children lists
                    var childrenMatch = true;
                    var childNode = elm.firstChild;
                    for(var i_7 = 0; i_7 < children.length; i_7++){
                        if (!childNode || !hydrate(childNode, children[i_7], insertedVnodeQueue, inVPre)) {
                            childrenMatch = false;
                            break;
                        }
                        childNode = childNode.nextSibling;
                    }
                    // if childNode is not null, it means the actual childNodes list is
                    // longer than the virtual children list.
                    if (!childrenMatch || childNode) return false;
                }
            }
            if ($0cd3b79ca22907b8$var$isDef(data)) {
                var fullInvoke = false;
                for(var key in data)if (!isRenderedModule(key)) {
                    fullInvoke = true;
                    invokeCreateHooks(vnode, insertedVnodeQueue);
                    break;
                }
                if (!fullInvoke && data["class"]) // ensure collecting deps for deep class bindings for future updates
                $0cd3b79ca22907b8$var$traverse(data["class"]);
            }
        } else if (elm.data !== vnode.text) elm.data = vnode.text;
        return true;
    }
    function assertNodeMatch(node, vnode, inVPre) {
        if ($0cd3b79ca22907b8$var$isDef(vnode.tag)) return vnode.tag.indexOf("vue-component") === 0 || !isUnknownElement(vnode, inVPre) && vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase());
        else return node.nodeType === (vnode.isComment ? 8 : 3);
    }
    return function patch(oldVnode, vnode, hydrating, removeOnly) {
        if ($0cd3b79ca22907b8$var$isUndef(vnode)) {
            if ($0cd3b79ca22907b8$var$isDef(oldVnode)) invokeDestroyHook(oldVnode);
            return;
        }
        var isInitialPatch = false;
        var insertedVnodeQueue = [];
        if ($0cd3b79ca22907b8$var$isUndef(oldVnode)) {
            // empty mount (likely as component), create new root element
            isInitialPatch = true;
            createElm(vnode, insertedVnodeQueue);
        } else {
            var isRealElement = $0cd3b79ca22907b8$var$isDef(oldVnode.nodeType);
            if (!isRealElement && $0cd3b79ca22907b8$var$sameVnode(oldVnode, vnode)) // patch existing root node
            patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
            else {
                if (isRealElement) {
                    // mounting to a real element
                    // check if this is server-rendered content and if we can perform
                    // a successful hydration.
                    if (oldVnode.nodeType === 1 && oldVnode.hasAttribute($0cd3b79ca22907b8$var$SSR_ATTR)) {
                        oldVnode.removeAttribute($0cd3b79ca22907b8$var$SSR_ATTR);
                        hydrating = true;
                    }
                    if ($0cd3b79ca22907b8$var$isTrue(hydrating)) {
                        if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
                            invokeInsertHook(vnode, insertedVnodeQueue, true);
                            return oldVnode;
                        }
                    }
                    // either not server-rendered, or hydration failed.
                    // create an empty node and replace it
                    oldVnode = emptyNodeAt(oldVnode);
                }
                // replacing existing element
                var oldElm = oldVnode.elm;
                var parentElm = nodeOps.parentNode(oldElm);
                // create new node
                createElm(vnode, insertedVnodeQueue, // extremely rare edge case: do not insert if old element is in a
                // leaving transition. Only happens when combining transition +
                // keep-alive + HOCs. (#4590)
                oldElm._leaveCb ? null : parentElm, nodeOps.nextSibling(oldElm));
                // update parent placeholder node element, recursively
                if ($0cd3b79ca22907b8$var$isDef(vnode.parent)) {
                    var ancestor = vnode.parent;
                    var patchable = isPatchable(vnode);
                    while(ancestor){
                        for(var i_8 = 0; i_8 < cbs.destroy.length; ++i_8)cbs.destroy[i_8](ancestor);
                        ancestor.elm = vnode.elm;
                        if (patchable) {
                            for(var i_9 = 0; i_9 < cbs.create.length; ++i_9)cbs.create[i_9]($0cd3b79ca22907b8$var$emptyNode, ancestor);
                            // #6513
                            // invoke insert hooks that may have been merged by create hooks.
                            // e.g. for directives that uses the "inserted" hook.
                            var insert_1 = ancestor.data.hook.insert;
                            if (insert_1.merged) // start at index 1 to avoid re-invoking component mounted hook
                            for(var i_10 = 1; i_10 < insert_1.fns.length; i_10++)insert_1.fns[i_10]();
                        } else $0cd3b79ca22907b8$var$registerRef(ancestor);
                        ancestor = ancestor.parent;
                    }
                }
                // destroy old node
                if ($0cd3b79ca22907b8$var$isDef(parentElm)) removeVnodes([
                    oldVnode
                ], 0, 0);
                else if ($0cd3b79ca22907b8$var$isDef(oldVnode.tag)) invokeDestroyHook(oldVnode);
            }
        }
        invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
        return vnode.elm;
    };
}
var $0cd3b79ca22907b8$var$directives = {
    create: $0cd3b79ca22907b8$var$updateDirectives,
    update: $0cd3b79ca22907b8$var$updateDirectives,
    destroy: function unbindDirectives(vnode) {
        // @ts-expect-error emptyNode is not VNodeWithData
        $0cd3b79ca22907b8$var$updateDirectives(vnode, $0cd3b79ca22907b8$var$emptyNode);
    }
};
function $0cd3b79ca22907b8$var$updateDirectives(oldVnode, vnode) {
    if (oldVnode.data.directives || vnode.data.directives) $0cd3b79ca22907b8$var$_update(oldVnode, vnode);
}
function $0cd3b79ca22907b8$var$_update(oldVnode, vnode) {
    var isCreate = oldVnode === $0cd3b79ca22907b8$var$emptyNode;
    var isDestroy = vnode === $0cd3b79ca22907b8$var$emptyNode;
    var oldDirs = $0cd3b79ca22907b8$var$normalizeDirectives(oldVnode.data.directives, oldVnode.context);
    var newDirs = $0cd3b79ca22907b8$var$normalizeDirectives(vnode.data.directives, vnode.context);
    var dirsWithInsert = [];
    var dirsWithPostpatch = [];
    var key, oldDir, dir;
    for(key in newDirs){
        oldDir = oldDirs[key];
        dir = newDirs[key];
        if (!oldDir) {
            // new directive, bind
            $0cd3b79ca22907b8$var$callHook(dir, "bind", vnode, oldVnode);
            if (dir.def && dir.def.inserted) dirsWithInsert.push(dir);
        } else {
            // existing directive, update
            dir.oldValue = oldDir.value;
            dir.oldArg = oldDir.arg;
            $0cd3b79ca22907b8$var$callHook(dir, "update", vnode, oldVnode);
            if (dir.def && dir.def.componentUpdated) dirsWithPostpatch.push(dir);
        }
    }
    if (dirsWithInsert.length) {
        var callInsert = function() {
            for(var i = 0; i < dirsWithInsert.length; i++)$0cd3b79ca22907b8$var$callHook(dirsWithInsert[i], "inserted", vnode, oldVnode);
        };
        if (isCreate) $0cd3b79ca22907b8$var$mergeVNodeHook(vnode, "insert", callInsert);
        else callInsert();
    }
    if (dirsWithPostpatch.length) $0cd3b79ca22907b8$var$mergeVNodeHook(vnode, "postpatch", function() {
        for(var i = 0; i < dirsWithPostpatch.length; i++)$0cd3b79ca22907b8$var$callHook(dirsWithPostpatch[i], "componentUpdated", vnode, oldVnode);
    });
    if (!isCreate) {
        for(key in oldDirs)if (!newDirs[key]) // no longer present, unbind
        $0cd3b79ca22907b8$var$callHook(oldDirs[key], "unbind", oldVnode, oldVnode, isDestroy);
    }
}
var $0cd3b79ca22907b8$var$emptyModifiers = Object.create(null);
function $0cd3b79ca22907b8$var$normalizeDirectives(dirs, vm) {
    var res = Object.create(null);
    if (!dirs) // $flow-disable-line
    return res;
    var i, dir;
    for(i = 0; i < dirs.length; i++){
        dir = dirs[i];
        if (!dir.modifiers) // $flow-disable-line
        dir.modifiers = $0cd3b79ca22907b8$var$emptyModifiers;
        res[$0cd3b79ca22907b8$var$getRawDirName(dir)] = dir;
        if (vm._setupState && vm._setupState.__sfc) {
            var setupDef = dir.def || $0cd3b79ca22907b8$var$resolveAsset(vm, "_setupState", "v-" + dir.name);
            if (typeof setupDef === "function") dir.def = {
                bind: setupDef,
                update: setupDef
            };
            else dir.def = setupDef;
        }
        dir.def = dir.def || $0cd3b79ca22907b8$var$resolveAsset(vm.$options, "directives", dir.name, true);
    }
    // $flow-disable-line
    return res;
}
function $0cd3b79ca22907b8$var$getRawDirName(dir) {
    return dir.rawName || "".concat(dir.name, ".").concat(Object.keys(dir.modifiers || {}).join("."));
}
function $0cd3b79ca22907b8$var$callHook(dir, hook, vnode, oldVnode, isDestroy) {
    var fn = dir.def && dir.def[hook];
    if (fn) try {
        fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
        $0cd3b79ca22907b8$var$handleError(e, vnode.context, "directive ".concat(dir.name, " ").concat(hook, " hook"));
    }
}
var $0cd3b79ca22907b8$var$baseModules = [
    $0cd3b79ca22907b8$var$ref,
    $0cd3b79ca22907b8$var$directives
];
function $0cd3b79ca22907b8$var$updateAttrs(oldVnode, vnode) {
    var opts = vnode.componentOptions;
    if ($0cd3b79ca22907b8$var$isDef(opts) && opts.Ctor.options.inheritAttrs === false) return;
    if ($0cd3b79ca22907b8$var$isUndef(oldVnode.data.attrs) && $0cd3b79ca22907b8$var$isUndef(vnode.data.attrs)) return;
    var key, cur, old;
    var elm = vnode.elm;
    var oldAttrs = oldVnode.data.attrs || {};
    var attrs = vnode.data.attrs || {};
    // clone observed objects, as the user probably wants to mutate it
    if ($0cd3b79ca22907b8$var$isDef(attrs.__ob__) || $0cd3b79ca22907b8$var$isTrue(attrs._v_attr_proxy)) attrs = vnode.data.attrs = $0cd3b79ca22907b8$var$extend({}, attrs);
    for(key in attrs){
        cur = attrs[key];
        old = oldAttrs[key];
        if (old !== cur) $0cd3b79ca22907b8$var$setAttr(elm, key, cur, vnode.data.pre);
    }
    // #4391: in IE9, setting type can reset value for input[type=radio]
    // #6666: IE/Edge forces progress value down to 1 before setting a max
    /* istanbul ignore if */ if (($0cd3b79ca22907b8$var$isIE || $0cd3b79ca22907b8$var$isEdge) && attrs.value !== oldAttrs.value) $0cd3b79ca22907b8$var$setAttr(elm, "value", attrs.value);
    for(key in oldAttrs)if ($0cd3b79ca22907b8$var$isUndef(attrs[key])) {
        if ($0cd3b79ca22907b8$var$isXlink(key)) elm.removeAttributeNS($0cd3b79ca22907b8$var$xlinkNS, $0cd3b79ca22907b8$var$getXlinkProp(key));
        else if (!$0cd3b79ca22907b8$var$isEnumeratedAttr(key)) elm.removeAttribute(key);
    }
}
function $0cd3b79ca22907b8$var$setAttr(el, key, value, isInPre) {
    if (isInPre || el.tagName.indexOf("-") > -1) $0cd3b79ca22907b8$var$baseSetAttr(el, key, value);
    else if ($0cd3b79ca22907b8$var$isBooleanAttr(key)) {
        // set attribute for blank value
        // e.g. <option disabled>Select one</option>
        if ($0cd3b79ca22907b8$var$isFalsyAttrValue(value)) el.removeAttribute(key);
        else {
            // technically allowfullscreen is a boolean attribute for <iframe>,
            // but Flash expects a value of "true" when used on <embed> tag
            value = key === "allowfullscreen" && el.tagName === "EMBED" ? "true" : key;
            el.setAttribute(key, value);
        }
    } else if ($0cd3b79ca22907b8$var$isEnumeratedAttr(key)) el.setAttribute(key, $0cd3b79ca22907b8$var$convertEnumeratedValue(key, value));
    else if ($0cd3b79ca22907b8$var$isXlink(key)) {
        if ($0cd3b79ca22907b8$var$isFalsyAttrValue(value)) el.removeAttributeNS($0cd3b79ca22907b8$var$xlinkNS, $0cd3b79ca22907b8$var$getXlinkProp(key));
        else el.setAttributeNS($0cd3b79ca22907b8$var$xlinkNS, key, value);
    } else $0cd3b79ca22907b8$var$baseSetAttr(el, key, value);
}
function $0cd3b79ca22907b8$var$baseSetAttr(el, key, value) {
    if ($0cd3b79ca22907b8$var$isFalsyAttrValue(value)) el.removeAttribute(key);
    else {
        // #7138: IE10 & 11 fires input event when setting placeholder on
        // <textarea>... block the first input event and remove the blocker
        // immediately.
        /* istanbul ignore if */ if ($0cd3b79ca22907b8$var$isIE && !$0cd3b79ca22907b8$var$isIE9 && el.tagName === "TEXTAREA" && key === "placeholder" && value !== "" && !el.__ieph) {
            var blocker_1 = function(e) {
                e.stopImmediatePropagation();
                el.removeEventListener("input", blocker_1);
            };
            el.addEventListener("input", blocker_1);
            // $flow-disable-line
            el.__ieph = true; /* IE placeholder patched */ 
        }
        el.setAttribute(key, value);
    }
}
var $0cd3b79ca22907b8$var$attrs = {
    create: $0cd3b79ca22907b8$var$updateAttrs,
    update: $0cd3b79ca22907b8$var$updateAttrs
};
function $0cd3b79ca22907b8$var$updateClass(oldVnode, vnode) {
    var el = vnode.elm;
    var data = vnode.data;
    var oldData = oldVnode.data;
    if ($0cd3b79ca22907b8$var$isUndef(data.staticClass) && $0cd3b79ca22907b8$var$isUndef(data.class) && ($0cd3b79ca22907b8$var$isUndef(oldData) || $0cd3b79ca22907b8$var$isUndef(oldData.staticClass) && $0cd3b79ca22907b8$var$isUndef(oldData.class))) return;
    var cls = $0cd3b79ca22907b8$var$genClassForVnode(vnode);
    // handle transition classes
    var transitionClass = el._transitionClasses;
    if ($0cd3b79ca22907b8$var$isDef(transitionClass)) cls = $0cd3b79ca22907b8$var$concat(cls, $0cd3b79ca22907b8$var$stringifyClass(transitionClass));
    // set the class
    if (cls !== el._prevClass) {
        el.setAttribute("class", cls);
        el._prevClass = cls;
    }
}
var $0cd3b79ca22907b8$var$klass = {
    create: $0cd3b79ca22907b8$var$updateClass,
    update: $0cd3b79ca22907b8$var$updateClass
};
// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var $0cd3b79ca22907b8$var$RANGE_TOKEN = "__r";
var $0cd3b79ca22907b8$var$CHECKBOX_RADIO_TOKEN = "__c";
// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function $0cd3b79ca22907b8$var$normalizeEvents(on) {
    /* istanbul ignore if */ if ($0cd3b79ca22907b8$var$isDef(on[$0cd3b79ca22907b8$var$RANGE_TOKEN])) {
        // IE input[type=range] only supports `change` event
        var event_1 = $0cd3b79ca22907b8$var$isIE ? "change" : "input";
        on[event_1] = [].concat(on[$0cd3b79ca22907b8$var$RANGE_TOKEN], on[event_1] || []);
        delete on[$0cd3b79ca22907b8$var$RANGE_TOKEN];
    }
    // This was originally intended to fix #4521 but no longer necessary
    // after 2.5. Keeping it for backwards compat with generated code from < 2.4
    /* istanbul ignore if */ if ($0cd3b79ca22907b8$var$isDef(on[$0cd3b79ca22907b8$var$CHECKBOX_RADIO_TOKEN])) {
        on.change = [].concat(on[$0cd3b79ca22907b8$var$CHECKBOX_RADIO_TOKEN], on.change || []);
        delete on[$0cd3b79ca22907b8$var$CHECKBOX_RADIO_TOKEN];
    }
}
var $0cd3b79ca22907b8$var$target;
function $0cd3b79ca22907b8$var$createOnceHandler(event, handler, capture) {
    var _target = $0cd3b79ca22907b8$var$target; // save current target element in closure
    return function onceHandler() {
        var res = handler.apply(null, arguments);
        if (res !== null) $0cd3b79ca22907b8$var$remove(event, onceHandler, capture, _target);
    };
}
// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var $0cd3b79ca22907b8$var$useMicrotaskFix = $0cd3b79ca22907b8$var$isUsingMicroTask && !($0cd3b79ca22907b8$var$isFF && Number($0cd3b79ca22907b8$var$isFF[1]) <= 53);
function $0cd3b79ca22907b8$var$add(name, handler, capture, passive) {
    // async edge case #6566: inner click event triggers patch, event handler
    // attached to outer element during patch, and triggered again. This
    // happens because browsers fire microtask ticks between event propagation.
    // the solution is simple: we save the timestamp when a handler is attached,
    // and the handler would only fire if the event passed to it was fired
    // AFTER it was attached.
    if ($0cd3b79ca22907b8$var$useMicrotaskFix) {
        var attachedTimestamp_1 = $0cd3b79ca22907b8$var$currentFlushTimestamp;
        var original_1 = handler;
        //@ts-expect-error
        handler = original_1._wrapper = function(e) {
            if (// no bubbling, should always fire.
            // this is just a safety net in case event.timeStamp is unreliable in
            // certain weird environments...
            e.target === e.currentTarget || // event is fired after handler attachment
            e.timeStamp >= attachedTimestamp_1 || // bail for environments that have buggy event.timeStamp implementations
            // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
            // #9681 QtWebEngine event.timeStamp is negative value
            e.timeStamp <= 0 || // #9448 bail if event is fired in another document in a multi-page
            // electron/nw.js app, since event.timeStamp will be using a different
            // starting reference
            e.target.ownerDocument !== document) return original_1.apply(this, arguments);
        };
    }
    $0cd3b79ca22907b8$var$target.addEventListener(name, handler, $0cd3b79ca22907b8$var$supportsPassive ? {
        capture: capture,
        passive: passive
    } : capture);
}
function $0cd3b79ca22907b8$var$remove(name, handler, capture, _target) {
    (_target || $0cd3b79ca22907b8$var$target).removeEventListener(name, //@ts-expect-error
    handler._wrapper || handler, capture);
}
function $0cd3b79ca22907b8$var$updateDOMListeners(oldVnode, vnode) {
    if ($0cd3b79ca22907b8$var$isUndef(oldVnode.data.on) && $0cd3b79ca22907b8$var$isUndef(vnode.data.on)) return;
    var on = vnode.data.on || {};
    var oldOn = oldVnode.data.on || {};
    // vnode is empty when removing all listeners,
    // and use old vnode dom element
    $0cd3b79ca22907b8$var$target = vnode.elm || oldVnode.elm;
    $0cd3b79ca22907b8$var$normalizeEvents(on);
    $0cd3b79ca22907b8$var$updateListeners(on, oldOn, $0cd3b79ca22907b8$var$add, $0cd3b79ca22907b8$var$remove, $0cd3b79ca22907b8$var$createOnceHandler, vnode.context);
    $0cd3b79ca22907b8$var$target = undefined;
}
var $0cd3b79ca22907b8$var$events = {
    create: $0cd3b79ca22907b8$var$updateDOMListeners,
    update: $0cd3b79ca22907b8$var$updateDOMListeners,
    // @ts-expect-error emptyNode has actually data
    destroy: function(vnode) {
        return $0cd3b79ca22907b8$var$updateDOMListeners(vnode, $0cd3b79ca22907b8$var$emptyNode);
    }
};
var $0cd3b79ca22907b8$var$svgContainer;
function $0cd3b79ca22907b8$var$updateDOMProps(oldVnode, vnode) {
    if ($0cd3b79ca22907b8$var$isUndef(oldVnode.data.domProps) && $0cd3b79ca22907b8$var$isUndef(vnode.data.domProps)) return;
    var key, cur;
    var elm = vnode.elm;
    var oldProps = oldVnode.data.domProps || {};
    var props = vnode.data.domProps || {};
    // clone observed objects, as the user probably wants to mutate it
    if ($0cd3b79ca22907b8$var$isDef(props.__ob__) || $0cd3b79ca22907b8$var$isTrue(props._v_attr_proxy)) props = vnode.data.domProps = $0cd3b79ca22907b8$var$extend({}, props);
    for(key in oldProps)if (!(key in props)) elm[key] = "";
    for(key in props){
        cur = props[key];
        // ignore children if the node has textContent or innerHTML,
        // as these will throw away existing DOM nodes and cause removal errors
        // on subsequent patches (#3360)
        if (key === "textContent" || key === "innerHTML") {
            if (vnode.children) vnode.children.length = 0;
            if (cur === oldProps[key]) continue;
            // #6601 work around Chrome version <= 55 bug where single textNode
            // replaced by innerHTML/textContent retains its parentNode property
            if (elm.childNodes.length === 1) elm.removeChild(elm.childNodes[0]);
        }
        if (key === "value" && elm.tagName !== "PROGRESS") {
            // store value as _value as well since
            // non-string values will be stringified
            elm._value = cur;
            // avoid resetting cursor position when value is the same
            var strCur = $0cd3b79ca22907b8$var$isUndef(cur) ? "" : String(cur);
            if ($0cd3b79ca22907b8$var$shouldUpdateValue(elm, strCur)) elm.value = strCur;
        } else if (key === "innerHTML" && $0cd3b79ca22907b8$var$isSVG(elm.tagName) && $0cd3b79ca22907b8$var$isUndef(elm.innerHTML)) {
            // IE doesn't support innerHTML for SVG elements
            $0cd3b79ca22907b8$var$svgContainer = $0cd3b79ca22907b8$var$svgContainer || document.createElement("div");
            $0cd3b79ca22907b8$var$svgContainer.innerHTML = "<svg>".concat(cur, "</svg>");
            var svg = $0cd3b79ca22907b8$var$svgContainer.firstChild;
            while(elm.firstChild)elm.removeChild(elm.firstChild);
            while(svg.firstChild)elm.appendChild(svg.firstChild);
        } else if (// skip the update if old and new VDOM state is the same.
        // `value` is handled separately because the DOM value may be temporarily
        // out of sync with VDOM state due to focus, composition and modifiers.
        // This  #4521 by skipping the unnecessary `checked` update.
        cur !== oldProps[key]) // some property updates can throw
        // e.g. `value` on <progress> w/ non-finite value
        try {
            elm[key] = cur;
        } catch (e) {}
    }
}
function $0cd3b79ca22907b8$var$shouldUpdateValue(elm, checkVal) {
    return(//@ts-expect-error
    !elm.composing && (elm.tagName === "OPTION" || $0cd3b79ca22907b8$var$isNotInFocusAndDirty(elm, checkVal) || $0cd3b79ca22907b8$var$isDirtyWithModifiers(elm, checkVal)));
}
function $0cd3b79ca22907b8$var$isNotInFocusAndDirty(elm, checkVal) {
    // return true when textbox (.number and .trim) loses focus and its value is
    // not equal to the updated value
    var notInFocus = true;
    // #6157
    // work around IE bug when accessing document.activeElement in an iframe
    try {
        notInFocus = document.activeElement !== elm;
    } catch (e) {}
    return notInFocus && elm.value !== checkVal;
}
function $0cd3b79ca22907b8$var$isDirtyWithModifiers(elm, newVal1) {
    var value = elm.value;
    var modifiers = elm._vModifiers; // injected by v-model runtime
    if ($0cd3b79ca22907b8$var$isDef(modifiers)) {
        if (modifiers.number) return $0cd3b79ca22907b8$var$toNumber(value) !== $0cd3b79ca22907b8$var$toNumber(newVal1);
        if (modifiers.trim) return value.trim() !== newVal1.trim();
    }
    return value !== newVal1;
}
var $0cd3b79ca22907b8$var$domProps = {
    create: $0cd3b79ca22907b8$var$updateDOMProps,
    update: $0cd3b79ca22907b8$var$updateDOMProps
};
var $0cd3b79ca22907b8$var$parseStyleText = $0cd3b79ca22907b8$var$cached(function(cssText) {
    var res = {};
    var listDelimiter = /;(?![^(]*\))/g;
    var propertyDelimiter = /:(.+)/;
    cssText.split(listDelimiter).forEach(function(item) {
        if (item) {
            var tmp = item.split(propertyDelimiter);
            tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return res;
});
// merge static and dynamic style data on the same vnode
function $0cd3b79ca22907b8$var$normalizeStyleData(data) {
    var style = $0cd3b79ca22907b8$var$normalizeStyleBinding(data.style);
    // static style is pre-processed into an object during compilation
    // and is always a fresh object, so it's safe to merge into it
    return data.staticStyle ? $0cd3b79ca22907b8$var$extend(data.staticStyle, style) : style;
}
// normalize possible array / string values into Object
function $0cd3b79ca22907b8$var$normalizeStyleBinding(bindingStyle) {
    if (Array.isArray(bindingStyle)) return $0cd3b79ca22907b8$var$toObject(bindingStyle);
    if (typeof bindingStyle === "string") return $0cd3b79ca22907b8$var$parseStyleText(bindingStyle);
    return bindingStyle;
}
/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */ function $0cd3b79ca22907b8$var$getStyle(vnode, checkChild) {
    var res = {};
    var styleData;
    if (checkChild) {
        var childNode = vnode;
        while(childNode.componentInstance){
            childNode = childNode.componentInstance._vnode;
            if (childNode && childNode.data && (styleData = $0cd3b79ca22907b8$var$normalizeStyleData(childNode.data))) $0cd3b79ca22907b8$var$extend(res, styleData);
        }
    }
    if (styleData = $0cd3b79ca22907b8$var$normalizeStyleData(vnode.data)) $0cd3b79ca22907b8$var$extend(res, styleData);
    var parentNode = vnode;
    // @ts-expect-error parentNode.parent not VNodeWithData
    while(parentNode = parentNode.parent)if (parentNode.data && (styleData = $0cd3b79ca22907b8$var$normalizeStyleData(parentNode.data))) $0cd3b79ca22907b8$var$extend(res, styleData);
    return res;
}
var $0cd3b79ca22907b8$var$cssVarRE = /^--/;
var $0cd3b79ca22907b8$var$importantRE = /\s*!important$/;
var $0cd3b79ca22907b8$var$setProp = function(el, name, val) {
    /* istanbul ignore if */ if ($0cd3b79ca22907b8$var$cssVarRE.test(name)) el.style.setProperty(name, val);
    else if ($0cd3b79ca22907b8$var$importantRE.test(val)) el.style.setProperty($0cd3b79ca22907b8$var$hyphenate(name), val.replace($0cd3b79ca22907b8$var$importantRE, ""), "important");
    else {
        var normalizedName = $0cd3b79ca22907b8$var$normalize(name);
        if (Array.isArray(val)) // Support values array created by autoprefixer, e.g.
        // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
        // Set them one by one, and the browser will only set those it can recognize
        for(var i = 0, len = val.length; i < len; i++)el.style[normalizedName] = val[i];
        else el.style[normalizedName] = val;
    }
};
var $0cd3b79ca22907b8$var$vendorNames = [
    "Webkit",
    "Moz",
    "ms"
];
var $0cd3b79ca22907b8$var$emptyStyle;
var $0cd3b79ca22907b8$var$normalize = $0cd3b79ca22907b8$var$cached(function(prop) {
    $0cd3b79ca22907b8$var$emptyStyle = $0cd3b79ca22907b8$var$emptyStyle || document.createElement("div").style;
    prop = $0cd3b79ca22907b8$var$camelize(prop);
    if (prop !== "filter" && prop in $0cd3b79ca22907b8$var$emptyStyle) return prop;
    var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
    for(var i = 0; i < $0cd3b79ca22907b8$var$vendorNames.length; i++){
        var name_1 = $0cd3b79ca22907b8$var$vendorNames[i] + capName;
        if (name_1 in $0cd3b79ca22907b8$var$emptyStyle) return name_1;
    }
});
function $0cd3b79ca22907b8$var$updateStyle(oldVnode, vnode) {
    var data = vnode.data;
    var oldData = oldVnode.data;
    if ($0cd3b79ca22907b8$var$isUndef(data.staticStyle) && $0cd3b79ca22907b8$var$isUndef(data.style) && $0cd3b79ca22907b8$var$isUndef(oldData.staticStyle) && $0cd3b79ca22907b8$var$isUndef(oldData.style)) return;
    var cur, name;
    var el = vnode.elm;
    var oldStaticStyle = oldData.staticStyle;
    var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};
    // if static style exists, stylebinding already merged into it when doing normalizeStyleData
    var oldStyle = oldStaticStyle || oldStyleBinding;
    var style = $0cd3b79ca22907b8$var$normalizeStyleBinding(vnode.data.style) || {};
    // store normalized style under a different key for next diff
    // make sure to clone it if it's reactive, since the user likely wants
    // to mutate it.
    vnode.data.normalizedStyle = $0cd3b79ca22907b8$var$isDef(style.__ob__) ? $0cd3b79ca22907b8$var$extend({}, style) : style;
    var newStyle = $0cd3b79ca22907b8$var$getStyle(vnode, true);
    for(name in oldStyle)if ($0cd3b79ca22907b8$var$isUndef(newStyle[name])) $0cd3b79ca22907b8$var$setProp(el, name, "");
    for(name in newStyle){
        cur = newStyle[name];
        if (cur !== oldStyle[name]) // ie9 setting to null has no effect, must use empty string
        $0cd3b79ca22907b8$var$setProp(el, name, cur == null ? "" : cur);
    }
}
var $0cd3b79ca22907b8$var$style = {
    create: $0cd3b79ca22907b8$var$updateStyle,
    update: $0cd3b79ca22907b8$var$updateStyle
};
var $0cd3b79ca22907b8$var$whitespaceRE = /\s+/;
/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */ function $0cd3b79ca22907b8$var$addClass(el, cls) {
    /* istanbul ignore if */ if (!cls || !(cls = cls.trim())) return;
    /* istanbul ignore else */ if (el.classList) {
        if (cls.indexOf(" ") > -1) cls.split($0cd3b79ca22907b8$var$whitespaceRE).forEach(function(c) {
            return el.classList.add(c);
        });
        else el.classList.add(cls);
    } else {
        var cur = " ".concat(el.getAttribute("class") || "", " ");
        if (cur.indexOf(" " + cls + " ") < 0) el.setAttribute("class", (cur + cls).trim());
    }
}
/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */ function $0cd3b79ca22907b8$var$removeClass(el, cls) {
    /* istanbul ignore if */ if (!cls || !(cls = cls.trim())) return;
    /* istanbul ignore else */ if (el.classList) {
        if (cls.indexOf(" ") > -1) cls.split($0cd3b79ca22907b8$var$whitespaceRE).forEach(function(c) {
            return el.classList.remove(c);
        });
        else el.classList.remove(cls);
        if (!el.classList.length) el.removeAttribute("class");
    } else {
        var cur = " ".concat(el.getAttribute("class") || "", " ");
        var tar = " " + cls + " ";
        while(cur.indexOf(tar) >= 0)cur = cur.replace(tar, " ");
        cur = cur.trim();
        if (cur) el.setAttribute("class", cur);
        else el.removeAttribute("class");
    }
}
function $0cd3b79ca22907b8$var$resolveTransition(def) {
    if (!def) return;
    /* istanbul ignore else */ if (typeof def === "object") {
        var res = {};
        if (def.css !== false) $0cd3b79ca22907b8$var$extend(res, $0cd3b79ca22907b8$var$autoCssTransition(def.name || "v"));
        $0cd3b79ca22907b8$var$extend(res, def);
        return res;
    } else if (typeof def === "string") return $0cd3b79ca22907b8$var$autoCssTransition(def);
}
var $0cd3b79ca22907b8$var$autoCssTransition = $0cd3b79ca22907b8$var$cached(function(name) {
    return {
        enterClass: "".concat(name, "-enter"),
        enterToClass: "".concat(name, "-enter-to"),
        enterActiveClass: "".concat(name, "-enter-active"),
        leaveClass: "".concat(name, "-leave"),
        leaveToClass: "".concat(name, "-leave-to"),
        leaveActiveClass: "".concat(name, "-leave-active")
    };
});
var $0cd3b79ca22907b8$var$hasTransition = $0cd3b79ca22907b8$var$inBrowser && !$0cd3b79ca22907b8$var$isIE9;
var $0cd3b79ca22907b8$var$TRANSITION = "transition";
var $0cd3b79ca22907b8$var$ANIMATION = "animation";
// Transition property/event sniffing
var $0cd3b79ca22907b8$var$transitionProp = "transition";
var $0cd3b79ca22907b8$var$transitionEndEvent = "transitionend";
var $0cd3b79ca22907b8$var$animationProp = "animation";
var $0cd3b79ca22907b8$var$animationEndEvent = "animationend";
if ($0cd3b79ca22907b8$var$hasTransition) {
    /* istanbul ignore if */ if (window.ontransitionend === undefined && window.onwebkittransitionend !== undefined) {
        $0cd3b79ca22907b8$var$transitionProp = "WebkitTransition";
        $0cd3b79ca22907b8$var$transitionEndEvent = "webkitTransitionEnd";
    }
    if (window.onanimationend === undefined && window.onwebkitanimationend !== undefined) {
        $0cd3b79ca22907b8$var$animationProp = "WebkitAnimation";
        $0cd3b79ca22907b8$var$animationEndEvent = "webkitAnimationEnd";
    }
}
// binding to window is necessary to make hot reload work in IE in strict mode
var $0cd3b79ca22907b8$var$raf = $0cd3b79ca22907b8$var$inBrowser ? window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : setTimeout : /* istanbul ignore next */ function(/* istanbul ignore next */ fn) {
    return fn();
};
function $0cd3b79ca22907b8$var$nextFrame(fn) {
    $0cd3b79ca22907b8$var$raf(function() {
        // @ts-expect-error
        $0cd3b79ca22907b8$var$raf(fn);
    });
}
function $0cd3b79ca22907b8$var$addTransitionClass(el, cls) {
    var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
    if (transitionClasses.indexOf(cls) < 0) {
        transitionClasses.push(cls);
        $0cd3b79ca22907b8$var$addClass(el, cls);
    }
}
function $0cd3b79ca22907b8$var$removeTransitionClass(el, cls) {
    if (el._transitionClasses) $0cd3b79ca22907b8$var$remove$2(el._transitionClasses, cls);
    $0cd3b79ca22907b8$var$removeClass(el, cls);
}
function $0cd3b79ca22907b8$var$whenTransitionEnds(el, expectedType, cb) {
    var _a = $0cd3b79ca22907b8$var$getTransitionInfo(el, expectedType), type = _a.type, timeout = _a.timeout, propCount = _a.propCount;
    if (!type) return cb();
    var event = type === $0cd3b79ca22907b8$var$TRANSITION ? $0cd3b79ca22907b8$var$transitionEndEvent : $0cd3b79ca22907b8$var$animationEndEvent;
    var ended = 0;
    var end = function() {
        el.removeEventListener(event, onEnd);
        cb();
    };
    var onEnd = function(e) {
        if (e.target === el) {
            if (++ended >= propCount) end();
        }
    };
    setTimeout(function() {
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(event, onEnd);
}
var $0cd3b79ca22907b8$var$transformRE = /\b(transform|all)(,|$)/;
function $0cd3b79ca22907b8$var$getTransitionInfo(el, expectedType) {
    var styles = window.getComputedStyle(el);
    // JSDOM may return undefined for transition properties
    var transitionDelays = (styles[$0cd3b79ca22907b8$var$transitionProp + "Delay"] || "").split(", ");
    var transitionDurations = (styles[$0cd3b79ca22907b8$var$transitionProp + "Duration"] || "").split(", ");
    var transitionTimeout = $0cd3b79ca22907b8$var$getTimeout(transitionDelays, transitionDurations);
    var animationDelays = (styles[$0cd3b79ca22907b8$var$animationProp + "Delay"] || "").split(", ");
    var animationDurations = (styles[$0cd3b79ca22907b8$var$animationProp + "Duration"] || "").split(", ");
    var animationTimeout = $0cd3b79ca22907b8$var$getTimeout(animationDelays, animationDurations);
    var type;
    var timeout = 0;
    var propCount = 0;
    /* istanbul ignore if */ if (expectedType === $0cd3b79ca22907b8$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $0cd3b79ca22907b8$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $0cd3b79ca22907b8$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $0cd3b79ca22907b8$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $0cd3b79ca22907b8$var$TRANSITION : $0cd3b79ca22907b8$var$ANIMATION : null;
        propCount = type ? type === $0cd3b79ca22907b8$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    var hasTransform = type === $0cd3b79ca22907b8$var$TRANSITION && $0cd3b79ca22907b8$var$transformRE.test(styles[$0cd3b79ca22907b8$var$transitionProp + "Property"]);
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $0cd3b79ca22907b8$var$getTimeout(delays, durations) {
    /* istanbul ignore next */ while(delays.length < durations.length)delays = delays.concat(delays);
    return Math.max.apply(null, durations.map(function(d, i) {
        return $0cd3b79ca22907b8$var$toMs(d) + $0cd3b79ca22907b8$var$toMs(delays[i]);
    }));
}
// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function $0cd3b79ca22907b8$var$toMs(s) {
    return Number(s.slice(0, -1).replace(",", ".")) * 1000;
}
function $0cd3b79ca22907b8$var$enter(vnode, toggleDisplay) {
    var el = vnode.elm;
    // call leave callback now
    if ($0cd3b79ca22907b8$var$isDef(el._leaveCb)) {
        el._leaveCb.cancelled = true;
        el._leaveCb();
    }
    var data = $0cd3b79ca22907b8$var$resolveTransition(vnode.data.transition);
    if ($0cd3b79ca22907b8$var$isUndef(data)) return;
    /* istanbul ignore if */ if ($0cd3b79ca22907b8$var$isDef(el._enterCb) || el.nodeType !== 1) return;
    var css = data.css, type = data.type, enterClass = data.enterClass, enterToClass = data.enterToClass, enterActiveClass = data.enterActiveClass, appearClass = data.appearClass, appearToClass = data.appearToClass, appearActiveClass = data.appearActiveClass, beforeEnter = data.beforeEnter, enter = data.enter, afterEnter = data.afterEnter, enterCancelled = data.enterCancelled, beforeAppear = data.beforeAppear, appear = data.appear, afterAppear = data.afterAppear, appearCancelled = data.appearCancelled, duration = data.duration;
    // activeInstance will always be the <transition> component managing this
    // transition. One edge case to check is when the <transition> is placed
    // as the root node of a child component. In that case we need to check
    // <transition>'s parent for appear check.
    var context = $0cd3b79ca22907b8$var$activeInstance;
    var transitionNode = $0cd3b79ca22907b8$var$activeInstance.$vnode;
    while(transitionNode && transitionNode.parent){
        context = transitionNode.context;
        transitionNode = transitionNode.parent;
    }
    var isAppear = !context._isMounted || !vnode.isRootInsert;
    if (isAppear && !appear && appear !== "") return;
    var startClass = isAppear && appearClass ? appearClass : enterClass;
    var activeClass = isAppear && appearActiveClass ? appearActiveClass : enterActiveClass;
    var toClass = isAppear && appearToClass ? appearToClass : enterToClass;
    var beforeEnterHook = isAppear ? beforeAppear || beforeEnter : beforeEnter;
    var enterHook = isAppear ? $0cd3b79ca22907b8$var$isFunction(appear) ? appear : enter : enter;
    var afterEnterHook = isAppear ? afterAppear || afterEnter : afterEnter;
    var enterCancelledHook = isAppear ? appearCancelled || enterCancelled : enterCancelled;
    var explicitEnterDuration = $0cd3b79ca22907b8$var$toNumber($0cd3b79ca22907b8$var$isObject(duration) ? duration.enter : duration);
    var expectsCSS = css !== false && !$0cd3b79ca22907b8$var$isIE9;
    var userWantsControl = $0cd3b79ca22907b8$var$getHookArgumentsLength(enterHook);
    var cb = el._enterCb = $0cd3b79ca22907b8$var$once(function() {
        if (expectsCSS) {
            $0cd3b79ca22907b8$var$removeTransitionClass(el, toClass);
            $0cd3b79ca22907b8$var$removeTransitionClass(el, activeClass);
        }
        // @ts-expect-error
        if (cb.cancelled) {
            if (expectsCSS) $0cd3b79ca22907b8$var$removeTransitionClass(el, startClass);
            enterCancelledHook && enterCancelledHook(el);
        } else afterEnterHook && afterEnterHook(el);
        el._enterCb = null;
    });
    if (!vnode.data.show) // remove pending leave element on enter by injecting an insert hook
    $0cd3b79ca22907b8$var$mergeVNodeHook(vnode, "insert", function() {
        var parent = el.parentNode;
        var pendingNode = parent && parent._pending && parent._pending[vnode.key];
        if (pendingNode && pendingNode.tag === vnode.tag && pendingNode.elm._leaveCb) pendingNode.elm._leaveCb();
        enterHook && enterHook(el, cb);
    });
    // start enter transition
    beforeEnterHook && beforeEnterHook(el);
    if (expectsCSS) {
        $0cd3b79ca22907b8$var$addTransitionClass(el, startClass);
        $0cd3b79ca22907b8$var$addTransitionClass(el, activeClass);
        $0cd3b79ca22907b8$var$nextFrame(function() {
            $0cd3b79ca22907b8$var$removeTransitionClass(el, startClass);
            // @ts-expect-error
            if (!cb.cancelled) {
                $0cd3b79ca22907b8$var$addTransitionClass(el, toClass);
                if (!userWantsControl) {
                    if ($0cd3b79ca22907b8$var$isValidDuration(explicitEnterDuration)) setTimeout(cb, explicitEnterDuration);
                    else $0cd3b79ca22907b8$var$whenTransitionEnds(el, type, cb);
                }
            }
        });
    }
    if (vnode.data.show) {
        toggleDisplay && toggleDisplay();
        enterHook && enterHook(el, cb);
    }
    if (!expectsCSS && !userWantsControl) cb();
}
function $0cd3b79ca22907b8$var$leave(vnode, rm) {
    var el = vnode.elm;
    // call enter callback now
    if ($0cd3b79ca22907b8$var$isDef(el._enterCb)) {
        el._enterCb.cancelled = true;
        el._enterCb();
    }
    var data = $0cd3b79ca22907b8$var$resolveTransition(vnode.data.transition);
    if ($0cd3b79ca22907b8$var$isUndef(data) || el.nodeType !== 1) return rm();
    /* istanbul ignore if */ if ($0cd3b79ca22907b8$var$isDef(el._leaveCb)) return;
    var css = data.css, type = data.type, leaveClass = data.leaveClass, leaveToClass = data.leaveToClass, leaveActiveClass = data.leaveActiveClass, beforeLeave = data.beforeLeave, leave = data.leave, afterLeave = data.afterLeave, leaveCancelled = data.leaveCancelled, delayLeave = data.delayLeave, duration = data.duration;
    var expectsCSS = css !== false && !$0cd3b79ca22907b8$var$isIE9;
    var userWantsControl = $0cd3b79ca22907b8$var$getHookArgumentsLength(leave);
    var explicitLeaveDuration = $0cd3b79ca22907b8$var$toNumber($0cd3b79ca22907b8$var$isObject(duration) ? duration.leave : duration);
    var cb = el._leaveCb = $0cd3b79ca22907b8$var$once(function() {
        if (el.parentNode && el.parentNode._pending) el.parentNode._pending[vnode.key] = null;
        if (expectsCSS) {
            $0cd3b79ca22907b8$var$removeTransitionClass(el, leaveToClass);
            $0cd3b79ca22907b8$var$removeTransitionClass(el, leaveActiveClass);
        }
        // @ts-expect-error
        if (cb.cancelled) {
            if (expectsCSS) $0cd3b79ca22907b8$var$removeTransitionClass(el, leaveClass);
            leaveCancelled && leaveCancelled(el);
        } else {
            rm();
            afterLeave && afterLeave(el);
        }
        el._leaveCb = null;
    });
    if (delayLeave) delayLeave(performLeave);
    else performLeave();
    function performLeave() {
        // the delayed leave may have already been cancelled
        // @ts-expect-error
        if (cb.cancelled) return;
        // record leaving element
        if (!vnode.data.show && el.parentNode) (el.parentNode._pending || (el.parentNode._pending = {}))[vnode.key] = vnode;
        beforeLeave && beforeLeave(el);
        if (expectsCSS) {
            $0cd3b79ca22907b8$var$addTransitionClass(el, leaveClass);
            $0cd3b79ca22907b8$var$addTransitionClass(el, leaveActiveClass);
            $0cd3b79ca22907b8$var$nextFrame(function() {
                $0cd3b79ca22907b8$var$removeTransitionClass(el, leaveClass);
                // @ts-expect-error
                if (!cb.cancelled) {
                    $0cd3b79ca22907b8$var$addTransitionClass(el, leaveToClass);
                    if (!userWantsControl) {
                        if ($0cd3b79ca22907b8$var$isValidDuration(explicitLeaveDuration)) setTimeout(cb, explicitLeaveDuration);
                        else $0cd3b79ca22907b8$var$whenTransitionEnds(el, type, cb);
                    }
                }
            });
        }
        leave && leave(el, cb);
        if (!expectsCSS && !userWantsControl) cb();
    }
}
// only used in dev mode
function $0cd3b79ca22907b8$var$checkDuration(val, name, vnode) {
    if (typeof val !== "number") $0cd3b79ca22907b8$var$warn("<transition> explicit ".concat(name, " duration is not a valid number - ") + "got ".concat(JSON.stringify(val), "."), vnode.context);
    else if (isNaN(val)) $0cd3b79ca22907b8$var$warn("<transition> explicit ".concat(name, " duration is NaN - ") + "the duration expression might be incorrect.", vnode.context);
}
function $0cd3b79ca22907b8$var$isValidDuration(val) {
    return typeof val === "number" && !isNaN(val);
}
/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */ function $0cd3b79ca22907b8$var$getHookArgumentsLength(fn) {
    if ($0cd3b79ca22907b8$var$isUndef(fn)) return false;
    // @ts-expect-error
    var invokerFns = fn.fns;
    if ($0cd3b79ca22907b8$var$isDef(invokerFns)) // invoker
    return $0cd3b79ca22907b8$var$getHookArgumentsLength(Array.isArray(invokerFns) ? invokerFns[0] : invokerFns);
    else // @ts-expect-error
    return (fn._length || fn.length) > 1;
}
function $0cd3b79ca22907b8$var$_enter(_, vnode) {
    if (vnode.data.show !== true) $0cd3b79ca22907b8$var$enter(vnode);
}
var $0cd3b79ca22907b8$var$transition = $0cd3b79ca22907b8$var$inBrowser ? {
    create: $0cd3b79ca22907b8$var$_enter,
    activate: $0cd3b79ca22907b8$var$_enter,
    remove: function(vnode, rm) {
        /* istanbul ignore else */ if (vnode.data.show !== true) // @ts-expect-error
        $0cd3b79ca22907b8$var$leave(vnode, rm);
        else rm();
    }
} : {};
var $0cd3b79ca22907b8$var$platformModules = [
    $0cd3b79ca22907b8$var$attrs,
    $0cd3b79ca22907b8$var$klass,
    $0cd3b79ca22907b8$var$events,
    $0cd3b79ca22907b8$var$domProps,
    $0cd3b79ca22907b8$var$style,
    $0cd3b79ca22907b8$var$transition
];
// the directive module should be applied last, after all
// built-in modules have been applied.
var $0cd3b79ca22907b8$var$modules = $0cd3b79ca22907b8$var$platformModules.concat($0cd3b79ca22907b8$var$baseModules);
var $0cd3b79ca22907b8$var$patch = $0cd3b79ca22907b8$var$createPatchFunction({
    nodeOps: $0cd3b79ca22907b8$var$nodeOps,
    modules: $0cd3b79ca22907b8$var$modules
});
/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */ /* istanbul ignore if */ if ($0cd3b79ca22907b8$var$isIE9) // http://www.matts411.com/post/internet-explorer-9-oninput/
document.addEventListener("selectionchange", function() {
    var el = document.activeElement;
    // @ts-expect-error
    if (el && el.vmodel) $0cd3b79ca22907b8$var$trigger(el, "input");
});
var $0cd3b79ca22907b8$var$directive = {
    inserted: function(el, binding, vnode, oldVnode) {
        if (vnode.tag === "select") {
            // #6903
            if (oldVnode.elm && !oldVnode.elm._vOptions) $0cd3b79ca22907b8$var$mergeVNodeHook(vnode, "postpatch", function() {
                $0cd3b79ca22907b8$var$directive.componentUpdated(el, binding, vnode);
            });
            else $0cd3b79ca22907b8$var$setSelected(el, binding, vnode.context);
            el._vOptions = [].map.call(el.options, $0cd3b79ca22907b8$var$getValue);
        } else if (vnode.tag === "textarea" || $0cd3b79ca22907b8$var$isTextInputType(el.type)) {
            el._vModifiers = binding.modifiers;
            if (!binding.modifiers.lazy) {
                el.addEventListener("compositionstart", $0cd3b79ca22907b8$var$onCompositionStart);
                el.addEventListener("compositionend", $0cd3b79ca22907b8$var$onCompositionEnd);
                // Safari < 10.2 & UIWebView doesn't fire compositionend when
                // switching focus before confirming composition choice
                // this also fixes the issue where some browsers e.g. iOS Chrome
                // fires "change" instead of "input" on autocomplete.
                el.addEventListener("change", $0cd3b79ca22907b8$var$onCompositionEnd);
                /* istanbul ignore if */ if ($0cd3b79ca22907b8$var$isIE9) el.vmodel = true;
            }
        }
    },
    componentUpdated: function(el, binding, vnode) {
        if (vnode.tag === "select") {
            $0cd3b79ca22907b8$var$setSelected(el, binding, vnode.context);
            // in case the options rendered by v-for have changed,
            // it's possible that the value is out-of-sync with the rendered options.
            // detect such cases and filter out values that no longer has a matching
            // option in the DOM.
            var prevOptions_1 = el._vOptions;
            var curOptions_1 = el._vOptions = [].map.call(el.options, $0cd3b79ca22907b8$var$getValue);
            if (curOptions_1.some(function(o, i) {
                return !$0cd3b79ca22907b8$var$looseEqual(o, prevOptions_1[i]);
            })) {
                // trigger change event if
                // no matching option found for at least one value
                var needReset = el.multiple ? binding.value.some(function(v) {
                    return $0cd3b79ca22907b8$var$hasNoMatchingOption(v, curOptions_1);
                }) : binding.value !== binding.oldValue && $0cd3b79ca22907b8$var$hasNoMatchingOption(binding.value, curOptions_1);
                if (needReset) $0cd3b79ca22907b8$var$trigger(el, "change");
            }
        }
    }
};
function $0cd3b79ca22907b8$var$setSelected(el, binding, vm) {
    $0cd3b79ca22907b8$var$actuallySetSelected(el, binding, vm);
    /* istanbul ignore if */ if ($0cd3b79ca22907b8$var$isIE || $0cd3b79ca22907b8$var$isEdge) setTimeout(function() {
        $0cd3b79ca22907b8$var$actuallySetSelected(el, binding, vm);
    }, 0);
}
function $0cd3b79ca22907b8$var$actuallySetSelected(el, binding, vm) {
    var value = binding.value;
    var isMultiple = el.multiple;
    if (isMultiple && !Array.isArray(value)) return;
    var selected, option;
    for(var i = 0, l = el.options.length; i < l; i++){
        option = el.options[i];
        if (isMultiple) {
            selected = $0cd3b79ca22907b8$var$looseIndexOf(value, $0cd3b79ca22907b8$var$getValue(option)) > -1;
            if (option.selected !== selected) option.selected = selected;
        } else if ($0cd3b79ca22907b8$var$looseEqual($0cd3b79ca22907b8$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple) el.selectedIndex = -1;
}
function $0cd3b79ca22907b8$var$hasNoMatchingOption(value, options) {
    return options.every(function(o) {
        return !$0cd3b79ca22907b8$var$looseEqual(o, value);
    });
}
function $0cd3b79ca22907b8$var$getValue(option) {
    return "_value" in option ? option._value : option.value;
}
function $0cd3b79ca22907b8$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $0cd3b79ca22907b8$var$onCompositionEnd(e) {
    // prevent triggering an input event for no reason
    if (!e.target.composing) return;
    e.target.composing = false;
    $0cd3b79ca22907b8$var$trigger(e.target, "input");
}
function $0cd3b79ca22907b8$var$trigger(el, type) {
    var e = document.createEvent("HTMLEvents");
    e.initEvent(type, true, true);
    el.dispatchEvent(e);
}
// recursively search for possible transition defined inside the component root
function $0cd3b79ca22907b8$var$locateNode(vnode) {
    // @ts-expect-error
    return vnode.componentInstance && (!vnode.data || !vnode.data.transition) ? $0cd3b79ca22907b8$var$locateNode(vnode.componentInstance._vnode) : vnode;
}
var $0cd3b79ca22907b8$var$show = {
    bind: function(el, _a, vnode) {
        var value = _a.value;
        vnode = $0cd3b79ca22907b8$var$locateNode(vnode);
        var transition = vnode.data && vnode.data.transition;
        var originalDisplay = el.__vOriginalDisplay = el.style.display === "none" ? "" : el.style.display;
        if (value && transition) {
            vnode.data.show = true;
            $0cd3b79ca22907b8$var$enter(vnode, function() {
                el.style.display = originalDisplay;
            });
        } else el.style.display = value ? originalDisplay : "none";
    },
    update: function(el, _a, vnode) {
        var value = _a.value, oldValue = _a.oldValue;
        /* istanbul ignore if */ if (!value === !oldValue) return;
        vnode = $0cd3b79ca22907b8$var$locateNode(vnode);
        var transition = vnode.data && vnode.data.transition;
        if (transition) {
            vnode.data.show = true;
            if (value) $0cd3b79ca22907b8$var$enter(vnode, function() {
                el.style.display = el.__vOriginalDisplay;
            });
            else $0cd3b79ca22907b8$var$leave(vnode, function() {
                el.style.display = "none";
            });
        } else el.style.display = value ? el.__vOriginalDisplay : "none";
    },
    unbind: function(el, binding, vnode, oldVnode, isDestroy) {
        if (!isDestroy) el.style.display = el.__vOriginalDisplay;
    }
};
var $0cd3b79ca22907b8$var$platformDirectives = {
    model: $0cd3b79ca22907b8$var$directive,
    show: $0cd3b79ca22907b8$var$show
};
// Provides transition support for a single element/component.
var $0cd3b79ca22907b8$var$transitionProps = {
    name: String,
    appear: Boolean,
    css: Boolean,
    mode: String,
    type: String,
    enterClass: String,
    leaveClass: String,
    enterToClass: String,
    leaveToClass: String,
    enterActiveClass: String,
    leaveActiveClass: String,
    appearClass: String,
    appearActiveClass: String,
    appearToClass: String,
    duration: [
        Number,
        String,
        Object
    ]
};
// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function $0cd3b79ca22907b8$var$getRealChild(vnode) {
    var compOptions = vnode && vnode.componentOptions;
    if (compOptions && compOptions.Ctor.options.abstract) return $0cd3b79ca22907b8$var$getRealChild($0cd3b79ca22907b8$var$getFirstComponentChild(compOptions.children));
    else return vnode;
}
function $0cd3b79ca22907b8$var$extractTransitionData(comp) {
    var data = {};
    var options = comp.$options;
    // props
    for(var key in options.propsData)data[key] = comp[key];
    // events.
    // extract listeners and pass them directly to the transition methods
    var listeners = options._parentListeners;
    for(var key in listeners)data[$0cd3b79ca22907b8$var$camelize(key)] = listeners[key];
    return data;
}
function $0cd3b79ca22907b8$var$placeholder(h, rawChild) {
    // @ts-expect-error
    if (/\d-keep-alive$/.test(rawChild.tag)) return h("keep-alive", {
        props: rawChild.componentOptions.propsData
    });
}
function $0cd3b79ca22907b8$var$hasParentTransition(vnode) {
    while(vnode = vnode.parent){
        if (vnode.data.transition) return true;
    }
}
function $0cd3b79ca22907b8$var$isSameChild(child, oldChild) {
    return oldChild.key === child.key && oldChild.tag === child.tag;
}
var $0cd3b79ca22907b8$var$isNotTextNode = function(c) {
    return c.tag || $0cd3b79ca22907b8$var$isAsyncPlaceholder(c);
};
var $0cd3b79ca22907b8$var$isVShowDirective = function(d) {
    return d.name === "show";
};
var $0cd3b79ca22907b8$var$Transition = {
    name: "transition",
    props: $0cd3b79ca22907b8$var$transitionProps,
    abstract: true,
    render: function(h) {
        var _this = this;
        var children = this.$slots.default;
        if (!children) return;
        // filter out text nodes (possible whitespaces)
        children = children.filter($0cd3b79ca22907b8$var$isNotTextNode);
        /* istanbul ignore if */ if (!children.length) return;
        var mode = this.mode;
        var rawChild = children[0];
        // if this is a component root node and the component's
        // parent container node also has transition, skip.
        if ($0cd3b79ca22907b8$var$hasParentTransition(this.$vnode)) return rawChild;
        // apply transition data to child
        // use getRealChild() to ignore abstract components e.g. keep-alive
        var child = $0cd3b79ca22907b8$var$getRealChild(rawChild);
        /* istanbul ignore if */ if (!child) return rawChild;
        if (this._leaving) return $0cd3b79ca22907b8$var$placeholder(h, rawChild);
        // ensure a key that is unique to the vnode type and to this transition
        // component instance. This key will be used to remove pending leaving nodes
        // during entering.
        var id = "__transition-".concat(this._uid, "-");
        child.key = child.key == null ? child.isComment ? id + "comment" : id + child.tag : $0cd3b79ca22907b8$var$isPrimitive(child.key) ? String(child.key).indexOf(id) === 0 ? child.key : id + child.key : child.key;
        var data = (child.data || (child.data = {})).transition = $0cd3b79ca22907b8$var$extractTransitionData(this);
        var oldRawChild = this._vnode;
        var oldChild = $0cd3b79ca22907b8$var$getRealChild(oldRawChild);
        // mark v-show
        // so that the transition module can hand over the control to the directive
        if (child.data.directives && child.data.directives.some($0cd3b79ca22907b8$var$isVShowDirective)) child.data.show = true;
        if (oldChild && oldChild.data && !$0cd3b79ca22907b8$var$isSameChild(child, oldChild) && !$0cd3b79ca22907b8$var$isAsyncPlaceholder(oldChild) && // #6687 component root is a comment node
        !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)) {
            // replace old child transition data with fresh one
            // important for dynamic transitions!
            var oldData = oldChild.data.transition = $0cd3b79ca22907b8$var$extend({}, data);
            // handle transition mode
            if (mode === "out-in") {
                // return placeholder node and queue update when leave finishes
                this._leaving = true;
                $0cd3b79ca22907b8$var$mergeVNodeHook(oldData, "afterLeave", function() {
                    _this._leaving = false;
                    _this.$forceUpdate();
                });
                return $0cd3b79ca22907b8$var$placeholder(h, rawChild);
            } else if (mode === "in-out") {
                if ($0cd3b79ca22907b8$var$isAsyncPlaceholder(child)) return oldRawChild;
                var delayedLeave_1;
                var performLeave = function() {
                    delayedLeave_1();
                };
                $0cd3b79ca22907b8$var$mergeVNodeHook(data, "afterEnter", performLeave);
                $0cd3b79ca22907b8$var$mergeVNodeHook(data, "enterCancelled", performLeave);
                $0cd3b79ca22907b8$var$mergeVNodeHook(oldData, "delayLeave", function(leave) {
                    delayedLeave_1 = leave;
                });
            }
        }
        return rawChild;
    }
};
// Provides transition support for list items.
var $0cd3b79ca22907b8$var$props = $0cd3b79ca22907b8$var$extend({
    tag: String,
    moveClass: String
}, $0cd3b79ca22907b8$var$transitionProps);
delete $0cd3b79ca22907b8$var$props.mode;
var $0cd3b79ca22907b8$var$TransitionGroup = {
    props: $0cd3b79ca22907b8$var$props,
    beforeMount: function() {
        var _this = this;
        var update = this._update;
        this._update = function(vnode, hydrating) {
            var restoreActiveInstance = $0cd3b79ca22907b8$var$setActiveInstance(_this);
            // force removing pass
            _this.__patch__(_this._vnode, _this.kept, false, true // removeOnly (!important, avoids unnecessary moves)
            );
            _this._vnode = _this.kept;
            restoreActiveInstance();
            update.call(_this, vnode, hydrating);
        };
    },
    render: function(h) {
        var tag = this.tag || this.$vnode.data.tag || "span";
        var map = Object.create(null);
        var prevChildren = this.prevChildren = this.children;
        var rawChildren = this.$slots.default || [];
        var children = this.children = [];
        var transitionData = $0cd3b79ca22907b8$var$extractTransitionData(this);
        for(var i = 0; i < rawChildren.length; i++){
            var c = rawChildren[i];
            if (c.tag) {
                if (c.key != null && String(c.key).indexOf("__vlist") !== 0) {
                    children.push(c);
                    map[c.key] = c;
                    (c.data || (c.data = {})).transition = transitionData;
                } else var opts, name_1;
            }
        }
        if (prevChildren) {
            var kept = [];
            var removed = [];
            for(var i = 0; i < prevChildren.length; i++){
                var c = prevChildren[i];
                c.data.transition = transitionData;
                // @ts-expect-error .getBoundingClientRect is not typed in Node
                c.data.pos = c.elm.getBoundingClientRect();
                if (map[c.key]) kept.push(c);
                else removed.push(c);
            }
            this.kept = h(tag, null, kept);
            this.removed = removed;
        }
        return h(tag, null, children);
    },
    updated: function() {
        var children = this.prevChildren;
        var moveClass = this.moveClass || (this.name || "v") + "-move";
        if (!children.length || !this.hasMove(children[0].elm, moveClass)) return;
        // we divide the work into three loops to avoid mixing DOM reads and writes
        // in each iteration - which helps prevent layout thrashing.
        children.forEach($0cd3b79ca22907b8$var$callPendingCbs);
        children.forEach($0cd3b79ca22907b8$var$recordPosition);
        children.forEach($0cd3b79ca22907b8$var$applyTranslation);
        // force reflow to put everything in position
        // assign to this to avoid being removed in tree-shaking
        // $flow-disable-line
        this._reflow = document.body.offsetHeight;
        children.forEach(function(c) {
            if (c.data.moved) {
                var el_1 = c.elm;
                var s = el_1.style;
                $0cd3b79ca22907b8$var$addTransitionClass(el_1, moveClass);
                s.transform = s.WebkitTransform = s.transitionDuration = "";
                el_1.addEventListener($0cd3b79ca22907b8$var$transitionEndEvent, el_1._moveCb = function cb(e) {
                    if (e && e.target !== el_1) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el_1.removeEventListener($0cd3b79ca22907b8$var$transitionEndEvent, cb);
                        el_1._moveCb = null;
                        $0cd3b79ca22907b8$var$removeTransitionClass(el_1, moveClass);
                    }
                });
            }
        });
    },
    methods: {
        hasMove: function(el, moveClass) {
            /* istanbul ignore if */ if (!$0cd3b79ca22907b8$var$hasTransition) return false;
            /* istanbul ignore if */ if (this._hasMove) return this._hasMove;
            // Detect whether an element with the move class applied has
            // CSS transitions. Since the element may be inside an entering
            // transition at this very moment, we make a clone of it and remove
            // all other transition classes applied to ensure only the move class
            // is applied.
            var clone = el.cloneNode();
            if (el._transitionClasses) el._transitionClasses.forEach(function(cls) {
                $0cd3b79ca22907b8$var$removeClass(clone, cls);
            });
            $0cd3b79ca22907b8$var$addClass(clone, moveClass);
            clone.style.display = "none";
            this.$el.appendChild(clone);
            var info = $0cd3b79ca22907b8$var$getTransitionInfo(clone);
            this.$el.removeChild(clone);
            return this._hasMove = info.hasTransform;
        }
    }
};
function $0cd3b79ca22907b8$var$callPendingCbs(c) {
    /* istanbul ignore if */ if (c.elm._moveCb) c.elm._moveCb();
    /* istanbul ignore if */ if (c.elm._enterCb) c.elm._enterCb();
}
function $0cd3b79ca22907b8$var$recordPosition(c) {
    c.data.newPos = c.elm.getBoundingClientRect();
}
function $0cd3b79ca22907b8$var$applyTranslation(c) {
    var oldPos = c.data.pos;
    var newPos = c.data.newPos;
    var dx = oldPos.left - newPos.left;
    var dy = oldPos.top - newPos.top;
    if (dx || dy) {
        c.data.moved = true;
        var s = c.elm.style;
        s.transform = s.WebkitTransform = "translate(".concat(dx, "px,").concat(dy, "px)");
        s.transitionDuration = "0s";
    }
}
var $0cd3b79ca22907b8$var$platformComponents = {
    Transition: $0cd3b79ca22907b8$var$Transition,
    TransitionGroup: $0cd3b79ca22907b8$var$TransitionGroup
};
// install platform specific utils
$0cd3b79ca22907b8$export$2e2bcd8739ae039.config.mustUseProp = $0cd3b79ca22907b8$var$mustUseProp;
$0cd3b79ca22907b8$export$2e2bcd8739ae039.config.isReservedTag = $0cd3b79ca22907b8$var$isReservedTag;
$0cd3b79ca22907b8$export$2e2bcd8739ae039.config.isReservedAttr = $0cd3b79ca22907b8$var$isReservedAttr;
$0cd3b79ca22907b8$export$2e2bcd8739ae039.config.getTagNamespace = $0cd3b79ca22907b8$var$getTagNamespace;
$0cd3b79ca22907b8$export$2e2bcd8739ae039.config.isUnknownElement = $0cd3b79ca22907b8$var$isUnknownElement;
// install platform runtime directives & components
$0cd3b79ca22907b8$var$extend($0cd3b79ca22907b8$export$2e2bcd8739ae039.options.directives, $0cd3b79ca22907b8$var$platformDirectives);
$0cd3b79ca22907b8$var$extend($0cd3b79ca22907b8$export$2e2bcd8739ae039.options.components, $0cd3b79ca22907b8$var$platformComponents);
// install platform patch function
$0cd3b79ca22907b8$export$2e2bcd8739ae039.prototype.__patch__ = $0cd3b79ca22907b8$var$inBrowser ? $0cd3b79ca22907b8$var$patch : $0cd3b79ca22907b8$var$noop;
// public mount method
$0cd3b79ca22907b8$export$2e2bcd8739ae039.prototype.$mount = function(el, hydrating) {
    el = el && $0cd3b79ca22907b8$var$inBrowser ? $0cd3b79ca22907b8$var$query(el) : undefined;
    return $0cd3b79ca22907b8$var$mountComponent(this, el, hydrating);
};
// devtools global hook
/* istanbul ignore next */ if ($0cd3b79ca22907b8$var$inBrowser) setTimeout(function() {
    if ($0cd3b79ca22907b8$var$config.devtools) {
        if ($0cd3b79ca22907b8$var$devtools) $0cd3b79ca22907b8$var$devtools.emit("init", $0cd3b79ca22907b8$export$2e2bcd8739ae039);
    }
}, 0);

});


parcelRequire.register("3EdsD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a7f8c9125723958$export$2e2bcd8739ae039; });
let $2a7f8c9125723958$var$script;





let $2a7f8c9125723958$var$initialize = ()=>{
    $2a7f8c9125723958$var$script = (parcelRequire("a8NQg"));
    if ($2a7f8c9125723958$var$script.__esModule) $2a7f8c9125723958$var$script = $2a7f8c9125723958$var$script.default;
    $2a7f8c9125723958$var$script.render = (parcelRequire("AXZ76")).render;
    $2a7f8c9125723958$var$script.staticRenderFns = (parcelRequire("AXZ76")).staticRenderFns;
    $2a7f8c9125723958$var$script._scopeId = "data-v-188cff";
    $2a7f8c9125723958$var$script.__cssModules = {};
    (parcelRequire("evv8E")).default($2a7f8c9125723958$var$script);
    $2a7f8c9125723958$var$script.__scopeId = "data-v-188cff";
    $2a7f8c9125723958$var$script.__file = "LoadingBar.vue";
};
$2a7f8c9125723958$var$initialize();
var $2a7f8c9125723958$export$2e2bcd8739ae039 = $2a7f8c9125723958$var$script;

});
parcelRequire.register("a8NQg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $762150567af2e34c$export$2e2bcd8739ae039; });
var $762150567af2e34c$var$scriptExports = {
    props: [
        "mode",
        "loading"
    ],
    data () {
        return {};
    },
    mounted () {},
    methods: {}
};
var $762150567af2e34c$var$options = typeof $762150567af2e34c$var$scriptExports === "function" ? $762150567af2e34c$var$scriptExports.options : $762150567af2e34c$var$scriptExports;
var $762150567af2e34c$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $762150567af2e34c$var$options;

});

parcelRequire.register("AXZ76", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $06f1e49eba494c30$export$b3890eb0ae9dca99; }, function (v) { return $06f1e49eba494c30$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $06f1e49eba494c30$export$f8436702749526f9; }, function (v) { return $06f1e49eba494c30$export$f8436702749526f9 = v; });
var $06f1e49eba494c30$export$b3890eb0ae9dca99;
var $06f1e49eba494c30$export$f8436702749526f9;
var $06f1e49eba494c30$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("transition", {
        attrs: {
            "name": "loading"
        }
    }, [
        _vm.loading && _vm.mode !== "latest" ? _c("div", {
            staticClass: "fixed top-0 left-0 z-50 flex items-center justify-center w-screen h-screen bg-black bg-opacity-40"
        }, [
            _c("div", {
                staticClass: "lds-ring"
            }, [
                _c("div"),
                _vm._v(" "),
                _c("div"),
                _vm._v(" "),
                _c("div"),
                _vm._v(" "),
                _c("div")
            ])
        ]) : _vm._e()
    ]);
};
var $06f1e49eba494c30$var$staticRenderFns = [];
$06f1e49eba494c30$export$b3890eb0ae9dca99 = $06f1e49eba494c30$var$render;
$06f1e49eba494c30$export$f8436702749526f9 = $06f1e49eba494c30$var$staticRenderFns;

});

parcelRequire.register("evv8E", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02b9be68dc48b221$export$2e2bcd8739ae039; });
let $02b9be68dc48b221$var$NOOP = ()=>{};
var $02b9be68dc48b221$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("6XlU4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51093e4fc7a5c941$export$2e2bcd8739ae039; });
let $51093e4fc7a5c941$var$script;




let $51093e4fc7a5c941$var$initialize = ()=>{
    $51093e4fc7a5c941$var$script = (parcelRequire("1GdUF"));
    if ($51093e4fc7a5c941$var$script.__esModule) $51093e4fc7a5c941$var$script = $51093e4fc7a5c941$var$script.default;
    $51093e4fc7a5c941$var$script.render = (parcelRequire("fpGhD")).render;
    $51093e4fc7a5c941$var$script.staticRenderFns = (parcelRequire("fpGhD")).staticRenderFns;
    $51093e4fc7a5c941$var$script._scopeId = "data-v-c081c3";
    (parcelRequire("cggIO")).default($51093e4fc7a5c941$var$script);
    $51093e4fc7a5c941$var$script.__scopeId = "data-v-c081c3";
    $51093e4fc7a5c941$var$script.__file = "FilterCategories.vue";
};
$51093e4fc7a5c941$var$initialize();
var $51093e4fc7a5c941$export$2e2bcd8739ae039 = $51093e4fc7a5c941$var$script;

});
parcelRequire.register("1GdUF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $13948185a75a6b75$export$2e2bcd8739ae039; });

var $a9ufu = parcelRequire("a9ufu");
var $13948185a75a6b75$var$scriptExports = {
    props: [
        "lang",
        "locales"
    ],
    data () {
        return {
            value: []
        };
    },
    computed: {
        options () {
            let result = [];
            if (this.lang) result = [
                {
                    label: this.locales[this.lang].categories.house,
                    value: "house"
                },
                {
                    label: this.locales[this.lang].categories.apartment,
                    value: "apartment"
                },
                {
                    label: this.locales[this.lang].categories.land,
                    value: "land"
                },
                {
                    label: this.locales[this.lang].categories.commercial,
                    value: "commercial"
                },
                {
                    label: this.locales[this.lang].categories.office,
                    value: "office"
                },
                {
                    label: this.locales[this.lang].categories.parking,
                    value: "parking"
                }
            ];
            return result;
        }
    },
    mounted () {
        (0, $a9ufu.default).$on("updateData", (item)=>{
            if (item.id === "categories") {
                this.value = [];
                item.data.forEach((value)=>{
                    this.value.push({
                        label: this.locales[this.lang].categories[value],
                        value: value
                    });
                });
            }
        });
    },
    methods: {
        edited () {
            (0, $a9ufu.default).$emit("setData", {
                id: "categories",
                data: this.value
            });
        }
    }
};
var $13948185a75a6b75$var$options = typeof $13948185a75a6b75$var$scriptExports === "function" ? $13948185a75a6b75$var$scriptExports.options : $13948185a75a6b75$var$scriptExports;
var $13948185a75a6b75$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $13948185a75a6b75$var$options;

});

parcelRequire.register("fpGhD", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $b389fd67392aaf1e$export$b3890eb0ae9dca99; }, function (v) { return $b389fd67392aaf1e$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $b389fd67392aaf1e$export$f8436702749526f9; }, function (v) { return $b389fd67392aaf1e$export$f8436702749526f9 = v; });
var $b389fd67392aaf1e$export$b3890eb0ae9dca99;
var $b389fd67392aaf1e$export$f8436702749526f9;
var $b389fd67392aaf1e$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("v-select", {
        attrs: {
            "multiple": "",
            "options": _vm.options,
            "placeholder": _vm.locales[_vm.lang].categories.label,
            "create-option": function(tag) {
                return {
                    label: tag,
                    value: tag
                };
            }
        },
        on: {
            "input": _vm.edited
        },
        scopedSlots: _vm._u([
            {
                key: "open-indicator",
                fn: function(ref) {
                    var attributes = ref.attributes;
                    return [
                        _c("span", _vm._b({}, "span", attributes, false), [
                            _c("i", {
                                staticClass: "text-gray-400 fal fa-chevron-down"
                            })
                        ])
                    ];
                }
            }
        ]),
        model: {
            value: _vm.value,
            callback: function($$v) {
                _vm.value = $$v;
            },
            expression: "value"
        }
    });
};
var $b389fd67392aaf1e$var$staticRenderFns = [];
$b389fd67392aaf1e$export$b3890eb0ae9dca99 = $b389fd67392aaf1e$var$render;
$b389fd67392aaf1e$export$f8436702749526f9 = $b389fd67392aaf1e$var$staticRenderFns;

});

parcelRequire.register("cggIO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ed3f33d97270638$export$2e2bcd8739ae039; });
let $8ed3f33d97270638$var$NOOP = ()=>{};
var $8ed3f33d97270638$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("2uJKh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d11de3acb37f0db$export$2e2bcd8739ae039; });
let $1d11de3acb37f0db$var$script;




let $1d11de3acb37f0db$var$initialize = ()=>{
    $1d11de3acb37f0db$var$script = (parcelRequire("gvVXb"));
    if ($1d11de3acb37f0db$var$script.__esModule) $1d11de3acb37f0db$var$script = $1d11de3acb37f0db$var$script.default;
    $1d11de3acb37f0db$var$script.render = (parcelRequire("imsTe")).render;
    $1d11de3acb37f0db$var$script.staticRenderFns = (parcelRequire("imsTe")).staticRenderFns;
    $1d11de3acb37f0db$var$script._scopeId = "data-v-ec9610";
    (parcelRequire("4GMjQ")).default($1d11de3acb37f0db$var$script);
    $1d11de3acb37f0db$var$script.__scopeId = "data-v-ec9610";
    $1d11de3acb37f0db$var$script.__file = "FilterMinMaxPrice.vue";
};
$1d11de3acb37f0db$var$initialize();
var $1d11de3acb37f0db$export$2e2bcd8739ae039 = $1d11de3acb37f0db$var$script;

});
parcelRequire.register("gvVXb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $c05c7ef60863b408$export$2e2bcd8739ae039; });

var $a9ufu = parcelRequire("a9ufu");
var $c05c7ef60863b408$var$scriptExports = {
    props: [
        "lang",
        "locales",
        "type"
    ],
    data () {
        return {
            value: {
                min: "",
                max: ""
            },
            options: [
                {
                    label: `€ ${this.$formatNumber(0, "DOT")}`,
                    value: ""
                },
                {
                    label: `€ ${this.$formatNumber(25000, "DOT")}`,
                    value: 25000
                },
                {
                    label: `€ ${this.$formatNumber(50000, "DOT")}`,
                    value: 50000
                },
                {
                    label: `€ ${this.$formatNumber(75000, "DOT")}`,
                    value: 75000
                },
                {
                    label: `€ ${this.$formatNumber(100000, "DOT")}`,
                    value: 100000
                },
                {
                    label: `€ ${this.$formatNumber(125000, "DOT")}`,
                    value: 125000
                },
                {
                    label: `€ ${this.$formatNumber(150000, "DOT")}`,
                    value: 150000
                },
                {
                    label: `€ ${this.$formatNumber(175000, "DOT")}`,
                    value: 175000
                },
                {
                    label: `€ ${this.$formatNumber(200000, "DOT")}`,
                    value: 200000
                },
                {
                    label: `€ ${this.$formatNumber(225000, "DOT")}`,
                    value: 225000
                },
                {
                    label: `€ ${this.$formatNumber(250000, "DOT")}`,
                    value: 250000
                },
                {
                    label: `€ ${this.$formatNumber(275000, "DOT")}`,
                    value: 275000
                },
                {
                    label: `€ ${this.$formatNumber(300000, "DOT")}`,
                    value: 300000
                },
                {
                    label: `€ ${this.$formatNumber(325000, "DOT")}`,
                    value: 325000
                },
                {
                    label: `€ ${this.$formatNumber(350000, "DOT")}`,
                    value: 350000
                },
                {
                    label: `€ ${this.$formatNumber(375000, "DOT")}`,
                    value: 375000
                },
                {
                    label: `€ ${this.$formatNumber(400000, "DOT")}`,
                    value: 400000
                },
                {
                    label: `€ ${this.$formatNumber(425000, "DOT")}`,
                    value: 425000
                },
                {
                    label: `€ ${this.$formatNumber(450000, "DOT")}`,
                    value: 450000
                },
                {
                    label: `€ ${this.$formatNumber(475000, "DOT")}`,
                    value: 475000
                },
                {
                    label: `€ ${this.$formatNumber(500000, "DOT")}`,
                    value: 500000
                },
                {
                    label: `€ ${this.$formatNumber(525000, "DOT")}`,
                    value: 525000
                },
                {
                    label: `€ ${this.$formatNumber(550000, "DOT")}`,
                    value: 550000
                },
                {
                    label: `€ ${this.$formatNumber(575000, "DOT")}`,
                    value: 575000
                },
                {
                    label: `€ ${this.$formatNumber(600000, "DOT")}`,
                    value: 600000
                },
                {
                    label: `€ ${this.$formatNumber(625000, "DOT")}`,
                    value: 625000
                },
                {
                    label: `€ ${this.$formatNumber(650000, "DOT")}`,
                    value: 650000
                },
                {
                    label: `€ ${this.$formatNumber(675000, "DOT")}`,
                    value: 675000
                },
                {
                    label: `€ ${this.$formatNumber(700000, "DOT")}`,
                    value: 700000
                },
                {
                    label: `€ ${this.$formatNumber(725000, "DOT")}`,
                    value: 725000
                },
                {
                    label: `€ ${this.$formatNumber(750000, "DOT")}`,
                    value: 750000
                },
                {
                    label: `€ ${this.$formatNumber(775000, "DOT")}`,
                    value: 775000
                },
                {
                    label: `€ ${this.$formatNumber(800000, "DOT")}`,
                    value: 800000
                },
                {
                    label: `€ ${this.$formatNumber(825000, "DOT")}`,
                    value: 825000
                },
                {
                    label: `€ ${this.$formatNumber(850000, "DOT")}`,
                    value: 850000
                },
                {
                    label: `€ ${this.$formatNumber(875000, "DOT")}`,
                    value: 875000
                },
                {
                    label: `€ ${this.$formatNumber(900000, "DOT")}`,
                    value: 900000
                },
                {
                    label: `€ ${this.$formatNumber(925000, "DOT")}`,
                    value: 925000
                },
                {
                    label: `€ ${this.$formatNumber(950000, "DOT")}`,
                    value: 950000
                },
                {
                    label: `€ ${this.$formatNumber(975000, "DOT")}`,
                    value: 975000
                },
                {
                    label: `€ ${this.$formatNumber(1000000, "DOT")}`,
                    value: 1000000
                },
                {
                    label: `€ ${this.$formatNumber(1500000, "DOT")}`,
                    value: 1500000
                },
                {
                    label: `€ ${this.$formatNumber(2000000, "DOT")}`,
                    value: 2000000
                },
                {
                    label: `€ ${this.$formatNumber(10000000, "DOT")}`,
                    value: 10000000
                },
                {
                    label: `€ ${this.$formatNumber(100000000, "DOT")}`,
                    value: 100000000
                }
            ]
        };
    },
    mounted () {
        if (this.type === "let") {
            // Append 500 and 1000 to the options array on the second position
            this.options.splice(1, 0, {
                label: `€ ${this.$formatNumber(500, "DOT")}`,
                value: 500
            });
            this.options.splice(2, 0, {
                label: `€ ${this.$formatNumber(1000, "DOT")}`,
                value: 1000
            });
        }
        (0, $a9ufu.default).$on("updateData", (item)=>{
            // Min
            if (item.id === "min_price" && item.data) this.value.min = {
                label: `€ ${this.$formatNumber(item.data, "DOT")}`,
                value: item.data
            };
            else if (item.id === "min_price" && !item.data) this.value.min = "";
            // Max
            if (item.id === "max_price" && item.data) this.value.max = {
                label: `€ ${this.$formatNumber(item.data, "DOT")}`,
                value: item.data
            };
            else if (item.id === "max_price" && !item.data) this.value.max = "";
        });
    },
    methods: {
        edited () {
            let min = "";
            let max = "";
            if (this.value.min) min = this.value.min.value;
            if (this.value.max) max = this.value.max.value;
            (0, $a9ufu.default).$emit("setData", {
                id: "min_max_price",
                data: {
                    min: min,
                    max: max
                }
            });
        }
    }
};
var $c05c7ef60863b408$var$options = typeof $c05c7ef60863b408$var$scriptExports === "function" ? $c05c7ef60863b408$var$scriptExports.options : $c05c7ef60863b408$var$scriptExports;
var $c05c7ef60863b408$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $c05c7ef60863b408$var$options;

});

parcelRequire.register("imsTe", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $d5e0b0f8f7be33b0$export$b3890eb0ae9dca99; }, function (v) { return $d5e0b0f8f7be33b0$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $d5e0b0f8f7be33b0$export$f8436702749526f9; }, function (v) { return $d5e0b0f8f7be33b0$export$f8436702749526f9 = v; });
var $d5e0b0f8f7be33b0$export$b3890eb0ae9dca99;
var $d5e0b0f8f7be33b0$export$f8436702749526f9;
var $d5e0b0f8f7be33b0$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", {
        staticClass: "flex flex-col space-y-5 lg:items-center lg:flex-row lg:space-y-0 lg:space-x-3"
    }, [
        _c("div", {
            staticClass: "lg:w-52"
        }, [
            _c("v-select", {
                attrs: {
                    "options": _vm.options,
                    "placeholder": _vm.locales[_vm.lang].min_price,
                    "filterable": false,
                    "searchable": false
                },
                on: {
                    "input": _vm.edited
                },
                scopedSlots: _vm._u([
                    {
                        key: "open-indicator",
                        fn: function(ref) {
                            var attributes = ref.attributes;
                            return [
                                _c("span", _vm._b({}, "span", attributes, false), [
                                    _c("i", {
                                        staticClass: "text-gray-400 fal fa-chevron-down"
                                    })
                                ])
                            ];
                        }
                    }
                ]),
                model: {
                    value: _vm.value.min,
                    callback: function($$v) {
                        _vm.$set(_vm.value, "min", $$v);
                    },
                    expression: "value.min"
                }
            })
        ], 1),
        _vm._v(" "),
        _c("p", {
            staticClass: "hidden mx-5 mt-4 text-sm tracking-wider uppercase lg:block"
        }, [
            _vm._v("\n    " + _vm._s(_vm.locales[_vm.lang].to) + "\n  ")
        ]),
        _vm._v(" "),
        _c("div", {
            staticClass: "lg:w-52"
        }, [
            _c("v-select", {
                attrs: {
                    "options": _vm.options,
                    "placeholder": _vm.locales[_vm.lang].max_price,
                    "filterable": false,
                    "searchable": false
                },
                on: {
                    "input": _vm.edited
                },
                scopedSlots: _vm._u([
                    {
                        key: "open-indicator",
                        fn: function(ref) {
                            var attributes = ref.attributes;
                            return [
                                _c("span", _vm._b({}, "span", attributes, false), [
                                    _c("i", {
                                        staticClass: "text-gray-400 fal fa-chevron-down"
                                    })
                                ])
                            ];
                        }
                    }
                ]),
                model: {
                    value: _vm.value.max,
                    callback: function($$v) {
                        _vm.$set(_vm.value, "max", $$v);
                    },
                    expression: "value.max"
                }
            })
        ], 1)
    ]);
};
var $d5e0b0f8f7be33b0$var$staticRenderFns = [];
$d5e0b0f8f7be33b0$export$b3890eb0ae9dca99 = $d5e0b0f8f7be33b0$var$render;
$d5e0b0f8f7be33b0$export$f8436702749526f9 = $d5e0b0f8f7be33b0$var$staticRenderFns;

});

parcelRequire.register("4GMjQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $36a090d32929da3e$export$2e2bcd8739ae039; });
let $36a090d32929da3e$var$NOOP = ()=>{};
var $36a090d32929da3e$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("fxJ9Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b50cf7eca0eebd78$export$2e2bcd8739ae039; });
let $b50cf7eca0eebd78$var$script;





let $b50cf7eca0eebd78$var$initialize = ()=>{
    $b50cf7eca0eebd78$var$script = (parcelRequire("2i8Zv"));
    if ($b50cf7eca0eebd78$var$script.__esModule) $b50cf7eca0eebd78$var$script = $b50cf7eca0eebd78$var$script.default;
    $b50cf7eca0eebd78$var$script.render = (parcelRequire("apddX")).render;
    $b50cf7eca0eebd78$var$script.staticRenderFns = (parcelRequire("apddX")).staticRenderFns;
    $b50cf7eca0eebd78$var$script._scopeId = "data-v-8827f6";
    $b50cf7eca0eebd78$var$script.__cssModules = {};
    (parcelRequire("8To4R")).default($b50cf7eca0eebd78$var$script);
    $b50cf7eca0eebd78$var$script.__scopeId = "data-v-8827f6";
    $b50cf7eca0eebd78$var$script.__file = "FilterRooms.vue";
};
$b50cf7eca0eebd78$var$initialize();
var $b50cf7eca0eebd78$export$2e2bcd8739ae039 = $b50cf7eca0eebd78$var$script;

});
parcelRequire.register("2i8Zv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $1ab43ca76fed5384$export$2e2bcd8739ae039; });

var $a9ufu = parcelRequire("a9ufu");
var $1ab43ca76fed5384$var$scriptExports = {
    props: [
        "lang",
        "locales"
    ],
    data () {
        return {
            value: false
        };
    },
    mounted () {
        (0, $a9ufu.default).$on("updateData", (item)=>{
            if (item.id === "rooms" && item.data) this.value = item.data;
            else if (item.id === "rooms" && !item.data) this.value = false;
        });
    },
    methods: {
        action (arg) {
            if (arg === "min") {
                if (this.value > 1) this.value -= 1;
                else this.value = false;
            }
            if (arg === "plus") {
                if (this.value < 100) this.value += 1;
            }
            this.edited();
        },
        edited () {
            (0, $a9ufu.default).$emit("setData", {
                id: "rooms",
                data: this.value
            });
        }
    }
};
var $1ab43ca76fed5384$var$options = typeof $1ab43ca76fed5384$var$scriptExports === "function" ? $1ab43ca76fed5384$var$scriptExports.options : $1ab43ca76fed5384$var$scriptExports;
var $1ab43ca76fed5384$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $1ab43ca76fed5384$var$options;

});

parcelRequire.register("apddX", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $79367f31e211ef6a$export$b3890eb0ae9dca99; }, function (v) { return $79367f31e211ef6a$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $79367f31e211ef6a$export$f8436702749526f9; }, function (v) { return $79367f31e211ef6a$export$f8436702749526f9 = v; });
var $79367f31e211ef6a$export$b3890eb0ae9dca99;
var $79367f31e211ef6a$export$f8436702749526f9;
var $79367f31e211ef6a$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", {
        staticClass: "flex items-center lg:pt-2"
    }, [
        _c("button", {
            staticClass: "flex items-center justify-center w-8 h-8 transition duration-200 border rounded-full shadow border-opacity-30 border-brand-500 hover:border-opacity-50 active:bg-brand-500 active:text-white active:border-opacity-100",
            on: {
                "click": function($event) {
                    return _vm.action("min");
                }
            }
        }, [
            _c("p", {
                staticClass: "-mt-1 text-2xl"
            }, [
                _vm._v("\n      -\n    ")
            ])
        ]),
        _vm._v(" "),
        _c("div", {
            staticClass: "w-32 text-sm tracking-wider text-center uppercase"
        }, [
            _c("transition", {
                attrs: {
                    "name": "rooms"
                }
            }, [
                _vm.value > 0 ? _c("p", {
                    staticClass: "text-base"
                }, [
                    _vm._v("\n        " + _vm._s(_vm.value) + "+\n      ")
                ]) : _vm._e()
            ]),
            _vm._v(" "),
            _c("p", {
                class: _vm.value > 0 ? "text-gray-400" : ""
            }, [
                _vm._v("\n      " + _vm._s(_vm.locales[_vm.lang].rooms) + "\n    ")
            ])
        ], 1),
        _vm._v(" "),
        _c("button", {
            staticClass: "flex items-center justify-center w-8 h-8 transition duration-200 border rounded-full shadow border-opacity-30 border-brand-500 hover:border-opacity-50 active:bg-brand-500 active:text-white active:border-opacity-100",
            on: {
                "click": function($event) {
                    return _vm.action("plus");
                }
            }
        }, [
            _c("p", {
                staticClass: "text-2xl"
            }, [
                _vm._v("\n      +\n    ")
            ])
        ])
    ]);
};
var $79367f31e211ef6a$var$staticRenderFns = [];
$79367f31e211ef6a$export$b3890eb0ae9dca99 = $79367f31e211ef6a$var$render;
$79367f31e211ef6a$export$f8436702749526f9 = $79367f31e211ef6a$var$staticRenderFns;

});

parcelRequire.register("8To4R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67962312c0ff4ca6$export$2e2bcd8739ae039; });
let $67962312c0ff4ca6$var$NOOP = ()=>{};
var $67962312c0ff4ca6$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("dDOAs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ee6286c29e288fa$export$2e2bcd8739ae039; });
let $9ee6286c29e288fa$var$script;




let $9ee6286c29e288fa$var$initialize = ()=>{
    $9ee6286c29e288fa$var$script = (parcelRequire("9JH7E"));
    if ($9ee6286c29e288fa$var$script.__esModule) $9ee6286c29e288fa$var$script = $9ee6286c29e288fa$var$script.default;
    $9ee6286c29e288fa$var$script.render = (parcelRequire("ggLUh")).render;
    $9ee6286c29e288fa$var$script.staticRenderFns = (parcelRequire("ggLUh")).staticRenderFns;
    $9ee6286c29e288fa$var$script._scopeId = "data-v-9ad39c";
    (parcelRequire("6qFbG")).default($9ee6286c29e288fa$var$script);
    $9ee6286c29e288fa$var$script.__scopeId = "data-v-9ad39c";
    $9ee6286c29e288fa$var$script.__file = "FilterStatus.vue";
};
$9ee6286c29e288fa$var$initialize();
var $9ee6286c29e288fa$export$2e2bcd8739ae039 = $9ee6286c29e288fa$var$script;

});
parcelRequire.register("9JH7E", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $7169c43eab867530$export$2e2bcd8739ae039; });

var $a9ufu = parcelRequire("a9ufu");
var $7169c43eab867530$var$scriptExports = {
    props: [
        "lang",
        "locales"
    ],
    data () {
        return {
            value: false
        };
    },
    mounted () {
        (0, $a9ufu.default).$on("updateData", (item)=>{
            if (item.id === "status") this.value = item.data;
        });
    },
    methods: {
        action () {
            this.value = !this.value;
            this.edited();
        },
        edited () {
            (0, $a9ufu.default).$emit("setData", {
                id: "status",
                data: this.value
            });
        }
    }
};
var $7169c43eab867530$var$options = typeof $7169c43eab867530$var$scriptExports === "function" ? $7169c43eab867530$var$scriptExports.options : $7169c43eab867530$var$scriptExports;
var $7169c43eab867530$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $7169c43eab867530$var$options;

});

parcelRequire.register("ggLUh", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $bd834d3f53c3c5e6$export$b3890eb0ae9dca99; }, function (v) { return $bd834d3f53c3c5e6$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $bd834d3f53c3c5e6$export$f8436702749526f9; }, function (v) { return $bd834d3f53c3c5e6$export$f8436702749526f9 = v; });
var $bd834d3f53c3c5e6$export$b3890eb0ae9dca99;
var $bd834d3f53c3c5e6$export$f8436702749526f9;
var $bd834d3f53c3c5e6$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", [
        _c("button", {
            staticClass: "flex items-center px-3 py-2 space-x-3 text-sm tracking-wider text-white uppercase transition duration-200 rounded-md cursor-pointer",
            class: _vm.value ? "bg-brand-500 hover:bg-brand-400" : "bg-gray-400 hover:bg-gray-500",
            on: {
                "click": _vm.action
            }
        }, [
            _c("p", [
                _vm._v("\n      " + _vm._s(_vm.locales[_vm.lang].only_available) + "\n    ")
            ]),
            _vm._v(" "),
            _c("div", {
                staticClass: "relative w-8"
            }, [
                _c("div", {
                    staticClass: "transform transition-all duration-200 absolute top-0 left-0 z-10 w-4 h-4 -mt-1.5 text-xs bg-white rounded-full shadow-lg",
                    class: _vm.value ? "" : "translate-x-full"
                }),
                _vm._v(" "),
                _c("div", {
                    staticClass: "h-1 bg-white rounded-lg opacity-50"
                })
            ])
        ])
    ]);
};
var $bd834d3f53c3c5e6$var$staticRenderFns = [];
$bd834d3f53c3c5e6$export$b3890eb0ae9dca99 = $bd834d3f53c3c5e6$var$render;
$bd834d3f53c3c5e6$export$f8436702749526f9 = $bd834d3f53c3c5e6$var$staticRenderFns;

});

parcelRequire.register("6qFbG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ae51ec1a0477602$export$2e2bcd8739ae039; });
let $4ae51ec1a0477602$var$NOOP = ()=>{};
var $4ae51ec1a0477602$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("67Buk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $475079e1f7868aa9$export$2e2bcd8739ae039; });
let $475079e1f7868aa9$var$script;




let $475079e1f7868aa9$var$initialize = ()=>{
    $475079e1f7868aa9$var$script = (parcelRequire("1zJ9X"));
    if ($475079e1f7868aa9$var$script.__esModule) $475079e1f7868aa9$var$script = $475079e1f7868aa9$var$script.default;
    $475079e1f7868aa9$var$script.render = (parcelRequire("c1Kpa")).render;
    $475079e1f7868aa9$var$script.staticRenderFns = (parcelRequire("c1Kpa")).staticRenderFns;
    $475079e1f7868aa9$var$script._scopeId = "data-v-0281f9";
    (parcelRequire("h9gBZ")).default($475079e1f7868aa9$var$script);
    $475079e1f7868aa9$var$script.__scopeId = "data-v-0281f9";
    $475079e1f7868aa9$var$script.__file = "FilterSort.vue";
};
$475079e1f7868aa9$var$initialize();
var $475079e1f7868aa9$export$2e2bcd8739ae039 = $475079e1f7868aa9$var$script;

});
parcelRequire.register("1zJ9X", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $125c1716c95fb0ba$export$2e2bcd8739ae039; });

var $a9ufu = parcelRequire("a9ufu");
var $125c1716c95fb0ba$var$scriptExports = {
    props: [
        "lang",
        "locales"
    ],
    data () {
        return {
            value: false
        };
    },
    computed: {
        options () {
            let result = [];
            if (this.lang) result = [
                {
                    label: this.locales[this.lang].sort.relevance,
                    orderBy: "relevance",
                    order: "desc"
                },
                {
                    label: this.locales[this.lang].sort.price_h_l,
                    orderBy: "price",
                    order: "desc"
                },
                {
                    label: this.locales[this.lang].sort.price_l_h,
                    orderBy: "price",
                    order: "asc"
                }
            ];
            return result;
        }
    },
    mounted () {
        (0, $a9ufu.default).$on("updateData", (item)=>{
            if (item.id === "sort") {
                if (item.data.orderBy === "relevance") this.value = {
                    label: this.locales[this.lang].sort.relevance,
                    order: item.data.order,
                    orderBy: item.data.orderBy
                };
                if (item.data.order === "desc" && item.data.orderBy === "price") this.value = {
                    label: this.locales[this.lang].sort.price_h_l,
                    order: item.data.order,
                    orderBy: item.data.orderBy
                };
                if (item.data.order === "asc" && item.data.orderBy === "price") this.value = {
                    label: this.locales[this.lang].sort.price_l_h,
                    order: item.data.order,
                    orderBy: item.data.orderBy
                };
                if (item.data.order === "desc" && item.data.orderBy === "date") this.value = {
                    label: this.locales[this.lang].sort.date_h_l,
                    order: item.data.order,
                    orderBy: item.data.orderBy
                };
                if (item.data.order === "asc" && item.data.orderBy === "date") this.value = {
                    label: this.locales[this.lang].sort.date_l_h,
                    order: item.data.order,
                    orderBy: item.data.orderBy
                };
            }
        });
    },
    methods: {
        edited () {
            (0, $a9ufu.default).$emit("setData", {
                id: "sort",
                data: this.value
            });
        }
    }
};
var $125c1716c95fb0ba$var$options = typeof $125c1716c95fb0ba$var$scriptExports === "function" ? $125c1716c95fb0ba$var$scriptExports.options : $125c1716c95fb0ba$var$scriptExports;
var $125c1716c95fb0ba$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $125c1716c95fb0ba$var$options;

});

parcelRequire.register("c1Kpa", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $8c1993158d77bef6$export$b3890eb0ae9dca99; }, function (v) { return $8c1993158d77bef6$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $8c1993158d77bef6$export$f8436702749526f9; }, function (v) { return $8c1993158d77bef6$export$f8436702749526f9 = v; });
var $8c1993158d77bef6$export$b3890eb0ae9dca99;
var $8c1993158d77bef6$export$f8436702749526f9;
var $8c1993158d77bef6$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("v-select", {
        attrs: {
            "options": _vm.options,
            "placeholder": _vm.locales[_vm.lang].sort.label,
            "filterable": false,
            "searchable": false,
            "clearable": false
        },
        on: {
            "input": _vm.edited
        },
        scopedSlots: _vm._u([
            {
                key: "selected-option",
                fn: function(ref) {
                    var label = ref.label;
                    return [
                        _c("div", [
                            _c("span", {
                                staticClass: "font-semibold"
                            }, [
                                _vm._v("\n        " + _vm._s(_vm.locales[_vm.lang].sort.label) + "\n      ")
                            ]),
                            _vm._v(" "),
                            _c("span", [
                                _vm._v(_vm._s(label))
                            ])
                        ])
                    ];
                }
            },
            {
                key: "open-indicator",
                fn: function(ref) {
                    var attributes = ref.attributes;
                    return [
                        _c("span", _vm._b({}, "span", attributes, false), [
                            _c("i", {
                                staticClass: "text-gray-400 fal fa-chevron-down"
                            })
                        ])
                    ];
                }
            }
        ]),
        model: {
            value: _vm.value,
            callback: function($$v) {
                _vm.value = $$v;
            },
            expression: "value"
        }
    });
};
var $8c1993158d77bef6$var$staticRenderFns = [];
$8c1993158d77bef6$export$b3890eb0ae9dca99 = $8c1993158d77bef6$var$render;
$8c1993158d77bef6$export$f8436702749526f9 = $8c1993158d77bef6$var$staticRenderFns;

});

parcelRequire.register("h9gBZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c7c029a8993fe098$export$2e2bcd8739ae039; });
let $c7c029a8993fe098$var$NOOP = ()=>{};
var $c7c029a8993fe098$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("lMoeL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdb0e1a249a20cc0$export$2e2bcd8739ae039; });
let $fdb0e1a249a20cc0$var$script;





let $fdb0e1a249a20cc0$var$initialize = ()=>{
    $fdb0e1a249a20cc0$var$script = (parcelRequire("l3QjQ"));
    if ($fdb0e1a249a20cc0$var$script.__esModule) $fdb0e1a249a20cc0$var$script = $fdb0e1a249a20cc0$var$script.default;
    $fdb0e1a249a20cc0$var$script.render = (parcelRequire("9YCsF")).render;
    $fdb0e1a249a20cc0$var$script.staticRenderFns = (parcelRequire("9YCsF")).staticRenderFns;
    $fdb0e1a249a20cc0$var$script._scopeId = "data-v-910413";
    $fdb0e1a249a20cc0$var$script.__cssModules = {};
    (parcelRequire("fHIt4")).default($fdb0e1a249a20cc0$var$script);
    $fdb0e1a249a20cc0$var$script.__scopeId = "data-v-910413";
    $fdb0e1a249a20cc0$var$script.__file = "MapView.vue";
};
$fdb0e1a249a20cc0$var$initialize();
var $fdb0e1a249a20cc0$export$2e2bcd8739ae039 = $fdb0e1a249a20cc0$var$script;

});
parcelRequire.register("l3QjQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f5527640b1a3aa25$export$2e2bcd8739ae039; });
/* global google */ 
var $4KcUv = parcelRequire("4KcUv");



var $f5527640b1a3aa25$var$scriptExports = {
    components: {},
    props: [
        "markerData",
        "store",
        "lang",
        "type"
    ],
    data () {
        return {
            markerLocations: [],
            markerActive: (parcelRequire("7HX5a")),
            markerInactive: (parcelRequire("fYB20")),
            markerCluster: true,
            infoWinOpen: true,
            infoWindowPos: null,
            infoWindowData: {},
            infoOptions: {
                pixelOffset: new google.maps.Size(0, -55)
            },
            clusterStyle: [
                {
                    textColor: "white",
                    url: (parcelRequire("7jghf")),
                    height: 30,
                    width: 30,
                    textSize: 14,
                    fontFamily: "futura-pt, Helvetica, Arial, sans-serif",
                    fontWeight: "500"
                }
            ],
            options: {
                zoomControl: true,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
                disableDefaultUi: true,
                styles: [
                    {
                        featureType: "water",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#e9e9e9"
                            },
                            {
                                lightness: 17
                            }
                        ]
                    },
                    {
                        featureType: "landscape",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#f5f5f5"
                            },
                            {
                                lightness: 20
                            }
                        ]
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#ffffff"
                            },
                            {
                                lightness: 17
                            }
                        ]
                    },
                    {
                        featureType: "road.highway",
                        elementType: "geometry.stroke",
                        stylers: [
                            {
                                color: "#ffffff"
                            },
                            {
                                lightness: 29
                            },
                            {
                                weight: 0.2
                            }
                        ]
                    },
                    {
                        featureType: "road.arterial",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#ffffff"
                            },
                            {
                                lightness: 18
                            }
                        ]
                    },
                    {
                        featureType: "road.local",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#ffffff"
                            },
                            {
                                lightness: 16
                            }
                        ]
                    },
                    {
                        featureType: "poi",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#f5f5f5"
                            },
                            {
                                lightness: 21
                            }
                        ]
                    },
                    {
                        featureType: "poi.park",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#dedede"
                            },
                            {
                                lightness: 21
                            }
                        ]
                    },
                    {
                        elementType: "labels.text.stroke",
                        stylers: [
                            {
                                visibility: "on"
                            },
                            {
                                color: "#ffffff"
                            },
                            {
                                lightness: 16
                            }
                        ]
                    },
                    {
                        elementType: "labels.text.fill",
                        stylers: [
                            {
                                saturation: 36
                            },
                            {
                                color: "#333333"
                            },
                            {
                                lightness: 40
                            }
                        ]
                    },
                    {
                        elementType: "labels.icon",
                        stylers: [
                            {
                                visibility: "off"
                            }
                        ]
                    },
                    {
                        featureType: "transit",
                        elementType: "geometry",
                        stylers: [
                            {
                                color: "#f2f2f2"
                            },
                            {
                                lightness: 19
                            }
                        ]
                    },
                    {
                        featureType: "administrative",
                        elementType: "geometry.fill",
                        stylers: [
                            {
                                color: "#fefefe"
                            },
                            {
                                lightness: 20
                            }
                        ]
                    },
                    {
                        featureType: "administrative",
                        elementType: "geometry.stroke",
                        stylers: [
                            {
                                color: "#fefefe"
                            },
                            {
                                lightness: 17
                            },
                            {
                                weight: 1.2
                            }
                        ]
                    }
                ]
            },
            center: {
                lat: 50.2000285,
                lng: 4.9881758
            }
        };
    },
    watch: {
        markerData () {
            this.renderMarkers();
        }
    },
    mounted () {
        this.renderMarkers();
    },
    methods: {
        formatLink (link) {
            const title = $4KcUv(this.infoWindowData.title[this.lang], {
                lower: true,
                strict: true
            });
            const url = link.split("/");
            let prefix = "";
            if (this.lang === "nl") {
                prefix = "te-huur";
                if (this.type === "sale") prefix = "te-koop";
            } else if (this.lang === "fr") {
                prefix = "a-louer";
                if (this.type === "sale") prefix = "a-vendre";
            }
            const str = `/${this.lang}/${prefix}/${url[5]}/${title}`;
            return str;
        },
        openEstate (marker) {
            this.infoWinOpen = true;
            this.infoWindowPos = {
                lat: Number(marker.position.lat),
                lng: Number(marker.position.lng)
            };
            this.infoWindowData = marker.data;
            this.setMarkerIcon(marker);
        },
        closeEstate () {
            this.infoWinOpen = false;
            this.resetMarkers();
        },
        resetMarkers () {
            this.markerLocations.forEach((marker)=>{
                marker.icon = this.markerInactive;
            });
        },
        setMarkerIcon (marker) {
            this.resetMarkers();
            marker.icon = this.markerActive;
        },
        resetMap () {
            this.infoWinOpen = false;
            if (this.markerData.length === 0) this.$refs.gmap.$mapPromise.then(()=>{
                this.$refs.gmap.$mapObject.setCenter({
                    lat: this.center.lat,
                    lng: this.center.lng
                });
                this.$refs.gmap.$mapObject.setZoom(7);
            });
            else {
                this.markerCluster = false;
                this.$nextTick(()=>{
                    this.markerCluster = true;
                });
            }
        },
        centerMap () {
            this.$refs.gmap.$mapPromise.then(()=>{
                const bounds = new google.maps.LatLngBounds();
                for (const m of this.markerLocations)bounds.extend(m.position);
                this.$refs.gmap.$mapObject.fitBounds(bounds);
            });
        },
        drawMarkers () {
            this.markerLocations = [];
            this.markerData.forEach((marker)=>{
                this.markerLocations.push({
                    position: {
                        lat: Number(marker.location.latitude),
                        lng: Number(marker.location.longitude)
                    },
                    icon: this.markerInactive,
                    data: marker
                });
            });
        },
        renderMarkers () {
            this.drawMarkers();
            if (this.markerData.length > 0) this.centerMap();
            this.resetMap();
        }
    }
};
var $f5527640b1a3aa25$var$options = typeof $f5527640b1a3aa25$var$scriptExports === "function" ? $f5527640b1a3aa25$var$scriptExports.options : $f5527640b1a3aa25$var$scriptExports;
var $f5527640b1a3aa25$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $f5527640b1a3aa25$var$options;

});
parcelRequire.register("4KcUv", function(module, exports) {
(function(name, root, factory) {
    module.exports = factory();
    module.exports["default"] = factory();
})("slugify", module.exports, function() {
    var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","\xa2":"cent","\xa3":"pound","\xa4":"currency","\xa5":"yen","\xa9":"(c)","\xaa":"a","\xae":"(r)","\xba":"o","\xc0":"A","\xc1":"A","\xc2":"A","\xc3":"A","\xc4":"A","\xc5":"A","\xc6":"AE","\xc7":"C","\xc8":"E","\xc9":"E","\xca":"E","\xcb":"E","\xcc":"I","\xcd":"I","\xce":"I","\xcf":"I","\xd0":"D","\xd1":"N","\xd2":"O","\xd3":"O","\xd4":"O","\xd5":"O","\xd6":"O","\xd8":"O","\xd9":"U","\xda":"U","\xdb":"U","\xdc":"U","\xdd":"Y","\xde":"TH","\xdf":"ss","\xe0":"a","\xe1":"a","\xe2":"a","\xe3":"a","\xe4":"a","\xe5":"a","\xe6":"ae","\xe7":"c","\xe8":"e","\xe9":"e","\xea":"e","\xeb":"e","\xec":"i","\xed":"i","\xee":"i","\xef":"i","\xf0":"d","\xf1":"n","\xf2":"o","\xf3":"o","\xf4":"o","\xf5":"o","\xf6":"o","\xf8":"o","\xf9":"u","\xfa":"u","\xfb":"u","\xfc":"u","\xfd":"y","\xfe":"th","\xff":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E\'","Ը":"Y\'","Թ":"T\'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C\'","Կ":"K","Հ":"H","Ձ":"D\'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R\'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P\'","Ք":"Q\'","Օ":"O\'\'","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"\'","’":"\'","“":"\\"","”":"\\"","„":"\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}');
    var locales = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"\xc4":"AE","\xe4":"ae","\xd6":"OE","\xf6":"oe","\xdc":"UE","\xfc":"ue","\xdf":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","\xa2":"centavos","\xa3":"libras","\xa4":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","\xa2":"centime","\xa3":"livre","\xa4":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","\xa2":"centavo","∑":"soma","\xa3":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"\xd8":"OE","\xf8":"oe","\xc5":"AA","\xe5":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"st\xf8rre end"},"nb":{"&":"og","\xc5":"AA","\xc6":"AE","\xd8":"OE","\xe5":"aa","\xe6":"ae","\xf8":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","\xc5":"AA","\xc4":"AE","\xd6":"OE","\xe5":"aa","\xe4":"ae","\xf6":"oe"}}');
    function replace(string, options) {
        if (typeof string !== "string") throw new Error("slugify: string argument expected");
        options = typeof options === "string" ? {
            replacement: options
        } : options || {};
        var locale = locales[options.locale] || {};
        var replacement = options.replacement === undefined ? "-" : options.replacement;
        var trim = options.trim === undefined ? true : options.trim;
        var slug = string.normalize().split("")// replace characters based on charMap
        .reduce(function(result, ch) {
            var appendChar = locale[ch];
            if (appendChar === undefined) appendChar = charMap[ch];
            if (appendChar === undefined) appendChar = ch;
            if (appendChar === replacement) appendChar = " ";
            return result + appendChar// remove not allowed characters
            .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, "");
        }, "");
        if (options.strict) slug = slug.replace(/[^A-Za-z0-9\s]/g, "");
        if (trim) slug = slug.trim();
        // Replace spaces with replacement character, treating multiple consecutive
        // spaces as a single space.
        slug = slug.replace(/\s+/g, replacement);
        if (options.lower) slug = slug.toLowerCase();
        return slug;
    }
    replace.extend = function(customMap) {
        Object.assign(charMap, customMap);
    };
    return replace;
});

});

parcelRequire.register("7HX5a", function(module, exports) {


module.exports = (parcelRequire("5waPY")).getBundleURL("gjvsV") + (parcelRequire("gm4sb")).resolve("4MFFx");

});
parcelRequire.register("5waPY", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $404858fdeb70fa97$export$bdfd709ae4826697; }, function (v) { return $404858fdeb70fa97$export$bdfd709ae4826697 = v; });
var $404858fdeb70fa97$export$bdfd709ae4826697;
var $404858fdeb70fa97$export$c9e73fbda7da57b6;
var $404858fdeb70fa97$export$5a759dc7a1cfb72a;
"use strict";
var $404858fdeb70fa97$var$bundleURL = {};
function $404858fdeb70fa97$var$getBundleURLCached(id) {
    var value = $404858fdeb70fa97$var$bundleURL[id];
    if (!value) {
        value = $404858fdeb70fa97$var$getBundleURL();
        $404858fdeb70fa97$var$bundleURL[id] = value;
    }
    return value;
}
function $404858fdeb70fa97$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $404858fdeb70fa97$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $404858fdeb70fa97$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $404858fdeb70fa97$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$404858fdeb70fa97$export$bdfd709ae4826697 = $404858fdeb70fa97$var$getBundleURLCached;
$404858fdeb70fa97$export$c9e73fbda7da57b6 = $404858fdeb70fa97$var$getBaseURL;
$404858fdeb70fa97$export$5a759dc7a1cfb72a = $404858fdeb70fa97$var$getOrigin;

});


parcelRequire.register("fYB20", function(module, exports) {


module.exports = (parcelRequire("5waPY")).getBundleURL("gjvsV") + (parcelRequire("gm4sb")).resolve("hSS48");

});

parcelRequire.register("7jghf", function(module, exports) {


module.exports = (parcelRequire("5waPY")).getBundleURL("gjvsV") + (parcelRequire("gm4sb")).resolve("5gXnW");

});


parcelRequire.register("9YCsF", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $74378d47c6c324f0$export$b3890eb0ae9dca99; }, function (v) { return $74378d47c6c324f0$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $74378d47c6c324f0$export$f8436702749526f9; }, function (v) { return $74378d47c6c324f0$export$f8436702749526f9 = v; });
var $74378d47c6c324f0$export$b3890eb0ae9dca99;
var $74378d47c6c324f0$export$f8436702749526f9;
var $74378d47c6c324f0$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", {
        staticClass: "relative"
    }, [
        _c("div", {
            staticClass: "aspect-ratio-5/6 lg:hidden"
        }),
        _vm._v(" "),
        _c("div", {
            staticClass: "hidden aspect-ratio-16/9 lg:block"
        }),
        _vm._v(" "),
        _c("GmapMap", {
            ref: "gmap",
            staticClass: "js-map",
            attrs: {
                "options": _vm.options,
                "center": _vm.center,
                "zoom": 7
            },
            on: {
                "click": _vm.closeEstate
            }
        }, [
            _vm.markerCluster ? _c("GmapCluster", {
                attrs: {
                    "zoom-on-click": true,
                    "styles": _vm.clusterStyle
                }
            }, _vm._l(_vm.markerLocations, function(m, index) {
                return _c("gmap-marker", {
                    key: index,
                    ref: "marker",
                    refInFor: true,
                    attrs: {
                        "position": m.position,
                        "icon": m.icon
                    },
                    on: {
                        "click": function($event) {
                            return _vm.openEstate(m);
                        }
                    }
                });
            }), 1) : _vm._e(),
            _vm._v(" "),
            _vm.infoWinOpen ? _c("gmap-info-window", {
                attrs: {
                    "options": _vm.infoOptions,
                    "position": _vm.infoWindowPos,
                    "opened": _vm.infoWinOpen
                },
                on: {
                    "closeclick": _vm.closeEstate
                }
            }, [
                _vm.infoWindowData.location ? _c("a", {
                    staticClass: "block max-w-xs",
                    attrs: {
                        "href": _vm.formatLink(_vm.infoWindowData.permalink),
                        "target": "_blank"
                    }
                }, [
                    _c("div", {
                        staticClass: "relative"
                    }, [
                        _vm.infoWindowData.status === "sold" || _vm.infoWindowData.status === "option" || _vm.infoWindowData.status === "under_contract" ? _c("p", {
                            staticClass: "absolute top-0 right-0 z-10 px-2 py-1 m-2 text-sm tracking-wider text-white uppercase rounded-md bg-danger-500"
                        }, [
                            _vm.infoWindowData.status === "sold" ? [
                                _vm._v("Verkocht")
                            ] : _vm._e(),
                            _vm._v(" "),
                            _vm.infoWindowData.status === "under_contract" ? [
                                _vm._v("\n              Onder contract\n            ")
                            ] : _vm._e(),
                            _vm._v(" "),
                            _vm.infoWindowData.status === "option" ? [
                                _vm._v("\n              In optie\n            ")
                            ] : _vm._e()
                        ], 2) : _vm._e(),
                        _vm._v(" "),
                        _c("div", {
                            staticClass: "aspect-ratio-16/9"
                        }),
                        _vm._v(" "),
                        _c("img", {
                            staticClass: "absolute top-0 left-0 object-cover object-center w-full h-full",
                            attrs: {
                                "src": _vm.infoWindowData.image
                            }
                        })
                    ]),
                    _vm._v(" "),
                    _c("div", {
                        staticClass: "p-5 text-white bg-brand-500"
                    }, [
                        _c("p", {
                            staticClass: "text-lg font-medium"
                        }, [
                            _vm._v("\n            " + _vm._s(_vm.infoWindowData.title[_vm.lang]) + "\n          ")
                        ]),
                        _vm._v(" "),
                        _vm.infoWindowData.status === "available" ? _c("div", {
                            staticClass: "mt-1"
                        }, [
                            _c("p", {
                                staticClass: "mb-1 opacity-80"
                            }, [
                                _vm._v("\n              " + _vm._s(_vm.infoWindowData.location.street) + ",\n              " + _vm._s(_vm.infoWindowData.location.postal_code) + "\n              " + _vm._s(_vm.infoWindowData.location.city) + "\n            ")
                            ]),
                            _vm._v(" "),
                            _c("p", [
                                _vm._v("\n              €\n              " + _vm._s(_vm.$formatNumber(parseInt(_vm.infoWindowData.price), "DOT")) + "\n            ")
                            ])
                        ]) : _vm._e()
                    ])
                ]) : _vm._e()
            ]) : _vm._e()
        ], 1)
    ], 1);
};
var $74378d47c6c324f0$var$staticRenderFns = [];
$74378d47c6c324f0$export$b3890eb0ae9dca99 = $74378d47c6c324f0$var$render;
$74378d47c6c324f0$export$f8436702749526f9 = $74378d47c6c324f0$var$staticRenderFns;

});

parcelRequire.register("fHIt4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6ed5d8c6f6439e4$export$2e2bcd8739ae039; });
let $b6ed5d8c6f6439e4$var$NOOP = ()=>{};
var $b6ed5d8c6f6439e4$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("d67vX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9891aa1aa9f5cdbf$export$2e2bcd8739ae039; });
let $9891aa1aa9f5cdbf$var$script;




let $9891aa1aa9f5cdbf$var$initialize = ()=>{
    $9891aa1aa9f5cdbf$var$script = (parcelRequire("4V0BN"));
    if ($9891aa1aa9f5cdbf$var$script.__esModule) $9891aa1aa9f5cdbf$var$script = $9891aa1aa9f5cdbf$var$script.default;
    $9891aa1aa9f5cdbf$var$script.render = (parcelRequire("6F5a3")).render;
    $9891aa1aa9f5cdbf$var$script.staticRenderFns = (parcelRequire("6F5a3")).staticRenderFns;
    $9891aa1aa9f5cdbf$var$script._scopeId = "data-v-a26e08";
    (parcelRequire("fXODd")).default($9891aa1aa9f5cdbf$var$script);
    $9891aa1aa9f5cdbf$var$script.__scopeId = "data-v-a26e08";
    $9891aa1aa9f5cdbf$var$script.__file = "SearchFilter.vue";
};
$9891aa1aa9f5cdbf$var$initialize();
var $9891aa1aa9f5cdbf$export$2e2bcd8739ae039 = $9891aa1aa9f5cdbf$var$script;

});
parcelRequire.register("4V0BN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $394cf528c01a7cbe$export$2e2bcd8739ae039; });

var $guGMf = parcelRequire("guGMf");

var $a9ufu = parcelRequire("a9ufu");

const $394cf528c01a7cbe$var$state = (parcelRequire("cUFT1"))();
var $394cf528c01a7cbe$var$scriptExports = {
    components: {
        GeoSuggest: $guGMf.GeoSuggest
    },
    props: [
        "store",
        "lang"
    ],
    data () {
        return {
            search: "",
            searchDefault: "",
            searchEdited: false,
            geosuggest: {
                open: false,
                selectedSuggestion: null,
                address: null
            }
        };
    },
    mounted () {
        (0, $guGMf.loadGmaps)("AIzaSyD5l9tULwAjtCepaEn8IcMpVrYGO8LeHL4");
        (0, $a9ufu.default).$on("updateData", (item)=>{
            if (item.id === "location") this.searchDefault = item.data.region;
        });
        this.$nextTick(()=>{
            if ($394cf528c01a7cbe$var$state.get("region")) this.searchDefault = decodeURI($394cf528c01a7cbe$var$state.get("region"));
        });
    },
    methods: {
        formatDescription (description, matchedSubstrings) {
            const search = description.replace(/,[^,]+$/, "");
            const matches = description.substr(matchedSubstrings.offset, matchedSubstrings.length);
            const unmatched = search.substr(matchedSubstrings.length, search.length);
            return [
                matches,
                unmatched
            ];
        },
        clearSearch () {
            this.searchDefault = "";
            (0, $a9ufu.default).$emit("setData", {
                id: "location",
                data: {
                    location: false,
                    region: ""
                }
            });
        },
        searchBlur () {
            if (!this.searchDefault) (0, $a9ufu.default).$emit("setData", {
                id: "location",
                data: {
                    location: false,
                    region: ""
                }
            });
        },
        openSuggest () {
            this.searchEdited = true;
            this.geosuggest.open = true;
        },
        closeSuggest () {
            this.geosuggest.open = false;
        },
        setSuggestion (suggestion) {
            this.geosuggest.selectedSuggestion = suggestion;
            this.closeSuggest();
        },
        geocode ($event) {
            this.searchDefault = $event.name;
            if ($event.normalizedAddress.postalCode) {
                if (isNaN(this.searchDefault)) this.searchDefault += ` (${$event.normalizedAddress.postalCode})`;
                else this.searchDefault += ` (${$event.normalizedAddress.city})`;
            }
            (0, $a9ufu.default).$emit("setData", {
                id: "location",
                data: {
                    location: $event.location,
                    region: this.searchDefault
                }
            });
        }
    }
};
var $394cf528c01a7cbe$var$options = typeof $394cf528c01a7cbe$var$scriptExports === "function" ? $394cf528c01a7cbe$var$scriptExports.options : $394cf528c01a7cbe$var$scriptExports;
var $394cf528c01a7cbe$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $394cf528c01a7cbe$var$options;

});
parcelRequire.register("guGMf", function(module, exports) {

$parcel$export(module.exports, "GeoSuggest", function () { return $c020a15615033660$export$e612fec99a671b19; });
$parcel$export(module.exports, "loadGmaps", function () { return $c020a15615033660$export$db5bd14216b48c67; });
var $c020a15615033660$var$t = function(t, e) {
    return (((t || "").match(e) || [])[1] || "").replace(/&#(\d+);/g, function(t, e) {
        return String.fromCharCode(e);
    });
}, $c020a15615033660$export$e612fec99a671b19 = {
    name: "GeoSuggest",
    props: {
        search: {
            type: String,
            required: !1
        },
        minLength: {
            type: Number,
            default: 3
        },
        suggestion: {
            required: !1,
            validator: function(t) {
                return "object" == typeof t && "string" == typeof t.description || "string" == typeof t;
            }
        },
        debounce: {
            type: Function,
            required: !1
        },
        types: {
            type: Array,
            required: !1
        },
        location: {
            type: Object,
            required: !1
        },
        radius: {
            type: Number,
            default: 0
        },
        bounds: {
            type: Object,
            required: !1
        },
        country: {
            type: [
                String,
                Array
            ],
            required: !1
        },
        placeDetailFields: {
            type: Array,
            required: !1
        },
        googleMaps: {
            type: [
                Object,
                Function
            ],
            required: !1
        }
    },
    data: function() {
        return {
            loading: !1,
            suggestions: [],
            t: null,
            i: null,
            o: null,
            s: null,
            u: null
        };
    },
    computed: {
        h: function() {
            return this.debounce ? this.debounce(this.p) : this.p;
        }
    },
    watch: {
        search: {
            immediate: !0,
            handler: function() {
                this.h();
            }
        },
        suggestion: {
            immediate: !0,
            handler: function(t) {
                t && "object" == typeof t && this.l(t);
            }
        }
    },
    methods: {
        g: function() {
            if (!this.t) {
                if (this.googleMaps) this.t = this.googleMaps;
                else {
                    if (!window.google) return console.warn("Tried to init GeoSuggest before loading GMaps"), !1;
                    this.t = window.google.maps;
                }
                this.i = new this.t.places.AutocompleteService, this.o = new this.t.places.PlacesService(document.createElement("div")), this.s = new this.t.places.AutocompleteSessionToken, this.u = new this.t.Geocoder;
            }
            return !0;
        },
        p: function() {
            var t = this;
            if (this.search) {
                if ((this.t || this.g()) && !(this.minLength && this.search.length < this.minLength) && this.i) {
                    var e = {
                        input: this.search,
                        sessionToken: this.s,
                        location: this.location,
                        radius: this.radius,
                        bounds: this.bounds,
                        types: this.types,
                        componentRestrictions: this.country ? {
                            country: this.country
                        } : void 0
                    };
                    this.loading = !0, this.i.getPlacePredictions(e, function(e) {
                        t.loading = !1, t.m(e || []);
                    });
                }
            } else this.m();
        },
        m: function(t) {
            void 0 === t && (t = []), this.suggestions = t.map(function(t) {
                return {
                    placeId: t.place_id,
                    description: t.description,
                    matchedSubstrings: t.matched_substrings[0]
                };
            }), this.$emit("suggestions", [].concat(this.suggestions));
        },
        l: function(t) {
            var e = this;
            if (this.u || this.g()) {
                if (t.placeId && this.o) {
                    var i = {
                        placeId: t.placeId,
                        sessionToken: this.s,
                        fields: this.placeDetailFields
                    };
                    this.o.getDetails(i, function(i, n) {
                        n === e.t.places.PlacesServiceStatus.OK ? (e.s = new e.t.places.AutocompleteSessionToken, e.v(t, i)) : e.j({
                            status: n
                        });
                    });
                } else {
                    var n = {
                        address: t.description,
                        bounds: this.bounds,
                        location: this.location,
                        componentRestrictions: this.country ? {
                            country: this.country
                        } : void 0
                    };
                    this.u.geocode(n, function(i, n) {
                        var o = i[0];
                        n === e.t.GeocoderStatus.OK ? e.v(t, o) : e.j({
                            status: n
                        });
                    });
                }
            }
        },
        j: function(t) {
            var e = t.status;
            this.$emit("error", {
                status: e
            });
        },
        v: function(t, e) {
            var i = (e.geometry || {}).location, n = Object.assign({}, t, {
                gmaps: e,
                location: i && {
                    lat: i.lat(),
                    lng: i.lng()
                }
            });
            this.$emit("geocoded", this.S(n));
        },
        S: function(e) {
            var i = (e.gmaps.address_components || []).reduce(function(t, e) {
                return Object.assign({}, t, e.types.reduce(function(t, i) {
                    var n;
                    return Object.assign({}, t, ((n = {})[i] = {
                        longName: e.long_name,
                        shortName: e.short_name
                    }, n));
                }, {}));
            }, {}), n = i.postal_code;
            void 0 === n && (n = {});
            var o = i.locality;
            void 0 === o && (o = {});
            var s = i.country;
            void 0 === s && (s = {});
            var r, d = i.administrative_area_level_1;
            void 0 === d && (d = {});
            var u = $c020a15615033660$var$t(e.gmaps.adr_address, /"street-address"\s*>(.+?)</i).replace(", " + (o.longName || "NO MATCH"), "");
            u ? r = e.gmaps.name !== u ? e.gmaps.name : "" : (u = e.gmaps.name, i.route && ![
                "street_address",
                "route"
            ].some(function(t) {
                return (e.gmaps.types || []).includes(t);
            }) && (r = u, u = i.route.longName + (i.street_number ? ", " + i.street_number.shortName : "")));
            var a = $c020a15615033660$var$t(e.gmaps.adr_address, /"region"\s*>(.+?)</i) || o.shortName || d.shortName, c = {
                streetAddress1: u,
                streetAddress2: r,
                region: a,
                city: o.longName || d.longName,
                postalCode: n.longName,
                countryName: s.longName,
                countryIso2: s.shortName
            };
            return Object.assign({}, e, {
                region: a,
                normalizedAddress: c,
                addressComponentMap: i,
                formattedAddress: e.gmaps.formatted_address,
                name: e.gmaps.name,
                types: e.gmaps.types
            });
        }
    },
    render: function() {
        return this.$scopedSlots.default && this.$scopedSlots.default({
            loading: this.loading,
            suggestions: this.suggestions
        });
    }
};
function $c020a15615033660$export$db5bd14216b48c67(t, e) {
    try {
        if ("undefined" == typeof window || "undefined" == typeof document) return;
        if ("object" == typeof window.google && "object" == typeof window.google.maps) {
            if ("object" == typeof window.google.maps.places) return;
            throw new Error("Google Maps is already loaded, but does not contain the places API.");
        }
        if (window.initVGAMaps = window.initVGAMaps || function() {
            this.loaded = !0;
        }, window.initVGAMaps.loaded) throw new Error("LoadGmaps loaded multiple times.");
        var i = document.createElement("script"), n = {
            libraries: "places",
            callback: "initVGAMaps"
        };
        if ("string" == typeof t) n.key = t;
        else {
            if ("object" != typeof t) throw new TypeError("apiKey should either be a string or an object");
            Object.keys(t).forEach(function(e) {
                n[e] = t[e];
            });
        }
        var o = "https://maps.googleapis.com/maps/api/js?" + Object.keys(n).map(function(t) {
            return encodeURIComponent(t) + "=" + encodeURIComponent(n[t]);
        }).join("&");
        e && (o = o + "&v=" + e), i.setAttribute("src", o), i.setAttribute("async", ""), i.setAttribute("defer", ""), document.body.append(i);
    } catch (t) {
        throw t.message = "LoadGmaps load error:" + t.message, t;
    }
}
function $c020a15615033660$var$n(t, o) {
    void 0 === o && (o = {});
    var s = o.apiKey;
    void 0 === s && (s = ""), $c020a15615033660$var$n.installed || ($c020a15615033660$var$n.installed = !0, t.component($c020a15615033660$export$e612fec99a671b19.name, $c020a15615033660$export$e612fec99a671b19), s && $c020a15615033660$export$db5bd14216b48c67(s));
}
var $c020a15615033660$var$o = null;
"undefined" != typeof window ? $c020a15615033660$var$o = window.Vue : "undefined" != typeof $parcel$global && ($c020a15615033660$var$o = $parcel$global.Vue), $c020a15615033660$var$o && $c020a15615033660$var$o.use({
    install: $c020a15615033660$var$n
}), $c020a15615033660$export$e612fec99a671b19.install = $c020a15615033660$var$n;
var $c020a15615033660$export$2e2bcd8739ae039 = $c020a15615033660$export$e612fec99a671b19;

});

parcelRequire.register("cUFT1", function(module, exports) {
"use strict";
var $966b34c83b04602c$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $966b34c83b04602c$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $966b34c83b04602c$var$QueryState(queryString, config) {
    var _this = this;
    var userConfig = config;
    this.queryState = {};
    this.config = {
        autoApply: true,
        castsToArray: false
    };
    var q = queryString;
    if ((typeof q === "undefined" ? "undefined" : $966b34c83b04602c$var$_typeof(q)) === "object") {
        userConfig = q;
        q = undefined;
    }
    if (q === undefined && typeof window !== "undefined") q = window.location.search;
    if (userConfig !== undefined) Object.keys(userConfig).forEach(function(key) {
        _this.config[key] = userConfig[key];
    });
    if (q !== undefined) {
        var string = q;
        if (q.indexOf("?") !== -1) string = q.split("?")[1];
        var params = string.split("&");
        if (params[0].length) params.forEach(function(param) {
            var _param$split$map = param.split("=").map(decodeURIComponent), _param$split$map2 = $966b34c83b04602c$var$_slicedToArray(_param$split$map, 2), key = _param$split$map2[0], value = _param$split$map2[1];
            var arrayValue = (value || "").split(",");
            if (arrayValue.length !== 1) _this.queryState[key] = arrayValue;
            else _this.queryState[key] = value;
        });
    }
}

$966b34c83b04602c$var$QueryState.prototype.get = (parcelRequire("bLpu7"));

$966b34c83b04602c$var$QueryState.prototype.set = (parcelRequire("kyBR6"));

$966b34c83b04602c$var$QueryState.prototype.remove = (parcelRequire("dZJaO"));

$966b34c83b04602c$var$QueryState.prototype.all = (parcelRequire("dgnNT"));

$966b34c83b04602c$var$QueryState.prototype.apply = (parcelRequire("cLAUR"));

$966b34c83b04602c$var$QueryState.prototype.toQueryString = (parcelRequire("1kNm3"));
module.exports = function(queryString, config) {
    return new $966b34c83b04602c$var$QueryState(queryString, config);
};

});
parcelRequire.register("bLpu7", function(module, exports) {
"use strict";
module.exports = function get(key) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (this.queryState[key] !== undefined) {
        if (this.config.castsToArray && !Array.isArray(this.queryState[key])) return [
            this.queryState[key]
        ];
        return this.queryState[key];
    }
    if (typeof defaultValue === "function") return defaultValue();
    return defaultValue;
};

});

parcelRequire.register("kyBR6", function(module, exports) {
"use strict";
var $ef7458efac7c620d$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
module.exports = function set(key, value) {
    var _this = this;
    if ((typeof key === "undefined" ? "undefined" : $ef7458efac7c620d$var$_typeof(key)) !== "object") this.queryState[key] = value;
    else Object.keys(key).forEach(function(prop) {
        _this.queryState[prop] = key[prop];
    });
    if (typeof window !== "undefined" && this.config.autoApply) this.apply();
    return this;
};

});

parcelRequire.register("dZJaO", function(module, exports) {
"use strict";
module.exports = function remove(key) {
    if (this.queryState[key] !== undefined) delete this.queryState[key];
    if (typeof window !== "undefined" && this.config.autoApply) this.apply();
    return this;
};

});

parcelRequire.register("dgnNT", function(module, exports) {
"use strict";
module.exports = function all() {
    var _this = this;
    var state = {};
    Object.keys(this.queryState).forEach(function(key) {
        state[key] = _this.get(key);
    });
    return state;
};

});

parcelRequire.register("cLAUR", function(module, exports) {
"use strict";
module.exports = function apply() {
    window.history.pushState(null, null, this.toQueryString());
};

});

parcelRequire.register("1kNm3", function(module, exports) {
"use strict";
module.exports = function toQueryString() {
    var _this = this;
    var params = Object.keys(this.queryState).map(function(key) {
        var value = _this.queryState[key];
        if (Array.isArray(value)) return encodeURIComponent(key) + "=" + value.map(encodeURIComponent).join(",");
        return encodeURIComponent(key) + "=" + encodeURIComponent(value);
    });
    return "?" + params.join("&");
};

});



parcelRequire.register("6F5a3", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $4d9a9355ea84dd0b$export$b3890eb0ae9dca99; }, function (v) { return $4d9a9355ea84dd0b$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $4d9a9355ea84dd0b$export$f8436702749526f9; }, function (v) { return $4d9a9355ea84dd0b$export$f8436702749526f9 = v; });
var $4d9a9355ea84dd0b$export$b3890eb0ae9dca99;
var $4d9a9355ea84dd0b$export$f8436702749526f9;
var $4d9a9355ea84dd0b$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", {
        staticClass: "w-full 2xl:max-w-lg"
    }, [
        _c("div", {
            staticClass: "relative"
        }, [
            _c("div", {
                staticClass: "relative"
            }, [
                _vm.searchDefault ? _c("i", {
                    staticClass: "absolute top-0 right-0 mt-3 text-xl text-gray-400 transition duration-200 cursor-pointer fal fa-times-circle hover:text-black",
                    on: {
                        "click": _vm.clearSearch
                    }
                }) : _c("i", {
                    staticClass: "absolute top-0 right-0 mt-4 text-gray-400 fal fa-search"
                }),
                _vm._v(" "),
                _c("input", {
                    directives: [
                        {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchDefault,
                            expression: "searchDefault"
                        }
                    ],
                    staticClass: "pr-6",
                    attrs: {
                        "type": "text",
                        "placeholder": _vm.store.locales[_vm.lang].search
                    },
                    domProps: {
                        "value": _vm.searchDefault
                    },
                    on: {
                        "input": [
                            function($event) {
                                if ($event.target.composing) return;
                                _vm.searchDefault = $event.target.value;
                            },
                            _vm.openSuggest
                        ],
                        "change": _vm.searchBlur
                    }
                })
            ]),
            _vm._v(" "),
            _c("GeoSuggest", {
                attrs: {
                    "country": "be",
                    "types": [
                        "(regions)"
                    ],
                    "search": _vm.searchDefault,
                    "suggestion": _vm.geosuggest.selectedSuggestion
                },
                on: {
                    "geocoded": function($event) {
                        return _vm.geocode($event);
                    }
                },
                scopedSlots: _vm._u([
                    {
                        key: "default",
                        fn: function(ref) {
                            var suggestions = ref.suggestions;
                            return [
                                suggestions.length && _vm.geosuggest.open ? _c("div", {
                                    staticClass: "absolute left-0 z-50 w-full top-full"
                                }, [
                                    _c("ul", {
                                        staticClass: "py-1 bg-white shadow-sm"
                                    }, _vm._l(suggestions, function(suggestion, index) {
                                        return _c("li", {
                                            key: index,
                                            staticClass: "px-3 py-2 text-lg transition duration-200 cursor-pointer hover:bg-gray-100",
                                            on: {
                                                "click": function($event) {
                                                    return _vm.setSuggestion(suggestion);
                                                }
                                            }
                                        }, [
                                            _c("span", {
                                                staticClass: "font-bold"
                                            }, [
                                                _vm._v(_vm._s(_vm.formatDescription(suggestion.description, suggestion.matchedSubstrings)[0]))
                                            ]),
                                            _c("span", {
                                                staticClass: "opacity-70"
                                            }, [
                                                _vm._v(_vm._s(_vm.formatDescription(suggestion.description, suggestion.matchedSubstrings)[1]))
                                            ])
                                        ]);
                                    }), 0)
                                ]) : _vm._e()
                            ];
                        }
                    }
                ])
            })
        ], 1)
    ]);
};
var $4d9a9355ea84dd0b$var$staticRenderFns = [];
$4d9a9355ea84dd0b$export$b3890eb0ae9dca99 = $4d9a9355ea84dd0b$var$render;
$4d9a9355ea84dd0b$export$f8436702749526f9 = $4d9a9355ea84dd0b$var$staticRenderFns;

});

parcelRequire.register("fXODd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9f3a40c89b06561$export$2e2bcd8739ae039; });
let $b9f3a40c89b06561$var$NOOP = ()=>{};
var $b9f3a40c89b06561$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("kHxEk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f121ece160105afa$export$2e2bcd8739ae039; });
let $f121ece160105afa$var$script;





let $f121ece160105afa$var$initialize = ()=>{
    $f121ece160105afa$var$script = (parcelRequire("lqaLz"));
    if ($f121ece160105afa$var$script.__esModule) $f121ece160105afa$var$script = $f121ece160105afa$var$script.default;
    $f121ece160105afa$var$script.render = (parcelRequire("4jbd8")).render;
    $f121ece160105afa$var$script.staticRenderFns = (parcelRequire("4jbd8")).staticRenderFns;
    $f121ece160105afa$var$script._scopeId = "data-v-f8ed9b";
    $f121ece160105afa$var$script.__cssModules = {};
    (parcelRequire("5XQDv")).default($f121ece160105afa$var$script);
    $f121ece160105afa$var$script.__scopeId = "data-v-f8ed9b";
    $f121ece160105afa$var$script.__file = "CardDefault.vue";
};
$f121ece160105afa$var$initialize();
var $f121ece160105afa$export$2e2bcd8739ae039 = $f121ece160105afa$var$script;

});
parcelRequire.register("lqaLz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0406439f8b171d37$export$2e2bcd8739ae039; });

var $hr0I9 = parcelRequire("hr0I9");

var $2YtuV = parcelRequire("2YtuV");

var $ac5cV = parcelRequire("ac5cV");

var $gIPS7 = parcelRequire("gIPS7");

var $4KcUv = parcelRequire("4KcUv");
var $0406439f8b171d37$var$scriptExports = {
    components: {
        IconLeft: $ac5cV.default,
        IconRight: $gIPS7.default,
        [(0, $2YtuV.Glide).name]: (0, $2YtuV.Glide),
        [(0, $2YtuV.GlideSlide).name]: (0, $2YtuV.GlideSlide)
    },
    props: [
        "loading",
        "estate",
        "estateData",
        "locales"
    ],
    data () {
        return {
            glideOptions: {
                type: "carousel",
                perView: 1,
                gap: 0,
                keyboard: false
            }
        };
    },
    mounted () {
        new (0, (/*@__PURE__*/$parcel$interopDefault($hr0I9)))({
            elements_selector: ".lazy",
            unobserve_entered: true
        });
    },
    methods: {
        prevent () {
            return false;
        },
        formatLink (link) {
            const title = $4KcUv(this.estate.meta.estate.title[this.estateData.lang], {
                lower: true,
                strict: true
            });
            const url = link.split("/");
            let prefix = "";
            if (this.estateData.lang === "nl") {
                prefix = "te-huur";
                if (this.estate.meta.features.negotiation === "sale") prefix = "te-koop";
            } else if (this.estateData.lang === "fr") {
                prefix = "a-louer";
                if (this.estate.meta.features.negotiation === "sale") prefix = "a-vendre";
            }
            const str = `/${this.estateData.lang}/${prefix}/${url[5]}/${title}`;
            return str;
        },
        formatType (type) {
            let output = "";
            switch(type){
                case "apartment":
                    if (this.estateData.lang === "nl") output = "Appartement";
                    else if (this.estateData.lang === "fr") output = "Appartement";
                    break;
                case "commercial":
                    if (this.estateData.lang === "nl") output = "Winkelpand";
                    else if (this.estateData.lang === "fr") output = "Magasin";
                    break;
                case "house":
                    if (this.estateData.lang === "nl") output = "Huis";
                    else if (this.estateData.lang === "fr") output = "Maison";
                    break;
                case "land":
                    if (this.estateData.lang === "nl") output = "Grond";
                    else if (this.estateData.lang === "fr") output = "Terrain";
                    break;
                case "office":
                    if (this.estateData.lang === "nl") output = "Kantoor";
                    else if (this.estateData.lang === "fr") output = "Office";
                    break;
                case "parking":
                    if (this.estateData.lang === "nl") output = "Parking";
                    else if (this.estateData.lang === "fr") output = "Parking";
                    break;
                default:
                    break;
            }
            return output;
        },
        formatNegotiation (negotiation) {
            let output = "";
            switch(negotiation){
                case "sale":
                    if (this.estateData.lang === "nl") output = "te koop";
                    else if (this.estateData.lang === "fr") output = "\xe0 vendre";
                    break;
                case "let":
                    if (this.estateData.lang === "nl") output = "te huur";
                    else if (this.estateData.lang === "fr") output = "\xe0 louer";
                    break;
                default:
                    break;
            }
            return output;
        },
        formatEPC (label) {
            if (label === "A++" && this.estateData.lang === "nl") label = "a+";
            if (label === "G" && this.estateData.lang === "nl") label = "f";
            return label.toLowerCase();
        }
    }
};
var $0406439f8b171d37$var$options = typeof $0406439f8b171d37$var$scriptExports === "function" ? $0406439f8b171d37$var$scriptExports.options : $0406439f8b171d37$var$scriptExports;
var $0406439f8b171d37$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $0406439f8b171d37$var$options;

});
parcelRequire.register("hr0I9", function(module, exports) {
!function(n, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    function n() {
        return n = Object.assign || function(n) {
            for(var t = 1; t < arguments.length; t++){
                var e = arguments[t];
                for(var i in e)Object.prototype.hasOwnProperty.call(e, i) && (n[i] = e[i]);
            }
            return n;
        }, n.apply(this, arguments);
    }
    var t = "undefined" != typeof window, e = t && !("onscroll" in window) || "undefined" != typeof navigator && /(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent), i = t && "IntersectionObserver" in window, o = t && "classList" in document.createElement("p"), a = t && window.devicePixelRatio > 1, r = {
        elements_selector: ".lazy",
        container: e || t ? document : null,
        threshold: 300,
        thresholds: null,
        data_src: "src",
        data_srcset: "srcset",
        data_sizes: "sizes",
        data_bg: "bg",
        data_bg_hidpi: "bg-hidpi",
        data_bg_multi: "bg-multi",
        data_bg_multi_hidpi: "bg-multi-hidpi",
        data_bg_set: "bg-set",
        data_poster: "poster",
        class_applied: "applied",
        class_loading: "loading",
        class_loaded: "loaded",
        class_error: "error",
        class_entered: "entered",
        class_exited: "exited",
        unobserve_completed: !0,
        unobserve_entered: !1,
        cancel_on_exit: !0,
        callback_enter: null,
        callback_exit: null,
        callback_applied: null,
        callback_loading: null,
        callback_loaded: null,
        callback_error: null,
        callback_finish: null,
        callback_cancel: null,
        use_native: !1,
        restore_on_error: !1
    }, c = function(t) {
        return n({}, r, t);
    }, l = function(n, t) {
        var e, i = "LazyLoad::Initialized", o = new n(t);
        try {
            e = new CustomEvent(i, {
                detail: {
                    instance: o
                }
            });
        } catch (n) {
            (e = document.createEvent("CustomEvent")).initCustomEvent(i, !1, !1, {
                instance: o
            });
        }
        window.dispatchEvent(e);
    }, u = "src", s = "srcset", d = "sizes", f = "poster", _ = "llOriginalAttrs", g = "data", v = "loading", b = "loaded", m = "applied", p = "error", h = "native", E = "data-", I = "ll-status", y = function(n, t) {
        return n.getAttribute(E + t);
    }, k = function(n) {
        return y(n, I);
    }, w = function(n, t) {
        return function(n, t, e) {
            var i = "data-ll-status";
            null !== e ? n.setAttribute(i, e) : n.removeAttribute(i);
        }(n, 0, t);
    }, A = function(n) {
        return w(n, null);
    }, L = function(n) {
        return null === k(n);
    }, O = function(n) {
        return k(n) === h;
    }, x = [
        v,
        b,
        m,
        p
    ], C = function(n, t, e, i) {
        n && (void 0 === i ? void 0 === e ? n(t) : n(t, e) : n(t, e, i));
    }, N = function(n, t) {
        o ? n.classList.add(t) : n.className += (n.className ? " " : "") + t;
    }, M = function(n, t) {
        o ? n.classList.remove(t) : n.className = n.className.replace(new RegExp("(^|\\s+)" + t + "(\\s+|$)"), " ").replace(/^\s+/, "").replace(/\s+$/, "");
    }, z = function(n) {
        return n.llTempImage;
    }, T = function(n, t) {
        if (t) {
            var e = t._observer;
            e && e.unobserve(n);
        }
    }, R = function(n, t) {
        n && (n.loadingCount += t);
    }, G = function(n, t) {
        n && (n.toLoadCount = t);
    }, j = function(n) {
        for(var t, e = [], i = 0; t = n.children[i]; i += 1)"SOURCE" === t.tagName && e.push(t);
        return e;
    }, D = function(n, t) {
        var e = n.parentNode;
        e && "PICTURE" === e.tagName && j(e).forEach(t);
    }, H = function(n, t) {
        j(n).forEach(t);
    }, V = [
        u
    ], F = [
        u,
        f
    ], B = [
        u,
        s,
        d
    ], J = [
        g
    ], P = function(n) {
        return !!n[_];
    }, S = function(n) {
        return n[_];
    }, U = function(n) {
        return delete n[_];
    }, $ = function(n, t) {
        if (!P(n)) {
            var e = {};
            t.forEach(function(t) {
                e[t] = n.getAttribute(t);
            }), n[_] = e;
        }
    }, q = function(n, t) {
        if (P(n)) {
            var e = S(n);
            t.forEach(function(t) {
                !function(n, t, e) {
                    e ? n.setAttribute(t, e) : n.removeAttribute(t);
                }(n, t, e[t]);
            });
        }
    }, K = function(n, t, e) {
        N(n, t.class_applied), w(n, m), e && (t.unobserve_completed && T(n, t), C(t.callback_applied, n, e));
    }, Q = function(n, t, e) {
        N(n, t.class_loading), w(n, v), e && (R(e, 1), C(t.callback_loading, n, e));
    }, W = function(n, t, e) {
        e && n.setAttribute(t, e);
    }, X = function(n, t) {
        W(n, d, y(n, t.data_sizes)), W(n, s, y(n, t.data_srcset)), W(n, u, y(n, t.data_src));
    }, Y = {
        IMG: function(n, t) {
            D(n, function(n) {
                $(n, B), X(n, t);
            }), $(n, B), X(n, t);
        },
        IFRAME: function(n, t) {
            $(n, V), W(n, u, y(n, t.data_src));
        },
        VIDEO: function(n, t) {
            H(n, function(n) {
                $(n, V), W(n, u, y(n, t.data_src));
            }), $(n, F), W(n, f, y(n, t.data_poster)), W(n, u, y(n, t.data_src)), n.load();
        },
        OBJECT: function(n, t) {
            $(n, J), W(n, g, y(n, t.data_src));
        }
    }, Z = [
        "IMG",
        "IFRAME",
        "VIDEO",
        "OBJECT"
    ], nn = function(n, t) {
        !t || function(n) {
            return n.loadingCount > 0;
        }(t) || function(n) {
            return n.toLoadCount > 0;
        }(t) || C(n.callback_finish, t);
    }, tn = function(n, t, e) {
        n.addEventListener(t, e), n.llEvLisnrs[t] = e;
    }, en = function(n, t, e) {
        n.removeEventListener(t, e);
    }, on = function(n) {
        return !!n.llEvLisnrs;
    }, an = function(n) {
        if (on(n)) {
            var t = n.llEvLisnrs;
            for(var e in t){
                var i = t[e];
                en(n, e, i);
            }
            delete n.llEvLisnrs;
        }
    }, rn = function(n, t, e) {
        !function(n) {
            delete n.llTempImage;
        }(n), R(e, -1), function(n) {
            n && (n.toLoadCount -= 1);
        }(e), M(n, t.class_loading), t.unobserve_completed && T(n, e);
    }, cn = function(n, t, e) {
        var i = z(n) || n;
        on(i) || function(n, t, e) {
            on(n) || (n.llEvLisnrs = {});
            var i = "VIDEO" === n.tagName ? "loadeddata" : "load";
            tn(n, i, t), tn(n, "error", e);
        }(i, function(o) {
            !function(n, t, e, i) {
                var o = O(t);
                rn(t, e, i), N(t, e.class_loaded), w(t, b), C(e.callback_loaded, t, i), o || nn(e, i);
            }(0, n, t, e), an(i);
        }, function(o) {
            !function(n, t, e, i) {
                var o = O(t);
                rn(t, e, i), N(t, e.class_error), w(t, p), C(e.callback_error, t, i), e.restore_on_error && q(t, B), o || nn(e, i);
            }(0, n, t, e), an(i);
        });
    }, ln = function(n, t, e) {
        !function(n) {
            return Z.indexOf(n.tagName) > -1;
        }(n) ? function(n, t, e) {
            !function(n) {
                n.llTempImage = document.createElement("IMG");
            }(n), cn(n, t, e), function(n) {
                P(n) || (n[_] = {
                    backgroundImage: n.style.backgroundImage
                });
            }(n), function(n, t, e) {
                var i = y(n, t.data_bg), o = y(n, t.data_bg_hidpi), r = a && o ? o : i;
                r && (n.style.backgroundImage = 'url("'.concat(r, '")'), z(n).setAttribute(u, r), Q(n, t, e));
            }(n, t, e), function(n, t, e) {
                var i = y(n, t.data_bg_multi), o = y(n, t.data_bg_multi_hidpi), r = a && o ? o : i;
                r && (n.style.backgroundImage = r, K(n, t, e));
            }(n, t, e), function(n, t, e) {
                var i = y(n, t.data_bg_set);
                if (i) {
                    var o = i.split("|"), a = o.map(function(n) {
                        return "image-set(".concat(n, ")");
                    });
                    n.style.backgroundImage = a.join(), "" === n.style.backgroundImage && (a = o.map(function(n) {
                        return "-webkit-image-set(".concat(n, ")");
                    }), n.style.backgroundImage = a.join()), K(n, t, e);
                }
            }(n, t, e);
        }(n, t, e) : function(n, t, e) {
            cn(n, t, e), function(n, t, e) {
                var i = Y[n.tagName];
                i && (i(n, t), Q(n, t, e));
            }(n, t, e);
        }(n, t, e);
    }, un = function(n) {
        n.removeAttribute(u), n.removeAttribute(s), n.removeAttribute(d);
    }, sn = function(n) {
        D(n, function(n) {
            q(n, B);
        }), q(n, B);
    }, dn = {
        IMG: sn,
        IFRAME: function(n) {
            q(n, V);
        },
        VIDEO: function(n) {
            H(n, function(n) {
                q(n, V);
            }), q(n, F), n.load();
        },
        OBJECT: function(n) {
            q(n, J);
        }
    }, fn = function(n, t) {
        (function(n) {
            var t = dn[n.tagName];
            t ? t(n) : function(n) {
                if (P(n)) {
                    var t = S(n);
                    n.style.backgroundImage = t.backgroundImage;
                }
            }(n);
        })(n), function(n, t) {
            L(n) || O(n) || (M(n, t.class_entered), M(n, t.class_exited), M(n, t.class_applied), M(n, t.class_loading), M(n, t.class_loaded), M(n, t.class_error));
        }(n, t), A(n), U(n);
    }, _n = [
        "IMG",
        "IFRAME",
        "VIDEO"
    ], gn = function(n) {
        return n.use_native && "loading" in HTMLImageElement.prototype;
    }, vn = function(n, t, e) {
        n.forEach(function(n) {
            return function(n) {
                return n.isIntersecting || n.intersectionRatio > 0;
            }(n) ? function(n, t, e, i) {
                var o = function(n) {
                    return x.indexOf(k(n)) >= 0;
                }(n);
                w(n, "entered"), N(n, e.class_entered), M(n, e.class_exited), function(n, t, e) {
                    t.unobserve_entered && T(n, e);
                }(n, e, i), C(e.callback_enter, n, t, i), o || ln(n, e, i);
            }(n.target, n, t, e) : function(n, t, e, i) {
                L(n) || (N(n, e.class_exited), function(n, t, e, i) {
                    e.cancel_on_exit && function(n) {
                        return k(n) === v;
                    }(n) && "IMG" === n.tagName && (an(n), function(n) {
                        D(n, function(n) {
                            un(n);
                        }), un(n);
                    }(n), sn(n), M(n, e.class_loading), R(i, -1), A(n), C(e.callback_cancel, n, t, i));
                }(n, t, e, i), C(e.callback_exit, n, t, i));
            }(n.target, n, t, e);
        });
    }, bn = function(n) {
        return Array.prototype.slice.call(n);
    }, mn = function(n) {
        return n.container.querySelectorAll(n.elements_selector);
    }, pn = function(n) {
        return function(n) {
            return k(n) === p;
        }(n);
    }, hn = function(n, t) {
        return function(n) {
            return bn(n).filter(L);
        }(n || mn(t));
    }, En = function(n, e) {
        var o = c(n);
        this._settings = o, this.loadingCount = 0, function(n, t) {
            i && !gn(n) && (t._observer = new IntersectionObserver(function(e) {
                vn(e, n, t);
            }, function(n) {
                return {
                    root: n.container === document ? null : n.container,
                    rootMargin: n.thresholds || n.threshold + "px"
                };
            }(n)));
        }(o, this), function(n, e) {
            t && (e._onlineHandler = function() {
                !function(n, t) {
                    var e;
                    (e = mn(n), bn(e).filter(pn)).forEach(function(t) {
                        M(t, n.class_error), A(t);
                    }), t.update();
                }(n, e);
            }, window.addEventListener("online", e._onlineHandler));
        }(o, this), this.update(e);
    };
    return En.prototype = {
        update: function(n) {
            var t, o, a = this._settings, r = hn(n, a);
            G(this, r.length), !e && i ? gn(a) ? function(n, t, e) {
                n.forEach(function(n) {
                    -1 !== _n.indexOf(n.tagName) && function(n, t, e) {
                        n.setAttribute("loading", "lazy"), cn(n, t, e), function(n, t) {
                            var e = Y[n.tagName];
                            e && e(n, t);
                        }(n, t), w(n, h);
                    }(n, t, e);
                }), G(e, 0);
            }(r, a, this) : (o = r, function(n) {
                n.disconnect();
            }(t = this._observer), function(n, t) {
                t.forEach(function(t) {
                    n.observe(t);
                });
            }(t, o)) : this.loadAll(r);
        },
        destroy: function() {
            this._observer && this._observer.disconnect(), t && window.removeEventListener("online", this._onlineHandler), mn(this._settings).forEach(function(n) {
                U(n);
            }), delete this._observer, delete this._settings, delete this._onlineHandler, delete this.loadingCount, delete this.toLoadCount;
        },
        loadAll: function(n) {
            var t = this, e = this._settings;
            hn(n, e).forEach(function(n) {
                T(n, t), ln(n, e, t);
            });
        },
        restoreAll: function() {
            var n = this._settings;
            mn(n).forEach(function(t) {
                fn(t, n);
            });
        }
    }, En.load = function(n, t) {
        var e = c(t);
        ln(n, e);
    }, En.resetStatus = function(n) {
        A(n);
    }, t && function(n, t) {
        if (t) {
            if (t.length) for(var e, i = 0; e = t[i]; i += 1)l(n, e);
            else l(n, t);
        }
    }(En, window.lazyLoadOptions), En;
});

});

parcelRequire.register("2YtuV", function(module, exports) {
module.exports = /******/ function(modules) {
    /******/ // The module cache
    /******/ var installedModules = {};
    /******/ /******/ // The require function
    /******/ function __webpack_require__(moduleId) {
        /******/ /******/ // Check if module is in cache
        /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
        /******/ // Create a new module (and put it into the cache)
        /******/ var module1 = installedModules[moduleId] = {
            /******/ i: moduleId,
            /******/ l: false,
            /******/ exports: {}
        };
        /******/ /******/ // Execute the module function
        /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
        /******/ /******/ // Flag the module as loaded
        /******/ module1.l = true;
        /******/ /******/ // Return the exports of the module
        /******/ return module1.exports;
    /******/ }
    /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
    /******/ __webpack_require__.m = modules;
    /******/ /******/ // expose the module cache
    /******/ __webpack_require__.c = installedModules;
    /******/ /******/ // define getter function for harmony exports
    /******/ __webpack_require__.d = function(exports, name, getter) {
        /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
            enumerable: true,
            get: getter
        });
    /******/ };
    /******/ /******/ // define __esModule on exports
    /******/ __webpack_require__.r = function(exports) {
        /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
            value: "Module"
        });
        /******/ Object.defineProperty(exports, "__esModule", {
            value: true
        });
    /******/ };
    /******/ /******/ // create a fake namespace object
    /******/ // mode & 1: value is a module id, require it
    /******/ // mode & 2: merge all properties of value into the ns
    /******/ // mode & 4: return value when already ns object
    /******/ // mode & 8|1: behave like require
    /******/ __webpack_require__.t = function(value, mode) {
        /******/ if (mode & 1) value = __webpack_require__(value);
        /******/ if (mode & 8) return value;
        /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
        /******/ var ns = Object.create(null);
        /******/ __webpack_require__.r(ns);
        /******/ Object.defineProperty(ns, "default", {
            enumerable: true,
            value: value
        });
        /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
            return value[key];
        }).bind(null, key));
        /******/ return ns;
    /******/ };
    /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/ __webpack_require__.n = function(module1) {
        /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
            return module1["default"];
        } : /******/ function getModuleExports() {
            return module1;
        };
        /******/ __webpack_require__.d(getter, "a", getter);
        /******/ return getter;
    /******/ };
    /******/ /******/ // Object.prototype.hasOwnProperty.call
    /******/ __webpack_require__.o = function(object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/ /******/ // __webpack_public_path__
    /******/ __webpack_require__.p = "";
    /******/ /******/ /******/ // Load entry module and return exports
    /******/ return __webpack_require__(__webpack_require__.s = "fb15");
/******/ }({
    /***/ "4d21": /***/ function(module1, exports, __webpack_require__) {
    // extracted by mini-css-extract-plugin
    /***/ },
    /***/ "f6fd": /***/ function(module1, exports) {
        // document.currentScript polyfill by Adam Miller
        // MIT license
        (function(document1) {
            var currentScript = "currentScript", scripts = document1.getElementsByTagName("script"); // Live NodeList collection
            // If browser needs currentScript polyfill, add get currentScript() to the document object
            if (!(currentScript in document1)) Object.defineProperty(document1, currentScript, {
                get: function() {
                    // IE 6-10 supports script readyState
                    // IE 10+ support stack trace
                    try {
                        throw new Error();
                    } catch (err) {
                        // Find the second match for the "at" string to get file src url from stack.
                        // Specifically works with the format of stack traces in IE.
                        var i, res = (/.*at [^\(]*\((.*):.+:.+\)$/ig.exec(err.stack) || [
                            false
                        ])[1];
                        // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
                        for(i in scripts){
                            if (scripts[i].src == res || scripts[i].readyState == "interactive") return scripts[i];
                        }
                        // If no match, return null
                        return null;
                    }
                }
            });
        })(document);
    /***/ },
    /***/ "fb15": /***/ function(module1, __webpack_exports__, __webpack_require__) {
        "use strict";
        __webpack_require__.r(__webpack_exports__);
        // CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
        // This file is imported into lib/wc client bundles.
        if (typeof window !== "undefined") {
            __webpack_require__("f6fd");
            var i;
            if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) __webpack_require__.p = i[1] // eslint-disable-line
            ;
        }
        // Indicate to webpack that this file can be concatenated
        /* harmony default export */ var setPublicPath = null;
        // CONCATENATED MODULE: ./node_modules/@glidejs/glide/dist/glide.esm.js
        /*!
 * Glide.js v3.4.1
 * (c) 2013-2019 Jędrzej Chałubek <jedrzej.chalubek@gmail.com> (http://jedrzejchalubek.com/)
 * Released under the MIT License.
 */ var defaults = {
            /**
   * Type of the movement.
   *
   * Available types:
   * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
   * `carousel` - Changes slides without starting over when it reaches the first or last slide.
   *
   * @type {String}
   */ type: "slider",
            /**
   * Start at specific slide number defined with zero-based index.
   *
   * @type {Number}
   */ startAt: 0,
            /**
   * A number of slides visible on the single viewport.
   *
   * @type {Number}
   */ perView: 1,
            /**
   * Focus currently active slide at a specified position in the track.
   *
   * Available inputs:
   * `center` - Current slide will be always focused at the center of a track.
   * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
   *
   * @type {String|Number}
   */ focusAt: 0,
            /**
   * A size of the gap added between slides.
   *
   * @type {Number}
   */ gap: 10,
            /**
   * Change slides after a specified interval. Use `false` for turning off autoplay.
   *
   * @type {Number|Boolean}
   */ autoplay: false,
            /**
   * Stop autoplay on mouseover event.
   *
   * @type {Boolean}
   */ hoverpause: true,
            /**
   * Allow for changing slides with left and right keyboard arrows.
   *
   * @type {Boolean}
   */ keyboard: true,
            /**
   * Stop running `perView` number of slides from the end. Use this
   * option if you don't want to have an empty space after
   * a slider. Works only with `slider` type and a
   * non-centered `focusAt` setting.
   *
   * @type {Boolean}
   */ bound: false,
            /**
   * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
   *
   * @type {Number|Boolean}
   */ swipeThreshold: 80,
            /**
   * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
   *
   * @type {Number|Boolean}
   */ dragThreshold: 120,
            /**
   * A maximum number of slides to which movement will be made on swiping or dragging. Use `false` for unlimited.
   *
   * @type {Number|Boolean}
   */ perTouch: false,
            /**
   * Moving distance ratio of the slides on a swiping and dragging.
   *
   * @type {Number}
   */ touchRatio: 0.5,
            /**
   * Angle required to activate slides moving on swiping or dragging.
   *
   * @type {Number}
   */ touchAngle: 45,
            /**
   * Duration of the animation in milliseconds.
   *
   * @type {Number}
   */ animationDuration: 400,
            /**
   * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
   *
   * @type {Boolean}
   */ rewind: true,
            /**
   * Duration of the rewinding animation of the `slider` type in milliseconds.
   *
   * @type {Number}
   */ rewindDuration: 800,
            /**
   * Easing function for the animation.
   *
   * @type {String}
   */ animationTimingFunc: "cubic-bezier(.165, .840, .440, 1)",
            /**
   * Throttle costly events at most once per every wait milliseconds.
   *
   * @type {Number}
   */ throttle: 10,
            /**
   * Moving direction mode.
   *
   * Available inputs:
   * - 'ltr' - left to right movement,
   * - 'rtl' - right to left movement.
   *
   * @type {String}
   */ direction: "ltr",
            /**
   * The distance value of the next and previous viewports which
   * have to peek in the current view. Accepts number and
   * pixels as a string. Left and right peeking can be
   * set up separately with a directions object.
   *
   * For example:
   * `100` - Peek 100px on the both sides.
   * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
   *
   * @type {Number|String|Object}
   */ peek: 0,
            /**
   * Collection of options applied at specified media breakpoints.
   * For example: display two slides per view under 800px.
   * `{
   *   '800px': {
   *     perView: 2
   *   }
   * }`
   */ breakpoints: {},
            /**
   * Collection of internally used HTML classes.
   *
   * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
   * @type {Object}
   */ classes: {
                direction: {
                    ltr: "glide--ltr",
                    rtl: "glide--rtl"
                },
                slider: "glide--slider",
                carousel: "glide--carousel",
                swipeable: "glide--swipeable",
                dragging: "glide--dragging",
                cloneSlide: "glide__slide--clone",
                activeNav: "glide__bullet--active",
                activeSlide: "glide__slide--active",
                disabledArrow: "glide__arrow--disabled"
            }
        };
        /**
 * Outputs warning message to the bowser console.
 *
 * @param  {String} msg
 * @return {Void}
 */ function warn(msg) {
            console.error("[Glide warn]: " + msg);
        }
        var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        var classCallCheck = function(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        };
        var createClass = function() {
            function defineProperties(target, props) {
                for(var i = 0; i < props.length; i++){
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            return function(Constructor, protoProps, staticProps) {
                if (protoProps) defineProperties(Constructor.prototype, protoProps);
                if (staticProps) defineProperties(Constructor, staticProps);
                return Constructor;
            };
        }();
        var _extends = Object.assign || function(target) {
            for(var i = 1; i < arguments.length; i++){
                var source = arguments[i];
                for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
            }
            return target;
        };
        var get = function get(object, property, receiver) {
            if (object === null) object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === undefined) {
                var parent = Object.getPrototypeOf(object);
                if (parent === null) return undefined;
                else return get(parent, property, receiver);
            } else if ("value" in desc) return desc.value;
            else {
                var getter = desc.get;
                if (getter === undefined) return undefined;
                return getter.call(receiver);
            }
        };
        var inherits = function(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
            if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        };
        var possibleConstructorReturn = function(self, call) {
            if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return call && (typeof call === "object" || typeof call === "function") ? call : self;
        };
        /**
 * Converts value entered as number
 * or string to integer value.
 *
 * @param {String} value
 * @returns {Number}
 */ function toInt(value) {
            return parseInt(value);
        }
        /**
 * Converts value entered as number
 * or string to flat value.
 *
 * @param {String} value
 * @returns {Number}
 */ function toFloat(value) {
            return parseFloat(value);
        }
        /**
 * Indicates whether the specified value is a string.
 *
 * @param  {*}   value
 * @return {Boolean}
 */ function isString(value) {
            return typeof value === "string";
        }
        /**
 * Indicates whether the specified value is an object.
 *
 * @param  {*} value
 * @return {Boolean}
 *
 * @see https://github.com/jashkenas/underscore
 */ function isObject(value) {
            var type = typeof value === "undefined" ? "undefined" : _typeof(value);
            return type === "function" || type === "object" && !!value; // eslint-disable-line no-mixed-operators
        }
        /**
 * Indicates whether the specified value is a number.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function isNumber(value) {
            return typeof value === "number";
        }
        /**
 * Indicates whether the specified value is a function.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function isFunction(value) {
            return typeof value === "function";
        }
        /**
 * Indicates whether the specified value is undefined.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function isUndefined(value) {
            return typeof value === "undefined";
        }
        /**
 * Indicates whether the specified value is an array.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function isArray(value) {
            return value.constructor === Array;
        }
        /**
 * Creates and initializes specified collection of extensions.
 * Each extension receives access to instance of glide and rest of components.
 *
 * @param {Object} glide
 * @param {Object} extensions
 *
 * @returns {Object}
 */ function mount(glide, extensions, events) {
            var components = {};
            for(var name in extensions)if (isFunction(extensions[name])) components[name] = extensions[name](glide, components, events);
            else warn("Extension must be a function");
            for(var _name in components)if (isFunction(components[_name].mount)) components[_name].mount();
            return components;
        }
        /**
 * Defines getter and setter property on the specified object.
 *
 * @param  {Object} obj         Object where property has to be defined.
 * @param  {String} prop        Name of the defined property.
 * @param  {Object} definition  Get and set definitions for the property.
 * @return {Void}
 */ function define(obj, prop, definition) {
            Object.defineProperty(obj, prop, definition);
        }
        /**
 * Sorts aphabetically object keys.
 *
 * @param  {Object} obj
 * @return {Object}
 */ function sortKeys(obj) {
            return Object.keys(obj).sort().reduce(function(r, k) {
                r[k] = obj[k];
                return r[k], r;
            }, {});
        }
        /**
 * Merges passed settings object with default options.
 *
 * @param  {Object} defaults
 * @param  {Object} settings
 * @return {Object}
 */ function mergeOptions(defaults, settings) {
            var options = _extends({}, defaults, settings);
            // `Object.assign` do not deeply merge objects, so we
            // have to do it manually for every nested object
            // in options. Although it does not look smart,
            // it's smaller and faster than some fancy
            // merging deep-merge algorithm script.
            if (settings.hasOwnProperty("classes")) {
                options.classes = _extends({}, defaults.classes, settings.classes);
                if (settings.classes.hasOwnProperty("direction")) options.classes.direction = _extends({}, defaults.classes.direction, settings.classes.direction);
            }
            if (settings.hasOwnProperty("breakpoints")) options.breakpoints = _extends({}, defaults.breakpoints, settings.breakpoints);
            return options;
        }
        var EventsBus = function() {
            /**
   * Construct a EventBus instance.
   *
   * @param {Object} events
   */ function EventsBus() {
                var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                classCallCheck(this, EventsBus);
                this.events = events;
                this.hop = events.hasOwnProperty;
            }
            /**
   * Adds listener to the specifed event.
   *
   * @param {String|Array} event
   * @param {Function} handler
   */ createClass(EventsBus, [
                {
                    key: "on",
                    value: function on(event, handler) {
                        if (isArray(event)) for(var i = 0; i < event.length; i++)this.on(event[i], handler);
                        // Create the event's object if not yet created
                        if (!this.hop.call(this.events, event)) this.events[event] = [];
                        // Add the handler to queue
                        var index = this.events[event].push(handler) - 1;
                        // Provide handle back for removal of event
                        return {
                            remove: function remove() {
                                delete this.events[event][index];
                            }
                        };
                    }
                },
                {
                    key: "emit",
                    value: function emit(event, context) {
                        if (isArray(event)) for(var i = 0; i < event.length; i++)this.emit(event[i], context);
                        // If the event doesn't exist, or there's no handlers in queue, just leave
                        if (!this.hop.call(this.events, event)) return;
                        // Cycle through events queue, fire!
                        this.events[event].forEach(function(item) {
                            item(context || {});
                        });
                    }
                }
            ]);
            return EventsBus;
        }();
        var Glide = function() {
            /**
   * Construct glide.
   *
   * @param  {String} selector
   * @param  {Object} options
   */ function Glide(selector) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                classCallCheck(this, Glide);
                this._c = {};
                this._t = [];
                this._e = new EventsBus();
                this.disabled = false;
                this.selector = selector;
                this.settings = mergeOptions(defaults, options);
                this.index = this.settings.startAt;
            }
            /**
   * Initializes glide.
   *
   * @param {Object} extensions Collection of extensions to initialize.
   * @return {Glide}
   */ createClass(Glide, [
                {
                    key: "mount",
                    value: function mount$$1() {
                        var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        this._e.emit("mount.before");
                        if (isObject(extensions)) this._c = mount(this, extensions, this._e);
                        else warn("You need to provide a object on `mount()`");
                        this._e.emit("mount.after");
                        return this;
                    }
                },
                {
                    key: "mutate",
                    value: function mutate() {
                        var transformers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                        if (isArray(transformers)) this._t = transformers;
                        else warn("You need to provide a array on `mutate()`");
                        return this;
                    }
                },
                {
                    key: "update",
                    value: function update() {
                        var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        this.settings = mergeOptions(this.settings, settings);
                        if (settings.hasOwnProperty("startAt")) this.index = settings.startAt;
                        this._e.emit("update");
                        return this;
                    }
                },
                {
                    key: "go",
                    value: function go(pattern) {
                        this._c.Run.make(pattern);
                        return this;
                    }
                },
                {
                    key: "move",
                    value: function move(distance) {
                        this._c.Transition.disable();
                        this._c.Move.make(distance);
                        return this;
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        this._e.emit("destroy");
                        return this;
                    }
                },
                {
                    key: "play",
                    value: function play() {
                        var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                        if (interval) this.settings.autoplay = interval;
                        this._e.emit("play");
                        return this;
                    }
                },
                {
                    key: "pause",
                    value: function pause() {
                        this._e.emit("pause");
                        return this;
                    }
                },
                {
                    key: "disable",
                    value: function disable() {
                        this.disabled = true;
                        return this;
                    }
                },
                {
                    key: "enable",
                    value: function enable() {
                        this.disabled = false;
                        return this;
                    }
                },
                {
                    key: "on",
                    value: function on(event, handler) {
                        this._e.on(event, handler);
                        return this;
                    }
                },
                {
                    key: "isType",
                    value: function isType(name) {
                        return this.settings.type === name;
                    }
                },
                {
                    key: "settings",
                    get: function get$$1() {
                        return this._o;
                    },
                    set: function set$$1(o) {
                        if (isObject(o)) this._o = o;
                        else warn("Options must be an `object` instance.");
                    }
                },
                {
                    key: "index",
                    get: function get$$1() {
                        return this._i;
                    },
                    set: function set$$1(i) {
                        this._i = toInt(i);
                    }
                },
                {
                    key: "type",
                    get: function get$$1() {
                        return this.settings.type;
                    }
                },
                {
                    key: "disabled",
                    get: function get$$1() {
                        return this._d;
                    },
                    set: function set$$1(status) {
                        this._d = !!status;
                    }
                }
            ]);
            return Glide;
        }();
        function Run(Glide, Components, Events) {
            var Run = {
                /**
     * Initializes autorunning of the glide.
     *
     * @return {Void}
     */ mount: function mount() {
                    this._o = false;
                },
                /**
     * Makes glides running based on the passed moving schema.
     *
     * @param {String} move
     */ make: function make(move) {
                    var _this = this;
                    if (!Glide.disabled) {
                        Glide.disable();
                        this.move = move;
                        Events.emit("run.before", this.move);
                        this.calculate();
                        Events.emit("run", this.move);
                        Components.Transition.after(function() {
                            if (_this.isStart()) Events.emit("run.start", _this.move);
                            if (_this.isEnd()) Events.emit("run.end", _this.move);
                            if (_this.isOffset("<") || _this.isOffset(">")) {
                                _this._o = false;
                                Events.emit("run.offset", _this.move);
                            }
                            Events.emit("run.after", _this.move);
                            Glide.enable();
                        });
                    }
                },
                /**
     * Calculates current index based on defined move.
     *
     * @return {Void}
     */ calculate: function calculate() {
                    var move = this.move, length = this.length;
                    var steps = move.steps, direction = move.direction;
                    var countableSteps = isNumber(toInt(steps)) && toInt(steps) !== 0;
                    switch(direction){
                        case ">":
                            if (steps === ">") Glide.index = length;
                            else if (this.isEnd()) {
                                if (!(Glide.isType("slider") && !Glide.settings.rewind)) {
                                    this._o = true;
                                    Glide.index = 0;
                                }
                            } else if (countableSteps) Glide.index += Math.min(length - Glide.index, -toInt(steps));
                            else Glide.index++;
                            break;
                        case "<":
                            if (steps === "<") Glide.index = 0;
                            else if (this.isStart()) {
                                if (!(Glide.isType("slider") && !Glide.settings.rewind)) {
                                    this._o = true;
                                    Glide.index = length;
                                }
                            } else if (countableSteps) Glide.index -= Math.min(Glide.index, toInt(steps));
                            else Glide.index--;
                            break;
                        case "=":
                            Glide.index = steps;
                            break;
                        default:
                            warn("Invalid direction pattern [" + direction + steps + "] has been used");
                            break;
                    }
                },
                /**
     * Checks if we are on the first slide.
     *
     * @return {Boolean}
     */ isStart: function isStart() {
                    return Glide.index === 0;
                },
                /**
     * Checks if we are on the last slide.
     *
     * @return {Boolean}
     */ isEnd: function isEnd() {
                    return Glide.index === this.length;
                },
                /**
     * Checks if we are making a offset run.
     *
     * @param {String} direction
     * @return {Boolean}
     */ isOffset: function isOffset(direction) {
                    return this._o && this.move.direction === direction;
                }
            };
            define(Run, "move", {
                /**
     * Gets value of the move schema.
     *
     * @returns {Object}
     */ get: function get() {
                    return this._m;
                },
                /**
     * Sets value of the move schema.
     *
     * @returns {Object}
     */ set: function set(value) {
                    var step = value.substr(1);
                    this._m = {
                        direction: value.substr(0, 1),
                        steps: step ? toInt(step) ? toInt(step) : step : 0
                    };
                }
            });
            define(Run, "length", {
                /**
     * Gets value of the running distance based
     * on zero-indexing number of slides.
     *
     * @return {Number}
     */ get: function get() {
                    var settings = Glide.settings;
                    var length = Components.Html.slides.length;
                    // If the `bound` option is acitve, a maximum running distance should be
                    // reduced by `perView` and `focusAt` settings. Running distance
                    // should end before creating an empty space after instance.
                    if (Glide.isType("slider") && settings.focusAt !== "center" && settings.bound) return length - 1 - (toInt(settings.perView) - 1) + toInt(settings.focusAt);
                    return length - 1;
                }
            });
            define(Run, "offset", {
                /**
     * Gets status of the offsetting flag.
     *
     * @return {Boolean}
     */ get: function get() {
                    return this._o;
                }
            });
            return Run;
        }
        /**
 * Returns a current time.
 *
 * @return {Number}
 */ function now() {
            return new Date().getTime();
        }
        /**
 * Returns a function, that, when invoked, will only be triggered
 * at most once during a given window of time.
 *
 * @param {Function} func
 * @param {Number} wait
 * @param {Object=} options
 * @return {Function}
 *
 * @see https://github.com/jashkenas/underscore
 */ function throttle(func, wait, options) {
            var timeout = void 0, context = void 0, args = void 0, result = void 0;
            var previous = 0;
            if (!options) options = {};
            var later = function later() {
                previous = options.leading === false ? 0 : now();
                timeout = null;
                result = func.apply(context, args);
                if (!timeout) context = args = null;
            };
            var throttled = function throttled() {
                var at = now();
                if (!previous && options.leading === false) previous = at;
                var remaining = wait - (at - previous);
                context = this;
                args = arguments;
                if (remaining <= 0 || remaining > wait) {
                    if (timeout) {
                        clearTimeout(timeout);
                        timeout = null;
                    }
                    previous = at;
                    result = func.apply(context, args);
                    if (!timeout) context = args = null;
                } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
                return result;
            };
            throttled.cancel = function() {
                clearTimeout(timeout);
                previous = 0;
                timeout = context = args = null;
            };
            return throttled;
        }
        var MARGIN_TYPE = {
            ltr: [
                "marginLeft",
                "marginRight"
            ],
            rtl: [
                "marginRight",
                "marginLeft"
            ]
        };
        function Gaps(Glide, Components, Events) {
            var Gaps = {
                /**
     * Applies gaps between slides. First and last
     * slides do not receive it's edge margins.
     *
     * @param {HTMLCollection} slides
     * @return {Void}
     */ apply: function apply(slides) {
                    for(var i = 0, len = slides.length; i < len; i++){
                        var style = slides[i].style;
                        var direction = Components.Direction.value;
                        if (i !== 0) style[MARGIN_TYPE[direction][0]] = this.value / 2 + "px";
                        else style[MARGIN_TYPE[direction][0]] = "";
                        if (i !== slides.length - 1) style[MARGIN_TYPE[direction][1]] = this.value / 2 + "px";
                        else style[MARGIN_TYPE[direction][1]] = "";
                    }
                },
                /**
     * Removes gaps from the slides.
     *
     * @param {HTMLCollection} slides
     * @returns {Void}
    */ remove: function remove(slides) {
                    for(var i = 0, len = slides.length; i < len; i++){
                        var style = slides[i].style;
                        style.marginLeft = "";
                        style.marginRight = "";
                    }
                }
            };
            define(Gaps, "value", {
                /**
     * Gets value of the gap.
     *
     * @returns {Number}
     */ get: function get() {
                    return toInt(Glide.settings.gap);
                }
            });
            define(Gaps, "grow", {
                /**
     * Gets additional dimentions value caused by gaps.
     * Used to increase width of the slides wrapper.
     *
     * @returns {Number}
     */ get: function get() {
                    return Gaps.value * (Components.Sizes.length - 1);
                }
            });
            define(Gaps, "reductor", {
                /**
     * Gets reduction value caused by gaps.
     * Used to subtract width of the slides.
     *
     * @returns {Number}
     */ get: function get() {
                    var perView = Glide.settings.perView;
                    return Gaps.value * (perView - 1) / perView;
                }
            });
            /**
   * Apply calculated gaps:
   * - after building, so slides (including clones) will receive proper margins
   * - on updating via API, to recalculate gaps with new options
   */ Events.on([
                "build.after",
                "update"
            ], throttle(function() {
                Gaps.apply(Components.Html.wrapper.children);
            }, 30));
            /**
   * Remove gaps:
   * - on destroying to bring markup to its inital state
   */ Events.on("destroy", function() {
                Gaps.remove(Components.Html.wrapper.children);
            });
            return Gaps;
        }
        /**
 * Finds siblings nodes of the passed node.
 *
 * @param  {Element} node
 * @return {Array}
 */ function siblings(node) {
            if (node && node.parentNode) {
                var n = node.parentNode.firstChild;
                var matched = [];
                for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== node) matched.push(n);
                return matched;
            }
            return [];
        }
        /**
 * Checks if passed node exist and is a valid element.
 *
 * @param  {Element} node
 * @return {Boolean}
 */ function exist(node) {
            if (node && node instanceof window.HTMLElement) return true;
            return false;
        }
        var TRACK_SELECTOR = '[data-glide-el="track"]';
        function Html(Glide, Components) {
            var Html = {
                /**
     * Setup slider HTML nodes.
     *
     * @param {Glide} glide
     */ mount: function mount() {
                    this.root = Glide.selector;
                    this.track = this.root.querySelector(TRACK_SELECTOR);
                    this.slides = Array.prototype.slice.call(this.wrapper.children).filter(function(slide) {
                        return !slide.classList.contains(Glide.settings.classes.cloneSlide);
                    });
                }
            };
            define(Html, "root", {
                /**
     * Gets node of the glide main element.
     *
     * @return {Object}
     */ get: function get() {
                    return Html._r;
                },
                /**
     * Sets node of the glide main element.
     *
     * @return {Object}
     */ set: function set(r) {
                    if (isString(r)) r = document.querySelector(r);
                    if (exist(r)) Html._r = r;
                    else warn("Root element must be a existing Html node");
                }
            });
            define(Html, "track", {
                /**
     * Gets node of the glide track with slides.
     *
     * @return {Object}
     */ get: function get() {
                    return Html._t;
                },
                /**
     * Sets node of the glide track with slides.
     *
     * @return {Object}
     */ set: function set(t) {
                    if (exist(t)) Html._t = t;
                    else warn("Could not find track element. Please use " + TRACK_SELECTOR + " attribute.");
                }
            });
            define(Html, "wrapper", {
                /**
     * Gets node of the slides wrapper.
     *
     * @return {Object}
     */ get: function get() {
                    return Html.track.children[0];
                }
            });
            return Html;
        }
        function Peek(Glide, Components, Events) {
            var Peek = {
                /**
     * Setups how much to peek based on settings.
     *
     * @return {Void}
     */ mount: function mount() {
                    this.value = Glide.settings.peek;
                }
            };
            define(Peek, "value", {
                /**
     * Gets value of the peek.
     *
     * @returns {Number|Object}
     */ get: function get() {
                    return Peek._v;
                },
                /**
     * Sets value of the peek.
     *
     * @param {Number|Object} value
     * @return {Void}
     */ set: function set(value) {
                    if (isObject(value)) {
                        value.before = toInt(value.before);
                        value.after = toInt(value.after);
                    } else value = toInt(value);
                    Peek._v = value;
                }
            });
            define(Peek, "reductor", {
                /**
     * Gets reduction value caused by peek.
     *
     * @returns {Number}
     */ get: function get() {
                    var value = Peek.value;
                    var perView = Glide.settings.perView;
                    if (isObject(value)) return value.before / perView + value.after / perView;
                    return value * 2 / perView;
                }
            });
            /**
   * Recalculate peeking sizes on:
   * - when resizing window to update to proper percents
   */ Events.on([
                "resize",
                "update"
            ], function() {
                Peek.mount();
            });
            return Peek;
        }
        function Move(Glide, Components, Events) {
            var Move = {
                /**
     * Constructs move component.
     *
     * @returns {Void}
     */ mount: function mount() {
                    this._o = 0;
                },
                /**
     * Calculates a movement value based on passed offset and currently active index.
     *
     * @param  {Number} offset
     * @return {Void}
     */ make: function make() {
                    var _this = this;
                    var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    this.offset = offset;
                    Events.emit("move", {
                        movement: this.value
                    });
                    Components.Transition.after(function() {
                        Events.emit("move.after", {
                            movement: _this.value
                        });
                    });
                }
            };
            define(Move, "offset", {
                /**
     * Gets an offset value used to modify current translate.
     *
     * @return {Object}
     */ get: function get() {
                    return Move._o;
                },
                /**
     * Sets an offset value used to modify current translate.
     *
     * @return {Object}
     */ set: function set(value) {
                    Move._o = !isUndefined(value) ? toInt(value) : 0;
                }
            });
            define(Move, "translate", {
                /**
     * Gets a raw movement value.
     *
     * @return {Number}
     */ get: function get() {
                    return Components.Sizes.slideWidth * Glide.index;
                }
            });
            define(Move, "value", {
                /**
     * Gets an actual movement value corrected by offset.
     *
     * @return {Number}
     */ get: function get() {
                    var offset = this.offset;
                    var translate = this.translate;
                    if (Components.Direction.is("rtl")) return translate + offset;
                    return translate - offset;
                }
            });
            /**
   * Make movement to proper slide on:
   * - before build, so glide will start at `startAt` index
   * - on each standard run to move to newly calculated index
   */ Events.on([
                "build.before",
                "run"
            ], function() {
                Move.make();
            });
            return Move;
        }
        function Sizes(Glide, Components, Events) {
            var Sizes = {
                /**
     * Setups dimentions of slides.
     *
     * @return {Void}
     */ setupSlides: function setupSlides() {
                    var width = this.slideWidth + "px";
                    var slides = Components.Html.slides;
                    for(var i = 0; i < slides.length; i++)slides[i].style.width = width;
                },
                /**
     * Setups dimentions of slides wrapper.
     *
     * @return {Void}
     */ setupWrapper: function setupWrapper(dimention) {
                    Components.Html.wrapper.style.width = this.wrapperSize + "px";
                },
                /**
     * Removes applied styles from HTML elements.
     *
     * @returns {Void}
     */ remove: function remove() {
                    var slides = Components.Html.slides;
                    for(var i = 0; i < slides.length; i++)slides[i].style.width = "";
                    Components.Html.wrapper.style.width = "";
                }
            };
            define(Sizes, "length", {
                /**
     * Gets count number of the slides.
     *
     * @return {Number}
     */ get: function get() {
                    return Components.Html.slides.length;
                }
            });
            define(Sizes, "width", {
                /**
     * Gets width value of the glide.
     *
     * @return {Number}
     */ get: function get() {
                    return Components.Html.root.offsetWidth;
                }
            });
            define(Sizes, "wrapperSize", {
                /**
     * Gets size of the slides wrapper.
     *
     * @return {Number}
     */ get: function get() {
                    return Sizes.slideWidth * Sizes.length + Components.Gaps.grow + Components.Clones.grow;
                }
            });
            define(Sizes, "slideWidth", {
                /**
     * Gets width value of the single slide.
     *
     * @return {Number}
     */ get: function get() {
                    return Sizes.width / Glide.settings.perView - Components.Peek.reductor - Components.Gaps.reductor;
                }
            });
            /**
   * Apply calculated glide's dimensions:
   * - before building, so other dimentions (e.g. translate) will be calculated propertly
   * - when resizing window to recalculate sildes dimensions
   * - on updating via API, to calculate dimensions based on new options
   */ Events.on([
                "build.before",
                "resize",
                "update"
            ], function() {
                Sizes.setupSlides();
                Sizes.setupWrapper();
            });
            /**
   * Remove calculated glide's dimensions:
   * - on destoting to bring markup to its inital state
   */ Events.on("destroy", function() {
                Sizes.remove();
            });
            return Sizes;
        }
        function Build(Glide, Components, Events) {
            var Build = {
                /**
     * Init glide building. Adds classes, sets
     * dimensions and setups initial state.
     *
     * @return {Void}
     */ mount: function mount() {
                    Events.emit("build.before");
                    this.typeClass();
                    this.activeClass();
                    Events.emit("build.after");
                },
                /**
     * Adds `type` class to the glide element.
     *
     * @return {Void}
     */ typeClass: function typeClass() {
                    Components.Html.root.classList.add(Glide.settings.classes[Glide.settings.type]);
                },
                /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */ activeClass: function activeClass() {
                    var classes = Glide.settings.classes;
                    var slide = Components.Html.slides[Glide.index];
                    if (slide) {
                        slide.classList.add(classes.activeSlide);
                        siblings(slide).forEach(function(sibling) {
                            sibling.classList.remove(classes.activeSlide);
                        });
                    }
                },
                /**
     * Removes HTML classes applied at building.
     *
     * @return {Void}
     */ removeClasses: function removeClasses() {
                    var classes = Glide.settings.classes;
                    Components.Html.root.classList.remove(classes[Glide.settings.type]);
                    Components.Html.slides.forEach(function(sibling) {
                        sibling.classList.remove(classes.activeSlide);
                    });
                }
            };
            /**
   * Clear building classes:
   * - on destroying to bring HTML to its initial state
   * - on updating to remove classes before remounting component
   */ Events.on([
                "destroy",
                "update"
            ], function() {
                Build.removeClasses();
            });
            /**
   * Remount component:
   * - on resizing of the window to calculate new dimentions
   * - on updating settings via API
   */ Events.on([
                "resize",
                "update"
            ], function() {
                Build.mount();
            });
            /**
   * Swap active class of current slide:
   * - after each move to the new index
   */ Events.on("move.after", function() {
                Build.activeClass();
            });
            return Build;
        }
        function Clones(Glide, Components, Events) {
            var Clones = {
                /**
     * Create pattern map and collect slides to be cloned.
     */ mount: function mount() {
                    this.items = [];
                    if (Glide.isType("carousel")) this.items = this.collect();
                },
                /**
     * Collect clones with pattern.
     *
     * @return {Void}
     */ collect: function collect() {
                    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                    var slides = Components.Html.slides;
                    var _Glide$settings = Glide.settings, perView = _Glide$settings.perView, classes = _Glide$settings.classes;
                    var peekIncrementer = +!!Glide.settings.peek;
                    var part = perView + peekIncrementer;
                    var start = slides.slice(0, part);
                    var end = slides.slice(-part);
                    for(var r = 0; r < Math.max(1, Math.floor(perView / slides.length)); r++){
                        for(var i = 0; i < start.length; i++){
                            var clone = start[i].cloneNode(true);
                            clone.classList.add(classes.cloneSlide);
                            items.push(clone);
                        }
                        for(var _i = 0; _i < end.length; _i++){
                            var _clone = end[_i].cloneNode(true);
                            _clone.classList.add(classes.cloneSlide);
                            items.unshift(_clone);
                        }
                    }
                    return items;
                },
                /**
     * Append cloned slides with generated pattern.
     *
     * @return {Void}
     */ append: function append() {
                    var items = this.items;
                    var _Components$Html = Components.Html, wrapper = _Components$Html.wrapper, slides = _Components$Html.slides;
                    var half = Math.floor(items.length / 2);
                    var prepend = items.slice(0, half).reverse();
                    var append = items.slice(half, items.length);
                    var width = Components.Sizes.slideWidth + "px";
                    for(var i = 0; i < append.length; i++)wrapper.appendChild(append[i]);
                    for(var _i2 = 0; _i2 < prepend.length; _i2++)wrapper.insertBefore(prepend[_i2], slides[0]);
                    for(var _i3 = 0; _i3 < items.length; _i3++)items[_i3].style.width = width;
                },
                /**
     * Remove all cloned slides.
     *
     * @return {Void}
     */ remove: function remove() {
                    var items = this.items;
                    for(var i = 0; i < items.length; i++)Components.Html.wrapper.removeChild(items[i]);
                }
            };
            define(Clones, "grow", {
                /**
     * Gets additional dimentions value caused by clones.
     *
     * @return {Number}
     */ get: function get() {
                    return (Components.Sizes.slideWidth + Components.Gaps.value) * Clones.items.length;
                }
            });
            /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */ Events.on("update", function() {
                Clones.remove();
                Clones.mount();
                Clones.append();
            });
            /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */ Events.on("build.before", function() {
                if (Glide.isType("carousel")) Clones.append();
            });
            /**
   * Remove clones HTMLElements:
   * - on destroying, to bring HTML to its initial state
   */ Events.on("destroy", function() {
                Clones.remove();
            });
            return Clones;
        }
        var EventsBinder = function() {
            /**
   * Construct a EventsBinder instance.
   */ function EventsBinder() {
                var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                classCallCheck(this, EventsBinder);
                this.listeners = listeners;
            }
            /**
   * Adds events listeners to arrows HTML elements.
   *
   * @param  {String|Array} events
   * @param  {Element|Window|Document} el
   * @param  {Function} closure
   * @param  {Boolean|Object} capture
   * @return {Void}
   */ createClass(EventsBinder, [
                {
                    key: "on",
                    value: function on(events, el, closure) {
                        var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                        if (isString(events)) events = [
                            events
                        ];
                        for(var i = 0; i < events.length; i++){
                            this.listeners[events[i]] = closure;
                            el.addEventListener(events[i], this.listeners[events[i]], capture);
                        }
                    }
                },
                {
                    key: "off",
                    value: function off(events, el) {
                        var capture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        if (isString(events)) events = [
                            events
                        ];
                        for(var i = 0; i < events.length; i++)el.removeEventListener(events[i], this.listeners[events[i]], capture);
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        delete this.listeners;
                    }
                }
            ]);
            return EventsBinder;
        }();
        function Resize(Glide, Components, Events) {
            /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new EventsBinder();
            var Resize = {
                /**
     * Initializes window bindings.
     */ mount: function mount() {
                    this.bind();
                },
                /**
     * Binds `rezsize` listener to the window.
     * It's a costly event, so we are debouncing it.
     *
     * @return {Void}
     */ bind: function bind() {
                    Binder.on("resize", window, throttle(function() {
                        Events.emit("resize");
                    }, Glide.settings.throttle));
                },
                /**
     * Unbinds listeners from the window.
     *
     * @return {Void}
     */ unbind: function unbind() {
                    Binder.off("resize", window);
                }
            };
            /**
   * Remove bindings from window:
   * - on destroying, to remove added EventListener
   */ Events.on("destroy", function() {
                Resize.unbind();
                Binder.destroy();
            });
            return Resize;
        }
        var VALID_DIRECTIONS = [
            "ltr",
            "rtl"
        ];
        var FLIPED_MOVEMENTS = {
            ">": "<",
            "<": ">",
            "=": "="
        };
        function Direction(Glide, Components, Events) {
            var Direction = {
                /**
     * Setups gap value based on settings.
     *
     * @return {Void}
     */ mount: function mount() {
                    this.value = Glide.settings.direction;
                },
                /**
     * Resolves pattern based on direction value
     *
     * @param {String} pattern
     * @returns {String}
     */ resolve: function resolve(pattern) {
                    var token = pattern.slice(0, 1);
                    if (this.is("rtl")) return pattern.split(token).join(FLIPED_MOVEMENTS[token]);
                    return pattern;
                },
                /**
     * Checks value of direction mode.
     *
     * @param {String} direction
     * @returns {Boolean}
     */ is: function is(direction) {
                    return this.value === direction;
                },
                /**
     * Applies direction class to the root HTML element.
     *
     * @return {Void}
     */ addClass: function addClass() {
                    Components.Html.root.classList.add(Glide.settings.classes.direction[this.value]);
                },
                /**
     * Removes direction class from the root HTML element.
     *
     * @return {Void}
     */ removeClass: function removeClass() {
                    Components.Html.root.classList.remove(Glide.settings.classes.direction[this.value]);
                }
            };
            define(Direction, "value", {
                /**
     * Gets value of the direction.
     *
     * @returns {Number}
     */ get: function get() {
                    return Direction._v;
                },
                /**
     * Sets value of the direction.
     *
     * @param {String} value
     * @return {Void}
     */ set: function set(value) {
                    if (VALID_DIRECTIONS.indexOf(value) > -1) Direction._v = value;
                    else warn("Direction value must be `ltr` or `rtl`");
                }
            });
            /**
   * Clear direction class:
   * - on destroy to bring HTML to its initial state
   * - on update to remove class before reappling bellow
   */ Events.on([
                "destroy",
                "update"
            ], function() {
                Direction.removeClass();
            });
            /**
   * Remount component:
   * - on update to reflect changes in direction value
   */ Events.on("update", function() {
                Direction.mount();
            });
            /**
   * Apply direction class:
   * - before building to apply class for the first time
   * - on updating to reapply direction class that may changed
   */ Events.on([
                "build.before",
                "update"
            ], function() {
                Direction.addClass();
            });
            return Direction;
        }
        /**
 * Reflects value of glide movement.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function Rtl(Glide, Components) {
            return {
                /**
     * Negates the passed translate if glide is in RTL option.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
                    if (Components.Direction.is("rtl")) return -translate;
                    return translate;
                }
            };
        }
        /**
 * Updates glide movement with a `gap` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function Gap(Glide, Components) {
            return {
                /**
     * Modifies passed translate value with number in the `gap` settings.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
                    return translate + Components.Gaps.value * Glide.index;
                }
            };
        }
        /**
 * Updates glide movement with width of additional clones width.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function Grow(Glide, Components) {
            return {
                /**
     * Adds to the passed translate width of the half of clones.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
                    return translate + Components.Clones.grow / 2;
                }
            };
        }
        /**
 * Updates glide movement with a `peek` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function Peeking(Glide, Components) {
            return {
                /**
     * Modifies passed translate value with a `peek` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
                    if (Glide.settings.focusAt >= 0) {
                        var peek = Components.Peek.value;
                        if (isObject(peek)) return translate - peek.before;
                        return translate - peek;
                    }
                    return translate;
                }
            };
        }
        /**
 * Updates glide movement with a `focusAt` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function Focusing(Glide, Components) {
            return {
                /**
     * Modifies passed translate value with index in the `focusAt` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
                    var gap = Components.Gaps.value;
                    var width = Components.Sizes.width;
                    var focusAt = Glide.settings.focusAt;
                    var slideWidth = Components.Sizes.slideWidth;
                    if (focusAt === "center") return translate - (width / 2 - slideWidth / 2);
                    return translate - slideWidth * focusAt - gap * focusAt;
                }
            };
        }
        /**
 * Applies diffrent transformers on translate value.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function mutator(Glide, Components, Events) {
            /**
   * Merge instance transformers with collection of default transformers.
   * It's important that the Rtl component be last on the list,
   * so it reflects all previous transformations.
   *
   * @type {Array}
   */ var TRANSFORMERS = [
                Gap,
                Grow,
                Peeking,
                Focusing
            ].concat(Glide._t, [
                Rtl
            ]);
            return {
                /**
     * Piplines translate value with registered transformers.
     *
     * @param  {Number} translate
     * @return {Number}
     */ mutate: function mutate(translate) {
                    for(var i = 0; i < TRANSFORMERS.length; i++){
                        var transformer = TRANSFORMERS[i];
                        if (isFunction(transformer) && isFunction(transformer().modify)) translate = transformer(Glide, Components, Events).modify(translate);
                        else warn("Transformer should be a function that returns an object with `modify()` method");
                    }
                    return translate;
                }
            };
        }
        function Translate(Glide, Components, Events) {
            var Translate = {
                /**
     * Sets value of translate on HTML element.
     *
     * @param {Number} value
     * @return {Void}
     */ set: function set(value) {
                    var transform = mutator(Glide, Components).mutate(value);
                    Components.Html.wrapper.style.transform = "translate3d(" + -1 * transform + "px, 0px, 0px)";
                },
                /**
     * Removes value of translate from HTML element.
     *
     * @return {Void}
     */ remove: function remove() {
                    Components.Html.wrapper.style.transform = "";
                }
            };
            /**
   * Set new translate value:
   * - on move to reflect index change
   * - on updating via API to reflect possible changes in options
   */ Events.on("move", function(context) {
                var gap = Components.Gaps.value;
                var length = Components.Sizes.length;
                var width = Components.Sizes.slideWidth;
                if (Glide.isType("carousel") && Components.Run.isOffset("<")) {
                    Components.Transition.after(function() {
                        Events.emit("translate.jump");
                        Translate.set(width * (length - 1));
                    });
                    return Translate.set(-width - gap * length);
                }
                if (Glide.isType("carousel") && Components.Run.isOffset(">")) {
                    Components.Transition.after(function() {
                        Events.emit("translate.jump");
                        Translate.set(0);
                    });
                    return Translate.set(width * length + gap * length);
                }
                return Translate.set(context.movement);
            });
            /**
   * Remove translate:
   * - on destroying to bring markup to its inital state
   */ Events.on("destroy", function() {
                Translate.remove();
            });
            return Translate;
        }
        function Transition(Glide, Components, Events) {
            /**
   * Holds inactivity status of transition.
   * When true transition is not applied.
   *
   * @type {Boolean}
   */ var disabled = false;
            var Transition = {
                /**
     * Composes string of the CSS transition.
     *
     * @param {String} property
     * @return {String}
     */ compose: function compose(property) {
                    var settings = Glide.settings;
                    if (!disabled) return property + " " + this.duration + "ms " + settings.animationTimingFunc;
                    return property + " 0ms " + settings.animationTimingFunc;
                },
                /**
     * Sets value of transition on HTML element.
     *
     * @param {String=} property
     * @return {Void}
     */ set: function set() {
                    var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "transform";
                    Components.Html.wrapper.style.transition = this.compose(property);
                },
                /**
     * Removes value of transition from HTML element.
     *
     * @return {Void}
     */ remove: function remove() {
                    Components.Html.wrapper.style.transition = "";
                },
                /**
     * Runs callback after animation.
     *
     * @param  {Function} callback
     * @return {Void}
     */ after: function after(callback) {
                    setTimeout(function() {
                        callback();
                    }, this.duration);
                },
                /**
     * Enable transition.
     *
     * @return {Void}
     */ enable: function enable() {
                    disabled = false;
                    this.set();
                },
                /**
     * Disable transition.
     *
     * @return {Void}
     */ disable: function disable() {
                    disabled = true;
                    this.set();
                }
            };
            define(Transition, "duration", {
                /**
     * Gets duration of the transition based
     * on currently running animation type.
     *
     * @return {Number}
     */ get: function get() {
                    var settings = Glide.settings;
                    if (Glide.isType("slider") && Components.Run.offset) return settings.rewindDuration;
                    return settings.animationDuration;
                }
            });
            /**
   * Set transition `style` value:
   * - on each moving, because it may be cleared by offset move
   */ Events.on("move", function() {
                Transition.set();
            });
            /**
   * Disable transition:
   * - before initial build to avoid transitioning from `0` to `startAt` index
   * - while resizing window and recalculating dimentions
   * - on jumping from offset transition at start and end edges in `carousel` type
   */ Events.on([
                "build.before",
                "resize",
                "translate.jump"
            ], function() {
                Transition.disable();
            });
            /**
   * Enable transition:
   * - on each running, because it may be disabled by offset move
   */ Events.on("run", function() {
                Transition.enable();
            });
            /**
   * Remove transition:
   * - on destroying to bring markup to its inital state
   */ Events.on("destroy", function() {
                Transition.remove();
            });
            return Transition;
        }
        /**
 * Test via a getter in the options object to see
 * if the passive property is accessed.
 *
 * @see https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
 */ var supportsPassive = false;
        try {
            var opts = Object.defineProperty({}, "passive", {
                get: function get() {
                    supportsPassive = true;
                }
            });
            window.addEventListener("testPassive", null, opts);
            window.removeEventListener("testPassive", null, opts);
        } catch (e) {}
        var supportsPassive$1 = supportsPassive;
        var START_EVENTS = [
            "touchstart",
            "mousedown"
        ];
        var MOVE_EVENTS = [
            "touchmove",
            "mousemove"
        ];
        var END_EVENTS = [
            "touchend",
            "touchcancel",
            "mouseup",
            "mouseleave"
        ];
        var MOUSE_EVENTS = [
            "mousedown",
            "mousemove",
            "mouseup",
            "mouseleave"
        ];
        function Swipe(Glide, Components, Events) {
            /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new EventsBinder();
            var swipeSin = 0;
            var swipeStartX = 0;
            var swipeStartY = 0;
            var disabled = false;
            var capture = supportsPassive$1 ? {
                passive: true
            } : false;
            var Swipe = {
                /**
     * Initializes swipe bindings.
     *
     * @return {Void}
     */ mount: function mount() {
                    this.bindSwipeStart();
                },
                /**
     * Handler for `swipestart` event. Calculates entry points of the user's tap.
     *
     * @param {Object} event
     * @return {Void}
     */ start: function start(event) {
                    if (!disabled && !Glide.disabled) {
                        this.disable();
                        var swipe = this.touches(event);
                        swipeSin = null;
                        swipeStartX = toInt(swipe.pageX);
                        swipeStartY = toInt(swipe.pageY);
                        this.bindSwipeMove();
                        this.bindSwipeEnd();
                        Events.emit("swipe.start");
                    }
                },
                /**
     * Handler for `swipemove` event. Calculates user's tap angle and distance.
     *
     * @param {Object} event
     */ move: function move(event) {
                    if (!Glide.disabled) {
                        var _Glide$settings = Glide.settings, touchAngle = _Glide$settings.touchAngle, touchRatio = _Glide$settings.touchRatio, classes = _Glide$settings.classes;
                        var swipe = this.touches(event);
                        var subExSx = toInt(swipe.pageX) - swipeStartX;
                        var subEySy = toInt(swipe.pageY) - swipeStartY;
                        var powEX = Math.abs(subExSx << 2);
                        var powEY = Math.abs(subEySy << 2);
                        var swipeHypotenuse = Math.sqrt(powEX + powEY);
                        var swipeCathetus = Math.sqrt(powEY);
                        swipeSin = Math.asin(swipeCathetus / swipeHypotenuse);
                        if (swipeSin * 180 / Math.PI < touchAngle) {
                            event.stopPropagation();
                            Components.Move.make(subExSx * toFloat(touchRatio));
                            Components.Html.root.classList.add(classes.dragging);
                            Events.emit("swipe.move");
                        } else return false;
                    }
                },
                /**
     * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
     *
     * @param {Object} event
     * @return {Void}
     */ end: function end(event) {
                    if (!Glide.disabled) {
                        var settings = Glide.settings;
                        var swipe = this.touches(event);
                        var threshold = this.threshold(event);
                        var swipeDistance = swipe.pageX - swipeStartX;
                        var swipeDeg = swipeSin * 180 / Math.PI;
                        var steps = Math.round(swipeDistance / Components.Sizes.slideWidth);
                        this.enable();
                        if (swipeDistance > threshold && swipeDeg < settings.touchAngle) {
                            // While swipe is positive and greater than threshold move backward.
                            if (settings.perTouch) steps = Math.min(steps, toInt(settings.perTouch));
                            if (Components.Direction.is("rtl")) steps = -steps;
                            Components.Run.make(Components.Direction.resolve("<" + steps));
                        } else if (swipeDistance < -threshold && swipeDeg < settings.touchAngle) {
                            // While swipe is negative and lower than negative threshold move forward.
                            if (settings.perTouch) steps = Math.max(steps, -toInt(settings.perTouch));
                            if (Components.Direction.is("rtl")) steps = -steps;
                            Components.Run.make(Components.Direction.resolve(">" + steps));
                        } else // While swipe don't reach distance apply previous transform.
                        Components.Move.make();
                        Components.Html.root.classList.remove(settings.classes.dragging);
                        this.unbindSwipeMove();
                        this.unbindSwipeEnd();
                        Events.emit("swipe.end");
                    }
                },
                /**
     * Binds swipe's starting event.
     *
     * @return {Void}
     */ bindSwipeStart: function bindSwipeStart() {
                    var _this = this;
                    var settings = Glide.settings;
                    if (settings.swipeThreshold) Binder.on(START_EVENTS[0], Components.Html.wrapper, function(event) {
                        _this.start(event);
                    }, capture);
                    if (settings.dragThreshold) Binder.on(START_EVENTS[1], Components.Html.wrapper, function(event) {
                        _this.start(event);
                    }, capture);
                },
                /**
     * Unbinds swipe's starting event.
     *
     * @return {Void}
     */ unbindSwipeStart: function unbindSwipeStart() {
                    Binder.off(START_EVENTS[0], Components.Html.wrapper, capture);
                    Binder.off(START_EVENTS[1], Components.Html.wrapper, capture);
                },
                /**
     * Binds swipe's moving event.
     *
     * @return {Void}
     */ bindSwipeMove: function bindSwipeMove() {
                    var _this2 = this;
                    Binder.on(MOVE_EVENTS, Components.Html.wrapper, throttle(function(event) {
                        _this2.move(event);
                    }, Glide.settings.throttle), capture);
                },
                /**
     * Unbinds swipe's moving event.
     *
     * @return {Void}
     */ unbindSwipeMove: function unbindSwipeMove() {
                    Binder.off(MOVE_EVENTS, Components.Html.wrapper, capture);
                },
                /**
     * Binds swipe's ending event.
     *
     * @return {Void}
     */ bindSwipeEnd: function bindSwipeEnd() {
                    var _this3 = this;
                    Binder.on(END_EVENTS, Components.Html.wrapper, function(event) {
                        _this3.end(event);
                    });
                },
                /**
     * Unbinds swipe's ending event.
     *
     * @return {Void}
     */ unbindSwipeEnd: function unbindSwipeEnd() {
                    Binder.off(END_EVENTS, Components.Html.wrapper);
                },
                /**
     * Normalizes event touches points accorting to different types.
     *
     * @param {Object} event
     */ touches: function touches(event) {
                    if (MOUSE_EVENTS.indexOf(event.type) > -1) return event;
                    return event.touches[0] || event.changedTouches[0];
                },
                /**
     * Gets value of minimum swipe distance settings based on event type.
     *
     * @return {Number}
     */ threshold: function threshold(event) {
                    var settings = Glide.settings;
                    if (MOUSE_EVENTS.indexOf(event.type) > -1) return settings.dragThreshold;
                    return settings.swipeThreshold;
                },
                /**
     * Enables swipe event.
     *
     * @return {self}
     */ enable: function enable() {
                    disabled = false;
                    Components.Transition.enable();
                    return this;
                },
                /**
     * Disables swipe event.
     *
     * @return {self}
     */ disable: function disable() {
                    disabled = true;
                    Components.Transition.disable();
                    return this;
                }
            };
            /**
   * Add component class:
   * - after initial building
   */ Events.on("build.after", function() {
                Components.Html.root.classList.add(Glide.settings.classes.swipeable);
            });
            /**
   * Remove swiping bindings:
   * - on destroying, to remove added EventListeners
   */ Events.on("destroy", function() {
                Swipe.unbindSwipeStart();
                Swipe.unbindSwipeMove();
                Swipe.unbindSwipeEnd();
                Binder.destroy();
            });
            return Swipe;
        }
        function Images(Glide, Components, Events) {
            /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new EventsBinder();
            var Images = {
                /**
     * Binds listener to glide wrapper.
     *
     * @return {Void}
     */ mount: function mount() {
                    this.bind();
                },
                /**
     * Binds `dragstart` event on wrapper to prevent dragging images.
     *
     * @return {Void}
     */ bind: function bind() {
                    Binder.on("dragstart", Components.Html.wrapper, this.dragstart);
                },
                /**
     * Unbinds `dragstart` event on wrapper.
     *
     * @return {Void}
     */ unbind: function unbind() {
                    Binder.off("dragstart", Components.Html.wrapper);
                },
                /**
     * Event handler. Prevents dragging.
     *
     * @return {Void}
     */ dragstart: function dragstart(event) {
                    event.preventDefault();
                }
            };
            /**
   * Remove bindings from images:
   * - on destroying, to remove added EventListeners
   */ Events.on("destroy", function() {
                Images.unbind();
                Binder.destroy();
            });
            return Images;
        }
        function Anchors(Glide, Components, Events) {
            /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new EventsBinder();
            /**
   * Holds detaching status of anchors.
   * Prevents detaching of already detached anchors.
   *
   * @private
   * @type {Boolean}
   */ var detached = false;
            /**
   * Holds preventing status of anchors.
   * If `true` redirection after click will be disabled.
   *
   * @private
   * @type {Boolean}
   */ var prevented = false;
            var Anchors = {
                /**
     * Setups a initial state of anchors component.
     *
     * @returns {Void}
     */ mount: function mount() {
                    /**
       * Holds collection of anchors elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._a = Components.Html.wrapper.querySelectorAll("a");
                    this.bind();
                },
                /**
     * Binds events to anchors inside a track.
     *
     * @return {Void}
     */ bind: function bind() {
                    Binder.on("click", Components.Html.wrapper, this.click);
                },
                /**
     * Unbinds events attached to anchors inside a track.
     *
     * @return {Void}
     */ unbind: function unbind() {
                    Binder.off("click", Components.Html.wrapper);
                },
                /**
     * Handler for click event. Prevents clicks when glide is in `prevent` status.
     *
     * @param  {Object} event
     * @return {Void}
     */ click: function click(event) {
                    if (prevented) {
                        event.stopPropagation();
                        event.preventDefault();
                    }
                },
                /**
     * Detaches anchors click event inside glide.
     *
     * @return {self}
     */ detach: function detach() {
                    prevented = true;
                    if (!detached) {
                        for(var i = 0; i < this.items.length; i++){
                            this.items[i].draggable = false;
                            this.items[i].setAttribute("data-href", this.items[i].getAttribute("href"));
                            this.items[i].removeAttribute("href");
                        }
                        detached = true;
                    }
                    return this;
                },
                /**
     * Attaches anchors click events inside glide.
     *
     * @return {self}
     */ attach: function attach() {
                    prevented = false;
                    if (detached) {
                        for(var i = 0; i < this.items.length; i++){
                            this.items[i].draggable = true;
                            this.items[i].setAttribute("href", this.items[i].getAttribute("data-href"));
                        }
                        detached = false;
                    }
                    return this;
                }
            };
            define(Anchors, "items", {
                /**
     * Gets collection of the arrows HTML elements.
     *
     * @return {HTMLElement[]}
     */ get: function get() {
                    return Anchors._a;
                }
            });
            /**
   * Detach anchors inside slides:
   * - on swiping, so they won't redirect to its `href` attributes
   */ Events.on("swipe.move", function() {
                Anchors.detach();
            });
            /**
   * Attach anchors inside slides:
   * - after swiping and transitions ends, so they can redirect after click again
   */ Events.on("swipe.end", function() {
                Components.Transition.after(function() {
                    Anchors.attach();
                });
            });
            /**
   * Unbind anchors inside slides:
   * - on destroying, to bring anchors to its initial state
   */ Events.on("destroy", function() {
                Anchors.attach();
                Anchors.unbind();
                Binder.destroy();
            });
            return Anchors;
        }
        var NAV_SELECTOR = '[data-glide-el="controls[nav]"]';
        var CONTROLS_SELECTOR = '[data-glide-el^="controls"]';
        function Controls(Glide, Components, Events) {
            /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new EventsBinder();
            var capture = supportsPassive$1 ? {
                passive: true
            } : false;
            var Controls = {
                /**
     * Inits arrows. Binds events listeners
     * to the arrows HTML elements.
     *
     * @return {Void}
     */ mount: function mount() {
                    /**
       * Collection of navigation HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._n = Components.Html.root.querySelectorAll(NAV_SELECTOR);
                    /**
       * Collection of controls HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._c = Components.Html.root.querySelectorAll(CONTROLS_SELECTOR);
                    this.addBindings();
                },
                /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */ setActive: function setActive() {
                    for(var i = 0; i < this._n.length; i++)this.addClass(this._n[i].children);
                },
                /**
     * Removes active class to current slide.
     *
     * @return {Void}
     */ removeActive: function removeActive() {
                    for(var i = 0; i < this._n.length; i++)this.removeClass(this._n[i].children);
                },
                /**
     * Toggles active class on items inside navigation.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */ addClass: function addClass(controls) {
                    var settings = Glide.settings;
                    var item = controls[Glide.index];
                    if (item) {
                        item.classList.add(settings.classes.activeNav);
                        siblings(item).forEach(function(sibling) {
                            sibling.classList.remove(settings.classes.activeNav);
                        });
                    }
                },
                /**
     * Removes active class from active control.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */ removeClass: function removeClass(controls) {
                    var item = controls[Glide.index];
                    if (item) item.classList.remove(Glide.settings.classes.activeNav);
                },
                /**
     * Adds handles to the each group of controls.
     *
     * @return {Void}
     */ addBindings: function addBindings() {
                    for(var i = 0; i < this._c.length; i++)this.bind(this._c[i].children);
                },
                /**
     * Removes handles from the each group of controls.
     *
     * @return {Void}
     */ removeBindings: function removeBindings() {
                    for(var i = 0; i < this._c.length; i++)this.unbind(this._c[i].children);
                },
                /**
     * Binds events to arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */ bind: function bind(elements) {
                    for(var i = 0; i < elements.length; i++){
                        Binder.on("click", elements[i], this.click);
                        Binder.on("touchstart", elements[i], this.click, capture);
                    }
                },
                /**
     * Unbinds events binded to the arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */ unbind: function unbind(elements) {
                    for(var i = 0; i < elements.length; i++)Binder.off([
                        "click",
                        "touchstart"
                    ], elements[i]);
                },
                /**
     * Handles `click` event on the arrows HTML elements.
     * Moves slider in driection precised in
     * `data-glide-dir` attribute.
     *
     * @param {Object} event
     * @return {Void}
     */ click: function click(event) {
                    event.preventDefault();
                    Components.Run.make(Components.Direction.resolve(event.currentTarget.getAttribute("data-glide-dir")));
                }
            };
            define(Controls, "items", {
                /**
     * Gets collection of the controls HTML elements.
     *
     * @return {HTMLElement[]}
     */ get: function get() {
                    return Controls._c;
                }
            });
            /**
   * Swap active class of current navigation item:
   * - after mounting to set it to initial index
   * - after each move to the new index
   */ Events.on([
                "mount.after",
                "move.after"
            ], function() {
                Controls.setActive();
            });
            /**
   * Remove bindings and HTML Classes:
   * - on destroying, to bring markup to its initial state
   */ Events.on("destroy", function() {
                Controls.removeBindings();
                Controls.removeActive();
                Binder.destroy();
            });
            return Controls;
        }
        function Keyboard(Glide, Components, Events) {
            /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new EventsBinder();
            var Keyboard = {
                /**
     * Binds keyboard events on component mount.
     *
     * @return {Void}
     */ mount: function mount() {
                    if (Glide.settings.keyboard) this.bind();
                },
                /**
     * Adds keyboard press events.
     *
     * @return {Void}
     */ bind: function bind() {
                    Binder.on("keyup", document, this.press);
                },
                /**
     * Removes keyboard press events.
     *
     * @return {Void}
     */ unbind: function unbind() {
                    Binder.off("keyup", document);
                },
                /**
     * Handles keyboard's arrows press and moving glide foward and backward.
     *
     * @param  {Object} event
     * @return {Void}
     */ press: function press(event) {
                    if (event.keyCode === 39) Components.Run.make(Components.Direction.resolve(">"));
                    if (event.keyCode === 37) Components.Run.make(Components.Direction.resolve("<"));
                }
            };
            /**
   * Remove bindings from keyboard:
   * - on destroying to remove added events
   * - on updating to remove events before remounting
   */ Events.on([
                "destroy",
                "update"
            ], function() {
                Keyboard.unbind();
            });
            /**
   * Remount component
   * - on updating to reflect potential changes in settings
   */ Events.on("update", function() {
                Keyboard.mount();
            });
            /**
   * Destroy binder:
   * - on destroying to remove listeners
   */ Events.on("destroy", function() {
                Binder.destroy();
            });
            return Keyboard;
        }
        function Autoplay(Glide, Components, Events) {
            /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new EventsBinder();
            var Autoplay = {
                /**
     * Initializes autoplaying and events.
     *
     * @return {Void}
     */ mount: function mount() {
                    this.start();
                    if (Glide.settings.hoverpause) this.bind();
                },
                /**
     * Starts autoplaying in configured interval.
     *
     * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Void}
     */ start: function start() {
                    var _this = this;
                    if (Glide.settings.autoplay) {
                        if (isUndefined(this._i)) this._i = setInterval(function() {
                            _this.stop();
                            Components.Run.make(">");
                            _this.start();
                        }, this.time);
                    }
                },
                /**
     * Stops autorunning of the glide.
     *
     * @return {Void}
     */ stop: function stop() {
                    this._i = clearInterval(this._i);
                },
                /**
     * Stops autoplaying while mouse is over glide's area.
     *
     * @return {Void}
     */ bind: function bind() {
                    var _this2 = this;
                    Binder.on("mouseover", Components.Html.root, function() {
                        _this2.stop();
                    });
                    Binder.on("mouseout", Components.Html.root, function() {
                        _this2.start();
                    });
                },
                /**
     * Unbind mouseover events.
     *
     * @returns {Void}
     */ unbind: function unbind() {
                    Binder.off([
                        "mouseover",
                        "mouseout"
                    ], Components.Html.root);
                }
            };
            define(Autoplay, "time", {
                /**
     * Gets time period value for the autoplay interval. Prioritizes
     * times in `data-glide-autoplay` attrubutes over options.
     *
     * @return {Number}
     */ get: function get() {
                    var autoplay = Components.Html.slides[Glide.index].getAttribute("data-glide-autoplay");
                    if (autoplay) return toInt(autoplay);
                    return toInt(Glide.settings.autoplay);
                }
            });
            /**
   * Stop autoplaying and unbind events:
   * - on destroying, to clear defined interval
   * - on updating via API to reset interval that may changed
   */ Events.on([
                "destroy",
                "update"
            ], function() {
                Autoplay.unbind();
            });
            /**
   * Stop autoplaying:
   * - before each run, to restart autoplaying
   * - on pausing via API
   * - on destroying, to clear defined interval
   * - while starting a swipe
   * - on updating via API to reset interval that may changed
   */ Events.on([
                "run.before",
                "pause",
                "destroy",
                "swipe.start",
                "update"
            ], function() {
                Autoplay.stop();
            });
            /**
   * Start autoplaying:
   * - after each run, to restart autoplaying
   * - on playing via API
   * - while ending a swipe
   */ Events.on([
                "run.after",
                "play",
                "swipe.end"
            ], function() {
                Autoplay.start();
            });
            /**
   * Remount autoplaying:
   * - on updating via API to reset interval that may changed
   */ Events.on("update", function() {
                Autoplay.mount();
            });
            /**
   * Destroy a binder:
   * - on destroying glide instance to clearup listeners
   */ Events.on("destroy", function() {
                Binder.destroy();
            });
            return Autoplay;
        }
        /**
 * Sorts keys of breakpoint object so they will be ordered from lower to bigger.
 *
 * @param {Object} points
 * @returns {Object}
 */ function sortBreakpoints(points) {
            if (isObject(points)) return sortKeys(points);
            else warn("Breakpoints option must be an object");
            return {};
        }
        function Breakpoints(Glide, Components, Events) {
            /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new EventsBinder();
            /**
   * Holds reference to settings.
   *
   * @type {Object}
   */ var settings = Glide.settings;
            /**
   * Holds reference to breakpoints object in settings. Sorts breakpoints
   * from smaller to larger. It is required in order to proper
   * matching currently active breakpoint settings.
   *
   * @type {Object}
   */ var points = sortBreakpoints(settings.breakpoints);
            /**
   * Cache initial settings before overwritting.
   *
   * @type {Object}
   */ var defaults = _extends({}, settings);
            var Breakpoints = {
                /**
     * Matches settings for currectly matching media breakpoint.
     *
     * @param {Object} points
     * @returns {Object}
     */ match: function match(points) {
                    if (typeof window.matchMedia !== "undefined") {
                        for(var point in points)if (points.hasOwnProperty(point)) {
                            if (window.matchMedia("(max-width: " + point + "px)").matches) return points[point];
                        }
                    }
                    return defaults;
                }
            };
            /**
   * Overwrite instance settings with currently matching breakpoint settings.
   * This happens right after component initialization.
   */ _extends(settings, Breakpoints.match(points));
            /**
   * Update glide with settings of matched brekpoint:
   * - window resize to update slider
   */ Binder.on("resize", window, throttle(function() {
                Glide.settings = mergeOptions(settings, Breakpoints.match(points));
            }, Glide.settings.throttle));
            /**
   * Resort and update default settings:
   * - on reinit via API, so breakpoint matching will be performed with options
   */ Events.on("update", function() {
                points = sortBreakpoints(points);
                defaults = _extends({}, settings);
            });
            /**
   * Unbind resize listener:
   * - on destroying, to bring markup to its initial state
   */ Events.on("destroy", function() {
                Binder.off("resize", window);
            });
            return Breakpoints;
        }
        var COMPONENTS = {
            // Required
            Html: Html,
            Translate: Translate,
            Transition: Transition,
            Direction: Direction,
            Peek: Peek,
            Sizes: Sizes,
            Gaps: Gaps,
            Move: Move,
            Clones: Clones,
            Resize: Resize,
            Build: Build,
            Run: Run,
            // Optional
            Swipe: Swipe,
            Images: Images,
            Anchors: Anchors,
            Controls: Controls,
            Keyboard: Keyboard,
            Autoplay: Autoplay,
            Breakpoints: Breakpoints
        };
        var Glide$1 = function(_Core) {
            inherits(Glide$$1, _Core);
            function Glide$$1() {
                classCallCheck(this, Glide$$1);
                return possibleConstructorReturn(this, (Glide$$1.__proto__ || Object.getPrototypeOf(Glide$$1)).apply(this, arguments));
            }
            createClass(Glide$$1, [
                {
                    key: "mount",
                    value: function mount() {
                        var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        return get(Glide$$1.prototype.__proto__ || Object.getPrototypeOf(Glide$$1.prototype), "mount", this).call(this, _extends({}, COMPONENTS, extensions));
                    }
                }
            ]);
            return Glide$$1;
        }(Glide);
        /* harmony default export */ var glide_esm = Glide$1;
        // EXTERNAL MODULE: ./node_modules/@glidejs/glide/dist/css/glide.core.min.css
        var glide_core_min = __webpack_require__("4d21");
        // CONCATENATED MODULE: ./src/components/events.js
        /* harmony default export */ var events = [
            "build.after",
            "build.before",
            "mount.after",
            "mount.before",
            "move.after",
            "move",
            "pause",
            "play",
            "resize",
            "run.after",
            "run.before",
            "run.end",
            "run.offset",
            "run.start",
            "run",
            "swipe.end",
            "swipe.move",
            "swipe.start",
            "translate.jump",
            "update"
        ];
        // CONCATENATED MODULE: ./src/components/Glide.js
        /* harmony default export */ var components_Glide = {
            name: "VueGlide",
            model: {
                prop: "active",
                event: "change"
            },
            props: {
                type: {
                    type: String,
                    default: "slider"
                },
                startAt: {
                    type: Number,
                    default: 0
                },
                perView: {
                    type: Number,
                    default: 3
                },
                focusAt: {
                    type: [
                        String,
                        Number
                    ],
                    default: 0
                },
                gap: {
                    type: Number,
                    default: 10
                },
                autoplay: {
                    type: [
                        Number,
                        Boolean
                    ],
                    default: false
                },
                hoverpause: {
                    type: Boolean,
                    default: true
                },
                keyboard: {
                    type: Boolean,
                    default: true
                },
                bound: {
                    type: Boolean,
                    default: false
                },
                swipeThreshold: {
                    type: [
                        Number,
                        Boolean
                    ],
                    default: 80
                },
                dragThreshold: {
                    type: [
                        Number,
                        Boolean
                    ],
                    default: 120
                },
                perTouch: {
                    type: [
                        Number,
                        Boolean
                    ],
                    default: false
                },
                touchRatio: {
                    type: Number,
                    default: 0.5
                },
                touchAngle: {
                    type: Number,
                    default: 45
                },
                animationDuration: {
                    type: Number,
                    default: 400
                },
                rewind: {
                    type: Boolean,
                    default: true
                },
                rewindDuration: {
                    type: Number,
                    default: 800
                },
                animationTimingFunc: {
                    type: String,
                    default: "cubic-bezier(0.165, 0.840, 0.440, 1.000)"
                },
                direction: {
                    type: String,
                    default: "ltr"
                },
                peek: {
                    type: [
                        Number,
                        Object
                    ],
                    default: 0
                },
                breakpoints: {
                    type: Object,
                    default: function _default() {}
                },
                classes: {
                    type: Object,
                    default: function _default() {}
                },
                throttle: {
                    type: Number,
                    default: 25
                },
                toSlideByClick: {
                    type: Boolean,
                    default: false
                },
                bullet: {
                    type: Boolean,
                    default: false
                },
                options: {
                    type: Object,
                    default: function _default() {}
                },
                active: {
                    type: Number,
                    default: null
                }
            },
            data: function data() {
                return {
                    glide: undefined
                };
            },
            render: function render(h) {
                var control;
                var bullet;
                var buttons = []; // Pass only vue-glide-slide
                var slides = this.$slots.default.filter(function(c) {
                    var isVueGlideTag = false;
                    if (c.componentOptions) isVueGlideTag = c.componentOptions.tag === "VueGlideSlide" || c.componentOptions.tag === "vue-glide-slide";
                    return isVueGlideTag;
                });
                if (this.$slots.control && this.$slots.control.length) control = h("div", {
                    "attrs": {
                        "data-glide-el": "controls"
                    }
                }, [
                    this.$slots.control
                ]);
                if (this.bullet) {
                    for(var i = 0; i < this.slidesCount; i++)buttons.push(h("button", {
                        key: i,
                        attrs: {
                            "data-glide-dir": "=" + i,
                            class: "glide__bullet"
                        }
                    }));
                    bullet = h("div", {
                        "class": "glide__bullets",
                        "attrs": {
                            "data-glide-el": "controls[nav]"
                        }
                    }, [
                        buttons
                    ]);
                }
                return h("div", {
                    "class": "glide"
                }, [
                    h("div", {
                        "class": "glide__track",
                        "attrs": {
                            "data-glide-el": "track"
                        }
                    }, [
                        h("ul", {
                            "class": "glide__slides"
                        }, [
                            slides
                        ])
                    ]),
                    control,
                    bullet
                ]);
            },
            watch: {
                active: function active() {
                    this.changeSlideByModel();
                }
            },
            computed: {
                currentSlide: function currentSlide() {
                    return this.glide.index;
                },
                slidesCount: function slidesCount() {
                    return this.$slots.default.filter(function(c) {
                        return c.componentOptions && c.componentOptions.tag === "vue-glide-slide";
                    }).length;
                }
            },
            mounted: function mounted() {
                this.init();
            },
            methods: {
                /**
     * Initialization glide
     */ init: function init() {
                    var defaultClasses = {
                        direction: {
                            ltr: "glide--ltr",
                            rtl: "glide--rtl"
                        },
                        slider: "glide--slider",
                        carousel: "glide--carousel",
                        swipeable: "glide--swipeable",
                        dragging: "glide--dragging",
                        cloneSlide: "glide__slide--clone",
                        activeNav: "glide__bullet--active",
                        activeSlide: "glide__slide--active",
                        disabledArrow: "glide__arrow--disabled"
                    };
                    var initOptions = Object.assign({}, this.$props); // Remove additional props 'options'
                    delete initOptions.options;
                    initOptions.classes = Object.assign(defaultClasses, this.classes);
                    var mergedOptions = Object.assign(initOptions, this.options);
                    if (this.toSlideByClick) this.goToSlideByClick();
                    this.glide = new glide_esm(this.$el, mergedOptions);
                    this.eventConnector(events);
                    this.glide.mount();
                    this.addEventListenerToSlide();
                    this.bindModel();
                    this.changeSlideByModel();
                },
                /**
     * Go to the slide
     * @param {string} pattern - special format glide.js api
     * Available pattern:
     * * > - Move one forward
     * * < - Move one backward
     * * ={i} - Go to {i} zero-based slide (eq. '=1', will go to second slide)
     * * >> - Rewinds to end (last slide)
     * * << - Rewinds to start (first slide)
     */ go: function go(pattern) {
                    this.glide.go(pattern);
                },
                /**
     * Go to the slide by click on slide
     */ goToSlideByClick: function goToSlideByClick() {
                    var _this = this;
                    this.$on("glide:slide-click", function(e) {
                        return _this.go("=".concat(e));
                    });
                },
                /**
     * Pass glide events to Vue events
     * @param {array} - glide events
     */ eventConnector: function eventConnector(events) {
                    var _this2 = this;
                    events.map(function(event) {
                        _this2.glide.on(event, function(e) {
                            var emitter = event.replace(/\./, "-");
                            _this2.$emit("glide:".concat(emitter), e);
                        });
                    });
                },
                /**
     * Bind v-model
     */ bindModel: function bindModel() {
                    var _this3 = this;
                    this.$on("glide:move", function() {
                        _this3.$emit("change", _this3.currentSlide);
                    });
                },
                /**
     * Change slide by v-model
     */ changeSlideByModel: function changeSlideByModel() {
                    if (this.active === null) return;
                    if (this.active > this.slidesCount - 1) return this.go("=".concat(this.slidesCount - 1));
                    if (this.active < 0) return this.go("=0");
                    this.go("=".concat(this.active));
                },
                /**
     * Adding an event handler for slides, including DOM cloned slider elements
     * When type is 'carousel', glide.js clones DOM slides
     * @returns {number} - index of slide
     */ addEventListenerToSlide: function addEventListenerToSlide() {
                    var _this4 = this;
                    var slides = document.querySelectorAll(".glide__slide");
                    slides = Array.from(slides);
                    slides.forEach(function(el) {
                        el.addEventListener("click", function(e) {
                            // Recursive bubbling from nested elements to find '.glide__slide'
                            var recursive = function recursive(el) {
                                var parent = el.parentNode;
                                var contain = parent.classList.contains("glide__slide");
                                if (contain) return _this4.$emit("glide:slide-click", Number(parent.dataset.glideIndex));
                                else recursive(parent);
                            };
                            if (!e.target.classList.contains("glide__slide")) recursive(e.target);
                            _this4.$emit("glide:slide-click", Number(e.target.dataset.glideIndex));
                        });
                    });
                }
            }
        };
        // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"59701e64-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/GlideSlide.vue?vue&type=template&id=28f23117&
        var render = function() {
            var _vm = this;
            var _h = _vm.$createElement;
            var _c = _vm._self._c || _h;
            return _c("li", {
                staticClass: "glide__slide",
                attrs: {
                    "data-glide-index": _vm.index
                }
            }, [
                _vm._t("default")
            ], 2);
        };
        var staticRenderFns = [];
        // CONCATENATED MODULE: ./src/components/GlideSlide.vue?vue&type=template&id=28f23117&
        // CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/GlideSlide.vue?vue&type=script&lang=js&
        //
        //
        //
        //
        //
        //
        //
        //
        /* harmony default export */ var GlideSlidevue_type_script_lang_js_ = {
            name: "VueGlideSlide",
            computed: {
                /**
     * Get index of current slide
     */ index: function index() {
                    var _this = this;
                    return this.$parent.$children.findIndex(function(slide) {
                        return slide._uid === _this._uid;
                    });
                }
            }
        };
        // CONCATENATED MODULE: ./src/components/GlideSlide.vue?vue&type=script&lang=js&
        /* harmony default export */ var components_GlideSlidevue_type_script_lang_js_ = GlideSlidevue_type_script_lang_js_;
        // CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
        /* globals __VUE_SSR_CONTEXT__ */ // IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
        // This module is a runtime utility for cleaner component module output and will
        // be included in the final webpack user bundle.
        function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, /* server only */ shadowMode /* vue-cli only */ ) {
            // Vue.extend constructor export interop
            var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
            // render functions
            if (render) {
                options.render = render;
                options.staticRenderFns = staticRenderFns;
                options._compiled = true;
            }
            // functional template
            if (functionalTemplate) options.functional = true;
            // scopedId
            if (scopeId) options._scopeId = "data-v-" + scopeId;
            var hook;
            if (moduleIdentifier) {
                hook = function(context) {
                    // 2.3 injection
                    context = context || // cached call
                    this.$vnode && this.$vnode.ssrContext || // stateful
                    this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext // functional
                    ;
                    // 2.2 with runInNewContext: true
                    if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") context = __VUE_SSR_CONTEXT__;
                    // inject component styles
                    if (injectStyles) injectStyles.call(this, context);
                    // register component module identifier for async chunk inferrence
                    if (context && context._registeredComponents) context._registeredComponents.add(moduleIdentifier);
                };
                // used by ssr in case component is cached and beforeCreate
                // never gets called
                options._ssrRegister = hook;
            } else if (injectStyles) hook = shadowMode ? function() {
                injectStyles.call(this, this.$root.$options.shadowRoot);
            } : injectStyles;
            if (hook) {
                if (options.functional) {
                    // for template-only hot-reload because in that case the render fn doesn't
                    // go through the normalizer
                    options._injectStyles = hook;
                    // register for functioal component in vue file
                    var originalRender = options.render;
                    options.render = function renderWithStyleInjection(h, context) {
                        hook.call(context);
                        return originalRender(h, context);
                    };
                } else {
                    // inject component registration as beforeCreate hook
                    var existing = options.beforeCreate;
                    options.beforeCreate = existing ? [].concat(existing, hook) : [
                        hook
                    ];
                }
            }
            return {
                exports: scriptExports,
                options: options
            };
        }
        // CONCATENATED MODULE: ./src/components/GlideSlide.vue
        /* normalize component */ var component = normalizeComponent(components_GlideSlidevue_type_script_lang_js_, render, staticRenderFns, false, null, null, null);
        /* harmony default export */ var GlideSlide = component.exports;
        // CONCATENATED MODULE: ./src/index.js
        /* harmony default export */ var src = {
            install: function install(Vue, options) {
                Vue.component(components_Glide.name, components_Glide);
                Vue.component(GlideSlide.name, GlideSlide);
            }
        };
        // CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js
        /* concated harmony reexport Glide */ __webpack_require__.d(__webpack_exports__, "Glide", function() {
            return components_Glide;
        });
        /* concated harmony reexport GlideSlide */ __webpack_require__.d(__webpack_exports__, "GlideSlide", function() {
            return GlideSlide;
        });
        /* harmony default export */ var entry_lib = __webpack_exports__["default"] = src;
    /***/ }
});

});

parcelRequire.register("ac5cV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $76bf107a903cc4dc$export$2e2bcd8739ae039; });
let $76bf107a903cc4dc$var$script;




let $76bf107a903cc4dc$var$initialize = ()=>{
    $76bf107a903cc4dc$var$script = (parcelRequire("6hrBq"));
    if ($76bf107a903cc4dc$var$script.__esModule) $76bf107a903cc4dc$var$script = $76bf107a903cc4dc$var$script.default;
    $76bf107a903cc4dc$var$script.render = (parcelRequire("dhB9j")).render;
    $76bf107a903cc4dc$var$script.staticRenderFns = (parcelRequire("dhB9j")).staticRenderFns;
    $76bf107a903cc4dc$var$script._scopeId = "data-v-0bcb62";
    (parcelRequire("a7qal")).default($76bf107a903cc4dc$var$script);
    $76bf107a903cc4dc$var$script.__scopeId = "data-v-0bcb62";
    $76bf107a903cc4dc$var$script.__file = "IconLeft.vue";
};
$76bf107a903cc4dc$var$initialize();
var $76bf107a903cc4dc$export$2e2bcd8739ae039 = $76bf107a903cc4dc$var$script;

});
parcelRequire.register("6hrBq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $4929bde9669d556e$export$2e2bcd8739ae039; });
var $4929bde9669d556e$var$scriptExports = {
    components: {},
    data () {
        return {};
    },
    methods: {}
};
var $4929bde9669d556e$var$options = typeof $4929bde9669d556e$var$scriptExports === "function" ? $4929bde9669d556e$var$scriptExports.options : $4929bde9669d556e$var$scriptExports;
var $4929bde9669d556e$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $4929bde9669d556e$var$options;

});

parcelRequire.register("dhB9j", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $9ab9adf23b951a46$export$b3890eb0ae9dca99; }, function (v) { return $9ab9adf23b951a46$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $9ab9adf23b951a46$export$f8436702749526f9; }, function (v) { return $9ab9adf23b951a46$export$f8436702749526f9 = v; });
var $9ab9adf23b951a46$export$b3890eb0ae9dca99;
var $9ab9adf23b951a46$export$f8436702749526f9;
var $9ab9adf23b951a46$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _vm._m(0);
};
var $9ab9adf23b951a46$var$staticRenderFns = [
    function() {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c("button", {
            staticClass: "flex items-center justify-center inline-block w-10 h-10 p-3 bg-white rounded-full text-brand-500"
        }, [
            _c("i", {
                staticClass: "block -ml-1 fal fa-chevron-left"
            })
        ]);
    }
];
$9ab9adf23b951a46$export$b3890eb0ae9dca99 = $9ab9adf23b951a46$var$render;
$9ab9adf23b951a46$export$f8436702749526f9 = $9ab9adf23b951a46$var$staticRenderFns;

});

parcelRequire.register("a7qal", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $75dedacc3059da9a$export$2e2bcd8739ae039; });
let $75dedacc3059da9a$var$NOOP = ()=>{};
var $75dedacc3059da9a$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("gIPS7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c2c8fe14e22bac73$export$2e2bcd8739ae039; });
let $c2c8fe14e22bac73$var$script;




let $c2c8fe14e22bac73$var$initialize = ()=>{
    $c2c8fe14e22bac73$var$script = (parcelRequire("lz3lm"));
    if ($c2c8fe14e22bac73$var$script.__esModule) $c2c8fe14e22bac73$var$script = $c2c8fe14e22bac73$var$script.default;
    $c2c8fe14e22bac73$var$script.render = (parcelRequire("cWVHS")).render;
    $c2c8fe14e22bac73$var$script.staticRenderFns = (parcelRequire("cWVHS")).staticRenderFns;
    $c2c8fe14e22bac73$var$script._scopeId = "data-v-263721";
    (parcelRequire("baYd0")).default($c2c8fe14e22bac73$var$script);
    $c2c8fe14e22bac73$var$script.__scopeId = "data-v-263721";
    $c2c8fe14e22bac73$var$script.__file = "IconRight.vue";
};
$c2c8fe14e22bac73$var$initialize();
var $c2c8fe14e22bac73$export$2e2bcd8739ae039 = $c2c8fe14e22bac73$var$script;

});
parcelRequire.register("lz3lm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $fb2f75ce604e77ab$export$2e2bcd8739ae039; });
var $fb2f75ce604e77ab$var$scriptExports = {
    components: {},
    data () {
        return {};
    },
    methods: {}
};
var $fb2f75ce604e77ab$var$options = typeof $fb2f75ce604e77ab$var$scriptExports === "function" ? $fb2f75ce604e77ab$var$scriptExports.options : $fb2f75ce604e77ab$var$scriptExports;
var $fb2f75ce604e77ab$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $fb2f75ce604e77ab$var$options;

});

parcelRequire.register("cWVHS", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $96d7aa2d29450ec6$export$b3890eb0ae9dca99; }, function (v) { return $96d7aa2d29450ec6$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $96d7aa2d29450ec6$export$f8436702749526f9; }, function (v) { return $96d7aa2d29450ec6$export$f8436702749526f9 = v; });
var $96d7aa2d29450ec6$export$b3890eb0ae9dca99;
var $96d7aa2d29450ec6$export$f8436702749526f9;
var $96d7aa2d29450ec6$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _vm._m(0);
};
var $96d7aa2d29450ec6$var$staticRenderFns = [
    function() {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c("button", {
            staticClass: "flex items-center justify-center inline-block w-10 h-10 p-3 bg-white rounded-full text-brand-500"
        }, [
            _c("i", {
                staticClass: "block -mr-1 fal fa-chevron-right"
            })
        ]);
    }
];
$96d7aa2d29450ec6$export$b3890eb0ae9dca99 = $96d7aa2d29450ec6$var$render;
$96d7aa2d29450ec6$export$f8436702749526f9 = $96d7aa2d29450ec6$var$staticRenderFns;

});

parcelRequire.register("baYd0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $822f551900792c9a$export$2e2bcd8739ae039; });
let $822f551900792c9a$var$NOOP = ()=>{};
var $822f551900792c9a$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRequire.register("4jbd8", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $3231a2024288dbc4$export$b3890eb0ae9dca99; }, function (v) { return $3231a2024288dbc4$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $3231a2024288dbc4$export$f8436702749526f9; }, function (v) { return $3231a2024288dbc4$export$f8436702749526f9 = v; });
var $3231a2024288dbc4$export$b3890eb0ae9dca99;
var $3231a2024288dbc4$export$f8436702749526f9;
var $3231a2024288dbc4$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("a", {
        staticClass: "relative block h-full p-5 transition-all duration-300 hover:bg-brand-500 hover:text-white group hover:shadow-2xl",
        attrs: {
            "href": _vm.formatLink(_vm.estate.permalink),
            "data-component": "card"
        }
    }, [
        _c("div", {
            staticClass: "absolute top-0 left-0 z-10 m-8 text-sm tracking-wider text-white uppercase lg:m-10"
        }, [
            _c("ul", {
                staticClass: "flex flex-wrap -m-2"
            }, [
                _vm.estate.meta.estate.status === "sold" || _vm.estate.meta.estate.status === "rented" || _vm.estate.meta.estate.status === "option" || _vm.estate.meta.estate.status === "under_contract" ? _c("li", {
                    staticClass: "p-2"
                }, [
                    _c("div", {
                        staticClass: "p-2 rounded-md bg-danger-500"
                    }, [
                        _vm.estate.meta.estate.status === "sold" ? [
                            _vm._v(_vm._s(_vm.locales[_vm.estateData.lang].sold))
                        ] : _vm._e(),
                        _vm._v(" "),
                        _vm.estate.meta.estate.status === "rented" ? [
                            _vm._v(_vm._s(_vm.locales[_vm.estateData.lang].rented))
                        ] : _vm._e(),
                        _vm._v(" "),
                        _vm.estate.meta.estate.status === "option" ? [
                            _vm._v(_vm._s(_vm.locales[_vm.estateData.lang].option))
                        ] : _vm._e(),
                        _vm._v(" "),
                        _vm.estate.meta.estate.status === "under_contract" ? [
                            _vm._v(_vm._s(_vm.locales[_vm.estateData.lang].under_contract))
                        ] : _vm._e()
                    ], 2)
                ]) : _vm._e(),
                _vm._v(" "),
                _vm.estate.meta.open_homes.hasOpenHome && _vm.estate.meta.estate.status === "available" ? _c("li", {
                    staticClass: "p-2"
                }, [
                    _c("div", {
                        staticClass: "p-2 rounded-md bg-danger-500"
                    }, [
                        _vm._v("\n          " + _vm._s(_vm.locales[_vm.estateData.lang].open_home) + "\n        ")
                    ])
                ]) : _vm._e()
            ])
        ]),
        _vm._v(" "),
        _vm.estate.meta.features.images.length > 0 ? _c("vue-glide", {
            attrs: {
                "options": _vm.glideOptions
            }
        }, [
            _vm.estate.meta.estate.status === "available" ? _vm._l(_vm.estate.meta.features.images.slice(0, 5), function(image) {
                return _c("vue-glide-slide", {
                    key: image.ID
                }, [
                    _c("div", {
                        staticClass: "aspect-ratio-4/3"
                    }),
                    _vm._v(" "),
                    _c("div", {
                        staticClass: "absolute top-0 left-0 z-10 w-full h-full transition duration-200 bg-black bg-opacity-50 opacity-0 lg:group-hover:opacity-100"
                    }),
                    _vm._v(" "),
                    _c("img", {
                        staticClass: "absolute top-0 left-0 z-0 object-cover object-center w-full h-full transition-all duration-200 transform group-hover:scale-105 lazy",
                        attrs: {
                            "data-src": image.sizes.thumbnail,
                            "alt": "Condrogest - " + _vm.estate.meta.estate.title[_vm.estateData.lang]
                        }
                    })
                ]);
            }) : [
                _c("vue-glide-slide", [
                    _c("div", {
                        staticClass: "aspect-ratio-4/3"
                    }),
                    _vm._v(" "),
                    _c("div", {
                        staticClass: "absolute top-0 left-0 z-10 w-full h-full bg-brand-500 opacity-40"
                    }),
                    _vm._v(" "),
                    _c("div", {
                        staticClass: "absolute top-0 left-0 w-full h-full opacity-50"
                    }, [
                        _c("img", {
                            staticClass: "absolute top-0 left-0 z-0 object-cover object-center w-full h-full lazy",
                            attrs: {
                                "data-src": _vm.estate.meta.features.images[0].sizes.thumbnail,
                                "alt": "Condrogest - " + _vm.estate.meta.estate.title[_vm.estateData.lang]
                            }
                        })
                    ])
                ])
            ],
            _vm._v(" "),
            _vm.estate.meta.features.images.length > 1 && _vm.estate.meta.estate.status === "available" ? _c("template", {
                slot: "control"
            }, [
                _c("button", {
                    staticClass: "px-5 py-16 transition duration-150 pointer-events-auto focus:outline-none glide__arrow glide__arrow--left active:opacity-50",
                    attrs: {
                        "data-glide-dir": "<"
                    },
                    on: {
                        "click": function($event) {
                            $event.stopPropagation();
                            return _vm.prevent.apply(null, arguments);
                        }
                    }
                }, [
                    _c("IconLeft")
                ], 1),
                _vm._v(" "),
                _c("button", {
                    staticClass: "px-5 py-16 transition duration-150 pointer-events-auto focus:outline-none glide__arrow glide__arrow--right active:opacity-50",
                    attrs: {
                        "data-glide-dir": ">"
                    },
                    on: {
                        "click": function($event) {
                            $event.stopPropagation();
                            return _vm.prevent.apply(null, arguments);
                        }
                    }
                }, [
                    _c("IconRight")
                ], 1)
            ]) : _vm._e()
        ], 2) : _vm._e(),
        _vm._v(" "),
        _c("div", {
            staticClass: "flex justify-between mt-4 mb-3"
        }, [
            _c("p", {
                staticClass: "mt-1 text-xs tracking-wider uppercase group-hover:opacity-50"
            }, [
                _vm._v("\n      " + _vm._s(_vm.formatType(_vm.estate.meta.features.type)) + "\n      " + _vm._s(_vm.formatNegotiation(_vm.estate.meta.features.negotiation)) + "\n    ")
            ]),
            _vm._v(" "),
            !_vm.estate.meta.location.hidden ? _c("div", {
                staticClass: "text-base"
            }, [
                _c("i", {
                    staticClass: "fas fa-map-marker-alt text-danger-500"
                }),
                _vm._v("\n      " + _vm._s(_vm.estate.meta.location.city) + "\n    ")
            ]) : _vm._e()
        ]),
        _vm._v(" "),
        _c("h3", {
            staticClass: "mb-3 lg:text-xl"
        }, [
            _vm._v("\n    " + _vm._s(_vm.estate.meta.estate.title[_vm.estateData.lang]) + "\n  ")
        ]),
        _vm._v(" "),
        !_vm.estate.meta.price.hidden ? _c("div", {
            staticClass: "mb-3"
        }, [
            !_vm.estate.meta.estate.is_project ? _c("p", [
                _vm._v("\n      €\n      " + _vm._s(_vm.$formatNumber(_vm.estate.meta.price.amount, "DOT")) + "\n    ")
            ]) : _c("p", [
                _vm.estate.meta.price.min_max.min && _vm.estate.meta.price.min_max.max ? _c("span", [
                    _vm._v("\n        € " + _vm._s(_vm.$formatNumber(_vm.estate.meta.price.min_max.min, "DOT")) + " -\n        € " + _vm._s(_vm.$formatNumber(_vm.estate.meta.price.min_max.max, "DOT")) + "\n      ")
                ]) : _vm._e(),
                _vm._v(" "),
                _vm.estate.meta.price.min_max.min && !_vm.estate.meta.price.min_max.max ? _c("span", [
                    _vm._v("\n        € " + _vm._s(_vm.$formatNumber(_vm.estate.meta.price.min_max.min, "DOT")) + "\n      ")
                ]) : _vm._e()
            ])
        ]) : _vm._e(),
        _vm._v(" "),
        _c("div", {
            staticClass: "flex items-center justify-between space-x-5"
        }, [
            _c("div", [
                _vm.estate.meta.energy_details.epc_category ? _c("img", {
                    staticClass: "h-5 lazy",
                    attrs: {
                        "data-src": "/wp-content/themes/condrogest/assets/img/energy/" + _vm.estateData.lang + "/" + _vm.formatEPC(_vm.estate.meta.energy_details.epc_category) + ".png"
                    }
                }) : _vm._e()
            ]),
            _vm._v(" "),
            _c("ul", {
                staticClass: "flex space-x-6"
            }, [
                parseInt(_vm.estate.meta.facilities.bedrooms) >= 1 ? _c("li", {
                    staticClass: "text-base"
                }, [
                    _c("i", {
                        staticClass: "mr-1 text-danger-500 fal fa-bed"
                    }),
                    _vm._v(" "),
                    _c("span", [
                        _vm._v(_vm._s(_vm.estate.meta.facilities.bedrooms))
                    ])
                ]) : _vm._e(),
                _vm._v(" "),
                parseInt(_vm.estate.meta.sizes.liveable_area.size) >= 1 ? _c("li", {
                    staticClass: "text-base"
                }, [
                    _c("i", {
                        staticClass: "mr-1 text-danger-500 fal fa-home-alt"
                    }),
                    _vm._v(" "),
                    _c("span", [
                        _vm._v(_vm._s(_vm.$formatNumber(_vm.estate.meta.sizes.liveable_area.size, "DOT")) + "㎡")
                    ])
                ]) : _vm._e(),
                _vm._v(" "),
                parseInt(_vm.estate.meta.sizes.plot_area.size) >= 1 ? _c("li", {
                    staticClass: "text-base"
                }, [
                    _c("i", {
                        staticClass: "mr-1 text-danger-500 fal fa-expand-arrows"
                    }),
                    _vm._v(" "),
                    _c("span", [
                        _vm._v(_vm._s(_vm.$formatNumber(_vm.estate.meta.sizes.plot_area.size, "DOT")) + "㎡")
                    ])
                ]) : _vm._e()
            ])
        ])
    ], 1);
};
var $3231a2024288dbc4$var$staticRenderFns = [];
$3231a2024288dbc4$export$b3890eb0ae9dca99 = $3231a2024288dbc4$var$render;
$3231a2024288dbc4$export$f8436702749526f9 = $3231a2024288dbc4$var$staticRenderFns;

});

parcelRequire.register("5XQDv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $457b4ae6dd3e20f2$export$2e2bcd8739ae039; });
let $457b4ae6dd3e20f2$var$NOOP = ()=>{};
var $457b4ae6dd3e20f2$export$2e2bcd8739ae039 = (script)=>{};

});


parcelRequire.register("dY8jF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2b7545dee97f728$export$2e2bcd8739ae039; });
let $a2b7545dee97f728$var$script;





let $a2b7545dee97f728$var$initialize = ()=>{
    $a2b7545dee97f728$var$script = (parcelRequire("1eCcq"));
    if ($a2b7545dee97f728$var$script.__esModule) $a2b7545dee97f728$var$script = $a2b7545dee97f728$var$script.default;
    $a2b7545dee97f728$var$script.render = (parcelRequire("h8MY1")).render;
    $a2b7545dee97f728$var$script.staticRenderFns = (parcelRequire("h8MY1")).staticRenderFns;
    $a2b7545dee97f728$var$script._scopeId = "data-v-f7b3e0";
    $a2b7545dee97f728$var$script.__cssModules = {};
    (parcelRequire("dzFu4")).default($a2b7545dee97f728$var$script);
    $a2b7545dee97f728$var$script.__scopeId = "data-v-f7b3e0";
    $a2b7545dee97f728$var$script.__file = "CardAlt.vue";
};
$a2b7545dee97f728$var$initialize();
var $a2b7545dee97f728$export$2e2bcd8739ae039 = $a2b7545dee97f728$var$script;

});
parcelRequire.register("1eCcq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0e64badf58f1e553$export$2e2bcd8739ae039; });

var $hr0I9 = parcelRequire("hr0I9");

var $2YtuV = parcelRequire("2YtuV");

var $ac5cV = parcelRequire("ac5cV");

var $gIPS7 = parcelRequire("gIPS7");

var $4KcUv = parcelRequire("4KcUv");
var $0e64badf58f1e553$var$scriptExports = {
    components: {
        IconLeft: $ac5cV.default,
        IconRight: $gIPS7.default,
        [(0, $2YtuV.Glide).name]: (0, $2YtuV.Glide),
        [(0, $2YtuV.GlideSlide).name]: (0, $2YtuV.GlideSlide)
    },
    props: [
        "loading",
        "estate",
        "estateData",
        "locales"
    ],
    data () {
        return {
            glideOptions: {
                type: "carousel",
                perView: 1,
                gap: 0,
                keyboard: false
            }
        };
    },
    computed: {
        percentage_sold () {
            const statusList = [];
            const totalItems = this.estate.meta.estate.properties.length;
            this.estate.meta.estate.properties.forEach((element)=>{
                statusList.push(element.status);
            });
            const occurences = statusList.filter((element)=>element === "available");
            return 100 - Math.ceil(occurences.length * 100 / totalItems);
        }
    },
    mounted () {
        new (0, (/*@__PURE__*/$parcel$interopDefault($hr0I9)))({
            elements_selector: ".lazy",
            unobserve_entered: true
        });
    },
    methods: {
        prevent () {
            return false;
        },
        formatLink (link) {
            const title = $4KcUv(this.estate.meta.estate.title[this.estateData.lang], {
                lower: true,
                strict: true
            });
            const url = link.split("/");
            let prefix = "";
            if (this.estateData.lang === "nl") {
                prefix = "te-huur";
                if (this.estate.meta.features.negotiation === "sale") prefix = "te-koop";
            } else if (this.estateData.lang === "fr") {
                prefix = "a-louer";
                if (this.estate.meta.features.negotiation === "sale") prefix = "a-vendre";
            }
            const str = `/${this.estateData.lang}/${prefix}/${url[5]}/${title}`;
            return str;
        },
        formatType (type) {
            let output = "";
            switch(type){
                case "apartment":
                    if (this.estateData.lang === "nl") output = "Appartement";
                    else if (this.estateData.lang === "fr") output = "Appartement";
                    break;
                case "commercial":
                    if (this.estateData.lang === "nl") output = "Winkelpand";
                    else if (this.estateData.lang === "fr") output = "Magasin";
                    break;
                case "house":
                    if (this.estateData.lang === "nl") output = "Huis";
                    else if (this.estateData.lang === "fr") output = "Maison";
                    break;
                case "land":
                    if (this.estateData.lang === "nl") output = "Grond";
                    else if (this.estateData.lang === "fr") output = "Terrain";
                    break;
                case "office":
                    if (this.estateData.lang === "nl") output = "Kantoor";
                    else if (this.estateData.lang === "fr") output = "Office";
                    break;
                case "parking":
                    if (this.estateData.lang === "nl") output = "Parking";
                    else if (this.estateData.lang === "fr") output = "Parking";
                    break;
                default:
                    break;
            }
            return output;
        },
        slideNav (dir) {
            if (dir === "<") this.$refs.slider.glide.go("<");
            else this.$refs.slider.glide.go(">");
        },
        formatNegotiation (negotiation) {
            let output = "";
            switch(negotiation){
                case "sale":
                    if (this.estateData.lang === "nl") output = "te koop";
                    else if (this.estateData.lang === "fr") output = "\xe0 vendre";
                    break;
                case "let":
                    if (this.estateData.lang === "nl") output = "te huur";
                    else if (this.estateData.lang === "fr") output = "\xe0 louer";
                    break;
                default:
                    break;
            }
            return output;
        }
    }
};
var $0e64badf58f1e553$var$options = typeof $0e64badf58f1e553$var$scriptExports === "function" ? $0e64badf58f1e553$var$scriptExports.options : $0e64badf58f1e553$var$scriptExports;
var $0e64badf58f1e553$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $0e64badf58f1e553$var$options;

});

parcelRequire.register("h8MY1", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $c7a92ae22ac7ea2d$export$b3890eb0ae9dca99; }, function (v) { return $c7a92ae22ac7ea2d$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $c7a92ae22ac7ea2d$export$f8436702749526f9; }, function (v) { return $c7a92ae22ac7ea2d$export$f8436702749526f9 = v; });
var $c7a92ae22ac7ea2d$export$b3890eb0ae9dca99;
var $c7a92ae22ac7ea2d$export$f8436702749526f9;
var $c7a92ae22ac7ea2d$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", {
        staticClass: "relative flex flex-col p-5 lg:flex-row lg:items-center",
        attrs: {
            "data-component": "card"
        }
    }, [
        _c("div", {
            staticClass: "lg:w-1/2"
        }, [
            _c("div", {
                staticClass: "relative"
            }, [
                _vm.percentage_sold > 0 ? _c("div", {
                    staticClass: "absolute top-0 right-0 z-10 flex items-center px-3 py-2 mt-5 -mr-2 text-sm tracking-wider text-white uppercase rounded-md shadow-lg lg:mt-10 lg:-mr-5 bg-danger-500"
                }, [
                    _vm.percentage_sold < 100 ? _c("svg", {
                        staticClass: "mr-2",
                        attrs: {
                            "height": "20",
                            "width": "20",
                            "viewBox": "0 0 20 20"
                        }
                    }, [
                        _c("circle", {
                            attrs: {
                                "r": "10",
                                "cx": "10",
                                "cy": "10",
                                "fill": "tomato"
                            }
                        }),
                        _vm._v(" "),
                        _c("circle", {
                            attrs: {
                                "r": "5",
                                "cx": "10",
                                "cy": "10",
                                "fill": "transparent",
                                "stroke": "white",
                                "stroke-width": "10",
                                "stroke-dasharray": _vm.percentage_sold * 31.4 / 100 + " 31.4",
                                "transform": "rotate(-90) translate(-20)"
                            }
                        })
                    ]) : _vm._e(),
                    _vm._v(" "),
                    _c("p", [
                        _vm._v(_vm._s(_vm.percentage_sold) + "% " + _vm._s(_vm.locales[_vm.estateData.lang].sold))
                    ])
                ]) : _vm._e(),
                _vm._v(" "),
                _vm.estate.meta.features.images.length > 0 ? _c("vue-glide", {
                    ref: "slider",
                    attrs: {
                        "options": _vm.glideOptions
                    }
                }, [
                    _vm.estate.meta.estate.status === "available" ? _vm._l(_vm.estate.meta.features.images.slice(0, 5), function(image) {
                        return _c("vue-glide-slide", {
                            key: image.ID
                        }, [
                            _c("div", {
                                staticClass: "aspect-ratio-16/9"
                            }),
                            _vm._v(" "),
                            _c("div", {
                                staticClass: "absolute top-0 left-0 z-10 w-full h-full transition duration-200 bg-black bg-opacity-50 opacity-0 lg:group-hover:opacity-100"
                            }),
                            _vm._v(" "),
                            _c("img", {
                                staticClass: "absolute top-0 left-0 z-0 object-cover object-center w-full h-full transition-all duration-200 transform group-hover:scale-105 lazy",
                                attrs: {
                                    "data-src": image.sizes.thumbnail,
                                    "alt": "Condrogest - " + _vm.estate.meta.estate.title[_vm.estateData.lang]
                                }
                            })
                        ]);
                    }) : [
                        _c("vue-glide-slide", [
                            _c("div", {
                                staticClass: "aspect-ratio-16/9"
                            }),
                            _vm._v(" "),
                            _c("div", {
                                staticClass: "absolute top-0 left-0 z-10 w-full h-full bg-brand-500 opacity-40"
                            }),
                            _vm._v(" "),
                            _c("div", {
                                staticClass: "absolute top-0 left-0 w-full h-full opacity-50"
                            }, [
                                _c("img", {
                                    staticClass: "absolute top-0 left-0 z-0 object-cover object-center w-full h-full lazy",
                                    attrs: {
                                        "data-src": _vm.estate.meta.features.images[0].sizes.thumbnail,
                                        "alt": "Condrogest - " + _vm.estate.meta.estate.title[_vm.estateData.lang]
                                    }
                                })
                            ])
                        ])
                    ]
                ], 2) : _vm._e()
            ], 1)
        ]),
        _vm._v(" "),
        _c("div", {
            staticClass: "lg:w-1/2 lg:pl-16"
        }, [
            _c("div", {
                staticClass: "mb-3 lg:mb-6"
            }, [
                !_vm.estate.meta.location.hidden ? _c("p", {
                    staticClass: "mb-2 lg:text-xl"
                }, [
                    _vm._v("\n        " + _vm._s(_vm.estate.meta.estate.properties.length) + "\n        " + _vm._s(_vm.locales[_vm.estateData.lang].units_in) + "\n        " + _vm._s(_vm.estate.meta.location.city) + "\n      ")
                ]) : _vm._e(),
                _vm._v(" "),
                _c("a", {
                    staticClass: "inline-block font-serif text-xl transition duration-200 lg:text-3xl lg:leading-tight lg:text-4xl hover:text-danger-500",
                    attrs: {
                        "href": _vm.formatLink(_vm.estate.permalink)
                    }
                }, [
                    _c("h3", [
                        _vm._v(_vm._s(_vm.estate.meta.estate.title[_vm.estateData.lang]))
                    ])
                ])
            ]),
            _vm._v(" "),
            _c("div", {
                staticClass: "flex items-center justify-between"
            }, [
                !_vm.estate.meta.price.hidden && _vm.estate.meta.price.min_max.max ? _c("div", [
                    _c("p", {
                        staticClass: "text-sm tracking-wider uppercase"
                    }, [
                        _vm._v("\n          " + _vm._s(_vm.locales[_vm.estateData.lang].starting_from) + "\n        ")
                    ]),
                    _vm._v(" "),
                    _c("p", {
                        staticClass: "lg:text-xl"
                    }, [
                        _vm._v("\n          €" + _vm._s(_vm.$formatNumber(_vm.estate.meta.price.min_max.min, "DOT")) + " -\n          €" + _vm._s(_vm.$formatNumber(_vm.estate.meta.price.min_max.max, "DOT")) + "\n        ")
                    ])
                ]) : _vm._e(),
                _vm._v(" "),
                _c("div", [
                    _c("a", {
                        staticClass: "text-sm tracking-wider uppercase btn-link is-line is-thick",
                        attrs: {
                            "href": _vm.formatLink(_vm.estate.permalink)
                        }
                    }, [
                        _vm._v("\n          " + _vm._s(_vm.locales[_vm.estateData.lang].more_info) + "\n        ")
                    ])
                ])
            ]),
            _vm._v(" "),
            _c("div", {
                staticClass: "flex items-center justify-between mt-5 lg:mt-10"
            }, [
                _vm.estate.meta.features.images.length > 1 && _vm.estate.meta.estate.status === "available" ? _c("div", {
                    staticClass: "hidden -ml-8 divide-x lg:flex"
                }, [
                    _c("button", {
                        staticClass: "relative px-3 py-3 transition duration-150 pointer-events-auto hover:opacity-50 focus:outline-none active:top-px",
                        on: {
                            "click": function($event) {
                                return _vm.slideNav("<");
                            }
                        }
                    }, [
                        _c("IconLeft")
                    ], 1),
                    _vm._v(" "),
                    _c("button", {
                        staticClass: "relative px-3 py-3 transition duration-150 pointer-events-auto hover:opacity-50 focus:outline-none active:top-px",
                        on: {
                            "click": function($event) {
                                return _vm.slideNav(">");
                            }
                        }
                    }, [
                        _c("IconRight")
                    ], 1)
                ]) : _vm._e(),
                _vm._v(" "),
                _vm.estate.meta.open_homes.hasOpenHome && _vm.estate.meta.estate.status === "available" ? _c("div", [
                    _c("div", {
                        staticClass: "px-3 py-2 text-white rounded-md bg-danger-500"
                    }, [
                        _c("i", {
                            staticClass: "mr-1 fas fa-eye"
                        }),
                        _vm._v(" "),
                        _c("span", {
                            staticClass: "text-sm tracking-wider uppercase"
                        }, [
                            _vm._v("\n            " + _vm._s(_vm.locales[_vm.estateData.lang].open_home) + "\n          ")
                        ])
                    ])
                ]) : _vm._e()
            ])
        ])
    ]);
};
var $c7a92ae22ac7ea2d$var$staticRenderFns = [];
$c7a92ae22ac7ea2d$export$b3890eb0ae9dca99 = $c7a92ae22ac7ea2d$var$render;
$c7a92ae22ac7ea2d$export$f8436702749526f9 = $c7a92ae22ac7ea2d$var$staticRenderFns;

});

parcelRequire.register("dzFu4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e1eb918e2806db4$export$2e2bcd8739ae039; });
let $9e1eb918e2806db4$var$NOOP = ()=>{};
var $9e1eb918e2806db4$export$2e2bcd8739ae039 = (script)=>{};

});



parcelRequire.register("5QPlT", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $4429a48cbc17248a$export$b3890eb0ae9dca99; }, function (v) { return $4429a48cbc17248a$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $4429a48cbc17248a$export$f8436702749526f9; }, function (v) { return $4429a48cbc17248a$export$f8436702749526f9 = v; });
var $4429a48cbc17248a$export$b3890eb0ae9dca99;
var $4429a48cbc17248a$export$f8436702749526f9;
var $4429a48cbc17248a$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", [
        _c("div", [
            _c("LoadingBar", {
                attrs: {
                    "mode": _vm.estateData.mode,
                    "loading": _vm.isLoading
                }
            })
        ], 1),
        _vm._v(" "),
        _vm.estateData.lang ? _c("div", {
            class: _vm.estateData.mode !== "latest" ? "mt-10 lg:mt-28" : "",
            attrs: {
                "data-sweepbright-list": ""
            }
        }, [
            _vm.estateData.mode !== "latest" ? _c("div", [
                _c("transition", {
                    attrs: {
                        "enter-active-class": "transition-all duration-300 ease-in-out",
                        "leave-active-class": "transition-all duration-300 ease-in-out",
                        "enter-class": "transform translate-x-full",
                        "enter-to-class": "transform translate-x-0",
                        "leave-class": "transform translate-x-0",
                        "leave-to-class": "transform translate-x-full"
                    }
                }, [
                    _vm.showFilter ? _c("div", {
                        staticClass: "fixed top-0 left-0 z-40 w-screen h-screen pt-24 overflow-hidden overflow-y-auto bg-gray-100 pb-36 lg:pb-0 lg:pt-0 lg:overflow-visible lg:w-auto lg:bg-transparent lg:static lg:h-auto"
                    }, [
                        _vm.estateData.type !== "projects" || _vm.showFilter ? _c("div", [
                            _c("div", {
                                staticClass: "top-0 z-10 w-full p-6 pb-3 mb-5 font-serif text-3xl text-white lg:w-auto bg-brand-500 lg:bg-transparent lg:text-brand-500 lg:leading-tight lg:p-0 lg:text-6xl",
                                class: _vm.estateData.type === "projects" ? "fixed lg:hidden" : "fixed lg:static"
                            }, [
                                _c("h1", [
                                    _vm._v(_vm._s(_vm.estateData.title))
                                ]),
                                _vm._v(" "),
                                _c("button", {
                                    staticClass: "absolute top-0 right-0 p-2 mt-3.5 mr-3 text-3xl transition lg:hidden hover:opacity-80 active:opacity-50",
                                    on: {
                                        "click": _vm.toggleFilter
                                    }
                                }, [
                                    _c("i", {
                                        staticClass: "fal fa-times"
                                    })
                                ])
                            ]),
                            _vm._v(" "),
                            (_vm.estateData.type !== "spain" ? "lg:hidden" : "") ? _c("div", {
                                staticClass: "flex-col w-full p-5 space-y-5 text-base bg-white shadow lg:shadow-none lg:bg-transparent lg:flex-row lg:items-start lg:space-x-8 lg:p-0 lg:space-y-0 lg:mb-10",
                                class: _vm.estateData.type === "projects" ? "lg:hidden" : "flex"
                            }, [
                                _c("div", {
                                    staticClass: "relative flex-1",
                                    class: _vm.estateData.type === "projects" ? "lg:hidden" : ""
                                }, [
                                    _c("SearchFilter", {
                                        attrs: {
                                            "store": _vm.store,
                                            "lang": _vm.estateData.lang
                                        }
                                    })
                                ], 1),
                                _vm._v(" "),
                                _c("div", {
                                    staticClass: "lg:w-52",
                                    class: _vm.estateData.type === "projects" ? "lg:hidden" : ""
                                }, [
                                    _c("FilterCategories", {
                                        attrs: {
                                            "lang": _vm.estateData.lang,
                                            "locales": _vm.store.locales
                                        }
                                    })
                                ], 1),
                                _vm._v(" "),
                                _vm.estateData.type !== "projects" ? _c("FilterMinMaxPrice", {
                                    attrs: {
                                        "lang": _vm.estateData.lang,
                                        "locales": _vm.store.locales,
                                        "type": _vm.estateData.type
                                    }
                                }) : _vm._e(),
                                _vm._v(" "),
                                _vm.estateData.type !== "projects" ? _c("FilterRooms", {
                                    attrs: {
                                        "lang": _vm.estateData.lang,
                                        "locales": _vm.store.locales
                                    }
                                }) : _vm._e()
                            ], 1) : _vm._e()
                        ]) : _vm._e(),
                        _vm._v(" "),
                        _c("div", {
                            staticClass: "mt-5 text-base bg-white shadow lg:shadow-none lg:bg-transparent lg:mb-10 lg:mt-0"
                        }, [
                            _c("div", {
                                staticClass: "flex flex-col-reverse p-5 pt-0 lg:p-0 lg:flex-row lg:items-center lg:justify-between"
                            }, [
                                !_vm.store.mapMode ? [
                                    _c("div", {
                                        staticClass: "mt-5 lg:hidden"
                                    }, [
                                        _vm.totalPages > 0 ? _c("button", {
                                            staticClass: "w-full btn btn-danger",
                                            on: {
                                                "click": _vm.toggleFilter
                                            }
                                        }, [
                                            _vm._v("\n										" + _vm._s(_vm.store.locales[_vm.estateData.lang].show_results) + "\n										" + _vm._s(_vm.totalPosts) + "\n									")
                                        ]) : _c("div", {
                                            staticClass: "text-center text-gray-500"
                                        }, [
                                            _c("div", {
                                                domProps: {
                                                    "innerHTML": _vm._s(_vm.store.locales[_vm.estateData.lang].empty_filter)
                                                }
                                            }),
                                            _vm._v(" "),
                                            _c("button", {
                                                staticClass: "w-full mt-5 btn btn-danger is-disabled",
                                                on: {
                                                    "click": _vm.toggleFilter
                                                }
                                            }, [
                                                _vm._v("\n											" + _vm._s(_vm.store.locales[_vm.estateData.lang].back_to_overview) + "\n										")
                                            ])
                                        ])
                                    ])
                                ] : _vm._e(),
                                _vm._v(" "),
                                _vm.store.mapMode && _vm.markersLoaded ? [
                                    _c("div", {
                                        staticClass: "mt-5 lg:hidden"
                                    }, [
                                        _vm.totalPages > 0 ? _c("button", {
                                            staticClass: "w-full btn btn-danger",
                                            on: {
                                                "click": _vm.toggleFilter
                                            }
                                        }, [
                                            _vm._v("\n										" + _vm._s(_vm.store.locales[_vm.estateData.lang].show_results) + "\n										(" + _vm._s(_vm.markers.length) + ")\n									")
                                        ]) : _c("div", {
                                            staticClass: "text-center text-gray-500"
                                        }, [
                                            _c("div", {
                                                domProps: {
                                                    "innerHTML": _vm._s(_vm.store.locales[_vm.estateData.lang].empty_filter)
                                                }
                                            }),
                                            _vm._v(" "),
                                            _c("button", {
                                                staticClass: "w-full mt-5 btn btn-danger is-disabled",
                                                on: {
                                                    "click": _vm.toggleFilter
                                                }
                                            }, [
                                                _vm._v("\n											" + _vm._s(_vm.store.locales[_vm.estateData.lang].back_to_overview) + "\n										")
                                            ])
                                        ])
                                    ])
                                ] : _vm._e(),
                                _vm._v(" "),
                                _c("div", {
                                    staticClass: "hidden lg:block"
                                }, [
                                    _vm.estateData.type !== "projects" ? _c("div", [
                                        _vm.totalPages > 0 && !_vm.store.mapMode ? _c("p", {
                                            staticClass: "text-xl"
                                        }, [
                                            _vm._v("\n										" + _vm._s(_vm.totalPosts) + "\n										" + _vm._s(_vm.store.locales[_vm.estateData.lang].total_results) + "\n									")
                                        ]) : _vm._e(),
                                        _vm._v(" "),
                                        _vm.totalPages > 0 && _vm.store.mapMode && _vm.markersLoaded ? _c("p", {
                                            staticClass: "text-xl"
                                        }, [
                                            _vm._v("\n										" + _vm._s(_vm.markers.length) + "\n										" + _vm._s(_vm.store.locales[_vm.estateData.lang].total_results) + "\n									")
                                        ]) : _vm._e()
                                    ]) : _vm._e()
                                ]),
                                _vm._v(" "),
                                _c("div", {
                                    staticClass: "flex flex-col mt-5 space-y-5 lg:items-center lg:space-x-8 lg:flex-row lg:space-y-0 lg:mt-0"
                                }, [
                                    _c("FilterStatus", {
                                        attrs: {
                                            "lang": _vm.estateData.lang,
                                            "locales": _vm.store.locales
                                        }
                                    }),
                                    _vm._v(" "),
                                    _c("a", {
                                        staticClass: "hidden lg:inline-block btn-link is-line",
                                        attrs: {
                                            "href": "#"
                                        },
                                        on: {
                                            "click": function($event) {
                                                $event.preventDefault();
                                                return _vm.loadMap.apply(null, arguments);
                                            }
                                        }
                                    }, [
                                        !_vm.store.mapMode ? [
                                            _c("i", {
                                                staticClass: "fas fa-map-marker-alt"
                                            }),
                                            _vm._v("\n										" + _vm._s(_vm.store.locales[_vm.estateData.lang].view_map) + "\n									")
                                        ] : [
                                            _c("i", {
                                                staticClass: "fas fa-th-large"
                                            }),
                                            _vm._v("\n										" + _vm._s(_vm.store.locales[_vm.estateData.lang].view_list) + "\n									")
                                        ]
                                    ], 2),
                                    _vm._v(" "),
                                    _vm.estateData.type !== "projects" ? _c("div", {
                                        staticClass: "lg:w-64"
                                    }, [
                                        _c("FilterSort", {
                                            attrs: {
                                                "lang": _vm.estateData.lang,
                                                "locales": _vm.store.locales
                                            }
                                        })
                                    ], 1) : _vm._e()
                                ], 1)
                            ], 2)
                        ])
                    ]) : _vm._e()
                ])
            ], 1) : _vm._e(),
            _vm._v(" "),
            _vm.estateData.mode !== "latest" ? _c("h1", {
                staticClass: "mb-5 font-serif text-3xl text-center lg:hidden"
            }, [
                _vm._v("\n			" + _vm._s(_vm.estateData.title) + "\n		")
            ]) : _vm._e(),
            _vm._v(" "),
            _vm.estateData.mode !== "latest" ? _c("div", {
                staticClass: "mb-6 lg:hidden"
            }, [
                _c("div", {
                    staticClass: "flex items-center justify-between mb-5"
                }, [
                    _c("a", {
                        staticClass: "btn-link is-line",
                        attrs: {
                            "href": "#"
                        },
                        on: {
                            "click": function($event) {
                                $event.preventDefault();
                                return _vm.loadMap.apply(null, arguments);
                            }
                        }
                    }, [
                        !_vm.store.mapMode ? [
                            _c("i", {
                                staticClass: "fas fa-map-marker-alt"
                            }),
                            _vm._v("\n						" + _vm._s(_vm.store.locales[_vm.estateData.lang].view_map) + "\n					")
                        ] : [
                            _c("i", {
                                staticClass: "fas fa-th-large"
                            }),
                            _vm._v("\n						" + _vm._s(_vm.store.locales[_vm.estateData.lang].view_list) + "\n					")
                        ]
                    ], 2),
                    _vm._v(" "),
                    _c("a", {
                        staticClass: "btn-link is-line",
                        attrs: {
                            "href": "#"
                        },
                        on: {
                            "click": function($event) {
                                $event.preventDefault();
                                return _vm.toggleFilter.apply(null, arguments);
                            }
                        }
                    }, [
                        _c("i", {
                            staticClass: "fas fa-filter"
                        }),
                        _vm._v("\n					" + _vm._s(_vm.store.locales[_vm.estateData.lang].filter) + "\n				")
                    ])
                ]),
                _vm._v(" "),
                _vm.estateData.type !== "projects" ? _c("div", {
                    staticClass: "text-center"
                }, [
                    _vm.totalPages > 0 && !_vm.store.mapMode ? _c("p", [
                        _vm._v("\n					" + _vm._s(_vm.totalPosts) + "\n					" + _vm._s(_vm.store.locales[_vm.estateData.lang].total_results) + "\n				")
                    ]) : _vm._e(),
                    _vm._v(" "),
                    _vm.totalPages > 0 && _vm.store.mapMode && _vm.markersLoaded ? _c("p", [
                        _vm._v("\n					" + _vm._s(_vm.markers.length) + "\n					" + _vm._s(_vm.store.locales[_vm.estateData.lang].total_results) + "\n				")
                    ]) : _vm._e()
                ]) : _vm._e()
            ]) : _vm._e(),
            _vm._v(" "),
            !_vm.store.mapMode && _vm.estates.length > 0 && _vm.totalPages > 0 ? _c("div", {
                staticClass: "flex flex-col -m-4 lg:-m-5 lg:flex-wrap lg:flex-row",
                class: _vm.estateData.type === "projects" ? "lg:w-11/12 lg:mx-auto" : ""
            }, _vm._l(_vm.estates, function(estate) {
                return _c("div", {
                    key: estate.uid,
                    class: _vm.estateData.type === "projects" ? "w-full" : "lg:w-1/2 xl:w-1/3"
                }, [
                    _vm.estateData.type !== "projects" ? [
                        _c("CardDefault", {
                            attrs: {
                                "estate": estate,
                                "loading": _vm.isLoading,
                                "estate-data": _vm.estateData,
                                "locales": _vm.store.locales
                            }
                        })
                    ] : [
                        _c("CardAlt", {
                            attrs: {
                                "estate": estate,
                                "loading": _vm.isLoading,
                                "estate-data": _vm.estateData,
                                "locales": _vm.store.locales
                            }
                        })
                    ]
                ], 2);
            }), 0) : _vm._e(),
            _vm._v(" "),
            !_vm.store.mapMode && _vm.estates.length === 0 && _vm.totalPages > -1 ? [
                _c("div", {
                    staticClass: "p-5 mt-10 text-center border rounded-md shadow lg:p-10 border-opacity-20 border-brand-500"
                }, [
                    _c("i", {
                        staticClass: "mb-2 text-6xl text-gray-400 fad fa-home"
                    }),
                    _vm._v(" "),
                    _c("p", [
                        _vm._v(_vm._s(_vm.store.locales[_vm.estateData.lang].no_results))
                    ])
                ])
            ] : _vm._e(),
            _vm._v(" "),
            _vm.store.mapMode && _vm.markersLoaded && _vm.markers.length > 0 ? _c("div", [
                _c("MapView", {
                    attrs: {
                        "marker-data": _vm.markers,
                        "store": _vm.store,
                        "lang": _vm.estateData.lang,
                        "type": _vm.estateData.type
                    }
                })
            ], 1) : _vm._e(),
            _vm._v(" "),
            _vm.store.mapMode && _vm.markersLoaded && _vm.markers.length === 0 ? [
                _c("div", {
                    staticClass: "p-5 mt-10 text-center border rounded-md shadow lg:p-10 border-opacity-20 border-brand-500"
                }, [
                    _c("i", {
                        staticClass: "mb-2 text-6xl text-gray-400 fad fa-home"
                    }),
                    _vm._v(" "),
                    _c("p", [
                        _vm._v(_vm._s(_vm.store.locales[_vm.estateData.lang].no_results))
                    ])
                ])
            ] : _vm._e(),
            _vm._v(" "),
            _vm.estates.length > 0 && _vm.totalPages > 0 && _vm.estateData.mode !== "latest" && !_vm.store.mapMode ? [
                _c("div", {
                    staticClass: "mt-12"
                }, [
                    _c("paginate", {
                        attrs: {
                            "page-count": _vm.totalPages,
                            "click-handler": _vm.$sweepBrightPaginate,
                            "disabled-class": "hidden",
                            "prev-link-class": "tracking-widest uppercase text-sm transition duration-200 hover:text-black focus:outline-none mr-5",
                            "next-link-class": "tracking-widest uppercase text-sm transition duration-200 hover:text-black focus:outline-none ml-5",
                            "container-class": "flex items-center space-x-3 justify-center",
                            "page-link-class": "focus:outline-none",
                            "page-class": "inline-block text-lg w-10 h-10 rounded-full flex items-center justify-center",
                            "active-class": "bg-black text-white",
                            "prev-text": "&larr; Back",
                            "next-text": "Next &rarr;",
                            "hide-prev-next": false
                        },
                        model: {
                            value: _vm.activePage,
                            callback: function($$v) {
                                _vm.activePage = $$v;
                            },
                            expression: "activePage"
                        }
                    })
                ], 1)
            ] : _vm._e()
        ], 2) : _vm._e()
    ]);
};
var $4429a48cbc17248a$var$staticRenderFns = [];
$4429a48cbc17248a$export$b3890eb0ae9dca99 = $4429a48cbc17248a$var$render;
$4429a48cbc17248a$export$f8436702749526f9 = $4429a48cbc17248a$var$staticRenderFns;

});

parcelRequire.register("3n25D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27452416ab3d8e64$export$2e2bcd8739ae039; });
let $27452416ab3d8e64$var$NOOP = ()=>{};
var $27452416ab3d8e64$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire.register("5uRil", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $4009185a15df0a94$export$2e2bcd8739ae039; });

var $hr0I9 = parcelRequire("hr0I9");

var $2YtuV = parcelRequire("2YtuV");
var $4009185a15df0a94$var$scriptExports = {
    components: {
        [(0, $2YtuV.Glide).name]: (0, $2YtuV.Glide),
        [(0, $2YtuV.GlideSlide).name]: (0, $2YtuV.GlideSlide)
    },
    data () {
        return {
            officesData: window.officesData,
            activeTab: 0,
            glideOptions: {
                type: "carousel",
                perView: 1,
                gap: 0,
                keyboard: false,
                animationDuration: 300,
                breakpoints: {
                    1023: {
                        gap: 15,
                        peek: {
                            before: 30,
                            after: 30
                        }
                    }
                }
            }
        };
    },
    mounted () {
        new (0, (/*@__PURE__*/$parcel$interopDefault($hr0I9)))({
            elements_selector: ".lazy",
            unobserve_entered: true
        });
    },
    methods: {
        setTab (id) {
            this.activeTab = id;
        }
    }
};
var $4009185a15df0a94$var$options = typeof $4009185a15df0a94$var$scriptExports === "function" ? $4009185a15df0a94$var$scriptExports.options : $4009185a15df0a94$var$scriptExports;
var $4009185a15df0a94$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $4009185a15df0a94$var$options;

});

parcelRequire.register("aq9nh", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $79639aad833738f3$export$b3890eb0ae9dca99; }, function (v) { return $79639aad833738f3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $79639aad833738f3$export$f8436702749526f9; }, function (v) { return $79639aad833738f3$export$f8436702749526f9 = v; });
var $79639aad833738f3$export$b3890eb0ae9dca99;
var $79639aad833738f3$export$f8436702749526f9;
var $79639aad833738f3$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", {
        staticClass: "flex flex-col space-y-10 xl:flex-row xl:space-y-0",
        attrs: {
            "data-component": "offices"
        }
    }, [
        _c("div", {
            staticClass: "w-10/12 mx-auto xl:w-3/12"
        }, [
            _c("h2", {
                staticClass: "font-serif text-3xl xl:leading-tight xl:text-5xl xl:mb-10"
            }, [
                _vm._v("\n      " + _vm._s(_vm.officesData.offices.length) + "\n      "),
                _vm.officesData.lang === "nl" ? [
                    _vm._v("\n        lokale kantoren\n      ")
                ] : _vm._e(),
                _vm._v(" "),
                _vm.officesData.lang === "fr" ? [
                    _vm._v("\n        agences locales\n      ")
                ] : _vm._e()
            ], 2),
            _vm._v(" "),
            _c("ul", {
                staticClass: "hidden space-y-6 xl:block"
            }, _vm._l(_vm.officesData.offices, function(office, index) {
                return _c("li", {
                    key: office.id
                }, [
                    _c("a", {
                        class: "text-base tracking-wider uppercase btn-link " + (index === _vm.activeTab ? "is-line" : "opacity-50 hover:opacity-100"),
                        attrs: {
                            "href": "#"
                        },
                        on: {
                            "click": function($event) {
                                $event.preventDefault();
                                $event.stopPropagation();
                                return _vm.setTab(index);
                            }
                        }
                    }, [
                        _vm._v("\n          " + _vm._s(office.title) + "\n        ")
                    ])
                ]);
            }), 0)
        ]),
        _vm._v(" "),
        _c("div", {
            staticClass: "xl:w-9/12"
        }, [
            _c("vue-glide", {
                attrs: {
                    "options": _vm.glideOptions
                },
                model: {
                    value: _vm.activeTab,
                    callback: function($$v) {
                        _vm.activeTab = $$v;
                    },
                    expression: "activeTab"
                }
            }, _vm._l(_vm.officesData.offices, function(office) {
                return _c("vue-glide-slide", {
                    key: office.id
                }, [
                    _c("div", {
                        staticClass: "flex flex-col pr-6 xl:flex-row-reverse xl:items-end xl:pb-28"
                    }, [
                        _c("div", {
                            staticClass: "relative z-0 w-full xl:w-1/2"
                        }, [
                            _c("div", {
                                staticClass: "w-full"
                            }, [
                                _c("div", {
                                    staticClass: "relative"
                                }, [
                                    _c("div", {
                                        staticClass: "aspect-ratio-4/3"
                                    }),
                                    _vm._v(" "),
                                    _c("img", {
                                        staticClass: "absolute top-0 left-0 z-0 object-cover object-center w-full h-full lazy",
                                        attrs: {
                                            "data-src": office.meta.images[0].sizes.medium
                                        }
                                    })
                                ])
                            ])
                        ]),
                        _vm._v(" "),
                        _c("div", {
                            staticClass: "relative z-10 w-full xl:w-1/2 xl:-right-1/4"
                        }, [
                            _c("div", {
                                class: "p-8 pb-12 xl:-mb-28 xl:p-14 xl:shadow-xl bg-opacity-95 " + (!_vm.officesData.light ? "bg-white text-brand-500" : "bg-brand-500 text-white")
                            }, [
                                _c("p", {
                                    staticClass: "mb-5 text-base tracking-wider uppercase xl:mb-8"
                                }, [
                                    _vm._v("\n                " + _vm._s(office.title) + "\n              ")
                                ]),
                                _vm._v(" "),
                                _c("ul", {
                                    staticClass: "mb-8 space-y-6 font-light xl:mb-10"
                                }, [
                                    _c("li", {
                                        staticClass: "flex"
                                    }, [
                                        _c("i", {
                                            staticClass: "w-8 fas fa-map-marker-alt text-danger-500"
                                        }),
                                        _vm._v(" "),
                                        _c("a", {
                                            staticClass: "-mt-1 transition duration-200 hover:text-danger-500",
                                            attrs: {
                                                "href": office.meta.office_details.google_maps,
                                                "target": "_blank"
                                            }
                                        }, [
                                            _c("p", [
                                                _vm._v(_vm._s(office.meta.office_details.street))
                                            ]),
                                            _vm._v(" "),
                                            _c("p", [
                                                _vm._v(_vm._s(office.meta.office_details.city))
                                            ])
                                        ])
                                    ]),
                                    _vm._v(" "),
                                    _c("li", {
                                        staticClass: "flex"
                                    }, [
                                        _c("i", {
                                            staticClass: "w-8 fas fa-phone text-danger-500"
                                        }),
                                        _vm._v(" "),
                                        _c("div", {
                                            staticClass: "-mt-1"
                                        }, [
                                            _c("a", {
                                                staticClass: "transition duration-200 hover:text-danger-500",
                                                attrs: {
                                                    "href": "tel:" + office.meta.office_details.phone
                                                }
                                            }, [
                                                _vm._v(_vm._s(office.meta.office_details.phone))
                                            ])
                                        ])
                                    ])
                                ]),
                                _vm._v(" "),
                                _c("a", {
                                    staticClass: "btn btn-danger",
                                    attrs: {
                                        "href": office.permalink
                                    }
                                }, [
                                    _vm.officesData.lang === "nl" ? [
                                        _vm._v("Ontdek ons kantoor")
                                    ] : _vm._e(),
                                    _vm._v(" "),
                                    _vm.officesData.lang === "fr" ? [
                                        _vm._v("Decouvrez cette agence")
                                    ] : _vm._e()
                                ], 2)
                            ])
                        ])
                    ])
                ]);
            }), 1)
        ], 1)
    ]);
};
var $79639aad833738f3$var$staticRenderFns = [];
$79639aad833738f3$export$b3890eb0ae9dca99 = $79639aad833738f3$var$render;
$79639aad833738f3$export$f8436702749526f9 = $79639aad833738f3$var$staticRenderFns;

});

parcelRequire.register("6wOI5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c0d11343977f2d5$export$2e2bcd8739ae039; });
let $4c0d11343977f2d5$var$NOOP = ()=>{};
var $4c0d11343977f2d5$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire.register("jWuYZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $e84b779c94445aa4$export$2e2bcd8739ae039; });

var $8ABro = parcelRequire("8ABro");

var $hr0I9 = parcelRequire("hr0I9");
var $e84b779c94445aa4$var$scriptExports = {
    components: {},
    data () {
        return {
            activeTab: 0,
            showTab: true,
            player: false,
            servicesData: window.servicesData
        };
    },
    mounted () {
        this.init();
    },
    methods: {
        youtubeParser (url) {
            const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
            const match = url.match(regExp);
            return match && match[7].length == 11 ? match[7] : false;
        },
        setTab (index) {
            this.activeTab = index;
            this.showTab = false;
            setTimeout(()=>{
                this.showTab = true;
            }, 200);
            this.$nextTick(()=>{
                this.init();
            });
        },
        init () {
            new (0, (/*@__PURE__*/$parcel$interopDefault($hr0I9)))({
                elements_selector: ".lazy",
                unobserve_entered: true
            });
            this.player = new (0, (/*@__PURE__*/$parcel$interopDefault($8ABro)))("#player", {
                controls: [
                    "play-large",
                    "play",
                    "progress",
                    "current-time",
                    "mute",
                    "volume",
                    "fullscreen"
                ]
            });
        }
    }
};
var $e84b779c94445aa4$var$options = typeof $e84b779c94445aa4$var$scriptExports === "function" ? $e84b779c94445aa4$var$scriptExports.options : $e84b779c94445aa4$var$scriptExports;
var $e84b779c94445aa4$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $e84b779c94445aa4$var$options;

});
parcelRequire.register("8ABro", function(module, exports) {
"object" == typeof navigator && function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    function e(e, t, i) {
        return (t = function(e) {
            var t = function(e, t) {
                if ("object" != typeof e || null === e) return e;
                var i = e[Symbol.toPrimitive];
                if (void 0 !== i) {
                    var s = i.call(e, t || "default");
                    if ("object" != typeof s) return s;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return ("string" === t ? String : Number)(e);
            }(e, "string");
            return "symbol" == typeof t ? t : String(t);
        }(t)) in e ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = i, e;
    }
    function t(e, t) {
        for(var i = 0; i < t.length; i++){
            var s = t[i];
            s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(e, s.key, s);
        }
    }
    function i(e, t, i) {
        return t in e ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = i, e;
    }
    function s(e, t) {
        var i = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var s = Object.getOwnPropertySymbols(e);
            t && (s = s.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), i.push.apply(i, s);
        }
        return i;
    }
    function n(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = null != arguments[t] ? arguments[t] : {};
            t % 2 ? s(Object(n), !0).forEach(function(t) {
                i(e, t, n[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
            });
        }
        return e;
    }
    var a = {
        addCSS: !0,
        thumbWidth: 15,
        watch: !0
    };
    var l = function(e) {
        return null != e ? e.constructor : null;
    }, r = function(e, t) {
        return !!(e && t && e instanceof t);
    }, o = function(e) {
        return null == e;
    }, c = function(e) {
        return l(e) === Object;
    }, u = function(e) {
        return l(e) === String;
    }, h = function(e) {
        return Array.isArray(e);
    }, d = function(e) {
        return r(e, NodeList);
    }, m = {
        nullOrUndefined: o,
        object: c,
        number: function(e) {
            return l(e) === Number && !Number.isNaN(e);
        },
        string: u,
        boolean: function(e) {
            return l(e) === Boolean;
        },
        function: function(e) {
            return l(e) === Function;
        },
        array: h,
        nodeList: d,
        element: function(e) {
            return r(e, Element);
        },
        event: function(e) {
            return r(e, Event);
        },
        empty: function(e) {
            return o(e) || (u(e) || h(e) || d(e)) && !e.length || c(e) && !Object.keys(e).length;
        }
    };
    function p(e, t) {
        if (1 > t) {
            var i = function(e) {
                var t = "".concat(e).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
                return t ? Math.max(0, (t[1] ? t[1].length : 0) - (t[2] ? +t[2] : 0)) : 0;
            }(t);
            return parseFloat(e.toFixed(i));
        }
        return Math.round(e / t) * t;
    }
    var g = function() {
        function e(t, i) {
            (function(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            })(this, e), m.element(t) ? this.element = t : m.string(t) && (this.element = document.querySelector(t)), m.element(this.element) && m.empty(this.element.rangeTouch) && (this.config = n({}, a, {}, i), this.init());
        }
        return function(e, i, s) {
            i && t(e.prototype, i), s && t(e, s);
        }(e, [
            {
                key: "init",
                value: function() {
                    e.enabled && (this.config.addCSS && (this.element.style.userSelect = "none", this.element.style.webKitUserSelect = "none", this.element.style.touchAction = "manipulation"), this.listeners(!0), this.element.rangeTouch = this);
                }
            },
            {
                key: "destroy",
                value: function() {
                    e.enabled && (this.config.addCSS && (this.element.style.userSelect = "", this.element.style.webKitUserSelect = "", this.element.style.touchAction = ""), this.listeners(!1), this.element.rangeTouch = null);
                }
            },
            {
                key: "listeners",
                value: function(e) {
                    var t = this, i = e ? "addEventListener" : "removeEventListener";
                    [
                        "touchstart",
                        "touchmove",
                        "touchend"
                    ].forEach(function(e) {
                        t.element[i](e, function(e) {
                            return t.set(e);
                        }, !1);
                    });
                }
            },
            {
                key: "get",
                value: function(t) {
                    if (!e.enabled || !m.event(t)) return null;
                    var i, s = t.target, n = t.changedTouches[0], a = parseFloat(s.getAttribute("min")) || 0, l = parseFloat(s.getAttribute("max")) || 100, r = parseFloat(s.getAttribute("step")) || 1, o = s.getBoundingClientRect(), c = 100 / o.width * (this.config.thumbWidth / 2) / 100;
                    return 0 > (i = 100 / o.width * (n.clientX - o.left)) ? i = 0 : 100 < i && (i = 100), 50 > i ? i -= (100 - 2 * i) * c : 50 < i && (i += 2 * (i - 50) * c), a + p(i / 100 * (l - a), r);
                }
            },
            {
                key: "set",
                value: function(t) {
                    e.enabled && m.event(t) && !t.target.disabled && (t.preventDefault(), t.target.value = this.get(t), function(e, t) {
                        if (e && t) {
                            var i = new Event(t, {
                                bubbles: !0
                            });
                            e.dispatchEvent(i);
                        }
                    }(t.target, "touchend" === t.type ? "change" : "input"));
                }
            }
        ], [
            {
                key: "setup",
                value: function(t) {
                    var i = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {}, s = null;
                    if (m.empty(t) || m.string(t) ? s = Array.from(document.querySelectorAll(m.string(t) ? t : 'input[type="range"]')) : m.element(t) ? s = [
                        t
                    ] : m.nodeList(t) ? s = Array.from(t) : m.array(t) && (s = t.filter(m.element)), m.empty(s)) return null;
                    var l = n({}, a, {}, i);
                    if (m.string(t) && l.watch) {
                        var r = new MutationObserver(function(i) {
                            Array.from(i).forEach(function(i) {
                                Array.from(i.addedNodes).forEach(function(i) {
                                    m.element(i) && function(e, t) {
                                        return (function() {
                                            return Array.from(document.querySelectorAll(t)).includes(this);
                                        }).call(e, t);
                                    }(i, t) && new e(i, l);
                                });
                            });
                        });
                        r.observe(document.body, {
                            childList: !0,
                            subtree: !0
                        });
                    }
                    return s.map(function(t) {
                        return new e(t, i);
                    });
                }
            },
            {
                key: "enabled",
                get: function() {
                    return "ontouchstart" in document.documentElement;
                }
            }
        ]), e;
    }();
    const f = (e)=>null != e ? e.constructor : null, y = (e, t)=>Boolean(e && t && e instanceof t), b = (e)=>null == e, v = (e)=>f(e) === Object, w = (e)=>f(e) === String, T = (e)=>"function" == typeof e, k = (e)=>Array.isArray(e), C = (e)=>y(e, NodeList), A = (e)=>b(e) || (w(e) || k(e) || C(e)) && !e.length || v(e) && !Object.keys(e).length;
    var S = {
        nullOrUndefined: b,
        object: v,
        number: (e)=>f(e) === Number && !Number.isNaN(e),
        string: w,
        boolean: (e)=>f(e) === Boolean,
        function: T,
        array: k,
        weakMap: (e)=>y(e, WeakMap),
        nodeList: C,
        element: (e)=>null !== e && "object" == typeof e && 1 === e.nodeType && "object" == typeof e.style && "object" == typeof e.ownerDocument,
        textNode: (e)=>f(e) === Text,
        event: (e)=>y(e, Event),
        keyboardEvent: (e)=>y(e, KeyboardEvent),
        cue: (e)=>y(e, window.TextTrackCue) || y(e, window.VTTCue),
        track: (e)=>y(e, TextTrack) || !b(e) && w(e.kind),
        promise: (e)=>y(e, Promise) && T(e.then),
        url: (e)=>{
            if (y(e, window.URL)) return !0;
            if (!w(e)) return !1;
            let t = e;
            e.startsWith("http://") && e.startsWith("https://") || (t = `http://${e}`);
            try {
                return !A(new URL(t).hostname);
            } catch (e) {
                return !1;
            }
        },
        empty: A
    };
    const E = (()=>{
        const e = document.createElement("span"), t = {
            WebkitTransition: "webkitTransitionEnd",
            MozTransition: "transitionend",
            OTransition: "oTransitionEnd otransitionend",
            transition: "transitionend"
        }, i = Object.keys(t).find((t)=>void 0 !== e.style[t]);
        return !!S.string(i) && t[i];
    })();
    function P(e, t) {
        setTimeout(()=>{
            try {
                e.hidden = !0, e.offsetHeight, e.hidden = !1;
            } catch (e) {}
        }, t);
    }
    var M = {
        isIE: Boolean(window.document.documentMode),
        isEdge: /Edge/g.test(navigator.userAgent),
        isWebKit: "WebkitAppearance" in document.documentElement.style && !/Edge/g.test(navigator.userAgent),
        isIPhone: /iPhone|iPod/gi.test(navigator.userAgent) && navigator.maxTouchPoints > 1,
        isIPadOS: "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1,
        isIos: /iPad|iPhone|iPod/gi.test(navigator.userAgent) && navigator.maxTouchPoints > 1
    };
    function N(e, t) {
        return t.split(".").reduce((e, t)=>e && e[t], e);
    }
    function x(e = {}, ...t) {
        if (!t.length) return e;
        const i = t.shift();
        return S.object(i) ? (Object.keys(i).forEach((t)=>{
            S.object(i[t]) ? (Object.keys(e).includes(t) || Object.assign(e, {
                [t]: {}
            }), x(e[t], i[t])) : Object.assign(e, {
                [t]: i[t]
            });
        }), x(e, ...t)) : e;
    }
    function L(e, t) {
        const i = e.length ? e : [
            e
        ];
        Array.from(i).reverse().forEach((e, i)=>{
            const s = i > 0 ? t.cloneNode(!0) : t, n = e.parentNode, a = e.nextSibling;
            s.appendChild(e), a ? n.insertBefore(s, a) : n.appendChild(s);
        });
    }
    function I(e, t) {
        S.element(e) && !S.empty(t) && Object.entries(t).filter(([, e])=>!S.nullOrUndefined(e)).forEach(([t, i])=>e.setAttribute(t, i));
    }
    function $(e, t, i) {
        const s = document.createElement(e);
        return S.object(t) && I(s, t), S.string(i) && (s.innerText = i), s;
    }
    function _(e, t, i, s) {
        S.element(t) && t.appendChild($(e, i, s));
    }
    function O(e) {
        S.nodeList(e) || S.array(e) ? Array.from(e).forEach(O) : S.element(e) && S.element(e.parentNode) && e.parentNode.removeChild(e);
    }
    function j(e) {
        if (!S.element(e)) return;
        let { length: t } = e.childNodes;
        for(; t > 0;)e.removeChild(e.lastChild), t -= 1;
    }
    function q(e, t) {
        return S.element(t) && S.element(t.parentNode) && S.element(e) ? (t.parentNode.replaceChild(e, t), e) : null;
    }
    function D(e, t) {
        if (!S.string(e) || S.empty(e)) return {};
        const i = {}, s = x({}, t);
        return e.split(",").forEach((e)=>{
            const t = e.trim(), n = t.replace(".", ""), a = t.replace(/[[\]]/g, "").split("="), [l] = a, r = a.length > 1 ? a[1].replace(/["']/g, "") : "";
            switch(t.charAt(0)){
                case ".":
                    S.string(s.class) ? i.class = `${s.class} ${n}` : i.class = n;
                    break;
                case "#":
                    i.id = t.replace("#", "");
                    break;
                case "[":
                    i[l] = r;
            }
        }), x(s, i);
    }
    function H(e, t) {
        if (!S.element(e)) return;
        let i = t;
        S.boolean(i) || (i = !e.hidden), e.hidden = i;
    }
    function R(e, t, i) {
        if (S.nodeList(e)) return Array.from(e).map((e)=>R(e, t, i));
        if (S.element(e)) {
            let s = "toggle";
            return void 0 !== i && (s = i ? "add" : "remove"), e.classList[s](t), e.classList.contains(t);
        }
        return !1;
    }
    function F(e, t) {
        return S.element(e) && e.classList.contains(t);
    }
    function V(e, t) {
        const { prototype: i } = Element;
        return (i.matches || i.webkitMatchesSelector || i.mozMatchesSelector || i.msMatchesSelector || function() {
            return Array.from(document.querySelectorAll(t)).includes(this);
        }).call(e, t);
    }
    function U(e) {
        return this.elements.container.querySelectorAll(e);
    }
    function B(e) {
        return this.elements.container.querySelector(e);
    }
    function W(e = null, t = !1) {
        S.element(e) && e.focus({
            preventScroll: !0,
            focusVisible: t
        });
    }
    const z = {
        "audio/ogg": "vorbis",
        "audio/wav": "1",
        "video/webm": "vp8, vorbis",
        "video/mp4": "avc1.42E01E, mp4a.40.2",
        "video/ogg": "theora"
    }, K = {
        audio: "canPlayType" in document.createElement("audio"),
        video: "canPlayType" in document.createElement("video"),
        check (e, t) {
            const i = K[e] || "html5" !== t;
            return {
                api: i,
                ui: i && K.rangeInput
            };
        },
        pip: !(M.isIPhone || !S.function($("video").webkitSetPresentationMode) && (!document.pictureInPictureEnabled || $("video").disablePictureInPicture)),
        airplay: S.function(window.WebKitPlaybackTargetAvailabilityEvent),
        playsinline: "playsInline" in document.createElement("video"),
        mime (e) {
            if (S.empty(e)) return !1;
            const [t] = e.split("/");
            let i = e;
            if (!this.isHTML5 || t !== this.type) return !1;
            Object.keys(z).includes(i) && (i += `; codecs="${z[e]}"`);
            try {
                return Boolean(i && this.media.canPlayType(i).replace(/no/, ""));
            } catch (e) {
                return !1;
            }
        },
        textTracks: "textTracks" in document.createElement("video"),
        rangeInput: (()=>{
            const e = document.createElement("input");
            return e.type = "range", "range" === e.type;
        })(),
        touch: "ontouchstart" in document.documentElement,
        transitions: !1 !== E,
        reducedMotion: "matchMedia" in window && window.matchMedia("(prefers-reduced-motion)").matches
    }, Y = (()=>{
        let e = !1;
        try {
            const t = Object.defineProperty({}, "passive", {
                get: ()=>(e = !0, null)
            });
            window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
        } catch (e) {}
        return e;
    })();
    function Q(e, t, i, s = !1, n = !0, a = !1) {
        if (!e || !("addEventListener" in e) || S.empty(t) || !S.function(i)) return;
        const l = t.split(" ");
        let r = a;
        Y && (r = {
            passive: n,
            capture: a
        }), l.forEach((t)=>{
            this && this.eventListeners && s && this.eventListeners.push({
                element: e,
                type: t,
                callback: i,
                options: r
            }), e[s ? "addEventListener" : "removeEventListener"](t, i, r);
        });
    }
    function X(e, t = "", i, s = !0, n = !1) {
        Q.call(this, e, t, i, !0, s, n);
    }
    function J(e, t = "", i, s = !0, n = !1) {
        Q.call(this, e, t, i, !1, s, n);
    }
    function G(e, t = "", i, s = !0, n = !1) {
        const a = (...l)=>{
            J(e, t, a, s, n), i.apply(this, l);
        };
        Q.call(this, e, t, a, !0, s, n);
    }
    function Z(e, t = "", i = !1, s = {}) {
        if (!S.element(e) || S.empty(t)) return;
        const n = new CustomEvent(t, {
            bubbles: i,
            detail: {
                ...s,
                plyr: this
            }
        });
        e.dispatchEvent(n);
    }
    function ee() {
        this && this.eventListeners && (this.eventListeners.forEach((e)=>{
            const { element: t, type: i, callback: s, options: n } = e;
            t.removeEventListener(i, s, n);
        }), this.eventListeners = []);
    }
    function te() {
        return new Promise((e)=>this.ready ? setTimeout(e, 0) : X.call(this, this.elements.container, "ready", e)).then(()=>{});
    }
    function ie(e) {
        S.promise(e) && e.then(null, ()=>{});
    }
    function se(e) {
        return S.array(e) ? e.filter((t, i)=>e.indexOf(t) === i) : e;
    }
    function ne(e, t) {
        return S.array(e) && e.length ? e.reduce((e, i)=>Math.abs(i - t) < Math.abs(e - t) ? i : e) : null;
    }
    function ae(e) {
        return !(!window || !window.CSS) && window.CSS.supports(e);
    }
    const le = [
        [
            1,
            1
        ],
        [
            4,
            3
        ],
        [
            3,
            4
        ],
        [
            5,
            4
        ],
        [
            4,
            5
        ],
        [
            3,
            2
        ],
        [
            2,
            3
        ],
        [
            16,
            10
        ],
        [
            10,
            16
        ],
        [
            16,
            9
        ],
        [
            9,
            16
        ],
        [
            21,
            9
        ],
        [
            9,
            21
        ],
        [
            32,
            9
        ],
        [
            9,
            32
        ]
    ].reduce((e, [t, i])=>({
            ...e,
            [t / i]: [
                t,
                i
            ]
        }), {});
    function re(e) {
        if (!(S.array(e) || S.string(e) && e.includes(":"))) return !1;
        return (S.array(e) ? e : e.split(":")).map(Number).every(S.number);
    }
    function oe(e) {
        if (!S.array(e) || !e.every(S.number)) return null;
        const [t, i] = e, s = (e, t)=>0 === t ? e : s(t, e % t), n = s(t, i);
        return [
            t / n,
            i / n
        ];
    }
    function ce(e) {
        const t = (e)=>re(e) ? e.split(":").map(Number) : null;
        let i = t(e);
        if (null === i && (i = t(this.config.ratio)), null === i && !S.empty(this.embed) && S.array(this.embed.ratio) && ({ ratio: i } = this.embed), null === i && this.isHTML5) {
            const { videoWidth: e, videoHeight: t } = this.media;
            i = [
                e,
                t
            ];
        }
        return oe(i);
    }
    function ue(e) {
        if (!this.isVideo) return {};
        const { wrapper: t } = this.elements, i = ce.call(this, e);
        if (!S.array(i)) return {};
        const [s, n] = oe(i), a = 100 / s * n;
        if (ae(`aspect-ratio: ${s}/${n}`) ? t.style.aspectRatio = `${s}/${n}` : t.style.paddingBottom = `${a}%`, this.isVimeo && !this.config.vimeo.premium && this.supported.ui) {
            const e = 100 / this.media.offsetWidth * parseInt(window.getComputedStyle(this.media).paddingBottom, 10), i = (e - a) / (e / 50);
            this.fullscreen.active ? t.style.paddingBottom = null : this.media.style.transform = `translateY(-${i}%)`;
        } else this.isHTML5 && t.classList.add(this.config.classNames.videoFixedRatio);
        return {
            padding: a,
            ratio: i
        };
    }
    function he(e, t, i = .05) {
        const s = e / t, n = ne(Object.keys(le), s);
        return Math.abs(n - s) <= i ? le[n] : [
            e,
            t
        ];
    }
    const de = {
        getSources () {
            if (!this.isHTML5) return [];
            return Array.from(this.media.querySelectorAll("source")).filter((e)=>{
                const t = e.getAttribute("type");
                return !!S.empty(t) || K.mime.call(this, t);
            });
        },
        getQualityOptions () {
            return this.config.quality.forced ? this.config.quality.options : de.getSources.call(this).map((e)=>Number(e.getAttribute("size"))).filter(Boolean);
        },
        setup () {
            if (!this.isHTML5) return;
            const e = this;
            e.options.speed = e.config.speed.options, S.empty(this.config.ratio) || ue.call(e), Object.defineProperty(e.media, "quality", {
                get () {
                    const t = de.getSources.call(e).find((t)=>t.getAttribute("src") === e.source);
                    return t && Number(t.getAttribute("size"));
                },
                set (t) {
                    if (e.quality !== t) {
                        if (e.config.quality.forced && S.function(e.config.quality.onChange)) e.config.quality.onChange(t);
                        else {
                            const i = de.getSources.call(e).find((e)=>Number(e.getAttribute("size")) === t);
                            if (!i) return;
                            const { currentTime: s, paused: n, preload: a, readyState: l, playbackRate: r } = e.media;
                            e.media.src = i.getAttribute("src"), ("none" !== a || l) && (e.once("loadedmetadata", ()=>{
                                e.speed = r, e.currentTime = s, n || ie(e.play());
                            }), e.media.load());
                        }
                        Z.call(e, e.media, "qualitychange", !1, {
                            quality: t
                        });
                    }
                }
            });
        },
        cancelRequests () {
            this.isHTML5 && (O(de.getSources.call(this)), this.media.setAttribute("src", this.config.blankVideo), this.media.load(), this.debug.log("Cancelled network requests"));
        }
    };
    function me(e, ...t) {
        return S.empty(e) ? e : e.toString().replace(/{(\d+)}/g, (e, i)=>t[i].toString());
    }
    const pe = (e = "", t = "", i = "")=>e.replace(new RegExp(t.toString().replace(/([.*+?^=!:${}()|[\]/\\])/g, "\\$1"), "g"), i.toString()), ge = (e = "")=>e.toString().replace(/\w\S*/g, (e)=>e.charAt(0).toUpperCase() + e.slice(1).toLowerCase());
    function fe(e = "") {
        let t = e.toString();
        return t = function(e = "") {
            let t = e.toString();
            return t = pe(t, "-", " "), t = pe(t, "_", " "), t = ge(t), pe(t, " ", "");
        }(t), t.charAt(0).toLowerCase() + t.slice(1);
    }
    function ye(e) {
        const t = document.createElement("div");
        return t.appendChild(e), t.innerHTML;
    }
    const be = {
        pip: "PIP",
        airplay: "AirPlay",
        html5: "HTML5",
        vimeo: "Vimeo",
        youtube: "YouTube"
    }, ve = {
        get (e = "", t = {}) {
            if (S.empty(e) || S.empty(t)) return "";
            let i = N(t.i18n, e);
            if (S.empty(i)) return Object.keys(be).includes(e) ? be[e] : "";
            const s = {
                "{seektime}": t.seekTime,
                "{title}": t.title
            };
            return Object.entries(s).forEach(([e, t])=>{
                i = pe(i, e, t);
            }), i;
        }
    };
    class we {
        constructor(t){
            e(this, "get", (e)=>{
                if (!we.supported || !this.enabled) return null;
                const t = window.localStorage.getItem(this.key);
                if (S.empty(t)) return null;
                const i = JSON.parse(t);
                return S.string(e) && e.length ? i[e] : i;
            }), e(this, "set", (e)=>{
                if (!we.supported || !this.enabled) return;
                if (!S.object(e)) return;
                let t = this.get();
                S.empty(t) && (t = {}), x(t, e);
                try {
                    window.localStorage.setItem(this.key, JSON.stringify(t));
                } catch (e) {}
            }), this.enabled = t.config.storage.enabled, this.key = t.config.storage.key;
        }
        static get supported() {
            try {
                if (!("localStorage" in window)) return !1;
                const e = "___test";
                return window.localStorage.setItem(e, e), window.localStorage.removeItem(e), !0;
            } catch (e) {
                return !1;
            }
        }
    }
    function Te(e, t = "text") {
        return new Promise((i, s)=>{
            try {
                const s = new XMLHttpRequest;
                if (!("withCredentials" in s)) return;
                s.addEventListener("load", ()=>{
                    if ("text" === t) try {
                        i(JSON.parse(s.responseText));
                    } catch (e) {
                        i(s.responseText);
                    }
                    else i(s.response);
                }), s.addEventListener("error", ()=>{
                    throw new Error(s.status);
                }), s.open("GET", e, !0), s.responseType = t, s.send();
            } catch (e) {
                s(e);
            }
        });
    }
    function ke(e, t) {
        if (!S.string(e)) return;
        const i = "cache", s = S.string(t);
        let n = !1;
        const a = ()=>null !== document.getElementById(t), l = (e, t)=>{
            e.innerHTML = t, s && a() || document.body.insertAdjacentElement("afterbegin", e);
        };
        if (!s || !a()) {
            const a = we.supported, r = document.createElement("div");
            if (r.setAttribute("hidden", ""), s && r.setAttribute("id", t), a) {
                const e = window.localStorage.getItem(`${i}-${t}`);
                if (n = null !== e, n) {
                    const t = JSON.parse(e);
                    l(r, t.content);
                }
            }
            Te(e).then((e)=>{
                if (!S.empty(e)) {
                    if (a) try {
                        window.localStorage.setItem(`${i}-${t}`, JSON.stringify({
                            content: e
                        }));
                    } catch (e) {}
                    l(r, e);
                }
            }).catch(()=>{});
        }
    }
    const Ce = (e)=>Math.trunc(e / 60 / 60 % 60, 10), Ae = (e)=>Math.trunc(e / 60 % 60, 10), Se = (e)=>Math.trunc(e % 60, 10);
    function Ee(e = 0, t = !1, i = !1) {
        if (!S.number(e)) return Ee(void 0, t, i);
        const s = (e)=>`0${e}`.slice(-2);
        let n = Ce(e);
        const a = Ae(e), l = Se(e);
        return n = t || n > 0 ? `${n}:` : "", `${i && e > 0 ? "-" : ""}${n}${s(a)}:${s(l)}`;
    }
    const Pe = {
        getIconUrl () {
            const e = new URL(this.config.iconUrl, window.location), t = window.location.host ? window.location.host : window.top.location.host, i = e.host !== t || M.isIE && !window.svg4everybody;
            return {
                url: this.config.iconUrl,
                cors: i
            };
        },
        findElements () {
            try {
                return this.elements.controls = B.call(this, this.config.selectors.controls.wrapper), this.elements.buttons = {
                    play: U.call(this, this.config.selectors.buttons.play),
                    pause: B.call(this, this.config.selectors.buttons.pause),
                    restart: B.call(this, this.config.selectors.buttons.restart),
                    rewind: B.call(this, this.config.selectors.buttons.rewind),
                    fastForward: B.call(this, this.config.selectors.buttons.fastForward),
                    mute: B.call(this, this.config.selectors.buttons.mute),
                    pip: B.call(this, this.config.selectors.buttons.pip),
                    airplay: B.call(this, this.config.selectors.buttons.airplay),
                    settings: B.call(this, this.config.selectors.buttons.settings),
                    captions: B.call(this, this.config.selectors.buttons.captions),
                    fullscreen: B.call(this, this.config.selectors.buttons.fullscreen)
                }, this.elements.progress = B.call(this, this.config.selectors.progress), this.elements.inputs = {
                    seek: B.call(this, this.config.selectors.inputs.seek),
                    volume: B.call(this, this.config.selectors.inputs.volume)
                }, this.elements.display = {
                    buffer: B.call(this, this.config.selectors.display.buffer),
                    currentTime: B.call(this, this.config.selectors.display.currentTime),
                    duration: B.call(this, this.config.selectors.display.duration)
                }, S.element(this.elements.progress) && (this.elements.display.seekTooltip = this.elements.progress.querySelector(`.${this.config.classNames.tooltip}`)), !0;
            } catch (e) {
                return this.debug.warn("It looks like there is a problem with your custom controls HTML", e), this.toggleNativeControls(!0), !1;
            }
        },
        createIcon (e, t) {
            const i = "http://www.w3.org/2000/svg", s = Pe.getIconUrl.call(this), n = `${s.cors ? "" : s.url}#${this.config.iconPrefix}`, a = document.createElementNS(i, "svg");
            I(a, x(t, {
                "aria-hidden": "true",
                focusable: "false"
            }));
            const l = document.createElementNS(i, "use"), r = `${n}-${e}`;
            return "href" in l && l.setAttributeNS("http://www.w3.org/1999/xlink", "href", r), l.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", r), a.appendChild(l), a;
        },
        createLabel (e, t = {}) {
            const i = ve.get(e, this.config);
            return $("span", {
                ...t,
                class: [
                    t.class,
                    this.config.classNames.hidden
                ].filter(Boolean).join(" ")
            }, i);
        },
        createBadge (e) {
            if (S.empty(e)) return null;
            const t = $("span", {
                class: this.config.classNames.menu.value
            });
            return t.appendChild($("span", {
                class: this.config.classNames.menu.badge
            }, e)), t;
        },
        createButton (e, t) {
            const i = x({}, t);
            let s = fe(e);
            const n = {
                element: "button",
                toggle: !1,
                label: null,
                icon: null,
                labelPressed: null,
                iconPressed: null
            };
            switch([
                "element",
                "icon",
                "label"
            ].forEach((e)=>{
                Object.keys(i).includes(e) && (n[e] = i[e], delete i[e]);
            }), "button" !== n.element || Object.keys(i).includes("type") || (i.type = "button"), Object.keys(i).includes("class") ? i.class.split(" ").some((e)=>e === this.config.classNames.control) || x(i, {
                class: `${i.class} ${this.config.classNames.control}`
            }) : i.class = this.config.classNames.control, e){
                case "play":
                    n.toggle = !0, n.label = "play", n.labelPressed = "pause", n.icon = "play", n.iconPressed = "pause";
                    break;
                case "mute":
                    n.toggle = !0, n.label = "mute", n.labelPressed = "unmute", n.icon = "volume", n.iconPressed = "muted";
                    break;
                case "captions":
                    n.toggle = !0, n.label = "enableCaptions", n.labelPressed = "disableCaptions", n.icon = "captions-off", n.iconPressed = "captions-on";
                    break;
                case "fullscreen":
                    n.toggle = !0, n.label = "enterFullscreen", n.labelPressed = "exitFullscreen", n.icon = "enter-fullscreen", n.iconPressed = "exit-fullscreen";
                    break;
                case "play-large":
                    i.class += ` ${this.config.classNames.control}--overlaid`, s = "play", n.label = "play", n.icon = "play";
                    break;
                default:
                    S.empty(n.label) && (n.label = s), S.empty(n.icon) && (n.icon = e);
            }
            const a = $(n.element);
            return n.toggle ? (a.appendChild(Pe.createIcon.call(this, n.iconPressed, {
                class: "icon--pressed"
            })), a.appendChild(Pe.createIcon.call(this, n.icon, {
                class: "icon--not-pressed"
            })), a.appendChild(Pe.createLabel.call(this, n.labelPressed, {
                class: "label--pressed"
            })), a.appendChild(Pe.createLabel.call(this, n.label, {
                class: "label--not-pressed"
            }))) : (a.appendChild(Pe.createIcon.call(this, n.icon)), a.appendChild(Pe.createLabel.call(this, n.label))), x(i, D(this.config.selectors.buttons[s], i)), I(a, i), "play" === s ? (S.array(this.elements.buttons[s]) || (this.elements.buttons[s] = []), this.elements.buttons[s].push(a)) : this.elements.buttons[s] = a, a;
        },
        createRange (e, t) {
            const i = $("input", x(D(this.config.selectors.inputs[e]), {
                type: "range",
                min: 0,
                max: 100,
                step: .01,
                value: 0,
                autocomplete: "off",
                role: "slider",
                "aria-label": ve.get(e, this.config),
                "aria-valuemin": 0,
                "aria-valuemax": 100,
                "aria-valuenow": 0
            }, t));
            return this.elements.inputs[e] = i, Pe.updateRangeFill.call(this, i), g.setup(i), i;
        },
        createProgress (e, t) {
            const i = $("progress", x(D(this.config.selectors.display[e]), {
                min: 0,
                max: 100,
                value: 0,
                role: "progressbar",
                "aria-hidden": !0
            }, t));
            if ("volume" !== e) {
                i.appendChild($("span", null, "0"));
                const t = {
                    played: "played",
                    buffer: "buffered"
                }[e], s = t ? ve.get(t, this.config) : "";
                i.innerText = `% ${s.toLowerCase()}`;
            }
            return this.elements.display[e] = i, i;
        },
        createTime (e, t) {
            const i = D(this.config.selectors.display[e], t), s = $("div", x(i, {
                class: `${i.class ? i.class : ""} ${this.config.classNames.display.time} `.trim(),
                "aria-label": ve.get(e, this.config),
                role: "timer"
            }), "00:00");
            return this.elements.display[e] = s, s;
        },
        bindMenuItemShortcuts (e, t) {
            X.call(this, e, "keydown keyup", (i)=>{
                if (![
                    " ",
                    "ArrowUp",
                    "ArrowDown",
                    "ArrowRight"
                ].includes(i.key)) return;
                if (i.preventDefault(), i.stopPropagation(), "keydown" === i.type) return;
                const s = V(e, '[role="menuitemradio"]');
                if (!s && [
                    " ",
                    "ArrowRight"
                ].includes(i.key)) Pe.showMenuPanel.call(this, t, !0);
                else {
                    let t;
                    " " !== i.key && ("ArrowDown" === i.key || s && "ArrowRight" === i.key ? (t = e.nextElementSibling, S.element(t) || (t = e.parentNode.firstElementChild)) : (t = e.previousElementSibling, S.element(t) || (t = e.parentNode.lastElementChild)), W.call(this, t, !0));
                }
            }, !1), X.call(this, e, "keyup", (e)=>{
                "Return" === e.key && Pe.focusFirstMenuItem.call(this, null, !0);
            });
        },
        createMenuItem ({ value: e, list: t, type: i, title: s, badge: n = null, checked: a = !1 }) {
            const l = D(this.config.selectors.inputs[i]), r = $("button", x(l, {
                type: "button",
                role: "menuitemradio",
                class: `${this.config.classNames.control} ${l.class ? l.class : ""}`.trim(),
                "aria-checked": a,
                value: e
            })), o = $("span");
            o.innerHTML = s, S.element(n) && o.appendChild(n), r.appendChild(o), Object.defineProperty(r, "checked", {
                enumerable: !0,
                get: ()=>"true" === r.getAttribute("aria-checked"),
                set (e) {
                    e && Array.from(r.parentNode.children).filter((e)=>V(e, '[role="menuitemradio"]')).forEach((e)=>e.setAttribute("aria-checked", "false")), r.setAttribute("aria-checked", e ? "true" : "false");
                }
            }), this.listeners.bind(r, "click keyup", (t)=>{
                if (!S.keyboardEvent(t) || " " === t.key) {
                    switch(t.preventDefault(), t.stopPropagation(), r.checked = !0, i){
                        case "language":
                            this.currentTrack = Number(e);
                            break;
                        case "quality":
                            this.quality = e;
                            break;
                        case "speed":
                            this.speed = parseFloat(e);
                    }
                    Pe.showMenuPanel.call(this, "home", S.keyboardEvent(t));
                }
            }, i, !1), Pe.bindMenuItemShortcuts.call(this, r, i), t.appendChild(r);
        },
        formatTime (e = 0, t = !1) {
            if (!S.number(e)) return e;
            return Ee(e, Ce(this.duration) > 0, t);
        },
        updateTimeDisplay (e = null, t = 0, i = !1) {
            S.element(e) && S.number(t) && (e.innerText = Pe.formatTime(t, i));
        },
        updateVolume () {
            this.supported.ui && (S.element(this.elements.inputs.volume) && Pe.setRange.call(this, this.elements.inputs.volume, this.muted ? 0 : this.volume), S.element(this.elements.buttons.mute) && (this.elements.buttons.mute.pressed = this.muted || 0 === this.volume));
        },
        setRange (e, t = 0) {
            S.element(e) && (e.value = t, Pe.updateRangeFill.call(this, e));
        },
        updateProgress (e) {
            if (!this.supported.ui || !S.event(e)) return;
            let t = 0;
            const i = (e, t)=>{
                const i = S.number(t) ? t : 0, s = S.element(e) ? e : this.elements.display.buffer;
                if (S.element(s)) {
                    s.value = i;
                    const e = s.getElementsByTagName("span")[0];
                    S.element(e) && (e.childNodes[0].nodeValue = i);
                }
            };
            if (e) switch(e.type){
                case "timeupdate":
                case "seeking":
                case "seeked":
                    s = this.currentTime, n = this.duration, t = 0 === s || 0 === n || Number.isNaN(s) || Number.isNaN(n) ? 0 : (s / n * 100).toFixed(2), "timeupdate" === e.type && Pe.setRange.call(this, this.elements.inputs.seek, t);
                    break;
                case "playing":
                case "progress":
                    i(this.elements.display.buffer, 100 * this.buffered);
            }
            var s, n;
        },
        updateRangeFill (e) {
            const t = S.event(e) ? e.target : e;
            if (S.element(t) && "range" === t.getAttribute("type")) {
                if (V(t, this.config.selectors.inputs.seek)) {
                    t.setAttribute("aria-valuenow", this.currentTime);
                    const e = Pe.formatTime(this.currentTime), i = Pe.formatTime(this.duration), s = ve.get("seekLabel", this.config);
                    t.setAttribute("aria-valuetext", s.replace("{currentTime}", e).replace("{duration}", i));
                } else if (V(t, this.config.selectors.inputs.volume)) {
                    const e = 100 * t.value;
                    t.setAttribute("aria-valuenow", e), t.setAttribute("aria-valuetext", `${e.toFixed(1)}%`);
                } else t.setAttribute("aria-valuenow", t.value);
                (M.isWebKit || M.isIPadOS) && t.style.setProperty("--value", t.value / t.max * 100 + "%");
            }
        },
        updateSeekTooltip (e) {
            var t, i;
            if (!this.config.tooltips.seek || !S.element(this.elements.inputs.seek) || !S.element(this.elements.display.seekTooltip) || 0 === this.duration) return;
            const s = this.elements.display.seekTooltip, n = `${this.config.classNames.tooltip}--visible`, a = (e)=>R(s, n, e);
            if (this.touch) return void a(!1);
            let l = 0;
            const r = this.elements.progress.getBoundingClientRect();
            if (S.event(e)) l = 100 / r.width * (e.pageX - r.left);
            else {
                if (!F(s, n)) return;
                l = parseFloat(s.style.left, 10);
            }
            l < 0 ? l = 0 : l > 100 && (l = 100);
            const o = this.duration / 100 * l;
            s.innerText = Pe.formatTime(o);
            const c = null === (t = this.config.markers) || void 0 === t || null === (i = t.points) || void 0 === i ? void 0 : i.find(({ time: e })=>e === Math.round(o));
            c && s.insertAdjacentHTML("afterbegin", `${c.label}<br>`), s.style.left = `${l}%`, S.event(e) && [
                "mouseenter",
                "mouseleave"
            ].includes(e.type) && a("mouseenter" === e.type);
        },
        timeUpdate (e) {
            const t = !S.element(this.elements.display.duration) && this.config.invertTime;
            Pe.updateTimeDisplay.call(this, this.elements.display.currentTime, t ? this.duration - this.currentTime : this.currentTime, t), e && "timeupdate" === e.type && this.media.seeking || Pe.updateProgress.call(this, e);
        },
        durationUpdate () {
            if (!this.supported.ui || !this.config.invertTime && this.currentTime) return;
            if (this.duration >= 2 ** 32) return H(this.elements.display.currentTime, !0), void H(this.elements.progress, !0);
            S.element(this.elements.inputs.seek) && this.elements.inputs.seek.setAttribute("aria-valuemax", this.duration);
            const e = S.element(this.elements.display.duration);
            !e && this.config.displayDuration && this.paused && Pe.updateTimeDisplay.call(this, this.elements.display.currentTime, this.duration), e && Pe.updateTimeDisplay.call(this, this.elements.display.duration, this.duration), this.config.markers.enabled && Pe.setMarkers.call(this), Pe.updateSeekTooltip.call(this);
        },
        toggleMenuButton (e, t) {
            H(this.elements.settings.buttons[e], !t);
        },
        updateSetting (e, t, i) {
            const s = this.elements.settings.panels[e];
            let n = null, a = t;
            if ("captions" === e) n = this.currentTrack;
            else {
                if (n = S.empty(i) ? this[e] : i, S.empty(n) && (n = this.config[e].default), !S.empty(this.options[e]) && !this.options[e].includes(n)) return void this.debug.warn(`Unsupported value of '${n}' for ${e}`);
                if (!this.config[e].options.includes(n)) return void this.debug.warn(`Disabled value of '${n}' for ${e}`);
            }
            if (S.element(a) || (a = s && s.querySelector('[role="menu"]')), !S.element(a)) return;
            this.elements.settings.buttons[e].querySelector(`.${this.config.classNames.menu.value}`).innerHTML = Pe.getLabel.call(this, e, n);
            const l = a && a.querySelector(`[value="${n}"]`);
            S.element(l) && (l.checked = !0);
        },
        getLabel (e, t) {
            switch(e){
                case "speed":
                    return 1 === t ? ve.get("normal", this.config) : `${t}&times;`;
                case "quality":
                    if (S.number(t)) {
                        const e = ve.get(`qualityLabel.${t}`, this.config);
                        return e.length ? e : `${t}p`;
                    }
                    return ge(t);
                case "captions":
                    return xe.getLabel.call(this);
                default:
                    return null;
            }
        },
        setQualityMenu (e) {
            if (!S.element(this.elements.settings.panels.quality)) return;
            const t = "quality", i = this.elements.settings.panels.quality.querySelector('[role="menu"]');
            S.array(e) && (this.options.quality = se(e).filter((e)=>this.config.quality.options.includes(e)));
            const s = !S.empty(this.options.quality) && this.options.quality.length > 1;
            if (Pe.toggleMenuButton.call(this, t, s), j(i), Pe.checkMenu.call(this), !s) return;
            const n = (e)=>{
                const t = ve.get(`qualityBadge.${e}`, this.config);
                return t.length ? Pe.createBadge.call(this, t) : null;
            };
            this.options.quality.sort((e, t)=>{
                const i = this.config.quality.options;
                return i.indexOf(e) > i.indexOf(t) ? 1 : -1;
            }).forEach((e)=>{
                Pe.createMenuItem.call(this, {
                    value: e,
                    list: i,
                    type: t,
                    title: Pe.getLabel.call(this, "quality", e),
                    badge: n(e)
                });
            }), Pe.updateSetting.call(this, t, i);
        },
        setCaptionsMenu () {
            if (!S.element(this.elements.settings.panels.captions)) return;
            const e = "captions", t = this.elements.settings.panels.captions.querySelector('[role="menu"]'), i = xe.getTracks.call(this), s = Boolean(i.length);
            if (Pe.toggleMenuButton.call(this, e, s), j(t), Pe.checkMenu.call(this), !s) return;
            const n = i.map((e, i)=>({
                    value: i,
                    checked: this.captions.toggled && this.currentTrack === i,
                    title: xe.getLabel.call(this, e),
                    badge: e.language && Pe.createBadge.call(this, e.language.toUpperCase()),
                    list: t,
                    type: "language"
                }));
            n.unshift({
                value: -1,
                checked: !this.captions.toggled,
                title: ve.get("disabled", this.config),
                list: t,
                type: "language"
            }), n.forEach(Pe.createMenuItem.bind(this)), Pe.updateSetting.call(this, e, t);
        },
        setSpeedMenu () {
            if (!S.element(this.elements.settings.panels.speed)) return;
            const e = "speed", t = this.elements.settings.panels.speed.querySelector('[role="menu"]');
            this.options.speed = this.options.speed.filter((e)=>e >= this.minimumSpeed && e <= this.maximumSpeed);
            const i = !S.empty(this.options.speed) && this.options.speed.length > 1;
            Pe.toggleMenuButton.call(this, e, i), j(t), Pe.checkMenu.call(this), i && (this.options.speed.forEach((i)=>{
                Pe.createMenuItem.call(this, {
                    value: i,
                    list: t,
                    type: e,
                    title: Pe.getLabel.call(this, "speed", i)
                });
            }), Pe.updateSetting.call(this, e, t));
        },
        checkMenu () {
            const { buttons: e } = this.elements.settings, t = !S.empty(e) && Object.values(e).some((e)=>!e.hidden);
            H(this.elements.settings.menu, !t);
        },
        focusFirstMenuItem (e, t = !1) {
            if (this.elements.settings.popup.hidden) return;
            let i = e;
            S.element(i) || (i = Object.values(this.elements.settings.panels).find((e)=>!e.hidden));
            const s = i.querySelector('[role^="menuitem"]');
            W.call(this, s, t);
        },
        toggleMenu (e) {
            const { popup: t } = this.elements.settings, i = this.elements.buttons.settings;
            if (!S.element(t) || !S.element(i)) return;
            const { hidden: s } = t;
            let n = s;
            if (S.boolean(e)) n = e;
            else if (S.keyboardEvent(e) && "Escape" === e.key) n = !1;
            else if (S.event(e)) {
                const s = S.function(e.composedPath) ? e.composedPath()[0] : e.target, a = t.contains(s);
                if (a || !a && e.target !== i && n) return;
            }
            i.setAttribute("aria-expanded", n), H(t, !n), R(this.elements.container, this.config.classNames.menu.open, n), n && S.keyboardEvent(e) ? Pe.focusFirstMenuItem.call(this, null, !0) : n || s || W.call(this, i, S.keyboardEvent(e));
        },
        getMenuSize (e) {
            const t = e.cloneNode(!0);
            t.style.position = "absolute", t.style.opacity = 0, t.removeAttribute("hidden"), e.parentNode.appendChild(t);
            const i = t.scrollWidth, s = t.scrollHeight;
            return O(t), {
                width: i,
                height: s
            };
        },
        showMenuPanel (e = "", t = !1) {
            const i = this.elements.container.querySelector(`#plyr-settings-${this.id}-${e}`);
            if (!S.element(i)) return;
            const s = i.parentNode, n = Array.from(s.children).find((e)=>!e.hidden);
            if (K.transitions && !K.reducedMotion) {
                s.style.width = `${n.scrollWidth}px`, s.style.height = `${n.scrollHeight}px`;
                const e = Pe.getMenuSize.call(this, i), t = (e)=>{
                    e.target === s && [
                        "width",
                        "height"
                    ].includes(e.propertyName) && (s.style.width = "", s.style.height = "", J.call(this, s, E, t));
                };
                X.call(this, s, E, t), s.style.width = `${e.width}px`, s.style.height = `${e.height}px`;
            }
            H(n, !0), H(i, !1), Pe.focusFirstMenuItem.call(this, i, t);
        },
        setDownloadUrl () {
            const e = this.elements.buttons.download;
            S.element(e) && e.setAttribute("href", this.download);
        },
        create (e) {
            const { bindMenuItemShortcuts: t, createButton: i, createProgress: s, createRange: n, createTime: a, setQualityMenu: l, setSpeedMenu: r, showMenuPanel: o } = Pe;
            this.elements.controls = null, S.array(this.config.controls) && this.config.controls.includes("play-large") && this.elements.container.appendChild(i.call(this, "play-large"));
            const c = $("div", D(this.config.selectors.controls.wrapper));
            this.elements.controls = c;
            const u = {
                class: "plyr__controls__item"
            };
            return se(S.array(this.config.controls) ? this.config.controls : []).forEach((l)=>{
                if ("restart" === l && c.appendChild(i.call(this, "restart", u)), "rewind" === l && c.appendChild(i.call(this, "rewind", u)), "play" === l && c.appendChild(i.call(this, "play", u)), "fast-forward" === l && c.appendChild(i.call(this, "fast-forward", u)), "progress" === l) {
                    const t = $("div", {
                        class: `${u.class} plyr__progress__container`
                    }), i = $("div", D(this.config.selectors.progress));
                    if (i.appendChild(n.call(this, "seek", {
                        id: `plyr-seek-${e.id}`
                    })), i.appendChild(s.call(this, "buffer")), this.config.tooltips.seek) {
                        const e = $("span", {
                            class: this.config.classNames.tooltip
                        }, "00:00");
                        i.appendChild(e), this.elements.display.seekTooltip = e;
                    }
                    this.elements.progress = i, t.appendChild(this.elements.progress), c.appendChild(t);
                }
                if ("current-time" === l && c.appendChild(a.call(this, "currentTime", u)), "duration" === l && c.appendChild(a.call(this, "duration", u)), "mute" === l || "volume" === l) {
                    let { volume: t } = this.elements;
                    if (S.element(t) && c.contains(t) || (t = $("div", x({}, u, {
                        class: `${u.class} plyr__volume`.trim()
                    })), this.elements.volume = t, c.appendChild(t)), "mute" === l && t.appendChild(i.call(this, "mute")), "volume" === l && !M.isIos && !M.isIPadOS) {
                        const i = {
                            max: 1,
                            step: .05,
                            value: this.config.volume
                        };
                        t.appendChild(n.call(this, "volume", x(i, {
                            id: `plyr-volume-${e.id}`
                        })));
                    }
                }
                if ("captions" === l && c.appendChild(i.call(this, "captions", u)), "settings" === l && !S.empty(this.config.settings)) {
                    const s = $("div", x({}, u, {
                        class: `${u.class} plyr__menu`.trim(),
                        hidden: ""
                    }));
                    s.appendChild(i.call(this, "settings", {
                        "aria-haspopup": !0,
                        "aria-controls": `plyr-settings-${e.id}`,
                        "aria-expanded": !1
                    }));
                    const n = $("div", {
                        class: "plyr__menu__container",
                        id: `plyr-settings-${e.id}`,
                        hidden: ""
                    }), a = $("div"), l = $("div", {
                        id: `plyr-settings-${e.id}-home`
                    }), r = $("div", {
                        role: "menu"
                    });
                    l.appendChild(r), a.appendChild(l), this.elements.settings.panels.home = l, this.config.settings.forEach((i)=>{
                        const s = $("button", x(D(this.config.selectors.buttons.settings), {
                            type: "button",
                            class: `${this.config.classNames.control} ${this.config.classNames.control}--forward`,
                            role: "menuitem",
                            "aria-haspopup": !0,
                            hidden: ""
                        }));
                        t.call(this, s, i), X.call(this, s, "click", ()=>{
                            o.call(this, i, !1);
                        });
                        const n = $("span", null, ve.get(i, this.config)), l = $("span", {
                            class: this.config.classNames.menu.value
                        });
                        l.innerHTML = e[i], n.appendChild(l), s.appendChild(n), r.appendChild(s);
                        const c = $("div", {
                            id: `plyr-settings-${e.id}-${i}`,
                            hidden: ""
                        }), u = $("button", {
                            type: "button",
                            class: `${this.config.classNames.control} ${this.config.classNames.control}--back`
                        });
                        u.appendChild($("span", {
                            "aria-hidden": !0
                        }, ve.get(i, this.config))), u.appendChild($("span", {
                            class: this.config.classNames.hidden
                        }, ve.get("menuBack", this.config))), X.call(this, c, "keydown", (e)=>{
                            "ArrowLeft" === e.key && (e.preventDefault(), e.stopPropagation(), o.call(this, "home", !0));
                        }, !1), X.call(this, u, "click", ()=>{
                            o.call(this, "home", !1);
                        }), c.appendChild(u), c.appendChild($("div", {
                            role: "menu"
                        })), a.appendChild(c), this.elements.settings.buttons[i] = s, this.elements.settings.panels[i] = c;
                    }), n.appendChild(a), s.appendChild(n), c.appendChild(s), this.elements.settings.popup = n, this.elements.settings.menu = s;
                }
                if ("pip" === l && K.pip && c.appendChild(i.call(this, "pip", u)), "airplay" === l && K.airplay && c.appendChild(i.call(this, "airplay", u)), "download" === l) {
                    const e = x({}, u, {
                        element: "a",
                        href: this.download,
                        target: "_blank"
                    });
                    this.isHTML5 && (e.download = "");
                    const { download: t } = this.config.urls;
                    !S.url(t) && this.isEmbed && x(e, {
                        icon: `logo-${this.provider}`,
                        label: this.provider
                    }), c.appendChild(i.call(this, "download", e));
                }
                "fullscreen" === l && c.appendChild(i.call(this, "fullscreen", u));
            }), this.isHTML5 && l.call(this, de.getQualityOptions.call(this)), r.call(this), c;
        },
        inject () {
            if (this.config.loadSprite) {
                const e = Pe.getIconUrl.call(this);
                e.cors && ke(e.url, "sprite-plyr");
            }
            this.id = Math.floor(1e4 * Math.random());
            let e = null;
            this.elements.controls = null;
            const t = {
                id: this.id,
                seektime: this.config.seekTime,
                title: this.config.title
            };
            let i = !0;
            S.function(this.config.controls) && (this.config.controls = this.config.controls.call(this, t)), this.config.controls || (this.config.controls = []), S.element(this.config.controls) || S.string(this.config.controls) ? e = this.config.controls : (e = Pe.create.call(this, {
                id: this.id,
                seektime: this.config.seekTime,
                speed: this.speed,
                quality: this.quality,
                captions: xe.getLabel.call(this)
            }), i = !1);
            let s;
            i && S.string(this.config.controls) && (e = ((e)=>{
                let i = e;
                return Object.entries(t).forEach(([e, t])=>{
                    i = pe(i, `{${e}}`, t);
                }), i;
            })(e)), S.string(this.config.selectors.controls.container) && (s = document.querySelector(this.config.selectors.controls.container)), S.element(s) || (s = this.elements.container);
            if (s[S.element(e) ? "insertAdjacentElement" : "insertAdjacentHTML"]("afterbegin", e), S.element(this.elements.controls) || Pe.findElements.call(this), !S.empty(this.elements.buttons)) {
                const e = (e)=>{
                    const t = this.config.classNames.controlPressed;
                    e.setAttribute("aria-pressed", "false"), Object.defineProperty(e, "pressed", {
                        configurable: !0,
                        enumerable: !0,
                        get: ()=>F(e, t),
                        set (i = !1) {
                            R(e, t, i), e.setAttribute("aria-pressed", i ? "true" : "false");
                        }
                    });
                };
                Object.values(this.elements.buttons).filter(Boolean).forEach((t)=>{
                    S.array(t) || S.nodeList(t) ? Array.from(t).filter(Boolean).forEach(e) : e(t);
                });
            }
            if (M.isEdge && P(s), this.config.tooltips.controls) {
                const { classNames: e, selectors: t } = this.config, i = `${t.controls.wrapper} ${t.labels} .${e.hidden}`, s = U.call(this, i);
                Array.from(s).forEach((e)=>{
                    R(e, this.config.classNames.hidden, !1), R(e, this.config.classNames.tooltip, !0);
                });
            }
        },
        setMediaMetadata () {
            try {
                "mediaSession" in navigator && (navigator.mediaSession.metadata = new window.MediaMetadata({
                    title: this.config.mediaMetadata.title,
                    artist: this.config.mediaMetadata.artist,
                    album: this.config.mediaMetadata.album,
                    artwork: this.config.mediaMetadata.artwork
                }));
            } catch (e) {}
        },
        setMarkers () {
            var e, t;
            if (!this.duration || this.elements.markers) return;
            const i = null === (e = this.config.markers) || void 0 === e || null === (t = e.points) || void 0 === t ? void 0 : t.filter(({ time: e })=>e > 0 && e < this.duration);
            if (null == i || !i.length) return;
            const s = document.createDocumentFragment(), n = document.createDocumentFragment();
            let a = null;
            const l = `${this.config.classNames.tooltip}--visible`, r = (e)=>R(a, l, e);
            i.forEach((e)=>{
                const t = $("span", {
                    class: this.config.classNames.marker
                }, ""), i = e.time / this.duration * 100 + "%";
                a && (t.addEventListener("mouseenter", ()=>{
                    e.label || (a.style.left = i, a.innerHTML = e.label, r(!0));
                }), t.addEventListener("mouseleave", ()=>{
                    r(!1);
                })), t.addEventListener("click", ()=>{
                    this.currentTime = e.time;
                }), t.style.left = i, n.appendChild(t);
            }), s.appendChild(n), this.config.tooltips.seek || (a = $("span", {
                class: this.config.classNames.tooltip
            }, ""), s.appendChild(a)), this.elements.markers = {
                points: n,
                tip: a
            }, this.elements.progress.appendChild(s);
        }
    };
    function Me(e, t = !0) {
        let i = e;
        if (t) {
            const e = document.createElement("a");
            e.href = i, i = e.href;
        }
        try {
            return new URL(i);
        } catch (e) {
            return null;
        }
    }
    function Ne(e) {
        const t = new URLSearchParams;
        return S.object(e) && Object.entries(e).forEach(([e, i])=>{
            t.set(e, i);
        }), t;
    }
    const xe = {
        setup () {
            if (!this.supported.ui) return;
            if (!this.isVideo || this.isYouTube || this.isHTML5 && !K.textTracks) return void (S.array(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && Pe.setCaptionsMenu.call(this));
            var e, t;
            if (S.element(this.elements.captions) || (this.elements.captions = $("div", D(this.config.selectors.captions)), this.elements.captions.setAttribute("dir", "auto"), e = this.elements.captions, t = this.elements.wrapper, S.element(e) && S.element(t) && t.parentNode.insertBefore(e, t.nextSibling)), M.isIE && window.URL) {
                const e = this.media.querySelectorAll("track");
                Array.from(e).forEach((e)=>{
                    const t = e.getAttribute("src"), i = Me(t);
                    null !== i && i.hostname !== window.location.href.hostname && [
                        "http:",
                        "https:"
                    ].includes(i.protocol) && Te(t, "blob").then((t)=>{
                        e.setAttribute("src", window.URL.createObjectURL(t));
                    }).catch(()=>{
                        O(e);
                    });
                });
            }
            const i = se((navigator.languages || [
                navigator.language || navigator.userLanguage || "en"
            ]).map((e)=>e.split("-")[0]));
            let s = (this.storage.get("language") || this.config.captions.language || "auto").toLowerCase();
            "auto" === s && ([s] = i);
            let n = this.storage.get("captions");
            if (S.boolean(n) || ({ active: n } = this.config.captions), Object.assign(this.captions, {
                toggled: !1,
                active: n,
                language: s,
                languages: i
            }), this.isHTML5) {
                const e = this.config.captions.update ? "addtrack removetrack" : "removetrack";
                X.call(this, this.media.textTracks, e, xe.update.bind(this));
            }
            setTimeout(xe.update.bind(this), 0);
        },
        update () {
            const e = xe.getTracks.call(this, !0), { active: t, language: i, meta: s, currentTrackNode: n } = this.captions, a = Boolean(e.find((e)=>e.language === i));
            this.isHTML5 && this.isVideo && e.filter((e)=>!s.get(e)).forEach((e)=>{
                this.debug.log("Track added", e), s.set(e, {
                    default: "showing" === e.mode
                }), "showing" === e.mode && (e.mode = "hidden"), X.call(this, e, "cuechange", ()=>xe.updateCues.call(this));
            }), (a && this.language !== i || !e.includes(n)) && (xe.setLanguage.call(this, i), xe.toggle.call(this, t && a)), this.elements && R(this.elements.container, this.config.classNames.captions.enabled, !S.empty(e)), S.array(this.config.controls) && this.config.controls.includes("settings") && this.config.settings.includes("captions") && Pe.setCaptionsMenu.call(this);
        },
        toggle (e, t = !0) {
            if (!this.supported.ui) return;
            const { toggled: i } = this.captions, s = this.config.classNames.captions.active, n = S.nullOrUndefined(e) ? !i : e;
            if (n !== i) {
                if (t || (this.captions.active = n, this.storage.set({
                    captions: n
                })), !this.language && n && !t) {
                    const e = xe.getTracks.call(this), t = xe.findTrack.call(this, [
                        this.captions.language,
                        ...this.captions.languages
                    ], !0);
                    return this.captions.language = t.language, void xe.set.call(this, e.indexOf(t));
                }
                this.elements.buttons.captions && (this.elements.buttons.captions.pressed = n), R(this.elements.container, s, n), this.captions.toggled = n, Pe.updateSetting.call(this, "captions"), Z.call(this, this.media, n ? "captionsenabled" : "captionsdisabled");
            }
            setTimeout(()=>{
                n && this.captions.toggled && (this.captions.currentTrackNode.mode = "hidden");
            });
        },
        set (e, t = !0) {
            const i = xe.getTracks.call(this);
            if (-1 !== e) {
                if (S.number(e)) {
                    if (e in i) {
                        if (this.captions.currentTrack !== e) {
                            this.captions.currentTrack = e;
                            const s = i[e], { language: n } = s || {};
                            this.captions.currentTrackNode = s, Pe.updateSetting.call(this, "captions"), t || (this.captions.language = n, this.storage.set({
                                language: n
                            })), this.isVimeo && this.embed.enableTextTrack(n), Z.call(this, this.media, "languagechange");
                        }
                        xe.toggle.call(this, !0, t), this.isHTML5 && this.isVideo && xe.updateCues.call(this);
                    } else this.debug.warn("Track not found", e);
                } else this.debug.warn("Invalid caption argument", e);
            } else xe.toggle.call(this, !1, t);
        },
        setLanguage (e, t = !0) {
            if (!S.string(e)) return void this.debug.warn("Invalid language argument", e);
            const i = e.toLowerCase();
            this.captions.language = i;
            const s = xe.getTracks.call(this), n = xe.findTrack.call(this, [
                i
            ]);
            xe.set.call(this, s.indexOf(n), t);
        },
        getTracks (e = !1) {
            return Array.from((this.media || {}).textTracks || []).filter((t)=>!this.isHTML5 || e || this.captions.meta.has(t)).filter((e)=>[
                    "captions",
                    "subtitles"
                ].includes(e.kind));
        },
        findTrack (e, t = !1) {
            const i = xe.getTracks.call(this), s = (e)=>Number((this.captions.meta.get(e) || {}).default), n = Array.from(i).sort((e, t)=>s(t) - s(e));
            let a;
            return e.every((e)=>(a = n.find((t)=>t.language === e), !a)), a || (t ? n[0] : void 0);
        },
        getCurrentTrack () {
            return xe.getTracks.call(this)[this.currentTrack];
        },
        getLabel (e) {
            let t = e;
            return !S.track(t) && K.textTracks && this.captions.toggled && (t = xe.getCurrentTrack.call(this)), S.track(t) ? S.empty(t.label) ? S.empty(t.language) ? ve.get("enabled", this.config) : e.language.toUpperCase() : t.label : ve.get("disabled", this.config);
        },
        updateCues (e) {
            if (!this.supported.ui) return;
            if (!S.element(this.elements.captions)) return void this.debug.warn("No captions element to render to");
            if (!S.nullOrUndefined(e) && !Array.isArray(e)) return void this.debug.warn("updateCues: Invalid input", e);
            let t = e;
            if (!t) {
                const e = xe.getCurrentTrack.call(this);
                t = Array.from((e || {}).activeCues || []).map((e)=>e.getCueAsHTML()).map(ye);
            }
            const i = t.map((e)=>e.trim()).join("\n");
            if (i !== this.elements.captions.innerHTML) {
                j(this.elements.captions);
                const e = $("span", D(this.config.selectors.caption));
                e.innerHTML = i, this.elements.captions.appendChild(e), Z.call(this, this.media, "cuechange");
            }
        }
    }, Le = {
        enabled: !0,
        title: "",
        debug: !1,
        autoplay: !1,
        autopause: !0,
        playsinline: !0,
        seekTime: 10,
        volume: 1,
        muted: !1,
        duration: null,
        displayDuration: !0,
        invertTime: !0,
        toggleInvert: !0,
        ratio: null,
        clickToPlay: !0,
        hideControls: !0,
        resetOnEnd: !1,
        disableContextMenu: !0,
        loadSprite: !0,
        iconPrefix: "plyr",
        iconUrl: "https://cdn.plyr.io/3.7.8/plyr.svg",
        blankVideo: "https://cdn.plyr.io/static/blank.mp4",
        quality: {
            default: 576,
            options: [
                4320,
                2880,
                2160,
                1440,
                1080,
                720,
                576,
                480,
                360,
                240
            ],
            forced: !1,
            onChange: null
        },
        loop: {
            active: !1
        },
        speed: {
            selected: 1,
            options: [
                .5,
                .75,
                1,
                1.25,
                1.5,
                1.75,
                2,
                4
            ]
        },
        keyboard: {
            focused: !0,
            global: !1
        },
        tooltips: {
            controls: !1,
            seek: !0
        },
        captions: {
            active: !1,
            language: "auto",
            update: !1
        },
        fullscreen: {
            enabled: !0,
            fallback: !0,
            iosNative: !1
        },
        storage: {
            enabled: !0,
            key: "plyr"
        },
        controls: [
            "play-large",
            "play",
            "progress",
            "current-time",
            "mute",
            "volume",
            "captions",
            "settings",
            "pip",
            "airplay",
            "fullscreen"
        ],
        settings: [
            "captions",
            "quality",
            "speed"
        ],
        i18n: {
            restart: "Restart",
            rewind: "Rewind {seektime}s",
            play: "Play",
            pause: "Pause",
            fastForward: "Forward {seektime}s",
            seek: "Seek",
            seekLabel: "{currentTime} of {duration}",
            played: "Played",
            buffered: "Buffered",
            currentTime: "Current time",
            duration: "Duration",
            volume: "Volume",
            mute: "Mute",
            unmute: "Unmute",
            enableCaptions: "Enable captions",
            disableCaptions: "Disable captions",
            download: "Download",
            enterFullscreen: "Enter fullscreen",
            exitFullscreen: "Exit fullscreen",
            frameTitle: "Player for {title}",
            captions: "Captions",
            settings: "Settings",
            pip: "PIP",
            menuBack: "Go back to previous menu",
            speed: "Speed",
            normal: "Normal",
            quality: "Quality",
            loop: "Loop",
            start: "Start",
            end: "End",
            all: "All",
            reset: "Reset",
            disabled: "Disabled",
            enabled: "Enabled",
            advertisement: "Ad",
            qualityBadge: {
                2160: "4K",
                1440: "HD",
                1080: "HD",
                720: "HD",
                576: "SD",
                480: "SD"
            }
        },
        urls: {
            download: null,
            vimeo: {
                sdk: "https://player.vimeo.com/api/player.js",
                iframe: "https://player.vimeo.com/video/{0}?{1}",
                api: "https://vimeo.com/api/oembed.json?url={0}"
            },
            youtube: {
                sdk: "https://www.youtube.com/iframe_api",
                api: "https://noembed.com/embed?url=https://www.youtube.com/watch?v={0}"
            },
            googleIMA: {
                sdk: "https://imasdk.googleapis.com/js/sdkloader/ima3.js"
            }
        },
        listeners: {
            seek: null,
            play: null,
            pause: null,
            restart: null,
            rewind: null,
            fastForward: null,
            mute: null,
            volume: null,
            captions: null,
            download: null,
            fullscreen: null,
            pip: null,
            airplay: null,
            speed: null,
            quality: null,
            loop: null,
            language: null
        },
        events: [
            "ended",
            "progress",
            "stalled",
            "playing",
            "waiting",
            "canplay",
            "canplaythrough",
            "loadstart",
            "loadeddata",
            "loadedmetadata",
            "timeupdate",
            "volumechange",
            "play",
            "pause",
            "error",
            "seeking",
            "seeked",
            "emptied",
            "ratechange",
            "cuechange",
            "download",
            "enterfullscreen",
            "exitfullscreen",
            "captionsenabled",
            "captionsdisabled",
            "languagechange",
            "controlshidden",
            "controlsshown",
            "ready",
            "statechange",
            "qualitychange",
            "adsloaded",
            "adscontentpause",
            "adscontentresume",
            "adstarted",
            "adsmidpoint",
            "adscomplete",
            "adsallcomplete",
            "adsimpression",
            "adsclick"
        ],
        selectors: {
            editable: "input, textarea, select, [contenteditable]",
            container: ".plyr",
            controls: {
                container: null,
                wrapper: ".plyr__controls"
            },
            labels: "[data-plyr]",
            buttons: {
                play: '[data-plyr="play"]',
                pause: '[data-plyr="pause"]',
                restart: '[data-plyr="restart"]',
                rewind: '[data-plyr="rewind"]',
                fastForward: '[data-plyr="fast-forward"]',
                mute: '[data-plyr="mute"]',
                captions: '[data-plyr="captions"]',
                download: '[data-plyr="download"]',
                fullscreen: '[data-plyr="fullscreen"]',
                pip: '[data-plyr="pip"]',
                airplay: '[data-plyr="airplay"]',
                settings: '[data-plyr="settings"]',
                loop: '[data-plyr="loop"]'
            },
            inputs: {
                seek: '[data-plyr="seek"]',
                volume: '[data-plyr="volume"]',
                speed: '[data-plyr="speed"]',
                language: '[data-plyr="language"]',
                quality: '[data-plyr="quality"]'
            },
            display: {
                currentTime: ".plyr__time--current",
                duration: ".plyr__time--duration",
                buffer: ".plyr__progress__buffer",
                loop: ".plyr__progress__loop",
                volume: ".plyr__volume--display"
            },
            progress: ".plyr__progress",
            captions: ".plyr__captions",
            caption: ".plyr__caption"
        },
        classNames: {
            type: "plyr--{0}",
            provider: "plyr--{0}",
            video: "plyr__video-wrapper",
            embed: "plyr__video-embed",
            videoFixedRatio: "plyr__video-wrapper--fixed-ratio",
            embedContainer: "plyr__video-embed__container",
            poster: "plyr__poster",
            posterEnabled: "plyr__poster-enabled",
            ads: "plyr__ads",
            control: "plyr__control",
            controlPressed: "plyr__control--pressed",
            playing: "plyr--playing",
            paused: "plyr--paused",
            stopped: "plyr--stopped",
            loading: "plyr--loading",
            hover: "plyr--hover",
            tooltip: "plyr__tooltip",
            cues: "plyr__cues",
            marker: "plyr__progress__marker",
            hidden: "plyr__sr-only",
            hideControls: "plyr--hide-controls",
            isTouch: "plyr--is-touch",
            uiSupported: "plyr--full-ui",
            noTransition: "plyr--no-transition",
            display: {
                time: "plyr__time"
            },
            menu: {
                value: "plyr__menu__value",
                badge: "plyr__badge",
                open: "plyr--menu-open"
            },
            captions: {
                enabled: "plyr--captions-enabled",
                active: "plyr--captions-active"
            },
            fullscreen: {
                enabled: "plyr--fullscreen-enabled",
                fallback: "plyr--fullscreen-fallback"
            },
            pip: {
                supported: "plyr--pip-supported",
                active: "plyr--pip-active"
            },
            airplay: {
                supported: "plyr--airplay-supported",
                active: "plyr--airplay-active"
            },
            previewThumbnails: {
                thumbContainer: "plyr__preview-thumb",
                thumbContainerShown: "plyr__preview-thumb--is-shown",
                imageContainer: "plyr__preview-thumb__image-container",
                timeContainer: "plyr__preview-thumb__time-container",
                scrubbingContainer: "plyr__preview-scrubbing",
                scrubbingContainerShown: "plyr__preview-scrubbing--is-shown"
            }
        },
        attributes: {
            embed: {
                provider: "data-plyr-provider",
                id: "data-plyr-embed-id",
                hash: "data-plyr-embed-hash"
            }
        },
        ads: {
            enabled: !1,
            publisherId: "",
            tagUrl: ""
        },
        previewThumbnails: {
            enabled: !1,
            src: ""
        },
        vimeo: {
            byline: !1,
            portrait: !1,
            title: !1,
            speed: !0,
            transparent: !1,
            customControls: !0,
            referrerPolicy: null,
            premium: !1
        },
        youtube: {
            rel: 0,
            showinfo: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            customControls: !0,
            noCookie: !1
        },
        mediaMetadata: {
            title: "",
            artist: "",
            album: "",
            artwork: []
        },
        markers: {
            enabled: !1,
            points: []
        }
    }, Ie = "picture-in-picture", $e = "inline", _e = {
        html5: "html5",
        youtube: "youtube",
        vimeo: "vimeo"
    }, Oe = "audio", je = "video";
    const qe = ()=>{};
    class De {
        constructor(e = !1){
            this.enabled = window.console && e, this.enabled && this.log("Debugging enabled");
        }
        get log() {
            return this.enabled ? Function.prototype.bind.call(console.log, console) : qe;
        }
        get warn() {
            return this.enabled ? Function.prototype.bind.call(console.warn, console) : qe;
        }
        get error() {
            return this.enabled ? Function.prototype.bind.call(console.error, console) : qe;
        }
    }
    class He {
        constructor(t){
            e(this, "onChange", ()=>{
                if (!this.supported) return;
                const e = this.player.elements.buttons.fullscreen;
                S.element(e) && (e.pressed = this.active);
                const t = this.target === this.player.media ? this.target : this.player.elements.container;
                Z.call(this.player, t, this.active ? "enterfullscreen" : "exitfullscreen", !0);
            }), e(this, "toggleFallback", (e = !1)=>{
                if (e ? this.scrollPosition = {
                    x: window.scrollX ?? 0,
                    y: window.scrollY ?? 0
                } : window.scrollTo(this.scrollPosition.x, this.scrollPosition.y), document.body.style.overflow = e ? "hidden" : "", R(this.target, this.player.config.classNames.fullscreen.fallback, e), M.isIos) {
                    let t = document.head.querySelector('meta[name="viewport"]');
                    const i = "viewport-fit=cover";
                    t || (t = document.createElement("meta"), t.setAttribute("name", "viewport"));
                    const s = S.string(t.content) && t.content.includes(i);
                    e ? (this.cleanupViewport = !s, s || (t.content += `,${i}`)) : this.cleanupViewport && (t.content = t.content.split(",").filter((e)=>e.trim() !== i).join(","));
                }
                this.onChange();
            }), e(this, "trapFocus", (e)=>{
                if (M.isIos || M.isIPadOS || !this.active || "Tab" !== e.key) return;
                const t = document.activeElement, i = U.call(this.player, "a[href], button:not(:disabled), input:not(:disabled), [tabindex]"), [s] = i, n = i[i.length - 1];
                t !== n || e.shiftKey ? t === s && e.shiftKey && (n.focus(), e.preventDefault()) : (s.focus(), e.preventDefault());
            }), e(this, "update", ()=>{
                if (this.supported) {
                    let e;
                    e = this.forceFallback ? "Fallback (forced)" : He.nativeSupported ? "Native" : "Fallback", this.player.debug.log(`${e} fullscreen enabled`);
                } else this.player.debug.log("Fullscreen not supported and fallback disabled");
                R(this.player.elements.container, this.player.config.classNames.fullscreen.enabled, this.supported);
            }), e(this, "enter", ()=>{
                this.supported && (M.isIos && this.player.config.fullscreen.iosNative ? this.player.isVimeo ? this.player.embed.requestFullscreen() : this.target.webkitEnterFullscreen() : !He.nativeSupported || this.forceFallback ? this.toggleFallback(!0) : this.prefix ? S.empty(this.prefix) || this.target[`${this.prefix}Request${this.property}`]() : this.target.requestFullscreen({
                    navigationUI: "hide"
                }));
            }), e(this, "exit", ()=>{
                if (this.supported) {
                    if (M.isIos && this.player.config.fullscreen.iosNative) this.player.isVimeo ? this.player.embed.exitFullscreen() : this.target.webkitEnterFullscreen(), ie(this.player.play());
                    else if (!He.nativeSupported || this.forceFallback) this.toggleFallback(!1);
                    else if (this.prefix) {
                        if (!S.empty(this.prefix)) {
                            const e = "moz" === this.prefix ? "Cancel" : "Exit";
                            document[`${this.prefix}${e}${this.property}`]();
                        }
                    } else (document.cancelFullScreen || document.exitFullscreen).call(document);
                }
            }), e(this, "toggle", ()=>{
                this.active ? this.exit() : this.enter();
            }), this.player = t, this.prefix = He.prefix, this.property = He.property, this.scrollPosition = {
                x: 0,
                y: 0
            }, this.forceFallback = "force" === t.config.fullscreen.fallback, this.player.elements.fullscreen = t.config.fullscreen.container && function(e, t) {
                const { prototype: i } = Element;
                return (i.closest || function() {
                    let e = this;
                    do {
                        if (V.matches(e, t)) return e;
                        e = e.parentElement || e.parentNode;
                    }while (null !== e && 1 === e.nodeType);
                    return null;
                }).call(e, t);
            }(this.player.elements.container, t.config.fullscreen.container), X.call(this.player, document, "ms" === this.prefix ? "MSFullscreenChange" : `${this.prefix}fullscreenchange`, ()=>{
                this.onChange();
            }), X.call(this.player, this.player.elements.container, "dblclick", (e)=>{
                S.element(this.player.elements.controls) && this.player.elements.controls.contains(e.target) || this.player.listeners.proxy(e, this.toggle, "fullscreen");
            }), X.call(this, this.player.elements.container, "keydown", (e)=>this.trapFocus(e)), this.update();
        }
        static get nativeSupported() {
            return !!(document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled);
        }
        get useNative() {
            return He.nativeSupported && !this.forceFallback;
        }
        static get prefix() {
            if (S.function(document.exitFullscreen)) return "";
            let e = "";
            return [
                "webkit",
                "moz",
                "ms"
            ].some((t)=>!(!S.function(document[`${t}ExitFullscreen`]) && !S.function(document[`${t}CancelFullScreen`])) && (e = t, !0)), e;
        }
        static get property() {
            return "moz" === this.prefix ? "FullScreen" : "Fullscreen";
        }
        get supported() {
            return [
                this.player.config.fullscreen.enabled,
                this.player.isVideo,
                He.nativeSupported || this.player.config.fullscreen.fallback,
                !this.player.isYouTube || He.nativeSupported || !M.isIos || this.player.config.playsinline && !this.player.config.fullscreen.iosNative
            ].every(Boolean);
        }
        get active() {
            if (!this.supported) return !1;
            if (!He.nativeSupported || this.forceFallback) return F(this.target, this.player.config.classNames.fullscreen.fallback);
            const e = this.prefix ? this.target.getRootNode()[`${this.prefix}${this.property}Element`] : this.target.getRootNode().fullscreenElement;
            return e && e.shadowRoot ? e === this.target.getRootNode().host : e === this.target;
        }
        get target() {
            return M.isIos && this.player.config.fullscreen.iosNative ? this.player.media : this.player.elements.fullscreen ?? this.player.elements.container;
        }
    }
    function Re(e, t = 1) {
        return new Promise((i, s)=>{
            const n = new Image, a = ()=>{
                delete n.onload, delete n.onerror, (n.naturalWidth >= t ? i : s)(n);
            };
            Object.assign(n, {
                onload: a,
                onerror: a,
                src: e
            });
        });
    }
    const Fe = {
        addStyleHook () {
            R(this.elements.container, this.config.selectors.container.replace(".", ""), !0), R(this.elements.container, this.config.classNames.uiSupported, this.supported.ui);
        },
        toggleNativeControls (e = !1) {
            e && this.isHTML5 ? this.media.setAttribute("controls", "") : this.media.removeAttribute("controls");
        },
        build () {
            if (this.listeners.media(), !this.supported.ui) return this.debug.warn(`Basic support only for ${this.provider} ${this.type}`), void Fe.toggleNativeControls.call(this, !0);
            S.element(this.elements.controls) || (Pe.inject.call(this), this.listeners.controls()), Fe.toggleNativeControls.call(this), this.isHTML5 && xe.setup.call(this), this.volume = null, this.muted = null, this.loop = null, this.quality = null, this.speed = null, Pe.updateVolume.call(this), Pe.timeUpdate.call(this), Pe.durationUpdate.call(this), Fe.checkPlaying.call(this), R(this.elements.container, this.config.classNames.pip.supported, K.pip && this.isHTML5 && this.isVideo), R(this.elements.container, this.config.classNames.airplay.supported, K.airplay && this.isHTML5), R(this.elements.container, this.config.classNames.isTouch, this.touch), this.ready = !0, setTimeout(()=>{
                Z.call(this, this.media, "ready");
            }, 0), Fe.setTitle.call(this), this.poster && Fe.setPoster.call(this, this.poster, !1).catch(()=>{}), this.config.duration && Pe.durationUpdate.call(this), this.config.mediaMetadata && Pe.setMediaMetadata.call(this);
        },
        setTitle () {
            let e = ve.get("play", this.config);
            if (S.string(this.config.title) && !S.empty(this.config.title) && (e += `, ${this.config.title}`), Array.from(this.elements.buttons.play || []).forEach((t)=>{
                t.setAttribute("aria-label", e);
            }), this.isEmbed) {
                const e = B.call(this, "iframe");
                if (!S.element(e)) return;
                const t = S.empty(this.config.title) ? "video" : this.config.title, i = ve.get("frameTitle", this.config);
                e.setAttribute("title", i.replace("{title}", t));
            }
        },
        togglePoster (e) {
            R(this.elements.container, this.config.classNames.posterEnabled, e);
        },
        setPoster (e, t = !0) {
            return t && this.poster ? Promise.reject(new Error("Poster already set")) : (this.media.setAttribute("data-poster", e), this.elements.poster.removeAttribute("hidden"), te.call(this).then(()=>Re(e)).catch((t)=>{
                throw e === this.poster && Fe.togglePoster.call(this, !1), t;
            }).then(()=>{
                if (e !== this.poster) throw new Error("setPoster cancelled by later call to setPoster");
            }).then(()=>(Object.assign(this.elements.poster.style, {
                    backgroundImage: `url('${e}')`,
                    backgroundSize: ""
                }), Fe.togglePoster.call(this, !0), e)));
        },
        checkPlaying (e) {
            R(this.elements.container, this.config.classNames.playing, this.playing), R(this.elements.container, this.config.classNames.paused, this.paused), R(this.elements.container, this.config.classNames.stopped, this.stopped), Array.from(this.elements.buttons.play || []).forEach((e)=>{
                Object.assign(e, {
                    pressed: this.playing
                }), e.setAttribute("aria-label", ve.get(this.playing ? "pause" : "play", this.config));
            }), S.event(e) && "timeupdate" === e.type || Fe.toggleControls.call(this);
        },
        checkLoading (e) {
            this.loading = [
                "stalled",
                "waiting"
            ].includes(e.type), clearTimeout(this.timers.loading), this.timers.loading = setTimeout(()=>{
                R(this.elements.container, this.config.classNames.loading, this.loading), Fe.toggleControls.call(this);
            }, this.loading ? 250 : 0);
        },
        toggleControls (e) {
            const { controls: t } = this.elements;
            if (t && this.config.hideControls) {
                const i = this.touch && this.lastSeekTime + 2e3 > Date.now();
                this.toggleControls(Boolean(e || this.loading || this.paused || t.pressed || t.hover || i));
            }
        },
        migrateStyles () {
            Object.values({
                ...this.media.style
            }).filter((e)=>!S.empty(e) && S.string(e) && e.startsWith("--plyr")).forEach((e)=>{
                this.elements.container.style.setProperty(e, this.media.style.getPropertyValue(e)), this.media.style.removeProperty(e);
            }), S.empty(this.media.style) && this.media.removeAttribute("style");
        }
    };
    class Ve {
        constructor(t){
            e(this, "firstTouch", ()=>{
                const { player: e } = this, { elements: t } = e;
                e.touch = !0, R(t.container, e.config.classNames.isTouch, !0);
            }), e(this, "global", (e = !0)=>{
                const { player: t } = this;
                t.config.keyboard.global && Q.call(t, window, "keydown keyup", this.handleKey, e, !1), Q.call(t, document.body, "click", this.toggleMenu, e), G.call(t, document.body, "touchstart", this.firstTouch);
            }), e(this, "container", ()=>{
                const { player: e } = this, { config: t, elements: i, timers: s } = e;
                !t.keyboard.global && t.keyboard.focused && X.call(e, i.container, "keydown keyup", this.handleKey, !1), X.call(e, i.container, "mousemove mouseleave touchstart touchmove enterfullscreen exitfullscreen", (t)=>{
                    const { controls: n } = i;
                    n && "enterfullscreen" === t.type && (n.pressed = !1, n.hover = !1);
                    let a = 0;
                    [
                        "touchstart",
                        "touchmove",
                        "mousemove"
                    ].includes(t.type) && (Fe.toggleControls.call(e, !0), a = e.touch ? 3e3 : 2e3), clearTimeout(s.controls), s.controls = setTimeout(()=>Fe.toggleControls.call(e, !1), a);
                });
                const n = ()=>{
                    if (!e.isVimeo || e.config.vimeo.premium) return;
                    const t = i.wrapper, { active: s } = e.fullscreen, [n, a] = ce.call(e), l = ae(`aspect-ratio: ${n} / ${a}`);
                    if (!s) return void (l ? (t.style.width = null, t.style.height = null) : (t.style.maxWidth = null, t.style.margin = null));
                    const [r, o] = [
                        Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
                        Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
                    ], c = r / o > n / a;
                    l ? (t.style.width = c ? "auto" : "100%", t.style.height = c ? "100%" : "auto") : (t.style.maxWidth = c ? o / a * n + "px" : null, t.style.margin = c ? "0 auto" : null);
                }, a = ()=>{
                    clearTimeout(s.resized), s.resized = setTimeout(n, 50);
                };
                X.call(e, i.container, "enterfullscreen exitfullscreen", (t)=>{
                    const { target: s } = e.fullscreen;
                    if (s !== i.container) return;
                    if (!e.isEmbed && S.empty(e.config.ratio)) return;
                    n();
                    ("enterfullscreen" === t.type ? X : J).call(e, window, "resize", a);
                });
            }), e(this, "media", ()=>{
                const { player: e } = this, { elements: t } = e;
                if (X.call(e, e.media, "timeupdate seeking seeked", (t)=>Pe.timeUpdate.call(e, t)), X.call(e, e.media, "durationchange loadeddata loadedmetadata", (t)=>Pe.durationUpdate.call(e, t)), X.call(e, e.media, "ended", ()=>{
                    e.isHTML5 && e.isVideo && e.config.resetOnEnd && (e.restart(), e.pause());
                }), X.call(e, e.media, "progress playing seeking seeked", (t)=>Pe.updateProgress.call(e, t)), X.call(e, e.media, "volumechange", (t)=>Pe.updateVolume.call(e, t)), X.call(e, e.media, "playing play pause ended emptied timeupdate", (t)=>Fe.checkPlaying.call(e, t)), X.call(e, e.media, "waiting canplay seeked playing", (t)=>Fe.checkLoading.call(e, t)), e.supported.ui && e.config.clickToPlay && !e.isAudio) {
                    const i = B.call(e, `.${e.config.classNames.video}`);
                    if (!S.element(i)) return;
                    X.call(e, t.container, "click", (s)=>{
                        ([
                            t.container,
                            i
                        ].includes(s.target) || i.contains(s.target)) && (e.touch && e.config.hideControls || (e.ended ? (this.proxy(s, e.restart, "restart"), this.proxy(s, ()=>{
                            ie(e.play());
                        }, "play")) : this.proxy(s, ()=>{
                            ie(e.togglePlay());
                        }, "play")));
                    });
                }
                e.supported.ui && e.config.disableContextMenu && X.call(e, t.wrapper, "contextmenu", (e)=>{
                    e.preventDefault();
                }, !1), X.call(e, e.media, "volumechange", ()=>{
                    e.storage.set({
                        volume: e.volume,
                        muted: e.muted
                    });
                }), X.call(e, e.media, "ratechange", ()=>{
                    Pe.updateSetting.call(e, "speed"), e.storage.set({
                        speed: e.speed
                    });
                }), X.call(e, e.media, "qualitychange", (t)=>{
                    Pe.updateSetting.call(e, "quality", null, t.detail.quality);
                }), X.call(e, e.media, "ready qualitychange", ()=>{
                    Pe.setDownloadUrl.call(e);
                });
                const i = e.config.events.concat([
                    "keyup",
                    "keydown"
                ]).join(" ");
                X.call(e, e.media, i, (i)=>{
                    let { detail: s = {} } = i;
                    "error" === i.type && (s = e.media.error), Z.call(e, t.container, i.type, !0, s);
                });
            }), e(this, "proxy", (e, t, i)=>{
                const { player: s } = this, n = s.config.listeners[i];
                let a = !0;
                S.function(n) && (a = n.call(s, e)), !1 !== a && S.function(t) && t.call(s, e);
            }), e(this, "bind", (e, t, i, s, n = !0)=>{
                const { player: a } = this, l = a.config.listeners[s], r = S.function(l);
                X.call(a, e, t, (e)=>this.proxy(e, i, s), n && !r);
            }), e(this, "controls", ()=>{
                const { player: e } = this, { elements: t } = e, i = M.isIE ? "change" : "input";
                if (t.buttons.play && Array.from(t.buttons.play).forEach((t)=>{
                    this.bind(t, "click", ()=>{
                        ie(e.togglePlay());
                    }, "play");
                }), this.bind(t.buttons.restart, "click", e.restart, "restart"), this.bind(t.buttons.rewind, "click", ()=>{
                    e.lastSeekTime = Date.now(), e.rewind();
                }, "rewind"), this.bind(t.buttons.fastForward, "click", ()=>{
                    e.lastSeekTime = Date.now(), e.forward();
                }, "fastForward"), this.bind(t.buttons.mute, "click", ()=>{
                    e.muted = !e.muted;
                }, "mute"), this.bind(t.buttons.captions, "click", ()=>e.toggleCaptions()), this.bind(t.buttons.download, "click", ()=>{
                    Z.call(e, e.media, "download");
                }, "download"), this.bind(t.buttons.fullscreen, "click", ()=>{
                    e.fullscreen.toggle();
                }, "fullscreen"), this.bind(t.buttons.pip, "click", ()=>{
                    e.pip = "toggle";
                }, "pip"), this.bind(t.buttons.airplay, "click", e.airplay, "airplay"), this.bind(t.buttons.settings, "click", (t)=>{
                    t.stopPropagation(), t.preventDefault(), Pe.toggleMenu.call(e, t);
                }, null, !1), this.bind(t.buttons.settings, "keyup", (t)=>{
                    [
                        " ",
                        "Enter"
                    ].includes(t.key) && ("Enter" !== t.key ? (t.preventDefault(), t.stopPropagation(), Pe.toggleMenu.call(e, t)) : Pe.focusFirstMenuItem.call(e, null, !0));
                }, null, !1), this.bind(t.settings.menu, "keydown", (t)=>{
                    "Escape" === t.key && Pe.toggleMenu.call(e, t);
                }), this.bind(t.inputs.seek, "mousedown mousemove", (e)=>{
                    const i = t.progress.getBoundingClientRect(), s = 100 / i.width * (e.pageX - i.left);
                    e.currentTarget.setAttribute("seek-value", s);
                }), this.bind(t.inputs.seek, "mousedown mouseup keydown keyup touchstart touchend", (t)=>{
                    const i = t.currentTarget, s = "play-on-seeked";
                    if (S.keyboardEvent(t) && ![
                        "ArrowLeft",
                        "ArrowRight"
                    ].includes(t.key)) return;
                    e.lastSeekTime = Date.now();
                    const n = i.hasAttribute(s), a = [
                        "mouseup",
                        "touchend",
                        "keyup"
                    ].includes(t.type);
                    n && a ? (i.removeAttribute(s), ie(e.play())) : !a && e.playing && (i.setAttribute(s, ""), e.pause());
                }), M.isIos) {
                    const t = U.call(e, 'input[type="range"]');
                    Array.from(t).forEach((e)=>this.bind(e, i, (e)=>P(e.target)));
                }
                this.bind(t.inputs.seek, i, (t)=>{
                    const i = t.currentTarget;
                    let s = i.getAttribute("seek-value");
                    S.empty(s) && (s = i.value), i.removeAttribute("seek-value"), e.currentTime = s / i.max * e.duration;
                }, "seek"), this.bind(t.progress, "mouseenter mouseleave mousemove", (t)=>Pe.updateSeekTooltip.call(e, t)), this.bind(t.progress, "mousemove touchmove", (t)=>{
                    const { previewThumbnails: i } = e;
                    i && i.loaded && i.startMove(t);
                }), this.bind(t.progress, "mouseleave touchend click", ()=>{
                    const { previewThumbnails: t } = e;
                    t && t.loaded && t.endMove(!1, !0);
                }), this.bind(t.progress, "mousedown touchstart", (t)=>{
                    const { previewThumbnails: i } = e;
                    i && i.loaded && i.startScrubbing(t);
                }), this.bind(t.progress, "mouseup touchend", (t)=>{
                    const { previewThumbnails: i } = e;
                    i && i.loaded && i.endScrubbing(t);
                }), M.isWebKit && Array.from(U.call(e, 'input[type="range"]')).forEach((t)=>{
                    this.bind(t, "input", (t)=>Pe.updateRangeFill.call(e, t.target));
                }), e.config.toggleInvert && !S.element(t.display.duration) && this.bind(t.display.currentTime, "click", ()=>{
                    0 !== e.currentTime && (e.config.invertTime = !e.config.invertTime, Pe.timeUpdate.call(e));
                }), this.bind(t.inputs.volume, i, (t)=>{
                    e.volume = t.target.value;
                }, "volume"), this.bind(t.controls, "mouseenter mouseleave", (i)=>{
                    t.controls.hover = !e.touch && "mouseenter" === i.type;
                }), t.fullscreen && Array.from(t.fullscreen.children).filter((e)=>!e.contains(t.container)).forEach((i)=>{
                    this.bind(i, "mouseenter mouseleave", (i)=>{
                        t.controls && (t.controls.hover = !e.touch && "mouseenter" === i.type);
                    });
                }), this.bind(t.controls, "mousedown mouseup touchstart touchend touchcancel", (e)=>{
                    t.controls.pressed = [
                        "mousedown",
                        "touchstart"
                    ].includes(e.type);
                }), this.bind(t.controls, "focusin", ()=>{
                    const { config: i, timers: s } = e;
                    R(t.controls, i.classNames.noTransition, !0), Fe.toggleControls.call(e, !0), setTimeout(()=>{
                        R(t.controls, i.classNames.noTransition, !1);
                    }, 0);
                    const n = this.touch ? 3e3 : 4e3;
                    clearTimeout(s.controls), s.controls = setTimeout(()=>Fe.toggleControls.call(e, !1), n);
                }), this.bind(t.inputs.volume, "wheel", (t)=>{
                    const i = t.webkitDirectionInvertedFromDevice, [s, n] = [
                        t.deltaX,
                        -t.deltaY
                    ].map((e)=>i ? -e : e), a = Math.sign(Math.abs(s) > Math.abs(n) ? s : n);
                    e.increaseVolume(a / 50);
                    const { volume: l } = e.media;
                    (1 === a && l < 1 || -1 === a && l > 0) && t.preventDefault();
                }, "volume", !1);
            }), this.player = t, this.lastKey = null, this.focusTimer = null, this.lastKeyDown = null, this.handleKey = this.handleKey.bind(this), this.toggleMenu = this.toggleMenu.bind(this), this.firstTouch = this.firstTouch.bind(this);
        }
        handleKey(e) {
            const { player: t } = this, { elements: i } = t, { key: s, type: n, altKey: a, ctrlKey: l, metaKey: r, shiftKey: o } = e, c = "keydown" === n, u = c && s === this.lastKey;
            if (a || l || r || o) return;
            if (!s) return;
            if (c) {
                const n = document.activeElement;
                if (S.element(n)) {
                    const { editable: s } = t.config.selectors, { seek: a } = i.inputs;
                    if (n !== a && V(n, s)) return;
                    if (" " === e.key && V(n, 'button, [role^="menuitem"]')) return;
                }
                switch([
                    " ",
                    "ArrowLeft",
                    "ArrowUp",
                    "ArrowRight",
                    "ArrowDown",
                    "0",
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "7",
                    "8",
                    "9",
                    "c",
                    "f",
                    "k",
                    "l",
                    "m"
                ].includes(s) && (e.preventDefault(), e.stopPropagation()), s){
                    case "0":
                    case "1":
                    case "2":
                    case "3":
                    case "4":
                    case "5":
                    case "6":
                    case "7":
                    case "8":
                    case "9":
                        u || (h = parseInt(s, 10), t.currentTime = t.duration / 10 * h);
                        break;
                    case " ":
                    case "k":
                        u || ie(t.togglePlay());
                        break;
                    case "ArrowUp":
                        t.increaseVolume(.1);
                        break;
                    case "ArrowDown":
                        t.decreaseVolume(.1);
                        break;
                    case "m":
                        u || (t.muted = !t.muted);
                        break;
                    case "ArrowRight":
                        t.forward();
                        break;
                    case "ArrowLeft":
                        t.rewind();
                        break;
                    case "f":
                        t.fullscreen.toggle();
                        break;
                    case "c":
                        u || t.toggleCaptions();
                        break;
                    case "l":
                        t.loop = !t.loop;
                }
                "Escape" === s && !t.fullscreen.usingNative && t.fullscreen.active && t.fullscreen.toggle(), this.lastKey = s;
            } else this.lastKey = null;
            var h;
        }
        toggleMenu(e) {
            Pe.toggleMenu.call(this.player, e);
        }
    }
    "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self && self;
    var Ue = function(e, t) {
        return e(t = {
            exports: {}
        }, t.exports), t.exports;
    }(function(e, t) {
        e.exports = function() {
            var e = function() {}, t = {}, i = {}, s = {};
            function n(e, t) {
                e = e.push ? e : [
                    e
                ];
                var n, a, l, r = [], o = e.length, c = o;
                for(n = function(e, i) {
                    i.length && r.push(e), --c || t(r);
                }; o--;)a = e[o], (l = i[a]) ? n(a, l) : (s[a] = s[a] || []).push(n);
            }
            function a(e, t) {
                if (e) {
                    var n = s[e];
                    if (i[e] = t, n) for(; n.length;)n[0](e, t), n.splice(0, 1);
                }
            }
            function l(t, i) {
                t.call && (t = {
                    success: t
                }), i.length ? (t.error || e)(i) : (t.success || e)(t);
            }
            function r(t, i, s, n) {
                var a, l, o = document, c = s.async, u = (s.numRetries || 0) + 1, h = s.before || e, d = t.replace(/[\?|#].*$/, ""), m = t.replace(/^(css|img)!/, "");
                n = n || 0, /(^css!|\.css$)/.test(d) ? ((l = o.createElement("link")).rel = "stylesheet", l.href = m, (a = "hideFocus" in l) && l.relList && (a = 0, l.rel = "preload", l.as = "style")) : /(^img!|\.(png|gif|jpg|svg|webp)$)/.test(d) ? (l = o.createElement("img")).src = m : ((l = o.createElement("script")).src = t, l.async = void 0 === c || c), l.onload = l.onerror = l.onbeforeload = function(e) {
                    var o = e.type[0];
                    if (a) try {
                        l.sheet.cssText.length || (o = "e");
                    } catch (e) {
                        18 != e.code && (o = "e");
                    }
                    if ("e" == o) {
                        if ((n += 1) < u) return r(t, i, s, n);
                    } else if ("preload" == l.rel && "style" == l.as) return l.rel = "stylesheet";
                    i(t, o, e.defaultPrevented);
                }, !1 !== h(t, l) && o.head.appendChild(l);
            }
            function o(e, t, i) {
                var s, n, a = (e = e.push ? e : [
                    e
                ]).length, l = a, o = [];
                for(s = function(e, i, s) {
                    if ("e" == i && o.push(e), "b" == i) {
                        if (!s) return;
                        o.push(e);
                    }
                    --a || t(o);
                }, n = 0; n < l; n++)r(e[n], s, i);
            }
            function c(e, i, s) {
                var n, r;
                if (i && i.trim && (n = i), r = (n ? s : i) || {}, n) {
                    if (n in t) throw "LoadJS";
                    t[n] = !0;
                }
                function c(t, i) {
                    o(e, function(e) {
                        l(r, e), t && l({
                            success: t,
                            error: i
                        }, e), a(n, e);
                    }, r);
                }
                if (r.returnPromise) return new Promise(c);
                c();
            }
            return c.ready = function(e, t) {
                return n(e, function(e) {
                    l(t, e);
                }), c;
            }, c.done = function(e) {
                a(e, []);
            }, c.reset = function() {
                t = {}, i = {}, s = {};
            }, c.isDefined = function(e) {
                return e in t;
            }, c;
        }();
    });
    function Be(e) {
        return new Promise((t, i)=>{
            Ue(e, {
                success: t,
                error: i
            });
        });
    }
    function We(e) {
        e && !this.embed.hasPlayed && (this.embed.hasPlayed = !0), this.media.paused === e && (this.media.paused = !e, Z.call(this, this.media, e ? "play" : "pause"));
    }
    const ze = {
        setup () {
            const e = this;
            R(e.elements.wrapper, e.config.classNames.embed, !0), e.options.speed = e.config.speed.options, ue.call(e), S.object(window.Vimeo) ? ze.ready.call(e) : Be(e.config.urls.vimeo.sdk).then(()=>{
                ze.ready.call(e);
            }).catch((t)=>{
                e.debug.warn("Vimeo SDK (player.js) failed to load", t);
            });
        },
        ready () {
            const e = this, t = e.config.vimeo, { premium: i, referrerPolicy: s, ...n } = t;
            let a = e.media.getAttribute("src"), l = "";
            S.empty(a) ? (a = e.media.getAttribute(e.config.attributes.embed.id), l = e.media.getAttribute(e.config.attributes.embed.hash)) : l = function(e) {
                const t = e.match(/^.*(vimeo.com\/|video\/)(\d+)(\?.*&*h=|\/)+([\d,a-f]+)/);
                return t && 5 === t.length ? t[4] : null;
            }(a);
            const r = l ? {
                h: l
            } : {};
            i && Object.assign(n, {
                controls: !1,
                sidedock: !1
            });
            const o = Ne({
                loop: e.config.loop.active,
                autoplay: e.autoplay,
                muted: e.muted,
                gesture: "media",
                playsinline: e.config.playsinline,
                ...r,
                ...n
            }), c = (u = a, S.empty(u) ? null : S.number(Number(u)) ? u : u.match(/^.*(vimeo.com\/|video\/)(\d+).*/) ? RegExp.$2 : u);
            var u;
            const h = $("iframe"), d = me(e.config.urls.vimeo.iframe, c, o);
            if (h.setAttribute("src", d), h.setAttribute("allowfullscreen", ""), h.setAttribute("allow", [
                "autoplay",
                "fullscreen",
                "picture-in-picture",
                "encrypted-media",
                "accelerometer",
                "gyroscope"
            ].join("; ")), S.empty(s) || h.setAttribute("referrerPolicy", s), i || !t.customControls) h.setAttribute("data-poster", e.poster), e.media = q(h, e.media);
            else {
                const t = $("div", {
                    class: e.config.classNames.embedContainer,
                    "data-poster": e.poster
                });
                t.appendChild(h), e.media = q(t, e.media);
            }
            t.customControls || Te(me(e.config.urls.vimeo.api, d)).then((t)=>{
                !S.empty(t) && t.thumbnail_url && Fe.setPoster.call(e, t.thumbnail_url).catch(()=>{});
            }), e.embed = new window.Vimeo.Player(h, {
                autopause: e.config.autopause,
                muted: e.muted
            }), e.media.paused = !0, e.media.currentTime = 0, e.supported.ui && e.embed.disableTextTrack(), e.media.play = ()=>(We.call(e, !0), e.embed.play()), e.media.pause = ()=>(We.call(e, !1), e.embed.pause()), e.media.stop = ()=>{
                e.pause(), e.currentTime = 0;
            };
            let { currentTime: m } = e.media;
            Object.defineProperty(e.media, "currentTime", {
                get: ()=>m,
                set (t) {
                    const { embed: i, media: s, paused: n, volume: a } = e, l = n && !i.hasPlayed;
                    s.seeking = !0, Z.call(e, s, "seeking"), Promise.resolve(l && i.setVolume(0)).then(()=>i.setCurrentTime(t)).then(()=>l && i.pause()).then(()=>l && i.setVolume(a)).catch(()=>{});
                }
            });
            let p = e.config.speed.selected;
            Object.defineProperty(e.media, "playbackRate", {
                get: ()=>p,
                set (t) {
                    e.embed.setPlaybackRate(t).then(()=>{
                        p = t, Z.call(e, e.media, "ratechange");
                    }).catch(()=>{
                        e.options.speed = [
                            1
                        ];
                    });
                }
            });
            let { volume: g } = e.config;
            Object.defineProperty(e.media, "volume", {
                get: ()=>g,
                set (t) {
                    e.embed.setVolume(t).then(()=>{
                        g = t, Z.call(e, e.media, "volumechange");
                    });
                }
            });
            let { muted: f } = e.config;
            Object.defineProperty(e.media, "muted", {
                get: ()=>f,
                set (t) {
                    const i = !!S.boolean(t) && t;
                    e.embed.setMuted(!!i || e.config.muted).then(()=>{
                        f = i, Z.call(e, e.media, "volumechange");
                    });
                }
            });
            let y, { loop: b } = e.config;
            Object.defineProperty(e.media, "loop", {
                get: ()=>b,
                set (t) {
                    const i = S.boolean(t) ? t : e.config.loop.active;
                    e.embed.setLoop(i).then(()=>{
                        b = i;
                    });
                }
            }), e.embed.getVideoUrl().then((t)=>{
                y = t, Pe.setDownloadUrl.call(e);
            }).catch((e)=>{
                this.debug.warn(e);
            }), Object.defineProperty(e.media, "currentSrc", {
                get: ()=>y
            }), Object.defineProperty(e.media, "ended", {
                get: ()=>e.currentTime === e.duration
            }), Promise.all([
                e.embed.getVideoWidth(),
                e.embed.getVideoHeight()
            ]).then((t)=>{
                const [i, s] = t;
                e.embed.ratio = he(i, s), ue.call(this);
            }), e.embed.setAutopause(e.config.autopause).then((t)=>{
                e.config.autopause = t;
            }), e.embed.getVideoTitle().then((t)=>{
                e.config.title = t, Fe.setTitle.call(this);
            }), e.embed.getCurrentTime().then((t)=>{
                m = t, Z.call(e, e.media, "timeupdate");
            }), e.embed.getDuration().then((t)=>{
                e.media.duration = t, Z.call(e, e.media, "durationchange");
            }), e.embed.getTextTracks().then((t)=>{
                e.media.textTracks = t, xe.setup.call(e);
            }), e.embed.on("cuechange", ({ cues: t = [] })=>{
                const i = t.map((e)=>(function(e) {
                        const t = document.createDocumentFragment(), i = document.createElement("div");
                        return t.appendChild(i), i.innerHTML = e, t.firstChild.innerText;
                    })(e.text));
                xe.updateCues.call(e, i);
            }), e.embed.on("loaded", ()=>{
                if (e.embed.getPaused().then((t)=>{
                    We.call(e, !t), t || Z.call(e, e.media, "playing");
                }), S.element(e.embed.element) && e.supported.ui) e.embed.element.setAttribute("tabindex", -1);
            }), e.embed.on("bufferstart", ()=>{
                Z.call(e, e.media, "waiting");
            }), e.embed.on("bufferend", ()=>{
                Z.call(e, e.media, "playing");
            }), e.embed.on("play", ()=>{
                We.call(e, !0), Z.call(e, e.media, "playing");
            }), e.embed.on("pause", ()=>{
                We.call(e, !1);
            }), e.embed.on("timeupdate", (t)=>{
                e.media.seeking = !1, m = t.seconds, Z.call(e, e.media, "timeupdate");
            }), e.embed.on("progress", (t)=>{
                e.media.buffered = t.percent, Z.call(e, e.media, "progress"), 1 === parseInt(t.percent, 10) && Z.call(e, e.media, "canplaythrough"), e.embed.getDuration().then((t)=>{
                    t !== e.media.duration && (e.media.duration = t, Z.call(e, e.media, "durationchange"));
                });
            }), e.embed.on("seeked", ()=>{
                e.media.seeking = !1, Z.call(e, e.media, "seeked");
            }), e.embed.on("ended", ()=>{
                e.media.paused = !0, Z.call(e, e.media, "ended");
            }), e.embed.on("error", (t)=>{
                e.media.error = t, Z.call(e, e.media, "error");
            }), t.customControls && setTimeout(()=>Fe.build.call(e), 0);
        }
    };
    function Ke(e) {
        e && !this.embed.hasPlayed && (this.embed.hasPlayed = !0), this.media.paused === e && (this.media.paused = !e, Z.call(this, this.media, e ? "play" : "pause"));
    }
    function Ye(e) {
        return e.noCookie ? "https://www.youtube-nocookie.com" : "http:" === window.location.protocol ? "http://www.youtube.com" : void 0;
    }
    const Qe = {
        setup () {
            if (R(this.elements.wrapper, this.config.classNames.embed, !0), S.object(window.YT) && S.function(window.YT.Player)) Qe.ready.call(this);
            else {
                const e = window.onYouTubeIframeAPIReady;
                window.onYouTubeIframeAPIReady = ()=>{
                    S.function(e) && e(), Qe.ready.call(this);
                }, Be(this.config.urls.youtube.sdk).catch((e)=>{
                    this.debug.warn("YouTube API failed to load", e);
                });
            }
        },
        getTitle (e) {
            Te(me(this.config.urls.youtube.api, e)).then((e)=>{
                if (S.object(e)) {
                    const { title: t, height: i, width: s } = e;
                    this.config.title = t, Fe.setTitle.call(this), this.embed.ratio = he(s, i);
                }
                ue.call(this);
            }).catch(()=>{
                ue.call(this);
            });
        },
        ready () {
            const e = this, t = e.config.youtube, i = e.media && e.media.getAttribute("id");
            if (!S.empty(i) && i.startsWith("youtube-")) return;
            let s = e.media.getAttribute("src");
            S.empty(s) && (s = e.media.getAttribute(this.config.attributes.embed.id));
            const n = (a = s, S.empty(a) ? null : a.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/) ? RegExp.$2 : a);
            var a;
            const l = $("div", {
                id: `${e.provider}-${Math.floor(1e4 * Math.random())}`,
                "data-poster": t.customControls ? e.poster : void 0
            });
            if (e.media = q(l, e.media), t.customControls) {
                const t = (e)=>`https://i.ytimg.com/vi/${n}/${e}default.jpg`;
                Re(t("maxres"), 121).catch(()=>Re(t("sd"), 121)).catch(()=>Re(t("hq"))).then((t)=>Fe.setPoster.call(e, t.src)).then((t)=>{
                    t.includes("maxres") || (e.elements.poster.style.backgroundSize = "cover");
                }).catch(()=>{});
            }
            e.embed = new window.YT.Player(e.media, {
                videoId: n,
                host: Ye(t),
                playerVars: x({}, {
                    autoplay: e.config.autoplay ? 1 : 0,
                    hl: e.config.hl,
                    controls: e.supported.ui && t.customControls ? 0 : 1,
                    disablekb: 1,
                    playsinline: e.config.playsinline && !e.config.fullscreen.iosNative ? 1 : 0,
                    cc_load_policy: e.captions.active ? 1 : 0,
                    cc_lang_pref: e.config.captions.language,
                    widget_referrer: window ? window.location.href : null
                }, t),
                events: {
                    onError (t) {
                        if (!e.media.error) {
                            const i = t.data, s = {
                                2: "The request contains an invalid parameter value. For example, this error occurs if you specify a video ID that does not have 11 characters, or if the video ID contains invalid characters, such as exclamation points or asterisks.",
                                5: "The requested content cannot be played in an HTML5 player or another error related to the HTML5 player has occurred.",
                                100: "The video requested was not found. This error occurs when a video has been removed (for any reason) or has been marked as private.",
                                101: "The owner of the requested video does not allow it to be played in embedded players.",
                                150: "The owner of the requested video does not allow it to be played in embedded players."
                            }[i] || "An unknown error occurred";
                            e.media.error = {
                                code: i,
                                message: s
                            }, Z.call(e, e.media, "error");
                        }
                    },
                    onPlaybackRateChange (t) {
                        const i = t.target;
                        e.media.playbackRate = i.getPlaybackRate(), Z.call(e, e.media, "ratechange");
                    },
                    onReady (i) {
                        if (S.function(e.media.play)) return;
                        const s = i.target;
                        Qe.getTitle.call(e, n), e.media.play = ()=>{
                            Ke.call(e, !0), s.playVideo();
                        }, e.media.pause = ()=>{
                            Ke.call(e, !1), s.pauseVideo();
                        }, e.media.stop = ()=>{
                            s.stopVideo();
                        }, e.media.duration = s.getDuration(), e.media.paused = !0, e.media.currentTime = 0, Object.defineProperty(e.media, "currentTime", {
                            get: ()=>Number(s.getCurrentTime()),
                            set (t) {
                                e.paused && !e.embed.hasPlayed && e.embed.mute(), e.media.seeking = !0, Z.call(e, e.media, "seeking"), s.seekTo(t);
                            }
                        }), Object.defineProperty(e.media, "playbackRate", {
                            get: ()=>s.getPlaybackRate(),
                            set (e) {
                                s.setPlaybackRate(e);
                            }
                        });
                        let { volume: a } = e.config;
                        Object.defineProperty(e.media, "volume", {
                            get: ()=>a,
                            set (t) {
                                a = t, s.setVolume(100 * a), Z.call(e, e.media, "volumechange");
                            }
                        });
                        let { muted: l } = e.config;
                        Object.defineProperty(e.media, "muted", {
                            get: ()=>l,
                            set (t) {
                                const i = S.boolean(t) ? t : l;
                                l = i, s[i ? "mute" : "unMute"](), s.setVolume(100 * a), Z.call(e, e.media, "volumechange");
                            }
                        }), Object.defineProperty(e.media, "currentSrc", {
                            get: ()=>s.getVideoUrl()
                        }), Object.defineProperty(e.media, "ended", {
                            get: ()=>e.currentTime === e.duration
                        });
                        const r = s.getAvailablePlaybackRates();
                        e.options.speed = r.filter((t)=>e.config.speed.options.includes(t)), e.supported.ui && t.customControls && e.media.setAttribute("tabindex", -1), Z.call(e, e.media, "timeupdate"), Z.call(e, e.media, "durationchange"), clearInterval(e.timers.buffering), e.timers.buffering = setInterval(()=>{
                            e.media.buffered = s.getVideoLoadedFraction(), (null === e.media.lastBuffered || e.media.lastBuffered < e.media.buffered) && Z.call(e, e.media, "progress"), e.media.lastBuffered = e.media.buffered, 1 === e.media.buffered && (clearInterval(e.timers.buffering), Z.call(e, e.media, "canplaythrough"));
                        }, 200), t.customControls && setTimeout(()=>Fe.build.call(e), 50);
                    },
                    onStateChange (i) {
                        const s = i.target;
                        clearInterval(e.timers.playing);
                        switch(e.media.seeking && [
                            1,
                            2
                        ].includes(i.data) && (e.media.seeking = !1, Z.call(e, e.media, "seeked")), i.data){
                            case -1:
                                Z.call(e, e.media, "timeupdate"), e.media.buffered = s.getVideoLoadedFraction(), Z.call(e, e.media, "progress");
                                break;
                            case 0:
                                Ke.call(e, !1), e.media.loop ? (s.stopVideo(), s.playVideo()) : Z.call(e, e.media, "ended");
                                break;
                            case 1:
                                t.customControls && !e.config.autoplay && e.media.paused && !e.embed.hasPlayed ? e.media.pause() : (Ke.call(e, !0), Z.call(e, e.media, "playing"), e.timers.playing = setInterval(()=>{
                                    Z.call(e, e.media, "timeupdate");
                                }, 50), e.media.duration !== s.getDuration() && (e.media.duration = s.getDuration(), Z.call(e, e.media, "durationchange")));
                                break;
                            case 2:
                                e.muted || e.embed.unMute(), Ke.call(e, !1);
                                break;
                            case 3:
                                Z.call(e, e.media, "waiting");
                        }
                        Z.call(e, e.elements.container, "statechange", !1, {
                            code: i.data
                        });
                    }
                }
            });
        }
    }, Xe = {
        setup () {
            this.media ? (R(this.elements.container, this.config.classNames.type.replace("{0}", this.type), !0), R(this.elements.container, this.config.classNames.provider.replace("{0}", this.provider), !0), this.isEmbed && R(this.elements.container, this.config.classNames.type.replace("{0}", "video"), !0), this.isVideo && (this.elements.wrapper = $("div", {
                class: this.config.classNames.video
            }), L(this.media, this.elements.wrapper), this.elements.poster = $("div", {
                class: this.config.classNames.poster
            }), this.elements.wrapper.appendChild(this.elements.poster)), this.isHTML5 ? de.setup.call(this) : this.isYouTube ? Qe.setup.call(this) : this.isVimeo && ze.setup.call(this)) : this.debug.warn("No media element found!");
        }
    };
    class Je {
        constructor(t){
            e(this, "load", ()=>{
                this.enabled && (S.object(window.google) && S.object(window.google.ima) ? this.ready() : Be(this.player.config.urls.googleIMA.sdk).then(()=>{
                    this.ready();
                }).catch(()=>{
                    this.trigger("error", new Error("Google IMA SDK failed to load"));
                }));
            }), e(this, "ready", ()=>{
                var e;
                this.enabled || ((e = this).manager && e.manager.destroy(), e.elements.displayContainer && e.elements.displayContainer.destroy(), e.elements.container.remove()), this.startSafetyTimer(12e3, "ready()"), this.managerPromise.then(()=>{
                    this.clearSafetyTimer("onAdsManagerLoaded()");
                }), this.listeners(), this.setupIMA();
            }), e(this, "setupIMA", ()=>{
                this.elements.container = $("div", {
                    class: this.player.config.classNames.ads
                }), this.player.elements.container.appendChild(this.elements.container), google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.ENABLED), google.ima.settings.setLocale(this.player.config.ads.language), google.ima.settings.setDisableCustomPlaybackForIOS10Plus(this.player.config.playsinline), this.elements.displayContainer = new google.ima.AdDisplayContainer(this.elements.container, this.player.media), this.loader = new google.ima.AdsLoader(this.elements.displayContainer), this.loader.addEventListener(google.ima.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED, (e)=>this.onAdsManagerLoaded(e), !1), this.loader.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (e)=>this.onAdError(e), !1), this.requestAds();
            }), e(this, "requestAds", ()=>{
                const { container: e } = this.player.elements;
                try {
                    const t = new google.ima.AdsRequest;
                    t.adTagUrl = this.tagUrl, t.linearAdSlotWidth = e.offsetWidth, t.linearAdSlotHeight = e.offsetHeight, t.nonLinearAdSlotWidth = e.offsetWidth, t.nonLinearAdSlotHeight = e.offsetHeight, t.forceNonLinearFullSlot = !1, t.setAdWillPlayMuted(!this.player.muted), this.loader.requestAds(t);
                } catch (e) {
                    this.onAdError(e);
                }
            }), e(this, "pollCountdown", (e = !1)=>{
                if (!e) return clearInterval(this.countdownTimer), void this.elements.container.removeAttribute("data-badge-text");
                this.countdownTimer = setInterval(()=>{
                    const e = Ee(Math.max(this.manager.getRemainingTime(), 0)), t = `${ve.get("advertisement", this.player.config)} - ${e}`;
                    this.elements.container.setAttribute("data-badge-text", t);
                }, 100);
            }), e(this, "onAdsManagerLoaded", (e)=>{
                if (!this.enabled) return;
                const t = new google.ima.AdsRenderingSettings;
                t.restoreCustomPlaybackStateOnAdBreakComplete = !0, t.enablePreloading = !0, this.manager = e.getAdsManager(this.player, t), this.cuePoints = this.manager.getCuePoints(), this.manager.addEventListener(google.ima.AdErrorEvent.Type.AD_ERROR, (e)=>this.onAdError(e)), Object.keys(google.ima.AdEvent.Type).forEach((e)=>{
                    this.manager.addEventListener(google.ima.AdEvent.Type[e], (e)=>this.onAdEvent(e));
                }), this.trigger("loaded");
            }), e(this, "addCuePoints", ()=>{
                S.empty(this.cuePoints) || this.cuePoints.forEach((e)=>{
                    if (0 !== e && -1 !== e && e < this.player.duration) {
                        const t = this.player.elements.progress;
                        if (S.element(t)) {
                            const i = 100 / this.player.duration * e, s = $("span", {
                                class: this.player.config.classNames.cues
                            });
                            s.style.left = `${i.toString()}%`, t.appendChild(s);
                        }
                    }
                });
            }), e(this, "onAdEvent", (e)=>{
                const { container: t } = this.player.elements, i = e.getAd(), s = e.getAdData();
                switch(((e)=>{
                    Z.call(this.player, this.player.media, `ads${e.replace(/_/g, "").toLowerCase()}`);
                })(e.type), e.type){
                    case google.ima.AdEvent.Type.LOADED:
                        this.trigger("loaded"), this.pollCountdown(!0), i.isLinear() || (i.width = t.offsetWidth, i.height = t.offsetHeight);
                        break;
                    case google.ima.AdEvent.Type.STARTED:
                        this.manager.setVolume(this.player.volume);
                        break;
                    case google.ima.AdEvent.Type.ALL_ADS_COMPLETED:
                        this.player.ended ? this.loadAds() : this.loader.contentComplete();
                        break;
                    case google.ima.AdEvent.Type.CONTENT_PAUSE_REQUESTED:
                        this.pauseContent();
                        break;
                    case google.ima.AdEvent.Type.CONTENT_RESUME_REQUESTED:
                        this.pollCountdown(), this.resumeContent();
                        break;
                    case google.ima.AdEvent.Type.LOG:
                        s.adError && this.player.debug.warn(`Non-fatal ad error: ${s.adError.getMessage()}`);
                }
            }), e(this, "onAdError", (e)=>{
                this.cancel(), this.player.debug.warn("Ads error", e);
            }), e(this, "listeners", ()=>{
                const { container: e } = this.player.elements;
                let t;
                this.player.on("canplay", ()=>{
                    this.addCuePoints();
                }), this.player.on("ended", ()=>{
                    this.loader.contentComplete();
                }), this.player.on("timeupdate", ()=>{
                    t = this.player.currentTime;
                }), this.player.on("seeked", ()=>{
                    const e = this.player.currentTime;
                    S.empty(this.cuePoints) || this.cuePoints.forEach((i, s)=>{
                        t < i && i < e && (this.manager.discardAdBreak(), this.cuePoints.splice(s, 1));
                    });
                }), window.addEventListener("resize", ()=>{
                    this.manager && this.manager.resize(e.offsetWidth, e.offsetHeight, google.ima.ViewMode.NORMAL);
                });
            }), e(this, "play", ()=>{
                const { container: e } = this.player.elements;
                this.managerPromise || this.resumeContent(), this.managerPromise.then(()=>{
                    this.manager.setVolume(this.player.volume), this.elements.displayContainer.initialize();
                    try {
                        this.initialized || (this.manager.init(e.offsetWidth, e.offsetHeight, google.ima.ViewMode.NORMAL), this.manager.start()), this.initialized = !0;
                    } catch (e) {
                        this.onAdError(e);
                    }
                }).catch(()=>{});
            }), e(this, "resumeContent", ()=>{
                this.elements.container.style.zIndex = "", this.playing = !1, ie(this.player.media.play());
            }), e(this, "pauseContent", ()=>{
                this.elements.container.style.zIndex = 3, this.playing = !0, this.player.media.pause();
            }), e(this, "cancel", ()=>{
                this.initialized && this.resumeContent(), this.trigger("error"), this.loadAds();
            }), e(this, "loadAds", ()=>{
                this.managerPromise.then(()=>{
                    this.manager && this.manager.destroy(), this.managerPromise = new Promise((e)=>{
                        this.on("loaded", e), this.player.debug.log(this.manager);
                    }), this.initialized = !1, this.requestAds();
                }).catch(()=>{});
            }), e(this, "trigger", (e, ...t)=>{
                const i = this.events[e];
                S.array(i) && i.forEach((e)=>{
                    S.function(e) && e.apply(this, t);
                });
            }), e(this, "on", (e, t)=>(S.array(this.events[e]) || (this.events[e] = []), this.events[e].push(t), this)), e(this, "startSafetyTimer", (e, t)=>{
                this.player.debug.log(`Safety timer invoked from: ${t}`), this.safetyTimer = setTimeout(()=>{
                    this.cancel(), this.clearSafetyTimer("startSafetyTimer()");
                }, e);
            }), e(this, "clearSafetyTimer", (e)=>{
                S.nullOrUndefined(this.safetyTimer) || (this.player.debug.log(`Safety timer cleared from: ${e}`), clearTimeout(this.safetyTimer), this.safetyTimer = null);
            }), this.player = t, this.config = t.config.ads, this.playing = !1, this.initialized = !1, this.elements = {
                container: null,
                displayContainer: null
            }, this.manager = null, this.loader = null, this.cuePoints = null, this.events = {}, this.safetyTimer = null, this.countdownTimer = null, this.managerPromise = new Promise((e, t)=>{
                this.on("loaded", e), this.on("error", t);
            }), this.load();
        }
        get enabled() {
            const { config: e } = this;
            return this.player.isHTML5 && this.player.isVideo && e.enabled && (!S.empty(e.publisherId) || S.url(e.tagUrl));
        }
        get tagUrl() {
            const { config: e } = this;
            if (S.url(e.tagUrl)) return e.tagUrl;
            return `https://go.aniview.com/api/adserver6/vast/?${Ne({
                AV_PUBLISHERID: "58c25bb0073ef448b1087ad6",
                AV_CHANNELID: "5a0458dc28a06145e4519d21",
                AV_URL: window.location.hostname,
                cb: Date.now(),
                AV_WIDTH: 640,
                AV_HEIGHT: 480,
                AV_CDIM2: e.publisherId
            })}`;
        }
    }
    function Ge(e = 0, t = 0, i = 255) {
        return Math.min(Math.max(e, t), i);
    }
    const Ze = (e)=>{
        const t = [];
        return e.split(/\r\n\r\n|\n\n|\r\r/).forEach((e)=>{
            const i = {};
            e.split(/\r\n|\n|\r/).forEach((e)=>{
                if (S.number(i.startTime)) {
                    if (!S.empty(e.trim()) && S.empty(i.text)) {
                        const t = e.trim().split("#xywh=");
                        [i.text] = t, t[1] && ([i.x, i.y, i.w, i.h] = t[1].split(","));
                    }
                } else {
                    const t = e.match(/([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})( ?--> ?)([0-9]{2})?:?([0-9]{2}):([0-9]{2}).([0-9]{2,3})/);
                    t && (i.startTime = 60 * Number(t[1] || 0) * 60 + 60 * Number(t[2]) + Number(t[3]) + Number(`0.${t[4]}`), i.endTime = 60 * Number(t[6] || 0) * 60 + 60 * Number(t[7]) + Number(t[8]) + Number(`0.${t[9]}`));
                }
            }), i.text && t.push(i);
        }), t;
    }, et = (e, t)=>{
        const i = {};
        return e > t.width / t.height ? (i.width = t.width, i.height = 1 / e * t.width) : (i.height = t.height, i.width = e * t.height), i;
    };
    class tt {
        constructor(t){
            e(this, "load", ()=>{
                this.player.elements.display.seekTooltip && (this.player.elements.display.seekTooltip.hidden = this.enabled), this.enabled && this.getThumbnails().then(()=>{
                    this.enabled && (this.render(), this.determineContainerAutoSizing(), this.listeners(), this.loaded = !0);
                });
            }), e(this, "getThumbnails", ()=>new Promise((e)=>{
                    const { src: t } = this.player.config.previewThumbnails;
                    if (S.empty(t)) throw new Error("Missing previewThumbnails.src config attribute");
                    const i = ()=>{
                        this.thumbnails.sort((e, t)=>e.height - t.height), this.player.debug.log("Preview thumbnails", this.thumbnails), e();
                    };
                    if (S.function(t)) t((e)=>{
                        this.thumbnails = e, i();
                    });
                    else {
                        const e = (S.string(t) ? [
                            t
                        ] : t).map((e)=>this.getThumbnail(e));
                        Promise.all(e).then(i);
                    }
                })), e(this, "getThumbnail", (e)=>new Promise((t)=>{
                    Te(e).then((i)=>{
                        const s = {
                            frames: Ze(i),
                            height: null,
                            urlPrefix: ""
                        };
                        s.frames[0].text.startsWith("/") || s.frames[0].text.startsWith("http://") || s.frames[0].text.startsWith("https://") || (s.urlPrefix = e.substring(0, e.lastIndexOf("/") + 1));
                        const n = new Image;
                        n.onload = ()=>{
                            s.height = n.naturalHeight, s.width = n.naturalWidth, this.thumbnails.push(s), t();
                        }, n.src = s.urlPrefix + s.frames[0].text;
                    });
                })), e(this, "startMove", (e)=>{
                if (this.loaded && S.event(e) && [
                    "touchmove",
                    "mousemove"
                ].includes(e.type) && this.player.media.duration) {
                    if ("touchmove" === e.type) this.seekTime = this.player.media.duration * (this.player.elements.inputs.seek.value / 100);
                    else {
                        var t, i;
                        const s = this.player.elements.progress.getBoundingClientRect(), n = 100 / s.width * (e.pageX - s.left);
                        this.seekTime = this.player.media.duration * (n / 100), this.seekTime < 0 && (this.seekTime = 0), this.seekTime > this.player.media.duration - 1 && (this.seekTime = this.player.media.duration - 1), this.mousePosX = e.pageX, this.elements.thumb.time.innerText = Ee(this.seekTime);
                        const a = null === (t = this.player.config.markers) || void 0 === t || null === (i = t.points) || void 0 === i ? void 0 : i.find(({ time: e })=>e === Math.round(this.seekTime));
                        a && this.elements.thumb.time.insertAdjacentHTML("afterbegin", `${a.label}<br>`);
                    }
                    this.showImageAtCurrentTime();
                }
            }), e(this, "endMove", ()=>{
                this.toggleThumbContainer(!1, !0);
            }), e(this, "startScrubbing", (e)=>{
                (S.nullOrUndefined(e.button) || !1 === e.button || 0 === e.button) && (this.mouseDown = !0, this.player.media.duration && (this.toggleScrubbingContainer(!0), this.toggleThumbContainer(!1, !0), this.showImageAtCurrentTime()));
            }), e(this, "endScrubbing", ()=>{
                this.mouseDown = !1, Math.ceil(this.lastTime) === Math.ceil(this.player.media.currentTime) ? this.toggleScrubbingContainer(!1) : G.call(this.player, this.player.media, "timeupdate", ()=>{
                    this.mouseDown || this.toggleScrubbingContainer(!1);
                });
            }), e(this, "listeners", ()=>{
                this.player.on("play", ()=>{
                    this.toggleThumbContainer(!1, !0);
                }), this.player.on("seeked", ()=>{
                    this.toggleThumbContainer(!1);
                }), this.player.on("timeupdate", ()=>{
                    this.lastTime = this.player.media.currentTime;
                });
            }), e(this, "render", ()=>{
                this.elements.thumb.container = $("div", {
                    class: this.player.config.classNames.previewThumbnails.thumbContainer
                }), this.elements.thumb.imageContainer = $("div", {
                    class: this.player.config.classNames.previewThumbnails.imageContainer
                }), this.elements.thumb.container.appendChild(this.elements.thumb.imageContainer);
                const e = $("div", {
                    class: this.player.config.classNames.previewThumbnails.timeContainer
                });
                this.elements.thumb.time = $("span", {}, "00:00"), e.appendChild(this.elements.thumb.time), this.elements.thumb.imageContainer.appendChild(e), S.element(this.player.elements.progress) && this.player.elements.progress.appendChild(this.elements.thumb.container), this.elements.scrubbing.container = $("div", {
                    class: this.player.config.classNames.previewThumbnails.scrubbingContainer
                }), this.player.elements.wrapper.appendChild(this.elements.scrubbing.container);
            }), e(this, "destroy", ()=>{
                this.elements.thumb.container && this.elements.thumb.container.remove(), this.elements.scrubbing.container && this.elements.scrubbing.container.remove();
            }), e(this, "showImageAtCurrentTime", ()=>{
                this.mouseDown ? this.setScrubbingContainerSize() : this.setThumbContainerSizeAndPos();
                const e = this.thumbnails[0].frames.findIndex((e)=>this.seekTime >= e.startTime && this.seekTime <= e.endTime), t = e >= 0;
                let i = 0;
                this.mouseDown || this.toggleThumbContainer(t), t && (this.thumbnails.forEach((t, s)=>{
                    this.loadedImages.includes(t.frames[e].text) && (i = s);
                }), e !== this.showingThumb && (this.showingThumb = e, this.loadImage(i)));
            }), e(this, "loadImage", (e = 0)=>{
                const t = this.showingThumb, i = this.thumbnails[e], { urlPrefix: s } = i, n = i.frames[t], a = i.frames[t].text, l = s + a;
                if (this.currentImageElement && this.currentImageElement.dataset.filename === a) this.showImage(this.currentImageElement, n, e, t, a, !1), this.currentImageElement.dataset.index = t, this.removeOldImages(this.currentImageElement);
                else {
                    this.loadingImage && this.usingSprites && (this.loadingImage.onload = null);
                    const i = new Image;
                    i.src = l, i.dataset.index = t, i.dataset.filename = a, this.showingThumbFilename = a, this.player.debug.log(`Loading image: ${l}`), i.onload = ()=>this.showImage(i, n, e, t, a, !0), this.loadingImage = i, this.removeOldImages(i);
                }
            }), e(this, "showImage", (e, t, i, s, n, a = !0)=>{
                this.player.debug.log(`Showing thumb: ${n}. num: ${s}. qual: ${i}. newimg: ${a}`), this.setImageSizeAndOffset(e, t), a && (this.currentImageContainer.appendChild(e), this.currentImageElement = e, this.loadedImages.includes(n) || this.loadedImages.push(n)), this.preloadNearby(s, !0).then(this.preloadNearby(s, !1)).then(this.getHigherQuality(i, e, t, n));
            }), e(this, "removeOldImages", (e)=>{
                Array.from(this.currentImageContainer.children).forEach((t)=>{
                    if ("img" !== t.tagName.toLowerCase()) return;
                    const i = this.usingSprites ? 500 : 1e3;
                    if (t.dataset.index !== e.dataset.index && !t.dataset.deleting) {
                        t.dataset.deleting = !0;
                        const { currentImageContainer: e } = this;
                        setTimeout(()=>{
                            e.removeChild(t), this.player.debug.log(`Removing thumb: ${t.dataset.filename}`);
                        }, i);
                    }
                });
            }), e(this, "preloadNearby", (e, t = !0)=>new Promise((i)=>{
                    setTimeout(()=>{
                        const s = this.thumbnails[0].frames[e].text;
                        if (this.showingThumbFilename === s) {
                            let n;
                            n = t ? this.thumbnails[0].frames.slice(e) : this.thumbnails[0].frames.slice(0, e).reverse();
                            let a = !1;
                            n.forEach((e)=>{
                                const t = e.text;
                                if (t !== s && !this.loadedImages.includes(t)) {
                                    a = !0, this.player.debug.log(`Preloading thumb filename: ${t}`);
                                    const { urlPrefix: e } = this.thumbnails[0], s = e + t, n = new Image;
                                    n.src = s, n.onload = ()=>{
                                        this.player.debug.log(`Preloaded thumb filename: ${t}`), this.loadedImages.includes(t) || this.loadedImages.push(t), i();
                                    };
                                }
                            }), a || i();
                        }
                    }, 300);
                })), e(this, "getHigherQuality", (e, t, i, s)=>{
                if (e < this.thumbnails.length - 1) {
                    let n = t.naturalHeight;
                    this.usingSprites && (n = i.h), n < this.thumbContainerHeight && setTimeout(()=>{
                        this.showingThumbFilename === s && (this.player.debug.log(`Showing higher quality thumb for: ${s}`), this.loadImage(e + 1));
                    }, 300);
                }
            }), e(this, "toggleThumbContainer", (e = !1, t = !1)=>{
                const i = this.player.config.classNames.previewThumbnails.thumbContainerShown;
                this.elements.thumb.container.classList.toggle(i, e), !e && t && (this.showingThumb = null, this.showingThumbFilename = null);
            }), e(this, "toggleScrubbingContainer", (e = !1)=>{
                const t = this.player.config.classNames.previewThumbnails.scrubbingContainerShown;
                this.elements.scrubbing.container.classList.toggle(t, e), e || (this.showingThumb = null, this.showingThumbFilename = null);
            }), e(this, "determineContainerAutoSizing", ()=>{
                (this.elements.thumb.imageContainer.clientHeight > 20 || this.elements.thumb.imageContainer.clientWidth > 20) && (this.sizeSpecifiedInCSS = !0);
            }), e(this, "setThumbContainerSizeAndPos", ()=>{
                const { imageContainer: e } = this.elements.thumb;
                if (this.sizeSpecifiedInCSS) {
                    if (e.clientHeight > 20 && e.clientWidth < 20) {
                        const t = Math.floor(e.clientHeight * this.thumbAspectRatio);
                        e.style.width = `${t}px`;
                    } else if (e.clientHeight < 20 && e.clientWidth > 20) {
                        const t = Math.floor(e.clientWidth / this.thumbAspectRatio);
                        e.style.height = `${t}px`;
                    }
                } else {
                    const t = Math.floor(this.thumbContainerHeight * this.thumbAspectRatio);
                    e.style.height = `${this.thumbContainerHeight}px`, e.style.width = `${t}px`;
                }
                this.setThumbContainerPos();
            }), e(this, "setThumbContainerPos", ()=>{
                const e = this.player.elements.progress.getBoundingClientRect(), t = this.player.elements.container.getBoundingClientRect(), { container: i } = this.elements.thumb, s = t.left - e.left + 10, n = t.right - e.left - i.clientWidth - 10, a = this.mousePosX - e.left - i.clientWidth / 2, l = Ge(a, s, n);
                i.style.left = `${l}px`, i.style.setProperty("--preview-arrow-offset", a - l + "px");
            }), e(this, "setScrubbingContainerSize", ()=>{
                const { width: e, height: t } = et(this.thumbAspectRatio, {
                    width: this.player.media.clientWidth,
                    height: this.player.media.clientHeight
                });
                this.elements.scrubbing.container.style.width = `${e}px`, this.elements.scrubbing.container.style.height = `${t}px`;
            }), e(this, "setImageSizeAndOffset", (e, t)=>{
                if (!this.usingSprites) return;
                const i = this.thumbContainerHeight / t.h;
                e.style.height = e.naturalHeight * i + "px", e.style.width = e.naturalWidth * i + "px", e.style.left = `-${t.x * i}px`, e.style.top = `-${t.y * i}px`;
            }), this.player = t, this.thumbnails = [], this.loaded = !1, this.lastMouseMoveTime = Date.now(), this.mouseDown = !1, this.loadedImages = [], this.elements = {
                thumb: {},
                scrubbing: {}
            }, this.load();
        }
        get enabled() {
            return this.player.isHTML5 && this.player.isVideo && this.player.config.previewThumbnails.enabled;
        }
        get currentImageContainer() {
            return this.mouseDown ? this.elements.scrubbing.container : this.elements.thumb.imageContainer;
        }
        get usingSprites() {
            return Object.keys(this.thumbnails[0].frames[0]).includes("w");
        }
        get thumbAspectRatio() {
            return this.usingSprites ? this.thumbnails[0].frames[0].w / this.thumbnails[0].frames[0].h : this.thumbnails[0].width / this.thumbnails[0].height;
        }
        get thumbContainerHeight() {
            if (this.mouseDown) {
                const { height: e } = et(this.thumbAspectRatio, {
                    width: this.player.media.clientWidth,
                    height: this.player.media.clientHeight
                });
                return e;
            }
            return this.sizeSpecifiedInCSS ? this.elements.thumb.imageContainer.clientHeight : Math.floor(this.player.media.clientWidth / this.thumbAspectRatio / 4);
        }
        get currentImageElement() {
            return this.mouseDown ? this.currentScrubbingImageElement : this.currentThumbnailImageElement;
        }
        set currentImageElement(e) {
            this.mouseDown ? this.currentScrubbingImageElement = e : this.currentThumbnailImageElement = e;
        }
    }
    const it = {
        insertElements (e, t) {
            S.string(t) ? _(e, this.media, {
                src: t
            }) : S.array(t) && t.forEach((t)=>{
                _(e, this.media, t);
            });
        },
        change (e) {
            N(e, "sources.length") ? (de.cancelRequests.call(this), this.destroy.call(this, ()=>{
                this.options.quality = [], O(this.media), this.media = null, S.element(this.elements.container) && this.elements.container.removeAttribute("class");
                const { sources: t, type: i } = e, [{ provider: s = _e.html5, src: n }] = t, a = "html5" === s ? i : "div", l = "html5" === s ? {} : {
                    src: n
                };
                Object.assign(this, {
                    provider: s,
                    type: i,
                    supported: K.check(i, s, this.config.playsinline),
                    media: $(a, l)
                }), this.elements.container.appendChild(this.media), S.boolean(e.autoplay) && (this.config.autoplay = e.autoplay), this.isHTML5 && (this.config.crossorigin && this.media.setAttribute("crossorigin", ""), this.config.autoplay && this.media.setAttribute("autoplay", ""), S.empty(e.poster) || (this.poster = e.poster), this.config.loop.active && this.media.setAttribute("loop", ""), this.config.muted && this.media.setAttribute("muted", ""), this.config.playsinline && this.media.setAttribute("playsinline", "")), Fe.addStyleHook.call(this), this.isHTML5 && it.insertElements.call(this, "source", t), this.config.title = e.title, Xe.setup.call(this), this.isHTML5 && Object.keys(e).includes("tracks") && it.insertElements.call(this, "track", e.tracks), (this.isHTML5 || this.isEmbed && !this.supported.ui) && Fe.build.call(this), this.isHTML5 && this.media.load(), S.empty(e.previewThumbnails) || (Object.assign(this.config.previewThumbnails, e.previewThumbnails), this.previewThumbnails && this.previewThumbnails.loaded && (this.previewThumbnails.destroy(), this.previewThumbnails = null), this.config.previewThumbnails.enabled && (this.previewThumbnails = new tt(this))), this.fullscreen.update();
            }, !0)) : this.debug.warn("Invalid source format");
        }
    };
    class st {
        constructor(t, i){
            if (e(this, "play", ()=>S.function(this.media.play) ? (this.ads && this.ads.enabled && this.ads.managerPromise.then(()=>this.ads.play()).catch(()=>ie(this.media.play())), this.media.play()) : null), e(this, "pause", ()=>this.playing && S.function(this.media.pause) ? this.media.pause() : null), e(this, "togglePlay", (e)=>(S.boolean(e) ? e : !this.playing) ? this.play() : this.pause()), e(this, "stop", ()=>{
                this.isHTML5 ? (this.pause(), this.restart()) : S.function(this.media.stop) && this.media.stop();
            }), e(this, "restart", ()=>{
                this.currentTime = 0;
            }), e(this, "rewind", (e)=>{
                this.currentTime -= S.number(e) ? e : this.config.seekTime;
            }), e(this, "forward", (e)=>{
                this.currentTime += S.number(e) ? e : this.config.seekTime;
            }), e(this, "increaseVolume", (e)=>{
                const t = this.media.muted ? 0 : this.volume;
                this.volume = t + (S.number(e) ? e : 0);
            }), e(this, "decreaseVolume", (e)=>{
                this.increaseVolume(-e);
            }), e(this, "airplay", ()=>{
                K.airplay && this.media.webkitShowPlaybackTargetPicker();
            }), e(this, "toggleControls", (e)=>{
                if (this.supported.ui && !this.isAudio) {
                    const t = F(this.elements.container, this.config.classNames.hideControls), i = void 0 === e ? void 0 : !e, s = R(this.elements.container, this.config.classNames.hideControls, i);
                    if (s && S.array(this.config.controls) && this.config.controls.includes("settings") && !S.empty(this.config.settings) && Pe.toggleMenu.call(this, !1), s !== t) {
                        const e = s ? "controlshidden" : "controlsshown";
                        Z.call(this, this.media, e);
                    }
                    return !s;
                }
                return !1;
            }), e(this, "on", (e, t)=>{
                X.call(this, this.elements.container, e, t);
            }), e(this, "once", (e, t)=>{
                G.call(this, this.elements.container, e, t);
            }), e(this, "off", (e, t)=>{
                J(this.elements.container, e, t);
            }), e(this, "destroy", (e, t = !1)=>{
                if (!this.ready) return;
                const i = ()=>{
                    document.body.style.overflow = "", this.embed = null, t ? (Object.keys(this.elements).length && (O(this.elements.buttons.play), O(this.elements.captions), O(this.elements.controls), O(this.elements.wrapper), this.elements.buttons.play = null, this.elements.captions = null, this.elements.controls = null, this.elements.wrapper = null), S.function(e) && e()) : (ee.call(this), de.cancelRequests.call(this), q(this.elements.original, this.elements.container), Z.call(this, this.elements.original, "destroyed", !0), S.function(e) && e.call(this.elements.original), this.ready = !1, setTimeout(()=>{
                        this.elements = null, this.media = null;
                    }, 200));
                };
                this.stop(), clearTimeout(this.timers.loading), clearTimeout(this.timers.controls), clearTimeout(this.timers.resized), this.isHTML5 ? (Fe.toggleNativeControls.call(this, !0), i()) : this.isYouTube ? (clearInterval(this.timers.buffering), clearInterval(this.timers.playing), null !== this.embed && S.function(this.embed.destroy) && this.embed.destroy(), i()) : this.isVimeo && (null !== this.embed && this.embed.unload().then(i), setTimeout(i, 200));
            }), e(this, "supports", (e)=>K.mime.call(this, e)), this.timers = {}, this.ready = !1, this.loading = !1, this.failed = !1, this.touch = K.touch, this.media = t, S.string(this.media) && (this.media = document.querySelectorAll(this.media)), (window.jQuery && this.media instanceof jQuery || S.nodeList(this.media) || S.array(this.media)) && (this.media = this.media[0]), this.config = x({}, Le, st.defaults, i || {}, (()=>{
                try {
                    return JSON.parse(this.media.getAttribute("data-plyr-config"));
                } catch (e) {
                    return {};
                }
            })()), this.elements = {
                container: null,
                fullscreen: null,
                captions: null,
                buttons: {},
                display: {},
                progress: {},
                inputs: {},
                settings: {
                    popup: null,
                    menu: null,
                    panels: {},
                    buttons: {}
                }
            }, this.captions = {
                active: null,
                currentTrack: -1,
                meta: new WeakMap
            }, this.fullscreen = {
                active: !1
            }, this.options = {
                speed: [],
                quality: []
            }, this.debug = new De(this.config.debug), this.debug.log("Config", this.config), this.debug.log("Support", K), S.nullOrUndefined(this.media) || !S.element(this.media)) return void this.debug.error("Setup failed: no suitable element passed");
            if (this.media.plyr) return void this.debug.warn("Target already setup");
            if (!this.config.enabled) return void this.debug.error("Setup failed: disabled by config");
            if (!K.check().api) return void this.debug.error("Setup failed: no support");
            const s = this.media.cloneNode(!0);
            s.autoplay = !1, this.elements.original = s;
            const n = this.media.tagName.toLowerCase();
            let a = null, l = null;
            switch(n){
                case "div":
                    if (a = this.media.querySelector("iframe"), S.element(a)) {
                        if (l = Me(a.getAttribute("src")), this.provider = function(e) {
                            return /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(e) ? _e.youtube : /^https?:\/\/player.vimeo.com\/video\/\d{0,9}(?=\b|\/)/.test(e) ? _e.vimeo : null;
                        }(l.toString()), this.elements.container = this.media, this.media = a, this.elements.container.className = "", l.search.length) {
                            const e = [
                                "1",
                                "true"
                            ];
                            e.includes(l.searchParams.get("autoplay")) && (this.config.autoplay = !0), e.includes(l.searchParams.get("loop")) && (this.config.loop.active = !0), this.isYouTube ? (this.config.playsinline = e.includes(l.searchParams.get("playsinline")), this.config.youtube.hl = l.searchParams.get("hl")) : this.config.playsinline = !0;
                        }
                    } else this.provider = this.media.getAttribute(this.config.attributes.embed.provider), this.media.removeAttribute(this.config.attributes.embed.provider);
                    if (S.empty(this.provider) || !Object.values(_e).includes(this.provider)) return void this.debug.error("Setup failed: Invalid provider");
                    this.type = je;
                    break;
                case "video":
                case "audio":
                    this.type = n, this.provider = _e.html5, this.media.hasAttribute("crossorigin") && (this.config.crossorigin = !0), this.media.hasAttribute("autoplay") && (this.config.autoplay = !0), (this.media.hasAttribute("playsinline") || this.media.hasAttribute("webkit-playsinline")) && (this.config.playsinline = !0), this.media.hasAttribute("muted") && (this.config.muted = !0), this.media.hasAttribute("loop") && (this.config.loop.active = !0);
                    break;
                default:
                    return void this.debug.error("Setup failed: unsupported type");
            }
            this.supported = K.check(this.type, this.provider), this.supported.api ? (this.eventListeners = [], this.listeners = new Ve(this), this.storage = new we(this), this.media.plyr = this, S.element(this.elements.container) || (this.elements.container = $("div"), L(this.media, this.elements.container)), Fe.migrateStyles.call(this), Fe.addStyleHook.call(this), Xe.setup.call(this), this.config.debug && X.call(this, this.elements.container, this.config.events.join(" "), (e)=>{
                this.debug.log(`event: ${e.type}`);
            }), this.fullscreen = new He(this), (this.isHTML5 || this.isEmbed && !this.supported.ui) && Fe.build.call(this), this.listeners.container(), this.listeners.global(), this.config.ads.enabled && (this.ads = new Je(this)), this.isHTML5 && this.config.autoplay && this.once("canplay", ()=>ie(this.play())), this.lastSeekTime = 0, this.config.previewThumbnails.enabled && (this.previewThumbnails = new tt(this))) : this.debug.error("Setup failed: no support");
        }
        get isHTML5() {
            return this.provider === _e.html5;
        }
        get isEmbed() {
            return this.isYouTube || this.isVimeo;
        }
        get isYouTube() {
            return this.provider === _e.youtube;
        }
        get isVimeo() {
            return this.provider === _e.vimeo;
        }
        get isVideo() {
            return this.type === je;
        }
        get isAudio() {
            return this.type === Oe;
        }
        get playing() {
            return Boolean(this.ready && !this.paused && !this.ended);
        }
        get paused() {
            return Boolean(this.media.paused);
        }
        get stopped() {
            return Boolean(this.paused && 0 === this.currentTime);
        }
        get ended() {
            return Boolean(this.media.ended);
        }
        set currentTime(e) {
            if (!this.duration) return;
            const t = S.number(e) && e > 0;
            this.media.currentTime = t ? Math.min(e, this.duration) : 0, this.debug.log(`Seeking to ${this.currentTime} seconds`);
        }
        get currentTime() {
            return Number(this.media.currentTime);
        }
        get buffered() {
            const { buffered: e } = this.media;
            return S.number(e) ? e : e && e.length && this.duration > 0 ? e.end(0) / this.duration : 0;
        }
        get seeking() {
            return Boolean(this.media.seeking);
        }
        get duration() {
            const e = parseFloat(this.config.duration), t = (this.media || {}).duration, i = S.number(t) && t !== 1 / 0 ? t : 0;
            return e || i;
        }
        set volume(e) {
            let t = e;
            S.string(t) && (t = Number(t)), S.number(t) || (t = this.storage.get("volume")), S.number(t) || ({ volume: t } = this.config), t > 1 && (t = 1), t < 0 && (t = 0), this.config.volume = t, this.media.volume = t, !S.empty(e) && this.muted && t > 0 && (this.muted = !1);
        }
        get volume() {
            return Number(this.media.volume);
        }
        set muted(e) {
            let t = e;
            S.boolean(t) || (t = this.storage.get("muted")), S.boolean(t) || (t = this.config.muted), this.config.muted = t, this.media.muted = t;
        }
        get muted() {
            return Boolean(this.media.muted);
        }
        get hasAudio() {
            return !this.isHTML5 || !!this.isAudio || Boolean(this.media.mozHasAudio) || Boolean(this.media.webkitAudioDecodedByteCount) || Boolean(this.media.audioTracks && this.media.audioTracks.length);
        }
        set speed(e) {
            let t = null;
            S.number(e) && (t = e), S.number(t) || (t = this.storage.get("speed")), S.number(t) || (t = this.config.speed.selected);
            const { minimumSpeed: i, maximumSpeed: s } = this;
            t = Ge(t, i, s), this.config.speed.selected = t, setTimeout(()=>{
                this.media && (this.media.playbackRate = t);
            }, 0);
        }
        get speed() {
            return Number(this.media.playbackRate);
        }
        get minimumSpeed() {
            return this.isYouTube ? Math.min(...this.options.speed) : this.isVimeo ? .5 : .0625;
        }
        get maximumSpeed() {
            return this.isYouTube ? Math.max(...this.options.speed) : this.isVimeo ? 2 : 16;
        }
        set quality(e) {
            const t = this.config.quality, i = this.options.quality;
            if (!i.length) return;
            let s = [
                !S.empty(e) && Number(e),
                this.storage.get("quality"),
                t.selected,
                t.default
            ].find(S.number), n = !0;
            if (!i.includes(s)) {
                const e = ne(i, s);
                this.debug.warn(`Unsupported quality option: ${s}, using ${e} instead`), s = e, n = !1;
            }
            t.selected = s, this.media.quality = s, n && this.storage.set({
                quality: s
            });
        }
        get quality() {
            return this.media.quality;
        }
        set loop(e) {
            const t = S.boolean(e) ? e : this.config.loop.active;
            this.config.loop.active = t, this.media.loop = t;
        }
        get loop() {
            return Boolean(this.media.loop);
        }
        set source(e) {
            it.change.call(this, e);
        }
        get source() {
            return this.media.currentSrc;
        }
        get download() {
            const { download: e } = this.config.urls;
            return S.url(e) ? e : this.source;
        }
        set download(e) {
            S.url(e) && (this.config.urls.download = e, Pe.setDownloadUrl.call(this));
        }
        set poster(e) {
            this.isVideo ? Fe.setPoster.call(this, e, !1).catch(()=>{}) : this.debug.warn("Poster can only be set for video");
        }
        get poster() {
            return this.isVideo ? this.media.getAttribute("poster") || this.media.getAttribute("data-poster") : null;
        }
        get ratio() {
            if (!this.isVideo) return null;
            const e = oe(ce.call(this));
            return S.array(e) ? e.join(":") : e;
        }
        set ratio(e) {
            this.isVideo ? S.string(e) && re(e) ? (this.config.ratio = oe(e), ue.call(this)) : this.debug.error(`Invalid aspect ratio specified (${e})`) : this.debug.warn("Aspect ratio can only be set for video");
        }
        set autoplay(e) {
            this.config.autoplay = S.boolean(e) ? e : this.config.autoplay;
        }
        get autoplay() {
            return Boolean(this.config.autoplay);
        }
        toggleCaptions(e) {
            xe.toggle.call(this, e, !1);
        }
        set currentTrack(e) {
            xe.set.call(this, e, !1), xe.setup.call(this);
        }
        get currentTrack() {
            const { toggled: e, currentTrack: t } = this.captions;
            return e ? t : -1;
        }
        set language(e) {
            xe.setLanguage.call(this, e, !1);
        }
        get language() {
            return (xe.getCurrentTrack.call(this) || {}).language;
        }
        set pip(e) {
            if (!K.pip) return;
            const t = S.boolean(e) ? e : !this.pip;
            S.function(this.media.webkitSetPresentationMode) && this.media.webkitSetPresentationMode(t ? Ie : $e), S.function(this.media.requestPictureInPicture) && (!this.pip && t ? this.media.requestPictureInPicture() : this.pip && !t && document.exitPictureInPicture());
        }
        get pip() {
            return K.pip ? S.empty(this.media.webkitPresentationMode) ? this.media === document.pictureInPictureElement : this.media.webkitPresentationMode === Ie : null;
        }
        setPreviewThumbnails(e) {
            this.previewThumbnails && this.previewThumbnails.loaded && (this.previewThumbnails.destroy(), this.previewThumbnails = null), Object.assign(this.config.previewThumbnails, e), this.config.previewThumbnails.enabled && (this.previewThumbnails = new tt(this));
        }
        static supported(e, t) {
            return K.check(e, t);
        }
        static loadSprite(e, t) {
            return ke(e, t);
        }
        static setup(e, t = {}) {
            let i = null;
            return S.string(e) ? i = Array.from(document.querySelectorAll(e)) : S.nodeList(e) ? i = Array.from(e) : S.array(e) && (i = e.filter(S.element)), S.empty(i) ? null : i.map((e)=>new st(e, t));
        }
    }
    var nt;
    return st.defaults = (nt = Le, JSON.parse(JSON.stringify(nt))), st;
});

});


parcelRequire.register("hnrNW", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $ca6a270bb61d31b0$export$b3890eb0ae9dca99; }, function (v) { return $ca6a270bb61d31b0$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $ca6a270bb61d31b0$export$f8436702749526f9; }, function (v) { return $ca6a270bb61d31b0$export$f8436702749526f9 = v; });
var $ca6a270bb61d31b0$export$b3890eb0ae9dca99;
var $ca6a270bb61d31b0$export$f8436702749526f9;
var $ca6a270bb61d31b0$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", {
        staticClass: "w-10/12 mx-auto"
    }, [
        _c("div", {
            staticClass: "flex flex-col space-y-16 lg:flex-row lg:space-x-20 lg:space-y-0"
        }, [
            _c("div", {
                staticClass: "lg:w-6/12"
            }, [
                _c("h2", {
                    staticClass: "mb-10 font-serif text-3xl lg:leading-tight lg:text-5xl"
                }, [
                    _vm._v("\n        " + _vm._s(_vm.servicesData.title) + "\n      ")
                ]),
                _vm._v(" "),
                _c("ul", {
                    staticClass: "flex flex-col mb-10 space-y-5 lg:space-x-10 lg:flex-row lg:space-y-0"
                }, _vm._l(_vm.servicesData.tabs, function(tab, index) {
                    return _c("li", {
                        key: index
                    }, [
                        _c("a", {
                            class: "text-base tracking-wider uppercase btn-link " + (index === _vm.activeTab ? "is-line" : "opacity-50 hover:opacity-100"),
                            attrs: {
                                "href": "#"
                            },
                            on: {
                                "click": function($event) {
                                    $event.preventDefault();
                                    $event.stopPropagation();
                                    return _vm.setTab(index);
                                }
                            }
                        }, [
                            _vm._v(_vm._s(tab.title))
                        ])
                    ]);
                }), 0),
                _vm._v(" "),
                _c("transition", {
                    attrs: {
                        "name": "tab"
                    }
                }, [
                    _vm.showTab ? [
                        _c("div", [
                            _c("div", {
                                staticClass: "font-light post lg:max-w-lg",
                                domProps: {
                                    "innerHTML": _vm._s(_vm.servicesData.tabs[_vm.activeTab].description)
                                }
                            }),
                            _vm._v(" "),
                            _vm.servicesData.tabs[_vm.activeTab].button.label && _vm.servicesData.tabs[_vm.activeTab].button.link ? _c("a", {
                                staticClass: "inline-block mt-10 btn btn-danger",
                                attrs: {
                                    "href": _vm.servicesData.tabs[_vm.activeTab].button.link
                                }
                            }, [
                                _vm._v("\n              " + _vm._s(_vm.servicesData.tabs[_vm.activeTab].button.label) + "\n            ")
                            ]) : _vm._e()
                        ])
                    ] : _vm._e()
                ], 2)
            ], 1),
            _vm._v(" "),
            _c("div", {
                staticClass: "lg:w-6/12"
            }, [
                _c("div", {
                    staticClass: "relative group"
                }, [
                    _c("div", {
                        staticClass: "aspect-ratio-4/3"
                    }),
                    _vm._v(" "),
                    _c("div", {
                        staticClass: "absolute top-0 left-0 z-10 w-full h-full"
                    }, [
                        _c("div", {
                            staticClass: "absolute top-0 left-0 z-0 w-full h-full -m-5 lg:-m-10 bg-brand-500"
                        }),
                        _vm._v(" "),
                        !_vm.servicesData.tabs[_vm.activeTab].use_video ? _c("img", {
                            staticClass: "absolute top-0 left-0 z-10 object-cover object-center w-full h-full lazy",
                            attrs: {
                                "data-src": _vm.servicesData.tabs[_vm.activeTab].image.sizes.medium
                            }
                        }) : _vm._e(),
                        _vm._v(" "),
                        _c("transition", {
                            attrs: {
                                "name": "tab"
                            }
                        }, [
                            _vm.servicesData.tabs[_vm.activeTab].use_video && _vm.showTab ? [
                                _c("div", {
                                    staticClass: "w-full h-full plyr__video-embed",
                                    attrs: {
                                        "id": "player"
                                    }
                                }, [
                                    _c("iframe", {
                                        staticClass: "absolute top-0 left-0 z-10 w-full h-full",
                                        attrs: {
                                            "src": "https://www.youtube.com/embed/" + _vm.youtubeParser(_vm.servicesData.tabs[_vm.activeTab].video) + "?origin=https://plyr.io&iv_load_policy=3&listType=user_uploads&controls=0&fs=0&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1",
                                            "allowfullscreen": "",
                                            "allowtransparency": "",
                                            "allow": "autoplay"
                                        }
                                    })
                                ])
                            ] : _vm._e()
                        ], 2)
                    ], 1)
                ])
            ])
        ])
    ]);
};
var $ca6a270bb61d31b0$var$staticRenderFns = [];
$ca6a270bb61d31b0$export$b3890eb0ae9dca99 = $ca6a270bb61d31b0$var$render;
$ca6a270bb61d31b0$export$f8436702749526f9 = $ca6a270bb61d31b0$var$staticRenderFns;

});

parcelRequire.register("96BGd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a11e70440ad3d6b$export$2e2bcd8739ae039; });
let $6a11e70440ad3d6b$var$NOOP = ()=>{};
var $6a11e70440ad3d6b$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire.register("81mWS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $5d7037d6666557a4$export$2e2bcd8739ae039; });

var $crpPU = parcelRequire("crpPU");
var $5d7037d6666557a4$var$scriptExports = {
    data () {
        return {
            imgEnvelope: (/*@__PURE__*/$parcel$interopDefault($crpPU)),
            popupData: window.popupSide,
            toggled: true
        };
    },
    mounted () {
        if (this.$cookies.get("popup-side-id")) this.checkLastModified();
        this.$cookies.set("popup-side-id", this.popupData.id);
        if (this.popupData.apply_to_page) this.init();
    },
    methods: {
        init () {
            if (!this.popupData.enable) this.$cookies.remove("popup-side-toggled");
            else this.showPopup();
        },
        checkLastModified () {
            if (this.$cookies.get("popup-side-id") !== this.popupData.id) this.$cookies.remove("popup-side-toggled");
        },
        close () {
            this.toggled = true;
            this.$cookies.set("popup-side-toggled", true);
        },
        showPopup () {
            if (this.$cookies.get("popup-side-toggled")) this.toggled = true;
            else setTimeout(()=>{
                this.toggled = false;
            }, 1000); // 1000
        }
    }
};
var $5d7037d6666557a4$var$options = typeof $5d7037d6666557a4$var$scriptExports === "function" ? $5d7037d6666557a4$var$scriptExports.options : $5d7037d6666557a4$var$scriptExports;
var $5d7037d6666557a4$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $5d7037d6666557a4$var$options;

});
parcelRequire.register("crpPU", function(module, exports) {


module.exports = (parcelRequire("5waPY")).getBundleURL("gjvsV") + (parcelRequire("gm4sb")).resolve("kzW04");

});


parcelRequire.register("eztfx", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $a9bb05f46de037d0$export$b3890eb0ae9dca99; }, function (v) { return $a9bb05f46de037d0$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $a9bb05f46de037d0$export$f8436702749526f9; }, function (v) { return $a9bb05f46de037d0$export$f8436702749526f9 = v; });
var $a9bb05f46de037d0$export$b3890eb0ae9dca99;
var $a9bb05f46de037d0$export$f8436702749526f9;
var $a9bb05f46de037d0$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("transition", {
        attrs: {
            "name": "popup-side",
            "appear": ""
        }
    }, [
        !_vm.toggled ? _c("div", {
            staticClass: "fixed bottom-0 right-0 z-40 w-full p-5",
            class: _vm.popupData.type !== "image" ? "lg:max-w-md" : "lg:max-w-xl"
        }, [
            _c("div", {
                staticClass: "flex overflow-hidden rounded-md shadow-lg"
            }, [
                _vm.popupData.type === "image" ? _c("div", {
                    staticClass: "relative w-44"
                }, [
                    _c("img", {
                        staticClass: "absolute top-0 left-0 object-cover object-center w-full h-full",
                        attrs: {
                            "src": _vm.popupData.image
                        }
                    })
                ]) : _vm._e(),
                _vm._v(" "),
                _c("div", {
                    staticClass: "relative w-full p-5 text-white lg:p-10 bg-brand-500"
                }, [
                    _c("button", {
                        staticClass: "absolute top-0 right-0 m-6 text-2xl transition duration-200 opacity-60 hover:opacity-100",
                        on: {
                            "click": _vm.close
                        }
                    }, [
                        _c("i", {
                            staticClass: "fal fa-times"
                        })
                    ]),
                    _vm._v(" "),
                    _c("p", {
                        staticClass: "lg:text-xl"
                    }, [
                        _vm._v("\n          " + _vm._s(_vm.popupData.message) + "\n        ")
                    ]),
                    _vm._v(" "),
                    _vm.popupData.action.enable ? _c("div", {
                        staticClass: "mt-5"
                    }, [
                        _c("a", {
                            staticClass: "btn btn-danger",
                            attrs: {
                                "href": _vm.popupData.action.link
                            }
                        }, [
                            _vm._v("\n            " + _vm._s(_vm.popupData.action.label) + "\n          ")
                        ])
                    ]) : _vm._e(),
                    _vm._v(" "),
                    _vm.popupData.type === "subscribe" ? _c("div", {
                        staticClass: "text-right"
                    }, [
                        _c("img", {
                            staticClass: "inline-block -mt-20 -mb-28 w-28",
                            attrs: {
                                "src": _vm.imgEnvelope
                            }
                        })
                    ]) : _vm._e()
                ])
            ])
        ]) : _vm._e()
    ]);
};
var $a9bb05f46de037d0$var$staticRenderFns = [];
$a9bb05f46de037d0$export$b3890eb0ae9dca99 = $a9bb05f46de037d0$var$render;
$a9bb05f46de037d0$export$f8436702749526f9 = $a9bb05f46de037d0$var$staticRenderFns;

});

parcelRequire.register("83H9q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5de0136c570608d4$export$2e2bcd8739ae039; });
let $5de0136c570608d4$var$NOOP = ()=>{};
var $5de0136c570608d4$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire.register("jAgsj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $e41e24dfd8d31b9e$export$2e2bcd8739ae039; });
var $e41e24dfd8d31b9e$var$scriptExports = {
    data () {
        return {
            popupData: window.popupTop,
            toggled: true
        };
    },
    mounted () {
        if (this.$cookies.get("popup-top-id")) this.checkLastModified();
        this.$cookies.set("popup-top-id", this.popupData.id);
        this.init();
    },
    methods: {
        init () {
            if (!this.popupData.enable) this.$cookies.remove("popup-top-toggled");
            else this.showPopup();
        },
        checkLastModified () {
            if (this.$cookies.get("popup-top-id") !== this.popupData.id) this.$cookies.remove("popup-top-toggled");
        },
        close () {
            this.toggled = true;
            this.$cookies.set("popup-top-toggled", true);
            this.hide();
        },
        hide () {
            this.toggled = true;
            document.querySelector(".js-navigation").classList.remove("mt-nav");
            document.querySelector("body").classList.remove("lg:pt-48");
            document.querySelector("body").classList.add("lg:pt-28");
        },
        showPopup () {
            if (this.$cookies.get("popup-top-toggled")) this.toggled = true;
            else {
                this.toggled = false;
                document.querySelector(".js-navigation").classList.add("mt-nav");
                document.querySelector("body").classList.add("lg:pt-48");
                document.querySelector("body").classList.remove("lg:pt-28");
            }
        }
    }
};
var $e41e24dfd8d31b9e$var$options = typeof $e41e24dfd8d31b9e$var$scriptExports === "function" ? $e41e24dfd8d31b9e$var$scriptExports.options : $e41e24dfd8d31b9e$var$scriptExports;
var $e41e24dfd8d31b9e$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $e41e24dfd8d31b9e$var$options;

});

parcelRequire.register("7iGZd", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $550b8f095b6972a3$export$b3890eb0ae9dca99; }, function (v) { return $550b8f095b6972a3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $550b8f095b6972a3$export$f8436702749526f9; }, function (v) { return $550b8f095b6972a3$export$f8436702749526f9 = v; });
var $550b8f095b6972a3$export$b3890eb0ae9dca99;
var $550b8f095b6972a3$export$f8436702749526f9;
var $550b8f095b6972a3$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("transition", {
        attrs: {
            "name": "popup-top",
            "mode": "in-out"
        }
    }, [
        !_vm.toggled ? _c("div", {
            staticClass: "fixed top-0 left-0 z-40 hidden w-full h-20 px-5 text-white bg-danger-500 lg:block"
        }, [
            _c("button", {
                staticClass: "absolute top-0 right-0 m-6 text-2xl transition duration-200 opacity-60 hover:opacity-100",
                on: {
                    "click": _vm.close
                }
            }, [
                _c("i", {
                    staticClass: "fal fa-times"
                })
            ]),
            _vm._v(" "),
            _c("div", {
                staticClass: "flex justify-center h-full"
            }, [
                _c("div", {
                    staticClass: "flex items-center mx-auto space-x-5 lg:max-w-5xl"
                }, [
                    _c("p", {
                        staticClass: "text-xl font-light opacity-80"
                    }, [
                        _vm._v("\n          " + _vm._s(_vm.popupData.message) + "\n        ")
                    ]),
                    _vm._v(" "),
                    _vm.popupData.action.enable ? _c("div", {
                        staticClass: "flex-shrink-0"
                    }, [
                        _c("a", {
                            staticClass: "btn btn-default",
                            attrs: {
                                "href": _vm.popupData.action.link
                            }
                        }, [
                            _vm._v("\n            " + _vm._s(_vm.popupData.action.label) + "\n          ")
                        ])
                    ]) : _vm._e()
                ])
            ])
        ]) : _vm._e()
    ]);
};
var $550b8f095b6972a3$var$staticRenderFns = [];
$550b8f095b6972a3$export$b3890eb0ae9dca99 = $550b8f095b6972a3$var$render;
$550b8f095b6972a3$export$f8436702749526f9 = $550b8f095b6972a3$var$staticRenderFns;

});

parcelRequire.register("2BQGv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e67e789110d8d94$export$2e2bcd8739ae039; });
let $1e67e789110d8d94$var$NOOP = ()=>{};
var $1e67e789110d8d94$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire.register("irt6H", function(module, exports) {
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */ (function(global, factory) {
    if (typeof define === "function" && define.amd) define(factory);
    else if (0, module.exports) module.exports = factory();
    else global.numeral = factory();
})(module.exports, function() {
    /************************************
        Variables
    ************************************/ var numeral, _, VERSION = "2.0.6", formats = {}, locales = {}, defaults = {
        currentLocale: "en",
        zeroFormat: null,
        nullFormat: null,
        defaultFormat: "0,0",
        scalePercentBy100: true
    }, options = {
        currentLocale: defaults.currentLocale,
        zeroFormat: defaults.zeroFormat,
        nullFormat: defaults.nullFormat,
        defaultFormat: defaults.defaultFormat,
        scalePercentBy100: defaults.scalePercentBy100
    };
    /************************************
        Constructors
    ************************************/ // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;
        this._value = number;
    }
    numeral = function(input) {
        var value, kind, unformatFunction, regexp;
        if (numeral.isNumeral(input)) value = input.value();
        else if (input === 0 || typeof input === "undefined") value = 0;
        else if (input === null || _.isNaN(input)) value = null;
        else if (typeof input === "string") {
            if (options.zeroFormat && input === options.zeroFormat) value = 0;
            else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, "").length) value = null;
            else {
                for(kind in formats){
                    regexp = typeof formats[kind].regexps.unformat === "function" ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;
                        break;
                    }
                }
                unformatFunction = unformatFunction || numeral._.stringToNumber;
                value = unformatFunction(input);
            }
        } else value = Number(input) || null;
        return new Numeral(input, value);
    };
    // version number
    numeral.version = VERSION;
    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };
    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale], negP = false, optDec = false, leadingCount = 0, abbr = "", trillion = 1000000000000, billion = 1000000000, million = 1000000, thousand = 1000, decimal = "", neg = false, abbrForce, abs, min, max, power, int, precision, signed, thousands, output;
            // make sure we never format a null value
            value = value || 0;
            abs = Math.abs(value);
            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, "(")) {
                negP = true;
                format = format.replace(/[\(|\)]/g, "");
            } else if (numeral._.includes(format, "+") || numeral._.includes(format, "-")) {
                signed = numeral._.includes(format, "+") ? format.indexOf("+") : value < 0 ? format.indexOf("-") : -1;
                format = format.replace(/[\+|\-]/g, "");
            }
            // see if abbreviation is wanted
            if (numeral._.includes(format, "a")) {
                abbrForce = format.match(/a(k|m|b|t)?/);
                abbrForce = abbrForce ? abbrForce[1] : false;
                // check for space before abbreviation
                if (numeral._.includes(format, " a")) abbr = " ";
                format = format.replace(new RegExp(abbr + "a[kmbt]?"), "");
                if (abs >= trillion && !abbrForce || abbrForce === "t") {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === "b") {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === "m") {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === "k") {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }
            // check for optional decimals
            if (numeral._.includes(format, "[.]")) {
                optDec = true;
                format = format.replace("[.]", ".");
            }
            // break number and format
            int = value.toString().split(".")[0];
            precision = format.split(".")[1];
            thousands = format.indexOf(",");
            leadingCount = (format.split(".")[0].split(",")[0].match(/0/g) || []).length;
            if (precision) {
                if (numeral._.includes(precision, "[")) {
                    precision = precision.replace("]", "");
                    precision = precision.split("[");
                    decimal = numeral._.toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
                } else decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                int = decimal.split(".")[0];
                if (numeral._.includes(decimal, ".")) decimal = locale.delimiters.decimal + decimal.split(".")[1];
                else decimal = "";
                if (optDec && Number(decimal.slice(1)) === 0) decimal = "";
            } else int = numeral._.toFixed(value, 0, roundingFunction);
            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);
                switch(abbr){
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }
            // format number
            if (numeral._.includes(int, "-")) {
                int = int.slice(1);
                neg = true;
            }
            if (int.length < leadingCount) for(var i = leadingCount - int.length; i > 0; i--)int = "0" + int;
            if (thousands > -1) int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + locale.delimiters.thousands);
            if (format.indexOf(".") === 0) int = "";
            output = int + decimal + (abbr ? abbr : "");
            if (negP) output = (negP && neg ? "(" : "") + output + (negP && neg ? ")" : "");
            else {
                if (signed >= 0) output = signed === 0 ? (neg ? "-" : "+") + output : output + (neg ? "-" : "+");
                else if (neg) output = "-" + output;
            }
            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale], stringOriginal = string, abbreviations = {
                thousand: 3,
                million: 6,
                billion: 9,
                trillion: 12
            }, abbreviation, value, i, regexp;
            if (options.zeroFormat && string === options.zeroFormat) value = 0;
            else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, "").length) value = null;
            else {
                value = 1;
                if (locale.delimiters.decimal !== ".") string = string.replace(/\./g, "").replace(locale.delimiters.decimal, ".");
                for(abbreviation in abbreviations){
                    regexp = new RegExp("[^a-zA-Z]" + locale.abbreviations[abbreviation] + "(?:\\)|(\\" + locale.currency.symbol + ")?(?:\\))?)?$");
                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }
                // check for negative number
                value *= (string.split("-").length + Math.min(string.split("(").length - 1, string.split(")").length - 1)) % 2 ? 1 : -1;
                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, "");
                value *= Number(string);
            }
            return value;
        },
        isNaN: function(value) {
            return typeof value === "number" && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/ ) {
            if (this === null) throw new TypeError("Array.prototype.reduce called on null or undefined");
            if (typeof callback !== "function") throw new TypeError(callback + " is not a function");
            var t = Object(array), len = t.length >>> 0, k = 0, value;
            if (arguments.length === 3) value = arguments[2];
            else {
                while(k < len && !(k in t))k++;
                if (k >= len) throw new TypeError("Reduce of empty array with no initial value");
                value = t[k++];
            }
            for(; k < len; k++)if (k in t) value = callback(value, t[k], k, t);
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */ multiplier: function(x) {
            var parts = x.toString().split(".");
            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */ correctionFactor: function() {
            var args = Array.prototype.slice.call(arguments);
            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */ toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split("."), minDecimals = maxDecimals - (optionals || 0), boundedPrecision, optionalsRegExp, power, output;
            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            else boundedPrecision = minDecimals;
            power = Math.pow(10, boundedPrecision);
            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + "e+" + boundedPrecision) / power).toFixed(boundedPrecision);
            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp("\\.?0{1," + (optionals - (maxDecimals - boundedPrecision)) + "}$");
                output = output.replace(optionalsRegExp, "");
            }
            return output;
        }
    };
    // avaliable options
    numeral.options = options;
    // avaliable formats
    numeral.formats = formats;
    // avaliable formats
    numeral.locales = locales;
    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) options.currentLocale = key.toLowerCase();
        return options.currentLocale;
    };
    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) return locales[options.currentLocale];
        key = key.toLowerCase();
        if (!locales[key]) throw new Error("Unknown locale : " + key);
        return locales[key];
    };
    numeral.reset = function() {
        for(var property in defaults)options[property] = defaults[property];
    };
    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof format === "string" ? format : null;
    };
    numeral.nullFormat = function(format) {
        options.nullFormat = typeof format === "string" ? format : null;
    };
    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof format === "string" ? format : "0.0";
    };
    numeral.register = function(type, name, format) {
        name = name.toLowerCase();
        if (this[type + "s"][name]) throw new TypeError(name + " " + type + " already registered.");
        this[type + "s"][name] = format;
        return format;
    };
    numeral.validate = function(val, culture) {
        var _decimalSep, _thousandSep, _currSymbol, _valArray, _abbrObj, _thousandRegEx, localeData, temp;
        //coerce val to string
        if (typeof val !== "string") {
            val += "";
            if (console.warn) console.warn("Numeral.js: Value is not string. It has been co-erced to: ", val);
        }
        //trim whitespaces from either sides
        val = val.trim();
        //if val is just digits return true
        if (!!val.match(/^\d+$/)) return true;
        //if val is empty return false
        if (val === "") return false;
        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }
        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === ".") _thousandSep = "\\.";
        else _thousandSep = localeData.delimiters.thousands;
        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) return false;
        }
        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) return false;
        }
        _thousandRegEx = new RegExp(_thousandSep + "{2}");
        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) return false;
            else {
                if (_valArray.length < 2) return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx);
                else {
                    if (_valArray[0].length === 1) return !!_valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                    else return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                }
            }
        }
        return false;
    };
    /************************************
        Numeral Prototype
    ************************************/ numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value, format = inputString || options.defaultFormat, kind, output, formatFunction;
            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;
            // format based on value
            if (value === 0 && options.zeroFormat !== null) output = options.zeroFormat;
            else if (value === null && options.nullFormat !== null) output = options.nullFormat;
            else {
                for(kind in formats)if (format.match(formats[kind].regexps.format)) {
                    formatFunction = formats[kind].format;
                    break;
                }
                formatFunction = formatFunction || numeral._.numberToFormat;
                output = formatFunction(value, format, roundingFunction);
            }
            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);
            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback, 0) / corrFactor;
            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }
            this._value = _.reduce([
                value
            ], cback, Math.round(this._value * corrFactor)) / corrFactor;
            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback, 1);
            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback);
            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };
    /************************************
        Default Locale && Format
    ************************************/ numeral.register("locale", "en", {
        delimiters: {
            thousands: ",",
            decimal: "."
        },
        abbreviations: {
            thousand: "k",
            million: "m",
            billion: "b",
            trillion: "t"
        },
        ordinal: function(number) {
            var b = number % 10;
            return ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
        },
        currency: {
            symbol: "$"
        }
    });
    (function() {
        numeral.register("format", "bps", {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, " BPS") ? " " : "", output;
                value = value * 10000;
                // check for space before BPS
                format = format.replace(/\s?BPS/, "");
                output = numeral._.numberToFormat(value, format, roundingFunction);
                if (numeral._.includes(output, ")")) {
                    output = output.split("");
                    output.splice(-1, 0, space + "BPS");
                    output = output.join("");
                } else output = output + space + "BPS";
                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
    })();
    (function() {
        var decimal = {
            base: 1000,
            suffixes: [
                "B",
                "KB",
                "MB",
                "GB",
                "TB",
                "PB",
                "EB",
                "ZB",
                "YB"
            ]
        }, binary = {
            base: 1024,
            suffixes: [
                "B",
                "KiB",
                "MiB",
                "GiB",
                "TiB",
                "PiB",
                "EiB",
                "ZiB",
                "YiB"
            ]
        };
        var allSuffixes = decimal.suffixes.concat(binary.suffixes.filter(function(item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join("|");
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = "(" + unformatRegex.replace("B", "B(?!PS)") + ")";
        numeral.register("format", "bytes", {
            regexps: {
                format: /([0\s]i?b)/,
                unformat: new RegExp(unformatRegex)
            },
            format: function(value, format, roundingFunction) {
                var output, bytes = numeral._.includes(format, "ib") ? binary : decimal, suffix = numeral._.includes(format, " b") || numeral._.includes(format, " ib") ? " " : "", power, min, max;
                // check for space before
                format = format.replace(/\s?i?b/, "");
                for(power = 0; power <= bytes.suffixes.length; power++){
                    min = Math.pow(bytes.base, power);
                    max = Math.pow(bytes.base, power + 1);
                    if (value === null || value === 0 || value >= min && value < max) {
                        suffix += bytes.suffixes[power];
                        if (min > 0) value = value / min;
                        break;
                    }
                }
                output = numeral._.numberToFormat(value, format, roundingFunction);
                return output + suffix;
            },
            unformat: function(string) {
                var value = numeral._.stringToNumber(string), power, bytesMultiplier;
                if (value) {
                    for(power = decimal.suffixes.length - 1; power >= 0; power--){
                        if (numeral._.includes(string, decimal.suffixes[power])) {
                            bytesMultiplier = Math.pow(decimal.base, power);
                            break;
                        }
                        if (numeral._.includes(string, binary.suffixes[power])) {
                            bytesMultiplier = Math.pow(binary.base, power);
                            break;
                        }
                    }
                    value *= bytesMultiplier || 1;
                }
                return value;
            }
        });
    })();
    (function() {
        numeral.register("format", "currency", {
            regexps: {
                format: /(\$)/
            },
            format: function(value, format, roundingFunction) {
                var locale = numeral.locales[numeral.options.currentLocale], symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                }, output, symbol, i;
                // strip format of spaces and $
                format = format.replace(/\s?\$\s?/, "");
                // format the number
                output = numeral._.numberToFormat(value, format, roundingFunction);
                // update the before and after based on value
                if (value >= 0) {
                    symbols.before = symbols.before.replace(/[\-\(]/, "");
                    symbols.after = symbols.after.replace(/[\-\)]/, "");
                } else if (value < 0 && !numeral._.includes(symbols.before, "-") && !numeral._.includes(symbols.before, "(")) symbols.before = "-" + symbols.before;
                // loop through each before symbol
                for(i = 0; i < symbols.before.length; i++){
                    symbol = symbols.before[i];
                    switch(symbol){
                        case "$":
                            output = numeral._.insert(output, locale.currency.symbol, i);
                            break;
                        case " ":
                            output = numeral._.insert(output, " ", i + locale.currency.symbol.length - 1);
                            break;
                    }
                }
                // loop through each after symbol
                for(i = symbols.after.length - 1; i >= 0; i--){
                    symbol = symbols.after[i];
                    switch(symbol){
                        case "$":
                            output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                            break;
                        case " ":
                            output = i === symbols.after.length - 1 ? output + " " : numeral._.insert(output, " ", -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                            break;
                    }
                }
                return output;
            }
        });
    })();
    (function() {
        numeral.register("format", "exponential", {
            regexps: {
                format: /(e\+|e-)/,
                unformat: /(e\+|e-)/
            },
            format: function(value, format, roundingFunction) {
                var output, exponential = typeof value === "number" && !numeral._.isNaN(value) ? value.toExponential() : "0e+0", parts = exponential.split("e");
                format = format.replace(/e[\+|\-]{1}0/, "");
                output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
                return output + "e" + parts[1];
            },
            unformat: function(string) {
                var parts = numeral._.includes(string, "e+") ? string.split("e+") : string.split("e-"), value = Number(parts[0]), power = Number(parts[1]);
                power = numeral._.includes(string, "e-") ? power *= -1 : power;
                function cback(accum, curr, currI, O) {
                    var corrFactor = numeral._.correctionFactor(accum, curr), num = accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
                    return num;
                }
                return numeral._.reduce([
                    value,
                    Math.pow(10, power)
                ], cback, 1);
            }
        });
    })();
    (function() {
        numeral.register("format", "ordinal", {
            regexps: {
                format: /(o)/
            },
            format: function(value, format, roundingFunction) {
                var locale = numeral.locales[numeral.options.currentLocale], output, ordinal = numeral._.includes(format, " o") ? " " : "";
                // check for space before
                format = format.replace(/\s?o/, "");
                ordinal += locale.ordinal(value);
                output = numeral._.numberToFormat(value, format, roundingFunction);
                return output + ordinal;
            }
        });
    })();
    (function() {
        numeral.register("format", "percentage", {
            regexps: {
                format: /(%)/,
                unformat: /(%)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, " %") ? " " : "", output;
                if (numeral.options.scalePercentBy100) value = value * 100;
                // check for space before %
                format = format.replace(/\s?\%/, "");
                output = numeral._.numberToFormat(value, format, roundingFunction);
                if (numeral._.includes(output, ")")) {
                    output = output.split("");
                    output.splice(-1, 0, space + "%");
                    output = output.join("");
                } else output = output + space + "%";
                return output;
            },
            unformat: function(string) {
                var number = numeral._.stringToNumber(string);
                if (numeral.options.scalePercentBy100) return number * 0.01;
                return number;
            }
        });
    })();
    (function() {
        numeral.register("format", "time", {
            regexps: {
                format: /(:)/,
                unformat: /(:)/
            },
            format: function(value, format, roundingFunction) {
                var hours = Math.floor(value / 60 / 60), minutes = Math.floor((value - hours * 3600) / 60), seconds = Math.round(value - hours * 3600 - minutes * 60);
                return hours + ":" + (minutes < 10 ? "0" + minutes : minutes) + ":" + (seconds < 10 ? "0" + seconds : seconds);
            },
            unformat: function(string) {
                var timeArray = string.split(":"), seconds = 0;
                // turn hours and minutes into seconds and add them all up
                if (timeArray.length === 3) {
                    // hours
                    seconds = seconds + Number(timeArray[0]) * 3600;
                    // minutes
                    seconds = seconds + Number(timeArray[1]) * 60;
                    // seconds
                    seconds = seconds + Number(timeArray[2]);
                } else if (timeArray.length === 2) {
                    // minutes
                    seconds = seconds + Number(timeArray[0]) * 60;
                    // seconds
                    seconds = seconds + Number(timeArray[1]);
                }
                return Number(seconds);
            }
        });
    })();
    return numeral;
});

});

parcelRequire.register("lbhRl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f6b87a8c3e5e051b$export$2e2bcd8739ae039; });

var $hkrtv = parcelRequire("hkrtv");

var $fV1dM = parcelRequire("fV1dM");


var $4KcUv = parcelRequire("4KcUv");
var $f6b87a8c3e5e051b$var$scriptExports = {
    components: {
        VueGoodTable: $fV1dM.VueGoodTable
    },
    computed: {
        floors () {
            let floors = [];
            this.units.forEach((unit)=>{
                if (unit.meta.location.floor) floors.push(parseInt(unit.meta.location.floor, 10));
            });
            if (floors.length > 0) floors = floors.filter((value, index, self)=>self.indexOf(value) === index).sort((a, b)=>a - b);
            return floors;
        }
    },
    data () {
        return {
            activeTab: "all",
            unitsData: window.unitsData,
            columns: [],
            rows: [],
            units: [],
            setCurrentPage: 1,
            perPage: 10
        };
    },
    methods: {
        setTab (tab) {
            if (tab === "all") this.addRows(this.units);
            else {
                let units = JSON.parse(JSON.stringify(this.units));
                units = units.filter((value)=>parseInt(value.meta.location.floor, 10) === tab);
                this.addRows(units);
            }
            this.activeTab = tab;
            this.setCurrentPage = 1;
        },
        disableRow (row) {
            return row.status !== "available" ? "is-disabled" : "";
        },
        formatLink (link) {
            const title = $4KcUv(link.row.title, {
                lower: true,
                strict: true
            });
            const url = link.row.permalink.split("/");
            let prefix = "";
            if (this.unitsData.lang === "nl") {
                prefix = "te-huur";
                if (link.row.negotiation === "sale") prefix = "te-koop";
            } else if (this.unitsData.lang === "fr") {
                prefix = "a-louer";
                if (link.row.negotiation === "sale") prefix = "a-vendre";
            }
            window.location = `/${this.unitsData.lang}/${prefix}/${url[5]}/${title}`;
        },
        addRows (data) {
            this.rows = [];
            data.forEach((estate)=>{
                if (this.unitsData.unit_id !== estate.id) {
                    let plotAreaSize = estate.meta.sizes.plot_area.size;
                    if (estate.meta.sizes.plot_area.unit === "are") plotAreaSize = estate.meta.sizes.plot_area.size * 100;
                    const column = {
                        permalink: estate.permalink,
                        number: estate.meta.location.number,
                        box: estate.meta.location.box,
                        floor: estate.meta.location.floor,
                        liveable_area: estate.meta.sizes.liveable_area.size,
                        plot_area: plotAreaSize,
                        price: estate.meta.price.amount,
                        price_hidden: estate.meta.price.hidden,
                        status: estate.meta.estate.status,
                        title: estate.meta.estate.title[this.unitsData.lang],
                        negotiation: estate.meta.features.negotiation
                    };
                    this.rows.push(column);
                }
            });
        },
        generateRows () {
            this.columns.push({
                label: this.unitsData.locales.number,
                field: "number",
                type: "number"
            });
            this.columns.push({
                label: this.unitsData.locales.box,
                field: "box",
                type: "number"
            });
            this.columns.push({
                label: this.unitsData.locales.floor,
                field: "floor",
                type: "number"
            });
            this.columns.push({
                label: this.unitsData.locales.living_area,
                field: "liveable_area",
                type: "number"
            });
            this.columns.push({
                label: this.unitsData.locales.surface_area,
                field: "plot_area",
                type: "number"
            });
            this.columns.push({
                label: this.unitsData.locales.price_value,
                field: "price",
                type: "number"
            });
            this.columns.push({
                label: this.unitsData.locales.status,
                field: "status"
            });
            this.columns.push({
                label: "Permalink",
                field: "permalink",
                hidden: true
            });
            this.columns.push({
                label: "Price hidden",
                field: "price_hidden",
                hidden: true
            });
            this.columns.push({
                label: "Title",
                field: "title",
                hidden: true
            });
            this.columns.push({
                label: "Negotiation",
                field: "negotiation",
                hidden: true
            });
        },
        getUnits () {
            (0, (/*@__PURE__*/$parcel$interopDefault($hkrtv))).get(`/wp-json/v1/sweepbright/property/${this.unitsData.id}/units`).then((response)=>{
                this.units = response.data.meta;
                this.units = [
                    ...new Map(this.units.map((item)=>[
                            item.meta.estate.id,
                            item
                        ])).values()
                ];
                this.addRows(this.units);
            });
        }
    },
    mounted () {
        this.getUnits();
        this.generateRows();
    }
};
var $f6b87a8c3e5e051b$var$options = typeof $f6b87a8c3e5e051b$var$scriptExports === "function" ? $f6b87a8c3e5e051b$var$scriptExports.options : $f6b87a8c3e5e051b$var$scriptExports;
var $f6b87a8c3e5e051b$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $f6b87a8c3e5e051b$var$options;

});
parcelRequire.register("hkrtv", function(module, exports) {

module.exports = (parcelRequire("7KQRm"));

});
parcelRequire.register("7KQRm", function(module, exports) {
"use strict";

var $cfXJ3 = parcelRequire("cfXJ3");

var $f9RLk = parcelRequire("f9RLk");

var $9fVgj = parcelRequire("9fVgj");

var $6Ozi4 = parcelRequire("6Ozi4");

var $eyroE = parcelRequire("eyroE");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $5a55d51f5112df3c$var$createInstance(defaultConfig) {
    var context = new $9fVgj(defaultConfig);
    var instance = $f9RLk($9fVgj.prototype.request, context);
    // Copy axios.prototype to instance
    $cfXJ3.extend(instance, $9fVgj.prototype, context);
    // Copy context to instance
    $cfXJ3.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $5a55d51f5112df3c$var$axios = $5a55d51f5112df3c$var$createInstance($eyroE);
// Expose Axios class to allow class inheritance
$5a55d51f5112df3c$var$axios.Axios = $9fVgj;
// Factory for creating new instances
$5a55d51f5112df3c$var$axios.create = function create(instanceConfig) {
    return $5a55d51f5112df3c$var$createInstance($6Ozi4($5a55d51f5112df3c$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$5a55d51f5112df3c$var$axios.Cancel = (parcelRequire("6otJi"));

$5a55d51f5112df3c$var$axios.CancelToken = (parcelRequire("emRt6"));

$5a55d51f5112df3c$var$axios.isCancel = (parcelRequire("9zOBF"));
// Expose all/spread
$5a55d51f5112df3c$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$5a55d51f5112df3c$var$axios.spread = (parcelRequire("6FgZm"));

// Expose isAxiosError
$5a55d51f5112df3c$var$axios.isAxiosError = (parcelRequire("2zbqN"));
module.exports = $5a55d51f5112df3c$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $5a55d51f5112df3c$var$axios;

});
parcelRequire.register("cfXJ3", function(module, exports) {
"use strict";

var $f9RLk = parcelRequire("f9RLk");
// utils is a library of generic helper functions non-specific to axios
var $8ec53706316d8141$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $8ec53706316d8141$var$isArray(val) {
    return $8ec53706316d8141$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $8ec53706316d8141$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $8ec53706316d8141$var$isBuffer(val) {
    return val !== null && !$8ec53706316d8141$var$isUndefined(val) && val.constructor !== null && !$8ec53706316d8141$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $8ec53706316d8141$var$isArrayBuffer(val) {
    return $8ec53706316d8141$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $8ec53706316d8141$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $8ec53706316d8141$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $8ec53706316d8141$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $8ec53706316d8141$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $8ec53706316d8141$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $8ec53706316d8141$var$isPlainObject(val) {
    if ($8ec53706316d8141$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $8ec53706316d8141$var$isDate(val) {
    return $8ec53706316d8141$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $8ec53706316d8141$var$isFile(val) {
    return $8ec53706316d8141$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $8ec53706316d8141$var$isBlob(val) {
    return $8ec53706316d8141$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $8ec53706316d8141$var$isFunction(val) {
    return $8ec53706316d8141$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $8ec53706316d8141$var$isStream(val) {
    return $8ec53706316d8141$var$isObject(val) && $8ec53706316d8141$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $8ec53706316d8141$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $8ec53706316d8141$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $8ec53706316d8141$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $8ec53706316d8141$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($8ec53706316d8141$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $8ec53706316d8141$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($8ec53706316d8141$var$isPlainObject(result[key]) && $8ec53706316d8141$var$isPlainObject(val)) result[key] = $8ec53706316d8141$var$merge(result[key], val);
        else if ($8ec53706316d8141$var$isPlainObject(val)) result[key] = $8ec53706316d8141$var$merge({}, val);
        else if ($8ec53706316d8141$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$8ec53706316d8141$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $8ec53706316d8141$var$extend(a, b, thisArg) {
    $8ec53706316d8141$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $f9RLk(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $8ec53706316d8141$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $8ec53706316d8141$var$isArray,
    isArrayBuffer: $8ec53706316d8141$var$isArrayBuffer,
    isBuffer: $8ec53706316d8141$var$isBuffer,
    isFormData: $8ec53706316d8141$var$isFormData,
    isArrayBufferView: $8ec53706316d8141$var$isArrayBufferView,
    isString: $8ec53706316d8141$var$isString,
    isNumber: $8ec53706316d8141$var$isNumber,
    isObject: $8ec53706316d8141$var$isObject,
    isPlainObject: $8ec53706316d8141$var$isPlainObject,
    isUndefined: $8ec53706316d8141$var$isUndefined,
    isDate: $8ec53706316d8141$var$isDate,
    isFile: $8ec53706316d8141$var$isFile,
    isBlob: $8ec53706316d8141$var$isBlob,
    isFunction: $8ec53706316d8141$var$isFunction,
    isStream: $8ec53706316d8141$var$isStream,
    isURLSearchParams: $8ec53706316d8141$var$isURLSearchParams,
    isStandardBrowserEnv: $8ec53706316d8141$var$isStandardBrowserEnv,
    forEach: $8ec53706316d8141$var$forEach,
    merge: $8ec53706316d8141$var$merge,
    extend: $8ec53706316d8141$var$extend,
    trim: $8ec53706316d8141$var$trim,
    stripBOM: $8ec53706316d8141$var$stripBOM
};

});
parcelRequire.register("f9RLk", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRequire.register("9fVgj", function(module, exports) {
"use strict";

var $cfXJ3 = parcelRequire("cfXJ3");

var $kh5iz = parcelRequire("kh5iz");

var $hbpe2 = parcelRequire("hbpe2");

var $bjupl = parcelRequire("bjupl");

var $6Ozi4 = parcelRequire("6Ozi4");

var $dY2DY = parcelRequire("dY2DY");
var $6bd1eed68c530ceb$var$validators = $dY2DY.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $6bd1eed68c530ceb$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $hbpe2(),
        response: new $hbpe2()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $6bd1eed68c530ceb$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $6Ozi4(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    var transitional = config.transitional;
    if (transitional !== undefined) $dY2DY.assertOptions(transitional, {
        silentJSONParsing: $6bd1eed68c530ceb$var$validators.transitional($6bd1eed68c530ceb$var$validators.boolean, "1.0.0"),
        forcedJSONParsing: $6bd1eed68c530ceb$var$validators.transitional($6bd1eed68c530ceb$var$validators.boolean, "1.0.0"),
        clarifyTimeoutError: $6bd1eed68c530ceb$var$validators.transitional($6bd1eed68c530ceb$var$validators.boolean, "1.0.0")
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $bjupl,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $bjupl(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$6bd1eed68c530ceb$var$Axios.prototype.getUri = function getUri(config) {
    config = $6Ozi4(this.defaults, config);
    return $kh5iz(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$cfXJ3.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $6bd1eed68c530ceb$var$Axios.prototype[method] = function(url, config) {
        return this.request($6Ozi4(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$cfXJ3.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $6bd1eed68c530ceb$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($6Ozi4(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $6bd1eed68c530ceb$var$Axios;

});
parcelRequire.register("kh5iz", function(module, exports) {
"use strict";

var $cfXJ3 = parcelRequire("cfXJ3");
function $ec298157471185b6$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($cfXJ3.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $cfXJ3.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($cfXJ3.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $cfXJ3.forEach(val, function parseValue(v) {
                if ($cfXJ3.isDate(v)) v = v.toISOString();
                else if ($cfXJ3.isObject(v)) v = JSON.stringify(v);
                parts.push($ec298157471185b6$var$encode(key) + "=" + $ec298157471185b6$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRequire.register("hbpe2", function(module, exports) {
"use strict";

var $cfXJ3 = parcelRequire("cfXJ3");
function $c827080148be903b$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $c827080148be903b$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $c827080148be903b$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $c827080148be903b$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $cfXJ3.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $c827080148be903b$var$InterceptorManager;

});

parcelRequire.register("bjupl", function(module, exports) {
"use strict";

var $cfXJ3 = parcelRequire("cfXJ3");

var $fr8i3 = parcelRequire("fr8i3");

var $9zOBF = parcelRequire("9zOBF");

var $eyroE = parcelRequire("eyroE");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $83c90e6e57aa4df7$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $83c90e6e57aa4df7$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $fr8i3.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $cfXJ3.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $cfXJ3.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $eyroE.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $83c90e6e57aa4df7$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $fr8i3.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$9zOBF(reason)) {
            $83c90e6e57aa4df7$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $fr8i3.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRequire.register("fr8i3", function(module, exports) {
"use strict";

var $cfXJ3 = parcelRequire("cfXJ3");

var $eyroE = parcelRequire("eyroE");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $eyroE;
    /*eslint no-param-reassign:0*/ $cfXJ3.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRequire.register("eyroE", function(module, exports) {

var $cmlvI = parcelRequire("cmlvI");
"use strict";

var $cfXJ3 = parcelRequire("cfXJ3");

var $9KfEp = parcelRequire("9KfEp");

var $53Eo5 = parcelRequire("53Eo5");
var $a9897e12be8d83bc$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $a9897e12be8d83bc$var$setContentTypeIfUnset(headers, value) {
    if (!$cfXJ3.isUndefined(headers) && $cfXJ3.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $a9897e12be8d83bc$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("cl3tj"));
    else if (typeof $cmlvI !== "undefined" && Object.prototype.toString.call($cmlvI) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("cl3tj"));
    return adapter;
}
function $a9897e12be8d83bc$var$stringifySafely(rawValue, parser, encoder) {
    if ($cfXJ3.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $cfXJ3.trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $a9897e12be8d83bc$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $a9897e12be8d83bc$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $9KfEp(headers, "Accept");
            $9KfEp(headers, "Content-Type");
            if ($cfXJ3.isFormData(data) || $cfXJ3.isArrayBuffer(data) || $cfXJ3.isBuffer(data) || $cfXJ3.isStream(data) || $cfXJ3.isFile(data) || $cfXJ3.isBlob(data)) return data;
            if ($cfXJ3.isArrayBufferView(data)) return data.buffer;
            if ($cfXJ3.isURLSearchParams(data)) {
                $a9897e12be8d83bc$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($cfXJ3.isObject(data) || headers && headers["Content-Type"] === "application/json") {
                $a9897e12be8d83bc$var$setContentTypeIfUnset(headers, "application/json");
                return $a9897e12be8d83bc$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
            if (strictJSONParsing || forcedJSONParsing && $cfXJ3.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === "SyntaxError") throw $53Eo5(e, this, "E_JSON_PARSE");
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$a9897e12be8d83bc$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$cfXJ3.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $a9897e12be8d83bc$var$defaults.headers[method] = {};
});
$cfXJ3.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $a9897e12be8d83bc$var$defaults.headers[method] = $cfXJ3.merge($a9897e12be8d83bc$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $a9897e12be8d83bc$var$defaults;

});
parcelRequire.register("cmlvI", function(module, exports) {
// shim for using process in browser
var $8ff839a7d0ad494d$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $8ff839a7d0ad494d$var$cachedSetTimeout;
var $8ff839a7d0ad494d$var$cachedClearTimeout;
function $8ff839a7d0ad494d$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $8ff839a7d0ad494d$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $8ff839a7d0ad494d$var$cachedSetTimeout = setTimeout;
        else $8ff839a7d0ad494d$var$cachedSetTimeout = $8ff839a7d0ad494d$var$defaultSetTimout;
    } catch (e) {
        $8ff839a7d0ad494d$var$cachedSetTimeout = $8ff839a7d0ad494d$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $8ff839a7d0ad494d$var$cachedClearTimeout = clearTimeout;
        else $8ff839a7d0ad494d$var$cachedClearTimeout = $8ff839a7d0ad494d$var$defaultClearTimeout;
    } catch (e) {
        $8ff839a7d0ad494d$var$cachedClearTimeout = $8ff839a7d0ad494d$var$defaultClearTimeout;
    }
})();
function $8ff839a7d0ad494d$var$runTimeout(fun) {
    if ($8ff839a7d0ad494d$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($8ff839a7d0ad494d$var$cachedSetTimeout === $8ff839a7d0ad494d$var$defaultSetTimout || !$8ff839a7d0ad494d$var$cachedSetTimeout) && setTimeout) {
        $8ff839a7d0ad494d$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8ff839a7d0ad494d$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $8ff839a7d0ad494d$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $8ff839a7d0ad494d$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $8ff839a7d0ad494d$var$runClearTimeout(marker) {
    if ($8ff839a7d0ad494d$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($8ff839a7d0ad494d$var$cachedClearTimeout === $8ff839a7d0ad494d$var$defaultClearTimeout || !$8ff839a7d0ad494d$var$cachedClearTimeout) && clearTimeout) {
        $8ff839a7d0ad494d$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $8ff839a7d0ad494d$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $8ff839a7d0ad494d$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $8ff839a7d0ad494d$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $8ff839a7d0ad494d$var$queue = [];
var $8ff839a7d0ad494d$var$draining = false;
var $8ff839a7d0ad494d$var$currentQueue;
var $8ff839a7d0ad494d$var$queueIndex = -1;
function $8ff839a7d0ad494d$var$cleanUpNextTick() {
    if (!$8ff839a7d0ad494d$var$draining || !$8ff839a7d0ad494d$var$currentQueue) return;
    $8ff839a7d0ad494d$var$draining = false;
    if ($8ff839a7d0ad494d$var$currentQueue.length) $8ff839a7d0ad494d$var$queue = $8ff839a7d0ad494d$var$currentQueue.concat($8ff839a7d0ad494d$var$queue);
    else $8ff839a7d0ad494d$var$queueIndex = -1;
    if ($8ff839a7d0ad494d$var$queue.length) $8ff839a7d0ad494d$var$drainQueue();
}
function $8ff839a7d0ad494d$var$drainQueue() {
    if ($8ff839a7d0ad494d$var$draining) return;
    var timeout = $8ff839a7d0ad494d$var$runTimeout($8ff839a7d0ad494d$var$cleanUpNextTick);
    $8ff839a7d0ad494d$var$draining = true;
    var len = $8ff839a7d0ad494d$var$queue.length;
    while(len){
        $8ff839a7d0ad494d$var$currentQueue = $8ff839a7d0ad494d$var$queue;
        $8ff839a7d0ad494d$var$queue = [];
        while(++$8ff839a7d0ad494d$var$queueIndex < len)if ($8ff839a7d0ad494d$var$currentQueue) $8ff839a7d0ad494d$var$currentQueue[$8ff839a7d0ad494d$var$queueIndex].run();
        $8ff839a7d0ad494d$var$queueIndex = -1;
        len = $8ff839a7d0ad494d$var$queue.length;
    }
    $8ff839a7d0ad494d$var$currentQueue = null;
    $8ff839a7d0ad494d$var$draining = false;
    $8ff839a7d0ad494d$var$runClearTimeout(timeout);
}
$8ff839a7d0ad494d$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $8ff839a7d0ad494d$var$queue.push(new $8ff839a7d0ad494d$var$Item(fun, args));
    if ($8ff839a7d0ad494d$var$queue.length === 1 && !$8ff839a7d0ad494d$var$draining) $8ff839a7d0ad494d$var$runTimeout($8ff839a7d0ad494d$var$drainQueue);
};
// v8 likes predictible objects
function $8ff839a7d0ad494d$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$8ff839a7d0ad494d$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$8ff839a7d0ad494d$var$process.title = "browser";
$8ff839a7d0ad494d$var$process.browser = true;
$8ff839a7d0ad494d$var$process.env = {};
$8ff839a7d0ad494d$var$process.argv = [];
$8ff839a7d0ad494d$var$process.version = ""; // empty string to avoid regexp issues
$8ff839a7d0ad494d$var$process.versions = {};
function $8ff839a7d0ad494d$var$noop() {}
$8ff839a7d0ad494d$var$process.on = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.addListener = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.once = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.off = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.removeListener = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.removeAllListeners = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.emit = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.prependListener = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.prependOnceListener = $8ff839a7d0ad494d$var$noop;
$8ff839a7d0ad494d$var$process.listeners = function(name) {
    return [];
};
$8ff839a7d0ad494d$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$8ff839a7d0ad494d$var$process.cwd = function() {
    return "/";
};
$8ff839a7d0ad494d$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$8ff839a7d0ad494d$var$process.umask = function() {
    return 0;
};

});

parcelRequire.register("9KfEp", function(module, exports) {
"use strict";

var $cfXJ3 = parcelRequire("cfXJ3");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $cfXJ3.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRequire.register("53Eo5", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});

parcelRequire.register("cl3tj", function(module, exports) {
"use strict";

var $cfXJ3 = parcelRequire("cfXJ3");

var $1iZhD = parcelRequire("1iZhD");

var $777Uo = parcelRequire("777Uo");

var $kh5iz = parcelRequire("kh5iz");

var $cDv4o = parcelRequire("cDv4o");

var $fNAMV = parcelRequire("fNAMV");

var $8Ri5J = parcelRequire("8Ri5J");

var $a47WW = parcelRequire("a47WW");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        if ($cfXJ3.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $cDv4o(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $kh5iz(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $fNAMV(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $1iZhD(resolve, reject, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($a47WW("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($a47WW("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($a47WW(timeoutErrorMessage, config, config.transitional && config.transitional.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($cfXJ3.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $8Ri5J(fullPath)) && config.xsrfCookieName ? $777Uo.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $cfXJ3.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$cfXJ3.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRequire.register("1iZhD", function(module, exports) {
"use strict";

var $a47WW = parcelRequire("a47WW");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($a47WW("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRequire.register("a47WW", function(module, exports) {
"use strict";

var $53Eo5 = parcelRequire("53Eo5");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $53Eo5(error, config, code, request, response);
};

});


parcelRequire.register("777Uo", function(module, exports) {
"use strict";

var $cfXJ3 = parcelRequire("cfXJ3");
module.exports = $cfXJ3.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($cfXJ3.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($cfXJ3.isString(path)) cookie.push("path=" + path);
            if ($cfXJ3.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRequire.register("cDv4o", function(module, exports) {
"use strict";

var $fWd87 = parcelRequire("fWd87");

var $dLRtT = parcelRequire("dLRtT");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$fWd87(requestedURL)) return $dLRtT(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRequire.register("fWd87", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRequire.register("dLRtT", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRequire.register("fNAMV", function(module, exports) {
"use strict";

var $cfXJ3 = parcelRequire("cfXJ3");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $b807f7f7b4b7c70f$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $cfXJ3.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $cfXJ3.trim(line.substr(0, i)).toLowerCase();
        val = $cfXJ3.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $b807f7f7b4b7c70f$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRequire.register("8Ri5J", function(module, exports) {
"use strict";

var $cfXJ3 = parcelRequire("cfXJ3");
module.exports = $cfXJ3.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $cfXJ3.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRequire.register("9zOBF", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRequire.register("6Ozi4", function(module, exports) {
"use strict";

var $cfXJ3 = parcelRequire("cfXJ3");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy",
        "params"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "timeoutMessage",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "decompress",
        "maxContentLength",
        "maxBodyLength",
        "maxRedirects",
        "transport",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath",
        "responseEncoding"
    ];
    var directMergeKeys = [
        "validateStatus"
    ];
    function getMergedValue(target, source) {
        if ($cfXJ3.isPlainObject(target) && $cfXJ3.isPlainObject(source)) return $cfXJ3.merge(target, source);
        else if ($cfXJ3.isPlainObject(source)) return $cfXJ3.merge({}, source);
        else if ($cfXJ3.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$cfXJ3.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$cfXJ3.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $cfXJ3.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$cfXJ3.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $cfXJ3.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $cfXJ3.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$cfXJ3.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$cfXJ3.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $cfXJ3.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $cfXJ3.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});

parcelRequire.register("dY2DY", function(module, exports) {
"use strict";

var $hcaXG = parcelRequire("hcaXG");
var $a2b2edf6325eabd8$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach(function(type, i) {
    $a2b2edf6325eabd8$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
var $a2b2edf6325eabd8$var$deprecatedWarnings = {};
var $a2b2edf6325eabd8$var$currentVerArr = $hcaXG.version.split(".");
/**
 * Compare package versions
 * @param {string} version
 * @param {string?} thanVersion
 * @returns {boolean}
 */ function $a2b2edf6325eabd8$var$isOlderVersion(version, thanVersion) {
    var pkgVersionArr = thanVersion ? thanVersion.split(".") : $a2b2edf6325eabd8$var$currentVerArr;
    var destVer = version.split(".");
    for(var i = 0; i < 3; i++){
        if (pkgVersionArr[i] > destVer[i]) return true;
        else if (pkgVersionArr[i] < destVer[i]) return false;
    }
    return false;
}
/**
 * Transitional option validator
 * @param {function|boolean?} validator
 * @param {string?} version
 * @param {string} message
 * @returns {function}
 */ $a2b2edf6325eabd8$var$validators.transitional = function transitional(validator, version, message) {
    var isDeprecated = version && $a2b2edf6325eabd8$var$isOlderVersion(version);
    function formatMessage(opt, desc) {
        return "[Axios v" + $hcaXG.version + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, " has been removed in " + version));
        if (isDeprecated && !$a2b2edf6325eabd8$var$deprecatedWarnings[opt]) {
            $a2b2edf6325eabd8$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $a2b2edf6325eabd8$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new TypeError("options must be an object");
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError("option " + opt + " must be " + result);
            continue;
        }
        if (allowUnknown !== true) throw Error("Unknown option " + opt);
    }
}
module.exports = {
    isOlderVersion: $a2b2edf6325eabd8$var$isOlderVersion,
    assertOptions: $a2b2edf6325eabd8$var$assertOptions,
    validators: $a2b2edf6325eabd8$var$validators
};

});
parcelRequire.register("hcaXG", function(module, exports) {
module.exports = JSON.parse('{"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}');

});



parcelRequire.register("6otJi", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $4a7c0ba89fe1b16d$var$Cancel(message) {
    this.message = message;
}
$4a7c0ba89fe1b16d$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$4a7c0ba89fe1b16d$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $4a7c0ba89fe1b16d$var$Cancel;

});

parcelRequire.register("emRt6", function(module, exports) {
"use strict";

var $6otJi = parcelRequire("6otJi");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $a75c987db5a96b51$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $6otJi(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $a75c987db5a96b51$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $a75c987db5a96b51$var$CancelToken.source = function source() {
    var cancel;
    var token = new $a75c987db5a96b51$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $a75c987db5a96b51$var$CancelToken;

});

parcelRequire.register("6FgZm", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRequire.register("2zbqN", function(module, exports) {
"use strict";
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === "object" && payload.isAxiosError === true;
};

});



parcelRequire.register("fV1dM", function(module, exports) {

$parcel$export(module.exports, "VueGoodTable", function () { return $b96d2069a202fabb$export$7ea51704840f7174; });
/**
 * vue-good-table v2.21.11
 * (c) 2018-present xaksis <shay@crayonbits.com>
 * https://github.com/xaksis/vue-good-table
 * Released under the MIT License.
 */ function $b96d2069a202fabb$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b96d2069a202fabb$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $b96d2069a202fabb$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b96d2069a202fabb$var$_typeof(obj);
}
function $b96d2069a202fabb$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b96d2069a202fabb$var$_slicedToArray(arr, i) {
    return $b96d2069a202fabb$var$_arrayWithHoles(arr) || $b96d2069a202fabb$var$_iterableToArrayLimit(arr, i) || $b96d2069a202fabb$var$_unsupportedIterableToArray(arr, i) || $b96d2069a202fabb$var$_nonIterableRest();
}
function $b96d2069a202fabb$var$_toConsumableArray(arr) {
    return $b96d2069a202fabb$var$_arrayWithoutHoles(arr) || $b96d2069a202fabb$var$_iterableToArray(arr) || $b96d2069a202fabb$var$_unsupportedIterableToArray(arr) || $b96d2069a202fabb$var$_nonIterableSpread();
}
function $b96d2069a202fabb$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $b96d2069a202fabb$var$_arrayLikeToArray(arr);
}
function $b96d2069a202fabb$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b96d2069a202fabb$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $b96d2069a202fabb$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $b96d2069a202fabb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b96d2069a202fabb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b96d2069a202fabb$var$_arrayLikeToArray(o, minLen);
}
function $b96d2069a202fabb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b96d2069a202fabb$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b96d2069a202fabb$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $b96d2069a202fabb$var$DEFAULT_SORT_TYPE = "asc";
var $b96d2069a202fabb$var$SORT_TYPES = {
    Ascending: "asc",
    Descending: "desc",
    None: "none"
};
var $b96d2069a202fabb$var$PAGINATION_MODES = {
    Pages: "pages",
    Records: "records"
};
var $b96d2069a202fabb$var$DEFAULT_ROWS_PER_PAGE_DROPDOWN = [
    10,
    20,
    30,
    40,
    50
];
var $b96d2069a202fabb$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $b96d2069a202fabb$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
var $b96d2069a202fabb$var$lodash_isequal = $b96d2069a202fabb$var$createCommonjsModule(function(module, exports) {
    /**
 * Lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $b96d2069a202fabb$var$commonjsGlobal == "object" && $b96d2069a202fabb$var$commonjsGlobal && $b96d2069a202fabb$var$commonjsGlobal.Object === Object && $b96d2069a202fabb$var$commonjsGlobal;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
    /** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
    /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
    /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
    /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
        return uid ? "Symbol(src)_1." + uid : "";
    }();
    /**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
    /** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    /** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol1 = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, symToStringTag = Symbol1 ? Symbol1.toStringTag : undefined;
    /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
    /* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set1 = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
    /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set1), weakMapCtorString = toSource(WeakMap);
    /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol1 ? Symbol1.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
    /**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
        var index = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while(++index < length){
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    /**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
    }
    /**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
        var result = this.has(key) && delete this.__data__[key];
        this.size -= result ? 1 : 0;
        return result;
    }
    /**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
            var result = data[key];
            return result === HASH_UNDEFINED ? undefined : result;
        }
        return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }
    /**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
    }
    /**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
        return this;
    }
    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    /**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
        var index = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while(++index < length){
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    /**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
    }
    /**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
        var data = this.__data__, index = assocIndexOf(data, key);
        if (index < 0) return false;
        var lastIndex = data.length - 1;
        if (index == lastIndex) data.pop();
        else splice.call(data, index, 1);
        --this.size;
        return true;
    }
    /**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
        var data = this.__data__, index = assocIndexOf(data, key);
        return index < 0 ? undefined : data[index][1];
    }
    /**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
    }
    /**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
        var data = this.__data__, index = assocIndexOf(data, key);
        if (index < 0) {
            ++this.size;
            data.push([
                key,
                value
            ]);
        } else data[index][1] = value;
        return this;
    }
    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    /**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
        var index = -1, length = entries == null ? 0 : entries.length;
        this.clear();
        while(++index < length){
            var entry = entries[index];
            this.set(entry[0], entry[1]);
        }
    }
    /**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
            "hash": new Hash,
            "map": new (Map || ListCache),
            "string": new Hash
        };
    }
    /**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
        var result = getMapData(this, key)["delete"](key);
        this.size -= result ? 1 : 0;
        return result;
    }
    /**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
        return getMapData(this, key).get(key);
    }
    /**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
        return getMapData(this, key).has(key);
    }
    /**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
        var data = getMapData(this, key), size = data.size;
        data.set(key, value);
        this.size += data.size == size ? 0 : 1;
        return this;
    }
    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    /**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
        var index = -1, length = values == null ? 0 : values.length;
        this.__data__ = new MapCache;
        while(++index < length)this.add(values[index]);
    }
    /**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
        this.__data__.set(value, HASH_UNDEFINED);
        return this;
    }
    /**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
        return this.__data__.has(value);
    }
    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;
    /**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
        var data = this.__data__ = new ListCache(entries);
        this.size = data.size;
    }
    /**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
        this.__data__ = new ListCache;
        this.size = 0;
    }
    /**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
        var data = this.__data__, result = data["delete"](key);
        this.size = data.size;
        return result;
    }
    /**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
        return this.__data__.get(key);
    }
    /**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
        return this.__data__.has(key);
    }
    /**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
        var data = this.__data__;
        if (data instanceof ListCache) {
            var pairs = data.__data__;
            if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                pairs.push([
                    key,
                    value
                ]);
                this.size = ++data.size;
                return this;
            }
            data = this.__data__ = new MapCache(pairs);
        }
        data.set(key, value);
        this.size = data.size;
        return this;
    }
    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype["delete"] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;
    /**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
        var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
        for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
        (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
        isIndex(key, length)))) result.push(key);
        return result;
    }
    /**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
        var length = array.length;
        while(length--){
            if (eq(array[length][0], key)) return length;
        }
        return -1;
    }
    /**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
        var result = keysFunc(object);
        return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }
    /**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
        if (value == null) return value === undefined ? undefinedTag : nullTag;
        return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    /**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
        return isObjectLike(value) && baseGetTag(value) == argsTag;
    }
    /**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
        if (value === other) return true;
        if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
        return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }
    /**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
        var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
        objTag = objTag == argsTag ? objectTag : objTag;
        othTag = othTag == argsTag ? objectTag : othTag;
        var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
        if (isSameTag && isBuffer(object)) {
            if (!isBuffer(other)) return false;
            objIsArr = true;
            objIsObj = false;
        }
        if (isSameTag && !objIsObj) {
            stack || (stack = new Stack);
            return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
        }
        if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
            var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
            if (objIsWrapped || othIsWrapped) {
                var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                stack || (stack = new Stack);
                return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
            }
        }
        if (!isSameTag) return false;
        stack || (stack = new Stack);
        return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }
    /**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
        if (!isObject(value) || isMasked(value)) return false;
        var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
    }
    /**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
        return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }
    /**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
        if (!isPrototype(object)) return nativeKeys(object);
        var result = [];
        for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
        return result;
    }
    /**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
        if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
        // Assume cyclic values are equal.
        var stacked = stack.get(array);
        if (stacked && stack.get(other)) return stacked == other;
        var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
        stack.set(array, other);
        stack.set(other, array);
        // Ignore non-index properties.
        while(++index < arrLength){
            var arrValue = array[index], othValue = other[index];
            if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
            if (compared !== undefined) {
                if (compared) continue;
                result = false;
                break;
            }
            // Recursively compare arrays (susceptible to call stack limits).
            if (seen) {
                if (!arraySome(other, function(othValue, othIndex) {
                    if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                })) {
                    result = false;
                    break;
                }
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                result = false;
                break;
            }
        }
        stack["delete"](array);
        stack["delete"](other);
        return result;
    }
    /**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
        switch(tag){
            case dataViewTag:
                if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                object = object.buffer;
                other = other.buffer;
            case arrayBufferTag:
                if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                return true;
            case boolTag:
            case dateTag:
            case numberTag:
                // Coerce booleans to `1` or `0` and dates to milliseconds.
                // Invalid dates are coerced to `NaN`.
                return eq(+object, +other);
            case errorTag:
                return object.name == other.name && object.message == other.message;
            case regexpTag:
            case stringTag:
                // Coerce regexes to strings and treat strings, primitives and objects,
                // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                // for more details.
                return object == other + "";
            case mapTag:
                var convert = mapToArray;
            case setTag:
                var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                convert || (convert = setToArray);
                if (object.size != other.size && !isPartial) return false;
                // Assume cyclic values are equal.
                var stacked = stack.get(object);
                if (stacked) return stacked == other;
                bitmask |= COMPARE_UNORDERED_FLAG;
                // Recursively compare objects (susceptible to call stack limits).
                stack.set(object, other);
                var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                stack["delete"](object);
                return result;
            case symbolTag:
                if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
        }
        return false;
    }
    /**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
        if (objLength != othLength && !isPartial) return false;
        var index = objLength;
        while(index--){
            var key = objProps[index];
            if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
        }
        // Assume cyclic values are equal.
        var stacked = stack.get(object);
        if (stacked && stack.get(other)) return stacked == other;
        var result = true;
        stack.set(object, other);
        stack.set(other, object);
        var skipCtor = isPartial;
        while(++index < objLength){
            key = objProps[index];
            var objValue = object[key], othValue = other[key];
            if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
            // Recursively compare objects (susceptible to call stack limits).
            if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                result = false;
                break;
            }
            skipCtor || (skipCtor = key == "constructor");
        }
        if (result && !skipCtor) {
            var objCtor = object.constructor, othCtor = other.constructor;
            // Non `Object` object instances with different constructors are not equal.
            if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
        }
        stack["delete"](object);
        stack["delete"](other);
        return result;
    }
    /**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
        return baseGetAllKeys(object, keys, getSymbols);
    }
    /**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
        var data = map.__data__;
        return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
    }
    /**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : undefined;
    }
    /**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
        var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
        try {
            value[symToStringTag] = undefined;
            var unmasked = true;
        } catch (e) {}
        var result = nativeObjectToString.call(value);
        if (unmasked) {
            if (isOwn) value[symToStringTag] = tag;
            else delete value[symToStringTag];
        }
        return result;
    }
    /**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
        if (object == null) return [];
        object = Object(object);
        return arrayFilter(nativeGetSymbols(object), function(symbol) {
            return propertyIsEnumerable.call(object, symbol);
        });
    };
    /**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set1 && getTag(new Set1) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
        var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
        if (ctorString) switch(ctorString){
            case dataViewCtorString:
                return dataViewTag;
            case mapCtorString:
                return mapTag;
            case promiseCtorString:
                return promiseTag;
            case setCtorString:
                return setTag;
            case weakMapCtorString:
                return weakMapTag;
        }
        return result;
    };
    /**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
        length = length == null ? MAX_SAFE_INTEGER : length;
        return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
    }
    /**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
        var type = typeof value;
        return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
    }
    /**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
    }
    /**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
        var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
        return value === proto;
    }
    /**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
        return nativeObjectToString.call(value);
    }
    /**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
        if (func != null) {
            try {
                return funcToString.call(func);
            } catch (e) {}
            try {
                return func + "";
            } catch (e) {}
        }
        return "";
    }
    /**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
        return value === other || value !== value && other !== other;
    }
    /**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
        return arguments;
    }()) ? baseIsArguments : function(value) {
        return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
    };
    /**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
    /**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction(value);
    }
    /**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
    /**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function isEqual(value, other) {
        return baseIsEqual(value, other);
    }
    /**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
        if (!isObject(value)) return false;
        // The use of `Object#toString` avoids issues with the `typeof` operator
        // in Safari 9 which returns 'object' for typed arrays and other constructors.
        var tag = baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    /**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
        return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    /**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
        var type = typeof value;
        return value != null && (type == "object" || type == "function");
    }
    /**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
        return value != null && typeof value == "object";
    }
    /**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
    /**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
        return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }
    /**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
        return [];
    }
    /**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
        return false;
    }
    module.exports = isEqual;
});
// all diacritics
var $b96d2069a202fabb$var$diacritics = {
    a: [
        "a",
        "\xe0",
        "\xe1",
        "\xe2",
        "\xe3",
        "\xe4",
        "\xe5",
        "\xe6",
        "ā",
        "ă",
        "ą",
        "ǎ",
        "ǟ",
        "ǡ",
        "ǻ",
        "ȁ",
        "ȃ",
        "ȧ",
        "ɐ",
        "ɑ",
        "ɒ",
        "ͣ",
        "а",
        "ӑ",
        "ӓ",
        "ᵃ",
        "ᵄ",
        "ᶏ",
        "ḁ",
        "ẚ",
        "ạ",
        "ả",
        "ấ",
        "ầ",
        "ẩ",
        "ẫ",
        "ậ",
        "ắ",
        "ằ",
        "ẳ",
        "ẵ",
        "ặ",
        "ₐ",
        "ⱥ",
        "ａ"
    ],
    b: [
        "b",
        "ƀ",
        "ƃ",
        "ɓ",
        "ᖯ",
        "ᵇ",
        "ᵬ",
        "ᶀ",
        "ḃ",
        "ḅ",
        "ḇ",
        "ｂ"
    ],
    c: [
        "c",
        "\xe7",
        "ć",
        "ĉ",
        "ċ",
        "č",
        "ƈ",
        "ȼ",
        "ɕ",
        "ͨ",
        "ᴄ",
        "ᶜ",
        "ḉ",
        "ↄ",
        "ｃ"
    ],
    d: [
        "d",
        "ď",
        "đ",
        "Ƌ",
        "ƌ",
        "ȡ",
        "ɖ",
        "ɗ",
        "ͩ",
        "ᵈ",
        "ᵭ",
        "ᶁ",
        "ᶑ",
        "ḋ",
        "ḍ",
        "ḏ",
        "ḑ",
        "ḓ",
        "ｄ"
    ],
    e: [
        "e",
        "\xe8",
        "\xe9",
        "\xea",
        "\xeb",
        "ē",
        "ĕ",
        "ė",
        "ę",
        "ě",
        "ǝ",
        "ȅ",
        "ȇ",
        "ȩ",
        "ɇ",
        "ɘ",
        "ͤ",
        "ᵉ",
        "ᶒ",
        "ḕ",
        "ḗ",
        "ḙ",
        "ḛ",
        "ḝ",
        "ẹ",
        "ẻ",
        "ẽ",
        "ế",
        "ề",
        "ể",
        "ễ",
        "ệ",
        "ₑ",
        "ｅ"
    ],
    f: [
        "f",
        "ƒ",
        "ᵮ",
        "ᶂ",
        "ᶠ",
        "ḟ",
        "ｆ"
    ],
    g: [
        "g",
        "ĝ",
        "ğ",
        "ġ",
        "ģ",
        "ǥ",
        "ǧ",
        "ǵ",
        "ɠ",
        "ɡ",
        "ᵍ",
        "ᵷ",
        "ᵹ",
        "ᶃ",
        "ᶢ",
        "ḡ",
        "ｇ"
    ],
    h: [
        "h",
        "ĥ",
        "ħ",
        "ƕ",
        "ȟ",
        "ɥ",
        "ɦ",
        "ʮ",
        "ʯ",
        "ʰ",
        "ʱ",
        "ͪ",
        "Һ",
        "һ",
        "ᑋ",
        "ᶣ",
        "ḣ",
        "ḥ",
        "ḧ",
        "ḩ",
        "ḫ",
        "ⱨ",
        "ｈ"
    ],
    i: [
        "i",
        "\xec",
        "\xed",
        "\xee",
        "\xef",
        "ĩ",
        "ī",
        "ĭ",
        "į",
        "ǐ",
        "ȉ",
        "ȋ",
        "ɨ",
        "ͥ",
        "ᴉ",
        "ᵎ",
        "ᵢ",
        "ᶖ",
        "ᶤ",
        "ḭ",
        "ḯ",
        "ỉ",
        "ị",
        "ｉ"
    ],
    j: [
        "j",
        "ĵ",
        "ǰ",
        "ɉ",
        "ʝ",
        "ʲ",
        "ᶡ",
        "ᶨ",
        "ｊ"
    ],
    k: [
        "k",
        "ķ",
        "ƙ",
        "ǩ",
        "ʞ",
        "ᵏ",
        "ᶄ",
        "ḱ",
        "ḳ",
        "ḵ",
        "ⱪ",
        "ｋ"
    ],
    l: [
        "l",
        "ĺ",
        "ļ",
        "ľ",
        "ŀ",
        "ł",
        "ƚ",
        "ȴ",
        "ɫ",
        "ɬ",
        "ɭ",
        "ˡ",
        "ᶅ",
        "ᶩ",
        "ᶪ",
        "ḷ",
        "ḹ",
        "ḻ",
        "ḽ",
        "ℓ",
        "ⱡ"
    ],
    m: [
        "m",
        "ɯ",
        "ɰ",
        "ɱ",
        "ͫ",
        "ᴟ",
        "ᵐ",
        "ᵚ",
        "ᵯ",
        "ᶆ",
        "ᶬ",
        "ᶭ",
        "ḿ",
        "ṁ",
        "ṃ",
        "㎡",
        "㎥",
        "ｍ"
    ],
    n: [
        "n",
        "\xf1",
        "ń",
        "ņ",
        "ň",
        "ŉ",
        "ƞ",
        "ǹ",
        "ȵ",
        "ɲ",
        "ɳ",
        "ᵰ",
        "ᶇ",
        "ᶮ",
        "ᶯ",
        "ṅ",
        "ṇ",
        "ṉ",
        "ṋ",
        "ⁿ",
        "ｎ"
    ],
    o: [
        "o",
        "\xf2",
        "\xf3",
        "\xf4",
        "\xf5",
        "\xf6",
        "\xf8",
        "ō",
        "ŏ",
        "ő",
        "ơ",
        "ǒ",
        "ǫ",
        "ǭ",
        "ǿ",
        "ȍ",
        "ȏ",
        "ȫ",
        "ȭ",
        "ȯ",
        "ȱ",
        "ɵ",
        "ͦ",
        "о",
        "ӧ",
        "ө",
        "ᴏ",
        "ᴑ",
        "ᴓ",
        "ᴼ",
        "ᵒ",
        "ᶱ",
        "ṍ",
        "ṏ",
        "ṑ",
        "ṓ",
        "ọ",
        "ỏ",
        "ố",
        "ồ",
        "ổ",
        "ỗ",
        "ộ",
        "ớ",
        "ờ",
        "ở",
        "ỡ",
        "ợ",
        "ₒ",
        "ｏ",
        "\uD801\uDC2C"
    ],
    p: [
        "p",
        "ᵖ",
        "ᵱ",
        "ᵽ",
        "ᶈ",
        "ṕ",
        "ṗ",
        "ｐ"
    ],
    q: [
        "q",
        "ɋ",
        "ʠ",
        "ᛩ",
        "ｑ"
    ],
    r: [
        "r",
        "ŕ",
        "ŗ",
        "ř",
        "ȑ",
        "ȓ",
        "ɍ",
        "ɹ",
        "ɻ",
        "ʳ",
        "ʴ",
        "ʵ",
        "ͬ",
        "ᵣ",
        "ᵲ",
        "ᶉ",
        "ṙ",
        "ṛ",
        "ṝ",
        "ṟ"
    ],
    s: [
        "s",
        "ś",
        "ŝ",
        "ş",
        "š",
        "ș",
        "ʂ",
        "ᔆ",
        "ᶊ",
        "ṡ",
        "ṣ",
        "ṥ",
        "ṧ",
        "ṩ",
        "ｓ"
    ],
    t: [
        "t",
        "ţ",
        "ť",
        "ŧ",
        "ƫ",
        "ƭ",
        "ț",
        "ʇ",
        "ͭ",
        "ᵀ",
        "ᵗ",
        "ᵵ",
        "ᶵ",
        "ṫ",
        "ṭ",
        "ṯ",
        "ṱ",
        "ẗ",
        "ｔ"
    ],
    u: [
        "u",
        "\xf9",
        "\xfa",
        "\xfb",
        "\xfc",
        "ũ",
        "ū",
        "ŭ",
        "ů",
        "ű",
        "ų",
        "ư",
        "ǔ",
        "ǖ",
        "ǘ",
        "ǚ",
        "ǜ",
        "ȕ",
        "ȗ",
        "ͧ",
        "ߎ",
        "ᵘ",
        "ᵤ",
        "ṳ",
        "ṵ",
        "ṷ",
        "ṹ",
        "ṻ",
        "ụ",
        "ủ",
        "ứ",
        "ừ",
        "ử",
        "ữ",
        "ự",
        "ｕ"
    ],
    v: [
        "v",
        "ʋ",
        "ͮ",
        "ᵛ",
        "ᵥ",
        "ᶹ",
        "ṽ",
        "ṿ",
        "ⱱ",
        "ｖ",
        "ⱴ"
    ],
    w: [
        "w",
        "ŵ",
        "ʷ",
        "ᵂ",
        "ẁ",
        "ẃ",
        "ẅ",
        "ẇ",
        "ẉ",
        "ẘ",
        "ⱳ",
        "ｗ"
    ],
    x: [
        "x",
        "̽",
        "͓",
        "ᶍ",
        "ͯ",
        "ẋ",
        "ẍ",
        "ₓ",
        "ｘ"
    ],
    y: [
        "y",
        "\xfd",
        "\xff",
        "ŷ",
        "ȳ",
        "ɏ",
        "ʸ",
        "ẏ",
        "ỳ",
        "ỵ",
        "ỷ",
        "ỹ",
        "ｙ"
    ],
    z: [
        "z",
        "ź",
        "ż",
        "ž",
        "ƶ",
        "ȥ",
        "ɀ",
        "ʐ",
        "ʑ",
        "ᙆ",
        "ᙇ",
        "ᶻ",
        "ᶼ",
        "ᶽ",
        "ẑ",
        "ẓ",
        "ẕ",
        "ⱬ",
        "ｚ"
    ]
}; // Precompiled Object with { key = Diacritic, value = real-Character }
var $b96d2069a202fabb$var$compiledDiactitics = function() {
    var x = {};
    for(var key in $b96d2069a202fabb$var$diacritics){
        var ok = $b96d2069a202fabb$var$diacritics[key];
        for(var rval in ok){
            var val = ok[rval]; // Do not replace the char with itself
            if (val !== key) x[val] = key;
        }
    }
    return x;
}(); // Regex for detecting non-ASCII-Characters in String
var $b96d2069a202fabb$var$regexNonASCII = /[^a-z0-9\s,.-]/;
/*
 * Main function of the module which removes all diacritics from the received text
 */ var $b96d2069a202fabb$var$diacriticless = function diacriticless(text) {
    // When there are only ascii-Characters in the string, skip processing and return text right away
    if (text.search($b96d2069a202fabb$var$regexNonASCII) === -1) return text;
    var result = "";
    var len = text.length;
    for(var i = 0; i < len; i++){
        var searchChar = text.charAt(i); // If applicable replace the diacritic character with the real one or use the original value
        result += searchChar in $b96d2069a202fabb$var$compiledDiactitics ? $b96d2069a202fabb$var$compiledDiactitics[searchChar] : searchChar;
    }
    return result;
};
var $b96d2069a202fabb$var$escapeRegExp = function escapeRegExp(str) {
    return str.replace(/[\\^$*+?.()|[\]{}]/g, "\\$&");
};
var $b96d2069a202fabb$var$defaultType = {
    format: function format(x) {
        return x;
    },
    filterPredicate: function filterPredicate(rowval, filter) {
        var skipDiacritics = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var fromDropdown = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        // take care of nulls
        if (typeof rowval === "undefined" || rowval === null) return false;
         // row value
        var rowValue = skipDiacritics ? String(rowval).toLowerCase() : $b96d2069a202fabb$var$diacriticless($b96d2069a202fabb$var$escapeRegExp(String(rowval)).toLowerCase()); // search term
        var searchTerm = skipDiacritics ? filter.toLowerCase() : $b96d2069a202fabb$var$diacriticless($b96d2069a202fabb$var$escapeRegExp(filter).toLowerCase()); // comparison
        return fromDropdown ? rowValue === searchTerm : rowValue.indexOf(searchTerm) > -1;
    },
    compare: function compare(x, y) {
        function cook(d) {
            if (typeof d === "undefined" || d === null) return "";
            return $b96d2069a202fabb$var$diacriticless(String(d).toLowerCase());
        }
        x = cook(x);
        y = cook(y);
        if (x < y) return -1;
        if (x > y) return 1;
        return 0;
    }
};
//
var $b96d2069a202fabb$var$script = {
    name: "VgtPaginationPageInfo",
    props: {
        currentPage: {
            "default": 1
        },
        lastPage: {
            "default": 1
        },
        totalRecords: {
            "default": 0
        },
        ofText: {
            "default": "of",
            type: String
        },
        pageText: {
            "default": "page",
            type: String
        },
        currentPerPage: {},
        mode: {
            "default": $b96d2069a202fabb$var$PAGINATION_MODES.Records
        },
        infoFn: {
            "default": null
        }
    },
    data: function data() {
        return {
            id: this.getId()
        };
    },
    computed: {
        pageInfo: function pageInfo() {
            return "".concat(this.ofText, " ").concat(this.lastPage);
        },
        firstRecordOnPage: function firstRecordOnPage() {
            return (this.currentPage - 1) * this.currentPerPage + 1;
        },
        lastRecordOnPage: function lastRecordOnPage() {
            // if the setting is set to 'all'
            if (this.currentPerPage === -1) return this.totalRecords;
            return Math.min(this.totalRecords, this.currentPage * this.currentPerPage);
        },
        recordInfo: function recordInfo() {
            var first = this.firstRecordOnPage;
            var last = this.lastRecordOnPage;
            if (last === 0) first = 0;
            return "".concat(first, " - ").concat(last, " ").concat(this.ofText, " ").concat(this.totalRecords);
        },
        infoParams: function infoParams() {
            var first = this.firstRecordOnPage;
            var last = this.lastRecordOnPage;
            if (last === 0) first = 0;
            return {
                firstRecordOnPage: first,
                lastRecordOnPage: last,
                totalRecords: this.totalRecords,
                currentPage: this.currentPage,
                totalPage: this.lastPage
            };
        }
    },
    methods: {
        getId: function getId() {
            return "vgt-page-input-".concat(Math.floor(Math.random() * Date.now()));
        },
        changePage: function changePage(event) {
            var value = parseInt(event.target.value, 10); //! invalid number
            if (Number.isNaN(value) || value > this.lastPage || value < 1) {
                event.target.value = this.currentPage;
                return false;
            } //* valid number
            event.target.value = value;
            this.$emit("page-changed", value);
        }
    },
    mounted: function mounted() {},
    components: {}
};
function $b96d2069a202fabb$var$normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */ , shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== "boolean") {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === "function" ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) options.functional = true;
    }
    // scopedId
    if (scopeId) options._scopeId = scopeId;
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function(context) {
            // 2.3 injection
            context = context || // cached call
            this.$vnode && this.$vnode.ssrContext || // stateful
            this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") context = __VUE_SSR_CONTEXT__;
            // inject component styles
            if (style) style.call(this, createInjectorSSR(context));
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) context._registeredComponents.add(moduleIdentifier);
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    } else if (style) hook = shadowMode ? function(context) {
        style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function(context) {
        style.call(this, createInjector(context));
    };
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        } else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [
                hook
            ];
        }
    }
    return script;
}
/* script */ var $b96d2069a202fabb$var$__vue_script__ = $b96d2069a202fabb$var$script;
/* template */ var $b96d2069a202fabb$var$__vue_render__ = function __vue_render__() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", {
        staticClass: "footer__navigation__page-info"
    }, [
        _vm.infoFn ? _c("div", [
            _vm._v("\n    " + _vm._s(_vm.infoFn(_vm.infoParams)) + "\n  ")
        ]) : _vm.mode === "pages" ? _c("form", {
            on: {
                "submit": function submit($event) {
                    $event.preventDefault();
                }
            }
        }, [
            _c("label", {
                staticClass: "page-info__label",
                attrs: {
                    "for": _vm.id
                }
            }, [
                _c("span", [
                    _vm._v(_vm._s(_vm.pageText))
                ]),
                _vm._v(" "),
                _c("input", {
                    staticClass: "footer__navigation__page-info__current-entry",
                    attrs: {
                        "id": _vm.id,
                        "aria-describedby": "change-page-hint",
                        "aria-controls": "vgb-table",
                        "type": "text"
                    },
                    domProps: {
                        "value": _vm.currentPage
                    },
                    on: {
                        "keyup": function keyup($event) {
                            if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
                            $event.stopPropagation();
                            return _vm.changePage($event);
                        }
                    }
                }),
                _vm._v(" "),
                _c("span", [
                    _vm._v(_vm._s(_vm.pageInfo))
                ])
            ]),
            _vm._v(" "),
            _c("span", {
                staticStyle: {
                    "display": "none"
                },
                attrs: {
                    "id": "change-page-hint"
                }
            }, [
                _vm._v("\n      Type a page number and press Enter to change the page.\n    ")
            ])
        ]) : _c("div", [
            _vm._v("\n    " + _vm._s(_vm.recordInfo) + "\n  ")
        ])
    ]);
};
var $b96d2069a202fabb$var$__vue_staticRenderFns__ = [];
/* style */ var $b96d2069a202fabb$var$__vue_inject_styles__ = undefined;
/* scoped */ var $b96d2069a202fabb$var$__vue_scope_id__ = "data-v-347cbcfa";
/* module identifier */ var $b96d2069a202fabb$var$__vue_module_identifier__ = undefined;
/* functional template */ var $b96d2069a202fabb$var$__vue_is_functional_template__ = false;
/* style inject */ /* style inject SSR */ /* style inject shadow dom */ var $b96d2069a202fabb$var$__vue_component__ = /*#__PURE__*/ $b96d2069a202fabb$var$normalizeComponent({
    render: $b96d2069a202fabb$var$__vue_render__,
    staticRenderFns: $b96d2069a202fabb$var$__vue_staticRenderFns__
}, $b96d2069a202fabb$var$__vue_inject_styles__, $b96d2069a202fabb$var$__vue_script__, $b96d2069a202fabb$var$__vue_scope_id__, $b96d2069a202fabb$var$__vue_is_functional_template__, $b96d2069a202fabb$var$__vue_module_identifier__, false, undefined, undefined, undefined);
//
var $b96d2069a202fabb$var$script$1 = {
    name: "VgtPagination",
    props: {
        styleClass: {
            "default": "table table-bordered"
        },
        total: {
            "default": null
        },
        perPage: {},
        rtl: {
            "default": false
        },
        perPageDropdownEnabled: {
            "default": true
        },
        customRowsPerPageDropdown: {
            "default": function _default() {
                return [];
            }
        },
        paginateDropdownAllowAll: {
            "default": true
        },
        mode: {
            "default": $b96d2069a202fabb$var$PAGINATION_MODES.Records
        },
        jumpFirstOrLast: {
            "default": false
        },
        // text options
        firstText: {
            "default": "First"
        },
        lastText: {
            "default": "Last"
        },
        nextText: {
            "default": "Next"
        },
        prevText: {
            "default": "Prev"
        },
        rowsPerPageText: {
            "default": "Rows per page:"
        },
        ofText: {
            "default": "of"
        },
        pageText: {
            "default": "page"
        },
        allText: {
            "default": "All"
        },
        infoFn: {
            "default": null
        }
    },
    data: function data() {
        return {
            id: this.getId(),
            currentPage: 1,
            prevPage: 0,
            currentPerPage: 10,
            rowsPerPageOptions: []
        };
    },
    watch: {
        perPage: {
            handler: function handler(newValue, oldValue) {
                this.handlePerPage();
                this.perPageChanged(oldValue);
            },
            immediate: true
        },
        customRowsPerPageDropdown: function customRowsPerPageDropdown() {
            this.handlePerPage();
        },
        total: {
            handler: function handler(newValue, oldValue) {
                if (this.rowsPerPageOptions.indexOf(this.currentPerPage) === -1) this.currentPerPage = newValue;
            }
        }
    },
    computed: {
        // Number of pages
        pagesCount: function pagesCount() {
            // if the setting is set to 'all'
            if (this.currentPerPage === -1) return 1;
            var quotient = Math.floor(this.total / this.currentPerPage);
            var remainder = this.total % this.currentPerPage;
            return remainder === 0 ? quotient : quotient + 1;
        },
        // Can go to first page
        firstIsPossible: function firstIsPossible() {
            return this.currentPage > 1;
        },
        // Can go to last page
        lastIsPossible: function lastIsPossible() {
            return this.currentPage < Math.ceil(this.total / this.currentPerPage);
        },
        // Can go to next page
        nextIsPossible: function nextIsPossible() {
            return this.currentPage < this.pagesCount;
        },
        // Can go to previous page
        prevIsPossible: function prevIsPossible() {
            return this.currentPage > 1;
        }
    },
    methods: {
        getId: function getId() {
            return "vgt-select-rpp-".concat(Math.floor(Math.random() * Date.now()));
        },
        // Change current page
        changePage: function changePage(pageNumber) {
            var emit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            if (pageNumber > 0 && this.total > this.currentPerPage * (pageNumber - 1)) {
                this.prevPage = this.currentPage;
                this.currentPage = pageNumber;
                this.pageChanged(emit);
            }
        },
        // Go to first page
        firstPage: function firstPage() {
            if (this.firstIsPossible) {
                this.currentPage = 1;
                this.prevPage = 0;
                this.pageChanged();
            }
        },
        // Go to last page
        lastPage: function lastPage() {
            if (this.lastIsPossible) {
                this.currentPage = this.pagesCount;
                this.prev = this.currentPage - 1;
                this.pageChanged();
            }
        },
        // Go to next page
        nextPage: function nextPage() {
            if (this.nextIsPossible) {
                this.prevPage = this.currentPage;
                ++this.currentPage;
                this.pageChanged();
            }
        },
        // Go to previous page
        previousPage: function previousPage() {
            if (this.prevIsPossible) {
                this.prevPage = this.currentPage;
                --this.currentPage;
                this.pageChanged();
            }
        },
        // Indicate page changing
        pageChanged: function pageChanged() {
            var emit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var payload = {
                currentPage: this.currentPage,
                prevPage: this.prevPage
            };
            if (!emit) payload.noEmit = true;
            this.$emit("page-changed", payload);
        },
        // Indicate per page changing
        perPageChanged: function perPageChanged(oldValue) {
            // go back to first page
            if (oldValue) //* only emit if this isn't first initialization
            this.$emit("per-page-changed", {
                currentPerPage: this.currentPerPage
            });
            this.changePage(1, false);
        },
        // Handle per page changing
        handlePerPage: function handlePerPage() {
            //* if there's a custom dropdown then we use that
            if (this.customRowsPerPageDropdown !== null && Array.isArray(this.customRowsPerPageDropdown) && this.customRowsPerPageDropdown.length !== 0) this.rowsPerPageOptions = JSON.parse(JSON.stringify(this.customRowsPerPageDropdown));
            else //* otherwise we use the default rows per page dropdown
            this.rowsPerPageOptions = JSON.parse(JSON.stringify($b96d2069a202fabb$var$DEFAULT_ROWS_PER_PAGE_DROPDOWN));
            if (this.perPage) {
                this.currentPerPage = this.perPage; // if perPage doesn't already exist, we add it
                var found = false;
                for(var i = 0; i < this.rowsPerPageOptions.length; i++)if (this.rowsPerPageOptions[i] === this.perPage) found = true;
                if (!found && this.perPage !== -1) this.rowsPerPageOptions.unshift(this.perPage);
            } else // reset to default
            this.currentPerPage = 10;
        }
    },
    mounted: function mounted() {},
    components: {
        "pagination-page-info": $b96d2069a202fabb$var$__vue_component__
    }
};
/* script */ var $b96d2069a202fabb$var$__vue_script__$1 = $b96d2069a202fabb$var$script$1;
/* template */ var $b96d2069a202fabb$var$__vue_render__$1 = function __vue_render__() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", {
        staticClass: "vgt-wrap__footer vgt-clearfix"
    }, [
        _vm.perPageDropdownEnabled ? _c("div", {
            staticClass: "footer__row-count vgt-pull-left"
        }, [
            _c("form", [
                _c("label", {
                    staticClass: "footer__row-count__label",
                    attrs: {
                        "for": _vm.id
                    }
                }, [
                    _vm._v(_vm._s(_vm.rowsPerPageText) + ":")
                ]),
                _vm._v(" "),
                _c("select", {
                    directives: [
                        {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.currentPerPage,
                            expression: "currentPerPage"
                        }
                    ],
                    staticClass: "footer__row-count__select",
                    attrs: {
                        "id": _vm.id,
                        "autocomplete": "off",
                        "name": "perPageSelect",
                        "aria-controls": "vgt-table"
                    },
                    on: {
                        "change": [
                            function($event) {
                                var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
                                    return o.selected;
                                }).map(function(o) {
                                    var val = "_value" in o ? o._value : o.value;
                                    return val;
                                });
                                _vm.currentPerPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
                            },
                            _vm.perPageChanged
                        ]
                    }
                }, [
                    _vm._l(_vm.rowsPerPageOptions, function(option, idx) {
                        return _c("option", {
                            key: idx,
                            domProps: {
                                "value": option
                            }
                        }, [
                            _vm._v("\n          " + _vm._s(option) + "\n        ")
                        ]);
                    }),
                    _vm._v(" "),
                    _vm.paginateDropdownAllowAll ? _c("option", {
                        domProps: {
                            "value": -1
                        }
                    }, [
                        _vm._v(_vm._s(_vm.allText))
                    ]) : _vm._e()
                ], 2)
            ])
        ]) : _vm._e(),
        _vm._v(" "),
        _c("div", {
            staticClass: "footer__navigation vgt-pull-right"
        }, [
            _c("pagination-page-info", {
                attrs: {
                    "total-records": _vm.total,
                    "last-page": _vm.pagesCount,
                    "current-page": _vm.currentPage,
                    "current-per-page": _vm.currentPerPage,
                    "of-text": _vm.ofText,
                    "page-text": _vm.pageText,
                    "info-fn": _vm.infoFn,
                    "mode": _vm.mode
                },
                on: {
                    "page-changed": _vm.changePage
                }
            }),
            _vm._v(" "),
            _vm.jumpFirstOrLast ? _c("button", {
                staticClass: "footer__navigation__page-btn",
                "class": {
                    disabled: !_vm.firstIsPossible
                },
                attrs: {
                    "type": "button",
                    "aria-controls": "vgt-table"
                },
                on: {
                    "click": function click($event) {
                        $event.preventDefault();
                        $event.stopPropagation();
                        return _vm.firstPage($event);
                    }
                }
            }, [
                _c("span", {
                    staticClass: "chevron",
                    "class": {
                        left: !_vm.rtl,
                        right: _vm.rtl
                    },
                    attrs: {
                        "aria-hidden": "true"
                    }
                }),
                _vm._v(" "),
                _c("span", [
                    _vm._v(_vm._s(_vm.firstText))
                ])
            ]) : _vm._e(),
            _vm._v(" "),
            _c("button", {
                staticClass: "footer__navigation__page-btn",
                "class": {
                    disabled: !_vm.prevIsPossible
                },
                attrs: {
                    "type": "button",
                    "aria-controls": "vgt-table"
                },
                on: {
                    "click": function click($event) {
                        $event.preventDefault();
                        $event.stopPropagation();
                        return _vm.previousPage($event);
                    }
                }
            }, [
                _c("span", {
                    staticClass: "chevron",
                    "class": {
                        "left": !_vm.rtl,
                        "right": _vm.rtl
                    },
                    attrs: {
                        "aria-hidden": "true"
                    }
                }),
                _vm._v(" "),
                _c("span", [
                    _vm._v(_vm._s(_vm.prevText))
                ])
            ]),
            _vm._v(" "),
            _c("button", {
                staticClass: "footer__navigation__page-btn",
                "class": {
                    disabled: !_vm.nextIsPossible
                },
                attrs: {
                    "type": "button",
                    "aria-controls": "vgt-table"
                },
                on: {
                    "click": function click($event) {
                        $event.preventDefault();
                        $event.stopPropagation();
                        return _vm.nextPage($event);
                    }
                }
            }, [
                _c("span", [
                    _vm._v(_vm._s(_vm.nextText))
                ]),
                _vm._v(" "),
                _c("span", {
                    staticClass: "chevron",
                    "class": {
                        "right": !_vm.rtl,
                        "left": _vm.rtl
                    },
                    attrs: {
                        "aria-hidden": "true"
                    }
                })
            ]),
            _vm._v(" "),
            _vm.jumpFirstOrLast ? _c("button", {
                staticClass: "footer__navigation__page-btn",
                "class": {
                    disabled: !_vm.lastIsPossible
                },
                attrs: {
                    "type": "button",
                    "aria-controls": "vgt-table"
                },
                on: {
                    "click": function click($event) {
                        $event.preventDefault();
                        $event.stopPropagation();
                        return _vm.lastPage($event);
                    }
                }
            }, [
                _c("span", [
                    _vm._v(_vm._s(_vm.lastText))
                ]),
                _vm._v(" "),
                _c("span", {
                    staticClass: "chevron",
                    "class": {
                        right: !_vm.rtl,
                        left: _vm.rtl
                    },
                    attrs: {
                        "aria-hidden": "true"
                    }
                })
            ]) : _vm._e()
        ], 1)
    ]);
};
var $b96d2069a202fabb$var$__vue_staticRenderFns__$1 = [];
/* style */ var $b96d2069a202fabb$var$__vue_inject_styles__$1 = undefined;
/* scoped */ var $b96d2069a202fabb$var$__vue_scope_id__$1 = undefined;
/* module identifier */ var $b96d2069a202fabb$var$__vue_module_identifier__$1 = undefined;
/* functional template */ var $b96d2069a202fabb$var$__vue_is_functional_template__$1 = false;
/* style inject */ /* style inject SSR */ /* style inject shadow dom */ var $b96d2069a202fabb$var$__vue_component__$1 = /*#__PURE__*/ $b96d2069a202fabb$var$normalizeComponent({
    render: $b96d2069a202fabb$var$__vue_render__$1,
    staticRenderFns: $b96d2069a202fabb$var$__vue_staticRenderFns__$1
}, $b96d2069a202fabb$var$__vue_inject_styles__$1, $b96d2069a202fabb$var$__vue_script__$1, $b96d2069a202fabb$var$__vue_scope_id__$1, $b96d2069a202fabb$var$__vue_is_functional_template__$1, $b96d2069a202fabb$var$__vue_module_identifier__$1, false, undefined, undefined, undefined);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var $b96d2069a202fabb$var$script$2 = {
    name: "VgtGlobalSearch",
    props: [
        "value",
        "searchEnabled",
        "globalSearchPlaceholder"
    ],
    data: function data() {
        return {
            globalSearchTerm: null,
            id: this.getId()
        };
    },
    computed: {
        showControlBar: function showControlBar() {
            if (this.searchEnabled) return true;
            if (this.$slots && this.$slots["internal-table-actions"]) return true;
            return false;
        }
    },
    methods: {
        updateValue: function updateValue(value) {
            this.$emit("input", value);
            this.$emit("on-keyup", value);
        },
        entered: function entered(value) {
            this.$emit("on-enter", value);
        },
        getId: function getId() {
            return "vgt-search-".concat(Math.floor(Math.random() * Date.now()));
        }
    }
};
/* script */ var $b96d2069a202fabb$var$__vue_script__$2 = $b96d2069a202fabb$var$script$2;
/* template */ var $b96d2069a202fabb$var$__vue_render__$2 = function __vue_render__() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _vm.showControlBar ? _c("div", {
        staticClass: "vgt-global-search vgt-clearfix"
    }, [
        _c("div", {
            staticClass: "vgt-global-search__input vgt-pull-left"
        }, [
            _vm.searchEnabled ? _c("form", {
                attrs: {
                    "role": "search"
                },
                on: {
                    "submit": function submit($event) {
                        $event.preventDefault();
                    }
                }
            }, [
                _c("label", {
                    attrs: {
                        "for": _vm.id
                    }
                }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("span", {
                        staticClass: "sr-only"
                    }, [
                        _vm._v("Search")
                    ])
                ]),
                _vm._v(" "),
                _c("input", {
                    staticClass: "vgt-input vgt-pull-left",
                    attrs: {
                        "id": _vm.id,
                        "type": "text",
                        "placeholder": _vm.globalSearchPlaceholder
                    },
                    domProps: {
                        "value": _vm.value
                    },
                    on: {
                        "input": function input($event) {
                            return _vm.updateValue($event.target.value);
                        },
                        "keyup": function keyup($event) {
                            if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
                            return _vm.entered($event.target.value);
                        }
                    }
                })
            ]) : _vm._e()
        ]),
        _vm._v(" "),
        _c("div", {
            staticClass: "vgt-global-search__actions vgt-pull-right"
        }, [
            _vm._t("internal-table-actions")
        ], 2)
    ]) : _vm._e();
};
var $b96d2069a202fabb$var$__vue_staticRenderFns__$2 = [
    function() {
        var _vm = this;
        var _h = _vm.$createElement;
        var _c = _vm._self._c || _h;
        return _c("span", {
            staticClass: "input__icon",
            attrs: {
                "aria-hidden": "true"
            }
        }, [
            _c("div", {
                staticClass: "magnifying-glass"
            })
        ]);
    }
];
/* style */ var $b96d2069a202fabb$var$__vue_inject_styles__$2 = undefined;
/* scoped */ var $b96d2069a202fabb$var$__vue_scope_id__$2 = undefined;
/* module identifier */ var $b96d2069a202fabb$var$__vue_module_identifier__$2 = undefined;
/* functional template */ var $b96d2069a202fabb$var$__vue_is_functional_template__$2 = false;
/* style inject */ /* style inject SSR */ /* style inject shadow dom */ var $b96d2069a202fabb$var$__vue_component__$2 = /*#__PURE__*/ $b96d2069a202fabb$var$normalizeComponent({
    render: $b96d2069a202fabb$var$__vue_render__$2,
    staticRenderFns: $b96d2069a202fabb$var$__vue_staticRenderFns__$2
}, $b96d2069a202fabb$var$__vue_inject_styles__$2, $b96d2069a202fabb$var$__vue_script__$2, $b96d2069a202fabb$var$__vue_scope_id__$2, $b96d2069a202fabb$var$__vue_is_functional_template__$2, $b96d2069a202fabb$var$__vue_module_identifier__$2, false, undefined, undefined, undefined);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var $b96d2069a202fabb$var$script$3 = {
    name: "VgtFilterRow",
    props: [
        "lineNumbers",
        "columns",
        "typedColumns",
        "globalSearchEnabled",
        "selectable",
        "mode"
    ],
    watch: {
        columns: {
            handler: function handler(newValue, oldValue) {
                this.populateInitialFilters();
            },
            deep: true,
            immediate: true
        }
    },
    data: function data() {
        return {
            columnFilters: {},
            timer: null
        };
    },
    computed: {
        // to create a filter row, we need to
        // make sure that there is atleast 1 column
        // that requires filtering
        hasFilterRow: function hasFilterRow() {
            // if (this.mode === 'remote' || !this.globalSearchEnabled) {
            for(var i = 0; i < this.columns.length; i++){
                var col = this.columns[i];
                if (col.filterOptions && col.filterOptions.enabled) return true;
            } // }
            return false;
        }
    },
    methods: {
        fieldKey: function fieldKey(field) {
            if (typeof field === "function" && field.name) return field.name;
            return field;
        },
        reset: function reset() {
            var emitEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            this.columnFilters = {};
            if (emitEvent) this.$emit("filter-changed", this.columnFilters);
        },
        isFilterable: function isFilterable(column) {
            return column.filterOptions && column.filterOptions.enabled;
        },
        isDropdown: function isDropdown(column) {
            return this.isFilterable(column) && column.filterOptions.filterDropdownItems && column.filterOptions.filterDropdownItems.length;
        },
        isDropdownObjects: function isDropdownObjects(column) {
            return this.isDropdown(column) && $b96d2069a202fabb$var$_typeof(column.filterOptions.filterDropdownItems[0]) === "object";
        },
        isDropdownArray: function isDropdownArray(column) {
            return this.isDropdown(column) && $b96d2069a202fabb$var$_typeof(column.filterOptions.filterDropdownItems[0]) !== "object";
        },
        getClasses: function getClasses(column) {
            var firstClass = "filter-th";
            return column.filterOptions && column.filterOptions.styleClass ? [
                firstClass
            ].concat($b96d2069a202fabb$var$_toConsumableArray(column.filterOptions.styleClass.split(" "))).join(" ") : firstClass;
        },
        // get column's defined placeholder or default one
        getPlaceholder: function getPlaceholder(column) {
            var placeholder = this.isFilterable(column) && column.filterOptions.placeholder || "Filter ".concat(column.label);
            return placeholder;
        },
        getName: function getName(column) {
            return "vgt-".concat(this.fieldKey(column.field));
        },
        updateFiltersOnEnter: function updateFiltersOnEnter(column, value) {
            if (this.timer) clearTimeout(this.timer);
            this.updateFiltersImmediately(column.field, value);
        },
        updateFiltersOnKeyup: function updateFiltersOnKeyup(column, value) {
            // if the trigger is enter, we don't filter on keyup
            if (column.filterOptions.trigger === "enter") return;
            this.updateFilters(column, value);
        },
        updateSlotFilter: function updateSlotFilter(column, value) {
            var fieldToFilter = column.filterOptions.slotFilterField || column.field;
            if (typeof column.filterOptions.formatValue === "function") value = column.filterOptions.formatValue(value);
            this.updateFiltersImmediately(fieldToFilter, value);
        },
        // since vue doesn't detect property addition and deletion, we
        // need to create helper function to set property etc
        updateFilters: function updateFilters(column, value) {
            var _this = this;
            if (this.timer) clearTimeout(this.timer);
            this.timer = setTimeout(function() {
                _this.updateFiltersImmediately(column.field, value);
            }, 400);
        },
        updateFiltersImmediately: function updateFiltersImmediately(field, value) {
            this.$set(this.columnFilters, this.fieldKey(field), value);
            this.$emit("filter-changed", this.columnFilters);
        },
        populateInitialFilters: function populateInitialFilters() {
            for(var i = 0; i < this.columns.length; i++){
                var col = this.columns[i]; // lets see if there are initial
                // filters supplied by user
                if (this.isFilterable(col) && typeof col.filterOptions.filterValue !== "undefined" && col.filterOptions.filterValue !== null) this.$set(this.columnFilters, this.fieldKey(col.field), col.filterOptions.filterValue); // this.updateFilters(col, col.filterOptions.filterValue);
            } //* lets emit event once all filters are set
            this.$emit("filter-changed", this.columnFilters);
        }
    }
};
/* script */ var $b96d2069a202fabb$var$__vue_script__$3 = $b96d2069a202fabb$var$script$3;
/* template */ var $b96d2069a202fabb$var$__vue_render__$3 = function __vue_render__() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _vm.hasFilterRow ? _c("tr", [
        _vm.lineNumbers ? _c("th") : _vm._e(),
        _vm._v(" "),
        _vm.selectable ? _c("th") : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.columns, function(column, index) {
            return !column.hidden ? _c("th", {
                key: index,
                "class": _vm.getClasses(column)
            }, [
                _vm._t("column-filter", [
                    _vm.isFilterable(column) ? _c("div", [
                        !_vm.isDropdown(column) ? _c("input", {
                            staticClass: "vgt-input",
                            attrs: {
                                "name": _vm.getName(column),
                                "type": "text",
                                "placeholder": _vm.getPlaceholder(column)
                            },
                            domProps: {
                                "value": _vm.columnFilters[_vm.fieldKey(column.field)]
                            },
                            on: {
                                "keyup": function keyup($event) {
                                    if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
                                    return _vm.updateFiltersOnEnter(column, $event.target.value);
                                },
                                "input": function input($event) {
                                    return _vm.updateFiltersOnKeyup(column, $event.target.value);
                                }
                            }
                        }) : _vm._e(),
                        _vm._v(" "),
                        _vm.isDropdownArray(column) ? _c("select", {
                            staticClass: "vgt-select",
                            attrs: {
                                "name": _vm.getName(column)
                            },
                            domProps: {
                                "value": _vm.columnFilters[_vm.fieldKey(column.field)]
                            },
                            on: {
                                "change": function change($event) {
                                    return _vm.updateFiltersImmediately(column.field, $event.target.value);
                                }
                            }
                        }, [
                            _c("option", {
                                key: "-1",
                                attrs: {
                                    "value": ""
                                }
                            }, [
                                _vm._v(_vm._s(_vm.getPlaceholder(column)))
                            ]),
                            _vm._v(" "),
                            _vm._l(column.filterOptions.filterDropdownItems, function(option, i) {
                                return _c("option", {
                                    key: i,
                                    domProps: {
                                        "value": option
                                    }
                                }, [
                                    _vm._v("\n              " + _vm._s(option) + "\n            ")
                                ]);
                            })
                        ], 2) : _vm._e(),
                        _vm._v(" "),
                        _vm.isDropdownObjects(column) ? _c("select", {
                            staticClass: "vgt-select",
                            attrs: {
                                "name": _vm.getName(column)
                            },
                            domProps: {
                                "value": _vm.columnFilters[_vm.fieldKey(column.field)]
                            },
                            on: {
                                "change": function change($event) {
                                    return _vm.updateFiltersImmediately(column.field, $event.target.value);
                                }
                            }
                        }, [
                            _c("option", {
                                key: "-1",
                                attrs: {
                                    "value": ""
                                }
                            }, [
                                _vm._v(_vm._s(_vm.getPlaceholder(column)))
                            ]),
                            _vm._v(" "),
                            _vm._l(column.filterOptions.filterDropdownItems, function(option, i) {
                                return _c("option", {
                                    key: i,
                                    domProps: {
                                        "value": option.value
                                    }
                                }, [
                                    _vm._v(_vm._s(option.text))
                                ]);
                            })
                        ], 2) : _vm._e()
                    ]) : _vm._e()
                ], {
                    "column": column,
                    "updateFilters": _vm.updateSlotFilter
                })
            ], 2) : _vm._e();
        })
    ], 2) : _vm._e();
};
var $b96d2069a202fabb$var$__vue_staticRenderFns__$3 = [];
/* style */ var $b96d2069a202fabb$var$__vue_inject_styles__$3 = undefined;
/* scoped */ var $b96d2069a202fabb$var$__vue_scope_id__$3 = "data-v-6869bf1c";
/* module identifier */ var $b96d2069a202fabb$var$__vue_module_identifier__$3 = undefined;
/* functional template */ var $b96d2069a202fabb$var$__vue_is_functional_template__$3 = false;
/* style inject */ /* style inject SSR */ /* style inject shadow dom */ var $b96d2069a202fabb$var$__vue_component__$3 = /*#__PURE__*/ $b96d2069a202fabb$var$normalizeComponent({
    render: $b96d2069a202fabb$var$__vue_render__$3,
    staticRenderFns: $b96d2069a202fabb$var$__vue_staticRenderFns__$3
}, $b96d2069a202fabb$var$__vue_inject_styles__$3, $b96d2069a202fabb$var$__vue_script__$3, $b96d2069a202fabb$var$__vue_scope_id__$3, $b96d2069a202fabb$var$__vue_is_functional_template__$3, $b96d2069a202fabb$var$__vue_module_identifier__$3, false, undefined, undefined, undefined);
function $b96d2069a202fabb$var$getColumnFirstSortType(column) {
    return column.firstSortType || $b96d2069a202fabb$var$DEFAULT_SORT_TYPE;
}
function $b96d2069a202fabb$var$getCurrentPrimarySort(sortArray, column) {
    return sortArray.length === 1 && sortArray[0].field === column.field ? sortArray[0].type : undefined;
}
function $b96d2069a202fabb$var$getNextSort(currentSort, column) {
    if ($b96d2069a202fabb$var$SORT_TYPES.Descending === $b96d2069a202fabb$var$getColumnFirstSortType(column) && currentSort === $b96d2069a202fabb$var$SORT_TYPES.Ascending) return $b96d2069a202fabb$var$SORT_TYPES.None;
    else if (currentSort === $b96d2069a202fabb$var$SORT_TYPES.Ascending) return $b96d2069a202fabb$var$SORT_TYPES.Descending;
    if ($b96d2069a202fabb$var$SORT_TYPES.Descending === $b96d2069a202fabb$var$getColumnFirstSortType(column) && currentSort === $b96d2069a202fabb$var$SORT_TYPES.Descending) return $b96d2069a202fabb$var$SORT_TYPES.Ascending;
    else if (currentSort === $b96d2069a202fabb$var$SORT_TYPES.Descending) return $b96d2069a202fabb$var$SORT_TYPES.None;
    if ($b96d2069a202fabb$var$SORT_TYPES.Descending === $b96d2069a202fabb$var$getColumnFirstSortType(column) && currentSort === $b96d2069a202fabb$var$SORT_TYPES.None) return $b96d2069a202fabb$var$SORT_TYPES.Descending;
    else return $b96d2069a202fabb$var$SORT_TYPES.Ascending;
}
function $b96d2069a202fabb$var$getIndex(sortArray, column) {
    for(var i = 0; i < sortArray.length; i++){
        if (column.field === sortArray[i].field) return i;
    }
    return -1;
}
var $b96d2069a202fabb$var$primarySort = function primarySort(sortArray, column) {
    var currentPrimarySort = $b96d2069a202fabb$var$getCurrentPrimarySort(sortArray, column);
    var nextPrimarySort = $b96d2069a202fabb$var$getNextSort(currentPrimarySort, column);
    return [
        {
            field: column.field,
            type: currentPrimarySort ? nextPrimarySort : $b96d2069a202fabb$var$getColumnFirstSortType(column)
        }
    ];
};
var $b96d2069a202fabb$var$secondarySort = function secondarySort(sortArray, column) {
    var index = $b96d2069a202fabb$var$getIndex(sortArray, column);
    if (index === -1) sortArray.push({
        field: column.field,
        type: $b96d2069a202fabb$var$getColumnFirstSortType(column)
    });
    else sortArray[index].type = $b96d2069a202fabb$var$getNextSort(sortArray[index].type, column);
    return sortArray;
};
//
var $b96d2069a202fabb$var$script$4 = {
    name: "VgtTableHeader",
    props: {
        lineNumbers: {
            "default": false,
            type: Boolean
        },
        selectable: {
            "default": false,
            type: Boolean
        },
        allSelected: {
            "default": false,
            type: Boolean
        },
        allSelectedIndeterminate: {
            "default": false,
            type: Boolean
        },
        columns: {
            type: Array
        },
        mode: {
            type: String
        },
        typedColumns: {},
        //* Sort related
        sortable: {
            type: Boolean
        },
        multipleColumnSort: {
            type: Boolean,
            "default": true
        },
        getClasses: {
            type: Function
        },
        //* search related
        searchEnabled: {
            type: Boolean
        },
        tableRef: {},
        paginated: {}
    },
    watch: {
        columns: {
            handler: function handler() {
                this.setColumnStyles();
            },
            immediate: true
        },
        tableRef: {
            handler: function handler() {
                this.setColumnStyles();
            },
            immediate: true
        },
        paginated: {
            handler: function handler() {
                if (this.tableRef) this.setColumnStyles();
            },
            deep: true
        }
    },
    data: function data() {
        return {
            checkBoxThStyle: {},
            lineNumberThStyle: {},
            columnStyles: [],
            sorts: [],
            ro: null
        };
    },
    computed: {},
    methods: {
        reset: function reset() {
            this.$refs["filter-row"].reset(true);
        },
        toggleSelectAll: function toggleSelectAll() {
            this.$emit("on-toggle-select-all");
        },
        isSortableColumn: function isSortableColumn(column) {
            var sortable = column.sortable;
            var isSortable = typeof sortable === "boolean" ? sortable : this.sortable;
            return isSortable;
        },
        sort: function sort(e, column) {
            //* if column is not sortable, return right here
            if (!this.isSortableColumn(column)) return;
            if (e.shiftKey && this.multipleColumnSort) this.sorts = $b96d2069a202fabb$var$secondarySort(this.sorts, column);
            else this.sorts = $b96d2069a202fabb$var$primarySort(this.sorts, column);
            this.$emit("on-sort-change", this.sorts);
        },
        setInitialSort: function setInitialSort(sorts) {
            this.sorts = sorts;
            this.$emit("on-sort-change", this.sorts);
        },
        getColumnSort: function getColumnSort(column) {
            for(var i = 0; i < this.sorts.length; i += 1){
                if (this.sorts[i].field === column.field) return this.sorts[i].type || "asc";
            }
            return null;
        },
        getColumnSortLong: function getColumnSortLong(column) {
            return this.getColumnSort(column) === "asc" ? "ascending" : "descending";
        },
        getHeaderClasses: function getHeaderClasses(column, index) {
            var classes = Object.assign({}, this.getClasses(index, "th"), {
                sortable: this.isSortableColumn(column),
                "sorting sorting-desc": this.getColumnSort(column) === "desc",
                "sorting sorting-asc": this.getColumnSort(column) === "asc"
            });
            return classes;
        },
        filterRows: function filterRows(columnFilters) {
            this.$emit("filter-changed", columnFilters);
        },
        getWidthStyle: function getWidthStyle(dom) {
            if (window && window.getComputedStyle && dom) {
                var cellStyle = window.getComputedStyle(dom, null);
                return {
                    width: cellStyle.width
                };
            }
            return {
                width: "auto"
            };
        },
        setColumnStyles: function setColumnStyles() {
            var colStyles = [];
            for(var i = 0; i < this.columns.length; i++)if (this.tableRef) {
                var skip = 0;
                if (this.selectable) skip++;
                if (this.lineNumbers) skip++;
                var cell = this.tableRef.rows[0].cells[i + skip];
                colStyles.push(this.getWidthStyle(cell));
            } else colStyles.push({
                minWidth: this.columns[i].width ? this.columns[i].width : "auto",
                maxWidth: this.columns[i].width ? this.columns[i].width : "auto",
                width: this.columns[i].width ? this.columns[i].width : "auto"
            });
            this.columnStyles = colStyles;
        },
        getColumnStyle: function getColumnStyle(column, index) {
            var styleObject = {
                minWidth: column.width ? column.width : "auto",
                maxWidth: column.width ? column.width : "auto",
                width: column.width ? column.width : "auto"
            }; //* if fixed header we need to get width from original table
            if (this.tableRef) {
                if (this.selectable) index++;
                if (this.lineNumbers) index++;
                var cell = this.tableRef.rows[0].cells[index];
                var cellStyle = window.getComputedStyle(cell, null);
                styleObject.width = cellStyle.width;
            }
            return styleObject;
        }
    },
    mounted: function mounted() {
        var _this = this;
        this.$nextTick(function() {
            // We're going to watch the parent element for resize events, and calculate column widths if it changes
            if ("ResizeObserver" in window) {
                _this.ro = new ResizeObserver(function() {
                    _this.setColumnStyles();
                });
                _this.ro.observe(_this.$parent.$el); // If this is a fixed-header table, we want to observe each column header from the non-fixed header.
                // You can imagine two columns swapping widths, which wouldn't cause the above to trigger.
                // This gets the first tr element of the primary table header, and iterates through its children (the th elements)
                if (_this.tableRef) Array.from(_this.$parent.$refs["table-header-primary"].$el.children[0].children).forEach(function(header) {
                    _this.ro.observe(header);
                });
            }
        });
    },
    beforeDestroy: function beforeDestroy() {
        if (this.ro) this.ro.disconnect();
    },
    components: {
        "vgt-filter-row": $b96d2069a202fabb$var$__vue_component__$3
    }
};
/* script */ var $b96d2069a202fabb$var$__vue_script__$4 = $b96d2069a202fabb$var$script$4;
/* template */ var $b96d2069a202fabb$var$__vue_render__$4 = function __vue_render__() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("thead", [
        _c("tr", [
            _vm.lineNumbers ? _c("th", {
                staticClass: "line-numbers",
                attrs: {
                    "scope": "col"
                }
            }) : _vm._e(),
            _vm._v(" "),
            _vm.selectable ? _c("th", {
                staticClass: "vgt-checkbox-col",
                attrs: {
                    "scope": "col"
                }
            }, [
                _c("input", {
                    attrs: {
                        "type": "checkbox"
                    },
                    domProps: {
                        "checked": _vm.allSelected,
                        "indeterminate": _vm.allSelectedIndeterminate
                    },
                    on: {
                        "change": _vm.toggleSelectAll
                    }
                })
            ]) : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.columns, function(column, index) {
                return !column.hidden ? _c("th", {
                    key: index,
                    "class": _vm.getHeaderClasses(column, index),
                    style: _vm.columnStyles[index],
                    attrs: {
                        "scope": "col",
                        "title": column.tooltip,
                        "aria-sort": _vm.getColumnSortLong(column),
                        "aria-controls": "col-" + index
                    }
                }, [
                    _vm._t("table-column", [
                        _vm._v("\n        " + _vm._s(column.label) + "\n      ")
                    ], {
                        "column": column
                    }),
                    _vm._v(" "),
                    _vm.isSortableColumn(column) ? _c("button", {
                        on: {
                            "click": function click($event) {
                                return _vm.sort($event, column);
                            }
                        }
                    }, [
                        _c("span", {
                            staticClass: "sr-only"
                        }, [
                            _vm._v("\n          Sort table by " + _vm._s(column.label) + " in " + _vm._s(_vm.getColumnSortLong(column)) + " order\n          ")
                        ])
                    ]) : _vm._e()
                ], 2) : _vm._e();
            })
        ], 2),
        _vm._v(" "),
        _c("vgt-filter-row", {
            ref: "filter-row",
            tag: "tr",
            attrs: {
                "global-search-enabled": _vm.searchEnabled,
                "line-numbers": _vm.lineNumbers,
                "selectable": _vm.selectable,
                "columns": _vm.columns,
                "mode": _vm.mode,
                "typed-columns": _vm.typedColumns
            },
            on: {
                "filter-changed": _vm.filterRows
            },
            scopedSlots: _vm._u([
                {
                    key: "column-filter",
                    fn: function fn(props) {
                        return [
                            _vm._t("column-filter", null, {
                                "column": props.column,
                                "updateFilters": props.updateFilters
                            })
                        ];
                    }
                }
            ], null, true)
        })
    ], 1);
};
var $b96d2069a202fabb$var$__vue_staticRenderFns__$4 = [];
/* style */ var $b96d2069a202fabb$var$__vue_inject_styles__$4 = undefined;
/* scoped */ var $b96d2069a202fabb$var$__vue_scope_id__$4 = undefined;
/* module identifier */ var $b96d2069a202fabb$var$__vue_module_identifier__$4 = undefined;
/* functional template */ var $b96d2069a202fabb$var$__vue_is_functional_template__$4 = false;
/* style inject */ /* style inject SSR */ /* style inject shadow dom */ var $b96d2069a202fabb$var$__vue_component__$4 = /*#__PURE__*/ $b96d2069a202fabb$var$normalizeComponent({
    render: $b96d2069a202fabb$var$__vue_render__$4,
    staticRenderFns: $b96d2069a202fabb$var$__vue_staticRenderFns__$4
}, $b96d2069a202fabb$var$__vue_inject_styles__$4, $b96d2069a202fabb$var$__vue_script__$4, $b96d2069a202fabb$var$__vue_scope_id__$4, $b96d2069a202fabb$var$__vue_is_functional_template__$4, $b96d2069a202fabb$var$__vue_module_identifier__$4, false, undefined, undefined, undefined);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var $b96d2069a202fabb$var$script$5 = {
    name: "VgtHeaderRow",
    props: {
        headerRow: {
            type: Object
        },
        columns: {
            type: Array
        },
        lineNumbers: {
            type: Boolean
        },
        selectable: {
            type: Boolean
        },
        selectAllByGroup: {
            type: Boolean
        },
        collapsable: {
            type: [
                Boolean,
                Number
            ],
            "default": false
        },
        collectFormatted: {
            type: Function
        },
        formattedRow: {
            type: Function
        },
        getClasses: {
            type: Function
        },
        fullColspan: {
            type: Number
        },
        groupIndex: {
            type: Number
        }
    },
    data: function data() {
        return {};
    },
    computed: {
        allSelected: function allSelected() {
            var headerRow = this.headerRow, groupChildObject = this.groupChildObject;
            return headerRow.children.filter(function(row) {
                return row.vgtSelected;
            }).length === headerRow.children.length;
        }
    },
    methods: {
        columnCollapsable: function columnCollapsable(currentIndex) {
            if (this.collapsable === true) return currentIndex === 0;
            return currentIndex === this.collapsable;
        },
        toggleSelectGroup: function toggleSelectGroup(event) {
            this.$emit("on-select-group-change", {
                groupIndex: this.groupIndex,
                checked: event.target.checked
            });
        }
    },
    mounted: function mounted() {},
    components: {}
};
/* script */ var $b96d2069a202fabb$var$__vue_script__$5 = $b96d2069a202fabb$var$script$5;
/* template */ var $b96d2069a202fabb$var$__vue_render__$5 = function __vue_render__() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("tr", [
        _vm.headerRow.mode === "span" ? _c("th", {
            staticClass: "vgt-left-align vgt-row-header",
            attrs: {
                "colspan": _vm.fullColspan
            }
        }, [
            _vm.selectAllByGroup ? [
                _vm._t("table-header-group-select", [
                    _c("input", {
                        attrs: {
                            "type": "checkbox"
                        },
                        domProps: {
                            "checked": _vm.allSelected
                        },
                        on: {
                            "change": function change($event) {
                                return _vm.toggleSelectGroup($event);
                            }
                        }
                    })
                ], {
                    "columns": _vm.columns,
                    "row": _vm.headerRow
                })
            ] : _vm._e(),
            _vm._v(" "),
            _c("span", {
                on: {
                    "click": function click($event) {
                        _vm.collapsable && _vm.$emit("vgtExpand", !_vm.headerRow.vgtIsExpanded);
                    }
                }
            }, [
                _vm.collapsable ? _c("span", {
                    staticClass: "triangle",
                    "class": {
                        "expand": _vm.headerRow.vgtIsExpanded
                    }
                }) : _vm._e(),
                _vm._v(" "),
                _vm._t("table-header-row", [
                    _vm.headerRow.html ? _c("span", {
                        domProps: {
                            "innerHTML": _vm._s(_vm.headerRow.label)
                        }
                    }) : _c("span", [
                        _vm._v("\n          " + _vm._s(_vm.headerRow.label) + "\n        ")
                    ])
                ], {
                    "row": _vm.headerRow
                })
            ], 2)
        ], 2) : _vm._e(),
        _vm._v(" "),
        _vm.headerRow.mode !== "span" && _vm.lineNumbers ? _c("th", {
            staticClass: "vgt-row-header"
        }) : _vm._e(),
        _vm._v(" "),
        _vm.headerRow.mode !== "span" && _vm.selectable ? _c("th", {
            staticClass: "vgt-row-header"
        }, [
            _vm.selectAllByGroup ? [
                _vm._t("table-header-group-select", [
                    _c("input", {
                        attrs: {
                            "type": "checkbox"
                        },
                        domProps: {
                            "checked": _vm.allSelected
                        },
                        on: {
                            "change": function change($event) {
                                return _vm.toggleSelectGroup($event);
                            }
                        }
                    })
                ], {
                    "columns": _vm.columns,
                    "row": _vm.headerRow
                })
            ] : _vm._e()
        ], 2) : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.columns, function(column, i) {
            return _vm.headerRow.mode !== "span" && !column.hidden ? _c("th", {
                key: i,
                staticClass: "vgt-row-header",
                "class": _vm.getClasses(i, "td"),
                on: {
                    "click": function click($event) {
                        _vm.columnCollapsable(i) && _vm.$emit("vgtExpand", !_vm.headerRow.vgtIsExpanded);
                    }
                }
            }, [
                _vm.columnCollapsable(i) ? _c("span", {
                    staticClass: "triangle",
                    "class": {
                        "expand": _vm.headerRow.vgtIsExpanded
                    }
                }) : _vm._e(),
                _vm._v(" "),
                _vm._t("table-header-row", [
                    !column.html ? _c("span", [
                        _vm._v("\n        " + _vm._s(_vm.collectFormatted(_vm.headerRow, column, true)) + "\n      ")
                    ]) : _vm._e(),
                    _vm._v(" "),
                    column.html ? _c("span", {
                        domProps: {
                            "innerHTML": _vm._s(_vm.collectFormatted(_vm.headerRow, column, true))
                        }
                    }) : _vm._e()
                ], {
                    "row": _vm.headerRow,
                    "column": column,
                    "formattedRow": _vm.formattedRow(_vm.headerRow, true)
                })
            ], 2) : _vm._e();
        })
    ], 2);
};
var $b96d2069a202fabb$var$__vue_staticRenderFns__$5 = [];
/* style */ var $b96d2069a202fabb$var$__vue_inject_styles__$5 = undefined;
/* scoped */ var $b96d2069a202fabb$var$__vue_scope_id__$5 = undefined;
/* module identifier */ var $b96d2069a202fabb$var$__vue_module_identifier__$5 = undefined;
/* functional template */ var $b96d2069a202fabb$var$__vue_is_functional_template__$5 = false;
/* style inject */ /* style inject SSR */ /* style inject shadow dom */ var $b96d2069a202fabb$var$__vue_component__$5 = /*#__PURE__*/ $b96d2069a202fabb$var$normalizeComponent({
    render: $b96d2069a202fabb$var$__vue_render__$5,
    staticRenderFns: $b96d2069a202fabb$var$__vue_staticRenderFns__$5
}, $b96d2069a202fabb$var$__vue_inject_styles__$5, $b96d2069a202fabb$var$__vue_script__$5, $b96d2069a202fabb$var$__vue_scope_id__$5, $b96d2069a202fabb$var$__vue_is_functional_template__$5, $b96d2069a202fabb$var$__vue_module_identifier__$5, false, undefined, undefined, undefined);
function $b96d2069a202fabb$var$toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
function $b96d2069a202fabb$var$requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $b96d2069a202fabb$var$toDate(argument) {
    $b96d2069a202fabb$var$requiredArgs(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $b96d2069a202fabb$var$addMilliseconds(dirtyDate, dirtyAmount) {
    $b96d2069a202fabb$var$requiredArgs(2, arguments);
    var timestamp = $b96d2069a202fabb$var$toDate(dirtyDate).getTime();
    var amount = $b96d2069a202fabb$var$toInteger(dirtyAmount);
    return new Date(timestamp + amount);
}
var $b96d2069a202fabb$var$MILLISECONDS_IN_MINUTE = 60000;
function $b96d2069a202fabb$var$getDateMillisecondsPart(date) {
    return date.getTime() % $b96d2069a202fabb$var$MILLISECONDS_IN_MINUTE;
}
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $b96d2069a202fabb$var$getTimezoneOffsetInMilliseconds(dirtyDate) {
    var date = new Date(dirtyDate.getTime());
    var baseTimezoneOffset = Math.ceil(date.getTimezoneOffset());
    date.setSeconds(0, 0);
    var hasNegativeUTCOffset = baseTimezoneOffset > 0;
    var millisecondsPartOfTimezoneOffset = hasNegativeUTCOffset ? ($b96d2069a202fabb$var$MILLISECONDS_IN_MINUTE + $b96d2069a202fabb$var$getDateMillisecondsPart(date)) % $b96d2069a202fabb$var$MILLISECONDS_IN_MINUTE : $b96d2069a202fabb$var$getDateMillisecondsPart(date);
    return baseTimezoneOffset * $b96d2069a202fabb$var$MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset;
}
/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */ function $b96d2069a202fabb$var$compareAsc(dirtyDateLeft, dirtyDateRight) {
    $b96d2069a202fabb$var$requiredArgs(2, arguments);
    var dateLeft = $b96d2069a202fabb$var$toDate(dirtyDateLeft);
    var dateRight = $b96d2069a202fabb$var$toDate(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1; // Return 0 if diff is 0; return NaN if diff is NaN
    else return diff;
}
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */ function $b96d2069a202fabb$var$isValid(dirtyDate) {
    $b96d2069a202fabb$var$requiredArgs(1, arguments);
    var date = $b96d2069a202fabb$var$toDate(dirtyDate);
    return !isNaN(date);
}
var $b96d2069a202fabb$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
function $b96d2069a202fabb$var$formatDistance(token, count, options) {
    options = options || {};
    var result;
    if (typeof $b96d2069a202fabb$var$formatDistanceLocale[token] === "string") result = $b96d2069a202fabb$var$formatDistanceLocale[token];
    else if (count === 1) result = $b96d2069a202fabb$var$formatDistanceLocale[token].one;
    else result = $b96d2069a202fabb$var$formatDistanceLocale[token].other.replace("{{count}}", count);
    if (options.addSuffix) {
        if (options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
}
function $b96d2069a202fabb$var$buildFormatLongFn(args) {
    return function(dirtyOptions) {
        var options = dirtyOptions || {};
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
var $b96d2069a202fabb$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $b96d2069a202fabb$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $b96d2069a202fabb$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $b96d2069a202fabb$var$formatLong = {
    date: $b96d2069a202fabb$var$buildFormatLongFn({
        formats: $b96d2069a202fabb$var$dateFormats,
        defaultWidth: "full"
    }),
    time: $b96d2069a202fabb$var$buildFormatLongFn({
        formats: $b96d2069a202fabb$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: $b96d2069a202fabb$var$buildFormatLongFn({
        formats: $b96d2069a202fabb$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $b96d2069a202fabb$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
function $b96d2069a202fabb$var$formatRelative(token, _date, _baseDate, _options) {
    return $b96d2069a202fabb$var$formatRelativeLocale[token];
}
function $b96d2069a202fabb$var$buildLocalizeFn(args) {
    return function(dirtyIndex, dirtyOptions) {
        var options = dirtyOptions || {};
        var context = options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        return valuesArray[index];
    };
}
var $b96d2069a202fabb$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $b96d2069a202fabb$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ] // Note: in English, the names of days of the week and months are capitalized.
};
var $b96d2069a202fabb$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $b96d2069a202fabb$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $b96d2069a202fabb$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $b96d2069a202fabb$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
function $b96d2069a202fabb$var$ordinalNumber(dirtyNumber, _dirtyOptions) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`:
    //
    //   var options = dirtyOptions || {}
    //   var unit = String(options.unit)
    //
    // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
}
var $b96d2069a202fabb$var$localize = {
    ordinalNumber: $b96d2069a202fabb$var$ordinalNumber,
    era: $b96d2069a202fabb$var$buildLocalizeFn({
        values: $b96d2069a202fabb$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: $b96d2069a202fabb$var$buildLocalizeFn({
        values: $b96d2069a202fabb$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: $b96d2069a202fabb$var$buildLocalizeFn({
        values: $b96d2069a202fabb$var$monthValues,
        defaultWidth: "wide"
    }),
    day: $b96d2069a202fabb$var$buildLocalizeFn({
        values: $b96d2069a202fabb$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: $b96d2069a202fabb$var$buildLocalizeFn({
        values: $b96d2069a202fabb$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $b96d2069a202fabb$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
function $b96d2069a202fabb$var$buildMatchPatternFn(args) {
    return function(dirtyString, dirtyOptions) {
        var string = String(dirtyString);
        var options = dirtyOptions || {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        return {
            value: value,
            rest: string.slice(matchedString.length)
        };
    };
}
function $b96d2069a202fabb$var$buildMatchFn(args) {
    return function(dirtyString, dirtyOptions) {
        var string = String(dirtyString);
        var options = dirtyOptions || {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var value;
        if (Object.prototype.toString.call(parsePatterns) === "[object Array]") value = $b96d2069a202fabb$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        else value = $b96d2069a202fabb$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        value = args.valueCallback ? args.valueCallback(value) : value;
        value = options.valueCallback ? options.valueCallback(value) : value;
        return {
            value: value,
            rest: string.slice(matchedString.length)
        };
    };
}
function $b96d2069a202fabb$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
}
function $b96d2069a202fabb$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
}
var $b96d2069a202fabb$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $b96d2069a202fabb$var$parseOrdinalNumberPattern = /\d+/i;
var $b96d2069a202fabb$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $b96d2069a202fabb$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $b96d2069a202fabb$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $b96d2069a202fabb$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $b96d2069a202fabb$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $b96d2069a202fabb$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $b96d2069a202fabb$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $b96d2069a202fabb$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $b96d2069a202fabb$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $b96d2069a202fabb$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $b96d2069a202fabb$var$match = {
    ordinalNumber: $b96d2069a202fabb$var$buildMatchPatternFn({
        matchPattern: $b96d2069a202fabb$var$matchOrdinalNumberPattern,
        parsePattern: $b96d2069a202fabb$var$parseOrdinalNumberPattern,
        valueCallback: function(value) {
            return parseInt(value, 10);
        }
    }),
    era: $b96d2069a202fabb$var$buildMatchFn({
        matchPatterns: $b96d2069a202fabb$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b96d2069a202fabb$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: $b96d2069a202fabb$var$buildMatchFn({
        matchPatterns: $b96d2069a202fabb$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b96d2069a202fabb$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function(index) {
            return index + 1;
        }
    }),
    month: $b96d2069a202fabb$var$buildMatchFn({
        matchPatterns: $b96d2069a202fabb$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b96d2069a202fabb$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: $b96d2069a202fabb$var$buildMatchFn({
        matchPatterns: $b96d2069a202fabb$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b96d2069a202fabb$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: $b96d2069a202fabb$var$buildMatchFn({
        matchPatterns: $b96d2069a202fabb$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $b96d2069a202fabb$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $b96d2069a202fabb$var$locale = {
    code: "en-US",
    formatDistance: $b96d2069a202fabb$var$formatDistance,
    formatLong: $b96d2069a202fabb$var$formatLong,
    formatRelative: $b96d2069a202fabb$var$formatRelative,
    localize: $b96d2069a202fabb$var$localize,
    match: $b96d2069a202fabb$var$match,
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $b96d2069a202fabb$var$subMilliseconds(dirtyDate, dirtyAmount) {
    $b96d2069a202fabb$var$requiredArgs(2, arguments);
    var amount = $b96d2069a202fabb$var$toInteger(dirtyAmount);
    return $b96d2069a202fabb$var$addMilliseconds(dirtyDate, -amount);
}
function $b96d2069a202fabb$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $b96d2069a202fabb$var$formatters = {
    // Year
    y: function(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return $b96d2069a202fabb$var$addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : $b96d2069a202fabb$var$addLeadingZeros(month + 1, 2);
    },
    // Day of the month
    d: function(date, token) {
        return $b96d2069a202fabb$var$addLeadingZeros(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function(date, token) {
        return $b96d2069a202fabb$var$addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function(date, token) {
        return $b96d2069a202fabb$var$addLeadingZeros(date.getUTCHours(), token.length);
    },
    // Minute
    m: function(date, token) {
        return $b96d2069a202fabb$var$addLeadingZeros(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function(date, token) {
        return $b96d2069a202fabb$var$addLeadingZeros(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return $b96d2069a202fabb$var$addLeadingZeros(fractionalSeconds, token.length);
    }
};
var $b96d2069a202fabb$var$MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $b96d2069a202fabb$var$getUTCDayOfYear(dirtyDate) {
    $b96d2069a202fabb$var$requiredArgs(1, arguments);
    var date = $b96d2069a202fabb$var$toDate(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $b96d2069a202fabb$var$MILLISECONDS_IN_DAY) + 1;
}
// See issue: https://github.com/date-fns/date-fns/issues/376
function $b96d2069a202fabb$var$startOfUTCISOWeek(dirtyDate) {
    $b96d2069a202fabb$var$requiredArgs(1, arguments);
    var weekStartsOn = 1;
    var date = $b96d2069a202fabb$var$toDate(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
// See issue: https://github.com/date-fns/date-fns/issues/376
function $b96d2069a202fabb$var$getUTCISOWeekYear(dirtyDate) {
    $b96d2069a202fabb$var$requiredArgs(1, arguments);
    var date = $b96d2069a202fabb$var$toDate(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = $b96d2069a202fabb$var$startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = $b96d2069a202fabb$var$startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
// See issue: https://github.com/date-fns/date-fns/issues/376
function $b96d2069a202fabb$var$startOfUTCISOWeekYear(dirtyDate) {
    $b96d2069a202fabb$var$requiredArgs(1, arguments);
    var year = $b96d2069a202fabb$var$getUTCISOWeekYear(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = $b96d2069a202fabb$var$startOfUTCISOWeek(fourthOfJanuary);
    return date;
}
var $b96d2069a202fabb$var$MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $b96d2069a202fabb$var$getUTCISOWeek(dirtyDate) {
    $b96d2069a202fabb$var$requiredArgs(1, arguments);
    var date = $b96d2069a202fabb$var$toDate(dirtyDate);
    var diff = $b96d2069a202fabb$var$startOfUTCISOWeek(date).getTime() - $b96d2069a202fabb$var$startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $b96d2069a202fabb$var$MILLISECONDS_IN_WEEK) + 1;
}
// See issue: https://github.com/date-fns/date-fns/issues/376
function $b96d2069a202fabb$var$startOfUTCWeek(dirtyDate, dirtyOptions) {
    $b96d2069a202fabb$var$requiredArgs(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : $b96d2069a202fabb$var$toInteger(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : $b96d2069a202fabb$var$toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = $b96d2069a202fabb$var$toDate(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
// See issue: https://github.com/date-fns/date-fns/issues/376
function $b96d2069a202fabb$var$getUTCWeekYear(dirtyDate, dirtyOptions) {
    $b96d2069a202fabb$var$requiredArgs(1, arguments);
    var date = $b96d2069a202fabb$var$toDate(dirtyDate, dirtyOptions);
    var year = date.getUTCFullYear();
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : $b96d2069a202fabb$var$toInteger(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : $b96d2069a202fabb$var$toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = $b96d2069a202fabb$var$startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = $b96d2069a202fabb$var$startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
// See issue: https://github.com/date-fns/date-fns/issues/376
function $b96d2069a202fabb$var$startOfUTCWeekYear(dirtyDate, dirtyOptions) {
    $b96d2069a202fabb$var$requiredArgs(1, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : $b96d2069a202fabb$var$toInteger(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : $b96d2069a202fabb$var$toInteger(options.firstWeekContainsDate);
    var year = $b96d2069a202fabb$var$getUTCWeekYear(dirtyDate, dirtyOptions);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = $b96d2069a202fabb$var$startOfUTCWeek(firstWeek, dirtyOptions);
    return date;
}
var $b96d2069a202fabb$var$MILLISECONDS_IN_WEEK$1 = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function $b96d2069a202fabb$var$getUTCWeek(dirtyDate, options) {
    $b96d2069a202fabb$var$requiredArgs(1, arguments);
    var date = $b96d2069a202fabb$var$toDate(dirtyDate);
    var diff = $b96d2069a202fabb$var$startOfUTCWeek(date, options).getTime() - $b96d2069a202fabb$var$startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $b96d2069a202fabb$var$MILLISECONDS_IN_WEEK$1) + 1;
}
var $b96d2069a202fabb$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
var $b96d2069a202fabb$var$formatters$1 = {
    // Era
    G: function(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return $b96d2069a202fabb$var$formatters.y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        var signedWeekYear = $b96d2069a202fabb$var$getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return $b96d2069a202fabb$var$addLeadingZeros(twoDigitYear, 2);
        } // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
         // Padding
        return $b96d2069a202fabb$var$addLeadingZeros(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        var isoWeekYear = $b96d2069a202fabb$var$getUTCISOWeekYear(date); // Padding
        return $b96d2069a202fabb$var$addLeadingZeros(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        var year = date.getUTCFullYear();
        return $b96d2069a202fabb$var$addLeadingZeros(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return $b96d2069a202fabb$var$addLeadingZeros(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return $b96d2069a202fabb$var$addLeadingZeros(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return $b96d2069a202fabb$var$formatters.M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return $b96d2069a202fabb$var$addLeadingZeros(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        var week = $b96d2069a202fabb$var$getUTCWeek(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return $b96d2069a202fabb$var$addLeadingZeros(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        var isoWeek = $b96d2069a202fabb$var$getUTCISOWeek(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return $b96d2069a202fabb$var$addLeadingZeros(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return $b96d2069a202fabb$var$formatters.d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        var dayOfYear = $b96d2069a202fabb$var$getUTCDayOfYear(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return $b96d2069a202fabb$var$addLeadingZeros(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return $b96d2069a202fabb$var$addLeadingZeros(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return $b96d2069a202fabb$var$addLeadingZeros(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return $b96d2069a202fabb$var$addLeadingZeros(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $b96d2069a202fabb$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $b96d2069a202fabb$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $b96d2069a202fabb$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $b96d2069a202fabb$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $b96d2069a202fabb$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $b96d2069a202fabb$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return $b96d2069a202fabb$var$formatters.h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return $b96d2069a202fabb$var$formatters.H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return $b96d2069a202fabb$var$addLeadingZeros(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return $b96d2069a202fabb$var$addLeadingZeros(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return $b96d2069a202fabb$var$formatters.m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return $b96d2069a202fabb$var$formatters.s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return $b96d2069a202fabb$var$formatters.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $b96d2069a202fabb$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $b96d2069a202fabb$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $b96d2069a202fabb$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $b96d2069a202fabb$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $b96d2069a202fabb$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $b96d2069a202fabb$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $b96d2069a202fabb$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $b96d2069a202fabb$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $b96d2069a202fabb$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $b96d2069a202fabb$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return $b96d2069a202fabb$var$addLeadingZeros(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return $b96d2069a202fabb$var$addLeadingZeros(timestamp, token.length);
    }
};
function $b96d2069a202fabb$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + $b96d2069a202fabb$var$addLeadingZeros(minutes, 2);
}
function $b96d2069a202fabb$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + $b96d2069a202fabb$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $b96d2069a202fabb$var$formatTimezone(offset, dirtyDelimiter);
}
function $b96d2069a202fabb$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = $b96d2069a202fabb$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $b96d2069a202fabb$var$addLeadingZeros(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
function $b96d2069a202fabb$var$dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
}
function $b96d2069a202fabb$var$timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
}
function $b96d2069a202fabb$var$dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/);
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $b96d2069a202fabb$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $b96d2069a202fabb$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $b96d2069a202fabb$var$timeLongFormatter(timePattern, formatLong));
}
var $b96d2069a202fabb$var$longFormatters = {
    p: $b96d2069a202fabb$var$timeLongFormatter,
    P: $b96d2069a202fabb$var$dateTimeLongFormatter
};
var $b96d2069a202fabb$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $b96d2069a202fabb$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $b96d2069a202fabb$var$isProtectedDayOfYearToken(token) {
    return $b96d2069a202fabb$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $b96d2069a202fabb$var$isProtectedWeekYearToken(token) {
    return $b96d2069a202fabb$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $b96d2069a202fabb$var$throwProtectedError(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
}
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $b96d2069a202fabb$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $b96d2069a202fabb$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $b96d2069a202fabb$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $b96d2069a202fabb$var$doubleQuoteRegExp = /''/g;
var $b96d2069a202fabb$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $b96d2069a202fabb$var$format(dirtyDate, dirtyFormatStr, dirtyOptions) {
    $b96d2069a202fabb$var$requiredArgs(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var locale$1 = options.locale || $b96d2069a202fabb$var$locale;
    var localeFirstWeekContainsDate = locale$1.options && locale$1.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : $b96d2069a202fabb$var$toInteger(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : $b96d2069a202fabb$var$toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var localeWeekStartsOn = locale$1.options && locale$1.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : $b96d2069a202fabb$var$toInteger(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : $b96d2069a202fabb$var$toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale$1.localize) throw new RangeError("locale must contain localize property");
    if (!locale$1.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = $b96d2069a202fabb$var$toDate(dirtyDate);
    if (!$b96d2069a202fabb$var$isValid(originalDate)) throw new RangeError("Invalid time value");
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = $b96d2069a202fabb$var$getTimezoneOffsetInMilliseconds(originalDate);
    var utcDate = $b96d2069a202fabb$var$subMilliseconds(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale$1,
        _originalDate: originalDate
    };
    var result = formatStr.match($b96d2069a202fabb$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = $b96d2069a202fabb$var$longFormatters[firstCharacter];
            return longFormatter(substring, locale$1.formatLong, formatterOptions);
        }
        return substring;
    }).join("").match($b96d2069a202fabb$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $b96d2069a202fabb$var$cleanEscapedString(substring);
        var formatter = $b96d2069a202fabb$var$formatters$1[firstCharacter];
        if (formatter) {
            if (!options.useAdditionalWeekYearTokens && $b96d2069a202fabb$var$isProtectedWeekYearToken(substring)) $b96d2069a202fabb$var$throwProtectedError(substring, dirtyFormatStr, dirtyDate);
            if (!options.useAdditionalDayOfYearTokens && $b96d2069a202fabb$var$isProtectedDayOfYearToken(substring)) $b96d2069a202fabb$var$throwProtectedError(substring, dirtyFormatStr, dirtyDate);
            return formatter(utcDate, substring, locale$1.localize, formatterOptions);
        }
        if (firstCharacter.match($b96d2069a202fabb$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $b96d2069a202fabb$var$cleanEscapedString(input) {
    return input.match($b96d2069a202fabb$var$escapedStringRegExp)[1].replace($b96d2069a202fabb$var$doubleQuoteRegExp, "'");
}
function $b96d2069a202fabb$var$assign(target, dirtyObject) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    dirtyObject = dirtyObject || {};
    for(var property in dirtyObject)if (dirtyObject.hasOwnProperty(property)) target[property] = dirtyObject[property];
    return target;
}
// See issue: https://github.com/date-fns/date-fns/issues/376
function $b96d2069a202fabb$var$setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
    $b96d2069a202fabb$var$requiredArgs(2, arguments);
    var options = dirtyOptions || {};
    var locale = options.locale;
    var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : $b96d2069a202fabb$var$toInteger(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : $b96d2069a202fabb$var$toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = $b96d2069a202fabb$var$toDate(dirtyDate);
    var day = $b96d2069a202fabb$var$toInteger(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// See issue: https://github.com/date-fns/date-fns/issues/376
function $b96d2069a202fabb$var$setUTCISODay(dirtyDate, dirtyDay) {
    $b96d2069a202fabb$var$requiredArgs(2, arguments);
    var day = $b96d2069a202fabb$var$toInteger(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = $b96d2069a202fabb$var$toDate(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// See issue: https://github.com/date-fns/date-fns/issues/376
function $b96d2069a202fabb$var$setUTCISOWeek(dirtyDate, dirtyISOWeek) {
    $b96d2069a202fabb$var$requiredArgs(2, arguments);
    var date = $b96d2069a202fabb$var$toDate(dirtyDate);
    var isoWeek = $b96d2069a202fabb$var$toInteger(dirtyISOWeek);
    var diff = $b96d2069a202fabb$var$getUTCISOWeek(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}
// See issue: https://github.com/date-fns/date-fns/issues/376
function $b96d2069a202fabb$var$setUTCWeek(dirtyDate, dirtyWeek, options) {
    $b96d2069a202fabb$var$requiredArgs(2, arguments);
    var date = $b96d2069a202fabb$var$toDate(dirtyDate);
    var week = $b96d2069a202fabb$var$toInteger(dirtyWeek);
    var diff = $b96d2069a202fabb$var$getUTCWeek(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}
var $b96d2069a202fabb$var$MILLISECONDS_IN_HOUR = 3600000;
var $b96d2069a202fabb$var$MILLISECONDS_IN_MINUTE$1 = 60000;
var $b96d2069a202fabb$var$MILLISECONDS_IN_SECOND = 1000;
var $b96d2069a202fabb$var$numericPatterns = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $b96d2069a202fabb$var$timezonePatterns = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function $b96d2069a202fabb$var$parseNumericPattern(pattern, string, valueCallback) {
    var matchResult = string.match(pattern);
    if (!matchResult) return null;
    var value = parseInt(matchResult[0], 10);
    return {
        value: valueCallback ? valueCallback(value) : value,
        rest: string.slice(matchResult[0].length)
    };
}
function $b96d2069a202fabb$var$parseTimezonePattern(pattern, string) {
    var matchResult = string.match(pattern);
    if (!matchResult) return null;
     // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: string.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * $b96d2069a202fabb$var$MILLISECONDS_IN_HOUR + minutes * $b96d2069a202fabb$var$MILLISECONDS_IN_MINUTE$1 + seconds * $b96d2069a202fabb$var$MILLISECONDS_IN_SECOND),
        rest: string.slice(matchResult[0].length)
    };
}
function $b96d2069a202fabb$var$parseAnyDigitsSigned(string, valueCallback) {
    return $b96d2069a202fabb$var$parseNumericPattern($b96d2069a202fabb$var$numericPatterns.anyDigitsSigned, string, valueCallback);
}
function $b96d2069a202fabb$var$parseNDigits(n, string, valueCallback) {
    switch(n){
        case 1:
            return $b96d2069a202fabb$var$parseNumericPattern($b96d2069a202fabb$var$numericPatterns.singleDigit, string, valueCallback);
        case 2:
            return $b96d2069a202fabb$var$parseNumericPattern($b96d2069a202fabb$var$numericPatterns.twoDigits, string, valueCallback);
        case 3:
            return $b96d2069a202fabb$var$parseNumericPattern($b96d2069a202fabb$var$numericPatterns.threeDigits, string, valueCallback);
        case 4:
            return $b96d2069a202fabb$var$parseNumericPattern($b96d2069a202fabb$var$numericPatterns.fourDigits, string, valueCallback);
        default:
            return $b96d2069a202fabb$var$parseNumericPattern(new RegExp("^\\d{1," + n + "}"), string, valueCallback);
    }
}
function $b96d2069a202fabb$var$parseNDigitsSigned(n, string, valueCallback) {
    switch(n){
        case 1:
            return $b96d2069a202fabb$var$parseNumericPattern($b96d2069a202fabb$var$numericPatterns.singleDigitSigned, string, valueCallback);
        case 2:
            return $b96d2069a202fabb$var$parseNumericPattern($b96d2069a202fabb$var$numericPatterns.twoDigitsSigned, string, valueCallback);
        case 3:
            return $b96d2069a202fabb$var$parseNumericPattern($b96d2069a202fabb$var$numericPatterns.threeDigitsSigned, string, valueCallback);
        case 4:
            return $b96d2069a202fabb$var$parseNumericPattern($b96d2069a202fabb$var$numericPatterns.fourDigitsSigned, string, valueCallback);
        default:
            return $b96d2069a202fabb$var$parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), string, valueCallback);
    }
}
function $b96d2069a202fabb$var$dayPeriodEnumToHours(enumValue) {
    switch(enumValue){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $b96d2069a202fabb$var$normalizeTwoDigitYear(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0; // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
var $b96d2069a202fabb$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $b96d2069a202fabb$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
]; // User for validation
function $b96d2069a202fabb$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */ var $b96d2069a202fabb$var$parsers = {
    // Era
    G: {
        priority: 140,
        parse: function(string, token, match, _options) {
            switch(token){
                // AD, BC
                case "G":
                case "GG":
                case "GGG":
                    return match.era(string, {
                        width: "abbreviated"
                    }) || match.era(string, {
                        width: "narrow"
                    });
                // A, B
                case "GGGGG":
                    return match.era(string, {
                        width: "narrow"
                    });
                // Anno Domini, Before Christ
                case "GGGG":
                default:
                    return match.era(string, {
                        width: "wide"
                    }) || match.era(string, {
                        width: "abbreviated"
                    }) || match.era(string, {
                        width: "narrow"
                    });
            }
        },
        set: function(date, flags, value, _options) {
            flags.era = value;
            date.setUTCFullYear(value, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "R",
            "u",
            "t",
            "T"
        ]
    },
    // Year
    y: {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        priority: 130,
        parse: function(string, token, match, _options) {
            var valueCallback = function(year) {
                return {
                    year: year,
                    isTwoDigitYear: token === "yy"
                };
            };
            switch(token){
                case "y":
                    return $b96d2069a202fabb$var$parseNDigits(4, string, valueCallback);
                case "yo":
                    return match.ordinalNumber(string, {
                        unit: "year",
                        valueCallback: valueCallback
                    });
                default:
                    return $b96d2069a202fabb$var$parseNDigits(token.length, string, valueCallback);
            }
        },
        validate: function(_date, value, _options) {
            return value.isTwoDigitYear || value.year > 0;
        },
        set: function(date, flags, value, _options) {
            var currentYear = date.getUTCFullYear();
            if (value.isTwoDigitYear) {
                var normalizedTwoDigitYear = $b96d2069a202fabb$var$normalizeTwoDigitYear(value.year, currentYear);
                date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
            var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
            date.setUTCFullYear(year, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // Local week-numbering year
    Y: {
        priority: 130,
        parse: function(string, token, match, _options) {
            var valueCallback = function(year) {
                return {
                    year: year,
                    isTwoDigitYear: token === "YY"
                };
            };
            switch(token){
                case "Y":
                    return $b96d2069a202fabb$var$parseNDigits(4, string, valueCallback);
                case "Yo":
                    return match.ordinalNumber(string, {
                        unit: "year",
                        valueCallback: valueCallback
                    });
                default:
                    return $b96d2069a202fabb$var$parseNDigits(token.length, string, valueCallback);
            }
        },
        validate: function(_date, value, _options) {
            return value.isTwoDigitYear || value.year > 0;
        },
        set: function(date, flags, value, options) {
            var currentYear = $b96d2069a202fabb$var$getUTCWeekYear(date, options);
            if (value.isTwoDigitYear) {
                var normalizedTwoDigitYear = $b96d2069a202fabb$var$normalizeTwoDigitYear(value.year, currentYear);
                date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return $b96d2069a202fabb$var$startOfUTCWeek(date, options);
            }
            var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
            date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
            date.setUTCHours(0, 0, 0, 0);
            return $b96d2069a202fabb$var$startOfUTCWeek(date, options);
        },
        incompatibleTokens: [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]
    },
    // ISO week-numbering year
    R: {
        priority: 130,
        parse: function(string, token, _match, _options) {
            if (token === "R") return $b96d2069a202fabb$var$parseNDigitsSigned(4, string);
            return $b96d2069a202fabb$var$parseNDigitsSigned(token.length, string);
        },
        set: function(_date, _flags, value, _options) {
            var firstWeekOfYear = new Date(0);
            firstWeekOfYear.setUTCFullYear(value, 0, 4);
            firstWeekOfYear.setUTCHours(0, 0, 0, 0);
            return $b96d2069a202fabb$var$startOfUTCISOWeek(firstWeekOfYear);
        },
        incompatibleTokens: [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // Extended year
    u: {
        priority: 130,
        parse: function(string, token, _match, _options) {
            if (token === "u") return $b96d2069a202fabb$var$parseNDigitsSigned(4, string);
            return $b96d2069a202fabb$var$parseNDigitsSigned(token.length, string);
        },
        set: function(date, _flags, value, _options) {
            date.setUTCFullYear(value, 0, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // Quarter
    Q: {
        priority: 120,
        parse: function(string, token, match, _options) {
            switch(token){
                // 1, 2, 3, 4
                case "Q":
                case "QQ":
                    // 01, 02, 03, 04
                    return $b96d2069a202fabb$var$parseNDigits(token.length, string);
                // 1st, 2nd, 3rd, 4th
                case "Qo":
                    return match.ordinalNumber(string, {
                        unit: "quarter"
                    });
                // Q1, Q2, Q3, Q4
                case "QQQ":
                    return match.quarter(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.quarter(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                case "QQQQQ":
                    return match.quarter(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                // 1st quarter, 2nd quarter, ...
                case "QQQQ":
                default:
                    return match.quarter(string, {
                        width: "wide",
                        context: "formatting"
                    }) || match.quarter(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.quarter(string, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 4;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth((value - 1) * 3, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // Stand-alone quarter
    q: {
        priority: 120,
        parse: function(string, token, match, _options) {
            switch(token){
                // 1, 2, 3, 4
                case "q":
                case "qq":
                    // 01, 02, 03, 04
                    return $b96d2069a202fabb$var$parseNDigits(token.length, string);
                // 1st, 2nd, 3rd, 4th
                case "qo":
                    return match.ordinalNumber(string, {
                        unit: "quarter"
                    });
                // Q1, Q2, Q3, Q4
                case "qqq":
                    return match.quarter(string, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || match.quarter(string, {
                        width: "narrow",
                        context: "standalone"
                    });
                // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                case "qqqqq":
                    return match.quarter(string, {
                        width: "narrow",
                        context: "standalone"
                    });
                // 1st quarter, 2nd quarter, ...
                case "qqqq":
                default:
                    return match.quarter(string, {
                        width: "wide",
                        context: "standalone"
                    }) || match.quarter(string, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || match.quarter(string, {
                        width: "narrow",
                        context: "standalone"
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 4;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth((value - 1) * 3, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // Month
    M: {
        priority: 110,
        parse: function(string, token, match, _options) {
            var valueCallback = function(value) {
                return value - 1;
            };
            switch(token){
                // 1, 2, ..., 12
                case "M":
                    return $b96d2069a202fabb$var$parseNumericPattern($b96d2069a202fabb$var$numericPatterns.month, string, valueCallback);
                // 01, 02, ..., 12
                case "MM":
                    return $b96d2069a202fabb$var$parseNDigits(2, string, valueCallback);
                // 1st, 2nd, ..., 12th
                case "Mo":
                    return match.ordinalNumber(string, {
                        unit: "month",
                        valueCallback: valueCallback
                    });
                // Jan, Feb, ..., Dec
                case "MMM":
                    return match.month(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.month(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                // J, F, ..., D
                case "MMMMM":
                    return match.month(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                // January, February, ..., December
                case "MMMM":
                default:
                    return match.month(string, {
                        width: "wide",
                        context: "formatting"
                    }) || match.month(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.month(string, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 11;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth(value, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // Stand-alone month
    L: {
        priority: 110,
        parse: function(string, token, match, _options) {
            var valueCallback = function(value) {
                return value - 1;
            };
            switch(token){
                // 1, 2, ..., 12
                case "L":
                    return $b96d2069a202fabb$var$parseNumericPattern($b96d2069a202fabb$var$numericPatterns.month, string, valueCallback);
                // 01, 02, ..., 12
                case "LL":
                    return $b96d2069a202fabb$var$parseNDigits(2, string, valueCallback);
                // 1st, 2nd, ..., 12th
                case "Lo":
                    return match.ordinalNumber(string, {
                        unit: "month",
                        valueCallback: valueCallback
                    });
                // Jan, Feb, ..., Dec
                case "LLL":
                    return match.month(string, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || match.month(string, {
                        width: "narrow",
                        context: "standalone"
                    });
                // J, F, ..., D
                case "LLLLL":
                    return match.month(string, {
                        width: "narrow",
                        context: "standalone"
                    });
                // January, February, ..., December
                case "LLLL":
                default:
                    return match.month(string, {
                        width: "wide",
                        context: "standalone"
                    }) || match.month(string, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || match.month(string, {
                        width: "narrow",
                        context: "standalone"
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 11;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth(value, 1);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // Local week of year
    w: {
        priority: 100,
        parse: function(string, token, match, _options) {
            switch(token){
                case "w":
                    return $b96d2069a202fabb$var$parseNumericPattern($b96d2069a202fabb$var$numericPatterns.week, string);
                case "wo":
                    return match.ordinalNumber(string, {
                        unit: "week"
                    });
                default:
                    return $b96d2069a202fabb$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 53;
        },
        set: function(date, _flags, value, options) {
            return $b96d2069a202fabb$var$startOfUTCWeek($b96d2069a202fabb$var$setUTCWeek(date, value, options), options);
        },
        incompatibleTokens: [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]
    },
    // ISO week of year
    I: {
        priority: 100,
        parse: function(string, token, match, _options) {
            switch(token){
                case "I":
                    return $b96d2069a202fabb$var$parseNumericPattern($b96d2069a202fabb$var$numericPatterns.week, string);
                case "Io":
                    return match.ordinalNumber(string, {
                        unit: "week"
                    });
                default:
                    return $b96d2069a202fabb$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 53;
        },
        set: function(date, _flags, value, options) {
            return $b96d2069a202fabb$var$startOfUTCISOWeek($b96d2069a202fabb$var$setUTCISOWeek(date, value, options), options);
        },
        incompatibleTokens: [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // Day of the month
    d: {
        priority: 90,
        subPriority: 1,
        parse: function(string, token, match, _options) {
            switch(token){
                case "d":
                    return $b96d2069a202fabb$var$parseNumericPattern($b96d2069a202fabb$var$numericPatterns.date, string);
                case "do":
                    return match.ordinalNumber(string, {
                        unit: "date"
                    });
                default:
                    return $b96d2069a202fabb$var$parseNDigits(token.length, string);
            }
        },
        validate: function(date, value, _options) {
            var year = date.getUTCFullYear();
            var isLeapYear = $b96d2069a202fabb$var$isLeapYearIndex(year);
            var month = date.getUTCMonth();
            if (isLeapYear) return value >= 1 && value <= $b96d2069a202fabb$var$DAYS_IN_MONTH_LEAP_YEAR[month];
            else return value >= 1 && value <= $b96d2069a202fabb$var$DAYS_IN_MONTH[month];
        },
        set: function(date, _flags, value, _options) {
            date.setUTCDate(value);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // Day of year
    D: {
        priority: 90,
        subPriority: 1,
        parse: function(string, token, match, _options) {
            switch(token){
                case "D":
                case "DD":
                    return $b96d2069a202fabb$var$parseNumericPattern($b96d2069a202fabb$var$numericPatterns.dayOfYear, string);
                case "Do":
                    return match.ordinalNumber(string, {
                        unit: "date"
                    });
                default:
                    return $b96d2069a202fabb$var$parseNDigits(token.length, string);
            }
        },
        validate: function(date, value, _options) {
            var year = date.getUTCFullYear();
            var isLeapYear = $b96d2069a202fabb$var$isLeapYearIndex(year);
            if (isLeapYear) return value >= 1 && value <= 366;
            else return value >= 1 && value <= 365;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMonth(0, value);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // Day of week
    E: {
        priority: 90,
        parse: function(string, token, match, _options) {
            switch(token){
                // Tue
                case "E":
                case "EE":
                case "EEE":
                    return match.day(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "short",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                // T
                case "EEEEE":
                    return match.day(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                // Tu
                case "EEEEEE":
                    return match.day(string, {
                        width: "short",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                // Tuesday
                case "EEEE":
                default:
                    return match.day(string, {
                        width: "wide",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "short",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 6;
        },
        set: function(date, _flags, value, options) {
            date = $b96d2069a202fabb$var$setUTCDay(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // Local day of week
    e: {
        priority: 90,
        parse: function(string, token, match, options) {
            var valueCallback = function(value) {
                var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
            };
            switch(token){
                // 3
                case "e":
                case "ee":
                    // 03
                    return $b96d2069a202fabb$var$parseNDigits(token.length, string, valueCallback);
                // 3rd
                case "eo":
                    return match.ordinalNumber(string, {
                        unit: "day",
                        valueCallback: valueCallback
                    });
                // Tue
                case "eee":
                    return match.day(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "short",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                // T
                case "eeeee":
                    return match.day(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                // Tu
                case "eeeeee":
                    return match.day(string, {
                        width: "short",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                // Tuesday
                case "eeee":
                default:
                    return match.day(string, {
                        width: "wide",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "short",
                        context: "formatting"
                    }) || match.day(string, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 6;
        },
        set: function(date, _flags, value, options) {
            date = $b96d2069a202fabb$var$setUTCDay(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]
    },
    // Stand-alone local day of week
    c: {
        priority: 90,
        parse: function(string, token, match, options) {
            var valueCallback = function(value) {
                var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
            };
            switch(token){
                // 3
                case "c":
                case "cc":
                    // 03
                    return $b96d2069a202fabb$var$parseNDigits(token.length, string, valueCallback);
                // 3rd
                case "co":
                    return match.ordinalNumber(string, {
                        unit: "day",
                        valueCallback: valueCallback
                    });
                // Tue
                case "ccc":
                    return match.day(string, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || match.day(string, {
                        width: "short",
                        context: "standalone"
                    }) || match.day(string, {
                        width: "narrow",
                        context: "standalone"
                    });
                // T
                case "ccccc":
                    return match.day(string, {
                        width: "narrow",
                        context: "standalone"
                    });
                // Tu
                case "cccccc":
                    return match.day(string, {
                        width: "short",
                        context: "standalone"
                    }) || match.day(string, {
                        width: "narrow",
                        context: "standalone"
                    });
                // Tuesday
                case "cccc":
                default:
                    return match.day(string, {
                        width: "wide",
                        context: "standalone"
                    }) || match.day(string, {
                        width: "abbreviated",
                        context: "standalone"
                    }) || match.day(string, {
                        width: "short",
                        context: "standalone"
                    }) || match.day(string, {
                        width: "narrow",
                        context: "standalone"
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 6;
        },
        set: function(date, _flags, value, options) {
            date = $b96d2069a202fabb$var$setUTCDay(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]
    },
    // ISO day of week
    i: {
        priority: 90,
        parse: function(string, token, match, _options) {
            var valueCallback = function(value) {
                if (value === 0) return 7;
                return value;
            };
            switch(token){
                // 2
                case "i":
                case "ii":
                    // 02
                    return $b96d2069a202fabb$var$parseNDigits(token.length, string);
                // 2nd
                case "io":
                    return match.ordinalNumber(string, {
                        unit: "day"
                    });
                // Tue
                case "iii":
                    return match.day(string, {
                        width: "abbreviated",
                        context: "formatting",
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: "short",
                        context: "formatting",
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: "narrow",
                        context: "formatting",
                        valueCallback: valueCallback
                    });
                // T
                case "iiiii":
                    return match.day(string, {
                        width: "narrow",
                        context: "formatting",
                        valueCallback: valueCallback
                    });
                // Tu
                case "iiiiii":
                    return match.day(string, {
                        width: "short",
                        context: "formatting",
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: "narrow",
                        context: "formatting",
                        valueCallback: valueCallback
                    });
                // Tuesday
                case "iiii":
                default:
                    return match.day(string, {
                        width: "wide",
                        context: "formatting",
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: "abbreviated",
                        context: "formatting",
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: "short",
                        context: "formatting",
                        valueCallback: valueCallback
                    }) || match.day(string, {
                        width: "narrow",
                        context: "formatting",
                        valueCallback: valueCallback
                    });
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 7;
        },
        set: function(date, _flags, value, options) {
            date = $b96d2069a202fabb$var$setUTCISODay(date, value, options);
            date.setUTCHours(0, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]
    },
    // AM or PM
    a: {
        priority: 80,
        parse: function(string, token, match, _options) {
            switch(token){
                case "a":
                case "aa":
                case "aaa":
                    return match.dayPeriod(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.dayPeriod(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "aaaaa":
                    return match.dayPeriod(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "aaaa":
                default:
                    return match.dayPeriod(string, {
                        width: "wide",
                        context: "formatting"
                    }) || match.dayPeriod(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.dayPeriod(string, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours($b96d2069a202fabb$var$dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "b",
            "B",
            "H",
            "K",
            "k",
            "t",
            "T"
        ]
    },
    // AM, PM, midnight
    b: {
        priority: 80,
        parse: function(string, token, match, _options) {
            switch(token){
                case "b":
                case "bb":
                case "bbb":
                    return match.dayPeriod(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.dayPeriod(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "bbbbb":
                    return match.dayPeriod(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "bbbb":
                default:
                    return match.dayPeriod(string, {
                        width: "wide",
                        context: "formatting"
                    }) || match.dayPeriod(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.dayPeriod(string, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours($b96d2069a202fabb$var$dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "a",
            "B",
            "H",
            "K",
            "k",
            "t",
            "T"
        ]
    },
    // in the morning, in the afternoon, in the evening, at night
    B: {
        priority: 80,
        parse: function(string, token, match, _options) {
            switch(token){
                case "B":
                case "BB":
                case "BBB":
                    return match.dayPeriod(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.dayPeriod(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "BBBBB":
                    return match.dayPeriod(string, {
                        width: "narrow",
                        context: "formatting"
                    });
                case "BBBB":
                default:
                    return match.dayPeriod(string, {
                        width: "wide",
                        context: "formatting"
                    }) || match.dayPeriod(string, {
                        width: "abbreviated",
                        context: "formatting"
                    }) || match.dayPeriod(string, {
                        width: "narrow",
                        context: "formatting"
                    });
            }
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours($b96d2069a202fabb$var$dayPeriodEnumToHours(value), 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "a",
            "b",
            "t",
            "T"
        ]
    },
    // Hour [1-12]
    h: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case "h":
                    return $b96d2069a202fabb$var$parseNumericPattern($b96d2069a202fabb$var$numericPatterns.hour12h, string);
                case "ho":
                    return match.ordinalNumber(string, {
                        unit: "hour"
                    });
                default:
                    return $b96d2069a202fabb$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 12;
        },
        set: function(date, _flags, value, _options) {
            var isPM = date.getUTCHours() >= 12;
            if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
            else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
            else date.setUTCHours(value, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]
    },
    // Hour [0-23]
    H: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case "H":
                    return $b96d2069a202fabb$var$parseNumericPattern($b96d2069a202fabb$var$numericPatterns.hour23h, string);
                case "Ho":
                    return match.ordinalNumber(string, {
                        unit: "hour"
                    });
                default:
                    return $b96d2069a202fabb$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 23;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCHours(value, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]
    },
    // Hour [0-11]
    K: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case "K":
                    return $b96d2069a202fabb$var$parseNumericPattern($b96d2069a202fabb$var$numericPatterns.hour11h, string);
                case "Ko":
                    return match.ordinalNumber(string, {
                        unit: "hour"
                    });
                default:
                    return $b96d2069a202fabb$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 11;
        },
        set: function(date, _flags, value, _options) {
            var isPM = date.getUTCHours() >= 12;
            if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
            else date.setUTCHours(value, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "a",
            "b",
            "h",
            "H",
            "k",
            "t",
            "T"
        ]
    },
    // Hour [1-24]
    k: {
        priority: 70,
        parse: function(string, token, match, _options) {
            switch(token){
                case "k":
                    return $b96d2069a202fabb$var$parseNumericPattern($b96d2069a202fabb$var$numericPatterns.hour24h, string);
                case "ko":
                    return match.ordinalNumber(string, {
                        unit: "hour"
                    });
                default:
                    return $b96d2069a202fabb$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 1 && value <= 24;
        },
        set: function(date, _flags, value, _options) {
            var hours = value <= 24 ? value % 24 : value;
            date.setUTCHours(hours, 0, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]
    },
    // Minute
    m: {
        priority: 60,
        parse: function(string, token, match, _options) {
            switch(token){
                case "m":
                    return $b96d2069a202fabb$var$parseNumericPattern($b96d2069a202fabb$var$numericPatterns.minute, string);
                case "mo":
                    return match.ordinalNumber(string, {
                        unit: "minute"
                    });
                default:
                    return $b96d2069a202fabb$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 59;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMinutes(value, 0, 0);
            return date;
        },
        incompatibleTokens: [
            "t",
            "T"
        ]
    },
    // Second
    s: {
        priority: 50,
        parse: function(string, token, match, _options) {
            switch(token){
                case "s":
                    return $b96d2069a202fabb$var$parseNumericPattern($b96d2069a202fabb$var$numericPatterns.second, string);
                case "so":
                    return match.ordinalNumber(string, {
                        unit: "second"
                    });
                default:
                    return $b96d2069a202fabb$var$parseNDigits(token.length, string);
            }
        },
        validate: function(_date, value, _options) {
            return value >= 0 && value <= 59;
        },
        set: function(date, _flags, value, _options) {
            date.setUTCSeconds(value, 0);
            return date;
        },
        incompatibleTokens: [
            "t",
            "T"
        ]
    },
    // Fraction of second
    S: {
        priority: 30,
        parse: function(string, token, _match, _options) {
            var valueCallback = function(value) {
                return Math.floor(value * Math.pow(10, -token.length + 3));
            };
            return $b96d2069a202fabb$var$parseNDigits(token.length, string, valueCallback);
        },
        set: function(date, _flags, value, _options) {
            date.setUTCMilliseconds(value);
            return date;
        },
        incompatibleTokens: [
            "t",
            "T"
        ]
    },
    // Timezone (ISO-8601. +00:00 is `'Z'`)
    X: {
        priority: 10,
        parse: function(string, token, _match, _options) {
            switch(token){
                case "X":
                    return $b96d2069a202fabb$var$parseTimezonePattern($b96d2069a202fabb$var$timezonePatterns.basicOptionalMinutes, string);
                case "XX":
                    return $b96d2069a202fabb$var$parseTimezonePattern($b96d2069a202fabb$var$timezonePatterns.basic, string);
                case "XXXX":
                    return $b96d2069a202fabb$var$parseTimezonePattern($b96d2069a202fabb$var$timezonePatterns.basicOptionalSeconds, string);
                case "XXXXX":
                    return $b96d2069a202fabb$var$parseTimezonePattern($b96d2069a202fabb$var$timezonePatterns.extendedOptionalSeconds, string);
                case "XXX":
                default:
                    return $b96d2069a202fabb$var$parseTimezonePattern($b96d2069a202fabb$var$timezonePatterns.extended, string);
            }
        },
        set: function(date, flags, value, _options) {
            if (flags.timestampIsSet) return date;
            return new Date(date.getTime() - value);
        },
        incompatibleTokens: [
            "t",
            "T",
            "x"
        ]
    },
    // Timezone (ISO-8601)
    x: {
        priority: 10,
        parse: function(string, token, _match, _options) {
            switch(token){
                case "x":
                    return $b96d2069a202fabb$var$parseTimezonePattern($b96d2069a202fabb$var$timezonePatterns.basicOptionalMinutes, string);
                case "xx":
                    return $b96d2069a202fabb$var$parseTimezonePattern($b96d2069a202fabb$var$timezonePatterns.basic, string);
                case "xxxx":
                    return $b96d2069a202fabb$var$parseTimezonePattern($b96d2069a202fabb$var$timezonePatterns.basicOptionalSeconds, string);
                case "xxxxx":
                    return $b96d2069a202fabb$var$parseTimezonePattern($b96d2069a202fabb$var$timezonePatterns.extendedOptionalSeconds, string);
                case "xxx":
                default:
                    return $b96d2069a202fabb$var$parseTimezonePattern($b96d2069a202fabb$var$timezonePatterns.extended, string);
            }
        },
        set: function(date, flags, value, _options) {
            if (flags.timestampIsSet) return date;
            return new Date(date.getTime() - value);
        },
        incompatibleTokens: [
            "t",
            "T",
            "X"
        ]
    },
    // Seconds timestamp
    t: {
        priority: 40,
        parse: function(string, _token, _match, _options) {
            return $b96d2069a202fabb$var$parseAnyDigitsSigned(string);
        },
        set: function(_date, _flags, value, _options) {
            return [
                new Date(value * 1000),
                {
                    timestampIsSet: true
                }
            ];
        },
        incompatibleTokens: "*"
    },
    // Milliseconds timestamp
    T: {
        priority: 20,
        parse: function(string, _token, _match, _options) {
            return $b96d2069a202fabb$var$parseAnyDigitsSigned(string);
        },
        set: function(_date, _flags, value, _options) {
            return [
                new Date(value),
                {
                    timestampIsSet: true
                }
            ];
        },
        incompatibleTokens: "*"
    }
};
var $b96d2069a202fabb$var$TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $b96d2069a202fabb$var$formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $b96d2069a202fabb$var$longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $b96d2069a202fabb$var$escapedStringRegExp$1 = /^'([^]*?)'?$/;
var $b96d2069a202fabb$var$doubleQuoteRegExp$1 = /''/g;
var $b96d2069a202fabb$var$notWhitespaceRegExp = /\S/;
var $b96d2069a202fabb$var$unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Old `parse` was renamed to `toDate`.
 *   Now `parse` is a new function which parses a string using a provided format.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward (toDate no longer accepts a string)
 *   toDate(1392098430000) // Unix to timestamp
 *   toDate(new Date(2014, 1, 11, 11, 30, 30)) // Cloning the date
 *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
 *   ```
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */ function $b96d2069a202fabb$var$parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
    $b96d2069a202fabb$var$requiredArgs(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var options = dirtyOptions || {};
    var locale$1 = options.locale || $b96d2069a202fabb$var$locale;
    if (!locale$1.match) throw new RangeError("locale must contain match property");
    var localeFirstWeekContainsDate = locale$1.options && locale$1.options.firstWeekContainsDate;
    var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : $b96d2069a202fabb$var$toInteger(localeFirstWeekContainsDate);
    var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : $b96d2069a202fabb$var$toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var localeWeekStartsOn = locale$1.options && locale$1.options.weekStartsOn;
    var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : $b96d2069a202fabb$var$toInteger(localeWeekStartsOn);
    var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : $b96d2069a202fabb$var$toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (formatString === "") {
        if (dateString === "") return $b96d2069a202fabb$var$toDate(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale$1 // If timezone isn't specified, it will be set to the system timezone
    };
    var setters = [
        {
            priority: $b96d2069a202fabb$var$TIMEZONE_UNIT_PRIORITY,
            subPriority: -1,
            set: $b96d2069a202fabb$var$dateToSystemTimezone,
            index: 0
        }
    ];
    var i;
    var tokens = formatString.match($b96d2069a202fabb$var$longFormattingTokensRegExp$1).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = $b96d2069a202fabb$var$longFormatters[firstCharacter];
            return longFormatter(substring, locale$1.formatLong, subFnOptions);
        }
        return substring;
    }).join("").match($b96d2069a202fabb$var$formattingTokensRegExp$1);
    var usedTokens = [];
    for(i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (!options.useAdditionalWeekYearTokens && $b96d2069a202fabb$var$isProtectedWeekYearToken(token)) $b96d2069a202fabb$var$throwProtectedError(token, formatString, dirtyDateString);
        if (!options.useAdditionalDayOfYearTokens && $b96d2069a202fabb$var$isProtectedDayOfYearToken(token)) $b96d2069a202fabb$var$throwProtectedError(token, formatString, dirtyDateString);
        var firstCharacter = token[0];
        var parser = $b96d2069a202fabb$var$parsers[firstCharacter];
        if (parser) {
            var incompatibleTokens = parser.incompatibleTokens;
            if (Array.isArray(incompatibleTokens)) {
                var incompatibleToken = void 0;
                for(var _i = 0; _i < usedTokens.length; _i++){
                    var usedToken = usedTokens[_i].token;
                    if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
                        incompatibleToken = usedTokens[_i];
                        break;
                    }
                }
                if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
            } else if (parser.incompatibleTokens === "*" && usedTokens.length) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            var parseResult = parser.parse(dateString, token, locale$1.match, subFnOptions);
            if (!parseResult) return new Date(NaN);
            setters.push({
                priority: parser.priority,
                subPriority: parser.subPriority || 0,
                set: parser.set,
                validate: parser.validate,
                value: parseResult.value,
                index: setters.length
            });
            dateString = parseResult.rest;
        } else {
            if (firstCharacter.match($b96d2069a202fabb$var$unescapedLatinCharacterRegExp$1)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
             // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $b96d2069a202fabb$var$cleanEscapedString$1(token);
             // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
            else return new Date(NaN);
        }
    } // Check if the remaining input contains something other than whitespace
    if (dateString.length > 0 && $b96d2069a202fabb$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = $b96d2069a202fabb$var$toDate(dirtyReferenceDate);
    if (isNaN(date)) return new Date(NaN);
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37
    var utcDate = $b96d2069a202fabb$var$subMilliseconds(date, $b96d2069a202fabb$var$getTimezoneOffsetInMilliseconds(date));
    var flags = {};
    for(i = 0; i < uniquePrioritySetters.length; i++){
        var setter = uniquePrioritySetters[i];
        if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) return new Date(NaN);
        var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)
        if (result[0]) {
            utcDate = result[0];
            $b96d2069a202fabb$var$assign(flags, result[1]); // Result is date
        } else utcDate = result;
    }
    return utcDate;
}
function $b96d2069a202fabb$var$dateToSystemTimezone(date, flags) {
    if (flags.timestampIsSet) return date;
    var convertedDate = new Date(0);
    convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
    convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
    return convertedDate;
}
function $b96d2069a202fabb$var$cleanEscapedString$1(input) {
    return input.match($b96d2069a202fabb$var$escapedStringRegExp$1)[1].replace($b96d2069a202fabb$var$doubleQuoteRegExp$1, "'");
}
var $b96d2069a202fabb$var$date = Object.assign({}, $b96d2069a202fabb$var$defaultType);
$b96d2069a202fabb$var$date.isRight = true;
$b96d2069a202fabb$var$date.compare = function(x, y, column) {
    function cook(d) {
        if (column && column.dateInputFormat) return $b96d2069a202fabb$var$parse("".concat(d), "".concat(column.dateInputFormat), new Date());
        return d;
    }
    x = cook(x);
    y = cook(y);
    if (!$b96d2069a202fabb$var$isValid(x)) return -1;
    if (!$b96d2069a202fabb$var$isValid(y)) return 1;
    return $b96d2069a202fabb$var$compareAsc(x, y);
};
$b96d2069a202fabb$var$date.format = function(v, column) {
    if (v === undefined || v === null) return ""; // convert to date
    var date = $b96d2069a202fabb$var$parse(v, column.dateInputFormat, new Date());
    if ($b96d2069a202fabb$var$isValid(date)) return $b96d2069a202fabb$var$format(date, column.dateOutputFormat);
    console.error('Not a valid date: "'.concat(v, '"'));
    return null;
};
var $b96d2069a202fabb$var$date$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    "default": $b96d2069a202fabb$var$date
});
var $b96d2069a202fabb$var$number = Object.assign({}, $b96d2069a202fabb$var$defaultType);
$b96d2069a202fabb$var$number.isRight = true;
$b96d2069a202fabb$var$number.filterPredicate = function(rowval, filter) {
    return $b96d2069a202fabb$var$number.compare(rowval, filter) === 0;
};
$b96d2069a202fabb$var$number.compare = function(x, y) {
    function cook(d) {
        // if d is null or undefined we give it the smallest
        // possible value
        if (d === undefined || d === null) return -Infinity;
        return d.indexOf(".") >= 0 ? parseFloat(d) : parseInt(d, 10);
    }
    x = typeof x === "number" ? x : cook(x);
    y = typeof y === "number" ? y : cook(y);
    if (x < y) return -1;
    if (x > y) return 1;
    return 0;
};
var $b96d2069a202fabb$var$number$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    "default": $b96d2069a202fabb$var$number
});
var $b96d2069a202fabb$var$decimal = Object.assign({}, $b96d2069a202fabb$var$number);
$b96d2069a202fabb$var$decimal.format = function(v) {
    if (v === undefined || v === null) return "";
    return parseFloat(Math.round(v * 100) / 100).toFixed(2);
};
var $b96d2069a202fabb$var$decimal$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    "default": $b96d2069a202fabb$var$decimal
});
var $b96d2069a202fabb$var$percentage = Object.assign({}, $b96d2069a202fabb$var$number);
$b96d2069a202fabb$var$percentage.format = function(v) {
    if (v === undefined || v === null) return "";
    return "".concat(parseFloat(v * 100).toFixed(2), "%");
};
var $b96d2069a202fabb$var$percentage$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    "default": $b96d2069a202fabb$var$percentage
});
var $b96d2069a202fabb$var$_boolean = Object.assign({}, $b96d2069a202fabb$var$defaultType);
$b96d2069a202fabb$var$_boolean.isRight = true;
$b96d2069a202fabb$var$_boolean.filterPredicate = function(rowval, filter) {
    return $b96d2069a202fabb$var$_boolean.compare(rowval, filter) === 0;
};
$b96d2069a202fabb$var$_boolean.compare = function(x, y) {
    function cook(d) {
        if (typeof d === "boolean") return d ? 1 : 0;
        if (typeof d === "string") return d === "true" ? 1 : 0;
        return -Infinity;
    }
    x = cook(x);
    y = cook(y);
    if (x < y) return -1;
    if (x > y) return 1;
    return 0;
};
var $b96d2069a202fabb$var$_boolean$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    "default": $b96d2069a202fabb$var$_boolean
});
var $b96d2069a202fabb$var$index = {
    date: $b96d2069a202fabb$var$date$1,
    decimal: $b96d2069a202fabb$var$decimal$1,
    number: $b96d2069a202fabb$var$number$1,
    percentage: $b96d2069a202fabb$var$percentage$1,
    "boolean": $b96d2069a202fabb$var$_boolean$1
};
var $b96d2069a202fabb$var$dataTypes = {};
var $b96d2069a202fabb$var$coreDataTypes = $b96d2069a202fabb$var$index;
Object.keys($b96d2069a202fabb$var$coreDataTypes).forEach(function(key) {
    var compName = key.replace(/^\.\//, "").replace(/\.js/, "");
    $b96d2069a202fabb$var$dataTypes[compName] = $b96d2069a202fabb$var$coreDataTypes[key]["default"];
});
var $b96d2069a202fabb$var$script$6 = {
    name: "vue-good-table",
    props: {
        isLoading: {
            "default": null,
            type: Boolean
        },
        maxHeight: {
            "default": null,
            type: String
        },
        fixedHeader: Boolean,
        theme: {
            "default": ""
        },
        mode: {
            "default": "local"
        },
        // could be remote
        totalRows: {},
        // required if mode = 'remote'
        styleClass: {
            "default": "vgt-table bordered"
        },
        columns: {},
        rows: {},
        lineNumbers: Boolean,
        responsive: {
            "default": true,
            type: Boolean
        },
        rtl: Boolean,
        rowStyleClass: {
            "default": null,
            type: [
                Function,
                String
            ]
        },
        compactMode: Boolean,
        groupOptions: {
            "default": function _default() {
                return {
                    enabled: false,
                    collapsable: false,
                    rowKey: null
                };
            }
        },
        selectOptions: {
            "default": function _default() {
                return {
                    enabled: false,
                    selectionInfoClass: "",
                    selectionText: "rows selected",
                    clearSelectionText: "clear",
                    disableSelectInfo: false,
                    selectAllByGroup: false
                };
            }
        },
        // sort
        sortOptions: {
            "default": function _default() {
                return {
                    enabled: true,
                    multipleColumns: true,
                    initialSortBy: {}
                };
            }
        },
        // pagination
        paginationOptions: {
            "default": function _default() {
                var _ref;
                return _ref = {
                    enabled: false,
                    position: "bottom",
                    perPage: 10,
                    perPageDropdown: null,
                    perPageDropdownEnabled: true
                }, $b96d2069a202fabb$var$_defineProperty(_ref, "position", "bottom"), $b96d2069a202fabb$var$_defineProperty(_ref, "dropdownAllowAll", true), $b96d2069a202fabb$var$_defineProperty(_ref, "mode", "records"), $b96d2069a202fabb$var$_defineProperty(_ref, "infoFn", null), $b96d2069a202fabb$var$_defineProperty(_ref, "jumpFirstOrLast", false), _ref;
            }
        },
        searchOptions: {
            "default": function _default() {
                return {
                    enabled: false,
                    trigger: null,
                    externalQuery: null,
                    searchFn: null,
                    placeholder: "Search Table"
                };
            }
        }
    },
    data: function data() {
        return {
            // loading state for remote mode
            tableLoading: false,
            // text options
            firstText: "First",
            lastText: "Last",
            nextText: "Next",
            prevText: "Previous",
            rowsPerPageText: "Rows per page",
            ofText: "of",
            allText: "All",
            pageText: "page",
            // internal select options
            selectable: false,
            selectOnCheckboxOnly: false,
            selectAllByPage: true,
            disableSelectInfo: false,
            selectionInfoClass: "",
            selectionText: "rows selected",
            clearSelectionText: "clear",
            // keys for rows that are currently expanded
            maintainExpanded: true,
            expandedRowKeys: new Set(),
            // internal sort options
            sortable: true,
            defaultSortBy: null,
            multipleColumnSort: true,
            // internal search options
            searchEnabled: false,
            searchTrigger: null,
            externalSearchQuery: null,
            searchFn: null,
            searchPlaceholder: "Search Table",
            searchSkipDiacritics: false,
            // internal pagination options
            perPage: null,
            paginate: false,
            paginateOnTop: false,
            paginateOnBottom: true,
            customRowsPerPageDropdown: [],
            paginateDropdownAllowAll: true,
            paginationMode: "records",
            paginationInfoFn: null,
            currentPage: 1,
            currentPerPage: 10,
            sorts: [],
            globalSearchTerm: "",
            filteredRows: [],
            columnFilters: {},
            forceSearch: false,
            sortChanged: false,
            dataTypes: $b96d2069a202fabb$var$dataTypes || {}
        };
    },
    watch: {
        rows: {
            handler: function handler() {
                this.$emit("update:isLoading", false);
                this.filterRows(this.columnFilters, false);
            },
            deep: true,
            immediate: true
        },
        selectOptions: {
            handler: function handler() {
                this.initializeSelect();
            },
            deep: true,
            immediate: true
        },
        paginationOptions: {
            handler: function handler(newValue, oldValue) {
                if (!$b96d2069a202fabb$var$lodash_isequal(newValue, oldValue)) this.initializePagination();
            },
            deep: true,
            immediate: true
        },
        searchOptions: {
            handler: function handler() {
                if (this.searchOptions.externalQuery !== undefined && this.searchOptions.externalQuery !== this.searchTerm) {
                    //* we need to set searchTerm to externalQuery first.
                    this.externalSearchQuery = this.searchOptions.externalQuery;
                    this.handleSearch();
                }
                this.initializeSearch();
            },
            deep: true,
            immediate: true
        },
        sortOptions: {
            handler: function handler(newValue, oldValue) {
                if (!$b96d2069a202fabb$var$lodash_isequal(newValue, oldValue)) this.initializeSort();
            },
            deep: true
        },
        selectedRows: function selectedRows(newValue, oldValue) {
            if (!$b96d2069a202fabb$var$lodash_isequal(newValue, oldValue)) this.$emit("on-selected-rows-change", {
                selectedRows: this.selectedRows
            });
        }
    },
    computed: {
        tableStyles: function tableStyles() {
            if (this.compactMode) return this.tableStyleClasses + "vgt-compact";
            else return this.tableStyleClasses;
        },
        hasFooterSlot: function hasFooterSlot() {
            return !!this.$slots["table-actions-bottom"];
        },
        wrapperStyles: function wrapperStyles() {
            return {
                overflow: "scroll-y",
                maxHeight: this.maxHeight ? this.maxHeight : "auto"
            };
        },
        rowKeyField: function rowKeyField() {
            return this.groupOptions.rowKey || "vgt_header_id";
        },
        hasHeaderRowTemplate: function hasHeaderRowTemplate() {
            return !!this.$slots["table-header-row"] || !!this.$scopedSlots["table-header-row"];
        },
        showEmptySlot: function showEmptySlot() {
            if (!this.paginated.length) return true;
            if (this.paginated[0].label === "no groups" && !this.paginated[0].children.length) return true;
            return false;
        },
        allSelected: function allSelected() {
            return this.selectedRowCount > 0 && (this.selectAllByPage && this.selectedPageRowsCount === this.totalPageRowCount || !this.selectAllByPage && this.selectedRowCount === this.totalRowCount);
        },
        allSelectedIndeterminate: function allSelectedIndeterminate() {
            return !this.allSelected && (this.selectAllByPage && this.selectedPageRowsCount > 0 || !this.selectAllByPage && this.selectedRowCount > 0);
        },
        selectionInfo: function selectionInfo() {
            return "".concat(this.selectedRowCount, " ").concat(this.selectionText);
        },
        selectedRowCount: function selectedRowCount() {
            return this.selectedRows.length;
        },
        selectedPageRowsCount: function selectedPageRowsCount() {
            return this.selectedPageRows.length;
        },
        selectedPageRows: function selectedPageRows() {
            var selectedRows = [];
            this.paginated.forEach(function(headerRow) {
                headerRow.children.forEach(function(row) {
                    if (row.vgtSelected) selectedRows.push(row);
                });
            });
            return selectedRows;
        },
        selectedRows: function selectedRows() {
            var selectedRows = [];
            this.processedRows.forEach(function(headerRow) {
                headerRow.children.forEach(function(row) {
                    if (row.vgtSelected) selectedRows.push(row);
                });
            });
            return selectedRows.sort(function(r1, r2) {
                return r1.originalIndex - r2.originalIndex;
            });
        },
        fullColspan: function fullColspan() {
            var fullColspan = 0;
            for(var i = 0; i < this.columns.length; i += 1)if (!this.columns[i].hidden) fullColspan += 1;
            if (this.lineNumbers) fullColspan++;
            if (this.selectable) fullColspan++;
            return fullColspan;
        },
        groupHeaderOnTop: function groupHeaderOnTop() {
            if (this.groupOptions && this.groupOptions.enabled && this.groupOptions.headerPosition && this.groupOptions.headerPosition === "bottom") return false;
            if (this.groupOptions && this.groupOptions.enabled) return true; // will only get here if groupOptions is false
            return false;
        },
        groupHeaderOnBottom: function groupHeaderOnBottom() {
            if (this.groupOptions && this.groupOptions.enabled && this.groupOptions.headerPosition && this.groupOptions.headerPosition === "bottom") return true;
            return false;
        },
        totalRowCount: function totalRowCount() {
            var total = this.processedRows.reduce(function(total, headerRow) {
                var childrenCount = headerRow.children ? headerRow.children.length : 0;
                return total + childrenCount;
            }, 0);
            return total;
        },
        totalPageRowCount: function totalPageRowCount() {
            var total = this.paginated.reduce(function(total, headerRow) {
                var childrenCount = headerRow.children ? headerRow.children.length : 0;
                return total + childrenCount;
            }, 0);
            return total;
        },
        wrapStyleClasses: function wrapStyleClasses() {
            var classes = "vgt-wrap";
            if (this.rtl) classes += " rtl";
            classes += " ".concat(this.theme);
            return classes;
        },
        tableStyleClasses: function tableStyleClasses() {
            var classes = this.styleClass;
            classes += " ".concat(this.theme);
            return classes;
        },
        searchTerm: function searchTerm() {
            return this.externalSearchQuery != null ? this.externalSearchQuery : this.globalSearchTerm;
        },
        //
        globalSearchAllowed: function globalSearchAllowed() {
            if (this.searchEnabled && !!this.globalSearchTerm && this.searchTrigger !== "enter") return true;
            if (this.externalSearchQuery != null && this.searchTrigger !== "enter") return true;
            if (this.forceSearch) {
                this.forceSearch = false;
                return true;
            }
            return false;
        },
        // this is done everytime sortColumn
        // or sort type changes
        //----------------------------------------
        processedRows: function processedRows() {
            var _this = this;
            // we only process rows when mode is local
            var computedRows = this.filteredRows;
            if (this.mode === "remote") return computedRows;
             // take care of the global filter here also
            if (this.globalSearchAllowed) {
                // here also we need to de-construct and then
                // re-construct the rows.
                var allRows = [];
                this.filteredRows.forEach(function(headerRow) {
                    allRows.push.apply(allRows, $b96d2069a202fabb$var$_toConsumableArray(headerRow.children));
                });
                var filteredRows = [];
                allRows.forEach(function(row) {
                    for(var i = 0; i < _this.columns.length; i += 1){
                        var col = _this.columns[i]; // if col does not have search disabled,
                        if (!col.globalSearchDisabled) {
                            // if a search function is provided,
                            // use that for searching, otherwise,
                            // use the default search behavior
                            if (_this.searchFn) {
                                var foundMatch = _this.searchFn(row, col, _this.collectFormatted(row, col), _this.searchTerm);
                                if (foundMatch) {
                                    filteredRows.push(row);
                                    break; // break the loop
                                }
                            } else {
                                // comparison
                                var matched = $b96d2069a202fabb$var$defaultType.filterPredicate(_this.collectFormatted(row, col), _this.searchTerm, _this.searchSkipDiacritics);
                                if (matched) {
                                    filteredRows.push(row);
                                    break; // break loop
                                }
                            }
                        }
                    }
                }); // this is where we emit on search
                this.$emit("on-search", {
                    searchTerm: this.searchTerm,
                    rowCount: filteredRows.length
                }); // here we need to reconstruct the nested structure
                // of rows
                computedRows = [];
                this.filteredRows.forEach(function(headerRow) {
                    var i = headerRow.vgt_header_id;
                    var children = filteredRows.filter(function(r) {
                        return r.vgt_id === i;
                    });
                    if (children.length) {
                        var newHeaderRow = JSON.parse(JSON.stringify(headerRow));
                        newHeaderRow.children = children;
                        computedRows.push(newHeaderRow);
                    }
                });
            }
            if (this.sorts.length) //* we need to sort
            computedRows.forEach(function(cRows) {
                cRows.children.sort(function(xRow, yRow) {
                    //* we need to get column for each sort
                    var sortValue;
                    for(var i = 0; i < _this.sorts.length; i += 1){
                        var srt = _this.sorts[i];
                        if (srt.type === $b96d2069a202fabb$var$SORT_TYPES.None) //* if no sort, we need to use the original index to sort.
                        sortValue = sortValue || xRow.originalIndex - yRow.originalIndex;
                        else {
                            var column = _this.getColumnForField(srt.field);
                            var xvalue = _this.collect(xRow, srt.field);
                            var yvalue = _this.collect(yRow, srt.field); //* if a custom sort function has been provided we use that
                            var sortFn = column.sortFn;
                            if (sortFn && typeof sortFn === "function") sortValue = sortValue || sortFn(xvalue, yvalue, column, xRow, yRow) * (srt.type === $b96d2069a202fabb$var$SORT_TYPES.Descending ? -1 : 1);
                            else //* else we use our own sort
                            sortValue = sortValue || column.typeDef.compare(xvalue, yvalue, column) * (srt.type === $b96d2069a202fabb$var$SORT_TYPES.Descending ? -1 : 1);
                        }
                    }
                    return sortValue;
                });
            });
             // if the filtering is event based, we need to maintain filter
            // rows
            if (this.searchTrigger === "enter") this.filteredRows = computedRows;
            return computedRows;
        },
        paginated: function paginated() {
            var _this2 = this;
            if (!this.processedRows.length) return [];
            if (this.mode === "remote") return this.processedRows;
             //* flatten the rows for paging.
            var paginatedRows = [];
            this.processedRows.forEach(function(childRows) {
                var _paginatedRows;
                //* only add headers when group options are enabled.
                if (_this2.groupOptions.enabled) paginatedRows.push(childRows);
                (_paginatedRows = paginatedRows).push.apply(_paginatedRows, $b96d2069a202fabb$var$_toConsumableArray(childRows.children));
            });
            if (this.paginate) {
                var pageStart = (this.currentPage - 1) * this.currentPerPage; // in case of filtering we might be on a page that is
                // not relevant anymore
                // also, if setting to all, current page will not be valid
                if (pageStart >= paginatedRows.length || this.currentPerPage === -1) {
                    this.currentPage = 1;
                    pageStart = 0;
                } // calculate page end now
                var pageEnd = paginatedRows.length + 1; // if the setting is not set to 'all'
                if (this.currentPerPage !== -1) pageEnd = this.currentPage * this.currentPerPage;
                paginatedRows = paginatedRows.slice(pageStart, pageEnd);
            } // reconstruct paginated rows here
            var reconstructedRows = [];
            paginatedRows.forEach(function(flatRow) {
                //* header row?
                if (flatRow.vgt_header_id !== undefined) {
                    _this2.handleExpanded(flatRow);
                    var newHeaderRow = JSON.parse(JSON.stringify(flatRow));
                    newHeaderRow.children = [];
                    reconstructedRows.push(newHeaderRow);
                } else {
                    //* child row
                    var hRow = reconstructedRows.find(function(r) {
                        return r.vgt_header_id === flatRow.vgt_id;
                    });
                    if (!hRow) {
                        hRow = _this2.processedRows.find(function(r) {
                            return r.vgt_header_id === flatRow.vgt_id;
                        });
                        if (hRow) {
                            hRow = JSON.parse(JSON.stringify(hRow));
                            hRow.children = [];
                            reconstructedRows.push(hRow);
                        }
                    }
                    hRow.children.push(flatRow);
                }
            });
            return reconstructedRows;
        },
        originalRows: function originalRows() {
            var rows = this.rows && this.rows.length ? JSON.parse(JSON.stringify(this.rows)) : [];
            var nestedRows = [];
            if (!this.groupOptions.enabled) nestedRows = this.handleGrouped([
                {
                    label: "no groups",
                    children: rows
                }
            ]);
            else nestedRows = this.handleGrouped(rows);
             // we need to preserve the original index of
            // rows so lets do that
            var index = 0;
            nestedRows.forEach(function(headerRow) {
                headerRow.children.forEach(function(row) {
                    row.originalIndex = index++;
                });
            });
            return nestedRows;
        },
        typedColumns: function typedColumns() {
            var columns = this.columns;
            for(var i = 0; i < this.columns.length; i++){
                var column = columns[i];
                column.typeDef = this.dataTypes[column.type] || $b96d2069a202fabb$var$defaultType;
            }
            return columns;
        },
        hasRowClickListener: function hasRowClickListener() {
            return this.$listeners && this.$listeners["on-row-click"];
        }
    },
    methods: {
        //* we need to check for expanded row state here
        //* to maintain it when sorting/filtering
        handleExpanded: function handleExpanded(headerRow) {
            if (this.maintainExpanded && this.expandedRowKeys.has(headerRow[this.rowKeyField])) this.$set(headerRow, "vgtIsExpanded", true);
            else this.$set(headerRow, "vgtIsExpanded", false);
        },
        toggleExpand: function toggleExpand(id) {
            var _this3 = this;
            var headerRow = this.filteredRows.find(function(r) {
                return r[_this3.rowKeyField] === id;
            });
            if (headerRow) this.$set(headerRow, "vgtIsExpanded", !headerRow.vgtIsExpanded);
            if (this.maintainExpanded && headerRow.vgtIsExpanded) this.expandedRowKeys.add(headerRow[this.rowKeyField]);
            else this.expandedRowKeys["delete"](headerRow[this.rowKeyField]);
        },
        expandAll: function expandAll() {
            var _this4 = this;
            this.filteredRows.forEach(function(row) {
                _this4.$set(row, "vgtIsExpanded", true);
                if (_this4.maintainExpanded) _this4.expandedRowKeys.add(row[_this4.rowKeyField]);
            });
        },
        collapseAll: function collapseAll() {
            var _this5 = this;
            this.filteredRows.forEach(function(row) {
                _this5.$set(row, "vgtIsExpanded", false);
                _this5.expandedRowKeys.clear();
            });
        },
        getColumnForField: function getColumnForField(field) {
            for(var i = 0; i < this.typedColumns.length; i += 1){
                if (this.typedColumns[i].field === field) return this.typedColumns[i];
            }
        },
        handleSearch: function handleSearch() {
            this.resetTable(); // for remote mode, we need to emit on-search
            if (this.mode === "remote") this.$emit("on-search", {
                searchTerm: this.searchTerm
            });
        },
        reset: function reset() {
            this.initializeSort();
            this.changePage(1);
            this.$refs["table-header-primary"].reset(true);
            if (this.$refs["table-header-secondary"]) this.$refs["table-header-secondary"].reset(true);
        },
        emitSelectedRows: function emitSelectedRows() {
            this.$emit("on-select-all", {
                selected: this.selectedRowCount === this.totalRowCount,
                selectedRows: this.selectedRows
            });
        },
        unselectAllInternal: function unselectAllInternal(forceAll) {
            var _this6 = this;
            var rows = this.selectAllByPage && !forceAll ? this.paginated : this.filteredRows;
            rows.forEach(function(headerRow, i) {
                headerRow.children.forEach(function(row, j) {
                    _this6.$set(row, "vgtSelected", false);
                });
            });
            this.emitSelectedRows();
        },
        toggleSelectAll: function toggleSelectAll() {
            var _this7 = this;
            if (this.allSelected) {
                this.unselectAllInternal();
                return;
            }
            var rows = this.selectAllByPage ? this.paginated : this.filteredRows;
            rows.forEach(function(headerRow) {
                headerRow.children.forEach(function(row) {
                    _this7.$set(row, "vgtSelected", true);
                });
            });
            this.emitSelectedRows();
        },
        toggleSelectGroup: function toggleSelectGroup(event, headerRow) {
            var _this8 = this;
            headerRow.children.forEach(function(row) {
                _this8.$set(row, "vgtSelected", event.checked);
            });
        },
        changePage: function changePage(value) {
            var enabled = this.paginate;
            var _this$$refs = this.$refs, paginationBottom = _this$$refs.paginationBottom, paginationTop = _this$$refs.paginationTop;
            if (enabled) {
                if (this.paginateOnTop && paginationTop) paginationTop.currentPage = value;
                if (this.paginateOnBottom && paginationBottom) paginationBottom.currentPage = value;
                 // we also need to set the currentPage
                // for table.
                this.currentPage = value;
            }
        },
        pageChangedEvent: function pageChangedEvent() {
            return {
                currentPage: this.currentPage,
                currentPerPage: this.currentPerPage,
                total: Math.floor(this.totalRowCount / this.currentPerPage)
            };
        },
        pageChanged: function pageChanged(pagination) {
            this.currentPage = pagination.currentPage;
            if (!pagination.noEmit) {
                var pageChangedEvent = this.pageChangedEvent();
                pageChangedEvent.prevPage = pagination.prevPage;
                this.$emit("on-page-change", pageChangedEvent);
                if (this.mode === "remote") this.$emit("update:isLoading", true);
            }
        },
        perPageChanged: function perPageChanged(pagination) {
            this.currentPerPage = pagination.currentPerPage; // ensure that both sides of pagination are in agreement
            // this fixes changes during position = 'both'
            var paginationPosition = this.paginationOptions.position;
            if (this.$refs.paginationTop && (paginationPosition === "top" || paginationPosition === "both")) this.$refs.paginationTop.currentPerPage = this.currentPerPage;
            if (this.$refs.paginationBottom && (paginationPosition === "bottom" || paginationPosition === "both")) this.$refs.paginationBottom.currentPerPage = this.currentPerPage;
             //* update perPage also
            var perPageChangedEvent = this.pageChangedEvent();
            this.$emit("on-per-page-change", perPageChangedEvent);
            if (this.mode === "remote") this.$emit("update:isLoading", true);
        },
        changeSort: function changeSort(sorts) {
            this.sorts = sorts;
            this.$emit("on-sort-change", sorts); // every time we change sort we need to reset to page 1
            this.changePage(1); // if the mode is remote, we don't need to do anything
            // after this. just set table loading to true
            if (this.mode === "remote") {
                this.$emit("update:isLoading", true);
                return;
            }
            this.sortChanged = true;
        },
        // checkbox click should always do the following
        onCheckboxClicked: function onCheckboxClicked(row, index, event) {
            this.$set(row, "vgtSelected", !row.vgtSelected);
            this.$emit("on-row-click", {
                row: row,
                pageIndex: index,
                selected: !!row.vgtSelected,
                event: event
            });
        },
        onRowDoubleClicked: function onRowDoubleClicked(row, index, event) {
            this.$emit("on-row-dblclick", {
                row: row,
                pageIndex: index,
                selected: !!row.vgtSelected,
                event: event
            });
        },
        onRowClicked: function onRowClicked(row, index, event) {
            if (this.selectable && !this.selectOnCheckboxOnly) this.$set(row, "vgtSelected", !row.vgtSelected);
            this.$emit("on-row-click", {
                row: row,
                pageIndex: index,
                selected: !!row.vgtSelected,
                event: event
            });
        },
        onRowAuxClicked: function onRowAuxClicked(row, index, event) {
            this.$emit("on-row-aux-click", {
                row: row,
                pageIndex: index,
                selected: !!row.vgtSelected,
                event: event
            });
        },
        onCellClicked: function onCellClicked(row, column, rowIndex, event) {
            this.$emit("on-cell-click", {
                row: row,
                column: column,
                rowIndex: rowIndex,
                event: event
            });
        },
        onMouseenter: function onMouseenter(row, index) {
            this.$emit("on-row-mouseenter", {
                row: row,
                pageIndex: index
            });
        },
        onMouseleave: function onMouseleave(row, index) {
            this.$emit("on-row-mouseleave", {
                row: row,
                pageIndex: index
            });
        },
        searchTableOnEnter: function searchTableOnEnter() {
            if (this.searchTrigger === "enter") {
                this.handleSearch(); // we reset the filteredRows here because
                // we want to search across everything.
                this.filteredRows = JSON.parse(JSON.stringify(this.originalRows));
                this.forceSearch = true;
                this.sortChanged = true;
            }
        },
        searchTableOnKeyUp: function searchTableOnKeyUp() {
            if (this.searchTrigger !== "enter") this.handleSearch();
        },
        resetTable: function resetTable() {
            this.unselectAllInternal(true); // every time we searchTable
            this.changePage(1);
        },
        // field can be:
        // 1. function (passed as a string using function.name. For example: 'bound myFunction')
        // 2. regular property - ex: 'prop'
        // 3. nested property path - ex: 'nested.prop'
        collect: function collect(obj, field) {
            // utility function to get nested property
            function dig(obj, selector) {
                var result = obj;
                var splitter = selector.split(".");
                for(var i = 0; i < splitter.length; i++){
                    if (typeof result === "undefined" || result === null) return undefined;
                    result = result[splitter[i]];
                }
                return result;
            }
            if (typeof field === "function") return field(obj);
            if (typeof field === "string") return dig(obj, field);
            return undefined;
        },
        collectFormatted: function collectFormatted(obj, column) {
            var headerRow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            var value;
            if (headerRow && column.headerField) value = this.collect(obj, column.headerField);
            else value = this.collect(obj, column.field);
            if (value === undefined) return ""; // if user has supplied custom formatter,
            // use that here
            if (column.formatFn && typeof column.formatFn === "function") return column.formatFn(value, obj);
             // lets format the resultant data
            var type = column.typeDef; // this will only happen if we try to collect formatted
            // before types have been initialized. for example: on
            // load when external query is specified.
            if (!type) type = this.dataTypes[column.type] || $b96d2069a202fabb$var$defaultType;
            var result = type.format(value, column); // we must have some values in compact mode
            if (this.compactMode && (result == "" || result == null)) return "-";
            return result;
        },
        formattedRow: function formattedRow(row) {
            var isHeaderRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var formattedRow = {};
            for(var i = 0; i < this.typedColumns.length; i++){
                var col = this.typedColumns[i]; // what happens if field is
                if (col.field) formattedRow[col.field] = this.collectFormatted(row, col, isHeaderRow);
            }
            return formattedRow;
        },
        // Get classes for the given column index & element.
        getClasses: function getClasses(index, element, row) {
            var _this$typedColumns$in = this.typedColumns[index], typeDef = _this$typedColumns$in.typeDef, custom = _this$typedColumns$in["".concat(element, "Class")];
            var isRight = typeDef.isRight;
            if (this.rtl) isRight = true;
            var classes = {
                "vgt-right-align": isRight,
                "vgt-left-align": !isRight
            }; // for td we need to check if value is
            // a function.
            if (typeof custom === "function") classes[custom(row)] = true;
            else if (typeof custom === "string") classes[custom] = true;
            return classes;
        },
        // method to filter rows
        filterRows: function filterRows(columnFilters) {
            var _this9 = this;
            var fromFilter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
            // if (!this.rows.length) return;
            // this is invoked either as a result of changing filters
            // or as a result of modifying rows.
            this.columnFilters = columnFilters;
            var computedRows = JSON.parse(JSON.stringify(this.originalRows));
            var instancesOfFiltering = false; // do we have a filter to care about?
            // if not we don't need to do anything
            if (this.columnFilters && Object.keys(this.columnFilters).length) {
                var _ret = function() {
                    // every time we filter rows, we need to set current page
                    // to 1
                    // if the mode is remote, we only need to reset, if this is
                    // being called from filter, not when rows are changing
                    if (_this9.mode !== "remote" || fromFilter) _this9.changePage(1);
                     // we need to emit an event and that's that.
                    // but this only needs to be invoked if filter is changing
                    // not when row object is modified.
                    if (fromFilter) _this9.$emit("on-column-filter", {
                        columnFilters: _this9.columnFilters
                    });
                     // if mode is remote, we don't do any filtering here.
                    if (_this9.mode === "remote") {
                        if (fromFilter) _this9.$emit("update:isLoading", true);
                        else // if remote filtering has already been taken care of.
                        _this9.filteredRows = computedRows;
                        return {
                            v: void 0
                        };
                    }
                    var fieldKey = function fieldKey(field) {
                        if (typeof field === "function" && field.name) return field.name;
                        return field;
                    };
                    var _loop = function _loop(i) {
                        var col = _this9.typedColumns[i];
                        if (_this9.columnFilters[fieldKey(col.field)]) {
                            instancesOfFiltering = true;
                            computedRows.forEach(function(headerRow) {
                                var newChildren = headerRow.children.filter(function(row) {
                                    // If column has a custom filter, use that.
                                    if (col.filterOptions && typeof col.filterOptions.filterFn === "function") return col.filterOptions.filterFn(_this9.collect(row, col.field), _this9.columnFilters[fieldKey(col.field)]);
                                     // Otherwise Use default filters
                                    var typeDef = col.typeDef;
                                    return typeDef.filterPredicate(_this9.collect(row, col.field), _this9.columnFilters[fieldKey(col.field)], false, col.filterOptions && $b96d2069a202fabb$var$_typeof(col.filterOptions.filterDropdownItems) === "object");
                                }); // should we remove the header?
                                headerRow.children = newChildren;
                            });
                        }
                    };
                    for(var i = 0; i < _this9.typedColumns.length; i++)_loop(i);
                }();
                if ($b96d2069a202fabb$var$_typeof(_ret) === "object") return _ret.v;
            }
            if (instancesOfFiltering) this.filteredRows = computedRows.filter(function(h) {
                return h.children && h.children.length;
            });
            else this.filteredRows = computedRows;
        },
        getCurrentIndex: function getCurrentIndex(rowId) {
            var index = 0;
            var found = false;
            for(var i = 0; i < this.paginated.length; i += 1){
                var headerRow = this.paginated[i];
                var children = headerRow.children;
                if (children && children.length) for(var j = 0; j < children.length; j += 1){
                    var c = children[j];
                    if (c.originalIndex === rowId) {
                        found = true;
                        break;
                    }
                    index += 1;
                }
                if (found) break;
            }
            return (this.currentPage - 1) * this.currentPerPage + index + 1;
        },
        getRowStyleClass: function getRowStyleClass(row) {
            var classes = "";
            if (this.hasRowClickListener) classes += "clickable";
            var rowStyleClasses;
            if (typeof this.rowStyleClass === "function") rowStyleClasses = this.rowStyleClass(row);
            else rowStyleClasses = this.rowStyleClass;
            if (rowStyleClasses) classes += " ".concat(rowStyleClasses);
            return classes;
        },
        handleGrouped: function handleGrouped(originalRows) {
            var _this10 = this;
            originalRows.forEach(function(headerRow, i) {
                headerRow.vgt_header_id = i;
                if (_this10.groupOptions.maintainExpanded && _this10.expandedRowKeys.has(headerRow[_this10.groupOptions.rowKey])) _this10.$set(headerRow, "vgtIsExpanded", true);
                headerRow.children.forEach(function(childRow) {
                    childRow.vgt_id = i;
                });
            });
            return originalRows;
        },
        initializePagination: function initializePagination() {
            var _this11 = this;
            var _this$paginationOptio = this.paginationOptions, enabled = _this$paginationOptio.enabled, perPage = _this$paginationOptio.perPage, position = _this$paginationOptio.position, perPageDropdown = _this$paginationOptio.perPageDropdown, perPageDropdownEnabled = _this$paginationOptio.perPageDropdownEnabled, dropdownAllowAll = _this$paginationOptio.dropdownAllowAll, firstLabel = _this$paginationOptio.firstLabel, lastLabel = _this$paginationOptio.lastLabel, nextLabel = _this$paginationOptio.nextLabel, prevLabel = _this$paginationOptio.prevLabel, rowsPerPageLabel = _this$paginationOptio.rowsPerPageLabel, ofLabel = _this$paginationOptio.ofLabel, pageLabel = _this$paginationOptio.pageLabel, allLabel = _this$paginationOptio.allLabel, setCurrentPage = _this$paginationOptio.setCurrentPage, mode = _this$paginationOptio.mode, infoFn = _this$paginationOptio.infoFn;
            if (typeof enabled === "boolean") this.paginate = enabled;
            if (typeof perPage === "number") this.perPage = perPage;
            if (position === "top") {
                this.paginateOnTop = true; // default is false
                this.paginateOnBottom = false; // default is true
            } else if (position === "both") {
                this.paginateOnTop = true;
                this.paginateOnBottom = true;
            }
            if (Array.isArray(perPageDropdown) && perPageDropdown.length) {
                this.customRowsPerPageDropdown = perPageDropdown;
                if (!this.perPage) {
                    var _perPageDropdown = $b96d2069a202fabb$var$_slicedToArray(perPageDropdown, 1);
                    this.perPage = _perPageDropdown[0];
                }
            }
            if (typeof perPageDropdownEnabled === "boolean") this.perPageDropdownEnabled = perPageDropdownEnabled;
            if (typeof dropdownAllowAll === "boolean") this.paginateDropdownAllowAll = dropdownAllowAll;
            if (typeof mode === "string") this.paginationMode = mode;
            if (typeof firstLabel === "string") this.firstText = firstLabel;
            if (typeof lastLabel === "string") this.lastText = lastLabel;
            if (typeof nextLabel === "string") this.nextText = nextLabel;
            if (typeof prevLabel === "string") this.prevText = prevLabel;
            if (typeof rowsPerPageLabel === "string") this.rowsPerPageText = rowsPerPageLabel;
            if (typeof ofLabel === "string") this.ofText = ofLabel;
            if (typeof pageLabel === "string") this.pageText = pageLabel;
            if (typeof allLabel === "string") this.allText = allLabel;
            if (typeof setCurrentPage === "number") setTimeout(function() {
                _this11.changePage(setCurrentPage);
            }, 500);
            if (typeof infoFn === "function") this.paginationInfoFn = infoFn;
        },
        initializeSearch: function initializeSearch() {
            var _this$searchOptions = this.searchOptions, enabled = _this$searchOptions.enabled, trigger = _this$searchOptions.trigger, externalQuery = _this$searchOptions.externalQuery, searchFn = _this$searchOptions.searchFn, placeholder = _this$searchOptions.placeholder, skipDiacritics = _this$searchOptions.skipDiacritics;
            if (typeof enabled === "boolean") this.searchEnabled = enabled;
            if (trigger === "enter") this.searchTrigger = trigger;
            if (typeof externalQuery === "string") this.externalSearchQuery = externalQuery;
            if (typeof searchFn === "function") this.searchFn = searchFn;
            if (typeof placeholder === "string") this.searchPlaceholder = placeholder;
            if (typeof skipDiacritics === "boolean") this.searchSkipDiacritics = skipDiacritics;
        },
        initializeSort: function initializeSort() {
            var _this$sortOptions = this.sortOptions, enabled = _this$sortOptions.enabled, initialSortBy = _this$sortOptions.initialSortBy, multipleColumns = _this$sortOptions.multipleColumns;
            var initSortBy = JSON.parse(JSON.stringify(initialSortBy || {}));
            if (typeof enabled === "boolean") this.sortable = enabled;
            if (typeof multipleColumns === "boolean") this.multipleColumnSort = multipleColumns;
             //* initialSortBy can be an array or an object
            if ($b96d2069a202fabb$var$_typeof(initSortBy) === "object") {
                var ref = this.fixedHeader ? this.$refs["table-header-secondary"] : this.$refs["table-header-primary"];
                if (Array.isArray(initSortBy)) ref.setInitialSort(initSortBy);
                else {
                    var hasField = Object.prototype.hasOwnProperty.call(initSortBy, "field");
                    if (hasField) ref.setInitialSort([
                        initSortBy
                    ]);
                }
            }
        },
        initializeSelect: function initializeSelect() {
            var _this$selectOptions = this.selectOptions, enabled = _this$selectOptions.enabled, selectionInfoClass = _this$selectOptions.selectionInfoClass, selectionText = _this$selectOptions.selectionText, clearSelectionText = _this$selectOptions.clearSelectionText, selectOnCheckboxOnly = _this$selectOptions.selectOnCheckboxOnly, selectAllByPage = _this$selectOptions.selectAllByPage, disableSelectInfo = _this$selectOptions.disableSelectInfo, selectAllByGroup = _this$selectOptions.selectAllByGroup;
            if (typeof enabled === "boolean") this.selectable = enabled;
            if (typeof selectOnCheckboxOnly === "boolean") this.selectOnCheckboxOnly = selectOnCheckboxOnly;
            if (typeof selectAllByPage === "boolean") this.selectAllByPage = selectAllByPage;
            if (typeof selectAllByGroup === "boolean") this.selectAllByGroup = selectAllByGroup;
            if (typeof disableSelectInfo === "boolean") this.disableSelectInfo = disableSelectInfo;
            if (typeof selectionInfoClass === "string") this.selectionInfoClass = selectionInfoClass;
            if (typeof selectionText === "string") this.selectionText = selectionText;
            if (typeof clearSelectionText === "string") this.clearSelectionText = clearSelectionText;
        }
    },
    mounted: function mounted() {
        if (this.perPage) this.currentPerPage = this.perPage;
        this.initializeSort();
    },
    components: {
        "vgt-pagination": $b96d2069a202fabb$var$__vue_component__$1,
        "vgt-global-search": $b96d2069a202fabb$var$__vue_component__$2,
        "vgt-header-row": $b96d2069a202fabb$var$__vue_component__$5,
        "vgt-table-header": $b96d2069a202fabb$var$__vue_component__$4
    }
};
/* script */ var $b96d2069a202fabb$var$__vue_script__$6 = $b96d2069a202fabb$var$script$6;
/* template */ var $b96d2069a202fabb$var$__vue_render__$6 = function __vue_render__() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", {
        "class": _vm.wrapStyleClasses
    }, [
        _vm.isLoading ? _c("div", {
            staticClass: "vgt-loading vgt-center-align"
        }, [
            _vm._t("loadingContent", [
                _c("span", {
                    staticClass: "vgt-loading__content"
                }, [
                    _vm._v("\n        Loading...\n      ")
                ])
            ])
        ], 2) : _vm._e(),
        _vm._v(" "),
        _c("div", {
            staticClass: "vgt-inner-wrap",
            "class": {
                "is-loading": _vm.isLoading
            }
        }, [
            _vm.paginate && _vm.paginateOnTop ? _vm._t("pagination-top", [
                _c("vgt-pagination", {
                    ref: "paginationTop",
                    attrs: {
                        "perPage": _vm.perPage,
                        "rtl": _vm.rtl,
                        "total": _vm.totalRows || _vm.totalRowCount,
                        "mode": _vm.paginationMode,
                        "jumpFirstOrLast": _vm.paginationOptions.jumpFirstOrLast,
                        "firstText": _vm.firstText,
                        "lastText": _vm.lastText,
                        "nextText": _vm.nextText,
                        "prevText": _vm.prevText,
                        "rowsPerPageText": _vm.rowsPerPageText,
                        "perPageDropdownEnabled": _vm.paginationOptions.perPageDropdownEnabled,
                        "customRowsPerPageDropdown": _vm.customRowsPerPageDropdown,
                        "paginateDropdownAllowAll": _vm.paginateDropdownAllowAll,
                        "ofText": _vm.ofText,
                        "pageText": _vm.pageText,
                        "allText": _vm.allText,
                        "info-fn": _vm.paginationInfoFn
                    },
                    on: {
                        "page-changed": _vm.pageChanged,
                        "per-page-changed": _vm.perPageChanged
                    }
                })
            ], {
                "pageChanged": _vm.pageChanged,
                "perPageChanged": _vm.perPageChanged,
                "total": _vm.totalRows || _vm.totalRowCount
            }) : _vm._e(),
            _vm._v(" "),
            _c("vgt-global-search", {
                attrs: {
                    "search-enabled": _vm.searchEnabled && _vm.externalSearchQuery == null,
                    "global-search-placeholder": _vm.searchPlaceholder
                },
                on: {
                    "on-keyup": _vm.searchTableOnKeyUp,
                    "on-enter": _vm.searchTableOnEnter
                },
                model: {
                    value: _vm.globalSearchTerm,
                    callback: function callback($$v) {
                        _vm.globalSearchTerm = $$v;
                    },
                    expression: "globalSearchTerm"
                }
            }, [
                _c("template", {
                    slot: "internal-table-actions"
                }, [
                    _vm._t("table-actions")
                ], 2)
            ], 2),
            _vm._v(" "),
            _vm.selectedRowCount && !_vm.disableSelectInfo ? _c("div", {
                staticClass: "vgt-selection-info-row clearfix",
                "class": _vm.selectionInfoClass
            }, [
                _vm._v("\n      " + _vm._s(_vm.selectionInfo) + "\n      "),
                _c("a", {
                    attrs: {
                        "href": ""
                    },
                    on: {
                        "click": function click($event) {
                            $event.preventDefault();
                            return _vm.unselectAllInternal(true);
                        }
                    }
                }, [
                    _vm._v("\n        " + _vm._s(_vm.clearSelectionText) + "\n      ")
                ]),
                _vm._v(" "),
                _c("div", {
                    staticClass: "vgt-selection-info-row__actions vgt-pull-right"
                }, [
                    _vm._t("selected-row-actions")
                ], 2)
            ]) : _vm._e(),
            _vm._v(" "),
            _c("div", {
                staticClass: "vgt-fixed-header"
            }, [
                _vm.fixedHeader ? _c("table", {
                    "class": _vm.tableStyleClasses,
                    attrs: {
                        "id": "vgt-table"
                    }
                }, [
                    _c("colgroup", _vm._l(_vm.columns, function(column, index) {
                        return _c("col", {
                            key: index,
                            attrs: {
                                "id": "col-" + index
                            }
                        });
                    }), 0),
                    _vm._v(" "),
                    _c("vgt-table-header", {
                        ref: "table-header-secondary",
                        tag: "thead",
                        attrs: {
                            "columns": _vm.columns,
                            "line-numbers": _vm.lineNumbers,
                            "selectable": _vm.selectable,
                            "all-selected": _vm.allSelected,
                            "all-selected-indeterminate": _vm.allSelectedIndeterminate,
                            "mode": _vm.mode,
                            "sortable": _vm.sortable,
                            "multiple-column-sort": _vm.multipleColumnSort,
                            "typed-columns": _vm.typedColumns,
                            "getClasses": _vm.getClasses,
                            "searchEnabled": _vm.searchEnabled,
                            "paginated": _vm.paginated,
                            "table-ref": _vm.$refs.table
                        },
                        on: {
                            "on-toggle-select-all": _vm.toggleSelectAll,
                            "on-sort-change": _vm.changeSort,
                            "filter-changed": _vm.filterRows
                        },
                        scopedSlots: _vm._u([
                            {
                                key: "table-column",
                                fn: function fn(props) {
                                    return [
                                        _vm._t("table-column", [
                                            _c("span", [
                                                _vm._v(_vm._s(props.column.label))
                                            ])
                                        ], {
                                            "column": props.column
                                        })
                                    ];
                                }
                            },
                            {
                                key: "column-filter",
                                fn: function fn(props) {
                                    return [
                                        _vm._t("column-filter", null, {
                                            "column": props.column,
                                            "updateFilters": props.updateFilters
                                        })
                                    ];
                                }
                            }
                        ], null, true)
                    })
                ], 1) : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", {
                "class": {
                    "vgt-responsive": _vm.responsive
                },
                style: _vm.wrapperStyles
            }, [
                _c("table", {
                    ref: "table",
                    "class": _vm.tableStyles,
                    attrs: {
                        "id": "vgt-table"
                    }
                }, [
                    _c("colgroup", _vm._l(_vm.columns, function(column, index) {
                        return _c("col", {
                            key: index,
                            attrs: {
                                "id": "col-" + index
                            }
                        });
                    }), 0),
                    _vm._v(" "),
                    _c("vgt-table-header", {
                        ref: "table-header-primary",
                        tag: "thead",
                        attrs: {
                            "columns": _vm.columns,
                            "line-numbers": _vm.lineNumbers,
                            "selectable": _vm.selectable,
                            "all-selected": _vm.allSelected,
                            "all-selected-indeterminate": _vm.allSelectedIndeterminate,
                            "mode": _vm.mode,
                            "sortable": _vm.sortable,
                            "multiple-column-sort": _vm.multipleColumnSort,
                            "typed-columns": _vm.typedColumns,
                            "getClasses": _vm.getClasses,
                            "searchEnabled": _vm.searchEnabled
                        },
                        on: {
                            "on-toggle-select-all": _vm.toggleSelectAll,
                            "on-sort-change": _vm.changeSort,
                            "filter-changed": _vm.filterRows
                        },
                        scopedSlots: _vm._u([
                            {
                                key: "table-column",
                                fn: function fn(props) {
                                    return [
                                        _vm._t("table-column", [
                                            _c("span", [
                                                _vm._v(_vm._s(props.column.label))
                                            ])
                                        ], {
                                            "column": props.column
                                        })
                                    ];
                                }
                            },
                            {
                                key: "column-filter",
                                fn: function fn(props) {
                                    return [
                                        _vm._t("column-filter", null, {
                                            "column": props.column,
                                            "updateFilters": props.updateFilters
                                        })
                                    ];
                                }
                            }
                        ], null, true)
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.paginated, function(headerRow, hIndex) {
                        return _c("tbody", {
                            key: hIndex
                        }, [
                            _vm.groupHeaderOnTop ? _c("vgt-header-row", {
                                "class": _vm.getRowStyleClass(headerRow),
                                attrs: {
                                    "header-row": headerRow,
                                    "columns": _vm.columns,
                                    "line-numbers": _vm.lineNumbers,
                                    "selectable": _vm.selectable,
                                    "select-all-by-group": _vm.selectAllByGroup,
                                    "collapsable": _vm.groupOptions.collapsable,
                                    "collect-formatted": _vm.collectFormatted,
                                    "formatted-row": _vm.formattedRow,
                                    "get-classes": _vm.getClasses,
                                    "full-colspan": _vm.fullColspan,
                                    "groupIndex": hIndex
                                },
                                on: {
                                    "vgtExpand": function vgtExpand($event) {
                                        return _vm.toggleExpand(headerRow[_vm.rowKeyField]);
                                    },
                                    "on-select-group-change": function onSelectGroupChange($event) {
                                        return _vm.toggleSelectGroup($event, headerRow);
                                    }
                                },
                                scopedSlots: _vm._u([
                                    {
                                        key: "table-header-row",
                                        fn: function fn(props) {
                                            return _vm.hasHeaderRowTemplate ? [
                                                _vm._t("table-header-row", null, {
                                                    "column": props.column,
                                                    "formattedRow": props.formattedRow,
                                                    "row": props.row
                                                })
                                            ] : undefined;
                                        }
                                    }
                                ], null, true)
                            }) : _vm._e(),
                            _vm._v(" "),
                            _vm._l(headerRow.children, function(row, index) {
                                return (_vm.groupOptions.collapsable ? headerRow.vgtIsExpanded : true) ? _c("tr", {
                                    key: row.originalIndex,
                                    "class": _vm.getRowStyleClass(row),
                                    on: {
                                        "mouseenter": function mouseenter($event) {
                                            return _vm.onMouseenter(row, index);
                                        },
                                        "mouseleave": function mouseleave($event) {
                                            return _vm.onMouseleave(row, index);
                                        },
                                        "dblclick": function dblclick($event) {
                                            return _vm.onRowDoubleClicked(row, index, $event);
                                        },
                                        "click": function click($event) {
                                            return _vm.onRowClicked(row, index, $event);
                                        },
                                        "auxclick": function auxclick($event) {
                                            return _vm.onRowAuxClicked(row, index, $event);
                                        }
                                    }
                                }, [
                                    _vm.lineNumbers ? _c("th", {
                                        staticClass: "line-numbers"
                                    }, [
                                        _vm._v("\n              " + _vm._s(_vm.getCurrentIndex(row.originalIndex)) + "\n            ")
                                    ]) : _vm._e(),
                                    _vm._v(" "),
                                    _vm.selectable ? _c("th", {
                                        staticClass: "vgt-checkbox-col",
                                        on: {
                                            "click": function click($event) {
                                                $event.stopPropagation();
                                                return _vm.onCheckboxClicked(row, index, $event);
                                            }
                                        }
                                    }, [
                                        _c("input", {
                                            attrs: {
                                                "type": "checkbox",
                                                "disabled": row.vgtDisabled
                                            },
                                            domProps: {
                                                "checked": row.vgtSelected
                                            }
                                        })
                                    ]) : _vm._e(),
                                    _vm._v(" "),
                                    _vm._l(_vm.columns, function(column, i) {
                                        return !column.hidden && column.field ? _c("td", {
                                            key: i,
                                            "class": _vm.getClasses(i, "td", row),
                                            attrs: {
                                                "data-label": _vm.compactMode ? column.label : undefined
                                            },
                                            on: {
                                                "click": function click($event) {
                                                    return _vm.onCellClicked(row, column, index, $event);
                                                }
                                            }
                                        }, [
                                            _vm._t("table-row", [
                                                !column.html ? _c("span", [
                                                    _vm._v("\n                  " + _vm._s(_vm.collectFormatted(row, column)) + "\n                ")
                                                ]) : _c("span", {
                                                    domProps: {
                                                        "innerHTML": _vm._s(_vm.collect(row, column.field))
                                                    }
                                                })
                                            ], {
                                                "row": row,
                                                "column": column,
                                                "formattedRow": _vm.formattedRow(row),
                                                "index": index
                                            })
                                        ], 2) : _vm._e();
                                    })
                                ], 2) : _vm._e();
                            }),
                            _vm._v(" "),
                            _vm.groupHeaderOnBottom ? _c("vgt-header-row", {
                                attrs: {
                                    "header-row": headerRow,
                                    "columns": _vm.columns,
                                    "line-numbers": _vm.lineNumbers,
                                    "selectable": _vm.selectable,
                                    "select-all-by-group": _vm.selectAllByGroup,
                                    "collect-formatted": _vm.collectFormatted,
                                    "formatted-row": _vm.formattedRow,
                                    "get-classes": _vm.getClasses,
                                    "full-colspan": _vm.fullColspan,
                                    "groupIndex": _vm.index
                                },
                                on: {
                                    "on-select-group-change": function onSelectGroupChange($event) {
                                        return _vm.toggleSelectGroup($event, headerRow);
                                    }
                                },
                                scopedSlots: _vm._u([
                                    {
                                        key: "table-header-row",
                                        fn: function fn(props) {
                                            return _vm.hasHeaderRowTemplate ? [
                                                _vm._t("table-header-row", null, {
                                                    "column": props.column,
                                                    "formattedRow": props.formattedRow,
                                                    "row": props.row
                                                })
                                            ] : undefined;
                                        }
                                    }
                                ], null, true)
                            }) : _vm._e()
                        ], 2);
                    }),
                    _vm._v(" "),
                    _vm.showEmptySlot ? _c("tbody", [
                        _c("tr", [
                            _c("td", {
                                attrs: {
                                    "colspan": _vm.fullColspan
                                }
                            }, [
                                _vm._t("emptystate", [
                                    _c("div", {
                                        staticClass: "vgt-center-align vgt-text-disabled"
                                    }, [
                                        _vm._v("\n                  No data for table\n                ")
                                    ])
                                ])
                            ], 2)
                        ])
                    ]) : _vm._e()
                ], 2)
            ]),
            _vm._v(" "),
            _vm.hasFooterSlot ? _c("div", {
                staticClass: "vgt-wrap__actions-footer"
            }, [
                _vm._t("table-actions-bottom")
            ], 2) : _vm._e(),
            _vm._v(" "),
            _vm.paginate && _vm.paginateOnBottom ? _vm._t("pagination-bottom", [
                _c("vgt-pagination", {
                    ref: "paginationBottom",
                    attrs: {
                        "perPage": _vm.perPage,
                        "rtl": _vm.rtl,
                        "total": _vm.totalRows || _vm.totalRowCount,
                        "mode": _vm.paginationMode,
                        "jumpFirstOrLast": _vm.paginationOptions.jumpFirstOrLast,
                        "firstText": _vm.firstText,
                        "lastText": _vm.lastText,
                        "nextText": _vm.nextText,
                        "prevText": _vm.prevText,
                        "rowsPerPageText": _vm.rowsPerPageText,
                        "perPageDropdownEnabled": _vm.paginationOptions.perPageDropdownEnabled,
                        "customRowsPerPageDropdown": _vm.customRowsPerPageDropdown,
                        "paginateDropdownAllowAll": _vm.paginateDropdownAllowAll,
                        "ofText": _vm.ofText,
                        "pageText": _vm.pageText,
                        "allText": _vm.allText,
                        "info-fn": _vm.paginationInfoFn
                    },
                    on: {
                        "page-changed": _vm.pageChanged,
                        "per-page-changed": _vm.perPageChanged
                    }
                })
            ], {
                "pageChanged": _vm.pageChanged,
                "perPageChanged": _vm.perPageChanged,
                "total": _vm.totalRows || _vm.totalRowCount
            }) : _vm._e()
        ], 2)
    ]);
};
var $b96d2069a202fabb$var$__vue_staticRenderFns__$6 = [];
/* style */ var $b96d2069a202fabb$var$__vue_inject_styles__$6 = undefined;
/* scoped */ var $b96d2069a202fabb$var$__vue_scope_id__$6 = undefined;
/* module identifier */ var $b96d2069a202fabb$var$__vue_module_identifier__$6 = undefined;
/* functional template */ var $b96d2069a202fabb$var$__vue_is_functional_template__$6 = false;
/* style inject */ /* style inject SSR */ /* style inject shadow dom */ var $b96d2069a202fabb$export$7ea51704840f7174 = /*#__PURE__*/ $b96d2069a202fabb$var$normalizeComponent({
    render: $b96d2069a202fabb$var$__vue_render__$6,
    staticRenderFns: $b96d2069a202fabb$var$__vue_staticRenderFns__$6
}, $b96d2069a202fabb$var$__vue_inject_styles__$6, $b96d2069a202fabb$var$__vue_script__$6, $b96d2069a202fabb$var$__vue_scope_id__$6, $b96d2069a202fabb$var$__vue_is_functional_template__$6, $b96d2069a202fabb$var$__vue_module_identifier__$6, false, undefined, undefined, undefined);
var $b96d2069a202fabb$var$VueGoodTablePlugin = {
    install: function install(Vue, options) {
        Vue.component($b96d2069a202fabb$export$7ea51704840f7174.name, $b96d2069a202fabb$export$7ea51704840f7174);
    }
}; // Automatic installation if Vue has been added to the global scope.
if (typeof window !== "undefined" && window.Vue) window.Vue.use($b96d2069a202fabb$var$VueGoodTablePlugin);
var $b96d2069a202fabb$export$2e2bcd8739ae039 = $b96d2069a202fabb$var$VueGoodTablePlugin;

});


parcelRequire.register("fXHoi", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $b9ee06370362b727$export$b3890eb0ae9dca99; }, function (v) { return $b9ee06370362b727$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $b9ee06370362b727$export$f8436702749526f9; }, function (v) { return $b9ee06370362b727$export$f8436702749526f9 = v; });
var $b9ee06370362b727$export$b3890eb0ae9dca99;
var $b9ee06370362b727$export$f8436702749526f9;
var $b9ee06370362b727$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", [
        _c("div", {
            staticClass: "flex justify-between mb-10 space-x-20"
        }, [
            _c("p", {
                staticClass: "font-serif text-3xl xl:leading-tight xl:text-5xl"
            }, [
                _vm._v("\n      " + _vm._s(_vm.unitsData.locales.heading) + "\n    ")
            ]),
            _vm._v(" "),
            _vm.floors && _vm.floors.length > 0 ? _c("ul", {
                staticClass: "hidden space-x-5 xl:flex"
            }, [
                _c("li", [
                    _c("a", {
                        staticClass: "relative p-3 text-sm tracking-wider uppercase transition duration-200 border border-white rounded-md active:top-px hover:bg-white",
                        class: _vm.activeTab === "all" ? "border-opacity-100 bg-white text-brand-500" : "border-opacity-25  hover:border-opacity-50 hover:bg-opacity-25",
                        attrs: {
                            "href": "#"
                        },
                        on: {
                            "click": function($event) {
                                $event.preventDefault();
                                return _vm.setTab("all");
                            }
                        }
                    }, [
                        _vm._v("\n          " + _vm._s(_vm.unitsData.locales.all_floors) + "\n        ")
                    ])
                ]),
                _vm._v(" "),
                _vm._l(_vm.floors, function(floor, index) {
                    return _c("li", {
                        key: index
                    }, [
                        _c("a", {
                            staticClass: "relative p-3 text-sm tracking-wider uppercase transition duration-200 border border-white rounded-md active:top-px hover:bg-white",
                            class: _vm.activeTab === floor ? "border-opacity-100 bg-white text-brand-500" : "border-opacity-25  hover:border-opacity-50 hover:bg-opacity-25",
                            attrs: {
                                "href": "#"
                            },
                            on: {
                                "click": function($event) {
                                    $event.preventDefault();
                                    return _vm.setTab(floor);
                                }
                            }
                        }, [
                            _vm._v("\n          " + _vm._s(_vm.unitsData.locales.floor) + " " + _vm._s(floor) + "\n        ")
                        ])
                    ]);
                })
            ], 2) : _vm._e()
        ]),
        _vm._v(" "),
        _c("vue-good-table", {
            attrs: {
                "styleClass": "vgt-table",
                "columns": _vm.columns,
                "rows": _vm.rows,
                "row-style-class": _vm.disableRow,
                "sort-options": {
                    enabled: true,
                    initialSortBy: [
                        {
                            field: "status",
                            type: "asc"
                        }
                    ]
                },
                "pagination-options": {
                    enabled: true,
                    mode: "pages",
                    perPage: this.perPage,
                    position: "bottom",
                    dropdownAllowAll: false,
                    setCurrentPage: this.setCurrentPage,
                    nextLabel: this.unitsData.locales.next,
                    prevLabel: this.unitsData.locales.back,
                    ofLabel: this.unitsData.locales.of,
                    pageLabel: this.unitsData.locales.page
                }
            },
            on: {
                "on-row-click": _vm.formatLink
            },
            scopedSlots: _vm._u([
                {
                    key: "table-row",
                    fn: function(props) {
                        return [
                            props.column.field == "number" ? [
                                props.row.number ? [
                                    _vm._v("\n          " + _vm._s(props.row.number) + "\n        ")
                                ] : [
                                    _vm._v(" - ")
                                ]
                            ] : props.column.field == "box" ? [
                                props.row.box ? [
                                    _vm._v("\n          " + _vm._s(props.row.box) + "\n        ")
                                ] : [
                                    _vm._v(" - ")
                                ]
                            ] : props.column.field == "floor" ? [
                                props.row.floor ? [
                                    _vm._v("\n          " + _vm._s(props.row.floor) + "\n        ")
                                ] : [
                                    _vm._v(" - ")
                                ]
                            ] : props.column.field == "liveable_area" ? [
                                props.row.liveable_area && props.row.liveable_area !== 0 ? [
                                    _vm._v("\n          " + _vm._s(_vm._f("numeral")(parseFloat(props.row.liveable_area), "0,0[.]00")) + "\n          m"),
                                    _c("sup", [
                                        _vm._v("2")
                                    ])
                                ] : [
                                    _vm._v(" - ")
                                ]
                            ] : props.column.field == "plot_area" ? [
                                props.row.plot_area && props.row.plot_area !== 0 ? [
                                    _vm._v("\n          " + _vm._s(_vm._f("numeral")(parseFloat(props.row.plot_area), "0,0[.]00")) + "\n          m"),
                                    _c("sup", [
                                        _vm._v("2")
                                    ])
                                ] : [
                                    _vm._v(" - ")
                                ]
                            ] : props.column.field == "price" ? [
                                !props.row.price_hidden && props.row.status !== "sold" && props.row.status !== "option" && props.row.price > 0 ? [
                                    _vm._v("\n          € " + _vm._s(_vm._f("numeral")(parseFloat(props.row.price), "0,0[.]00")) + "\n        ")
                                ] : [
                                    _vm._v(" - ")
                                ]
                            ] : props.column.field == "status" ? [
                                props.row.status === "available" ? _c("div", {
                                    staticClass: "inline-block px-3 py-2 text-xs font-medium tracking-wider text-white uppercase rounded-md shadow bg-danger-500"
                                }, [
                                    _vm._v("\n          " + _vm._s(_vm.unitsData.locales.for_sale) + "\n        ")
                                ]) : props.row.status === "option" ? _c("div", {
                                    staticClass: "inline-block px-3 py-2 text-xs font-medium leading-loose tracking-widest uppercase"
                                }, [
                                    _vm._v("\n          " + _vm._s(_vm.unitsData.locales.option) + "\n        ")
                                ]) : props.row.status === "sold" ? _c("div", {
                                    staticClass: "inline-block px-3 py-2 text-xs font-medium leading-loose tracking-widest uppercase"
                                }, [
                                    _vm._v("\n          " + _vm._s(_vm.unitsData.locales.sold) + "\n        ")
                                ]) : props.row.status === "under_contract" ? _c("div", {
                                    staticClass: "inline-block px-3 py-2 text-xs font-medium leading-loose tracking-widest uppercase"
                                }, [
                                    _vm._v("\n          " + _vm._s(_vm.unitsData.locales.under_contract) + "\n        ")
                                ]) : _vm._e()
                            ] : _vm._e()
                        ];
                    }
                }
            ])
        })
    ], 1);
};
var $b9ee06370362b727$var$staticRenderFns = [];
$b9ee06370362b727$export$b3890eb0ae9dca99 = $b9ee06370362b727$var$render;
$b9ee06370362b727$export$f8436702749526f9 = $b9ee06370362b727$var$staticRenderFns;

});

parcelRequire.register("ggmL9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd6fcb80e0744de5$export$2e2bcd8739ae039; });
let $bd6fcb80e0744de5$var$NOOP = ()=>{};
var $bd6fcb80e0744de5$export$2e2bcd8739ae039 = (script)=>{};

});

parcelRequire.register("cz3gu", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $925b4944b3eb37fc$export$2e2bcd8739ae039; });

var $hcHv8 = parcelRequire("hcHv8");


var $hr0I9 = parcelRequire("hr0I9");
var $925b4944b3eb37fc$var$scriptExports = {
    components: {
        CoolLightBox: $hcHv8.default
    },
    data () {
        return {
            index: null,
            galleryData: window.galleryData
        };
    },
    computed: {
        thumbnails () {
            let results = [];
            if (this.galleryData.vr) results = this.galleryData.images.slice(0, 3);
            else results = this.galleryData.images.slice(1, 4);
            return results;
        },
        gallery () {
            const results = [];
            this.galleryData.images.forEach((image)=>{
                results.push(image.sizes.large);
            });
            return results;
        },
        hasSidebar () {
            let result = true;
            if (!this.galleryData.vr && this.galleryData.images.length === 1) result = false;
            return result;
        },
        hasMoreImages () {
            let result = false;
            if (this.galleryData.vr && this.galleryData.images.length > 3) result = this.galleryData.images.length - 3;
            else if (!this.galleryData.vr && this.galleryData.images.length > 4) result = this.galleryData.images.length - 4;
            return result;
        }
    },
    mounted () {
        new (0, (/*@__PURE__*/$parcel$interopDefault($hr0I9)))({
            elements_selector: ".lazy",
            unobserve_entered: true
        });
    },
    methods: {}
};
var $925b4944b3eb37fc$var$options = typeof $925b4944b3eb37fc$var$scriptExports === "function" ? $925b4944b3eb37fc$var$scriptExports.options : $925b4944b3eb37fc$var$scriptExports;
var $925b4944b3eb37fc$export$2e2bcd8739ae039 // parcel transformer vue2 compiler hack
 = $925b4944b3eb37fc$var$options;

});
parcelRequire.register("hcHv8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c8654d17047f9f6d$export$2e2bcd8739ae039; });

var $gYJCo = parcelRequire("gYJCo");
var $c8654d17047f9f6d$var$attributes = [
    "media",
    "srcset",
    "sizes",
    "src"
];
var $c8654d17047f9f6d$var$LazyLoadDirective = {
    inserted: function(el) {
        function loadImage1() {
            var imageElement = $c8654d17047f9f6d$var$findChild(el, "img");
            var pictureElement = $c8654d17047f9f6d$var$findChild(el, "picture");
            if (imageElement) {
                $c8654d17047f9f6d$var$setLoadListeners(imageElement);
                $c8654d17047f9f6d$var$swapAttributes(imageElement);
            } else if (pictureElement) {
                var pictureImg = $c8654d17047f9f6d$var$findChild(pictureElement, "img");
                var pictureSources = Array.from(pictureElement.children).filter(function(child) {
                    return child.nodeName === "SOURCE";
                });
                if (pictureImg) {
                    $c8654d17047f9f6d$var$setLoadListeners(pictureImg);
                    if (pictureSources.length) pictureSources.forEach(function(source) {
                        $c8654d17047f9f6d$var$swapAttributes(source);
                    });
                    $c8654d17047f9f6d$var$swapAttributes(pictureImg);
                }
            }
        }
        function handleIntersect(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    loadImage1();
                    observer.unobserve(el);
                }
            });
        }
        function createObserver() {
            var options = {
                root: null,
                threshold: "0"
            };
            var observer = new IntersectionObserver(handleIntersect, options);
            observer.observe(el);
        }
        if (window["IntersectionObserver"]) createObserver();
        else loadImage1();
    }
};
function $c8654d17047f9f6d$var$swapAttributes(el) {
    $c8654d17047f9f6d$var$attributes.forEach(function(attribute) {
        var dataAttribute = el.dataset[attribute];
        if (dataAttribute) {
            el[attribute] = dataAttribute;
            el.removeAttribute("data-" + attribute);
        }
    });
}
function $c8654d17047f9f6d$var$setLoadListeners(el) {
    el.addEventListener("load", function() {
        setTimeout(function() {
            return el.classList.add("loaded");
        }, 100);
    });
    el.addEventListener("error", function() {
        return console.log("error");
    });
}
function $c8654d17047f9f6d$var$findChild(parent, nodeName) {
    return Array.from(parent.children).find(function(el) {
        return el.nodeName === nodeName.toUpperCase();
    });
}
var $c8654d17047f9f6d$var$AutoplayObserver = {
    inserted: function(el) {
        // getYoutube ID
        function isYoutubeVideo(url) {
            // youtube data
            var youtubeRegex = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
            var ytId = url.match(youtubeRegex) ? RegExp.$1 : false;
            if (ytId) return true;
            return false;
        }
        function autoplayVideo() {
            var tagName = el.tagName;
            var autoplay = el.dataset.autoplay;
            if (autoplay) {
                if (tagName === "VIDEO") {
                    el.muted = true;
                    el.autoplay = true;
                    return;
                }
                if (tagName === "IFRAME") {
                    var url = new URL(el.src);
                    var muted = "muted";
                    if (isYoutubeVideo(el.src)) muted = "mute";
                    // append autoplay
                    url.searchParams.append(muted, 1);
                    url.searchParams.append("autoplay", 1);
                    el.src = url.href;
                }
            }
        }
        function handleIntersect(entries, observer) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    autoplayVideo();
                    observer.unobserve(el);
                }
            });
        }
        function createObserver() {
            var options = {
                root: null,
                threshold: "0"
            };
            var observer = new IntersectionObserver(handleIntersect, options);
            observer.observe(el);
        }
        if (window["IntersectionObserver"]) createObserver();
        else loadImage();
    }
};
//
var $c8654d17047f9f6d$var$script = {
    directives: {
        lazyload: $c8654d17047f9f6d$var$LazyLoadDirective,
        autoplayObserver: $c8654d17047f9f6d$var$AutoplayObserver
    },
    data: function data() {
        return {
            // swipe data
            initialMouseX: 0,
            initialMouseY: 0,
            endMouseX: 0,
            endMouseY: 0,
            swipeType: null,
            IsSwipping: false,
            isDraggingSwipe: false,
            // use for mouse wheel
            prevTime: 0,
            // swipe effect
            xSwipeWrapper: 0,
            ySwipeWrapper: 0,
            swipeAnimation: null,
            swipeInterval: null,
            lightboxInnerWidth: null,
            // styles data
            imgIndex: this.index,
            isVisible: false,
            paddingBottom: false,
            imageLoading: false,
            showThumbs: false,
            isFullScreenMode: false,
            // aspect ratio videos
            aspectRatioVideo: {
                width: "auto",
                height: "auto"
            },
            // props to bind styles
            buttonsVisible: true,
            scale: 1,
            top: 0,
            left: 0,
            lastX: 0,
            lastY: 0,
            isDraging: false,
            canZoom: true,
            isZooming: false,
            transition: "all .3s ease",
            zoomBar: 0,
            // slideshow playing data
            isPlayingSlideShow: false,
            intervalProgress: null,
            loopData: false,
            stylesInterval: {
                "display": "block"
            }
        };
    },
    props: {
        index: {
            required: true
        },
        effect: {
            type: String,
            default: "swipe"
        },
        items: {
            type: Array,
            required: true
        },
        loop: {
            type: Boolean,
            default: true
        },
        slideshow: {
            type: Boolean,
            default: true
        },
        slideshowColorBar: {
            type: String,
            default: "#fa4242"
        },
        slideshowDuration: {
            type: Number,
            default: 3000
        },
        useZoomBar: {
            type: Boolean,
            default: false
        },
        closeOnClickOutsideMobile: {
            type: Boolean,
            default: false
        },
        srcName: {
            type: String,
            default: "src"
        },
        srcSetName: {
            type: String,
            default: "srcset"
        },
        srcThumb: {
            type: String,
            default: "thumb"
        },
        srcMediaType: {
            type: String,
            default: "mediaType"
        },
        overlayColor: {
            type: String,
            default: "rgba(30, 30, 30, .9)"
        },
        zIndex: {
            type: Number,
            default: 9999
        },
        gallery: {
            type: Boolean,
            default: true
        },
        fullScreen: {
            type: Boolean,
            default: false
        },
        thumbsPosition: {
            type: String,
            default: "right"
        },
        youtubeCookies: {
            type: Boolean,
            default: true
        },
        enableWheelEvent: {
            type: Boolean,
            default: false
        },
        showCloseButton: {
            type: Boolean,
            default: true
        },
        disableZoom: {
            type: Boolean,
            default: false
        },
        dir: {
            type: String,
            default: "ltr"
        },
        enableScrollLock: {
            type: Boolean,
            default: true
        },
        translations: {
            type: Object,
            default: function default$1() {
                return {
                    previous: "Previous",
                    next: "Next",
                    showThumbNails: "Show thumbnails",
                    playSlideShow: "Play slideshow",
                    fullScreen: "Fullscreen",
                    close: "Close"
                };
            }
        }
    },
    watch: {
        zoomBar: function zoomBar(newVal, prevVal) {
            var item;
            if (this.isZooming) {
                if (this.effect == "swipe") item = this.$refs.items[this.imgIndex].childNodes[0];
                else item = this.$refs.items.childNodes[0];
                var newZoom = 1.6 + newVal / 10;
                item.style.transform = "translate3d(calc(-50% + " + this.left + "px), calc(-50% + " + this.top + "px), 0px) scale3d(" + newZoom + ", " + newZoom + ", " + newZoom + ")";
            }
        },
        showThumbs: function showThumbs(prev, val) {
            var widthGalleryBlock = 212;
            var swipeAnimation = "all .3s ease";
            if (window.innerWidth < 767) {
                widthGalleryBlock = 102;
                swipeAnimation = null;
            }
            if (this.thumbsPosition === "bottom") widthGalleryBlock = 0;
            var self = this;
            this.swipeAnimation = swipeAnimation;
            if (prev) {
                if (this.dir === "rtl") this.xSwipeWrapper = this.imgIndex * (window.innerWidth - widthGalleryBlock) + 30 * this.imgIndex;
                else this.xSwipeWrapper = -this.imgIndex * (window.innerWidth - widthGalleryBlock) - 30 * this.imgIndex;
            } else if (this.dir === "rtl") this.xSwipeWrapper = this.imgIndex * window.innerWidth + 30 * this.imgIndex;
            else this.xSwipeWrapper = -this.imgIndex * window.innerWidth - 30 * this.imgIndex;
            setTimeout(function() {
                self.swipeAnimation = null;
            }, 300);
        },
        index: function index(prev, val) {
            var self = this;
            // body scroll lock
            var $body = document.querySelector("body");
            if (prev !== null) {
                // swipe type
                this.swipeType = null;
                this.initialMouseY = 0;
                this.ySwipeWrapper = 0;
                // set loop from data
                this.loopData = this.loop;
                // swipe effect case remove loop
                if (this.effect === "swipe") {
                    this.loopData = false;
                    window.addEventListener("resize", this.xPositionOnResize);
                }
                // add img index
                this.imgIndex = prev;
                this.isVisible = true;
                // add events listener
                window.addEventListener("keydown", this.eventListener);
                // add wheel event
                if (this.enableWheelEvent) window.addEventListener("wheel", this.wheelEvent);
                // add click event
                setTimeout(function() {
                    window.addEventListener("click", self.showButtons);
                }, 200);
                if (this.enableScrollLock) setTimeout(function() {
                    self.setCompensateForScrollbar();
                    (0, $gYJCo.disableBodyScroll)(self.$refs.coolLightbox);
                }, 50);
            } else {
                // hide and stop slideshow
                this.isVisible = false;
                this.stopSlideShow();
                // set starts X to 0
                this.startsX = 0;
                this.initialMouseY = 0;
                this.swipeType = null;
                // clear interval
                clearInterval(this.swipeInterval);
                this.swipeAnimation = null;
                // finish swipe
                this.isDraggingSwipe = false;
                this.isZooming = true;
                // remove events listener
                window.removeEventListener("keydown", this.eventListener);
                if (this.enableScrollLock) {
                    self.removeCompensateForScrollbar();
                    (0, $gYJCo.enableBodyScroll)(self.$refs.coolLightbox);
                }
                // remove click event
                window.removeEventListener("click", this.showButtons);
                // remove resize event
                window.removeEventListener("resize", this.xPositionOnResize);
                // remove wheel event
                if (this.enableWheelEvent) window.removeEventListener("wheel", this.wheelEvent);
            }
        },
        imgIndex: function imgIndex(prev, val) {
            var this$1 = this;
            // when animation is loaded
            this.$nextTick(function() {
                if (this$1.effect === "swipe") {
                    this$1.setLightboxInnerWidth();
                    this$1.setXPosition(prev);
                }
                if (prev !== null & val === null) this$1.$emit("on-open", prev);
                if (prev !== null) {
                    if (prev !== val) {
                        if (!this$1.getYoutubeUrl(this$1.getItemSrc(prev)) && !this$1.getVimeoUrl(this$1.getItemSrc(prev))) this$1.stopVideos();
                    }
                    // if is an image change imageLoading to true
                    if (!this$1.getVideoUrl(this$1.getItemSrc(prev))) {
                        if (!this$1.is_cached(this$1.getItemSrc(prev))) this$1.imageLoading = true;
                    }
                    // add caption padding to Lightbox wrapper
                    this$1.addCaptionPadding();
                    // setAspectRatioVideo when is swipe
                    if (this$1.effect === "swipe") this$1.setAspectRatioVideo();
                    else if (this$1.getVideoUrl(this$1.getItemSrc(prev))) this$1.setAspectRatioVideo();
                }
                // reset zoom
                this$1.resetZoom();
                // reset swipe type
                this$1.swipeType = null;
                this$1.ySwipeWrapper = 0;
            });
        }
    },
    beforeDestroy: function beforeDestroy() {
        if (this.enableScrollLock) {
            this.removeCompensateForScrollbar();
            if (this.$refs.coolLightbox) (0, $gYJCo.enableBodyScroll)(this.$refs.coolLightbox);
        }
    },
    methods: {
        getExtFromItem: function getExtFromItem(imgIndex) {
            if (imgIndex === null) return false;
            if (this.checkIfIsObject(imgIndex)) {
                var item = this.items[imgIndex];
                //item extension is specified, so return it
                if (item["ext"]) return item["ext"];
                return "mp4";
            }
        },
        stopVideos: function stopVideos() {
            var videos = document.getElementsByClassName("cool-lightbox-video");
            var isVideoPlaying = function(video) {
                return !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
            };
            if (videos.length > 0) Array.prototype.forEach.call(videos, function(video) {
                var type = video.tagName;
                if (type === "IFRAME") {
                    var iframeSrc = video.src;
                    return video.src = iframeSrc;
                }
                if (isVideoPlaying(video)) return video.pause();
            });
        },
        removeCompensateForScrollbar: function removeCompensateForScrollbar() {
            document.body.classList.remove("compensate-for-scrollbar");
            var noscrollStyle = document.getElementById("coollightbox-style-noscroll");
            if (noscrollStyle !== null) document.getElementById("coollightbox-style-noscroll").remove();
        },
        setCompensateForScrollbar: function setCompensateForScrollbar() {
            var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            if (!isMobile && document.body.scrollHeight > window.innerHeight) {
                document.getElementsByTagName("head")[0].insertAdjacentHTML("beforeend", '<style id="coollightbox-style-noscroll" type="text/css">.compensate-for-scrollbar{margin-right:' + (window.innerWidth - document.documentElement.clientWidth) + "px;}</style>");
                document.body.classList.add("compensate-for-scrollbar");
            }
        },
        setAutoplay: function setAutoplay(itemIndex) {
            if (this.checkIfIsObject(itemIndex) && this.items[itemIndex].hasOwnProperty("autoplay") && this.items[itemIndex].autoplay) return true;
            return false;
        },
        toggleFullScreenMode: function toggleFullScreenMode() {
            if (this.isFullScreenMode) this.closeFullscreen();
            else this.fullScreenMode();
            this.isFullScreenMode = !this.isFullScreenMode;
        },
        closeFullscreen: function closeFullscreen() {
            if (document.exitFullscreen) document.exitFullscreen();
            else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
            else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
            else if (document.msExitFullscreen) document.msExitFullscreen();
        },
        fullScreenMode: function fullScreenMode() {
            /* Get the documentElement (<html>) to display the page in fullscreen */ var elem = document.documentElement;
            if (elem.requestFullscreen) elem.requestFullscreen();
            else if (elem.mozRequestFullScreen) elem.mozRequestFullScreen();
            else if (elem.webkitRequestFullscreen) elem.webkitRequestFullscreen();
            else if (elem.msRequestFullscreen) elem.msRequestFullscreen();
        },
        // check if event is arrow button or toolbar button
        checkIfIsButton: function checkIfIsButton(event) {
            var elements = ".cool-lightbox__iframe *, .cool-lightbox-button, .cool-lightbox-button *, .cool-lightbox-toolbar__btn, .cool-lightbox-toolbar__btn *, .cool-lightbox-caption h6, .cool-lightbox-caption p, .cool-lightbox-caption a";
            if (event.target.matches(elements)) return true;
            return false;
        },
        // start swipe event
        startSwipe: function startSwipe(event) {
            if (this.isZooming) return false;
            // check if is some button
            if (this.checkIfIsButton(event)) return false;
            // clear interval
            clearInterval(this.swipeInterval);
            this.swipeAnimation = null;
            // starts swipe
            this.isDraggingSwipe = true;
            this.initialMouseX = this.getMouseXPosFromEvent(event);
            this.initialMouseY = this.getMouseYPosFromEvent(event);
        },
        // continue swipe event
        continueSwipe: function continueSwipe(event) {
            if (this.isDraggingSwipe) {
                this.IsSwipping = true;
                var currentPosX = this.getMouseXPosFromEvent(event);
                var currentPosY = this.getMouseYPosFromEvent(event);
                var windowWidth = this.lightboxInnerWidth;
                // diffs
                var diffX = Math.abs(currentPosX - this.initialMouseX);
                var diffY = Math.abs(currentPosY - this.initialMouseY);
                // swipe type
                if (this.swipeType == null) {
                    if (diffY > 5 || diffX > 5) {
                        if (diffY > diffX) this.swipeType = "v";
                        else this.swipeType = "h";
                    }
                }
                // swipe
                if (this.swipeType == "h") {
                    // swipe wrapper
                    if (this.dir === "rtl") this.xSwipeWrapper = windowWidth * this.imgIndex + currentPosX - this.initialMouseX + 30 * this.imgIndex;
                    else this.xSwipeWrapper = -(windowWidth * this.imgIndex) + currentPosX - this.initialMouseX - 30 * this.imgIndex;
                } else this.ySwipeWrapper = currentPosY - this.initialMouseY;
                // mobile caseS
                if (event.type === "touchmove") {
                    this.endMouseX = this.getMouseXPosFromEvent(event);
                    this.endMouseY = this.getMouseYPosFromEvent(event);
                }
            }
        },
        // end swipe event
        endSwipe: function endSwipe(event) {
            if (this.checkIfIsButton(event) && this.initialMouseX === 0) return false;
            // event check is dragging and swipe
            var self = this;
            var swipeType = this.swipeType;
            this.isDraggingSwipe = false;
            // horizontal swipe type
            if (this.initialMouseX === 0 && swipeType == "h") return false;
            // touch end fixes
            if (event.type !== "touchend") {
                this.endMouseX = this.getMouseXPosFromEvent(event);
                this.endMouseY = this.getMouseYPosFromEvent(event);
            } else {
                if (this.endMouseX === 0) return;
            }
            // check if is dragged
            if (this.endMouseX - this.initialMouseX === 0 && swipeType == "h" || this.isZooming || this.endMouseY - this.initialMouseY === 0 && swipeType == "v") return;
            // set swipe animation
            this.setSwipeAnimation();
            // reset swipe data
            setTimeout(function() {
                self.IsSwipping = false;
                self.initialMouseX = 0;
                self.endMouseX = 0;
            }, 10);
            // type of swipe
            if (this.swipeType === "h") {
                // if the swipe is to the right
                if (this.endMouseX - this.initialMouseX < -40) {
                    if (this.dir === "rtl") return this.swipeToLeft();
                    return this.swipeToRight();
                }
                // if the swipe is to the left
                if (this.endMouseX - this.initialMouseX > 40) {
                    if (this.dir === "rtl") return this.swipeToRight();
                    return this.swipeToLeft();
                }
            }
            if (this.swipeType === "v") {
                var diffY = Math.abs(this.endMouseY - this.initialMouseY);
                // diff Y
                if (diffY >= 90) this.close();
                else this.ySwipeWrapper = 0;
            }
            this.swipeType = null;
            var windowWidth = this.lightboxInnerWidth;
            if (this.dir === "rtl") {
                this.xSwipeWrapper = this.imgIndex * windowWidth + 30 * this.imgIndex;
                return;
            }
            this.xSwipeWrapper = -this.imgIndex * windowWidth - 30 * this.imgIndex;
        },
        // swipe to left effect
        swipeToLeft: function swipeToLeft() {
            if (!this.hasPrevious && this.effect === "swipe") {
                if (this.dir === "rtl") return this.xSwipeWrapper = this.imgIndex * this.lightboxInnerWidth + 30 * this.imgIndex;
                return this.xSwipeWrapper = -this.imgIndex * this.lightboxInnerWidth - 30 * this.imgIndex;
            }
            this.changeIndexToPrev();
        },
        // swipe to right effect
        swipeToRight: function swipeToRight() {
            if (!this.hasNext && this.effect === "swipe") {
                if (this.dir === "rtl") return this.xSwipeWrapper = this.imgIndex * this.lightboxInnerWidth + 30 * this.imgIndex;
                return this.xSwipeWrapper = -this.imgIndex * this.lightboxInnerWidth - 30 * this.imgIndex;
            }
            this.changeIndexToNext();
        },
        // function that return x position from event
        getMouseXPosFromEvent: function getMouseXPosFromEvent(event) {
            if (event.type.indexOf("mouse") !== -1) return event.clientX;
            return event.touches[0].clientX;
        },
        // function that return Y position from event
        getMouseYPosFromEvent: function getMouseYPosFromEvent(event) {
            if (event.type.indexOf("mouse") !== -1) return event.clientY;
            return event.touches[0].clientY;
        },
        // check if the image is cached
        is_cached: function is_cached(src) {
            var image = new Image();
            image.src = src;
            return image.complete;
        },
        // image loaded event
        imageLoaded: function imageLoaded() {
            this.imageLoading = false;
        },
        // get video url
        itemThumb: function itemThumb(itemUrl, itemIndex) {
            var thumb = this.getItemThumb(itemIndex);
            if (thumb) return thumb;
            var youtubeID = this.getYoutubeID(itemUrl);
            if (youtubeID) return "https://img.youtube.com/vi/" + youtubeID + "/mqdefault.jpg";
            var vimeoID = this.getVimeoID(itemUrl);
            if (vimeoID) return false;
            return itemUrl;
        },
        isItemPicture: function isItemPicture(imgIndex) {
            if (imgIndex === null) return false;
            var item = this.items[imgIndex];
            if (this.checkIfIsObject(imgIndex)) return item.picture;
            return false;
        },
        getPictureSources: function getPictureSources(imgIndex) {
            if (imgIndex === null) return false;
            var picture = this.items[imgIndex].picture;
            return picture.sources ? picture.sources : [];
        },
        // get item src
        getItemSrc: function getItemSrc(imgIndex) {
            if (imgIndex === null) return false;
            var item = this.items[imgIndex];
            if (this.checkIfIsObject(imgIndex)) return item[this.srcName];
            return item;
        },
        getItemSrcSet: function getItemSrcSet(imgIndex) {
            if (imgIndex === null) return false;
            var item = this.items[imgIndex];
            if (this.checkIfIsObject(imgIndex)) return item[this.srcSetName];
            return null;
        },
        getItemSizes: function getItemSizes(imgIndex) {
            if (imgIndex === null) return false;
            var item = this.items[imgIndex];
            if (this.checkIfIsObject(imgIndex)) return item.sizes;
            return null;
        },
        getItemAlt: function getItemAlt(imgIndex) {
            if (imgIndex === null) return false;
            var item = this.items[imgIndex];
            if (this.checkIfIsObject(imgIndex)) return item.alt;
            return null;
        },
        getItemThumb: function getItemThumb(imgIndex) {
            if (imgIndex === null) return false;
            var item = this.items[imgIndex];
            if (this.checkIfIsObject(imgIndex)) return item[this.srcThumb];
            if (this.getVideoUrl(item)) return false;
            return item;
        },
        // get item media type
        getMediaType: function getMediaType(imgIndex) {
            if (imgIndex === null) return false;
            if (this.checkIfIsObject(imgIndex)) {
                var item$1 = this.items[imgIndex];
                //item type is specified, so return it
                if (item$1[this.srcMediaType]) return item$1[this.srcMediaType];
            }
            if (this.getVideoUrl(this.getItemSrc(imgIndex))) return "video";
            else if (this.getPDFurl(this.getItemSrc(imgIndex))) return "iframe";
            else return "image";
        },
        // toggle play slideshow event
        togglePlaySlideshow: function togglePlaySlideshow() {
            if (!this.slideshow) return false;
            if (!this.hasNext && !this.loopData) return false;
            this.isPlayingSlideShow = !this.isPlayingSlideShow;
            // if is playing move if not stop it
            if (this.isPlayingSlideShow) this.move();
            else this.stopSlideShow();
        },
        // stop slideshow
        stopSlideShow: function stopSlideShow() {
            this.isPlayingSlideShow = false;
            clearInterval(this.intervalProgress);
            this.stylesInterval = {
                "transform": "scaleX(0)",
                "transition": "none"
            };
        },
        // move event in zoom
        move: function move() {
            var self = this;
            this.progressWidth = 100;
            this.intervalProgress = setInterval(frame, this.slideshowDuration + 90);
            self.stylesInterval = {
                "transform": "scaleX(1)",
                "background": this.slideshowColorBar,
                "transition-duration": this.slideshowDuration + "ms"
            };
            function frame() {
                self.stylesInterval = {
                    "transform": "scaleX(0)",
                    "transition": "none"
                };
                if (self.dir === "rtl") self.onPrevClick(true);
                else self.onNextClick(true);
                if (!self.hasNext && !self.loopData) self.stopSlideShow();
                else setTimeout(function() {
                    self.stylesInterval = {
                        "transform": "scaleX(1)",
                        "background": self.slideshowColorBar,
                        "transition-duration": self.slideshowDuration + "ms"
                    };
                }, 50);
            }
        },
        // show buttons event
        showButtons: function showButtons(event) {
            if (this.disableZoom && !this.checkIfIsButton(event)) {
                var self = this;
                setTimeout(function() {
                    self.buttonsVisible = !self.buttonsVisible;
                }, 100);
            }
        },
        // check if is allowed to drag
        checkMouseEventPropButton: function checkMouseEventPropButton(button) {
            if (!this.isZooming) return false;
            // mouse left btn click
            return button === 0;
        },
        // handle mouse down event
        handleMouseDown: function handleMouseDown(e) {
            if (!(e.type === "touchstart" && this.isZooming || e.type === "mousedown" && this.checkMouseEventPropButton(e.button))) return;
            this.lastX = (e.type === "touchstart" ? e.touches[0] : e).clientX;
            this.lastY = (e.type === "touchstart" ? e.touches[0] : e).clientY;
            if (this.isZooming) this.isDraging = true;
            e.stopPropagation();
        },
        // handle mouse up event
        handleMouseUp: function handleMouseUp(e) {
            if (!(e.type === "touchend" && this.isZooming || e.type === "mouseup" && this.checkMouseEventPropButton(e.button))) return;
            this.isDraging = false;
            this.lastX = this.lastY = 0;
            // Fix drag zoom out
            var thisContext = this;
            setTimeout(function() {
                thisContext.canZoom = true;
            }, 100);
        },
        // handle mouse leave event
        handleMouseLeave: function handleMouseLeave(e) {
            if (!(e.type === "mouseleave" && this.isZooming)) return;
            this.isDraging = false;
            this.lastX = this.lastY = 0;
            // Fix drag zoom out
            var thisContext = this;
            setTimeout(function() {
                thisContext.canZoom = true;
            }, 100);
        },
        // handle mouse move event
        handleMouseMove: function handleMouseMove(e) {
            if (!(e.type === "touchmove" && this.isZooming || e.type === "mousemove" && this.checkMouseEventPropButton(e.button))) return;
            if (this.isDraging) {
                var clientX = (e.type === "touchmove" ? e.touches[0] : e).clientX;
                var clientY = (e.type === "touchmove" ? e.touches[0] : e).clientY;
                this.top = this.top - this.lastY + clientY;
                this.left = this.left - this.lastX + clientX;
                this.lastX = clientX;
                this.lastY = clientY;
                this.canZoom = false;
                var item = e.target.parentNode.nodeName === "PICTURE" ? e.target.parentNode.parentNode : e.target.parentNode;
                var newZoom = 1.6 + this.zoomBar / 10;
                item.style.transform = "translate3d(calc(-50% + " + this.left + "px), calc(-50% + " + this.top + "px), 0px) scale3d(" + newZoom + ", " + newZoom + ", " + newZoom + ")";
            }
            e.stopPropagation();
        },
        // zoom image event
        zoomImage: function zoomImage(indexImage) {
            if (this.disableZoom) return false;
            if (!this.canZoom) return false;
            if (this.IsSwipping) return false;
            // item zoom
            var item;
            if (this.effect == "swipe") item = this.$refs.items[this.imgIndex].childNodes[0];
            else item = this.$refs.items.childNodes[0];
            // zoom variables
            var isZooming = this.isZooming;
            var thisContext = this;
            // Is zooming check
            if (isZooming) {
                if (!this.isDraging) {
                    this.isZooming = false;
                    this.zoomBar = 0;
                }
            } else this.isZooming = true;
            // check if is zooming
            if (this.isZooming) {
                this.stopSlideShow();
                // add scale
                item.style.transform = "translate3d(calc(-50%), calc(-50%), 0px) scale3d(1.6, 1.6, 1.6)";
                // hide buttons
                this.buttonsVisible = false;
                // fix drag transition problems
                setTimeout(function() {
                    thisContext.transition = "all .0s ease";
                }, 100);
            } else {
                // show buttons
                this.buttonsVisible = true;
                this.resetZoom();
            }
        },
        // Reset zoom data
        resetZoom: function resetZoom() {
            this.scale = 1;
            this.left = 0;
            this.top = 0;
            this.zoomBar = 0;
            this.isZooming = false;
            this.swipeType = null;
            this.transition = "all .3s ease";
            // only if index is not null
            if (this.imgIndex != null) {
                var item;
                if (this.effect == "swipe") item = this.$refs.items[this.imgIndex].childNodes[0];
                else item = this.$refs.items.childNodes[0];
                // reset styles
                if (this.disableZoom) item.style.transform = "translate3d(calc(-50% + " + this.left + "px), calc(-50% + " + this.top + "px), 0px)";
                else item.style.transform = "translate3d(calc(-50% + " + this.left + "px), calc(-50% + " + this.top + "px), 0px) scale3d(1, 1, 1)";
                this.initialMouseX = 0;
                if (window.innerWidth >= 700) this.buttonsVisible = true;
            }
        },
        // Aspect Ratio responsive video
        setAspectRatioVideo: function setAspectRatioVideo() {
            var thisContext = this;
            var el = document.getElementsByClassName("cool-lightbox__inner");
            el = el[0];
            var computedStyle = getComputedStyle(el);
            if (window.innerWidth < 1440) {
                var width = el.clientWidth;
                var height = Math.round(width / 16 * 9);
                this.aspectRatioVideo.height = height + "px";
                this.aspectRatioVideo.width = width + "px";
            } else setTimeout(function() {
                var height = el.clientHeight;
                height -= parseFloat(computedStyle.paddingTop) + parseFloat(computedStyle.paddingBottom);
                var width = height / 9 * 16;
                thisContext.aspectRatioVideo.height = height + "px";
                thisContext.aspectRatioVideo.width = width + "px";
            }, 150);
        },
        // close event
        close: function close() {
            this.stopSlideShow();
            this.swipeType = null;
            this.$emit("close", this.imgIndex);
            this.showThumbs = false;
            this.imgIndex = null;
        },
        wheelEvent: function wheelEvent(event) {
            var delay = 350;
            var currentTime = new Date().getTime();
            var direction = event.deltaY > 0 ? "top" : "down";
            if (currentTime - this.prevTime < delay) return;
            this.prevTime = currentTime;
            switch(direction){
                case "top":
                    return this.changeIndexToPrev();
                case "down":
                    return this.changeIndexToNext();
            }
        },
        // close event click outside
        closeModal: function closeModal(event) {
            if (!this.closeOnClickOutsideMobile) {
                if (window.innerWidth < 700) return false;
            }
            if (this.IsSwipping) return false;
            var elements = ".cool-lightbox__iframe, .cool-lightbox__iframe *, .cool-lightbox-zoom, .cool-lightbox-zoom *, .cool-lightbox-thumbs, svg, path, rect, .cool-lightbox-thumbs *, .cool-lightbox-button, .cool-lightbox-toolbar__btn, .cool-lightbox-toolbar__btn *, .cool-lightbox-button *, .cool-lightbox__slide__img *, .cool-lightbox-video, .cool-lightbox-caption h6, .cool-lightbox-caption p, .cool-lightbox-caption a";
            if (!event.target.matches(elements)) this.close();
        },
        // set swipe animation
        setSwipeAnimation: function setSwipeAnimation() {
            var self = this;
            clearInterval(this.swipeInterval);
            this.swipeAnimation = null;
            // animation swipe
            this.swipeAnimation = "all .3s ease";
            this.swipeInterval = setInterval(interval, 330);
            function interval() {
                self.swipeAnimation = null;
            }
        },
        // next slide event
        onNextClick: function onNextClick(isFromSlideshow) {
            if (isFromSlideshow === void 0) isFromSlideshow = false;
            if (this.isZooming) return false;
            if (!isFromSlideshow) this.stopSlideShow();
            this.setSwipeAnimation();
            if (this.dir === "rtl") return this.changeIndexToPrev();
            this.changeIndexToNext();
        },
        // prev slide event
        onPrevClick: function onPrevClick(isFromSlideshow) {
            if (isFromSlideshow === void 0) isFromSlideshow = false;
            if (this.isZooming) return false;
            if (!isFromSlideshow) this.stopSlideShow();
            this.setSwipeAnimation();
            if (this.dir === "rtl") return this.changeIndexToNext();
            this.changeIndexToPrev();
        },
        // change to next index
        changeIndexToNext: function changeIndexToNext() {
            if (this.hasNext) this.onIndexChange(this.imgIndex + 1);
            else // only if has loop prop
            if (this.loopData) this.onIndexChange(0);
        },
        // change to prev index
        changeIndexToPrev: function changeIndexToPrev() {
            if (this.hasPrevious) this.onIndexChange(this.imgIndex - 1);
            else // only if has loop prop
            if (this.loopData) this.onIndexChange(this.items.length - 1);
        },
        // set lightbox inner width
        setLightboxInnerWidth: function setLightboxInnerWidth() {
            var el = document.getElementsByClassName("cool-lightbox__inner");
            var width = el[0].clientWidth;
            this.lightboxInnerWidth = width;
        },
        // x position on resize event
        xPositionOnResize: function xPositionOnResize() {
            this.setLightboxInnerWidth();
            var index = this.imgIndex;
            if (this.dir === "rtl") {
                this.xSwipeWrapper = index * this.lightboxInnerWidth + 30 * index;
                return;
            }
            // set x position
            this.xSwipeWrapper = -index * this.lightboxInnerWidth - 30 * index;
        },
        // set x position by img index
        setXPosition: function setXPosition(index) {
            if (this.dir === "rtl") {
                this.xSwipeWrapper = index * this.lightboxInnerWidth + 30 * index;
                return;
            }
            // set x position
            this.xSwipeWrapper = -index * this.lightboxInnerWidth - 30 * index;
            return;
        },
        // index change
        onIndexChange: function onIndexChange(index) {
            var self = this;
            this.imgIndex = index;
            this.$emit("on-change", index);
            setTimeout(function() {
                self.$emit("on-change-end", index);
            }, 400);
        },
        // caption size
        addCaptionPadding: function addCaptionPadding() {
            if (this.checkIfIsObject(this.imgIndex) && (this.items[this.imgIndex].title || this.items[this.imgIndex].descripcion)) {
                var el = document.getElementsByClassName("cool-lightbox-caption");
                if (el.length > 0) this.paddingBottom = el[0].offsetHeight;
            } else this.paddingBottom = 60;
        },
        getPDFurl: function getPDFurl(url) {
            if (this.imgIndex === null) return false;
            var str = new String(url);
            if (str.endsWith(".pdf")) return url;
            return false;
        },
        // check if is video
        getVideoUrl: function getVideoUrl(itemSrc) {
            var youtubeUrl = this.getYoutubeUrl(itemSrc);
            var vimeoUrl = this.getVimeoUrl(itemSrc);
            var mp4Url = this.checkIsMp4(itemSrc);
            if (youtubeUrl) return youtubeUrl;
            if (vimeoUrl) return vimeoUrl;
            if (mp4Url) return mp4Url;
            return false;
        },
        // getYoutube ID
        getYoutubeID: function getYoutubeID(url) {
            // youtube data
            var youtubeRegex = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
            var ytId = url.match(youtubeRegex) ? RegExp.$1 : false;
            if (ytId) return ytId;
            return false;
        },
        // get youtube url
        getYoutubeUrl: function getYoutubeUrl(url) {
            // youtube data
            var ytId = this.getYoutubeID(url);
            // if is youtube video
            if (ytId) {
                // check if allows youtube cookies
                if (this.youtubeCookies) return "https://www.youtube.com/embed/" + ytId;
                return "https://www.youtube-nocookie.com/embed/" + ytId;
            }
            return false;
        },
        // vimeo ID
        getVimeoID: function getVimeoID(url) {
            // if is vimeo video
            var result = url.match(/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i);
            if (result !== null) return result[1];
            return false;
        },
        // get vimeo url
        getVimeoUrl: function getVimeoUrl(url) {
            // if is vimeo video
            var result = url.match(/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i);
            if (result !== null) return "//player.vimeo.com/video/" + result[1] + "?hd=1&show_title=1&show_byline=1&show_portrait=0&fullscreen=1";
            return false;
        },
        // check if video is mp4
        checkIsMp4: function checkIsMp4(url) {
            if (this.imgIndex === null) return false;
            var str = new String(url);
            var videoExtensions = [
                ".mp4",
                ".mov",
                ".webm",
                ".ogg",
                ".avi"
            ];
            var isValidExtension = videoExtensions.filter(function(videoExtension) {
                return str.indexOf(videoExtension) !== -1 || str.indexOf(videoExtension.toUpperCase()) !== -1;
            }).length > 0;
            if (isValidExtension) return url;
            return false;
        },
        // if is video get extension
        getVideoExt: function getVideoExt(url) {
            if (this.imgIndex === null) return false;
            var str = new String(url);
            if (str.indexOf(".mp4") !== -1 || str.indexOf(".mov") !== -1) return "mp4";
            if (str.indexOf(".webm") !== -1) return "webm";
            if (str.indexOf(".ogg") !== -1) return "ogg";
            if (str.indexOf(".avi") !== -1) return "avi";
            return false;
        },
        // check if item is object
        checkIfIsObject: function checkIfIsObject(itemIndex) {
            var item = this.items[itemIndex];
            if (typeof item === "object" && item !== null) return true;
            return false;
        },
        // arrows and escape events
        eventListener: function eventListener(e) {
            switch(e.keyCode){
                case 39:
                    return this.onNextClick();
                case 37:
                    return this.onPrevClick();
                case 38:
                case 40:
                case " ":
                    return e.preventDefault();
                case 27:
                    return this.close();
            }
        }
    },
    computed: {
        // Images wrapper styles to use drag and zoom
        imgWrapperStyle: function imgWrapperStyle() {
            return {
                top: "50%",
                left: "50%",
                transition: this.transition
            };
        },
        // lightbox styles
        lightboxStyles: function lightboxStyles() {
            return {
                "z-index": this.zIndex,
                "background-color": this.overlayColor
            };
        },
        innerStyles: function innerStyles() {
            return {
                "padding-bottom": this.paddingBottom + "px"
            };
        },
        // get item src
        itemSrc: function itemSrc() {
            if (this.imgIndex === null) return false;
            var item = this.items[this.imgIndex];
            if (this.checkIfIsObject(this.imgIndex)) return item[this.srcName];
            return item;
        },
        // Lightbox classes
        lightboxClasses: function lightboxClasses() {
            var classesReturn = [
                {
                    "cool-lightbox--can-zoom": this.canZoom && !this.disableZoom
                },
                {
                    "cool-lightbox--zoom-disabled": this.disableZoom
                },
                {
                    "cool-lightbox--is-zooming": this.isZooming
                },
                {
                    "cool-lightbox--show-thumbs": this.showThumbs
                },
                {
                    "cool-lightbox--is-swipping": this.isDraggingSwipe
                }
            ];
            var classString = "cool-lightbox--thumbs-" + this.thumbsPosition;
            classesReturn.push(classString);
            return classesReturn;
        },
        // Buttons classes
        buttonsClasses: function buttonsClasses() {
            return {
                "hidden": !this.buttonsVisible
            };
        },
        // check if the slide has next element
        hasNextButton: function hasNextButton() {
            if (this.dir === "rtl") return this.imgIndex - 1 >= 0;
            return this.imgIndex + 1 < this.items.length;
        },
        // check if the slide has previous element
        hasPreviousButton: function hasPreviousButton() {
            if (this.dir === "rtl") return this.imgIndex + 1 < this.items.length;
            return this.imgIndex - 1 >= 0;
        },
        // check if the slide has next element
        hasNext: function hasNext() {
            return this.imgIndex + 1 < this.items.length;
        },
        // check if the slide has previous element
        hasPrevious: function hasPrevious() {
            return this.imgIndex - 1 >= 0;
        }
    }
};
function $c8654d17047f9f6d$var$normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== "boolean") {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    } // Vue.extend constructor export interop.
    var options = typeof script === "function" ? script.options : script; // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true; // functional template
        if (isFunctionalTemplate) options.functional = true;
    } // scopedId
    if (scopeId) options._scopeId = scopeId;
    var hook;
    if (moduleIdentifier) {
        // server build
        hook = function hook(context) {
            // 2.3 injection
            context = context || // cached call
            this.$vnode && this.$vnode.ssrContext || // stateful
            this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") context = __VUE_SSR_CONTEXT__;
             // inject component styles
            if (style) style.call(this, createInjectorSSR(context));
             // register component module identifier for async chunk inference
            if (context && context._registeredComponents) context._registeredComponents.add(moduleIdentifier);
        }; // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    } else if (style) hook = shadowMode ? function() {
        style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function(context) {
        style.call(this, createInjector(context));
    };
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            var originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        } else {
            // inject component registration as beforeCreate hook
            var existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [
                hook
            ];
        }
    }
    return script;
}
var $c8654d17047f9f6d$var$normalizeComponent_1 = $c8654d17047f9f6d$var$normalizeComponent;
/* script */ var $c8654d17047f9f6d$var$__vue_script__ = $c8654d17047f9f6d$var$script;
/* template */ var $c8654d17047f9f6d$var$__vue_render__ = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("transition", {
        attrs: {
            "name": "cool-lightbox-modal"
        }
    }, [
        _vm.isVisible ? _c("div", {
            ref: "coolLightbox",
            staticClass: "cool-lightbox",
            class: _vm.lightboxClasses,
            style: _vm.lightboxStyles,
            on: {
                "click": _vm.closeModal
            }
        }, [
            _vm.gallery ? _c("div", {
                staticClass: "cool-lightbox-thumbs"
            }, [
                _c("div", {
                    staticClass: "cool-lightbox-thumbs__list"
                }, _vm._l(_vm.items, function(item, itemIndex) {
                    return _c("button", {
                        key: itemIndex,
                        staticClass: "cool-lightbox__thumb",
                        class: {
                            active: itemIndex === _vm.imgIndex,
                            "is-video": _vm.getMediaType(itemIndex) === "video"
                        },
                        attrs: {
                            "type": "button"
                        },
                        on: {
                            "click": function($event) {
                                _vm.imgIndex = itemIndex;
                            }
                        }
                    }, [
                        _vm.getMediaType(itemIndex) === "video" ? _c("svg", {
                            staticClass: "cool-lightbox__thumb__icon",
                            attrs: {
                                "xmlns": "http://www.w3.org/2000/svg",
                                "viewBox": "0 0 24 24"
                            }
                        }, [
                            _c("path", {
                                attrs: {
                                    "d": "M6.5 5.4v13.2l11-6.6z"
                                }
                            })
                        ]) : _vm._e(),
                        _vm._v(" "),
                        _c("img", {
                            attrs: {
                                "src": _vm.itemThumb(_vm.getItemSrc(itemIndex), itemIndex),
                                "alt": ""
                            }
                        })
                    ]);
                }), 0)
            ]) : _vm._e(),
            _vm._v(" "),
            _c("div", {
                staticClass: "cool-lightbox__inner",
                style: _vm.innerStyles,
                on: {
                    "mousedown": _vm.startSwipe,
                    "mousemove": _vm.continueSwipe,
                    "mouseup": _vm.endSwipe,
                    "touchstart": _vm.startSwipe,
                    "touchmove": _vm.continueSwipe,
                    "touchend": _vm.endSwipe
                }
            }, [
                _c("div", {
                    staticClass: "cool-lightbox__progressbar",
                    style: _vm.stylesInterval
                }),
                _vm._v(" "),
                _c("div", {
                    staticClass: "cool-lightbox__navigation"
                }, [
                    _c("button", {
                        directives: [
                            {
                                name: "show",
                                rawName: "v-show",
                                value: (_vm.hasPreviousButton || _vm.loopData) && _vm.items.length > 1,
                                expression: "(hasPreviousButton || loopData) && items.length > 1"
                            }
                        ],
                        staticClass: "cool-lightbox-button cool-lightbox-button--prev",
                        class: _vm.buttonsClasses,
                        attrs: {
                            "type": "button",
                            "title": _vm.translations.previous
                        },
                        on: {
                            "click": _vm.onPrevClick
                        }
                    }, [
                        _vm._t("icon-previous", function() {
                            return [
                                _c("div", {
                                    staticClass: "cool-lightbox-button__icon"
                                }, [
                                    _c("svg", {
                                        attrs: {
                                            "xmlns": "http://www.w3.org/2000/svg",
                                            "viewBox": "0 0 24 24"
                                        }
                                    }, [
                                        _c("path", {
                                            attrs: {
                                                "d": "M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"
                                            }
                                        })
                                    ])
                                ])
                            ];
                        })
                    ], 2),
                    _vm._v(" "),
                    _c("button", {
                        directives: [
                            {
                                name: "show",
                                rawName: "v-show",
                                value: (_vm.hasNextButton || _vm.loopData) && _vm.items.length > 1,
                                expression: "(hasNextButton || loopData) && items.length > 1"
                            }
                        ],
                        staticClass: "cool-lightbox-button cool-lightbox-button--next",
                        class: _vm.buttonsClasses,
                        attrs: {
                            "type": "button",
                            "title": _vm.translations.next
                        },
                        on: {
                            "click": function($event) {
                                return _vm.onNextClick(false);
                            }
                        }
                    }, [
                        _vm._t("icon-next", function() {
                            return [
                                _c("div", {
                                    staticClass: "cool-lightbox-button__icon"
                                }, [
                                    _c("svg", {
                                        attrs: {
                                            "xmlns": "http://www.w3.org/2000/svg",
                                            "viewBox": "0 0 24 24"
                                        }
                                    }, [
                                        _c("path", {
                                            attrs: {
                                                "d": "M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"
                                            }
                                        })
                                    ])
                                ])
                            ];
                        })
                    ], 2)
                ]),
                _vm._v(" "),
                _vm.effect === "swipe" ? _c("div", {
                    staticClass: "cool-lightbox__wrapper cool-lightbox__wrapper--swipe",
                    style: {
                        transform: "translate3d(" + _vm.xSwipeWrapper + "px, " + _vm.ySwipeWrapper + "px, 0)",
                        transition: _vm.swipeAnimation
                    }
                }, _vm._l(_vm.items, function(item, itemIndex) {
                    return _c("div", {
                        key: itemIndex,
                        ref: "items",
                        refInFor: true,
                        staticClass: "cool-lightbox__slide",
                        class: {
                            "cool-lightbox__slide--current": itemIndex === _vm.imgIndex
                        }
                    }, [
                        _vm.getMediaType(itemIndex) === "image" ? _c("div", {
                            directives: [
                                {
                                    name: "lazyload",
                                    rawName: "v-lazyload"
                                }
                            ],
                            key: "image",
                            staticClass: "cool-lightbox__slide__img",
                            style: _vm.imgWrapperStyle
                        }, [
                            !_vm.isItemPicture(itemIndex) ? _c("img", {
                                key: itemIndex,
                                attrs: {
                                    "data-src": _vm.getItemSrc(itemIndex),
                                    "data-srcset": _vm.getItemSrcSet(itemIndex),
                                    "data-sizes": _vm.getItemSizes(itemIndex),
                                    "draggable": "false",
                                    "alt": _vm.getItemAlt(itemIndex)
                                },
                                on: {
                                    "load": _vm.imageLoaded,
                                    "click": function($event) {
                                        return _vm.zoomImage(itemIndex);
                                    },
                                    "mousedown": function($event) {
                                        return _vm.handleMouseDown($event);
                                    },
                                    "mouseup": function($event) {
                                        return _vm.handleMouseUp($event);
                                    },
                                    "mouseleave": function($event) {
                                        return _vm.handleMouseLeave($event);
                                    },
                                    "mousemove": function($event) {
                                        return _vm.handleMouseMove($event);
                                    },
                                    "touchstart": function($event) {
                                        return _vm.handleMouseDown($event);
                                    },
                                    "touchmove": function($event) {
                                        return _vm.handleMouseMove($event);
                                    },
                                    "touchend": function($event) {
                                        return _vm.handleMouseUp($event);
                                    }
                                }
                            }) : _c("picture", {
                                key: itemIndex
                            }, [
                                _vm._l(_vm.getPictureSources(itemIndex), function(source, sourceIndex) {
                                    return _c("source", {
                                        key: "source-" + _vm.imgIndex + "-" + sourceIndex,
                                        attrs: {
                                            "data-srcset": source.srcset,
                                            "data-media": source.media,
                                            "type": source.type,
                                            "data-sizes": source.sizes || _vm.getItemSizes(_vm.imgIndex)
                                        }
                                    });
                                }),
                                _vm._v(" "),
                                _c("img", {
                                    attrs: {
                                        "data-src": _vm.getItemSrc(itemIndex),
                                        "data-srcset": _vm.getItemSrcSet(itemIndex),
                                        "data-sizes": _vm.getItemSizes(itemIndex),
                                        "draggable": "false",
                                        "alt": _vm.getItemAlt(itemIndex)
                                    },
                                    on: {
                                        "load": _vm.imageLoaded,
                                        "click": function($event) {
                                            return _vm.zoomImage(itemIndex);
                                        },
                                        "mousedown": function($event) {
                                            return _vm.handleMouseDown($event);
                                        },
                                        "mouseup": function($event) {
                                            return _vm.handleMouseUp($event);
                                        },
                                        "mouseleave": function($event) {
                                            return _vm.handleMouseLeave($event);
                                        },
                                        "mousemove": function($event) {
                                            return _vm.handleMouseMove($event);
                                        },
                                        "touchstart": function($event) {
                                            return _vm.handleMouseDown($event);
                                        },
                                        "touchmove": function($event) {
                                            return _vm.handleMouseMove($event);
                                        },
                                        "touchend": function($event) {
                                            return _vm.handleMouseUp($event);
                                        }
                                    }
                                })
                            ], 2),
                            _vm._v(" "),
                            _c("div", {
                                directives: [
                                    {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.imageLoading,
                                        expression: "imageLoading"
                                    }
                                ],
                                staticClass: "cool-lightbox-loading-wrapper"
                            }, [
                                _vm._t("loading", function() {
                                    return [
                                        _c("div", {
                                            staticClass: "cool-lightbox-loading"
                                        })
                                    ];
                                })
                            ], 2)
                        ]) : _c("div", {
                            key: "video",
                            staticClass: "cool-lightbox__iframe"
                        }, [
                            !_vm.checkIsMp4(_vm.getItemSrc(itemIndex)) && _vm.getMediaType(itemIndex) === "video" ? _c("iframe", {
                                directives: [
                                    {
                                        name: "autoplayObserver",
                                        rawName: "v-autoplayObserver"
                                    }
                                ],
                                key: itemIndex,
                                staticClass: "cool-lightbox-video",
                                style: _vm.aspectRatioVideo,
                                attrs: {
                                    "data-autoplay": _vm.setAutoplay(itemIndex),
                                    "src": _vm.getVideoUrl(_vm.getItemSrc(itemIndex)),
                                    "frameborder": "0",
                                    "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                                    "allowfullscreen": ""
                                }
                            }) : _vm._e(),
                            _vm._v(" "),
                            _vm.getMediaType(itemIndex) === "iframe" || _vm.getPDFurl(_vm.getItemSrc(itemIndex)) ? _c("iframe", {
                                key: itemIndex,
                                staticClass: "cool-lightbox-pdf",
                                attrs: {
                                    "src": _vm.getItemSrc(itemIndex),
                                    "frameborder": "0",
                                    "allowfullscreen": ""
                                }
                            }) : _vm._e(),
                            _vm._v(" "),
                            _vm.checkIsMp4(_vm.getItemSrc(itemIndex)) || _vm.getMediaType(itemIndex) === "webVideo" ? _c("video", {
                                directives: [
                                    {
                                        name: "autoplayObserver",
                                        rawName: "v-autoplayObserver"
                                    }
                                ],
                                key: _vm.checkIsMp4(_vm.getItemSrc(itemIndex)),
                                staticClass: "cool-lightbox-video",
                                style: _vm.aspectRatioVideo,
                                attrs: {
                                    "data-autoplay": _vm.setAutoplay(itemIndex),
                                    "controls": "",
                                    "controlslist": "nodownload",
                                    "l": "",
                                    "poster": ""
                                }
                            }, [
                                _c("source", {
                                    attrs: {
                                        "src": _vm.checkIsMp4(_vm.getItemSrc(itemIndex)),
                                        "type": "video/" + (_vm.getVideoExt(_vm.getItemSrc(itemIndex)) ? _vm.getVideoExt(_vm.getItemSrc(itemIndex)) : _vm.getExtFromItem(itemIndex))
                                    }
                                }),
                                _vm._v("\n              Sorry, your browser doesn't support embedded videos\n            ")
                            ]) : _vm._e()
                        ])
                    ]);
                }), 0) : _vm._e(),
                _vm._v(" "),
                _vm.effect === "fade" ? _c("div", {
                    staticClass: "cool-lightbox__wrapper"
                }, [
                    _c("div", {
                        ref: "items",
                        staticClass: "cool-lightbox__slide cool-lightbox__slide--current"
                    }, [
                        _c("transition", {
                            attrs: {
                                "name": "cool-lightbox-slide-change",
                                "mode": "out-in"
                            }
                        }, [
                            _vm.getMediaType(_vm.imgIndex) === "image" ? _c("div", {
                                key: "image",
                                staticClass: "cool-lightbox__slide__img",
                                style: _vm.imgWrapperStyle
                            }, [
                                !_vm.isItemPicture(_vm.imgIndex) ? _c("transition", {
                                    attrs: {
                                        "name": "cool-lightbox-slide-change",
                                        "mode": "out-in"
                                    }
                                }, [
                                    _c("img", {
                                        key: _vm.imgIndex,
                                        attrs: {
                                            "src": _vm.getItemSrc(_vm.imgIndex),
                                            "srcset": _vm.getItemSrcSet(_vm.imgIndex),
                                            "sizes": _vm.getItemSizes(_vm.imgIndex),
                                            "draggable": "false",
                                            "alt": _vm.getItemAlt(_vm.imgIndex)
                                        },
                                        on: {
                                            "load": _vm.imageLoaded,
                                            "click": _vm.zoomImage,
                                            "mousedown": function($event) {
                                                return _vm.handleMouseDown($event);
                                            },
                                            "mouseup": function($event) {
                                                return _vm.handleMouseUp($event);
                                            },
                                            "mouseleave": function($event) {
                                                return _vm.handleMouseLeave($event);
                                            },
                                            "mousemove": function($event) {
                                                return _vm.handleMouseMove($event);
                                            }
                                        }
                                    })
                                ]) : _c("transition", {
                                    attrs: {
                                        "name": "cool-lightbox-slide-change",
                                        "mode": "out-in"
                                    }
                                }, [
                                    _c("picture", {
                                        key: _vm.imgIndex
                                    }, [
                                        _vm._l(_vm.getPictureSources(_vm.imgIndex), function(source, sourceIndex) {
                                            return _c("source", {
                                                key: "source-" + _vm.imgIndex + "-" + sourceIndex,
                                                attrs: {
                                                    "srcset": source.srcset,
                                                    "type": source.type,
                                                    "media": source.media,
                                                    "sizes": source.sizes || _vm.getItemSizes(_vm.imgIndex)
                                                }
                                            });
                                        }),
                                        _vm._v(" "),
                                        _c("img", {
                                            attrs: {
                                                "src": _vm.getItemSrc(_vm.imgIndex),
                                                "srcset": _vm.getItemSrcSet(_vm.imgIndex),
                                                "sizes": _vm.getItemSizes(_vm.imgIndex),
                                                "draggable": "false",
                                                "alt": _vm.getItemAlt(_vm.imgIndex)
                                            },
                                            on: {
                                                "load": _vm.imageLoaded,
                                                "click": function($event) {
                                                    return _vm.zoomImage(_vm.imgIndex);
                                                },
                                                "mousedown": function($event) {
                                                    return _vm.handleMouseDown($event);
                                                },
                                                "mouseup": function($event) {
                                                    return _vm.handleMouseUp($event);
                                                },
                                                "mouseleave": function($event) {
                                                    return _vm.handleMouseLeave($event);
                                                },
                                                "mousemove": function($event) {
                                                    return _vm.handleMouseMove($event);
                                                }
                                            }
                                        })
                                    ], 2)
                                ]),
                                _vm._v(" "),
                                _c("div", {
                                    directives: [
                                        {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.imageLoading,
                                            expression: "imageLoading"
                                        }
                                    ],
                                    staticClass: "cool-lightbox-loading-wrapper"
                                }, [
                                    _vm._t("loading", function() {
                                        return [
                                            _c("div", {
                                                staticClass: "cool-lightbox-loading"
                                            })
                                        ];
                                    })
                                ], 2)
                            ], 1) : _c("div", {
                                key: "video",
                                staticClass: "cool-lightbox__iframe"
                            }, [
                                _c("transition", {
                                    attrs: {
                                        "name": "cool-lightbox-slide-change",
                                        "mode": "out-in"
                                    }
                                }, [
                                    !_vm.checkIsMp4(_vm.getItemSrc(_vm.imgIndex)) && _vm.getMediaType(_vm.imgIndex) === "video" ? _c("iframe", {
                                        directives: [
                                            {
                                                name: "autoplayObserver",
                                                rawName: "v-autoplayObserver"
                                            }
                                        ],
                                        key: _vm.getVideoUrl(_vm.getItemSrc(_vm.imgIndex)),
                                        staticClass: "cool-lightbox-video",
                                        style: _vm.aspectRatioVideo,
                                        attrs: {
                                            "data-autoplay": _vm.setAutoplay(_vm.imgIndex),
                                            "src": _vm.getVideoUrl(_vm.getItemSrc(_vm.imgIndex)),
                                            "frameborder": "0",
                                            "allow": "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
                                            "allowfullscreen": ""
                                        }
                                    }) : _vm._e(),
                                    _vm._v(" "),
                                    _vm.getMediaType(_vm.imgIndex) === "iframe" || _vm.getPDFurl(_vm.getItemSrc(_vm.imgIndex)) ? _c("iframe", {
                                        key: _vm.imgIndex,
                                        staticClass: "cool-lightbox-pdf",
                                        attrs: {
                                            "src": _vm.getItemSrc(_vm.imgIndex),
                                            "frameborder": "0",
                                            "allowfullscreen": ""
                                        }
                                    }) : _vm._e(),
                                    _vm._v(" "),
                                    _vm.checkIsMp4(_vm.getItemSrc(_vm.imgIndex)) || _vm.getMediaType(_vm.imgIndex) === "webVideo" ? _c("video", {
                                        directives: [
                                            {
                                                name: "autoplayObserver",
                                                rawName: "v-autoplayObserver"
                                            }
                                        ],
                                        key: _vm.checkIsMp4(_vm.getItemSrc(_vm.imgIndex)),
                                        staticClass: "cool-lightbox-video",
                                        style: _vm.aspectRatioVideo,
                                        attrs: {
                                            "data-autoplay": _vm.setAutoplay(_vm.imgIndex),
                                            "controls": "",
                                            "controlslist": "nodownload",
                                            "poster": ""
                                        }
                                    }, [
                                        _c("source", {
                                            attrs: {
                                                "src": _vm.checkIsMp4(_vm.getItemSrc(_vm.imgIndex)),
                                                "type": "video/" + (_vm.getVideoExt(_vm.getItemSrc(_vm.imgIndex)) ? _vm.getVideoExt(_vm.getItemSrc(_vm.imgIndex)) : _vm.getExtFromItem(_vm.imgIndex))
                                            }
                                        }),
                                        _vm._v("\n                  Sorry, your browser doesn't support embedded videos\n                ")
                                    ]) : _vm._e()
                                ])
                            ], 1)
                        ])
                    ], 1)
                ]) : _vm._e(),
                _vm._v(" "),
                _c("transition", {
                    attrs: {
                        "name": "cool-lightbox-modal"
                    }
                }, [
                    _c("div", {
                        directives: [
                            {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.checkIfIsObject(_vm.imgIndex) && (_vm.items[_vm.imgIndex].title || _vm.items[_vm.imgIndex].description),
                                expression: "checkIfIsObject(imgIndex) && (items[imgIndex].title || items[imgIndex].description)"
                            }
                        ],
                        key: "caption-block",
                        staticClass: "cool-lightbox-caption"
                    }, [
                        _c("transition", {
                            attrs: {
                                "name": "cool-lightbox-slide-change",
                                "mode": "out-in"
                            }
                        }, [
                            _vm.checkIfIsObject(_vm.imgIndex) && _vm.items[_vm.imgIndex].title ? _c("h6", {
                                key: "title",
                                domProps: {
                                    "innerHTML": _vm._s(_vm.items[_vm.imgIndex].title)
                                }
                            }) : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("transition", {
                            attrs: {
                                "name": "cool-lightbox-slide-change",
                                "mode": "out-in"
                            }
                        }, [
                            _vm.checkIfIsObject(_vm.imgIndex) && _vm.items[_vm.imgIndex].description ? _c("p", {
                                key: "description",
                                domProps: {
                                    "innerHTML": _vm._s(_vm.items[_vm.imgIndex].description)
                                }
                            }) : _vm._e()
                        ])
                    ], 1)
                ]),
                _vm._v(" "),
                _c("div", {
                    staticClass: "cool-lightbox-toolbar",
                    class: _vm.buttonsClasses
                }, [
                    this.slideshow && _vm.items.length > 1 ? _c("button", {
                        staticClass: "cool-lightbox-toolbar__btn",
                        attrs: {
                            "type": "button",
                            "title": _vm.translations.playSlideShow
                        },
                        on: {
                            "click": _vm.togglePlaySlideshow
                        }
                    }, [
                        !_vm.isPlayingSlideShow ? _c("svg", {
                            attrs: {
                                "xmlns": "http://www.w3.org/2000/svg",
                                "viewBox": "0 0 24 24"
                            }
                        }, [
                            _c("path", {
                                attrs: {
                                    "d": "M6.5 5.4v13.2l11-6.6z"
                                }
                            })
                        ]) : _c("svg", {
                            attrs: {
                                "xmlns": "http://www.w3.org/2000/svg"
                            }
                        }, [
                            _c("g", [
                                _c("rect", {
                                    attrs: {
                                        "id": "svg_4",
                                        "height": "11.97529",
                                        "width": "11.728392",
                                        "y": "6.030873",
                                        "x": "6.259265",
                                        "stroke-width": "1.5",
                                        "stroke": "#000",
                                        "fill": "#000000"
                                    }
                                })
                            ])
                        ])
                    ]) : _vm._e(),
                    _vm._v(" "),
                    _vm.items.length > 1 && _vm.gallery ? _c("button", {
                        staticClass: "cool-lightbox-toolbar__btn",
                        attrs: {
                            "type": "button",
                            "title": _vm.translations.showThumbNails
                        },
                        on: {
                            "click": function($event) {
                                _vm.showThumbs = !_vm.showThumbs;
                            }
                        }
                    }, [
                        _c("svg", {
                            attrs: {
                                "xmlns": "http://www.w3.org/2000/svg",
                                "viewBox": "0 0 24 24"
                            }
                        }, [
                            _c("path", {
                                attrs: {
                                    "d": "M14.59 14.59h3.76v3.76h-3.76v-3.76zm-4.47\n            0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76v-3.76zm-4.47\n            0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76V5.65zm-4.47\n            0h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76H5.65V5.65z"
                                }
                            })
                        ])
                    ]) : _vm._e(),
                    _vm._v(" "),
                    _vm.fullScreen ? _c("button", {
                        staticClass: "cool-lightbox-toolbar__btn",
                        attrs: {
                            "type": "button",
                            "title": _vm.translations.fullScreen
                        },
                        on: {
                            "click": _vm.toggleFullScreenMode
                        }
                    }, [
                        _c("svg", {
                            attrs: {
                                "width": "20px",
                                "height": "20px",
                                "viewBox": "0 0 18 18",
                                "xmlns": "http://www.w3.org/2000/svg"
                            }
                        }, [
                            _c("path", {
                                attrs: {
                                    "d": "M4.5 11H3v4h4v-1.5H4.5V11zM3 7h1.5V4.5H7V3H3v4zm10.5 6.5H11V15h4v-4h-1.5v2.5zM11 3v1.5h2.5V7H15V3h-4z"
                                }
                            })
                        ])
                    ]) : _vm._e(),
                    _vm._v(" "),
                    _vm.showCloseButton ? _c("button", {
                        staticClass: "cool-lightbox-toolbar__btn",
                        attrs: {
                            "type": "button",
                            "title": _vm.translations.close
                        },
                        on: {
                            "click": _vm.close
                        }
                    }, [
                        _vm._t("close", function() {
                            return [
                                _c("svg", {
                                    attrs: {
                                        "xmlns": "http://www.w3.org/2000/svg",
                                        "viewBox": "0 0 24 24"
                                    }
                                }, [
                                    _c("path", {
                                        attrs: {
                                            "d": "M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"
                                        }
                                    })
                                ])
                            ];
                        })
                    ], 2) : _vm._e()
                ])
            ], 1),
            _vm._v(" "),
            _c("transition", {
                attrs: {
                    "name": "cool-lightbox-modal"
                }
            }, [
                _vm.isZooming && _vm.useZoomBar ? _c("div", {
                    staticClass: "cool-lightbox-zoom"
                }, [
                    _c("svg", {
                        staticClass: "cool-lightbox-zoom__icon",
                        attrs: {
                            "height": "469pt",
                            "viewBox": "0 -192 469.33333 469",
                            "width": "469pt",
                            "xmlns": "http://www.w3.org/2000/svg"
                        }
                    }, [
                        _c("path", {
                            attrs: {
                                "d": "m437.332031.167969h-405.332031c-17.664062\n          0-32 14.335937-32 32v21.332031c0 17.664062 14.335938 32 32 32h405.332031c17.664063 0 32-14.335938\n          32-32v-21.332031c0-17.664063-14.335937-32-32-32zm0 0"
                            }
                        })
                    ]),
                    _vm._v(" "),
                    _c("input", {
                        directives: [
                            {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.zoomBar,
                                expression: "zoomBar"
                            }
                        ],
                        attrs: {
                            "type": "range",
                            "name": "points",
                            "min": "0",
                            "max": "50"
                        },
                        domProps: {
                            "value": _vm.zoomBar
                        },
                        on: {
                            "__r": function($event) {
                                _vm.zoomBar = $event.target.value;
                            }
                        }
                    }),
                    _vm._v(" "),
                    _c("svg", {
                        staticClass: "cool-lightbox-zoom__icon",
                        attrs: {
                            "height": "426.66667pt",
                            "viewBox": "0 0 426.66667 426.66667",
                            "width": "426.66667pt",
                            "xmlns": "http://www.w3.org/2000/svg"
                        }
                    }, [
                        _c("path", {
                            attrs: {
                                "d": "m405.332031 192h-170.664062v-170.667969c0-11.773437-9.558594-21.332031-21.335938-21.332031-11.773437 0-21.332031\n          9.558594-21.332031 21.332031v170.667969h-170.667969c-11.773437 0-21.332031 9.558594-21.332031 21.332031 0\n          11.777344 9.558594 21.335938 21.332031 21.335938h170.667969v170.664062c0 11.777344 9.558594 21.335938 21.332031\n          21.335938 11.777344 0 21.335938-9.558594 21.335938-21.335938v-170.664062h170.664062c11.777344 0 21.335938-9.558594\n          21.335938-21.335938 0-11.773437-9.558594-21.332031-21.335938-21.332031zm0 0"
                            }
                        })
                    ])
                ]) : _vm._e()
            ])
        ], 1) : _vm._e()
    ]);
};
var $c8654d17047f9f6d$var$__vue_staticRenderFns__ = [];
/* style */ var $c8654d17047f9f6d$var$__vue_inject_styles__ = undefined;
/* scoped */ var $c8654d17047f9f6d$var$__vue_scope_id__ = undefined;
/* module identifier */ var $c8654d17047f9f6d$var$__vue_module_identifier__ = undefined;
/* functional template */ var $c8654d17047f9f6d$var$__vue_is_functional_template__ = false;
/* style inject */ /* style inject SSR */ var $c8654d17047f9f6d$var$CoolLightBox = $c8654d17047f9f6d$var$normalizeComponent_1({
    render: $c8654d17047f9f6d$var$__vue_render__,
    staticRenderFns: $c8654d17047f9f6d$var$__vue_staticRenderFns__
}, $c8654d17047f9f6d$var$__vue_inject_styles__, $c8654d17047f9f6d$var$__vue_script__, $c8654d17047f9f6d$var$__vue_scope_id__, $c8654d17047f9f6d$var$__vue_is_functional_template__, $c8654d17047f9f6d$var$__vue_module_identifier__, undefined, undefined);
function $c8654d17047f9f6d$var$install(Vue) {
    if ($c8654d17047f9f6d$var$install.installed) return;
    $c8654d17047f9f6d$var$install.installed = true;
    Vue.component("CoolLightBox", $c8654d17047f9f6d$var$CoolLightBox);
}
var $c8654d17047f9f6d$var$plugin = {
    install: $c8654d17047f9f6d$var$install
};
var $c8654d17047f9f6d$var$GlobalVue = null;
if (typeof window !== "undefined") $c8654d17047f9f6d$var$GlobalVue = window.Vue;
else if (typeof $parcel$global !== "undefined") $c8654d17047f9f6d$var$GlobalVue = $parcel$global.vue;
if ($c8654d17047f9f6d$var$GlobalVue) $c8654d17047f9f6d$var$GlobalVue.use($c8654d17047f9f6d$var$plugin);
$c8654d17047f9f6d$var$CoolLightBox.install = $c8654d17047f9f6d$var$install;
var $c8654d17047f9f6d$export$2e2bcd8739ae039 = $c8654d17047f9f6d$var$CoolLightBox;

});
parcelRequire.register("gYJCo", function(module, exports) {

$parcel$export(module.exports, "disableBodyScroll", function () { return $c5c5a2c4613b0b88$export$24fdf68abf432c44; });
$parcel$export(module.exports, "enableBodyScroll", function () { return $c5c5a2c4613b0b88$export$e5d0524c3725571e; });
function $c5c5a2c4613b0b88$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
// Older browsers don't support event options, feature detect it.
// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi
var $c5c5a2c4613b0b88$var$hasPassiveEvents = false;
if (typeof window !== "undefined") {
    var $c5c5a2c4613b0b88$var$passiveTestOptions = {
        get passive () {
            $c5c5a2c4613b0b88$var$hasPassiveEvents = true;
            return undefined;
        }
    };
    window.addEventListener("testPassive", null, $c5c5a2c4613b0b88$var$passiveTestOptions);
    window.removeEventListener("testPassive", null, $c5c5a2c4613b0b88$var$passiveTestOptions);
}
var $c5c5a2c4613b0b88$var$isIosDevice = typeof window !== "undefined" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
var $c5c5a2c4613b0b88$var$locks = [];
var $c5c5a2c4613b0b88$var$documentListenerAdded = false;
var $c5c5a2c4613b0b88$var$initialClientY = -1;
var $c5c5a2c4613b0b88$var$previousBodyOverflowSetting = void 0;
var $c5c5a2c4613b0b88$var$previousBodyPaddingRight = void 0;
// returns true if `el` should be allowed to receive touchmove events.
var $c5c5a2c4613b0b88$var$allowTouchMove = function allowTouchMove(el) {
    return $c5c5a2c4613b0b88$var$locks.some(function(lock) {
        if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) return true;
        return false;
    });
};
var $c5c5a2c4613b0b88$var$preventDefault = function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    // For the case whereby consumers adds a touchmove event listener to document.
    // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
    // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
    // the touchmove event on document will break.
    if ($c5c5a2c4613b0b88$var$allowTouchMove(e.target)) return true;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
};
var $c5c5a2c4613b0b88$var$setOverflowHidden = function setOverflowHidden(options) {
    // If previousBodyPaddingRight is already set, don't set it again.
    if ($c5c5a2c4613b0b88$var$previousBodyPaddingRight === undefined) {
        var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
        var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
        if (_reserveScrollBarGap && scrollBarGap > 0) {
            $c5c5a2c4613b0b88$var$previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = scrollBarGap + "px";
        }
    }
    // If previousBodyOverflowSetting is already set, don't set it again.
    if ($c5c5a2c4613b0b88$var$previousBodyOverflowSetting === undefined) {
        $c5c5a2c4613b0b88$var$previousBodyOverflowSetting = document.body.style.overflow;
        document.body.style.overflow = "hidden";
    }
};
var $c5c5a2c4613b0b88$var$restoreOverflowSetting = function restoreOverflowSetting() {
    if ($c5c5a2c4613b0b88$var$previousBodyPaddingRight !== undefined) {
        document.body.style.paddingRight = $c5c5a2c4613b0b88$var$previousBodyPaddingRight;
        // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
        // can be set again.
        $c5c5a2c4613b0b88$var$previousBodyPaddingRight = undefined;
    }
    if ($c5c5a2c4613b0b88$var$previousBodyOverflowSetting !== undefined) {
        document.body.style.overflow = $c5c5a2c4613b0b88$var$previousBodyOverflowSetting;
        // Restore previousBodyOverflowSetting to undefined
        // so setOverflowHidden knows it can be set again.
        $c5c5a2c4613b0b88$var$previousBodyOverflowSetting = undefined;
    }
};
// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var $c5c5a2c4613b0b88$var$isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
    return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};
var $c5c5a2c4613b0b88$var$handleScroll = function handleScroll(event, targetElement) {
    var clientY = event.targetTouches[0].clientY - $c5c5a2c4613b0b88$var$initialClientY;
    if ($c5c5a2c4613b0b88$var$allowTouchMove(event.target)) return false;
    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) // element is at the top of its scroll.
    return $c5c5a2c4613b0b88$var$preventDefault(event);
    if ($c5c5a2c4613b0b88$var$isTargetElementTotallyScrolled(targetElement) && clientY < 0) // element is at the bottom of its scroll.
    return $c5c5a2c4613b0b88$var$preventDefault(event);
    event.stopPropagation();
    return true;
};
var $c5c5a2c4613b0b88$export$24fdf68abf432c44 = function disableBodyScroll(targetElement, options) {
    // targetElement must be provided
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
        return;
    }
    // disableBodyScroll must not have been called on this targetElement before
    if ($c5c5a2c4613b0b88$var$locks.some(function(lock) {
        return lock.targetElement === targetElement;
    })) return;
    var lock = {
        targetElement: targetElement,
        options: options || {}
    };
    $c5c5a2c4613b0b88$var$locks = [].concat($c5c5a2c4613b0b88$var$_toConsumableArray($c5c5a2c4613b0b88$var$locks), [
        lock
    ]);
    if ($c5c5a2c4613b0b88$var$isIosDevice) {
        targetElement.ontouchstart = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $c5c5a2c4613b0b88$var$initialClientY = event.targetTouches[0].clientY;
        };
        targetElement.ontouchmove = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $c5c5a2c4613b0b88$var$handleScroll(event, targetElement);
        };
        if (!$c5c5a2c4613b0b88$var$documentListenerAdded) {
            document.addEventListener("touchmove", $c5c5a2c4613b0b88$var$preventDefault, $c5c5a2c4613b0b88$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $c5c5a2c4613b0b88$var$documentListenerAdded = true;
        }
    } else $c5c5a2c4613b0b88$var$setOverflowHidden(options);
};
var $c5c5a2c4613b0b88$export$45a3ef215b2a5866 = function clearAllBodyScrollLocks() {
    if ($c5c5a2c4613b0b88$var$isIosDevice) {
        // Clear all locks ontouchstart/ontouchmove handlers, and the references.
        $c5c5a2c4613b0b88$var$locks.forEach(function(lock) {
            lock.targetElement.ontouchstart = null;
            lock.targetElement.ontouchmove = null;
        });
        if ($c5c5a2c4613b0b88$var$documentListenerAdded) {
            document.removeEventListener("touchmove", $c5c5a2c4613b0b88$var$preventDefault, $c5c5a2c4613b0b88$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $c5c5a2c4613b0b88$var$documentListenerAdded = false;
        }
        // Reset initial clientY.
        $c5c5a2c4613b0b88$var$initialClientY = -1;
    } else $c5c5a2c4613b0b88$var$restoreOverflowSetting();
    $c5c5a2c4613b0b88$var$locks = [];
};
var $c5c5a2c4613b0b88$export$e5d0524c3725571e = function enableBodyScroll(targetElement) {
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
        return;
    }
    $c5c5a2c4613b0b88$var$locks = $c5c5a2c4613b0b88$var$locks.filter(function(lock) {
        return lock.targetElement !== targetElement;
    });
    if ($c5c5a2c4613b0b88$var$isIosDevice) {
        targetElement.ontouchstart = null;
        targetElement.ontouchmove = null;
        if ($c5c5a2c4613b0b88$var$documentListenerAdded && $c5c5a2c4613b0b88$var$locks.length === 0) {
            document.removeEventListener("touchmove", $c5c5a2c4613b0b88$var$preventDefault, $c5c5a2c4613b0b88$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $c5c5a2c4613b0b88$var$documentListenerAdded = false;
        }
    } else if (!$c5c5a2c4613b0b88$var$locks.length) $c5c5a2c4613b0b88$var$restoreOverflowSetting();
};

});



parcelRequire.register("lWyIp", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $ff99f17c0223f980$export$b3890eb0ae9dca99; }, function (v) { return $ff99f17c0223f980$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "staticRenderFns", function () { return $ff99f17c0223f980$export$f8436702749526f9; }, function (v) { return $ff99f17c0223f980$export$f8436702749526f9 = v; });
var $ff99f17c0223f980$export$b3890eb0ae9dca99;
var $ff99f17c0223f980$export$f8436702749526f9;
var $ff99f17c0223f980$var$render = function() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c("div", [
        _c("CoolLightBox", {
            attrs: {
                "items": _vm.gallery,
                "index": _vm.index
            },
            on: {
                "close": function($event) {
                    _vm.index = null;
                }
            }
        }),
        _vm._v(" "),
        _c("div", {
            staticClass: "flex lg:-mt-40 lg:-mt-96 lg:space-x-5"
        }, [
            _c("div", {
                staticClass: "w-full",
                class: _vm.hasSidebar ? "lg:w-9/12" : ""
            }, [
                _c("div", {
                    staticClass: "relative lg:w-full lg:h-full"
                }, [
                    _vm.galleryData.vr ? _c("iframe", {
                        staticClass: "absolute top-0 left-0 hidden w-full h-full lg:block",
                        attrs: {
                            "src": _vm.galleryData.vr
                        }
                    }) : _c("a", {
                        staticClass: "relative hidden w-full h-full group lg:block",
                        attrs: {
                            "href": "#"
                        },
                        on: {
                            "click": function($event) {
                                $event.preventDefault();
                                _vm.index = 0;
                            }
                        }
                    }, [
                        _c("div", {
                            staticClass: "absolute z-10 w-full h-full transition duration-200 bg-black opacity-0 group-hover:opacity-20"
                        }),
                        _vm._v(" "),
                        _c("div", {
                            staticClass: "aspect-ratio-16/9"
                        }),
                        _vm._v(" "),
                        _c("img", {
                            staticClass: "absolute top-0 left-0 z-0 object-cover object-center w-full h-full lazy",
                            attrs: {
                                "alt": _vm.galleryData.title,
                                "data-src": _vm.galleryData.images[0].sizes["large"]
                            }
                        })
                    ]),
                    _vm._v(" "),
                    _c("a", {
                        staticClass: "relative block w-full h-full -mt-48 group lg:hidden",
                        attrs: {
                            "href": "#"
                        },
                        on: {
                            "click": function($event) {
                                $event.preventDefault();
                                _vm.index = 0;
                            }
                        }
                    }, [
                        _c("div", {
                            staticClass: "absolute z-10 w-full h-full transition duration-200 bg-black opacity-0 group-hover:opacity-20"
                        }),
                        _vm._v(" "),
                        _c("div", {
                            staticClass: "aspect-ratio-4/3"
                        }),
                        _vm._v(" "),
                        _c("img", {
                            staticClass: "absolute top-0 left-0 z-0 object-cover object-center w-full h-full lazy",
                            attrs: {
                                "alt": _vm.galleryData.title,
                                "data-src": _vm.galleryData.images[0].sizes["large"]
                            }
                        })
                    ])
                ])
            ]),
            _vm._v(" "),
            _vm.hasSidebar ? _c("div", {
                staticClass: "hidden w-3/12 lg:block"
            }, [
                _c("div", {
                    staticClass: "space-y-5"
                }, _vm._l(_vm.thumbnails, function(thumbnail, i) {
                    return _c("a", {
                        key: i,
                        staticClass: "relative block text-white group text-shadow",
                        attrs: {
                            "href": thumbnail.sizes.large
                        },
                        on: {
                            "click": function($event) {
                                $event.preventDefault();
                                _vm.galleryData.vr ? _vm.index = i : _vm.index = i + 1;
                            }
                        }
                    }, [
                        _vm.hasMoreImages && i === _vm.thumbnails.length - 1 ? _c("div", {
                            staticClass: "absolute z-20 flex items-center justify-center w-full h-full"
                        }, [
                            _c("p", {
                                staticClass: "font-serif text-6xl"
                            }, [
                                _vm._v("+" + _vm._s(_vm.hasMoreImages))
                            ])
                        ]) : _vm._e(),
                        _vm._v(" "),
                        _vm.hasMoreImages && i === _vm.thumbnails.length - 1 ? _c("div", {
                            staticClass: "absolute z-10 w-full h-full transition duration-200 bg-opacity-80 opacity-90 bg-brand-500 group-hover:opacity-50"
                        }) : _c("div", {
                            staticClass: "absolute z-10 w-full h-full transition duration-200 bg-opacity-50 opacity-0 bg-brand-500 group-hover:opacity-50"
                        }),
                        _vm._v(" "),
                        _c("div", {
                            staticClass: "aspect-ratio-16/9"
                        }),
                        _vm._v(" "),
                        _c("img", {
                            staticClass: "absolute top-0 left-0 z-0 object-cover object-center w-full h-full lazy",
                            attrs: {
                                "alt": _vm.galleryData.title,
                                "data-src": thumbnail.sizes.thumbnail
                            }
                        })
                    ]);
                }), 0)
            ]) : _vm._e()
        ])
    ], 1);
};
var $ff99f17c0223f980$var$staticRenderFns = [];
$ff99f17c0223f980$export$b3890eb0ae9dca99 = $ff99f17c0223f980$var$render;
$ff99f17c0223f980$export$f8436702749526f9 = $ff99f17c0223f980$var$staticRenderFns;

});

parcelRequire.register("fZLQP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba51abbcce814086$export$2e2bcd8739ae039; });
let $ba51abbcce814086$var$NOOP = ()=>{};
var $ba51abbcce814086$export$2e2bcd8739ae039 = (script)=>{};

});

var $27c15869b3390a08$exports = {};

(parcelRequire("gm4sb")).register(JSON.parse('{"gjvsV":"main.js","4MFFx":"marker-active.d14e1cd0.svg","hSS48":"marker-inactive.be12b3b2.svg","5gXnW":"cluster.3640db95.svg","kzW04":"envelope.259abdac.png","1BEzS":"main.css"}'));



var $jAv3h = parcelRequire("jAv3h");
const $7c607fc5debc0337$var$navigation = ()=>{
    if (document.querySelector(".js-navigation")) {
        // Fixed navigation
        let init = 0;
        const detachMenu = ()=>{
            document.querySelector(".js-navigation").classList.add("is-detached");
            document.querySelector(".js-navigation").classList.remove("is-attached");
        };
        const attachMenu = ()=>{
            document.querySelector(".js-navigation").classList.add("is-attached");
            document.querySelector(".js-navigation").classList.remove("is-detached");
            if (init < 21) init += 1;
            if (init === 20) document.querySelector(".js-navigation").classList.add("is-animated");
        };
        const hideMenu = ()=>{
            document.querySelector(".js-navigation").classList.add("is-hidden");
        };
        const showMenu = ()=>{
            document.querySelector(".js-navigation").classList.remove("is-hidden");
        };
        if (document.querySelector(".js-navigation")) {
            let lastScroll = 0;
            const fixedScroll = ()=>{
                const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
                const scrollPos = window.scrollY;
                if (scrollPos > 0) {
                    if (currentScroll > 0 && currentScroll < 70) {
                        // Down
                        lastScroll = currentScroll;
                        detachMenu();
                    } else if (currentScroll > 70 && lastScroll <= currentScroll) {
                        // Down
                        lastScroll = currentScroll;
                        hideMenu();
                    } else {
                        // Up
                        lastScroll = currentScroll;
                        showMenu();
                        detachMenu();
                    }
                } else {
                    lastScroll = 0;
                    showMenu();
                    attachMenu();
                }
            };
            fixedScroll();
            (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))(document).on("scroll", ()=>{
                fixedScroll();
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))(document).on("resize", ()=>{
                fixedScroll();
            });
        }
    }
};
var $7c607fc5debc0337$export$2e2bcd8739ae039 = $7c607fc5debc0337$var$navigation;



var $16hem = parcelRequire("16hem");
let $8e01706655999e58$var$script;





let $8e01706655999e58$var$initialize = ()=>{
    $8e01706655999e58$var$script = (parcelRequire("5NVy9"));
    if ($8e01706655999e58$var$script.__esModule) $8e01706655999e58$var$script = $8e01706655999e58$var$script.default;
    $8e01706655999e58$var$script.render = (parcelRequire("dJGnT")).render;
    $8e01706655999e58$var$script.staticRenderFns = (parcelRequire("dJGnT")).staticRenderFns;
    $8e01706655999e58$var$script._scopeId = "data-v-ddc2bb";
    $8e01706655999e58$var$script.__cssModules = {};
    (parcelRequire("lgVAD")).default($8e01706655999e58$var$script);
    $8e01706655999e58$var$script.__scopeId = "data-v-ddc2bb";
    $8e01706655999e58$var$script.__file = "HeaderItem.vue";
};
$8e01706655999e58$var$initialize();
var $8e01706655999e58$export$2e2bcd8739ae039 = $8e01706655999e58$var$script;


const $4a40c00b717d9100$var$header = ()=>{
    if (document.querySelector("#header")) {
        (0, $16hem.default).config.productionTip = false;
        (0, $16hem.default).config.devtools = false;
        new (0, $16hem.default)({
            el: "#header",
            render: (h)=>h((0, $8e01706655999e58$export$2e2bcd8739ae039))
        });
    }
};
var $4a40c00b717d9100$export$2e2bcd8739ae039 = $4a40c00b717d9100$var$header;


const $0ed154dc5b49c6a8$var$contact = ()=>{
    if (window.wp_message_submit) {
        const anchor = document.querySelector("#wp-contact-sent");
        anchor.scrollIntoView();
    }
    document.addEventListener("wp_contact_estate_sent", ()=>{
        const anchor = document.querySelector("#wp-contact-sent");
        anchor.scrollIntoView();
    }, false);
    if (document.querySelector(".wpcf7")) {
        const flashError = [
            "m-0",
            "mt-8",
            "bg-danger-500",
            "text-white",
            "px-4",
            "py-3",
            "relative"
        ];
        const flashSuccess = [
            "m-0",
            "mt-8",
            "bg-brand-500",
            "text-white",
            "px-4",
            "py-3",
            "relative"
        ];
        document.addEventListener("wpcf7invalid", ()=>{
            document.querySelector(".wpcf7-response-output").classList.add(...flashError);
        }, false);
        document.addEventListener("wpcf7spam", ()=>{
            document.querySelector(".wpcf7-response-output").classList.add(...flashError);
        }, false);
        document.addEventListener("wpcf7mailfailed", ()=>{
            console.log(document.querySelector(".wpcf7-response-output"));
            document.querySelector(".wpcf7-response-output").classList.add(...flashError);
        }, false);
        document.addEventListener("wpcf7mailsent", ()=>{
            document.querySelector(".wpcf7-response-output").classList.add(...flashSuccess);
        }, false);
    }
};
var $0ed154dc5b49c6a8$export$2e2bcd8739ae039 = $0ed154dc5b49c6a8$var$contact;


var $7ce91c2db8c0f171$exports = {};
/*! smooth-scroll v16.1.3 | (c) 2020 Chris Ferdinandi | MIT License | http://github.com/cferdinandi/smooth-scroll */ window.Element && !Element.prototype.closest && (Element.prototype.closest = function(e) {
    var t, n = (this.document || this.ownerDocument).querySelectorAll(e), o = this;
    do {
        for(t = n.length; 0 <= --t && n.item(t) !== o;);
    }while (t < 0 && (o = o.parentElement));
    return o;
}), function() {
    if ("function" == typeof window.CustomEvent) return;
    function e(e, t) {
        t = t || {
            bubbles: !1,
            cancelable: !1,
            detail: void 0
        };
        var n = document.createEvent("CustomEvent");
        return n.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), n;
    }
    e.prototype = window.Event.prototype, window.CustomEvent = e;
}(), function() {
    for(var r = 0, e = [
        "ms",
        "moz",
        "webkit",
        "o"
    ], t = 0; t < e.length && !window.requestAnimationFrame; ++t)window.requestAnimationFrame = window[e[t] + "RequestAnimationFrame"], window.cancelAnimationFrame = window[e[t] + "CancelAnimationFrame"] || window[e[t] + "CancelRequestAnimationFrame"];
    window.requestAnimationFrame || (window.requestAnimationFrame = function(e, t) {
        var n = (new Date).getTime(), o = Math.max(0, 16 - (n - r)), a = window.setTimeout(function() {
            e(n + o);
        }, o);
        return r = n + o, a;
    }), window.cancelAnimationFrame || (window.cancelAnimationFrame = function(e) {
        clearTimeout(e);
    });
}(), function(e, t) {
    "function" == typeof define && define.amd ? define([], function() {
        return t(e);
    }) : $7ce91c2db8c0f171$exports = t(e);
}("undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof window ? window : $7ce91c2db8c0f171$exports, function(M) {
    "use strict";
    var q = {
        ignore: "[data-scroll-ignore]",
        header: null,
        topOnEmptyHash: !0,
        speed: 500,
        speedAsDuration: !1,
        durationMax: null,
        durationMin: null,
        clip: !0,
        offset: 0,
        easing: "easeInOutCubic",
        customEasing: null,
        updateURL: !0,
        popstate: !0,
        emitEvents: !0
    }, I = function() {
        var n = {};
        return Array.prototype.forEach.call(arguments, function(e) {
            for(var t in e){
                if (!e.hasOwnProperty(t)) return;
                n[t] = e[t];
            }
        }), n;
    }, r = function(e) {
        "#" === e.charAt(0) && (e = e.substr(1));
        for(var t, n = String(e), o = n.length, a = -1, r = "", i = n.charCodeAt(0); ++a < o;){
            if (0 === (t = n.charCodeAt(a))) throw new InvalidCharacterError("Invalid character: the input contains U+0000.");
            1 <= t && t <= 31 || 127 == t || 0 === a && 48 <= t && t <= 57 || 1 === a && 48 <= t && t <= 57 && 45 === i ? r += "\\" + t.toString(16) + " " : r += 128 <= t || 45 === t || 95 === t || 48 <= t && t <= 57 || 65 <= t && t <= 90 || 97 <= t && t <= 122 ? n.charAt(a) : "\\" + n.charAt(a);
        }
        return "#" + r;
    }, F = function() {
        return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
    }, L = function(e) {
        var t;
        return e ? (t = e, parseInt(M.getComputedStyle(t).height, 10) + e.offsetTop) : 0;
    }, x = function(e, t, n) {
        0 === e && document.body.focus(), n || (e.focus(), document.activeElement !== e && (e.setAttribute("tabindex", "-1"), e.focus(), e.style.outline = "none"), M.scrollTo(0, t));
    }, H = function(e, t, n, o) {
        if (t.emitEvents && "function" == typeof M.CustomEvent) {
            var a = new CustomEvent(e, {
                bubbles: !0,
                detail: {
                    anchor: n,
                    toggle: o
                }
            });
            document.dispatchEvent(a);
        }
    };
    return function(o, e) {
        var b, a, A, O, C = {};
        C.cancelScroll = function(e) {
            cancelAnimationFrame(O), O = null, e || H("scrollCancel", b);
        }, C.animateScroll = function(a, r, e) {
            C.cancelScroll();
            var i = I(b || q, e || {}), c = "[object Number]" === Object.prototype.toString.call(a), t = c || !a.tagName ? null : a;
            if (c || t) {
                var s = M.pageYOffset;
                i.header && !A && (A = document.querySelector(i.header));
                var n, o, u, l, m, d, f, h, p = L(A), g = c ? a : function(e, t, n, o) {
                    var a = 0;
                    if (e.offsetParent) for(; a += e.offsetTop, e = e.offsetParent;);
                    return a = Math.max(a - t - n, 0), o && (a = Math.min(a, F() - M.innerHeight)), a;
                }(t, p, parseInt("function" == typeof i.offset ? i.offset(a, r) : i.offset, 10), i.clip), y = g - s, v = F(), w = 0, S = (n = y, u = (o = i).speedAsDuration ? o.speed : Math.abs(n / 1e3 * o.speed), o.durationMax && u > o.durationMax ? o.durationMax : o.durationMin && u < o.durationMin ? o.durationMin : parseInt(u, 10)), E = function(e) {
                    var t, n, o;
                    l || (l = e), w += e - l, d = s + y * (n = m = 1 < (m = 0 === S ? 0 : w / S) ? 1 : m, "easeInQuad" === (t = i).easing && (o = n * n), "easeOutQuad" === t.easing && (o = n * (2 - n)), "easeInOutQuad" === t.easing && (o = n < .5 ? 2 * n * n : (4 - 2 * n) * n - 1), "easeInCubic" === t.easing && (o = n * n * n), "easeOutCubic" === t.easing && (o = --n * n * n + 1), "easeInOutCubic" === t.easing && (o = n < .5 ? 4 * n * n * n : (n - 1) * (2 * n - 2) * (2 * n - 2) + 1), "easeInQuart" === t.easing && (o = n * n * n * n), "easeOutQuart" === t.easing && (o = 1 - --n * n * n * n), "easeInOutQuart" === t.easing && (o = n < .5 ? 8 * n * n * n * n : 1 - 8 * --n * n * n * n), "easeInQuint" === t.easing && (o = n * n * n * n * n), "easeOutQuint" === t.easing && (o = 1 + --n * n * n * n * n), "easeInOutQuint" === t.easing && (o = n < .5 ? 16 * n * n * n * n * n : 1 + 16 * --n * n * n * n * n), t.customEasing && (o = t.customEasing(n)), o || n), M.scrollTo(0, Math.floor(d)), function(e, t) {
                        var n = M.pageYOffset;
                        if (e == t || n == t || (s < t && M.innerHeight + n) >= v) return C.cancelScroll(!0), x(a, t, c), H("scrollStop", i, a, r), O = l = null, true;
                    }(d, g) || (O = M.requestAnimationFrame(E), l = e);
                };
                0 === M.pageYOffset && M.scrollTo(0, 0), f = a, h = i, c || history.pushState && h.updateURL && history.pushState({
                    smoothScroll: JSON.stringify(h),
                    anchor: f.id
                }, document.title, f === document.documentElement ? "#top" : "#" + f.id), "matchMedia" in M && M.matchMedia("(prefers-reduced-motion)").matches ? x(a, Math.floor(g), !1) : (H("scrollStart", i, a, r), C.cancelScroll(!0), M.requestAnimationFrame(E));
            }
        };
        var t = function(e) {
            if (!e.defaultPrevented && !(0 !== e.button || e.metaKey || e.ctrlKey || e.shiftKey) && "closest" in e.target && (a = e.target.closest(o)) && "a" === a.tagName.toLowerCase() && !e.target.closest(b.ignore) && a.hostname === M.location.hostname && a.pathname === M.location.pathname && /#/.test(a.href)) {
                var t, n;
                try {
                    t = r(decodeURIComponent(a.hash));
                } catch (e) {
                    t = r(a.hash);
                }
                if ("#" === t) {
                    if (!b.topOnEmptyHash) return;
                    n = document.documentElement;
                } else n = document.querySelector(t);
                (n = n || "#top" !== t ? n : document.documentElement) && (e.preventDefault(), function(e) {
                    if (history.replaceState && e.updateURL && !history.state) {
                        var t = M.location.hash;
                        t = t || "", history.replaceState({
                            smoothScroll: JSON.stringify(e),
                            anchor: t || M.pageYOffset
                        }, document.title, t || M.location.href);
                    }
                }(b), C.animateScroll(n, a));
            }
        }, n = function(e) {
            if (null !== history.state && history.state.smoothScroll && history.state.smoothScroll === JSON.stringify(b)) {
                var t = history.state.anchor;
                "string" == typeof t && t && !(t = document.querySelector(r(history.state.anchor))) || C.animateScroll(t, null, {
                    updateURL: !1
                });
            }
        };
        C.destroy = function() {
            b && (document.removeEventListener("click", t, !1), M.removeEventListener("popstate", n, !1), C.cancelScroll(), O = A = a = b = null);
        };
        return function() {
            if (!("querySelector" in document && "addEventListener" in M && "requestAnimationFrame" in M && "closest" in M.Element.prototype)) throw "Smooth Scroll: This browser does not support the required JavaScript methods and browser APIs.";
            C.destroy(), b = I(q, e || {}), A = b.header ? document.querySelector(b.header) : null, document.addEventListener("click", t, !1), b.updateURL && b.popstate && M.addEventListener("popstate", n, !1);
        }(), C;
    };
});



var $hr0I9 = parcelRequire("hr0I9");
var $fe6128a024b72d4c$exports = {};
/*!
 * in-view 0.6.1 - Get notified when a DOM element enters or exits the viewport.
 * Copyright (c) 2016 Cam Wiegert <cam@camwiegert.com> - https://camwiegert.github.io/in-view
 * License: MIT
 */ !function(t, e) {
    $fe6128a024b72d4c$exports = e();
}($fe6128a024b72d4c$exports, function() {
    return function(t) {
        function e(r) {
            if (n[r]) return n[r].exports;
            var i = n[r] = {
                exports: {},
                id: r,
                loaded: !1
            };
            return t[r].call(i.exports, i, i.exports, e), i.loaded = !0, i.exports;
        }
        var n = {};
        return e.m = t, e.c = n, e.p = "", e(0);
    }([
        function(t, e, n) {
            "use strict";
            function r(t) {
                return t && t.__esModule ? t : {
                    "default": t
                };
            }
            var i = n(2), o = r(i);
            t.exports = o["default"];
        },
        function(t, e) {
            function n(t) {
                var e = typeof t;
                return null != t && ("object" == e || "function" == e);
            }
            t.exports = n;
        },
        function(t, e, n) {
            "use strict";
            function r(t) {
                return t && t.__esModule ? t : {
                    "default": t
                };
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var i = n(9), o = r(i), u = n(3), f = r(u), s = n(4), c = function() {
                if ("undefined" != typeof window) {
                    var t = 100, e = [
                        "scroll",
                        "resize",
                        "load"
                    ], n = {
                        history: []
                    }, r = {
                        offset: {},
                        threshold: 0,
                        test: s.inViewport
                    }, i = (0, o["default"])(function() {
                        n.history.forEach(function(t) {
                            n[t].check();
                        });
                    }, t);
                    e.forEach(function(t) {
                        return addEventListener(t, i);
                    }), window.MutationObserver && addEventListener("DOMContentLoaded", function() {
                        new MutationObserver(i).observe(document.body, {
                            attributes: !0,
                            childList: !0,
                            subtree: !0
                        });
                    });
                    var u = function(t) {
                        if ("string" == typeof t) {
                            var e = [].slice.call(document.querySelectorAll(t));
                            return n.history.indexOf(t) > -1 ? n[t].elements = e : (n[t] = (0, f["default"])(e, r), n.history.push(t)), n[t];
                        }
                    };
                    return u.offset = function(t) {
                        if (void 0 === t) return r.offset;
                        var e = function(t) {
                            return "number" == typeof t;
                        };
                        return [
                            "top",
                            "right",
                            "bottom",
                            "left"
                        ].forEach(e(t) ? function(e) {
                            return r.offset[e] = t;
                        } : function(n) {
                            return e(t[n]) ? r.offset[n] = t[n] : null;
                        }), r.offset;
                    }, u.threshold = function(t) {
                        return "number" == typeof t && t >= 0 && t <= 1 ? r.threshold = t : r.threshold;
                    }, u.test = function(t) {
                        return "function" == typeof t ? r.test = t : r.test;
                    }, u.is = function(t) {
                        return r.test(t, r);
                    }, u.offset(0), u;
                }
            };
            e["default"] = c();
        },
        function(t, e) {
            "use strict";
            function n(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            });
            var r = function() {
                function t(t, e) {
                    for(var n = 0; n < e.length; n++){
                        var r = e[n];
                        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                    }
                }
                return function(e, n, r) {
                    return n && t(e.prototype, n), r && t(e, r), e;
                };
            }(), i = function() {
                function t(e, r) {
                    n(this, t), this.options = r, this.elements = e, this.current = [], this.handlers = {
                        enter: [],
                        exit: []
                    }, this.singles = {
                        enter: [],
                        exit: []
                    };
                }
                return r(t, [
                    {
                        key: "check",
                        value: function() {
                            var t = this;
                            return this.elements.forEach(function(e) {
                                var n = t.options.test(e, t.options), r = t.current.indexOf(e), i = r > -1, o = n && !i, u = !n && i;
                                o && (t.current.push(e), t.emit("enter", e)), u && (t.current.splice(r, 1), t.emit("exit", e));
                            }), this;
                        }
                    },
                    {
                        key: "on",
                        value: function(t, e) {
                            return this.handlers[t].push(e), this;
                        }
                    },
                    {
                        key: "once",
                        value: function(t, e) {
                            return this.singles[t].unshift(e), this;
                        }
                    },
                    {
                        key: "emit",
                        value: function(t, e) {
                            for(; this.singles[t].length;)this.singles[t].pop()(e);
                            for(var n = this.handlers[t].length; --n > -1;)this.handlers[t][n](e);
                            return this;
                        }
                    }
                ]), t;
            }();
            e["default"] = function(t, e) {
                return new i(t, e);
            };
        },
        function(t, e) {
            "use strict";
            function n(t, e) {
                var n = t.getBoundingClientRect(), r = n.top, i = n.right, o = n.bottom, u = n.left, f = n.width, s = n.height, c = {
                    t: o,
                    r: window.innerWidth - u,
                    b: window.innerHeight - r,
                    l: i
                }, a = {
                    x: e.threshold * f,
                    y: e.threshold * s
                };
                return c.t > e.offset.top + a.y && c.r > e.offset.right + a.x && c.b > e.offset.bottom + a.y && c.l > e.offset.left + a.x;
            }
            Object.defineProperty(e, "__esModule", {
                value: !0
            }), e.inViewport = n;
        },
        function(t, e) {
            (function(e) {
                var n = "object" == typeof e && e && e.Object === Object && e;
                t.exports = n;
            }).call(e, function() {
                return this;
            }());
        },
        function(t, e, n) {
            var r = n(5), i = "object" == typeof self && self && self.Object === Object && self, o = r || i || Function("return this")();
            t.exports = o;
        },
        function(t, e, n) {
            function r(t, e, n) {
                function r(e) {
                    var n = x, r = m;
                    return x = m = void 0, E = e, w = t.apply(r, n);
                }
                function a(t) {
                    return E = t, j = setTimeout(h, e), M ? r(t) : w;
                }
                function l(t) {
                    var n = t - O, r = t - E, i = e - n;
                    return _ ? c(i, g - r) : i;
                }
                function d(t) {
                    var n = t - O, r = t - E;
                    return void 0 === O || n >= e || n < 0 || _ && r >= g;
                }
                function h() {
                    var t = o();
                    return d(t) ? p(t) : void (j = setTimeout(h, l(t)));
                }
                function p(t) {
                    return j = void 0, T && x ? r(t) : (x = m = void 0, w);
                }
                function v() {
                    void 0 !== j && clearTimeout(j), E = 0, x = O = m = j = void 0;
                }
                function y() {
                    return void 0 === j ? w : p(o());
                }
                function b() {
                    var t = o(), n = d(t);
                    if (x = arguments, m = this, O = t, n) {
                        if (void 0 === j) return a(O);
                        if (_) return j = setTimeout(h, e), r(O);
                    }
                    return void 0 === j && (j = setTimeout(h, e)), w;
                }
                var x, m, g, w, j, O, E = 0, M = !1, _ = !1, T = !0;
                if ("function" != typeof t) throw new TypeError(f);
                return e = u(e) || 0, i(n) && (M = !!n.leading, _ = "maxWait" in n, g = _ ? s(u(n.maxWait) || 0, e) : g, T = "trailing" in n ? !!n.trailing : T), b.cancel = v, b.flush = y, b;
            }
            var i = n(1), o = n(8), u = n(10), f = "Expected a function", s = Math.max, c = Math.min;
            t.exports = r;
        },
        function(t, e, n) {
            var r = n(6), i = function() {
                return r.Date.now();
            };
            t.exports = i;
        },
        function(t, e, n) {
            function r(t, e, n) {
                var r = !0, f = !0;
                if ("function" != typeof t) throw new TypeError(u);
                return o(n) && (r = "leading" in n ? !!n.leading : r, f = "trailing" in n ? !!n.trailing : f), i(t, e, {
                    leading: r,
                    maxWait: e,
                    trailing: f
                });
            }
            var i = n(7), o = n(1), u = "Expected a function";
            t.exports = r;
        },
        function(t, e) {
            function n(t) {
                return t;
            }
            t.exports = n;
        }
    ]);
});


const $e08697c769e000aa$var$effects = ()=>{
    // Lazyload
    new (0, (/*@__PURE__*/$parcel$interopDefault($hr0I9)))({
        elements_selector: ".lazy",
        unobserve_entered: true
    });
    // Smooth scroll
    new (0, (/*@__PURE__*/$parcel$interopDefault($7ce91c2db8c0f171$exports)))('a[data-scroll][href*="#"]', {
        speed: 400,
        offset () {
            const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            let offset = 64; // @UPDATE: navigation height
            if (windowWidth > 768) offset = 0;
            return offset;
        }
    });
    // In-view
    if (document.querySelector("[data-in-view]")) {
        (0, (/*@__PURE__*/$parcel$interopDefault($fe6128a024b72d4c$exports))).offset(0);
        (0, (/*@__PURE__*/$parcel$interopDefault($fe6128a024b72d4c$exports)))("[data-in-view]").on("enter", (el)=>{
            el.classList.remove("data-clipping");
            el.classList.add("data-clipping");
        }).on("exit", (el)=>{
            el.classList.remove("data-clipping");
        });
    }
};
var $e08697c769e000aa$export$2e2bcd8739ae039 = $e08697c769e000aa$var$effects;


function $608705cbe9abf74c$var$e(e, t) {
    for(var o = 0; o < t.length; o++){
        var n = t[o];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
}
function $608705cbe9abf74c$var$t(e) {
    return function(e) {
        if (Array.isArray(e)) return $608705cbe9abf74c$var$o(e);
    }(e) || function(e) {
        if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    }(e) || function(e, t) {
        if (!e) return;
        if ("string" == typeof e) return $608705cbe9abf74c$var$o(e, t);
        var n = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === n && e.constructor && (n = e.constructor.name);
        if ("Map" === n || "Set" === n) return Array.from(e);
        if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $608705cbe9abf74c$var$o(e, t);
    }(e) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $608705cbe9abf74c$var$o(e, t) {
    (null == t || t > e.length) && (t = e.length);
    for(var o = 0, n = new Array(t); o < t; o++)n[o] = e[o];
    return n;
}
var $608705cbe9abf74c$var$n, $608705cbe9abf74c$var$i, $608705cbe9abf74c$var$a, $608705cbe9abf74c$var$r, $608705cbe9abf74c$var$s, $608705cbe9abf74c$var$l = ($608705cbe9abf74c$var$n = [
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    "select:not([disabled]):not([aria-hidden])",
    "textarea:not([disabled]):not([aria-hidden])",
    "button:not([disabled]):not([aria-hidden])",
    "iframe",
    "object",
    "embed",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"])'
], $608705cbe9abf74c$var$i = function() {
    function o(e) {
        var n = e.targetModal, i = e.triggers, a = void 0 === i ? [] : i, r = e.onShow, s = void 0 === r ? function() {} : r, l = e.onClose, c = void 0 === l ? function() {} : l, d = e.openTrigger, u = void 0 === d ? "data-micromodal-trigger" : d, f = e.closeTrigger, h = void 0 === f ? "data-micromodal-close" : f, v = e.openClass, g = void 0 === v ? "is-open" : v, m = e.disableScroll, b = void 0 !== m && m, y = e.disableFocus, p = void 0 !== y && y, w = e.awaitCloseAnimation, E = void 0 !== w && w, k = e.awaitOpenAnimation, M = void 0 !== k && k, A = e.debugMode, C = void 0 !== A && A;
        !function(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, o), this.modal = document.getElementById(n), this.config = {
            debugMode: C,
            disableScroll: b,
            openTrigger: u,
            closeTrigger: h,
            openClass: g,
            onShow: s,
            onClose: c,
            awaitCloseAnimation: E,
            awaitOpenAnimation: M,
            disableFocus: p
        }, a.length > 0 && this.registerTriggers.apply(this, $608705cbe9abf74c$var$t(a)), this.onClick = this.onClick.bind(this), this.onKeydown = this.onKeydown.bind(this);
    }
    var i, a, r;
    return i = o, a = [
        {
            key: "registerTriggers",
            value: function() {
                for(var e = this, t = arguments.length, o = new Array(t), n = 0; n < t; n++)o[n] = arguments[n];
                o.filter(Boolean).forEach(function(t) {
                    t.addEventListener("click", function(t) {
                        return e.showModal(t);
                    });
                });
            }
        },
        {
            key: "showModal",
            value: function() {
                var e = this, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                if (this.activeElement = document.activeElement, this.modal.setAttribute("aria-hidden", "false"), this.modal.classList.add(this.config.openClass), this.scrollBehaviour("disable"), this.addEventListeners(), this.config.awaitOpenAnimation) {
                    var o = function t() {
                        e.modal.removeEventListener("animationend", t, !1), e.setFocusToFirstNode();
                    };
                    this.modal.addEventListener("animationend", o, !1);
                } else this.setFocusToFirstNode();
                this.config.onShow(this.modal, this.activeElement, t);
            }
        },
        {
            key: "closeModal",
            value: function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, t = this.modal;
                if (this.modal.setAttribute("aria-hidden", "true"), this.removeEventListeners(), this.scrollBehaviour("enable"), this.activeElement && this.activeElement.focus && this.activeElement.focus(), this.config.onClose(this.modal, this.activeElement, e), this.config.awaitCloseAnimation) {
                    var o = this.config.openClass;
                    this.modal.addEventListener("animationend", function e() {
                        t.classList.remove(o), t.removeEventListener("animationend", e, !1);
                    }, !1);
                } else t.classList.remove(this.config.openClass);
            }
        },
        {
            key: "closeModalById",
            value: function(e) {
                this.modal = document.getElementById(e), this.modal && this.closeModal();
            }
        },
        {
            key: "scrollBehaviour",
            value: function(e) {
                if (this.config.disableScroll) {
                    var t = document.querySelector("body");
                    switch(e){
                        case "enable":
                            Object.assign(t.style, {
                                overflow: ""
                            });
                            break;
                        case "disable":
                            Object.assign(t.style, {
                                overflow: "hidden"
                            });
                    }
                }
            }
        },
        {
            key: "addEventListeners",
            value: function() {
                this.modal.addEventListener("touchstart", this.onClick), this.modal.addEventListener("click", this.onClick), document.addEventListener("keydown", this.onKeydown);
            }
        },
        {
            key: "removeEventListeners",
            value: function() {
                this.modal.removeEventListener("touchstart", this.onClick), this.modal.removeEventListener("click", this.onClick), document.removeEventListener("keydown", this.onKeydown);
            }
        },
        {
            key: "onClick",
            value: function(e) {
                (e.target.hasAttribute(this.config.closeTrigger) || e.target.parentNode.hasAttribute(this.config.closeTrigger)) && (e.preventDefault(), e.stopPropagation(), this.closeModal(e));
            }
        },
        {
            key: "onKeydown",
            value: function(e) {
                27 === e.keyCode && this.closeModal(e), 9 === e.keyCode && this.retainFocus(e);
            }
        },
        {
            key: "getFocusableNodes",
            value: function() {
                var e = this.modal.querySelectorAll($608705cbe9abf74c$var$n);
                return Array.apply(void 0, $608705cbe9abf74c$var$t(e));
            }
        },
        {
            key: "setFocusToFirstNode",
            value: function() {
                var e = this;
                if (!this.config.disableFocus) {
                    var t = this.getFocusableNodes();
                    if (0 !== t.length) {
                        var o = t.filter(function(t) {
                            return !t.hasAttribute(e.config.closeTrigger);
                        });
                        o.length > 0 && o[0].focus(), 0 === o.length && t[0].focus();
                    }
                }
            }
        },
        {
            key: "retainFocus",
            value: function(e) {
                var t = this.getFocusableNodes();
                if (0 !== t.length) {
                    if (t = t.filter(function(e) {
                        return null !== e.offsetParent;
                    }), this.modal.contains(document.activeElement)) {
                        var o = t.indexOf(document.activeElement);
                        e.shiftKey && 0 === o && (t[t.length - 1].focus(), e.preventDefault()), !e.shiftKey && t.length > 0 && o === t.length - 1 && (t[0].focus(), e.preventDefault());
                    } else t[0].focus();
                }
            }
        }
    ], $608705cbe9abf74c$var$e(i.prototype, a), r && $608705cbe9abf74c$var$e(i, r), o;
}(), $608705cbe9abf74c$var$a = null, $608705cbe9abf74c$var$r = function(e) {
    if (!document.getElementById(e)) return console.warn("MicroModal: ❗Seems like you have missed %c'".concat(e, "'"), "background-color: #f8f9fa;color: #50596c;font-weight: bold;", "ID somewhere in your code. Refer example below to resolve it."), console.warn("%cExample:", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", '<div class="modal" id="'.concat(e, '"></div>')), !1;
}, $608705cbe9abf74c$var$s = function(e, t) {
    if (function(e) {
        e.length <= 0 && (console.warn("MicroModal: ❗Please specify at least one %c'micromodal-trigger'", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", "data attribute."), console.warn("%cExample:", "background-color: #f8f9fa;color: #50596c;font-weight: bold;", '<a href="#" data-micromodal-trigger="my-modal"></a>'));
    }(e), !t) return !0;
    for(var o in t)$608705cbe9abf74c$var$r(o);
    return !0;
}, {
    init: function(e) {
        var o = Object.assign({}, {
            openTrigger: "data-micromodal-trigger"
        }, e), n = $608705cbe9abf74c$var$t(document.querySelectorAll("[".concat(o.openTrigger, "]"))), r = function(e, t) {
            var o = [];
            return e.forEach(function(e) {
                var n = e.attributes[t].value;
                void 0 === o[n] && (o[n] = []), o[n].push(e);
            }), o;
        }(n, o.openTrigger);
        if (!0 !== o.debugMode || !1 !== $608705cbe9abf74c$var$s(n, r)) for(var l in r){
            var c = r[l];
            o.targetModal = l, o.triggers = $608705cbe9abf74c$var$t(c), $608705cbe9abf74c$var$a = new $608705cbe9abf74c$var$i(o);
        }
    },
    show: function(e, t) {
        var o = t || {};
        o.targetModal = e, !0 === o.debugMode && !1 === $608705cbe9abf74c$var$r(e) || ($608705cbe9abf74c$var$a && $608705cbe9abf74c$var$a.removeEventListeners(), ($608705cbe9abf74c$var$a = new $608705cbe9abf74c$var$i(o)).showModal());
    },
    close: function(e) {
        e ? $608705cbe9abf74c$var$a.closeModalById(e) : $608705cbe9abf74c$var$a.closeModal();
    }
});
"undefined" != typeof window && (window.MicroModal = $608705cbe9abf74c$var$l);
var $608705cbe9abf74c$export$2e2bcd8739ae039 = $608705cbe9abf74c$var$l;


const $0565f1dd1f0ba03b$var$modal = ()=>{
    if (document.querySelector(".modal")) (0, $608705cbe9abf74c$export$2e2bcd8739ae039).init({
        disableScroll: true
    });
};
var $0565f1dd1f0ba03b$export$2e2bcd8739ae039 = $0565f1dd1f0ba03b$var$modal;



var $jAv3h = parcelRequire("jAv3h");
/*!
 * Glide.js v3.6.0
 * (c) 2013-2022 Jędrzej Chałubek (https://github.com/jedrzejchalubek/)
 * Released under the MIT License.
 */ function $afd51e1b4d76e42d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $afd51e1b4d76e42d$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $afd51e1b4d76e42d$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $afd51e1b4d76e42d$var$_typeof(obj);
}
function $afd51e1b4d76e42d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $afd51e1b4d76e42d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $afd51e1b4d76e42d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $afd51e1b4d76e42d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $afd51e1b4d76e42d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $afd51e1b4d76e42d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $afd51e1b4d76e42d$var$_setPrototypeOf(subClass, superClass);
}
function $afd51e1b4d76e42d$var$_getPrototypeOf(o) {
    $afd51e1b4d76e42d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $afd51e1b4d76e42d$var$_getPrototypeOf(o);
}
function $afd51e1b4d76e42d$var$_setPrototypeOf(o, p) {
    $afd51e1b4d76e42d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $afd51e1b4d76e42d$var$_setPrototypeOf(o, p);
}
function $afd51e1b4d76e42d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $afd51e1b4d76e42d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $afd51e1b4d76e42d$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $afd51e1b4d76e42d$var$_assertThisInitialized(self);
}
function $afd51e1b4d76e42d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $afd51e1b4d76e42d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $afd51e1b4d76e42d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $afd51e1b4d76e42d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $afd51e1b4d76e42d$var$_possibleConstructorReturn(this, result);
    };
}
function $afd51e1b4d76e42d$var$_superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $afd51e1b4d76e42d$var$_getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
function $afd51e1b4d76e42d$var$_get() {
    if (typeof Reflect !== "undefined" && Reflect.get) $afd51e1b4d76e42d$var$_get = Reflect.get;
    else $afd51e1b4d76e42d$var$_get = function _get(target, property, receiver) {
        var base = $afd51e1b4d76e42d$var$_superPropBase(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(arguments.length < 3 ? target : receiver);
        return desc.value;
    };
    return $afd51e1b4d76e42d$var$_get.apply(this, arguments);
}
var $afd51e1b4d76e42d$var$defaults = {
    /**
   * Type of the movement.
   *
   * Available types:
   * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
   * `carousel` - Changes slides without starting over when it reaches the first or last slide.
   *
   * @type {String}
   */ type: "slider",
    /**
   * Start at specific slide number defined with zero-based index.
   *
   * @type {Number}
   */ startAt: 0,
    /**
   * A number of slides visible on the single viewport.
   *
   * @type {Number}
   */ perView: 1,
    /**
   * Focus currently active slide at a specified position in the track.
   *
   * Available inputs:
   * `center` - Current slide will be always focused at the center of a track.
   * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
   *
   * @type {String|Number}
   */ focusAt: 0,
    /**
   * A size of the gap added between slides.
   *
   * @type {Number}
   */ gap: 10,
    /**
   * Change slides after a specified interval. Use `false` for turning off autoplay.
   *
   * @type {Number|Boolean}
   */ autoplay: false,
    /**
   * Stop autoplay on mouseover event.
   *
   * @type {Boolean}
   */ hoverpause: true,
    /**
   * Allow for changing slides with left and right keyboard arrows.
   *
   * @type {Boolean}
   */ keyboard: true,
    /**
   * Stop running `perView` number of slides from the end. Use this
   * option if you don't want to have an empty space after
   * a slider. Works only with `slider` type and a
   * non-centered `focusAt` setting.
   *
   * @type {Boolean}
   */ bound: false,
    /**
   * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
   *
   * @type {Number|Boolean}
   */ swipeThreshold: 80,
    /**
   * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
   *
   * @type {Number|Boolean}
   */ dragThreshold: 120,
    /**
   * A number of slides moved on single swipe.
   *
   * Available types:
   * `` - Moves slider by one slide per swipe
   * `|` - Moves slider between views per swipe (number of slides defined in `perView` options)
   *
   * @type {String}
   */ perSwipe: "",
    /**
   * Moving distance ratio of the slides on a swiping and dragging.
   *
   * @type {Number}
   */ touchRatio: 0.5,
    /**
   * Angle required to activate slides moving on swiping or dragging.
   *
   * @type {Number}
   */ touchAngle: 45,
    /**
   * Duration of the animation in milliseconds.
   *
   * @type {Number}
   */ animationDuration: 400,
    /**
   * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
   *
   * @type {Boolean}
   */ rewind: true,
    /**
   * Duration of the rewinding animation of the `slider` type in milliseconds.
   *
   * @type {Number}
   */ rewindDuration: 800,
    /**
   * Easing function for the animation.
   *
   * @type {String}
   */ animationTimingFunc: "cubic-bezier(.165, .840, .440, 1)",
    /**
   * Wait for the animation to finish until the next user input can be processed
   *
   * @type {boolean}
   */ waitForTransition: true,
    /**
   * Throttle costly events at most once per every wait milliseconds.
   *
   * @type {Number}
   */ throttle: 10,
    /**
   * Moving direction mode.
   *
   * Available inputs:
   * - 'ltr' - left to right movement,
   * - 'rtl' - right to left movement.
   *
   * @type {String}
   */ direction: "ltr",
    /**
   * The distance value of the next and previous viewports which
   * have to peek in the current view. Accepts number and
   * pixels as a string. Left and right peeking can be
   * set up separately with a directions object.
   *
   * For example:
   * `100` - Peek 100px on the both sides.
   * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
   *
   * @type {Number|String|Object}
   */ peek: 0,
    /**
   * Defines how many clones of current viewport will be generated.
   *
   * @type {Number}
   */ cloningRatio: 1,
    /**
   * Collection of options applied at specified media breakpoints.
   * For example: display two slides per view under 800px.
   * `{
   *   '800px': {
   *     perView: 2
   *   }
   * }`
   */ breakpoints: {},
    /**
   * Collection of internally used HTML classes.
   *
   * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
   * @type {Object}
   */ classes: {
        swipeable: "glide--swipeable",
        dragging: "glide--dragging",
        direction: {
            ltr: "glide--ltr",
            rtl: "glide--rtl"
        },
        type: {
            slider: "glide--slider",
            carousel: "glide--carousel"
        },
        slide: {
            clone: "glide__slide--clone",
            active: "glide__slide--active"
        },
        arrow: {
            disabled: "glide__arrow--disabled"
        },
        nav: {
            active: "glide__bullet--active"
        }
    }
};
/**
 * Outputs warning message to the bowser console.
 *
 * @param  {String} msg
 * @return {Void}
 */ function $afd51e1b4d76e42d$var$warn(msg) {
    console.error("[Glide warn]: ".concat(msg));
}
/**
 * Converts value entered as number
 * or string to integer value.
 *
 * @param {String} value
 * @returns {Number}
 */ function $afd51e1b4d76e42d$var$toInt(value) {
    return parseInt(value);
}
/**
 * Converts value entered as number
 * or string to flat value.
 *
 * @param {String} value
 * @returns {Number}
 */ function $afd51e1b4d76e42d$var$toFloat(value) {
    return parseFloat(value);
}
/**
 * Indicates whether the specified value is a string.
 *
 * @param  {*}   value
 * @return {Boolean}
 */ function $afd51e1b4d76e42d$var$isString(value) {
    return typeof value === "string";
}
/**
 * Indicates whether the specified value is an object.
 *
 * @param  {*} value
 * @return {Boolean}
 *
 * @see https://github.com/jashkenas/underscore
 */ function $afd51e1b4d76e42d$var$isObject(value) {
    var type = $afd51e1b4d76e42d$var$_typeof(value);
    return type === "function" || type === "object" && !!value; // eslint-disable-line no-mixed-operators
}
/**
 * Indicates whether the specified value is a function.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function $afd51e1b4d76e42d$var$isFunction(value) {
    return typeof value === "function";
}
/**
 * Indicates whether the specified value is undefined.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function $afd51e1b4d76e42d$var$isUndefined(value) {
    return typeof value === "undefined";
}
/**
 * Indicates whether the specified value is an array.
 *
 * @param  {*} value
 * @return {Boolean}
 */ function $afd51e1b4d76e42d$var$isArray(value) {
    return value.constructor === Array;
}
/**
 * Creates and initializes specified collection of extensions.
 * Each extension receives access to instance of glide and rest of components.
 *
 * @param {Object} glide
 * @param {Object} extensions
 *
 * @returns {Object}
 */ function $afd51e1b4d76e42d$var$mount(glide, extensions, events) {
    var components = {};
    for(var name in extensions)if ($afd51e1b4d76e42d$var$isFunction(extensions[name])) components[name] = extensions[name](glide, components, events);
    else $afd51e1b4d76e42d$var$warn("Extension must be a function");
    for(var _name in components)if ($afd51e1b4d76e42d$var$isFunction(components[_name].mount)) components[_name].mount();
    return components;
}
/**
 * Defines getter and setter property on the specified object.
 *
 * @param  {Object} obj         Object where property has to be defined.
 * @param  {String} prop        Name of the defined property.
 * @param  {Object} definition  Get and set definitions for the property.
 * @return {Void}
 */ function $afd51e1b4d76e42d$var$define(obj, prop, definition) {
    Object.defineProperty(obj, prop, definition);
}
/**
 * Sorts aphabetically object keys.
 *
 * @param  {Object} obj
 * @return {Object}
 */ function $afd51e1b4d76e42d$var$sortKeys(obj) {
    return Object.keys(obj).sort().reduce(function(r, k) {
        r[k] = obj[k];
        return r[k], r;
    }, {});
}
/**
 * Merges passed settings object with default options.
 *
 * @param  {Object} defaults
 * @param  {Object} settings
 * @return {Object}
 */ function $afd51e1b4d76e42d$var$mergeOptions(defaults, settings) {
    var options = Object.assign({}, defaults, settings); // `Object.assign` do not deeply merge objects, so we
    // have to do it manually for every nested object
    // in options. Although it does not look smart,
    // it's smaller and faster than some fancy
    // merging deep-merge algorithm script.
    if (settings.hasOwnProperty("classes")) {
        options.classes = Object.assign({}, defaults.classes, settings.classes);
        if (settings.classes.hasOwnProperty("direction")) options.classes.direction = Object.assign({}, defaults.classes.direction, settings.classes.direction);
        if (settings.classes.hasOwnProperty("type")) options.classes.type = Object.assign({}, defaults.classes.type, settings.classes.type);
        if (settings.classes.hasOwnProperty("slide")) options.classes.slide = Object.assign({}, defaults.classes.slide, settings.classes.slide);
        if (settings.classes.hasOwnProperty("arrow")) options.classes.arrow = Object.assign({}, defaults.classes.arrow, settings.classes.arrow);
        if (settings.classes.hasOwnProperty("nav")) options.classes.nav = Object.assign({}, defaults.classes.nav, settings.classes.nav);
    }
    if (settings.hasOwnProperty("breakpoints")) options.breakpoints = Object.assign({}, defaults.breakpoints, settings.breakpoints);
    return options;
}
var $afd51e1b4d76e42d$var$EventsBus = /*#__PURE__*/ function() {
    /**
   * Construct a EventBus instance.
   *
   * @param {Object} events
   */ function EventsBus() {
        var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $afd51e1b4d76e42d$var$_classCallCheck(this, EventsBus);
        this.events = events;
        this.hop = events.hasOwnProperty;
    }
    /**
   * Adds listener to the specifed event.
   *
   * @param {String|Array} event
   * @param {Function} handler
   */ $afd51e1b4d76e42d$var$_createClass(EventsBus, [
        {
            key: "on",
            value: function on(event, handler) {
                if ($afd51e1b4d76e42d$var$isArray(event)) {
                    for(var i = 0; i < event.length; i++)this.on(event[i], handler);
                    return;
                } // Create the event's object if not yet created
                if (!this.hop.call(this.events, event)) this.events[event] = [];
                 // Add the handler to queue
                var index = this.events[event].push(handler) - 1; // Provide handle back for removal of event
                return {
                    remove: function remove() {
                        delete this.events[event][index];
                    }
                };
            }
        },
        {
            key: "emit",
            value: function emit(event, context) {
                if ($afd51e1b4d76e42d$var$isArray(event)) {
                    for(var i = 0; i < event.length; i++)this.emit(event[i], context);
                    return;
                } // If the event doesn't exist, or there's no handlers in queue, just leave
                if (!this.hop.call(this.events, event)) return;
                 // Cycle through events queue, fire!
                this.events[event].forEach(function(item) {
                    item(context || {});
                });
            }
        }
    ]);
    return EventsBus;
}();
var $afd51e1b4d76e42d$var$Glide$1 = /*#__PURE__*/ function() {
    /**
   * Construct glide.
   *
   * @param  {String} selector
   * @param  {Object} options
   */ function Glide(selector) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $afd51e1b4d76e42d$var$_classCallCheck(this, Glide);
        this._c = {};
        this._t = [];
        this._e = new $afd51e1b4d76e42d$var$EventsBus();
        this.disabled = false;
        this.selector = selector;
        this.settings = $afd51e1b4d76e42d$var$mergeOptions($afd51e1b4d76e42d$var$defaults, options);
        this.index = this.settings.startAt;
    }
    /**
   * Initializes glide.
   *
   * @param {Object} extensions Collection of extensions to initialize.
   * @return {Glide}
   */ $afd51e1b4d76e42d$var$_createClass(Glide, [
        {
            key: "mount",
            value: function mount$1() {
                var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                this._e.emit("mount.before");
                if ($afd51e1b4d76e42d$var$isObject(extensions)) this._c = $afd51e1b4d76e42d$var$mount(this, extensions, this._e);
                else $afd51e1b4d76e42d$var$warn("You need to provide a object on `mount()`");
                this._e.emit("mount.after");
                return this;
            }
        },
        {
            key: "mutate",
            value: function mutate() {
                var transformers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                if ($afd51e1b4d76e42d$var$isArray(transformers)) this._t = transformers;
                else $afd51e1b4d76e42d$var$warn("You need to provide a array on `mutate()`");
                return this;
            }
        },
        {
            key: "update",
            value: function update() {
                var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                this.settings = $afd51e1b4d76e42d$var$mergeOptions(this.settings, settings);
                if (settings.hasOwnProperty("startAt")) this.index = settings.startAt;
                this._e.emit("update");
                return this;
            }
        },
        {
            key: "go",
            value: function go(pattern) {
                this._c.Run.make(pattern);
                return this;
            }
        },
        {
            key: "move",
            value: function move(distance) {
                this._c.Transition.disable();
                this._c.Move.make(distance);
                return this;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this._e.emit("destroy");
                return this;
            }
        },
        {
            key: "play",
            value: function play() {
                var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
                if (interval) this.settings.autoplay = interval;
                this._e.emit("play");
                return this;
            }
        },
        {
            key: "pause",
            value: function pause() {
                this._e.emit("pause");
                return this;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this.disabled = true;
                return this;
            }
        },
        {
            key: "enable",
            value: function enable() {
                this.disabled = false;
                return this;
            }
        },
        {
            key: "on",
            value: function on(event, handler) {
                this._e.on(event, handler);
                return this;
            }
        },
        {
            key: "isType",
            value: function isType(name) {
                return this.settings.type === name;
            }
        },
        {
            key: "settings",
            get: function get() {
                return this._o;
            },
            set: function set(o) {
                if ($afd51e1b4d76e42d$var$isObject(o)) this._o = o;
                else $afd51e1b4d76e42d$var$warn("Options must be an `object` instance.");
            }
        },
        {
            key: "index",
            get: function get() {
                return this._i;
            },
            set: function set(i) {
                this._i = $afd51e1b4d76e42d$var$toInt(i);
            }
        },
        {
            key: "type",
            get: function get() {
                return this.settings.type;
            }
        },
        {
            key: "disabled",
            get: function get() {
                return this._d;
            },
            set: function set(status) {
                this._d = !!status;
            }
        }
    ]);
    return Glide;
}();
function $afd51e1b4d76e42d$var$Run(Glide, Components, Events) {
    var Run = {
        /**
     * Initializes autorunning of the glide.
     *
     * @return {Void}
     */ mount: function mount() {
            this._o = false;
        },
        /**
     * Makes glides running based on the passed moving schema.
     *
     * @param {String} move
     */ make: function make(move) {
            var _this = this;
            if (!Glide.disabled) {
                !Glide.settings.waitForTransition || Glide.disable();
                this.move = move;
                Events.emit("run.before", this.move);
                this.calculate();
                Events.emit("run", this.move);
                Components.Transition.after(function() {
                    if (_this.isStart()) Events.emit("run.start", _this.move);
                    if (_this.isEnd()) Events.emit("run.end", _this.move);
                    if (_this.isOffset()) {
                        _this._o = false;
                        Events.emit("run.offset", _this.move);
                    }
                    Events.emit("run.after", _this.move);
                    Glide.enable();
                });
            }
        },
        /**
     * Calculates current index based on defined move.
     *
     * @return {Number|Undefined}
     */ calculate: function calculate() {
            var move = this.move, length = this.length;
            var steps = move.steps, direction = move.direction; // By default assume that size of view is equal to one slide
            var viewSize = 1; // While direction is `=` we want jump to
            // a specified index described in steps.
            if (direction === "=") {
                // Check if bound is true, 
                // as we want to avoid whitespaces.
                if (Glide.settings.bound && $afd51e1b4d76e42d$var$toInt(steps) > length) {
                    Glide.index = length;
                    return;
                }
                Glide.index = steps;
                return;
            } // When pattern is equal to `>>` we want
            // fast forward to the last slide.
            if (direction === ">" && steps === ">") {
                Glide.index = length;
                return;
            } // When pattern is equal to `<<` we want
            // fast forward to the first slide.
            if (direction === "<" && steps === "<") {
                Glide.index = 0;
                return;
            } // pagination movement
            if (direction === "|") viewSize = Glide.settings.perView || 1;
             // we are moving forward
            if (direction === ">" || direction === "|" && steps === ">") {
                var index = calculateForwardIndex(viewSize);
                if (index > length) this._o = true;
                Glide.index = normalizeForwardIndex(index, viewSize);
                return;
            } // we are moving backward
            if (direction === "<" || direction === "|" && steps === "<") {
                var _index = calculateBackwardIndex(viewSize);
                if (_index < 0) this._o = true;
                Glide.index = normalizeBackwardIndex(_index, viewSize);
                return;
            }
            $afd51e1b4d76e42d$var$warn("Invalid direction pattern [".concat(direction).concat(steps, "] has been used"));
        },
        /**
     * Checks if we are on the first slide.
     *
     * @return {Boolean}
     */ isStart: function isStart() {
            return Glide.index <= 0;
        },
        /**
     * Checks if we are on the last slide.
     *
     * @return {Boolean}
     */ isEnd: function isEnd() {
            return Glide.index >= this.length;
        },
        /**
     * Checks if we are making a offset run.
     *
     * @param {String} direction
     * @return {Boolean}
     */ isOffset: function isOffset() {
            var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
            if (!direction) return this._o;
            if (!this._o) return false;
             // did we view to the right?
            if (direction === "|>") return this.move.direction === "|" && this.move.steps === ">";
             // did we view to the left?
            if (direction === "|<") return this.move.direction === "|" && this.move.steps === "<";
            return this.move.direction === direction;
        },
        /**
     * Checks if bound mode is active
     *
     * @return {Boolean}
     */ isBound: function isBound() {
            return Glide.isType("slider") && Glide.settings.focusAt !== "center" && Glide.settings.bound;
        }
    };
    /**
   * Returns index value to move forward/to the right
   *
   * @param viewSize
   * @returns {Number}
   */ function calculateForwardIndex(viewSize) {
        var index = Glide.index;
        if (Glide.isType("carousel")) return index + viewSize;
        return index + (viewSize - index % viewSize);
    }
    /**
   * Normalizes the given forward index based on glide settings, preventing it to exceed certain boundaries
   *
   * @param index
   * @param length
   * @param viewSize
   * @returns {Number}
   */ function normalizeForwardIndex(index, viewSize) {
        var length = Run.length;
        if (index <= length) return index;
        if (Glide.isType("carousel")) return index - (length + 1);
        if (Glide.settings.rewind) {
            // bound does funny things with the length, therefor we have to be certain
            // that we are on the last possible index value given by bound
            if (Run.isBound() && !Run.isEnd()) return length;
            return 0;
        }
        if (Run.isBound()) return length;
        return Math.floor(length / viewSize) * viewSize;
    }
    /**
   * Calculates index value to move backward/to the left
   *
   * @param viewSize
   * @returns {Number}
   */ function calculateBackwardIndex(viewSize) {
        var index = Glide.index;
        if (Glide.isType("carousel")) return index - viewSize;
         // ensure our back navigation results in the same index as a forward navigation
        // to experience a homogeneous paging
        var view = Math.ceil(index / viewSize);
        return (view - 1) * viewSize;
    }
    /**
   * Normalizes the given backward index based on glide settings, preventing it to exceed certain boundaries
   *
   * @param index
   * @param length
   * @param viewSize
   * @returns {*}
   */ function normalizeBackwardIndex(index, viewSize) {
        var length = Run.length;
        if (index >= 0) return index;
        if (Glide.isType("carousel")) return index + (length + 1);
        if (Glide.settings.rewind) {
            // bound does funny things with the length, therefor we have to be certain
            // that we are on first possible index value before we to rewind to the length given by bound
            if (Run.isBound() && Run.isStart()) return length;
            return Math.floor(length / viewSize) * viewSize;
        }
        return 0;
    }
    $afd51e1b4d76e42d$var$define(Run, "move", {
        /**
     * Gets value of the move schema.
     *
     * @returns {Object}
     */ get: function get() {
            return this._m;
        },
        /**
     * Sets value of the move schema.
     *
     * @returns {Object}
     */ set: function set(value) {
            var step = value.substr(1);
            this._m = {
                direction: value.substr(0, 1),
                steps: step ? $afd51e1b4d76e42d$var$toInt(step) ? $afd51e1b4d76e42d$var$toInt(step) : step : 0
            };
        }
    });
    $afd51e1b4d76e42d$var$define(Run, "length", {
        /**
     * Gets value of the running distance based
     * on zero-indexing number of slides.
     *
     * @return {Number}
     */ get: function get() {
            var settings = Glide.settings;
            var length = Components.Html.slides.length; // If the `bound` option is active, a maximum running distance should be
            // reduced by `perView` and `focusAt` settings. Running distance
            // should end before creating an empty space after instance.
            if (this.isBound()) return length - 1 - ($afd51e1b4d76e42d$var$toInt(settings.perView) - 1) + $afd51e1b4d76e42d$var$toInt(settings.focusAt);
            return length - 1;
        }
    });
    $afd51e1b4d76e42d$var$define(Run, "offset", {
        /**
     * Gets status of the offsetting flag.
     *
     * @return {Boolean}
     */ get: function get() {
            return this._o;
        }
    });
    return Run;
}
/**
 * Returns a current time.
 *
 * @return {Number}
 */ function $afd51e1b4d76e42d$var$now() {
    return new Date().getTime();
}
/**
 * Returns a function, that, when invoked, will only be triggered
 * at most once during a given window of time.
 *
 * @param {Function} func
 * @param {Number} wait
 * @param {Object=} options
 * @return {Function}
 *
 * @see https://github.com/jashkenas/underscore
 */ function $afd51e1b4d76e42d$var$throttle(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};
    var later = function later() {
        previous = options.leading === false ? 0 : $afd51e1b4d76e42d$var$now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
    };
    var throttled = function throttled() {
        var at = $afd51e1b4d76e42d$var$now();
        if (!previous && options.leading === false) previous = at;
        var remaining = wait - (at - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = at;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
        return result;
    };
    throttled.cancel = function() {
        clearTimeout(timeout);
        previous = 0;
        timeout = context = args = null;
    };
    return throttled;
}
var $afd51e1b4d76e42d$var$MARGIN_TYPE = {
    ltr: [
        "marginLeft",
        "marginRight"
    ],
    rtl: [
        "marginRight",
        "marginLeft"
    ]
};
function $afd51e1b4d76e42d$var$Gaps(Glide, Components, Events) {
    var Gaps = {
        /**
     * Applies gaps between slides. First and last
     * slides do not receive it's edge margins.
     *
     * @param {HTMLCollection} slides
     * @return {Void}
     */ apply: function apply(slides) {
            for(var i = 0, len = slides.length; i < len; i++){
                var style = slides[i].style;
                var direction = Components.Direction.value;
                if (i !== 0) style[$afd51e1b4d76e42d$var$MARGIN_TYPE[direction][0]] = "".concat(this.value / 2, "px");
                else style[$afd51e1b4d76e42d$var$MARGIN_TYPE[direction][0]] = "";
                if (i !== slides.length - 1) style[$afd51e1b4d76e42d$var$MARGIN_TYPE[direction][1]] = "".concat(this.value / 2, "px");
                else style[$afd51e1b4d76e42d$var$MARGIN_TYPE[direction][1]] = "";
            }
        },
        /**
     * Removes gaps from the slides.
     *
     * @param {HTMLCollection} slides
     * @returns {Void}
    */ remove: function remove(slides) {
            for(var i = 0, len = slides.length; i < len; i++){
                var style = slides[i].style;
                style.marginLeft = "";
                style.marginRight = "";
            }
        }
    };
    $afd51e1b4d76e42d$var$define(Gaps, "value", {
        /**
     * Gets value of the gap.
     *
     * @returns {Number}
     */ get: function get() {
            return $afd51e1b4d76e42d$var$toInt(Glide.settings.gap);
        }
    });
    $afd51e1b4d76e42d$var$define(Gaps, "grow", {
        /**
     * Gets additional dimensions value caused by gaps.
     * Used to increase width of the slides wrapper.
     *
     * @returns {Number}
     */ get: function get() {
            return Gaps.value * Components.Sizes.length;
        }
    });
    $afd51e1b4d76e42d$var$define(Gaps, "reductor", {
        /**
     * Gets reduction value caused by gaps.
     * Used to subtract width of the slides.
     *
     * @returns {Number}
     */ get: function get() {
            var perView = Glide.settings.perView;
            return Gaps.value * (perView - 1) / perView;
        }
    });
    /**
   * Apply calculated gaps:
   * - after building, so slides (including clones) will receive proper margins
   * - on updating via API, to recalculate gaps with new options
   */ Events.on([
        "build.after",
        "update"
    ], $afd51e1b4d76e42d$var$throttle(function() {
        Gaps.apply(Components.Html.wrapper.children);
    }, 30));
    /**
   * Remove gaps:
   * - on destroying to bring markup to its inital state
   */ Events.on("destroy", function() {
        Gaps.remove(Components.Html.wrapper.children);
    });
    return Gaps;
}
/**
 * Finds siblings nodes of the passed node.
 *
 * @param  {Element} node
 * @return {Array}
 */ function $afd51e1b4d76e42d$var$siblings(node) {
    if (node && node.parentNode) {
        var n = node.parentNode.firstChild;
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== node) matched.push(n);
        return matched;
    }
    return [];
}
/**
 * Checks if passed node exist and is a valid element.
 *
 * @param  {Element} node
 * @return {Boolean}
 */ function $afd51e1b4d76e42d$var$exist(node) {
    if (node && node instanceof window.HTMLElement) return true;
    return false;
}
/**
 * Coerces a NodeList to an Array.
 *
 * @param  {NodeList} nodeList
 * @return {Array}
 */ function $afd51e1b4d76e42d$var$toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
}
var $afd51e1b4d76e42d$var$TRACK_SELECTOR = '[data-glide-el="track"]';
function $afd51e1b4d76e42d$var$Html(Glide, Components, Events) {
    var Html = {
        /**
     * Setup slider HTML nodes.
     *
     * @param {Glide} glide
     */ mount: function mount() {
            this.root = Glide.selector;
            this.track = this.root.querySelector($afd51e1b4d76e42d$var$TRACK_SELECTOR);
            this.collectSlides();
        },
        /**
     * Collect slides
     */ collectSlides: function collectSlides() {
            this.slides = $afd51e1b4d76e42d$var$toArray(this.wrapper.children).filter(function(slide) {
                return !slide.classList.contains(Glide.settings.classes.slide.clone);
            });
        }
    };
    $afd51e1b4d76e42d$var$define(Html, "root", {
        /**
     * Gets node of the glide main element.
     *
     * @return {Object}
     */ get: function get() {
            return Html._r;
        },
        /**
     * Sets node of the glide main element.
     *
     * @return {Object}
     */ set: function set(r) {
            if ($afd51e1b4d76e42d$var$isString(r)) r = document.querySelector(r);
            if ($afd51e1b4d76e42d$var$exist(r)) Html._r = r;
            else $afd51e1b4d76e42d$var$warn("Root element must be a existing Html node");
        }
    });
    $afd51e1b4d76e42d$var$define(Html, "track", {
        /**
     * Gets node of the glide track with slides.
     *
     * @return {Object}
     */ get: function get() {
            return Html._t;
        },
        /**
     * Sets node of the glide track with slides.
     *
     * @return {Object}
     */ set: function set(t) {
            if ($afd51e1b4d76e42d$var$exist(t)) Html._t = t;
            else $afd51e1b4d76e42d$var$warn("Could not find track element. Please use ".concat($afd51e1b4d76e42d$var$TRACK_SELECTOR, " attribute."));
        }
    });
    $afd51e1b4d76e42d$var$define(Html, "wrapper", {
        /**
     * Gets node of the slides wrapper.
     *
     * @return {Object}
     */ get: function get() {
            return Html.track.children[0];
        }
    });
    /**
   * Add/remove/reorder dynamic slides
   */ Events.on("update", function() {
        Html.collectSlides();
    });
    return Html;
}
function $afd51e1b4d76e42d$var$Peek(Glide, Components, Events) {
    var Peek = {
        /**
     * Setups how much to peek based on settings.
     *
     * @return {Void}
     */ mount: function mount() {
            this.value = Glide.settings.peek;
        }
    };
    $afd51e1b4d76e42d$var$define(Peek, "value", {
        /**
     * Gets value of the peek.
     *
     * @returns {Number|Object}
     */ get: function get() {
            return Peek._v;
        },
        /**
     * Sets value of the peek.
     *
     * @param {Number|Object} value
     * @return {Void}
     */ set: function set(value) {
            if ($afd51e1b4d76e42d$var$isObject(value)) {
                value.before = $afd51e1b4d76e42d$var$toInt(value.before);
                value.after = $afd51e1b4d76e42d$var$toInt(value.after);
            } else value = $afd51e1b4d76e42d$var$toInt(value);
            Peek._v = value;
        }
    });
    $afd51e1b4d76e42d$var$define(Peek, "reductor", {
        /**
     * Gets reduction value caused by peek.
     *
     * @returns {Number}
     */ get: function get() {
            var value = Peek.value;
            var perView = Glide.settings.perView;
            if ($afd51e1b4d76e42d$var$isObject(value)) return value.before / perView + value.after / perView;
            return value * 2 / perView;
        }
    });
    /**
   * Recalculate peeking sizes on:
   * - when resizing window to update to proper percents
   */ Events.on([
        "resize",
        "update"
    ], function() {
        Peek.mount();
    });
    return Peek;
}
function $afd51e1b4d76e42d$var$Move(Glide, Components, Events) {
    var Move = {
        /**
     * Constructs move component.
     *
     * @returns {Void}
     */ mount: function mount() {
            this._o = 0;
        },
        /**
     * Calculates a movement value based on passed offset and currently active index.
     *
     * @param  {Number} offset
     * @return {Void}
     */ make: function make() {
            var _this = this;
            var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
            this.offset = offset;
            Events.emit("move", {
                movement: this.value
            });
            Components.Transition.after(function() {
                Events.emit("move.after", {
                    movement: _this.value
                });
            });
        }
    };
    $afd51e1b4d76e42d$var$define(Move, "offset", {
        /**
     * Gets an offset value used to modify current translate.
     *
     * @return {Object}
     */ get: function get() {
            return Move._o;
        },
        /**
     * Sets an offset value used to modify current translate.
     *
     * @return {Object}
     */ set: function set(value) {
            Move._o = !$afd51e1b4d76e42d$var$isUndefined(value) ? $afd51e1b4d76e42d$var$toInt(value) : 0;
        }
    });
    $afd51e1b4d76e42d$var$define(Move, "translate", {
        /**
     * Gets a raw movement value.
     *
     * @return {Number}
     */ get: function get() {
            return Components.Sizes.slideWidth * Glide.index;
        }
    });
    $afd51e1b4d76e42d$var$define(Move, "value", {
        /**
     * Gets an actual movement value corrected by offset.
     *
     * @return {Number}
     */ get: function get() {
            var offset = this.offset;
            var translate = this.translate;
            if (Components.Direction.is("rtl")) return translate + offset;
            return translate - offset;
        }
    });
    /**
   * Make movement to proper slide on:
   * - before build, so glide will start at `startAt` index
   * - on each standard run to move to newly calculated index
   */ Events.on([
        "build.before",
        "run"
    ], function() {
        Move.make();
    });
    return Move;
}
function $afd51e1b4d76e42d$var$Sizes(Glide, Components, Events) {
    var Sizes = {
        /**
     * Setups dimensions of slides.
     *
     * @return {Void}
     */ setupSlides: function setupSlides() {
            var width = "".concat(this.slideWidth, "px");
            var slides = Components.Html.slides;
            for(var i = 0; i < slides.length; i++)slides[i].style.width = width;
        },
        /**
     * Setups dimensions of slides wrapper.
     *
     * @return {Void}
     */ setupWrapper: function setupWrapper() {
            Components.Html.wrapper.style.width = "".concat(this.wrapperSize, "px");
        },
        /**
     * Removes applied styles from HTML elements.
     *
     * @returns {Void}
     */ remove: function remove() {
            var slides = Components.Html.slides;
            for(var i = 0; i < slides.length; i++)slides[i].style.width = "";
            Components.Html.wrapper.style.width = "";
        }
    };
    $afd51e1b4d76e42d$var$define(Sizes, "length", {
        /**
     * Gets count number of the slides.
     *
     * @return {Number}
     */ get: function get() {
            return Components.Html.slides.length;
        }
    });
    $afd51e1b4d76e42d$var$define(Sizes, "width", {
        /**
     * Gets width value of the slider (visible area).
     *
     * @return {Number}
     */ get: function get() {
            return Components.Html.track.offsetWidth;
        }
    });
    $afd51e1b4d76e42d$var$define(Sizes, "wrapperSize", {
        /**
     * Gets size of the slides wrapper.
     *
     * @return {Number}
     */ get: function get() {
            return Sizes.slideWidth * Sizes.length + Components.Gaps.grow + Components.Clones.grow;
        }
    });
    $afd51e1b4d76e42d$var$define(Sizes, "slideWidth", {
        /**
     * Gets width value of a single slide.
     *
     * @return {Number}
     */ get: function get() {
            return Sizes.width / Glide.settings.perView - Components.Peek.reductor - Components.Gaps.reductor;
        }
    });
    /**
   * Apply calculated glide's dimensions:
   * - before building, so other dimensions (e.g. translate) will be calculated propertly
   * - when resizing window to recalculate sildes dimensions
   * - on updating via API, to calculate dimensions based on new options
   */ Events.on([
        "build.before",
        "resize",
        "update"
    ], function() {
        Sizes.setupSlides();
        Sizes.setupWrapper();
    });
    /**
   * Remove calculated glide's dimensions:
   * - on destoting to bring markup to its inital state
   */ Events.on("destroy", function() {
        Sizes.remove();
    });
    return Sizes;
}
function $afd51e1b4d76e42d$var$Build(Glide, Components, Events) {
    var Build = {
        /**
     * Init glide building. Adds classes, sets
     * dimensions and setups initial state.
     *
     * @return {Void}
     */ mount: function mount() {
            Events.emit("build.before");
            this.typeClass();
            this.activeClass();
            Events.emit("build.after");
        },
        /**
     * Adds `type` class to the glide element.
     *
     * @return {Void}
     */ typeClass: function typeClass() {
            Components.Html.root.classList.add(Glide.settings.classes.type[Glide.settings.type]);
        },
        /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */ activeClass: function activeClass() {
            var classes = Glide.settings.classes;
            var slide = Components.Html.slides[Glide.index];
            if (slide) {
                slide.classList.add(classes.slide.active);
                $afd51e1b4d76e42d$var$siblings(slide).forEach(function(sibling) {
                    sibling.classList.remove(classes.slide.active);
                });
            }
        },
        /**
     * Removes HTML classes applied at building.
     *
     * @return {Void}
     */ removeClasses: function removeClasses() {
            var _Glide$settings$class = Glide.settings.classes, type = _Glide$settings$class.type, slide = _Glide$settings$class.slide;
            Components.Html.root.classList.remove(type[Glide.settings.type]);
            Components.Html.slides.forEach(function(sibling) {
                sibling.classList.remove(slide.active);
            });
        }
    };
    /**
   * Clear building classes:
   * - on destroying to bring HTML to its initial state
   * - on updating to remove classes before remounting component
   */ Events.on([
        "destroy",
        "update"
    ], function() {
        Build.removeClasses();
    });
    /**
   * Remount component:
   * - on resizing of the window to calculate new dimensions
   * - on updating settings via API
   */ Events.on([
        "resize",
        "update"
    ], function() {
        Build.mount();
    });
    /**
   * Swap active class of current slide:
   * - after each move to the new index
   */ Events.on("move.after", function() {
        Build.activeClass();
    });
    return Build;
}
function $afd51e1b4d76e42d$var$Clones(Glide, Components, Events) {
    var Clones = {
        /**
     * Create pattern map and collect slides to be cloned.
     */ mount: function mount() {
            this.items = [];
            if (Glide.isType("carousel")) this.items = this.collect();
        },
        /**
     * Collect clones with pattern.
     *
     * @return {[]}
     */ collect: function collect() {
            var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
            var slides = Components.Html.slides;
            var _Glide$settings = Glide.settings, perView = _Glide$settings.perView, classes = _Glide$settings.classes, cloningRatio = _Glide$settings.cloningRatio;
            if (slides.length !== 0) {
                var peekIncrementer = +!!Glide.settings.peek;
                var cloneCount = perView + peekIncrementer + Math.round(perView / 2);
                var append = slides.slice(0, cloneCount).reverse();
                var prepend = slides.slice(cloneCount * -1);
                for(var r = 0; r < Math.max(cloningRatio, Math.floor(perView / slides.length)); r++){
                    for(var i = 0; i < append.length; i++){
                        var clone = append[i].cloneNode(true);
                        clone.classList.add(classes.slide.clone);
                        items.push(clone);
                    }
                    for(var _i = 0; _i < prepend.length; _i++){
                        var _clone = prepend[_i].cloneNode(true);
                        _clone.classList.add(classes.slide.clone);
                        items.unshift(_clone);
                    }
                }
            }
            return items;
        },
        /**
     * Append cloned slides with generated pattern.
     *
     * @return {Void}
     */ append: function append() {
            var items = this.items;
            var _Components$Html = Components.Html, wrapper = _Components$Html.wrapper, slides = _Components$Html.slides;
            var half = Math.floor(items.length / 2);
            var prepend = items.slice(0, half).reverse();
            var append = items.slice(half * -1).reverse();
            var width = "".concat(Components.Sizes.slideWidth, "px");
            for(var i = 0; i < append.length; i++)wrapper.appendChild(append[i]);
            for(var _i2 = 0; _i2 < prepend.length; _i2++)wrapper.insertBefore(prepend[_i2], slides[0]);
            for(var _i3 = 0; _i3 < items.length; _i3++)items[_i3].style.width = width;
        },
        /**
     * Remove all cloned slides.
     *
     * @return {Void}
     */ remove: function remove() {
            var items = this.items;
            for(var i = 0; i < items.length; i++)Components.Html.wrapper.removeChild(items[i]);
        }
    };
    $afd51e1b4d76e42d$var$define(Clones, "grow", {
        /**
     * Gets additional dimensions value caused by clones.
     *
     * @return {Number}
     */ get: function get() {
            return (Components.Sizes.slideWidth + Components.Gaps.value) * Clones.items.length;
        }
    });
    /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */ Events.on("update", function() {
        Clones.remove();
        Clones.mount();
        Clones.append();
    });
    /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */ Events.on("build.before", function() {
        if (Glide.isType("carousel")) Clones.append();
    });
    /**
   * Remove clones HTMLElements:
   * - on destroying, to bring HTML to its initial state
   */ Events.on("destroy", function() {
        Clones.remove();
    });
    return Clones;
}
var $afd51e1b4d76e42d$var$EventsBinder = /*#__PURE__*/ function() {
    /**
   * Construct a EventsBinder instance.
   */ function EventsBinder() {
        var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        $afd51e1b4d76e42d$var$_classCallCheck(this, EventsBinder);
        this.listeners = listeners;
    }
    /**
   * Adds events listeners to arrows HTML elements.
   *
   * @param  {String|Array} events
   * @param  {Element|Window|Document} el
   * @param  {Function} closure
   * @param  {Boolean|Object} capture
   * @return {Void}
   */ $afd51e1b4d76e42d$var$_createClass(EventsBinder, [
        {
            key: "on",
            value: function on(events, el, closure) {
                var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                if ($afd51e1b4d76e42d$var$isString(events)) events = [
                    events
                ];
                for(var i = 0; i < events.length; i++){
                    this.listeners[events[i]] = closure;
                    el.addEventListener(events[i], this.listeners[events[i]], capture);
                }
            }
        },
        {
            key: "off",
            value: function off(events, el) {
                var capture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                if ($afd51e1b4d76e42d$var$isString(events)) events = [
                    events
                ];
                for(var i = 0; i < events.length; i++)el.removeEventListener(events[i], this.listeners[events[i]], capture);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                delete this.listeners;
            }
        }
    ]);
    return EventsBinder;
}();
function $afd51e1b4d76e42d$var$Resize(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $afd51e1b4d76e42d$var$EventsBinder();
    var Resize = {
        /**
     * Initializes window bindings.
     */ mount: function mount() {
            this.bind();
        },
        /**
     * Binds `rezsize` listener to the window.
     * It's a costly event, so we are debouncing it.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on("resize", window, $afd51e1b4d76e42d$var$throttle(function() {
                Events.emit("resize");
            }, Glide.settings.throttle));
        },
        /**
     * Unbinds listeners from the window.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off("resize", window);
        }
    };
    /**
   * Remove bindings from window:
   * - on destroying, to remove added EventListener
   */ Events.on("destroy", function() {
        Resize.unbind();
        Binder.destroy();
    });
    return Resize;
}
var $afd51e1b4d76e42d$var$VALID_DIRECTIONS = [
    "ltr",
    "rtl"
];
var $afd51e1b4d76e42d$var$FLIPED_MOVEMENTS = {
    ">": "<",
    "<": ">",
    "=": "="
};
function $afd51e1b4d76e42d$var$Direction(Glide, Components, Events) {
    var Direction = {
        /**
     * Setups gap value based on settings.
     *
     * @return {Void}
     */ mount: function mount() {
            this.value = Glide.settings.direction;
        },
        /**
     * Resolves pattern based on direction value
     *
     * @param {String} pattern
     * @returns {String}
     */ resolve: function resolve(pattern) {
            var token = pattern.slice(0, 1);
            if (this.is("rtl")) return pattern.split(token).join($afd51e1b4d76e42d$var$FLIPED_MOVEMENTS[token]);
            return pattern;
        },
        /**
     * Checks value of direction mode.
     *
     * @param {String} direction
     * @returns {Boolean}
     */ is: function is(direction) {
            return this.value === direction;
        },
        /**
     * Applies direction class to the root HTML element.
     *
     * @return {Void}
     */ addClass: function addClass() {
            Components.Html.root.classList.add(Glide.settings.classes.direction[this.value]);
        },
        /**
     * Removes direction class from the root HTML element.
     *
     * @return {Void}
     */ removeClass: function removeClass() {
            Components.Html.root.classList.remove(Glide.settings.classes.direction[this.value]);
        }
    };
    $afd51e1b4d76e42d$var$define(Direction, "value", {
        /**
     * Gets value of the direction.
     *
     * @returns {Number}
     */ get: function get() {
            return Direction._v;
        },
        /**
     * Sets value of the direction.
     *
     * @param {String} value
     * @return {Void}
     */ set: function set(value) {
            if ($afd51e1b4d76e42d$var$VALID_DIRECTIONS.indexOf(value) > -1) Direction._v = value;
            else $afd51e1b4d76e42d$var$warn("Direction value must be `ltr` or `rtl`");
        }
    });
    /**
   * Clear direction class:
   * - on destroy to bring HTML to its initial state
   * - on update to remove class before reappling bellow
   */ Events.on([
        "destroy",
        "update"
    ], function() {
        Direction.removeClass();
    });
    /**
   * Remount component:
   * - on update to reflect changes in direction value
   */ Events.on("update", function() {
        Direction.mount();
    });
    /**
   * Apply direction class:
   * - before building to apply class for the first time
   * - on updating to reapply direction class that may changed
   */ Events.on([
        "build.before",
        "update"
    ], function() {
        Direction.addClass();
    });
    return Direction;
}
/**
 * Reflects value of glide movement.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $afd51e1b4d76e42d$var$Rtl(Glide, Components) {
    return {
        /**
     * Negates the passed translate if glide is in RTL option.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            if (Components.Direction.is("rtl")) return -translate;
            return translate;
        }
    };
}
/**
 * Updates glide movement with a `gap` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $afd51e1b4d76e42d$var$Gap(Glide, Components) {
    return {
        /**
     * Modifies passed translate value with number in the `gap` settings.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            var multiplier = Math.floor(translate / Components.Sizes.slideWidth);
            return translate + Components.Gaps.value * multiplier;
        }
    };
}
/**
 * Updates glide movement with width of additional clones width.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $afd51e1b4d76e42d$var$Grow(Glide, Components) {
    return {
        /**
     * Adds to the passed translate width of the half of clones.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            return translate + Components.Clones.grow / 2;
        }
    };
}
/**
 * Updates glide movement with a `peek` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $afd51e1b4d76e42d$var$Peeking(Glide, Components) {
    return {
        /**
     * Modifies passed translate value with a `peek` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            if (Glide.settings.focusAt >= 0) {
                var peek = Components.Peek.value;
                if ($afd51e1b4d76e42d$var$isObject(peek)) return translate - peek.before;
                return translate - peek;
            }
            return translate;
        }
    };
}
/**
 * Updates glide movement with a `focusAt` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $afd51e1b4d76e42d$var$Focusing(Glide, Components) {
    return {
        /**
     * Modifies passed translate value with index in the `focusAt` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */ modify: function modify(translate) {
            var gap = Components.Gaps.value;
            var width = Components.Sizes.width;
            var focusAt = Glide.settings.focusAt;
            var slideWidth = Components.Sizes.slideWidth;
            if (focusAt === "center") return translate - (width / 2 - slideWidth / 2);
            return translate - slideWidth * focusAt - gap * focusAt;
        }
    };
}
/**
 * Applies diffrent transformers on translate value.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */ function $afd51e1b4d76e42d$var$mutator(Glide, Components, Events) {
    /**
   * Merge instance transformers with collection of default transformers.
   * It's important that the Rtl component be last on the list,
   * so it reflects all previous transformations.
   *
   * @type {Array}
   */ var TRANSFORMERS = [
        $afd51e1b4d76e42d$var$Gap,
        $afd51e1b4d76e42d$var$Grow,
        $afd51e1b4d76e42d$var$Peeking,
        $afd51e1b4d76e42d$var$Focusing
    ].concat(Glide._t, [
        $afd51e1b4d76e42d$var$Rtl
    ]);
    return {
        /**
     * Piplines translate value with registered transformers.
     *
     * @param  {Number} translate
     * @return {Number}
     */ mutate: function mutate(translate) {
            for(var i = 0; i < TRANSFORMERS.length; i++){
                var transformer = TRANSFORMERS[i];
                if ($afd51e1b4d76e42d$var$isFunction(transformer) && $afd51e1b4d76e42d$var$isFunction(transformer().modify)) translate = transformer(Glide, Components, Events).modify(translate);
                else $afd51e1b4d76e42d$var$warn("Transformer should be a function that returns an object with `modify()` method");
            }
            return translate;
        }
    };
}
function $afd51e1b4d76e42d$var$Translate(Glide, Components, Events) {
    var Translate = {
        /**
     * Sets value of translate on HTML element.
     *
     * @param {Number} value
     * @return {Void}
     */ set: function set(value) {
            var transform = $afd51e1b4d76e42d$var$mutator(Glide, Components).mutate(value);
            var translate3d = "translate3d(".concat(-1 * transform, "px, 0px, 0px)");
            Components.Html.wrapper.style.mozTransform = translate3d; // needed for supported Firefox 10-15
            Components.Html.wrapper.style.webkitTransform = translate3d; // needed for supported Chrome 10-35, Safari 5.1-8, and Opera 15-22
            Components.Html.wrapper.style.transform = translate3d;
        },
        /**
     * Removes value of translate from HTML element.
     *
     * @return {Void}
     */ remove: function remove() {
            Components.Html.wrapper.style.transform = "";
        },
        /**
     * @return {number}
     */ getStartIndex: function getStartIndex() {
            var length = Components.Sizes.length;
            var index = Glide.index;
            var perView = Glide.settings.perView;
            if (Components.Run.isOffset(">") || Components.Run.isOffset("|>")) return length + (index - perView);
             // "modulo length" converts an index that equals length to zero
            return (index + perView) % length;
        },
        /**
     * @return {number}
     */ getTravelDistance: function getTravelDistance() {
            var travelDistance = Components.Sizes.slideWidth * Glide.settings.perView;
            if (Components.Run.isOffset(">") || Components.Run.isOffset("|>")) // reverse travel distance so that we don't have to change subtract operations
            return travelDistance * -1;
            return travelDistance;
        }
    };
    /**
   * Set new translate value:
   * - on move to reflect index change
   * - on updating via API to reflect possible changes in options
   */ Events.on("move", function(context) {
        if (!Glide.isType("carousel") || !Components.Run.isOffset()) return Translate.set(context.movement);
        Components.Transition.after(function() {
            Events.emit("translate.jump");
            Translate.set(Components.Sizes.slideWidth * Glide.index);
        });
        var startWidth = Components.Sizes.slideWidth * Components.Translate.getStartIndex();
        return Translate.set(startWidth - Components.Translate.getTravelDistance());
    });
    /**
   * Remove translate:
   * - on destroying to bring markup to its inital state
   */ Events.on("destroy", function() {
        Translate.remove();
    });
    return Translate;
}
function $afd51e1b4d76e42d$var$Transition(Glide, Components, Events) {
    /**
   * Holds inactivity status of transition.
   * When true transition is not applied.
   *
   * @type {Boolean}
   */ var disabled = false;
    var Transition = {
        /**
     * Composes string of the CSS transition.
     *
     * @param {String} property
     * @return {String}
     */ compose: function compose(property) {
            var settings = Glide.settings;
            if (!disabled) return "".concat(property, " ").concat(this.duration, "ms ").concat(settings.animationTimingFunc);
            return "".concat(property, " 0ms ").concat(settings.animationTimingFunc);
        },
        /**
     * Sets value of transition on HTML element.
     *
     * @param {String=} property
     * @return {Void}
     */ set: function set() {
            var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "transform";
            Components.Html.wrapper.style.transition = this.compose(property);
        },
        /**
     * Removes value of transition from HTML element.
     *
     * @return {Void}
     */ remove: function remove() {
            Components.Html.wrapper.style.transition = "";
        },
        /**
     * Runs callback after animation.
     *
     * @param  {Function} callback
     * @return {Void}
     */ after: function after(callback) {
            setTimeout(function() {
                callback();
            }, this.duration);
        },
        /**
     * Enable transition.
     *
     * @return {Void}
     */ enable: function enable() {
            disabled = false;
            this.set();
        },
        /**
     * Disable transition.
     *
     * @return {Void}
     */ disable: function disable() {
            disabled = true;
            this.set();
        }
    };
    $afd51e1b4d76e42d$var$define(Transition, "duration", {
        /**
     * Gets duration of the transition based
     * on currently running animation type.
     *
     * @return {Number}
     */ get: function get() {
            var settings = Glide.settings;
            if (Glide.isType("slider") && Components.Run.offset) return settings.rewindDuration;
            return settings.animationDuration;
        }
    });
    /**
   * Set transition `style` value:
   * - on each moving, because it may be cleared by offset move
   */ Events.on("move", function() {
        Transition.set();
    });
    /**
   * Disable transition:
   * - before initial build to avoid transitioning from `0` to `startAt` index
   * - while resizing window and recalculating dimensions
   * - on jumping from offset transition at start and end edges in `carousel` type
   */ Events.on([
        "build.before",
        "resize",
        "translate.jump"
    ], function() {
        Transition.disable();
    });
    /**
   * Enable transition:
   * - on each running, because it may be disabled by offset move
   */ Events.on("run", function() {
        Transition.enable();
    });
    /**
   * Remove transition:
   * - on destroying to bring markup to its inital state
   */ Events.on("destroy", function() {
        Transition.remove();
    });
    return Transition;
}
/**
 * Test via a getter in the options object to see
 * if the passive property is accessed.
 *
 * @see https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
 */ var $afd51e1b4d76e42d$var$supportsPassive = false;
try {
    var $afd51e1b4d76e42d$var$opts = Object.defineProperty({}, "passive", {
        get: function get() {
            $afd51e1b4d76e42d$var$supportsPassive = true;
        }
    });
    window.addEventListener("testPassive", null, $afd51e1b4d76e42d$var$opts);
    window.removeEventListener("testPassive", null, $afd51e1b4d76e42d$var$opts);
} catch (e) {}
var $afd51e1b4d76e42d$var$supportsPassive$1 = $afd51e1b4d76e42d$var$supportsPassive;
var $afd51e1b4d76e42d$var$START_EVENTS = [
    "touchstart",
    "mousedown"
];
var $afd51e1b4d76e42d$var$MOVE_EVENTS = [
    "touchmove",
    "mousemove"
];
var $afd51e1b4d76e42d$var$END_EVENTS = [
    "touchend",
    "touchcancel",
    "mouseup",
    "mouseleave"
];
var $afd51e1b4d76e42d$var$MOUSE_EVENTS = [
    "mousedown",
    "mousemove",
    "mouseup",
    "mouseleave"
];
function $afd51e1b4d76e42d$var$Swipe(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $afd51e1b4d76e42d$var$EventsBinder();
    var swipeSin = 0;
    var swipeStartX = 0;
    var swipeStartY = 0;
    var disabled = false;
    var capture = $afd51e1b4d76e42d$var$supportsPassive$1 ? {
        passive: true
    } : false;
    var Swipe = {
        /**
     * Initializes swipe bindings.
     *
     * @return {Void}
     */ mount: function mount() {
            this.bindSwipeStart();
        },
        /**
     * Handler for `swipestart` event. Calculates entry points of the user's tap.
     *
     * @param {Object} event
     * @return {Void}
     */ start: function start(event) {
            if (!disabled && !Glide.disabled) {
                this.disable();
                var swipe = this.touches(event);
                swipeSin = null;
                swipeStartX = $afd51e1b4d76e42d$var$toInt(swipe.pageX);
                swipeStartY = $afd51e1b4d76e42d$var$toInt(swipe.pageY);
                this.bindSwipeMove();
                this.bindSwipeEnd();
                Events.emit("swipe.start");
            }
        },
        /**
     * Handler for `swipemove` event. Calculates user's tap angle and distance.
     *
     * @param {Object} event
     */ move: function move(event) {
            if (!Glide.disabled) {
                var _Glide$settings = Glide.settings, touchAngle = _Glide$settings.touchAngle, touchRatio = _Glide$settings.touchRatio, classes = _Glide$settings.classes;
                var swipe = this.touches(event);
                var subExSx = $afd51e1b4d76e42d$var$toInt(swipe.pageX) - swipeStartX;
                var subEySy = $afd51e1b4d76e42d$var$toInt(swipe.pageY) - swipeStartY;
                var powEX = Math.abs(subExSx << 2);
                var powEY = Math.abs(subEySy << 2);
                var swipeHypotenuse = Math.sqrt(powEX + powEY);
                var swipeCathetus = Math.sqrt(powEY);
                swipeSin = Math.asin(swipeCathetus / swipeHypotenuse);
                if (swipeSin * 180 / Math.PI < touchAngle) {
                    event.stopPropagation();
                    Components.Move.make(subExSx * $afd51e1b4d76e42d$var$toFloat(touchRatio));
                    Components.Html.root.classList.add(classes.dragging);
                    Events.emit("swipe.move");
                } else return false;
            }
        },
        /**
     * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
     *
     * @param {Object} event
     * @return {Void}
     */ end: function end(event) {
            if (!Glide.disabled) {
                var _Glide$settings2 = Glide.settings, perSwipe = _Glide$settings2.perSwipe, touchAngle = _Glide$settings2.touchAngle, classes = _Glide$settings2.classes;
                var swipe = this.touches(event);
                var threshold = this.threshold(event);
                var swipeDistance = swipe.pageX - swipeStartX;
                var swipeDeg = swipeSin * 180 / Math.PI;
                this.enable();
                if (swipeDistance > threshold && swipeDeg < touchAngle) Components.Run.make(Components.Direction.resolve("".concat(perSwipe, "<")));
                else if (swipeDistance < -threshold && swipeDeg < touchAngle) Components.Run.make(Components.Direction.resolve("".concat(perSwipe, ">")));
                else // While swipe don't reach distance apply previous transform.
                Components.Move.make();
                Components.Html.root.classList.remove(classes.dragging);
                this.unbindSwipeMove();
                this.unbindSwipeEnd();
                Events.emit("swipe.end");
            }
        },
        /**
     * Binds swipe's starting event.
     *
     * @return {Void}
     */ bindSwipeStart: function bindSwipeStart() {
            var _this = this;
            var _Glide$settings3 = Glide.settings, swipeThreshold = _Glide$settings3.swipeThreshold, dragThreshold = _Glide$settings3.dragThreshold;
            if (swipeThreshold) Binder.on($afd51e1b4d76e42d$var$START_EVENTS[0], Components.Html.wrapper, function(event) {
                _this.start(event);
            }, capture);
            if (dragThreshold) Binder.on($afd51e1b4d76e42d$var$START_EVENTS[1], Components.Html.wrapper, function(event) {
                _this.start(event);
            }, capture);
        },
        /**
     * Unbinds swipe's starting event.
     *
     * @return {Void}
     */ unbindSwipeStart: function unbindSwipeStart() {
            Binder.off($afd51e1b4d76e42d$var$START_EVENTS[0], Components.Html.wrapper, capture);
            Binder.off($afd51e1b4d76e42d$var$START_EVENTS[1], Components.Html.wrapper, capture);
        },
        /**
     * Binds swipe's moving event.
     *
     * @return {Void}
     */ bindSwipeMove: function bindSwipeMove() {
            var _this2 = this;
            Binder.on($afd51e1b4d76e42d$var$MOVE_EVENTS, Components.Html.wrapper, $afd51e1b4d76e42d$var$throttle(function(event) {
                _this2.move(event);
            }, Glide.settings.throttle), capture);
        },
        /**
     * Unbinds swipe's moving event.
     *
     * @return {Void}
     */ unbindSwipeMove: function unbindSwipeMove() {
            Binder.off($afd51e1b4d76e42d$var$MOVE_EVENTS, Components.Html.wrapper, capture);
        },
        /**
     * Binds swipe's ending event.
     *
     * @return {Void}
     */ bindSwipeEnd: function bindSwipeEnd() {
            var _this3 = this;
            Binder.on($afd51e1b4d76e42d$var$END_EVENTS, Components.Html.wrapper, function(event) {
                _this3.end(event);
            });
        },
        /**
     * Unbinds swipe's ending event.
     *
     * @return {Void}
     */ unbindSwipeEnd: function unbindSwipeEnd() {
            Binder.off($afd51e1b4d76e42d$var$END_EVENTS, Components.Html.wrapper);
        },
        /**
     * Normalizes event touches points accorting to different types.
     *
     * @param {Object} event
     */ touches: function touches(event) {
            if ($afd51e1b4d76e42d$var$MOUSE_EVENTS.indexOf(event.type) > -1) return event;
            return event.touches[0] || event.changedTouches[0];
        },
        /**
     * Gets value of minimum swipe distance settings based on event type.
     *
     * @return {Number}
     */ threshold: function threshold(event) {
            var settings = Glide.settings;
            if ($afd51e1b4d76e42d$var$MOUSE_EVENTS.indexOf(event.type) > -1) return settings.dragThreshold;
            return settings.swipeThreshold;
        },
        /**
     * Enables swipe event.
     *
     * @return {self}
     */ enable: function enable() {
            disabled = false;
            Components.Transition.enable();
            return this;
        },
        /**
     * Disables swipe event.
     *
     * @return {self}
     */ disable: function disable() {
            disabled = true;
            Components.Transition.disable();
            return this;
        }
    };
    /**
   * Add component class:
   * - after initial building
   */ Events.on("build.after", function() {
        Components.Html.root.classList.add(Glide.settings.classes.swipeable);
    });
    /**
   * Remove swiping bindings:
   * - on destroying, to remove added EventListeners
   */ Events.on("destroy", function() {
        Swipe.unbindSwipeStart();
        Swipe.unbindSwipeMove();
        Swipe.unbindSwipeEnd();
        Binder.destroy();
    });
    return Swipe;
}
function $afd51e1b4d76e42d$var$Images(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $afd51e1b4d76e42d$var$EventsBinder();
    var Images = {
        /**
     * Binds listener to glide wrapper.
     *
     * @return {Void}
     */ mount: function mount() {
            this.bind();
        },
        /**
     * Binds `dragstart` event on wrapper to prevent dragging images.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on("dragstart", Components.Html.wrapper, this.dragstart);
        },
        /**
     * Unbinds `dragstart` event on wrapper.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off("dragstart", Components.Html.wrapper);
        },
        /**
     * Event handler. Prevents dragging.
     *
     * @return {Void}
     */ dragstart: function dragstart(event) {
            event.preventDefault();
        }
    };
    /**
   * Remove bindings from images:
   * - on destroying, to remove added EventListeners
   */ Events.on("destroy", function() {
        Images.unbind();
        Binder.destroy();
    });
    return Images;
}
function $afd51e1b4d76e42d$var$Anchors(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $afd51e1b4d76e42d$var$EventsBinder();
    /**
   * Holds detaching status of anchors.
   * Prevents detaching of already detached anchors.
   *
   * @private
   * @type {Boolean}
   */ var detached = false;
    /**
   * Holds preventing status of anchors.
   * If `true` redirection after click will be disabled.
   *
   * @private
   * @type {Boolean}
   */ var prevented = false;
    var Anchors = {
        /**
     * Setups a initial state of anchors component.
     *
     * @returns {Void}
     */ mount: function mount() {
            /**
       * Holds collection of anchors elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._a = Components.Html.wrapper.querySelectorAll("a");
            this.bind();
        },
        /**
     * Binds events to anchors inside a track.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on("click", Components.Html.wrapper, this.click);
        },
        /**
     * Unbinds events attached to anchors inside a track.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off("click", Components.Html.wrapper);
        },
        /**
     * Handler for click event. Prevents clicks when glide is in `prevent` status.
     *
     * @param  {Object} event
     * @return {Void}
     */ click: function click(event) {
            if (prevented) {
                event.stopPropagation();
                event.preventDefault();
            }
        },
        /**
     * Detaches anchors click event inside glide.
     *
     * @return {self}
     */ detach: function detach() {
            prevented = true;
            if (!detached) {
                for(var i = 0; i < this.items.length; i++)this.items[i].draggable = false;
                detached = true;
            }
            return this;
        },
        /**
     * Attaches anchors click events inside glide.
     *
     * @return {self}
     */ attach: function attach() {
            prevented = false;
            if (detached) {
                for(var i = 0; i < this.items.length; i++)this.items[i].draggable = true;
                detached = false;
            }
            return this;
        }
    };
    $afd51e1b4d76e42d$var$define(Anchors, "items", {
        /**
     * Gets collection of the arrows HTML elements.
     *
     * @return {HTMLElement[]}
     */ get: function get() {
            return Anchors._a;
        }
    });
    /**
   * Detach anchors inside slides:
   * - on swiping, so they won't redirect to its `href` attributes
   */ Events.on("swipe.move", function() {
        Anchors.detach();
    });
    /**
   * Attach anchors inside slides:
   * - after swiping and transitions ends, so they can redirect after click again
   */ Events.on("swipe.end", function() {
        Components.Transition.after(function() {
            Anchors.attach();
        });
    });
    /**
   * Unbind anchors inside slides:
   * - on destroying, to bring anchors to its initial state
   */ Events.on("destroy", function() {
        Anchors.attach();
        Anchors.unbind();
        Binder.destroy();
    });
    return Anchors;
}
var $afd51e1b4d76e42d$var$NAV_SELECTOR = '[data-glide-el="controls[nav]"]';
var $afd51e1b4d76e42d$var$CONTROLS_SELECTOR = '[data-glide-el^="controls"]';
var $afd51e1b4d76e42d$var$PREVIOUS_CONTROLS_SELECTOR = "".concat($afd51e1b4d76e42d$var$CONTROLS_SELECTOR, ' [data-glide-dir*="<"]');
var $afd51e1b4d76e42d$var$NEXT_CONTROLS_SELECTOR = "".concat($afd51e1b4d76e42d$var$CONTROLS_SELECTOR, ' [data-glide-dir*=">"]');
function $afd51e1b4d76e42d$var$Controls(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $afd51e1b4d76e42d$var$EventsBinder();
    var capture = $afd51e1b4d76e42d$var$supportsPassive$1 ? {
        passive: true
    } : false;
    var Controls = {
        /**
     * Inits arrows. Binds events listeners
     * to the arrows HTML elements.
     *
     * @return {Void}
     */ mount: function mount() {
            /**
       * Collection of navigation HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._n = Components.Html.root.querySelectorAll($afd51e1b4d76e42d$var$NAV_SELECTOR);
            /**
       * Collection of controls HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */ this._c = Components.Html.root.querySelectorAll($afd51e1b4d76e42d$var$CONTROLS_SELECTOR);
            /**
       * Collection of arrow control HTML elements.
       *
       * @private
       * @type {Object}
       */ this._arrowControls = {
                previous: Components.Html.root.querySelectorAll($afd51e1b4d76e42d$var$PREVIOUS_CONTROLS_SELECTOR),
                next: Components.Html.root.querySelectorAll($afd51e1b4d76e42d$var$NEXT_CONTROLS_SELECTOR)
            };
            this.addBindings();
        },
        /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */ setActive: function setActive() {
            for(var i = 0; i < this._n.length; i++)this.addClass(this._n[i].children);
        },
        /**
     * Removes active class to current slide.
     *
     * @return {Void}
     */ removeActive: function removeActive() {
            for(var i = 0; i < this._n.length; i++)this.removeClass(this._n[i].children);
        },
        /**
     * Toggles active class on items inside navigation.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */ addClass: function addClass(controls) {
            var settings = Glide.settings;
            var item = controls[Glide.index];
            if (!item) return;
            if (item) {
                item.classList.add(settings.classes.nav.active);
                $afd51e1b4d76e42d$var$siblings(item).forEach(function(sibling) {
                    sibling.classList.remove(settings.classes.nav.active);
                });
            }
        },
        /**
     * Removes active class from active control.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */ removeClass: function removeClass(controls) {
            var item = controls[Glide.index];
            if (item) item.classList.remove(Glide.settings.classes.nav.active);
        },
        /**
     * Calculates, removes or adds `Glide.settings.classes.disabledArrow` class on the control arrows
     */ setArrowState: function setArrowState() {
            if (Glide.settings.rewind) return;
            var next = Controls._arrowControls.next;
            var previous = Controls._arrowControls.previous;
            this.resetArrowState(next, previous);
            if (Glide.index === 0) this.disableArrow(previous);
            if (Glide.index === Components.Run.length) this.disableArrow(next);
        },
        /**
     * Removes `Glide.settings.classes.disabledArrow` from given NodeList elements
     *
     * @param {NodeList[]} lists
     */ resetArrowState: function resetArrowState() {
            var settings = Glide.settings;
            for(var _len = arguments.length, lists = new Array(_len), _key = 0; _key < _len; _key++)lists[_key] = arguments[_key];
            lists.forEach(function(list) {
                $afd51e1b4d76e42d$var$toArray(list).forEach(function(element) {
                    element.classList.remove(settings.classes.arrow.disabled);
                });
            });
        },
        /**
     * Adds `Glide.settings.classes.disabledArrow` to given NodeList elements
     *
     * @param {NodeList[]} lists
     */ disableArrow: function disableArrow() {
            var settings = Glide.settings;
            for(var _len2 = arguments.length, lists = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)lists[_key2] = arguments[_key2];
            lists.forEach(function(list) {
                $afd51e1b4d76e42d$var$toArray(list).forEach(function(element) {
                    element.classList.add(settings.classes.arrow.disabled);
                });
            });
        },
        /**
     * Adds handles to the each group of controls.
     *
     * @return {Void}
     */ addBindings: function addBindings() {
            for(var i = 0; i < this._c.length; i++)this.bind(this._c[i].children);
        },
        /**
     * Removes handles from the each group of controls.
     *
     * @return {Void}
     */ removeBindings: function removeBindings() {
            for(var i = 0; i < this._c.length; i++)this.unbind(this._c[i].children);
        },
        /**
     * Binds events to arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */ bind: function bind(elements) {
            for(var i = 0; i < elements.length; i++){
                Binder.on("click", elements[i], this.click);
                Binder.on("touchstart", elements[i], this.click, capture);
            }
        },
        /**
     * Unbinds events binded to the arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */ unbind: function unbind(elements) {
            for(var i = 0; i < elements.length; i++)Binder.off([
                "click",
                "touchstart"
            ], elements[i]);
        },
        /**
     * Handles `click` event on the arrows HTML elements.
     * Moves slider in direction given via the
     * `data-glide-dir` attribute.
     *
     * @param {Object} event
     * @return {void}
     */ click: function click(event) {
            if (!$afd51e1b4d76e42d$var$supportsPassive$1 && event.type === "touchstart") event.preventDefault();
            var direction = event.currentTarget.getAttribute("data-glide-dir");
            Components.Run.make(Components.Direction.resolve(direction));
        }
    };
    $afd51e1b4d76e42d$var$define(Controls, "items", {
        /**
     * Gets collection of the controls HTML elements.
     *
     * @return {HTMLElement[]}
     */ get: function get() {
            return Controls._c;
        }
    });
    /**
   * Swap active class of current navigation item:
   * - after mounting to set it to initial index
   * - after each move to the new index
   */ Events.on([
        "mount.after",
        "move.after"
    ], function() {
        Controls.setActive();
    });
    /**
   * Add or remove disabled class of arrow elements
   */ Events.on([
        "mount.after",
        "run"
    ], function() {
        Controls.setArrowState();
    });
    /**
   * Remove bindings and HTML Classes:
   * - on destroying, to bring markup to its initial state
   */ Events.on("destroy", function() {
        Controls.removeBindings();
        Controls.removeActive();
        Binder.destroy();
    });
    return Controls;
}
function $afd51e1b4d76e42d$var$Keyboard(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $afd51e1b4d76e42d$var$EventsBinder();
    var Keyboard = {
        /**
     * Binds keyboard events on component mount.
     *
     * @return {Void}
     */ mount: function mount() {
            if (Glide.settings.keyboard) this.bind();
        },
        /**
     * Adds keyboard press events.
     *
     * @return {Void}
     */ bind: function bind() {
            Binder.on("keyup", document, this.press);
        },
        /**
     * Removes keyboard press events.
     *
     * @return {Void}
     */ unbind: function unbind() {
            Binder.off("keyup", document);
        },
        /**
     * Handles keyboard's arrows press and moving glide foward and backward.
     *
     * @param  {Object} event
     * @return {Void}
     */ press: function press(event) {
            var perSwipe = Glide.settings.perSwipe;
            if (event.code === "ArrowRight") Components.Run.make(Components.Direction.resolve("".concat(perSwipe, ">")));
            if (event.code === "ArrowLeft") Components.Run.make(Components.Direction.resolve("".concat(perSwipe, "<")));
        }
    };
    /**
   * Remove bindings from keyboard:
   * - on destroying to remove added events
   * - on updating to remove events before remounting
   */ Events.on([
        "destroy",
        "update"
    ], function() {
        Keyboard.unbind();
    });
    /**
   * Remount component
   * - on updating to reflect potential changes in settings
   */ Events.on("update", function() {
        Keyboard.mount();
    });
    /**
   * Destroy binder:
   * - on destroying to remove listeners
   */ Events.on("destroy", function() {
        Binder.destroy();
    });
    return Keyboard;
}
function $afd51e1b4d76e42d$var$Autoplay(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $afd51e1b4d76e42d$var$EventsBinder();
    var Autoplay = {
        /**
     * Initializes autoplaying and events.
     *
     * @return {Void}
     */ mount: function mount() {
            this.enable();
            this.start();
            if (Glide.settings.hoverpause) this.bind();
        },
        /**
     * Enables autoplaying
     *
     * @returns {Void}
     */ enable: function enable() {
            this._e = true;
        },
        /**
     * Disables autoplaying.
     *
     * @returns {Void}
     */ disable: function disable() {
            this._e = false;
        },
        /**
     * Starts autoplaying in configured interval.
     *
     * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Void}
     */ start: function start() {
            var _this = this;
            if (!this._e) return;
            this.enable();
            if (Glide.settings.autoplay) {
                if ($afd51e1b4d76e42d$var$isUndefined(this._i)) this._i = setInterval(function() {
                    _this.stop();
                    Components.Run.make(">");
                    _this.start();
                    Events.emit("autoplay");
                }, this.time);
            }
        },
        /**
     * Stops autorunning of the glide.
     *
     * @return {Void}
     */ stop: function stop() {
            this._i = clearInterval(this._i);
        },
        /**
     * Stops autoplaying while mouse is over glide's area.
     *
     * @return {Void}
     */ bind: function bind() {
            var _this2 = this;
            Binder.on("mouseover", Components.Html.root, function() {
                if (_this2._e) _this2.stop();
            });
            Binder.on("mouseout", Components.Html.root, function() {
                if (_this2._e) _this2.start();
            });
        },
        /**
     * Unbind mouseover events.
     *
     * @returns {Void}
     */ unbind: function unbind() {
            Binder.off([
                "mouseover",
                "mouseout"
            ], Components.Html.root);
        }
    };
    $afd51e1b4d76e42d$var$define(Autoplay, "time", {
        /**
     * Gets time period value for the autoplay interval. Prioritizes
     * times in `data-glide-autoplay` attrubutes over options.
     *
     * @return {Number}
     */ get: function get() {
            var autoplay = Components.Html.slides[Glide.index].getAttribute("data-glide-autoplay");
            if (autoplay) return $afd51e1b4d76e42d$var$toInt(autoplay);
            return $afd51e1b4d76e42d$var$toInt(Glide.settings.autoplay);
        }
    });
    /**
   * Stop autoplaying and unbind events:
   * - on destroying, to clear defined interval
   * - on updating via API to reset interval that may changed
   */ Events.on([
        "destroy",
        "update"
    ], function() {
        Autoplay.unbind();
    });
    /**
   * Stop autoplaying:
   * - before each run, to restart autoplaying
   * - on pausing via API
   * - on destroying, to clear defined interval
   * - while starting a swipe
   * - on updating via API to reset interval that may changed
   */ Events.on([
        "run.before",
        "swipe.start",
        "update"
    ], function() {
        Autoplay.stop();
    });
    Events.on([
        "pause",
        "destroy"
    ], function() {
        Autoplay.disable();
        Autoplay.stop();
    });
    /**
   * Start autoplaying:
   * - after each run, to restart autoplaying
   * - on playing via API
   * - while ending a swipe
   */ Events.on([
        "run.after",
        "swipe.end"
    ], function() {
        Autoplay.start();
    });
    /**
   * Start autoplaying:
   * - after each run, to restart autoplaying
   * - on playing via API
   * - while ending a swipe
   */ Events.on([
        "play"
    ], function() {
        Autoplay.enable();
        Autoplay.start();
    });
    /**
   * Remount autoplaying:
   * - on updating via API to reset interval that may changed
   */ Events.on("update", function() {
        Autoplay.mount();
    });
    /**
   * Destroy a binder:
   * - on destroying glide instance to clearup listeners
   */ Events.on("destroy", function() {
        Binder.destroy();
    });
    return Autoplay;
}
/**
 * Sorts keys of breakpoint object so they will be ordered from lower to bigger.
 *
 * @param {Object} points
 * @returns {Object}
 */ function $afd51e1b4d76e42d$var$sortBreakpoints(points) {
    if ($afd51e1b4d76e42d$var$isObject(points)) return $afd51e1b4d76e42d$var$sortKeys(points);
    else $afd51e1b4d76e42d$var$warn("Breakpoints option must be an object");
    return {};
}
function $afd51e1b4d76e42d$var$Breakpoints(Glide, Components, Events) {
    /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */ var Binder = new $afd51e1b4d76e42d$var$EventsBinder();
    /**
   * Holds reference to settings.
   *
   * @type {Object}
   */ var settings = Glide.settings;
    /**
   * Holds reference to breakpoints object in settings. Sorts breakpoints
   * from smaller to larger. It is required in order to proper
   * matching currently active breakpoint settings.
   *
   * @type {Object}
   */ var points = $afd51e1b4d76e42d$var$sortBreakpoints(settings.breakpoints);
    /**
   * Cache initial settings before overwritting.
   *
   * @type {Object}
   */ var defaults = Object.assign({}, settings);
    var Breakpoints = {
        /**
     * Matches settings for currectly matching media breakpoint.
     *
     * @param {Object} points
     * @returns {Object}
     */ match: function match(points) {
            if (typeof window.matchMedia !== "undefined") {
                for(var point in points)if (points.hasOwnProperty(point)) {
                    if (window.matchMedia("(max-width: ".concat(point, "px)")).matches) return points[point];
                }
            }
            return defaults;
        }
    };
    /**
   * Overwrite instance settings with currently matching breakpoint settings.
   * This happens right after component initialization.
   */ Object.assign(settings, Breakpoints.match(points));
    /**
   * Update glide with settings of matched brekpoint:
   * - window resize to update slider
   */ Binder.on("resize", window, $afd51e1b4d76e42d$var$throttle(function() {
        Glide.settings = $afd51e1b4d76e42d$var$mergeOptions(settings, Breakpoints.match(points));
    }, Glide.settings.throttle));
    /**
   * Resort and update default settings:
   * - on reinit via API, so breakpoint matching will be performed with options
   */ Events.on("update", function() {
        points = $afd51e1b4d76e42d$var$sortBreakpoints(points);
        defaults = Object.assign({}, settings);
    });
    /**
   * Unbind resize listener:
   * - on destroying, to bring markup to its initial state
   */ Events.on("destroy", function() {
        Binder.off("resize", window);
    });
    return Breakpoints;
}
var $afd51e1b4d76e42d$var$COMPONENTS = {
    // Required
    Html: $afd51e1b4d76e42d$var$Html,
    Translate: $afd51e1b4d76e42d$var$Translate,
    Transition: $afd51e1b4d76e42d$var$Transition,
    Direction: $afd51e1b4d76e42d$var$Direction,
    Peek: $afd51e1b4d76e42d$var$Peek,
    Sizes: $afd51e1b4d76e42d$var$Sizes,
    Gaps: $afd51e1b4d76e42d$var$Gaps,
    Move: $afd51e1b4d76e42d$var$Move,
    Clones: $afd51e1b4d76e42d$var$Clones,
    Resize: $afd51e1b4d76e42d$var$Resize,
    Build: $afd51e1b4d76e42d$var$Build,
    Run: $afd51e1b4d76e42d$var$Run,
    // Optional
    Swipe: $afd51e1b4d76e42d$var$Swipe,
    Images: $afd51e1b4d76e42d$var$Images,
    Anchors: $afd51e1b4d76e42d$var$Anchors,
    Controls: $afd51e1b4d76e42d$var$Controls,
    Keyboard: $afd51e1b4d76e42d$var$Keyboard,
    Autoplay: $afd51e1b4d76e42d$var$Autoplay,
    Breakpoints: $afd51e1b4d76e42d$var$Breakpoints
};
var $afd51e1b4d76e42d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Core) {
    $afd51e1b4d76e42d$var$_inherits(Glide, _Core);
    var _super = $afd51e1b4d76e42d$var$_createSuper(Glide);
    function Glide() {
        $afd51e1b4d76e42d$var$_classCallCheck(this, Glide);
        return _super.apply(this, arguments);
    }
    $afd51e1b4d76e42d$var$_createClass(Glide, [
        {
            key: "mount",
            value: function mount() {
                var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                return $afd51e1b4d76e42d$var$_get($afd51e1b4d76e42d$var$_getPrototypeOf(Glide.prototype), "mount", this).call(this, Object.assign({}, $afd51e1b4d76e42d$var$COMPONENTS, extensions));
            }
        }
    ]);
    return Glide;
}($afd51e1b4d76e42d$var$Glide$1);


var $82f1bebb27f9dc4b$exports = {};
!function(e, t) {
    var n, o;
    $82f1bebb27f9dc4b$exports = t();
}(window, function() {
    return function(e) {
        var t = {};
        function n(o) {
            if (t[o]) return t[o].exports;
            var i = t[o] = {
                i: o,
                l: !1,
                exports: {}
            };
            return e[o].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
        }
        return n.m = e, n.c = t, n.d = function(e, t, o) {
            n.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: o
            });
        }, n.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, n.t = function(e, t) {
            if (1 & t && (e = n(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var o = Object.create(null);
            if (n.r(o), Object.defineProperty(o, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)n.d(o, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return o;
        }, n.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return n.d(t, "a", t), t;
        }, n.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, n.p = "", n(n.s = 0);
    }([
        function(e, t, n) {
            "use strict";
            n.r(t);
            var o, i = "fslightbox-", r = "".concat(i, "styles"), s = "".concat(i, "cursor-grabbing"), a = "".concat(i, "full-dimension"), c = "".concat(i, "flex-centered"), l = "".concat(i, "open"), u = "".concat(i, "transform-transition"), d = "".concat(i, "absoluted"), f = "".concat(i, "slide-btn"), p = "".concat(f, "-container"), h = "".concat(i, "fade-in"), m = "".concat(i, "fade-out"), g = h + "-strong", v = m + "-strong", b = "".concat(i, "opacity-"), x = "".concat(b, "1"), y = "".concat(i, "source");
            function w(e) {
                return (w = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e;
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                })(e);
            }
            function S(e) {
                var t = e.stageIndexes, n = e.core.stageManager, o = e.props.sources.length - 1;
                n.getPreviousSlideIndex = function() {
                    return 0 === t.current ? o : t.current - 1;
                }, n.getNextSlideIndex = function() {
                    return t.current === o ? 0 : t.current + 1;
                }, n.updateStageIndexes = 0 === o ? function() {} : 1 === o ? function() {
                    0 === t.current ? (t.next = 1, delete t.previous) : (t.previous = 0, delete t.next);
                } : function() {
                    t.previous = n.getPreviousSlideIndex(), t.next = n.getNextSlideIndex();
                }, n.i = o <= 2 ? function() {
                    return !0;
                } : function(e) {
                    var n = t.current;
                    if (0 === n && e === o || n === o && 0 === e) return !0;
                    var i = n - e;
                    return -1 === i || 0 === i || 1 === i;
                };
            }
            "object" === ("undefined" == typeof document ? "undefined" : w(document)) && ((o = document.createElement("style")).className = r, o.appendChild(document.createTextNode(".fslightbox-absoluted{position:absolute;top:0;left:0}.fslightbox-fade-in{animation:fslightbox-fade-in .3s cubic-bezier(0,0,.7,1)}.fslightbox-fade-out{animation:fslightbox-fade-out .3s ease}.fslightbox-fade-in-strong{animation:fslightbox-fade-in-strong .3s cubic-bezier(0,0,.7,1)}.fslightbox-fade-out-strong{animation:fslightbox-fade-out-strong .3s ease}@keyframes fslightbox-fade-in{from{opacity:.65}to{opacity:1}}@keyframes fslightbox-fade-out{from{opacity:.35}to{opacity:0}}@keyframes fslightbox-fade-in-strong{from{opacity:.3}to{opacity:1}}@keyframes fslightbox-fade-out-strong{from{opacity:1}to{opacity:0}}.fslightbox-cursor-grabbing{cursor:grabbing}.fslightbox-full-dimension{width:100%;height:100%}.fslightbox-open{overflow:hidden;height:100%}.fslightbox-flex-centered{display:flex;justify-content:center;align-items:center}.fslightbox-opacity-0{opacity:0!important}.fslightbox-opacity-1{opacity:1!important}.fslightbox-scrollbarfix{padding-right:17px}.fslightbox-transform-transition{transition:transform .3s}.fslightbox-container{font-family:Arial,sans-serif;position:fixed;top:0;left:0;background:linear-gradient(rgba(30,30,30,.9),#000 1810%);touch-action:pinch-zoom;z-index:1000000000;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent}.fslightbox-container *{box-sizing:border-box}.fslightbox-svg-path{transition:fill .15s ease;fill:#ddd}.fslightbox-nav{height:45px;width:100%;position:absolute;top:0;left:0}.fslightbox-slide-number-container{display:flex;justify-content:center;align-items:center;position:relative;height:100%;font-size:15px;color:#d7d7d7;z-index:0;max-width:55px;text-align:left}.fslightbox-slide-number-container .fslightbox-flex-centered{height:100%}.fslightbox-slash{display:block;margin:0 5px;width:1px;height:12px;transform:rotate(15deg);background:#fff}.fslightbox-toolbar{position:absolute;z-index:3;right:0;top:0;height:100%;display:flex;background:rgba(35,35,35,.65)}.fslightbox-toolbar-button{height:100%;width:45px;cursor:pointer}.fslightbox-toolbar-button:hover .fslightbox-svg-path{fill:#fff}.fslightbox-slide-btn-container{display:flex;align-items:center;padding:12px 12px 12px 6px;position:absolute;top:50%;cursor:pointer;z-index:3;transform:translateY(-50%)}@media (min-width:476px){.fslightbox-slide-btn-container{padding:22px 22px 22px 6px}}@media (min-width:768px){.fslightbox-slide-btn-container{padding:30px 30px 30px 6px}}.fslightbox-slide-btn-container:hover .fslightbox-svg-path{fill:#f1f1f1}.fslightbox-slide-btn{padding:9px;font-size:26px;background:rgba(35,35,35,.65)}@media (min-width:768px){.fslightbox-slide-btn{padding:10px}}@media (min-width:1600px){.fslightbox-slide-btn{padding:11px}}.fslightbox-slide-btn-container-previous{left:0}@media (max-width:475.99px){.fslightbox-slide-btn-container-previous{padding-left:3px}}.fslightbox-slide-btn-container-next{right:0;padding-left:12px;padding-right:3px}@media (min-width:476px){.fslightbox-slide-btn-container-next{padding-left:22px}}@media (min-width:768px){.fslightbox-slide-btn-container-next{padding-left:30px}}@media (min-width:476px){.fslightbox-slide-btn-container-next{padding-right:6px}}.fslightbox-down-event-detector{position:absolute;z-index:1}.fslightbox-slide-swiping-hoverer{z-index:4}.fslightbox-invalid-file-wrapper{font-size:22px;color:#eaebeb;margin:auto}.fslightbox-video{object-fit:cover}.fslightbox-youtube-iframe{border:0}.fslightboxl{display:block;margin:auto;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:67px;height:67px}.fslightboxl div{box-sizing:border-box;display:block;position:absolute;width:54px;height:54px;margin:6px;border:5px solid;border-color:#999 transparent transparent transparent;border-radius:50%;animation:fslightboxl 1.2s cubic-bezier(.5,0,.5,1) infinite}.fslightboxl div:nth-child(1){animation-delay:-.45s}.fslightboxl div:nth-child(2){animation-delay:-.3s}.fslightboxl div:nth-child(3){animation-delay:-.15s}@keyframes fslightboxl{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}.fslightbox-source{position:relative;z-index:2;opacity:0}")), document.head.appendChild(o));
            function L(e) {
                var t, n = e.props, o = 0, i = {};
                this.getSourceTypeFromLocalStorageByUrl = function(e) {
                    return t[e] ? t[e] : r(e);
                }, this.handleReceivedSourceTypeForUrl = function(e, n) {
                    if (!1 === i[n] && (o--, "invalid" !== e ? i[n] = e : delete i[n], 0 === o)) {
                        !function(e, t) {
                            for(var n in t)e[n] = t[n];
                        }(t, i);
                        try {
                            localStorage.setItem("fslightbox-types", JSON.stringify(t));
                        } catch (e) {}
                    }
                };
                var r = function(e) {
                    o++, i[e] = !1;
                };
                if (n.disableLocalStorage) this.getSourceTypeFromLocalStorageByUrl = function() {}, this.handleReceivedSourceTypeForUrl = function() {};
                else {
                    try {
                        t = JSON.parse(localStorage.getItem("fslightbox-types"));
                    } catch (e) {}
                    t || (t = {}, this.getSourceTypeFromLocalStorageByUrl = r);
                }
            }
            function A(e, t, n, o) {
                var i = e.data, r = e.elements.sources, s = n / o, a = 0;
                this.adjustSize = function() {
                    if ((a = i.maxSourceWidth / s) < i.maxSourceHeight) return n < i.maxSourceWidth && (a = o), c();
                    a = o > i.maxSourceHeight ? i.maxSourceHeight : o, c();
                };
                var c = function() {
                    r[t].style.width = a * s + "px", r[t].style.height = a + "px";
                };
            }
            function C(e, t) {
                var n = this, o = e.collections.sourceSizers, i = e.elements, r = i.sourceAnimationWrappers, s = i.sources, a = e.isl, c = e.resolve;
                function l(e, n) {
                    o[t] = c(A, [
                        t,
                        e,
                        n
                    ]), o[t].adjustSize();
                }
                this.runActions = function(e, o) {
                    a[t] = !0, s[t].classList.add(x), r[t].classList.add(g), r[t].removeChild(r[t].firstChild), l(e, o), n.runActions = l;
                };
            }
            function E(e, t) {
                var n, o = this, i = e.elements.sources, r = e.props, s = (0, e.resolve)(C, [
                    t
                ]);
                this.handleImageLoad = function(e) {
                    var t = e.target, n = t.naturalWidth, o = t.naturalHeight;
                    s.runActions(n, o);
                }, this.handleVideoLoad = function(e) {
                    var t = e.target, o = t.videoWidth, i = t.videoHeight;
                    n = !0, s.runActions(o, i);
                }, this.handleNotMetaDatedVideoLoad = function() {
                    n || o.handleYoutubeLoad();
                }, this.handleYoutubeLoad = function() {
                    var e = 1920, t = 1080;
                    r.maxYoutubeDimensions && (e = r.maxYoutubeDimensions.width, t = r.maxYoutubeDimensions.height), s.runActions(e, t);
                }, this.handleCustomLoad = function() {
                    var e = i[t], n = e.offsetWidth, r = e.offsetHeight;
                    n && r ? s.runActions(n, r) : setTimeout(o.handleCustomLoad);
                };
            }
            function F(e, t, n) {
                var o = e.elements.sources, i = e.props.customClasses, r = i[t] ? i[t] : "";
                o[t].className = n + " " + r;
            }
            function I(e, t) {
                var n = e.elements.sources, o = e.props.customAttributes;
                for(var i in o[t])n[t].setAttribute(i, o[t][i]);
            }
            function T(e, t) {
                var n = e.collections.sourceLoadHandlers, o = e.elements, i = o.sources, r = o.sourceAnimationWrappers, s = e.props.sources;
                i[t] = document.createElement("img"), F(e, t, y), i[t].src = s[t], i[t].onload = n[t].handleImageLoad, I(e, t), r[t].appendChild(i[t]);
            }
            function N(e, t) {
                var n = e.collections.sourceLoadHandlers, o = e.elements, i = o.sources, r = o.sourceAnimationWrappers, s = e.props, a = s.sources, c = s.videosPosters;
                i[t] = document.createElement("video"), F(e, t, y), i[t].src = a[t], i[t].onloadedmetadata = function(e) {
                    n[t].handleVideoLoad(e);
                }, i[t].controls = !0, I(e, t), c[t] && (i[t].poster = c[t]);
                var l = document.createElement("source");
                l.src = a[t], i[t].appendChild(l), setTimeout(n[t].handleNotMetaDatedVideoLoad, 3e3), r[t].appendChild(i[t]);
            }
            function z(e, t) {
                var n = e.collections.sourceLoadHandlers, o = e.elements, r = o.sources, s = o.sourceAnimationWrappers, a = e.props.sources;
                r[t] = document.createElement("iframe"), F(e, t, "".concat(y, " ").concat(i, "youtube-iframe"));
                var c = a[t], l = c.split("?")[1];
                r[t].src = "https://www.youtube.com/embed/".concat(c.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/)[2], "?").concat(l || ""), r[t].allowFullscreen = !0, I(e, t), s[t].appendChild(r[t]), n[t].handleYoutubeLoad();
            }
            function P(e, t) {
                var n = e.collections.sourceLoadHandlers, o = e.elements, i = o.sources, r = o.sourceAnimationWrappers, s = e.props.sources;
                i[t] = s[t], F(e, t, "".concat(i[t].className, " ").concat(y)), r[t].appendChild(i[t]), n[t].handleCustomLoad();
            }
            function k(e, t) {
                var n = e.elements, o = n.sources, r = n.sourceAnimationWrappers;
                e.props.sources;
                o[t] = document.createElement("div"), o[t].className = "".concat(i, "invalid-file-wrapper ").concat(c), o[t].innerHTML = "Invalid source", r[t].classList.add(g), r[t].removeChild(r[t].firstChild), r[t].appendChild(o[t]);
            }
            function H(e) {
                var t = e.collections, n = t.sourceLoadHandlers, o = t.sourcesRenderFunctions, i = e.core.sourceDisplayFacade, r = e.resolve;
                this.runActionsForSourceTypeAndIndex = function(t, s) {
                    var a;
                    switch("invalid" !== t && (n[s] = r(E, [
                        s
                    ])), t){
                        case "image":
                            a = T;
                            break;
                        case "video":
                            a = N;
                            break;
                        case "youtube":
                            a = z;
                            break;
                        case "custom":
                            a = P;
                            break;
                        default:
                            a = k;
                    }
                    o[s] = function() {
                        return a(e, s);
                    }, i.displaySourcesWhichShouldBeDisplayed();
                };
            }
            function W() {
                var e, t, n, o = {
                    isUrlYoutubeOne: function(e) {
                        var t = document.createElement("a");
                        return t.href = e, "www.youtube.com" === t.hostname || "youtu.be" === t.hostname;
                    },
                    getTypeFromResponseContentType: function(e) {
                        return e.slice(0, e.indexOf("/"));
                    }
                };
                function i() {
                    if (4 !== n.readyState) {
                        if (2 === n.readyState) {
                            var e;
                            switch(o.getTypeFromResponseContentType(n.getResponseHeader("content-type"))){
                                case "image":
                                    e = "image";
                                    break;
                                case "video":
                                    e = "video";
                                    break;
                                default:
                                    e = "invalid";
                            }
                            n.onreadystatechange = null, n.abort(), t(e);
                        }
                    } else t("invalid");
                }
                this.setUrlToCheck = function(t) {
                    e = t;
                }, this.getSourceType = function(r) {
                    if (o.isUrlYoutubeOne(e)) return r("youtube");
                    t = r, (n = new XMLHttpRequest).onreadystatechange = i, n.open("GET", e, !0), n.send();
                };
            }
            function R(e, t, n) {
                var o = e.props, i = o.types, r = o.type, s = o.sources, a = e.resolve;
                this.getTypeSetByClientForIndex = function(e) {
                    var t;
                    return i && i[e] ? t = i[e] : r && (t = r), t;
                }, this.retrieveTypeWithXhrForIndex = function(e) {
                    var o = a(W);
                    o.setUrlToCheck(s[e]), o.getSourceType(function(o) {
                        t.handleReceivedSourceTypeForUrl(o, s[e]), n.runActionsForSourceTypeAndIndex(o, e);
                    });
                };
            }
            function D(e, t) {
                var n = e.core.stageManager, o = e.elements, i = o.smw, r = o.sourceWrappersContainer, s = e.props, l = 0, f = document.createElement("div");
                function p(e) {
                    f.style.transform = "translateX(".concat(e + l, "px)"), l = 0;
                }
                function h() {
                    return (1 + s.slideDistance) * innerWidth;
                }
                f.className = "".concat(d, " ").concat(a, " ").concat(c), f.s = function() {
                    f.style.display = "flex";
                }, f.h = function() {
                    f.style.display = "none";
                }, f.a = function() {
                    f.classList.add(u);
                }, f.d = function() {
                    f.classList.remove(u);
                }, f.n = function() {
                    f.style.removeProperty("transform");
                }, f.v = function(e) {
                    return l = e, f;
                }, f.ne = function() {
                    p(-h());
                }, f.z = function() {
                    p(0);
                }, f.p = function() {
                    p(h());
                }, n.i(t) || f.h(), i[t] = f, r.appendChild(f), function(e, t) {
                    var n = e.elements, o = n.smw, i = n.sourceAnimationWrappers, r = document.createElement("div"), s = document.createElement("div");
                    s.className = "fslightboxl";
                    for(var a = 0; a < 3; a++){
                        var c = document.createElement("div");
                        s.appendChild(c);
                    }
                    r.appendChild(s), o[t].appendChild(r), i[t] = r;
                }(e, t);
            }
            function O(e, t, n, o) {
                var r = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                r.setAttributeNS(null, "width", t), r.setAttributeNS(null, "height", t), r.setAttributeNS(null, "viewBox", n);
                var s = document.createElementNS("http://www.w3.org/2000/svg", "path");
                return s.setAttributeNS(null, "class", "".concat(i, "svg-path")), s.setAttributeNS(null, "d", o), r.appendChild(s), e.appendChild(r), r;
            }
            function M(e, t) {
                var n = document.createElement("div");
                return n.className = "".concat(i, "toolbar-button ").concat(c), n.title = t, e.appendChild(n), n;
            }
            function j(e, t) {
                var n = document.createElement("div");
                n.className = "".concat(i, "toolbar"), t.appendChild(n), function(e, t) {
                    var n = e.componentsServices, o = e.data, i = e.fs, r = "M4.5 11H3v4h4v-1.5H4.5V11zM3 7h1.5V4.5H7V3H3v4zm10.5 6.5H11V15h4v-4h-1.5v2.5zM11 3v1.5h2.5V7H15V3h-4z", s = M(t);
                    s.title = "Enter fullscreen";
                    var a = O(s, "20px", "0 0 18 18", r);
                    n.ofs = function() {
                        o.ifs = !0, s.title = "Exit fullscreen", a.setAttributeNS(null, "width", "24px"), a.setAttributeNS(null, "height", "24px"), a.setAttributeNS(null, "viewBox", "0 0 950 1024"), a.firstChild.setAttributeNS(null, "d", "M682 342h128v84h-212v-212h84v128zM598 810v-212h212v84h-128v128h-84zM342 342v-128h84v212h-212v-84h128zM214 682v-84h212v212h-84v-128h-128z");
                    }, n.xfs = function() {
                        o.ifs = !1, s.title = "Enter fullscreen", a.setAttributeNS(null, "width", "20px"), a.setAttributeNS(null, "height", "20px"), a.setAttributeNS(null, "viewBox", "0 0 18 18"), a.firstChild.setAttributeNS(null, "d", r);
                    }, s.onclick = i.t;
                }(e, n), function(e, t) {
                    var n = M(t, "Close");
                    n.onclick = e.core.lightboxCloser.closeLightbox, O(n, "20px", "0 0 24 24", "M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z");
                }(e, n);
            }
            function X(e) {
                var t = e.props.sources, n = e.elements.container, o = document.createElement("div");
                o.className = "".concat(i, "nav"), n.appendChild(o), j(e, o), t.length > 1 && function(e, t) {
                    var n = e.componentsServices, o = e.props.sources, r = (e.stageIndexes, document.createElement("div"));
                    r.className = "".concat(i, "slide-number-container");
                    var s = document.createElement("div");
                    s.className = c;
                    var a = document.createElement("span");
                    n.setSlideNumber = function(e) {
                        return a.innerHTML = e;
                    };
                    var l = document.createElement("span");
                    l.className = "".concat(i, "slash");
                    var u = document.createElement("div");
                    u.innerHTML = o.length, r.appendChild(s), s.appendChild(a), s.appendChild(l), s.appendChild(u), t.appendChild(r), setTimeout(function() {
                        s.offsetWidth > 55 && (r.style.justifyContent = "flex-start");
                    });
                }(e, o);
            }
            function B(e, t, n, o) {
                var i = e.elements.container, r = n.charAt(0).toUpperCase() + n.slice(1), s = document.createElement("div");
                s.className = "".concat(p, " ").concat(p, "-").concat(n), s.title = "".concat(r, " slide"), s.onclick = t, function(e, t) {
                    var n = document.createElement("div");
                    n.className = "".concat(f, " ").concat(c), O(n, "20px", "0 0 20 20", t), e.appendChild(n);
                }(s, o), i.appendChild(s);
            }
            function U(e) {
                var t = e.core, n = t.lightboxCloser, o = t.slideChangeFacade, i = e.fs;
                this.listener = function(e) {
                    switch(e.key){
                        case "Escape":
                            n.closeLightbox();
                            break;
                        case "ArrowLeft":
                            o.changeToPrevious();
                            break;
                        case "ArrowRight":
                            o.changeToNext();
                            break;
                        case "F11":
                            e.preventDefault(), i.t();
                    }
                };
            }
            function q(e) {
                var t = e.elements, n = e.sourcePointerProps, o = e.stageIndexes;
                function i(e, o) {
                    t.smw[e].v(n.swipedX)[o]();
                }
                this.runActionsForEvent = function(e) {
                    var r, a, c;
                    t.container.contains(t.slideSwipingHoverer) || t.container.appendChild(t.slideSwipingHoverer), r = t.container, a = s, (c = r.classList).contains(a) || c.add(a), n.swipedX = e.screenX - n.downScreenX;
                    var l = o.previous, u = o.next;
                    i(o.current, "z"), void 0 !== l && n.swipedX > 0 ? i(l, "ne") : void 0 !== u && n.swipedX < 0 && i(u, "p");
                };
            }
            function V(e) {
                var t = e.props.sources, n = e.resolve, o = e.sourcePointerProps, i = n(q);
                1 === t.length ? this.listener = function() {
                    o.swipedX = 1;
                } : this.listener = function(e) {
                    o.isPointering && i.runActionsForEvent(e);
                };
            }
            function _(e) {
                var t = e.core.slideIndexChanger, n = e.elements.smw, o = e.stageIndexes, i = e.sws;
                function r(e) {
                    var t = n[o.current];
                    t.a(), t[e]();
                }
                function s(e, t) {
                    void 0 !== e && (n[e].s(), n[e][t]());
                }
                this.runPositiveSwipedXActions = function() {
                    var e = o.previous;
                    if (void 0 === e) r("z");
                    else {
                        r("p");
                        var n = o.next;
                        t.changeTo(e);
                        var a = o.previous;
                        i.d(a), i.b(n), r("z"), s(a, "ne");
                    }
                }, this.runNegativeSwipedXActions = function() {
                    var e = o.next;
                    if (void 0 === e) r("z");
                    else {
                        r("ne");
                        var n = o.previous;
                        t.changeTo(e);
                        var a = o.next;
                        i.d(a), i.b(n), r("z"), s(a, "p");
                    }
                };
            }
            function Y(e, t) {
                e.contains(t) && e.removeChild(t);
            }
            function J(e) {
                var t = e.core.lightboxCloser, n = e.elements, o = e.resolve, i = e.sourcePointerProps, r = o(_);
                this.runNoSwipeActions = function() {
                    Y(n.container, n.slideSwipingHoverer), i.isSourceDownEventTarget || t.closeLightbox(), i.isPointering = !1;
                }, this.runActions = function() {
                    i.swipedX > 0 ? r.runPositiveSwipedXActions() : r.runNegativeSwipedXActions(), Y(n.container, n.slideSwipingHoverer), n.container.classList.remove(s), i.isPointering = !1;
                };
            }
            function G(e) {
                var t = e.resolve, n = e.sourcePointerProps, o = t(J);
                this.listener = function() {
                    n.isPointering && (n.swipedX ? o.runActions() : o.runNoSwipeActions());
                };
            }
            function $(e) {
                var t = this, n = e.core, o = n.eventsDispatcher, i = n.globalEventsController, r = n.scrollbarRecompensor, s = e.data, a = e.elements, c = e.fs, u = e.props, d = e.sourcePointerProps;
                this.isLightboxFadingOut = !1, this.runActions = function() {
                    t.isLightboxFadingOut = !0, a.container.classList.add(v), i.removeListeners(), u.exitFullscreenOnClose && s.ifs && c.x(), setTimeout(function() {
                        t.isLightboxFadingOut = !1, d.isPointering = !1, a.container.classList.remove(v), document.documentElement.classList.remove(l), r.removeRecompense(), document.body.removeChild(a.container), o.dispatch("onClose");
                    }, 270);
                };
            }
            function K(e, t) {
                var n = e.classList;
                n.contains(t) && n.remove(t);
            }
            function Q(e) {
                var t, n, o;
                n = (t = e).core.eventsDispatcher, o = t.props, n.dispatch = function(e) {
                    o[e] && o[e]();
                }, function(e) {
                    var t = e.componentsServices, n = e.data, o = e.fs, i = [
                        "fullscreenchange",
                        "webkitfullscreenchange",
                        "mozfullscreenchange",
                        "MSFullscreenChange"
                    ];
                    function r(e) {
                        for(var t = 0; t < i.length; t++)document[e](i[t], s);
                    }
                    function s() {
                        document.fullscreenElement || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement ? t.ofs() : t.xfs();
                    }
                    o.o = function() {
                        t.ofs();
                        var e = document.documentElement;
                        e.requestFullscreen ? e.requestFullscreen() : e.mozRequestFullScreen ? e.mozRequestFullScreen() : e.webkitRequestFullscreen ? e.webkitRequestFullscreen() : e.msRequestFullscreen && e.msRequestFullscreen();
                    }, o.x = function() {
                        t.xfs(), document.exitFullscreen ? document.exitFullscreen() : document.mozCancelFullScreen ? document.mozCancelFullScreen() : document.webkitExitFullscreen ? document.webkitExitFullscreen() : document.msExitFullscreen && document.msExitFullscreen();
                    }, o.t = function() {
                        n.ifs ? o.x() : o.o();
                    }, o.l = function() {
                        r("addEventListener");
                    }, o.q = function() {
                        r("removeEventListener");
                    };
                }(e), function(e) {
                    var t = e.core, n = t.globalEventsController, o = t.windowResizeActioner, i = e.fs, r = e.resolve, s = r(U), a = r(V), c = r(G);
                    n.attachListeners = function() {
                        document.addEventListener("pointermove", a.listener), document.addEventListener("pointerup", c.listener), addEventListener("resize", o.runActions), document.addEventListener("keydown", s.listener), i.l();
                    }, n.removeListeners = function() {
                        document.removeEventListener("pointermove", a.listener), document.removeEventListener("pointerup", c.listener), removeEventListener("resize", o.runActions), document.removeEventListener("keydown", s.listener), i.q();
                    };
                }(e), function(e) {
                    var t = e.core.lightboxCloser, n = (0, e.resolve)($);
                    t.closeLightbox = function() {
                        n.isLightboxFadingOut || n.runActions();
                    };
                }(e), function(e) {
                    var t = e.data, n = e.core.scrollbarRecompensor;
                    function o() {
                        document.body.offsetHeight > innerHeight && (document.body.style.marginRight = t.scrollbarWidth + "px");
                    }
                    n.addRecompense = function() {
                        "complete" === document.readyState ? o() : addEventListener("load", function() {
                            o(), n.addRecompense = o;
                        });
                    }, n.removeRecompense = function() {
                        document.body.style.removeProperty("margin-right");
                    };
                }(e), function(e) {
                    var t = e.core, n = t.slideChangeFacade, o = t.slideIndexChanger, i = t.stageManager;
                    e.props.sources.length > 1 ? (n.changeToPrevious = function() {
                        o.jumpTo(i.getPreviousSlideIndex());
                    }, n.changeToNext = function() {
                        o.jumpTo(i.getNextSlideIndex());
                    }) : (n.changeToPrevious = function() {}, n.changeToNext = function() {});
                }(e), function(e) {
                    var t = e.componentsServices, n = e.core, o = n.slideIndexChanger, i = n.sourceDisplayFacade, r = n.stageManager, s = e.elements, a = s.smw, c = s.sourceAnimationWrappers, l = e.isl, u = e.stageIndexes, d = e.sws;
                    o.changeTo = function(e) {
                        u.current = e, r.updateStageIndexes(), t.setSlideNumber(e + 1), i.displaySourcesWhichShouldBeDisplayed();
                    }, o.jumpTo = function(e) {
                        var t = u.previous, n = u.current, i = u.next, s = l[n], f = l[e];
                        o.changeTo(e);
                        for(var p = 0; p < a.length; p++)a[p].d();
                        d.d(n), d.c(), requestAnimationFrame(function() {
                            requestAnimationFrame(function() {
                                var e = u.previous, o = u.next;
                                function p() {
                                    r.i(n) ? n === u.previous ? a[n].ne() : n === u.next && a[n].p() : (a[n].h(), a[n].n());
                                }
                                s && c[n].classList.add(m), f && c[u.current].classList.add(h), d.a(), void 0 !== e && e !== n && a[e].ne(), a[u.current].n(), void 0 !== o && o !== n && a[o].p(), d.b(t), d.b(i), l[n] ? setTimeout(p, 260) : p();
                            });
                        });
                    };
                }(e), function(e) {
                    var t = e.core.sourcesPointerDown, n = e.elements, o = n.smw, i = n.sources, r = e.sourcePointerProps, s = e.stageIndexes;
                    t.listener = function(e) {
                        "VIDEO" !== e.target.tagName && e.preventDefault(), r.isPointering = !0, r.downScreenX = e.screenX, r.swipedX = 0;
                        var t = i[s.current];
                        t && t.contains(e.target) ? r.isSourceDownEventTarget = !0 : r.isSourceDownEventTarget = !1;
                        for(var n = 0; n < o.length; n++)o[n].d();
                    };
                }(e), function(e) {
                    var t = e.collections.sourcesRenderFunctions, n = e.core.sourceDisplayFacade, o = e.props, i = e.stageIndexes;
                    function r(e) {
                        t[e] && (t[e](), delete t[e]);
                    }
                    n.displaySourcesWhichShouldBeDisplayed = function() {
                        if (o.loadOnlyCurrentSource) r(i.current);
                        else for(var e in i)r(i[e]);
                    };
                }(e), function(e) {
                    var t = e.core.stageManager, n = e.elements, o = n.smw, i = n.sourceAnimationWrappers, r = e.isl, s = e.stageIndexes, a = e.sws;
                    a.a = function() {
                        for(var e in s)o[s[e]].s();
                    }, a.b = function(e) {
                        void 0 === e || t.i(e) || (o[e].h(), o[e].n());
                    }, a.c = function() {
                        for(var e in s)a.d(s[e]);
                    }, a.d = function(e) {
                        if (r[e]) {
                            var t = i[e];
                            K(t, g), K(t, h), K(t, m);
                        }
                    };
                }(e), function(e) {
                    var t = e.collections.sourceSizers, n = e.core.windowResizeActioner, o = e.data, i = e.elements.smw, r = e.stageIndexes;
                    n.runActions = function() {
                        innerWidth < 992 ? o.maxSourceWidth = innerWidth : o.maxSourceWidth = .9 * innerWidth, o.maxSourceHeight = .9 * innerHeight;
                        for(var e = 0; e < i.length; e++)i[e].d(), t[e] && t[e].adjustSize();
                        var n = r.previous, s = r.next;
                        void 0 !== n && i[n].ne(), void 0 !== s && i[s].p();
                    };
                }(e);
            }
            function Z(e) {
                var t = e.componentsServices, n = e.core, o = n.eventsDispatcher, r = n.globalEventsController, s = n.scrollbarRecompensor, c = n.sourceDisplayFacade, u = n.stageManager, f = n.windowResizeActioner, p = e.data, h = e.elements, m = (e.props, e.stageIndexes), v = e.sws;
                function b() {
                    var t, n;
                    p.i = !0, p.scrollbarWidth = function() {
                        var e = document.createElement("div"), t = e.style, n = document.createElement("div");
                        t.visibility = "hidden", t.width = "100px", t.msOverflowStyle = "scrollbar", t.overflow = "scroll", n.style.width = "100%", document.body.appendChild(e);
                        var o = e.offsetWidth;
                        e.appendChild(n);
                        var i = n.offsetWidth;
                        return document.body.removeChild(e), o - i;
                    }(), Q(e), h.container = document.createElement("div"), h.container.className = "".concat(i, "container ").concat(a, " ").concat(g), function(e) {
                        var t = e.elements;
                        t.slideSwipingHoverer = document.createElement("div"), t.slideSwipingHoverer.className = "".concat(i, "slide-swiping-hoverer ").concat(a, " ").concat(d);
                    }(e), X(e), function(e) {
                        var t = e.core.sourcesPointerDown, n = e.elements, o = e.props.sources, i = document.createElement("div");
                        i.className = "".concat(d, " ").concat(a), n.container.appendChild(i), i.addEventListener("pointerdown", t.listener), n.sourceWrappersContainer = i;
                        for(var r = 0; r < o.length; r++)D(e, r);
                    }(e), e.props.sources.length > 1 && (n = (t = e).core.slideChangeFacade, B(t, n.changeToPrevious, "previous", "M18.271,9.212H3.615l4.184-4.184c0.306-0.306,0.306-0.801,0-1.107c-0.306-0.306-0.801-0.306-1.107,0L1.21,9.403C1.194,9.417,1.174,9.421,1.158,9.437c-0.181,0.181-0.242,0.425-0.209,0.66c0.005,0.038,0.012,0.071,0.022,0.109c0.028,0.098,0.075,0.188,0.142,0.271c0.021,0.026,0.021,0.061,0.045,0.085c0.015,0.016,0.034,0.02,0.05,0.033l5.484,5.483c0.306,0.307,0.801,0.307,1.107,0c0.306-0.305,0.306-0.801,0-1.105l-4.184-4.185h14.656c0.436,0,0.788-0.353,0.788-0.788S18.707,9.212,18.271,9.212z"), B(t, n.changeToNext, "next", "M1.729,9.212h14.656l-4.184-4.184c-0.307-0.306-0.307-0.801,0-1.107c0.305-0.306,0.801-0.306,1.106,0l5.481,5.482c0.018,0.014,0.037,0.019,0.053,0.034c0.181,0.181,0.242,0.425,0.209,0.66c-0.004,0.038-0.012,0.071-0.021,0.109c-0.028,0.098-0.075,0.188-0.143,0.271c-0.021,0.026-0.021,0.061-0.045,0.085c-0.015,0.016-0.034,0.02-0.051,0.033l-5.483,5.483c-0.306,0.307-0.802,0.307-1.106,0c-0.307-0.305-0.307-0.801,0-1.105l4.184-4.185H1.729c-0.436,0-0.788-0.353-0.788-0.788S1.293,9.212,1.729,9.212z")), function(e) {
                        for(var t = e.props.sources, n = e.resolve, o = n(L), i = n(H), r = n(R, [
                            o,
                            i
                        ]), s = 0; s < t.length; s++)if ("string" == typeof t[s]) {
                            var a = r.getTypeSetByClientForIndex(s);
                            if (a) i.runActionsForSourceTypeAndIndex(a, s);
                            else {
                                var c = o.getSourceTypeFromLocalStorageByUrl(t[s]);
                                c ? i.runActionsForSourceTypeAndIndex(c, s) : r.retrieveTypeWithXhrForIndex(s);
                            }
                        } else i.runActionsForSourceTypeAndIndex("custom", s);
                    }(e), o.dispatch("onInit");
                }
                e.open = function() {
                    var n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, i = m.previous, a = m.current, d = m.next;
                    m.current = n, p.i || S(e), u.updateStageIndexes(), p.i ? (v.c(), v.a(), v.b(i), v.b(a), v.b(d), o.dispatch("onShow")) : b(), c.displaySourcesWhichShouldBeDisplayed(), t.setSlideNumber(n + 1), document.body.appendChild(h.container), document.documentElement.classList.add(l), s.addRecompense(), r.attachListeners(), f.runActions(), h.smw[m.current].n(), o.dispatch("onOpen");
                };
            }
            function ee(e, t, n) {
                return (ee = te() ? Reflect.construct.bind() : function(e, t, n) {
                    var o = [
                        null
                    ];
                    o.push.apply(o, t);
                    var i = new (Function.bind.apply(e, o));
                    return n && ne(i, n.prototype), i;
                }).apply(null, arguments);
            }
            function te() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }
            function ne(e, t) {
                return (ne = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                    return e.__proto__ = t, e;
                })(e, t);
            }
            function oe(e) {
                return function(e) {
                    if (Array.isArray(e)) return ie(e);
                }(e) || function(e) {
                    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
                }(e) || function(e, t) {
                    if (!e) return;
                    if ("string" == typeof e) return ie(e, t);
                    var n = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === n && e.constructor && (n = e.constructor.name);
                    if ("Map" === n || "Set" === n) return Array.from(e);
                    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return ie(e, t);
                }(e) || function() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function ie(e, t) {
                (null == t || t > e.length) && (t = e.length);
                for(var n = 0, o = new Array(t); n < t; n++)o[n] = e[n];
                return o;
            }
            function re() {
                for(var e = document.getElementsByTagName("a"), t = function(t) {
                    if (!e[t].hasAttribute("data-fslightbox")) return "continue";
                    var n = e[t].hasAttribute("data-href") ? e[t].getAttribute("data-href") : e[t].getAttribute("href");
                    if (!n) return console.warn('The "data-fslightbox" attribute was set without the "href" attribute.'), "continue";
                    var o = e[t].getAttribute("data-fslightbox");
                    fsLightboxInstances[o] || (fsLightboxInstances[o] = new FsLightbox);
                    var i = null;
                    "#" === n.charAt(0) ? (i = document.getElementById(n.substring(1)).cloneNode(!0)).removeAttribute("id") : i = n, fsLightboxInstances[o].props.sources.push(i), fsLightboxInstances[o].elements.a.push(e[t]);
                    var r = fsLightboxInstances[o].props.sources.length - 1;
                    e[t].onclick = function(e) {
                        e.preventDefault(), fsLightboxInstances[o].open(r);
                    }, d("types", "data-type"), d("videosPosters", "data-video-poster"), d("customClasses", "data-class"), d("customClasses", "data-custom-class");
                    for(var s = [
                        "href",
                        "data-fslightbox",
                        "data-href",
                        "data-type",
                        "data-video-poster",
                        "data-class",
                        "data-custom-class"
                    ], a = e[t].attributes, c = fsLightboxInstances[o].props.customAttributes, l = 0; l < a.length; l++)if (-1 === s.indexOf(a[l].name) && "data-" === a[l].name.substr(0, 5)) {
                        c[r] || (c[r] = {});
                        var u = a[l].name.substr(5);
                        c[r][u] = a[l].value;
                    }
                    function d(n, i) {
                        e[t].hasAttribute(i) && (fsLightboxInstances[o].props[n][r] = e[t].getAttribute(i));
                    }
                }, n = 0; n < e.length; n++)t(n);
                var o = Object.keys(fsLightboxInstances);
                window.fsLightbox = fsLightboxInstances[o[o.length - 1]];
            }
            window.FsLightbox = function() {
                var e = this;
                this.props = {
                    sources: [],
                    customAttributes: [],
                    customClasses: [],
                    types: [],
                    videosPosters: [],
                    slideDistance: .3
                }, this.data = {
                    isFullscreenOpen: !1,
                    maxSourceWidth: 0,
                    maxSourceHeight: 0,
                    scrollbarWidth: 0
                }, this.isl = [], this.sourcePointerProps = {
                    downScreenX: null,
                    isPointering: !1,
                    isSourceDownEventTarget: !1,
                    swipedX: 0
                }, this.stageIndexes = {}, this.elements = {
                    a: [],
                    container: null,
                    slideSwipingHoverer: null,
                    smw: [],
                    sourceWrappersContainer: null,
                    sources: [],
                    sourceAnimationWrappers: []
                }, this.componentsServices = {
                    setSlideNumber: function() {}
                }, this.resolve = function(t) {
                    var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
                    return n.unshift(e), ee(t, oe(n));
                }, this.collections = {
                    sourceLoadHandlers: [],
                    sourcesRenderFunctions: [],
                    sourceSizers: []
                }, this.core = {
                    eventsDispatcher: {},
                    globalEventsController: {},
                    lightboxCloser: {},
                    lightboxUpdater: {},
                    scrollbarRecompensor: {},
                    slideChangeFacade: {},
                    slideIndexChanger: {},
                    sourcesPointerDown: {},
                    sourceDisplayFacade: {},
                    stageManager: {},
                    windowResizeActioner: {}
                }, this.fs = {}, this.sws = {}, Z(this), this.close = function() {
                    return e.core.lightboxCloser.closeLightbox();
                };
            }, window.fsLightboxInstances = {}, re(), window.refreshFsLightbox = function() {
                for(var e in fsLightboxInstances){
                    var t = fsLightboxInstances[e].props;
                    fsLightboxInstances[e] = new FsLightbox, fsLightboxInstances[e].props = t, fsLightboxInstances[e].props.sources = [], fsLightboxInstances[e].elements.a = [];
                }
                re();
            };
        }
    ]);
});


const $401ce02445c9337c$var$slider = ()=>{
    if (document.querySelector(".js-banner-slider")) {
        const bannerSlider = new (0, $afd51e1b4d76e42d$export$2e2bcd8739ae039)(".js-banner-slider", {
            type: "carousel",
            perView: 1,
            gap: 0,
            animationDuration: 500,
            autoplay: 5000,
            hoverpause: false,
            breakpoints: {
                1023: {
                    autoplay: false
                }
            }
        });
        let step = 0;
        bannerSlider.on("run", (arg)=>{
            if (arg.direction === "<") {
                if (step <= 0) step = window.sliderData.total_banner_slides - 1;
                else step -= 1;
            } else if (arg.direction === ">") {
                if (step >= window.sliderData.total_banner_slides - 1) step = 0;
                else step += 1;
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))("[data-banner-slide]").fadeOut(250, ()=>{
                setTimeout(()=>{
                    (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))(`[data-banner-slide="${step}"]`).fadeIn(250);
                }, 250);
            });
        });
        bannerSlider.mount();
    }
    if (document.querySelector(".js-job-slider")) {
        const jobSlider = new (0, $afd51e1b4d76e42d$export$2e2bcd8739ae039)(".js-job-slider", {
            type: "carousel",
            perView: 1,
            gap: 0,
            animationDuration: 500,
            autoplay: 5000,
            hoverpause: false,
            breakpoints: {
                1023: {
                    autoplay: false
                }
            }
        });
        jobSlider.mount();
        const resizeEvent = window.document.createEvent("UIEvents");
        resizeEvent.initUIEvent("resize", true, false, window, 0);
        window.dispatchEvent(resizeEvent);
    }
    if (document.querySelector(".js-estate-mobile-slider")) {
        const estateSlider = new (0, $afd51e1b4d76e42d$export$2e2bcd8739ae039)(".js-estate-mobile-slider", {
            type: "carousel",
            perView: 1,
            gap: 0,
            animationDuration: 500
        });
        estateSlider.mount();
    }
    if (document.querySelector(".js-step-slider")) {
        const stepSlider = new (0, $afd51e1b4d76e42d$export$2e2bcd8739ae039)(".js-step-slider", {
            type: "carousel",
            perView: 2,
            gap: 80,
            animationDuration: 500,
            autoplay: false,
            peek: {
                before: 0,
                after: 200
            },
            breakpoints: {
                1023: {
                    perView: 1,
                    gap: 35,
                    peek: {
                        before: 0,
                        after: 50
                    }
                }
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))('[data-slider-prev="step"]').on("click", ()=>{
            stepSlider.go("<");
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))('[data-slider-next="step"]').on("click", ()=>{
            stepSlider.go(">");
        });
        stepSlider.mount();
        const resizeEvent = window.document.createEvent("UIEvents");
        resizeEvent.initUIEvent("resize", true, false, window, 0);
        window.dispatchEvent(resizeEvent);
    }
    if (document.querySelector(".js-estate-slider")) {
        const totalSlides = (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))(".js-estate-slider").find("[data-glide-count]").attr("data-glide-count");
        let perView = 1;
        if (totalSlides > 1) perView = 2;
        const estateSlider = new (0, $afd51e1b4d76e42d$export$2e2bcd8739ae039)(".js-estate-slider", {
            type: "carousel",
            perView: perView,
            gap: 10,
            animationDuration: 500,
            autoplay: false,
            breakpoints: {
                1023: {
                    perView: 1
                }
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))("[data-slider-prev]").on("click", ()=>{
            estateSlider.go("<");
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))("[data-slider-next]").on("click", ()=>{
            estateSlider.go(">");
        });
        estateSlider.mount();
        const resizeEvent = window.document.createEvent("UIEvents");
        resizeEvent.initUIEvent("resize", true, false, window, 0);
        window.dispatchEvent(resizeEvent);
    }
};
var $401ce02445c9337c$export$2e2bcd8739ae039 = $401ce02445c9337c$var$slider;



var $16hem = parcelRequire("16hem");

var $jAv3h = parcelRequire("jAv3h");
var $2d3f87e6748db6a4$exports = {};
"use strict";
Object.defineProperty($2d3f87e6748db6a4$exports, "__esModule", {
    value: true
});
$2d3f87e6748db6a4$exports.StreetViewPanorama = $2d3f87e6748db6a4$exports.MountableMixin = $2d3f87e6748db6a4$exports.Autocomplete = $2d3f87e6748db6a4$exports.MapElementFactory = $2d3f87e6748db6a4$exports.MapElementMixin = $2d3f87e6748db6a4$exports.PlaceInput = $2d3f87e6748db6a4$exports.Map = $2d3f87e6748db6a4$exports.InfoWindow = $2d3f87e6748db6a4$exports.Rectangle = $2d3f87e6748db6a4$exports.Cluster = $2d3f87e6748db6a4$exports.Circle = $2d3f87e6748db6a4$exports.Polygon = $2d3f87e6748db6a4$exports.Polyline = $2d3f87e6748db6a4$exports.Marker = $2d3f87e6748db6a4$exports.loadGmapApi = undefined;
var $2d3f87e6748db6a4$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
// Vue component imports
$2d3f87e6748db6a4$exports.install = $2d3f87e6748db6a4$var$install;
$2d3f87e6748db6a4$exports.gmapApi = $2d3f87e6748db6a4$var$gmapApi;
var $5c0a1f8f805e9117$exports = {};
"use strict";
Object.defineProperty($5c0a1f8f805e9117$exports, "__esModule", {
    value: true
});
// This piece of code was orignally written by sindresorhus and can be seen here
// https://github.com/sindresorhus/lazy-value/blob/master/index.js
$5c0a1f8f805e9117$exports.default = function(fn) {
    var called = false;
    var ret = void 0;
    return function() {
        if (!called) {
            called = true;
            ret = fn();
        }
        return ret;
    };
};


var $2d3f87e6748db6a4$var$_lazyValue2 = $2d3f87e6748db6a4$var$_interopRequireDefault($5c0a1f8f805e9117$exports);
var $7b5b32f9f855f555$exports = {};
"use strict";
Object.defineProperty($7b5b32f9f855f555$exports, "__esModule", {
    value: true
});
var $7b5b32f9f855f555$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $7b5b32f9f855f555$var$isApiSetUp = false;
/**
 * @param apiKey    API Key, or object with the URL parameters. For example
 *                  to use Google Maps Premium API, pass
 *                    `{ client: <YOUR-CLIENT-ID> }`.
 *                  You may pass the libraries and/or version (as `v`) parameter into
 *                  this parameter and skip the next two parameters
 * @param version   Google Maps version
 * @param libraries Libraries to load (@see
 *                  https://developers.google.com/maps/documentation/javascript/libraries)
 * @param loadCn    Boolean. If set to true, the map will be loaded from google maps China
 *                  (@see https://developers.google.com/maps/documentation/javascript/basics#GoogleMapsChina)
 *
 * Example:
 * ```
 *      import {load} from 'vue-google-maps'
 *
 *      load(<YOUR-API-KEY>)
 *
 *      load({
 *              key: <YOUR-API-KEY>,
 *      })
 *
 *      load({
 *              client: <YOUR-CLIENT-ID>,
 *              channel: <YOUR CHANNEL>
 *      })
 * ```
 */ var $7b5b32f9f855f555$var$loadGmapApi = $7b5b32f9f855f555$exports.loadGmapApi = function(options, loadCn) {
    if (typeof document === "undefined") // Do nothing if run from server-side
    return;
    if (!$7b5b32f9f855f555$var$isApiSetUp) {
        $7b5b32f9f855f555$var$isApiSetUp = true;
        var googleMapScript = document.createElement("SCRIPT");
        // Allow options to be an object.
        // This is to support more esoteric means of loading Google Maps,
        // such as Google for business
        // https://developers.google.com/maps/documentation/javascript/get-api-key#premium-auth
        if ((typeof options === "undefined" ? "undefined" : $7b5b32f9f855f555$var$_typeof(options)) !== "object") throw new Error("options should  be an object");
        // libraries
        if (Array.prototype.isPrototypeOf(options.libraries)) options.libraries = options.libraries.join(",");
        options["callback"] = "vueGoogleMapsInit";
        var baseUrl = "https://maps.googleapis.com/";
        if (typeof loadCn === "boolean" && loadCn === true) baseUrl = "https://maps.google.cn/";
        var url = baseUrl + "maps/api/js?" + Object.keys(options).map(function(key) {
            return encodeURIComponent(key) + "=" + encodeURIComponent(options[key]);
        }).join("&");
        googleMapScript.setAttribute("src", url);
        googleMapScript.setAttribute("async", "");
        googleMapScript.setAttribute("defer", "");
        document.head.appendChild(googleMapScript);
    } else throw new Error("You already started the loading of google maps");
};


var $7d169b24ab9db908$exports = {};
"use strict";
Object.defineProperty($7d169b24ab9db908$exports, "__esModule", {
    value: true
});

var $3P0WM = parcelRequire("3P0WM");
var $7d169b24ab9db908$var$_mapElementFactory2 = $7d169b24ab9db908$var$_interopRequireDefault($3P0WM);
function $7d169b24ab9db908$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7d169b24ab9db908$var$props = {
    animation: {
        twoWay: true,
        type: Number
    },
    attribution: {
        type: Object
    },
    clickable: {
        type: Boolean,
        twoWay: true,
        default: true
    },
    cursor: {
        type: String,
        twoWay: true
    },
    draggable: {
        type: Boolean,
        twoWay: true,
        default: false
    },
    icon: {
        twoWay: true
    },
    label: {},
    opacity: {
        type: Number,
        default: 1
    },
    options: {
        type: Object
    },
    place: {
        type: Object
    },
    position: {
        type: Object,
        twoWay: true
    },
    shape: {
        type: Object,
        twoWay: true
    },
    title: {
        type: String,
        twoWay: true
    },
    zIndex: {
        type: Number,
        twoWay: true
    },
    visible: {
        twoWay: true,
        default: true
    }
};
var $7d169b24ab9db908$var$events = [
    "click",
    "rightclick",
    "dblclick",
    "drag",
    "dragstart",
    "dragend",
    "mouseup",
    "mousedown",
    "mouseover",
    "mouseout"
];
/**
 * @class Marker
 *
 * Marker class with extra support for
 *
 * - Embedded info windows
 * - Clustered markers
 *
 * Support for clustered markers is for backward-compatability
 * reasons. Otherwise we should use a cluster-marker mixin or
 * subclass.
 */ $7d169b24ab9db908$exports.default = (0, $7d169b24ab9db908$var$_mapElementFactory2.default)({
    mappedProps: $7d169b24ab9db908$var$props,
    events: $7d169b24ab9db908$var$events,
    name: "marker",
    ctr: function ctr() {
        return google.maps.Marker;
    },
    inject: {
        "$clusterPromise": {
            default: null
        }
    },
    render: function render(h) {
        if (!this.$slots.default || this.$slots.default.length === 0) return "";
        else if (this.$slots.default.length === 1) // So that infowindows can have a marker parent
        return this.$slots.default[0];
        else return h("div", this.$slots.default);
    },
    destroyed: function destroyed() {
        if (!this.$markerObject) return;
        if (this.$clusterObject) // Repaint will be performed in `updated()` of cluster
        this.$clusterObject.removeMarker(this.$markerObject, true);
        else this.$markerObject.setMap(null);
    },
    beforeCreate: function beforeCreate(options) {
        if (this.$clusterPromise) options.map = null;
        return this.$clusterPromise;
    },
    afterCreate: function afterCreate(inst) {
        var _this = this;
        if (this.$clusterPromise) this.$clusterPromise.then(function(co) {
            co.addMarker(inst);
            _this.$clusterObject = co;
        });
    }
});


var $2d3f87e6748db6a4$var$_marker2 = $2d3f87e6748db6a4$var$_interopRequireDefault($7d169b24ab9db908$exports);
var $e1db25eb34c3abb4$exports = {};
"use strict";
Object.defineProperty($e1db25eb34c3abb4$exports, "__esModule", {
    value: true
});
var $e1db25eb34c3abb4$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();

var $3P0WM = parcelRequire("3P0WM");
var $e1db25eb34c3abb4$var$_mapElementFactory2 = $e1db25eb34c3abb4$var$_interopRequireDefault($3P0WM);
function $e1db25eb34c3abb4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e1db25eb34c3abb4$var$props = {
    draggable: {
        type: Boolean
    },
    editable: {
        type: Boolean
    },
    options: {
        twoWay: false,
        type: Object
    },
    path: {
        type: Array,
        twoWay: true
    }
};
var $e1db25eb34c3abb4$var$events = [
    "click",
    "dblclick",
    "drag",
    "dragend",
    "dragstart",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "rightclick"
];
$e1db25eb34c3abb4$exports.default = (0, $e1db25eb34c3abb4$var$_mapElementFactory2.default)({
    mappedProps: $e1db25eb34c3abb4$var$props,
    props: {
        deepWatch: {
            type: Boolean,
            default: false
        }
    },
    events: $e1db25eb34c3abb4$var$events,
    name: "polyline",
    ctr: function ctr() {
        return google.maps.Polyline;
    },
    afterCreate: function afterCreate() {
        var _this = this;
        var clearEvents = function() {};
        this.$watch("path", function(path) {
            if (path) {
                clearEvents();
                _this.$polylineObject.setPath(path);
                var mvcPath = _this.$polylineObject.getPath();
                var eventListeners = [];
                var updatePaths = function() {
                    _this.$emit("path_changed", _this.$polylineObject.getPath());
                };
                eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("insert_at", updatePaths)
                ]);
                eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("remove_at", updatePaths)
                ]);
                eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("set_at", updatePaths)
                ]);
                clearEvents = function() {
                    eventListeners.map(function(_ref) {
                        var _ref2 = $e1db25eb34c3abb4$var$_slicedToArray(_ref, 2), obj = _ref2[0], listenerHandle = _ref2[1];
                        return google.maps.event.removeListener(listenerHandle);
                    });
                };
            }
        }, {
            deep: this.deepWatch,
            immediate: true
        });
    }
});


var $2d3f87e6748db6a4$var$_polyline2 = $2d3f87e6748db6a4$var$_interopRequireDefault($e1db25eb34c3abb4$exports);
var $1219e4efe811a241$exports = {};
"use strict";
Object.defineProperty($1219e4efe811a241$exports, "__esModule", {
    value: true
});
var $1219e4efe811a241$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();

var $3P0WM = parcelRequire("3P0WM");
var $1219e4efe811a241$var$_mapElementFactory2 = $1219e4efe811a241$var$_interopRequireDefault($3P0WM);
function $1219e4efe811a241$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1219e4efe811a241$var$props = {
    draggable: {
        type: Boolean
    },
    editable: {
        type: Boolean
    },
    options: {
        type: Object
    },
    path: {
        type: Array,
        twoWay: true,
        noBind: true
    },
    paths: {
        type: Array,
        twoWay: true,
        noBind: true
    }
};
var $1219e4efe811a241$var$events = [
    "click",
    "dblclick",
    "drag",
    "dragend",
    "dragstart",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "rightclick"
];
$1219e4efe811a241$exports.default = (0, $1219e4efe811a241$var$_mapElementFactory2.default)({
    props: {
        deepWatch: {
            type: Boolean,
            default: false
        }
    },
    events: $1219e4efe811a241$var$events,
    mappedProps: $1219e4efe811a241$var$props,
    name: "polygon",
    ctr: function ctr() {
        return google.maps.Polygon;
    },
    beforeCreate: function beforeCreate(options) {
        if (!options.path) delete options.path;
        if (!options.paths) delete options.paths;
    },
    afterCreate: function afterCreate(inst) {
        var _this = this;
        var clearEvents = function() {};
        // Watch paths, on our own, because we do not want to set either when it is
        // empty
        this.$watch("paths", function(paths) {
            if (paths) {
                clearEvents();
                inst.setPaths(paths);
                var updatePaths = function() {
                    _this.$emit("paths_changed", inst.getPaths());
                };
                var eventListeners = [];
                var mvcArray = inst.getPaths();
                for(var i = 0; i < mvcArray.getLength(); i++){
                    var mvcPath = mvcArray.getAt(i);
                    eventListeners.push([
                        mvcPath,
                        mvcPath.addListener("insert_at", updatePaths)
                    ]);
                    eventListeners.push([
                        mvcPath,
                        mvcPath.addListener("remove_at", updatePaths)
                    ]);
                    eventListeners.push([
                        mvcPath,
                        mvcPath.addListener("set_at", updatePaths)
                    ]);
                }
                eventListeners.push([
                    mvcArray,
                    mvcArray.addListener("insert_at", updatePaths)
                ]);
                eventListeners.push([
                    mvcArray,
                    mvcArray.addListener("remove_at", updatePaths)
                ]);
                eventListeners.push([
                    mvcArray,
                    mvcArray.addListener("set_at", updatePaths)
                ]);
                clearEvents = function() {
                    eventListeners.map(function(_ref) {
                        var _ref2 = $1219e4efe811a241$var$_slicedToArray(_ref, 2), obj = _ref2[0], listenerHandle = _ref2[1];
                        return google.maps.event.removeListener(listenerHandle);
                    });
                };
            }
        }, {
            deep: this.deepWatch,
            immediate: true
        });
        this.$watch("path", function(path) {
            if (path) {
                clearEvents();
                inst.setPaths(path);
                var mvcPath = inst.getPath();
                var eventListeners = [];
                var updatePaths = function() {
                    _this.$emit("path_changed", inst.getPath());
                };
                eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("insert_at", updatePaths)
                ]);
                eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("remove_at", updatePaths)
                ]);
                eventListeners.push([
                    mvcPath,
                    mvcPath.addListener("set_at", updatePaths)
                ]);
                clearEvents = function() {
                    eventListeners.map(function(_ref3) {
                        var _ref4 = $1219e4efe811a241$var$_slicedToArray(_ref3, 2), obj = _ref4[0], listenerHandle = _ref4[1];
                        return google.maps.event.removeListener(listenerHandle);
                    });
                };
            }
        }, {
            deep: this.deepWatch,
            immediate: true
        });
    }
});


var $2d3f87e6748db6a4$var$_polygon2 = $2d3f87e6748db6a4$var$_interopRequireDefault($1219e4efe811a241$exports);
var $ea8ef714fa6dee2d$exports = {};
"use strict";
Object.defineProperty($ea8ef714fa6dee2d$exports, "__esModule", {
    value: true
});

var $3P0WM = parcelRequire("3P0WM");
var $ea8ef714fa6dee2d$var$_mapElementFactory2 = $ea8ef714fa6dee2d$var$_interopRequireDefault($3P0WM);
function $ea8ef714fa6dee2d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ea8ef714fa6dee2d$var$props = {
    center: {
        type: Object,
        twoWay: true,
        required: true
    },
    radius: {
        type: Number,
        twoWay: true
    },
    draggable: {
        type: Boolean,
        default: false
    },
    editable: {
        type: Boolean,
        default: false
    },
    options: {
        type: Object,
        twoWay: false
    }
};
var $ea8ef714fa6dee2d$var$events = [
    "click",
    "dblclick",
    "drag",
    "dragend",
    "dragstart",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "rightclick"
];
$ea8ef714fa6dee2d$exports.default = (0, $ea8ef714fa6dee2d$var$_mapElementFactory2.default)({
    mappedProps: $ea8ef714fa6dee2d$var$props,
    name: "circle",
    ctr: function ctr() {
        return google.maps.Circle;
    },
    events: $ea8ef714fa6dee2d$var$events
});


var $2d3f87e6748db6a4$var$_circle2 = $2d3f87e6748db6a4$var$_interopRequireDefault($ea8ef714fa6dee2d$exports);
var $9b4947302c5ffa60$exports = {};
"use strict";
Object.defineProperty($9b4947302c5ffa60$exports, "__esModule", {
    value: true
});

var $3P0WM = parcelRequire("3P0WM");
var $9b4947302c5ffa60$var$_mapElementFactory2 = $9b4947302c5ffa60$var$_interopRequireDefault($3P0WM);
function $9b4947302c5ffa60$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9b4947302c5ffa60$var$props = {
    bounds: {
        type: Object,
        twoWay: true
    },
    draggable: {
        type: Boolean,
        default: false
    },
    editable: {
        type: Boolean,
        default: false
    },
    options: {
        type: Object,
        twoWay: false
    }
};
var $9b4947302c5ffa60$var$events = [
    "click",
    "dblclick",
    "drag",
    "dragend",
    "dragstart",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "rightclick"
];
$9b4947302c5ffa60$exports.default = (0, $9b4947302c5ffa60$var$_mapElementFactory2.default)({
    mappedProps: $9b4947302c5ffa60$var$props,
    name: "rectangle",
    ctr: function ctr() {
        return google.maps.Rectangle;
    },
    events: $9b4947302c5ffa60$var$events
});


var $2d3f87e6748db6a4$var$_rectangle2 = $2d3f87e6748db6a4$var$_interopRequireDefault($9b4947302c5ffa60$exports);
var $58a2d480a492d077$exports = {};

$parcel$defineInteropFlag($58a2d480a492d077$exports);

$parcel$export($58a2d480a492d077$exports, "default", function () { return $58a2d480a492d077$export$2e2bcd8739ae039; });
let $58a2d480a492d077$var$script;




let $58a2d480a492d077$var$initialize = ()=>{
    $58a2d480a492d077$var$script = (parcelRequire("kI4kR"));
    if ($58a2d480a492d077$var$script.__esModule) $58a2d480a492d077$var$script = $58a2d480a492d077$var$script.default;
    $58a2d480a492d077$var$script.render = (parcelRequire("jSVgF")).render;
    $58a2d480a492d077$var$script.staticRenderFns = (parcelRequire("jSVgF")).staticRenderFns;
    $58a2d480a492d077$var$script._scopeId = "data-v-2a38f9";
    (parcelRequire("ivs1J")).default($58a2d480a492d077$var$script);
    $58a2d480a492d077$var$script.__scopeId = "data-v-2a38f9";
    $58a2d480a492d077$var$script.__file = "infoWindow.vue";
};
$58a2d480a492d077$var$initialize();
var $58a2d480a492d077$export$2e2bcd8739ae039 = $58a2d480a492d077$var$script;


var $2d3f87e6748db6a4$var$_infoWindow2 = $2d3f87e6748db6a4$var$_interopRequireDefault($58a2d480a492d077$exports);
var $1057a83531065fc5$exports = {};

$parcel$defineInteropFlag($1057a83531065fc5$exports);

$parcel$export($1057a83531065fc5$exports, "default", function () { return $1057a83531065fc5$export$2e2bcd8739ae039; });
let $1057a83531065fc5$var$script;





let $1057a83531065fc5$var$initialize = ()=>{
    $1057a83531065fc5$var$script = (parcelRequire("f4FUa"));
    if ($1057a83531065fc5$var$script.__esModule) $1057a83531065fc5$var$script = $1057a83531065fc5$var$script.default;
    $1057a83531065fc5$var$script.render = (parcelRequire("eT7TD")).render;
    $1057a83531065fc5$var$script.staticRenderFns = (parcelRequire("eT7TD")).staticRenderFns;
    $1057a83531065fc5$var$script._scopeId = "data-v-bd0d12";
    $1057a83531065fc5$var$script.__cssModules = {};
    (parcelRequire("crHYS")).default($1057a83531065fc5$var$script);
    $1057a83531065fc5$var$script.__scopeId = "data-v-bd0d12";
    $1057a83531065fc5$var$script.__file = "map.vue";
};
$1057a83531065fc5$var$initialize();
var $1057a83531065fc5$export$2e2bcd8739ae039 = $1057a83531065fc5$var$script;


var $2d3f87e6748db6a4$var$_map2 = $2d3f87e6748db6a4$var$_interopRequireDefault($1057a83531065fc5$exports);
var $04c22b185e0e7a9e$exports = {};

$parcel$defineInteropFlag($04c22b185e0e7a9e$exports);

$parcel$export($04c22b185e0e7a9e$exports, "default", function () { return $04c22b185e0e7a9e$export$2e2bcd8739ae039; });
let $04c22b185e0e7a9e$var$script;





let $04c22b185e0e7a9e$var$initialize = ()=>{
    $04c22b185e0e7a9e$var$script = (parcelRequire("kT3cN"));
    if ($04c22b185e0e7a9e$var$script.__esModule) $04c22b185e0e7a9e$var$script = $04c22b185e0e7a9e$var$script.default;
    $04c22b185e0e7a9e$var$script.render = (parcelRequire("g4sLo")).render;
    $04c22b185e0e7a9e$var$script.staticRenderFns = (parcelRequire("g4sLo")).staticRenderFns;
    $04c22b185e0e7a9e$var$script._scopeId = "data-v-fc6c02";
    $04c22b185e0e7a9e$var$script.__cssModules = {};
    (parcelRequire("gJBUS")).default($04c22b185e0e7a9e$var$script);
    $04c22b185e0e7a9e$var$script.__scopeId = "data-v-fc6c02";
    $04c22b185e0e7a9e$var$script.__file = "streetViewPanorama.vue";
};
$04c22b185e0e7a9e$var$initialize();
var $04c22b185e0e7a9e$export$2e2bcd8739ae039 = $04c22b185e0e7a9e$var$script;


var $2d3f87e6748db6a4$var$_streetViewPanorama2 = $2d3f87e6748db6a4$var$_interopRequireDefault($04c22b185e0e7a9e$exports);
var $ebd6f29e1fcc1d9f$exports = {};

$parcel$defineInteropFlag($ebd6f29e1fcc1d9f$exports);

$parcel$export($ebd6f29e1fcc1d9f$exports, "default", function () { return $ebd6f29e1fcc1d9f$export$2e2bcd8739ae039; });
let $ebd6f29e1fcc1d9f$var$script;




let $ebd6f29e1fcc1d9f$var$initialize = ()=>{
    $ebd6f29e1fcc1d9f$var$script = (parcelRequire("9UsEM"));
    if ($ebd6f29e1fcc1d9f$var$script.__esModule) $ebd6f29e1fcc1d9f$var$script = $ebd6f29e1fcc1d9f$var$script.default;
    $ebd6f29e1fcc1d9f$var$script.render = (parcelRequire("knm8z")).render;
    $ebd6f29e1fcc1d9f$var$script.staticRenderFns = (parcelRequire("knm8z")).staticRenderFns;
    $ebd6f29e1fcc1d9f$var$script._scopeId = "data-v-1c2196";
    (parcelRequire("hiWaH")).default($ebd6f29e1fcc1d9f$var$script);
    $ebd6f29e1fcc1d9f$var$script.__scopeId = "data-v-1c2196";
    $ebd6f29e1fcc1d9f$var$script.__file = "placeInput.vue";
};
$ebd6f29e1fcc1d9f$var$initialize();
var $ebd6f29e1fcc1d9f$export$2e2bcd8739ae039 = $ebd6f29e1fcc1d9f$var$script;


var $2d3f87e6748db6a4$var$_placeInput2 = $2d3f87e6748db6a4$var$_interopRequireDefault($ebd6f29e1fcc1d9f$exports);
var $7dfe913372c771e9$exports = {};

$parcel$defineInteropFlag($7dfe913372c771e9$exports);

$parcel$export($7dfe913372c771e9$exports, "default", function () { return $7dfe913372c771e9$export$2e2bcd8739ae039; });
let $7dfe913372c771e9$var$script;




let $7dfe913372c771e9$var$initialize = ()=>{
    $7dfe913372c771e9$var$script = (parcelRequire("1QxqX"));
    if ($7dfe913372c771e9$var$script.__esModule) $7dfe913372c771e9$var$script = $7dfe913372c771e9$var$script.default;
    $7dfe913372c771e9$var$script.render = (parcelRequire("cd2Go")).render;
    $7dfe913372c771e9$var$script.staticRenderFns = (parcelRequire("cd2Go")).staticRenderFns;
    $7dfe913372c771e9$var$script._scopeId = "data-v-f8a20c";
    (parcelRequire("f4fmr")).default($7dfe913372c771e9$var$script);
    $7dfe913372c771e9$var$script.__scopeId = "data-v-f8a20c";
    $7dfe913372c771e9$var$script.__file = "autocomplete.vue";
};
$7dfe913372c771e9$var$initialize();
var $7dfe913372c771e9$export$2e2bcd8739ae039 = $7dfe913372c771e9$var$script;


var $2d3f87e6748db6a4$var$_autocomplete2 = $2d3f87e6748db6a4$var$_interopRequireDefault($7dfe913372c771e9$exports);

var $6H6Oq = parcelRequire("6H6Oq");
var $2d3f87e6748db6a4$var$_mapElementMixin2 = $2d3f87e6748db6a4$var$_interopRequireDefault($6H6Oq);

var $3P0WM = parcelRequire("3P0WM");
var $2d3f87e6748db6a4$var$_mapElementFactory2 = $2d3f87e6748db6a4$var$_interopRequireDefault($3P0WM);

var $7ICIr = parcelRequire("7ICIr");
var $2d3f87e6748db6a4$var$_mountableMixin2 = $2d3f87e6748db6a4$var$_interopRequireDefault($7ICIr);
function $2d3f87e6748db6a4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// HACK: Cluster should be loaded conditionally
// However in the web version, it's not possible to write
// `import 'vue2-google-maps/src/components/cluster'`, so we need to
// import it anyway (but we don't have to register it)
// Therefore we use babel-plugin-transform-inline-environment-variables to
// set BUILD_DEV to truthy / falsy
var $2d3f87e6748db6a4$var$Cluster = undefined;
var $2d3f87e6748db6a4$var$GmapApi = null;
// export everything
$2d3f87e6748db6a4$exports.loadGmapApi = $7b5b32f9f855f555$exports.loadGmapApi;
$2d3f87e6748db6a4$exports.Marker = $2d3f87e6748db6a4$var$_marker2.default;
$2d3f87e6748db6a4$exports.Polyline = $2d3f87e6748db6a4$var$_polyline2.default;
$2d3f87e6748db6a4$exports.Polygon = $2d3f87e6748db6a4$var$_polygon2.default;
$2d3f87e6748db6a4$exports.Circle = $2d3f87e6748db6a4$var$_circle2.default;
$2d3f87e6748db6a4$exports.Cluster = $2d3f87e6748db6a4$var$Cluster;
$2d3f87e6748db6a4$exports.Rectangle = $2d3f87e6748db6a4$var$_rectangle2.default;
$2d3f87e6748db6a4$exports.InfoWindow = $2d3f87e6748db6a4$var$_infoWindow2.default;
$2d3f87e6748db6a4$exports.Map = $2d3f87e6748db6a4$var$_map2.default;
$2d3f87e6748db6a4$exports.PlaceInput = $2d3f87e6748db6a4$var$_placeInput2.default;
$2d3f87e6748db6a4$exports.MapElementMixin = $2d3f87e6748db6a4$var$_mapElementMixin2.default;
$2d3f87e6748db6a4$exports.MapElementFactory = $2d3f87e6748db6a4$var$_mapElementFactory2.default;
$2d3f87e6748db6a4$exports.Autocomplete = $2d3f87e6748db6a4$var$_autocomplete2.default;
$2d3f87e6748db6a4$exports.MountableMixin = $2d3f87e6748db6a4$var$_mountableMixin2.default;
$2d3f87e6748db6a4$exports.StreetViewPanorama = $2d3f87e6748db6a4$var$_streetViewPanorama2.default;
function $2d3f87e6748db6a4$var$install(Vue, options) {
    // Set defaults
    options = $2d3f87e6748db6a4$var$_extends({
        installComponents: true,
        autobindAllEvents: false
    }, options);
    // Update the global `GmapApi`. This will allow
    // components to use the `google` global reactively
    // via:
    //   import {gmapApi} from 'vue2-google-maps'
    //   export default {  computed: { google: gmapApi }  }
    $2d3f87e6748db6a4$var$GmapApi = new Vue({
        data: {
            gmapApi: null
        }
    });
    var defaultResizeBus = new Vue();
    // Use a lazy to only load the API when
    // a VGM component is loaded
    var gmapApiPromiseLazy = $2d3f87e6748db6a4$var$makeGmapApiPromiseLazy(options);
    Vue.mixin({
        created: function created() {
            this.$gmapDefaultResizeBus = defaultResizeBus;
            this.$gmapOptions = options;
            this.$gmapApiPromiseLazy = gmapApiPromiseLazy;
        }
    });
    Vue.$gmapDefaultResizeBus = defaultResizeBus;
    Vue.$gmapApiPromiseLazy = gmapApiPromiseLazy;
    if (options.installComponents) {
        Vue.component("GmapMap", $2d3f87e6748db6a4$var$_map2.default);
        Vue.component("GmapMarker", $2d3f87e6748db6a4$var$_marker2.default);
        Vue.component("GmapInfoWindow", $2d3f87e6748db6a4$var$_infoWindow2.default);
        Vue.component("GmapPolyline", $2d3f87e6748db6a4$var$_polyline2.default);
        Vue.component("GmapPolygon", $2d3f87e6748db6a4$var$_polygon2.default);
        Vue.component("GmapCircle", $2d3f87e6748db6a4$var$_circle2.default);
        Vue.component("GmapRectangle", $2d3f87e6748db6a4$var$_rectangle2.default);
        Vue.component("GmapAutocomplete", $2d3f87e6748db6a4$var$_autocomplete2.default);
        Vue.component("GmapPlaceInput", $2d3f87e6748db6a4$var$_placeInput2.default);
        Vue.component("GmapStreetViewPanorama", $2d3f87e6748db6a4$var$_streetViewPanorama2.default);
    }
}
function $2d3f87e6748db6a4$var$makeGmapApiPromiseLazy(options) {
    // Things to do once the API is loaded
    function onApiLoaded() {
        $2d3f87e6748db6a4$var$GmapApi.gmapApi = {};
        return window.google;
    }
    if (options.load) // If library should load the API
    return (0, $2d3f87e6748db6a4$var$_lazyValue2.default)(function() {
        // Load the
        // This will only be evaluated once
        if (typeof window === "undefined") // server side -- never resolve this promise
        return new Promise(function() {}).then(onApiLoaded);
        else return new Promise(function(resolve, reject) {
            try {
                window["vueGoogleMapsInit"] = resolve;
                (0, $7b5b32f9f855f555$exports.loadGmapApi)(options.load, options.loadCn);
            } catch (err) {
                reject(err);
            }
        }).then(onApiLoaded);
    });
    else {
        // If library should not handle API, provide
        // end-users with the global `vueGoogleMapsInit: () => undefined`
        // when the Google Maps API has been loaded
        var promise = new Promise(function(resolve) {
            if (typeof window === "undefined") // Do nothing if run from server-side
            return;
            window["vueGoogleMapsInit"] = resolve;
        }).then(onApiLoaded);
        return (0, $2d3f87e6748db6a4$var$_lazyValue2.default)(function() {
            return promise;
        });
    }
}
function $2d3f87e6748db6a4$var$gmapApi() {
    return $2d3f87e6748db6a4$var$GmapApi.gmapApi && window.google;
}


var $5e2fc088c50853fb$exports = {};
"use strict";
Object.defineProperty($5e2fc088c50853fb$exports, "__esModule", {
    value: true
});
var $081d9a930e071882$exports = {};
/**
 * @name MarkerClustererPlus for Google Maps V3
 * @version 2.1.2 [May 28, 2014]
 * @author Gary Little
 * @fileoverview
 * The library creates and manages per-zoom-level clusters for large amounts of markers.
 * <p>
 * This is an enhanced V3 implementation of the
 * <a href="http://gmaps-utility-library-dev.googlecode.com/svn/tags/markerclusterer/"
 * >V2 MarkerClusterer</a> by Xiaoxi Wu. It is based on the
 * <a href="http://google-maps-utility-library-v3.googlecode.com/svn/tags/markerclusterer/"
 * >V3 MarkerClusterer</a> port by Luke Mahe. MarkerClustererPlus was created by Gary Little.
 * <p>
 * v2.0 release: MarkerClustererPlus v2.0 is backward compatible with MarkerClusterer v1.0. It
 *  adds support for the <code>ignoreHidden</code>, <code>title</code>, <code>batchSizeIE</code>,
 *  and <code>calculator</code> properties as well as support for four more events. It also allows
 *  greater control over the styling of the text that appears on the cluster marker. The
 *  documentation has been significantly improved and the overall code has been simplified and
 *  polished. Very large numbers of markers can now be managed without causing Javascript timeout
 *  errors on Internet Explorer. Note that the name of the <code>clusterclick</code> event has been
 *  deprecated. The new name is <code>click</code>, so please change your application code now.
 */ /**
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @name ClusterIconStyle
 * @class This class represents the object for values in the <code>styles</code> array passed
 *  to the {@link MarkerClusterer} constructor. The element in this array that is used to
 *  style the cluster icon is determined by calling the <code>calculator</code> function.
 *
 * @property {string} url The URL of the cluster icon image file. Required.
 * @property {number} height The display height (in pixels) of the cluster icon. Required.
 * @property {number} width The display width (in pixels) of the cluster icon. Required.
 * @property {Array} [anchorText] The position (in pixels) from the center of the cluster icon to
 *  where the text label is to be centered and drawn. The format is <code>[yoffset, xoffset]</code>
 *  where <code>yoffset</code> increases as you go down from center and <code>xoffset</code>
 *  increases to the right of center. The default is <code>[0, 0]</code>.
 * @property {Array} [anchorIcon] The anchor position (in pixels) of the cluster icon. This is the
 *  spot on the cluster icon that is to be aligned with the cluster position. The format is
 *  <code>[yoffset, xoffset]</code> where <code>yoffset</code> increases as you go down and
 *  <code>xoffset</code> increases to the right of the top-left corner of the icon. The default
 *  anchor position is the center of the cluster icon.
 * @property {string} [textColor="black"] The color of the label text shown on the
 *  cluster icon.
 * @property {number} [textSize=11] The size (in pixels) of the label text shown on the
 *  cluster icon.
 * @property {string} [textDecoration="none"] The value of the CSS <code>text-decoration</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [fontWeight="bold"] The value of the CSS <code>font-weight</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [fontStyle="normal"] The value of the CSS <code>font-style</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [fontFamily="Arial,sans-serif"] The value of the CSS <code>font-family</code>
 *  property for the label text shown on the cluster icon.
 * @property {string} [backgroundPosition="0 0"] The position of the cluster icon image
 *  within the image defined by <code>url</code>. The format is <code>"xpos ypos"</code>
 *  (the same format as for the CSS <code>background-position</code> property). You must set
 *  this property appropriately when the image defined by <code>url</code> represents a sprite
 *  containing multiple images. Note that the position <i>must</i> be specified in px units.
 */ /**
 * @name ClusterIconInfo
 * @class This class is an object containing general information about a cluster icon. This is
 *  the object that a <code>calculator</code> function returns.
 *
 * @property {string} text The text of the label to be shown on the cluster icon.
 * @property {number} index The index plus 1 of the element in the <code>styles</code>
 *  array to be used to style the cluster icon.
 * @property {string} title The tooltip to display when the mouse moves over the cluster icon.
 *  If this value is <code>undefined</code> or <code>""</code>, <code>title</code> is set to the
 *  value of the <code>title</code> property passed to the MarkerClusterer.
 */ /**
 * A cluster icon.
 *
 * @constructor
 * @extends google.maps.OverlayView
 * @param {Cluster} cluster The cluster with which the icon is to be associated.
 * @param {Array} [styles] An array of {@link ClusterIconStyle} defining the cluster icons
 *  to use for various cluster sizes.
 * @private
 */ function $081d9a930e071882$var$ClusterIcon(cluster, styles) {
    cluster.getMarkerClusterer().extend($081d9a930e071882$var$ClusterIcon, google.maps.OverlayView);
    this.cluster_ = cluster;
    this.className_ = cluster.getMarkerClusterer().getClusterClass();
    this.styles_ = styles;
    this.center_ = null;
    this.div_ = null;
    this.sums_ = null;
    this.visible_ = false;
    this.setMap(cluster.getMap()); // Note: this causes onAdd to be called
}
/**
 * Adds the icon to the DOM.
 */ $081d9a930e071882$var$ClusterIcon.prototype.onAdd = function() {
    var cClusterIcon = this;
    var cMouseDownInCluster;
    var cDraggingMapByCluster;
    this.div_ = document.createElement("div");
    this.div_.className = this.className_;
    if (this.visible_) this.show();
    this.getPanes().overlayMouseTarget.appendChild(this.div_);
    // Fix for Issue 157
    this.boundsChangedListener_ = google.maps.event.addListener(this.getMap(), "bounds_changed", function() {
        cDraggingMapByCluster = cMouseDownInCluster;
    });
    google.maps.event.addDomListener(this.div_, "mousedown", function() {
        cMouseDownInCluster = true;
        cDraggingMapByCluster = false;
    });
    google.maps.event.addDomListener(this.div_, "click", function(e) {
        cMouseDownInCluster = false;
        if (!cDraggingMapByCluster) {
            var theBounds;
            var mz;
            var mc = cClusterIcon.cluster_.getMarkerClusterer();
            /**
       * This event is fired when a cluster marker is clicked.
       * @name MarkerClusterer#click
       * @param {Cluster} c The cluster that was clicked.
       * @event
       */ google.maps.event.trigger(mc, "click", cClusterIcon.cluster_);
            google.maps.event.trigger(mc, "clusterclick", cClusterIcon.cluster_); // deprecated name
            // The default click handler follows. Disable it by setting
            // the zoomOnClick property to false.
            if (mc.getZoomOnClick()) {
                // Zoom into the cluster.
                mz = mc.getMaxZoom();
                theBounds = cClusterIcon.cluster_.getBounds();
                mc.getMap().fitBounds(theBounds);
                // There is a fix for Issue 170 here:
                setTimeout(function() {
                    mc.getMap().fitBounds(theBounds);
                    // Don't zoom beyond the max zoom level
                    if (mz !== null && mc.getMap().getZoom() > mz) mc.getMap().setZoom(mz + 1);
                }, 100);
            }
            // Prevent event propagation to the map:
            e.cancelBubble = true;
            if (e.stopPropagation) e.stopPropagation();
        }
    });
    google.maps.event.addDomListener(this.div_, "mouseover", function() {
        var mc = cClusterIcon.cluster_.getMarkerClusterer();
        /**
     * This event is fired when the mouse moves over a cluster marker.
     * @name MarkerClusterer#mouseover
     * @param {Cluster} c The cluster that the mouse moved over.
     * @event
     */ google.maps.event.trigger(mc, "mouseover", cClusterIcon.cluster_);
    });
    google.maps.event.addDomListener(this.div_, "mouseout", function() {
        var mc = cClusterIcon.cluster_.getMarkerClusterer();
        /**
     * This event is fired when the mouse moves out of a cluster marker.
     * @name MarkerClusterer#mouseout
     * @param {Cluster} c The cluster that the mouse moved out of.
     * @event
     */ google.maps.event.trigger(mc, "mouseout", cClusterIcon.cluster_);
    });
};
/**
 * Removes the icon from the DOM.
 */ $081d9a930e071882$var$ClusterIcon.prototype.onRemove = function() {
    if (this.div_ && this.div_.parentNode) {
        this.hide();
        google.maps.event.removeListener(this.boundsChangedListener_);
        google.maps.event.clearInstanceListeners(this.div_);
        this.div_.parentNode.removeChild(this.div_);
        this.div_ = null;
    }
};
/**
 * Draws the icon.
 */ $081d9a930e071882$var$ClusterIcon.prototype.draw = function() {
    if (this.visible_) {
        var pos = this.getPosFromLatLng_(this.center_);
        this.div_.style.top = pos.y + "px";
        this.div_.style.left = pos.x + "px";
    }
};
/**
 * Hides the icon.
 */ $081d9a930e071882$var$ClusterIcon.prototype.hide = function() {
    if (this.div_) this.div_.style.display = "none";
    this.visible_ = false;
};
/**
 * Positions and shows the icon.
 */ $081d9a930e071882$var$ClusterIcon.prototype.show = function() {
    if (this.div_) {
        var img = "";
        // NOTE: values must be specified in px units
        var bp = this.backgroundPosition_.split(" ");
        var spriteH = parseInt(bp[0].replace(/^\s+|\s+$/g, ""), 10);
        var spriteV = parseInt(bp[1].replace(/^\s+|\s+$/g, ""), 10);
        var pos = this.getPosFromLatLng_(this.center_);
        this.div_.style.cssText = this.createCss(pos);
        img = "<img src='" + this.url_ + "' style='position: absolute; top: " + spriteV + "px; left: " + spriteH + "px; ";
        if (!this.cluster_.getMarkerClusterer().enableRetinaIcons_) img += "clip: rect(" + -1 * spriteV + "px, " + (-1 * spriteH + this.width_) + "px, " + (-1 * spriteV + this.height_) + "px, " + -1 * spriteH + "px);";
        img += "'>";
        this.div_.innerHTML = img + "<div style='" + "position: absolute;" + "top: " + this.anchorText_[0] + "px;" + "left: " + this.anchorText_[1] + "px;" + "color: " + this.textColor_ + ";" + "font-size: " + this.textSize_ + "px;" + "font-family: " + this.fontFamily_ + ";" + "font-weight: " + this.fontWeight_ + ";" + "font-style: " + this.fontStyle_ + ";" + "text-decoration: " + this.textDecoration_ + ";" + "text-align: center;" + "width: " + this.width_ + "px;" + "line-height:" + this.height_ + "px;" + "'>" + this.sums_.text + "</div>";
        if (typeof this.sums_.title === "undefined" || this.sums_.title === "") this.div_.title = this.cluster_.getMarkerClusterer().getTitle();
        else this.div_.title = this.sums_.title;
        this.div_.style.display = "";
    }
    this.visible_ = true;
};
/**
 * Sets the icon styles to the appropriate element in the styles array.
 *
 * @param {ClusterIconInfo} sums The icon label text and styles index.
 */ $081d9a930e071882$var$ClusterIcon.prototype.useStyle = function(sums) {
    this.sums_ = sums;
    var index = Math.max(0, sums.index - 1);
    index = Math.min(this.styles_.length - 1, index);
    var style = this.styles_[index];
    this.url_ = style.url;
    this.height_ = style.height;
    this.width_ = style.width;
    this.anchorText_ = style.anchorText || [
        0,
        0
    ];
    this.anchorIcon_ = style.anchorIcon || [
        parseInt(this.height_ / 2, 10),
        parseInt(this.width_ / 2, 10)
    ];
    this.textColor_ = style.textColor || "black";
    this.textSize_ = style.textSize || 11;
    this.textDecoration_ = style.textDecoration || "none";
    this.fontWeight_ = style.fontWeight || "bold";
    this.fontStyle_ = style.fontStyle || "normal";
    this.fontFamily_ = style.fontFamily || "Arial,sans-serif";
    this.backgroundPosition_ = style.backgroundPosition || "0 0";
};
/**
 * Sets the position at which to center the icon.
 *
 * @param {google.maps.LatLng} center The latlng to set as the center.
 */ $081d9a930e071882$var$ClusterIcon.prototype.setCenter = function(center) {
    this.center_ = center;
};
/**
 * Creates the cssText style parameter based on the position of the icon.
 *
 * @param {google.maps.Point} pos The position of the icon.
 * @return {string} The CSS style text.
 */ $081d9a930e071882$var$ClusterIcon.prototype.createCss = function(pos) {
    var style = [];
    style.push("cursor: pointer;");
    style.push("position: absolute; top: " + pos.y + "px; left: " + pos.x + "px;");
    style.push("width: " + this.width_ + "px; height: " + this.height_ + "px;");
    return style.join("");
};
/**
 * Returns the position at which to place the DIV depending on the latlng.
 *
 * @param {google.maps.LatLng} latlng The position in latlng.
 * @return {google.maps.Point} The position in pixels.
 */ $081d9a930e071882$var$ClusterIcon.prototype.getPosFromLatLng_ = function(latlng) {
    var pos = this.getProjection().fromLatLngToDivPixel(latlng);
    pos.x -= this.anchorIcon_[1];
    pos.y -= this.anchorIcon_[0];
    pos.x = parseInt(pos.x, 10);
    pos.y = parseInt(pos.y, 10);
    return pos;
};
/**
 * Creates a single cluster that manages a group of proximate markers.
 *  Used internally, do not call this constructor directly.
 * @constructor
 * @param {MarkerClusterer} mc The <code>MarkerClusterer</code> object with which this
 *  cluster is associated.
 */ function $081d9a930e071882$var$Cluster(mc) {
    this.markerClusterer_ = mc;
    this.map_ = mc.getMap();
    this.gridSize_ = mc.getGridSize();
    this.minClusterSize_ = mc.getMinimumClusterSize();
    this.averageCenter_ = mc.getAverageCenter();
    this.markers_ = [];
    this.center_ = null;
    this.bounds_ = null;
    this.clusterIcon_ = new $081d9a930e071882$var$ClusterIcon(this, mc.getStyles());
}
/**
 * Returns the number of markers managed by the cluster. You can call this from
 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
 * for the <code>MarkerClusterer</code> object.
 *
 * @return {number} The number of markers in the cluster.
 */ $081d9a930e071882$var$Cluster.prototype.getSize = function() {
    return this.markers_.length;
};
/**
 * Returns the array of markers managed by the cluster. You can call this from
 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
 * for the <code>MarkerClusterer</code> object.
 *
 * @return {Array} The array of markers in the cluster.
 */ $081d9a930e071882$var$Cluster.prototype.getMarkers = function() {
    return this.markers_;
};
/**
 * Returns the center of the cluster. You can call this from
 * a <code>click</code>, <code>mouseover</code>, or <code>mouseout</code> event handler
 * for the <code>MarkerClusterer</code> object.
 *
 * @return {google.maps.LatLng} The center of the cluster.
 */ $081d9a930e071882$var$Cluster.prototype.getCenter = function() {
    return this.center_;
};
/**
 * Returns the map with which the cluster is associated.
 *
 * @return {google.maps.Map} The map.
 * @ignore
 */ $081d9a930e071882$var$Cluster.prototype.getMap = function() {
    return this.map_;
};
/**
 * Returns the <code>MarkerClusterer</code> object with which the cluster is associated.
 *
 * @return {MarkerClusterer} The associated marker clusterer.
 * @ignore
 */ $081d9a930e071882$var$Cluster.prototype.getMarkerClusterer = function() {
    return this.markerClusterer_;
};
/**
 * Returns the bounds of the cluster.
 *
 * @return {google.maps.LatLngBounds} the cluster bounds.
 * @ignore
 */ $081d9a930e071882$var$Cluster.prototype.getBounds = function() {
    var i;
    var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
    var markers = this.getMarkers();
    for(i = 0; i < markers.length; i++)bounds.extend(markers[i].getPosition());
    return bounds;
};
/**
 * Removes the cluster from the map.
 *
 * @ignore
 */ $081d9a930e071882$var$Cluster.prototype.remove = function() {
    this.clusterIcon_.setMap(null);
    this.markers_ = [];
    delete this.markers_;
};
/**
 * Adds a marker to the cluster.
 *
 * @param {google.maps.Marker} marker The marker to be added.
 * @return {boolean} True if the marker was added.
 * @ignore
 */ $081d9a930e071882$var$Cluster.prototype.addMarker = function(marker) {
    var i;
    var mCount;
    var mz;
    if (this.isMarkerAlreadyAdded_(marker)) return false;
    if (!this.center_) {
        this.center_ = marker.getPosition();
        this.calculateBounds_();
    } else if (this.averageCenter_) {
        var l = this.markers_.length + 1;
        var lat = (this.center_.lat() * (l - 1) + marker.getPosition().lat()) / l;
        var lng = (this.center_.lng() * (l - 1) + marker.getPosition().lng()) / l;
        this.center_ = new google.maps.LatLng(lat, lng);
        this.calculateBounds_();
    }
    marker.isAdded = true;
    this.markers_.push(marker);
    mCount = this.markers_.length;
    mz = this.markerClusterer_.getMaxZoom();
    if (mz !== null && this.map_.getZoom() > mz) // Zoomed in past max zoom, so show the marker.
    {
        if (marker.getMap() !== this.map_) marker.setMap(this.map_);
    } else if (mCount < this.minClusterSize_) // Min cluster size not reached so show the marker.
    {
        if (marker.getMap() !== this.map_) marker.setMap(this.map_);
    } else if (mCount === this.minClusterSize_) // Hide the markers that were showing.
    for(i = 0; i < mCount; i++)this.markers_[i].setMap(null);
    else marker.setMap(null);
    this.updateIcon_();
    return true;
};
/**
 * Determines if a marker lies within the cluster's bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker lies in the bounds.
 * @ignore
 */ $081d9a930e071882$var$Cluster.prototype.isMarkerInClusterBounds = function(marker) {
    return this.bounds_.contains(marker.getPosition());
};
/**
 * Calculates the extended bounds of the cluster with the grid.
 */ $081d9a930e071882$var$Cluster.prototype.calculateBounds_ = function() {
    var bounds = new google.maps.LatLngBounds(this.center_, this.center_);
    this.bounds_ = this.markerClusterer_.getExtendedBounds(bounds);
};
/**
 * Updates the cluster icon.
 */ $081d9a930e071882$var$Cluster.prototype.updateIcon_ = function() {
    var mCount = this.markers_.length;
    var mz = this.markerClusterer_.getMaxZoom();
    if (mz !== null && this.map_.getZoom() > mz) {
        this.clusterIcon_.hide();
        return;
    }
    if (mCount < this.minClusterSize_) {
        // Min cluster size not yet reached.
        this.clusterIcon_.hide();
        return;
    }
    var numStyles = this.markerClusterer_.getStyles().length;
    var sums = this.markerClusterer_.getCalculator()(this.markers_, numStyles);
    this.clusterIcon_.setCenter(this.center_);
    this.clusterIcon_.useStyle(sums);
    this.clusterIcon_.show();
};
/**
 * Determines if a marker has already been added to the cluster.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @return {boolean} True if the marker has already been added.
 */ $081d9a930e071882$var$Cluster.prototype.isMarkerAlreadyAdded_ = function(marker) {
    var i;
    if (this.markers_.indexOf) return this.markers_.indexOf(marker) !== -1;
    else for(i = 0; i < this.markers_.length; i++){
        if (marker === this.markers_[i]) return true;
    }
    return false;
};
/**
 * @name MarkerClustererOptions
 * @class This class represents the optional parameter passed to
 *  the {@link MarkerClusterer} constructor.
 * @property {number} [gridSize=60] The grid size of a cluster in pixels. The grid is a square.
 * @property {number} [maxZoom=null] The maximum zoom level at which clustering is enabled or
 *  <code>null</code> if clustering is to be enabled at all zoom levels.
 * @property {boolean} [zoomOnClick=true] Whether to zoom the map when a cluster marker is
 *  clicked. You may want to set this to <code>false</code> if you have installed a handler
 *  for the <code>click</code> event and it deals with zooming on its own.
 * @property {boolean} [averageCenter=false] Whether the position of a cluster marker should be
 *  the average position of all markers in the cluster. If set to <code>false</code>, the
 *  cluster marker is positioned at the location of the first marker added to the cluster.
 * @property {number} [minimumClusterSize=2] The minimum number of markers needed in a cluster
 *  before the markers are hidden and a cluster marker appears.
 * @property {boolean} [ignoreHidden=false] Whether to ignore hidden markers in clusters. You
 *  may want to set this to <code>true</code> to ensure that hidden markers are not included
 *  in the marker count that appears on a cluster marker (this count is the value of the
 *  <code>text</code> property of the result returned by the default <code>calculator</code>).
 *  If set to <code>true</code> and you change the visibility of a marker being clustered, be
 *  sure to also call <code>MarkerClusterer.repaint()</code>.
 * @property {string} [title=""] The tooltip to display when the mouse moves over a cluster
 *  marker. (Alternatively, you can use a custom <code>calculator</code> function to specify a
 *  different tooltip for each cluster marker.)
 * @property {function} [calculator=MarkerClusterer.CALCULATOR] The function used to determine
 *  the text to be displayed on a cluster marker and the index indicating which style to use
 *  for the cluster marker. The input parameters for the function are (1) the array of markers
 *  represented by a cluster marker and (2) the number of cluster icon styles. It returns a
 *  {@link ClusterIconInfo} object. The default <code>calculator</code> returns a
 *  <code>text</code> property which is the number of markers in the cluster and an
 *  <code>index</code> property which is one higher than the lowest integer such that
 *  <code>10^i</code> exceeds the number of markers in the cluster, or the size of the styles
 *  array, whichever is less. The <code>styles</code> array element used has an index of
 *  <code>index</code> minus 1. For example, the default <code>calculator</code> returns a
 *  <code>text</code> value of <code>"125"</code> and an <code>index</code> of <code>3</code>
 *  for a cluster icon representing 125 markers so the element used in the <code>styles</code>
 *  array is <code>2</code>. A <code>calculator</code> may also return a <code>title</code>
 *  property that contains the text of the tooltip to be used for the cluster marker. If
 *   <code>title</code> is not defined, the tooltip is set to the value of the <code>title</code>
 *   property for the MarkerClusterer.
 * @property {string} [clusterClass="cluster"] The name of the CSS class defining general styles
 *  for the cluster markers. Use this class to define CSS styles that are not set up by the code
 *  that processes the <code>styles</code> array.
 * @property {Array} [styles] An array of {@link ClusterIconStyle} elements defining the styles
 *  of the cluster markers to be used. The element to be used to style a given cluster marker
 *  is determined by the function defined by the <code>calculator</code> property.
 *  The default is an array of {@link ClusterIconStyle} elements whose properties are derived
 *  from the values for <code>imagePath</code>, <code>imageExtension</code>, and
 *  <code>imageSizes</code>.
 * @property {boolean} [enableRetinaIcons=false] Whether to allow the use of cluster icons that
 * have sizes that are some multiple (typically double) of their actual display size. Icons such
 * as these look better when viewed on high-resolution monitors such as Apple's Retina displays.
 * Note: if this property is <code>true</code>, sprites cannot be used as cluster icons.
 * @property {number} [batchSize=MarkerClusterer.BATCH_SIZE] Set this property to the
 *  number of markers to be processed in a single batch when using a browser other than
 *  Internet Explorer (for Internet Explorer, use the batchSizeIE property instead).
 * @property {number} [batchSizeIE=MarkerClusterer.BATCH_SIZE_IE] When Internet Explorer is
 *  being used, markers are processed in several batches with a small delay inserted between
 *  each batch in an attempt to avoid Javascript timeout errors. Set this property to the
 *  number of markers to be processed in a single batch; select as high a number as you can
 *  without causing a timeout error in the browser. This number might need to be as low as 100
 *  if 15,000 markers are being managed, for example.
 * @property {string} [imagePath=MarkerClusterer.IMAGE_PATH]
 *  The full URL of the root name of the group of image files to use for cluster icons.
 *  The complete file name is of the form <code>imagePath</code>n.<code>imageExtension</code>
 *  where n is the image file number (1, 2, etc.).
 * @property {string} [imageExtension=MarkerClusterer.IMAGE_EXTENSION]
 *  The extension name for the cluster icon image files (e.g., <code>"png"</code> or
 *  <code>"jpg"</code>).
 * @property {Array} [imageSizes=MarkerClusterer.IMAGE_SIZES]
 *  An array of numbers containing the widths of the group of
 *  <code>imagePath</code>n.<code>imageExtension</code> image files.
 *  (The images are assumed to be square.)
 */ /**
 * Creates a MarkerClusterer object with the options specified in {@link MarkerClustererOptions}.
 * @constructor
 * @extends google.maps.OverlayView
 * @param {google.maps.Map} map The Google map to attach to.
 * @param {Array.<google.maps.Marker>} [opt_markers] The markers to be added to the cluster.
 * @param {MarkerClustererOptions} [opt_options] The optional parameters.
 */ function $081d9a930e071882$var$MarkerClusterer(map, opt_markers, opt_options) {
    // MarkerClusterer implements google.maps.OverlayView interface. We use the
    // extend function to extend MarkerClusterer with google.maps.OverlayView
    // because it might not always be available when the code is defined so we
    // look for it at the last possible moment. If it doesn't exist now then
    // there is no point going ahead :)
    this.extend($081d9a930e071882$var$MarkerClusterer, google.maps.OverlayView);
    opt_markers = opt_markers || [];
    opt_options = opt_options || {};
    this.markers_ = [];
    this.clusters_ = [];
    this.listeners_ = [];
    this.activeMap_ = null;
    this.ready_ = false;
    this.gridSize_ = opt_options.gridSize || 60;
    this.minClusterSize_ = opt_options.minimumClusterSize || 2;
    this.maxZoom_ = opt_options.maxZoom || null;
    this.styles_ = opt_options.styles || [];
    this.title_ = opt_options.title || "";
    this.zoomOnClick_ = true;
    if (opt_options.zoomOnClick !== undefined) this.zoomOnClick_ = opt_options.zoomOnClick;
    this.averageCenter_ = false;
    if (opt_options.averageCenter !== undefined) this.averageCenter_ = opt_options.averageCenter;
    this.ignoreHidden_ = false;
    if (opt_options.ignoreHidden !== undefined) this.ignoreHidden_ = opt_options.ignoreHidden;
    this.enableRetinaIcons_ = false;
    if (opt_options.enableRetinaIcons !== undefined) this.enableRetinaIcons_ = opt_options.enableRetinaIcons;
    this.imagePath_ = opt_options.imagePath || $081d9a930e071882$var$MarkerClusterer.IMAGE_PATH;
    this.imageExtension_ = opt_options.imageExtension || $081d9a930e071882$var$MarkerClusterer.IMAGE_EXTENSION;
    this.imageSizes_ = opt_options.imageSizes || $081d9a930e071882$var$MarkerClusterer.IMAGE_SIZES;
    this.calculator_ = opt_options.calculator || $081d9a930e071882$var$MarkerClusterer.CALCULATOR;
    this.batchSize_ = opt_options.batchSize || $081d9a930e071882$var$MarkerClusterer.BATCH_SIZE;
    this.batchSizeIE_ = opt_options.batchSizeIE || $081d9a930e071882$var$MarkerClusterer.BATCH_SIZE_IE;
    this.clusterClass_ = opt_options.clusterClass || "cluster";
    if (navigator.userAgent.toLowerCase().indexOf("msie") !== -1) // Try to avoid IE timeout when processing a huge number of markers:
    this.batchSize_ = this.batchSizeIE_;
    this.setupStyles_();
    this.addMarkers(opt_markers, true);
    this.setMap(map); // Note: this causes onAdd to be called
}
/**
 * Implementation of the onAdd interface method.
 * @ignore
 */ $081d9a930e071882$var$MarkerClusterer.prototype.onAdd = function() {
    var cMarkerClusterer = this;
    this.activeMap_ = this.getMap();
    this.ready_ = true;
    this.repaint();
    // Add the map event listeners
    this.listeners_ = [
        google.maps.event.addListener(this.getMap(), "zoom_changed", function() {
            cMarkerClusterer.resetViewport_(false);
            // Workaround for this Google bug: when map is at level 0 and "-" of
            // zoom slider is clicked, a "zoom_changed" event is fired even though
            // the map doesn't zoom out any further. In this situation, no "idle"
            // event is triggered so the cluster markers that have been removed
            // do not get redrawn. Same goes for a zoom in at maxZoom.
            if (this.getZoom() === (this.get("minZoom") || 0) || this.getZoom() === this.get("maxZoom")) google.maps.event.trigger(this, "idle");
        }),
        google.maps.event.addListener(this.getMap(), "idle", function() {
            cMarkerClusterer.redraw_();
        })
    ];
};
/**
 * Implementation of the onRemove interface method.
 * Removes map event listeners and all cluster icons from the DOM.
 * All managed markers are also put back on the map.
 * @ignore
 */ $081d9a930e071882$var$MarkerClusterer.prototype.onRemove = function() {
    var i;
    // Put all the managed markers back on the map:
    for(i = 0; i < this.markers_.length; i++)if (this.markers_[i].getMap() !== this.activeMap_) this.markers_[i].setMap(this.activeMap_);
    // Remove all clusters:
    for(i = 0; i < this.clusters_.length; i++)this.clusters_[i].remove();
    this.clusters_ = [];
    // Remove map event listeners:
    for(i = 0; i < this.listeners_.length; i++)google.maps.event.removeListener(this.listeners_[i]);
    this.listeners_ = [];
    this.activeMap_ = null;
    this.ready_ = false;
};
/**
 * Implementation of the draw interface method.
 * @ignore
 */ $081d9a930e071882$var$MarkerClusterer.prototype.draw = function() {};
/**
 * Sets up the styles object.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.setupStyles_ = function() {
    var i, size;
    if (this.styles_.length > 0) return;
    for(i = 0; i < this.imageSizes_.length; i++){
        size = this.imageSizes_[i];
        this.styles_.push({
            url: this.imagePath_ + (i + 1) + "." + this.imageExtension_,
            height: size,
            width: size
        });
    }
};
/**
 *  Fits the map to the bounds of the markers managed by the clusterer.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.fitMapToMarkers = function() {
    var i;
    var markers = this.getMarkers();
    var bounds = new google.maps.LatLngBounds();
    for(i = 0; i < markers.length; i++)bounds.extend(markers[i].getPosition());
    this.getMap().fitBounds(bounds);
};
/**
 * Returns the value of the <code>gridSize</code> property.
 *
 * @return {number} The grid size.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.getGridSize = function() {
    return this.gridSize_;
};
/**
 * Sets the value of the <code>gridSize</code> property.
 *
 * @param {number} gridSize The grid size.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.setGridSize = function(gridSize) {
    this.gridSize_ = gridSize;
};
/**
 * Returns the value of the <code>minimumClusterSize</code> property.
 *
 * @return {number} The minimum cluster size.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.getMinimumClusterSize = function() {
    return this.minClusterSize_;
};
/**
 * Sets the value of the <code>minimumClusterSize</code> property.
 *
 * @param {number} minimumClusterSize The minimum cluster size.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.setMinimumClusterSize = function(minimumClusterSize) {
    this.minClusterSize_ = minimumClusterSize;
};
/**
 *  Returns the value of the <code>maxZoom</code> property.
 *
 *  @return {number} The maximum zoom level.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.getMaxZoom = function() {
    return this.maxZoom_;
};
/**
 *  Sets the value of the <code>maxZoom</code> property.
 *
 *  @param {number} maxZoom The maximum zoom level.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.setMaxZoom = function(maxZoom) {
    this.maxZoom_ = maxZoom;
};
/**
 *  Returns the value of the <code>styles</code> property.
 *
 *  @return {Array} The array of styles defining the cluster markers to be used.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.getStyles = function() {
    return this.styles_;
};
/**
 *  Sets the value of the <code>styles</code> property.
 *
 *  @param {Array.<ClusterIconStyle>} styles The array of styles to use.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.setStyles = function(styles) {
    this.styles_ = styles;
};
/**
 * Returns the value of the <code>title</code> property.
 *
 * @return {string} The content of the title text.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.getTitle = function() {
    return this.title_;
};
/**
 *  Sets the value of the <code>title</code> property.
 *
 *  @param {string} title The value of the title property.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.setTitle = function(title) {
    this.title_ = title;
};
/**
 * Returns the value of the <code>zoomOnClick</code> property.
 *
 * @return {boolean} True if zoomOnClick property is set.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.getZoomOnClick = function() {
    return this.zoomOnClick_;
};
/**
 *  Sets the value of the <code>zoomOnClick</code> property.
 *
 *  @param {boolean} zoomOnClick The value of the zoomOnClick property.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.setZoomOnClick = function(zoomOnClick) {
    this.zoomOnClick_ = zoomOnClick;
};
/**
 * Returns the value of the <code>averageCenter</code> property.
 *
 * @return {boolean} True if averageCenter property is set.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.getAverageCenter = function() {
    return this.averageCenter_;
};
/**
 *  Sets the value of the <code>averageCenter</code> property.
 *
 *  @param {boolean} averageCenter The value of the averageCenter property.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.setAverageCenter = function(averageCenter) {
    this.averageCenter_ = averageCenter;
};
/**
 * Returns the value of the <code>ignoreHidden</code> property.
 *
 * @return {boolean} True if ignoreHidden property is set.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.getIgnoreHidden = function() {
    return this.ignoreHidden_;
};
/**
 *  Sets the value of the <code>ignoreHidden</code> property.
 *
 *  @param {boolean} ignoreHidden The value of the ignoreHidden property.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.setIgnoreHidden = function(ignoreHidden) {
    this.ignoreHidden_ = ignoreHidden;
};
/**
 * Returns the value of the <code>enableRetinaIcons</code> property.
 *
 * @return {boolean} True if enableRetinaIcons property is set.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.getEnableRetinaIcons = function() {
    return this.enableRetinaIcons_;
};
/**
 *  Sets the value of the <code>enableRetinaIcons</code> property.
 *
 *  @param {boolean} enableRetinaIcons The value of the enableRetinaIcons property.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.setEnableRetinaIcons = function(enableRetinaIcons) {
    this.enableRetinaIcons_ = enableRetinaIcons;
};
/**
 * Returns the value of the <code>imageExtension</code> property.
 *
 * @return {string} The value of the imageExtension property.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.getImageExtension = function() {
    return this.imageExtension_;
};
/**
 *  Sets the value of the <code>imageExtension</code> property.
 *
 *  @param {string} imageExtension The value of the imageExtension property.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.setImageExtension = function(imageExtension) {
    this.imageExtension_ = imageExtension;
};
/**
 * Returns the value of the <code>imagePath</code> property.
 *
 * @return {string} The value of the imagePath property.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.getImagePath = function() {
    return this.imagePath_;
};
/**
 *  Sets the value of the <code>imagePath</code> property.
 *
 *  @param {string} imagePath The value of the imagePath property.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.setImagePath = function(imagePath) {
    this.imagePath_ = imagePath;
};
/**
 * Returns the value of the <code>imageSizes</code> property.
 *
 * @return {Array} The value of the imageSizes property.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.getImageSizes = function() {
    return this.imageSizes_;
};
/**
 *  Sets the value of the <code>imageSizes</code> property.
 *
 *  @param {Array} imageSizes The value of the imageSizes property.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.setImageSizes = function(imageSizes) {
    this.imageSizes_ = imageSizes;
};
/**
 * Returns the value of the <code>calculator</code> property.
 *
 * @return {function} the value of the calculator property.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.getCalculator = function() {
    return this.calculator_;
};
/**
 * Sets the value of the <code>calculator</code> property.
 *
 * @param {function(Array.<google.maps.Marker>, number)} calculator The value
 *  of the calculator property.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.setCalculator = function(calculator) {
    this.calculator_ = calculator;
};
/**
 * Returns the value of the <code>batchSizeIE</code> property.
 *
 * @return {number} the value of the batchSizeIE property.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.getBatchSizeIE = function() {
    return this.batchSizeIE_;
};
/**
 * Sets the value of the <code>batchSizeIE</code> property.
 *
 *  @param {number} batchSizeIE The value of the batchSizeIE property.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.setBatchSizeIE = function(batchSizeIE) {
    this.batchSizeIE_ = batchSizeIE;
};
/**
 * Returns the value of the <code>clusterClass</code> property.
 *
 * @return {string} the value of the clusterClass property.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.getClusterClass = function() {
    return this.clusterClass_;
};
/**
 * Sets the value of the <code>clusterClass</code> property.
 *
 *  @param {string} clusterClass The value of the clusterClass property.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.setClusterClass = function(clusterClass) {
    this.clusterClass_ = clusterClass;
};
/**
 *  Returns the array of markers managed by the clusterer.
 *
 *  @return {Array} The array of markers managed by the clusterer.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.getMarkers = function() {
    return this.markers_;
};
/**
 *  Returns the number of markers managed by the clusterer.
 *
 *  @return {number} The number of markers.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.getTotalMarkers = function() {
    return this.markers_.length;
};
/**
 * Returns the current array of clusters formed by the clusterer.
 *
 * @return {Array} The array of clusters formed by the clusterer.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.getClusters = function() {
    return this.clusters_;
};
/**
 * Returns the number of clusters formed by the clusterer.
 *
 * @return {number} The number of clusters formed by the clusterer.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.getTotalClusters = function() {
    return this.clusters_.length;
};
/**
 * Adds a marker to the clusterer. The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>.
 *
 * @param {google.maps.Marker} marker The marker to add.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.addMarker = function(marker, opt_nodraw) {
    this.pushMarkerTo_(marker);
    if (!opt_nodraw) this.redraw_();
};
/**
 * Adds an array of markers to the clusterer. The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to add.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.addMarkers = function(markers, opt_nodraw) {
    var key;
    for(key in markers)if (markers.hasOwnProperty(key)) this.pushMarkerTo_(markers[key]);
    if (!opt_nodraw) this.redraw_();
};
/**
 * Pushes a marker to the clusterer.
 *
 * @param {google.maps.Marker} marker The marker to add.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.pushMarkerTo_ = function(marker) {
    // If the marker is draggable add a listener so we can update the clusters on the dragend:
    if (marker.getDraggable()) {
        var cMarkerClusterer = this;
        google.maps.event.addListener(marker, "dragend", function() {
            if (cMarkerClusterer.ready_) {
                this.isAdded = false;
                cMarkerClusterer.repaint();
            }
        });
    }
    marker.isAdded = false;
    this.markers_.push(marker);
};
/**
 * Removes a marker from the cluster.  The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>. Returns <code>true</code> if the
 *  marker was removed from the clusterer.
 *
 * @param {google.maps.Marker} marker The marker to remove.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 * @return {boolean} True if the marker was removed from the clusterer.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.removeMarker = function(marker, opt_nodraw) {
    var removed = this.removeMarker_(marker);
    if (!opt_nodraw && removed) this.repaint();
    return removed;
};
/**
 * Removes an array of markers from the cluster. The clusters are redrawn unless
 *  <code>opt_nodraw</code> is set to <code>true</code>. Returns <code>true</code> if markers
 *  were removed from the clusterer.
 *
 * @param {Array.<google.maps.Marker>} markers The markers to remove.
 * @param {boolean} [opt_nodraw] Set to <code>true</code> to prevent redrawing.
 * @return {boolean} True if markers were removed from the clusterer.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.removeMarkers = function(markers, opt_nodraw) {
    var i, r;
    var removed = false;
    for(i = 0; i < markers.length; i++){
        r = this.removeMarker_(markers[i]);
        removed = removed || r;
    }
    if (!opt_nodraw && removed) this.repaint();
    return removed;
};
/**
 * Removes a marker and returns true if removed, false if not.
 *
 * @param {google.maps.Marker} marker The marker to remove
 * @return {boolean} Whether the marker was removed or not
 */ $081d9a930e071882$var$MarkerClusterer.prototype.removeMarker_ = function(marker) {
    var i;
    var index = -1;
    if (this.markers_.indexOf) index = this.markers_.indexOf(marker);
    else {
        for(i = 0; i < this.markers_.length; i++)if (marker === this.markers_[i]) {
            index = i;
            break;
        }
    }
    if (index === -1) // Marker is not in our list of markers, so do nothing:
    return false;
    marker.setMap(null);
    this.markers_.splice(index, 1); // Remove the marker from the list of managed markers
    return true;
};
/**
 * Removes all clusters and markers from the map and also removes all markers
 *  managed by the clusterer.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.clearMarkers = function() {
    this.resetViewport_(true);
    this.markers_ = [];
};
/**
 * Recalculates and redraws all the marker clusters from scratch.
 *  Call this after changing any properties.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.repaint = function() {
    var oldClusters = this.clusters_.slice();
    this.clusters_ = [];
    this.resetViewport_(false);
    this.redraw_();
    // Remove the old clusters.
    // Do it in a timeout to prevent blinking effect.
    setTimeout(function() {
        var i;
        for(i = 0; i < oldClusters.length; i++)oldClusters[i].remove();
    }, 0);
};
/**
 * Returns the current bounds extended by the grid size.
 *
 * @param {google.maps.LatLngBounds} bounds The bounds to extend.
 * @return {google.maps.LatLngBounds} The extended bounds.
 * @ignore
 */ $081d9a930e071882$var$MarkerClusterer.prototype.getExtendedBounds = function(bounds) {
    var projection = this.getProjection();
    // Turn the bounds into latlng.
    var tr = new google.maps.LatLng(bounds.getNorthEast().lat(), bounds.getNorthEast().lng());
    var bl = new google.maps.LatLng(bounds.getSouthWest().lat(), bounds.getSouthWest().lng());
    // Convert the points to pixels and the extend out by the grid size.
    var trPix = projection.fromLatLngToDivPixel(tr);
    trPix.x += this.gridSize_;
    trPix.y -= this.gridSize_;
    var blPix = projection.fromLatLngToDivPixel(bl);
    blPix.x -= this.gridSize_;
    blPix.y += this.gridSize_;
    // Convert the pixel points back to LatLng
    var ne = projection.fromDivPixelToLatLng(trPix);
    var sw = projection.fromDivPixelToLatLng(blPix);
    // Extend the bounds to contain the new bounds.
    bounds.extend(ne);
    bounds.extend(sw);
    return bounds;
};
/**
 * Redraws all the clusters.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.redraw_ = function() {
    this.createClusters_(0);
};
/**
 * Removes all clusters from the map. The markers are also removed from the map
 *  if <code>opt_hide</code> is set to <code>true</code>.
 *
 * @param {boolean} [opt_hide] Set to <code>true</code> to also remove the markers
 *  from the map.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.resetViewport_ = function(opt_hide) {
    var i, marker;
    // Remove all the clusters
    for(i = 0; i < this.clusters_.length; i++)this.clusters_[i].remove();
    this.clusters_ = [];
    // Reset the markers to not be added and to be removed from the map.
    for(i = 0; i < this.markers_.length; i++){
        marker = this.markers_[i];
        marker.isAdded = false;
        if (opt_hide) marker.setMap(null);
    }
};
/**
 * Calculates the distance between two latlng locations in km.
 *
 * @param {google.maps.LatLng} p1 The first lat lng point.
 * @param {google.maps.LatLng} p2 The second lat lng point.
 * @return {number} The distance between the two points in km.
 * @see http://www.movable-type.co.uk/scripts/latlong.html
*/ $081d9a930e071882$var$MarkerClusterer.prototype.distanceBetweenPoints_ = function(p1, p2) {
    var R = 6371; // Radius of the Earth in km
    var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
    var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
};
/**
 * Determines if a marker is contained in a bounds.
 *
 * @param {google.maps.Marker} marker The marker to check.
 * @param {google.maps.LatLngBounds} bounds The bounds to check against.
 * @return {boolean} True if the marker is in the bounds.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.isMarkerInBounds_ = function(marker, bounds) {
    return bounds.contains(marker.getPosition());
};
/**
 * Adds a marker to a cluster, or creates a new cluster.
 *
 * @param {google.maps.Marker} marker The marker to add.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.addToClosestCluster_ = function(marker) {
    var i, d, cluster, center;
    var distance = 40000; // Some large number
    var clusterToAddTo = null;
    for(i = 0; i < this.clusters_.length; i++){
        cluster = this.clusters_[i];
        center = cluster.getCenter();
        if (center) {
            d = this.distanceBetweenPoints_(center, marker.getPosition());
            if (d < distance) {
                distance = d;
                clusterToAddTo = cluster;
            }
        }
    }
    if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) clusterToAddTo.addMarker(marker);
    else {
        cluster = new $081d9a930e071882$var$Cluster(this);
        cluster.addMarker(marker);
        this.clusters_.push(cluster);
    }
};
/**
 * Creates the clusters. This is done in batches to avoid timeout errors
 *  in some browsers when there is a huge number of markers.
 *
 * @param {number} iFirst The index of the first marker in the batch of
 *  markers to be added to clusters.
 */ $081d9a930e071882$var$MarkerClusterer.prototype.createClusters_ = function(iFirst) {
    var i, marker;
    var mapBounds;
    var cMarkerClusterer = this;
    if (!this.ready_) return;
    // Cancel previous batch processing if we're working on the first batch:
    if (iFirst === 0) {
        /**
     * This event is fired when the <code>MarkerClusterer</code> begins
     *  clustering markers.
     * @name MarkerClusterer#clusteringbegin
     * @param {MarkerClusterer} mc The MarkerClusterer whose markers are being clustered.
     * @event
     */ google.maps.event.trigger(this, "clusteringbegin", this);
        if (typeof this.timerRefStatic !== "undefined") {
            clearTimeout(this.timerRefStatic);
            delete this.timerRefStatic;
        }
    }
    // Get our current map view bounds.
    // Create a new bounds object so we don't affect the map.
    //
    // See Comments 9 & 11 on Issue 3651 relating to this workaround for a Google Maps bug:
    if (this.getMap().getZoom() > 3) mapBounds = new google.maps.LatLngBounds(this.getMap().getBounds().getSouthWest(), this.getMap().getBounds().getNorthEast());
    else mapBounds = new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625));
    var bounds = this.getExtendedBounds(mapBounds);
    var iLast = Math.min(iFirst + this.batchSize_, this.markers_.length);
    for(i = iFirst; i < iLast; i++){
        marker = this.markers_[i];
        if (!marker.isAdded && this.isMarkerInBounds_(marker, bounds)) {
            if (!this.ignoreHidden_ || this.ignoreHidden_ && marker.getVisible()) this.addToClosestCluster_(marker);
        }
    }
    if (iLast < this.markers_.length) this.timerRefStatic = setTimeout(function() {
        cMarkerClusterer.createClusters_(iLast);
    }, 0);
    else {
        delete this.timerRefStatic;
        /**
     * This event is fired when the <code>MarkerClusterer</code> stops
     *  clustering markers.
     * @name MarkerClusterer#clusteringend
     * @param {MarkerClusterer} mc The MarkerClusterer whose markers are being clustered.
     * @event
     */ google.maps.event.trigger(this, "clusteringend", this);
    }
};
/**
 * Extends an object's prototype by another's.
 *
 * @param {Object} obj1 The object to be extended.
 * @param {Object} obj2 The object to extend with.
 * @return {Object} The new extended object.
 * @ignore
 */ $081d9a930e071882$var$MarkerClusterer.prototype.extend = function(obj1, obj2) {
    return (function(object) {
        var property;
        for(property in object.prototype)this.prototype[property] = object.prototype[property];
        return this;
    }).apply(obj1, [
        obj2
    ]);
};
/**
 * The default function for determining the label text and style
 * for a cluster icon.
 *
 * @param {Array.<google.maps.Marker>} markers The array of markers represented by the cluster.
 * @param {number} numStyles The number of marker styles available.
 * @return {ClusterIconInfo} The information resource for the cluster.
 * @constant
 * @ignore
 */ $081d9a930e071882$var$MarkerClusterer.CALCULATOR = function(markers, numStyles) {
    var index = 0;
    var title = "";
    var count = markers.length.toString();
    var dv = count;
    while(dv !== 0){
        dv = parseInt(dv / 10, 10);
        index++;
    }
    index = Math.min(index, numStyles);
    return {
        text: count,
        index: index,
        title: title
    };
};
/**
 * The number of markers to process in one batch.
 *
 * @type {number}
 * @constant
 */ $081d9a930e071882$var$MarkerClusterer.BATCH_SIZE = 2000;
/**
 * The number of markers to process in one batch (IE only).
 *
 * @type {number}
 * @constant
 */ $081d9a930e071882$var$MarkerClusterer.BATCH_SIZE_IE = 500;
/**
 * The default root name for the marker cluster images.
 *
 * @type {string}
 * @constant
 */ $081d9a930e071882$var$MarkerClusterer.IMAGE_PATH = "https://raw.githubusercontent.com/googlemaps/v3-utility-library/master/markerclustererplus/images/m";
/**
 * The default extension name for the marker cluster images.
 *
 * @type {string}
 * @constant
 */ $081d9a930e071882$var$MarkerClusterer.IMAGE_EXTENSION = "png";
/**
 * The default array of sizes for the marker cluster images.
 *
 * @type {Array.<number>}
 * @constant
 */ $081d9a930e071882$var$MarkerClusterer.IMAGE_SIZES = [
    53,
    56,
    66,
    78,
    90
];
$081d9a930e071882$exports = $081d9a930e071882$var$MarkerClusterer;


var $5e2fc088c50853fb$var$_markerClustererPlus2 = $5e2fc088c50853fb$var$_interopRequireDefault($081d9a930e071882$exports);

var $3P0WM = parcelRequire("3P0WM");
var $5e2fc088c50853fb$var$_mapElementFactory2 = $5e2fc088c50853fb$var$_interopRequireDefault($3P0WM);
function $5e2fc088c50853fb$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5e2fc088c50853fb$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
} /**
                                                                                                                                                                                                                               * @class Cluster
                                                                                                                                                                                                                               * @prop $clusterObject -- Exposes the marker clusterer to
                                                                                                                                                                                                                                     descendent Marker classes. Override this if you area
                                                                                                                                                                                                                                     extending the class
                                                                                                                                                                                                                             
                                                                                                                                                                                                                               List of properties from
                                                                                                                                                                                                                               https://github.com/googlemaps/v3-utility-library/blob/master/markerclustererplus/src/markerclusterer.js
                                                                                                                                                                                                                             **/ 
var $5e2fc088c50853fb$var$props = {
    maxZoom: {
        type: Number,
        twoWay: false
    },
    batchSizeIE: {
        type: Number,
        twoWay: false
    },
    calculator: {
        type: Function,
        twoWay: false
    },
    enableRetinaIcons: {
        type: Boolean,
        twoWay: false
    },
    gridSize: {
        type: Number,
        twoWay: false
    },
    ignoreHidden: {
        type: Boolean,
        twoWay: false
    },
    imageExtension: {
        type: String,
        twoWay: false
    },
    imagePath: {
        type: String,
        twoWay: false
    },
    imageSizes: {
        type: Array,
        twoWay: false
    },
    minimumClusterSize: {
        type: Number,
        twoWay: false
    },
    styles: {
        type: Array,
        twoWay: false
    },
    zoomOnClick: {
        type: Boolean,
        twoWay: false
    }
};
var $5e2fc088c50853fb$var$events = [
    "click",
    "rightclick",
    "dblclick",
    "drag",
    "dragstart",
    "dragend",
    "mouseup",
    "mousedown",
    "mouseover",
    "mouseout"
];
$5e2fc088c50853fb$exports.default = (0, $5e2fc088c50853fb$var$_mapElementFactory2.default)({
    mappedProps: $5e2fc088c50853fb$var$props,
    events: $5e2fc088c50853fb$var$events,
    name: "cluster",
    ctr: function ctr() {
        if (typeof $5e2fc088c50853fb$var$_markerClustererPlus2.default === "undefined") {
            /* eslint-disable no-console */ console.error("MarkerClusterer is not installed! require() it or include it from https://cdnjs.cloudflare.com/ajax/libs/js-marker-clusterer/1.0.0/markerclusterer.js");
            throw new Error("MarkerClusterer is not installed! require() it or include it from https://cdnjs.cloudflare.com/ajax/libs/js-marker-clusterer/1.0.0/markerclusterer.js");
        }
        return $5e2fc088c50853fb$var$_markerClustererPlus2.default;
    },
    ctrArgs: function ctrArgs(_ref) {
        var map = _ref.map, otherOptions = $5e2fc088c50853fb$var$_objectWithoutProperties(_ref, [
            "map"
        ]);
        return [
            map,
            [],
            otherOptions
        ];
    },
    render: function render(h) {
        // <div><slot></slot></div>
        return h("div", this.$slots.default);
    },
    afterCreate: function afterCreate(inst) {
        var reinsertMarkers = function() {
            var oldMarkers = inst.getMarkers();
            inst.clearMarkers();
            inst.addMarkers(oldMarkers);
        };
        for(var prop in $5e2fc088c50853fb$var$props)if ($5e2fc088c50853fb$var$props[prop].twoWay) this.$on(prop.toLowerCase() + "_changed", reinsertMarkers);
    },
    updated: function updated() {
        if (this.$clusterObject) this.$clusterObject.repaint();
    },
    beforeDestroy: function beforeDestroy() {
        var _this = this;
        /* Performance optimization when destroying a large number of markers */ this.$children.forEach(function(marker) {
            if (marker.$clusterObject === _this.$clusterObject) marker.$clusterObject = null;
        });
        if (this.$clusterObject) this.$clusterObject.clearMarkers();
    }
});


var $608dba8cc927f948$exports = {};
!function(e, t) {
    $608dba8cc927f948$exports = t();
}("undefined" != typeof self ? self : $608dba8cc927f948$exports, function() {
    return (()=>{
        var e = {
            646: (e)=>{
                e.exports = function(e) {
                    if (Array.isArray(e)) {
                        for(var t = 0, n = new Array(e.length); t < e.length; t++)n[t] = e[t];
                        return n;
                    }
                };
            },
            713: (e)=>{
                e.exports = function(e, t, n) {
                    return t in e ? Object.defineProperty(e, t, {
                        value: n,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[t] = n, e;
                };
            },
            860: (e)=>{
                e.exports = function(e) {
                    if (Symbol.iterator in Object(e) || "[object Arguments]" === Object.prototype.toString.call(e)) return Array.from(e);
                };
            },
            206: (e)=>{
                e.exports = function() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance");
                };
            },
            319: (e, t, n)=>{
                var o = n(646), i = n(860), s = n(206);
                e.exports = function(e) {
                    return o(e) || i(e) || s();
                };
            },
            8: (e)=>{
                function t(n) {
                    return "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? e.exports = t = function(e) {
                        return typeof e;
                    } : e.exports = t = function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, t(n);
                }
                e.exports = t;
            }
        }, t = {};
        function n(o) {
            var i = t[o];
            if (void 0 !== i) return i.exports;
            var s = t[o] = {
                exports: {}
            };
            return e[o](s, s.exports, n), s.exports;
        }
        n.n = (e)=>{
            var t = e && e.__esModule ? ()=>e.default : ()=>e;
            return n.d(t, {
                a: t
            }), t;
        }, n.d = (e, t)=>{
            for(var o in t)n.o(t, o) && !n.o(e, o) && Object.defineProperty(e, o, {
                enumerable: !0,
                get: t[o]
            });
        }, n.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), n.r = (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        };
        var o = {};
        return (()=>{
            "use strict";
            n.r(o), n.d(o, {
                VueSelect: ()=>m,
                default: ()=>O,
                mixins: ()=>_
            });
            var e = n(319), t = n.n(e), i = n(8), s = n.n(i), r = n(713), a = n.n(r);
            const l = {
                props: {
                    autoscroll: {
                        type: Boolean,
                        default: !0
                    }
                },
                watch: {
                    typeAheadPointer: function() {
                        this.autoscroll && this.maybeAdjustScroll();
                    },
                    open: function(e) {
                        var t = this;
                        this.autoscroll && e && this.$nextTick(function() {
                            return t.maybeAdjustScroll();
                        });
                    }
                },
                methods: {
                    maybeAdjustScroll: function() {
                        var e, t = (null === (e = this.$refs.dropdownMenu) || void 0 === e ? void 0 : e.children[this.typeAheadPointer]) || !1;
                        if (t) {
                            var n = this.getDropdownViewport(), o = t.getBoundingClientRect(), i = o.top, s = o.bottom, r = o.height;
                            if (i < n.top) return this.$refs.dropdownMenu.scrollTop = t.offsetTop;
                            if (s > n.bottom) return this.$refs.dropdownMenu.scrollTop = t.offsetTop - (n.height - r);
                        }
                    },
                    getDropdownViewport: function() {
                        return this.$refs.dropdownMenu ? this.$refs.dropdownMenu.getBoundingClientRect() : {
                            height: 0,
                            top: 0,
                            bottom: 0
                        };
                    }
                }
            }, c = {
                data: function() {
                    return {
                        typeAheadPointer: -1
                    };
                },
                watch: {
                    filteredOptions: function() {
                        for(var e = 0; e < this.filteredOptions.length; e++)if (this.selectable(this.filteredOptions[e])) {
                            this.typeAheadPointer = e;
                            break;
                        }
                    },
                    open: function(e) {
                        e && this.typeAheadToLastSelected();
                    },
                    selectedValue: function() {
                        this.open && this.typeAheadToLastSelected();
                    }
                },
                methods: {
                    typeAheadUp: function() {
                        for(var e = this.typeAheadPointer - 1; e >= 0; e--)if (this.selectable(this.filteredOptions[e])) {
                            this.typeAheadPointer = e;
                            break;
                        }
                    },
                    typeAheadDown: function() {
                        for(var e = this.typeAheadPointer + 1; e < this.filteredOptions.length; e++)if (this.selectable(this.filteredOptions[e])) {
                            this.typeAheadPointer = e;
                            break;
                        }
                    },
                    typeAheadSelect: function() {
                        var e = this.filteredOptions[this.typeAheadPointer];
                        e && this.selectable(e) && this.select(e);
                    },
                    typeAheadToLastSelected: function() {
                        var e = 0 !== this.selectedValue.length ? this.filteredOptions.indexOf(this.selectedValue[this.selectedValue.length - 1]) : -1;
                        -1 !== e && (this.typeAheadPointer = e);
                    }
                }
            }, u = {
                props: {
                    loading: {
                        type: Boolean,
                        default: !1
                    }
                },
                data: function() {
                    return {
                        mutableLoading: !1
                    };
                },
                watch: {
                    search: function() {
                        this.$emit("search", this.search, this.toggleLoading);
                    },
                    loading: function(e) {
                        this.mutableLoading = e;
                    }
                },
                methods: {
                    toggleLoading: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                        return this.mutableLoading = null == e ? !this.mutableLoading : e;
                    }
                }
            };
            function p(e, t, n, o, i, s, r, a) {
                var l, c = "function" == typeof e ? e.options : e;
                if (t && (c.render = t, c.staticRenderFns = n, c._compiled = !0), o && (c.functional = !0), s && (c._scopeId = "data-v-" + s), r ? (l = function(e) {
                    (e = e || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (e = __VUE_SSR_CONTEXT__), i && i.call(this, e), e && e._registeredComponents && e._registeredComponents.add(r);
                }, c._ssrRegister = l) : i && (l = a ? function() {
                    i.call(this, (c.functional ? this.parent : this).$root.$options.shadowRoot);
                } : i), l) {
                    if (c.functional) {
                        c._injectStyles = l;
                        var u = c.render;
                        c.render = function(e, t) {
                            return l.call(t), u(e, t);
                        };
                    } else {
                        var p = c.beforeCreate;
                        c.beforeCreate = p ? [].concat(p, l) : [
                            l
                        ];
                    }
                }
                return {
                    exports: e,
                    options: c
                };
            }
            const h = {
                Deselect: p({}, function() {
                    var e = this.$createElement, t = this._self._c || e;
                    return t("svg", {
                        attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "10",
                            height: "10"
                        }
                    }, [
                        t("path", {
                            attrs: {
                                d: "M6.895455 5l2.842897-2.842898c.348864-.348863.348864-.914488 0-1.263636L9.106534.261648c-.348864-.348864-.914489-.348864-1.263636 0L5 3.104545 2.157102.261648c-.348863-.348864-.914488-.348864-1.263636 0L.261648.893466c-.348864.348864-.348864.914489 0 1.263636L3.104545 5 .261648 7.842898c-.348864.348863-.348864.914488 0 1.263636l.631818.631818c.348864.348864.914773.348864 1.263636 0L5 6.895455l2.842898 2.842897c.348863.348864.914772.348864 1.263636 0l.631818-.631818c.348864-.348864.348864-.914489 0-1.263636L6.895455 5z"
                            }
                        })
                    ]);
                }, [], !1, null, null, null).exports,
                OpenIndicator: p({}, function() {
                    var e = this.$createElement, t = this._self._c || e;
                    return t("svg", {
                        attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "14",
                            height: "10"
                        }
                    }, [
                        t("path", {
                            attrs: {
                                d: "M9.211364 7.59931l4.48338-4.867229c.407008-.441854.407008-1.158247 0-1.60046l-.73712-.80023c-.407008-.441854-1.066904-.441854-1.474243 0L7 5.198617 2.51662.33139c-.407008-.441853-1.066904-.441853-1.474243 0l-.737121.80023c-.407008.441854-.407008 1.158248 0 1.600461l4.48338 4.867228L7 10l2.211364-2.40069z"
                            }
                        })
                    ]);
                }, [], !1, null, null, null).exports
            }, d = {
                inserted: function(e, t, n) {
                    var o = n.context;
                    if (o.appendToBody) {
                        var i = o.$refs.toggle.getBoundingClientRect(), s = i.height, r = i.top, a = i.left, l = i.width, c = window.scrollX || window.pageXOffset, u = window.scrollY || window.pageYOffset;
                        e.unbindPosition = o.calculatePosition(e, o, {
                            width: l + "px",
                            left: c + a + "px",
                            top: u + r + s + "px"
                        }), document.body.appendChild(e);
                    }
                },
                unbind: function(e, t, n) {
                    n.context.appendToBody && (e.unbindPosition && "function" == typeof e.unbindPosition && e.unbindPosition(), e.parentNode && e.parentNode.removeChild(e));
                }
            };
            const f = function(e) {
                var t = {};
                return Object.keys(e).sort().forEach(function(n) {
                    t[n] = e[n];
                }), JSON.stringify(t);
            };
            var y = 0;
            const g = function() {
                return ++y;
            };
            function b(e, t) {
                var n = Object.keys(e);
                if (Object.getOwnPropertySymbols) {
                    var o = Object.getOwnPropertySymbols(e);
                    t && (o = o.filter(function(t) {
                        return Object.getOwnPropertyDescriptor(e, t).enumerable;
                    })), n.push.apply(n, o);
                }
                return n;
            }
            function v(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? b(Object(n), !0).forEach(function(t) {
                        a()(e, t, n[t]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : b(Object(n)).forEach(function(t) {
                        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                    });
                }
                return e;
            }
            const m = p({
                components: v({}, h),
                directives: {
                    appendToBody: d
                },
                mixins: [
                    l,
                    c,
                    u
                ],
                props: {
                    value: {},
                    components: {
                        type: Object,
                        default: function() {
                            return {};
                        }
                    },
                    options: {
                        type: Array,
                        default: function() {
                            return [];
                        }
                    },
                    disabled: {
                        type: Boolean,
                        default: !1
                    },
                    clearable: {
                        type: Boolean,
                        default: !0
                    },
                    deselectFromDropdown: {
                        type: Boolean,
                        default: !1
                    },
                    searchable: {
                        type: Boolean,
                        default: !0
                    },
                    multiple: {
                        type: Boolean,
                        default: !1
                    },
                    placeholder: {
                        type: String,
                        default: ""
                    },
                    transition: {
                        type: String,
                        default: "vs__fade"
                    },
                    clearSearchOnSelect: {
                        type: Boolean,
                        default: !0
                    },
                    closeOnSelect: {
                        type: Boolean,
                        default: !0
                    },
                    label: {
                        type: String,
                        default: "label"
                    },
                    autocomplete: {
                        type: String,
                        default: "off"
                    },
                    reduce: {
                        type: Function,
                        default: function(e) {
                            return e;
                        }
                    },
                    selectable: {
                        type: Function,
                        default: function(e) {
                            return !0;
                        }
                    },
                    getOptionLabel: {
                        type: Function,
                        default: function(e) {
                            return "object" === s()(e) ? e.hasOwnProperty(this.label) ? e[this.label] : console.warn('[vue-select warn]: Label key "option.'.concat(this.label, '" does not') + " exist in options object ".concat(JSON.stringify(e), ".\n") + "https://vue-select.org/api/props.html#getoptionlabel") : e;
                        }
                    },
                    getOptionKey: {
                        type: Function,
                        default: function(e) {
                            if ("object" !== s()(e)) return e;
                            try {
                                return e.hasOwnProperty("id") ? e.id : f(e);
                            } catch (t) {
                                return console.warn("[vue-select warn]: Could not stringify this option to generate unique key. Please provide'getOptionKey' prop to return a unique key for each option.\nhttps://vue-select.org/api/props.html#getoptionkey", e, t);
                            }
                        }
                    },
                    onTab: {
                        type: Function,
                        default: function() {
                            this.selectOnTab && !this.isComposing && this.typeAheadSelect();
                        }
                    },
                    taggable: {
                        type: Boolean,
                        default: !1
                    },
                    tabindex: {
                        type: Number,
                        default: null
                    },
                    pushTags: {
                        type: Boolean,
                        default: !1
                    },
                    filterable: {
                        type: Boolean,
                        default: !0
                    },
                    filterBy: {
                        type: Function,
                        default: function(e, t, n) {
                            return (t || "").toLocaleLowerCase().indexOf(n.toLocaleLowerCase()) > -1;
                        }
                    },
                    filter: {
                        type: Function,
                        default: function(e, t) {
                            var n = this;
                            return e.filter(function(e) {
                                var o = n.getOptionLabel(e);
                                return "number" == typeof o && (o = o.toString()), n.filterBy(e, o, t);
                            });
                        }
                    },
                    createOption: {
                        type: Function,
                        default: function(e) {
                            return "object" === s()(this.optionList[0]) ? a()({}, this.label, e) : e;
                        }
                    },
                    resetOnOptionsChange: {
                        default: !1,
                        validator: function(e) {
                            return [
                                "function",
                                "boolean"
                            ].includes(s()(e));
                        }
                    },
                    clearSearchOnBlur: {
                        type: Function,
                        default: function(e) {
                            var t = e.clearSearchOnSelect, n = e.multiple;
                            return t && !n;
                        }
                    },
                    noDrop: {
                        type: Boolean,
                        default: !1
                    },
                    inputId: {
                        type: String
                    },
                    dir: {
                        type: String,
                        default: "auto"
                    },
                    selectOnTab: {
                        type: Boolean,
                        default: !1
                    },
                    selectOnKeyCodes: {
                        type: Array,
                        default: function() {
                            return [
                                13
                            ];
                        }
                    },
                    searchInputQuerySelector: {
                        type: String,
                        default: "[type=search]"
                    },
                    mapKeydown: {
                        type: Function,
                        default: function(e, t) {
                            return e;
                        }
                    },
                    appendToBody: {
                        type: Boolean,
                        default: !1
                    },
                    calculatePosition: {
                        type: Function,
                        default: function(e, t, n) {
                            var o = n.width, i = n.top, s = n.left;
                            e.style.top = i, e.style.left = s, e.style.width = o;
                        }
                    },
                    dropdownShouldOpen: {
                        type: Function,
                        default: function(e) {
                            var t = e.noDrop, n = e.open, o = e.mutableLoading;
                            return !t && n && !o;
                        }
                    },
                    uid: {
                        type: [
                            String,
                            Number
                        ],
                        default: function() {
                            return g();
                        }
                    }
                },
                data: function() {
                    return {
                        search: "",
                        open: !1,
                        isComposing: !1,
                        pushedTags: [],
                        _value: []
                    };
                },
                computed: {
                    isTrackingValues: function() {
                        return void 0 === this.value || this.$options.propsData.hasOwnProperty("reduce");
                    },
                    selectedValue: function() {
                        var e = this.value;
                        return this.isTrackingValues && (e = this.$data._value), null != e && "" !== e ? [].concat(e) : [];
                    },
                    optionList: function() {
                        return this.options.concat(this.pushTags ? this.pushedTags : []);
                    },
                    searchEl: function() {
                        return this.$scopedSlots.search ? this.$refs.selectedOptions.querySelector(this.searchInputQuerySelector) : this.$refs.search;
                    },
                    scope: function() {
                        var e = this, t = {
                            search: this.search,
                            loading: this.loading,
                            searching: this.searching,
                            filteredOptions: this.filteredOptions
                        };
                        return {
                            search: {
                                attributes: v({
                                    disabled: this.disabled,
                                    placeholder: this.searchPlaceholder,
                                    tabindex: this.tabindex,
                                    readonly: !this.searchable,
                                    id: this.inputId,
                                    "aria-autocomplete": "list",
                                    "aria-labelledby": "vs".concat(this.uid, "__combobox"),
                                    "aria-controls": "vs".concat(this.uid, "__listbox"),
                                    ref: "search",
                                    type: "search",
                                    autocomplete: this.autocomplete,
                                    value: this.search
                                }, this.dropdownOpen && this.filteredOptions[this.typeAheadPointer] ? {
                                    "aria-activedescendant": "vs".concat(this.uid, "__option-").concat(this.typeAheadPointer)
                                } : {}),
                                events: {
                                    compositionstart: function() {
                                        return e.isComposing = !0;
                                    },
                                    compositionend: function() {
                                        return e.isComposing = !1;
                                    },
                                    keydown: this.onSearchKeyDown,
                                    keypress: this.onSearchKeyPress,
                                    blur: this.onSearchBlur,
                                    focus: this.onSearchFocus,
                                    input: function(t) {
                                        return e.search = t.target.value;
                                    }
                                }
                            },
                            spinner: {
                                loading: this.mutableLoading
                            },
                            noOptions: {
                                search: this.search,
                                loading: this.mutableLoading,
                                searching: this.searching
                            },
                            openIndicator: {
                                attributes: {
                                    ref: "openIndicator",
                                    role: "presentation",
                                    class: "vs__open-indicator"
                                }
                            },
                            listHeader: t,
                            listFooter: t,
                            header: v({}, t, {
                                deselect: this.deselect
                            }),
                            footer: v({}, t, {
                                deselect: this.deselect
                            })
                        };
                    },
                    childComponents: function() {
                        return v({}, h, {}, this.components);
                    },
                    stateClasses: function() {
                        return {
                            "vs--open": this.dropdownOpen,
                            "vs--single": !this.multiple,
                            "vs--multiple": this.multiple,
                            "vs--searching": this.searching && !this.noDrop,
                            "vs--searchable": this.searchable && !this.noDrop,
                            "vs--unsearchable": !this.searchable,
                            "vs--loading": this.mutableLoading,
                            "vs--disabled": this.disabled
                        };
                    },
                    searching: function() {
                        return !!this.search;
                    },
                    dropdownOpen: function() {
                        return this.dropdownShouldOpen(this);
                    },
                    searchPlaceholder: function() {
                        return this.isValueEmpty && this.placeholder ? this.placeholder : void 0;
                    },
                    filteredOptions: function() {
                        var e = [].concat(this.optionList);
                        if (!this.filterable && !this.taggable) return e;
                        var t = this.search.length ? this.filter(e, this.search, this) : e;
                        if (this.taggable && this.search.length) {
                            var n = this.createOption(this.search);
                            this.optionExists(n) || t.unshift(n);
                        }
                        return t;
                    },
                    isValueEmpty: function() {
                        return 0 === this.selectedValue.length;
                    },
                    showClearButton: function() {
                        return !this.multiple && this.clearable && !this.open && !this.isValueEmpty;
                    }
                },
                watch: {
                    options: function(e, t) {
                        var n = this;
                        !this.taggable && ("function" == typeof n.resetOnOptionsChange ? n.resetOnOptionsChange(e, t, n.selectedValue) : n.resetOnOptionsChange) && this.clearSelection(), this.value && this.isTrackingValues && this.setInternalValueFromOptions(this.value);
                    },
                    value: {
                        immediate: !0,
                        handler: function(e) {
                            this.isTrackingValues && this.setInternalValueFromOptions(e);
                        }
                    },
                    multiple: function() {
                        this.clearSelection();
                    },
                    open: function(e) {
                        this.$emit(e ? "open" : "close");
                    },
                    search: function(e) {
                        e.length && (this.open = !0);
                    }
                },
                created: function() {
                    this.mutableLoading = this.loading, this.$on("option:created", this.pushTag);
                },
                methods: {
                    setInternalValueFromOptions: function(e) {
                        var t = this;
                        Array.isArray(e) ? this.$data._value = e.map(function(e) {
                            return t.findOptionFromReducedValue(e);
                        }) : this.$data._value = this.findOptionFromReducedValue(e);
                    },
                    select: function(e) {
                        this.$emit("option:selecting", e), this.isOptionSelected(e) ? this.deselectFromDropdown && (this.clearable || this.multiple && this.selectedValue.length > 1) && this.deselect(e) : (this.taggable && !this.optionExists(e) && this.$emit("option:created", e), this.multiple && (e = this.selectedValue.concat(e)), this.updateValue(e), this.$emit("option:selected", e)), this.onAfterSelect(e);
                    },
                    deselect: function(e) {
                        var t = this;
                        this.$emit("option:deselecting", e), this.updateValue(this.selectedValue.filter(function(n) {
                            return !t.optionComparator(n, e);
                        })), this.$emit("option:deselected", e);
                    },
                    clearSelection: function() {
                        this.updateValue(this.multiple ? [] : null);
                    },
                    onAfterSelect: function(e) {
                        var t = this;
                        this.closeOnSelect && (this.open = !this.open), this.clearSearchOnSelect && (this.search = ""), this.noDrop && this.multiple && this.$nextTick(function() {
                            return t.$refs.search.focus();
                        });
                    },
                    updateValue: function(e) {
                        var t = this;
                        void 0 === this.value && (this.$data._value = e), null !== e && (e = Array.isArray(e) ? e.map(function(e) {
                            return t.reduce(e);
                        }) : this.reduce(e)), this.$emit("input", e);
                    },
                    toggleDropdown: function(e) {
                        var n = e.target !== this.searchEl;
                        n && e.preventDefault();
                        var o = [].concat(t()(this.$refs.deselectButtons || []), t()([
                            this.$refs.clearButton
                        ]));
                        void 0 === this.searchEl || o.filter(Boolean).some(function(t) {
                            return t.contains(e.target) || t === e.target;
                        }) ? e.preventDefault() : this.open && n ? this.searchEl.blur() : this.disabled || (this.open = !0, this.searchEl.focus());
                    },
                    isOptionSelected: function(e) {
                        var t = this;
                        return this.selectedValue.some(function(n) {
                            return t.optionComparator(n, e);
                        });
                    },
                    isOptionDeselectable: function(e) {
                        return this.isOptionSelected(e) && this.deselectFromDropdown;
                    },
                    optionComparator: function(e, t) {
                        return this.getOptionKey(e) === this.getOptionKey(t);
                    },
                    findOptionFromReducedValue: function(e) {
                        var n = this, o = [].concat(t()(this.options), t()(this.pushedTags)).filter(function(t) {
                            return JSON.stringify(n.reduce(t)) === JSON.stringify(e);
                        });
                        return 1 === o.length ? o[0] : o.find(function(e) {
                            return n.optionComparator(e, n.$data._value);
                        }) || e;
                    },
                    closeSearchOptions: function() {
                        this.open = !1, this.$emit("search:blur");
                    },
                    maybeDeleteValue: function() {
                        if (!this.searchEl.value.length && this.selectedValue && this.selectedValue.length && this.clearable) {
                            var e = null;
                            this.multiple && (e = t()(this.selectedValue.slice(0, this.selectedValue.length - 1))), this.updateValue(e);
                        }
                    },
                    optionExists: function(e) {
                        var t = this;
                        return this.optionList.some(function(n) {
                            return t.optionComparator(n, e);
                        });
                    },
                    normalizeOptionForSlot: function(e) {
                        return "object" === s()(e) ? e : a()({}, this.label, e);
                    },
                    pushTag: function(e) {
                        this.pushedTags.push(e);
                    },
                    onEscape: function() {
                        this.search.length ? this.search = "" : this.open = !1;
                    },
                    onSearchBlur: function() {
                        if (!this.mousedown || this.searching) {
                            var e = this.clearSearchOnSelect, t = this.multiple;
                            return this.clearSearchOnBlur({
                                clearSearchOnSelect: e,
                                multiple: t
                            }) && (this.search = ""), void this.closeSearchOptions();
                        }
                        this.mousedown = !1, 0 !== this.search.length || 0 !== this.options.length || this.closeSearchOptions();
                    },
                    onSearchFocus: function() {
                        this.open = !0, this.$emit("search:focus");
                    },
                    onMousedown: function() {
                        this.mousedown = !0;
                    },
                    onMouseUp: function() {
                        this.mousedown = !1;
                    },
                    onSearchKeyDown: function(e) {
                        var t = this, n = function(e) {
                            return e.preventDefault(), !t.isComposing && t.typeAheadSelect();
                        }, o = {
                            8: function(e) {
                                return t.maybeDeleteValue();
                            },
                            9: function(e) {
                                return t.onTab();
                            },
                            27: function(e) {
                                return t.onEscape();
                            },
                            38: function(e) {
                                if (e.preventDefault(), t.open) return t.typeAheadUp();
                                t.open = !0;
                            },
                            40: function(e) {
                                if (e.preventDefault(), t.open) return t.typeAheadDown();
                                t.open = !0;
                            }
                        };
                        this.selectOnKeyCodes.forEach(function(e) {
                            return o[e] = n;
                        });
                        var i = this.mapKeydown(o, this);
                        if ("function" == typeof i[e.keyCode]) return i[e.keyCode](e);
                    },
                    onSearchKeyPress: function(e) {
                        this.open || 32 !== e.keyCode || (e.preventDefault(), this.open = !0);
                    }
                }
            }, function() {
                var e = this, t = e.$createElement, n = e._self._c || t;
                return n("div", {
                    staticClass: "v-select",
                    class: e.stateClasses,
                    attrs: {
                        dir: e.dir
                    }
                }, [
                    e._t("header", null, null, e.scope.header),
                    e._v(" "),
                    n("div", {
                        ref: "toggle",
                        staticClass: "vs__dropdown-toggle",
                        attrs: {
                            id: "vs" + e.uid + "__combobox",
                            role: "combobox",
                            "aria-expanded": e.dropdownOpen.toString(),
                            "aria-owns": "vs" + e.uid + "__listbox",
                            "aria-label": "Search for option"
                        },
                        on: {
                            mousedown: function(t) {
                                return e.toggleDropdown(t);
                            }
                        }
                    }, [
                        n("div", {
                            ref: "selectedOptions",
                            staticClass: "vs__selected-options"
                        }, [
                            e._l(e.selectedValue, function(t) {
                                return e._t("selected-option-container", [
                                    n("span", {
                                        key: e.getOptionKey(t),
                                        staticClass: "vs__selected"
                                    }, [
                                        e._t("selected-option", [
                                            e._v("\n            " + e._s(e.getOptionLabel(t)) + "\n          ")
                                        ], null, e.normalizeOptionForSlot(t)),
                                        e._v(" "),
                                        e.multiple ? n("button", {
                                            ref: "deselectButtons",
                                            refInFor: !0,
                                            staticClass: "vs__deselect",
                                            attrs: {
                                                disabled: e.disabled,
                                                type: "button",
                                                title: "Deselect " + e.getOptionLabel(t),
                                                "aria-label": "Deselect " + e.getOptionLabel(t)
                                            },
                                            on: {
                                                click: function(n) {
                                                    return e.deselect(t);
                                                }
                                            }
                                        }, [
                                            n(e.childComponents.Deselect, {
                                                tag: "component"
                                            })
                                        ], 1) : e._e()
                                    ], 2)
                                ], {
                                    option: e.normalizeOptionForSlot(t),
                                    deselect: e.deselect,
                                    multiple: e.multiple,
                                    disabled: e.disabled
                                });
                            }),
                            e._v(" "),
                            e._t("search", [
                                n("input", e._g(e._b({
                                    staticClass: "vs__search"
                                }, "input", e.scope.search.attributes, !1), e.scope.search.events))
                            ], null, e.scope.search)
                        ], 2),
                        e._v(" "),
                        n("div", {
                            ref: "actions",
                            staticClass: "vs__actions"
                        }, [
                            n("button", {
                                directives: [
                                    {
                                        name: "show",
                                        rawName: "v-show",
                                        value: e.showClearButton,
                                        expression: "showClearButton"
                                    }
                                ],
                                ref: "clearButton",
                                staticClass: "vs__clear",
                                attrs: {
                                    disabled: e.disabled,
                                    type: "button",
                                    title: "Clear Selected",
                                    "aria-label": "Clear Selected"
                                },
                                on: {
                                    click: e.clearSelection
                                }
                            }, [
                                n(e.childComponents.Deselect, {
                                    tag: "component"
                                })
                            ], 1),
                            e._v(" "),
                            e._t("open-indicator", [
                                e.noDrop ? e._e() : n(e.childComponents.OpenIndicator, e._b({
                                    tag: "component"
                                }, "component", e.scope.openIndicator.attributes, !1))
                            ], null, e.scope.openIndicator),
                            e._v(" "),
                            e._t("spinner", [
                                n("div", {
                                    directives: [
                                        {
                                            name: "show",
                                            rawName: "v-show",
                                            value: e.mutableLoading,
                                            expression: "mutableLoading"
                                        }
                                    ],
                                    staticClass: "vs__spinner"
                                }, [
                                    e._v("Loading...")
                                ])
                            ], null, e.scope.spinner)
                        ], 2)
                    ]),
                    e._v(" "),
                    n("transition", {
                        attrs: {
                            name: e.transition
                        }
                    }, [
                        e.dropdownOpen ? n("ul", {
                            directives: [
                                {
                                    name: "append-to-body",
                                    rawName: "v-append-to-body"
                                }
                            ],
                            key: "vs" + e.uid + "__listbox",
                            ref: "dropdownMenu",
                            staticClass: "vs__dropdown-menu",
                            attrs: {
                                id: "vs" + e.uid + "__listbox",
                                role: "listbox",
                                tabindex: "-1"
                            },
                            on: {
                                mousedown: function(t) {
                                    return t.preventDefault(), e.onMousedown(t);
                                },
                                mouseup: e.onMouseUp
                            }
                        }, [
                            e._t("list-header", null, null, e.scope.listHeader),
                            e._v(" "),
                            e._l(e.filteredOptions, function(t, o) {
                                return n("li", {
                                    key: e.getOptionKey(t),
                                    staticClass: "vs__dropdown-option",
                                    class: {
                                        "vs__dropdown-option--deselect": e.isOptionDeselectable(t) && o === e.typeAheadPointer,
                                        "vs__dropdown-option--selected": e.isOptionSelected(t),
                                        "vs__dropdown-option--highlight": o === e.typeAheadPointer,
                                        "vs__dropdown-option--disabled": !e.selectable(t)
                                    },
                                    attrs: {
                                        id: "vs" + e.uid + "__option-" + o,
                                        role: "option",
                                        "aria-selected": o === e.typeAheadPointer || null
                                    },
                                    on: {
                                        mouseover: function(n) {
                                            e.selectable(t) && (e.typeAheadPointer = o);
                                        },
                                        click: function(n) {
                                            n.preventDefault(), n.stopPropagation(), e.selectable(t) && e.select(t);
                                        }
                                    }
                                }, [
                                    e._t("option", [
                                        e._v("\n          " + e._s(e.getOptionLabel(t)) + "\n        ")
                                    ], null, e.normalizeOptionForSlot(t))
                                ], 2);
                            }),
                            e._v(" "),
                            0 === e.filteredOptions.length ? n("li", {
                                staticClass: "vs__no-options"
                            }, [
                                e._t("no-options", [
                                    e._v("\n          Sorry, no matching options.\n        ")
                                ], null, e.scope.noOptions)
                            ], 2) : e._e(),
                            e._v(" "),
                            e._t("list-footer", null, null, e.scope.listFooter)
                        ], 2) : n("ul", {
                            staticStyle: {
                                display: "none",
                                visibility: "hidden"
                            },
                            attrs: {
                                id: "vs" + e.uid + "__listbox",
                                role: "listbox"
                            }
                        })
                    ]),
                    e._v(" "),
                    e._t("footer", null, null, e.scope.footer)
                ], 2);
            }, [], !1, null, null, null).exports, _ = {
                ajax: u,
                pointer: c,
                pointerScroll: l
            }, O = m;
        })(), o;
    })();
});



let $d234ab82734ed330$var$script;




let $d234ab82734ed330$var$initialize = ()=>{
    $d234ab82734ed330$var$script = (parcelRequire("kBln0"));
    if ($d234ab82734ed330$var$script.__esModule) $d234ab82734ed330$var$script = $d234ab82734ed330$var$script.default;
    $d234ab82734ed330$var$script.render = (parcelRequire("5QPlT")).render;
    $d234ab82734ed330$var$script.staticRenderFns = (parcelRequire("5QPlT")).staticRenderFns;
    $d234ab82734ed330$var$script._scopeId = "data-v-4d6017";
    (parcelRequire("3n25D")).default($d234ab82734ed330$var$script);
    $d234ab82734ed330$var$script.__scopeId = "data-v-4d6017";
    $d234ab82734ed330$var$script.__file = "EstateOverview.vue";
};
$d234ab82734ed330$var$initialize();
var $d234ab82734ed330$export$2e2bcd8739ae039 = $d234ab82734ed330$var$script;


var $bfe465c47986393c$exports = {};
parcelRequire = function(e, r, t, n) {
    var i, o = "function" == typeof parcelRequire && parcelRequire, u = undefined;
    function f(t, n) {
        if (!r[t]) {
            if (!e[t]) {
                var i = "function" == typeof parcelRequire && parcelRequire;
                if (!n && i) return i(t, !0);
                if (o) return o(t, !0);
                if (u && "string" == typeof t) return u(t);
                var c = new Error("Cannot find module '" + t + "'");
                throw c.code = "MODULE_NOT_FOUND", c;
            }
            p.resolve = function(r) {
                return e[t][1][r] || r;
            }, p.cache = {};
            var l = r[t] = new f.Module(t);
            e[t][0].call(l.exports, p, l, l.exports, this);
        }
        return r[t].exports;
        function p(e) {
            return f(p.resolve(e));
        }
    }
    f.isParcelRequire = !0, f.Module = function(e) {
        this.id = e, this.bundle = f, this.exports = {};
    }, f.modules = e, f.cache = r, f.parent = o, f.register = function(r, t) {
        e[r] = [
            function(e, r) {
                r.exports = t;
            },
            {}
        ];
    };
    for(var c = 0; c < t.length; c++)try {
        f(t[c]);
    } catch (e) {
        i || (i = e);
    }
    if (t.length) {
        var l = f(t[t.length - 1]);
        $bfe465c47986393c$exports = l;
    }
    if (parcelRequire = f, i) throw i;
    return f;
}({
    "nb4k": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(r, n) {
                return function() {
                    for(var t = new Array(arguments.length), e = 0; e < t.length; e++)t[e] = arguments[e];
                    return r.apply(n, t);
                };
            };
        },
        {}
    ],
    "zIVT": [
        function(require1, module1, exports) {
            "use strict";
            var r = require1("./helpers/bind"), t = Object.prototype.toString;
            function n(r) {
                return "[object Array]" === t.call(r);
            }
            function e(r) {
                return void 0 === r;
            }
            function o(r) {
                return null !== r && !e(r) && null !== r.constructor && !e(r.constructor) && "function" == typeof r.constructor.isBuffer && r.constructor.isBuffer(r);
            }
            function i(r) {
                return "[object ArrayBuffer]" === t.call(r);
            }
            function u(r) {
                return "undefined" != typeof FormData && r instanceof FormData;
            }
            function c(r) {
                return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView ? ArrayBuffer.isView(r) : r && r.buffer && r.buffer instanceof ArrayBuffer;
            }
            function f(r) {
                return "string" == typeof r;
            }
            function a(r) {
                return "number" == typeof r;
            }
            function l(r) {
                return null !== r && "object" == typeof r;
            }
            function s(r) {
                if ("[object Object]" !== t.call(r)) return !1;
                var n = Object.getPrototypeOf(r);
                return null === n || n === Object.prototype;
            }
            function p(r) {
                return "[object Date]" === t.call(r);
            }
            function d(r) {
                return "[object File]" === t.call(r);
            }
            function y(r) {
                return "[object Blob]" === t.call(r);
            }
            function b(r) {
                return "[object Function]" === t.call(r);
            }
            function j(r) {
                return l(r) && b(r.pipe);
            }
            function v(r) {
                return "undefined" != typeof URLSearchParams && r instanceof URLSearchParams;
            }
            function B(r) {
                return r.replace(/^\s*/, "").replace(/\s*$/, "");
            }
            function m() {
                return ("undefined" == typeof navigator || "ReactNative" !== navigator.product && "NativeScript" !== navigator.product && "NS" !== navigator.product) && "undefined" != typeof window && "undefined" != typeof document;
            }
            function g(r, t) {
                if (null != r) {
                    if ("object" != typeof r && (r = [
                        r
                    ]), n(r)) for(var e = 0, o = r.length; e < o; e++)t.call(null, r[e], e, r);
                    else for(var i in r)Object.prototype.hasOwnProperty.call(r, i) && t.call(null, r[i], i, r);
                }
            }
            function A() {
                var r = {};
                function t(t, e) {
                    s(r[e]) && s(t) ? r[e] = A(r[e], t) : s(t) ? r[e] = A({}, t) : n(t) ? r[e] = t.slice() : r[e] = t;
                }
                for(var e = 0, o = arguments.length; e < o; e++)g(arguments[e], t);
                return r;
            }
            function O(t, n, e) {
                return g(n, function(n, o) {
                    t[o] = e && "function" == typeof n ? r(n, e) : n;
                }), t;
            }
            function h(r) {
                return 65279 === r.charCodeAt(0) && (r = r.slice(1)), r;
            }
            module1.exports = {
                isArray: n,
                isArrayBuffer: i,
                isBuffer: o,
                isFormData: u,
                isArrayBufferView: c,
                isString: f,
                isNumber: a,
                isObject: l,
                isPlainObject: s,
                isUndefined: e,
                isDate: p,
                isFile: d,
                isBlob: y,
                isFunction: b,
                isStream: j,
                isURLSearchParams: v,
                isStandardBrowserEnv: m,
                forEach: g,
                merge: A,
                extend: O,
                trim: B,
                stripBOM: h
            };
        },
        {
            "./helpers/bind": "nb4k"
        }
    ],
    "RS1v": [
        function(require1, module1, exports) {
            "use strict";
            var e = require1("./../utils");
            function r(e) {
                return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
            }
            module1.exports = function(i, n, t) {
                if (!n) return i;
                var a;
                if (t) a = t(n);
                else if (e.isURLSearchParams(n)) a = n.toString();
                else {
                    var c = [];
                    e.forEach(n, function(i, n) {
                        null != i && (e.isArray(i) ? n += "[]" : i = [
                            i
                        ], e.forEach(i, function(i) {
                            e.isDate(i) ? i = i.toISOString() : e.isObject(i) && (i = JSON.stringify(i)), c.push(r(n) + "=" + r(i));
                        }));
                    }), a = c.join("&");
                }
                if (a) {
                    var o = i.indexOf("#");
                    -1 !== o && (i = i.slice(0, o)), i += (-1 === i.indexOf("?") ? "?" : "&") + a;
                }
                return i;
            };
        },
        {
            "./../utils": "zIVT"
        }
    ],
    "GGkJ": [
        function(require1, module1, exports) {
            "use strict";
            var t = require1("./../utils");
            function e() {
                this.handlers = [];
            }
            e.prototype.use = function(t, e) {
                return this.handlers.push({
                    fulfilled: t,
                    rejected: e
                }), this.handlers.length - 1;
            }, e.prototype.eject = function(t) {
                this.handlers[t] && (this.handlers[t] = null);
            }, e.prototype.forEach = function(e) {
                t.forEach(this.handlers, function(t) {
                    null !== t && e(t);
                });
            }, module1.exports = e;
        },
        {
            "./../utils": "zIVT"
        }
    ],
    "i7gz": [
        function(require1, module1, exports) {
            "use strict";
            var r = require1("./../utils");
            module1.exports = function(t, u, e) {
                return r.forEach(e, function(r) {
                    t = r(t, u);
                }), t;
            };
        },
        {
            "./../utils": "zIVT"
        }
    ],
    "C9l1": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(t) {
                return !(!t || !t.__CANCEL__);
            };
        },
        {}
    ],
    "TOXd": [
        function(require1, module1, exports) {
            "use strict";
            var e = require1("../utils");
            module1.exports = function(t, r) {
                e.forEach(t, function(e, o) {
                    o !== r && o.toUpperCase() === r.toUpperCase() && (t[r] = e, delete t[o]);
                });
            };
        },
        {
            "../utils": "zIVT"
        }
    ],
    "obgR": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(e, i, s, t, n) {
                return e.config = i, s && (e.code = s), e.request = t, e.response = n, e.isAxiosError = !0, e.toJSON = function() {
                    return {
                        message: this.message,
                        name: this.name,
                        description: this.description,
                        number: this.number,
                        fileName: this.fileName,
                        lineNumber: this.lineNumber,
                        columnNumber: this.columnNumber,
                        stack: this.stack,
                        config: this.config,
                        code: this.code
                    };
                }, e;
            };
        },
        {}
    ],
    "lGrg": [
        function(require1, module1, exports) {
            "use strict";
            var r = require1("./enhanceError");
            module1.exports = function(e, n, o, t, u) {
                var a = new Error(e);
                return r(a, n, o, t, u);
            };
        },
        {
            "./enhanceError": "obgR"
        }
    ],
    "wZW9": [
        function(require1, module1, exports) {
            "use strict";
            var t = require1("./createError");
            module1.exports = function(e, s, u) {
                var a = u.config.validateStatus;
                u.status && a && !a(u.status) ? s(t("Request failed with status code " + u.status, u.config, null, u.request, u)) : e(u);
            };
        },
        {
            "./createError": "lGrg"
        }
    ],
    "OhlP": [
        function(require1, module1, exports) {
            "use strict";
            var e = require1("./../utils");
            module1.exports = e.isStandardBrowserEnv() ? {
                write: function(n, t, o, r, i, u) {
                    var s = [];
                    s.push(n + "=" + encodeURIComponent(t)), e.isNumber(o) && s.push("expires=" + new Date(o).toGMTString()), e.isString(r) && s.push("path=" + r), e.isString(i) && s.push("domain=" + i), !0 === u && s.push("secure"), document.cookie = s.join("; ");
                },
                read: function(e) {
                    var n = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
                    return n ? decodeURIComponent(n[3]) : null;
                },
                remove: function(e) {
                    this.write(e, "", Date.now() - 864e5);
                }
            } : {
                write: function() {},
                read: function() {
                    return null;
                },
                remove: function() {}
            };
        },
        {
            "./../utils": "zIVT"
        }
    ],
    "ExB0": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(t) {
                return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(t);
            };
        },
        {}
    ],
    "BTlr": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(e, r) {
                return r ? e.replace(/\/+$/, "") + "/" + r.replace(/^\/+/, "") : e;
            };
        },
        {}
    ],
    "d0lp": [
        function(require1, module1, exports) {
            "use strict";
            var e = require1("../helpers/isAbsoluteURL"), r = require1("../helpers/combineURLs");
            module1.exports = function(s, u) {
                return s && !e(u) ? r(s, u) : u;
            };
        },
        {
            "../helpers/isAbsoluteURL": "ExB0",
            "../helpers/combineURLs": "BTlr"
        }
    ],
    "T8HP": [
        function(require1, module1, exports) {
            "use strict";
            var e = require1("./../utils"), t = [
                "age",
                "authorization",
                "content-length",
                "content-type",
                "etag",
                "expires",
                "from",
                "host",
                "if-modified-since",
                "if-unmodified-since",
                "last-modified",
                "location",
                "max-forwards",
                "proxy-authorization",
                "referer",
                "retry-after",
                "user-agent"
            ];
            module1.exports = function(r) {
                var i, o, n, s = {};
                return r ? (e.forEach(r.split("\n"), function(r) {
                    if (n = r.indexOf(":"), i = e.trim(r.substr(0, n)).toLowerCase(), o = e.trim(r.substr(n + 1)), i) {
                        if (s[i] && t.indexOf(i) >= 0) return;
                        s[i] = "set-cookie" === i ? (s[i] ? s[i] : []).concat([
                            o
                        ]) : s[i] ? s[i] + ", " + o : o;
                    }
                }), s) : s;
            };
        },
        {
            "./../utils": "zIVT"
        }
    ],
    "DmB6": [
        function(require1, module1, exports) {
            "use strict";
            var t = require1("./../utils");
            module1.exports = t.isStandardBrowserEnv() ? function() {
                var r, e = /(msie|trident)/i.test(navigator.userAgent), o = document.createElement("a");
                function a(t) {
                    var r = t;
                    return e && (o.setAttribute("href", r), r = o.href), o.setAttribute("href", r), {
                        href: o.href,
                        protocol: o.protocol ? o.protocol.replace(/:$/, "") : "",
                        host: o.host,
                        search: o.search ? o.search.replace(/^\?/, "") : "",
                        hash: o.hash ? o.hash.replace(/^#/, "") : "",
                        hostname: o.hostname,
                        port: o.port,
                        pathname: "/" === o.pathname.charAt(0) ? o.pathname : "/" + o.pathname
                    };
                }
                return r = a(window.location.href), function(e) {
                    var o = t.isString(e) ? a(e) : e;
                    return o.protocol === r.protocol && o.host === r.host;
                };
            }() : function() {
                return !0;
            };
        },
        {
            "./../utils": "zIVT"
        }
    ],
    "LYEs": [
        function(require1, module1, exports) {
            "use strict";
            var e = require1("./../utils"), r = require1("./../core/settle"), t = require1("./../helpers/cookies"), s = require1("./../helpers/buildURL"), o = require1("../core/buildFullPath"), n = require1("./../helpers/parseHeaders"), a = require1("./../helpers/isURLSameOrigin"), i = require1("../core/createError");
            module1.exports = function(u) {
                return new Promise(function(l, d) {
                    var p = u.data, c = u.headers;
                    e.isFormData(p) && delete c["Content-Type"], (e.isBlob(p) || e.isFile(p)) && p.type && delete c["Content-Type"];
                    var f = new XMLHttpRequest;
                    if (u.auth) {
                        var h = u.auth.username || "", m = unescape(encodeURIComponent(u.auth.password)) || "";
                        c.Authorization = "Basic " + btoa(h + ":" + m);
                    }
                    var y = o(u.baseURL, u.url);
                    if (f.open(u.method.toUpperCase(), s(y, u.params, u.paramsSerializer), !0), f.timeout = u.timeout, f.onreadystatechange = function() {
                        if (f && 4 === f.readyState && (0 !== f.status || f.responseURL && 0 === f.responseURL.indexOf("file:"))) {
                            var e = "getAllResponseHeaders" in f ? n(f.getAllResponseHeaders()) : null, t = {
                                data: u.responseType && "text" !== u.responseType ? f.response : f.responseText,
                                status: f.status,
                                statusText: f.statusText,
                                headers: e,
                                config: u,
                                request: f
                            };
                            r(l, d, t), f = null;
                        }
                    }, f.onabort = function() {
                        f && (d(i("Request aborted", u, "ECONNABORTED", f)), f = null);
                    }, f.onerror = function() {
                        d(i("Network Error", u, null, f)), f = null;
                    }, f.ontimeout = function() {
                        var e = "timeout of " + u.timeout + "ms exceeded";
                        u.timeoutErrorMessage && (e = u.timeoutErrorMessage), d(i(e, u, "ECONNABORTED", f)), f = null;
                    }, e.isStandardBrowserEnv()) {
                        var T = (u.withCredentials || a(y)) && u.xsrfCookieName ? t.read(u.xsrfCookieName) : void 0;
                        T && (c[u.xsrfHeaderName] = T);
                    }
                    if ("setRequestHeader" in f && e.forEach(c, function(e, r) {
                        void 0 === p && "content-type" === r.toLowerCase() ? delete c[r] : f.setRequestHeader(r, e);
                    }), e.isUndefined(u.withCredentials) || (f.withCredentials = !!u.withCredentials), u.responseType) try {
                        f.responseType = u.responseType;
                    } catch (R) {
                        if ("json" !== u.responseType) throw R;
                    }
                    "function" == typeof u.onDownloadProgress && f.addEventListener("progress", u.onDownloadProgress), "function" == typeof u.onUploadProgress && f.upload && f.upload.addEventListener("progress", u.onUploadProgress), u.cancelToken && u.cancelToken.promise.then(function(e) {
                        f && (f.abort(), d(e), f = null);
                    }), p || (p = null), f.send(p);
                });
            };
        },
        {
            "./../utils": "zIVT",
            "./../core/settle": "wZW9",
            "./../helpers/cookies": "OhlP",
            "./../helpers/buildURL": "RS1v",
            "../core/buildFullPath": "d0lp",
            "./../helpers/parseHeaders": "T8HP",
            "./../helpers/isURLSameOrigin": "DmB6",
            "../core/createError": "lGrg"
        }
    ],
    "rH1J": [
        function(require1, module1, exports) {
            var t, e, n = module1.exports = {};
            function r() {
                throw new Error("setTimeout has not been defined");
            }
            function o() {
                throw new Error("clearTimeout has not been defined");
            }
            function i(e) {
                if (t === setTimeout) return setTimeout(e, 0);
                if ((t === r || !t) && setTimeout) return t = setTimeout, setTimeout(e, 0);
                try {
                    return t(e, 0);
                } catch (n) {
                    try {
                        return t.call(null, e, 0);
                    } catch (n) {
                        return t.call(this, e, 0);
                    }
                }
            }
            function u(t) {
                if (e === clearTimeout) return clearTimeout(t);
                if ((e === o || !e) && clearTimeout) return e = clearTimeout, clearTimeout(t);
                try {
                    return e(t);
                } catch (n) {
                    try {
                        return e.call(null, t);
                    } catch (n) {
                        return e.call(this, t);
                    }
                }
            }
            !function() {
                try {
                    t = "function" == typeof setTimeout ? setTimeout : r;
                } catch (n) {
                    t = r;
                }
                try {
                    e = "function" == typeof clearTimeout ? clearTimeout : o;
                } catch (n) {
                    e = o;
                }
            }();
            var c, s = [], l = !1, a = -1;
            function f() {
                l && c && (l = !1, c.length ? s = c.concat(s) : a = -1, s.length && h());
            }
            function h() {
                if (!l) {
                    var t = i(f);
                    l = !0;
                    for(var e = s.length; e;){
                        for(c = s, s = []; ++a < e;)c && c[a].run();
                        a = -1, e = s.length;
                    }
                    c = null, l = !1, u(t);
                }
            }
            function m(t, e) {
                this.fun = t, this.array = e;
            }
            function p() {}
            n.nextTick = function(t) {
                var e = new Array(arguments.length - 1);
                if (arguments.length > 1) for(var n = 1; n < arguments.length; n++)e[n - 1] = arguments[n];
                s.push(new m(t, e)), 1 !== s.length || l || i(h);
            }, m.prototype.run = function() {
                this.fun.apply(null, this.array);
            }, n.title = "browser", n.env = {}, n.argv = [], n.version = "", n.versions = {}, n.on = p, n.addListener = p, n.once = p, n.off = p, n.removeListener = p, n.removeAllListeners = p, n.emit = p, n.prependListener = p, n.prependOnceListener = p, n.listeners = function(t) {
                return [];
            }, n.binding = function(t) {
                throw new Error("process.binding is not supported");
            }, n.cwd = function() {
                return "/";
            }, n.chdir = function(t) {
                throw new Error("process.chdir is not supported");
            }, n.umask = function() {
                return 0;
            };
        },
        {}
    ],
    "T2kP": [
        function(require1, module1, exports) {
            var process = require1("process");
            var e = require1("process"), t = require1("./utils"), r = require1("./helpers/normalizeHeaderName"), n = {
                "Content-Type": "application/x-www-form-urlencoded"
            };
            function a(e, r) {
                !t.isUndefined(e) && t.isUndefined(e["Content-Type"]) && (e["Content-Type"] = r);
            }
            function i() {
                var t;
                return "undefined" != typeof XMLHttpRequest ? t = require1("./adapters/xhr") : void 0 !== e && "[object process]" === Object.prototype.toString.call(e) && (t = require1("./adapters/http")), t;
            }
            var o = {
                adapter: i(),
                transformRequest: [
                    function(e, n) {
                        return r(n, "Accept"), r(n, "Content-Type"), t.isFormData(e) || t.isArrayBuffer(e) || t.isBuffer(e) || t.isStream(e) || t.isFile(e) || t.isBlob(e) ? e : t.isArrayBufferView(e) ? e.buffer : t.isURLSearchParams(e) ? (a(n, "application/x-www-form-urlencoded;charset=utf-8"), e.toString()) : t.isObject(e) ? (a(n, "application/json;charset=utf-8"), JSON.stringify(e)) : e;
                    }
                ],
                transformResponse: [
                    function(e) {
                        if ("string" == typeof e) try {
                            e = JSON.parse(e);
                        } catch (t) {}
                        return e;
                    }
                ],
                timeout: 0,
                xsrfCookieName: "XSRF-TOKEN",
                xsrfHeaderName: "X-XSRF-TOKEN",
                maxContentLength: -1,
                maxBodyLength: -1,
                validateStatus: function(e) {
                    return e >= 200 && e < 300;
                },
                headers: {
                    common: {
                        Accept: "application/json, text/plain, */*"
                    }
                }
            };
            t.forEach([
                "delete",
                "get",
                "head"
            ], function(e) {
                o.headers[e] = {};
            }), t.forEach([
                "post",
                "put",
                "patch"
            ], function(e) {
                o.headers[e] = t.merge(n);
            }), module1.exports = o;
        },
        {
            "./utils": "zIVT",
            "./helpers/normalizeHeaderName": "TOXd",
            "./adapters/xhr": "LYEs",
            "./adapters/http": "LYEs",
            "process": "rH1J"
        }
    ],
    "U2VI": [
        function(require1, module1, exports) {
            "use strict";
            var e = require1("./../utils"), r = require1("./transformData"), a = require1("../cancel/isCancel"), t = require1("../defaults");
            function s(e) {
                e.cancelToken && e.cancelToken.throwIfRequested();
            }
            module1.exports = function(n) {
                return s(n), n.headers = n.headers || {}, n.data = r(n.data, n.headers, n.transformRequest), n.headers = e.merge(n.headers.common || {}, n.headers[n.method] || {}, n.headers), e.forEach([
                    "delete",
                    "get",
                    "head",
                    "post",
                    "put",
                    "patch",
                    "common"
                ], function(e) {
                    delete n.headers[e];
                }), (n.adapter || t.adapter)(n).then(function(e) {
                    return s(n), e.data = r(e.data, e.headers, n.transformResponse), e;
                }, function(e) {
                    return a(e) || (s(n), e && e.response && (e.response.data = r(e.response.data, e.response.headers, n.transformResponse))), Promise.reject(e);
                });
            };
        },
        {
            "./../utils": "zIVT",
            "./transformData": "i7gz",
            "../cancel/isCancel": "C9l1",
            "../defaults": "T2kP"
        }
    ],
    "Qj6T": [
        function(require1, module1, exports) {
            "use strict";
            var e = require1("../utils");
            module1.exports = function(n, t) {
                t = t || {};
                var r = {}, o = [
                    "url",
                    "method",
                    "data"
                ], i = [
                    "headers",
                    "auth",
                    "proxy",
                    "params"
                ], a = [
                    "baseURL",
                    "transformRequest",
                    "transformResponse",
                    "paramsSerializer",
                    "timeout",
                    "timeoutMessage",
                    "withCredentials",
                    "adapter",
                    "responseType",
                    "xsrfCookieName",
                    "xsrfHeaderName",
                    "onUploadProgress",
                    "onDownloadProgress",
                    "decompress",
                    "maxContentLength",
                    "maxBodyLength",
                    "maxRedirects",
                    "transport",
                    "httpAgent",
                    "httpsAgent",
                    "cancelToken",
                    "socketPath",
                    "responseEncoding"
                ], s = [
                    "validateStatus"
                ];
                function c(n, t) {
                    return e.isPlainObject(n) && e.isPlainObject(t) ? e.merge(n, t) : e.isPlainObject(t) ? e.merge({}, t) : e.isArray(t) ? t.slice() : t;
                }
                function d(o) {
                    e.isUndefined(t[o]) ? e.isUndefined(n[o]) || (r[o] = c(void 0, n[o])) : r[o] = c(n[o], t[o]);
                }
                e.forEach(o, function(n) {
                    e.isUndefined(t[n]) || (r[n] = c(void 0, t[n]));
                }), e.forEach(i, d), e.forEach(a, function(o) {
                    e.isUndefined(t[o]) ? e.isUndefined(n[o]) || (r[o] = c(void 0, n[o])) : r[o] = c(void 0, t[o]);
                }), e.forEach(s, function(e) {
                    e in t ? r[e] = c(n[e], t[e]) : e in n && (r[e] = c(void 0, n[e]));
                });
                var f = o.concat(i).concat(a).concat(s), u = Object.keys(n).concat(Object.keys(t)).filter(function(e) {
                    return -1 === f.indexOf(e);
                });
                return e.forEach(u, d), r;
            };
        },
        {
            "../utils": "zIVT"
        }
    ],
    "RB6n": [
        function(require1, module1, exports) {
            "use strict";
            var e = require1("./../utils"), t = require1("../helpers/buildURL"), r = require1("./InterceptorManager"), o = require1("./dispatchRequest"), s = require1("./mergeConfig");
            function i(e) {
                this.defaults = e, this.interceptors = {
                    request: new r,
                    response: new r
                };
            }
            i.prototype.request = function(e) {
                "string" == typeof e ? (e = arguments[1] || {}).url = arguments[0] : e = e || {}, (e = s(this.defaults, e)).method ? e.method = e.method.toLowerCase() : this.defaults.method ? e.method = this.defaults.method.toLowerCase() : e.method = "get";
                var t = [
                    o,
                    void 0
                ], r = Promise.resolve(e);
                for(this.interceptors.request.forEach(function(e) {
                    t.unshift(e.fulfilled, e.rejected);
                }), this.interceptors.response.forEach(function(e) {
                    t.push(e.fulfilled, e.rejected);
                }); t.length;)r = r.then(t.shift(), t.shift());
                return r;
            }, i.prototype.getUri = function(e) {
                return e = s(this.defaults, e), t(e.url, e.params, e.paramsSerializer).replace(/^\?/, "");
            }, e.forEach([
                "delete",
                "get",
                "head",
                "options"
            ], function(e) {
                i.prototype[e] = function(t, r) {
                    return this.request(s(r || {}, {
                        method: e,
                        url: t
                    }));
                };
            }), e.forEach([
                "post",
                "put",
                "patch"
            ], function(e) {
                i.prototype[e] = function(t, r, o) {
                    return this.request(s(o || {}, {
                        method: e,
                        url: t,
                        data: r
                    }));
                };
            }), module1.exports = i;
        },
        {
            "./../utils": "zIVT",
            "../helpers/buildURL": "RS1v",
            "./InterceptorManager": "GGkJ",
            "./dispatchRequest": "U2VI",
            "./mergeConfig": "Qj6T"
        }
    ],
    "RlDD": [
        function(require1, module1, exports) {
            "use strict";
            function t(t) {
                this.message = t;
            }
            t.prototype.toString = function() {
                return "Cancel" + (this.message ? ": " + this.message : "");
            }, t.prototype.__CANCEL__ = !0, module1.exports = t;
        },
        {}
    ],
    "VWBb": [
        function(require1, module1, exports) {
            "use strict";
            var e = require1("./Cancel");
            function n(n) {
                if ("function" != typeof n) throw new TypeError("executor must be a function.");
                var o;
                this.promise = new Promise(function(e) {
                    o = e;
                });
                var r = this;
                n(function(n) {
                    r.reason || (r.reason = new e(n), o(r.reason));
                });
            }
            n.prototype.throwIfRequested = function() {
                if (this.reason) throw this.reason;
            }, n.source = function() {
                var e;
                return {
                    token: new n(function(n) {
                        e = n;
                    }),
                    cancel: e
                };
            }, module1.exports = n;
        },
        {
            "./Cancel": "RlDD"
        }
    ],
    "Kbjq": [
        function(require1, module1, exports) {
            "use strict";
            module1.exports = function(n) {
                return function(t) {
                    return n.apply(null, t);
                };
            };
        },
        {}
    ],
    "HXpE": [
        function(require1, module1, exports) {
            "use strict";
            var e = require1("./utils"), r = require1("./helpers/bind"), n = require1("./core/Axios"), u = require1("./core/mergeConfig"), t = require1("./defaults");
            function i(u) {
                var t = new n(u), i = r(n.prototype.request, t);
                return e.extend(i, n.prototype, t), e.extend(i, t), i;
            }
            var l = i(t);
            l.Axios = n, l.create = function(e) {
                return i(u(l.defaults, e));
            }, l.Cancel = require1("./cancel/Cancel"), l.CancelToken = require1("./cancel/CancelToken"), l.isCancel = require1("./cancel/isCancel"), l.all = function(e) {
                return Promise.all(e);
            }, l.spread = require1("./helpers/spread"), module1.exports = l, module1.exports.default = l;
        },
        {
            "./utils": "zIVT",
            "./helpers/bind": "nb4k",
            "./core/Axios": "RB6n",
            "./core/mergeConfig": "Qj6T",
            "./defaults": "T2kP",
            "./cancel/Cancel": "RlDD",
            "./cancel/CancelToken": "VWBb",
            "./cancel/isCancel": "C9l1",
            "./helpers/spread": "Kbjq"
        }
    ],
    "uj17": [
        function(require1, module1, exports) {
            module1.exports = require1("./lib/axios");
        },
        {
            "./lib/axios": "HXpE"
        }
    ],
    "eeO1": [
        function(require1, module1, exports) {
            var global = arguments[3];
            var process = require1("process");
            var define;
            var e, t = arguments[3], n = require1("process");
            !function(e, t) {
                "use strict";
                "object" == typeof module1 && "object" == typeof module1.exports ? module1.exports = e.document ? t(e, !0) : function(e) {
                    if (!e.document) throw new Error("jQuery requires a window with a document");
                    return t(e);
                } : t(e);
            }("undefined" != typeof window ? window : this, function(t, n) {
                "use strict";
                var r = [], i = Object.getPrototypeOf, o = r.slice, a = r.flat ? function(e) {
                    return r.flat.call(e);
                } : function(e) {
                    return r.concat.apply([], e);
                }, s = r.push, u = r.indexOf, l = {}, c = l.toString, f = l.hasOwnProperty, p = f.toString, d = p.call(Object), h = {}, g = function(e) {
                    return "function" == typeof e && "number" != typeof e.nodeType && "function" != typeof e.item;
                }, v = function(e) {
                    return null != e && e === e.window;
                }, y = t.document, m = {
                    type: !0,
                    src: !0,
                    nonce: !0,
                    noModule: !0
                };
                function x(e, t, n) {
                    var r, i, o = (n = n || y).createElement("script");
                    if (o.text = e, t) for(r in m)(i = t[r] || t.getAttribute && t.getAttribute(r)) && o.setAttribute(r, i);
                    n.head.appendChild(o).parentNode.removeChild(o);
                }
                function b(e) {
                    return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? l[c.call(e)] || "object" : typeof e;
                }
                var w = function(e, t) {
                    return new w.fn.init(e, t);
                };
                function T(e) {
                    var t = !!e && "length" in e && e.length, n = b(e);
                    return !g(e) && !v(e) && ("array" === n || 0 === t || "number" == typeof t && t > 0 && t - 1 in e);
                }
                w.fn = w.prototype = {
                    jquery: "3.6.0",
                    constructor: w,
                    length: 0,
                    toArray: function() {
                        return o.call(this);
                    },
                    get: function(e) {
                        return null == e ? o.call(this) : e < 0 ? this[e + this.length] : this[e];
                    },
                    pushStack: function(e) {
                        var t = w.merge(this.constructor(), e);
                        return t.prevObject = this, t;
                    },
                    each: function(e) {
                        return w.each(this, e);
                    },
                    map: function(e) {
                        return this.pushStack(w.map(this, function(t, n) {
                            return e.call(t, n, t);
                        }));
                    },
                    slice: function() {
                        return this.pushStack(o.apply(this, arguments));
                    },
                    first: function() {
                        return this.eq(0);
                    },
                    last: function() {
                        return this.eq(-1);
                    },
                    even: function() {
                        return this.pushStack(w.grep(this, function(e, t) {
                            return (t + 1) % 2;
                        }));
                    },
                    odd: function() {
                        return this.pushStack(w.grep(this, function(e, t) {
                            return t % 2;
                        }));
                    },
                    eq: function(e) {
                        var t = this.length, n = +e + (e < 0 ? t : 0);
                        return this.pushStack(n >= 0 && n < t ? [
                            this[n]
                        ] : []);
                    },
                    end: function() {
                        return this.prevObject || this.constructor();
                    },
                    push: s,
                    sort: r.sort,
                    splice: r.splice
                }, w.extend = w.fn.extend = function() {
                    var e, t, n, r, i, o, a = arguments[0] || {}, s = 1, u = arguments.length, l = !1;
                    for("boolean" == typeof a && (l = a, a = arguments[s] || {}, s++), "object" == typeof a || g(a) || (a = {}), s === u && (a = this, s--); s < u; s++)if (null != (e = arguments[s])) for(t in e)r = e[t], "__proto__" !== t && a !== r && (l && r && (w.isPlainObject(r) || (i = Array.isArray(r))) ? (n = a[t], o = i && !Array.isArray(n) ? [] : i || w.isPlainObject(n) ? n : {}, i = !1, a[t] = w.extend(l, o, r)) : void 0 !== r && (a[t] = r));
                    return a;
                }, w.extend({
                    expando: "jQuery" + ("3.6.0" + Math.random()).replace(/\D/g, ""),
                    isReady: !0,
                    error: function(e) {
                        throw new Error(e);
                    },
                    noop: function() {},
                    isPlainObject: function(e) {
                        var t, n;
                        return !(!e || "[object Object]" !== c.call(e)) && (!(t = i(e)) || "function" == typeof (n = f.call(t, "constructor") && t.constructor) && p.call(n) === d);
                    },
                    isEmptyObject: function(e) {
                        var t;
                        for(t in e)return !1;
                        return !0;
                    },
                    globalEval: function(e, t, n) {
                        x(e, {
                            nonce: t && t.nonce
                        }, n);
                    },
                    each: function(e, t) {
                        var n, r = 0;
                        if (T(e)) for(n = e.length; r < n && !1 !== t.call(e[r], r, e[r]); r++);
                        else for(r in e)if (!1 === t.call(e[r], r, e[r])) break;
                        return e;
                    },
                    makeArray: function(e, t) {
                        var n = t || [];
                        return null != e && (T(Object(e)) ? w.merge(n, "string" == typeof e ? [
                            e
                        ] : e) : s.call(n, e)), n;
                    },
                    inArray: function(e, t, n) {
                        return null == t ? -1 : u.call(t, e, n);
                    },
                    merge: function(e, t) {
                        for(var n = +t.length, r = 0, i = e.length; r < n; r++)e[i++] = t[r];
                        return e.length = i, e;
                    },
                    grep: function(e, t, n) {
                        for(var r = [], i = 0, o = e.length, a = !n; i < o; i++)!t(e[i], i) !== a && r.push(e[i]);
                        return r;
                    },
                    map: function(e, t, n) {
                        var r, i, o = 0, s = [];
                        if (T(e)) for(r = e.length; o < r; o++)null != (i = t(e[o], o, n)) && s.push(i);
                        else for(o in e)null != (i = t(e[o], o, n)) && s.push(i);
                        return a(s);
                    },
                    guid: 1,
                    support: h
                }), "function" == typeof Symbol && (w.fn[Symbol.iterator] = r[Symbol.iterator]), w.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(e, t) {
                    l["[object " + t + "]"] = t.toLowerCase();
                });
                var C = function(e) {
                    var t, n, r, i, o, a, s, u, l, c, f, p, d, h, g, v, y, m, x, b = "sizzle" + 1 * new Date, w = e.document, T = 0, C = 0, E = ue(), S = ue(), k = ue(), A = ue(), N = function(e, t) {
                        return e === t && (f = !0), 0;
                    }, j = {}.hasOwnProperty, D = [], q = D.pop, L = D.push, H = D.push, O = D.slice, P = function(e, t) {
                        for(var n = 0, r = e.length; n < r; n++)if (e[n] === t) return n;
                        return -1;
                    }, R = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", M = "[\\x20\\t\\r\\n\\f]", I = "(?:\\\\[\\da-fA-F]{1,6}" + M + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\x00-\\x7f])+", W = "\\[" + M + "*(" + I + ")(?:" + M + "*([*^$|!~]?=)" + M + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + I + "))|)" + M + "*\\]", F = ":(" + I + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + W + ")*)|.*)\\)|)", B = new RegExp(M + "+", "g"), $ = new RegExp("^" + M + "+|((?:^|[^\\\\])(?:\\\\.)*)" + M + "+$", "g"), _ = new RegExp("^" + M + "*," + M + "*"), z = new RegExp("^" + M + "*([>+~]|" + M + ")" + M + "*"), U = new RegExp(M + "|>"), X = new RegExp(F), V = new RegExp("^" + I + "$"), G = {
                        ID: new RegExp("^#(" + I + ")"),
                        CLASS: new RegExp("^\\.(" + I + ")"),
                        TAG: new RegExp("^(" + I + "|[*])"),
                        ATTR: new RegExp("^" + W),
                        PSEUDO: new RegExp("^" + F),
                        CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + M + "*(even|odd|(([+-]|)(\\d*)n|)" + M + "*(?:([+-]|)" + M + "*(\\d+)|))" + M + "*\\)|)", "i"),
                        bool: new RegExp("^(?:" + R + ")$", "i"),
                        needsContext: new RegExp("^" + M + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + M + "*((?:-\\d)?\\d*)" + M + "*\\)|)(?=[^-]|$)", "i")
                    }, Y = /HTML$/i, Q = /^(?:input|select|textarea|button)$/i, J = /^h\d$/i, K = /^[^{]+\{\s*\[native \w/, Z = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, ee = /[+~]/, te = new RegExp("\\\\[\\da-fA-F]{1,6}" + M + "?|\\\\([^\\r\\n\\f])", "g"), ne = function(e, t) {
                        var n = "0x" + e.slice(1) - 65536;
                        return t || (n < 0 ? String.fromCharCode(n + 65536) : String.fromCharCode(n >> 10 | 55296, 1023 & n | 56320));
                    }, re = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, ie = function(e, t) {
                        return t ? "\x00" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e;
                    }, oe = function() {
                        p();
                    }, ae = be(function(e) {
                        return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase();
                    }, {
                        dir: "parentNode",
                        next: "legend"
                    });
                    try {
                        H.apply(D = O.call(w.childNodes), w.childNodes), D[w.childNodes.length].nodeType;
                    } catch (Se) {
                        H = {
                            apply: D.length ? function(e, t) {
                                L.apply(e, O.call(t));
                            } : function(e, t) {
                                for(var n = e.length, r = 0; e[n++] = t[r++];);
                                e.length = n - 1;
                            }
                        };
                    }
                    function se(e, t, r, i) {
                        var o, s, l, c, f, h, y, m = t && t.ownerDocument, w = t ? t.nodeType : 9;
                        if (r = r || [], "string" != typeof e || !e || 1 !== w && 9 !== w && 11 !== w) return r;
                        if (!i && (p(t), t = t || d, g)) {
                            if (11 !== w && (f = Z.exec(e))) {
                                if (o = f[1]) {
                                    if (9 === w) {
                                        if (!(l = t.getElementById(o))) return r;
                                        if (l.id === o) return r.push(l), r;
                                    } else if (m && (l = m.getElementById(o)) && x(t, l) && l.id === o) return r.push(l), r;
                                } else {
                                    if (f[2]) return H.apply(r, t.getElementsByTagName(e)), r;
                                    if ((o = f[3]) && n.getElementsByClassName && t.getElementsByClassName) return H.apply(r, t.getElementsByClassName(o)), r;
                                }
                            }
                            if (n.qsa && !A[e + " "] && (!v || !v.test(e)) && (1 !== w || "object" !== t.nodeName.toLowerCase())) {
                                if (y = e, m = t, 1 === w && (U.test(e) || z.test(e))) {
                                    for((m = ee.test(e) && ye(t.parentNode) || t) === t && n.scope || ((c = t.getAttribute("id")) ? c = c.replace(re, ie) : t.setAttribute("id", c = b)), s = (h = a(e)).length; s--;)h[s] = (c ? "#" + c : ":scope") + " " + xe(h[s]);
                                    y = h.join(",");
                                }
                                try {
                                    return H.apply(r, m.querySelectorAll(y)), r;
                                } catch (T) {
                                    A(e, !0);
                                } finally{
                                    c === b && t.removeAttribute("id");
                                }
                            }
                        }
                        return u(e.replace($, "$1"), t, r, i);
                    }
                    function ue() {
                        var e = [];
                        return function t(n, i) {
                            return e.push(n + " ") > r.cacheLength && delete t[e.shift()], t[n + " "] = i;
                        };
                    }
                    function le(e) {
                        return e[b] = !0, e;
                    }
                    function ce(e) {
                        var t = d.createElement("fieldset");
                        try {
                            return !!e(t);
                        } catch (Se) {
                            return !1;
                        } finally{
                            t.parentNode && t.parentNode.removeChild(t), t = null;
                        }
                    }
                    function fe(e, t) {
                        for(var n = e.split("|"), i = n.length; i--;)r.attrHandle[n[i]] = t;
                    }
                    function pe(e, t) {
                        var n = t && e, r = n && 1 === e.nodeType && 1 === t.nodeType && e.sourceIndex - t.sourceIndex;
                        if (r) return r;
                        if (n) {
                            for(; n = n.nextSibling;)if (n === t) return -1;
                        }
                        return e ? 1 : -1;
                    }
                    function de(e) {
                        return function(t) {
                            return "input" === t.nodeName.toLowerCase() && t.type === e;
                        };
                    }
                    function he(e) {
                        return function(t) {
                            var n = t.nodeName.toLowerCase();
                            return ("input" === n || "button" === n) && t.type === e;
                        };
                    }
                    function ge(e) {
                        return function(t) {
                            return "form" in t ? t.parentNode && !1 === t.disabled ? "label" in t ? "label" in t.parentNode ? t.parentNode.disabled === e : t.disabled === e : t.isDisabled === e || t.isDisabled !== !e && ae(t) === e : t.disabled === e : "label" in t && t.disabled === e;
                        };
                    }
                    function ve(e) {
                        return le(function(t) {
                            return t = +t, le(function(n, r) {
                                for(var i, o = e([], n.length, t), a = o.length; a--;)n[i = o[a]] && (n[i] = !(r[i] = n[i]));
                            });
                        });
                    }
                    function ye(e) {
                        return e && void 0 !== e.getElementsByTagName && e;
                    }
                    for(t in n = se.support = {}, o = se.isXML = function(e) {
                        var t = e && e.namespaceURI, n = e && (e.ownerDocument || e).documentElement;
                        return !Y.test(t || n && n.nodeName || "HTML");
                    }, p = se.setDocument = function(e) {
                        var t, i, a = e ? e.ownerDocument || e : w;
                        return a != d && 9 === a.nodeType && a.documentElement ? (h = (d = a).documentElement, g = !o(d), w != d && (i = d.defaultView) && i.top !== i && (i.addEventListener ? i.addEventListener("unload", oe, !1) : i.attachEvent && i.attachEvent("onunload", oe)), n.scope = ce(function(e) {
                            return h.appendChild(e).appendChild(d.createElement("div")), void 0 !== e.querySelectorAll && !e.querySelectorAll(":scope fieldset div").length;
                        }), n.attributes = ce(function(e) {
                            return e.className = "i", !e.getAttribute("className");
                        }), n.getElementsByTagName = ce(function(e) {
                            return e.appendChild(d.createComment("")), !e.getElementsByTagName("*").length;
                        }), n.getElementsByClassName = K.test(d.getElementsByClassName), n.getById = ce(function(e) {
                            return h.appendChild(e).id = b, !d.getElementsByName || !d.getElementsByName(b).length;
                        }), n.getById ? (r.filter.ID = function(e) {
                            var t = e.replace(te, ne);
                            return function(e) {
                                return e.getAttribute("id") === t;
                            };
                        }, r.find.ID = function(e, t) {
                            if (void 0 !== t.getElementById && g) {
                                var n = t.getElementById(e);
                                return n ? [
                                    n
                                ] : [];
                            }
                        }) : (r.filter.ID = function(e) {
                            var t = e.replace(te, ne);
                            return function(e) {
                                var n = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                                return n && n.value === t;
                            };
                        }, r.find.ID = function(e, t) {
                            if (void 0 !== t.getElementById && g) {
                                var n, r, i, o = t.getElementById(e);
                                if (o) {
                                    if ((n = o.getAttributeNode("id")) && n.value === e) return [
                                        o
                                    ];
                                    for(i = t.getElementsByName(e), r = 0; o = i[r++];)if ((n = o.getAttributeNode("id")) && n.value === e) return [
                                        o
                                    ];
                                }
                                return [];
                            }
                        }), r.find.TAG = n.getElementsByTagName ? function(e, t) {
                            return void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e) : n.qsa ? t.querySelectorAll(e) : void 0;
                        } : function(e, t) {
                            var n, r = [], i = 0, o = t.getElementsByTagName(e);
                            if ("*" === e) {
                                for(; n = o[i++];)1 === n.nodeType && r.push(n);
                                return r;
                            }
                            return o;
                        }, r.find.CLASS = n.getElementsByClassName && function(e, t) {
                            if (void 0 !== t.getElementsByClassName && g) return t.getElementsByClassName(e);
                        }, y = [], v = [], (n.qsa = K.test(d.querySelectorAll)) && (ce(function(e) {
                            var t;
                            h.appendChild(e).innerHTML = "<a id='" + b + "'></a><select id='" + b + "-\r\\' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && v.push("[*^$]=" + M + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || v.push("\\[" + M + "*(?:value|" + R + ")"), e.querySelectorAll("[id~=" + b + "-]").length || v.push("~="), (t = d.createElement("input")).setAttribute("name", ""), e.appendChild(t), e.querySelectorAll("[name='']").length || v.push("\\[" + M + "*name" + M + "*=" + M + "*(?:''|\"\")"), e.querySelectorAll(":checked").length || v.push(":checked"), e.querySelectorAll("a#" + b + "+*").length || v.push(".#.+[+~]"), e.querySelectorAll("\\\f"), v.push("[\\r\\n\\f]");
                        }), ce(function(e) {
                            e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                            var t = d.createElement("input");
                            t.setAttribute("type", "hidden"), e.appendChild(t).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && v.push("name" + M + "*[*^$|!~]?="), 2 !== e.querySelectorAll(":enabled").length && v.push(":enabled", ":disabled"), h.appendChild(e).disabled = !0, 2 !== e.querySelectorAll(":disabled").length && v.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), v.push(",.*:");
                        })), (n.matchesSelector = K.test(m = h.matches || h.webkitMatchesSelector || h.mozMatchesSelector || h.oMatchesSelector || h.msMatchesSelector)) && ce(function(e) {
                            n.disconnectedMatch = m.call(e, "*"), m.call(e, "[s!='']:x"), y.push("!=", F);
                        }), v = v.length && new RegExp(v.join("|")), y = y.length && new RegExp(y.join("|")), t = K.test(h.compareDocumentPosition), x = t || K.test(h.contains) ? function(e, t) {
                            var n = 9 === e.nodeType ? e.documentElement : e, r = t && t.parentNode;
                            return e === r || !(!r || 1 !== r.nodeType || !(n.contains ? n.contains(r) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(r)));
                        } : function(e, t) {
                            if (t) {
                                for(; t = t.parentNode;)if (t === e) return !0;
                            }
                            return !1;
                        }, N = t ? function(e, t) {
                            if (e === t) return f = !0, 0;
                            var r = !e.compareDocumentPosition - !t.compareDocumentPosition;
                            return r || (1 & (r = (e.ownerDocument || e) == (t.ownerDocument || t) ? e.compareDocumentPosition(t) : 1) || !n.sortDetached && t.compareDocumentPosition(e) === r ? e == d || e.ownerDocument == w && x(w, e) ? -1 : t == d || t.ownerDocument == w && x(w, t) ? 1 : c ? P(c, e) - P(c, t) : 0 : 4 & r ? -1 : 1);
                        } : function(e, t) {
                            if (e === t) return f = !0, 0;
                            var n, r = 0, i = e.parentNode, o = t.parentNode, a = [
                                e
                            ], s = [
                                t
                            ];
                            if (!i || !o) return e == d ? -1 : t == d ? 1 : i ? -1 : o ? 1 : c ? P(c, e) - P(c, t) : 0;
                            if (i === o) return pe(e, t);
                            for(n = e; n = n.parentNode;)a.unshift(n);
                            for(n = t; n = n.parentNode;)s.unshift(n);
                            for(; a[r] === s[r];)r++;
                            return r ? pe(a[r], s[r]) : a[r] == w ? -1 : s[r] == w ? 1 : 0;
                        }, d) : d;
                    }, se.matches = function(e, t) {
                        return se(e, null, null, t);
                    }, se.matchesSelector = function(e, t) {
                        if (p(e), n.matchesSelector && g && !A[t + " "] && (!y || !y.test(t)) && (!v || !v.test(t))) try {
                            var r = m.call(e, t);
                            if (r || n.disconnectedMatch || e.document && 11 !== e.document.nodeType) return r;
                        } catch (Se) {
                            A(t, !0);
                        }
                        return se(t, d, null, [
                            e
                        ]).length > 0;
                    }, se.contains = function(e, t) {
                        return (e.ownerDocument || e) != d && p(e), x(e, t);
                    }, se.attr = function(e, t) {
                        (e.ownerDocument || e) != d && p(e);
                        var i = r.attrHandle[t.toLowerCase()], o = i && j.call(r.attrHandle, t.toLowerCase()) ? i(e, t, !g) : void 0;
                        return void 0 !== o ? o : n.attributes || !g ? e.getAttribute(t) : (o = e.getAttributeNode(t)) && o.specified ? o.value : null;
                    }, se.escape = function(e) {
                        return (e + "").replace(re, ie);
                    }, se.error = function(e) {
                        throw new Error("Syntax error, unrecognized expression: " + e);
                    }, se.uniqueSort = function(e) {
                        var t, r = [], i = 0, o = 0;
                        if (f = !n.detectDuplicates, c = !n.sortStable && e.slice(0), e.sort(N), f) {
                            for(; t = e[o++];)t === e[o] && (i = r.push(o));
                            for(; i--;)e.splice(r[i], 1);
                        }
                        return c = null, e;
                    }, i = se.getText = function(e) {
                        var t, n = "", r = 0, o = e.nodeType;
                        if (o) {
                            if (1 === o || 9 === o || 11 === o) {
                                if ("string" == typeof e.textContent) return e.textContent;
                                for(e = e.firstChild; e; e = e.nextSibling)n += i(e);
                            } else if (3 === o || 4 === o) return e.nodeValue;
                        } else for(; t = e[r++];)n += i(t);
                        return n;
                    }, (r = se.selectors = {
                        cacheLength: 50,
                        createPseudo: le,
                        match: G,
                        attrHandle: {},
                        find: {},
                        relative: {
                            ">": {
                                dir: "parentNode",
                                first: !0
                            },
                            " ": {
                                dir: "parentNode"
                            },
                            "+": {
                                dir: "previousSibling",
                                first: !0
                            },
                            "~": {
                                dir: "previousSibling"
                            }
                        },
                        preFilter: {
                            ATTR: function(e) {
                                return e[1] = e[1].replace(te, ne), e[3] = (e[3] || e[4] || e[5] || "").replace(te, ne), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4);
                            },
                            CHILD: function(e) {
                                return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || se.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && se.error(e[0]), e;
                            },
                            PSEUDO: function(e) {
                                var t, n = !e[6] && e[2];
                                return G.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : n && X.test(n) && (t = a(n, !0)) && (t = n.indexOf(")", n.length - t) - n.length) && (e[0] = e[0].slice(0, t), e[2] = n.slice(0, t)), e.slice(0, 3));
                            }
                        },
                        filter: {
                            TAG: function(e) {
                                var t = e.replace(te, ne).toLowerCase();
                                return "*" === e ? function() {
                                    return !0;
                                } : function(e) {
                                    return e.nodeName && e.nodeName.toLowerCase() === t;
                                };
                            },
                            CLASS: function(e) {
                                var t = E[e + " "];
                                return t || (t = new RegExp("(^|" + M + ")" + e + "(" + M + "|$)"), E(e, function(e) {
                                    return t.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "");
                                }));
                            },
                            ATTR: function(e, t, n) {
                                return function(r) {
                                    var i = se.attr(r, e);
                                    return null == i ? "!=" === t : !t || (i += "", "=" === t ? i === n : "!=" === t ? i !== n : "^=" === t ? n && 0 === i.indexOf(n) : "*=" === t ? n && i.indexOf(n) > -1 : "$=" === t ? n && i.slice(-n.length) === n : "~=" === t ? (" " + i.replace(B, " ") + " ").indexOf(n) > -1 : "|=" === t && (i === n || i.slice(0, n.length + 1) === n + "-"));
                                };
                            },
                            CHILD: function(e, t, n, r, i) {
                                var o = "nth" !== e.slice(0, 3), a = "last" !== e.slice(-4), s = "of-type" === t;
                                return 1 === r && 0 === i ? function(e) {
                                    return !!e.parentNode;
                                } : function(t, n, u) {
                                    var l, c, f, p, d, h, g = o !== a ? "nextSibling" : "previousSibling", v = t.parentNode, y = s && t.nodeName.toLowerCase(), m = !u && !s, x = !1;
                                    if (v) {
                                        if (o) {
                                            for(; g;){
                                                for(p = t; p = p[g];)if (s ? p.nodeName.toLowerCase() === y : 1 === p.nodeType) return !1;
                                                h = g = "only" === e && !h && "nextSibling";
                                            }
                                            return !0;
                                        }
                                        if (h = [
                                            a ? v.firstChild : v.lastChild
                                        ], a && m) {
                                            for(x = (d = (l = (c = (f = (p = v)[b] || (p[b] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[e] || [])[0] === T && l[1]) && l[2], p = d && v.childNodes[d]; p = ++d && p && p[g] || (x = d = 0) || h.pop();)if (1 === p.nodeType && ++x && p === t) {
                                                c[e] = [
                                                    T,
                                                    d,
                                                    x
                                                ];
                                                break;
                                            }
                                        } else if (m && (x = d = (l = (c = (f = (p = t)[b] || (p[b] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[e] || [])[0] === T && l[1]), !1 === x) for(; (p = ++d && p && p[g] || (x = d = 0) || h.pop()) && ((s ? p.nodeName.toLowerCase() !== y : 1 !== p.nodeType) || !++x || (m && ((c = (f = p[b] || (p[b] = {}))[p.uniqueID] || (f[p.uniqueID] = {}))[e] = [
                                            T,
                                            x
                                        ]), p !== t)););
                                        return (x -= i) === r || x % r == 0 && x / r >= 0;
                                    }
                                };
                            },
                            PSEUDO: function(e, t) {
                                var n, i = r.pseudos[e] || r.setFilters[e.toLowerCase()] || se.error("unsupported pseudo: " + e);
                                return i[b] ? i(t) : i.length > 1 ? (n = [
                                    e,
                                    e,
                                    "",
                                    t
                                ], r.setFilters.hasOwnProperty(e.toLowerCase()) ? le(function(e, n) {
                                    for(var r, o = i(e, t), a = o.length; a--;)e[r = P(e, o[a])] = !(n[r] = o[a]);
                                }) : function(e) {
                                    return i(e, 0, n);
                                }) : i;
                            }
                        },
                        pseudos: {
                            not: le(function(e) {
                                var t = [], n = [], r = s(e.replace($, "$1"));
                                return r[b] ? le(function(e, t, n, i) {
                                    for(var o, a = r(e, null, i, []), s = e.length; s--;)(o = a[s]) && (e[s] = !(t[s] = o));
                                }) : function(e, i, o) {
                                    return t[0] = e, r(t, null, o, n), t[0] = null, !n.pop();
                                };
                            }),
                            has: le(function(e) {
                                return function(t) {
                                    return se(e, t).length > 0;
                                };
                            }),
                            contains: le(function(e) {
                                return e = e.replace(te, ne), function(t) {
                                    return (t.textContent || i(t)).indexOf(e) > -1;
                                };
                            }),
                            lang: le(function(e) {
                                return V.test(e || "") || se.error("unsupported lang: " + e), e = e.replace(te, ne).toLowerCase(), function(t) {
                                    var n;
                                    do {
                                        if (n = g ? t.lang : t.getAttribute("xml:lang") || t.getAttribute("lang")) return (n = n.toLowerCase()) === e || 0 === n.indexOf(e + "-");
                                    }while ((t = t.parentNode) && 1 === t.nodeType);
                                    return !1;
                                };
                            }),
                            target: function(t) {
                                var n = e.location && e.location.hash;
                                return n && n.slice(1) === t.id;
                            },
                            root: function(e) {
                                return e === h;
                            },
                            focus: function(e) {
                                return e === d.activeElement && (!d.hasFocus || d.hasFocus()) && !!(e.type || e.href || ~e.tabIndex);
                            },
                            enabled: ge(!1),
                            disabled: ge(!0),
                            checked: function(e) {
                                var t = e.nodeName.toLowerCase();
                                return "input" === t && !!e.checked || "option" === t && !!e.selected;
                            },
                            selected: function(e) {
                                return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected;
                            },
                            empty: function(e) {
                                for(e = e.firstChild; e; e = e.nextSibling)if (e.nodeType < 6) return !1;
                                return !0;
                            },
                            parent: function(e) {
                                return !r.pseudos.empty(e);
                            },
                            header: function(e) {
                                return J.test(e.nodeName);
                            },
                            input: function(e) {
                                return Q.test(e.nodeName);
                            },
                            button: function(e) {
                                var t = e.nodeName.toLowerCase();
                                return "input" === t && "button" === e.type || "button" === t;
                            },
                            text: function(e) {
                                var t;
                                return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (t = e.getAttribute("type")) || "text" === t.toLowerCase());
                            },
                            first: ve(function() {
                                return [
                                    0
                                ];
                            }),
                            last: ve(function(e, t) {
                                return [
                                    t - 1
                                ];
                            }),
                            eq: ve(function(e, t, n) {
                                return [
                                    n < 0 ? n + t : n
                                ];
                            }),
                            even: ve(function(e, t) {
                                for(var n = 0; n < t; n += 2)e.push(n);
                                return e;
                            }),
                            odd: ve(function(e, t) {
                                for(var n = 1; n < t; n += 2)e.push(n);
                                return e;
                            }),
                            lt: ve(function(e, t, n) {
                                for(var r = n < 0 ? n + t : n > t ? t : n; --r >= 0;)e.push(r);
                                return e;
                            }),
                            gt: ve(function(e, t, n) {
                                for(var r = n < 0 ? n + t : n; ++r < t;)e.push(r);
                                return e;
                            })
                        }
                    }).pseudos.nth = r.pseudos.eq, {
                        radio: !0,
                        checkbox: !0,
                        file: !0,
                        password: !0,
                        image: !0
                    })r.pseudos[t] = de(t);
                    for(t in {
                        submit: !0,
                        reset: !0
                    })r.pseudos[t] = he(t);
                    function me() {}
                    function xe(e) {
                        for(var t = 0, n = e.length, r = ""; t < n; t++)r += e[t].value;
                        return r;
                    }
                    function be(e, t, n) {
                        var r = t.dir, i = t.next, o = i || r, a = n && "parentNode" === o, s = C++;
                        return t.first ? function(t, n, i) {
                            for(; t = t[r];)if (1 === t.nodeType || a) return e(t, n, i);
                            return !1;
                        } : function(t, n, u) {
                            var l, c, f, p = [
                                T,
                                s
                            ];
                            if (u) {
                                for(; t = t[r];)if ((1 === t.nodeType || a) && e(t, n, u)) return !0;
                            } else for(; t = t[r];)if (1 === t.nodeType || a) {
                                if (c = (f = t[b] || (t[b] = {}))[t.uniqueID] || (f[t.uniqueID] = {}), i && i === t.nodeName.toLowerCase()) t = t[r] || t;
                                else {
                                    if ((l = c[o]) && l[0] === T && l[1] === s) return p[2] = l[2];
                                    if (c[o] = p, p[2] = e(t, n, u)) return !0;
                                }
                            }
                            return !1;
                        };
                    }
                    function we(e) {
                        return e.length > 1 ? function(t, n, r) {
                            for(var i = e.length; i--;)if (!e[i](t, n, r)) return !1;
                            return !0;
                        } : e[0];
                    }
                    function Te(e, t, n, r, i) {
                        for(var o, a = [], s = 0, u = e.length, l = null != t; s < u; s++)(o = e[s]) && (n && !n(o, r, i) || (a.push(o), l && t.push(s)));
                        return a;
                    }
                    function Ce(e, t, n, r, i, o) {
                        return r && !r[b] && (r = Ce(r)), i && !i[b] && (i = Ce(i, o)), le(function(o, a, s, u) {
                            var l, c, f, p = [], d = [], h = a.length, g = o || function(e, t, n) {
                                for(var r = 0, i = t.length; r < i; r++)se(e, t[r], n);
                                return n;
                            }(t || "*", s.nodeType ? [
                                s
                            ] : s, []), v = !e || !o && t ? g : Te(g, p, e, s, u), y = n ? i || (o ? e : h || r) ? [] : a : v;
                            if (n && n(v, y, s, u), r) for(l = Te(y, d), r(l, [], s, u), c = l.length; c--;)(f = l[c]) && (y[d[c]] = !(v[d[c]] = f));
                            if (o) {
                                if (i || e) {
                                    if (i) {
                                        for(l = [], c = y.length; c--;)(f = y[c]) && l.push(v[c] = f);
                                        i(null, y = [], l, u);
                                    }
                                    for(c = y.length; c--;)(f = y[c]) && (l = i ? P(o, f) : p[c]) > -1 && (o[l] = !(a[l] = f));
                                }
                            } else y = Te(y === a ? y.splice(h, y.length) : y), i ? i(null, a, y, u) : H.apply(a, y);
                        });
                    }
                    function Ee(e) {
                        for(var t, n, i, o = e.length, a = r.relative[e[0].type], s = a || r.relative[" "], u = a ? 1 : 0, c = be(function(e) {
                            return e === t;
                        }, s, !0), f = be(function(e) {
                            return P(t, e) > -1;
                        }, s, !0), p = [
                            function(e, n, r) {
                                var i = !a && (r || n !== l) || ((t = n).nodeType ? c(e, n, r) : f(e, n, r));
                                return t = null, i;
                            }
                        ]; u < o; u++)if (n = r.relative[e[u].type]) p = [
                            be(we(p), n)
                        ];
                        else {
                            if ((n = r.filter[e[u].type].apply(null, e[u].matches))[b]) {
                                for(i = ++u; i < o && !r.relative[e[i].type]; i++);
                                return Ce(u > 1 && we(p), u > 1 && xe(e.slice(0, u - 1).concat({
                                    value: " " === e[u - 2].type ? "*" : ""
                                })).replace($, "$1"), n, u < i && Ee(e.slice(u, i)), i < o && Ee(e = e.slice(i)), i < o && xe(e));
                            }
                            p.push(n);
                        }
                        return we(p);
                    }
                    return me.prototype = r.filters = r.pseudos, r.setFilters = new me, a = se.tokenize = function(e, t) {
                        var n, i, o, a, s, u, l, c = S[e + " "];
                        if (c) return t ? 0 : c.slice(0);
                        for(s = e, u = [], l = r.preFilter; s;){
                            for(a in n && !(i = _.exec(s)) || (i && (s = s.slice(i[0].length) || s), u.push(o = [])), n = !1, (i = z.exec(s)) && (n = i.shift(), o.push({
                                value: n,
                                type: i[0].replace($, " ")
                            }), s = s.slice(n.length)), r.filter)!(i = G[a].exec(s)) || l[a] && !(i = l[a](i)) || (n = i.shift(), o.push({
                                value: n,
                                type: a,
                                matches: i
                            }), s = s.slice(n.length));
                            if (!n) break;
                        }
                        return t ? s.length : s ? se.error(e) : S(e, u).slice(0);
                    }, s = se.compile = function(e, t) {
                        var n, i = [], o = [], s = k[e + " "];
                        if (!s) {
                            for(t || (t = a(e)), n = t.length; n--;)(s = Ee(t[n]))[b] ? i.push(s) : o.push(s);
                            (s = k(e, function(e, t) {
                                var n = t.length > 0, i = e.length > 0, o = function(o, a, s, u, c) {
                                    var f, h, v, y = 0, m = "0", x = o && [], b = [], w = l, C = o || i && r.find.TAG("*", c), E = T += null == w ? 1 : Math.random() || .1, S = C.length;
                                    for(c && (l = a == d || a || c); m !== S && null != (f = C[m]); m++){
                                        if (i && f) {
                                            for(h = 0, a || f.ownerDocument == d || (p(f), s = !g); v = e[h++];)if (v(f, a || d, s)) {
                                                u.push(f);
                                                break;
                                            }
                                            c && (T = E);
                                        }
                                        n && ((f = !v && f) && y--, o && x.push(f));
                                    }
                                    if (y += m, n && m !== y) {
                                        for(h = 0; v = t[h++];)v(x, b, a, s);
                                        if (o) {
                                            if (y > 0) for(; m--;)x[m] || b[m] || (b[m] = q.call(u));
                                            b = Te(b);
                                        }
                                        H.apply(u, b), c && !o && b.length > 0 && y + t.length > 1 && se.uniqueSort(u);
                                    }
                                    return c && (T = E, l = w), x;
                                };
                                return n ? le(o) : o;
                            }(o, i))).selector = e;
                        }
                        return s;
                    }, u = se.select = function(e, t, n, i) {
                        var o, u, l, c, f, p = "function" == typeof e && e, d = !i && a(e = p.selector || e);
                        if (n = n || [], 1 === d.length) {
                            if ((u = d[0] = d[0].slice(0)).length > 2 && "ID" === (l = u[0]).type && 9 === t.nodeType && g && r.relative[u[1].type]) {
                                if (!(t = (r.find.ID(l.matches[0].replace(te, ne), t) || [])[0])) return n;
                                p && (t = t.parentNode), e = e.slice(u.shift().value.length);
                            }
                            for(o = G.needsContext.test(e) ? 0 : u.length; o-- && (l = u[o], !r.relative[c = l.type]);)if ((f = r.find[c]) && (i = f(l.matches[0].replace(te, ne), ee.test(u[0].type) && ye(t.parentNode) || t))) {
                                if (u.splice(o, 1), !(e = i.length && xe(u))) return H.apply(n, i), n;
                                break;
                            }
                        }
                        return (p || s(e, d))(i, t, !g, n, !t || ee.test(e) && ye(t.parentNode) || t), n;
                    }, n.sortStable = b.split("").sort(N).join("") === b, n.detectDuplicates = !!f, p(), n.sortDetached = ce(function(e) {
                        return 1 & e.compareDocumentPosition(d.createElement("fieldset"));
                    }), ce(function(e) {
                        return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href");
                    }) || fe("type|href|height|width", function(e, t, n) {
                        if (!n) return e.getAttribute(t, "type" === t.toLowerCase() ? 1 : 2);
                    }), n.attributes && ce(function(e) {
                        return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value");
                    }) || fe("value", function(e, t, n) {
                        if (!n && "input" === e.nodeName.toLowerCase()) return e.defaultValue;
                    }), ce(function(e) {
                        return null == e.getAttribute("disabled");
                    }) || fe(R, function(e, t, n) {
                        var r;
                        if (!n) return !0 === e[t] ? t.toLowerCase() : (r = e.getAttributeNode(t)) && r.specified ? r.value : null;
                    }), se;
                }(t);
                w.find = C, w.expr = C.selectors, w.expr[":"] = w.expr.pseudos, w.uniqueSort = w.unique = C.uniqueSort, w.text = C.getText, w.isXMLDoc = C.isXML, w.contains = C.contains, w.escapeSelector = C.escape;
                var E = function(e, t, n) {
                    for(var r = [], i = void 0 !== n; (e = e[t]) && 9 !== e.nodeType;)if (1 === e.nodeType) {
                        if (i && w(e).is(n)) break;
                        r.push(e);
                    }
                    return r;
                }, S = function(e, t) {
                    for(var n = []; e; e = e.nextSibling)1 === e.nodeType && e !== t && n.push(e);
                    return n;
                }, k = w.expr.match.needsContext;
                function A(e, t) {
                    return e.nodeName && e.nodeName.toLowerCase() === t.toLowerCase();
                }
                var N = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
                function j(e, t, n) {
                    return g(t) ? w.grep(e, function(e, r) {
                        return !!t.call(e, r, e) !== n;
                    }) : t.nodeType ? w.grep(e, function(e) {
                        return e === t !== n;
                    }) : "string" != typeof t ? w.grep(e, function(e) {
                        return u.call(t, e) > -1 !== n;
                    }) : w.filter(t, e, n);
                }
                w.filter = function(e, t, n) {
                    var r = t[0];
                    return n && (e = ":not(" + e + ")"), 1 === t.length && 1 === r.nodeType ? w.find.matchesSelector(r, e) ? [
                        r
                    ] : [] : w.find.matches(e, w.grep(t, function(e) {
                        return 1 === e.nodeType;
                    }));
                }, w.fn.extend({
                    find: function(e) {
                        var t, n, r = this.length, i = this;
                        if ("string" != typeof e) return this.pushStack(w(e).filter(function() {
                            for(t = 0; t < r; t++)if (w.contains(i[t], this)) return !0;
                        }));
                        for(n = this.pushStack([]), t = 0; t < r; t++)w.find(e, i[t], n);
                        return r > 1 ? w.uniqueSort(n) : n;
                    },
                    filter: function(e) {
                        return this.pushStack(j(this, e || [], !1));
                    },
                    not: function(e) {
                        return this.pushStack(j(this, e || [], !0));
                    },
                    is: function(e) {
                        return !!j(this, "string" == typeof e && k.test(e) ? w(e) : e || [], !1).length;
                    }
                });
                var D, q = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
                (w.fn.init = function(e, t, n) {
                    var r, i;
                    if (!e) return this;
                    if (n = n || D, "string" == typeof e) {
                        if (!(r = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [
                            null,
                            e,
                            null
                        ] : q.exec(e)) || !r[1] && t) return !t || t.jquery ? (t || n).find(e) : this.constructor(t).find(e);
                        if (r[1]) {
                            if (t = t instanceof w ? t[0] : t, w.merge(this, w.parseHTML(r[1], t && t.nodeType ? t.ownerDocument || t : y, !0)), N.test(r[1]) && w.isPlainObject(t)) for(r in t)g(this[r]) ? this[r](t[r]) : this.attr(r, t[r]);
                            return this;
                        }
                        return (i = y.getElementById(r[2])) && (this[0] = i, this.length = 1), this;
                    }
                    return e.nodeType ? (this[0] = e, this.length = 1, this) : g(e) ? void 0 !== n.ready ? n.ready(e) : e(w) : w.makeArray(e, this);
                }).prototype = w.fn, D = w(y);
                var L = /^(?:parents|prev(?:Until|All))/, H = {
                    children: !0,
                    contents: !0,
                    next: !0,
                    prev: !0
                };
                function O(e, t) {
                    for(; (e = e[t]) && 1 !== e.nodeType;);
                    return e;
                }
                w.fn.extend({
                    has: function(e) {
                        var t = w(e, this), n = t.length;
                        return this.filter(function() {
                            for(var e = 0; e < n; e++)if (w.contains(this, t[e])) return !0;
                        });
                    },
                    closest: function(e, t) {
                        var n, r = 0, i = this.length, o = [], a = "string" != typeof e && w(e);
                        if (!k.test(e)) {
                            for(; r < i; r++)for(n = this[r]; n && n !== t; n = n.parentNode)if (n.nodeType < 11 && (a ? a.index(n) > -1 : 1 === n.nodeType && w.find.matchesSelector(n, e))) {
                                o.push(n);
                                break;
                            }
                        }
                        return this.pushStack(o.length > 1 ? w.uniqueSort(o) : o);
                    },
                    index: function(e) {
                        return e ? "string" == typeof e ? u.call(w(e), this[0]) : u.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
                    },
                    add: function(e, t) {
                        return this.pushStack(w.uniqueSort(w.merge(this.get(), w(e, t))));
                    },
                    addBack: function(e) {
                        return this.add(null == e ? this.prevObject : this.prevObject.filter(e));
                    }
                }), w.each({
                    parent: function(e) {
                        var t = e.parentNode;
                        return t && 11 !== t.nodeType ? t : null;
                    },
                    parents: function(e) {
                        return E(e, "parentNode");
                    },
                    parentsUntil: function(e, t, n) {
                        return E(e, "parentNode", n);
                    },
                    next: function(e) {
                        return O(e, "nextSibling");
                    },
                    prev: function(e) {
                        return O(e, "previousSibling");
                    },
                    nextAll: function(e) {
                        return E(e, "nextSibling");
                    },
                    prevAll: function(e) {
                        return E(e, "previousSibling");
                    },
                    nextUntil: function(e, t, n) {
                        return E(e, "nextSibling", n);
                    },
                    prevUntil: function(e, t, n) {
                        return E(e, "previousSibling", n);
                    },
                    siblings: function(e) {
                        return S((e.parentNode || {}).firstChild, e);
                    },
                    children: function(e) {
                        return S(e.firstChild);
                    },
                    contents: function(e) {
                        return null != e.contentDocument && i(e.contentDocument) ? e.contentDocument : (A(e, "template") && (e = e.content || e), w.merge([], e.childNodes));
                    }
                }, function(e, t) {
                    w.fn[e] = function(n, r) {
                        var i = w.map(this, t, n);
                        return "Until" !== e.slice(-5) && (r = n), r && "string" == typeof r && (i = w.filter(r, i)), this.length > 1 && (H[e] || w.uniqueSort(i), L.test(e) && i.reverse()), this.pushStack(i);
                    };
                });
                var P = /[^\x20\t\r\n\f]+/g;
                function R(e) {
                    return e;
                }
                function M(e) {
                    throw e;
                }
                function I(e, t, n, r) {
                    var i;
                    try {
                        e && g(i = e.promise) ? i.call(e).done(t).fail(n) : e && g(i = e.then) ? i.call(e, t, n) : t.apply(void 0, [
                            e
                        ].slice(r));
                    } catch (e) {
                        n.apply(void 0, [
                            e
                        ]);
                    }
                }
                w.Callbacks = function(e) {
                    e = "string" == typeof e ? function(e) {
                        var t = {};
                        return w.each(e.match(P) || [], function(e, n) {
                            t[n] = !0;
                        }), t;
                    }(e) : w.extend({}, e);
                    var t, n, r, i, o = [], a = [], s = -1, u = function() {
                        for(i = i || e.once, r = t = !0; a.length; s = -1)for(n = a.shift(); ++s < o.length;)!1 === o[s].apply(n[0], n[1]) && e.stopOnFalse && (s = o.length, n = !1);
                        e.memory || (n = !1), t = !1, i && (o = n ? [] : "");
                    }, l = {
                        add: function() {
                            return o && (n && !t && (s = o.length - 1, a.push(n)), function t(n) {
                                w.each(n, function(n, r) {
                                    g(r) ? e.unique && l.has(r) || o.push(r) : r && r.length && "string" !== b(r) && t(r);
                                });
                            }(arguments), n && !t && u()), this;
                        },
                        remove: function() {
                            return w.each(arguments, function(e, t) {
                                for(var n; (n = w.inArray(t, o, n)) > -1;)o.splice(n, 1), n <= s && s--;
                            }), this;
                        },
                        has: function(e) {
                            return e ? w.inArray(e, o) > -1 : o.length > 0;
                        },
                        empty: function() {
                            return o && (o = []), this;
                        },
                        disable: function() {
                            return i = a = [], o = n = "", this;
                        },
                        disabled: function() {
                            return !o;
                        },
                        lock: function() {
                            return i = a = [], n || t || (o = n = ""), this;
                        },
                        locked: function() {
                            return !!i;
                        },
                        fireWith: function(e, n) {
                            return i || (n = [
                                e,
                                (n = n || []).slice ? n.slice() : n
                            ], a.push(n), t || u()), this;
                        },
                        fire: function() {
                            return l.fireWith(this, arguments), this;
                        },
                        fired: function() {
                            return !!r;
                        }
                    };
                    return l;
                }, w.extend({
                    Deferred: function(e) {
                        var n = [
                            [
                                "notify",
                                "progress",
                                w.Callbacks("memory"),
                                w.Callbacks("memory"),
                                2
                            ],
                            [
                                "resolve",
                                "done",
                                w.Callbacks("once memory"),
                                w.Callbacks("once memory"),
                                0,
                                "resolved"
                            ],
                            [
                                "reject",
                                "fail",
                                w.Callbacks("once memory"),
                                w.Callbacks("once memory"),
                                1,
                                "rejected"
                            ]
                        ], r = "pending", i = {
                            state: function() {
                                return r;
                            },
                            always: function() {
                                return o.done(arguments).fail(arguments), this;
                            },
                            catch: function(e) {
                                return i.then(null, e);
                            },
                            pipe: function() {
                                var e = arguments;
                                return w.Deferred(function(t) {
                                    w.each(n, function(n, r) {
                                        var i = g(e[r[4]]) && e[r[4]];
                                        o[r[1]](function() {
                                            var e = i && i.apply(this, arguments);
                                            e && g(e.promise) ? e.promise().progress(t.notify).done(t.resolve).fail(t.reject) : t[r[0] + "With"](this, i ? [
                                                e
                                            ] : arguments);
                                        });
                                    }), e = null;
                                }).promise();
                            },
                            then: function(e, r, i) {
                                var o = 0;
                                function a(e, n, r, i) {
                                    return function() {
                                        var s = this, u = arguments, l = function() {
                                            var t, l;
                                            if (!(e < o)) {
                                                if ((t = r.apply(s, u)) === n.promise()) throw new TypeError("Thenable self-resolution");
                                                l = t && ("object" == typeof t || "function" == typeof t) && t.then, g(l) ? i ? l.call(t, a(o, n, R, i), a(o, n, M, i)) : (o++, l.call(t, a(o, n, R, i), a(o, n, M, i), a(o, n, R, n.notifyWith))) : (r !== R && (s = void 0, u = [
                                                    t
                                                ]), (i || n.resolveWith)(s, u));
                                            }
                                        }, c = i ? l : function() {
                                            try {
                                                l();
                                            } catch (t) {
                                                w.Deferred.exceptionHook && w.Deferred.exceptionHook(t, c.stackTrace), e + 1 >= o && (r !== M && (s = void 0, u = [
                                                    t
                                                ]), n.rejectWith(s, u));
                                            }
                                        };
                                        e ? c() : (w.Deferred.getStackHook && (c.stackTrace = w.Deferred.getStackHook()), t.setTimeout(c));
                                    };
                                }
                                return w.Deferred(function(t) {
                                    n[0][3].add(a(0, t, g(i) ? i : R, t.notifyWith)), n[1][3].add(a(0, t, g(e) ? e : R)), n[2][3].add(a(0, t, g(r) ? r : M));
                                }).promise();
                            },
                            promise: function(e) {
                                return null != e ? w.extend(e, i) : i;
                            }
                        }, o = {};
                        return w.each(n, function(e, t) {
                            var a = t[2], s = t[5];
                            i[t[1]] = a.add, s && a.add(function() {
                                r = s;
                            }, n[3 - e][2].disable, n[3 - e][3].disable, n[0][2].lock, n[0][3].lock), a.add(t[3].fire), o[t[0]] = function() {
                                return o[t[0] + "With"](this === o ? void 0 : this, arguments), this;
                            }, o[t[0] + "With"] = a.fireWith;
                        }), i.promise(o), e && e.call(o, o), o;
                    },
                    when: function(e) {
                        var t = arguments.length, n = t, r = Array(n), i = o.call(arguments), a = w.Deferred(), s = function(e) {
                            return function(n) {
                                r[e] = this, i[e] = arguments.length > 1 ? o.call(arguments) : n, --t || a.resolveWith(r, i);
                            };
                        };
                        if (t <= 1 && (I(e, a.done(s(n)).resolve, a.reject, !t), "pending" === a.state() || g(i[n] && i[n].then))) return a.then();
                        for(; n--;)I(i[n], s(n), a.reject);
                        return a.promise();
                    }
                });
                var W = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
                w.Deferred.exceptionHook = function(e, n) {
                    t.console && t.console.warn && e && W.test(e.name) && t.console.warn("jQuery.Deferred exception: " + e.message, e.stack, n);
                }, w.readyException = function(e) {
                    t.setTimeout(function() {
                        throw e;
                    });
                };
                var F = w.Deferred();
                function B() {
                    y.removeEventListener("DOMContentLoaded", B), t.removeEventListener("load", B), w.ready();
                }
                w.fn.ready = function(e) {
                    return F.then(e).catch(function(e) {
                        w.readyException(e);
                    }), this;
                }, w.extend({
                    isReady: !1,
                    readyWait: 1,
                    ready: function(e) {
                        (!0 === e ? --w.readyWait : w.isReady) || (w.isReady = !0, !0 !== e && --w.readyWait > 0 || F.resolveWith(y, [
                            w
                        ]));
                    }
                }), w.ready.then = F.then, "complete" === y.readyState || "loading" !== y.readyState && !y.documentElement.doScroll ? t.setTimeout(w.ready) : (y.addEventListener("DOMContentLoaded", B), t.addEventListener("load", B));
                var $ = function(e, t, n, r, i, o, a) {
                    var s = 0, u = e.length, l = null == n;
                    if ("object" === b(n)) for(s in i = !0, n)$(e, t, s, n[s], !0, o, a);
                    else if (void 0 !== r && (i = !0, g(r) || (a = !0), l && (a ? (t.call(e, r), t = null) : (l = t, t = function(e, t, n) {
                        return l.call(w(e), n);
                    })), t)) for(; s < u; s++)t(e[s], n, a ? r : r.call(e[s], s, t(e[s], n)));
                    return i ? e : l ? t.call(e) : u ? t(e[0], n) : o;
                }, _ = /^-ms-/, z = /-([a-z])/g;
                function U(e, t) {
                    return t.toUpperCase();
                }
                function X(e) {
                    return e.replace(_, "ms-").replace(z, U);
                }
                var V = function(e) {
                    return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType;
                };
                function G() {
                    this.expando = w.expando + G.uid++;
                }
                G.uid = 1, G.prototype = {
                    cache: function(e) {
                        var t = e[this.expando];
                        return t || (t = {}, V(e) && (e.nodeType ? e[this.expando] = t : Object.defineProperty(e, this.expando, {
                            value: t,
                            configurable: !0
                        }))), t;
                    },
                    set: function(e, t, n) {
                        var r, i = this.cache(e);
                        if ("string" == typeof t) i[X(t)] = n;
                        else for(r in t)i[X(r)] = t[r];
                        return i;
                    },
                    get: function(e, t) {
                        return void 0 === t ? this.cache(e) : e[this.expando] && e[this.expando][X(t)];
                    },
                    access: function(e, t, n) {
                        return void 0 === t || t && "string" == typeof t && void 0 === n ? this.get(e, t) : (this.set(e, t, n), void 0 !== n ? n : t);
                    },
                    remove: function(e, t) {
                        var n, r = e[this.expando];
                        if (void 0 !== r) {
                            if (void 0 !== t) {
                                n = (t = Array.isArray(t) ? t.map(X) : (t = X(t)) in r ? [
                                    t
                                ] : t.match(P) || []).length;
                                for(; n--;)delete r[t[n]];
                            }
                            (void 0 === t || w.isEmptyObject(r)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando]);
                        }
                    },
                    hasData: function(e) {
                        var t = e[this.expando];
                        return void 0 !== t && !w.isEmptyObject(t);
                    }
                };
                var Y = new G, Q = new G, J = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, K = /[A-Z]/g;
                function Z(e, t, n) {
                    var r;
                    if (void 0 === n && 1 === e.nodeType) {
                        if (r = "data-" + t.replace(K, "-$&").toLowerCase(), "string" == typeof (n = e.getAttribute(r))) {
                            try {
                                n = function(e) {
                                    return "true" === e || "false" !== e && ("null" === e ? null : e === +e + "" ? +e : J.test(e) ? JSON.parse(e) : e);
                                }(n);
                            } catch (i) {}
                            Q.set(e, t, n);
                        } else n = void 0;
                    }
                    return n;
                }
                w.extend({
                    hasData: function(e) {
                        return Q.hasData(e) || Y.hasData(e);
                    },
                    data: function(e, t, n) {
                        return Q.access(e, t, n);
                    },
                    removeData: function(e, t) {
                        Q.remove(e, t);
                    },
                    _data: function(e, t, n) {
                        return Y.access(e, t, n);
                    },
                    _removeData: function(e, t) {
                        Y.remove(e, t);
                    }
                }), w.fn.extend({
                    data: function(e, t) {
                        var n, r, i, o = this[0], a = o && o.attributes;
                        if (void 0 === e) {
                            if (this.length && (i = Q.get(o), 1 === o.nodeType && !Y.get(o, "hasDataAttrs"))) {
                                for(n = a.length; n--;)a[n] && 0 === (r = a[n].name).indexOf("data-") && (r = X(r.slice(5)), Z(o, r, i[r]));
                                Y.set(o, "hasDataAttrs", !0);
                            }
                            return i;
                        }
                        return "object" == typeof e ? this.each(function() {
                            Q.set(this, e);
                        }) : $(this, function(t) {
                            var n;
                            if (o && void 0 === t) return void 0 !== (n = Q.get(o, e)) ? n : void 0 !== (n = Z(o, e)) ? n : void 0;
                            this.each(function() {
                                Q.set(this, e, t);
                            });
                        }, null, t, arguments.length > 1, null, !0);
                    },
                    removeData: function(e) {
                        return this.each(function() {
                            Q.remove(this, e);
                        });
                    }
                }), w.extend({
                    queue: function(e, t, n) {
                        var r;
                        if (e) return t = (t || "fx") + "queue", r = Y.get(e, t), n && (!r || Array.isArray(n) ? r = Y.access(e, t, w.makeArray(n)) : r.push(n)), r || [];
                    },
                    dequeue: function(e, t) {
                        t = t || "fx";
                        var n = w.queue(e, t), r = n.length, i = n.shift(), o = w._queueHooks(e, t);
                        "inprogress" === i && (i = n.shift(), r--), i && ("fx" === t && n.unshift("inprogress"), delete o.stop, i.call(e, function() {
                            w.dequeue(e, t);
                        }, o)), !r && o && o.empty.fire();
                    },
                    _queueHooks: function(e, t) {
                        var n = t + "queueHooks";
                        return Y.get(e, n) || Y.access(e, n, {
                            empty: w.Callbacks("once memory").add(function() {
                                Y.remove(e, [
                                    t + "queue",
                                    n
                                ]);
                            })
                        });
                    }
                }), w.fn.extend({
                    queue: function(e, t) {
                        var n = 2;
                        return "string" != typeof e && (t = e, e = "fx", n--), arguments.length < n ? w.queue(this[0], e) : void 0 === t ? this : this.each(function() {
                            var n = w.queue(this, e, t);
                            w._queueHooks(this, e), "fx" === e && "inprogress" !== n[0] && w.dequeue(this, e);
                        });
                    },
                    dequeue: function(e) {
                        return this.each(function() {
                            w.dequeue(this, e);
                        });
                    },
                    clearQueue: function(e) {
                        return this.queue(e || "fx", []);
                    },
                    promise: function(e, t) {
                        var n, r = 1, i = w.Deferred(), o = this, a = this.length, s = function() {
                            --r || i.resolveWith(o, [
                                o
                            ]);
                        };
                        for("string" != typeof e && (t = e, e = void 0), e = e || "fx"; a--;)(n = Y.get(o[a], e + "queueHooks")) && n.empty && (r++, n.empty.add(s));
                        return s(), i.promise(t);
                    }
                });
                var ee = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source, te = new RegExp("^(?:([+-])=|)(" + ee + ")([a-z%]*)$", "i"), ne = [
                    "Top",
                    "Right",
                    "Bottom",
                    "Left"
                ], re = y.documentElement, ie = function(e) {
                    return w.contains(e.ownerDocument, e);
                }, oe = {
                    composed: !0
                };
                re.getRootNode && (ie = function(e) {
                    return w.contains(e.ownerDocument, e) || e.getRootNode(oe) === e.ownerDocument;
                });
                var ae = function(e, t) {
                    return "none" === (e = t || e).style.display || "" === e.style.display && ie(e) && "none" === w.css(e, "display");
                };
                function se(e, t, n, r) {
                    var i, o, a = 20, s = r ? function() {
                        return r.cur();
                    } : function() {
                        return w.css(e, t, "");
                    }, u = s(), l = n && n[3] || (w.cssNumber[t] ? "" : "px"), c = e.nodeType && (w.cssNumber[t] || "px" !== l && +u) && te.exec(w.css(e, t));
                    if (c && c[3] !== l) {
                        for(u /= 2, l = l || c[3], c = +u || 1; a--;)w.style(e, t, c + l), (1 - o) * (1 - (o = s() / u || .5)) <= 0 && (a = 0), c /= o;
                        c *= 2, w.style(e, t, c + l), n = n || [];
                    }
                    return n && (c = +c || +u || 0, i = n[1] ? c + (n[1] + 1) * n[2] : +n[2], r && (r.unit = l, r.start = c, r.end = i)), i;
                }
                var ue = {};
                function le(e) {
                    var t, n = e.ownerDocument, r = e.nodeName, i = ue[r];
                    return i || (t = n.body.appendChild(n.createElement(r)), i = w.css(t, "display"), t.parentNode.removeChild(t), "none" === i && (i = "block"), ue[r] = i, i);
                }
                function ce(e, t) {
                    for(var n, r, i = [], o = 0, a = e.length; o < a; o++)(r = e[o]).style && (n = r.style.display, t ? ("none" === n && (i[o] = Y.get(r, "display") || null, i[o] || (r.style.display = "")), "" === r.style.display && ae(r) && (i[o] = le(r))) : "none" !== n && (i[o] = "none", Y.set(r, "display", n)));
                    for(o = 0; o < a; o++)null != i[o] && (e[o].style.display = i[o]);
                    return e;
                }
                w.fn.extend({
                    show: function() {
                        return ce(this, !0);
                    },
                    hide: function() {
                        return ce(this);
                    },
                    toggle: function(e) {
                        return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each(function() {
                            ae(this) ? w(this).show() : w(this).hide();
                        });
                    }
                });
                var fe, pe, de = /^(?:checkbox|radio)$/i, he = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i, ge = /^$|^module$|\/(?:java|ecma)script/i;
                fe = y.createDocumentFragment().appendChild(y.createElement("div")), (pe = y.createElement("input")).setAttribute("type", "radio"), pe.setAttribute("checked", "checked"), pe.setAttribute("name", "t"), fe.appendChild(pe), h.checkClone = fe.cloneNode(!0).cloneNode(!0).lastChild.checked, fe.innerHTML = "<textarea>x</textarea>", h.noCloneChecked = !!fe.cloneNode(!0).lastChild.defaultValue, fe.innerHTML = "<option></option>", h.option = !!fe.lastChild;
                var ve = {
                    thead: [
                        1,
                        "<table>",
                        "</table>"
                    ],
                    col: [
                        2,
                        "<table><colgroup>",
                        "</colgroup></table>"
                    ],
                    tr: [
                        2,
                        "<table><tbody>",
                        "</tbody></table>"
                    ],
                    td: [
                        3,
                        "<table><tbody><tr>",
                        "</tr></tbody></table>"
                    ],
                    _default: [
                        0,
                        "",
                        ""
                    ]
                };
                function ye(e, t) {
                    var n;
                    return n = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(t || "*") : [], void 0 === t || t && A(e, t) ? w.merge([
                        e
                    ], n) : n;
                }
                function me(e, t) {
                    for(var n = 0, r = e.length; n < r; n++)Y.set(e[n], "globalEval", !t || Y.get(t[n], "globalEval"));
                }
                ve.tbody = ve.tfoot = ve.colgroup = ve.caption = ve.thead, ve.th = ve.td, h.option || (ve.optgroup = ve.option = [
                    1,
                    "<select multiple='multiple'>",
                    "</select>"
                ]);
                var xe = /<|&#?\w+;/;
                function be(e, t, n, r, i) {
                    for(var o, a, s, u, l, c, f = t.createDocumentFragment(), p = [], d = 0, h = e.length; d < h; d++)if ((o = e[d]) || 0 === o) {
                        if ("object" === b(o)) w.merge(p, o.nodeType ? [
                            o
                        ] : o);
                        else if (xe.test(o)) {
                            for(a = a || f.appendChild(t.createElement("div")), s = (he.exec(o) || [
                                "",
                                ""
                            ])[1].toLowerCase(), u = ve[s] || ve._default, a.innerHTML = u[1] + w.htmlPrefilter(o) + u[2], c = u[0]; c--;)a = a.lastChild;
                            w.merge(p, a.childNodes), (a = f.firstChild).textContent = "";
                        } else p.push(t.createTextNode(o));
                    }
                    for(f.textContent = "", d = 0; o = p[d++];)if (r && w.inArray(o, r) > -1) i && i.push(o);
                    else if (l = ie(o), a = ye(f.appendChild(o), "script"), l && me(a), n) for(c = 0; o = a[c++];)ge.test(o.type || "") && n.push(o);
                    return f;
                }
                var we = /^([^.]*)(?:\.(.+)|)/;
                function Te() {
                    return !0;
                }
                function Ce() {
                    return !1;
                }
                function Ee(e, t) {
                    return e === function() {
                        try {
                            return y.activeElement;
                        } catch (e) {}
                    }() == ("focus" === t);
                }
                function Se(e, t, n, r, i, o) {
                    var a, s;
                    if ("object" == typeof t) {
                        for(s in "string" != typeof n && (r = r || n, n = void 0), t)Se(e, s, n, r, t[s], o);
                        return e;
                    }
                    if (null == r && null == i ? (i = n, r = n = void 0) : null == i && ("string" == typeof n ? (i = r, r = void 0) : (i = r, r = n, n = void 0)), !1 === i) i = Ce;
                    else if (!i) return e;
                    return 1 === o && (a = i, (i = function(e) {
                        return w().off(e), a.apply(this, arguments);
                    }).guid = a.guid || (a.guid = w.guid++)), e.each(function() {
                        w.event.add(this, t, i, r, n);
                    });
                }
                function ke(e, t, n) {
                    n ? (Y.set(e, t, !1), w.event.add(e, t, {
                        namespace: !1,
                        handler: function(e) {
                            var r, i, a = Y.get(this, t);
                            if (1 & e.isTrigger && this[t]) {
                                if (a.length) (w.event.special[t] || {}).delegateType && e.stopPropagation();
                                else if (a = o.call(arguments), Y.set(this, t, a), r = n(this, t), this[t](), a !== (i = Y.get(this, t)) || r ? Y.set(this, t, !1) : i = {}, a !== i) return e.stopImmediatePropagation(), e.preventDefault(), i && i.value;
                            } else a.length && (Y.set(this, t, {
                                value: w.event.trigger(w.extend(a[0], w.Event.prototype), a.slice(1), this)
                            }), e.stopImmediatePropagation());
                        }
                    })) : void 0 === Y.get(e, t) && w.event.add(e, t, Te);
                }
                w.event = {
                    global: {},
                    add: function(e, t, n, r, i) {
                        var o, a, s, u, l, c, f, p, d, h, g, v = Y.get(e);
                        if (V(e)) for(n.handler && (n = (o = n).handler, i = o.selector), i && w.find.matchesSelector(re, i), n.guid || (n.guid = w.guid++), (u = v.events) || (u = v.events = Object.create(null)), (a = v.handle) || (a = v.handle = function(t) {
                            return void 0 !== w && w.event.triggered !== t.type ? w.event.dispatch.apply(e, arguments) : void 0;
                        }), l = (t = (t || "").match(P) || [
                            ""
                        ]).length; l--;)d = g = (s = we.exec(t[l]) || [])[1], h = (s[2] || "").split(".").sort(), d && (f = w.event.special[d] || {}, d = (i ? f.delegateType : f.bindType) || d, f = w.event.special[d] || {}, c = w.extend({
                            type: d,
                            origType: g,
                            data: r,
                            handler: n,
                            guid: n.guid,
                            selector: i,
                            needsContext: i && w.expr.match.needsContext.test(i),
                            namespace: h.join(".")
                        }, o), (p = u[d]) || ((p = u[d] = []).delegateCount = 0, f.setup && !1 !== f.setup.call(e, r, h, a) || e.addEventListener && e.addEventListener(d, a)), f.add && (f.add.call(e, c), c.handler.guid || (c.handler.guid = n.guid)), i ? p.splice(p.delegateCount++, 0, c) : p.push(c), w.event.global[d] = !0);
                    },
                    remove: function(e, t, n, r, i) {
                        var o, a, s, u, l, c, f, p, d, h, g, v = Y.hasData(e) && Y.get(e);
                        if (v && (u = v.events)) {
                            for(l = (t = (t || "").match(P) || [
                                ""
                            ]).length; l--;)if (d = g = (s = we.exec(t[l]) || [])[1], h = (s[2] || "").split(".").sort(), d) {
                                for(f = w.event.special[d] || {}, p = u[d = (r ? f.delegateType : f.bindType) || d] || [], s = s[2] && new RegExp("(^|\\.)" + h.join("\\.(?:.*\\.|)") + "(\\.|$)"), a = o = p.length; o--;)c = p[o], !i && g !== c.origType || n && n.guid !== c.guid || s && !s.test(c.namespace) || r && r !== c.selector && ("**" !== r || !c.selector) || (p.splice(o, 1), c.selector && p.delegateCount--, f.remove && f.remove.call(e, c));
                                a && !p.length && (f.teardown && !1 !== f.teardown.call(e, h, v.handle) || w.removeEvent(e, d, v.handle), delete u[d]);
                            } else for(d in u)w.event.remove(e, d + t[l], n, r, !0);
                            w.isEmptyObject(u) && Y.remove(e, "handle events");
                        }
                    },
                    dispatch: function(e) {
                        var t, n, r, i, o, a, s = new Array(arguments.length), u = w.event.fix(e), l = (Y.get(this, "events") || Object.create(null))[u.type] || [], c = w.event.special[u.type] || {};
                        for(s[0] = u, t = 1; t < arguments.length; t++)s[t] = arguments[t];
                        if (u.delegateTarget = this, !c.preDispatch || !1 !== c.preDispatch.call(this, u)) {
                            for(a = w.event.handlers.call(this, u, l), t = 0; (i = a[t++]) && !u.isPropagationStopped();)for(u.currentTarget = i.elem, n = 0; (o = i.handlers[n++]) && !u.isImmediatePropagationStopped();)u.rnamespace && !1 !== o.namespace && !u.rnamespace.test(o.namespace) || (u.handleObj = o, u.data = o.data, void 0 !== (r = ((w.event.special[o.origType] || {}).handle || o.handler).apply(i.elem, s)) && !1 === (u.result = r) && (u.preventDefault(), u.stopPropagation()));
                            return c.postDispatch && c.postDispatch.call(this, u), u.result;
                        }
                    },
                    handlers: function(e, t) {
                        var n, r, i, o, a, s = [], u = t.delegateCount, l = e.target;
                        if (u && l.nodeType && !("click" === e.type && e.button >= 1)) {
                            for(; l !== this; l = l.parentNode || this)if (1 === l.nodeType && ("click" !== e.type || !0 !== l.disabled)) {
                                for(o = [], a = {}, n = 0; n < u; n++)void 0 === a[i = (r = t[n]).selector + " "] && (a[i] = r.needsContext ? w(i, this).index(l) > -1 : w.find(i, this, null, [
                                    l
                                ]).length), a[i] && o.push(r);
                                o.length && s.push({
                                    elem: l,
                                    handlers: o
                                });
                            }
                        }
                        return l = this, u < t.length && s.push({
                            elem: l,
                            handlers: t.slice(u)
                        }), s;
                    },
                    addProp: function(e, t) {
                        Object.defineProperty(w.Event.prototype, e, {
                            enumerable: !0,
                            configurable: !0,
                            get: g(t) ? function() {
                                if (this.originalEvent) return t(this.originalEvent);
                            } : function() {
                                if (this.originalEvent) return this.originalEvent[e];
                            },
                            set: function(t) {
                                Object.defineProperty(this, e, {
                                    enumerable: !0,
                                    configurable: !0,
                                    writable: !0,
                                    value: t
                                });
                            }
                        });
                    },
                    fix: function(e) {
                        return e[w.expando] ? e : new w.Event(e);
                    },
                    special: {
                        load: {
                            noBubble: !0
                        },
                        click: {
                            setup: function(e) {
                                var t = this || e;
                                return de.test(t.type) && t.click && A(t, "input") && ke(t, "click", Te), !1;
                            },
                            trigger: function(e) {
                                var t = this || e;
                                return de.test(t.type) && t.click && A(t, "input") && ke(t, "click"), !0;
                            },
                            _default: function(e) {
                                var t = e.target;
                                return de.test(t.type) && t.click && A(t, "input") && Y.get(t, "click") || A(t, "a");
                            }
                        },
                        beforeunload: {
                            postDispatch: function(e) {
                                void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result);
                            }
                        }
                    }
                }, w.removeEvent = function(e, t, n) {
                    e.removeEventListener && e.removeEventListener(t, n);
                }, w.Event = function(e, t) {
                    if (!(this instanceof w.Event)) return new w.Event(e, t);
                    e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? Te : Ce, this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target, this.currentTarget = e.currentTarget, this.relatedTarget = e.relatedTarget) : this.type = e, t && w.extend(this, t), this.timeStamp = e && e.timeStamp || Date.now(), this[w.expando] = !0;
                }, w.Event.prototype = {
                    constructor: w.Event,
                    isDefaultPrevented: Ce,
                    isPropagationStopped: Ce,
                    isImmediatePropagationStopped: Ce,
                    isSimulated: !1,
                    preventDefault: function() {
                        var e = this.originalEvent;
                        this.isDefaultPrevented = Te, e && !this.isSimulated && e.preventDefault();
                    },
                    stopPropagation: function() {
                        var e = this.originalEvent;
                        this.isPropagationStopped = Te, e && !this.isSimulated && e.stopPropagation();
                    },
                    stopImmediatePropagation: function() {
                        var e = this.originalEvent;
                        this.isImmediatePropagationStopped = Te, e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation();
                    }
                }, w.each({
                    altKey: !0,
                    bubbles: !0,
                    cancelable: !0,
                    changedTouches: !0,
                    ctrlKey: !0,
                    detail: !0,
                    eventPhase: !0,
                    metaKey: !0,
                    pageX: !0,
                    pageY: !0,
                    shiftKey: !0,
                    view: !0,
                    char: !0,
                    code: !0,
                    charCode: !0,
                    key: !0,
                    keyCode: !0,
                    button: !0,
                    buttons: !0,
                    clientX: !0,
                    clientY: !0,
                    offsetX: !0,
                    offsetY: !0,
                    pointerId: !0,
                    pointerType: !0,
                    screenX: !0,
                    screenY: !0,
                    targetTouches: !0,
                    toElement: !0,
                    touches: !0,
                    which: !0
                }, w.event.addProp), w.each({
                    focus: "focusin",
                    blur: "focusout"
                }, function(e, t) {
                    w.event.special[e] = {
                        setup: function() {
                            return ke(this, e, Ee), !1;
                        },
                        trigger: function() {
                            return ke(this, e), !0;
                        },
                        _default: function() {
                            return !0;
                        },
                        delegateType: t
                    };
                }), w.each({
                    mouseenter: "mouseover",
                    mouseleave: "mouseout",
                    pointerenter: "pointerover",
                    pointerleave: "pointerout"
                }, function(e, t) {
                    w.event.special[e] = {
                        delegateType: t,
                        bindType: t,
                        handle: function(e) {
                            var n, r = e.relatedTarget, i = e.handleObj;
                            return r && (r === this || w.contains(this, r)) || (e.type = i.origType, n = i.handler.apply(this, arguments), e.type = t), n;
                        }
                    };
                }), w.fn.extend({
                    on: function(e, t, n, r) {
                        return Se(this, e, t, n, r);
                    },
                    one: function(e, t, n, r) {
                        return Se(this, e, t, n, r, 1);
                    },
                    off: function(e, t, n) {
                        var r, i;
                        if (e && e.preventDefault && e.handleObj) return r = e.handleObj, w(e.delegateTarget).off(r.namespace ? r.origType + "." + r.namespace : r.origType, r.selector, r.handler), this;
                        if ("object" == typeof e) {
                            for(i in e)this.off(i, t, e[i]);
                            return this;
                        }
                        return !1 !== t && "function" != typeof t || (n = t, t = void 0), !1 === n && (n = Ce), this.each(function() {
                            w.event.remove(this, e, n, t);
                        });
                    }
                });
                var Ae = /<script|<style|<link/i, Ne = /checked\s*(?:[^=]|=\s*.checked.)/i, je = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
                function De(e, t) {
                    return A(e, "table") && A(11 !== t.nodeType ? t : t.firstChild, "tr") && w(e).children("tbody")[0] || e;
                }
                function qe(e) {
                    return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e;
                }
                function Le(e) {
                    return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"), e;
                }
                function He(e, t) {
                    var n, r, i, o, a, s;
                    if (1 === t.nodeType) {
                        if (Y.hasData(e) && (s = Y.get(e).events)) for(i in Y.remove(t, "handle events"), s)for(n = 0, r = s[i].length; n < r; n++)w.event.add(t, i, s[i][n]);
                        Q.hasData(e) && (o = Q.access(e), a = w.extend({}, o), Q.set(t, a));
                    }
                }
                function Oe(e, t, n, r) {
                    t = a(t);
                    var i, o, s, u, l, c, f = 0, p = e.length, d = p - 1, v = t[0], y = g(v);
                    if (y || p > 1 && "string" == typeof v && !h.checkClone && Ne.test(v)) return e.each(function(i) {
                        var o = e.eq(i);
                        y && (t[0] = v.call(this, i, o.html())), Oe(o, t, n, r);
                    });
                    if (p && (o = (i = be(t, e[0].ownerDocument, !1, e, r)).firstChild, 1 === i.childNodes.length && (i = o), o || r)) {
                        for(u = (s = w.map(ye(i, "script"), qe)).length; f < p; f++)l = i, f !== d && (l = w.clone(l, !0, !0), u && w.merge(s, ye(l, "script"))), n.call(e[f], l, f);
                        if (u) for(c = s[s.length - 1].ownerDocument, w.map(s, Le), f = 0; f < u; f++)l = s[f], ge.test(l.type || "") && !Y.access(l, "globalEval") && w.contains(c, l) && (l.src && "module" !== (l.type || "").toLowerCase() ? w._evalUrl && !l.noModule && w._evalUrl(l.src, {
                            nonce: l.nonce || l.getAttribute("nonce")
                        }, c) : x(l.textContent.replace(je, ""), l, c));
                    }
                    return e;
                }
                function Pe(e, t, n) {
                    for(var r, i = t ? w.filter(t, e) : e, o = 0; null != (r = i[o]); o++)n || 1 !== r.nodeType || w.cleanData(ye(r)), r.parentNode && (n && ie(r) && me(ye(r, "script")), r.parentNode.removeChild(r));
                    return e;
                }
                w.extend({
                    htmlPrefilter: function(e) {
                        return e;
                    },
                    clone: function(e, t, n) {
                        var r, i, o, a, s, u, l, c = e.cloneNode(!0), f = ie(e);
                        if (!(h.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || w.isXMLDoc(e))) for(a = ye(c), r = 0, i = (o = ye(e)).length; r < i; r++)s = o[r], u = a[r], l = void 0, "input" === (l = u.nodeName.toLowerCase()) && de.test(s.type) ? u.checked = s.checked : "input" !== l && "textarea" !== l || (u.defaultValue = s.defaultValue);
                        if (t) {
                            if (n) for(o = o || ye(e), a = a || ye(c), r = 0, i = o.length; r < i; r++)He(o[r], a[r]);
                            else He(e, c);
                        }
                        return (a = ye(c, "script")).length > 0 && me(a, !f && ye(e, "script")), c;
                    },
                    cleanData: function(e) {
                        for(var t, n, r, i = w.event.special, o = 0; void 0 !== (n = e[o]); o++)if (V(n)) {
                            if (t = n[Y.expando]) {
                                if (t.events) for(r in t.events)i[r] ? w.event.remove(n, r) : w.removeEvent(n, r, t.handle);
                                n[Y.expando] = void 0;
                            }
                            n[Q.expando] && (n[Q.expando] = void 0);
                        }
                    }
                }), w.fn.extend({
                    detach: function(e) {
                        return Pe(this, e, !0);
                    },
                    remove: function(e) {
                        return Pe(this, e);
                    },
                    text: function(e) {
                        return $(this, function(e) {
                            return void 0 === e ? w.text(this) : this.empty().each(function() {
                                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e);
                            });
                        }, null, e, arguments.length);
                    },
                    append: function() {
                        return Oe(this, arguments, function(e) {
                            1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || De(this, e).appendChild(e);
                        });
                    },
                    prepend: function() {
                        return Oe(this, arguments, function(e) {
                            if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                                var t = De(this, e);
                                t.insertBefore(e, t.firstChild);
                            }
                        });
                    },
                    before: function() {
                        return Oe(this, arguments, function(e) {
                            this.parentNode && this.parentNode.insertBefore(e, this);
                        });
                    },
                    after: function() {
                        return Oe(this, arguments, function(e) {
                            this.parentNode && this.parentNode.insertBefore(e, this.nextSibling);
                        });
                    },
                    empty: function() {
                        for(var e, t = 0; null != (e = this[t]); t++)1 === e.nodeType && (w.cleanData(ye(e, !1)), e.textContent = "");
                        return this;
                    },
                    clone: function(e, t) {
                        return e = null != e && e, t = null == t ? e : t, this.map(function() {
                            return w.clone(this, e, t);
                        });
                    },
                    html: function(e) {
                        return $(this, function(e) {
                            var t = this[0] || {}, n = 0, r = this.length;
                            if (void 0 === e && 1 === t.nodeType) return t.innerHTML;
                            if ("string" == typeof e && !Ae.test(e) && !ve[(he.exec(e) || [
                                "",
                                ""
                            ])[1].toLowerCase()]) {
                                e = w.htmlPrefilter(e);
                                try {
                                    for(; n < r; n++)1 === (t = this[n] || {}).nodeType && (w.cleanData(ye(t, !1)), t.innerHTML = e);
                                    t = 0;
                                } catch (i) {}
                            }
                            t && this.empty().append(e);
                        }, null, e, arguments.length);
                    },
                    replaceWith: function() {
                        var e = [];
                        return Oe(this, arguments, function(t) {
                            var n = this.parentNode;
                            w.inArray(this, e) < 0 && (w.cleanData(ye(this)), n && n.replaceChild(t, this));
                        }, e);
                    }
                }), w.each({
                    appendTo: "append",
                    prependTo: "prepend",
                    insertBefore: "before",
                    insertAfter: "after",
                    replaceAll: "replaceWith"
                }, function(e, t) {
                    w.fn[e] = function(e) {
                        for(var n, r = [], i = w(e), o = i.length - 1, a = 0; a <= o; a++)n = a === o ? this : this.clone(!0), w(i[a])[t](n), s.apply(r, n.get());
                        return this.pushStack(r);
                    };
                });
                var Re = new RegExp("^(" + ee + ")(?!px)[a-z%]+$", "i"), Me = function(e) {
                    var n = e.ownerDocument.defaultView;
                    return n && n.opener || (n = t), n.getComputedStyle(e);
                }, Ie = function(e, t, n) {
                    var r, i, o = {};
                    for(i in t)o[i] = e.style[i], e.style[i] = t[i];
                    for(i in r = n.call(e), t)e.style[i] = o[i];
                    return r;
                }, We = new RegExp(ne.join("|"), "i");
                function Fe(e, t, n) {
                    var r, i, o, a, s = e.style;
                    return (n = n || Me(e)) && ("" !== (a = n.getPropertyValue(t) || n[t]) || ie(e) || (a = w.style(e, t)), !h.pixelBoxStyles() && Re.test(a) && We.test(t) && (r = s.width, i = s.minWidth, o = s.maxWidth, s.minWidth = s.maxWidth = s.width = a, a = n.width, s.width = r, s.minWidth = i, s.maxWidth = o)), void 0 !== a ? a + "" : a;
                }
                function Be(e, t) {
                    return {
                        get: function() {
                            if (!e()) return (this.get = t).apply(this, arguments);
                            delete this.get;
                        }
                    };
                }
                !function() {
                    function e() {
                        if (c) {
                            l.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", c.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", re.appendChild(l).appendChild(c);
                            var e = t.getComputedStyle(c);
                            r = "1%" !== e.top, u = 12 === n(e.marginLeft), c.style.right = "60%", a = 36 === n(e.right), i = 36 === n(e.width), c.style.position = "absolute", o = 12 === n(c.offsetWidth / 3), re.removeChild(l), c = null;
                        }
                    }
                    function n(e) {
                        return Math.round(parseFloat(e));
                    }
                    var r, i, o, a, s, u, l = y.createElement("div"), c = y.createElement("div");
                    c.style && (c.style.backgroundClip = "content-box", c.cloneNode(!0).style.backgroundClip = "", h.clearCloneStyle = "content-box" === c.style.backgroundClip, w.extend(h, {
                        boxSizingReliable: function() {
                            return e(), i;
                        },
                        pixelBoxStyles: function() {
                            return e(), a;
                        },
                        pixelPosition: function() {
                            return e(), r;
                        },
                        reliableMarginLeft: function() {
                            return e(), u;
                        },
                        scrollboxSize: function() {
                            return e(), o;
                        },
                        reliableTrDimensions: function() {
                            var e, n, r, i;
                            return null == s && (e = y.createElement("table"), n = y.createElement("tr"), r = y.createElement("div"), e.style.cssText = "position:absolute;left:-11111px;border-collapse:separate", n.style.cssText = "border:1px solid", n.style.height = "1px", r.style.height = "9px", r.style.display = "block", re.appendChild(e).appendChild(n).appendChild(r), i = t.getComputedStyle(n), s = parseInt(i.height, 10) + parseInt(i.borderTopWidth, 10) + parseInt(i.borderBottomWidth, 10) === n.offsetHeight, re.removeChild(e)), s;
                        }
                    }));
                }();
                var $e = [
                    "Webkit",
                    "Moz",
                    "ms"
                ], _e = y.createElement("div").style, ze = {};
                function Ue(e) {
                    var t = w.cssProps[e] || ze[e];
                    return t || (e in _e ? e : ze[e] = function(e) {
                        for(var t = e[0].toUpperCase() + e.slice(1), n = $e.length; n--;)if ((e = $e[n] + t) in _e) return e;
                    }(e) || e);
                }
                var Xe = /^(none|table(?!-c[ea]).+)/, Ve = /^--/, Ge = {
                    position: "absolute",
                    visibility: "hidden",
                    display: "block"
                }, Ye = {
                    letterSpacing: "0",
                    fontWeight: "400"
                };
                function Qe(e, t, n) {
                    var r = te.exec(t);
                    return r ? Math.max(0, r[2] - (n || 0)) + (r[3] || "px") : t;
                }
                function Je(e, t, n, r, i, o) {
                    var a = "width" === t ? 1 : 0, s = 0, u = 0;
                    if (n === (r ? "border" : "content")) return 0;
                    for(; a < 4; a += 2)"margin" === n && (u += w.css(e, n + ne[a], !0, i)), r ? ("content" === n && (u -= w.css(e, "padding" + ne[a], !0, i)), "margin" !== n && (u -= w.css(e, "border" + ne[a] + "Width", !0, i))) : (u += w.css(e, "padding" + ne[a], !0, i), "padding" !== n ? u += w.css(e, "border" + ne[a] + "Width", !0, i) : s += w.css(e, "border" + ne[a] + "Width", !0, i));
                    return !r && o >= 0 && (u += Math.max(0, Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - o - u - s - .5)) || 0), u;
                }
                function Ke(e, t, n) {
                    var r = Me(e), i = (!h.boxSizingReliable() || n) && "border-box" === w.css(e, "boxSizing", !1, r), o = i, a = Fe(e, t, r), s = "offset" + t[0].toUpperCase() + t.slice(1);
                    if (Re.test(a)) {
                        if (!n) return a;
                        a = "auto";
                    }
                    return (!h.boxSizingReliable() && i || !h.reliableTrDimensions() && A(e, "tr") || "auto" === a || !parseFloat(a) && "inline" === w.css(e, "display", !1, r)) && e.getClientRects().length && (i = "border-box" === w.css(e, "boxSizing", !1, r), (o = s in e) && (a = e[s])), (a = parseFloat(a) || 0) + Je(e, t, n || (i ? "border" : "content"), o, r, a) + "px";
                }
                function Ze(e, t, n, r, i) {
                    return new Ze.prototype.init(e, t, n, r, i);
                }
                w.extend({
                    cssHooks: {
                        opacity: {
                            get: function(e, t) {
                                if (t) {
                                    var n = Fe(e, "opacity");
                                    return "" === n ? "1" : n;
                                }
                            }
                        }
                    },
                    cssNumber: {
                        animationIterationCount: !0,
                        columnCount: !0,
                        fillOpacity: !0,
                        flexGrow: !0,
                        flexShrink: !0,
                        fontWeight: !0,
                        gridArea: !0,
                        gridColumn: !0,
                        gridColumnEnd: !0,
                        gridColumnStart: !0,
                        gridRow: !0,
                        gridRowEnd: !0,
                        gridRowStart: !0,
                        lineHeight: !0,
                        opacity: !0,
                        order: !0,
                        orphans: !0,
                        widows: !0,
                        zIndex: !0,
                        zoom: !0
                    },
                    cssProps: {},
                    style: function(e, t, n, r) {
                        if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                            var i, o, a, s = X(t), u = Ve.test(t), l = e.style;
                            if (u || (t = Ue(s)), a = w.cssHooks[t] || w.cssHooks[s], void 0 === n) return a && "get" in a && void 0 !== (i = a.get(e, !1, r)) ? i : l[t];
                            "string" === (o = typeof n) && (i = te.exec(n)) && i[1] && (n = se(e, t, i), o = "number"), null != n && n == n && ("number" !== o || u || (n += i && i[3] || (w.cssNumber[s] ? "" : "px")), h.clearCloneStyle || "" !== n || 0 !== t.indexOf("background") || (l[t] = "inherit"), a && "set" in a && void 0 === (n = a.set(e, n, r)) || (u ? l.setProperty(t, n) : l[t] = n));
                        }
                    },
                    css: function(e, t, n, r) {
                        var i, o, a, s = X(t);
                        return Ve.test(t) || (t = Ue(s)), (a = w.cssHooks[t] || w.cssHooks[s]) && "get" in a && (i = a.get(e, !0, n)), void 0 === i && (i = Fe(e, t, r)), "normal" === i && t in Ye && (i = Ye[t]), "" === n || n ? (o = parseFloat(i), !0 === n || isFinite(o) ? o || 0 : i) : i;
                    }
                }), w.each([
                    "height",
                    "width"
                ], function(e, t) {
                    w.cssHooks[t] = {
                        get: function(e, n, r) {
                            if (n) return !Xe.test(w.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? Ke(e, t, r) : Ie(e, Ge, function() {
                                return Ke(e, t, r);
                            });
                        },
                        set: function(e, n, r) {
                            var i, o = Me(e), a = !h.scrollboxSize() && "absolute" === o.position, s = (a || r) && "border-box" === w.css(e, "boxSizing", !1, o), u = r ? Je(e, t, r, s, o) : 0;
                            return s && a && (u -= Math.ceil(e["offset" + t[0].toUpperCase() + t.slice(1)] - parseFloat(o[t]) - Je(e, t, "border", !1, o) - .5)), u && (i = te.exec(n)) && "px" !== (i[3] || "px") && (e.style[t] = n, n = w.css(e, t)), Qe(0, n, u);
                        }
                    };
                }), w.cssHooks.marginLeft = Be(h.reliableMarginLeft, function(e, t) {
                    if (t) return (parseFloat(Fe(e, "marginLeft")) || e.getBoundingClientRect().left - Ie(e, {
                        marginLeft: 0
                    }, function() {
                        return e.getBoundingClientRect().left;
                    })) + "px";
                }), w.each({
                    margin: "",
                    padding: "",
                    border: "Width"
                }, function(e, t) {
                    w.cssHooks[e + t] = {
                        expand: function(n) {
                            for(var r = 0, i = {}, o = "string" == typeof n ? n.split(" ") : [
                                n
                            ]; r < 4; r++)i[e + ne[r] + t] = o[r] || o[r - 2] || o[0];
                            return i;
                        }
                    }, "margin" !== e && (w.cssHooks[e + t].set = Qe);
                }), w.fn.extend({
                    css: function(e, t) {
                        return $(this, function(e, t, n) {
                            var r, i, o = {}, a = 0;
                            if (Array.isArray(t)) {
                                for(r = Me(e), i = t.length; a < i; a++)o[t[a]] = w.css(e, t[a], !1, r);
                                return o;
                            }
                            return void 0 !== n ? w.style(e, t, n) : w.css(e, t);
                        }, e, t, arguments.length > 1);
                    }
                }), w.Tween = Ze, Ze.prototype = {
                    constructor: Ze,
                    init: function(e, t, n, r, i, o) {
                        this.elem = e, this.prop = n, this.easing = i || w.easing._default, this.options = t, this.start = this.now = this.cur(), this.end = r, this.unit = o || (w.cssNumber[n] ? "" : "px");
                    },
                    cur: function() {
                        var e = Ze.propHooks[this.prop];
                        return e && e.get ? e.get(this) : Ze.propHooks._default.get(this);
                    },
                    run: function(e) {
                        var t, n = Ze.propHooks[this.prop];
                        return this.options.duration ? this.pos = t = w.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = t = e, this.now = (this.end - this.start) * t + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), n && n.set ? n.set(this) : Ze.propHooks._default.set(this), this;
                    }
                }, Ze.prototype.init.prototype = Ze.prototype, Ze.propHooks = {
                    _default: {
                        get: function(e) {
                            var t;
                            return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (t = w.css(e.elem, e.prop, "")) && "auto" !== t ? t : 0;
                        },
                        set: function(e) {
                            w.fx.step[e.prop] ? w.fx.step[e.prop](e) : 1 !== e.elem.nodeType || !w.cssHooks[e.prop] && null == e.elem.style[Ue(e.prop)] ? e.elem[e.prop] = e.now : w.style(e.elem, e.prop, e.now + e.unit);
                        }
                    }
                }, Ze.propHooks.scrollTop = Ze.propHooks.scrollLeft = {
                    set: function(e) {
                        e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now);
                    }
                }, w.easing = {
                    linear: function(e) {
                        return e;
                    },
                    swing: function(e) {
                        return .5 - Math.cos(e * Math.PI) / 2;
                    },
                    _default: "swing"
                }, w.fx = Ze.prototype.init, w.fx.step = {};
                var et, tt, nt = /^(?:toggle|show|hide)$/, rt = /queueHooks$/;
                function it() {
                    tt && (!1 === y.hidden && t.requestAnimationFrame ? t.requestAnimationFrame(it) : t.setTimeout(it, w.fx.interval), w.fx.tick());
                }
                function ot() {
                    return t.setTimeout(function() {
                        et = void 0;
                    }), et = Date.now();
                }
                function at(e, t) {
                    var n, r = 0, i = {
                        height: e
                    };
                    for(t = t ? 1 : 0; r < 4; r += 2 - t)i["margin" + (n = ne[r])] = i["padding" + n] = e;
                    return t && (i.opacity = i.width = e), i;
                }
                function st(e, t, n) {
                    for(var r, i = (ut.tweeners[t] || []).concat(ut.tweeners["*"]), o = 0, a = i.length; o < a; o++)if (r = i[o].call(n, t, e)) return r;
                }
                function ut(e, t, n) {
                    var r, i, o = 0, a = ut.prefilters.length, s = w.Deferred().always(function() {
                        delete u.elem;
                    }), u = function() {
                        if (i) return !1;
                        for(var t = et || ot(), n = Math.max(0, l.startTime + l.duration - t), r = 1 - (n / l.duration || 0), o = 0, a = l.tweens.length; o < a; o++)l.tweens[o].run(r);
                        return s.notifyWith(e, [
                            l,
                            r,
                            n
                        ]), r < 1 && a ? n : (a || s.notifyWith(e, [
                            l,
                            1,
                            0
                        ]), s.resolveWith(e, [
                            l
                        ]), !1);
                    }, l = s.promise({
                        elem: e,
                        props: w.extend({}, t),
                        opts: w.extend(!0, {
                            specialEasing: {},
                            easing: w.easing._default
                        }, n),
                        originalProperties: t,
                        originalOptions: n,
                        startTime: et || ot(),
                        duration: n.duration,
                        tweens: [],
                        createTween: function(t, n) {
                            var r = w.Tween(e, l.opts, t, n, l.opts.specialEasing[t] || l.opts.easing);
                            return l.tweens.push(r), r;
                        },
                        stop: function(t) {
                            var n = 0, r = t ? l.tweens.length : 0;
                            if (i) return this;
                            for(i = !0; n < r; n++)l.tweens[n].run(1);
                            return t ? (s.notifyWith(e, [
                                l,
                                1,
                                0
                            ]), s.resolveWith(e, [
                                l,
                                t
                            ])) : s.rejectWith(e, [
                                l,
                                t
                            ]), this;
                        }
                    }), c = l.props;
                    for(!function(e, t) {
                        var n, r, i, o, a;
                        for(n in e)if (i = t[r = X(n)], o = e[n], Array.isArray(o) && (i = o[1], o = e[n] = o[0]), n !== r && (e[r] = o, delete e[n]), (a = w.cssHooks[r]) && ("expand" in a)) for(n in o = a.expand(o), delete e[r], o)(n in e) || (e[n] = o[n], t[n] = i);
                        else t[r] = i;
                    }(c, l.opts.specialEasing); o < a; o++)if (r = ut.prefilters[o].call(l, e, c, l.opts)) return g(r.stop) && (w._queueHooks(l.elem, l.opts.queue).stop = r.stop.bind(r)), r;
                    return w.map(c, st, l), g(l.opts.start) && l.opts.start.call(e, l), l.progress(l.opts.progress).done(l.opts.done, l.opts.complete).fail(l.opts.fail).always(l.opts.always), w.fx.timer(w.extend(u, {
                        elem: e,
                        anim: l,
                        queue: l.opts.queue
                    })), l;
                }
                w.Animation = w.extend(ut, {
                    tweeners: {
                        "*": [
                            function(e, t) {
                                var n = this.createTween(e, t);
                                return se(n.elem, e, te.exec(t), n), n;
                            }
                        ]
                    },
                    tweener: function(e, t) {
                        g(e) ? (t = e, e = [
                            "*"
                        ]) : e = e.match(P);
                        for(var n, r = 0, i = e.length; r < i; r++)n = e[r], ut.tweeners[n] = ut.tweeners[n] || [], ut.tweeners[n].unshift(t);
                    },
                    prefilters: [
                        function(e, t, n) {
                            var r, i, o, a, s, u, l, c, f = "width" in t || "height" in t, p = this, d = {}, h = e.style, g = e.nodeType && ae(e), v = Y.get(e, "fxshow");
                            for(r in n.queue || (null == (a = w._queueHooks(e, "fx")).unqueued && (a.unqueued = 0, s = a.empty.fire, a.empty.fire = function() {
                                a.unqueued || s();
                            }), a.unqueued++, p.always(function() {
                                p.always(function() {
                                    a.unqueued--, w.queue(e, "fx").length || a.empty.fire();
                                });
                            })), t)if (i = t[r], nt.test(i)) {
                                if (delete t[r], o = o || "toggle" === i, i === (g ? "hide" : "show")) {
                                    if ("show" !== i || !v || void 0 === v[r]) continue;
                                    g = !0;
                                }
                                d[r] = v && v[r] || w.style(e, r);
                            }
                            if ((u = !w.isEmptyObject(t)) || !w.isEmptyObject(d)) for(r in f && 1 === e.nodeType && (n.overflow = [
                                h.overflow,
                                h.overflowX,
                                h.overflowY
                            ], null == (l = v && v.display) && (l = Y.get(e, "display")), "none" === (c = w.css(e, "display")) && (l ? c = l : (ce([
                                e
                            ], !0), l = e.style.display || l, c = w.css(e, "display"), ce([
                                e
                            ]))), ("inline" === c || "inline-block" === c && null != l) && "none" === w.css(e, "float") && (u || (p.done(function() {
                                h.display = l;
                            }), null == l && (c = h.display, l = "none" === c ? "" : c)), h.display = "inline-block")), n.overflow && (h.overflow = "hidden", p.always(function() {
                                h.overflow = n.overflow[0], h.overflowX = n.overflow[1], h.overflowY = n.overflow[2];
                            })), u = !1, d)u || (v ? "hidden" in v && (g = v.hidden) : v = Y.access(e, "fxshow", {
                                display: l
                            }), o && (v.hidden = !g), g && ce([
                                e
                            ], !0), p.done(function() {
                                for(r in g || ce([
                                    e
                                ]), Y.remove(e, "fxshow"), d)w.style(e, r, d[r]);
                            })), u = st(g ? v[r] : 0, r, p), r in v || (v[r] = u.start, g && (u.end = u.start, u.start = 0));
                        }
                    ],
                    prefilter: function(e, t) {
                        t ? ut.prefilters.unshift(e) : ut.prefilters.push(e);
                    }
                }), w.speed = function(e, t, n) {
                    var r = e && "object" == typeof e ? w.extend({}, e) : {
                        complete: n || !n && t || g(e) && e,
                        duration: e,
                        easing: n && t || t && !g(t) && t
                    };
                    return w.fx.off ? r.duration = 0 : "number" != typeof r.duration && (r.duration in w.fx.speeds ? r.duration = w.fx.speeds[r.duration] : r.duration = w.fx.speeds._default), null != r.queue && !0 !== r.queue || (r.queue = "fx"), r.old = r.complete, r.complete = function() {
                        g(r.old) && r.old.call(this), r.queue && w.dequeue(this, r.queue);
                    }, r;
                }, w.fn.extend({
                    fadeTo: function(e, t, n, r) {
                        return this.filter(ae).css("opacity", 0).show().end().animate({
                            opacity: t
                        }, e, n, r);
                    },
                    animate: function(e, t, n, r) {
                        var i = w.isEmptyObject(e), o = w.speed(t, n, r), a = function() {
                            var t = ut(this, w.extend({}, e), o);
                            (i || Y.get(this, "finish")) && t.stop(!0);
                        };
                        return a.finish = a, i || !1 === o.queue ? this.each(a) : this.queue(o.queue, a);
                    },
                    stop: function(e, t, n) {
                        var r = function(e) {
                            var t = e.stop;
                            delete e.stop, t(n);
                        };
                        return "string" != typeof e && (n = t, t = e, e = void 0), t && this.queue(e || "fx", []), this.each(function() {
                            var t = !0, i = null != e && e + "queueHooks", o = w.timers, a = Y.get(this);
                            if (i) a[i] && a[i].stop && r(a[i]);
                            else for(i in a)a[i] && a[i].stop && rt.test(i) && r(a[i]);
                            for(i = o.length; i--;)o[i].elem !== this || null != e && o[i].queue !== e || (o[i].anim.stop(n), t = !1, o.splice(i, 1));
                            !t && n || w.dequeue(this, e);
                        });
                    },
                    finish: function(e) {
                        return !1 !== e && (e = e || "fx"), this.each(function() {
                            var t, n = Y.get(this), r = n[e + "queue"], i = n[e + "queueHooks"], o = w.timers, a = r ? r.length : 0;
                            for(n.finish = !0, w.queue(this, e, []), i && i.stop && i.stop.call(this, !0), t = o.length; t--;)o[t].elem === this && o[t].queue === e && (o[t].anim.stop(!0), o.splice(t, 1));
                            for(t = 0; t < a; t++)r[t] && r[t].finish && r[t].finish.call(this);
                            delete n.finish;
                        });
                    }
                }), w.each([
                    "toggle",
                    "show",
                    "hide"
                ], function(e, t) {
                    var n = w.fn[t];
                    w.fn[t] = function(e, r, i) {
                        return null == e || "boolean" == typeof e ? n.apply(this, arguments) : this.animate(at(t, !0), e, r, i);
                    };
                }), w.each({
                    slideDown: at("show"),
                    slideUp: at("hide"),
                    slideToggle: at("toggle"),
                    fadeIn: {
                        opacity: "show"
                    },
                    fadeOut: {
                        opacity: "hide"
                    },
                    fadeToggle: {
                        opacity: "toggle"
                    }
                }, function(e, t) {
                    w.fn[e] = function(e, n, r) {
                        return this.animate(t, e, n, r);
                    };
                }), w.timers = [], w.fx.tick = function() {
                    var e, t = 0, n = w.timers;
                    for(et = Date.now(); t < n.length; t++)(e = n[t])() || n[t] !== e || n.splice(t--, 1);
                    n.length || w.fx.stop(), et = void 0;
                }, w.fx.timer = function(e) {
                    w.timers.push(e), w.fx.start();
                }, w.fx.interval = 13, w.fx.start = function() {
                    tt || (tt = !0, it());
                }, w.fx.stop = function() {
                    tt = null;
                }, w.fx.speeds = {
                    slow: 600,
                    fast: 200,
                    _default: 400
                }, w.fn.delay = function(e, n) {
                    return e = w.fx && w.fx.speeds[e] || e, n = n || "fx", this.queue(n, function(n, r) {
                        var i = t.setTimeout(n, e);
                        r.stop = function() {
                            t.clearTimeout(i);
                        };
                    });
                }, function() {
                    var e = y.createElement("input"), t = y.createElement("select").appendChild(y.createElement("option"));
                    e.type = "checkbox", h.checkOn = "" !== e.value, h.optSelected = t.selected, (e = y.createElement("input")).value = "t", e.type = "radio", h.radioValue = "t" === e.value;
                }();
                var lt, ct = w.expr.attrHandle;
                w.fn.extend({
                    attr: function(e, t) {
                        return $(this, w.attr, e, t, arguments.length > 1);
                    },
                    removeAttr: function(e) {
                        return this.each(function() {
                            w.removeAttr(this, e);
                        });
                    }
                }), w.extend({
                    attr: function(e, t, n) {
                        var r, i, o = e.nodeType;
                        if (3 !== o && 8 !== o && 2 !== o) return void 0 === e.getAttribute ? w.prop(e, t, n) : (1 === o && w.isXMLDoc(e) || (i = w.attrHooks[t.toLowerCase()] || (w.expr.match.bool.test(t) ? lt : void 0)), void 0 !== n ? null === n ? void w.removeAttr(e, t) : i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : (e.setAttribute(t, n + ""), n) : i && "get" in i && null !== (r = i.get(e, t)) ? r : null == (r = w.find.attr(e, t)) ? void 0 : r);
                    },
                    attrHooks: {
                        type: {
                            set: function(e, t) {
                                if (!h.radioValue && "radio" === t && A(e, "input")) {
                                    var n = e.value;
                                    return e.setAttribute("type", t), n && (e.value = n), t;
                                }
                            }
                        }
                    },
                    removeAttr: function(e, t) {
                        var n, r = 0, i = t && t.match(P);
                        if (i && 1 === e.nodeType) for(; n = i[r++];)e.removeAttribute(n);
                    }
                }), lt = {
                    set: function(e, t, n) {
                        return !1 === t ? w.removeAttr(e, n) : e.setAttribute(n, n), n;
                    }
                }, w.each(w.expr.match.bool.source.match(/\w+/g), function(e, t) {
                    var n = ct[t] || w.find.attr;
                    ct[t] = function(e, t, r) {
                        var i, o, a = t.toLowerCase();
                        return r || (o = ct[a], ct[a] = i, i = null != n(e, t, r) ? a : null, ct[a] = o), i;
                    };
                });
                var ft = /^(?:input|select|textarea|button)$/i, pt = /^(?:a|area)$/i;
                function dt(e) {
                    return (e.match(P) || []).join(" ");
                }
                function ht(e) {
                    return e.getAttribute && e.getAttribute("class") || "";
                }
                function gt(e) {
                    return Array.isArray(e) ? e : "string" == typeof e && e.match(P) || [];
                }
                w.fn.extend({
                    prop: function(e, t) {
                        return $(this, w.prop, e, t, arguments.length > 1);
                    },
                    removeProp: function(e) {
                        return this.each(function() {
                            delete this[w.propFix[e] || e];
                        });
                    }
                }), w.extend({
                    prop: function(e, t, n) {
                        var r, i, o = e.nodeType;
                        if (3 !== o && 8 !== o && 2 !== o) return 1 === o && w.isXMLDoc(e) || (t = w.propFix[t] || t, i = w.propHooks[t]), void 0 !== n ? i && "set" in i && void 0 !== (r = i.set(e, n, t)) ? r : e[t] = n : i && "get" in i && null !== (r = i.get(e, t)) ? r : e[t];
                    },
                    propHooks: {
                        tabIndex: {
                            get: function(e) {
                                var t = w.find.attr(e, "tabindex");
                                return t ? parseInt(t, 10) : ft.test(e.nodeName) || pt.test(e.nodeName) && e.href ? 0 : -1;
                            }
                        }
                    },
                    propFix: {
                        for: "htmlFor",
                        class: "className"
                    }
                }), h.optSelected || (w.propHooks.selected = {
                    get: function(e) {
                        var t = e.parentNode;
                        return t && t.parentNode && t.parentNode.selectedIndex, null;
                    },
                    set: function(e) {
                        var t = e.parentNode;
                        t && (t.selectedIndex, t.parentNode && t.parentNode.selectedIndex);
                    }
                }), w.each([
                    "tabIndex",
                    "readOnly",
                    "maxLength",
                    "cellSpacing",
                    "cellPadding",
                    "rowSpan",
                    "colSpan",
                    "useMap",
                    "frameBorder",
                    "contentEditable"
                ], function() {
                    w.propFix[this.toLowerCase()] = this;
                }), w.fn.extend({
                    addClass: function(e) {
                        var t, n, r, i, o, a, s, u = 0;
                        if (g(e)) return this.each(function(t) {
                            w(this).addClass(e.call(this, t, ht(this)));
                        });
                        if ((t = gt(e)).length) {
                            for(; n = this[u++];)if (i = ht(n), r = 1 === n.nodeType && " " + dt(i) + " ") {
                                for(a = 0; o = t[a++];)r.indexOf(" " + o + " ") < 0 && (r += o + " ");
                                i !== (s = dt(r)) && n.setAttribute("class", s);
                            }
                        }
                        return this;
                    },
                    removeClass: function(e) {
                        var t, n, r, i, o, a, s, u = 0;
                        if (g(e)) return this.each(function(t) {
                            w(this).removeClass(e.call(this, t, ht(this)));
                        });
                        if (!arguments.length) return this.attr("class", "");
                        if ((t = gt(e)).length) {
                            for(; n = this[u++];)if (i = ht(n), r = 1 === n.nodeType && " " + dt(i) + " ") {
                                for(a = 0; o = t[a++];)for(; r.indexOf(" " + o + " ") > -1;)r = r.replace(" " + o + " ", " ");
                                i !== (s = dt(r)) && n.setAttribute("class", s);
                            }
                        }
                        return this;
                    },
                    toggleClass: function(e, t) {
                        var n = typeof e, r = "string" === n || Array.isArray(e);
                        return "boolean" == typeof t && r ? t ? this.addClass(e) : this.removeClass(e) : g(e) ? this.each(function(n) {
                            w(this).toggleClass(e.call(this, n, ht(this), t), t);
                        }) : this.each(function() {
                            var t, i, o, a;
                            if (r) for(i = 0, o = w(this), a = gt(e); t = a[i++];)o.hasClass(t) ? o.removeClass(t) : o.addClass(t);
                            else void 0 !== e && "boolean" !== n || ((t = ht(this)) && Y.set(this, "__className__", t), this.setAttribute && this.setAttribute("class", t || !1 === e ? "" : Y.get(this, "__className__") || ""));
                        });
                    },
                    hasClass: function(e) {
                        var t, n, r = 0;
                        for(t = " " + e + " "; n = this[r++];)if (1 === n.nodeType && (" " + dt(ht(n)) + " ").indexOf(t) > -1) return !0;
                        return !1;
                    }
                });
                var vt = /\r/g;
                w.fn.extend({
                    val: function(e) {
                        var t, n, r, i = this[0];
                        return arguments.length ? (r = g(e), this.each(function(n) {
                            var i;
                            1 === this.nodeType && (null == (i = r ? e.call(this, n, w(this).val()) : e) ? i = "" : "number" == typeof i ? i += "" : Array.isArray(i) && (i = w.map(i, function(e) {
                                return null == e ? "" : e + "";
                            })), (t = w.valHooks[this.type] || w.valHooks[this.nodeName.toLowerCase()]) && "set" in t && void 0 !== t.set(this, i, "value") || (this.value = i));
                        })) : i ? (t = w.valHooks[i.type] || w.valHooks[i.nodeName.toLowerCase()]) && "get" in t && void 0 !== (n = t.get(i, "value")) ? n : "string" == typeof (n = i.value) ? n.replace(vt, "") : null == n ? "" : n : void 0;
                    }
                }), w.extend({
                    valHooks: {
                        option: {
                            get: function(e) {
                                var t = w.find.attr(e, "value");
                                return null != t ? t : dt(w.text(e));
                            }
                        },
                        select: {
                            get: function(e) {
                                var t, n, r, i = e.options, o = e.selectedIndex, a = "select-one" === e.type, s = a ? null : [], u = a ? o + 1 : i.length;
                                for(r = o < 0 ? u : a ? o : 0; r < u; r++)if (((n = i[r]).selected || r === o) && !n.disabled && (!n.parentNode.disabled || !A(n.parentNode, "optgroup"))) {
                                    if (t = w(n).val(), a) return t;
                                    s.push(t);
                                }
                                return s;
                            },
                            set: function(e, t) {
                                for(var n, r, i = e.options, o = w.makeArray(t), a = i.length; a--;)((r = i[a]).selected = w.inArray(w.valHooks.option.get(r), o) > -1) && (n = !0);
                                return n || (e.selectedIndex = -1), o;
                            }
                        }
                    }
                }), w.each([
                    "radio",
                    "checkbox"
                ], function() {
                    w.valHooks[this] = {
                        set: function(e, t) {
                            if (Array.isArray(t)) return e.checked = w.inArray(w(e).val(), t) > -1;
                        }
                    }, h.checkOn || (w.valHooks[this].get = function(e) {
                        return null === e.getAttribute("value") ? "on" : e.value;
                    });
                }), h.focusin = "onfocusin" in t;
                var yt = /^(?:focusinfocus|focusoutblur)$/, mt = function(e) {
                    e.stopPropagation();
                };
                w.extend(w.event, {
                    trigger: function(e, n, r, i) {
                        var o, a, s, u, l, c, p, d, h = [
                            r || y
                        ], m = f.call(e, "type") ? e.type : e, x = f.call(e, "namespace") ? e.namespace.split(".") : [];
                        if (a = d = s = r = r || y, 3 !== r.nodeType && 8 !== r.nodeType && !yt.test(m + w.event.triggered) && (m.indexOf(".") > -1 && (x = m.split("."), m = x.shift(), x.sort()), l = m.indexOf(":") < 0 && "on" + m, (e = e[w.expando] ? e : new w.Event(m, "object" == typeof e && e)).isTrigger = i ? 2 : 3, e.namespace = x.join("."), e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + x.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target || (e.target = r), n = null == n ? [
                            e
                        ] : w.makeArray(n, [
                            e
                        ]), p = w.event.special[m] || {}, i || !p.trigger || !1 !== p.trigger.apply(r, n))) {
                            if (!i && !p.noBubble && !v(r)) {
                                for(u = p.delegateType || m, yt.test(u + m) || (a = a.parentNode); a; a = a.parentNode)h.push(a), s = a;
                                s === (r.ownerDocument || y) && h.push(s.defaultView || s.parentWindow || t);
                            }
                            for(o = 0; (a = h[o++]) && !e.isPropagationStopped();)d = a, e.type = o > 1 ? u : p.bindType || m, (c = (Y.get(a, "events") || Object.create(null))[e.type] && Y.get(a, "handle")) && c.apply(a, n), (c = l && a[l]) && c.apply && V(a) && (e.result = c.apply(a, n), !1 === e.result && e.preventDefault());
                            return e.type = m, i || e.isDefaultPrevented() || p._default && !1 !== p._default.apply(h.pop(), n) || !V(r) || l && g(r[m]) && !v(r) && ((s = r[l]) && (r[l] = null), w.event.triggered = m, e.isPropagationStopped() && d.addEventListener(m, mt), r[m](), e.isPropagationStopped() && d.removeEventListener(m, mt), w.event.triggered = void 0, s && (r[l] = s)), e.result;
                        }
                    },
                    simulate: function(e, t, n) {
                        var r = w.extend(new w.Event, n, {
                            type: e,
                            isSimulated: !0
                        });
                        w.event.trigger(r, null, t);
                    }
                }), w.fn.extend({
                    trigger: function(e, t) {
                        return this.each(function() {
                            w.event.trigger(e, t, this);
                        });
                    },
                    triggerHandler: function(e, t) {
                        var n = this[0];
                        if (n) return w.event.trigger(e, t, n, !0);
                    }
                }), h.focusin || w.each({
                    focus: "focusin",
                    blur: "focusout"
                }, function(e, t) {
                    var n = function(e) {
                        w.event.simulate(t, e.target, w.event.fix(e));
                    };
                    w.event.special[t] = {
                        setup: function() {
                            var r = this.ownerDocument || this.document || this, i = Y.access(r, t);
                            i || r.addEventListener(e, n, !0), Y.access(r, t, (i || 0) + 1);
                        },
                        teardown: function() {
                            var r = this.ownerDocument || this.document || this, i = Y.access(r, t) - 1;
                            i ? Y.access(r, t, i) : (r.removeEventListener(e, n, !0), Y.remove(r, t));
                        }
                    };
                });
                var xt = t.location, bt = {
                    guid: Date.now()
                }, wt = /\?/;
                w.parseXML = function(e) {
                    var n, r;
                    if (!e || "string" != typeof e) return null;
                    try {
                        n = (new t.DOMParser).parseFromString(e, "text/xml");
                    } catch (i) {}
                    return r = n && n.getElementsByTagName("parsererror")[0], n && !r || w.error("Invalid XML: " + (r ? w.map(r.childNodes, function(e) {
                        return e.textContent;
                    }).join("\n") : e)), n;
                };
                var Tt = /\[\]$/, Ct = /\r?\n/g, Et = /^(?:submit|button|image|reset|file)$/i, St = /^(?:input|select|textarea|keygen)/i;
                function kt(e, t, n, r) {
                    var i;
                    if (Array.isArray(t)) w.each(t, function(t, i) {
                        n || Tt.test(e) ? r(e, i) : kt(e + "[" + ("object" == typeof i && null != i ? t : "") + "]", i, n, r);
                    });
                    else if (n || "object" !== b(t)) r(e, t);
                    else for(i in t)kt(e + "[" + i + "]", t[i], n, r);
                }
                w.param = function(e, t) {
                    var n, r = [], i = function(e, t) {
                        var n = g(t) ? t() : t;
                        r[r.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == n ? "" : n);
                    };
                    if (null == e) return "";
                    if (Array.isArray(e) || e.jquery && !w.isPlainObject(e)) w.each(e, function() {
                        i(this.name, this.value);
                    });
                    else for(n in e)kt(n, e[n], t, i);
                    return r.join("&");
                }, w.fn.extend({
                    serialize: function() {
                        return w.param(this.serializeArray());
                    },
                    serializeArray: function() {
                        return this.map(function() {
                            var e = w.prop(this, "elements");
                            return e ? w.makeArray(e) : this;
                        }).filter(function() {
                            var e = this.type;
                            return this.name && !w(this).is(":disabled") && St.test(this.nodeName) && !Et.test(e) && (this.checked || !de.test(e));
                        }).map(function(e, t) {
                            var n = w(this).val();
                            return null == n ? null : Array.isArray(n) ? w.map(n, function(e) {
                                return {
                                    name: t.name,
                                    value: e.replace(Ct, "\r\n")
                                };
                            }) : {
                                name: t.name,
                                value: n.replace(Ct, "\r\n")
                            };
                        }).get();
                    }
                });
                var At = /%20/g, Nt = /#.*$/, jt = /([?&])_=[^&]*/, Dt = /^(.*?):[ \t]*([^\r\n]*)$/gm, qt = /^(?:GET|HEAD)$/, Lt = /^\/\//, Ht = {}, Ot = {}, Pt = "*/".concat("*"), Rt = y.createElement("a");
                function Mt(e) {
                    return function(t, n) {
                        "string" != typeof t && (n = t, t = "*");
                        var r, i = 0, o = t.toLowerCase().match(P) || [];
                        if (g(n)) for(; r = o[i++];)"+" === r[0] ? (r = r.slice(1) || "*", (e[r] = e[r] || []).unshift(n)) : (e[r] = e[r] || []).push(n);
                    };
                }
                function It(e, t, n, r) {
                    var i = {}, o = e === Ot;
                    function a(s) {
                        var u;
                        return i[s] = !0, w.each(e[s] || [], function(e, s) {
                            var l = s(t, n, r);
                            return "string" != typeof l || o || i[l] ? o ? !(u = l) : void 0 : (t.dataTypes.unshift(l), a(l), !1);
                        }), u;
                    }
                    return a(t.dataTypes[0]) || !i["*"] && a("*");
                }
                function Wt(e, t) {
                    var n, r, i = w.ajaxSettings.flatOptions || {};
                    for(n in t)void 0 !== t[n] && ((i[n] ? e : r || (r = {}))[n] = t[n]);
                    return r && w.extend(!0, e, r), e;
                }
                Rt.href = xt.href, w.extend({
                    active: 0,
                    lastModified: {},
                    etag: {},
                    ajaxSettings: {
                        url: xt.href,
                        type: "GET",
                        isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(xt.protocol),
                        global: !0,
                        processData: !0,
                        async: !0,
                        contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                        accepts: {
                            "*": Pt,
                            text: "text/plain",
                            html: "text/html",
                            xml: "application/xml, text/xml",
                            json: "application/json, text/javascript"
                        },
                        contents: {
                            xml: /\bxml\b/,
                            html: /\bhtml/,
                            json: /\bjson\b/
                        },
                        responseFields: {
                            xml: "responseXML",
                            text: "responseText",
                            json: "responseJSON"
                        },
                        converters: {
                            "* text": String,
                            "text html": !0,
                            "text json": JSON.parse,
                            "text xml": w.parseXML
                        },
                        flatOptions: {
                            url: !0,
                            context: !0
                        }
                    },
                    ajaxSetup: function(e, t) {
                        return t ? Wt(Wt(e, w.ajaxSettings), t) : Wt(w.ajaxSettings, e);
                    },
                    ajaxPrefilter: Mt(Ht),
                    ajaxTransport: Mt(Ot),
                    ajax: function(e, n) {
                        "object" == typeof e && (n = e, e = void 0), n = n || {};
                        var r, i, o, a, s, u, l, c, f, p, d = w.ajaxSetup({}, n), h = d.context || d, g = d.context && (h.nodeType || h.jquery) ? w(h) : w.event, v = w.Deferred(), m = w.Callbacks("once memory"), x = d.statusCode || {}, b = {}, T = {}, C = "canceled", E = {
                            readyState: 0,
                            getResponseHeader: function(e) {
                                var t;
                                if (l) {
                                    if (!a) for(a = {}; t = Dt.exec(o);)a[t[1].toLowerCase() + " "] = (a[t[1].toLowerCase() + " "] || []).concat(t[2]);
                                    t = a[e.toLowerCase() + " "];
                                }
                                return null == t ? null : t.join(", ");
                            },
                            getAllResponseHeaders: function() {
                                return l ? o : null;
                            },
                            setRequestHeader: function(e, t) {
                                return null == l && (e = T[e.toLowerCase()] = T[e.toLowerCase()] || e, b[e] = t), this;
                            },
                            overrideMimeType: function(e) {
                                return null == l && (d.mimeType = e), this;
                            },
                            statusCode: function(e) {
                                var t;
                                if (e) {
                                    if (l) E.always(e[E.status]);
                                    else for(t in e)x[t] = [
                                        x[t],
                                        e[t]
                                    ];
                                }
                                return this;
                            },
                            abort: function(e) {
                                var t = e || C;
                                return r && r.abort(t), S(0, t), this;
                            }
                        };
                        if (v.promise(E), d.url = ((e || d.url || xt.href) + "").replace(Lt, xt.protocol + "//"), d.type = n.method || n.type || d.method || d.type, d.dataTypes = (d.dataType || "*").toLowerCase().match(P) || [
                            ""
                        ], null == d.crossDomain) {
                            u = y.createElement("a");
                            try {
                                u.href = d.url, u.href = u.href, d.crossDomain = Rt.protocol + "//" + Rt.host != u.protocol + "//" + u.host;
                            } catch (k) {
                                d.crossDomain = !0;
                            }
                        }
                        if (d.data && d.processData && "string" != typeof d.data && (d.data = w.param(d.data, d.traditional)), It(Ht, d, n, E), l) return E;
                        for(f in (c = w.event && d.global) && 0 == w.active++ && w.event.trigger("ajaxStart"), d.type = d.type.toUpperCase(), d.hasContent = !qt.test(d.type), i = d.url.replace(Nt, ""), d.hasContent ? d.data && d.processData && 0 === (d.contentType || "").indexOf("application/x-www-form-urlencoded") && (d.data = d.data.replace(At, "+")) : (p = d.url.slice(i.length), d.data && (d.processData || "string" == typeof d.data) && (i += (wt.test(i) ? "&" : "?") + d.data, delete d.data), !1 === d.cache && (i = i.replace(jt, "$1"), p = (wt.test(i) ? "&" : "?") + "_=" + bt.guid++ + p), d.url = i + p), d.ifModified && (w.lastModified[i] && E.setRequestHeader("If-Modified-Since", w.lastModified[i]), w.etag[i] && E.setRequestHeader("If-None-Match", w.etag[i])), (d.data && d.hasContent && !1 !== d.contentType || n.contentType) && E.setRequestHeader("Content-Type", d.contentType), E.setRequestHeader("Accept", d.dataTypes[0] && d.accepts[d.dataTypes[0]] ? d.accepts[d.dataTypes[0]] + ("*" !== d.dataTypes[0] ? ", " + Pt + "; q=0.01" : "") : d.accepts["*"]), d.headers)E.setRequestHeader(f, d.headers[f]);
                        if (d.beforeSend && (!1 === d.beforeSend.call(h, E, d) || l)) return E.abort();
                        if (C = "abort", m.add(d.complete), E.done(d.success), E.fail(d.error), r = It(Ot, d, n, E)) {
                            if (E.readyState = 1, c && g.trigger("ajaxSend", [
                                E,
                                d
                            ]), l) return E;
                            d.async && d.timeout > 0 && (s = t.setTimeout(function() {
                                E.abort("timeout");
                            }, d.timeout));
                            try {
                                l = !1, r.send(b, S);
                            } catch (k) {
                                if (l) throw k;
                                S(-1, k);
                            }
                        } else S(-1, "No Transport");
                        function S(e, n, a, u) {
                            var f, p, y, b, T, C = n;
                            l || (l = !0, s && t.clearTimeout(s), r = void 0, o = u || "", E.readyState = e > 0 ? 4 : 0, f = e >= 200 && e < 300 || 304 === e, a && (b = function(e, t, n) {
                                for(var r, i, o, a, s = e.contents, u = e.dataTypes; "*" === u[0];)u.shift(), void 0 === r && (r = e.mimeType || t.getResponseHeader("Content-Type"));
                                if (r) {
                                    for(i in s)if (s[i] && s[i].test(r)) {
                                        u.unshift(i);
                                        break;
                                    }
                                }
                                if (u[0] in n) o = u[0];
                                else {
                                    for(i in n){
                                        if (!u[0] || e.converters[i + " " + u[0]]) {
                                            o = i;
                                            break;
                                        }
                                        a || (a = i);
                                    }
                                    o = o || a;
                                }
                                if (o) return o !== u[0] && u.unshift(o), n[o];
                            }(d, E, a)), !f && w.inArray("script", d.dataTypes) > -1 && w.inArray("json", d.dataTypes) < 0 && (d.converters["text script"] = function() {}), b = function(e, t, n, r) {
                                var i, o, a, s, u, l = {}, c = e.dataTypes.slice();
                                if (c[1]) for(a in e.converters)l[a.toLowerCase()] = e.converters[a];
                                for(o = c.shift(); o;)if (e.responseFields[o] && (n[e.responseFields[o]] = t), !u && r && e.dataFilter && (t = e.dataFilter(t, e.dataType)), u = o, o = c.shift()) {
                                    if ("*" === o) o = u;
                                    else if ("*" !== u && u !== o) {
                                        if (!(a = l[u + " " + o] || l["* " + o])) {
                                            for(i in l)if ((s = i.split(" "))[1] === o && (a = l[u + " " + s[0]] || l["* " + s[0]])) {
                                                !0 === a ? a = l[i] : !0 !== l[i] && (o = s[0], c.unshift(s[1]));
                                                break;
                                            }
                                        }
                                        if (!0 !== a) {
                                            if (a && e.throws) t = a(t);
                                            else try {
                                                t = a(t);
                                            } catch (k) {
                                                return {
                                                    state: "parsererror",
                                                    error: a ? k : "No conversion from " + u + " to " + o
                                                };
                                            }
                                        }
                                    }
                                }
                                return {
                                    state: "success",
                                    data: t
                                };
                            }(d, b, E, f), f ? (d.ifModified && ((T = E.getResponseHeader("Last-Modified")) && (w.lastModified[i] = T), (T = E.getResponseHeader("etag")) && (w.etag[i] = T)), 204 === e || "HEAD" === d.type ? C = "nocontent" : 304 === e ? C = "notmodified" : (C = b.state, p = b.data, f = !(y = b.error))) : (y = C, !e && C || (C = "error", e < 0 && (e = 0))), E.status = e, E.statusText = (n || C) + "", f ? v.resolveWith(h, [
                                p,
                                C,
                                E
                            ]) : v.rejectWith(h, [
                                E,
                                C,
                                y
                            ]), E.statusCode(x), x = void 0, c && g.trigger(f ? "ajaxSuccess" : "ajaxError", [
                                E,
                                d,
                                f ? p : y
                            ]), m.fireWith(h, [
                                E,
                                C
                            ]), c && (g.trigger("ajaxComplete", [
                                E,
                                d
                            ]), --w.active || w.event.trigger("ajaxStop")));
                        }
                        return E;
                    },
                    getJSON: function(e, t, n) {
                        return w.get(e, t, n, "json");
                    },
                    getScript: function(e, t) {
                        return w.get(e, void 0, t, "script");
                    }
                }), w.each([
                    "get",
                    "post"
                ], function(e, t) {
                    w[t] = function(e, n, r, i) {
                        return g(n) && (i = i || r, r = n, n = void 0), w.ajax(w.extend({
                            url: e,
                            type: t,
                            dataType: i,
                            data: n,
                            success: r
                        }, w.isPlainObject(e) && e));
                    };
                }), w.ajaxPrefilter(function(e) {
                    var t;
                    for(t in e.headers)"content-type" === t.toLowerCase() && (e.contentType = e.headers[t] || "");
                }), w._evalUrl = function(e, t, n) {
                    return w.ajax({
                        url: e,
                        type: "GET",
                        dataType: "script",
                        cache: !0,
                        async: !1,
                        global: !1,
                        converters: {
                            "text script": function() {}
                        },
                        dataFilter: function(e) {
                            w.globalEval(e, t, n);
                        }
                    });
                }, w.fn.extend({
                    wrapAll: function(e) {
                        var t;
                        return this[0] && (g(e) && (e = e.call(this[0])), t = w(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && t.insertBefore(this[0]), t.map(function() {
                            for(var e = this; e.firstElementChild;)e = e.firstElementChild;
                            return e;
                        }).append(this)), this;
                    },
                    wrapInner: function(e) {
                        return g(e) ? this.each(function(t) {
                            w(this).wrapInner(e.call(this, t));
                        }) : this.each(function() {
                            var t = w(this), n = t.contents();
                            n.length ? n.wrapAll(e) : t.append(e);
                        });
                    },
                    wrap: function(e) {
                        var t = g(e);
                        return this.each(function(n) {
                            w(this).wrapAll(t ? e.call(this, n) : e);
                        });
                    },
                    unwrap: function(e) {
                        return this.parent(e).not("body").each(function() {
                            w(this).replaceWith(this.childNodes);
                        }), this;
                    }
                }), w.expr.pseudos.hidden = function(e) {
                    return !w.expr.pseudos.visible(e);
                }, w.expr.pseudos.visible = function(e) {
                    return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
                }, w.ajaxSettings.xhr = function() {
                    try {
                        return new t.XMLHttpRequest;
                    } catch (e) {}
                };
                var Ft = {
                    0: 200,
                    1223: 204
                }, Bt = w.ajaxSettings.xhr();
                h.cors = !!Bt && "withCredentials" in Bt, h.ajax = Bt = !!Bt, w.ajaxTransport(function(e) {
                    var n, r;
                    if (h.cors || Bt && !e.crossDomain) return {
                        send: function(i, o) {
                            var a, s = e.xhr();
                            if (s.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields) for(a in e.xhrFields)s[a] = e.xhrFields[a];
                            for(a in e.mimeType && s.overrideMimeType && s.overrideMimeType(e.mimeType), e.crossDomain || i["X-Requested-With"] || (i["X-Requested-With"] = "XMLHttpRequest"), i)s.setRequestHeader(a, i[a]);
                            n = function(e) {
                                return function() {
                                    n && (n = r = s.onload = s.onerror = s.onabort = s.ontimeout = s.onreadystatechange = null, "abort" === e ? s.abort() : "error" === e ? "number" != typeof s.status ? o(0, "error") : o(s.status, s.statusText) : o(Ft[s.status] || s.status, s.statusText, "text" !== (s.responseType || "text") || "string" != typeof s.responseText ? {
                                        binary: s.response
                                    } : {
                                        text: s.responseText
                                    }, s.getAllResponseHeaders()));
                                };
                            }, s.onload = n(), r = s.onerror = s.ontimeout = n("error"), void 0 !== s.onabort ? s.onabort = r : s.onreadystatechange = function() {
                                4 === s.readyState && t.setTimeout(function() {
                                    n && r();
                                });
                            }, n = n("abort");
                            try {
                                s.send(e.hasContent && e.data || null);
                            } catch (u) {
                                if (n) throw u;
                            }
                        },
                        abort: function() {
                            n && n();
                        }
                    };
                }), w.ajaxPrefilter(function(e) {
                    e.crossDomain && (e.contents.script = !1);
                }), w.ajaxSetup({
                    accepts: {
                        script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
                    },
                    contents: {
                        script: /\b(?:java|ecma)script\b/
                    },
                    converters: {
                        "text script": function(e) {
                            return w.globalEval(e), e;
                        }
                    }
                }), w.ajaxPrefilter("script", function(e) {
                    void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET");
                }), w.ajaxTransport("script", function(e) {
                    var t, n;
                    if (e.crossDomain || e.scriptAttrs) return {
                        send: function(r, i) {
                            t = w("<script>").attr(e.scriptAttrs || {}).prop({
                                charset: e.scriptCharset,
                                src: e.url
                            }).on("load error", n = function(e) {
                                t.remove(), n = null, e && i("error" === e.type ? 404 : 200, e.type);
                            }), y.head.appendChild(t[0]);
                        },
                        abort: function() {
                            n && n();
                        }
                    };
                });
                var $t, _t = [], zt = /(=)\?(?=&|$)|\?\?/;
                w.ajaxSetup({
                    jsonp: "callback",
                    jsonpCallback: function() {
                        var e = _t.pop() || w.expando + "_" + bt.guid++;
                        return this[e] = !0, e;
                    }
                }), w.ajaxPrefilter("json jsonp", function(e, n, r) {
                    var i, o, a, s = !1 !== e.jsonp && (zt.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && zt.test(e.data) && "data");
                    if (s || "jsonp" === e.dataTypes[0]) return i = e.jsonpCallback = g(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, s ? e[s] = e[s].replace(zt, "$1" + i) : !1 !== e.jsonp && (e.url += (wt.test(e.url) ? "&" : "?") + e.jsonp + "=" + i), e.converters["script json"] = function() {
                        return a || w.error(i + " was not called"), a[0];
                    }, e.dataTypes[0] = "json", o = t[i], t[i] = function() {
                        a = arguments;
                    }, r.always(function() {
                        void 0 === o ? w(t).removeProp(i) : t[i] = o, e[i] && (e.jsonpCallback = n.jsonpCallback, _t.push(i)), a && g(o) && o(a[0]), a = o = void 0;
                    }), "script";
                }), h.createHTMLDocument = (($t = y.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>", 2 === $t.childNodes.length), w.parseHTML = function(e, t, n) {
                    var r, i, o;
                    return "string" != typeof e ? [] : ("boolean" == typeof t && (n = t, t = !1), t || (h.createHTMLDocument ? ((r = (t = y.implementation.createHTMLDocument("")).createElement("base")).href = y.location.href, t.head.appendChild(r)) : t = y), o = !n && [], (i = N.exec(e)) ? [
                        t.createElement(i[1])
                    ] : (i = be([
                        e
                    ], t, o), o && o.length && w(o).remove(), w.merge([], i.childNodes)));
                }, w.fn.load = function(e, t, n) {
                    var r, i, o, a = this, s = e.indexOf(" ");
                    return s > -1 && (r = dt(e.slice(s)), e = e.slice(0, s)), g(t) ? (n = t, t = void 0) : t && "object" == typeof t && (i = "POST"), a.length > 0 && w.ajax({
                        url: e,
                        type: i || "GET",
                        dataType: "html",
                        data: t
                    }).done(function(e) {
                        o = arguments, a.html(r ? w("<div>").append(w.parseHTML(e)).find(r) : e);
                    }).always(n && function(e, t) {
                        a.each(function() {
                            n.apply(this, o || [
                                e.responseText,
                                t,
                                e
                            ]);
                        });
                    }), this;
                }, w.expr.pseudos.animated = function(e) {
                    return w.grep(w.timers, function(t) {
                        return e === t.elem;
                    }).length;
                }, w.offset = {
                    setOffset: function(e, t, n) {
                        var r, i, o, a, s, u, l = w.css(e, "position"), c = w(e), f = {};
                        "static" === l && (e.style.position = "relative"), s = c.offset(), o = w.css(e, "top"), u = w.css(e, "left"), ("absolute" === l || "fixed" === l) && (o + u).indexOf("auto") > -1 ? (a = (r = c.position()).top, i = r.left) : (a = parseFloat(o) || 0, i = parseFloat(u) || 0), g(t) && (t = t.call(e, n, w.extend({}, s))), null != t.top && (f.top = t.top - s.top + a), null != t.left && (f.left = t.left - s.left + i), "using" in t ? t.using.call(e, f) : c.css(f);
                    }
                }, w.fn.extend({
                    offset: function(e) {
                        if (arguments.length) return void 0 === e ? this : this.each(function(t) {
                            w.offset.setOffset(this, e, t);
                        });
                        var t, n, r = this[0];
                        return r ? r.getClientRects().length ? (t = r.getBoundingClientRect(), n = r.ownerDocument.defaultView, {
                            top: t.top + n.pageYOffset,
                            left: t.left + n.pageXOffset
                        }) : {
                            top: 0,
                            left: 0
                        } : void 0;
                    },
                    position: function() {
                        if (this[0]) {
                            var e, t, n, r = this[0], i = {
                                top: 0,
                                left: 0
                            };
                            if ("fixed" === w.css(r, "position")) t = r.getBoundingClientRect();
                            else {
                                for(t = this.offset(), n = r.ownerDocument, e = r.offsetParent || n.documentElement; e && (e === n.body || e === n.documentElement) && "static" === w.css(e, "position");)e = e.parentNode;
                                e && e !== r && 1 === e.nodeType && ((i = w(e).offset()).top += w.css(e, "borderTopWidth", !0), i.left += w.css(e, "borderLeftWidth", !0));
                            }
                            return {
                                top: t.top - i.top - w.css(r, "marginTop", !0),
                                left: t.left - i.left - w.css(r, "marginLeft", !0)
                            };
                        }
                    },
                    offsetParent: function() {
                        return this.map(function() {
                            for(var e = this.offsetParent; e && "static" === w.css(e, "position");)e = e.offsetParent;
                            return e || re;
                        });
                    }
                }), w.each({
                    scrollLeft: "pageXOffset",
                    scrollTop: "pageYOffset"
                }, function(e, t) {
                    var n = "pageYOffset" === t;
                    w.fn[e] = function(r) {
                        return $(this, function(e, r, i) {
                            var o;
                            if (v(e) ? o = e : 9 === e.nodeType && (o = e.defaultView), void 0 === i) return o ? o[t] : e[r];
                            o ? o.scrollTo(n ? o.pageXOffset : i, n ? i : o.pageYOffset) : e[r] = i;
                        }, e, r, arguments.length);
                    };
                }), w.each([
                    "top",
                    "left"
                ], function(e, t) {
                    w.cssHooks[t] = Be(h.pixelPosition, function(e, n) {
                        if (n) return n = Fe(e, t), Re.test(n) ? w(e).position()[t] + "px" : n;
                    });
                }), w.each({
                    Height: "height",
                    Width: "width"
                }, function(e, t) {
                    w.each({
                        padding: "inner" + e,
                        content: t,
                        "": "outer" + e
                    }, function(n, r) {
                        w.fn[r] = function(i, o) {
                            var a = arguments.length && (n || "boolean" != typeof i), s = n || (!0 === i || !0 === o ? "margin" : "border");
                            return $(this, function(t, n, i) {
                                var o;
                                return v(t) ? 0 === r.indexOf("outer") ? t["inner" + e] : t.document.documentElement["client" + e] : 9 === t.nodeType ? (o = t.documentElement, Math.max(t.body["scroll" + e], o["scroll" + e], t.body["offset" + e], o["offset" + e], o["client" + e])) : void 0 === i ? w.css(t, n, s) : w.style(t, n, i, s);
                            }, t, a ? i : void 0, a);
                        };
                    });
                }), w.each([
                    "ajaxStart",
                    "ajaxStop",
                    "ajaxComplete",
                    "ajaxError",
                    "ajaxSuccess",
                    "ajaxSend"
                ], function(e, t) {
                    w.fn[t] = function(e) {
                        return this.on(t, e);
                    };
                }), w.fn.extend({
                    bind: function(e, t, n) {
                        return this.on(e, null, t, n);
                    },
                    unbind: function(e, t) {
                        return this.off(e, null, t);
                    },
                    delegate: function(e, t, n, r) {
                        return this.on(t, e, n, r);
                    },
                    undelegate: function(e, t, n) {
                        return 1 === arguments.length ? this.off(e, "**") : this.off(t, e || "**", n);
                    },
                    hover: function(e, t) {
                        return this.mouseenter(e).mouseleave(t || e);
                    }
                }), w.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(e, t) {
                    w.fn[t] = function(e, n) {
                        return arguments.length > 0 ? this.on(t, null, e, n) : this.trigger(t);
                    };
                });
                var Ut = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
                w.proxy = function(e, t) {
                    var n, r, i;
                    if ("string" == typeof t && (n = e[t], t = e, e = n), g(e)) return r = o.call(arguments, 2), (i = function() {
                        return e.apply(t || this, r.concat(o.call(arguments)));
                    }).guid = e.guid = e.guid || w.guid++, i;
                }, w.holdReady = function(e) {
                    e ? w.readyWait++ : w.ready(!0);
                }, w.isArray = Array.isArray, w.parseJSON = JSON.parse, w.nodeName = A, w.isFunction = g, w.isWindow = v, w.camelCase = X, w.type = b, w.now = Date.now, w.isNumeric = function(e) {
                    var t = w.type(e);
                    return ("number" === t || "string" === t) && !isNaN(e - parseFloat(e));
                }, w.trim = function(e) {
                    return null == e ? "" : (e + "").replace(Ut, "");
                }, "function" == typeof e && e.amd && e("jquery", [], function() {
                    return w;
                });
                var Xt = t.jQuery, Vt = t.$;
                return w.noConflict = function(e) {
                    return t.$ === w && (t.$ = Vt), e && t.jQuery === w && (t.jQuery = Xt), w;
                }, void 0 === n && (t.jQuery = t.$ = w), w;
            });
        },
        {
            "process": "rH1J"
        }
    ],
    "lvA9": [
        function(require1, module1, exports) {
            var define;
            var e;
            !function(t, n) {
                "object" == typeof exports && "object" == typeof module1 ? module1.exports = n() : "function" == typeof e && e.amd ? e([], n) : "object" == typeof exports ? exports.VuejsPaginate = n() : t.VuejsPaginate = n();
            }(this, function() {
                return function(e) {
                    function t(s) {
                        if (n[s]) return n[s].exports;
                        var a = n[s] = {
                            exports: {},
                            id: s,
                            loaded: !1
                        };
                        return e[s].call(a.exports, a, a.exports, t), a.loaded = !0, a.exports;
                    }
                    var n = {};
                    return t.m = e, t.c = n, t.p = "", t(0);
                }([
                    function(e, t, n) {
                        "use strict";
                        var s = function(e) {
                            return e && e.__esModule ? e : {
                                default: e
                            };
                        }(n(1));
                        e.exports = s.default;
                    },
                    function(e, t, n) {
                        n(2);
                        var s = n(6)(n(7), n(8), "data-v-82963a40", null);
                        e.exports = s.exports;
                    },
                    function(e, t, n) {
                        var s = n(3);
                        "string" == typeof s && (s = [
                            [
                                e.id,
                                s,
                                ""
                            ]
                        ]), n(5)(s, {}), s.locals && (e.exports = s.locals);
                    },
                    function(e, t, n) {
                        (e.exports = n(4)()).push([
                            e.id,
                            "a[data-v-82963a40]{cursor:pointer}",
                            ""
                        ]);
                    },
                    function(e, t) {
                        e.exports = function() {
                            var e = [];
                            return e.toString = function() {
                                for(var e = [], t = 0; t < this.length; t++){
                                    var n = this[t];
                                    n[2] ? e.push("@media " + n[2] + "{" + n[1] + "}") : e.push(n[1]);
                                }
                                return e.join("");
                            }, e.i = function(t, n) {
                                "string" == typeof t && (t = [
                                    [
                                        null,
                                        t,
                                        ""
                                    ]
                                ]);
                                for(var s = {}, a = 0; a < this.length; a++){
                                    var i = this[a][0];
                                    "number" == typeof i && (s[i] = !0);
                                }
                                for(a = 0; a < t.length; a++){
                                    var r = t[a];
                                    "number" == typeof r[0] && s[r[0]] || (n && !r[2] ? r[2] = n : n && (r[2] = "(" + r[2] + ") and (" + n + ")"), e.push(r));
                                }
                            }, e;
                        };
                    },
                    function(e, t, n) {
                        function s(e, t) {
                            for(var n = 0; n < e.length; n++){
                                var s = e[n], a = o[s.id];
                                if (a) {
                                    a.refs++;
                                    for(var i = 0; i < a.parts.length; i++)a.parts[i](s.parts[i]);
                                    for(; i < s.parts.length; i++)a.parts.push(r(s.parts[i], t));
                                } else {
                                    var l = [];
                                    for(i = 0; i < s.parts.length; i++)l.push(r(s.parts[i], t));
                                    o[s.id] = {
                                        id: s.id,
                                        refs: 1,
                                        parts: l
                                    };
                                }
                            }
                        }
                        function a(e) {
                            for(var t = [], n = {}, s = 0; s < e.length; s++){
                                var a = e[s], i = a[0], r = {
                                    css: a[1],
                                    media: a[2],
                                    sourceMap: a[3]
                                };
                                n[i] ? n[i].parts.push(r) : t.push(n[i] = {
                                    id: i,
                                    parts: [
                                        r
                                    ]
                                });
                            }
                            return t;
                        }
                        function i(e) {
                            var t = document.createElement("style");
                            return t.type = "text/css", function(e, t) {
                                var n = c(), s = g[g.length - 1];
                                if ("top" === e.insertAt) s ? s.nextSibling ? n.insertBefore(t, s.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), g.push(t);
                                else {
                                    if ("bottom" !== e.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
                                    n.appendChild(t);
                                }
                            }(e, t), t;
                        }
                        function r(e, t) {
                            var n, s, a;
                            if (t.singleton) {
                                var r = f++;
                                n = p || (p = i(t)), s = l.bind(null, n, r, !1), a = l.bind(null, n, r, !0);
                            } else n = i(t), s = (function(e, t) {
                                var n = t.css, s = t.media, a = t.sourceMap;
                                if (s && e.setAttribute("media", s), a && (n += "\n/*# sourceURL=" + a.sources[0] + " */", n += "\n"), e.styleSheet) e.styleSheet.cssText = n;
                                else {
                                    for(; e.firstChild;)e.removeChild(e.firstChild);
                                    e.appendChild(document.createTextNode(n));
                                }
                            }).bind(null, n), a = function() {
                                !function(e) {
                                    e.parentNode.removeChild(e);
                                    var t = g.indexOf(e);
                                    t >= 0 && g.splice(t, 1);
                                }(n);
                            };
                            return s(e), function(t) {
                                if (t) {
                                    if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
                                    s(e = t);
                                } else a();
                            };
                        }
                        function l(e, t, n, s) {
                            var a = n ? "" : s.css;
                            if (e.styleSheet) e.styleSheet.cssText = h(t, a);
                            else {
                                var i = document.createTextNode(a), r = e.childNodes;
                                r[t] && e.removeChild(r[t]), r.length ? e.insertBefore(i, r[t]) : e.appendChild(i);
                            }
                        }
                        var o = {}, u = function(e) {
                            var t;
                            return function() {
                                return void 0 === t && (t = e.apply(this, arguments)), t;
                            };
                        }, d = u(function() {
                            return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
                        }), c = u(function() {
                            return document.head || document.getElementsByTagName("head")[0];
                        }), p = null, f = 0, g = [];
                        e.exports = function(e, t) {
                            void 0 === (t = t || {}).singleton && (t.singleton = d()), void 0 === t.insertAt && (t.insertAt = "bottom");
                            var n = a(e);
                            return s(n, t), function(e) {
                                for(var i = [], r = 0; r < n.length; r++){
                                    var l = n[r];
                                    (u = o[l.id]).refs--, i.push(u);
                                }
                                e && s(a(e), t);
                                for(r = 0; r < i.length; r++){
                                    var u;
                                    if (0 === (u = i[r]).refs) {
                                        for(var d = 0; d < u.parts.length; d++)u.parts[d]();
                                        delete o[u.id];
                                    }
                                }
                            };
                        };
                        var h = function() {
                            var e = [];
                            return function(t, n) {
                                return e[t] = n, e.filter(Boolean).join("\n");
                            };
                        }();
                    },
                    function(e, t) {
                        e.exports = function(e, t, n, s) {
                            var a, i = e = e || {}, r = typeof e.default;
                            "object" !== r && "function" !== r || (a = e, i = e.default);
                            var l = "function" == typeof i ? i.options : i;
                            if (t && (l.render = t.render, l.staticRenderFns = t.staticRenderFns), n && (l._scopeId = n), s) {
                                var o = l.computed || (l.computed = {});
                                Object.keys(s).forEach(function(e) {
                                    var t = s[e];
                                    o[e] = function() {
                                        return t;
                                    };
                                });
                            }
                            return {
                                esModule: a,
                                exports: i,
                                options: l
                            };
                        };
                    },
                    function(e, t) {
                        "use strict";
                        Object.defineProperty(t, "__esModule", {
                            value: !0
                        }), t.default = {
                            props: {
                                value: {
                                    type: Number
                                },
                                pageCount: {
                                    type: Number,
                                    required: !0
                                },
                                forcePage: {
                                    type: Number
                                },
                                clickHandler: {
                                    type: Function,
                                    default: function() {}
                                },
                                pageRange: {
                                    type: Number,
                                    default: 3
                                },
                                marginPages: {
                                    type: Number,
                                    default: 1
                                },
                                prevText: {
                                    type: String,
                                    default: "Prev"
                                },
                                nextText: {
                                    type: String,
                                    default: "Next"
                                },
                                breakViewText: {
                                    type: String,
                                    default: "…"
                                },
                                containerClass: {
                                    type: String
                                },
                                pageClass: {
                                    type: String
                                },
                                pageLinkClass: {
                                    type: String
                                },
                                prevClass: {
                                    type: String
                                },
                                prevLinkClass: {
                                    type: String
                                },
                                nextClass: {
                                    type: String
                                },
                                nextLinkClass: {
                                    type: String
                                },
                                breakViewClass: {
                                    type: String
                                },
                                breakViewLinkClass: {
                                    type: String
                                },
                                activeClass: {
                                    type: String,
                                    default: "active"
                                },
                                disabledClass: {
                                    type: String,
                                    default: "disabled"
                                },
                                noLiSurround: {
                                    type: Boolean,
                                    default: !1
                                },
                                firstLastButton: {
                                    type: Boolean,
                                    default: !1
                                },
                                firstButtonText: {
                                    type: String,
                                    default: "First"
                                },
                                lastButtonText: {
                                    type: String,
                                    default: "Last"
                                },
                                hidePrevNext: {
                                    type: Boolean,
                                    default: !1
                                }
                            },
                            beforeUpdate: function() {
                                void 0 !== this.forcePage && this.forcePage !== this.selected && (this.selected = this.forcePage);
                            },
                            computed: {
                                selected: {
                                    get: function() {
                                        return this.value || this.innerValue;
                                    },
                                    set: function(e) {
                                        this.innerValue = e;
                                    }
                                },
                                pages: function() {
                                    var e = this, t = {};
                                    if (this.pageCount <= this.pageRange) for(var n = 0; n < this.pageCount; n++){
                                        var s = {
                                            index: n,
                                            content: n + 1,
                                            selected: n === this.selected - 1
                                        };
                                        t[n] = s;
                                    }
                                    else {
                                        for(var a = Math.floor(this.pageRange / 2), i = function(n) {
                                            var s = {
                                                index: n,
                                                content: n + 1,
                                                selected: n === e.selected - 1
                                            };
                                            t[n] = s;
                                        }, r = function(e) {
                                            t[e] = {
                                                disabled: !0,
                                                breakView: !0
                                            };
                                        }, l = 0; l < this.marginPages; l++)i(l);
                                        var o = 0;
                                        this.selected - a > 0 && (o = this.selected - 1 - a);
                                        var u = o + this.pageRange - 1;
                                        u >= this.pageCount && (o = (u = this.pageCount - 1) - this.pageRange + 1);
                                        for(var d = o; d <= u && d <= this.pageCount - 1; d++)i(d);
                                        o > this.marginPages && r(o - 1), u + 1 < this.pageCount - this.marginPages && r(u + 1);
                                        for(var c = this.pageCount - 1; c >= this.pageCount - this.marginPages; c--)i(c);
                                    }
                                    return t;
                                }
                            },
                            data: function() {
                                return {
                                    innerValue: 1
                                };
                            },
                            methods: {
                                handlePageSelected: function(e) {
                                    this.selected !== e && (this.innerValue = e, this.$emit("input", e), this.clickHandler(e));
                                },
                                prevPage: function() {
                                    this.selected <= 1 || this.handlePageSelected(this.selected - 1);
                                },
                                nextPage: function() {
                                    this.selected >= this.pageCount || this.handlePageSelected(this.selected + 1);
                                },
                                firstPageSelected: function() {
                                    return 1 === this.selected;
                                },
                                lastPageSelected: function() {
                                    return this.selected === this.pageCount || 0 === this.pageCount;
                                },
                                selectFirstPage: function() {
                                    this.selected <= 1 || this.handlePageSelected(1);
                                },
                                selectLastPage: function() {
                                    this.selected >= this.pageCount || this.handlePageSelected(this.pageCount);
                                }
                            }
                        };
                    },
                    function(e, t) {
                        e.exports = {
                            render: function() {
                                var e = this, t = e.$createElement, n = e._self._c || t;
                                return e.noLiSurround ? n("div", {
                                    class: e.containerClass
                                }, [
                                    e.firstLastButton ? n("a", {
                                        class: [
                                            e.pageLinkClass,
                                            e.firstPageSelected() ? e.disabledClass : ""
                                        ],
                                        attrs: {
                                            tabindex: "0"
                                        },
                                        domProps: {
                                            innerHTML: e._s(e.firstButtonText)
                                        },
                                        on: {
                                            click: function(t) {
                                                e.selectFirstPage();
                                            },
                                            keyup: function(t) {
                                                return "button" in t || !e._k(t.keyCode, "enter", 13) ? void e.selectFirstPage() : null;
                                            }
                                        }
                                    }) : e._e(),
                                    e._v(" "),
                                    e.firstPageSelected() && e.hidePrevNext ? e._e() : n("a", {
                                        class: [
                                            e.prevLinkClass,
                                            e.firstPageSelected() ? e.disabledClass : ""
                                        ],
                                        attrs: {
                                            tabindex: "0"
                                        },
                                        domProps: {
                                            innerHTML: e._s(e.prevText)
                                        },
                                        on: {
                                            click: function(t) {
                                                e.prevPage();
                                            },
                                            keyup: function(t) {
                                                return "button" in t || !e._k(t.keyCode, "enter", 13) ? void e.prevPage() : null;
                                            }
                                        }
                                    }),
                                    e._v(" "),
                                    e._l(e.pages, function(t) {
                                        return [
                                            t.breakView ? n("a", {
                                                class: [
                                                    e.pageLinkClass,
                                                    e.breakViewLinkClass,
                                                    t.disabled ? e.disabledClass : ""
                                                ],
                                                attrs: {
                                                    tabindex: "0"
                                                }
                                            }, [
                                                e._t("breakViewContent", [
                                                    e._v(e._s(e.breakViewText))
                                                ])
                                            ], 2) : t.disabled ? n("a", {
                                                class: [
                                                    e.pageLinkClass,
                                                    t.selected ? e.activeClass : "",
                                                    e.disabledClass
                                                ],
                                                attrs: {
                                                    tabindex: "0"
                                                }
                                            }, [
                                                e._v(e._s(t.content))
                                            ]) : n("a", {
                                                class: [
                                                    e.pageLinkClass,
                                                    t.selected ? e.activeClass : ""
                                                ],
                                                attrs: {
                                                    tabindex: "0"
                                                },
                                                on: {
                                                    click: function(n) {
                                                        e.handlePageSelected(t.index + 1);
                                                    },
                                                    keyup: function(n) {
                                                        return "button" in n || !e._k(n.keyCode, "enter", 13) ? void e.handlePageSelected(t.index + 1) : null;
                                                    }
                                                }
                                            }, [
                                                e._v(e._s(t.content))
                                            ])
                                        ];
                                    }),
                                    e._v(" "),
                                    e.lastPageSelected() && e.hidePrevNext ? e._e() : n("a", {
                                        class: [
                                            e.nextLinkClass,
                                            e.lastPageSelected() ? e.disabledClass : ""
                                        ],
                                        attrs: {
                                            tabindex: "0"
                                        },
                                        domProps: {
                                            innerHTML: e._s(e.nextText)
                                        },
                                        on: {
                                            click: function(t) {
                                                e.nextPage();
                                            },
                                            keyup: function(t) {
                                                return "button" in t || !e._k(t.keyCode, "enter", 13) ? void e.nextPage() : null;
                                            }
                                        }
                                    }),
                                    e._v(" "),
                                    e.firstLastButton ? n("a", {
                                        class: [
                                            e.pageLinkClass,
                                            e.lastPageSelected() ? e.disabledClass : ""
                                        ],
                                        attrs: {
                                            tabindex: "0"
                                        },
                                        domProps: {
                                            innerHTML: e._s(e.lastButtonText)
                                        },
                                        on: {
                                            click: function(t) {
                                                e.selectLastPage();
                                            },
                                            keyup: function(t) {
                                                return "button" in t || !e._k(t.keyCode, "enter", 13) ? void e.selectLastPage() : null;
                                            }
                                        }
                                    }) : e._e()
                                ], 2) : n("ul", {
                                    class: e.containerClass
                                }, [
                                    e.firstLastButton ? n("li", {
                                        class: [
                                            e.pageClass,
                                            e.firstPageSelected() ? e.disabledClass : ""
                                        ]
                                    }, [
                                        n("a", {
                                            class: e.pageLinkClass,
                                            attrs: {
                                                tabindex: e.firstPageSelected() ? -1 : 0
                                            },
                                            domProps: {
                                                innerHTML: e._s(e.firstButtonText)
                                            },
                                            on: {
                                                click: function(t) {
                                                    e.selectFirstPage();
                                                },
                                                keyup: function(t) {
                                                    return "button" in t || !e._k(t.keyCode, "enter", 13) ? void e.selectFirstPage() : null;
                                                }
                                            }
                                        })
                                    ]) : e._e(),
                                    e._v(" "),
                                    e.firstPageSelected() && e.hidePrevNext ? e._e() : n("li", {
                                        class: [
                                            e.prevClass,
                                            e.firstPageSelected() ? e.disabledClass : ""
                                        ]
                                    }, [
                                        n("a", {
                                            class: e.prevLinkClass,
                                            attrs: {
                                                tabindex: e.firstPageSelected() ? -1 : 0
                                            },
                                            domProps: {
                                                innerHTML: e._s(e.prevText)
                                            },
                                            on: {
                                                click: function(t) {
                                                    e.prevPage();
                                                },
                                                keyup: function(t) {
                                                    return "button" in t || !e._k(t.keyCode, "enter", 13) ? void e.prevPage() : null;
                                                }
                                            }
                                        })
                                    ]),
                                    e._v(" "),
                                    e._l(e.pages, function(t) {
                                        return n("li", {
                                            class: [
                                                e.pageClass,
                                                t.selected ? e.activeClass : "",
                                                t.disabled ? e.disabledClass : "",
                                                t.breakView ? e.breakViewClass : ""
                                            ]
                                        }, [
                                            t.breakView ? n("a", {
                                                class: [
                                                    e.pageLinkClass,
                                                    e.breakViewLinkClass
                                                ],
                                                attrs: {
                                                    tabindex: "0"
                                                }
                                            }, [
                                                e._t("breakViewContent", [
                                                    e._v(e._s(e.breakViewText))
                                                ])
                                            ], 2) : t.disabled ? n("a", {
                                                class: e.pageLinkClass,
                                                attrs: {
                                                    tabindex: "0"
                                                }
                                            }, [
                                                e._v(e._s(t.content))
                                            ]) : n("a", {
                                                class: e.pageLinkClass,
                                                attrs: {
                                                    tabindex: "0"
                                                },
                                                on: {
                                                    click: function(n) {
                                                        e.handlePageSelected(t.index + 1);
                                                    },
                                                    keyup: function(n) {
                                                        return "button" in n || !e._k(n.keyCode, "enter", 13) ? void e.handlePageSelected(t.index + 1) : null;
                                                    }
                                                }
                                            }, [
                                                e._v(e._s(t.content))
                                            ])
                                        ]);
                                    }),
                                    e._v(" "),
                                    e.lastPageSelected() && e.hidePrevNext ? e._e() : n("li", {
                                        class: [
                                            e.nextClass,
                                            e.lastPageSelected() ? e.disabledClass : ""
                                        ]
                                    }, [
                                        n("a", {
                                            class: e.nextLinkClass,
                                            attrs: {
                                                tabindex: e.lastPageSelected() ? -1 : 0
                                            },
                                            domProps: {
                                                innerHTML: e._s(e.nextText)
                                            },
                                            on: {
                                                click: function(t) {
                                                    e.nextPage();
                                                },
                                                keyup: function(t) {
                                                    return "button" in t || !e._k(t.keyCode, "enter", 13) ? void e.nextPage() : null;
                                                }
                                            }
                                        })
                                    ]),
                                    e._v(" "),
                                    e.firstLastButton ? n("li", {
                                        class: [
                                            e.pageClass,
                                            e.lastPageSelected() ? e.disabledClass : ""
                                        ]
                                    }, [
                                        n("a", {
                                            class: e.pageLinkClass,
                                            attrs: {
                                                tabindex: e.lastPageSelected() ? -1 : 0
                                            },
                                            domProps: {
                                                innerHTML: e._s(e.lastButtonText)
                                            },
                                            on: {
                                                click: function(t) {
                                                    e.selectLastPage();
                                                },
                                                keyup: function(t) {
                                                    return "button" in t || !e._k(t.keyCode, "enter", 13) ? void e.selectLastPage() : null;
                                                }
                                            }
                                        })
                                    ]) : e._e()
                                ], 2);
                            },
                            staticRenderFns: []
                        };
                    }
                ]);
            });
        },
        {}
    ],
    "DmfW": [
        function(require1, module1, exports) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: !0
            }), exports.default = void 0;
            var t = s(require1("axios")), e = s(require1("jquery")), a = s(require1("vuejs-paginate"));
            function s(t) {
                return t && t.__esModule ? t : {
                    default: t
                };
            }
            var r = {
                install: function(s) {
                    s.component("paginate", a.default), s.mixin({
                        computed: {
                            activePage: {
                                get: function() {
                                    return this.request.page;
                                },
                                set: function() {}
                            }
                        },
                        data: function() {
                            return {
                                count: 0,
                                countListener: 0,
                                isLoading: !1,
                                estates: [],
                                markers: [],
                                totalPages: -1,
                                totalPosts: 0,
                                requestDefault: {},
                                request: {
                                    page: 1,
                                    sort: {
                                        order: "desc",
                                        orderBy: "relevance"
                                    },
                                    recent: !1,
                                    showAll: !1,
                                    filters: {
                                        status: !1,
                                        new_home: !1,
                                        negotiation: !1,
                                        category: [],
                                        subcategory: [],
                                        agent: !1,
                                        office: !1,
                                        facilities: {
                                            bedrooms: {
                                                min: !1,
                                                max: !1
                                            }
                                        },
                                        price: {
                                            min: !1,
                                            max: !1
                                        },
                                        plot_area: {
                                            min: !1,
                                            max: !1
                                        },
                                        liveable_area: {
                                            min: !1,
                                            max: !1
                                        },
                                        locations: [],
                                        location: {
                                            region: "",
                                            lat: !1,
                                            lng: !1,
                                            distance: !1
                                        }
                                    }
                                }
                            };
                        },
                        methods: {
                            $getNumberFormat: function(t) {
                                var e = "DOT";
                                return "en" === t && (e = "COMMA"), e;
                            },
                            $formatNumber: function(t, e) {
                                switch(e){
                                    case "DOT":
                                        t = t.toString().replace(/\./g, ",").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                                        break;
                                    case "COMMA":
                                        t = t.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                                }
                                return t;
                            },
                            $urlParam: function() {
                                var t = {}, e = window.location.href;
                                return e.indexOf("#") > -1 && (e = window.location.href.substr(0, window.location.href.lastIndexOf("#"))), e.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(e, a, s) {
                                    t[a] = s;
                                }), t;
                            },
                            $urlQuery: function() {
                                var t = this, e = this.$urlParam().negotiation, a = this.$urlParam().region, s = parseFloat(this.$urlParam().lat), r = parseFloat(this.$urlParam().lng);
                                if (e && (this.request.filters.negotiation = e), s && r && a && (this.request.filters.location.region = a, this.request.filters.location.lat = s, this.request.filters.location.lng = r), this.$urlParam().locations) {
                                    var i = !!this.$urlParam().locations && decodeURIComponent(this.$urlParam().locations.replace(/\+/g, "%20")).split("[").slice(1);
                                    i && i.forEach(function(e) {
                                        var a = e.slice(0, -1).split(",");
                                        a[1] = parseFloat(a[1]), a[2] = parseFloat(a[2]), t.request.filters.locations.push({
                                            latLng: {
                                                lat: a[1],
                                                lng: a[2]
                                            }
                                        });
                                    });
                                }
                                var o = !!this.$urlParam().price && decodeURIComponent(this.$urlParam().price).split(",");
                                this.$urlParam().price && o && 2 === o.length && (o[1] = "false" !== o[1] && parseInt(o[1]), this.request.filters.price = {
                                    min: parseInt(o[0]),
                                    max: o[1]
                                });
                                var n = !!this.$urlParam().plot_area && decodeURIComponent(this.$urlParam().plot_area).split(",");
                                this.$urlParam().plot_area && n && 2 === n.length && (n[1] = "false" !== n[1] && parseFloat(n[1]), this.request.filters.plot_area = {
                                    min: parseFloat(n[0]),
                                    max: n[1]
                                });
                                var l = !!this.$urlParam().liveable_area && decodeURIComponent(this.$urlParam().liveable_area).split(",");
                                if (this.$urlParam().liveable_area && l && 2 === l.length && (l[1] = "false" !== l[1] && parseFloat(l[1]), this.request.filters.liveable_area = {
                                    min: parseFloat(l[0]),
                                    max: l[1]
                                }), this.$urlParam().sort) {
                                    var u = !!this.$urlParam().sort && decodeURIComponent(this.$urlParam().sort).split(",");
                                    this.request.sort.order = u[1], this.request.sort.orderBy = u[0];
                                }
                                this.$urlParam().category && (this.request.filters.category = [
                                    this.$urlParam().category
                                ]), this.$urlParam().subcategory && (this.request.filters.subcategory = [
                                    this.$urlParam().subcategory
                                ]);
                                var h = 1;
                                window.location.hash && (h = parseInt(window.location.hash.substr(1), 10)), this.$search({
                                    page: h
                                }), window.requestFromUrl = this.request, this.$forceUpdate();
                            },
                            $search: function(t) {
                                var e = 1;
                                t && t.page && (e = t.page);
                                var a = {
                                    page: e,
                                    sort: this.request.sort,
                                    filters: this.request.filters
                                };
                                t && t.mapMode ? (a.mapMode = !0, this.request.mapMode = !0) : this.request.mapMode = !1, this.$sweepBrightInit(a);
                            },
                            $list: function() {
                                this.$urlQuery();
                            },
                            generateUUID: function() {
                                var t = (new Date).getTime();
                                return "undefined" != typeof performance && "function" == typeof performance.now && (t += performance.now()), "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
                                    var a = (t + 16 * Math.random()) % 16 | 0;
                                    return t = Math.floor(t / 16), ("x" === e ? a : 3 & a | 8).toString(16);
                                });
                            },
                            generateUid: function(t) {
                                var e = this;
                                return t.forEach(function(t) {
                                    t.uid = e.generateUUID();
                                }), t;
                            },
                            storeEstates: function(t, a) {
                                a.data.estates && a.data.estates.length > 0 ? this.estates = this.generateUid(a.data.estates) : this.estates = [], this.totalPages = a.data.totalPages, this.totalPosts = a.data.totalPosts;
                                var s = new Event("loadedEstates");
                                window.dispatchEvent(s), this.isLoading = !1, t && t.callback && t.callback(), window.location.hash && document.querySelector("[data-sweepbright-list]") && ((0, e.default)("html, body").animate({
                                    scrollTop: (0, e.default)("[data-sweepbright-list]").offset().top - 100
                                }, 200), (0, e.default)("[data-sweepbright-list]").animate({
                                    scrollTop: 0
                                }, 200));
                            },
                            storeMarkers: function(t) {
                                t.data.estates && t.data.estates.length > 0 ? this.markers = this.generateUid(t.data.estates) : this.markers = [], this.totalPages = t.data.totalPages, this.totalPosts = t.data.totalPosts;
                                var e = new Event("loadedMap");
                                window.dispatchEvent(e);
                            },
                            getEstates: function(e) {
                                var a = this;
                                this.isLoading = !0, t.default.post("/wp-json/v1/sweepbright/list", this.request).then(function(t) {
                                    e && e.mapMode ? a.storeMarkers(t) : a.storeEstates(e, t);
                                });
                            },
                            $sweepBrightPaginate: function(t) {
                                this.request.page = t, window.location.hash = t;
                            },
                            $sweepBrightReset: function() {
                                this.count += 1, 1 === this.count && (this.requestDefault = Object.assign({}, this.request)), this.request = Object.assign({}, this.requestDefault);
                            },
                            $loadEstates: function(t, e) {
                                this.$sweepBrightReset(), window.location.hash && (this.request.page = parseInt(window.location.hash.substr(1), 10)), t && t.recent && (this.request.recent = t.recent), t && t.showAll && (this.request.showAll = t.showAll), t && t.mapMode && (this.request.mapMode = t.mapMode), t && t.sort && (this.request.sort = t.sort), t && t.category && (this.request.filters.category = t.category), t && t.subcategory && (this.request.filters.subcategory = t.subcategory), t && t.filters && (this.request.filters = t.filters), Number.isInteger(this.request.page) && (e ? this.getEstates({
                                    callback: e
                                }) : this.getEstates(t));
                            },
                            $eventListener: function() {
                                var t = this;
                                this.countListener += 1, 1 === this.countListener && window.addEventListener("hashchange", function() {
                                    t.$loadEstates({
                                        sort: t.request.sort,
                                        filters: t.request.filters
                                    });
                                }, !1);
                            },
                            $sweepBrightInit: function(t, e) {
                                this.$eventListener(), this.$loadEstates(t, e);
                            }
                        }
                    });
                }
            };
            exports.default = r;
        },
        {
            "axios": "uj17",
            "jquery": "eeO1",
            "vuejs-paginate": "lvA9"
        }
    ]
}, {}, [
    "DmfW"
], null) //# sourceMappingURL=public/dist/wp-sweepbright-public.js.map
;


const $9c692fdc905fc837$var$estateOverview = ()=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))(".estate-overview").each((index, el)=>{
        (0, $16hem.default).config.productionTip = false;
        (0, $16hem.default).config.devtools = false;
        (0, $16hem.default).use((0, (/*@__PURE__*/$parcel$interopDefault($bfe465c47986393c$exports))));
        (0, $16hem.default).use($2d3f87e6748db6a4$exports, {
            load: {
                key: "AIzaSyD5l9tULwAjtCepaEn8IcMpVrYGO8LeHL4",
                libraries: "places"
            }
        });
        (0, $16hem.default).component("GmapCluster", (0, (/*@__PURE__*/$parcel$interopDefault($5e2fc088c50853fb$exports))));
        (0, $16hem.default).component("v-select", (0, (/*@__PURE__*/$parcel$interopDefault($608dba8cc927f948$exports))));
        new (0, $16hem.default)({
            el: `.${el.className}`,
            render: (h)=>h((0, $d234ab82734ed330$export$2e2bcd8739ae039), {
                    props: {
                        component: (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))(el).data("component")
                    }
                })
        });
    });
};
var $9c692fdc905fc837$export$2e2bcd8739ae039 = $9c692fdc905fc837$var$estateOverview;



var $16hem = parcelRequire("16hem");
let $260423f6e788fc9b$var$script;





let $260423f6e788fc9b$var$initialize = ()=>{
    $260423f6e788fc9b$var$script = (parcelRequire("5uRil"));
    if ($260423f6e788fc9b$var$script.__esModule) $260423f6e788fc9b$var$script = $260423f6e788fc9b$var$script.default;
    $260423f6e788fc9b$var$script.render = (parcelRequire("aq9nh")).render;
    $260423f6e788fc9b$var$script.staticRenderFns = (parcelRequire("aq9nh")).staticRenderFns;
    $260423f6e788fc9b$var$script._scopeId = "data-v-9ccd1d";
    $260423f6e788fc9b$var$script.__cssModules = {};
    (parcelRequire("6wOI5")).default($260423f6e788fc9b$var$script);
    $260423f6e788fc9b$var$script.__scopeId = "data-v-9ccd1d";
    $260423f6e788fc9b$var$script.__file = "OfficesList.vue";
};
$260423f6e788fc9b$var$initialize();
var $260423f6e788fc9b$export$2e2bcd8739ae039 = $260423f6e788fc9b$var$script;


const $628caac1cf237288$var$offices = ()=>{
    if (document.querySelector("#offices")) {
        (0, $16hem.default).config.productionTip = false;
        (0, $16hem.default).config.devtools = false;
        new (0, $16hem.default)({
            el: "#offices",
            render: (h)=>h((0, $260423f6e788fc9b$export$2e2bcd8739ae039))
        });
    }
};
var $628caac1cf237288$export$2e2bcd8739ae039 = $628caac1cf237288$var$offices;



var $16hem = parcelRequire("16hem");
let $e99ffb91ac86e1c9$var$script;





let $e99ffb91ac86e1c9$var$initialize = ()=>{
    $e99ffb91ac86e1c9$var$script = (parcelRequire("jWuYZ"));
    if ($e99ffb91ac86e1c9$var$script.__esModule) $e99ffb91ac86e1c9$var$script = $e99ffb91ac86e1c9$var$script.default;
    $e99ffb91ac86e1c9$var$script.render = (parcelRequire("hnrNW")).render;
    $e99ffb91ac86e1c9$var$script.staticRenderFns = (parcelRequire("hnrNW")).staticRenderFns;
    $e99ffb91ac86e1c9$var$script._scopeId = "data-v-7c1636";
    $e99ffb91ac86e1c9$var$script.__cssModules = {};
    (parcelRequire("96BGd")).default($e99ffb91ac86e1c9$var$script);
    $e99ffb91ac86e1c9$var$script.__scopeId = "data-v-7c1636";
    $e99ffb91ac86e1c9$var$script.__file = "ServicesList.vue";
};
$e99ffb91ac86e1c9$var$initialize();
var $e99ffb91ac86e1c9$export$2e2bcd8739ae039 = $e99ffb91ac86e1c9$var$script;


const $585f78c3134879cb$var$services = ()=>{
    if (document.querySelector("#services")) {
        (0, $16hem.default).config.productionTip = false;
        (0, $16hem.default).config.devtools = false;
        new (0, $16hem.default)({
            el: "#services",
            render: (h)=>h((0, $e99ffb91ac86e1c9$export$2e2bcd8739ae039))
        });
    }
};
var $585f78c3134879cb$export$2e2bcd8739ae039 = $585f78c3134879cb$var$services;



var $jAv3h = parcelRequire("jAv3h");
var $26a6655a0dba627a$exports = {};
/**
 * @preserve
 * Sharer.js
 *
 * @description Create your own social share buttons
 * @version 0.2.12
 * @author Ellison Leao <ellisonleao@gmail.com>
 * @license GPLv3
 *
 */ /**
 * @constructor
 */ var $26a6655a0dba627a$var$Sharer = function(elem) {
    this.elem = elem;
};
$26a6655a0dba627a$var$Sharer.prototype = {
    /**
     *  @function getValue
     *  @description Helper to get the attribute of a DOM element
     *  @param {String} attr DOM element attribute
     *  @returns {String|Empty} returns the attr value or empty string
     */ getValue: function(attr) {
        var val = this.elem.getAttribute("data-" + attr);
        return val === undefined || val === null ? false : val;
    },
    /**
     * @event share
     * @description Main share event. Will pop a window or redirect to a link
     * based on the data-sharer attribute.
     */ share: function() {
        var sharer = this.getValue("sharer").toLowerCase(), sharers = {
            facebook: {
                shareUrl: "https://www.facebook.com/sharer/sharer.php",
                params: {
                    u: this.getValue("url")
                }
            },
            googleplus: {
                shareUrl: "https://plus.google.com/share",
                params: {
                    url: this.getValue("url")
                }
            },
            linkedin: {
                shareUrl: "https://www.linkedin.com/shareArticle",
                params: {
                    url: this.getValue("url"),
                    mini: true
                }
            },
            twitter: {
                shareUrl: "https://twitter.com/intent/tweet/",
                params: {
                    text: this.getValue("title"),
                    url: this.getValue("url"),
                    hashtags: this.getValue("hashtags"),
                    via: this.getValue("via")
                }
            },
            email: {
                shareUrl: "mailto:" + this.getValue("to"),
                params: {
                    subject: this.getValue("subject"),
                    body: this.getValue("title") + "\n" + this.getValue("url")
                },
                isLink: true
            },
            whatsapp: {
                shareUrl: "whatsapp://send",
                params: {
                    text: this.getValue("title") + " " + this.getValue("url")
                },
                isLink: true
            },
            telegram: {
                shareUrl: "tg://msg_url",
                params: {
                    text: this.getValue("title") + " " + this.getValue("url")
                },
                isLink: true
            },
            viber: {
                shareUrl: "viber://forward",
                params: {
                    text: this.getValue("title") + " " + this.getValue("url")
                },
                isLink: true
            },
            line: {
                shareUrl: "http://line.me/R/msg/text/?" + encodeURIComponent(this.getValue("title") + " " + this.getValue("url")),
                isLink: true
            },
            pinterest: {
                shareUrl: "https://www.pinterest.com/pin/create/button/",
                params: {
                    url: this.getValue("url")
                }
            },
            tumblr: {
                shareUrl: "http://tumblr.com/widgets/share/tool",
                params: {
                    canonicalUrl: this.getValue("url"),
                    content: this.getValue("url"),
                    posttype: "link",
                    title: this.getValue("title"),
                    caption: this.getValue("caption"),
                    tags: this.getValue("tags")
                }
            },
            hackernews: {
                shareUrl: "https://news.ycombinator.com/submitlink",
                params: {
                    u: this.getValue("url"),
                    t: this.getValue("title")
                }
            },
            reddit: {
                shareUrl: "https://www.reddit.com/submit",
                params: {
                    "url": this.getValue("url")
                }
            },
            vk: {
                shareUrl: "http://vk.com/share.php",
                params: {
                    url: this.getValue("url"),
                    title: this.getValue("title"),
                    description: this.getValue("caption"),
                    image: this.getValue("image")
                }
            },
            xing: {
                shareUrl: "https://www.xing.com/app/user",
                params: {
                    "op": "share",
                    "url": this.getValue("url"),
                    "title": this.getValue("title")
                }
            },
            buffer: {
                shareUrl: "https://buffer.com/add",
                params: {
                    url: this.getValue("url"),
                    title: this.getValue("title"),
                    via: this.getValue("via"),
                    picture: this.getValue("picture")
                }
            },
            instapaper: {
                shareUrl: "http://www.instapaper.com/edit",
                params: {
                    url: this.getValue("url"),
                    title: this.getValue("title"),
                    description: this.getValue("description")
                }
            },
            pocket: {
                shareUrl: "https://getpocket.com/save",
                params: {
                    url: this.getValue("url")
                }
            },
            digg: {
                shareUrl: "http://www.digg.com/submit",
                params: {
                    url: this.getValue("url")
                }
            },
            stumbleupon: {
                shareUrl: "http://www.stumbleupon.com/submit",
                params: {
                    url: this.getValue("url"),
                    title: this.getValue("title")
                }
            },
            flipboard: {
                shareUrl: "https://share.flipboard.com/bookmarklet/popout",
                params: {
                    v: 2,
                    title: this.getValue("title"),
                    url: this.getValue("url"),
                    t: Date.now()
                }
            },
            weibo: {
                shareUrl: "http://service.weibo.com/share/share.php",
                params: {
                    url: this.getValue("url"),
                    title: this.getValue("title"),
                    language: "zh_cn"
                }
            },
            renren: {
                shareUrl: "http://share.renren.com/share/buttonshare",
                params: {
                    link: this.getValue("url")
                }
            },
            myspace: {
                shareUrl: "https://myspace.com/post",
                params: {
                    u: this.getValue("url"),
                    t: this.getValue("title"),
                    c: this.getValue("description")
                }
            },
            blogger: {
                shareUrl: "https://www.blogger.com/blog-this.g",
                params: {
                    u: this.getValue("url"),
                    n: this.getValue("title"),
                    t: this.getValue("description")
                }
            },
            baidu: {
                shareUrl: "http://cang.baidu.com/do/add",
                params: {
                    it: this.getValue("title"),
                    iu: this.getValue("url")
                }
            },
            hatenabookmark: {
                shareUrl: "http://b.hatena.ne.jp/entry/" + this.getValue("url")
            }
        }, s = sharers[sharer];
        // custom popups sizes
        if (s) {
            s.width = this.getValue("width");
            s.height = this.getValue("height");
        }
        return s !== undefined ? this.urlSharer(s) : false;
    },
    /**
     * @event urlSharer
     * @param {Object} sharer
     */ urlSharer: function(sharer) {
        var p = sharer.params || {}, keys = Object.keys(p), i, str = keys.length > 0 ? "?" : "";
        for(i = 0; i < keys.length; i++){
            if (str !== "?") str += "&";
            if (p[keys[i]]) str += keys[i] + "=" + encodeURIComponent(p[keys[i]]);
        }
        sharer.shareUrl += str;
        if (!sharer.isLink) {
            var popWidth = sharer.width || 600, popHeight = sharer.height || 480, left = window.innerWidth / 2 - popWidth / 2 + window.screenX, top = window.innerHeight / 2 - popHeight / 2 + window.screenY, popParams = "scrollbars=no, width=" + popWidth + ", height=" + popHeight + ", top=" + top + ", left=" + left, newWindow = window.open(sharer.shareUrl, "", popParams);
            if (window.focus) newWindow.focus();
        } else window.location.href = sharer.shareUrl;
    }
};
$26a6655a0dba627a$exports = $26a6655a0dba627a$var$Sharer;


const $1c3fb0888fd8179d$var$share = ()=>{
    if (document.querySelector("[data-sharer]")) (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))("[data-sharer]").on("click", (e)=>{
        e.preventDefault();
        const sharer = new (0, (/*@__PURE__*/$parcel$interopDefault($26a6655a0dba627a$exports)))(e.currentTarget);
        sharer.share();
    });
};
var $1c3fb0888fd8179d$export$2e2bcd8739ae039 = $1c3fb0888fd8179d$var$share;


// uncomment for packing
// import "../styles/index.scss";

var $gYJCo = parcelRequire("gYJCo");
class $9ebac42b371ed00c$var$ImageCompare {
    constructor(el, settings = {}){
        const defaults = {
            controlColor: "#FFFFFF",
            controlShadow: true,
            addCircle: false,
            addCircleBlur: true,
            showLabels: false,
            labelOptions: {
                before: "Before",
                after: "After",
                onHover: false
            },
            smoothing: true,
            smoothingAmount: 100,
            hoverStart: false,
            verticalMode: false,
            startingPoint: 50,
            fluidMode: false
        };
        this.settings = Object.assign(defaults, settings);
        this.safariAgent = navigator.userAgent.indexOf("Safari") != -1 && navigator.userAgent.indexOf("Chrome") == -1;
        this.el = el;
        this.images = {};
        this.wrapper = null;
        this.control = null;
        this.arrowContainer = null;
        this.arrowAnimator = [];
        this.active = false;
        this.slideWidth = 50;
        this.lineWidth = 2;
        this.arrowCoordinates = {
            circle: [
                5,
                3
            ],
            standard: [
                8,
                0
            ]
        };
    }
    mount() {
        // Temporarily disable Safari smoothing
        if (this.safariAgent) this.settings.smoothing = false;
        this._shapeContainer();
        this._getImages();
        this._buildControl();
        this._events();
    }
    _events() {
        let bodyStyles = `

    `;
        // Desktop events
        this.el.addEventListener("mousedown", (ev)=>{
            this._activate(true);
            document.body.classList.add("icv__body");
            (0, $gYJCo.disableBodyScroll)(this.el, {
                reserveScrollBarGap: true
            });
            this._slideCompare(ev);
        });
        this.el.addEventListener("mousemove", (ev)=>this.active && this._slideCompare(ev));
        this.el.addEventListener("mouseup", ()=>this._activate(false));
        document.body.addEventListener("mouseup", ()=>{
            document.body.classList.remove("icv__body");
            (0, $gYJCo.enableBodyScroll)(this.el);
            this._activate(false);
        });
        // Mobile events
        this.control.addEventListener("touchstart", (e)=>{
            this._activate(true);
            document.body.classList.add("icv__body");
            (0, $gYJCo.disableBodyScroll)(this.el, {
                reserveScrollBarGap: true
            });
        });
        this.el.addEventListener("touchmove", (ev)=>{
            this.active && this._slideCompare(ev);
        });
        this.el.addEventListener("touchend", ()=>{
            this._activate(false);
            document.body.classList.remove("icv__body");
            (0, $gYJCo.enableBodyScroll)(this.el);
        });
        // hover
        this.el.addEventListener("mouseenter", ()=>{
            this.settings.hoverStart && this._activate(true);
            let coord = this.settings.addCircle ? this.arrowCoordinates.circle : this.arrowCoordinates.standard;
            this.arrowAnimator.forEach((anim, i)=>{
                anim.style.cssText = `
        ${this.settings.verticalMode ? `transform: translateY(${coord[1] * (i === 0 ? 1 : -1)}px);` : `transform: translateX(${coord[1] * (i === 0 ? 1 : -1)}px);`}
        `;
            });
        });
        this.el.addEventListener("mouseleave", ()=>{
            let coord = this.settings.addCircle ? this.arrowCoordinates.circle : this.arrowCoordinates.standard;
            this.arrowAnimator.forEach((anim, i)=>{
                anim.style.cssText = `
        ${this.settings.verticalMode ? `transform: translateY(${i === 0 ? `${coord[0]}px` : `-${coord[0]}px`});` : `transform: translateX(${i === 0 ? `${coord[0]}px` : `-${coord[0]}px`});`}
        `;
            });
        });
    }
    _slideCompare(ev) {
        let bounds = this.el.getBoundingClientRect();
        let x = ev.touches !== undefined ? ev.touches[0].clientX - bounds.left : ev.clientX - bounds.left;
        let y = ev.touches !== undefined ? ev.touches[0].clientY - bounds.top : ev.clientY - bounds.top;
        let position = this.settings.verticalMode ? y / bounds.height * 100 : x / bounds.width * 100;
        if (position >= 0 && position <= 100) {
            this.settings.verticalMode ? this.control.style.top = `calc(${position}% - ${this.slideWidth / 2}px)` : this.control.style.left = `calc(${position}% - ${this.slideWidth / 2}px)`;
            if (this.settings.fluidMode) this.settings.verticalMode ? this.wrapper.style.clipPath = `inset(0 0 ${100 - position}% 0)` : this.wrapper.style.clipPath = `inset(0 0 0 ${position}%)`;
            else this.settings.verticalMode ? this.wrapper.style.height = `calc(${position}%)` : this.wrapper.style.width = `calc(${100 - position}%)`;
        }
    }
    _activate(state) {
        this.active = state;
    }
    _shapeContainer() {
        let imposter = document.createElement("div");
        let label_l = document.createElement("span");
        let label_r = document.createElement("span");
        label_l.classList.add("icv__label", "icv__label-before", "keep");
        label_r.classList.add("icv__label", "icv__label-after", "keep");
        if (this.settings.labelOptions.onHover) {
            label_l.classList.add("on-hover");
            label_r.classList.add("on-hover");
        }
        if (this.settings.verticalMode) {
            label_l.classList.add("vertical");
            label_r.classList.add("vertical");
        }
        label_l.innerHTML = this.settings.labelOptions.before || "Before";
        label_r.innerHTML = this.settings.labelOptions.after || "After";
        if (this.settings.showLabels) {
            this.el.appendChild(label_l);
            this.el.appendChild(label_r);
        }
        this.el.classList.add(`icv`, this.settings.verticalMode ? `icv__icv--vertical` : `icv__icv--horizontal`, this.settings.fluidMode ? `icv__is--fluid` : `standard`);
        imposter.classList.add("icv__imposter");
        this.el.appendChild(imposter);
    }
    _buildControl() {
        let control = document.createElement("div");
        let uiLine = document.createElement("div");
        let arrows = document.createElement("div");
        let circle = document.createElement("div");
        const arrowSize = "20";
        arrows.classList.add("icv__theme-wrapper");
        for(var idx = 0; idx <= 1; idx++){
            let animator = document.createElement(`div`);
            let arrow = `<svg
      height="15"
      width="15"
       style="
       transform: 
       scale(${this.settings.addCircle ? 0.7 : 1.5})  
       rotateZ(${idx === 0 ? this.settings.verticalMode ? `-90deg` : `180deg` : this.settings.verticalMode ? `90deg` : `0deg`}); height: ${arrowSize}px; width: ${arrowSize}px;
       
       ${this.settings.controlShadow ? `
       -webkit-filter: drop-shadow( 0px 3px 5px rgba(0, 0, 0, .33));
       filter: drop-shadow( 0px ${idx === 0 ? "-3px" : "3px"} 5px rgba(0, 0, 0, .33));
       ` : ``}
       "
       xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 15 15">
       <path ${this.settings.addCircle ? `fill="transparent"` : `fill="${this.settings.controlColor}"`}
       stroke="${this.settings.controlColor}"
       stroke-linecap="round"
       stroke-width="${this.settings.addCircle ? 3 : 0}"
       d="M4.5 1.9L10 7.65l-5.5 5.4"
       />
     </svg>`;
            animator.innerHTML += arrow;
            this.arrowAnimator.push(animator);
            arrows.appendChild(animator);
        }
        let coord = this.settings.addCircle ? this.arrowCoordinates.circle : this.arrowCoordinates.standard;
        this.arrowAnimator.forEach((anim, i)=>{
            anim.classList.add("icv__arrow-wrapper");
            anim.style.cssText = `
      ${this.settings.verticalMode ? `transform: translateY(${i === 0 ? `${coord[0]}px` : `-${coord[0]}px`});` : `transform: translateX(${i === 0 ? `${coord[0]}px` : `-${coord[0]}px`});`}
      `;
        });
        control.classList.add("icv__control");
        control.style.cssText = `
    ${this.settings.verticalMode ? `height` : `width `}: ${this.slideWidth}px;
    ${this.settings.verticalMode ? `top` : `left `}: calc(${this.settings.startingPoint}% - ${this.slideWidth / 2}px);
    ${"ontouchstart" in document.documentElement ? `` : this.settings.smoothing ? `transition: ${this.settings.smoothingAmount}ms ease-out;` : ``}
    `;
        uiLine.classList.add("icv__control-line");
        uiLine.style.cssText = `
      ${this.settings.verticalMode ? `height` : `width `}: ${this.lineWidth}px;
      background: ${this.settings.controlColor};
        ${this.settings.controlShadow ? `box-shadow: 0px 0px 15px rgba(0,0,0,0.33);` : ``}
    `;
        let uiLine2 = uiLine.cloneNode(true);
        circle.classList.add("icv__circle");
        circle.style.cssText = `

      ${this.settings.addCircleBlur && `-webkit-backdrop-filter: blur(5px); backdrop-filter: blur(5px)`};
      
      border: ${this.lineWidth}px solid ${this.settings.controlColor};
      ${this.settings.controlShadow && `box-shadow: 0px 0px 15px rgba(0,0,0,0.33)`};
    `;
        control.appendChild(uiLine);
        this.settings.addCircle && control.appendChild(circle);
        control.appendChild(arrows);
        control.appendChild(uiLine2);
        this.arrowContainer = arrows;
        this.control = control;
        this.el.appendChild(control);
    }
    _getImages() {
        let children = this.el.querySelectorAll("img, .keep");
        this.el.innerHTML = "";
        children.forEach((img)=>{
            this.el.appendChild(img);
        });
        let childrenImages = [
            ...children
        ].filter((element)=>element.nodeName.toLowerCase() === "img");
        //  this.settings.verticalMode && [...children].reverse();
        this.settings.verticalMode && childrenImages.reverse();
        for(let idx = 0; idx <= 1; idx++){
            let child = childrenImages[idx];
            child.classList.add("icv__img");
            child.classList.add(idx === 0 ? `icv__img-a` : `icv__img-b`);
            if (idx === 1) {
                let wrapper = document.createElement("div");
                let afterUrl = childrenImages[1].src;
                wrapper.classList.add("icv__wrapper");
                wrapper.style.cssText = `
            width: ${100 - this.settings.startingPoint}%; 
            height: ${this.settings.startingPoint}%;

            ${"ontouchstart" in document.documentElement ? `` : this.settings.smoothing ? `transition: ${this.settings.smoothingAmount}ms ease-out;` : ``}
            ${this.settings.fluidMode && `background-image: url(${afterUrl}); clip-path: inset(${this.settings.verticalMode ? ` 0 0 ${100 - this.settings.startingPoint}% 0` : `0 0 0 ${this.settings.startingPoint}%`})`}
        `;
                wrapper.appendChild(child);
                this.wrapper = wrapper;
                this.el.appendChild(this.wrapper);
            }
        }
        if (this.settings.fluidMode) {
            let url = childrenImages[0].src;
            let fluidWrapper = document.createElement("div");
            fluidWrapper.classList.add("icv__fluidwrapper");
            fluidWrapper.style.cssText = `
 
        background-image: url(${url});
        
      `;
            this.el.appendChild(fluidWrapper);
        }
    }
}
var // const el = document.querySelectorAll(".image-compare");
// el.forEach((viewer) => {
//   let v = new ImageCompare(viewer, {
//     controlShadow: false,
//     showLabels: true,
//     labelOptions: {
//       onHover: true,
//       before: "Draft",
//       after: "Final",
//     },
//   }).mount();
// });
$9ebac42b371ed00c$export$2e2bcd8739ae039 = $9ebac42b371ed00c$var$ImageCompare;


const $5ac3e10b0f4f71ca$var$compare = ()=>{
    if (document.querySelector(".js-compare-image")) {
        const element = document.querySelector(".js-compare-image");
        new (0, $9ebac42b371ed00c$export$2e2bcd8739ae039)(element, {
            controlShadow: true,
            addCircle: true,
            addCircleBlur: true
        }).mount();
    }
};
var $5ac3e10b0f4f71ca$export$2e2bcd8739ae039 = $5ac3e10b0f4f71ca$var$compare;



var $jAv3h = parcelRequire("jAv3h");
const $6f4339b9c5ae7e5b$var$tags = ()=>{
    if (document.querySelector("[data-tags]")) (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))("[data-value]").on("click", (e)=>{
        e.preventDefault();
        (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))("[data-value]").removeAttr("data-active");
        (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))(e.currentTarget).attr("data-active", "");
        (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))('[name="your-subject"]').val((0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))(e.currentTarget).data("value"));
    });
};
var $6f4339b9c5ae7e5b$export$2e2bcd8739ae039 = $6f4339b9c5ae7e5b$var$tags;



var $jAv3h = parcelRequire("jAv3h");

var $jAv3h = parcelRequire("jAv3h");
const $eeb686ae25985f8d$var$niceNumber = function($) {
    $.fn.niceNumber = function(options) {
        const defaults = {
            autoSize: true,
            autoSizeBuffer: 1,
            buttonDecrement: "-",
            buttonIncrement: "+",
            buttonPosition: "around",
            /**
        callbackFunction
        @param {$input} currentInput - the input running the callback
        @param {number} amount - the amount after increase/decrease
        @param {object} settings - the passed niceNumber settings
      * */ onDecrement: false,
            onIncrement: false
        };
        const settings = $.extend(defaults, options);
        return this.each(function() {
            const currentInput = this;
            const $currentInput = $(currentInput);
            const maxValue = $currentInput.attr("max");
            const minValue = $currentInput.attr("min");
            let attrMax = null;
            let attrMin = null;
            // Skip already initialized input
            if ($currentInput.attr("data-nice-number-initialized")) return;
            // Handle max and min values
            if (maxValue !== undefined && maxValue !== false) attrMax = parseFloat(maxValue);
            if (minValue !== undefined && minValue !== false) attrMin = parseFloat(minValue);
            // Fix issue with initial value being < min
            if (attrMin && !currentInput.value) $currentInput.val(attrMin);
            // Generate container
            const $inputContainer = $("<div/>", {
                class: "nice-number"
            }).insertAfter(currentInput);
            // Generate interval (object so it is passed by reference)
            const interval = {};
            // Generate buttons
            const $minusButton = $("<button/>").attr("type", "button").html(settings.buttonDecrement).on("mousedown mouseup mouseleave", (event)=>{
                changeInterval(event.type, interval, ()=>{
                    const currentValue = parseFloat($currentInput.val() || 0);
                    if (attrMin == null || attrMin < currentValue) {
                        const newValue = currentValue - 1;
                        $currentInput.val(newValue);
                        if (settings.onDecrement) settings.onDecrement($currentInput, newValue, settings);
                    }
                });
                // Trigger the input event here to avoid event spam
                if (event.type == "mouseup" || event.type == "mouseleave") $currentInput.trigger("input");
            });
            const $plusButton = $("<button/>").attr("type", "button").html(settings.buttonIncrement).on("mousedown mouseup mouseleave", (event)=>{
                changeInterval(event.type, interval, ()=>{
                    const currentValue = parseFloat($currentInput.val() || 0);
                    if (attrMax == null || attrMax > currentValue) {
                        const newValue = currentValue + 1;
                        $currentInput.val(newValue);
                        if (settings.onIncrement) settings.onIncrement($currentInput, newValue, settings);
                    }
                });
                // Trigger the input event here to avoid event spam
                if (event.type == "mouseup" || event.type == "mouseleave") $currentInput.trigger("input");
            });
            // Remember that we have initialized this input
            $currentInput.attr("data-nice-number-initialized", true);
            // Append elements
            switch(settings.buttonPosition){
                case "left":
                    $minusButton.appendTo($inputContainer);
                    $plusButton.appendTo($inputContainer);
                    $currentInput.appendTo($inputContainer);
                    break;
                case "right":
                    $currentInput.appendTo($inputContainer);
                    $minusButton.appendTo($inputContainer);
                    $plusButton.appendTo($inputContainer);
                    break;
                case "around":
                default:
                    $minusButton.appendTo($inputContainer);
                    $currentInput.appendTo($inputContainer);
                    $plusButton.appendTo($inputContainer);
                    break;
            }
            // Nicely size input
            if (settings.autoSize) {
                $currentInput.width(`${$currentInput.val().length + settings.autoSizeBuffer}ch`);
                $currentInput.on("keyup input", ()=>{
                    $currentInput.animate({
                        width: `${$currentInput.val().length + settings.autoSizeBuffer}ch`
                    }, 200);
                });
            }
        });
    };
    function changeInterval(eventType, interval, callback) {
        if (eventType == "mousedown") {
            interval.timeout = setTimeout(()=>{
                interval.actualInterval = setInterval(()=>{
                    callback();
                }, 100);
            }, 200);
            callback();
        } else {
            if (interval.timeout) clearTimeout(interval.timeout);
            if (interval.actualInterval) clearInterval(interval.actualInterval);
        }
    }
}((0, (/*@__PURE__*/$parcel$interopDefault($jAv3h))));


const $4f896a8bc4a68623$var$form = ()=>{
    if (document.querySelector(".input-number")) (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))(".input-number").niceNumber();
};
var $4f896a8bc4a68623$export$2e2bcd8739ae039 = $4f896a8bc4a68623$var$form;



var $16hem = parcelRequire("16hem");
var $36fd10bb97624f39$exports = {};
/**
 * Vue Cookies v1.8.3
 * https://github.com/cmp-cc/vue-cookies
 *
 * Copyright 2016, cmp-cc
 * Released under the MIT license
 */ (function() {
    var defaultConfig = {
        expires: "1d",
        path: "; path=/",
        domain: "",
        secure: "",
        sameSite: "; SameSite=Lax"
    };
    var VueCookies = {
        // install of Vue
        install: function(Vue, options) {
            if (options) this.config(options.expires, options.path, options.domain, options.secure, options.sameSite);
            if (Vue.prototype) Vue.prototype.$cookies = this;
            if (Vue.config && Vue.config.globalProperties) {
                Vue.config.globalProperties.$cookies = this;
                Vue.provide("$cookies", this);
            }
            Vue.$cookies = this;
        },
        config: function(expires, path, domain, secure, sameSite) {
            defaultConfig.expires = expires ? expires : "1d";
            defaultConfig.path = path ? "; path=" + path : "; path=/";
            defaultConfig.domain = domain ? "; domain=" + domain : "";
            defaultConfig.secure = secure ? "; Secure" : "";
            defaultConfig.sameSite = sameSite ? "; SameSite=" + sameSite : "; SameSite=Lax";
        },
        get: function(key) {
            var value = decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
            if (value && (value.substring(0, 1) === "{" && value.substring(value.length - 1, value.length) === "}" || value.substring(0, 1) === "[" && value.substring(value.length - 1, value.length) === "]")) try {
                value = JSON.parse(value);
            } catch (e) {
                return value;
            }
            return value;
        },
        set: function(key, value, expires, path, domain, secure, sameSite) {
            if (!key) throw new Error("Cookie name is not found in the first argument.");
            else if (/^(?:expires|max\-age|path|domain|secure|SameSite)$/i.test(key)) throw new Error('Cookie name illegality. Cannot be set to ["expires","max-age","path","domain","secure","SameSite"]	 current key name: ' + key);
            // support json object
            if (value && typeof value === "object") value = JSON.stringify(value);
            var _expires = "";
            expires = expires == undefined ? defaultConfig.expires : expires;
            if (expires && expires != 0) switch(expires.constructor){
                case Number:
                    if (expires === Infinity || expires === -1) _expires = "; expires=Fri, 31 Dec 9999 23:59:59 GMT";
                    else _expires = "; max-age=" + expires;
                    break;
                case String:
                    if (/^(?:\d+(y|m|d|h|min|s))$/i.test(expires)) {
                        // get capture number group
                        var _expireTime = expires.replace(/^(\d+)(?:y|m|d|h|min|s)$/i, "$1");
                        // get capture type group , to lower case
                        switch(expires.replace(/^(?:\d+)(y|m|d|h|min|s)$/i, "$1").toLowerCase()){
                            // Frequency sorting
                            case "m":
                                _expires = "; max-age=" + +_expireTime * 2592000;
                                break; // 60 * 60 * 24 * 30
                            case "d":
                                _expires = "; max-age=" + +_expireTime * 86400;
                                break; // 60 * 60 * 24
                            case "h":
                                _expires = "; max-age=" + +_expireTime * 3600;
                                break; // 60 * 60
                            case "min":
                                _expires = "; max-age=" + +_expireTime * 60;
                                break; // 60
                            case "s":
                                _expires = "; max-age=" + _expireTime;
                                break;
                            case "y":
                                _expires = "; max-age=" + +_expireTime * 31104000;
                                break; // 60 * 60 * 24 * 30 * 12
                            default:
                                new Error('unknown exception of "set operation"');
                        }
                    } else _expires = "; expires=" + expires;
                    break;
                case Date:
                    _expires = "; expires=" + expires.toUTCString();
                    break;
            }
            document.cookie = encodeURIComponent(key) + "=" + encodeURIComponent(value) + _expires + (domain ? "; domain=" + domain : defaultConfig.domain) + (path ? "; path=" + path : defaultConfig.path) + (secure == undefined ? defaultConfig.secure : secure ? "; Secure" : "") + (sameSite == undefined ? defaultConfig.sameSite : sameSite ? "; SameSite=" + sameSite : "");
            return this;
        },
        remove: function(key, path, domain) {
            if (!key || !this.isKey(key)) return false;
            document.cookie = encodeURIComponent(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (domain ? "; domain=" + domain : defaultConfig.domain) + (path ? "; path=" + path : defaultConfig.path) + "; SameSite=Lax";
            return true;
        },
        isKey: function(key) {
            return new RegExp("(?:^|;\\s*)" + encodeURIComponent(key).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=").test(document.cookie);
        },
        keys: function() {
            if (!document.cookie) return [];
            var _keys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
            for(var _index = 0; _index < _keys.length; _index++)_keys[_index] = decodeURIComponent(_keys[_index]);
            return _keys;
        }
    };
    $36fd10bb97624f39$exports = VueCookies;
    // vue-cookies can exist independently,no dependencies library
    if (typeof window !== "undefined") window.$cookies = VueCookies;
})();


let $219b60fb94ef7405$var$script;





let $219b60fb94ef7405$var$initialize = ()=>{
    $219b60fb94ef7405$var$script = (parcelRequire("81mWS"));
    if ($219b60fb94ef7405$var$script.__esModule) $219b60fb94ef7405$var$script = $219b60fb94ef7405$var$script.default;
    $219b60fb94ef7405$var$script.render = (parcelRequire("eztfx")).render;
    $219b60fb94ef7405$var$script.staticRenderFns = (parcelRequire("eztfx")).staticRenderFns;
    $219b60fb94ef7405$var$script._scopeId = "data-v-19ed3e";
    $219b60fb94ef7405$var$script.__cssModules = {};
    (parcelRequire("83H9q")).default($219b60fb94ef7405$var$script);
    $219b60fb94ef7405$var$script.__scopeId = "data-v-19ed3e";
    $219b60fb94ef7405$var$script.__file = "PopupSide.vue";
};
$219b60fb94ef7405$var$initialize();
var $219b60fb94ef7405$export$2e2bcd8739ae039 = $219b60fb94ef7405$var$script;


let $d32792d2963595b2$var$script;





let $d32792d2963595b2$var$initialize = ()=>{
    $d32792d2963595b2$var$script = (parcelRequire("jAgsj"));
    if ($d32792d2963595b2$var$script.__esModule) $d32792d2963595b2$var$script = $d32792d2963595b2$var$script.default;
    $d32792d2963595b2$var$script.render = (parcelRequire("7iGZd")).render;
    $d32792d2963595b2$var$script.staticRenderFns = (parcelRequire("7iGZd")).staticRenderFns;
    $d32792d2963595b2$var$script._scopeId = "data-v-f0ca49";
    $d32792d2963595b2$var$script.__cssModules = {};
    (parcelRequire("2BQGv")).default($d32792d2963595b2$var$script);
    $d32792d2963595b2$var$script.__scopeId = "data-v-f0ca49";
    $d32792d2963595b2$var$script.__file = "PopupTop.vue";
};
$d32792d2963595b2$var$initialize();
var $d32792d2963595b2$export$2e2bcd8739ae039 = $d32792d2963595b2$var$script;


const $9c1d87fb5cbe8c16$var$popup = ()=>{
    if (document.querySelector("#popup-side")) {
        (0, $16hem.default).config.productionTip = false;
        (0, $16hem.default).config.devtools = false;
        (0, $16hem.default).use((0, (/*@__PURE__*/$parcel$interopDefault($36fd10bb97624f39$exports))));
        (0, $16hem.default).$cookies.config("30d");
        new (0, $16hem.default)({
            el: "#popup-side",
            render: (h)=>h((0, $219b60fb94ef7405$export$2e2bcd8739ae039))
        });
    }
    if (document.querySelector("#popup-top")) {
        (0, $16hem.default).config.productionTip = false;
        (0, $16hem.default).config.devtools = false;
        (0, $16hem.default).use((0, (/*@__PURE__*/$parcel$interopDefault($36fd10bb97624f39$exports))));
        (0, $16hem.default).$cookies.config("30d");
        new (0, $16hem.default)({
            el: "#popup-top",
            render: (h)=>h((0, $d32792d2963595b2$export$2e2bcd8739ae039))
        });
    }
};
var $9c1d87fb5cbe8c16$export$2e2bcd8739ae039 = $9c1d87fb5cbe8c16$var$popup;



var $jAv3h = parcelRequire("jAv3h");

var $16hem = parcelRequire("16hem");


var $irt6H = parcelRequire("irt6H");
var $f3d160249de3492f$exports = {};

/*! @preserve
 * numeral.js
 * locales : 2.0.6
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */ (function(global, factory) {
    if (typeof define === "function" && define.amd) define([
        "numeral"
    ], factory);
    else if (0, $f3d160249de3492f$exports) factory((parcelRequire("irt6H")));
    else factory(global.numeral);
})($f3d160249de3492f$exports, function(numeral) {
    (function() {
        numeral.register("locale", "bg", {
            delimiters: {
                thousands: " ",
                decimal: ","
            },
            abbreviations: {
                thousand: "хил",
                million: "млн",
                billion: "млрд",
                trillion: "трлн"
            },
            ordinal: function(number) {
                // google translate suggests:
                // 1st=1-ви; 2nd=2-ри; 7th=7-ми;
                // 8th=8-ми and many others end with -ти
                // for example 3rd=3-ти
                // However since I've seen suggestions that in
                // Bulgarian the ordinal can be taken in
                // different forms (masculine, feminine, neuter)
                // I've opted to wimp out on commiting that to code
                return "";
            },
            currency: {
                symbol: "лв"
            }
        });
    })();
    (function() {
        numeral.register("locale", "chs", {
            delimiters: {
                thousands: ",",
                decimal: "."
            },
            abbreviations: {
                thousand: "千",
                million: "百万",
                billion: "十亿",
                trillion: "兆"
            },
            ordinal: function(number) {
                return ".";
            },
            currency: {
                symbol: "\xa5"
            }
        });
    })();
    (function() {
        numeral.register("locale", "cs", {
            delimiters: {
                thousands: " ",
                decimal: ","
            },
            abbreviations: {
                thousand: "tis.",
                million: "mil.",
                billion: "b",
                trillion: "t"
            },
            ordinal: function() {
                return ".";
            },
            currency: {
                symbol: "Kč"
            }
        });
    })();
    (function() {
        numeral.register("locale", "da-dk", {
            delimiters: {
                thousands: ".",
                decimal: ","
            },
            abbreviations: {
                thousand: "k",
                million: "mio",
                billion: "mia",
                trillion: "b"
            },
            ordinal: function(number) {
                return ".";
            },
            currency: {
                symbol: "DKK"
            }
        });
    })();
    (function() {
        numeral.register("locale", "de-ch", {
            delimiters: {
                thousands: " ",
                decimal: ","
            },
            abbreviations: {
                thousand: "k",
                million: "m",
                billion: "b",
                trillion: "t"
            },
            ordinal: function(number) {
                return ".";
            },
            currency: {
                symbol: "CHF"
            }
        });
    })();
    (function() {
        numeral.register("locale", "de", {
            delimiters: {
                thousands: " ",
                decimal: ","
            },
            abbreviations: {
                thousand: "k",
                million: "m",
                billion: "b",
                trillion: "t"
            },
            ordinal: function(number) {
                return ".";
            },
            currency: {
                symbol: "€"
            }
        });
    })();
    (function() {
        numeral.register("locale", "en-au", {
            delimiters: {
                thousands: ",",
                decimal: "."
            },
            abbreviations: {
                thousand: "k",
                million: "m",
                billion: "b",
                trillion: "t"
            },
            ordinal: function(number) {
                var b = number % 10;
                return ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            },
            currency: {
                symbol: "$"
            }
        });
    })();
    (function() {
        numeral.register("locale", "en-gb", {
            delimiters: {
                thousands: ",",
                decimal: "."
            },
            abbreviations: {
                thousand: "k",
                million: "m",
                billion: "b",
                trillion: "t"
            },
            ordinal: function(number) {
                var b = number % 10;
                return ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            },
            currency: {
                symbol: "\xa3"
            }
        });
    })();
    (function() {
        numeral.register("locale", "en-za", {
            delimiters: {
                thousands: " ",
                decimal: ","
            },
            abbreviations: {
                thousand: "k",
                million: "m",
                billion: "b",
                trillion: "t"
            },
            ordinal: function(number) {
                var b = number % 10;
                return ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            },
            currency: {
                symbol: "R"
            }
        });
    })();
    (function() {
        numeral.register("locale", "es-es", {
            delimiters: {
                thousands: ".",
                decimal: ","
            },
            abbreviations: {
                thousand: "k",
                million: "mm",
                billion: "b",
                trillion: "t"
            },
            ordinal: function(number) {
                var b = number % 10;
                return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
            },
            currency: {
                symbol: "€"
            }
        });
    })();
    (function() {
        numeral.register("locale", "es", {
            delimiters: {
                thousands: ".",
                decimal: ","
            },
            abbreviations: {
                thousand: "k",
                million: "mm",
                billion: "b",
                trillion: "t"
            },
            ordinal: function(number) {
                var b = number % 10;
                return b === 1 || b === 3 ? "er" : b === 2 ? "do" : b === 7 || b === 0 ? "mo" : b === 8 ? "vo" : b === 9 ? "no" : "to";
            },
            currency: {
                symbol: "$"
            }
        });
    })();
    (function() {
        numeral.register("locale", "et", {
            delimiters: {
                thousands: " ",
                decimal: ","
            },
            abbreviations: {
                thousand: " tuh",
                million: " mln",
                billion: " mld",
                trillion: " trl"
            },
            ordinal: function(number) {
                return ".";
            },
            currency: {
                symbol: "€"
            }
        });
    })();
    (function() {
        numeral.register("locale", "fi", {
            delimiters: {
                thousands: " ",
                decimal: ","
            },
            abbreviations: {
                thousand: "k",
                million: "M",
                billion: "G",
                trillion: "T"
            },
            ordinal: function(number) {
                return ".";
            },
            currency: {
                symbol: "€"
            }
        });
    })();
    (function() {
        numeral.register("locale", "fr-ca", {
            delimiters: {
                thousands: " ",
                decimal: ","
            },
            abbreviations: {
                thousand: "k",
                million: "M",
                billion: "G",
                trillion: "T"
            },
            ordinal: function(number) {
                return number === 1 ? "er" : "e";
            },
            currency: {
                symbol: "$"
            }
        });
    })();
    (function() {
        numeral.register("locale", "fr-ch", {
            delimiters: {
                thousands: "'",
                decimal: "."
            },
            abbreviations: {
                thousand: "k",
                million: "m",
                billion: "b",
                trillion: "t"
            },
            ordinal: function(number) {
                return number === 1 ? "er" : "e";
            },
            currency: {
                symbol: "CHF"
            }
        });
    })();
    (function() {
        numeral.register("locale", "fr", {
            delimiters: {
                thousands: " ",
                decimal: ","
            },
            abbreviations: {
                thousand: "k",
                million: "m",
                billion: "b",
                trillion: "t"
            },
            ordinal: function(number) {
                return number === 1 ? "er" : "e";
            },
            currency: {
                symbol: "€"
            }
        });
    })();
    (function() {
        numeral.register("locale", "hu", {
            delimiters: {
                thousands: " ",
                decimal: ","
            },
            abbreviations: {
                thousand: "E",
                million: "M",
                billion: "Mrd",
                trillion: "T" // trillió
            },
            ordinal: function(number) {
                return ".";
            },
            currency: {
                symbol: " Ft"
            }
        });
    })();
    (function() {
        numeral.register("locale", "it", {
            delimiters: {
                thousands: ".",
                decimal: ","
            },
            abbreviations: {
                thousand: "mila",
                million: "mil",
                billion: "b",
                trillion: "t"
            },
            ordinal: function(number) {
                return "\xba";
            },
            currency: {
                symbol: "€"
            }
        });
    })();
    (function() {
        numeral.register("locale", "ja", {
            delimiters: {
                thousands: ",",
                decimal: "."
            },
            abbreviations: {
                thousand: "千",
                million: "百万",
                billion: "十億",
                trillion: "兆"
            },
            ordinal: function(number) {
                return ".";
            },
            currency: {
                symbol: "\xa5"
            }
        });
    })();
    (function() {
        numeral.register("locale", "lv", {
            delimiters: {
                thousands: " ",
                decimal: ","
            },
            abbreviations: {
                thousand: " tūkst.",
                million: " milj.",
                billion: " mljrd.",
                trillion: " trilj."
            },
            ordinal: function(number) {
                return ".";
            },
            currency: {
                symbol: "€"
            }
        });
    })();
    (function() {
        numeral.register("locale", "nl-be", {
            delimiters: {
                thousands: " ",
                decimal: ","
            },
            abbreviations: {
                thousand: "k",
                million: " mln",
                billion: " mld",
                trillion: " bln"
            },
            ordinal: function(number) {
                var remainder = number % 100;
                return number !== 0 && remainder <= 1 || remainder === 8 || remainder >= 20 ? "ste" : "de";
            },
            currency: {
                symbol: "€ "
            }
        });
    })();
    (function() {
        numeral.register("locale", "nl-nl", {
            delimiters: {
                thousands: ".",
                decimal: ","
            },
            abbreviations: {
                thousand: "k",
                million: "mln",
                billion: "mrd",
                trillion: "bln"
            },
            ordinal: function(number) {
                var remainder = number % 100;
                return number !== 0 && remainder <= 1 || remainder === 8 || remainder >= 20 ? "ste" : "de";
            },
            currency: {
                symbol: "€ "
            }
        });
    })();
    (function() {
        numeral.register("locale", "no", {
            delimiters: {
                thousands: " ",
                decimal: ","
            },
            abbreviations: {
                thousand: "k",
                million: "m",
                billion: "b",
                trillion: "t"
            },
            ordinal: function(number) {
                return ".";
            },
            currency: {
                symbol: "kr"
            }
        });
    })();
    (function() {
        numeral.register("locale", "pl", {
            delimiters: {
                thousands: " ",
                decimal: ","
            },
            abbreviations: {
                thousand: "tys.",
                million: "mln",
                billion: "mld",
                trillion: "bln"
            },
            ordinal: function(number) {
                return ".";
            },
            currency: {
                symbol: "PLN"
            }
        });
    })();
    (function() {
        numeral.register("locale", "pt-br", {
            delimiters: {
                thousands: ".",
                decimal: ","
            },
            abbreviations: {
                thousand: "mil",
                million: "milh\xf5es",
                billion: "b",
                trillion: "t"
            },
            ordinal: function(number) {
                return "\xba";
            },
            currency: {
                symbol: "R$"
            }
        });
    })();
    (function() {
        numeral.register("locale", "pt-pt", {
            delimiters: {
                thousands: " ",
                decimal: ","
            },
            abbreviations: {
                thousand: "k",
                million: "m",
                billion: "b",
                trillion: "t"
            },
            ordinal: function(number) {
                return "\xba";
            },
            currency: {
                symbol: "€"
            }
        });
    })();
    (function() {
        numeral.register("locale", "ru-ua", {
            delimiters: {
                thousands: " ",
                decimal: ","
            },
            abbreviations: {
                thousand: "тыс.",
                million: "млн",
                billion: "b",
                trillion: "t"
            },
            ordinal: function() {
                // not ideal, but since in Russian it can taken on
                // different forms (masculine, feminine, neuter)
                // this is all we can do
                return ".";
            },
            currency: {
                symbol: "₴"
            }
        });
    })();
    (function() {
        numeral.register("locale", "ru", {
            delimiters: {
                thousands: " ",
                decimal: ","
            },
            abbreviations: {
                thousand: "тыс.",
                million: "млн.",
                billion: "млрд.",
                trillion: "трлн."
            },
            ordinal: function() {
                // not ideal, but since in Russian it can taken on
                // different forms (masculine, feminine, neuter)
                // this is all we can do
                return ".";
            },
            currency: {
                symbol: "руб."
            }
        });
    })();
    (function() {
        numeral.register("locale", "sk", {
            delimiters: {
                thousands: " ",
                decimal: ","
            },
            abbreviations: {
                thousand: "tis.",
                million: "mil.",
                billion: "b",
                trillion: "t"
            },
            ordinal: function() {
                return ".";
            },
            currency: {
                symbol: "€"
            }
        });
    })();
    (function() {
        numeral.register("locale", "sl", {
            delimiters: {
                thousands: ".",
                decimal: ","
            },
            abbreviations: {
                thousand: "k",
                million: "mio",
                billion: "mrd",
                trillion: "trilijon"
            },
            ordinal: function() {
                return ".";
            },
            currency: {
                symbol: "€"
            }
        });
    })();
    (function() {
        numeral.register("locale", "th", {
            delimiters: {
                thousands: ",",
                decimal: "."
            },
            abbreviations: {
                thousand: "พัน",
                million: "ล้าน",
                billion: "พันล้าน",
                trillion: "ล้านล้าน"
            },
            ordinal: function(number) {
                return ".";
            },
            currency: {
                symbol: "฿"
            }
        });
    })();
    (function() {
        var suffixes = {
            1: "'inci",
            5: "'inci",
            8: "'inci",
            70: "'inci",
            80: "'inci",
            2: "'nci",
            7: "'nci",
            20: "'nci",
            50: "'nci",
            3: "'\xfcnc\xfc",
            4: "'\xfcnc\xfc",
            100: "'\xfcnc\xfc",
            6: "'ncı",
            9: "'uncu",
            10: "'uncu",
            30: "'uncu",
            60: "'ıncı",
            90: "'ıncı"
        };
        numeral.register("locale", "tr", {
            delimiters: {
                thousands: ".",
                decimal: ","
            },
            abbreviations: {
                thousand: "bin",
                million: "milyon",
                billion: "milyar",
                trillion: "trilyon"
            },
            ordinal: function(number) {
                if (number === 0) return "'ıncı";
                var a = number % 10, b = number % 100 - a, c = number >= 100 ? 100 : null;
                return suffixes[a] || suffixes[b] || suffixes[c];
            },
            currency: {
                symbol: "₺"
            }
        });
    })();
    (function() {
        numeral.register("locale", "uk-ua", {
            delimiters: {
                thousands: " ",
                decimal: ","
            },
            abbreviations: {
                thousand: "тис.",
                million: "млн",
                billion: "млрд",
                trillion: "блн"
            },
            ordinal: function() {
                // not ideal, but since in Ukrainian it can taken on
                // different forms (masculine, feminine, neuter)
                // this is all we can do
                return "";
            },
            currency: {
                symbol: "₴"
            }
        });
    })();
    (function() {
        numeral.register("locale", "vi", {
            delimiters: {
                thousands: ".",
                decimal: ","
            },
            abbreviations: {
                thousand: " ngh\xecn",
                million: " triệu",
                billion: " tỷ",
                trillion: " ngh\xecn tỷ"
            },
            ordinal: function() {
                return ".";
            },
            currency: {
                symbol: "₫"
            }
        });
    })();
});


var $6a0b18e9b9957be4$var$abbreviate = function abbreviate(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($irt6H)))(value).format("0.0a");
};
var $6a0b18e9b9957be4$var$bytes = function bytes(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($irt6H)))(value).format("0 b");
};
var $6a0b18e9b9957be4$var$exposedNumeral = function exposedNumeral(value, format) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($irt6H)))(value).format(format);
};
var $6a0b18e9b9957be4$var$exponential = function exponential(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($irt6H)))(value).format("0.[00]e+0");
};
var $6a0b18e9b9957be4$var$ordinal = function ordinal(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($irt6H)))(value).format("Oo");
};
var $6a0b18e9b9957be4$var$percentage = function percentage(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($irt6H)))(value).format("0.[00]%");
};
var $6a0b18e9b9957be4$var$separator = function separator(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($irt6H)))(value).format("0,0");
};
var $6a0b18e9b9957be4$var$currency = function currency(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($irt6H)))(value).format("$0,0.00");
};
var $6a0b18e9b9957be4$var$vueNumeralFilterInstaller = {
    install: function install(vue) {
        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? "en-gb" : _ref$locale;
        (0, (/*@__PURE__*/$parcel$interopDefault($irt6H))).locale(locale);
        vue.filter("abbreviate", $6a0b18e9b9957be4$var$abbreviate);
        vue.filter("bytes", $6a0b18e9b9957be4$var$bytes);
        vue.filter("exponential", $6a0b18e9b9957be4$var$exponential);
        vue.filter("numeral", $6a0b18e9b9957be4$var$exposedNumeral);
        vue.filter("ordinal", $6a0b18e9b9957be4$var$ordinal);
        vue.filter("percentage", $6a0b18e9b9957be4$var$percentage);
        vue.filter("separator", $6a0b18e9b9957be4$var$separator);
        vue.filter("currency", $6a0b18e9b9957be4$var$currency);
    }
};
if (typeof window !== "undefined" && window.Vue) Vue.use($6a0b18e9b9957be4$var$vueNumeralFilterInstaller);
var $6a0b18e9b9957be4$export$2e2bcd8739ae039 = $6a0b18e9b9957be4$var$vueNumeralFilterInstaller;


let $35e1ee243de00d8b$var$script;




let $35e1ee243de00d8b$var$initialize = ()=>{
    $35e1ee243de00d8b$var$script = (parcelRequire("lbhRl"));
    if ($35e1ee243de00d8b$var$script.__esModule) $35e1ee243de00d8b$var$script = $35e1ee243de00d8b$var$script.default;
    $35e1ee243de00d8b$var$script.render = (parcelRequire("fXHoi")).render;
    $35e1ee243de00d8b$var$script.staticRenderFns = (parcelRequire("fXHoi")).staticRenderFns;
    $35e1ee243de00d8b$var$script._scopeId = "data-v-65ca68";
    (parcelRequire("ggmL9")).default($35e1ee243de00d8b$var$script);
    $35e1ee243de00d8b$var$script.__scopeId = "data-v-65ca68";
    $35e1ee243de00d8b$var$script.__file = "UnitsTable.vue";
};
$35e1ee243de00d8b$var$initialize();
var $35e1ee243de00d8b$export$2e2bcd8739ae039 = $35e1ee243de00d8b$var$script;


var $6e53deaba691026b$exports = {};

/*!
 * @preserve
 *
 * Readmore.js jQuery plugin
 * Author: @jed_foster
 * Project home: http://jedfoster.github.io/Readmore.js
 * Licensed under the MIT license
 *
 * Debounce function from http://davidwalsh.name/javascript-debounce-function
 */ /* global jQuery */ (function(factory) {
    if (typeof define === "function" && define.amd) // AMD
    define([
        "jquery"
    ], factory);
    else // CommonJS
    $6e53deaba691026b$exports = factory((parcelRequire("jAv3h")));
})(function($) {
    "use strict";
    var readmore = "readmore", defaults = {
        speed: 100,
        collapsedHeight: 200,
        heightMargin: 16,
        moreLink: '<a href="#">Read More</a>',
        lessLink: '<a href="#">Close</a>',
        embedCSS: true,
        blockCSS: "display: block; width: 100%;",
        startOpen: false,
        // callbacks
        blockProcessed: function() {},
        beforeToggle: function() {},
        afterToggle: function() {}
    }, cssEmbedded = {}, uniqueIdCounter = 0;
    function debounce(func, wait, immediate) {
        var timeout;
        return function() {
            var context = this, args = arguments;
            var later = function() {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }
    function uniqueId(prefix) {
        var id = ++uniqueIdCounter;
        return String(prefix === null ? "rmjs-" : prefix) + id;
    }
    function setBoxHeights(element) {
        var el = element.clone().css({
            height: "auto",
            width: element.width(),
            maxHeight: "none",
            overflow: "hidden"
        }).insertAfter(element), expandedHeight = el.outerHeight(), cssMaxHeight = parseInt(el.css({
            maxHeight: ""
        }).css("max-height").replace(/[^-\d\.]/g, ""), 10), defaultHeight = element.data("defaultHeight");
        el.remove();
        var collapsedHeight = cssMaxHeight || element.data("collapsedHeight") || defaultHeight;
        // Store our measurements.
        element.data({
            expandedHeight: expandedHeight,
            maxHeight: cssMaxHeight,
            collapsedHeight: collapsedHeight
        })// and disable any `max-height` property set in CSS
        .css({
            maxHeight: "none"
        });
    }
    var resizeBoxes = debounce(function() {
        $("[data-readmore]").each(function() {
            var current = $(this), isExpanded = current.attr("aria-expanded") === "true";
            setBoxHeights(current);
            current.css({
                height: current.data(isExpanded ? "expandedHeight" : "collapsedHeight")
            });
        });
    }, 100);
    function embedCSS(options) {
        if (!cssEmbedded[options.selector]) {
            var styles = " ";
            if (options.embedCSS && options.blockCSS !== "") styles += options.selector + " + [data-readmore-toggle], " + options.selector + "[data-readmore]{" + options.blockCSS + "}";
            // Include the transition CSS even if embedCSS is false
            styles += options.selector + "[data-readmore]{" + "transition: height " + options.speed + "ms;" + "overflow: hidden;" + "}";
            (function(d, u) {
                var css = d.createElement("style");
                css.type = "text/css";
                if (css.styleSheet) css.styleSheet.cssText = u;
                else css.appendChild(d.createTextNode(u));
                d.getElementsByTagName("head")[0].appendChild(css);
            })(document, styles);
            cssEmbedded[options.selector] = true;
        }
    }
    function Readmore(element, options) {
        this.element = element;
        this.options = $.extend({}, defaults, options);
        embedCSS(this.options);
        this._defaults = defaults;
        this._name = readmore;
        this.init();
        // IE8 chokes on `window.addEventListener`, so need to test for support.
        if (window.addEventListener) {
            // Need to resize boxes when the page has fully loaded.
            window.addEventListener("load", resizeBoxes);
            window.addEventListener("resize", resizeBoxes);
        } else {
            window.attachEvent("load", resizeBoxes);
            window.attachEvent("resize", resizeBoxes);
        }
    }
    Readmore.prototype = {
        init: function() {
            var current = $(this.element);
            current.data({
                defaultHeight: this.options.collapsedHeight,
                heightMargin: this.options.heightMargin
            });
            setBoxHeights(current);
            var collapsedHeight = current.data("collapsedHeight"), heightMargin = current.data("heightMargin");
            if (current.outerHeight(true) <= collapsedHeight + heightMargin) {
                // The block is shorter than the limit, so there's no need to truncate it.
                if (this.options.blockProcessed && typeof this.options.blockProcessed === "function") this.options.blockProcessed(current, false);
                return true;
            } else {
                var id = current.attr("id") || uniqueId(), useLink = this.options.startOpen ? this.options.lessLink : this.options.moreLink;
                current.attr({
                    "data-readmore": "",
                    "aria-expanded": this.options.startOpen,
                    "id": id
                });
                current.after($(useLink).on("click", function(_this) {
                    return function(event) {
                        _this.toggle(this, current[0], event);
                    };
                }(this)).attr({
                    "data-readmore-toggle": id,
                    "aria-controls": id
                }));
                if (!this.options.startOpen) current.css({
                    height: collapsedHeight
                });
                if (this.options.blockProcessed && typeof this.options.blockProcessed === "function") this.options.blockProcessed(current, true);
            }
        },
        toggle: function(trigger, element, event) {
            if (event) event.preventDefault();
            if (!trigger) trigger = $('[aria-controls="' + this.element.id + '"]')[0];
            if (!element) element = this.element;
            var $element = $(element), newHeight = "", newLink = "", expanded = false, collapsedHeight = $element.data("collapsedHeight");
            if ($element.height() <= collapsedHeight) {
                newHeight = $element.data("expandedHeight") + "px";
                newLink = "lessLink";
                expanded = true;
            } else {
                newHeight = collapsedHeight;
                newLink = "moreLink";
            }
            // Fire beforeToggle callback
            // Since we determined the new "expanded" state above we're now out of sync
            // with our true current state, so we need to flip the value of `expanded`
            if (this.options.beforeToggle && typeof this.options.beforeToggle === "function") this.options.beforeToggle(trigger, $element, !expanded);
            $element.css({
                "height": newHeight
            });
            // Fire afterToggle callback
            $element.on("transitionend", function(_this) {
                return function() {
                    if (_this.options.afterToggle && typeof _this.options.afterToggle === "function") _this.options.afterToggle(trigger, $element, expanded);
                    $(this).attr({
                        "aria-expanded": expanded
                    }).off("transitionend");
                };
            }(this));
            $(trigger).replaceWith($(this.options[newLink]).on("click", function(_this) {
                return function(event) {
                    _this.toggle(this, element, event);
                };
            }(this)).attr({
                "data-readmore-toggle": $element.attr("id"),
                "aria-controls": $element.attr("id")
            }));
        },
        destroy: function() {
            $(this.element).each(function() {
                var current = $(this);
                current.attr({
                    "data-readmore": null,
                    "aria-expanded": null
                }).css({
                    maxHeight: "",
                    height: ""
                }).next("[data-readmore-toggle]").remove();
                current.removeData();
            });
        }
    };
    $.fn.readmore = function(options) {
        var args = arguments, selector = this.selector;
        options = options || {};
        if (typeof options === "object") return this.each(function() {
            if ($.data(this, "plugin_" + readmore)) {
                var instance = $.data(this, "plugin_" + readmore);
                instance.destroy.apply(instance);
            }
            options.selector = selector;
            $.data(this, "plugin_" + readmore, new Readmore(this, options));
        });
        else if (typeof options === "string" && options[0] !== "_" && options !== "init") return this.each(function() {
            var instance = $.data(this, "plugin_" + readmore);
            if (instance instanceof Readmore && typeof instance[options] === "function") instance[options].apply(instance, Array.prototype.slice.call(args, 1));
        });
    };
});


const $bd62cd9f35e22496$var$estate = ()=>{
    // Units
    if (document.querySelector("#units")) {
        (0, $16hem.default).use((0, $6a0b18e9b9957be4$export$2e2bcd8739ae039), {
            locale: "nl-nl"
        });
        new (0, $16hem.default)({
            el: "#units",
            render: (h)=>h((0, $35e1ee243de00d8b$export$2e2bcd8739ae039))
        });
    }
    if (document.querySelector(".js-estate")) {
        const youtubeParser = (url)=>{
            // Ondersteunt watch, embed, shorts, en youtu.be links
            const regExp = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([^\s&?\/]+)/;
            const match = url.match(regExp);
            return match && match[1].length === 11 ? match[1] : false;
        };
        const $iframe = (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))("#estateVideo").find("iframe");
        if ($iframe.length) {
            const videoUrl = $iframe.attr("data-video");
            if (typeof videoUrl === "string" && videoUrl.trim() !== "") {
                const videoId = youtubeParser(videoUrl);
                if (videoId && typeof videoId === "string" && videoId.length === 11) {
                    const videoSrc = `${videoId}?iv_load_policy=3&listType=user_uploads&controls=1&fs=0&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1`;
                    $iframe.attr("src", `https://www.youtube.com/embed/${videoSrc}`);
                    if (videoUrl.includes("shorts")) {
                        $iframe.addClass("is-shorts");
                        if ($iframe.parent().length) $iframe.parent().addClass("has-shorts-video");
                    }
                }
            }
        }
    }
    // Description
    if (document.querySelector(".js-description")) {
        let txtReadmore = "Lire plus";
        let txtReadless = "Lire moins";
        if (window.descriptionData.lang === "nl") {
            txtReadmore = "Lees meer";
            txtReadless = "Lees minder";
        }
        (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))(".js-description").readmore({
            speed: 75,
            collapsedHeight: 110,
            moreLink: `<a href="#" class="mt-6 btn-link is-line">${txtReadmore}</a>`,
            lessLink: `<a href="#" class="mt-6 btn-link is-line">${txtReadless}</a>`
        });
    }
    // Modal
    if (document.querySelector(".modal")) (0, $608705cbe9abf74c$export$2e2bcd8739ae039).init({
        disableScroll: true,
        awaitCloseAnimation: true
    });
    // Investment
    if (document.querySelector("#modal-investment")) {
        (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))(".js-open-investment").on("click", (e)=>{
            e.preventDefault();
            (0, $608705cbe9abf74c$export$2e2bcd8739ae039).show("modal-investment");
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))(".js-close-investment").on("click", (e)=>{
            e.preventDefault();
            (0, $608705cbe9abf74c$export$2e2bcd8739ae039).close("modal-investment");
        });
    }
    // Rent
    if (document.querySelector("#modal-rent")) {
        (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))(".js-open-rent").on("click", (e)=>{
            e.preventDefault();
            (0, $608705cbe9abf74c$export$2e2bcd8739ae039).show("modal-rent");
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))(".js-close-rent").on("click", (e)=>{
            e.preventDefault();
            (0, $608705cbe9abf74c$export$2e2bcd8739ae039).close("modal-rent");
        });
    }
};
var $bd62cd9f35e22496$export$2e2bcd8739ae039 = $bd62cd9f35e22496$var$estate;



var $16hem = parcelRequire("16hem");
let $86cedd0741e9430c$var$script;





let $86cedd0741e9430c$var$initialize = ()=>{
    $86cedd0741e9430c$var$script = (parcelRequire("cz3gu"));
    if ($86cedd0741e9430c$var$script.__esModule) $86cedd0741e9430c$var$script = $86cedd0741e9430c$var$script.default;
    $86cedd0741e9430c$var$script.render = (parcelRequire("lWyIp")).render;
    $86cedd0741e9430c$var$script.staticRenderFns = (parcelRequire("lWyIp")).staticRenderFns;
    $86cedd0741e9430c$var$script._scopeId = "data-v-50ef07";
    $86cedd0741e9430c$var$script.__cssModules = {};
    (parcelRequire("fZLQP")).default($86cedd0741e9430c$var$script);
    $86cedd0741e9430c$var$script.__scopeId = "data-v-50ef07";
    $86cedd0741e9430c$var$script.__file = "GalleryList.vue";
};
$86cedd0741e9430c$var$initialize();
var $86cedd0741e9430c$export$2e2bcd8739ae039 = $86cedd0741e9430c$var$script;


const $d3100a5383f44df4$var$gallery = ()=>{
    if (document.querySelector("#gallery")) {
        (0, $16hem.default).config.productionTip = false;
        (0, $16hem.default).config.devtools = false;
        new (0, $16hem.default)({
            el: "#gallery",
            render: (h)=>h((0, $86cedd0741e9430c$export$2e2bcd8739ae039))
        });
    }
};
var $d3100a5383f44df4$export$2e2bcd8739ae039 = $d3100a5383f44df4$var$gallery;



var $jAv3h = parcelRequire("jAv3h");
const $043656a10d2a7a08$var$video = ()=>{
    if (document.querySelector(".js-video")) {
        // Video
        const youtubeParser = (url)=>{
            const regExp = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([^\s&?\/]+)/;
            const match = url.match(regExp);
            return match && match[1].length === 11 ? match[1] : false;
        };
        const video = `${youtubeParser((0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))("#youtubeVideo").find("iframe").attr("data-video"))}?amp;iv_load_policy=3&amp;listType=user_uploads&amp;controls=1&amp;fs=0&amp;modestbranding=1&amp;playsinline=1&amp;showinfo=0&amp;rel=0&amp;enablejsapi=1`;
        (0, (/*@__PURE__*/$parcel$interopDefault($jAv3h)))("#youtubeVideo").find("iframe").attr("src", `https://www.youtube.com/embed/${video}`);
    }
};
var $043656a10d2a7a08$export$2e2bcd8739ae039 = $043656a10d2a7a08$var$video;


(0, $7c607fc5debc0337$export$2e2bcd8739ae039)();
(0, $4a40c00b717d9100$export$2e2bcd8739ae039)();
(0, $0ed154dc5b49c6a8$export$2e2bcd8739ae039)();
(0, $e08697c769e000aa$export$2e2bcd8739ae039)();
(0, $0565f1dd1f0ba03b$export$2e2bcd8739ae039)();
(0, $401ce02445c9337c$export$2e2bcd8739ae039)();
(0, $9c692fdc905fc837$export$2e2bcd8739ae039)();
(0, $628caac1cf237288$export$2e2bcd8739ae039)();
(0, $585f78c3134879cb$export$2e2bcd8739ae039)();
(0, $1c3fb0888fd8179d$export$2e2bcd8739ae039)();
(0, $5ac3e10b0f4f71ca$export$2e2bcd8739ae039)();
(0, $6f4339b9c5ae7e5b$export$2e2bcd8739ae039)();
(0, $4f896a8bc4a68623$export$2e2bcd8739ae039)();
(0, $9c1d87fb5cbe8c16$export$2e2bcd8739ae039)();
(0, $bd62cd9f35e22496$export$2e2bcd8739ae039)();
(0, $d3100a5383f44df4$export$2e2bcd8739ae039)();
(0, $043656a10d2a7a08$export$2e2bcd8739ae039)();

})();
//# sourceMappingURL=main.js.map
